function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e419) { throw _e419; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e420) { didErr = true; err = _e420; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * AgoraWebSDK_N-v4.20.0-0-g334e514b-dirty Copyright AgoraInc.
 */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).AgoraRTC = t();
}(this, function () {
  "use strict";

  var _pI$ACCESS_POINT, _pI$UNILBS, _pI$STRING_UID_ALLOCA, _Uv, _Vv;

  function e(e, t) {
    return t.forEach(function (t) {
      t && "string" != typeof t && !Array.isArray(t) && Object.keys(t).forEach(function (i) {
        if ("default" !== i && !(i in e)) {
          var n = Object.getOwnPropertyDescriptor(t, i);
          Object.defineProperty(e, i, n.get ? n : {
            enumerable: !0,
            get: function get() {
              return t[i];
            }
          });
        }
      });
    }), Object.freeze(e);
  }

  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  var n = function n(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  },
      s = !n(function () {
    var e = function () {}.bind();

    return "function" != typeof e || e.hasOwnProperty("prototype");
  }),
      r = s,
      o = Function.prototype,
      a = o.call,
      c = r && o.bind.bind(a, a),
      d = r ? c : function (e) {
    return function () {
      return a.apply(e, arguments);
    };
  },
      l = d({}.isPrototypeOf),
      u = function u(e) {
    return e && e.Math == Math && e;
  },
      h = u("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || u("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || u("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || u("object" == _typeof(t) && t) || function () {
    return this;
  }() || t || Function("return this")(),
      p = s,
      _ = Function.prototype,
      E = _.apply,
      m = _.call,
      f = "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && Reflect.apply || (p ? m.bind(E) : function () {
    return m.apply(E, arguments);
  }),
      T = d,
      g = T({}.toString),
      S = T("".slice),
      R = function R(e) {
    return S(g(e), 8, -1);
  },
      C = R,
      I = d,
      v = function v(e) {
    if ("Function" === C(e)) return I(e);
  },
      y = "object" == (typeof document === "undefined" ? "undefined" : _typeof(document)) && document.all,
      A = {
    all: y,
    IS_HTMLDDA: void 0 === y && void 0 !== y
  },
      b = A.all,
      w = A.IS_HTMLDDA ? function (e) {
    return "function" == typeof e || e === b;
  } : function (e) {
    return "function" == typeof e;
  },
      O = {},
      N = !n(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1];
  }),
      D = s,
      P = Function.prototype.call,
      L = D ? P.bind(P) : function () {
    return P.apply(P, arguments);
  },
      k = {},
      M = {}.propertyIsEnumerable,
      U = Object.getOwnPropertyDescriptor,
      x = U && !M.call({
    1: 2
  }, 1);

  k.f = x ? function (e) {
    var t = U(this, e);
    return !!t && t.enumerable;
  } : M;

  var V,
      F,
      B = function B(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  },
      j = n,
      G = R,
      W = Object,
      H = d("".split),
      K = j(function () {
    return !W("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == G(e) ? H(e, "") : W(e);
  } : W,
      Y = function Y(e) {
    return null == e;
  },
      q = Y,
      J = TypeError,
      z = function z(e) {
    if (q(e)) throw J("Can't call method on " + e);
    return e;
  },
      X = K,
      Q = z,
      Z = function Z(e) {
    return X(Q(e));
  },
      $ = w,
      ee = A.all,
      te = A.IS_HTMLDDA ? function (e) {
    return "object" == _typeof(e) ? null !== e : $(e) || e === ee;
  } : function (e) {
    return "object" == _typeof(e) ? null !== e : $(e);
  },
      ie = {},
      ne = ie,
      se = h,
      re = w,
      oe = function oe(e) {
    return re(e) ? e : void 0;
  },
      ae = function ae(e, t) {
    return arguments.length < 2 ? oe(ne[e]) || oe(se[e]) : ne[e] && ne[e][t] || se[e] && se[e][t];
  },
      ce = "undefined" != typeof navigator && String(navigator.userAgent) || "",
      de = h,
      le = ce,
      ue = de.process,
      he = de.Deno,
      pe = ue && ue.versions || he && he.version,
      _e = pe && pe.v8;

  _e && (F = (V = _e.split("."))[0] > 0 && V[0] < 4 ? 1 : +(V[0] + V[1])), !F && le && (!(V = le.match(/Edge\/(\d+)/)) || V[1] >= 74) && (V = le.match(/Chrome\/(\d+)/)) && (F = +V[1]);

  var Ee = F,
      me = Ee,
      fe = n,
      Te = h.String,
      ge = !!Object.getOwnPropertySymbols && !fe(function () {
    var e = Symbol();
    return !Te(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && me && me < 41;
  }),
      Se = ge && !Symbol.sham && "symbol" == _typeof(Symbol.iterator),
      Re = ae,
      Ce = w,
      Ie = l,
      ve = Object,
      ye = Se ? function (e) {
    return "symbol" == _typeof(e);
  } : function (e) {
    var t = Re("Symbol");
    return Ce(t) && Ie(t.prototype, ve(e));
  },
      Ae = String,
      be = function be(e) {
    try {
      return Ae(e);
    } catch (e) {
      return "Object";
    }
  },
      we = w,
      Oe = be,
      Ne = TypeError,
      De = function De(e) {
    if (we(e)) return e;
    throw Ne(Oe(e) + " is not a function");
  },
      Pe = De,
      Le = Y,
      ke = function ke(e, t) {
    var i = e[t];
    return Le(i) ? void 0 : Pe(i);
  },
      Me = L,
      Ue = w,
      xe = te,
      Ve = TypeError,
      Fe = {
    exports: {}
  },
      Be = h,
      je = Object.defineProperty,
      Ge = function Ge(e, t) {
    try {
      je(Be, e, {
        value: t,
        configurable: !0,
        writable: !0
      });
    } catch (i) {
      Be[e] = t;
    }

    return t;
  },
      We = "__core-js_shared__",
      He = h[We] || Ge(We, {}),
      Ke = He;

  (Fe.exports = function (e, t) {
    return Ke[e] || (Ke[e] = void 0 !== t ? t : {});
  })("versions", []).push({
    version: "3.31.1",
    mode: "pure",
    copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.31.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
  });

  var Ye = Fe.exports,
      qe = z,
      Je = Object,
      ze = function ze(e) {
    return Je(qe(e));
  },
      Xe = ze,
      Qe = d({}.hasOwnProperty),
      Ze = Object.hasOwn || function (e, t) {
    return Qe(Xe(e), t);
  },
      $e = d,
      et = 0,
      tt = Math.random(),
      it = $e(1..toString),
      nt = function nt(e) {
    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + it(++et + tt, 36);
  },
      st = Ye,
      rt = Ze,
      ot = nt,
      at = ge,
      ct = Se,
      dt = h.Symbol,
      lt = st("wks"),
      ut = ct ? dt.for || dt : dt && dt.withoutSetter || ot,
      ht = function ht(e) {
    return rt(lt, e) || (lt[e] = at && rt(dt, e) ? dt[e] : ut("Symbol." + e)), lt[e];
  },
      pt = L,
      _t = te,
      Et = ye,
      mt = ke,
      ft = function ft(e, t) {
    var i, n;
    if ("string" === t && Ue(i = e.toString) && !xe(n = Me(i, e))) return n;
    if (Ue(i = e.valueOf) && !xe(n = Me(i, e))) return n;
    if ("string" !== t && Ue(i = e.toString) && !xe(n = Me(i, e))) return n;
    throw Ve("Can't convert object to primitive value");
  },
      Tt = TypeError,
      gt = ht("toPrimitive"),
      St = function St(e, t) {
    if (!_t(e) || Et(e)) return e;
    var i,
        n = mt(e, gt);

    if (n) {
      if (void 0 === t && (t = "default"), i = pt(n, e, t), !_t(i) || Et(i)) return i;
      throw Tt("Can't convert object to primitive value");
    }

    return void 0 === t && (t = "number"), ft(e, t);
  },
      Rt = ye,
      Ct = function Ct(e) {
    var t = St(e, "string");
    return Rt(t) ? t : t + "";
  },
      It = te,
      vt = h.document,
      yt = It(vt) && It(vt.createElement),
      At = function At(e) {
    return yt ? vt.createElement(e) : {};
  },
      bt = At,
      wt = !N && !n(function () {
    return 7 != Object.defineProperty(bt("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      Ot = N,
      Nt = L,
      Dt = k,
      Pt = B,
      Lt = Z,
      kt = Ct,
      Mt = Ze,
      Ut = wt,
      xt = Object.getOwnPropertyDescriptor;

  O.f = Ot ? xt : function (e, t) {
    if (e = Lt(e), t = kt(t), Ut) try {
      return xt(e, t);
    } catch (e) {}
    if (Mt(e, t)) return Pt(!Nt(Dt.f, e, t), e[t]);
  };

  var Vt = n,
      Ft = w,
      Bt = /#|\.prototype\./,
      jt = function jt(e, t) {
    var i = Wt[Gt(e)];
    return i == Kt || i != Ht && (Ft(t) ? Vt(t) : !!t);
  },
      Gt = jt.normalize = function (e) {
    return String(e).replace(Bt, ".").toLowerCase();
  },
      Wt = jt.data = {},
      Ht = jt.NATIVE = "N",
      Kt = jt.POLYFILL = "P",
      Yt = jt,
      qt = De,
      Jt = s,
      zt = v(v.bind),
      Xt = function Xt(e, t) {
    return qt(e), void 0 === t ? e : Jt ? zt(e, t) : function () {
      return e.apply(t, arguments);
    };
  },
      Qt = {},
      Zt = N && n(function () {
    return 42 != Object.defineProperty(function () {}, "prototype", {
      value: 42,
      writable: !1
    }).prototype;
  }),
      $t = te,
      ei = String,
      ti = TypeError,
      ii = function ii(e) {
    if ($t(e)) return e;
    throw ti(ei(e) + " is not an object");
  },
      ni = N,
      si = wt,
      ri = Zt,
      oi = ii,
      ai = Ct,
      ci = TypeError,
      di = Object.defineProperty,
      li = Object.getOwnPropertyDescriptor,
      ui = "enumerable",
      hi = "configurable",
      pi = "writable";

  Qt.f = ni ? ri ? function (e, t, i) {
    if (oi(e), t = ai(t), oi(i), "function" == typeof e && "prototype" === t && "value" in i && pi in i && !i[pi]) {
      var n = li(e, t);
      n && n[pi] && (e[t] = i.value, i = {
        configurable: hi in i ? i[hi] : n[hi],
        enumerable: ui in i ? i[ui] : n[ui],
        writable: !1
      });
    }

    return di(e, t, i);
  } : di : function (e, t, i) {
    if (oi(e), t = ai(t), oi(i), si) try {
      return di(e, t, i);
    } catch (e) {}
    if ("get" in i || "set" in i) throw ci("Accessors not supported");
    return "value" in i && (e[t] = i.value), e;
  };

  var _i = Qt,
      Ei = B,
      mi = N ? function (e, t, i) {
    return _i.f(e, t, Ei(1, i));
  } : function (e, t, i) {
    return e[t] = i, e;
  },
      fi = h,
      Ti = f,
      gi = v,
      Si = w,
      Ri = O.f,
      Ci = Yt,
      Ii = ie,
      vi = Xt,
      yi = mi,
      Ai = Ze,
      bi = function bi(e) {
    var t = function t(i, n, s) {
      if (this instanceof t) {
        switch (arguments.length) {
          case 0:
            return new e();

          case 1:
            return new e(i);

          case 2:
            return new e(i, n);
        }

        return new e(i, n, s);
      }

      return Ti(e, this, arguments);
    };

    return t.prototype = e.prototype, t;
  },
      wi = function wi(e, t) {
    var i,
        n,
        s,
        r,
        o,
        a,
        c,
        d,
        l,
        u = e.target,
        h = e.global,
        p = e.stat,
        _ = e.proto,
        E = h ? fi : p ? fi[u] : (fi[u] || {}).prototype,
        m = h ? Ii : Ii[u] || yi(Ii, u, {})[u],
        f = m.prototype;

    for (r in t) {
      n = !(i = Ci(h ? r : u + (p ? "." : "#") + r, e.forced)) && E && Ai(E, r), a = m[r], n && (c = e.dontCallGetSet ? (l = Ri(E, r)) && l.value : E[r]), o = n && c ? c : t[r], n && _typeof(a) == _typeof(o) || (d = e.bind && n ? vi(o, fi) : e.wrap && n ? bi(o) : _ && Si(o) ? gi(o) : o, (e.sham || o && o.sham || a && a.sham) && yi(d, "sham", !0), yi(m, r, d), _ && (Ai(Ii, s = u + "Prototype") || yi(Ii, s, {}), yi(Ii[s], r, o), e.real && f && (i || !f[r]) && yi(f, r, o)));
    }
  },
      Oi = Math.ceil,
      Ni = Math.floor,
      Di = Math.trunc || function (e) {
    var t = +e;
    return (t > 0 ? Ni : Oi)(t);
  },
      Pi = function Pi(e) {
    var t = +e;
    return t != t || 0 === t ? 0 : Di(t);
  },
      Li = Pi,
      ki = Math.max,
      Mi = Math.min,
      Ui = function Ui(e, t) {
    var i = Li(e);
    return i < 0 ? ki(i + t, 0) : Mi(i, t);
  },
      xi = Pi,
      Vi = Math.min,
      Fi = function Fi(e) {
    return e > 0 ? Vi(xi(e), 9007199254740991) : 0;
  },
      Bi = function Bi(e) {
    return Fi(e.length);
  },
      ji = Z,
      Gi = Ui,
      Wi = Bi,
      Hi = function Hi(e) {
    return function (t, i, n) {
      var s,
          r = ji(t),
          o = Wi(r),
          a = Gi(n, o);

      if (e && i != i) {
        for (; o > a;) {
          if ((s = r[a++]) != s) return !0;
        }
      } else for (; o > a; a++) {
        if ((e || a in r) && r[a] === i) return e || a || 0;
      }

      return !e && -1;
    };
  },
      Ki = {
    includes: Hi(!0),
    indexOf: Hi(!1)
  },
      Yi = Ki.includes;

  wi({
    target: "Array",
    proto: !0,
    forced: n(function () {
      return !Array(1).includes();
    })
  }, {
    includes: function includes(e) {
      return Yi(this, e, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var qi = ie,
      Ji = function Ji(e) {
    return qi[e + "Prototype"];
  },
      zi = Ji("Array").includes,
      Xi = te,
      Qi = R,
      Zi = ht("match"),
      $i = function $i(e) {
    var t;
    return Xi(e) && (void 0 !== (t = e[Zi]) ? !!t : "RegExp" == Qi(e));
  },
      en = TypeError,
      tn = {};

  tn[ht("toStringTag")] = "z";

  var nn = "[object z]" === String(tn),
      sn = nn,
      rn = w,
      on = R,
      an = ht("toStringTag"),
      cn = Object,
      dn = "Arguments" == on(function () {
    return arguments;
  }()),
      ln = sn ? on : function (e) {
    var t, i, n;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (i = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = cn(e), an)) ? i : dn ? on(t) : "Object" == (n = on(t)) && rn(t.callee) ? "Arguments" : n;
  },
      un = ln,
      hn = String,
      pn = function pn(e) {
    if ("Symbol" === un(e)) throw TypeError("Cannot convert a Symbol value to a string");
    return hn(e);
  },
      _n = ht("match"),
      En = wi,
      mn = function mn(e) {
    if ($i(e)) throw en("The method doesn't accept regular expressions");
    return e;
  },
      fn = z,
      Tn = pn,
      gn = function gn(e) {
    var t = /./;

    try {
      "/./"[e](t);
    } catch (i) {
      try {
        return t[_n] = !1, "/./"[e](t);
      } catch (e) {}
    }

    return !1;
  },
      Sn = d("".indexOf);

  En({
    target: "String",
    proto: !0,
    forced: !gn("includes")
  }, {
    includes: function includes(e) {
      return !!~Sn(Tn(fn(this)), Tn(mn(e)), arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var Rn = Ji("String").includes,
      Cn = l,
      In = zi,
      vn = Rn,
      yn = Array.prototype,
      An = String.prototype,
      bn = i(function (e) {
    var t = e.includes;
    return e === yn || Cn(yn, e) && t === yn.includes ? In : "string" == typeof e || e === An || Cn(An, e) && t === An.includes ? vn : t;
  });
  var wn = !0,
      On = !0;

  function Nn(e, t, i) {
    var n = e.match(t);
    return n && n.length >= i && parseInt(n[i], 10);
  }

  function Dn(e, t, i) {
    if (!e.RTCPeerConnection) return;
    var n = e.RTCPeerConnection.prototype,
        s = n.addEventListener;

    n.addEventListener = function (e, n) {
      if (e !== t) return s.apply(this, arguments);

      var r = function r(e) {
        var t = i(e);
        t && (n.handleEvent ? n.handleEvent(t) : n(t));
      };

      return this._eventMap = this._eventMap || {}, this._eventMap[t] || (this._eventMap[t] = new Map()), this._eventMap[t].set(n, r), s.apply(this, [e, r]);
    };

    var r = n.removeEventListener;
    n.removeEventListener = function (e, i) {
      if (e !== t || !this._eventMap || !this._eventMap[t]) return r.apply(this, arguments);
      if (!this._eventMap[t].has(i)) return r.apply(this, arguments);

      var n = this._eventMap[t].get(i);

      return this._eventMap[t].delete(i), 0 === this._eventMap[t].size && delete this._eventMap[t], 0 === Object.keys(this._eventMap).length && delete this._eventMap, r.apply(this, [e, n]);
    }, Object.defineProperty(n, "on" + t, {
      get: function get() {
        return this["_on" + t];
      },
      set: function set(e) {
        this["_on" + t] && (this.removeEventListener(t, this["_on" + t]), delete this["_on" + t]), e && this.addEventListener(t, this["_on" + t] = e);
      },
      enumerable: !0,
      configurable: !0
    });
  }

  function Pn(e) {
    return "boolean" != typeof e ? new Error("Argument type: " + _typeof(e) + ". Please use a boolean.") : (wn = e, e ? "adapter.js logging disabled" : "adapter.js logging enabled");
  }

  function Ln(e) {
    return "boolean" != typeof e ? new Error("Argument type: " + _typeof(e) + ". Please use a boolean.") : (On = !e, "adapter.js deprecation warnings " + (e ? "disabled" : "enabled"));
  }

  function kn() {
    if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) {
      if (wn) return;
      "undefined" != typeof console && "function" == typeof console.log && console.log.apply(console, arguments);
    }
  }

  function Mn(e, t) {
    On && console.warn(e + " is deprecated, please use " + t + " instead.");
  }

  function Un(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }

  function xn(e) {
    return Un(e) ? Object.keys(e).reduce(function (t, i) {
      var n = Un(e[i]),
          s = n ? xn(e[i]) : e[i],
          r = n && !Object.keys(s).length;
      return void 0 === s || r ? t : Object.assign(t, _defineProperty({}, i, s));
    }, {}) : e;
  }

  function Vn(e, t, i) {
    t && !i.has(t.id) && (i.set(t.id, t), Object.keys(t).forEach(function (n) {
      n.endsWith("Id") ? Vn(e, e.get(t[n]), i) : n.endsWith("Ids") && t[n].forEach(function (t) {
        Vn(e, e.get(t), i);
      });
    }));
  }

  function Fn(e, t, i) {
    var n = i ? "outbound-rtp" : "inbound-rtp",
        s = new Map();
    if (null === t) return s;
    var r = [];
    return e.forEach(function (e) {
      "track" === e.type && e.trackIdentifier === t.id && r.push(e);
    }), r.forEach(function (t) {
      e.forEach(function (i) {
        i.type === n && i.trackId === t.id && Vn(e, i, s);
      });
    }), s;
  }

  var Bn = kn;

  function jn(e, t) {
    var i = e && e.navigator;
    if (!i.mediaDevices) return;

    var n = function n(e) {
      if ("object" != _typeof(e) || e.mandatory || e.optional) return e;
      var t = {};
      return Object.keys(e).forEach(function (i) {
        if ("require" === i || "advanced" === i || "mediaSource" === i) return;
        var n = "object" == _typeof(e[i]) ? e[i] : {
          ideal: e[i]
        };
        void 0 !== n.exact && "number" == typeof n.exact && (n.min = n.max = n.exact);

        var s = function s(e, t) {
          return e ? e + t.charAt(0).toUpperCase() + t.slice(1) : "deviceId" === t ? "sourceId" : t;
        };

        if (void 0 !== n.ideal) {
          t.optional = t.optional || [];
          var _e2 = {};
          "number" == typeof n.ideal ? (_e2[s("min", i)] = n.ideal, t.optional.push(_e2), _e2 = {}, _e2[s("max", i)] = n.ideal, t.optional.push(_e2)) : (_e2[s("", i)] = n.ideal, t.optional.push(_e2));
        }

        void 0 !== n.exact && "number" != typeof n.exact ? (t.mandatory = t.mandatory || {}, t.mandatory[s("", i)] = n.exact) : ["min", "max"].forEach(function (e) {
          void 0 !== n[e] && (t.mandatory = t.mandatory || {}, t.mandatory[s(e, i)] = n[e]);
        });
      }), e.advanced && (t.optional = (t.optional || []).concat(e.advanced)), t;
    },
        s = function s(e, _s2) {
      if (t.version >= 61) return _s2(e);

      if ((e = JSON.parse(JSON.stringify(e))) && "object" == _typeof(e.audio)) {
        var _t2 = function _t2(e, t, i) {
          t in e && !(i in e) && (e[i] = e[t], delete e[t]);
        };

        _t2((e = JSON.parse(JSON.stringify(e))).audio, "autoGainControl", "googAutoGainControl"), _t2(e.audio, "noiseSuppression", "googNoiseSuppression"), e.audio = n(e.audio);
      }

      if (e && "object" == _typeof(e.video)) {
        var _r2 = e.video.facingMode;
        _r2 = _r2 && ("object" == _typeof(_r2) ? _r2 : {
          ideal: _r2
        });

        var _o2 = t.version < 66;

        if (_r2 && ("user" === _r2.exact || "environment" === _r2.exact || "user" === _r2.ideal || "environment" === _r2.ideal) && (!i.mediaDevices.getSupportedConstraints || !i.mediaDevices.getSupportedConstraints().facingMode || _o2)) {
          var _t3;

          if (delete e.video.facingMode, "environment" === _r2.exact || "environment" === _r2.ideal ? _t3 = ["back", "rear"] : "user" !== _r2.exact && "user" !== _r2.ideal || (_t3 = ["front"]), _t3) return i.mediaDevices.enumerateDevices().then(function (i) {
            var o = (i = i.filter(function (e) {
              return "videoinput" === e.kind;
            })).find(function (e) {
              return _t3.some(function (t) {
                return e.label.toLowerCase().includes(t);
              });
            });
            return !o && i.length && _t3.includes("back") && (o = i[i.length - 1]), o && (e.video.deviceId = _r2.exact ? {
              exact: o.deviceId
            } : {
              ideal: o.deviceId
            }), e.video = n(e.video), Bn("chrome: " + JSON.stringify(e)), _s2(e);
          });
        }

        e.video = n(e.video);
      }

      return Bn("chrome: " + JSON.stringify(e)), _s2(e);
    },
        r = function r(e) {
      return t.version >= 64 ? e : {
        name: {
          PermissionDeniedError: "NotAllowedError",
          PermissionDismissedError: "NotAllowedError",
          InvalidStateError: "NotAllowedError",
          DevicesNotFoundError: "NotFoundError",
          ConstraintNotSatisfiedError: "OverconstrainedError",
          TrackStartError: "NotReadableError",
          MediaDeviceFailedDueToShutdown: "NotAllowedError",
          MediaDeviceKillSwitchOn: "NotAllowedError",
          TabCaptureError: "AbortError",
          ScreenCaptureError: "AbortError",
          DeviceCaptureError: "AbortError"
        }[e.name] || e.name,
        message: e.message,
        constraint: e.constraint || e.constraintName,
        toString: function toString() {
          return this.name + (this.message && ": ") + this.message;
        }
      };
    };

    if (i.getUserMedia = function (e, t, n) {
      s(e, function (e) {
        i.webkitGetUserMedia(e, t, function (e) {
          n && n(r(e));
        });
      });
    }.bind(i), i.mediaDevices.getUserMedia) {
      var _e3 = i.mediaDevices.getUserMedia.bind(i.mediaDevices);

      i.mediaDevices.getUserMedia = function (t) {
        return s(t, function (t) {
          return _e3(t).then(function (e) {
            if (t.audio && !e.getAudioTracks().length || t.video && !e.getVideoTracks().length) throw e.getTracks().forEach(function (e) {
              e.stop();
            }), new DOMException("", "NotFoundError");
            return e;
          }, function (e) {
            return Promise.reject(r(e));
          });
        });
      };
    }
  }

  function Gn(e) {
    e.MediaStream = e.MediaStream || e.webkitMediaStream;
  }

  function Wn(e) {
    if ("object" == _typeof(e) && e.RTCPeerConnection && !("ontrack" in e.RTCPeerConnection.prototype)) {
      Object.defineProperty(e.RTCPeerConnection.prototype, "ontrack", {
        get: function get() {
          return this._ontrack;
        },
        set: function set(e) {
          this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = e);
        },
        enumerable: !0,
        configurable: !0
      });
      var _t4 = e.RTCPeerConnection.prototype.setRemoteDescription;

      e.RTCPeerConnection.prototype.setRemoteDescription = function () {
        var _this = this;

        return this._ontrackpoly || (this._ontrackpoly = function (t) {
          t.stream.addEventListener("addtrack", function (i) {
            var n;
            n = e.RTCPeerConnection.prototype.getReceivers ? _this.getReceivers().find(function (e) {
              return e.track && e.track.id === i.track.id;
            }) : {
              track: i.track
            };
            var s = new Event("track");
            s.track = i.track, s.receiver = n, s.transceiver = {
              receiver: n
            }, s.streams = [t.stream], _this.dispatchEvent(s);
          }), t.stream.getTracks().forEach(function (i) {
            var n;
            n = e.RTCPeerConnection.prototype.getReceivers ? _this.getReceivers().find(function (e) {
              return e.track && e.track.id === i.id;
            }) : {
              track: i
            };
            var s = new Event("track");
            s.track = i, s.receiver = n, s.transceiver = {
              receiver: n
            }, s.streams = [t.stream], _this.dispatchEvent(s);
          });
        }, this.addEventListener("addstream", this._ontrackpoly)), _t4.apply(this, arguments);
      };
    } else Dn(e, "track", function (e) {
      return e.transceiver || Object.defineProperty(e, "transceiver", {
        value: {
          receiver: e.receiver
        }
      }), e;
    });
  }

  function Hn(e) {
    if ("object" == _typeof(e) && e.RTCPeerConnection && !("getSenders" in e.RTCPeerConnection.prototype) && "createDTMFSender" in e.RTCPeerConnection.prototype) {
      var _t5 = function _t5(e, t) {
        return {
          track: t,

          get dtmf() {
            return void 0 === this._dtmf && ("audio" === t.kind ? this._dtmf = e.createDTMFSender(t) : this._dtmf = null), this._dtmf;
          },

          _pc: e
        };
      };

      if (!e.RTCPeerConnection.prototype.getSenders) {
        e.RTCPeerConnection.prototype.getSenders = function () {
          return this._senders = this._senders || [], this._senders.slice();
        };

        var _i3 = e.RTCPeerConnection.prototype.addTrack;

        e.RTCPeerConnection.prototype.addTrack = function (e, n) {
          var s = _i3.apply(this, arguments);

          return s || (s = _t5(this, e), this._senders.push(s)), s;
        };

        var _n3 = e.RTCPeerConnection.prototype.removeTrack;

        e.RTCPeerConnection.prototype.removeTrack = function (e) {
          _n3.apply(this, arguments);

          var t = this._senders.indexOf(e);

          -1 !== t && this._senders.splice(t, 1);
        };
      }

      var _i2 = e.RTCPeerConnection.prototype.addStream;

      e.RTCPeerConnection.prototype.addStream = function (e) {
        var _this2 = this;

        this._senders = this._senders || [], _i2.apply(this, [e]), e.getTracks().forEach(function (e) {
          _this2._senders.push(_t5(_this2, e));
        });
      };

      var _n2 = e.RTCPeerConnection.prototype.removeStream;

      e.RTCPeerConnection.prototype.removeStream = function (e) {
        var _this3 = this;

        this._senders = this._senders || [], _n2.apply(this, [e]), e.getTracks().forEach(function (e) {
          var t = _this3._senders.find(function (t) {
            return t.track === e;
          });

          t && _this3._senders.splice(_this3._senders.indexOf(t), 1);
        });
      };
    } else if ("object" == _typeof(e) && e.RTCPeerConnection && "getSenders" in e.RTCPeerConnection.prototype && "createDTMFSender" in e.RTCPeerConnection.prototype && e.RTCRtpSender && !("dtmf" in e.RTCRtpSender.prototype)) {
      var _t6 = e.RTCPeerConnection.prototype.getSenders;
      e.RTCPeerConnection.prototype.getSenders = function () {
        var _this4 = this;

        var e = _t6.apply(this, []);

        return e.forEach(function (e) {
          return e._pc = _this4;
        }), e;
      }, Object.defineProperty(e.RTCRtpSender.prototype, "dtmf", {
        get: function get() {
          return void 0 === this._dtmf && ("audio" === this.track.kind ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
        }
      });
    }
  }

  function Kn(e) {
    if (!e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection.prototype.getStats;

    e.RTCPeerConnection.prototype.getStats = function () {
      var _this5 = this;

      var _arguments = Array.prototype.slice.call(arguments),
          e = _arguments[0],
          i = _arguments[1],
          n = _arguments[2];

      if (arguments.length > 0 && "function" == typeof e) return t.apply(this, arguments);
      if (0 === t.length && (0 === arguments.length || "function" != typeof e)) return t.apply(this, []);

      var s = function s(e) {
        var t = {};
        return e.result().forEach(function (e) {
          var i = {
            id: e.id,
            timestamp: e.timestamp,
            type: {
              localcandidate: "local-candidate",
              remotecandidate: "remote-candidate"
            }[e.type] || e.type
          };
          e.names().forEach(function (t) {
            i[t] = e.stat(t);
          }), t[i.id] = i;
        }), t;
      },
          r = function r(e) {
        return new Map(Object.keys(e).map(function (t) {
          return [t, e[t]];
        }));
      };

      if (arguments.length >= 2) {
        var _n4 = function _n4(e) {
          i(r(s(e)));
        };

        return t.apply(this, [_n4, e]);
      }

      return new Promise(function (e, i) {
        t.apply(_this5, [function (t) {
          e(r(s(t)));
        }, i]);
      }).then(i, n);
    };
  }

  function Yn(e) {
    if (!("object" == _typeof(e) && e.RTCPeerConnection && e.RTCRtpSender && e.RTCRtpReceiver)) return;

    if (!("getStats" in e.RTCRtpSender.prototype)) {
      var _t7 = e.RTCPeerConnection.prototype.getSenders;
      _t7 && (e.RTCPeerConnection.prototype.getSenders = function () {
        var _this6 = this;

        var e = _t7.apply(this, []);

        return e.forEach(function (e) {
          return e._pc = _this6;
        }), e;
      });
      var _i4 = e.RTCPeerConnection.prototype.addTrack;
      _i4 && (e.RTCPeerConnection.prototype.addTrack = function () {
        var e = _i4.apply(this, arguments);

        return e._pc = this, e;
      }), e.RTCRtpSender.prototype.getStats = function () {
        var e = this;
        return this._pc.getStats().then(function (t) {
          return Fn(t, e.track, !0);
        });
      };
    }

    if (!("getStats" in e.RTCRtpReceiver.prototype)) {
      var _t8 = e.RTCPeerConnection.prototype.getReceivers;
      _t8 && (e.RTCPeerConnection.prototype.getReceivers = function () {
        var _this7 = this;

        var e = _t8.apply(this, []);

        return e.forEach(function (e) {
          return e._pc = _this7;
        }), e;
      }), Dn(e, "track", function (e) {
        return e.receiver._pc = e.srcElement, e;
      }), e.RTCRtpReceiver.prototype.getStats = function () {
        var e = this;
        return this._pc.getStats().then(function (t) {
          return Fn(t, e.track, !1);
        });
      };
    }

    if (!("getStats" in e.RTCRtpSender.prototype) || !("getStats" in e.RTCRtpReceiver.prototype)) return;
    var t = e.RTCPeerConnection.prototype.getStats;

    e.RTCPeerConnection.prototype.getStats = function () {
      if (arguments.length > 0 && arguments[0] instanceof e.MediaStreamTrack) {
        var _e4 = arguments[0];

        var _t9, _i5, _n5;

        return this.getSenders().forEach(function (i) {
          i.track === _e4 && (_t9 ? _n5 = !0 : _t9 = i);
        }), this.getReceivers().forEach(function (t) {
          return t.track === _e4 && (_i5 ? _n5 = !0 : _i5 = t), t.track === _e4;
        }), _n5 || _t9 && _i5 ? Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError")) : _t9 ? _t9.getStats() : _i5 ? _i5.getStats() : Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
      }

      return t.apply(this, arguments);
    };
  }

  function qn(e) {
    e.RTCPeerConnection.prototype.getLocalStreams = function () {
      var _this8 = this;

      return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map(function (e) {
        return _this8._shimmedLocalStreams[e][0];
      });
    };

    var t = e.RTCPeerConnection.prototype.addTrack;

    e.RTCPeerConnection.prototype.addTrack = function (e, i) {
      if (!i) return t.apply(this, arguments);
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      var n = t.apply(this, arguments);
      return this._shimmedLocalStreams[i.id] ? -1 === this._shimmedLocalStreams[i.id].indexOf(n) && this._shimmedLocalStreams[i.id].push(n) : this._shimmedLocalStreams[i.id] = [i, n], n;
    };

    var i = e.RTCPeerConnection.prototype.addStream;

    e.RTCPeerConnection.prototype.addStream = function (e) {
      var _this9 = this;

      this._shimmedLocalStreams = this._shimmedLocalStreams || {}, e.getTracks().forEach(function (e) {
        if (_this9.getSenders().find(function (t) {
          return t.track === e;
        })) throw new DOMException("Track already exists.", "InvalidAccessError");
      });
      var t = this.getSenders();
      i.apply(this, arguments);
      var n = this.getSenders().filter(function (e) {
        return -1 === t.indexOf(e);
      });
      this._shimmedLocalStreams[e.id] = [e].concat(n);
    };

    var n = e.RTCPeerConnection.prototype.removeStream;

    e.RTCPeerConnection.prototype.removeStream = function (e) {
      return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[e.id], n.apply(this, arguments);
    };

    var s = e.RTCPeerConnection.prototype.removeTrack;

    e.RTCPeerConnection.prototype.removeTrack = function (e) {
      var _this10 = this;

      return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, e && Object.keys(this._shimmedLocalStreams).forEach(function (t) {
        var i = _this10._shimmedLocalStreams[t].indexOf(e);

        -1 !== i && _this10._shimmedLocalStreams[t].splice(i, 1), 1 === _this10._shimmedLocalStreams[t].length && delete _this10._shimmedLocalStreams[t];
      }), s.apply(this, arguments);
    };
  }

  function Jn(e, t) {
    if (!e.RTCPeerConnection) return;
    if (e.RTCPeerConnection.prototype.addTrack && t.version >= 65) return qn(e);
    var i = e.RTCPeerConnection.prototype.getLocalStreams;

    e.RTCPeerConnection.prototype.getLocalStreams = function () {
      var _this11 = this;

      var e = i.apply(this);
      return this._reverseStreams = this._reverseStreams || {}, e.map(function (e) {
        return _this11._reverseStreams[e.id];
      });
    };

    var n = e.RTCPeerConnection.prototype.addStream;

    e.RTCPeerConnection.prototype.addStream = function (t) {
      var _this12 = this;

      if (this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, t.getTracks().forEach(function (e) {
        if (_this12.getSenders().find(function (t) {
          return t.track === e;
        })) throw new DOMException("Track already exists.", "InvalidAccessError");
      }), !this._reverseStreams[t.id]) {
        var _i6 = new e.MediaStream(t.getTracks());

        this._streams[t.id] = _i6, this._reverseStreams[_i6.id] = t, t = _i6;
      }

      n.apply(this, [t]);
    };

    var s = e.RTCPeerConnection.prototype.removeStream;

    function r(e, t) {
      var i = t.sdp;
      return Object.keys(e._reverseStreams || []).forEach(function (t) {
        var n = e._reverseStreams[t],
            s = e._streams[n.id];
        i = i.replace(new RegExp(s.id, "g"), n.id);
      }), new RTCSessionDescription({
        type: t.type,
        sdp: i
      });
    }

    e.RTCPeerConnection.prototype.removeStream = function (e) {
      this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, s.apply(this, [this._streams[e.id] || e]), delete this._reverseStreams[this._streams[e.id] ? this._streams[e.id].id : e.id], delete this._streams[e.id];
    }, e.RTCPeerConnection.prototype.addTrack = function (t, i) {
      var _this13 = this;

      if ("closed" === this.signalingState) throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
      var n = [].slice.call(arguments, 1);
      if (1 !== n.length || !n[0].getTracks().find(function (e) {
        return e === t;
      })) throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
      if (this.getSenders().find(function (e) {
        return e.track === t;
      })) throw new DOMException("Track already exists.", "InvalidAccessError");
      this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {};
      var s = this._streams[i.id];
      if (s) s.addTrack(t), Promise.resolve().then(function () {
        _this13.dispatchEvent(new Event("negotiationneeded"));
      });else {
        var _n6 = new e.MediaStream([t]);

        this._streams[i.id] = _n6, this._reverseStreams[_n6.id] = i, this.addStream(_n6);
      }
      return this.getSenders().find(function (e) {
        return e.track === t;
      });
    }, ["createOffer", "createAnswer"].forEach(function (t) {
      var i = e.RTCPeerConnection.prototype[t],
          n = _defineProperty({}, t, function () {
        var _this14 = this;

        var e = arguments;
        return arguments.length && "function" == typeof arguments[0] ? i.apply(this, [function (t) {
          var i = r(_this14, t);
          e[0].apply(null, [i]);
        }, function (t) {
          e[1] && e[1].apply(null, t);
        }, arguments[2]]) : i.apply(this, arguments).then(function (e) {
          return r(_this14, e);
        });
      });

      e.RTCPeerConnection.prototype[t] = n[t];
    });
    var o = e.RTCPeerConnection.prototype.setLocalDescription;

    e.RTCPeerConnection.prototype.setLocalDescription = function () {
      return arguments.length && arguments[0].type ? (arguments[0] = function (e, t) {
        var i = t.sdp;
        return Object.keys(e._reverseStreams || []).forEach(function (t) {
          var n = e._reverseStreams[t],
              s = e._streams[n.id];
          i = i.replace(new RegExp(n.id, "g"), s.id);
        }), new RTCSessionDescription({
          type: t.type,
          sdp: i
        });
      }(this, arguments[0]), o.apply(this, arguments)) : o.apply(this, arguments);
    };

    var a = Object.getOwnPropertyDescriptor(e.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(e.RTCPeerConnection.prototype, "localDescription", {
      get: function get() {
        var e = a.get.apply(this);
        return "" === e.type ? e : r(this, e);
      }
    }), e.RTCPeerConnection.prototype.removeTrack = function (e) {
      var _this15 = this;

      if ("closed" === this.signalingState) throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
      if (!e._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
      if (!(e._pc === this)) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
      var t;
      this._streams = this._streams || {}, Object.keys(this._streams).forEach(function (i) {
        _this15._streams[i].getTracks().find(function (t) {
          return e.track === t;
        }) && (t = _this15._streams[i]);
      }), t && (1 === t.getTracks().length ? this.removeStream(this._reverseStreams[t.id]) : t.removeTrack(e.track), this.dispatchEvent(new Event("negotiationneeded")));
    };
  }

  function zn(e, t) {
    !e.RTCPeerConnection && e.webkitRTCPeerConnection && (e.RTCPeerConnection = e.webkitRTCPeerConnection), e.RTCPeerConnection && t.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function (t) {
      var i = e.RTCPeerConnection.prototype[t],
          n = _defineProperty({}, t, function () {
        return arguments[0] = new ("addIceCandidate" === t ? e.RTCIceCandidate : e.RTCSessionDescription)(arguments[0]), i.apply(this, arguments);
      });

      e.RTCPeerConnection.prototype[t] = n[t];
    });
  }

  function Xn(e, t) {
    Dn(e, "negotiationneeded", function (e) {
      var i = e.target;
      if (!(t.version < 72 || i.getConfiguration && "plan-b" === i.getConfiguration().sdpSemantics) || "stable" === i.signalingState) return e;
    });
  }

  var Qn = Object.freeze({
    __proto__: null,
    fixNegotiationNeeded: Xn,
    shimAddTrackRemoveTrack: Jn,
    shimAddTrackRemoveTrackWithNative: qn,
    shimGetDisplayMedia: function shimGetDisplayMedia(e, t) {
      e.navigator.mediaDevices && "getDisplayMedia" in e.navigator.mediaDevices || e.navigator.mediaDevices && ("function" == typeof t ? e.navigator.mediaDevices.getDisplayMedia = function (i) {
        return t(i).then(function (t) {
          var n = i.video && i.video.width,
              s = i.video && i.video.height,
              r = i.video && i.video.frameRate;
          return i.video = {
            mandatory: {
              chromeMediaSource: "desktop",
              chromeMediaSourceId: t,
              maxFrameRate: r || 3
            }
          }, n && (i.video.mandatory.maxWidth = n), s && (i.video.mandatory.maxHeight = s), e.navigator.mediaDevices.getUserMedia(i);
        });
      } : console.error("shimGetDisplayMedia: getSourceId argument is not a function"));
    },
    shimGetSendersWithDtmf: Hn,
    shimGetStats: Kn,
    shimGetUserMedia: jn,
    shimMediaStream: Gn,
    shimOnTrack: Wn,
    shimPeerConnection: zn,
    shimSenderReceiverGetStats: Yn
  });

  function Zn(e, t) {
    var i = e && e.navigator,
        n = e && e.MediaStreamTrack;

    if (i.getUserMedia = function (e, t, n) {
      Mn("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia"), i.mediaDevices.getUserMedia(e).then(t, n);
    }, !(t.version > 55 && "autoGainControl" in i.mediaDevices.getSupportedConstraints())) {
      var _e5 = function _e5(e, t, i) {
        t in e && !(i in e) && (e[i] = e[t], delete e[t]);
      },
          _t10 = i.mediaDevices.getUserMedia.bind(i.mediaDevices);

      if (i.mediaDevices.getUserMedia = function (i) {
        return "object" == _typeof(i) && "object" == _typeof(i.audio) && (i = JSON.parse(JSON.stringify(i)), _e5(i.audio, "autoGainControl", "mozAutoGainControl"), _e5(i.audio, "noiseSuppression", "mozNoiseSuppression")), _t10(i);
      }, n && n.prototype.getSettings) {
        var _t11 = n.prototype.getSettings;

        n.prototype.getSettings = function () {
          var i = _t11.apply(this, arguments);

          return _e5(i, "mozAutoGainControl", "autoGainControl"), _e5(i, "mozNoiseSuppression", "noiseSuppression"), i;
        };
      }

      if (n && n.prototype.applyConstraints) {
        var _t12 = n.prototype.applyConstraints;

        n.prototype.applyConstraints = function (i) {
          return "audio" === this.kind && "object" == _typeof(i) && (i = JSON.parse(JSON.stringify(i)), _e5(i, "autoGainControl", "mozAutoGainControl"), _e5(i, "noiseSuppression", "mozNoiseSuppression")), _t12.apply(this, [i]);
        };
      }
    }
  }

  function $n(e) {
    "object" == _typeof(e) && e.RTCTrackEvent && "receiver" in e.RTCTrackEvent.prototype && !("transceiver" in e.RTCTrackEvent.prototype) && Object.defineProperty(e.RTCTrackEvent.prototype, "transceiver", {
      get: function get() {
        return {
          receiver: this.receiver
        };
      }
    });
  }

  function es(e, t) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection && !e.mozRTCPeerConnection) return;
    !e.RTCPeerConnection && e.mozRTCPeerConnection && (e.RTCPeerConnection = e.mozRTCPeerConnection), t.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function (t) {
      var i = e.RTCPeerConnection.prototype[t],
          n = _defineProperty({}, t, function () {
        return arguments[0] = new ("addIceCandidate" === t ? e.RTCIceCandidate : e.RTCSessionDescription)(arguments[0]), i.apply(this, arguments);
      });

      e.RTCPeerConnection.prototype[t] = n[t];
    });
    var i = {
      inboundrtp: "inbound-rtp",
      outboundrtp: "outbound-rtp",
      candidatepair: "candidate-pair",
      localcandidate: "local-candidate",
      remotecandidate: "remote-candidate"
    },
        n = e.RTCPeerConnection.prototype.getStats;

    e.RTCPeerConnection.prototype.getStats = function () {
      var _arguments2 = Array.prototype.slice.call(arguments),
          e = _arguments2[0],
          s = _arguments2[1],
          r = _arguments2[2];

      return n.apply(this, [e || null]).then(function (e) {
        if (t.version < 53 && !s) try {
          e.forEach(function (e) {
            e.type = i[e.type] || e.type;
          });
        } catch (t) {
          if ("TypeError" !== t.name) throw t;
          e.forEach(function (t, n) {
            e.set(n, Object.assign({}, t, {
              type: i[t.type] || t.type
            }));
          });
        }
        return e;
      }).then(s, r);
    };
  }

  function ts(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection || !e.RTCRtpSender) return;
    if (e.RTCRtpSender && "getStats" in e.RTCRtpSender.prototype) return;
    var t = e.RTCPeerConnection.prototype.getSenders;
    t && (e.RTCPeerConnection.prototype.getSenders = function () {
      var _this16 = this;

      var e = t.apply(this, []);
      return e.forEach(function (e) {
        return e._pc = _this16;
      }), e;
    });
    var i = e.RTCPeerConnection.prototype.addTrack;
    i && (e.RTCPeerConnection.prototype.addTrack = function () {
      var e = i.apply(this, arguments);
      return e._pc = this, e;
    }), e.RTCRtpSender.prototype.getStats = function () {
      return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
  }

  function is(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection || !e.RTCRtpSender) return;
    if (e.RTCRtpSender && "getStats" in e.RTCRtpReceiver.prototype) return;
    var t = e.RTCPeerConnection.prototype.getReceivers;
    t && (e.RTCPeerConnection.prototype.getReceivers = function () {
      var _this17 = this;

      var e = t.apply(this, []);
      return e.forEach(function (e) {
        return e._pc = _this17;
      }), e;
    }), Dn(e, "track", function (e) {
      return e.receiver._pc = e.srcElement, e;
    }), e.RTCRtpReceiver.prototype.getStats = function () {
      return this._pc.getStats(this.track);
    };
  }

  function ns(e) {
    e.RTCPeerConnection && !("removeStream" in e.RTCPeerConnection.prototype) && (e.RTCPeerConnection.prototype.removeStream = function (e) {
      var _this18 = this;

      Mn("removeStream", "removeTrack"), this.getSenders().forEach(function (t) {
        t.track && e.getTracks().includes(t.track) && _this18.removeTrack(t);
      });
    });
  }

  function ss(e) {
    e.DataChannel && !e.RTCDataChannel && (e.RTCDataChannel = e.DataChannel);
  }

  function rs(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection.prototype.addTransceiver;
    t && (e.RTCPeerConnection.prototype.addTransceiver = function () {
      this.setParametersPromises = [];
      var e = arguments[1] && arguments[1].sendEncodings;
      void 0 === e && (e = []), e = _toConsumableArray(e);
      var i = e.length > 0;
      i && e.forEach(function (e) {
        if ("rid" in e) {
          if (!/^[a-z0-9]{0,16}$/i.test(e.rid)) throw new TypeError("Invalid RID value provided.");
        }

        if ("scaleResolutionDownBy" in e && !(parseFloat(e.scaleResolutionDownBy) >= 1)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
        if ("maxFramerate" in e && !(parseFloat(e.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
      });
      var n = t.apply(this, arguments);

      if (i) {
        var _t13 = n.sender,
            _i7 = _t13.getParameters();

        (!("encodings" in _i7) || 1 === _i7.encodings.length && 0 === Object.keys(_i7.encodings[0]).length) && (_i7.encodings = e, _t13.sendEncodings = e, this.setParametersPromises.push(_t13.setParameters(_i7).then(function () {
          delete _t13.sendEncodings;
        }).catch(function () {
          delete _t13.sendEncodings;
        })));
      }

      return n;
    });
  }

  function os(e) {
    if ("object" != _typeof(e) || !e.RTCRtpSender) return;
    var t = e.RTCRtpSender.prototype.getParameters;
    t && (e.RTCRtpSender.prototype.getParameters = function () {
      var e = t.apply(this, arguments);
      return "encodings" in e || (e.encodings = [].concat(this.sendEncodings || [{}])), e;
    });
  }

  function as(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection.prototype.createOffer;

    e.RTCPeerConnection.prototype.createOffer = function () {
      var _arguments3 = arguments,
          _this19 = this;

      return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(function () {
        return t.apply(_this19, _arguments3);
      }).finally(function () {
        _this19.setParametersPromises = [];
      }) : t.apply(this, arguments);
    };
  }

  function cs(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection.prototype.createAnswer;

    e.RTCPeerConnection.prototype.createAnswer = function () {
      var _arguments4 = arguments,
          _this20 = this;

      return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(function () {
        return t.apply(_this20, _arguments4);
      }).finally(function () {
        _this20.setParametersPromises = [];
      }) : t.apply(this, arguments);
    };
  }

  var ds = Object.freeze({
    __proto__: null,
    shimAddTransceiver: rs,
    shimCreateAnswer: cs,
    shimCreateOffer: as,
    shimGetDisplayMedia: function shimGetDisplayMedia(e, t) {
      e.navigator.mediaDevices && "getDisplayMedia" in e.navigator.mediaDevices || e.navigator.mediaDevices && (e.navigator.mediaDevices.getDisplayMedia = function (i) {
        if (!i || !i.video) {
          var _e6 = new DOMException("getDisplayMedia without video constraints is undefined");

          return _e6.name = "NotFoundError", _e6.code = 8, Promise.reject(_e6);
        }

        return !0 === i.video ? i.video = {
          mediaSource: t
        } : i.video.mediaSource = t, e.navigator.mediaDevices.getUserMedia(i);
      });
    },
    shimGetParameters: os,
    shimGetUserMedia: Zn,
    shimOnTrack: $n,
    shimPeerConnection: es,
    shimRTCDataChannel: ss,
    shimReceiverGetStats: is,
    shimRemoveStream: ns,
    shimSenderGetStats: ts
  });

  function ls(e) {
    if ("object" == _typeof(e) && e.RTCPeerConnection) {
      if ("getLocalStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getLocalStreams = function () {
        return this._localStreams || (this._localStreams = []), this._localStreams;
      }), !("addStream" in e.RTCPeerConnection.prototype)) {
        var _t14 = e.RTCPeerConnection.prototype.addTrack;
        e.RTCPeerConnection.prototype.addStream = function (e) {
          var _this21 = this;

          this._localStreams || (this._localStreams = []), this._localStreams.includes(e) || this._localStreams.push(e), e.getAudioTracks().forEach(function (i) {
            return _t14.call(_this21, i, e);
          }), e.getVideoTracks().forEach(function (i) {
            return _t14.call(_this21, i, e);
          });
        }, e.RTCPeerConnection.prototype.addTrack = function (e) {
          var _this22 = this;

          for (var _len = arguments.length, i = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            i[_key - 1] = arguments[_key];
          }

          return i && i.forEach(function (e) {
            _this22._localStreams ? _this22._localStreams.includes(e) || _this22._localStreams.push(e) : _this22._localStreams = [e];
          }), _t14.apply(this, arguments);
        };
      }

      "removeStream" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.removeStream = function (e) {
        var _this23 = this;

        this._localStreams || (this._localStreams = []);

        var t = this._localStreams.indexOf(e);

        if (-1 === t) return;

        this._localStreams.splice(t, 1);

        var i = e.getTracks();
        this.getSenders().forEach(function (e) {
          i.includes(e.track) && _this23.removeTrack(e);
        });
      });
    }
  }

  function us(e) {
    if ("object" == _typeof(e) && e.RTCPeerConnection && ("getRemoteStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getRemoteStreams = function () {
      return this._remoteStreams ? this._remoteStreams : [];
    }), !("onaddstream" in e.RTCPeerConnection.prototype))) {
      Object.defineProperty(e.RTCPeerConnection.prototype, "onaddstream", {
        get: function get() {
          return this._onaddstream;
        },
        set: function set(e) {
          var _this24 = this;

          this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = e), this.addEventListener("track", this._onaddstreampoly = function (e) {
            e.streams.forEach(function (e) {
              if (_this24._remoteStreams || (_this24._remoteStreams = []), _this24._remoteStreams.includes(e)) return;

              _this24._remoteStreams.push(e);

              var t = new Event("addstream");
              t.stream = e, _this24.dispatchEvent(t);
            });
          });
        }
      });
      var _t15 = e.RTCPeerConnection.prototype.setRemoteDescription;

      e.RTCPeerConnection.prototype.setRemoteDescription = function () {
        var e = this;
        return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function (t) {
          t.streams.forEach(function (t) {
            if (e._remoteStreams || (e._remoteStreams = []), e._remoteStreams.indexOf(t) >= 0) return;

            e._remoteStreams.push(t);

            var i = new Event("addstream");
            i.stream = t, e.dispatchEvent(i);
          });
        }), _t15.apply(e, arguments);
      };
    }
  }

  function hs(e) {
    if ("object" != _typeof(e) || !e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection.prototype,
        i = t.createOffer,
        n = t.createAnswer,
        s = t.setLocalDescription,
        r = t.setRemoteDescription,
        o = t.addIceCandidate;
    t.createOffer = function (e, t) {
      var n = arguments.length >= 2 ? arguments[2] : arguments[0],
          s = i.apply(this, [n]);
      return t ? (s.then(e, t), Promise.resolve()) : s;
    }, t.createAnswer = function (e, t) {
      var i = arguments.length >= 2 ? arguments[2] : arguments[0],
          s = n.apply(this, [i]);
      return t ? (s.then(e, t), Promise.resolve()) : s;
    };

    var a = function a(e, t, i) {
      var n = s.apply(this, [e]);
      return i ? (n.then(t, i), Promise.resolve()) : n;
    };

    t.setLocalDescription = a, a = function a(e, t, i) {
      var n = r.apply(this, [e]);
      return i ? (n.then(t, i), Promise.resolve()) : n;
    }, t.setRemoteDescription = a, a = function a(e, t, i) {
      var n = o.apply(this, [e]);
      return i ? (n.then(t, i), Promise.resolve()) : n;
    }, t.addIceCandidate = a;
  }

  function ps(e) {
    var t = e && e.navigator;

    if (t.mediaDevices && t.mediaDevices.getUserMedia) {
      var _e7 = t.mediaDevices,
          _i8 = _e7.getUserMedia.bind(_e7);

      t.mediaDevices.getUserMedia = function (e) {
        return _i8(_s(e));
      };
    }

    !t.getUserMedia && t.mediaDevices && t.mediaDevices.getUserMedia && (t.getUserMedia = function (e, i, n) {
      t.mediaDevices.getUserMedia(e).then(i, n);
    }.bind(t));
  }

  function _s(e) {
    return e && void 0 !== e.video ? Object.assign({}, e, {
      video: xn(e.video)
    }) : e;
  }

  function Es(e) {
    if (!e.RTCPeerConnection) return;
    var t = e.RTCPeerConnection;
    e.RTCPeerConnection = function (e, i) {
      if (e && e.iceServers) {
        var _t16 = [];

        for (var _i9 = 0; _i9 < e.iceServers.length; _i9++) {
          var _n10 = e.iceServers[_i9];
          !_n10.hasOwnProperty("urls") && _n10.hasOwnProperty("url") ? (Mn("RTCIceServer.url", "RTCIceServer.urls"), _n10 = JSON.parse(JSON.stringify(_n10)), _n10.urls = _n10.url, delete _n10.url, _t16.push(_n10)) : _t16.push(e.iceServers[_i9]);
        }

        e.iceServers = _t16;
      }

      return new t(e, i);
    }, e.RTCPeerConnection.prototype = t.prototype, "generateCertificate" in t && Object.defineProperty(e.RTCPeerConnection, "generateCertificate", {
      get: function get() {
        return t.generateCertificate;
      }
    });
  }

  function ms(e) {
    "object" == _typeof(e) && e.RTCTrackEvent && "receiver" in e.RTCTrackEvent.prototype && !("transceiver" in e.RTCTrackEvent.prototype) && Object.defineProperty(e.RTCTrackEvent.prototype, "transceiver", {
      get: function get() {
        return {
          receiver: this.receiver
        };
      }
    });
  }

  function fs(e) {
    var t = e.RTCPeerConnection.prototype.createOffer;

    e.RTCPeerConnection.prototype.createOffer = function (e) {
      if (e) {
        void 0 !== e.offerToReceiveAudio && (e.offerToReceiveAudio = !!e.offerToReceiveAudio);

        var _t17 = this.getTransceivers().find(function (e) {
          return "audio" === e.receiver.track.kind;
        });

        !1 === e.offerToReceiveAudio && _t17 ? "sendrecv" === _t17.direction ? _t17.setDirection ? _t17.setDirection("sendonly") : _t17.direction = "sendonly" : "recvonly" === _t17.direction && (_t17.setDirection ? _t17.setDirection("inactive") : _t17.direction = "inactive") : !0 !== e.offerToReceiveAudio || _t17 || this.addTransceiver("audio", {
          direction: "recvonly"
        }), void 0 !== e.offerToReceiveVideo && (e.offerToReceiveVideo = !!e.offerToReceiveVideo);

        var _i10 = this.getTransceivers().find(function (e) {
          return "video" === e.receiver.track.kind;
        });

        !1 === e.offerToReceiveVideo && _i10 ? "sendrecv" === _i10.direction ? _i10.setDirection ? _i10.setDirection("sendonly") : _i10.direction = "sendonly" : "recvonly" === _i10.direction && (_i10.setDirection ? _i10.setDirection("inactive") : _i10.direction = "inactive") : !0 !== e.offerToReceiveVideo || _i10 || this.addTransceiver("video", {
          direction: "recvonly"
        });
      }

      return t.apply(this, arguments);
    };
  }

  function Ts(e) {
    "object" != _typeof(e) || e.AudioContext || (e.AudioContext = e.webkitAudioContext);
  }

  var gs = Object.freeze({
    __proto__: null,
    shimAudioContext: Ts,
    shimCallbacksAPI: hs,
    shimConstraints: _s,
    shimCreateOfferLegacy: fs,
    shimGetUserMedia: ps,
    shimLocalStreamsAPI: ls,
    shimRTCIceServerUrls: Es,
    shimRemoteStreamsAPI: us,
    shimTrackEventTransceiver: ms
  }),
      Ss = {
    exports: {}
  };
  !function (e) {
    var t = {
      generateIdentifier: function generateIdentifier() {
        return Math.random().toString(36).substring(2, 12);
      }
    };
    t.localCName = t.generateIdentifier(), t.splitLines = function (e) {
      return e.trim().split("\n").map(function (e) {
        return e.trim();
      });
    }, t.splitSections = function (e) {
      return e.split("\nm=").map(function (e, t) {
        return (t > 0 ? "m=" + e : e).trim() + "\r\n";
      });
    }, t.getDescription = function (e) {
      var i = t.splitSections(e);
      return i && i[0];
    }, t.getMediaSections = function (e) {
      var i = t.splitSections(e);
      return i.shift(), i;
    }, t.matchPrefix = function (e, i) {
      return t.splitLines(e).filter(function (e) {
        return 0 === e.indexOf(i);
      });
    }, t.parseCandidate = function (e) {
      var t;
      t = 0 === e.indexOf("a=candidate:") ? e.substring(12).split(" ") : e.substring(10).split(" ");
      var i = {
        foundation: t[0],
        component: {
          1: "rtp",
          2: "rtcp"
        }[t[1]] || t[1],
        protocol: t[2].toLowerCase(),
        priority: parseInt(t[3], 10),
        ip: t[4],
        address: t[4],
        port: parseInt(t[5], 10),
        type: t[7]
      };

      for (var _e8 = 8; _e8 < t.length; _e8 += 2) {
        switch (t[_e8]) {
          case "raddr":
            i.relatedAddress = t[_e8 + 1];
            break;

          case "rport":
            i.relatedPort = parseInt(t[_e8 + 1], 10);
            break;

          case "tcptype":
            i.tcpType = t[_e8 + 1];
            break;

          case "ufrag":
            i.ufrag = t[_e8 + 1], i.usernameFragment = t[_e8 + 1];
            break;

          default:
            void 0 === i[t[_e8]] && (i[t[_e8]] = t[_e8 + 1]);
        }
      }

      return i;
    }, t.writeCandidate = function (e) {
      var t = [];
      t.push(e.foundation);
      var i = e.component;
      "rtp" === i ? t.push(1) : "rtcp" === i ? t.push(2) : t.push(i), t.push(e.protocol.toUpperCase()), t.push(e.priority), t.push(e.address || e.ip), t.push(e.port);
      var n = e.type;
      return t.push("typ"), t.push(n), "host" !== n && e.relatedAddress && e.relatedPort && (t.push("raddr"), t.push(e.relatedAddress), t.push("rport"), t.push(e.relatedPort)), e.tcpType && "tcp" === e.protocol.toLowerCase() && (t.push("tcptype"), t.push(e.tcpType)), (e.usernameFragment || e.ufrag) && (t.push("ufrag"), t.push(e.usernameFragment || e.ufrag)), "candidate:" + t.join(" ");
    }, t.parseIceOptions = function (e) {
      return e.substring(14).split(" ");
    }, t.parseRtpMap = function (e) {
      var t = e.substring(9).split(" ");
      var i = {
        payloadType: parseInt(t.shift(), 10)
      };
      return t = t[0].split("/"), i.name = t[0], i.clockRate = parseInt(t[1], 10), i.channels = 3 === t.length ? parseInt(t[2], 10) : 1, i.numChannels = i.channels, i;
    }, t.writeRtpMap = function (e) {
      var t = e.payloadType;
      void 0 !== e.preferredPayloadType && (t = e.preferredPayloadType);
      var i = e.channels || e.numChannels || 1;
      return "a=rtpmap:" + t + " " + e.name + "/" + e.clockRate + (1 !== i ? "/" + i : "") + "\r\n";
    }, t.parseExtmap = function (e) {
      var t = e.substring(9).split(" ");
      return {
        id: parseInt(t[0], 10),
        direction: t[0].indexOf("/") > 0 ? t[0].split("/")[1] : "sendrecv",
        uri: t[1],
        attributes: t.slice(2).join(" ")
      };
    }, t.writeExtmap = function (e) {
      return "a=extmap:" + (e.id || e.preferredId) + (e.direction && "sendrecv" !== e.direction ? "/" + e.direction : "") + " " + e.uri + (e.attributes ? " " + e.attributes : "") + "\r\n";
    }, t.parseFmtp = function (e) {
      var t = {};
      var i;
      var n = e.substring(e.indexOf(" ") + 1).split(";");

      for (var _e9 = 0; _e9 < n.length; _e9++) {
        i = n[_e9].trim().split("="), t[i[0].trim()] = i[1];
      }

      return t;
    }, t.writeFmtp = function (e) {
      var t = "",
          i = e.payloadType;

      if (void 0 !== e.preferredPayloadType && (i = e.preferredPayloadType), e.parameters && Object.keys(e.parameters).length) {
        var _n11 = [];
        Object.keys(e.parameters).forEach(function (t) {
          void 0 !== e.parameters[t] ? _n11.push(t + "=" + e.parameters[t]) : _n11.push(t);
        }), t += "a=fmtp:" + i + " " + _n11.join(";") + "\r\n";
      }

      return t;
    }, t.parseRtcpFb = function (e) {
      var t = e.substring(e.indexOf(" ") + 1).split(" ");
      return {
        type: t.shift(),
        parameter: t.join(" ")
      };
    }, t.writeRtcpFb = function (e) {
      var t = "",
          i = e.payloadType;
      return void 0 !== e.preferredPayloadType && (i = e.preferredPayloadType), e.rtcpFeedback && e.rtcpFeedback.length && e.rtcpFeedback.forEach(function (e) {
        t += "a=rtcp-fb:" + i + " " + e.type + (e.parameter && e.parameter.length ? " " + e.parameter : "") + "\r\n";
      }), t;
    }, t.parseSsrcMedia = function (e) {
      var t = e.indexOf(" "),
          i = {
        ssrc: parseInt(e.substring(7, t), 10)
      },
          n = e.indexOf(":", t);
      return n > -1 ? (i.attribute = e.substring(t + 1, n), i.value = e.substring(n + 1)) : i.attribute = e.substring(t + 1), i;
    }, t.parseSsrcGroup = function (e) {
      var t = e.substring(13).split(" ");
      return {
        semantics: t.shift(),
        ssrcs: t.map(function (e) {
          return parseInt(e, 10);
        })
      };
    }, t.getMid = function (e) {
      var i = t.matchPrefix(e, "a=mid:")[0];
      if (i) return i.substring(6);
    }, t.parseFingerprint = function (e) {
      var t = e.substring(14).split(" ");
      return {
        algorithm: t[0].toLowerCase(),
        value: t[1].toUpperCase()
      };
    }, t.getDtlsParameters = function (e, i) {
      return {
        role: "auto",
        fingerprints: t.matchPrefix(e + i, "a=fingerprint:").map(t.parseFingerprint)
      };
    }, t.writeDtlsParameters = function (e, t) {
      var i = "a=setup:" + t + "\r\n";
      return e.fingerprints.forEach(function (e) {
        i += "a=fingerprint:" + e.algorithm + " " + e.value + "\r\n";
      }), i;
    }, t.parseCryptoLine = function (e) {
      var t = e.substring(9).split(" ");
      return {
        tag: parseInt(t[0], 10),
        cryptoSuite: t[1],
        keyParams: t[2],
        sessionParams: t.slice(3)
      };
    }, t.writeCryptoLine = function (e) {
      return "a=crypto:" + e.tag + " " + e.cryptoSuite + " " + ("object" == _typeof(e.keyParams) ? t.writeCryptoKeyParams(e.keyParams) : e.keyParams) + (e.sessionParams ? " " + e.sessionParams.join(" ") : "") + "\r\n";
    }, t.parseCryptoKeyParams = function (e) {
      if (0 !== e.indexOf("inline:")) return null;
      var t = e.substring(7).split("|");
      return {
        keyMethod: "inline",
        keySalt: t[0],
        lifeTime: t[1],
        mkiValue: t[2] ? t[2].split(":")[0] : void 0,
        mkiLength: t[2] ? t[2].split(":")[1] : void 0
      };
    }, t.writeCryptoKeyParams = function (e) {
      return e.keyMethod + ":" + e.keySalt + (e.lifeTime ? "|" + e.lifeTime : "") + (e.mkiValue && e.mkiLength ? "|" + e.mkiValue + ":" + e.mkiLength : "");
    }, t.getCryptoParameters = function (e, i) {
      return t.matchPrefix(e + i, "a=crypto:").map(t.parseCryptoLine);
    }, t.getIceParameters = function (e, i) {
      var n = t.matchPrefix(e + i, "a=ice-ufrag:")[0],
          s = t.matchPrefix(e + i, "a=ice-pwd:")[0];
      return n && s ? {
        usernameFragment: n.substring(12),
        password: s.substring(10)
      } : null;
    }, t.writeIceParameters = function (e) {
      var t = "a=ice-ufrag:" + e.usernameFragment + "\r\na=ice-pwd:" + e.password + "\r\n";
      return e.iceLite && (t += "a=ice-lite\r\n"), t;
    }, t.parseRtpParameters = function (e) {
      var i = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
      },
          n = t.splitLines(e)[0].split(" ");
      i.profile = n[2];

      for (var _s3 = 3; _s3 < n.length; _s3++) {
        var _r3 = n[_s3],
            _o3 = t.matchPrefix(e, "a=rtpmap:" + _r3 + " ")[0];

        if (_o3) {
          var _n12 = t.parseRtpMap(_o3),
              _s4 = t.matchPrefix(e, "a=fmtp:" + _r3 + " ");

          switch (_n12.parameters = _s4.length ? t.parseFmtp(_s4[0]) : {}, _n12.rtcpFeedback = t.matchPrefix(e, "a=rtcp-fb:" + _r3 + " ").map(t.parseRtcpFb), i.codecs.push(_n12), _n12.name.toUpperCase()) {
            case "RED":
            case "ULPFEC":
              i.fecMechanisms.push(_n12.name.toUpperCase());
          }
        }
      }

      t.matchPrefix(e, "a=extmap:").forEach(function (e) {
        i.headerExtensions.push(t.parseExtmap(e));
      });
      var s = t.matchPrefix(e, "a=rtcp-fb:* ").map(t.parseRtcpFb);
      return i.codecs.forEach(function (e) {
        s.forEach(function (t) {
          e.rtcpFeedback.find(function (e) {
            return e.type === t.type && e.parameter === t.parameter;
          }) || e.rtcpFeedback.push(t);
        });
      }), i;
    }, t.writeRtpDescription = function (e, i) {
      var n = "";
      n += "m=" + e + " ", n += i.codecs.length > 0 ? "9" : "0", n += " " + (i.profile || "UDP/TLS/RTP/SAVPF") + " ", n += i.codecs.map(function (e) {
        return void 0 !== e.preferredPayloadType ? e.preferredPayloadType : e.payloadType;
      }).join(" ") + "\r\n", n += "c=IN IP4 0.0.0.0\r\n", n += "a=rtcp:9 IN IP4 0.0.0.0\r\n", i.codecs.forEach(function (e) {
        n += t.writeRtpMap(e), n += t.writeFmtp(e), n += t.writeRtcpFb(e);
      });
      var s = 0;
      return i.codecs.forEach(function (e) {
        e.maxptime > s && (s = e.maxptime);
      }), s > 0 && (n += "a=maxptime:" + s + "\r\n"), i.headerExtensions && i.headerExtensions.forEach(function (e) {
        n += t.writeExtmap(e);
      }), n;
    }, t.parseRtpEncodingParameters = function (e) {
      var i = [],
          n = t.parseRtpParameters(e),
          s = -1 !== n.fecMechanisms.indexOf("RED"),
          r = -1 !== n.fecMechanisms.indexOf("ULPFEC"),
          o = t.matchPrefix(e, "a=ssrc:").map(function (e) {
        return t.parseSsrcMedia(e);
      }).filter(function (e) {
        return "cname" === e.attribute;
      }),
          a = o.length > 0 && o[0].ssrc;
      var c;
      var d = t.matchPrefix(e, "a=ssrc-group:FID").map(function (e) {
        return e.substring(17).split(" ").map(function (e) {
          return parseInt(e, 10);
        });
      });
      d.length > 0 && d[0].length > 1 && d[0][0] === a && (c = d[0][1]), n.codecs.forEach(function (e) {
        if ("RTX" === e.name.toUpperCase() && e.parameters.apt) {
          var _t18 = {
            ssrc: a,
            codecPayloadType: parseInt(e.parameters.apt, 10)
          };
          a && c && (_t18.rtx = {
            ssrc: c
          }), i.push(_t18), s && (_t18 = JSON.parse(JSON.stringify(_t18)), _t18.fec = {
            ssrc: a,
            mechanism: r ? "red+ulpfec" : "red"
          }, i.push(_t18));
        }
      }), 0 === i.length && a && i.push({
        ssrc: a
      });
      var l = t.matchPrefix(e, "b=");
      return l.length && (l = 0 === l[0].indexOf("b=TIAS:") ? parseInt(l[0].substring(7), 10) : 0 === l[0].indexOf("b=AS:") ? 1e3 * parseInt(l[0].substring(5), 10) * .95 - 16e3 : void 0, i.forEach(function (e) {
        e.maxBitrate = l;
      })), i;
    }, t.parseRtcpParameters = function (e) {
      var i = {},
          n = t.matchPrefix(e, "a=ssrc:").map(function (e) {
        return t.parseSsrcMedia(e);
      }).filter(function (e) {
        return "cname" === e.attribute;
      })[0];
      n && (i.cname = n.value, i.ssrc = n.ssrc);
      var s = t.matchPrefix(e, "a=rtcp-rsize");
      i.reducedSize = s.length > 0, i.compound = 0 === s.length;
      var r = t.matchPrefix(e, "a=rtcp-mux");
      return i.mux = r.length > 0, i;
    }, t.writeRtcpParameters = function (e) {
      var t = "";
      return e.reducedSize && (t += "a=rtcp-rsize\r\n"), e.mux && (t += "a=rtcp-mux\r\n"), void 0 !== e.ssrc && e.cname && (t += "a=ssrc:" + e.ssrc + " cname:" + e.cname + "\r\n"), t;
    }, t.parseMsid = function (e) {
      var i;
      var n = t.matchPrefix(e, "a=msid:");
      if (1 === n.length) return i = n[0].substring(7).split(" "), {
        stream: i[0],
        track: i[1]
      };
      var s = t.matchPrefix(e, "a=ssrc:").map(function (e) {
        return t.parseSsrcMedia(e);
      }).filter(function (e) {
        return "msid" === e.attribute;
      });
      return s.length > 0 ? (i = s[0].value.split(" "), {
        stream: i[0],
        track: i[1]
      }) : void 0;
    }, t.parseSctpDescription = function (e) {
      var i = t.parseMLine(e),
          n = t.matchPrefix(e, "a=max-message-size:");
      var s;
      n.length > 0 && (s = parseInt(n[0].substring(19), 10)), isNaN(s) && (s = 65536);
      var r = t.matchPrefix(e, "a=sctp-port:");
      if (r.length > 0) return {
        port: parseInt(r[0].substring(12), 10),
        protocol: i.fmt,
        maxMessageSize: s
      };
      var o = t.matchPrefix(e, "a=sctpmap:");

      if (o.length > 0) {
        var _e10 = o[0].substring(10).split(" ");

        return {
          port: parseInt(_e10[0], 10),
          protocol: _e10[1],
          maxMessageSize: s
        };
      }
    }, t.writeSctpDescription = function (e, t) {
      var i = [];
      return i = "DTLS/SCTP" !== e.protocol ? ["m=" + e.kind + " 9 " + e.protocol + " " + t.protocol + "\r\n", "c=IN IP4 0.0.0.0\r\n", "a=sctp-port:" + t.port + "\r\n"] : ["m=" + e.kind + " 9 " + e.protocol + " " + t.port + "\r\n", "c=IN IP4 0.0.0.0\r\n", "a=sctpmap:" + t.port + " " + t.protocol + " 65535\r\n"], void 0 !== t.maxMessageSize && i.push("a=max-message-size:" + t.maxMessageSize + "\r\n"), i.join("");
    }, t.generateSessionId = function () {
      return Math.random().toString().substr(2, 22);
    }, t.writeSessionBoilerplate = function (e, i, n) {
      var s;
      var r = void 0 !== i ? i : 2;
      s = e || t.generateSessionId();
      return "v=0\r\no=" + (n || "thisisadapterortc") + " " + s + " " + r + " IN IP4 127.0.0.1\r\ns=-\r\nt=0 0\r\n";
    }, t.getDirection = function (e, i) {
      var n = t.splitLines(e);

      for (var _e11 = 0; _e11 < n.length; _e11++) {
        switch (n[_e11]) {
          case "a=sendrecv":
          case "a=sendonly":
          case "a=recvonly":
          case "a=inactive":
            return n[_e11].substring(2);
        }
      }

      return i ? t.getDirection(i) : "sendrecv";
    }, t.getKind = function (e) {
      return t.splitLines(e)[0].split(" ")[0].substring(2);
    }, t.isRejected = function (e) {
      return "0" === e.split(" ", 2)[1];
    }, t.parseMLine = function (e) {
      var i = t.splitLines(e)[0].substring(2).split(" ");
      return {
        kind: i[0],
        port: parseInt(i[1], 10),
        protocol: i[2],
        fmt: i.slice(3).join(" ")
      };
    }, t.parseOLine = function (e) {
      var i = t.matchPrefix(e, "o=")[0].substring(2).split(" ");
      return {
        username: i[0],
        sessionId: i[1],
        sessionVersion: parseInt(i[2], 10),
        netType: i[3],
        addressType: i[4],
        address: i[5]
      };
    }, t.isValidSDP = function (e) {
      if ("string" != typeof e || 0 === e.length) return !1;
      var i = t.splitLines(e);

      for (var _e12 = 0; _e12 < i.length; _e12++) {
        if (i[_e12].length < 2 || "=" !== i[_e12].charAt(1)) return !1;
      }

      return !0;
    }, e.exports = t;
  }(Ss);
  var Rs = Ss.exports,
      Cs = i(Rs),
      Is = e({
    __proto__: null,
    default: Cs
  }, [Rs]);

  function vs(e) {
    if (!e.RTCIceCandidate || e.RTCIceCandidate && "foundation" in e.RTCIceCandidate.prototype) return;
    var t = e.RTCIceCandidate;
    e.RTCIceCandidate = function (e) {
      if ("object" == _typeof(e) && e.candidate && 0 === e.candidate.indexOf("a=") && ((e = JSON.parse(JSON.stringify(e))).candidate = e.candidate.substr(2)), e.candidate && e.candidate.length) {
        var _i11 = new t(e),
            _n13 = Cs.parseCandidate(e.candidate),
            _s5 = Object.assign(_i11, _n13);

        return _s5.toJSON = function () {
          return {
            candidate: _s5.candidate,
            sdpMid: _s5.sdpMid,
            sdpMLineIndex: _s5.sdpMLineIndex,
            usernameFragment: _s5.usernameFragment
          };
        }, _s5;
      }

      return new t(e);
    }, e.RTCIceCandidate.prototype = t.prototype, Dn(e, "icecandidate", function (t) {
      return t.candidate && Object.defineProperty(t, "candidate", {
        value: new e.RTCIceCandidate(t.candidate),
        writable: "false"
      }), t;
    });
  }

  function ys(e) {
    !e.RTCIceCandidate || e.RTCIceCandidate && "relayProtocol" in e.RTCIceCandidate.prototype || Dn(e, "icecandidate", function (e) {
      if (e.candidate) {
        var _t19 = Cs.parseCandidate(e.candidate.candidate);

        "relay" === _t19.type && (e.candidate.relayProtocol = {
          0: "tls",
          1: "tcp",
          2: "udp"
        }[_t19.priority >> 24]);
      }

      return e;
    });
  }

  function As(e, t) {
    if (!e.RTCPeerConnection) return;
    "sctp" in e.RTCPeerConnection.prototype || Object.defineProperty(e.RTCPeerConnection.prototype, "sctp", {
      get: function get() {
        return void 0 === this._sctp ? null : this._sctp;
      }
    });

    var i = function i(e) {
      if (!e || !e.sdp) return !1;
      var t = Cs.splitSections(e.sdp);
      return t.shift(), t.some(function (e) {
        var t = Cs.parseMLine(e);
        return t && "application" === t.kind && -1 !== t.protocol.indexOf("SCTP");
      });
    },
        n = function n(e) {
      var t = e.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
      if (null === t || t.length < 2) return -1;
      var i = parseInt(t[1], 10);
      return i != i ? -1 : i;
    },
        s = function s(e) {
      var i = 65536;
      return "firefox" === t.browser && (i = t.version < 57 ? -1 === e ? 16384 : 2147483637 : t.version < 60 ? 57 === t.version ? 65535 : 65536 : 2147483637), i;
    },
        r = function r(e, i) {
      var n = 65536;
      "firefox" === t.browser && 57 === t.version && (n = 65535);
      var s = Cs.matchPrefix(e.sdp, "a=max-message-size:");
      return s.length > 0 ? n = parseInt(s[0].substr(19), 10) : "firefox" === t.browser && -1 !== i && (n = 2147483637), n;
    },
        o = e.RTCPeerConnection.prototype.setRemoteDescription;

    e.RTCPeerConnection.prototype.setRemoteDescription = function () {
      if (this._sctp = null, "chrome" === t.browser && t.version >= 76) {
        var _this$getConfiguratio = this.getConfiguration(),
            _e13 = _this$getConfiguratio.sdpSemantics;

        "plan-b" === _e13 && Object.defineProperty(this, "sctp", {
          get: function get() {
            return void 0 === this._sctp ? null : this._sctp;
          },
          enumerable: !0,
          configurable: !0
        });
      }

      if (i(arguments[0])) {
        var _e14 = n(arguments[0]),
            _t20 = s(_e14),
            _i12 = r(arguments[0], _e14);

        var _o4;

        _o4 = 0 === _t20 && 0 === _i12 ? Number.POSITIVE_INFINITY : 0 === _t20 || 0 === _i12 ? Math.max(_t20, _i12) : Math.min(_t20, _i12);
        var _a2 = {};
        Object.defineProperty(_a2, "maxMessageSize", {
          get: function get() {
            return _o4;
          }
        }), this._sctp = _a2;
      }

      return o.apply(this, arguments);
    };
  }

  function bs(e) {
    if (!e.RTCPeerConnection || !("createDataChannel" in e.RTCPeerConnection.prototype)) return;

    function t(e, t) {
      var i = e.send;

      e.send = function () {
        var n = arguments[0],
            s = n.length || n.size || n.byteLength;
        if ("open" === e.readyState && t.sctp && s > t.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + t.sctp.maxMessageSize + " bytes)");
        return i.apply(e, arguments);
      };
    }

    var i = e.RTCPeerConnection.prototype.createDataChannel;
    e.RTCPeerConnection.prototype.createDataChannel = function () {
      var e = i.apply(this, arguments);
      return t(e, this), e;
    }, Dn(e, "datachannel", function (e) {
      return t(e.channel, e.target), e;
    });
  }

  function ws(e) {
    if (!e.RTCPeerConnection || "connectionState" in e.RTCPeerConnection.prototype) return;
    var t = e.RTCPeerConnection.prototype;
    Object.defineProperty(t, "connectionState", {
      get: function get() {
        return {
          completed: "connected",
          checking: "connecting"
        }[this.iceConnectionState] || this.iceConnectionState;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t, "onconnectionstatechange", {
      get: function get() {
        return this._onconnectionstatechange || null;
      },
      set: function set(e) {
        this._onconnectionstatechange && (this.removeEventListener("connectionstatechange", this._onconnectionstatechange), delete this._onconnectionstatechange), e && this.addEventListener("connectionstatechange", this._onconnectionstatechange = e);
      },
      enumerable: !0,
      configurable: !0
    }), ["setLocalDescription", "setRemoteDescription"].forEach(function (e) {
      var i = t[e];

      t[e] = function () {
        return this._connectionstatechangepoly || (this._connectionstatechangepoly = function (e) {
          var t = e.target;

          if (t._lastConnectionState !== t.connectionState) {
            t._lastConnectionState = t.connectionState;

            var _i13 = new Event("connectionstatechange", e);

            t.dispatchEvent(_i13);
          }

          return e;
        }, this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly)), i.apply(this, arguments);
      };
    });
  }

  function Os(e, t) {
    if (!e.RTCPeerConnection) return;
    if ("chrome" === t.browser && t.version >= 71) return;
    if ("safari" === t.browser && t.version >= 605) return;
    var i = e.RTCPeerConnection.prototype.setRemoteDescription;

    e.RTCPeerConnection.prototype.setRemoteDescription = function (t) {
      if (t && t.sdp && -1 !== t.sdp.indexOf("\na=extmap-allow-mixed")) {
        var _i14 = t.sdp.split("\n").filter(function (e) {
          return "a=extmap-allow-mixed" !== e.trim();
        }).join("\n");

        e.RTCSessionDescription && t instanceof e.RTCSessionDescription ? arguments[0] = new e.RTCSessionDescription({
          type: t.type,
          sdp: _i14
        }) : t.sdp = _i14;
      }

      return i.apply(this, arguments);
    };
  }

  function Ns(e, t) {
    if (!e.RTCPeerConnection || !e.RTCPeerConnection.prototype) return;
    var i = e.RTCPeerConnection.prototype.addIceCandidate;
    i && 0 !== i.length && (e.RTCPeerConnection.prototype.addIceCandidate = function () {
      return arguments[0] ? ("chrome" === t.browser && t.version < 78 || "firefox" === t.browser && t.version < 68 || "safari" === t.browser) && arguments[0] && "" === arguments[0].candidate ? Promise.resolve() : i.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), Promise.resolve());
    });
  }

  function Ds(e, t) {
    if (!e.RTCPeerConnection || !e.RTCPeerConnection.prototype) return;
    var i = e.RTCPeerConnection.prototype.setLocalDescription;
    i && 0 !== i.length && (e.RTCPeerConnection.prototype.setLocalDescription = function () {
      var _this25 = this;

      var e = arguments[0] || {};
      if ("object" != _typeof(e) || e.type && e.sdp) return i.apply(this, arguments);
      if (e = {
        type: e.type,
        sdp: e.sdp
      }, !e.type) switch (this.signalingState) {
        case "stable":
        case "have-local-offer":
        case "have-remote-pranswer":
          e.type = "offer";
          break;

        default:
          e.type = "answer";
      }
      if (e.sdp || "offer" !== e.type && "answer" !== e.type) return i.apply(this, [e]);
      return ("offer" === e.type ? this.createOffer : this.createAnswer).apply(this).then(function (e) {
        return i.apply(_this25, [e]);
      });
    });
  }

  var Ps = Object.freeze({
    __proto__: null,
    removeExtmapAllowMixed: Os,
    shimAddIceCandidateNullOrEmpty: Ns,
    shimConnectionState: ws,
    shimMaxMessageSize: As,
    shimParameterlessSetLocalDescription: Ds,
    shimRTCIceCandidate: vs,
    shimRTCIceCandidateRelayProtocol: ys,
    shimSendThrowTypeError: bs
  });
  !function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        e = _ref.window;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      shimChrome: !0,
      shimFirefox: !0,
      shimSafari: !0
    };

    var i = kn,
        n = function (e) {
      var t = {
        browser: null,
        version: null
      };
      if (void 0 === e || !e.navigator) return t.browser = "Not a browser.", t;
      var i = e.navigator;
      if (i.mozGetUserMedia) t.browser = "firefox", t.version = Nn(i.userAgent, /Firefox\/(\d+)\./, 1);else if (i.webkitGetUserMedia || !1 === e.isSecureContext && e.webkitRTCPeerConnection) t.browser = "chrome", t.version = Nn(i.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);else {
        if (!e.RTCPeerConnection || !i.userAgent.match(/AppleWebKit\/(\d+)\./)) return t.browser = "Not a supported browser.", t;
        t.browser = "safari", t.version = Nn(i.userAgent, /AppleWebKit\/(\d+)\./, 1), t.supportsUnifiedPlan = e.RTCRtpTransceiver && "currentDirection" in e.RTCRtpTransceiver.prototype;
      }
      return t;
    }(e),
        s = {
      browserDetails: n,
      commonShim: Ps,
      extractVersion: Nn,
      disableLog: Pn,
      disableWarnings: Ln,
      sdp: Is
    };

    switch (n.browser) {
      case "chrome":
        if (!Qn || !zn || !t.shimChrome) return i("Chrome shim is not included in this adapter release."), s;
        if (null === n.version) return i("Chrome shim can not determine version, not shimming."), s;
        i("adapter.js shimming chrome."), s.browserShim = Qn, Ns(e, n), Ds(e), jn(e, n), Gn(e), zn(e, n), Wn(e), Jn(e, n), Hn(e), Kn(e), Yn(e), Xn(e, n), vs(e), ys(e), ws(e), As(e, n), bs(e), Os(e, n);
        break;

      case "firefox":
        if (!ds || !es || !t.shimFirefox) return i("Firefox shim is not included in this adapter release."), s;
        i("adapter.js shimming firefox."), s.browserShim = ds, Ns(e, n), Ds(e), Zn(e, n), es(e, n), $n(e), ns(e), ts(e), is(e), ss(e), rs(e), os(e), as(e), cs(e), vs(e), ws(e), As(e, n), bs(e);
        break;

      case "safari":
        if (!gs || !t.shimSafari) return i("Safari shim is not included in this adapter release."), s;
        i("adapter.js shimming safari."), s.browserShim = gs, Ns(e, n), Ds(e), Es(e), fs(e), hs(e), ls(e), us(e), ms(e), ps(e), Ts(e), vs(e), ys(e), As(e, n), bs(e), Os(e, n);
        break;

      default:
        i("Unsupported browser!");
    }
  }({
    window: "undefined" == typeof window ? void 0 : window
  });
  var Ls = {
    exports: {}
  },
      ks = wi,
      Ms = N,
      Us = Qt.f;
  ks({
    target: "Object",
    stat: !0,
    forced: Object.defineProperty !== Us,
    sham: !Ms
  }, {
    defineProperty: Us
  });

  var xs = ie.Object,
      Vs = Ls.exports = function (e, t, i) {
    return xs.defineProperty(e, t, i);
  };

  xs.defineProperty.sham && (Vs.sham = !0);

  var Fs = i(Ls.exports),
      Bs = R,
      js = Array.isArray || function (e) {
    return "Array" == Bs(e);
  },
      Gs = TypeError,
      Ws = Ct,
      Hs = Qt,
      Ks = B,
      Ys = function Ys(e, t, i) {
    var n = Ws(t);
    n in e ? Hs.f(e, n, Ks(0, i)) : e[n] = i;
  },
      qs = w,
      Js = He,
      zs = d(Function.toString);

  qs(Js.inspectSource) || (Js.inspectSource = function (e) {
    return zs(e);
  });

  var Xs = Js.inspectSource,
      Qs = d,
      Zs = n,
      $s = w,
      er = ln,
      tr = Xs,
      ir = function ir() {},
      nr = [],
      sr = ae("Reflect", "construct"),
      rr = /^\s*(?:class|function)\b/,
      or = Qs(rr.exec),
      ar = !rr.exec(ir),
      cr = function cr(e) {
    if (!$s(e)) return !1;

    try {
      return sr(ir, nr, e), !0;
    } catch (e) {
      return !1;
    }
  },
      dr = function dr(e) {
    if (!$s(e)) return !1;

    switch (er(e)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }

    try {
      return ar || !!or(rr, tr(e));
    } catch (e) {
      return !0;
    }
  };

  dr.sham = !0;

  var lr = !sr || Zs(function () {
    var e;
    return cr(cr.call) || !cr(Object) || !cr(function () {
      e = !0;
    }) || e;
  }) ? dr : cr,
      ur = js,
      hr = lr,
      pr = te,
      _r = ht("species"),
      Er = Array,
      mr = function mr(e) {
    var t;
    return ur(e) && (t = e.constructor, (hr(t) && (t === Er || ur(t.prototype)) || pr(t) && null === (t = t[_r])) && (t = void 0)), void 0 === t ? Er : t;
  },
      fr = function fr(e, t) {
    return new (mr(e))(0 === t ? 0 : t);
  },
      Tr = n,
      gr = Ee,
      Sr = ht("species"),
      Rr = wi,
      Cr = n,
      Ir = js,
      vr = te,
      yr = ze,
      Ar = Bi,
      br = function br(e) {
    if (e > 9007199254740991) throw Gs("Maximum allowed index exceeded");
    return e;
  },
      wr = Ys,
      Or = fr,
      Nr = function Nr(e) {
    return gr >= 51 || !Tr(function () {
      var t = [];
      return (t.constructor = {})[Sr] = function () {
        return {
          foo: 1
        };
      }, 1 !== t[e](Boolean).foo;
    });
  },
      Dr = Ee,
      Pr = ht("isConcatSpreadable"),
      Lr = Dr >= 51 || !Cr(function () {
    var e = [];
    return e[Pr] = !1, e.concat()[0] !== e;
  }),
      kr = function kr(e) {
    if (!vr(e)) return !1;
    var t = e[Pr];
    return void 0 !== t ? !!t : Ir(e);
  };

  Rr({
    target: "Array",
    proto: !0,
    arity: 1,
    forced: !Lr || !Nr("concat")
  }, {
    concat: function concat(e) {
      var t,
          i,
          n,
          s,
          r,
          o = yr(this),
          a = Or(o, 0),
          c = 0;

      for (t = -1, n = arguments.length; t < n; t++) {
        if (kr(r = -1 === t ? o : arguments[t])) for (s = Ar(r), br(c + s), i = 0; i < s; i++, c++) {
          i in r && wr(a, c, r[i]);
        } else br(c + 1), wr(a, c++, r);
      }

      return a.length = c, a;
    }
  });

  var Mr = {},
      Ur = {},
      xr = Ze,
      Vr = Z,
      Fr = Ki.indexOf,
      Br = Ur,
      jr = d([].push),
      Gr = function Gr(e, t) {
    var i,
        n = Vr(e),
        s = 0,
        r = [];

    for (i in n) {
      !xr(Br, i) && xr(n, i) && jr(r, i);
    }

    for (; t.length > s;) {
      xr(n, i = t[s++]) && (~Fr(r, i) || jr(r, i));
    }

    return r;
  },
      Wr = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
      Hr = Gr,
      Kr = Wr,
      Yr = Object.keys || function (e) {
    return Hr(e, Kr);
  },
      qr = N,
      Jr = Zt,
      zr = Qt,
      Xr = ii,
      Qr = Z,
      Zr = Yr;

  Mr.f = qr && !Jr ? Object.defineProperties : function (e, t) {
    Xr(e);

    for (var i, n = Qr(t), s = Zr(t), r = s.length, o = 0; r > o;) {
      zr.f(e, i = s[o++], n[i]);
    }

    return e;
  };

  var $r,
      eo = ae("document", "documentElement"),
      to = nt,
      io = Ye("keys"),
      no = function no(e) {
    return io[e] || (io[e] = to(e));
  },
      so = ii,
      ro = Mr,
      oo = Wr,
      ao = Ur,
      co = eo,
      lo = At,
      uo = "prototype",
      ho = "script",
      po = no("IE_PROTO"),
      _o = function _o() {},
      Eo = function Eo(e) {
    return "<" + ho + ">" + e + "</" + ho + ">";
  },
      mo = function mo(e) {
    e.write(Eo("")), e.close();
    var t = e.parentWindow.Object;
    return e = null, t;
  },
      _fo = function fo() {
    try {
      $r = new ActiveXObject("htmlfile");
    } catch (e) {}

    var e, t, i;
    _fo = "undefined" != typeof document ? document.domain && $r ? mo($r) : (t = lo("iframe"), i = "java" + ho + ":", t.style.display = "none", co.appendChild(t), t.src = String(i), (e = t.contentWindow.document).open(), e.write(Eo("document.F=Object")), e.close(), e.F) : mo($r);

    for (var n = oo.length; n--;) {
      delete _fo[uo][oo[n]];
    }

    return _fo();
  };

  ao[po] = !0;

  var To = Object.create || function (e, t) {
    var i;
    return null !== e ? (_o[uo] = so(e), i = new _o(), _o[uo] = null, i[po] = e) : i = _fo(), void 0 === t ? i : ro.f(i, t);
  },
      go = {},
      So = Gr,
      Ro = Wr.concat("length", "prototype");

  go.f = Object.getOwnPropertyNames || function (e) {
    return So(e, Ro);
  };

  var Co = {},
      Io = Ui,
      vo = Bi,
      yo = Ys,
      Ao = Array,
      bo = Math.max,
      wo = function wo(e, t, i) {
    for (var n = vo(e), s = Io(t, n), r = Io(void 0 === i ? n : i, n), o = Ao(bo(r - s, 0)), a = 0; s < r; s++, a++) {
      yo(o, a, e[s]);
    }

    return o.length = a, o;
  },
      Oo = R,
      No = Z,
      Do = go.f,
      Po = wo,
      Lo = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  Co.f = function (e) {
    return Lo && "Window" == Oo(e) ? function (e) {
      try {
        return Do(e);
      } catch (e) {
        return Po(Lo);
      }
    }(e) : Do(No(e));
  };

  var ko = {};
  ko.f = Object.getOwnPropertySymbols;

  var Mo = mi,
      Uo = function Uo(e, t, i, n) {
    return n && n.enumerable ? e[t] = i : Mo(e, t, i), e;
  },
      xo = Qt,
      Vo = function Vo(e, t, i) {
    return xo.f(e, t, i);
  },
      Fo = {},
      Bo = ht;

  Fo.f = Bo;

  var jo,
      Go,
      Wo,
      Ho = ie,
      Ko = Ze,
      Yo = Fo,
      qo = Qt.f,
      Jo = function Jo(e) {
    var t = Ho.Symbol || (Ho.Symbol = {});
    Ko(t, e) || qo(t, e, {
      value: Yo.f(e)
    });
  },
      zo = L,
      Xo = ae,
      Qo = ht,
      Zo = Uo,
      $o = function $o() {
    var e = Xo("Symbol"),
        t = e && e.prototype,
        i = t && t.valueOf,
        n = Qo("toPrimitive");
    t && !t[n] && Zo(t, n, function (e) {
      return zo(i, this);
    }, {
      arity: 1
    });
  },
      ea = ln,
      ta = nn ? {}.toString : function () {
    return "[object " + ea(this) + "]";
  },
      ia = nn,
      na = Qt.f,
      sa = mi,
      ra = Ze,
      oa = ta,
      aa = ht("toStringTag"),
      ca = function ca(e, t, i, n) {
    if (e) {
      var s = i ? e : e.prototype;
      ra(s, aa) || na(s, aa, {
        configurable: !0,
        value: t
      }), n && !ia && sa(s, "toString", oa);
    }
  },
      da = w,
      la = h.WeakMap,
      ua = da(la) && /native code/.test(String(la)),
      ha = h,
      pa = te,
      _a = mi,
      Ea = Ze,
      ma = He,
      fa = no,
      Ta = Ur,
      ga = "Object already initialized",
      Sa = ha.TypeError,
      Ra = ha.WeakMap;

  if (ua || ma.state) {
    var Ca = ma.state || (ma.state = new Ra());
    Ca.get = Ca.get, Ca.has = Ca.has, Ca.set = Ca.set, jo = function jo(e, t) {
      if (Ca.has(e)) throw Sa(ga);
      return t.facade = e, Ca.set(e, t), t;
    }, Go = function Go(e) {
      return Ca.get(e) || {};
    }, Wo = function Wo(e) {
      return Ca.has(e);
    };
  } else {
    var Ia = fa("state");
    Ta[Ia] = !0, jo = function jo(e, t) {
      if (Ea(e, Ia)) throw Sa(ga);
      return t.facade = e, _a(e, Ia, t), t;
    }, Go = function Go(e) {
      return Ea(e, Ia) ? e[Ia] : {};
    }, Wo = function Wo(e) {
      return Ea(e, Ia);
    };
  }

  var va = {
    set: jo,
    get: Go,
    has: Wo,
    enforce: function enforce(e) {
      return Wo(e) ? Go(e) : jo(e, {});
    },
    getterFor: function getterFor(e) {
      return function (t) {
        var i;
        if (!pa(t) || (i = Go(t)).type !== e) throw Sa("Incompatible receiver, " + e + " required");
        return i;
      };
    }
  },
      ya = Xt,
      Aa = K,
      ba = ze,
      wa = Bi,
      Oa = fr,
      Na = d([].push),
      Da = function Da(e) {
    var t = 1 == e,
        i = 2 == e,
        n = 3 == e,
        s = 4 == e,
        r = 6 == e,
        o = 7 == e,
        a = 5 == e || r;
    return function (c, d, l, u) {
      for (var h, p, _ = ba(c), E = Aa(_), m = ya(d, l), f = wa(E), T = 0, g = u || Oa, S = t ? g(c, f) : i || o ? g(c, 0) : void 0; f > T; T++) {
        if ((a || T in E) && (p = m(h = E[T], T, _), e)) if (t) S[T] = p;else if (p) switch (e) {
          case 3:
            return !0;

          case 5:
            return h;

          case 6:
            return T;

          case 2:
            Na(S, h);
        } else switch (e) {
          case 4:
            return !1;

          case 7:
            Na(S, h);
        }
      }

      return r ? -1 : n || s ? s : S;
    };
  },
      Pa = {
    forEach: Da(0),
    map: Da(1),
    filter: Da(2),
    some: Da(3),
    every: Da(4),
    find: Da(5),
    findIndex: Da(6),
    filterReject: Da(7)
  },
      La = wi,
      ka = h,
      Ma = L,
      Ua = d,
      xa = N,
      Va = ge,
      Fa = n,
      Ba = Ze,
      ja = l,
      Ga = ii,
      Wa = Z,
      Ha = Ct,
      Ka = pn,
      Ya = B,
      qa = To,
      Ja = Yr,
      za = go,
      Xa = Co,
      Qa = ko,
      Za = O,
      $a = Qt,
      ec = Mr,
      tc = k,
      ic = Uo,
      nc = Vo,
      sc = Ye,
      rc = Ur,
      oc = nt,
      ac = ht,
      cc = Fo,
      dc = Jo,
      lc = $o,
      uc = ca,
      hc = va,
      pc = Pa.forEach,
      _c = no("hidden"),
      Ec = "Symbol",
      mc = "prototype",
      fc = hc.set,
      Tc = hc.getterFor(Ec),
      gc = Object[mc],
      Sc = ka.Symbol,
      Rc = Sc && Sc[mc],
      Cc = ka.TypeError,
      Ic = ka.QObject,
      vc = Za.f,
      yc = $a.f,
      Ac = Xa.f,
      bc = tc.f,
      wc = Ua([].push),
      Oc = sc("symbols"),
      Nc = sc("op-symbols"),
      Dc = sc("wks"),
      Pc = !Ic || !Ic[mc] || !Ic[mc].findChild,
      Lc = xa && Fa(function () {
    return 7 != qa(yc({}, "a", {
      get: function get() {
        return yc(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (e, t, i) {
    var n = vc(gc, t);
    n && delete gc[t], yc(e, t, i), n && e !== gc && yc(gc, t, n);
  } : yc,
      kc = function kc(e, t) {
    var i = Oc[e] = qa(Rc);
    return fc(i, {
      type: Ec,
      tag: e,
      description: t
    }), xa || (i.description = t), i;
  },
      Mc = function Mc(e, t, i) {
    e === gc && Mc(Nc, t, i), Ga(e);
    var n = Ha(t);
    return Ga(i), Ba(Oc, n) ? (i.enumerable ? (Ba(e, _c) && e[_c][n] && (e[_c][n] = !1), i = qa(i, {
      enumerable: Ya(0, !1)
    })) : (Ba(e, _c) || yc(e, _c, Ya(1, {})), e[_c][n] = !0), Lc(e, n, i)) : yc(e, n, i);
  },
      Uc = function Uc(e, t) {
    Ga(e);
    var i = Wa(t),
        n = Ja(i).concat(Bc(i));
    return pc(n, function (t) {
      xa && !Ma(xc, i, t) || Mc(e, t, i[t]);
    }), e;
  },
      xc = function xc(e) {
    var t = Ha(e),
        i = Ma(bc, this, t);
    return !(this === gc && Ba(Oc, t) && !Ba(Nc, t)) && (!(i || !Ba(this, t) || !Ba(Oc, t) || Ba(this, _c) && this[_c][t]) || i);
  },
      Vc = function Vc(e, t) {
    var i = Wa(e),
        n = Ha(t);

    if (i !== gc || !Ba(Oc, n) || Ba(Nc, n)) {
      var s = vc(i, n);
      return !s || !Ba(Oc, n) || Ba(i, _c) && i[_c][n] || (s.enumerable = !0), s;
    }
  },
      Fc = function Fc(e) {
    var t = Ac(Wa(e)),
        i = [];
    return pc(t, function (e) {
      Ba(Oc, e) || Ba(rc, e) || wc(i, e);
    }), i;
  },
      Bc = function Bc(e) {
    var t = e === gc,
        i = Ac(t ? Nc : Wa(e)),
        n = [];
    return pc(i, function (e) {
      !Ba(Oc, e) || t && !Ba(gc, e) || wc(n, Oc[e]);
    }), n;
  };

  Va || (Sc = function Sc() {
    if (ja(Rc, this)) throw Cc("Symbol is not a constructor");

    var e = arguments.length && void 0 !== arguments[0] ? Ka(arguments[0]) : void 0,
        t = oc(e),
        i = function i(e) {
      this === gc && Ma(i, Nc, e), Ba(this, _c) && Ba(this[_c], t) && (this[_c][t] = !1), Lc(this, t, Ya(1, e));
    };

    return xa && Pc && Lc(gc, t, {
      configurable: !0,
      set: i
    }), kc(t, e);
  }, ic(Rc = Sc[mc], "toString", function () {
    return Tc(this).tag;
  }), ic(Sc, "withoutSetter", function (e) {
    return kc(oc(e), e);
  }), tc.f = xc, $a.f = Mc, ec.f = Uc, Za.f = Vc, za.f = Xa.f = Fc, Qa.f = Bc, cc.f = function (e) {
    return kc(ac(e), e);
  }, xa && nc(Rc, "description", {
    configurable: !0,
    get: function get() {
      return Tc(this).description;
    }
  })), La({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: !Va,
    sham: !Va
  }, {
    Symbol: Sc
  }), pc(Ja(Dc), function (e) {
    dc(e);
  }), La({
    target: Ec,
    stat: !0,
    forced: !Va
  }, {
    useSetter: function useSetter() {
      Pc = !0;
    },
    useSimple: function useSimple() {
      Pc = !1;
    }
  }), La({
    target: "Object",
    stat: !0,
    forced: !Va,
    sham: !xa
  }, {
    create: function create(e, t) {
      return void 0 === t ? qa(e) : Uc(qa(e), t);
    },
    defineProperty: Mc,
    defineProperties: Uc,
    getOwnPropertyDescriptor: Vc
  }), La({
    target: "Object",
    stat: !0,
    forced: !Va
  }, {
    getOwnPropertyNames: Fc
  }), lc(), uc(Sc, Ec), rc[_c] = !0;
  var jc = ge && !!Symbol.for && !!Symbol.keyFor,
      Gc = wi,
      Wc = ae,
      Hc = Ze,
      Kc = pn,
      Yc = Ye,
      qc = jc,
      Jc = Yc("string-to-symbol-registry"),
      zc = Yc("symbol-to-string-registry");
  Gc({
    target: "Symbol",
    stat: !0,
    forced: !qc
  }, {
    for: function _for(e) {
      var t = Kc(e);
      if (Hc(Jc, t)) return Jc[t];
      var i = Wc("Symbol")(t);
      return Jc[t] = i, zc[i] = t, i;
    }
  });
  var Xc = wi,
      Qc = Ze,
      Zc = ye,
      $c = be,
      ed = jc,
      td = Ye("symbol-to-string-registry");
  Xc({
    target: "Symbol",
    stat: !0,
    forced: !ed
  }, {
    keyFor: function keyFor(e) {
      if (!Zc(e)) throw TypeError($c(e) + " is not a symbol");
      if (Qc(td, e)) return td[e];
    }
  });

  var id = d([].slice),
      nd = js,
      sd = w,
      rd = R,
      od = pn,
      ad = d([].push),
      cd = wi,
      dd = ae,
      ld = f,
      ud = L,
      hd = d,
      pd = n,
      _d = w,
      Ed = ye,
      md = id,
      fd = function fd(e) {
    if (sd(e)) return e;

    if (nd(e)) {
      for (var t = e.length, i = [], n = 0; n < t; n++) {
        var s = e[n];
        "string" == typeof s ? ad(i, s) : "number" != typeof s && "Number" != rd(s) && "String" != rd(s) || ad(i, od(s));
      }

      var r = i.length,
          o = !0;
      return function (e, t) {
        if (o) return o = !1, t;
        if (nd(this)) return t;

        for (var n = 0; n < r; n++) {
          if (i[n] === e) return t;
        }
      };
    }
  },
      Td = ge,
      gd = String,
      Sd = dd("JSON", "stringify"),
      Rd = hd(/./.exec),
      Cd = hd("".charAt),
      Id = hd("".charCodeAt),
      vd = hd("".replace),
      yd = hd(1..toString),
      Ad = /[\uD800-\uDFFF]/g,
      bd = /^[\uD800-\uDBFF]$/,
      wd = /^[\uDC00-\uDFFF]$/,
      Od = !Td || pd(function () {
    var e = dd("Symbol")();
    return "[null]" != Sd([e]) || "{}" != Sd({
      a: e
    }) || "{}" != Sd(Object(e));
  }),
      Nd = pd(function () {
    return "\"\\udf06\\ud834\"" !== Sd("\uDF06\uD834") || "\"\\udead\"" !== Sd("\uDEAD");
  }),
      Dd = function Dd(e, t) {
    var i = md(arguments),
        n = fd(t);
    if (_d(n) || void 0 !== e && !Ed(e)) return i[1] = function (e, t) {
      if (_d(n) && (t = ud(n, this, gd(e), t)), !Ed(t)) return t;
    }, ld(Sd, null, i);
  },
      Pd = function Pd(e, t, i) {
    var n = Cd(i, t - 1),
        s = Cd(i, t + 1);
    return Rd(bd, e) && !Rd(wd, s) || Rd(wd, e) && !Rd(bd, n) ? "\\u" + yd(Id(e, 0), 16) : e;
  };

  Sd && cd({
    target: "JSON",
    stat: !0,
    arity: 3,
    forced: Od || Nd
  }, {
    stringify: function stringify(e, t, i) {
      var n = md(arguments),
          s = ld(Od ? Dd : Sd, null, n);
      return Nd && "string" == typeof s ? vd(s, Ad, Pd) : s;
    }
  });
  var Ld = ko,
      kd = ze;
  wi({
    target: "Object",
    stat: !0,
    forced: !ge || n(function () {
      Ld.f(1);
    })
  }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(e) {
      var t = Ld.f;
      return t ? t(kd(e)) : [];
    }
  }), Jo("asyncIterator"), Jo("hasInstance"), Jo("isConcatSpreadable"), Jo("iterator"), Jo("match"), Jo("matchAll"), Jo("replace"), Jo("search"), Jo("species"), Jo("split");
  var Md = $o;
  Jo("toPrimitive"), Md();
  var Ud = ae,
      xd = ca;
  Jo("toStringTag"), xd(Ud("Symbol"), "Symbol"), Jo("unscopables"), ca(h.JSON, "JSON", !0);
  var Vd,
      Fd,
      Bd,
      jd = ie.Symbol,
      Gd = {},
      Wd = N,
      Hd = Ze,
      Kd = Function.prototype,
      Yd = Wd && Object.getOwnPropertyDescriptor,
      qd = Hd(Kd, "name"),
      Jd = {
    EXISTS: qd,
    PROPER: qd && "something" === function () {}.name,
    CONFIGURABLE: qd && (!Wd || Wd && Yd(Kd, "name").configurable)
  },
      zd = !n(function () {
    function e() {}

    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }),
      Xd = Ze,
      Qd = w,
      Zd = ze,
      $d = zd,
      el = no("IE_PROTO"),
      tl = Object,
      il = tl.prototype,
      nl = $d ? tl.getPrototypeOf : function (e) {
    var t = Zd(e);
    if (Xd(t, el)) return t[el];
    var i = t.constructor;
    return Qd(i) && t instanceof i ? i.prototype : t instanceof tl ? il : null;
  },
      sl = n,
      rl = w,
      ol = te,
      al = To,
      cl = nl,
      dl = Uo,
      ll = ht("iterator"),
      ul = !1;
  [].keys && ("next" in (Bd = [].keys()) ? (Fd = cl(cl(Bd))) !== Object.prototype && (Vd = Fd) : ul = !0);
  var hl = !ol(Vd) || sl(function () {
    var e = {};
    return Vd[ll].call(e) !== e;
  });
  rl((Vd = hl ? {} : al(Vd))[ll]) || dl(Vd, ll, function () {
    return this;
  });

  var pl = {
    IteratorPrototype: Vd,
    BUGGY_SAFARI_ITERATORS: ul
  },
      _l = pl.IteratorPrototype,
      El = To,
      ml = B,
      fl = ca,
      Tl = Gd,
      gl = function gl() {
    return this;
  },
      Sl = d,
      Rl = De,
      Cl = w,
      Il = String,
      vl = TypeError,
      yl = function yl(e, t, i) {
    try {
      return Sl(Rl(Object.getOwnPropertyDescriptor(e, t)[i]));
    } catch (e) {}
  },
      Al = ii,
      bl = function bl(e) {
    if ("object" == _typeof(e) || Cl(e)) return e;
    throw vl("Can't set " + Il(e) + " as a prototype");
  },
      wl = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var e,
        t = !1,
        i = {};

    try {
      (e = yl(Object.prototype, "__proto__", "set"))(i, []), t = i instanceof Array;
    } catch (e) {}

    return function (i, n) {
      return Al(i), bl(n), t ? e(i, n) : i.__proto__ = n, i;
    };
  }() : void 0),
      Ol = wi,
      Nl = L,
      Dl = Jd,
      Pl = function Pl(e, t, i, n) {
    var s = t + " Iterator";
    return e.prototype = El(_l, {
      next: ml(+!n, i)
    }), fl(e, s, !1, !0), Tl[s] = gl, e;
  },
      Ll = nl,
      kl = ca,
      Ml = Uo,
      Ul = Gd,
      xl = pl,
      Vl = Dl.PROPER,
      Fl = xl.BUGGY_SAFARI_ITERATORS,
      Bl = ht("iterator"),
      jl = "keys",
      Gl = "values",
      Wl = "entries",
      Hl = function Hl() {
    return this;
  },
      Kl = function Kl(e, t, i, n, s, r, o) {
    Pl(i, t, n);

    var a,
        c,
        d,
        l = function l(e) {
      if (e === s && E) return E;
      if (!Fl && e in p) return p[e];

      switch (e) {
        case jl:
        case Gl:
        case Wl:
          return function () {
            return new i(this, e);
          };
      }

      return function () {
        return new i(this);
      };
    },
        u = t + " Iterator",
        h = !1,
        p = e.prototype,
        _ = p[Bl] || p["@@iterator"] || s && p[s],
        E = !Fl && _ || l(s),
        m = "Array" == t && p.entries || _;

    if (m && (a = Ll(m.call(new e()))) !== Object.prototype && a.next && (kl(a, u, !0, !0), Ul[u] = Hl), Vl && s == Gl && _ && _.name !== Gl && (h = !0, E = function E() {
      return Nl(_, this);
    }), s) if (c = {
      values: l(Gl),
      keys: r ? E : l(jl),
      entries: l(Wl)
    }, o) for (d in c) {
      (Fl || h || !(d in p)) && Ml(p, d, c[d]);
    } else Ol({
      target: t,
      proto: !0,
      forced: Fl || h
    }, c);
    return o && p[Bl] !== E && Ml(p, Bl, E, {
      name: s
    }), Ul[t] = E, c;
  },
      Yl = function Yl(e, t) {
    return {
      value: e,
      done: t
    };
  },
      ql = Z,
      Jl = Gd,
      zl = va;

  Qt.f;
  var Xl = Kl,
      Ql = Yl,
      Zl = "Array Iterator",
      $l = zl.set,
      eu = zl.getterFor(Zl);
  Xl(Array, "Array", function (e, t) {
    $l(this, {
      type: Zl,
      target: ql(e),
      index: 0,
      kind: t
    });
  }, function () {
    var e = eu(this),
        t = e.target,
        i = e.kind,
        n = e.index++;
    return !t || n >= t.length ? (e.target = void 0, Ql(void 0, !0)) : Ql("keys" == i ? n : "values" == i ? t[n] : [n, t[n]], !1);
  }, "values"), Jl.Arguments = Jl.Array;
  var tu = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  },
      iu = h,
      nu = ln,
      su = mi,
      ru = Gd,
      ou = ht("toStringTag");

  for (var au in tu) {
    var cu = iu[au],
        du = cu && cu.prototype;
    du && nu(du) !== ou && su(du, ou, au), ru[au] = ru.Array;
  }

  var lu = jd,
      uu = ht,
      hu = Qt.f,
      pu = uu("metadata"),
      _u = Function.prototype;
  void 0 === _u[pu] && hu(_u, pu, {
    value: null
  }), Jo("dispose"), Jo("metadata");
  var Eu = lu;
  Jo("asyncDispose");

  var mu = d,
      fu = ae("Symbol"),
      Tu = fu.keyFor,
      gu = mu(fu.prototype.valueOf),
      Su = fu.isRegisteredSymbol || function (e) {
    try {
      return void 0 !== Tu(gu(e));
    } catch (e) {
      return !1;
    }
  };

  wi({
    target: "Symbol",
    stat: !0
  }, {
    isRegisteredSymbol: Su
  });

  for (var Ru = Ye, Cu = ae, Iu = d, vu = ye, yu = ht, Au = Cu("Symbol"), bu = Au.isWellKnownSymbol, wu = Cu("Object", "getOwnPropertyNames"), Ou = Iu(Au.prototype.valueOf), Nu = Ru("wks"), Du = 0, Pu = wu(Au), Lu = Pu.length; Du < Lu; Du++) {
    try {
      var ku = Pu[Du];
      vu(Au[ku]) && yu(ku);
    } catch (e) {}
  }

  var Mu = function Mu(e) {
    if (bu && bu(e)) return !0;

    try {
      for (var t = Ou(e), i = 0, n = wu(Nu), s = n.length; i < s; i++) {
        if (Nu[n[i]] == t) return !0;
      }
    } catch (e) {}

    return !1;
  };

  wi({
    target: "Symbol",
    stat: !0,
    forced: !0
  }, {
    isWellKnownSymbol: Mu
  }), Jo("matcher"), Jo("observable"), wi({
    target: "Symbol",
    stat: !0,
    name: "isRegisteredSymbol"
  }, {
    isRegistered: Su
  }), wi({
    target: "Symbol",
    stat: !0,
    name: "isWellKnownSymbol",
    forced: !0
  }, {
    isWellKnown: Mu
  }), Jo("metadataKey"), Jo("patternMatch"), Jo("replaceAll");

  var Uu = i(Eu),
      xu = d,
      Vu = Pi,
      Fu = pn,
      Bu = z,
      ju = xu("".charAt),
      Gu = xu("".charCodeAt),
      Wu = xu("".slice),
      Hu = function Hu(e) {
    return function (t, i) {
      var n,
          s,
          r = Fu(Bu(t)),
          o = Vu(i),
          a = r.length;
      return o < 0 || o >= a ? e ? "" : void 0 : (n = Gu(r, o)) < 55296 || n > 56319 || o + 1 === a || (s = Gu(r, o + 1)) < 56320 || s > 57343 ? e ? ju(r, o) : n : e ? Wu(r, o, o + 2) : s - 56320 + (n - 55296 << 10) + 65536;
    };
  },
      Ku = {
    codeAt: Hu(!1),
    charAt: Hu(!0)
  }.charAt,
      Yu = pn,
      qu = va,
      Ju = Kl,
      zu = Yl,
      Xu = "String Iterator",
      Qu = qu.set,
      Zu = qu.getterFor(Xu);

  Ju(String, "String", function (e) {
    Qu(this, {
      type: Xu,
      string: Yu(e),
      index: 0
    });
  }, function () {
    var e,
        t = Zu(this),
        i = t.string,
        n = t.index;
    return n >= i.length ? zu(void 0, !0) : (e = Ku(i, n), t.index += e.length, zu(e, !1));
  });
  var $u = i(Fo.f("iterator"));

  function eh(e) {
    return eh = "function" == typeof Uu && "symbol" == _typeof($u) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Uu && e.constructor === Uu && e !== Uu.prototype ? "symbol" : _typeof(e);
    }, eh(e);
  }

  var th = i(Fo.f("toPrimitive"));

  function ih(e) {
    var t = function (e, t) {
      if ("object" !== eh(e) || null === e) return e;
      var i = e[th];

      if (void 0 !== i) {
        var n = i.call(e, t || "default");
        if ("object" !== eh(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }(e, "string");

    return "symbol" === eh(t) ? t : String(t);
  }

  function nh(e, t, i) {
    return (t = ih(t)) in e ? Fs(e, t, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = i, e;
  }

  var sh = Ji("Array").keys,
      rh = ln,
      oh = Ze,
      ah = l,
      ch = sh,
      dh = Array.prototype,
      lh = {
    DOMTokenList: !0,
    NodeList: !0
  },
      uh = i(function (e) {
    var t = e.keys;
    return e === dh || ah(dh, e) && t === dh.keys || oh(lh, rh(e)) ? ch : t;
  }),
      hh = be,
      ph = TypeError,
      _h = wo,
      Eh = Math.floor,
      mh = function mh(e, t) {
    var i = e.length,
        n = Eh(i / 2);
    return i < 8 ? fh(e, t) : Th(e, mh(_h(e, 0, n), t), mh(_h(e, n), t), t);
  },
      fh = function fh(e, t) {
    for (var i, n, s = e.length, r = 1; r < s;) {
      for (n = r, i = e[r]; n && t(e[n - 1], i) > 0;) {
        e[n] = e[--n];
      }

      n !== r++ && (e[n] = i);
    }

    return e;
  },
      Th = function Th(e, t, i, n) {
    for (var s = t.length, r = i.length, o = 0, a = 0; o < s || a < r;) {
      e[o + a] = o < s && a < r ? n(t[o], i[a]) <= 0 ? t[o++] : i[a++] : o < s ? t[o++] : i[a++];
    }

    return e;
  },
      gh = mh,
      Sh = n,
      Rh = function Rh(e, t) {
    var i = [][e];
    return !!i && Sh(function () {
      i.call(null, t || function () {
        return 1;
      }, 1);
    });
  },
      Ch = ce.match(/firefox\/(\d+)/i),
      Ih = !!Ch && +Ch[1],
      vh = /MSIE|Trident/.test(ce),
      yh = ce.match(/AppleWebKit\/(\d+)\./),
      Ah = !!yh && +yh[1],
      bh = wi,
      wh = d,
      Oh = De,
      Nh = ze,
      Dh = Bi,
      Ph = function Ph(e, t) {
    if (!delete e[t]) throw ph("Cannot delete property " + hh(t) + " of " + hh(e));
  },
      Lh = pn,
      kh = n,
      Mh = gh,
      Uh = Rh,
      xh = Ih,
      Vh = vh,
      Fh = Ee,
      Bh = Ah,
      jh = [],
      Gh = wh(jh.sort),
      Wh = wh(jh.push),
      Hh = kh(function () {
    jh.sort(void 0);
  }),
      Kh = kh(function () {
    jh.sort(null);
  }),
      Yh = Uh("sort"),
      qh = !kh(function () {
    if (Fh) return Fh < 70;

    if (!(xh && xh > 3)) {
      if (Vh) return !0;
      if (Bh) return Bh < 603;
      var e,
          t,
          i,
          n,
          s = "";

      for (e = 65; e < 76; e++) {
        switch (t = String.fromCharCode(e), e) {
          case 66:
          case 69:
          case 70:
          case 72:
            i = 3;
            break;

          case 68:
          case 71:
            i = 4;
            break;

          default:
            i = 2;
        }

        for (n = 0; n < 47; n++) {
          jh.push({
            k: t + n,
            v: i
          });
        }
      }

      for (jh.sort(function (e, t) {
        return t.v - e.v;
      }), n = 0; n < jh.length; n++) {
        t = jh[n].k.charAt(0), s.charAt(s.length - 1) !== t && (s += t);
      }

      return "DGBEFHACIJK" !== s;
    }
  });

  bh({
    target: "Array",
    proto: !0,
    forced: Hh || !Kh || !Yh || !qh
  }, {
    sort: function sort(e) {
      void 0 !== e && Oh(e);
      var t = Nh(this);
      if (qh) return void 0 === e ? Gh(t) : Gh(t, e);
      var i,
          n,
          s = [],
          r = Dh(t);

      for (n = 0; n < r; n++) {
        n in t && Wh(s, t[n]);
      }

      for (Mh(s, function (e) {
        return function (t, i) {
          return void 0 === i ? -1 : void 0 === t ? 1 : void 0 !== e ? +e(t, i) || 0 : Lh(t) > Lh(i) ? 1 : -1;
        };
      }(e)), i = Dh(s), n = 0; n < i;) {
        t[n] = s[n++];
      }

      for (; n < r;) {
        Ph(t, n++);
      }

      return t;
    }
  });

  var Jh = Ji("Array").sort,
      zh = l,
      Xh = Jh,
      Qh = Array.prototype,
      Zh = i(function (e) {
    var t = e.sort;
    return e === Qh || zh(Qh, e) && t === Qh.sort ? Xh : t;
  }),
      $h = ae,
      ep = go,
      tp = ko,
      ip = ii,
      np = d([].concat),
      sp = $h("Reflect", "ownKeys") || function (e) {
    var t = ep.f(ip(e)),
        i = tp.f;
    return i ? np(t, i(e)) : t;
  },
      rp = Ze,
      op = sp,
      ap = O,
      cp = Qt,
      dp = te,
      lp = mi,
      up = Error,
      hp = d("".replace),
      pp = String(up("zxcasd").stack),
      _p = /\n\s*at [^:]*:[^\n]*/,
      Ep = _p.test(pp),
      mp = B,
      fp = !n(function () {
    var e = Error("a");
    return !("stack" in e) || (Object.defineProperty(e, "stack", mp(1, 7)), 7 !== e.stack);
  }),
      Tp = mi,
      gp = function gp(e, t) {
    if (Ep && "string" == typeof e && !up.prepareStackTrace) for (; t--;) {
      e = hp(e, _p, "");
    }
    return e;
  },
      Sp = fp,
      Rp = Error.captureStackTrace,
      Cp = Gd,
      Ip = ht("iterator"),
      vp = Array.prototype,
      yp = ln,
      Ap = ke,
      bp = Y,
      wp = Gd,
      Op = ht("iterator"),
      Np = function Np(e) {
    if (!bp(e)) return Ap(e, Op) || Ap(e, "@@iterator") || wp[yp(e)];
  },
      Dp = L,
      Pp = De,
      Lp = ii,
      kp = be,
      Mp = Np,
      Up = TypeError,
      xp = L,
      Vp = ii,
      Fp = ke,
      Bp = Xt,
      jp = L,
      Gp = ii,
      Wp = be,
      Hp = function Hp(e) {
    return void 0 !== e && (Cp.Array === e || vp[Ip] === e);
  },
      Kp = Bi,
      Yp = l,
      qp = function qp(e, t) {
    var i = arguments.length < 2 ? Mp(e) : t;
    if (Pp(i)) return Lp(Dp(i, e));
    throw Up(kp(e) + " is not iterable");
  },
      Jp = Np,
      zp = function zp(e, t, i) {
    var n, s;
    Vp(e);

    try {
      if (!(n = Fp(e, "return"))) {
        if ("throw" === t) throw i;
        return i;
      }

      n = xp(n, e);
    } catch (e) {
      s = !0, n = e;
    }

    if ("throw" === t) throw i;
    if (s) throw n;
    return Vp(n), i;
  },
      Xp = TypeError,
      Qp = function Qp(e, t) {
    this.stopped = e, this.result = t;
  },
      Zp = Qp.prototype,
      $p = function $p(e, t, i) {
    var n,
        s,
        r,
        o,
        a,
        c,
        d,
        l = i && i.that,
        u = !(!i || !i.AS_ENTRIES),
        h = !(!i || !i.IS_RECORD),
        p = !(!i || !i.IS_ITERATOR),
        _ = !(!i || !i.INTERRUPTED),
        E = Bp(t, l),
        m = function m(e) {
      return n && zp(n, "normal", e), new Qp(!0, e);
    },
        f = function f(e) {
      return u ? (Gp(e), _ ? E(e[0], e[1], m) : E(e[0], e[1])) : _ ? E(e, m) : E(e);
    };

    if (h) n = e.iterator;else if (p) n = e;else {
      if (!(s = Jp(e))) throw Xp(Wp(e) + " is not iterable");

      if (Hp(s)) {
        for (r = 0, o = Kp(e); o > r; r++) {
          if ((a = f(e[r])) && Yp(Zp, a)) return a;
        }

        return new Qp(!1);
      }

      n = qp(e, s);
    }

    for (c = h ? e.next : n.next; !(d = jp(c, n)).done;) {
      try {
        a = f(d.value);
      } catch (e) {
        zp(n, "throw", e);
      }

      if ("object" == _typeof(a) && a && Yp(Zp, a)) return a;
    }

    return new Qp(!1);
  },
      e_ = pn,
      t_ = wi,
      i_ = l,
      n_ = nl,
      s_ = wl,
      r_ = function r_(e, t, i) {
    for (var n = op(t), s = cp.f, r = ap.f, o = 0; o < n.length; o++) {
      var a = n[o];
      rp(e, a) || i && rp(i, a) || s(e, a, r(t, a));
    }
  },
      o_ = To,
      a_ = mi,
      c_ = B,
      d_ = function d_(e, t) {
    dp(t) && "cause" in t && lp(e, "cause", t.cause);
  },
      l_ = function l_(e, t, i, n) {
    Sp && (Rp ? Rp(e, t) : Tp(e, "stack", gp(i, n)));
  },
      u_ = $p,
      h_ = function h_(e, t) {
    return void 0 === e ? arguments.length < 2 ? "" : t : e_(e);
  },
      p_ = ht("toStringTag"),
      __ = Error,
      E_ = [].push,
      m_ = function m_(e, t) {
    var i,
        n = i_(f_, this);
    s_ ? i = s_(__(), n ? n_(this) : f_) : (i = n ? this : o_(f_), a_(i, p_, "Error")), void 0 !== t && a_(i, "message", h_(t)), l_(i, m_, i.stack, 1), arguments.length > 2 && d_(i, arguments[2]);
    var s = [];
    return u_(e, E_, {
      that: s
    }), a_(i, "errors", s), i;
  };

  s_ ? s_(m_, __) : r_(m_, __, {
    name: !0
  });
  var f_ = m_.prototype = o_(__.prototype, {
    constructor: c_(1, m_),
    message: c_(1, ""),
    name: c_(1, "AggregateError")
  });
  t_({
    global: !0,
    constructor: !0,
    arity: 2
  }, {
    AggregateError: m_
  });

  var T_,
      g_,
      S_,
      R_,
      C_ = "undefined" != typeof process && "process" == R(process),
      I_ = ae,
      v_ = Vo,
      y_ = N,
      A_ = ht("species"),
      b_ = l,
      w_ = TypeError,
      O_ = lr,
      N_ = be,
      D_ = TypeError,
      P_ = ii,
      L_ = function L_(e) {
    if (O_(e)) return e;
    throw D_(N_(e) + " is not a constructor");
  },
      k_ = Y,
      M_ = ht("species"),
      U_ = function U_(e, t) {
    var i,
        n = P_(e).constructor;
    return void 0 === n || k_(i = P_(n)[M_]) ? t : L_(i);
  },
      x_ = TypeError,
      V_ = /(?:ipad|iphone|ipod).*applewebkit/i.test(ce),
      F_ = h,
      B_ = f,
      j_ = Xt,
      G_ = w,
      W_ = Ze,
      H_ = n,
      K_ = eo,
      Y_ = id,
      q_ = At,
      J_ = function J_(e, t) {
    if (e < t) throw x_("Not enough arguments");
    return e;
  },
      z_ = V_,
      X_ = C_,
      Q_ = F_.setImmediate,
      Z_ = F_.clearImmediate,
      $_ = F_.process,
      eE = F_.Dispatch,
      tE = F_.Function,
      iE = F_.MessageChannel,
      nE = F_.String,
      sE = 0,
      rE = {},
      oE = "onreadystatechange";

  H_(function () {
    T_ = F_.location;
  });

  var aE = function aE(e) {
    if (W_(rE, e)) {
      var t = rE[e];
      delete rE[e], t();
    }
  },
      cE = function cE(e) {
    return function () {
      aE(e);
    };
  },
      dE = function dE(e) {
    aE(e.data);
  },
      lE = function lE(e) {
    F_.postMessage(nE(e), T_.protocol + "//" + T_.host);
  };

  Q_ && Z_ || (Q_ = function Q_(e) {
    J_(arguments.length, 1);
    var t = G_(e) ? e : tE(e),
        i = Y_(arguments, 1);
    return rE[++sE] = function () {
      B_(t, void 0, i);
    }, g_(sE), sE;
  }, Z_ = function Z_(e) {
    delete rE[e];
  }, X_ ? g_ = function g_(e) {
    $_.nextTick(cE(e));
  } : eE && eE.now ? g_ = function g_(e) {
    eE.now(cE(e));
  } : iE && !z_ ? (R_ = (S_ = new iE()).port2, S_.port1.onmessage = dE, g_ = j_(R_.postMessage, R_)) : F_.addEventListener && G_(F_.postMessage) && !F_.importScripts && T_ && "file:" !== T_.protocol && !H_(lE) ? (g_ = lE, F_.addEventListener("message", dE, !1)) : g_ = oE in q_("script") ? function (e) {
    K_.appendChild(q_("script"))[oE] = function () {
      K_.removeChild(this), aE(e);
    };
  } : function (e) {
    setTimeout(cE(e), 0);
  });

  var uE = {
    set: Q_,
    clear: Z_
  },
      hE = function hE() {
    this.head = null, this.tail = null;
  };

  hE.prototype = {
    add: function add(e) {
      var t = {
        item: e,
        next: null
      },
          i = this.tail;
      i ? i.next = t : this.head = t, this.tail = t;
    },
    get: function get() {
      var e = this.head;
      if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
    }
  };

  var pE,
      _E,
      EE,
      mE,
      fE,
      TE = hE,
      gE = /ipad|iphone|ipod/i.test(ce) && "undefined" != typeof Pebble,
      SE = /web0s(?!.*chrome)/i.test(ce),
      RE = h,
      CE = Xt,
      IE = O.f,
      vE = uE.set,
      yE = TE,
      AE = V_,
      bE = gE,
      wE = SE,
      OE = C_,
      NE = RE.MutationObserver || RE.WebKitMutationObserver,
      DE = RE.document,
      PE = RE.process,
      LE = RE.Promise,
      kE = IE(RE, "queueMicrotask"),
      ME = kE && kE.value;

  if (!ME) {
    var UE = new yE(),
        xE = function xE() {
      var e, t;

      for (OE && (e = PE.domain) && e.exit(); t = UE.get();) {
        try {
          t();
        } catch (e) {
          throw UE.head && pE(), e;
        }
      }

      e && e.enter();
    };

    AE || OE || wE || !NE || !DE ? !bE && LE && LE.resolve ? ((mE = LE.resolve(void 0)).constructor = LE, fE = CE(mE.then, mE), pE = function pE() {
      fE(xE);
    }) : OE ? pE = function pE() {
      PE.nextTick(xE);
    } : (vE = CE(vE, RE), pE = function pE() {
      vE(xE);
    }) : (_E = !0, EE = DE.createTextNode(""), new NE(xE).observe(EE, {
      characterData: !0
    }), pE = function pE() {
      EE.data = _E = !_E;
    }), ME = function ME(e) {
      UE.head || pE(), UE.add(e);
    };
  }

  var VE = ME,
      FE = function FE(e) {
    try {
      return {
        error: !1,
        value: e()
      };
    } catch (e) {
      return {
        error: !0,
        value: e
      };
    }
  },
      BE = h.Promise,
      jE = "object" == (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) && Deno && "object" == _typeof(Deno.version),
      GE = !jE && !C_ && "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && "object" == (typeof document === "undefined" ? "undefined" : _typeof(document)),
      WE = h,
      HE = BE,
      KE = w,
      YE = Yt,
      qE = Xs,
      JE = ht,
      zE = GE,
      XE = jE,
      QE = Ee,
      ZE = HE && HE.prototype,
      $E = JE("species"),
      em = !1,
      tm = KE(WE.PromiseRejectionEvent),
      im = YE("Promise", function () {
    var e = qE(HE),
        t = e !== String(HE);
    if (!t && 66 === QE) return !0;
    if (!ZE.catch || !ZE.finally) return !0;

    if (!QE || QE < 51 || !/native code/.test(e)) {
      var i = new HE(function (e) {
        e(1);
      }),
          n = function n(e) {
        e(function () {}, function () {});
      };

      if ((i.constructor = {})[$E] = n, !(em = i.then(function () {}) instanceof n)) return !0;
    }

    return !t && (zE || XE) && !tm;
  }),
      nm = {
    CONSTRUCTOR: im,
    REJECTION_EVENT: tm,
    SUBCLASSING: em
  },
      sm = {},
      rm = De,
      om = TypeError,
      am = function am(e) {
    var t, i;
    this.promise = new e(function (e, n) {
      if (void 0 !== t || void 0 !== i) throw om("Bad Promise constructor");
      t = e, i = n;
    }), this.resolve = rm(t), this.reject = rm(i);
  };

  sm.f = function (e) {
    return new am(e);
  };

  var cm,
      dm,
      lm = wi,
      um = C_,
      hm = h,
      pm = L,
      _m = Uo,
      Em = ca,
      mm = function mm(e) {
    var t = I_(e);
    y_ && t && !t[A_] && v_(t, A_, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  },
      fm = De,
      Tm = w,
      gm = te,
      Sm = function Sm(e, t) {
    if (b_(t, e)) return e;
    throw w_("Incorrect invocation");
  },
      Rm = U_,
      Cm = uE.set,
      Im = VE,
      vm = function vm(e, t) {
    try {
      1 == arguments.length ? console.error(e) : console.error(e, t);
    } catch (e) {}
  },
      ym = FE,
      Am = TE,
      bm = va,
      wm = BE,
      Om = nm,
      Nm = sm,
      Dm = "Promise",
      Pm = Om.CONSTRUCTOR,
      Lm = Om.REJECTION_EVENT,
      km = bm.getterFor(Dm),
      Mm = bm.set,
      Um = wm && wm.prototype,
      xm = wm,
      Vm = Um,
      Fm = hm.TypeError,
      Bm = hm.document,
      jm = hm.process,
      Gm = Nm.f,
      Wm = Gm,
      Hm = !!(Bm && Bm.createEvent && hm.dispatchEvent),
      Km = "unhandledrejection",
      Ym = function Ym(e) {
    var t;
    return !(!gm(e) || !Tm(t = e.then)) && t;
  },
      qm = function qm(e, t) {
    var i,
        n,
        s,
        r = t.value,
        o = 1 == t.state,
        a = o ? e.ok : e.fail,
        c = e.resolve,
        d = e.reject,
        l = e.domain;

    try {
      a ? (o || (2 === t.rejection && Zm(t), t.rejection = 1), !0 === a ? i = r : (l && l.enter(), i = a(r), l && (l.exit(), s = !0)), i === e.promise ? d(Fm("Promise-chain cycle")) : (n = Ym(i)) ? pm(n, i, c, d) : c(i)) : d(r);
    } catch (e) {
      l && !s && l.exit(), d(e);
    }
  },
      Jm = function Jm(e, t) {
    e.notified || (e.notified = !0, Im(function () {
      for (var i, n = e.reactions; i = n.get();) {
        qm(i, e);
      }

      e.notified = !1, t && !e.rejection && Xm(e);
    }));
  },
      zm = function zm(e, t, i) {
    var n, s;
    Hm ? ((n = Bm.createEvent("Event")).promise = t, n.reason = i, n.initEvent(e, !1, !0), hm.dispatchEvent(n)) : n = {
      promise: t,
      reason: i
    }, !Lm && (s = hm["on" + e]) ? s(n) : e === Km && vm("Unhandled promise rejection", i);
  },
      Xm = function Xm(e) {
    pm(Cm, hm, function () {
      var t,
          i = e.facade,
          n = e.value;
      if (Qm(e) && (t = ym(function () {
        um ? jm.emit("unhandledRejection", n, i) : zm(Km, i, n);
      }), e.rejection = um || Qm(e) ? 2 : 1, t.error)) throw t.value;
    });
  },
      Qm = function Qm(e) {
    return 1 !== e.rejection && !e.parent;
  },
      Zm = function Zm(e) {
    pm(Cm, hm, function () {
      var t = e.facade;
      um ? jm.emit("rejectionHandled", t) : zm("rejectionhandled", t, e.value);
    });
  },
      $m = function $m(e, t, i) {
    return function (n) {
      e(t, n, i);
    };
  },
      ef = function ef(e, t, i) {
    e.done || (e.done = !0, i && (e = i), e.value = t, e.state = 2, Jm(e, !0));
  },
      tf = function tf(e, t, i) {
    if (!e.done) {
      e.done = !0, i && (e = i);

      try {
        if (e.facade === t) throw Fm("Promise can't be resolved itself");
        var n = Ym(t);
        n ? Im(function () {
          var i = {
            done: !1
          };

          try {
            pm(n, t, $m(tf, i, e), $m(ef, i, e));
          } catch (t) {
            ef(i, t, e);
          }
        }) : (e.value = t, e.state = 1, Jm(e, !1));
      } catch (t) {
        ef({
          done: !1
        }, t, e);
      }
    }
  };

  Pm && (Vm = (xm = function xm(e) {
    Sm(this, Vm), fm(e), pm(cm, this);
    var t = km(this);

    try {
      e($m(tf, t), $m(ef, t));
    } catch (e) {
      ef(t, e);
    }
  }).prototype, (cm = function cm(e) {
    Mm(this, {
      type: Dm,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new Am(),
      rejection: !1,
      state: 0,
      value: void 0
    });
  }).prototype = _m(Vm, "then", function (e, t) {
    var i = km(this),
        n = Gm(Rm(this, xm));
    return i.parent = !0, n.ok = !Tm(e) || e, n.fail = Tm(t) && t, n.domain = um ? jm.domain : void 0, 0 == i.state ? i.reactions.add(n) : Im(function () {
      qm(n, i);
    }), n.promise;
  }), dm = function dm() {
    var e = new cm(),
        t = km(e);
    this.promise = e, this.resolve = $m(tf, t), this.reject = $m(ef, t);
  }, Nm.f = Gm = function Gm(e) {
    return e === xm || undefined === e ? new dm(e) : Wm(e);
  }), lm({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: Pm
  }, {
    Promise: xm
  }), Em(xm, Dm, !1, !0), mm(Dm);
  var nf = ht("iterator"),
      sf = !1;

  try {
    var rf = 0,
        of = {
      next: function next() {
        return {
          done: !!rf++
        };
      },
      return: function _return() {
        sf = !0;
      }
    };
    of[nf] = function () {
      return this;
    }, Array.from(of, function () {
      throw 2;
    });
  } catch (e) {}

  var af = BE,
      cf = function cf(e, t) {
    if (!t && !sf) return !1;
    var i = !1;

    try {
      var n = {};
      n[nf] = function () {
        return {
          next: function next() {
            return {
              done: i = !0
            };
          }
        };
      }, e(n);
    } catch (e) {}

    return i;
  },
      df = nm.CONSTRUCTOR || !cf(function (e) {
    af.all(e).then(void 0, function () {});
  }),
      lf = L,
      uf = De,
      hf = sm,
      pf = FE,
      _f = $p;

  wi({
    target: "Promise",
    stat: !0,
    forced: df
  }, {
    all: function all(e) {
      var t = this,
          i = hf.f(t),
          n = i.resolve,
          s = i.reject,
          r = pf(function () {
        var i = uf(t.resolve),
            r = [],
            o = 0,
            a = 1;
        _f(e, function (e) {
          var c = o++,
              d = !1;
          a++, lf(i, t, e).then(function (e) {
            d || (d = !0, r[c] = e, --a || n(r));
          }, s);
        }), --a || n(r);
      });
      return r.error && s(r.value), i.promise;
    }
  });
  var Ef = wi,
      mf = nm.CONSTRUCTOR;
  BE && BE.prototype, Ef({
    target: "Promise",
    proto: !0,
    forced: mf,
    real: !0
  }, {
    catch: function _catch(e) {
      return this.then(void 0, e);
    }
  });
  var ff = L,
      Tf = De,
      gf = sm,
      Sf = FE,
      Rf = $p;
  wi({
    target: "Promise",
    stat: !0,
    forced: df
  }, {
    race: function race(e) {
      var t = this,
          i = gf.f(t),
          n = i.reject,
          s = Sf(function () {
        var s = Tf(t.resolve);
        Rf(e, function (e) {
          ff(s, t, e).then(i.resolve, n);
        });
      });
      return s.error && n(s.value), i.promise;
    }
  });
  var Cf = L,
      If = sm;
  wi({
    target: "Promise",
    stat: !0,
    forced: nm.CONSTRUCTOR
  }, {
    reject: function reject(e) {
      var t = If.f(this);
      return Cf(t.reject, void 0, e), t.promise;
    }
  });

  var vf = ii,
      yf = te,
      Af = sm,
      bf = function bf(e, t) {
    if (vf(e), yf(t) && t.constructor === e) return t;
    var i = Af.f(e);
    return (0, i.resolve)(t), i.promise;
  },
      wf = wi,
      Of = BE,
      Nf = nm.CONSTRUCTOR,
      Df = bf,
      Pf = ae("Promise"),
      Lf = !Nf;

  wf({
    target: "Promise",
    stat: !0,
    forced: true
  }, {
    resolve: function resolve(e) {
      return Df(Lf && this === Pf ? Of : this, e);
    }
  });
  var kf = L,
      Mf = De,
      Uf = sm,
      xf = FE,
      Vf = $p;
  wi({
    target: "Promise",
    stat: !0,
    forced: df
  }, {
    allSettled: function allSettled(e) {
      var t = this,
          i = Uf.f(t),
          n = i.resolve,
          s = i.reject,
          r = xf(function () {
        var i = Mf(t.resolve),
            s = [],
            r = 0,
            o = 1;
        Vf(e, function (e) {
          var a = r++,
              c = !1;
          o++, kf(i, t, e).then(function (e) {
            c || (c = !0, s[a] = {
              status: "fulfilled",
              value: e
            }, --o || n(s));
          }, function (e) {
            c || (c = !0, s[a] = {
              status: "rejected",
              reason: e
            }, --o || n(s));
          });
        }), --o || n(s);
      });
      return r.error && s(r.value), i.promise;
    }
  });
  var Ff = L,
      Bf = De,
      jf = ae,
      Gf = sm,
      Wf = FE,
      Hf = $p,
      Kf = "No one promise resolved";
  wi({
    target: "Promise",
    stat: !0,
    forced: df
  }, {
    any: function any(e) {
      var t = this,
          i = jf("AggregateError"),
          n = Gf.f(t),
          s = n.resolve,
          r = n.reject,
          o = Wf(function () {
        var n = Bf(t.resolve),
            o = [],
            a = 0,
            c = 1,
            d = !1;
        Hf(e, function (e) {
          var l = a++,
              u = !1;
          c++, Ff(n, t, e).then(function (e) {
            u || d || (d = !0, s(e));
          }, function (e) {
            u || d || (u = !0, o[l] = e, --c || r(new i(o, Kf)));
          });
        }), --c || r(new i(o, Kf));
      });
      return o.error && r(o.value), n.promise;
    }
  });
  var Yf = wi,
      qf = BE,
      Jf = n,
      zf = ae,
      Xf = w,
      Qf = U_,
      Zf = bf,
      $f = qf && qf.prototype;
  Yf({
    target: "Promise",
    proto: !0,
    real: !0,
    forced: !!qf && Jf(function () {
      $f.finally.call({
        then: function then() {}
      }, function () {});
    })
  }, {
    finally: function _finally(e) {
      var t = Qf(this, zf("Promise")),
          i = Xf(e);
      return this.then(i ? function (i) {
        return Zf(t, e()).then(function () {
          return i;
        });
      } : e, i ? function (i) {
        return Zf(t, e()).then(function () {
          throw i;
        });
      } : e);
    }
  });
  var eT = ie.Promise,
      tT = i(eT);

  var iT = function iT() {};

  function nT() {
    var e = {
      promise: void 0,
      isResolved: !1,
      isRejected: !1,
      isFinished: !1,
      resolve: void 0,
      reject: void 0,
      cancel: iT
    };
    return e.promise = new tT(function (t, i) {
      e.resolve = function (i) {
        e.isFinished || (e.isResolved = !0, e.isFinished = !0, t(i), e.value = i);
      }, e.reject = function (t) {
        e.isFinished || (e.isRejected = !0, e.isFinished = !0, i(t));
      };
    }), e;
  }

  var sT = new Map(),
      rT = new Map(),
      oT = new Map();
  var aT, cT;
  !function (e) {
    e.WIN_10 = "Windows 10", e.WIN_81 = "Windows 8.1", e.WIN_8 = "Windows 8", e.WIN_7 = "Windows 7", e.WIN_VISTA = "Windows Vista", e.WIN_SERVER_2003 = "Windows Server 2003", e.WIN_XP = "Windows XP", e.WIN_2000 = "Windows 2000", e.ANDROID = "Android", e.HARMONY_OS = "HarmonyOS", e.OPEN_BSD = "Open BSD", e.SUN_OS = "Sun OS", e.LINUX = "Linux", e.IOS = "iOS", e.MAC_OS = "Mac OS", e.CHROMIUM_OS = "Chromium OS", e.QNX = "QNX", e.UNIX = "UNIX", e.BEOS = "BeOS", e.OS_2 = "OS/2", e.SEARCH_BOT = "Search Bot";
  }(aT || (aT = {})), function (e) {
    e.CHROME = "Chrome", e.SAFARI = "Safari", e.EDGE = "Edge", e.FIREFOX = "Firefox", e.OPERA = "OPR", e.QQ = "QQBrowser", e.WECHAT = "MicroMessenger";
  }(cT || (cT = {}));
  var dT = {
    exports: {}
  };
  !function (e, i) {
    !function (t, n) {
      var s = "function",
          r = "undefined",
          o = "object",
          a = "string",
          c = "major",
          d = "model",
          l = "name",
          u = "type",
          h = "vendor",
          p = "version",
          _ = "architecture",
          E = "console",
          m = "mobile",
          f = "tablet",
          T = "smarttv",
          g = "wearable",
          S = "embedded",
          R = "Amazon",
          C = "Apple",
          I = "ASUS",
          v = "BlackBerry",
          y = "Browser",
          A = "Chrome",
          b = "Firefox",
          w = "Google",
          O = "Huawei",
          N = "LG",
          D = "Microsoft",
          P = "Motorola",
          L = "Opera",
          k = "Samsung",
          M = "Sharp",
          U = "Sony",
          x = "Xiaomi",
          V = "Zebra",
          F = "Facebook",
          B = "Chromium OS",
          j = "Mac OS",
          G = function G(e) {
        for (var t = {}, i = 0; i < e.length; i++) {
          t[e[i].toUpperCase()] = e[i];
        }

        return t;
      },
          W = function W(e, t) {
        return _typeof(e) === a && -1 !== H(t).indexOf(H(e));
      },
          H = function H(e) {
        return e.toLowerCase();
      },
          K = function K(e, t) {
        if (_typeof(e) === a) return e = e.replace(/^\s\s*/, ""), _typeof(t) === r ? e : e.substring(0, 350);
      },
          Y = function Y(e, t) {
        for (var i, r, a, c, d, l, u = 0; u < t.length && !d;) {
          var h = t[u],
              p = t[u + 1];

          for (i = r = 0; i < h.length && !d && h[i];) {
            if (d = h[i++].exec(e)) for (a = 0; a < p.length; a++) {
              l = d[++r], _typeof(c = p[a]) === o && c.length > 0 ? 2 === c.length ? _typeof(c[1]) == s ? this[c[0]] = c[1].call(this, l) : this[c[0]] = c[1] : 3 === c.length ? _typeof(c[1]) !== s || c[1].exec && c[1].test ? this[c[0]] = l ? l.replace(c[1], c[2]) : n : this[c[0]] = l ? c[1].call(this, l, c[2]) : n : 4 === c.length && (this[c[0]] = l ? c[3].call(this, l.replace(c[1], c[2])) : n) : this[c] = l || n;
            }
          }

          u += 2;
        }
      },
          q = function q(e, t) {
        for (var i in t) {
          if (_typeof(t[i]) === o && t[i].length > 0) {
            for (var s = 0; s < t[i].length; s++) {
              if (W(t[i][s], e)) return "?" === i ? n : i;
            }
          } else if (W(t[i], e)) return "?" === i ? n : i;
        }

        return e;
      },
          J = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      },
          z = {
        browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [p, [l, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [p, [l, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [l, p], [/opios[\/ ]+([\w\.]+)/i], [p, [l, L + " Mini"]], [/\bopr\/([\w\.]+)/i], [p, [l, L]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [l, p], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [p, [l, "UC" + y]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [p, [l, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [p, [l, "WeChat"]], [/konqueror\/([\w\.]+)/i], [p, [l, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [p, [l, "IE"]], [/yabrowser\/([\w\.]+)/i], [p, [l, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[l, /(.+)/, "$1 Secure " + y], p], [/\bfocus\/([\w\.]+)/i], [p, [l, b + " Focus"]], [/\bopt\/([\w\.]+)/i], [p, [l, L + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [p, [l, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [p, [l, "Dolphin"]], [/coast\/([\w\.]+)/i], [p, [l, L + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [p, [l, "MIUI " + y]], [/fxios\/([-\w\.]+)/i], [p, [l, b]], [/\bqihu|(qi?ho?o?|360)browser/i], [[l, "360 " + y]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[l, /(.+)/, "$1 " + y], p], [/(comodo_dragon)\/([\w\.]+)/i], [[l, /_/g, " "], p], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [l, p], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [l], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[l, F], p], [/(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [l, p], [/\bgsa\/([\w\.]+) .*safari\//i], [p, [l, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [p, [l, A + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[l, A + " WebView"], p], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [p, [l, "Android " + y]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [l, p], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [p, [l, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [p, l], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [l, [p, q, {
          "1.0": "/8",
          1.2: "/1",
          1.3: "/3",
          "2.0": "/412",
          "2.0.2": "/416",
          "2.0.3": "/417",
          "2.0.4": "/419",
          "?": "/"
        }]], [/(webkit|khtml)\/([\w\.]+)/i], [l, p], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[l, "Netscape"], p], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [p, [l, b + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [l, p], [/(cobalt)\/([\w\.]+)/i], [l, [p, /master.|lts./, ""]]],
        cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[_, "amd64"]], [/(ia32(?=;))/i], [[_, H]], [/((?:i[346]|x)86)[;\)]/i], [[_, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[_, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[_, "armhf"]], [/windows (ce|mobile); ppc;/i], [[_, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[_, /ower/, "", H]], [/(sun4\w)[;\)]/i], [[_, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[_, H]]],
        device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [d, [h, k], [u, f]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [d, [h, k], [u, m]], [/\((ip(?:hone|od)[\w ]*);/i], [d, [h, C], [u, m]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [d, [h, C], [u, f]], [/(macintosh);/i], [d, [h, C]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [d, [h, M], [u, m]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [d, [h, O], [u, f]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [d, [h, O], [u, m]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[d, /_/g, " "], [h, x], [u, m]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[d, /_/g, " "], [h, x], [u, f]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [d, [h, "OPPO"], [u, m]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [d, [h, "Vivo"], [u, m]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [d, [h, "Realme"], [u, m]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [d, [h, P], [u, m]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [d, [h, P], [u, f]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [d, [h, N], [u, f]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [d, [h, N], [u, m]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [d, [h, "Lenovo"], [u, f]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[d, /_/g, " "], [h, "Nokia"], [u, m]], [/(pixel c)\b/i], [d, [h, w], [u, f]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [d, [h, w], [u, m]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [d, [h, U], [u, m]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[d, "Xperia Tablet"], [h, U], [u, f]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [d, [h, "OnePlus"], [u, m]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [d, [h, R], [u, f]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[d, /(.+)/g, "Fire Phone $1"], [h, R], [u, m]], [/(playbook);[-\w\),; ]+(rim)/i], [d, h, [u, f]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [d, [h, v], [u, m]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [d, [h, I], [u, f]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [d, [h, I], [u, m]], [/(nexus 9)/i], [d, [h, "HTC"], [u, f]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [h, [d, /_/g, " "], [u, m]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [d, [h, "Acer"], [u, f]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [d, [h, "Meizu"], [u, m]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [h, d, [u, m]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [h, d, [u, f]], [/(surface duo)/i], [d, [h, D], [u, f]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [d, [h, "Fairphone"], [u, m]], [/(u304aa)/i], [d, [h, "AT&T"], [u, m]], [/\bsie-(\w*)/i], [d, [h, "Siemens"], [u, m]], [/\b(rct\w+) b/i], [d, [h, "RCA"], [u, f]], [/\b(venue[\d ]{2,7}) b/i], [d, [h, "Dell"], [u, f]], [/\b(q(?:mv|ta)\w+) b/i], [d, [h, "Verizon"], [u, f]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [d, [h, "Barnes & Noble"], [u, f]], [/\b(tm\d{3}\w+) b/i], [d, [h, "NuVision"], [u, f]], [/\b(k88) b/i], [d, [h, "ZTE"], [u, f]], [/\b(nx\d{3}j) b/i], [d, [h, "ZTE"], [u, m]], [/\b(gen\d{3}) b.+49h/i], [d, [h, "Swiss"], [u, m]], [/\b(zur\d{3}) b/i], [d, [h, "Swiss"], [u, f]], [/\b((zeki)?tb.*\b) b/i], [d, [h, "Zeki"], [u, f]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[h, "Dragon Touch"], d, [u, f]], [/\b(ns-?\w{0,9}) b/i], [d, [h, "Insignia"], [u, f]], [/\b((nxa|next)-?\w{0,9}) b/i], [d, [h, "NextBook"], [u, f]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[h, "Voice"], d, [u, m]], [/\b(lvtel\-)?(v1[12]) b/i], [[h, "LvTel"], d, [u, m]], [/\b(ph-1) /i], [d, [h, "Essential"], [u, m]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [d, [h, "Envizen"], [u, f]], [/\b(trio[-\w\. ]+) b/i], [d, [h, "MachSpeed"], [u, f]], [/\btu_(1491) b/i], [d, [h, "Rotor"], [u, f]], [/(shield[\w ]+) b/i], [d, [h, "Nvidia"], [u, f]], [/(sprint) (\w+)/i], [h, d, [u, m]], [/(kin\.[onetw]{3})/i], [[d, /\./g, " "], [h, D], [u, m]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [d, [h, V], [u, f]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [d, [h, V], [u, m]], [/smart-tv.+(samsung)/i], [h, [u, T]], [/hbbtv.+maple;(\d+)/i], [[d, /^/, "SmartTV"], [h, k], [u, T]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[h, N], [u, T]], [/(apple) ?tv/i], [h, [d, C + " TV"], [u, T]], [/crkey/i], [[d, A + "cast"], [h, w], [u, T]], [/droid.+aft(\w)( bui|\))/i], [d, [h, R], [u, T]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [d, [h, M], [u, T]], [/(bravia[\w ]+)( bui|\))/i], [d, [h, U], [u, T]], [/(mitv-\w{5}) bui/i], [d, [h, x], [u, T]], [/Hbbtv.*(technisat) (.*);/i], [h, d, [u, T]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[h, K], [d, K], [u, T]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[u, T]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [h, d, [u, E]], [/droid.+; (shield) bui/i], [d, [h, "Nvidia"], [u, E]], [/(playstation [345portablevi]+)/i], [d, [h, U], [u, E]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [d, [h, D], [u, E]], [/((pebble))app/i], [h, d, [u, g]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [d, [h, C], [u, g]], [/droid.+; (glass) \d/i], [d, [h, w], [u, g]], [/droid.+; (wt63?0{2,3})\)/i], [d, [h, V], [u, g]], [/(quest( 2| pro)?)/i], [d, [h, F], [u, g]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [h, [u, S]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [d, [u, m]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [d, [u, f]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[u, f]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[u, m]], [/(android[-\w\. ]{0,9});.+buil/i], [d, [h, "Generic"]]],
        engine: [[/windows.+ edge\/([\w\.]+)/i], [p, [l, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [p, [l, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [l, p], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [p, l]],
        os: [[/microsoft (windows) (vista|xp)/i], [l, p], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [l, [p, q, J]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[l, "Windows"], [p, q, J]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[p, /_/g, "."], [l, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[l, j], [p, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [p, l], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [l, p], [/\(bb(10);/i], [p, [l, v]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [p, [l, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [p, [l, b + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [p, [l, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [p, [l, "watchOS"]], [/crkey\/([\d\.]+)/i], [p, [l, A + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[l, B], p], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [l, p], [/(sunos) ?([\w\.\d]*)/i], [[l, "Solaris"], p], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [l, p]]
      },
          X = function X(e, i) {
        if (_typeof(e) === o && (i = e, e = n), !(this instanceof X)) return new X(e, i).getResult();
        var E = _typeof(t) !== r && t.navigator ? t.navigator : n,
            T = e || (E && E.userAgent ? E.userAgent : ""),
            g = E && E.userAgentData ? E.userAgentData : n,
            S = i ? function (e, t) {
          var i = {};

          for (var n in e) {
            t[n] && t[n].length % 2 == 0 ? i[n] = t[n].concat(e[n]) : i[n] = e[n];
          }

          return i;
        }(z, i) : z;
        return this.getBrowser = function () {
          var e = {};
          return e[l] = n, e[p] = n, Y.call(e, T, S.browser), e[c] = function (e) {
            return _typeof(e) === a ? e.replace(/[^\d\.]/g, "").split(".")[0] : n;
          }(e[p]), E && E.brave && _typeof(E.brave.isBrave) == s && (e[l] = "Brave"), e;
        }, this.getCPU = function () {
          var e = {};
          return e[_] = n, Y.call(e, T, S.cpu), e;
        }, this.getDevice = function () {
          var e = {};
          return e[h] = n, e[d] = n, e[u] = n, Y.call(e, T, S.device), !e[u] && g && g.mobile && (e[u] = m), "Macintosh" == e[d] && E && _typeof(E.standalone) !== r && E.maxTouchPoints && E.maxTouchPoints > 2 && (e[d] = "iPad", e[u] = f), e;
        }, this.getEngine = function () {
          var e = {};
          return e[l] = n, e[p] = n, Y.call(e, T, S.engine), e;
        }, this.getOS = function () {
          var e = {};
          return e[l] = n, e[p] = n, Y.call(e, T, S.os), !e[l] && g && "Unknown" != g.platform && (e[l] = g.platform.replace(/chrome os/i, B).replace(/macos/i, j)), e;
        }, this.getResult = function () {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function () {
          return T;
        }, this.setUA = function (e) {
          return T = _typeof(e) === a && e.length > 350 ? K(e, 350) : e, this;
        }, this.setUA(T), this;
      };

      X.VERSION = "0.7.34", X.BROWSER = G([l, p, c]), X.CPU = G([_]), X.DEVICE = G([d, h, u, E, m, T, f, g, S]), X.ENGINE = X.OS = G([l, p]), e.exports && (i = e.exports = X), i.UAParser = X;
      var Q = _typeof(t) !== r && (t.jQuery || t.Zepto);

      if (Q && !Q.ua) {
        var Z = new X();
        Q.ua = Z.getResult(), Q.ua.get = function () {
          return Z.getUA();
        }, Q.ua.set = function (e) {
          Z.setUA(e);
          var t = Z.getResult();

          for (var i in t) {
            Q.ua[i] = t[i];
          }
        };
      }
    }("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? window : t);
  }(dT, dT.exports);
  var lT = new (i(dT.exports))();
  var uT = lT.getResult(),
      hT = null;

  function pT(e) {
    if (!hT) {
      e && lT.setUA(e), uT = lT.getResult();

      var _t21 = function (e) {
        if ("Blink" === e.engine.name && "WeChat" !== e.browser.name) return cT.CHROME;

        switch (e.browser.name) {
          case "Chrome Headless":
          case "Chrome":
          case "Chromium":
            return cT.CHROME;

          case "Safari":
          case "Mobile Safari":
            return cT.SAFARI;

          case "Edge":
            return cT.EDGE;

          case "Firefox":
            return cT.FIREFOX;

          case "QQBrowser":
            return cT.QQ;

          case "Opera":
            return cT.OPERA;

          case "WeChat":
            return cT.WECHAT;

          default:
            return e.browser.name || "";
        }
      }(uT),
          _i15 = function (e) {
        var t;
        t = "Blink" === e.engine.name ? e.engine.version || "" : e.browser.version || "";
        return t.split(".")[0];
      }(uT),
          _n14 = function (e) {
        if ("Windows" === e.os.name) return e.os.version ? e.os.name + " " + e.os.version : e.os.name;
        return e.os.name || "";
      }(uT),
          _s6 = uT.os.version;

      if (!(_t21 && _i15 && _n14 && _s6)) return {
        name: _t21,
        version: _i15,
        os: _n14,
        osVersion: _s6
      };
      hT = {
        name: _t21,
        version: _i15,
        os: _n14,
        osVersion: _s6
      };
    }

    return hT;
  }

  function _T() {
    return pT().os;
  }

  function ET() {
    var e = pT();
    return "".concat(e.os, " ").concat(e.osVersion);
  }

  function mT() {
    var e = pT();
    return !!("WebKit" === uT.engine.name && e.os === aT.MAC_OS && navigator.maxTouchPoints && navigator.maxTouchPoints > 0 && e.name !== cT.SAFARI || CT() && e.name !== cT.SAFARI);
  }

  function fT() {
    var e = pT();

    if (mT()) {
      if (e.os === aT.MAC_OS) return !0;

      if (e.os === aT.IOS) {
        var _e15 = uT.os.version && uT.os.version.split(".");

        if (_e15 && 14 === Number(_e15[0]) && _e15[1] && Number(_e15[1]) >= 3) return !0;
        if (_e15 && Number(_e15[0]) > 14) return !0;
      }
    }

    return !1;
  }

  function TT() {
    return "WebKit" === uT.engine.name;
  }

  function gT() {
    return pT().name === cT.CHROME;
  }

  function ST() {
    return pT().name === cT.SAFARI;
  }

  function RT() {
    return pT().name === cT.FIREFOX;
  }

  function CT() {
    return pT().os === aT.IOS;
  }

  function IT(e) {
    var t = pT();
    return !(t.name !== cT.CHROME || !t.osVersion) && Number(t.version) >= e;
  }

  function vT(e) {
    var t = pT();
    return !(t.name !== cT.EDGE || !t.osVersion) && Number(t.version) >= e;
  }

  function yT(e) {
    var t = pT();
    return !(t.name !== cT.OPERA || !t.osVersion) && Number(t.version) >= e;
  }

  function AT() {
    var e = pT();
    return !(e.name !== cT.CHROME || !e.osVersion) && Number(e.version) <= 90;
  }

  function bT() {
    var e = pT();
    if (e.os !== aT.IOS || !e.osVersion) return !1;
    var t = e.osVersion.split(".");
    return Number(t[0]) < 14 || 14 === Number(t[0]) && Number(t[1]) <= 6;
  }

  function wT() {
    var e = pT();
    if (e.os !== aT.IOS || !e.osVersion) return !1;
    var t = e.osVersion.split(".");
    return 15 === Number(t[0]);
  }

  function OT() {
    var e = pT();
    if (e.os !== aT.IOS || !e.osVersion) return !1;
    var t = e.osVersion.split(".");
    return 16 === Number(t[0]);
  }

  function NT() {
    var e = pT();
    if (e.os !== aT.IOS || !e.osVersion) return !1;
    var t = e.osVersion.split(".");
    return 15 === Number(t[0]) && Number(t[1]) >= 1;
  }

  function DT() {
    return ST() && navigator.maxTouchPoints > 0;
  }

  function PT() {
    return pT().name === cT.WECHAT;
  }

  function LT() {
    return window.navigator.appVersion && null !== window.navigator.appVersion.match(/Chrome\/([\w\W]*?)\./) && window.navigator.appVersion.match(/Chrome\/([\w\W]*?)\./)[1] <= 35;
  }

  function kT() {
    var e = pT();
    if (e.name === cT.EDGE || e.name === cT.SAFARI) return !1;
    return !!navigator.userAgent.toLocaleLowerCase().match(/chrome\/[\d]./i);
  }

  function MT() {
    return _T() === aT.ANDROID;
  }

  function UT() {
    var e = pT();
    return MT() && (e.name === cT.CHROME || e.name === cT.WECHAT || /chrome|chromium/i.test(navigator.userAgent));
  }

  var xT;
  !function (e) {
    e.UNEXPECTED_ERROR = "UNEXPECTED_ERROR", e.UNEXPECTED_RESPONSE = "UNEXPECTED_RESPONSE", e.TIMEOUT = "TIMEOUT", e.INVALID_PARAMS = "INVALID_PARAMS", e.NOT_READABLE = "NOT_READABLE", e.NOT_SUPPORTED = "NOT_SUPPORTED", e.INVALID_OPERATION = "INVALID_OPERATION", e.OPERATION_ABORTED = "OPERATION_ABORTED", e.WEB_SECURITY_RESTRICT = "WEB_SECURITY_RESTRICT", e.EXCHANGE_SDP_FAILED = "EXCHANGE_SDP_FAILED", e.ADD_CANDIDATE_FAILED = "ADD_CANDIDATE_FAILED", e.DATACHANNEL_FAILED = "DATACHANNEL_FAILED", e.NETWORK_ERROR = "NETWORK_ERROR", e.NETWORK_TIMEOUT = "NETWORK_TIMEOUT", e.NETWORK_RESPONSE_ERROR = "NETWORK_RESPONSE_ERROR", e.API_INVOKE_TIMEOUT = "API_INVOKE_TIMEOUT", e.ENUMERATE_DEVICES_FAILED = "ENUMERATE_DEVICES_FAILED", e.DEVICE_NOT_FOUND = "DEVICE_NOT_FOUND", e.ELECTRON_IS_NULL = "ELECTRON_IS_NULL", e.ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR = "ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR", e.CHROME_PLUGIN_NO_RESPONSE = "CHROME_PLUGIN_NO_RESPONSE", e.CHROME_PLUGIN_NOT_INSTALL = "CHROME_PLUGIN_NOT_INSTALL", e.MEDIA_OPTION_INVALID = "MEDIA_OPTION_INVALID", e.PERMISSION_DENIED = "PERMISSION_DENIED", e.CONSTRAINT_NOT_SATISFIED = "CONSTRAINT_NOT_SATISFIED", e.TRACK_IS_DISABLED = "TRACK_IS_DISABLED", e.GET_VIDEO_ELEMENT_VISIBLE_ERROR = "GET_VIDEO_ELEMENT_VISIBLE_ERROR", e.SHARE_AUDIO_NOT_ALLOWED = "SHARE_AUDIO_NOT_ALLOWED", e.LOW_STREAM_ENCODING_ERROR = "LOW_STREAM_ENCODING_ERROR", e.SET_ENCODING_PARAMETER_ERROR = "SET_ENCODING_PARAMETER_ERROR", e.TRACK_STATE_UNREACHABLE = "TRACK_STATE_UNREACHABLE", e.INVALID_UINT_UID_FROM_STRING_UID = "INVALID_UINT_UID_FROM_STRING_UID", e.CAN_NOT_GET_PROXY_SERVER = "CAN_NOT_GET_PROXY_SERVER", e.CAN_NOT_GET_GATEWAY_SERVER = "CAN_NOT_GET_GATEWAY_SERVER", e.VOID_GATEWAY_ADDRESS = "VOID_GATEWAY_ADDRESS", e.UID_CONFLICT = "UID_CONFLICT", e.MULTI_UNILBS_RESPONSE_ERROR = "MULTI_UNILBS_RESPONSE_ERROR", e.UPDATE_TICKET_FAILED = "UPDATE_TICKET_FAILED", e.INVALID_LOCAL_TRACK = "INVALID_LOCAL_TRACK", e.INVALID_TRACK = "INVALID_TRACK", e.SENDER_NOT_FOUND = "SENDER_NOT_FOUND", e.CREATE_OFFER_FAILED = "CREATE_OFFER_FAILED", e.SET_ANSWER_FAILED = "SET_ANSWER_FAILED", e.ICE_FAILED = "ICE_FAILED", e.PC_CLOSED = "PC_CLOSED", e.SENDER_REPLACE_FAILED = "SENDER_REPLACE_FAILED", e.GET_LOCAL_CAPABILITIES_FAILED = "GET_LOCAL_CAPABILITIES_FAILED", e.GET_LOCAL_CONNECTION_PARAMS_FAILED = "GET_LOCAL_CONNECTION_PARAMS_FAILED", e.SUBSCRIBE_FAILED = "SUBSCRIBE_FAILED", e.UNSUBSCRIBE_FAILED = "UNSUBSCRIBE_FAILED", e.GATEWAY_P2P_LOST = "GATEWAY_P2P_LOST", e.NO_ICE_CANDIDATE = "NO_ICE_CANDIDATE", e.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS = "CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS", e.EXIST_DISABLED_VIDEO_TRACK = "EXIST_DISABLED_VIDEO_TRACK", e.INVALID_REMOTE_USER = "INVALID_REMOTE_USER", e.REMOTE_USER_IS_NOT_PUBLISHED = "REMOTE_USER_IS_NOT_PUBLISHED", e.CUSTOM_REPORT_SEND_FAILED = "CUSTOM_REPORT_SEND_FAILED", e.CUSTOM_REPORT_FREQUENCY_TOO_HIGH = "CUSTOM_REPORT_FREQUENCY_TOO_HIGH", e.FETCH_AUDIO_FILE_FAILED = "FETCH_AUDIO_FILE_FAILED", e.READ_LOCAL_AUDIO_FILE_ERROR = "READ_LOCAL_AUDIO_FILE_ERROR", e.DECODE_AUDIO_FILE_FAILED = "DECODE_AUDIO_FILE_FAILED", e.WS_ABORT = "WS_ABORT", e.WS_DISCONNECT = "WS_DISCONNECT", e.WS_ERR = "WS_ERR", e.EXTERNAL_SIGNAL_ABORT = "EXTERNAL_SIGNAL_ABORT", e.LIVE_STREAMING_TASK_CONFLICT = "LIVE_STREAMING_TASK_CONFLICT", e.LIVE_STREAMING_INVALID_ARGUMENT = "LIVE_STREAMING_INVALID_ARGUMENT", e.LIVE_STREAMING_INTERNAL_SERVER_ERROR = "LIVE_STREAMING_INTERNAL_SERVER_ERROR", e.LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED = "LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED", e.LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED = "LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED", e.LIVE_STREAMING_CDN_ERROR = "LIVE_STREAMING_CDN_ERROR", e.LIVE_STREAMING_INVALID_RAW_STREAM = "LIVE_STREAMING_INVALID_RAW_STREAM", e.LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT = "LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT", e.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE = "LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE", e.LIVE_STREAMING_WARN_FREQUENT_REQUEST = "LIVE_STREAMING_WARN_FREQUENT_REQUEST", e.WEBGL_INTERNAL_ERROR = "WEBGL_INTERNAL_ERROR", e.BEAUTY_PROCESSOR_INTERNAL_ERROR = "BEAUTY_PROCESSOR_INTERNAL_ERROR", e.CROSS_CHANNEL_WAIT_STATUS_ERROR = "CROSS_CHANNEL_WAIT_STATUS_ERROR", e.CROSS_CHANNEL_FAILED_JOIN_SRC = "CROSS_CHANNEL_FAILED_JOIN_SEC", e.CROSS_CHANNEL_FAILED_JOIN_DEST = "CROSS_CHANNEL_FAILED_JOIN_DEST", e.CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST = "CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST", e.CROSS_CHANNEL_SERVER_ERROR_RESPONSE = "CROSS_CHANNEL_SERVER_ERROR_RESPONSE", e.METADATA_OUT_OF_RANGE = "METADATA_OUT_OF_RANGE", e.LOCAL_AEC_ERROR = "LOCAL_AEC_ERROR", e.INVALID_PLUGIN = "INVALID_PLUGIN", e.DISCONNECT_P2P = "DISCONNECT_P2P", e.INIT_WEBSOCKET_TIMEOUT = "INIT_WEBSOCKET_TIMEOUT", e.CONVERTING_IMAGEDATA_TO_BLOB_FAILED = "CONVERTING_IMAGEDATA_TO_BLOB_FAILED", e.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED = "CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED", e.INIT_DATACHANNEL_TIMEOUT = "INIT_DATACHANNEL_TIMEOUT", e.DATACHANNEL_CONNECTION_TIMEOUT = "DATACHANNEL_CONNECTION_TIMEOUT", e.PROHIBITED_OPERATION = "PROHIBITED_OPERATION", e.IMAGE_MODERATION_UPLOAD_FAILED = "IMAGE_MODERATION_UPLOAD_FAILED", e.P2P_MESSAGE_FAILED = "P2P_MESSAGE_FAILED";
  }(xT || (xT = {}));

  var VT = /*#__PURE__*/function (_Error) {
    _inherits(VT, _Error);

    var _super = _createSuper(VT);

    function VT(e) {
      var _this26;

      _classCallCheck(this, VT);

      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          i = arguments.length > 2 ? arguments[2] : void 0;
      _this26 = _super.call(this, t), nh(_assertThisInitialized(_this26), "code", void 0), nh(_assertThisInitialized(_this26), "message", void 0), nh(_assertThisInitialized(_this26), "data", void 0), nh(_assertThisInitialized(_this26), "name", "AgoraRTCException"), _this26.code = e, _this26.message = "AgoraRTCError ".concat(_this26.code, ": ").concat(t), _this26.data = i;
      return _this26;
    }

    _createClass(VT, [{
      key: "toString",
      value: function toString() {
        return this.data ? "data: ".concat(JSON.stringify(this.data), "\n").concat(this.stack) : "".concat(this.stack);
      }
    }, {
      key: "print",
      value: function print() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "error",
            t = arguments.length > 1 ? arguments[1] : void 0;
        return "error" === e && (t || console).error(this.toString()), "warning" === e && (t || console).warn(this.toString()), this;
      }
    }, {
      key: "throw",
      value: function _throw(e) {
        throw this.print("error", e), this;
      }
    }]);

    return VT;
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  function FT(e, t) {
    if ("boolean" != typeof e) throw new VT(xT.INVALID_PARAMS, "Invalid ".concat(t, ": The value is of the boolean type."));
  }

  function BT(e, t, i) {
    if (bn(i).call(i, e)) return;
    throw new VT(xT.INVALID_PARAMS, "".concat(t, " can only be set as ").concat(JSON.stringify(i)));
  }

  function jT(e, t) {
    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e4;

    if (e < i || e > n || (!(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]) && !function (e) {
      return "number" == typeof e && e % 1 == 0;
    }(e)) {
      throw new VT(xT.INVALID_PARAMS, "invalid ".concat(t, ": the value range is [").concat(i, ", ").concat(n, "]. integer only"));
    }
  }

  function GT(e, t) {
    if ("number" != typeof e) {
      if (!(e.min || e.max || e.ideal || e.exact)) {
        throw new VT(xT.INVALID_PARAMS, "".concat(t, " is not a valid ConstrainLong"));
      }

      void 0 !== e.min && jT(e.min, "".concat(t, ".min"), 0, 1 / 0), void 0 !== e.max && jT(e.max, "".concat(t, ".max"), 1, 1 / 0), void 0 !== e.exact && jT(e.exact, "".concat(t, ".exact"), 1, 1 / 0), void 0 !== e.ideal && jT(e.ideal, "".concat(t, ".ideal"), 1, 1 / 0);
    } else jT(e, t, 1, 1 / 0);
  }

  function WT(e, t) {
    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 255,
        s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
    if (null == e) throw new VT(xT.INVALID_PARAMS, "".concat(t || "param", " cannot be empty"));
    if (!YT(e, i, n, s)) throw new VT(xT.INVALID_PARAMS, "Invalid ".concat(t || "string param", ": Length of the string: [").concat(i, ",").concat(n, "].").concat(s ? " ASCII characters only." : ""));
  }

  function HT(e, t) {
    if (!Array.isArray(e)) throw new VT(xT.INVALID_PARAMS, "".concat(t, " should be an array"));
  }

  function KT(e) {
    return null == e;
  }

  function YT(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 255,
        n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
    return "string" == typeof e && e.length <= i && e.length >= t && (!n || function (e) {
      if ("string" != typeof e) return !1;

      for (var _t22 = 0; _t22 < e.length; _t22 += 1) {
        var _i16 = e.charCodeAt(_t22);

        if (_i16 < 0 || _i16 > 255) return !1;
      }

      return !0;
    }(e));
  }

  function qT(e, t, i) {
    if ("getBigUint64" in DataView.prototype) return e.getBigUint64(t, i);
    var n = e.getUint32(t, i),
        s = e.getUint32(t + 4, i),
        r = Number(!!i),
        o = Number(!i);
    return BigInt(n * o + s * r) << BigInt(32) | BigInt(n * r + s * o);
  }

  function JT(e, t, i, n) {
    if ("setBigUint64" in DataView.prototype) return e.setBigUint64(t, i, n);
    var s = Number(i >> BigInt(32)),
        r = Number(i & BigInt(4294967295));
    n ? (e.setUint32(t + 4, s, n), e.setUint32(t, r, n)) : (e.setUint32(t, s, n), e.setUint32(t + 4, r, n));
  }

  var zT, XT;
  !function (e) {
    e.COVERED = "COVERED", e.POSITION = "POSITION", e.SIZE = "SIZE", e.STYLE = "STYLE";
  }(zT || (zT = {})), function (e) {
    e.UNMOUNTED = "UNMOUNTED", e.INVALID_HTML_ELEMENT = "INVALID_HTML_ELEMENT";
  }(XT || (XT = {}));
  var QT = new ( /*#__PURE__*/function () {
    function _class() {
      var _this27 = this;

      _classCallCheck(this, _class);

      nh(this, "_clientSize", null), nh(this, "getClientWidth", function () {
        return document.documentElement ? document.documentElement.clientWidth : document.body.clientWidth;
      }), nh(this, "getClientHeight", function () {
        return document.documentElement ? document.documentElement.clientHeight : document.body.clientHeight;
      }), nh(this, "getStyle", function (e) {
        return window.getComputedStyle(e, null);
      }), nh(this, "checkCssVisibleProperty", function (e) {
        var t;
        var i = !0;

        var n = _this27.getStyle(e),
            s = n.display,
            r = n.visibility,
            o = n.opacity,
            a = n.filter;

        if (("none" === s || bn(t = ["hidden", "collapse"]).call(t, r) || Number(o) < .1) && (i = !1), !i) return !1;

        if (a) {
          a.split(" ").filter(function (e) {
            var t;
            var i = e.split("(")[0];
            return bn(t = ["brightness", "blur", "opacity"]).call(t, i);
          }).map(function (e) {
            var _e$split = e.split(/\(|\)/),
                _e$split2 = _slicedToArray(_e$split, 2),
                t = _e$split2[0],
                i = _e$split2[1];

            return [t, Number(i.match(/^[0-9\.]+/))];
          }).forEach(function (e) {
            var _e16 = _slicedToArray(e, 2),
                t = _e16[0],
                n = _e16[1];

            switch (t) {
              case "brightness":
                (n < .1 || n > 3) && (i = !1);
                break;

              case "blur":
                n > 3 && (i = !1);
                break;

              case "opacity":
                n < .1 && (i = !1);
            }
          });
        }

        return i;
      }), nh(this, "checkPropertyUpToAllParentNodes", function (e, t) {
        var i = !0,
            n = !0;

        var s = function s(e) {
          return t(e);
        };

        var r = e;

        for (; r && n;) {
          s(r) || (i = !1, n = !1), r = r.parentElement, r || (n = !1);
        }

        return i;
      }), nh(this, "checkActualCssVisibleIncludeInherit", function (e) {
        return _this27.checkPropertyUpToAllParentNodes(e, _this27.checkCssVisibleProperty);
      }), nh(this, "getSizeAboutClient", function (e) {
        var _e$getBoundingClientR = e.getBoundingClientRect(),
            t = _e$getBoundingClientR.width,
            i = _e$getBoundingClientR.height,
            n = _e$getBoundingClientR.left,
            s = _e$getBoundingClientR.right,
            r = _e$getBoundingClientR.top,
            o = _e$getBoundingClientR.bottom,
            a = _this27.getClientWidth(),
            c = _this27.getClientHeight();

        return {
          width: t,
          height: i,
          left: n,
          right: s,
          top: r,
          bottom: o,
          clientWidth: a,
          clientHeight: c,
          clientMin: Math.min(a, c)
        };
      }), nh(this, "checkActualSize", function () {
        var _this27$_clientSize = _this27._clientSize,
            e = _this27$_clientSize.width,
            t = _this27$_clientSize.height,
            i = _this27$_clientSize.clientMin;
        return _this27.checkSizeIsVisible(e, t, i);
      }), nh(this, "elementFromPoint", function (e, t) {
        return document.elementFromPoint ? document.elementFromPoint(e, t) : null;
      }), nh(this, "checkCoverForAPoint", function (e, t, i) {
        var n = _this27.elementFromPoint(e, t);

        return null !== n && n !== i;
      }), nh(this, "getPointPositionList", function () {
        var _this27$_clientSize2 = _this27._clientSize,
            e = _this27$_clientSize2.width,
            t = _this27$_clientSize2.height,
            i = _this27$_clientSize2.left,
            n = _this27$_clientSize2.top,
            s = e / 6,
            r = t / 6,
            o = [],
            a = Math.pow(10, 6);

        for (var _e17 = 0; _e17 < 5; _e17++) {
          for (var _t23 = 0; _t23 < 5; _t23++) {
            var _c2 = (i * a + (0 === _e17 ? .1 : 4 === _e17 ? (s * _e17 * a - 1e5) / a : s * _e17) * a) / a,
                _d2 = (n * a + (0 === _t23 ? .1 : 4 === _t23 ? (r * _t23 * a - 1e5) / a : r * _t23) * a) / a;

            o.push({
              x: _c2,
              y: _d2
            });
          }
        }

        return [].concat(o);
      }), nh(this, "checkElementCover", function (e) {
        return _this27.getPointPositionList().map(function (t) {
          return _this27.checkCoverForAPoint(t.x, t.y, e);
        }).filter(function (e) {
          return !!e;
        }).length > 6;
      }), nh(this, "checkSizeIsVisible", function (e, t, i) {
        return (e > 50 || i / e <= 10) && (t > 50 || i / t <= 10);
      }), nh(this, "checkSizeOfPartInClient", function () {
        var _this27$_clientSize3 = _this27._clientSize,
            e = _this27$_clientSize3.left,
            t = _this27$_clientSize3.right,
            i = _this27$_clientSize3.top,
            n = _this27$_clientSize3.bottom,
            s = _this27$_clientSize3.clientHeight,
            r = _this27$_clientSize3.clientWidth,
            o = _this27$_clientSize3.clientMin;
        var a, c, d, l;
        if (e < 0) a = 0;else {
          if (!(e < r)) return !1;
          a = e;
        }
        if (t < 0) return !1;
        if (c = t < r ? t : r, i < 0) d = 0;else {
          if (!(i < s)) return !1;
          d = i;
        }
        if (n < 0) return !1;
        l = n < s ? n : s;
        var u = c - a,
            h = l - d;
        return _this27.checkSizeIsVisible(u, h, o);
      }), nh(this, "returnHiddenResult", function (e) {
        return _this27._clientSize = null, {
          visible: !1,
          reason: e
        };
      }), nh(this, "checkOneElementVisible", function (e) {
        if (e instanceof HTMLElement) {
          if (_this27.checkElementIsMountedOnDom(e)) {
            if (_this27.checkActualCssVisibleIncludeInherit(e)) {
              if (_this27._clientSize = _this27.getSizeAboutClient(e), _this27.checkElementCover(e)) return _this27.returnHiddenResult(zT.COVERED);
              {
                var _e18 = _this27.checkActualSize(),
                    _t24 = _this27.checkSizeOfPartInClient();

                return _e18 && !_t24 ? _this27.returnHiddenResult(zT.POSITION) : _e18 ? (_this27._clientSize = null, {
                  visible: !0
                }) : _this27.returnHiddenResult(zT.SIZE);
              }
            }

            return _this27.returnHiddenResult(zT.STYLE);
          }

          return _this27.returnHiddenResult(XT.UNMOUNTED);
        }

        return _this27.returnHiddenResult(XT.INVALID_HTML_ELEMENT);
      }), nh(this, "checkElementIsMountedOnDom", function (e) {
        return _this27.checkPropertyUpToAllParentNodes(e, function (e) {
          return "HTML" !== e.nodeName.toUpperCase() ? null !== e.parentElement : !!document.documentElement;
        });
      });
    }

    return _createClass(_class);
  }())();

  function ZT(e) {
    return new TextEncoder().encode(e);
  }

  var $T = function $T(e, t) {
    var i = new Uint8Array(e.byteLength + t.byteLength);
    return i.set(new Uint8Array(e), 0), i.set(new Uint8Array(t), e.byteLength), i;
  };

  var eg = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var t, i, n, s;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = function (e) {
                var t = window.atob(e),
                    i = new Uint8Array(new ArrayBuffer(t.length));

                for (var _e19 = 0; _e19 < t.length; _e19 += 1) {
                  i[_e19] = t.charCodeAt(_e19);
                }

                return i;
              }("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCMnXAHkKIGAM+x4N22gCI+Wyu\nSTM9ztkT3uYslTT2PuKmZfPzhH6kVdO7PTjGCOZnAsyb3oTtWat0KcxQ4jxvqQV+\nHvYl3iI1Yd4vl2c3qRMJPLtRDfNxa2Mcxgq7e9aEUibzdd0st+OJAy3tOj/Y0aVy\nxQiYDz3vqa6bP29adwIDAQAB");

              _context.next = 3;
              return window.crypto.subtle.importKey("spki", t, {
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, !0, ["encrypt"]);

            case 3:
              i = _context.sent;
              n = ZT(e);
              _context.next = 7;
              return window.crypto.subtle.encrypt({
                name: "RSA-OAEP"
              }, i, n);

            case 7:
              s = _context.sent;
              return _context.abrupt("return", function (e) {
                var t = "";

                for (var _i17 = 0; _i17 < e.length; _i17 += 1) {
                  t += String.fromCharCode(e[_i17]);
                }

                return window.btoa(t);
              }(new Uint8Array(s)));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function eg(_x) {
      return _ref2.apply(this, arguments);
    };
  }(),
      tg = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = function (e, t) {
                var i = "";
                return new Uint8Array(e).forEach(function (e) {
                  i += e.toString(t).padStart(2, "0");
                }), i;
              };

              _context2.next = 3;
              return crypto.subtle.digest("SHA-256", ZT(e));

            case 3:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, 16));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function tg(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var ig = /*#__PURE__*/function () {
    function ig() {
      _classCallCheck(this, ig);

      nh(this, "_events", {}), nh(this, "addListener", this.on);
    }

    _createClass(ig, [{
      key: "getListeners",
      value: function getListeners(e) {
        return this._events[e] ? this._events[e].map(function (e) {
          return e.listener;
        }) : [];
      }
    }, {
      key: "on",
      value: function on(e, t) {
        this._events[e] || (this._events[e] = []);
        var i = this._events[e];
        -1 === this._indexOfListener(i, t) && i.push({
          listener: t,
          once: !1
        });
      }
    }, {
      key: "once",
      value: function once(e, t) {
        this._events[e] || (this._events[e] = []);
        var i = this._events[e];
        -1 === this._indexOfListener(i, t) && i.push({
          listener: t,
          once: !0
        });
      }
    }, {
      key: "off",
      value: function off(e, t) {
        if (!this._events[e]) return;

        var i = this._events[e],
            n = this._indexOfListener(i, t);

        -1 !== n && i.splice(n, 1), 0 === this._events[e].length && delete this._events[e];
      }
    }, {
      key: "removeAllListeners",
      value: function removeAllListeners(e) {
        e ? delete this._events[e] : this._events = {};
      }
    }, {
      key: "emit",
      value: function emit(e) {
        this._events[e] || (this._events[e] = []);

        var t = this._events[e].map(function (e) {
          return e;
        });

        for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) {
          n[s - 1] = arguments[s];
        }

        for (var _i18 = 0; _i18 < t.length; _i18 += 1) {
          var _s7 = t[_i18];
          _s7.once && this.off(e, _s7.listener), _s7.listener.apply(this, n || []);
        }
      }
    }, {
      key: "safeEmit",
      value: function safeEmit(e) {
        var _this28 = this;

        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          i[n - 1] = arguments[n];
        }

        _toConsumableArray(this._events[e] || []).forEach(function (t) {
          t.once && _this28.off(e, t.listener);

          try {
            t.listener.apply(_this28, i);
          } catch (t) {
            console.error("safeEmit event:".concat(e, " error ").concat(null == t ? void 0 : t.toString()));
          }
        });
      }
    }, {
      key: "_indexOfListener",
      value: function _indexOfListener(e, t) {
        var i = e.length;

        for (; i--;) {
          if (e[i].listener === t) return i;
        }

        return -1;
      }
    }]);

    return ig;
  }();

  var ng = null;

  function sg() {
    if (ng) return ng;
    if (window.electron) return ng = window.electron;
    if (!window.require) return null;

    try {
      return ng = window.require("electron"), ng;
    } catch (e) {
      return null;
    }
  }

  var rg, og, ag, cg, dg, lg, ug, hg;

  function pg(e) {
    return jT(e.timeout, "config.timeout", 0, 1e5), jT(e.timeoutFactor, "config.timeoutFactor", 0, 100, !1), jT(e.maxRetryCount, "config.maxRetryConfig", 0, 1 / 0), jT(e.maxRetryTimeout, "config.maxRetryTimeout", 0, 1 / 0), !0;
  }

  function _g(e) {
    if (!Array.isArray(e) || e.length < 1) return !1;

    try {
      e.forEach(function (e) {
        if (!e.urls) throw Error();
      });
    } catch (e) {
      return !1;
    }

    return !0;
  }

  function Eg(e) {
    return WT(e.turnServerURL, "turnServerURL"), WT(e.username, "username"), WT(e.password, "password"), e.udpport && jT(e.udpport, "udpport", 1, 99999, !0), e.forceturn && FT(e.forceturn, "forceturn"), e.security && FT(e.security, "security"), e.tcpport && jT(e.tcpport, "tcpport", 1, 99999, !0), !0;
  }

  function mg(e) {
    return void 0 !== e.level && BT(e.level, "level", [1, 2, 3]), void 0 !== e.delay && jT(e.delay, "delay", 0, 3e3, !0), !0;
  }

  function fg(e, t) {
    for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++) {
      n[s - 2] = arguments[s];
    }

    return 0 === e.getListeners(t).length ? tT.reject(new VT(xT.UNEXPECTED_ERROR, "can not emit promise")) : new tT(function (i, s) {
      e.emit.apply(e, [t].concat(n, [i, s]));
    });
  }

  function Tg(e, t) {
    if (0 === e.getListeners(t).length) return tT.resolve();

    for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++) {
      n[s - 2] = arguments[s];
    }

    return fg.apply(void 0, [e, t].concat(n));
  }

  function gg(e, t) {
    if (0 === e.getListeners(t).length) return null;

    for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++) {
      n[s - 2] = arguments[s];
    }

    return Sg.apply(void 0, [e, t].concat(n));
  }

  function Sg(e, t) {
    var i = null,
        n = null;

    for (var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++) {
      r[o - 2] = arguments[o];
    }

    if (e.emit.apply(e, [t].concat(r, [function (e) {
      i = e;
    }, function (e) {
      n = e;
    }])), null !== n) throw n;
    if (null === i) throw new VT(xT.UNEXPECTED_ERROR, "handler is not sync");
    return i;
  }

  !function (e) {
    e.CREATE_CLIENT = "createClient", e.CHECK_SYSTEM_REQUIREMENTS = "checkSystemRequirements", e.SET_AREA = "setArea", e.CHECK_VIDEO_TRACK_IS_ACTIVE = "checkVideoTrackIsActive", e.CHECK_AUDIO_TRACK_IS_ACTIVE = "checkAudioTrackIsActive", e.CREATE_MIC_AUDIO_TRACK = "createMicrophoneAudioTrack", e.CREATE_CUSTOM_AUDIO_TRACK = "createCustomAudioTrack", e.CREATE_BUFFER_AUDIO_TRACK = "createBufferSourceAudioTrack", e.CREATE_CAM_VIDEO_TRACK = "createCameraVideoTrack", e.CREATE_CUSTOM_VIDEO_TRACK = "createCustomVideoTrack", e.CREATE_MIC_AND_CAM_TRACKS = "createMicrophoneAndCameraTracks", e.CREATE_SCREEN_VIDEO_TRACK = "createScreenVideoTrack", e.SET_ENCRYPTION_CONFIG = "Client.setEncryptionConfig", e.START_PROXY_SERVER = "Client.startProxyServer", e.STOP_PROXY_SERVER = "Client.stopProxyServer", e.SET_PROXY_SERVER = "Client.setProxyServer", e.SET_TURN_SERVER = "Client.setTurnServer", e.SET_CLIENT_ROLE = "Client.setClientRole", e.SET_LOW_STREAM_PARAMETER = "Client.setLowStreamParameter", e.ENABLE_DUAL_STREAM = "Client.enableDualStream", e.DISABLE_DUAL_STREAM = "Client.disableDualStream", e.JOIN = "Client.join", e.LEAVE = "Client.leave", e.PUBLISH = "Client.publish", e.UNPUBLISH = "Client.unpublish", e.SUBSCRIBE = "Client.subscribe", e.MASS_SUBSCRIBE = "Client.massSubscribe", e.MASS_UNSUBSCRIBE = "Client.massUnsubscribe", e.UNSUBSCRIBE = "Client.unsubscribe", e.RENEW_TOKEN = "Client.renewToken", e.SET_REMOTE_VIDEO_STREAM_TYPE = "Client.setRemoteVideoStreamType", e.SET_STREAM_FALLBACK_OPTION = "Client.setStreamFallbackOption", e.ENABLE_AUDIO_VOLUME_INDICATOR = "Client.enableAudioVolumeIndicator", e.SEND_CUSTOM_REPORT_MESSAGE = "Client.sendCustomReportMessage", e.INSPECT_VIDEO_CONTENT = "Client.inspectVideoContent", e.STOP_INSPECT_VIDEO_CONTENT = "Client.stopInspectVideoContent", e.JOIN_FALLBACK_TO_PROXY = "Client._joinFallbackToProxy", e.DATACHANNEL_FAILBACK = "Client._datachannelFailback", e.ON_LIVE_STREAM_WARNING = "Client.onLiveStreamWarning", e.ON_LIVE_STREAM_ERROR = "Client.onLiveStreamingError", e.START_LIVE_STREAMING = "Client.startLiveStreaming", e.SET_LIVE_TRANSCODING = "Client.setLiveTranscoding", e.STOP_LIVE_STREAMING = "Client.stopLiveStreaming", e.ADD_INJECT_STREAM_URL = "Client.addInjectStreamUrl", e.REMOVE_INJECT_STREAM_URL = "Client.removeInjectStreamUrl", e.START_CHANNEL_MEDIA_RELAY = "Client.startChannelMediaRelay", e.UPDATE_CHANNEL_MEDIA_RELAY = "Client.updateChannelMediaRelay", e.STOP_CHANNEL_MEDIA_RELAY = "Client.stopChannelMediaRelay", e.REQUEST_CONFIG_DISTRIBUTE = "_config-distribute-request", e.SET_CONFIG_DISTRIBUTE = "_configDistribute", e.LOCAL_TRACK_SET_MUTED = "LocalTrack.setMute", e.LOCAL_AUDIO_TRACK_PLAY = "LocalAudioTrack.play", e.LOCAL_AUDIO_TRACK_PLAY_IN_ELEMENT = "LocalAudioTrack.playInElement", e.LOCAL_AUDIO_TRACK_STOP = "LocalAudioTrack.stop", e.LOCAL_AUDIO_TRACK_SET_VOLUME = "LocalAudioTrack.setVolume", e.MIC_AUDIO_TRACK_SET_DEVICE = "MicrophoneAudioTrack.setDevice", e.BUFFER_AUDIO_TRACK_START = "BufferSourceAudioTrack.startProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_STOP = "BufferSourceAudioTrack.stopProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_PAUSE = "BufferSourceAudioTrack.pauseProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_RESUME = "BufferSourceAudioTrack.resumeProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_SEEK = "BufferSourceAudioTrack.seekAudioBuffer", e.LOCAL_VIDEO_TRACK_PLAY = "LocalVideoTrack.play", e.LOCAL_VIDEO_TRACK_STOP = "LocalVideoTrack.stop", e.LOCAL_VIDEO_TRACK_GET_VIDEO_VISIBLE = "LocalVideoTrack.getVideoElementVisibleStatus", e.LOCAL_VIDEO_TRACK_BEAUTY = "LocalVideoTrack.setBeautyEffect", e.CAM_VIDEO_TRACK_SET_DEVICE = "CameraVideoTrack.setDevice", e.CAM_VIDEO_TRACK_SET_ENCODER_CONFIG = "CameraVideoTrack.setEncoderConfiguration", e.REMOTE_VIDEO_TRACK_PLAY = "RemoteVideoTrack.play", e.REMOTE_VIDEO_TRACK_STOP = "RemoteVideoTrack.stop", e.REMOTE_VIDEO_TRACK_GET_VIDEO_VISIBLE = "RemoteVideoTrack.getVideoElementVisibleStatus", e.REMOTE_AUDIO_TRACK_PLAY = "RemoteAudioTrack.play", e.REMOTE_AUDIO_TRACK_STOP = "RemoteAudioTrack.stop", e.REMOTE_AUDIO_SET_VOLUME = "RemoteAudioTrack.setVolume", e.REMOTE_AUDIO_SET_OUTPUT_DEVICE = "RemoteAudioTrack.setOutputDevice", e.GET_MEDIA_STREAM_TRACK = "Track.getMediaStreamTrack", e.STREAM_TYPE_CHANGE = "streamTypeChange", e.CONNECTION_STATE_CHANGE = "connectionStateChange", e.LOAD_CONFIG_FROM_LOCALSTORAGE = "loadConfigFromLocalStorage", e.IMAGE_MODERATION_UPLOAD = "imageModerationUpload";
  }(rg || (rg = {})), function (e) {
    e.TRACER = "tracer";
  }(og || (og = {})), function (e) {
    e[e.AUDIENCE_LEVEL_LOW_LATENCY = 1] = "AUDIENCE_LEVEL_LOW_LATENCY", e[e.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY = 2] = "AUDIENCE_LEVEL_ULTRA_LOW_LATENCY", e[e.AUDIENCE_LEVEL_SYNC_LATENCY = 3] = "AUDIENCE_LEVEL_SYNC_LATENCY";
  }(ag || (ag = {})), function (e) {
    e.LEAVE = "LEAVE", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.UID_BANNED = "UID_BANNED", e.IP_BANNED = "IP_BANNED", e.CHANNEL_BANNED = "CHANNEL_BANNED", e.FALLBACK = "FALLBACK", e.LICENSE_MISSING = "LICENSE_MISSING", e.LICENSE_EXPIRED = "LICENSE_EXPIRED", e.LICENSE_MINUTES_EXCEEDED = "LICENSE_MINUTES_EXCEEDED", e.LICENSE_PERIOD_INVALID = "LICENSE_PERIOD_INVALID", e.LICENSE_MULTIPLE_SDK_SERVICE = "LICENSE_MULTIPLE_SDK_SERVICE", e.LICENSE_ILLEGAL = "LICENSE_ILLEGAL", e.TOKEN_EXPIRE = "TOKEN_EXPIRE";
  }(cg || (cg = {})), function (e) {
    e.CONNECTION_STATE_CHANGE = "connection-state-change", e.MEDIA_RECONNECT_START = "media-reconnect-start", e.MEDIA_RECONNECT_END = "media-reconnect-end", e.IS_USING_CLOUD_PROXY = "is-using-cloud-proxy", e.USER_JOINED = "user-joined", e.USER_LEAVED = "user-left", e.USER_PUBLISHED = "user-published", e.USER_UNPUBLISHED = "user-unpublished", e.USER_INFO_UPDATED = "user-info-updated", e.CLIENT_BANNED = "client-banned", e.CHANNEL_MEDIA_RELAY_STATE = "channel-media-relay-state", e.CHANNEL_MEDIA_RELAY_EVENT = "channel-media-relay-event", e.VOLUME_INDICATOR = "volume-indicator", e.CRYPT_ERROR = "crypt-error", e.ON_TOKEN_PRIVILEGE_WILL_EXPIRE = "token-privilege-will-expire", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "token-privilege-did-expire", e.NETWORK_QUALITY = "network-quality", e.STREAM_TYPE_CHANGED = "stream-type-changed", e.STREAM_FALLBACK = "stream-fallback", e.RECEIVE_METADATA = "receive-metadata", e.STREAM_MESSAGE = "stream-message", e.LIVE_STREAMING_ERROR = "live-streaming-error", e.LIVE_STREAMING_WARNING = "live-streaming-warning", e.INJECT_STREAM_STATUS = "stream-inject-status", e.EXCEPTION = "exception", e.ERROR = "error", e.P2P_LOST = "p2p_lost", e.JOIN_FALLBACK_TO_PROXY = "join-fallback-to-proxy", e.CHANNEL_FALLBACK_TO_WEBSOCKET = "channel-fallback-to-websocket", e.MEDIA_CONNECTION_TYPE_CHANGE = "media-connection-type-change", e.PUBLISHED_USER_LIST = "published-user-list", e.CONTENT_INSPECT_CONNECTION_STATE_CHANGE = "content-inspect-connection-state-change", e.CONTENT_INSPECT_ERROR = "content-inspect-error", e.CONTENT_INSPECT_RESULT = "content-inspect-result", e.IMAGE_MODERATION_CONNECTION_STATE_CHANGE = "image-moderation-connection-state-change";
  }(dg || (dg = {})), function (e) {
    e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.MULTI_IP = "MULTI_IP", e.TIMEOUT = "TIMEOUT", e.OFFLINE = "OFFLINE", e.LEAVE = "LEAVE", e.P2P_FAILED = "P2P_FAILED", e.FALLBACK = "FALLBACK";
  }(lg || (lg = {})), function (e) {
    e.ONLINE = "ONLINE", e.OFFLINE = "OFFLINE";
  }(ug || (ug = {})), function (e) {
    e.NETWORK_STATE_CHANGE = "NETWORK_STATE_CHANGE", e.ONLINE = "ONLINE", e.OFFLINE = "OFFLINE";
  }(hg || (hg = {}));
  var Rg = new ( /*#__PURE__*/function (_ig) {
    _inherits(_class2, _ig);

    var _super2 = _createSuper(_class2);

    function _class2() {
      var _this29;

      _classCallCheck(this, _class2);

      _this29 = _super2.call(this), nh(_assertThisInitialized(_this29), "_moduleName", "network-indicator"), nh(_assertThisInitialized(_this29), "_networkState", ug.ONLINE), nh(_assertThisInitialized(_this29), "onlineWaiter", void 0), window.addEventListener("online", function () {
        _this29.networkState = ug.ONLINE;
      }), window.addEventListener("offline", function () {
        _this29.networkState = ug.OFFLINE;
      });
      return _this29;
    }

    _createClass(_class2, [{
      key: "networkState",
      get: function get() {
        return this._networkState;
      },
      set: function set(e) {
        var _this30 = this;

        this.emit(hg.NETWORK_STATE_CHANGE, e, this._networkState), e === ug.ONLINE ? this.emit(hg.ONLINE) : e === ug.OFFLINE && (this.onlineWaiter = new tT(function (e) {
          _this30.once(hg.ONLINE, function () {
            _this30.onlineWaiter = void 0, e(ug.ONLINE);
          });
        }), this.emit(hg.OFFLINE)), this._networkState = e;
      }
    }, {
      key: "isOnline",
      get: function get() {
        return this._networkState === ug.ONLINE;
      }
    }]);

    return _class2;
  }(ig))();

  function Cg(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Ig(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Cg(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Cg(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function vg(e, t) {
    var i = e.indexOf(t);
    -1 !== i && e.splice(i, 1);
  }

  function yg(e) {
    var t = [];
    return e.forEach(function (e) {
      -1 === t.indexOf(e) && t.push(e);
    }), t;
  }

  function Ag(e) {
    void 0 !== tT ? tT.resolve().then(e) : setTimeout(e, 0);
  }

  function bg(e) {
    return JSON.parse(JSON.stringify(e));
  }

  function wg(e) {
    try {
      return bg(e);
    } catch (t) {
      return e;
    }
  }

  var Og = {};

  function Ng(e, t) {
    Og[t] || (Og[t] = !0, e());
  }

  function Dg(e) {
    var t = window.atob(e),
        i = new Uint8Array(new ArrayBuffer(t.length));

    for (var _e20 = 0; _e20 < t.length; _e20 += 1) {
      i[_e20] = t.charCodeAt(_e20);
    }

    return i;
  }

  function Pg(e) {
    var t = "";

    for (var _i19 = 0; _i19 < e.length; _i19 += 1) {
      t += String.fromCharCode(e[_i19]);
    }

    return window.btoa(t);
  }

  function Lg(e) {
    return window.TextEncoder ? new TextEncoder().encode(e).length : e.length;
  }

  function kg(e) {
    var t = 0;
    return /DingTalk/i.test(navigator.userAgent) && e.realFormData && (e = e.realFormData), e.forEach(function (e) {
      t += "string" == typeof e ? Lg(e) : e.size;
    }), t + 138;
  }

  function Mg(e) {
    var t = new VT(xT.TIMEOUT, "timeout");
    return new tT(function (i, n) {
      window.setTimeout(function () {
        return n(t);
      }, e);
    });
  }

  function Ug(e) {
    return new tT(function (t) {
      window.setTimeout(t, e);
    });
  }

  function xg() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 7,
        t = arguments.length > 1 ? arguments[1] : void 0;
    var i = Math.random().toString(16).substr(2, e).toLowerCase();
    return i.length === e ? "".concat(t).concat(i) : "".concat(t).concat(i) + xg(e - i.length, "");
  }

  function Vg() {
    return xg(32, "").toUpperCase();
  }

  var Fg = function Fg() {};

  var Bg = new ( /*#__PURE__*/function () {
    function _class3() {
      _classCallCheck(this, _class3);

      nh(this, "fnMap", new Map());
    }

    _createClass(_class3, [{
      key: "throttleByKey",
      value: function throttleByKey(e, t, i, n) {
        var _this31 = this;

        for (var s = arguments.length, r = new Array(s > 4 ? s - 4 : 0), o = 4; o < s; o++) {
          r[o - 4] = arguments[o];
        }

        if (this.fnMap.has(t)) {
          var _s8 = this.fnMap.get(t);

          if (_s8.threshold !== i) {
            _s8.fn.apply(_s8, _toConsumableArray(_s8.args)), clearTimeout(_s8.timer);

            var _o5 = window.setTimeout(function () {
              var e = _this31.fnMap.get(t);

              e && e.fn.apply(e, _toConsumableArray(e.args)), _this31.fnMap.delete(t);
            }, i);

            this.fnMap.set(t, {
              fn: e,
              threshold: i,
              timer: _o5,
              args: r,
              skipFn: n
            });
          } else _s8.skipFn && _s8.skipFn.apply(_s8, _toConsumableArray(_s8.args)), this.fnMap.set(t, Ig(Ig({}, _s8), {}, {
            fn: e,
            args: r,
            skipFn: n
          }));
        } else {
          var _s9 = window.setTimeout(function () {
            var e = _this31.fnMap.get(t);

            e && e.fn.apply(e, _toConsumableArray(e.args)), _this31.fnMap.delete(t);
          }, i);

          this.fnMap.set(t, {
            fn: e,
            threshold: i,
            timer: _s9,
            args: r,
            skipFn: n
          });
        }
      }
    }]);

    return _class3;
  }())(),
      jg = Bg.throttleByKey.bind(Bg);

  function Gg(e) {
    return "object" == _typeof(e) && null !== e && !(e instanceof RegExp);
  }

  function Wg(e, t) {
    if (!Gg(e) || !Gg(t)) return t;
    if (Array.isArray(e) && !Array.isArray(t) || !Array.isArray(e) && Array.isArray(t)) return t;

    if (Array.isArray(t) && Array.isArray(e)) {
      var _i20 = _toConsumableArray(e);

      for (var _n15 = 0; _n15 < t.length; _n15++) {
        _i20[_n15] = Wg(e[_n15], t[_n15]);
      }

      return _i20;
    }

    {
      var _i21 = Ig({}, e);

      for (var _n16 in t) {
        Object.prototype.hasOwnProperty.call(t, _n16) && (Object.prototype.hasOwnProperty.call(e, _n16) ? _i21[_n16] = Wg(e[_n16], t[_n16]) : _i21[_n16] = t[_n16]);
      }

      return _i21;
    }
  }

  var Hg = 1,
      Kg = console;

  var Yg = /*#__PURE__*/function () {
    function Yg(e) {
      _classCallCheck(this, Yg);

      nh(this, "lockingPromise", tT.resolve()), nh(this, "locks", 0), nh(this, "name", ""), nh(this, "lockId", void 0), this.lockId = Hg++, e && (this.name = e), Kg.debug("[lock-".concat(this.name, "-").concat(this.lockId, "] is created."));
    }

    _createClass(Yg, [{
      key: "isLocked",
      get: function get() {
        return this.locks > 0;
      }
    }, {
      key: "lock",
      value: function lock(e) {
        var _this32 = this;

        var t;
        this.locks += 1, Kg.debug("[lock-".concat(this.name, "-").concat(this.lockId, "] is locked, current queue ").concat(this.locks, ". ").concat("string" == typeof e ? e : ""));
        var i = new tT(function (i) {
          t = function t() {
            _this32.locks -= 1, Kg.debug("[lock-".concat(_this32.name, "-").concat(_this32.lockId, "] is not locked, current queue ").concat(_this32.locks, ". ").concat("string" == typeof e ? e : "")), i();
          };
        }),
            n = this.lockingPromise.then(function () {
          return t;
        });
        return this.lockingPromise = this.lockingPromise.then(function () {
          return i;
        }), n;
      }
    }], [{
      key: "setLogger",
      value: function setLogger(e) {
        Kg = e;
      }
    }]);

    return Yg;
  }();

  function qg(e, t) {
    return function (i, n, s) {
      var r = s.value;
      if ("function" != typeof r) throw new Error("Cannot use mutex on object property.");
      return s.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var i,
            s,
            o,
            a,
            c,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = this[t];

                if (i) {
                  _context3.next = 3;
                  break;
                }

                throw new Error("mutex property key ".concat(t, " doesn't exist on ").concat(e));

              case 3:
                _context3.next = 5;
                return i.lock("From ".concat(e, ".").concat(n));

              case 5:
                s = _context3.sent;
                _context3.prev = 6;

                for (o = _args3.length, a = new Array(o), c = 0; c < o; c++) {
                  a[c] = _args3[c];
                }

                _context3.next = 10;
                return r.apply(this, a);

              case 10:
                return _context3.abrupt("return", _context3.sent);

              case 11:
                _context3.prev = 11;
                s();
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6,, 11, 14]]);
      })), s;
    };
  }

  var Jg = {
    timeout: 500,
    timeoutFactor: 1.5,
    maxRetryCount: 1 / 0,
    maxRetryTimeout: 1e4
  };

  function zg(e, t) {
    var i = Math.floor(t.timeout * Math.pow(t.timeoutFactor, e));
    return Math.min(t.maxRetryTimeout, i);
  }

  function Xg(e, t, i, n) {
    var s = Object.assign({}, Jg, n);
    var r = s.timeout;

    var o = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return function (e) {
                  return new tT(function (t) {
                    window.setTimeout(t, e);
                  });
                }(r);

              case 2:
                r *= s.timeoutFactor;
                r = Math.min(s.maxRetryTimeout, r);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function o() {
        return _ref5.apply(this, arguments);
      };
    }();

    var a = !1;
    var c = new tT( /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(n, r) {
        var _c3, _i22;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = t || function () {
                  return !1;
                }, i = i || function () {
                  return !0;
                };
                _c3 = 0;

              case 2:
                if (!(_c3 < s.maxRetryCount)) {
                  _context5.next = 28;
                  break;
                }

                if (!a) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", r(new VT(xT.OPERATION_ABORTED)));

              case 5:
                _context5.prev = 5;
                _context5.next = 8;
                return e();

              case 8:
                _i22 = _context5.sent;

                if (t(_i22, _c3)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", n(_i22));

              case 11:
                if (!(_c3 + 1 === s.maxRetryCount)) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("return", n(_i22));

              case 13:
                _context5.next = 15;
                return o();

              case 15:
                _context5.next = 25;
                break;

              case 17:
                _context5.prev = 17;
                _context5.t0 = _context5["catch"](5);

                if (i(_context5.t0, _c3)) {
                  _context5.next = 21;
                  break;
                }

                return _context5.abrupt("return", r(_context5.t0));

              case 21:
                if (!(_c3 + 1 === s.maxRetryCount)) {
                  _context5.next = 23;
                  break;
                }

                return _context5.abrupt("return", r(_context5.t0));

              case 23:
                _context5.next = 25;
                return o();

              case 25:
                _c3 += 1;
                _context5.next = 2;
                break;

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[5, 17]]);
      }));

      return function (_x3, _x4) {
        return _ref6.apply(this, arguments);
      };
    }());
    return c.cancel = function () {
      return a = !0;
    }, c;
  }

  var Qg = De,
      Zg = ze,
      $g = K,
      eS = Bi,
      tS = TypeError,
      iS = function iS(e) {
    return function (t, i, n, s) {
      Qg(i);
      var r = Zg(t),
          o = $g(r),
          a = eS(r),
          c = e ? a - 1 : 0,
          d = e ? -1 : 1;
      if (n < 2) for (;;) {
        if (c in o) {
          s = o[c], c += d;
          break;
        }

        if (c += d, e ? c < 0 : a <= c) throw tS("Reduce of empty array with no initial value");
      }

      for (; e ? c >= 0 : a > c; c += d) {
        c in o && (s = i(s, o[c], c, r));
      }

      return s;
    };
  },
      nS = {
    left: iS(!1),
    right: iS(!0)
  }.left;

  wi({
    target: "Array",
    proto: !0,
    forced: !C_ && Ee > 79 && Ee < 83 || !Rh("reduce")
  }, {
    reduce: function reduce(e) {
      var t = arguments.length;
      return nS(this, e, t, t > 1 ? arguments[1] : void 0);
    }
  });
  var sS = Ji("Array").reduce,
      rS = l,
      oS = sS,
      aS = Array.prototype,
      cS = i(function (e) {
    var t = e.reduce;
    return e === aS || rS(aS, e) && t === aS.reduce ? oS : t;
  });

  var dS = /*#__PURE__*/function () {
    function dS(e) {
      _classCallCheck(this, dS);

      nh(this, "input", []), nh(this, "size", void 0), this.size = e;
    }

    _createClass(dS, [{
      key: "add",
      value: function add(e) {
        this.input.push(e), this.input.length > this.size && this.input.splice(0, 1);
      }
    }, {
      key: "mean",
      value: function mean() {
        var e;
        return 0 === this.input.length ? 0 : cS(e = this.input).call(e, function (e, t) {
          return e + t;
        }) / this.input.length;
      }
    }]);

    return dS;
  }();

  var lS,
      uS = {
    exports: {}
  },
      hS = function hS(e, t) {
    return function () {
      for (var i = new Array(arguments.length), n = 0; n < i.length; n++) {
        i[n] = arguments[n];
      }

      return e.apply(t, i);
    };
  },
      pS = hS,
      _S = Object.prototype.toString,
      ES = (lS = Object.create(null), function (e) {
    var t = _S.call(e);

    return lS[t] || (lS[t] = t.slice(8, -1).toLowerCase());
  });

  function mS(e) {
    return e = e.toLowerCase(), function (t) {
      return ES(t) === e;
    };
  }

  function fS(e) {
    return Array.isArray(e);
  }

  function TS(e) {
    return void 0 === e;
  }

  var gS = mS("ArrayBuffer");

  function SS(e) {
    return null !== e && "object" == _typeof(e);
  }

  function RS(e) {
    if ("object" !== ES(e)) return !1;
    var t = Object.getPrototypeOf(e);
    return null === t || t === Object.prototype;
  }

  var CS = mS("Date"),
      IS = mS("File"),
      vS = mS("Blob"),
      yS = mS("FileList");

  function AS(e) {
    return "[object Function]" === _S.call(e);
  }

  var bS = mS("URLSearchParams");

  function wS(e, t) {
    if (null != e) if ("object" != _typeof(e) && (e = [e]), fS(e)) for (var i = 0, n = e.length; i < n; i++) {
      t.call(null, e[i], i, e);
    } else for (var s in e) {
      Object.prototype.hasOwnProperty.call(e, s) && t.call(null, e[s], s, e);
    }
  }

  var OS,
      NS = (OS = "undefined" != typeof Uint8Array && Object.getPrototypeOf(Uint8Array), function (e) {
    return OS && e instanceof OS;
  }),
      DS = {
    isArray: fS,
    isArrayBuffer: gS,
    isBuffer: function isBuffer(e) {
      return null !== e && !TS(e) && null !== e.constructor && !TS(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    },
    isFormData: function isFormData(e) {
      var t = "[object FormData]";
      return e && ("function" == typeof FormData && e instanceof FormData || _S.call(e) === t || AS(e.toString) && e.toString() === t);
    },
    isArrayBufferView: function isArrayBufferView(e) {
      return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && gS(e.buffer);
    },
    isString: function isString(e) {
      return "string" == typeof e;
    },
    isNumber: function isNumber(e) {
      return "number" == typeof e;
    },
    isObject: SS,
    isPlainObject: RS,
    isUndefined: TS,
    isDate: CS,
    isFile: IS,
    isBlob: vS,
    isFunction: AS,
    isStream: function isStream(e) {
      return SS(e) && AS(e.pipe);
    },
    isURLSearchParams: bS,
    isStandardBrowserEnv: function isStandardBrowserEnv() {
      return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
    },
    forEach: wS,
    merge: function e() {
      var t = {};

      function i(i, n) {
        RS(t[n]) && RS(i) ? t[n] = e(t[n], i) : RS(i) ? t[n] = e({}, i) : fS(i) ? t[n] = i.slice() : t[n] = i;
      }

      for (var n = 0, s = arguments.length; n < s; n++) {
        wS(arguments[n], i);
      }

      return t;
    },
    extend: function extend(e, t, i) {
      return wS(t, function (t, n) {
        e[n] = i && "function" == typeof t ? pS(t, i) : t;
      }), e;
    },
    trim: function trim(e) {
      return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
    },
    stripBOM: function stripBOM(e) {
      return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
    },
    inherits: function inherits(e, t, i, n) {
      e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, i && Object.assign(e.prototype, i);
    },
    toFlatObject: function toFlatObject(e, t, i) {
      var n,
          s,
          r,
          o = {};
      t = t || {};

      do {
        for (s = (n = Object.getOwnPropertyNames(e)).length; s-- > 0;) {
          o[r = n[s]] || (t[r] = e[r], o[r] = !0);
        }

        e = Object.getPrototypeOf(e);
      } while (e && (!i || i(e, t)) && e !== Object.prototype);

      return t;
    },
    kindOf: ES,
    kindOfTest: mS,
    endsWith: function endsWith(e, t, i) {
      e = String(e), (void 0 === i || i > e.length) && (i = e.length), i -= t.length;
      var n = e.indexOf(t, i);
      return -1 !== n && n === i;
    },
    toArray: function toArray(e) {
      if (!e) return null;
      var t = e.length;
      if (TS(t)) return null;

      for (var i = new Array(t); t-- > 0;) {
        i[t] = e[t];
      }

      return i;
    },
    isTypedArray: NS,
    isFileList: yS
  },
      PS = DS;

  function LS(e) {
    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }

  var kS = function kS(e, t, i) {
    if (!t) return e;
    var n;
    if (i) n = i(t);else if (PS.isURLSearchParams(t)) n = t.toString();else {
      var s = [];
      PS.forEach(t, function (e, t) {
        null != e && (PS.isArray(e) ? t += "[]" : e = [e], PS.forEach(e, function (e) {
          PS.isDate(e) ? e = e.toISOString() : PS.isObject(e) && (e = JSON.stringify(e)), s.push(LS(t) + "=" + LS(e));
        }));
      }), n = s.join("&");
    }

    if (n) {
      var r = e.indexOf("#");
      -1 !== r && (e = e.slice(0, r)), e += (-1 === e.indexOf("?") ? "?" : "&") + n;
    }

    return e;
  },
      MS = DS;

  function US() {
    this.handlers = [];
  }

  US.prototype.use = function (e, t, i) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: !!i && i.synchronous,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }, US.prototype.eject = function (e) {
    this.handlers[e] && (this.handlers[e] = null);
  }, US.prototype.forEach = function (e) {
    MS.forEach(this.handlers, function (t) {
      null !== t && e(t);
    });
  };
  var xS,
      VS,
      FS = US,
      BS = DS;

  function jS() {
    if (VS) return xS;
    VS = 1;
    var e = DS;

    function t(e, t, i, n, s) {
      Error.call(this), this.message = e, this.name = "AxiosError", t && (this.code = t), i && (this.config = i), n && (this.request = n), s && (this.response = s);
    }

    e.inherits(t, Error, {
      toJSON: function toJSON() {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var i = t.prototype,
        n = {};
    return ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED"].forEach(function (e) {
      n[e] = {
        value: e
      };
    }), Object.defineProperties(t, n), Object.defineProperty(i, "isAxiosError", {
      value: !0
    }), t.from = function (n, s, r, o, a, c) {
      var d = Object.create(i);
      return e.toFlatObject(n, d, function (e) {
        return e !== Error.prototype;
      }), t.call(d, n.message, s, r, o, a), d.name = n.name, c && Object.assign(d, c), d;
    }, xS = t;
  }

  var GS,
      WS,
      HS,
      KS,
      YS,
      qS,
      JS = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  };

  function zS() {
    if (WS) return GS;
    WS = 1;
    var e = DS;
    return GS = function GS(t, i) {
      i = i || new FormData();
      var n = [];

      function s(t) {
        return null === t ? "" : e.isDate(t) ? t.toISOString() : e.isArrayBuffer(t) || e.isTypedArray(t) ? "function" == typeof Blob ? new Blob([t]) : Buffer.from(t) : t;
      }

      return function t(r, o) {
        if (e.isPlainObject(r) || e.isArray(r)) {
          if (-1 !== n.indexOf(r)) throw Error("Circular reference detected in " + o);
          n.push(r), e.forEach(r, function (n, r) {
            if (!e.isUndefined(n)) {
              var a,
                  c = o ? o + "." + r : r;
              if (n && !o && "object" == _typeof(n)) if (e.endsWith(r, "{}")) n = JSON.stringify(n);else if (e.endsWith(r, "[]") && (a = e.toArray(n))) return void a.forEach(function (t) {
                !e.isUndefined(t) && i.append(c, s(t));
              });
              t(n, c);
            }
          }), n.pop();
        } else i.append(o, s(r));
      }(t), i;
    }, GS;
  }

  function XS() {
    if (KS) return HS;
    KS = 1;
    var e = jS();
    return HS = function HS(t, i, n) {
      var s = n.config.validateStatus;
      n.status && s && !s(n.status) ? i(new e("Request failed with status code " + n.status, [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
    };
  }

  function QS() {
    if (qS) return YS;
    qS = 1;
    var e = DS;
    return YS = e.isStandardBrowserEnv() ? {
      write: function write(t, i, n, s, r, o) {
        var a = [];
        a.push(t + "=" + encodeURIComponent(i)), e.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), e.isString(s) && a.push("path=" + s), e.isString(r) && a.push("domain=" + r), !0 === o && a.push("secure"), document.cookie = a.join("; ");
      },
      read: function read(e) {
        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return t ? decodeURIComponent(t[3]) : null;
      },
      remove: function remove(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    }, YS;
  }

  var ZS,
      $S,
      eR,
      tR,
      iR,
      nR,
      sR,
      rR,
      oR,
      aR,
      cR,
      dR,
      lR = function lR(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  },
      uR = function uR(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  },
      hR = function hR(e, t) {
    return e && !lR(t) ? uR(e, t) : t;
  };

  function pR() {
    if ($S) return ZS;
    $S = 1;
    var e = DS,
        t = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
    return ZS = function ZS(i) {
      var n,
          s,
          r,
          o = {};
      return i ? (e.forEach(i.split("\n"), function (i) {
        if (r = i.indexOf(":"), n = e.trim(i.substr(0, r)).toLowerCase(), s = e.trim(i.substr(r + 1)), n) {
          if (o[n] && t.indexOf(n) >= 0) return;
          o[n] = "set-cookie" === n ? (o[n] ? o[n] : []).concat([s]) : o[n] ? o[n] + ", " + s : s;
        }
      }), o) : o;
    }, ZS;
  }

  function _R() {
    if (tR) return eR;
    tR = 1;
    var e = DS;
    return eR = e.isStandardBrowserEnv() ? function () {
      var t,
          i = /(msie|trident)/i.test(navigator.userAgent),
          n = document.createElement("a");

      function s(e) {
        var t = e;
        return i && (n.setAttribute("href", t), t = n.href), n.setAttribute("href", t), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
        };
      }

      return t = s(window.location.href), function (i) {
        var n = e.isString(i) ? s(i) : i;
        return n.protocol === t.protocol && n.host === t.host;
      };
    }() : function () {
      return !0;
    };
  }

  function ER() {
    if (nR) return iR;
    nR = 1;
    var e = jS();

    function t(t) {
      e.call(this, null == t ? "canceled" : t, e.ERR_CANCELED), this.name = "CanceledError";
    }

    return DS.inherits(t, e, {
      __CANCEL__: !0
    }), iR = t;
  }

  function mR() {
    return rR || (rR = 1, sR = function sR(e) {
      var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
      return t && t[1] || "";
    }), sR;
  }

  function fR() {
    if (aR) return oR;
    aR = 1;

    var e = DS,
        t = XS(),
        i = QS(),
        n = kS,
        s = hR,
        r = pR(),
        o = _R(),
        a = JS,
        c = jS(),
        d = ER(),
        l = mR();

    return oR = function oR(u) {
      return new Promise(function (h, p) {
        var _,
            E = u.data,
            m = u.headers,
            f = u.responseType;

        function T() {
          u.cancelToken && u.cancelToken.unsubscribe(_), u.signal && u.signal.removeEventListener("abort", _);
        }

        e.isFormData(E) && e.isStandardBrowserEnv() && delete m["Content-Type"];
        var g = new XMLHttpRequest();

        if (u.auth) {
          var S = u.auth.username || "",
              R = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
          m.Authorization = "Basic " + btoa(S + ":" + R);
        }

        var C = s(u.baseURL, u.url);

        function I() {
          if (g) {
            var e = "getAllResponseHeaders" in g ? r(g.getAllResponseHeaders()) : null,
                i = {
              data: f && "text" !== f && "json" !== f ? g.response : g.responseText,
              status: g.status,
              statusText: g.statusText,
              headers: e,
              config: u,
              request: g
            };
            t(function (e) {
              h(e), T();
            }, function (e) {
              p(e), T();
            }, i), g = null;
          }
        }

        if (g.open(u.method.toUpperCase(), n(C, u.params, u.paramsSerializer), !0), g.timeout = u.timeout, "onloadend" in g ? g.onloadend = I : g.onreadystatechange = function () {
          g && 4 === g.readyState && (0 !== g.status || g.responseURL && 0 === g.responseURL.indexOf("file:")) && setTimeout(I);
        }, g.onabort = function () {
          g && (p(new c("Request aborted", c.ECONNABORTED, u, g)), g = null);
        }, g.onerror = function () {
          p(new c("Network Error", c.ERR_NETWORK, u, g, g)), g = null;
        }, g.ontimeout = function () {
          var e = u.timeout ? "timeout of " + u.timeout + "ms exceeded" : "timeout exceeded",
              t = u.transitional || a;
          u.timeoutErrorMessage && (e = u.timeoutErrorMessage), p(new c(e, t.clarifyTimeoutError ? c.ETIMEDOUT : c.ECONNABORTED, u, g)), g = null;
        }, e.isStandardBrowserEnv()) {
          var v = (u.withCredentials || o(C)) && u.xsrfCookieName ? i.read(u.xsrfCookieName) : void 0;
          v && (m[u.xsrfHeaderName] = v);
        }

        "setRequestHeader" in g && e.forEach(m, function (e, t) {
          void 0 === E && "content-type" === t.toLowerCase() ? delete m[t] : g.setRequestHeader(t, e);
        }), e.isUndefined(u.withCredentials) || (g.withCredentials = !!u.withCredentials), f && "json" !== f && (g.responseType = u.responseType), "function" == typeof u.onDownloadProgress && g.addEventListener("progress", u.onDownloadProgress), "function" == typeof u.onUploadProgress && g.upload && g.upload.addEventListener("progress", u.onUploadProgress), (u.cancelToken || u.signal) && (_ = function _(e) {
          g && (p(!e || e && e.type ? new d() : e), g.abort(), g = null);
        }, u.cancelToken && u.cancelToken.subscribe(_), u.signal && (u.signal.aborted ? _() : u.signal.addEventListener("abort", _))), E || (E = null);
        var y = l(C);
        y && -1 === ["http", "https", "file"].indexOf(y) ? p(new c("Unsupported protocol " + y + ":", c.ERR_BAD_REQUEST, u)) : g.send(E);
      });
    }, oR;
  }

  var TR = DS,
      gR = function gR(e, t) {
    BS.forEach(e, function (i, n) {
      n !== t && n.toUpperCase() === t.toUpperCase() && (e[t] = i, delete e[n]);
    });
  },
      SR = jS(),
      RR = JS,
      CR = zS(),
      IR = {
    "Content-Type": "application/x-www-form-urlencoded"
  };

  function vR(e, t) {
    !TR.isUndefined(e) && TR.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
  }

  var yR,
      AR = {
    transitional: RR,
    adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (yR = fR()), yR),
    transformRequest: [function (e, t) {
      if (gR(t, "Accept"), gR(t, "Content-Type"), TR.isFormData(e) || TR.isArrayBuffer(e) || TR.isBuffer(e) || TR.isStream(e) || TR.isFile(e) || TR.isBlob(e)) return e;
      if (TR.isArrayBufferView(e)) return e.buffer;
      if (TR.isURLSearchParams(e)) return vR(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
      var i,
          n = TR.isObject(e),
          s = t && t["Content-Type"];

      if ((i = TR.isFileList(e)) || n && "multipart/form-data" === s) {
        var r = this.env && this.env.FormData;
        return CR(i ? {
          "files[]": e
        } : e, r && new r());
      }

      return n || "application/json" === s ? (vR(t, "application/json"), function (e, t, i) {
        if (TR.isString(e)) try {
          return (t || JSON.parse)(e), TR.trim(e);
        } catch (e) {
          if ("SyntaxError" !== e.name) throw e;
        }
        return (i || JSON.stringify)(e);
      }(e)) : e;
    }],
    transformResponse: [function (e) {
      var t = this.transitional || AR.transitional,
          i = t && t.silentJSONParsing,
          n = t && t.forcedJSONParsing,
          s = !i && "json" === this.responseType;
      if (s || n && TR.isString(e) && e.length) try {
        return JSON.parse(e);
      } catch (e) {
        if (s) {
          if ("SyntaxError" === e.name) throw SR.from(e, SR.ERR_BAD_RESPONSE, this, null, this.response);
          throw e;
        }
      }
      return e;
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: dR ? cR : (dR = 1, cR = null)
    },
    validateStatus: function validateStatus(e) {
      return e >= 200 && e < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  TR.forEach(["delete", "get", "head"], function (e) {
    AR.headers[e] = {};
  }), TR.forEach(["post", "put", "patch"], function (e) {
    AR.headers[e] = TR.merge(IR);
  });
  var bR,
      wR,
      OR = AR,
      NR = DS,
      DR = OR;

  function PR() {
    return wR ? bR : (wR = 1, bR = function bR(e) {
      return !(!e || !e.__CANCEL__);
    });
  }

  var LR = DS,
      kR = function kR(e, t, i) {
    var n = this || DR;
    return NR.forEach(i, function (i) {
      e = i.call(n, e, t);
    }), e;
  },
      MR = PR(),
      UR = OR,
      xR = ER();

  function VR(e) {
    if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new xR();
  }

  var FR,
      BR,
      jR = DS,
      GR = function GR(e, t) {
    t = t || {};
    var i = {};

    function n(e, t) {
      return jR.isPlainObject(e) && jR.isPlainObject(t) ? jR.merge(e, t) : jR.isPlainObject(t) ? jR.merge({}, t) : jR.isArray(t) ? t.slice() : t;
    }

    function s(i) {
      return jR.isUndefined(t[i]) ? jR.isUndefined(e[i]) ? void 0 : n(void 0, e[i]) : n(e[i], t[i]);
    }

    function r(e) {
      if (!jR.isUndefined(t[e])) return n(void 0, t[e]);
    }

    function o(i) {
      return jR.isUndefined(t[i]) ? jR.isUndefined(e[i]) ? void 0 : n(void 0, e[i]) : n(void 0, t[i]);
    }

    function a(i) {
      return i in t ? n(e[i], t[i]) : i in e ? n(void 0, e[i]) : void 0;
    }

    var c = {
      url: r,
      method: r,
      data: r,
      baseURL: o,
      transformRequest: o,
      transformResponse: o,
      paramsSerializer: o,
      timeout: o,
      timeoutMessage: o,
      withCredentials: o,
      adapter: o,
      responseType: o,
      xsrfCookieName: o,
      xsrfHeaderName: o,
      onUploadProgress: o,
      onDownloadProgress: o,
      decompress: o,
      maxContentLength: o,
      maxBodyLength: o,
      beforeRedirect: o,
      transport: o,
      httpAgent: o,
      httpsAgent: o,
      cancelToken: o,
      socketPath: o,
      responseEncoding: o,
      validateStatus: a
    };
    return jR.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
      var t = c[e] || s,
          n = t(e);
      jR.isUndefined(n) && t !== a || (i[e] = n);
    }), i;
  };

  function WR() {
    return BR ? FR : (BR = 1, FR = {
      version: "0.27.2"
    });
  }

  var HR = WR().version,
      KR = jS(),
      YR = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, t) {
    YR[e] = function (i) {
      return _typeof(i) === e || "a" + (t < 1 ? "n " : " ") + e;
    };
  });
  var qR = {};

  YR.transitional = function (e, t, i) {
    function n(e, t) {
      return "[Axios v" + HR + "] Transitional option '" + e + "'" + t + (i ? ". " + i : "");
    }

    return function (i, s, r) {
      if (!1 === e) throw new KR(n(s, " has been removed" + (t ? " in " + t : "")), KR.ERR_DEPRECATED);
      return t && !qR[s] && (qR[s] = !0, console.warn(n(s, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(i, s, r);
    };
  };

  var JR,
      zR,
      XR,
      QR,
      ZR,
      $R,
      eC = {
    assertOptions: function assertOptions(e, t, i) {
      if ("object" != _typeof(e)) throw new KR("options must be an object", KR.ERR_BAD_OPTION_VALUE);

      for (var n = Object.keys(e), s = n.length; s-- > 0;) {
        var r = n[s],
            o = t[r];

        if (o) {
          var a = e[r],
              c = void 0 === a || o(a, r, e);
          if (!0 !== c) throw new KR("option " + r + " must be " + c, KR.ERR_BAD_OPTION_VALUE);
        } else if (!0 !== i) throw new KR("Unknown option " + r, KR.ERR_BAD_OPTION);
      }
    },
    validators: YR
  },
      tC = DS,
      iC = kS,
      nC = FS,
      sC = function sC(e) {
    return VR(e), e.headers = e.headers || {}, e.data = kR.call(e, e.data, e.headers, e.transformRequest), e.headers = LR.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), LR.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
      delete e.headers[t];
    }), (e.adapter || UR.adapter)(e).then(function (t) {
      return VR(e), t.data = kR.call(e, t.data, t.headers, e.transformResponse), t;
    }, function (t) {
      return MR(t) || (VR(e), t && t.response && (t.response.data = kR.call(e, t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
    });
  },
      rC = GR,
      oC = hR,
      aC = eC,
      cC = aC.validators;

  function dC(e) {
    this.defaults = e, this.interceptors = {
      request: new nC(),
      response: new nC()
    };
  }

  dC.prototype.request = function (e, t) {
    "string" == typeof e ? (t = t || {}).url = e : t = e || {}, (t = rC(this.defaults, t)).method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
    var i = t.transitional;
    void 0 !== i && aC.assertOptions(i, {
      silentJSONParsing: cC.transitional(cC.boolean),
      forcedJSONParsing: cC.transitional(cC.boolean),
      clarifyTimeoutError: cC.transitional(cC.boolean)
    }, !1);
    var n = [],
        s = !0;
    this.interceptors.request.forEach(function (e) {
      "function" == typeof e.runWhen && !1 === e.runWhen(t) || (s = s && e.synchronous, n.unshift(e.fulfilled, e.rejected));
    });
    var r,
        o = [];

    if (this.interceptors.response.forEach(function (e) {
      o.push(e.fulfilled, e.rejected);
    }), !s) {
      var a = [sC, void 0];

      for (Array.prototype.unshift.apply(a, n), a = a.concat(o), r = Promise.resolve(t); a.length;) {
        r = r.then(a.shift(), a.shift());
      }

      return r;
    }

    for (var c = t; n.length;) {
      var d = n.shift(),
          l = n.shift();

      try {
        c = d(c);
      } catch (e) {
        l(e);
        break;
      }
    }

    try {
      r = sC(c);
    } catch (e) {
      return Promise.reject(e);
    }

    for (; o.length;) {
      r = r.then(o.shift(), o.shift());
    }

    return r;
  }, dC.prototype.getUri = function (e) {
    e = rC(this.defaults, e);
    var t = oC(e.baseURL, e.url);
    return iC(t, e.params, e.paramsSerializer);
  }, tC.forEach(["delete", "get", "head", "options"], function (e) {
    dC.prototype[e] = function (t, i) {
      return this.request(rC(i || {}, {
        method: e,
        url: t,
        data: (i || {}).data
      }));
    };
  }), tC.forEach(["post", "put", "patch"], function (e) {
    function t(t) {
      return function (i, n, s) {
        return this.request(rC(s || {}, {
          method: e,
          headers: t ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: i,
          data: n
        }));
      };
    }

    dC.prototype[e] = t(), dC.prototype[e + "Form"] = t(!0);
  });
  var lC = DS,
      uC = hS,
      hC = dC,
      pC = GR;

  var _C = function e(t) {
    var i = new hC(t),
        n = uC(hC.prototype.request, i);
    return lC.extend(n, hC.prototype, i), lC.extend(n, i), n.create = function (i) {
      return e(pC(t, i));
    }, n;
  }(OR);

  _C.Axios = hC, _C.CanceledError = ER(), _C.CancelToken = function () {
    if (zR) return JR;
    zR = 1;
    var e = ER();

    function t(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");
      var i;
      this.promise = new Promise(function (e) {
        i = e;
      });
      var n = this;
      this.promise.then(function (e) {
        if (n._listeners) {
          var t,
              i = n._listeners.length;

          for (t = 0; t < i; t++) {
            n._listeners[t](e);
          }

          n._listeners = null;
        }
      }), this.promise.then = function (e) {
        var t,
            i = new Promise(function (e) {
          n.subscribe(e), t = e;
        }).then(e);
        return i.cancel = function () {
          n.unsubscribe(t);
        }, i;
      }, t(function (t) {
        n.reason || (n.reason = new e(t), i(n.reason));
      });
    }

    return t.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, t.prototype.subscribe = function (e) {
      this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
    }, t.prototype.unsubscribe = function (e) {
      if (this._listeners) {
        var t = this._listeners.indexOf(e);

        -1 !== t && this._listeners.splice(t, 1);
      }
    }, t.source = function () {
      var e;
      return {
        token: new t(function (t) {
          e = t;
        }),
        cancel: e
      };
    }, JR = t;
  }(), _C.isCancel = PR(), _C.VERSION = WR().version, _C.toFormData = zS(), _C.AxiosError = jS(), _C.Cancel = _C.CanceledError, _C.all = function (e) {
    return Promise.all(e);
  }, _C.spread = QR ? XR : (QR = 1, XR = function XR(e) {
    return function (t) {
      return e.apply(null, t);
    };
  }), _C.isAxiosError = function () {
    if ($R) return ZR;
    $R = 1;
    var e = DS;
    return ZR = function ZR(t) {
      return e.isObject(t) && !0 === t.isAxiosError;
    };
  }(), uS.exports = _C, uS.exports.default = _C;
  var EC = i(uS.exports);

  function mC(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function fC(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? mC(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : mC(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var TC,
      gC = 0,
      SC = 0;

  function RC(e, t, i, n) {
    return new tT(function (s, r) {
      t.responseType = t.responseType || "json", t.data && !i ? (t.data = JSON.stringify(t.data), gC += Lg(t.data)) : i && (t.data.size ? gC += t.data.size : t.data instanceof FormData ? gC += kg(t.data) : gC += Lg(JSON.stringify(t.data))), t.headers = t.headers || {}, t.headers["Content-Type"] = t.headers["Content-Type"] || "application/json", t.method = "POST", t.url = e, EC.request(t).then(function (e) {
        "string" == typeof e.data ? SC += Lg(e.data) : e.data instanceof ArrayBuffer || e.data instanceof Uint8Array ? SC += e.data.byteLength : SC += Lg(JSON.stringify(e.data)), n && s({
          data: e.data,
          headers: e.headers
        }), s(e.data);
      }).catch(function (e) {
        EC.isCancel(e) ? r(new VT(xT.OPERATION_ABORTED, "cancel token canceled")) : "ECONNABORTED" === e.code ? r(new VT(xT.NETWORK_TIMEOUT, e.message)) : e.response ? r(new VT(xT.NETWORK_RESPONSE_ERROR, e.response.status)) : r(new VT(xT.NETWORK_ERROR, e.message));
      });
    });
  }

  function CC(_x5, _x6) {
    return _CC.apply(this, arguments);
  }

  function _CC() {
    _CC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee467(e, t) {
      var i;
      return _regeneratorRuntime.wrap(function _callee467$(_context467) {
        while (1) {
          switch (_context467.prev = _context467.next) {
            case 0:
              i = new Blob([t.data], {
                type: "buffer"
              });
              _context467.next = 3;
              return RC(e, fC(fC({}, t), {}, {
                data: i,
                headers: {
                  "Content-Type": "application/octet-stream"
                }
              }), !0);

            case 3:
              return _context467.abrupt("return", _context467.sent);

            case 4:
            case "end":
              return _context467.stop();
          }
        }
      }, _callee467);
    }));
    return _CC.apply(this, arguments);
  }

  var IC = function IC() {
    return "HTTPS" === (TC || TC || (TC = (window.location.protocol.split(":")[0] || "").toUpperCase(), TC));
  },
      vC = function vC() {
    return void 0 !== window.isSecureContext;
  };

  var yC = function (e) {
    if (e.match(/[0-9]+\.[0-9]+\.[0-9]+$/)) return e;
    var t = e.match(/([0-9]+\.[0-9]+\.[0-9]+)\-alpha\.([0-9]+)/);

    if (t && t[1] && t[2]) {
      var _e21 = t[1],
          _i23 = t[2];
      return "".concat(_e21, ".").concat(_i23);
    }

    var i = e.match(/([0-9]+\.[0-9]+\.[0-9]+)\-special\.([0-9]+)/);

    if (i && i[1] && i[2]) {
      var _e22 = i[1],
          _t25 = i[2];
      return "".concat(_e22, ".").concat(100 * (Number(_t25) + 1));
    }

    return "4.0.0.999";
  }("4.20.0"),
      AC = function () {
    try {
      return !0 === JSON.parse("true");
    } catch (e) {
      return !0;
    }
  }();

  var bC;
  !function (e) {
    e.Default = "default", e.Auto = "auto", e.Relay = "relay", e.SdRtn = "sd-rtn";
  }(bC || (bC = {}));
  var wC = "v4.20.0-0-g334e514b-dirty(12/8/2023, 3:48:29 PM)",
      OC = {
    PROCESS_ID: "",
    ENCRYPT_AES: !0,
    AREAS: ["CHINA", "GLOBAL"],
    WEBCS_DOMAIN: ["webrtc2-ap-web-1.agora.io", "webrtc2-2.ap.sd-rtn.com"],
    WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-ap-web-3.agora.io", "webrtc2-4.ap.sd-rtn.com"],
    PROXY_CS: ["ap-proxy-1.agora.io", "ap-proxy-2.agora.io"],
    CDS_AP: ["cds-ap-web-1.agora.io", "cds-web-2.ap.sd-rtn.com", "cds-ap-web-3.agora.io", "cds-web-4.ap.sd-rtn.com"],
    ACCOUNT_REGISTER: ["sua-ap-web-1.agora.io", "sua-web-2.ap.sd-rtn.com", "sua-ap-web-3.agora.io", "sua-web-4.ap.sd-rtn.com"],
    UAP_AP: ["uap-ap-web-1.agora.io", "uap-web-2.ap.sd-rtn.com", "uap-ap-web-3.agora.io", "uap-web-4.ap.sd-rtn.com"],
    LOG_UPLOAD_SERVER: "logservice.agora.io",
    EVENT_REPORT_DOMAIN: "statscollector-1.agora.io",
    EVENT_REPORT_BACKUP_DOMAIN: "web-2.statscollector.sd-rtn.com",
    ENABLE_EVENT_REPORT: !0,
    GATEWAY_ADDRESS: [],
    GATEWAY_WSS_ADDRESS: "",
    LIVE_STREAMING_ADDRESS: "",
    HTTP_CONNECT_TIMEOUT: 5e3,
    SIGNAL_REQUEST_TIMEOUT: 1e4,
    REPORT_STATS: !0,
    UPLOAD_LOG: !1,
    NOT_REPORT_EVENT: [],
    SUBSCRIBE_TWCC: !1,
    PUBLISH_TWCC: !1,
    PING_PONG_TIME_OUT: 10,
    WEBSOCKET_TIMEOUT_MIN: 1e4,
    EVENT_REPORT_SEND_INTERVAL: 3e3,
    CONFIG_DISTRIBUTE_INTERVAL: 3e5,
    ENABLE_CONFIG_DISTRIBUTE: !0,
    CANDIDATE_TIMEOUT: 5e3,
    SHOW_REPORT_INVOKER_LOG: !1,
    JOIN_EXTEND: "",
    PUB_EXTEND: "",
    SUB_EXTEND: "",
    FORCE_TURN: !1,
    TURN_ENABLE_TCP: !0,
    TURN_ENABLE_UDP: !0,
    MAX_UPLOAD_CACHE: 50,
    UPLOAD_CACHE_INTERVAL: 2e3,
    AJAX_REQUEST_CONCURRENT: 3,
    REPORT_APP_SCENARIO: void 0,
    GATEWAY_DOMAINS: ["edge.agora.io", "edge.sd-rtn.com"],
    CONNECT_GATEWAY_WITHOUT_DOMAIN: !1,
    WORKER_DOMAIN: "edge.agora.io",
    TURN_DOMAIN: "edge.agora.io",
    EVENT_REPORT_RETRY: !0,
    CHROME_FORCE_PLAN_B: !1,
    AUDIO_SOURCE_VOLUME_UPDATE_INTERVAL: 400,
    AUDIO_SOURCE_AVG_VOLUME_DURATION: 3e3,
    AUDIO_VOLUME_INDICATION_INTERVAL: 2e3,
    VOLUME_VOICE_WEIGHT: 10,
    GET_VOLUME_OF_MUTED_AUDIO_TRACK: !1,
    STATS_UPDATE_INTERVAL: 250,
    NORMAL_EVENT_QUEUE_CAPACITY: 100,
    CUSTOM_REPORT: !0,
    CUSTOM_REPORT_LIMIT: 20,
    PROXY_SERVER_TYPE2: "webnginx-proxy.agora.io",
    PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.sd-rtn.com", "webrtc-cloud-proxy.agora.io"],
    CUSTOM_PUB_ANSWER_MODIFIER: null,
    CUSTOM_SUB_ANSWER_MODIFIER: null,
    CUSTOM_PUB_OFFER_MODIFIER: null,
    CUSTOM_SUB_OFFER_MODIFIER: null,
    DSCP_TYPE: "high",
    REMOVE_NEW_CODECS: !0,
    FRAGEMENT_LENGTH: 3,
    WEBSOCKET_COMPRESS: !1,
    SIMULCAST: !1,
    PRELOAD_MEDIA_COUNT: 0,
    USE_PUB_RTX: !1,
    USE_SUB_RTX: !1,
    CHECK_VIDEO_VISIBLE_INTERVAL: 3e4,
    CHECK_LOCAL_STATS_INTERVAL: 100,
    PROFILE_SWITCH_INTERVAL: 2e3,
    UNSUPPORTED_VIDEO_CODEC: [],
    ENUMERATE_DEVICES_INTERVAL: !1,
    ENUMERATE_DEVICES_INTERVAL_TIME: 1e4,
    USE_NEW_TOKEN: !1,
    CLOSE_AFB_FOR_LOCAL_AP: !0,
    JOIN_MAX_CONCURRENCY: 6,
    JOIN_WITH_FALLBACK_SIGNAL_PROXY: !0,
    JOIN_WITH_FALLBACK_MEDIA_PROXY: !0,
    JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE: !1,
    JOIN_GATEWAY_TRY_443PORT_DURATION: 2e3,
    JOIN_GATEWAY_USE_443PORT_ONLY: !1,
    JOIN_GATEWAY_USE_DUAL_DOMAIN: !0,
    JOIN_GATEWAY_FALLBACK_PORT: 443,
    USE_TURN_SERVER_OF_GATEWAY: !1,
    H264_PROFILE_LEVEL_ID: "",
    USE_NEW_LOG: !1,
    LOG_VERSION: 3,
    MEDIA_DEVICE_CONSTRAINTS: null,
    ENCRYPT_PROXY_USERNAME_AND_PSW: !0,
    SDP_LOGGING: !1,
    CSP_DETECTED_HOSTNAME_LIST: ["agora.io", "sd-rtn.com"],
    REMOTE_AUDIO_TRACK_USES_WEB_AUDIO: !1,
    LOCAL_AUDIO_TRACK_USES_WEB_AUDIO: !0,
    BITRATE_ADAPTER_TYPE: "STANDARD_BITRATE",
    AI_DENOISER_PARAMETERS: {},
    ADJUST_3A_FROM_PLUGINS: !0,
    RAISE_H264_BASELINE_PRIORITY: !0,
    FILTER_SEND_H264_BASELINE: !1,
    ENABLE_PUBLISHED_USER_LIST: !0,
    MAX_SUBSCRIPTION: 50,
    X_GOOGLE_START_BITRATE: void 0,
    NEW_REPORT_SERVER: !1,
    NEW_REPORT_SERVER_DOMAINS: ["data-reporting.agora.io", "data-reporting.agora.io"],
    VIDEO_INSPECT_WORKER_MESSAGE_LENGTH_LIMIT: 3e5,
    VIDEO_INSPECT_INTERVAL_MINIMUM: 1e3,
    VIDEO_INSPECT_QUALITY_RATIO: .9,
    VIDEO_INSPECT_WORKER_MANAGER_HOST: "edge.agora.io",
    VIDEO_INSPECT_WORKER_MANAGER_PORT: "",
    VIDEO_INSPECT_WORKER_PORT: "",
    SHOW_VIDEO_INSPECT_WORKER_MESSAGE: !1,
    STATS_COLLECTOR_PORT: 443,
    FORCE_TURN_TCP: !1,
    SUBSCRIBE_AUDIO_FILTER_TOPN: void 0,
    ENABLE_PUBLISH_AUDIO_FILTER: void 0,
    DISABLE_FEC: void 0,
    WEBAUDIO_INIT_OPTIONS: void 0,
    FILTER_VIDEO_FEC: !0,
    FILTER_AUDIO_FEC: !1,
    CHROME_DUAL_STREAM_USE_ENCODING: !0,
    DISABLE_DUAL_STREAM_USE_ENCODING: !1,
    EXTENSION_USAGE_UPLOAD_INTERVAL: 1e4,
    ICE_RESTART: !0,
    ICE_RESTART_INTERVAL: 1e4,
    NEW_ICE_RESTART: !1,
    ENABLE_USER_LICENSE_CHECK: !0,
    SIGNAL_CHANNEL: 0,
    TRANSMITTER_INITIAL_RTT: 30,
    TRANSMITTER_INITIAL_RTO: 30,
    TRANSMITTER_MAX_BATCH_ACK_COUNT: 2,
    TRANSMITTER_MAX_RTO: 500,
    DATACHANNEL_COMPRESS: !1,
    FINGERPRINT: null,
    DC_JOIN_WITH_FAILBACK: 5e3,
    ENABLE_VIDEO_FRAME_CALLBACK: !0,
    VIDEO_FREEZE_DURATION: 500,
    SPATIALIZER_PARAMETERS: {},
    UPLOAD_LOG_INTERVAL: 3e3,
    UPLOAD_LOG_REQUEST_RETRY_INTERVAL: 2e3,
    UPLOAD_LOG_REQUEST_MAX_RETRY_INTERVAL: 2e4,
    UPLOAD_LOG_TRY_INTERVAL_WHILE_OFF: 5e3,
    UPLOAD_LOG_RETRY_INTERVAL_V1: 1e4,
    UPLOAD_LOG_TWICE_RETRY_INTERVAL_V1: 200,
    UPLOAD_LOG_LENGTH_EACH_TIME: 10,
    APP_TYPE: 0,
    DISABLE_WEBAUDIO: !1,
    CHANNEL_MEDIA_RELAY_SERVERS: void 0,
    KEEP_LAST_FRAME: !0,
    FORWARD_P2P_CREATION: !0,
    SYNC_GROUP: !0,
    BLOCK_LOCAL_CLIENT: !1,
    AP_AREA: !0,
    SVC: [],
    ENABLE_ENCODED_TRANSFORM: !1,
    IMAGE_MODERATION_WORKER_HOST: "edge.agora.io",
    IMAGE_MODERATION_WORKER_MESSAGE_LENGTH_LIMIT: 3e5,
    IMAGE_MODERATION_INTERVAL_MINIMUM: 1e3,
    SHOW_IMAGE_MODERATION_WORKER_MESSAGE: !1,
    IMAGE_MODERATION_QUALITY_RATIO: .9,
    IMAGE_MODERATION_UPLOAD_REPORT_INTERVAL: 5e3,
    SHOW_GLOBAL_CLIENT_LIST: !1,
    ENABLE_DATASTREAM_2: !1,
    DATASTREAM_MAX_RETRANSMITS: 10,
    ENABLE_USER_AUTO_REBALANCE_CHECK: !0,
    ENABLE_INSTANT_VIDEO: !1,
    ENABLE_NTP_REPORT: !1,
    USE_XR: !1,
    TCP_CANDIDATE_ONLY: !1,
    EXTERNAL_SIGNAL_REQUEST_TIMEOUT: 3e3,
    SHOW_P2P_LOG: !1,
    MAX_P2P_TIMEOUT: 3e4,
    P2P_TOKEN_INTERVAL: 1e3,
    SHOW_DATASTREAM2_LOG: !1,
    RESTRICTION_SET_PLAYBACK_DEVICE: !0,
    ACCOUNT_REGISTER_RETRY_TIMEOUT: 1,
    ACCOUNT_REGISTER_RETRY_RATIO: 2,
    ACCOUNT_REGISTER_RETRY_TIMEOUT_MAX: 6e4,
    ACCOUNT_REGISTER_RETRY_COUNT_MAX: 1e5,
    AUDIO_CONTEXT: null,
    WEBCS_BACKUP_CONNECT_TIMEOUT: 6e3,
    PLAYER_STATE_DEFER: 2e3,
    SIGNAL_REQUEST_WATCH_INTERVAL: 1e3,
    FILEPATH_LENMAX: 255,
    DUALSTREAM_OPERATION_CHECK: !0,
    MEDIA_ELEMENT_EXISTS_DEPTH: 3,
    SHIM_CANDIDATE: !1,
    LEAVE_MSG_TIMEOUT: 2e3,
    STATS_FILTER: {
      transportId: !0,
      googTrackId: !0
    },
    FILTER_VIDEO_CODEC: [],
    PLUGIN_INFO: []
  };

  function NC(e, t, i) {
    var n, s;
    bn(n = Object.keys(OC)).call(n, e) && (!i && bn(s = Object.keys(PC)).call(s, e) || (OC[e] = t));
  }

  function DC(e) {
    return OC[e];
  }

  var PC = {};

  function LC(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function kC(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? LC(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : LC(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var MC;
  !function (e) {
    e.SET_SESSION_ID = "SET_SESSION_ID", e.SET_P2P_ID = "SET_P2P_id", e.SET_DC_ID = "SET_DC_id", e.SET_UID = "SET_UID", e.SET_INT_UID = "SET_INT_UID", e.SET_PUB_ID = "SET_PUB_ID", e.SET_CLOUD_PROXY_SERVER_MODE = "SET_CLOUD_PROXY_SERVER_MODE", e.KEY_METRIC_CLIENT_CREATED = "KEY_METRIC_CLIENT_CREATED", e.KEY_METRIC_JOIN_START = "KEY_METRIC_JOIN_START", e.AVOID_JOIN_START = "AVOID_JOIN_START", e.KEY_METRIC_JOIN_END = "KEY_METRIC_JOIN_END", e.KEY_METRIC_REQUEST_AP_START = "KEY_METRIC_REQUEST_AP_START", e.KEY_METRIC_REQUEST_AP_END = "KEY_METRIC_REQUEST_AP_END", e.KEY_METRIC_JOIN_GATEWAY_START = "KEY_METRIC_JOIN_GATEWAY_START", e.KEY_METRIC_JOIN_GATEWAY_END = "KEY_METRIC_JOIN_GATEWAY_END", e.KEY_METRIC_PEER_CONNECTION_START = "KEY_METRIC_PEER_CONNECTION_START", e.KEY_METRIC_PEER_CONNECTION_END = "KEY_METRIC_PEER_CONNECTION_END", e.KEY_METRIC_DESCRIPTION_START = "KEY_METRIC_DESCRIPTION_START", e.KEY_METRIC_ICE_CONNECTION_END = "KEY_METRIC_ICE_CONNECTION_END", e.KEY_METRIC_SIGNAL_CHANNEL_OPEN = "KEY_METRIC_SIGNAL_CHANNEL_OPEN", e.KEY_METRIC_PUBLISH = "KEY_METRIC_PUBLISH", e.KEY_METRIC_SUBSCRIBE = "KEY_METRIC_SUBSCRIBE", e.RECORD_JOIN_CHANNEL_SERVICE = "RECORD_JOIN_CHANNEL_SERVICE", e.RESET_JOIN_CHANNEL_SERVICE_RECORDS = "RESET_JOIN_CHANNEL_SERVICE_RECORDS", e.RESET_KEY_METRICS = "RESET_KEY_METRICS", e.SET_USE_DATACHANNEL = "SET_USE_DATACHANNEL", e.SET_USE_P2P = "SET_USE_P2P", e.SET_TRANSPORT_TYPE = "SET_TRANSPORT_TYPE";
  }(MC || (MC = {}));

  var UC = /*#__PURE__*/function () {
    function UC(e, t, i, n) {
      _classCallCheck(this, UC);

      nh(this, "state", void 0), this.state = {
        codec: e,
        audioCodec: t,
        mode: i,
        clientId: n,
        sessionId: null,
        p2pId: 0,
        dcId: 0,
        pubId: 0,
        subId: 0,
        avoidJoinStart: 0,
        keyMetrics: {
          publish: [],
          subscribe: []
        },
        joinChannelServiceRecords: [],
        cloudProxyServerMode: "disabled",
        useDataChannel: !1,
        useP2P: !1,
        p2pTransport: bC.Default
      };
    }

    _createClass(UC, [{
      key: "dispatch",
      value: function dispatch(e) {
        this.state = function (e, t) {
          switch (t.type) {
            case MC.SET_SESSION_ID:
              return kC(kC({}, e), {}, {
                sessionId: t.sessionId
              });

            case MC.SET_P2P_ID:
              return kC(kC({}, e), {}, {
                p2pId: t.p2pId
              });

            case MC.SET_UID:
              return kC(kC({}, e), {}, {
                uid: t.uid
              });

            case MC.SET_INT_UID:
              return kC(kC({}, e), {}, {
                intUid: t.intUid
              });

            case MC.SET_PUB_ID:
              return kC(kC({}, e), {}, {
                pubId: t.pubId
              });

            case MC.KEY_METRIC_CLIENT_CREATED:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  clientCreated: t.metric
                })
              });

            case MC.KEY_METRIC_JOIN_START:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  joinStart: t.metric
                })
              });

            case MC.AVOID_JOIN_START:
              return kC(kC({}, e), {}, {
                avoidJoinStart: t.avoidJoinStart
              });

            case MC.KEY_METRIC_JOIN_END:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  joinEnd: t.metric
                })
              });

            case MC.KEY_METRIC_REQUEST_AP_START:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  requestAPStart: t.metric
                })
              });

            case MC.KEY_METRIC_REQUEST_AP_END:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  requestAPEnd: t.metric
                })
              });

            case MC.KEY_METRIC_JOIN_GATEWAY_START:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  joinGatewayStart: t.metric
                })
              });

            case MC.KEY_METRIC_JOIN_GATEWAY_END:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  joinGatewayEnd: t.metric
                })
              });

            case MC.KEY_METRIC_PEER_CONNECTION_START:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  peerConnectionStart: t.metric
                })
              });

            case MC.KEY_METRIC_PEER_CONNECTION_END:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  peerConnectionEnd: t.metric
                })
              });

            case MC.KEY_METRIC_DESCRIPTION_START:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  descriptionStart: t.metric
                })
              });

            case MC.KEY_METRIC_SIGNAL_CHANNEL_OPEN:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  signalChannelOpen: t.metric
                })
              });

            case MC.KEY_METRIC_ICE_CONNECTION_END:
              return kC(kC({}, e), {}, {
                keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                  iceConnectionEnd: t.metric
                })
              });

            case MC.KEY_METRIC_PUBLISH:
              {
                var _i24 = e.keyMetrics.publish,
                    _n17 = _i24.findIndex(function (e) {
                  return e.trackId === t.metric.trackId;
                });

                return -1 !== _n17 ? (_i24[_n17] = kC(kC({}, _i24[_n17]), t.metric), kC(kC({}, e), {}, {
                  keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                    publish: _toConsumableArray(_i24)
                  })
                })) : kC(kC({}, e), {}, {
                  keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                    publish: [].concat(_toConsumableArray(e.keyMetrics.publish), [t.metric])
                  })
                });
              }

            case MC.KEY_METRIC_SUBSCRIBE:
              {
                var _i25 = e.keyMetrics.subscribe,
                    _n18 = _i25.findIndex(function (e) {
                  return e.userId === t.metric.userId && e.type === t.metric.type;
                });

                return -1 !== _n18 ? (_i25[_n18] = kC(kC({}, _i25[_n18]), t.metric), kC(kC({}, e), {}, {
                  keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                    subscribe: _toConsumableArray(_i25)
                  })
                })) : kC(kC({}, e), {}, {
                  keyMetrics: kC(kC({}, e.keyMetrics), {}, {
                    subscribe: [].concat(_toConsumableArray(e.keyMetrics.subscribe), [t.metric])
                  })
                });
              }

            case MC.SET_CLOUD_PROXY_SERVER_MODE:
              return e.cloudProxyServerMode = t.mode, e;

            case MC.RECORD_JOIN_CHANNEL_SERVICE:
              return "number" != typeof t.index ? e.joinChannelServiceRecords = [].concat(_toConsumableArray(e.joinChannelServiceRecords), [t.record]) : (e.joinChannelServiceRecords[t.index] = kC(kC({}, e.joinChannelServiceRecords[t.index]), t.record), e.joinChannelServiceRecords = _toConsumableArray(e.joinChannelServiceRecords)), e;

            case MC.RESET_JOIN_CHANNEL_SERVICE_RECORDS:
              return e.joinChannelServiceRecords = [], e;

            case MC.RESET_KEY_METRICS:
              return e.keyMetrics = {
                publish: [],
                subscribe: []
              }, e;

            case MC.SET_USE_DATACHANNEL:
              return kC(kC({}, e), {}, {
                useDataChannel: t.val
              });

            case MC.SET_USE_P2P:
              return kC(kC({}, e), {}, {
                useP2P: t.val
              });

            case MC.SET_TRANSPORT_TYPE:
              return kC(kC({}, e), {}, {
                p2pTransport: t.val
              });

            default:
              return e;
          }
        }(this.state, e);
      }
    }, {
      key: "sessionId",
      get: function get() {
        return this.state.sessionId;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_SESSION_ID,
          sessionId: e
        });
      }
    }, {
      key: "codec",
      get: function get() {
        return this.state.codec;
      },
      set: function set(e) {
        this.state.codec = e;
      }
    }, {
      key: "mode",
      get: function get() {
        return this.state.mode;
      }
    }, {
      key: "audioCodec",
      get: function get() {
        return this.state.audioCodec;
      }
    }, {
      key: "clientId",
      get: function get() {
        return this.state.clientId;
      }
    }, {
      key: "p2pId",
      get: function get() {
        return this.state.p2pId;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_P2P_ID,
          p2pId: e
        });
      }
    }, {
      key: "dcId",
      get: function get() {
        return this.state.dcId;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_DC_ID,
          dcId: e
        });
      }
    }, {
      key: "uid",
      get: function get() {
        return this.state.uid;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_UID,
          uid: e
        });
      }
    }, {
      key: "intUid",
      get: function get() {
        return this.state.intUid;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_INT_UID,
          intUid: e
        });
      }
    }, {
      key: "pubId",
      get: function get() {
        return this.state.pubId;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_PUB_ID,
          pubId: e
        });
      }
    }, {
      key: "cloudProxyServerMode",
      get: function get() {
        return this.state.cloudProxyServerMode;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_CLOUD_PROXY_SERVER_MODE,
          mode: e
        });
      }
    }, {
      key: "useDataChannel",
      get: function get() {
        return this.state.useDataChannel;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_USE_DATACHANNEL,
          val: e
        });
      }
    }, {
      key: "useP2P",
      get: function get() {
        return this.state.useP2P;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_USE_P2P,
          val: e
        });
      }
    }, {
      key: "p2pTransport",
      get: function get() {
        return this.state.p2pTransport;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.SET_TRANSPORT_TYPE,
          val: e
        });
      }
    }, {
      key: "clientCreated",
      value: function clientCreated() {
        this.dispatch({
          type: MC.KEY_METRIC_CLIENT_CREATED,
          metric: Date.now()
        });
      }
    }, {
      key: "joinStart",
      value: function joinStart() {
        this.dispatch({
          type: MC.KEY_METRIC_JOIN_START,
          metric: Date.now()
        });
      }
    }, {
      key: "joinEnd",
      value: function joinEnd() {
        this.dispatch({
          type: MC.KEY_METRIC_JOIN_END,
          metric: Date.now()
        });
      }
    }, {
      key: "requestAPStart",
      value: function requestAPStart() {
        this.dispatch({
          type: MC.KEY_METRIC_REQUEST_AP_START,
          metric: Date.now()
        });
      }
    }, {
      key: "requestAPEnd",
      value: function requestAPEnd() {
        this.dispatch({
          type: MC.KEY_METRIC_REQUEST_AP_END,
          metric: Date.now()
        });
      }
    }, {
      key: "joinGatewayStart",
      value: function joinGatewayStart() {
        this.dispatch({
          type: MC.KEY_METRIC_JOIN_GATEWAY_START,
          metric: Date.now()
        });
      }
    }, {
      key: "joinGatewayEnd",
      value: function joinGatewayEnd() {
        this.dispatch({
          type: MC.KEY_METRIC_JOIN_GATEWAY_END,
          metric: Date.now()
        });
      }
    }, {
      key: "peerConnectionStart",
      value: function peerConnectionStart() {
        this.dispatch({
          type: MC.KEY_METRIC_PEER_CONNECTION_START,
          metric: Date.now()
        });
      }
    }, {
      key: "peerConnectionEnd",
      value: function peerConnectionEnd() {
        this.dispatch({
          type: MC.KEY_METRIC_PEER_CONNECTION_END,
          metric: Date.now()
        });
      }
    }, {
      key: "descriptionStart",
      value: function descriptionStart() {
        this.dispatch({
          type: MC.KEY_METRIC_DESCRIPTION_START,
          metric: Date.now()
        });
      }
    }, {
      key: "signalChannelOpen",
      value: function signalChannelOpen() {
        this.dispatch({
          type: MC.KEY_METRIC_SIGNAL_CHANNEL_OPEN,
          metric: Date.now()
        });
      }
    }, {
      key: "iceConnectionEnd",
      value: function iceConnectionEnd() {
        this.dispatch({
          type: MC.KEY_METRIC_ICE_CONNECTION_END,
          metric: Date.now()
        });
      }
    }, {
      key: "publish",
      value: function publish(e, t, i, n) {
        this.dispatch({
          type: MC.KEY_METRIC_PUBLISH,
          metric: kC(kC({
            trackId: e,
            type: t
          }, i && {
            publishStart: i
          }), n && {
            publishEnd: n
          })
        });
      }
    }, {
      key: "subscribe",
      value: function subscribe(e, t, i, n, s, r, o) {
        this.dispatch({
          type: MC.KEY_METRIC_SUBSCRIBE,
          metric: kC(kC(kC(kC(kC({
            userId: e,
            type: t
          }, i && {
            subscribeStart: i
          }), n && {
            subscribeEnd: n
          }), s && {
            firstFrame: s
          }), r && {
            streamAdded: r
          }), o && {
            firstDecoded: o
          })
        });
      }
    }, {
      key: "massSubscribe",
      value: function massSubscribe(e, t, i, n) {
        var _this33 = this;

        e.forEach(function (e) {
          _this33.dispatch({
            type: MC.KEY_METRIC_SUBSCRIBE,
            metric: kC(kC(kC({
              userId: e.userId,
              type: e.type
            }, t && {
              subscribeStart: t
            }), i && {
              subscribeEnd: i
            }), n && {
              firstFrame: n
            })
          });
        });
      }
    }, {
      key: "keyMetrics",
      get: function get() {
        return this.state.keyMetrics;
      }
    }, {
      key: "recordJoinChannelService",
      value: function recordJoinChannelService(e, t) {
        "gateway" === e.service && Array.isArray(e.urls) && (e.urls = e.urls.map(function (e) {
          return e.replace(/(\d+)-\d+-\d+-(\d+)/, "$1-*-*-$2");
        }));

        try {
          return "number" != typeof t ? (this.dispatch({
            type: MC.RECORD_JOIN_CHANNEL_SERVICE,
            record: kC(kC({}, e), {}, {
              sessionId: this.sessionId,
              cloudProxyMode: this.cloudProxyServerMode,
              uid: this.uid
            })
          }), this.state.joinChannelServiceRecords.length - 1) : (t < 0 || t >= this.state.joinChannelServiceRecords.length || this.dispatch({
            type: MC.RECORD_JOIN_CHANNEL_SERVICE,
            record: e,
            index: t
          }), t);
        } catch (e) {
          return 0;
        }
      }
    }, {
      key: "resetJoinChannelServiceRecords",
      value: function resetJoinChannelServiceRecords() {
        this.dispatch({
          type: MC.RESET_JOIN_CHANNEL_SERVICE_RECORDS
        });
      }
    }, {
      key: "resetKeyMetrics",
      value: function resetKeyMetrics() {
        this.dispatch({
          type: MC.RESET_KEY_METRICS
        });
      }
    }, {
      key: "joinChannelServiceRecords",
      get: function get() {
        try {
          return this.state.joinChannelServiceRecords;
        } catch (e) {
          return [];
        }
      }
    }, {
      key: "avoidJoinStart",
      get: function get() {
        return this.state.avoidJoinStart;
      },
      set: function set(e) {
        this.dispatch({
          type: MC.AVOID_JOIN_START,
          avoidJoinStart: e
        });
      }
    }]);

    return UC;
  }();

  var xC, VC;
  !function (e) {
    e.h264 = "h264", e.h265 = "h265", e.vp8 = "vp8", e.vp9 = "vp9", e.av1 = "av1";
  }(xC || (xC = {})), function (e) {
    e.opus = "opus", e.pcma = "pcma", e.pcmu = "pcmu", e.g722 = "g722";
  }(VC || (VC = {}));
  var FC = new ( /*#__PURE__*/function (_ig2) {
    _inherits(_class4, _ig2);

    var _super3 = _createSuper(_class4);

    function _class4() {
      _classCallCheck(this, _class4);

      return _super3.apply(this, arguments);
    }

    _createClass(_class4, [{
      key: "reportLogUploadError",
      value: function reportLogUploadError(e) {
        this.emit("REPORT_LOG_UPLOAD", e);
      }
    }]);

    return _class4;
  }(ig))();

  var BC = /*#__PURE__*/function () {
    function BC(e) {
      _classCallCheck(this, BC);

      nh(this, "logger", void 0), nh(this, "prefixLists", []), this.logger = e;
    }

    _createClass(BC, [{
      key: "debug",
      value: function debug() {
        var _this$logger;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        (_this$logger = this.logger).debug.apply(_this$logger, _toConsumableArray(this.prefixLists).concat(t));
      }
    }, {
      key: "info",
      value: function info() {
        var _this$logger2;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        (_this$logger2 = this.logger).info.apply(_this$logger2, _toConsumableArray(this.prefixLists).concat(t));
      }
    }, {
      key: "warning",
      value: function warning() {
        var _this$logger3;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        (_this$logger3 = this.logger).warning.apply(_this$logger3, _toConsumableArray(this.prefixLists).concat(t));
      }
    }, {
      key: "error",
      value: function error() {
        var _this$logger4;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        (_this$logger4 = this.logger).error.apply(_this$logger4, _toConsumableArray(this.prefixLists).concat(t));
      }
    }, {
      key: "prefix",
      value: function prefix(e) {
        return this.prefixLists.push(e), this;
      }
    }, {
      key: "popPrefix",
      value: function popPrefix() {
        return this.prefixLists.pop(), this;
      }
    }]);

    return BC;
  }();

  function jC() {
    var e = new Date();
    return e.toTimeString().split(" ")[0] + ":" + e.getMilliseconds();
  }

  function GC() {
    var e = new Date(),
        t = /((\d+:){2}\d+)/.exec(new Date().toUTCString());
    return t ? (null == t ? void 0 : t[0]) + ":" + e.getUTCMilliseconds() : e.toTimeString().split(" ")[0] + ":" + e.getMilliseconds();
  }

  var WC = {
    DEBUG: 0,
    INFO: 1,
    WARNING: 2,
    ERROR: 3,
    NONE: 4
  },
      HC = Date.now(),
      KC = function KC(e) {
    for (var _t26 in WC) {
      if (Object.prototype.hasOwnProperty.call(WC, _t26) && WC[_t26] === e) return _t26;
    }

    return "DEFAULT";
  };

  var YC = new ( /*#__PURE__*/function () {
    function _class5() {
      var _this34 = this;

      _classCallCheck(this, _class5);

      nh(this, "proxyServerURL", void 0), nh(this, "logLevel", WC.DEBUG), nh(this, "uploadState", "collecting"), nh(this, "uploadLogWaitingList", []), nh(this, "uploadLogUploadingList", []), nh(this, "uploadErrorCount", 0), nh(this, "currentLogID", 0), nh(this, "url", void 0), nh(this, "extLog", function (e, t) {
        _this34.appendLogToWaitingList.apply(_this34, [e].concat(_toConsumableArray(t)));
      });
    }

    _createClass(_class5, [{
      key: "debug",
      value: function debug() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var n = [WC.DEBUG].concat(t);
        this.log.apply(this, n);
      }
    }, {
      key: "info",
      value: function info() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var n = [WC.INFO].concat(t);
        this.log.apply(this, n);
      }
    }, {
      key: "warning",
      value: function warning() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var n = [WC.WARNING].concat(t);
        this.log.apply(this, n);
      }
    }, {
      key: "warn",
      value: function warn() {
        this.warning.apply(this, arguments);
      }
    }, {
      key: "error",
      value: function error() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var n = [WC.ERROR].concat(t);
        this.log.apply(this, n);
      }
    }, {
      key: "upload",
      value: function upload() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var n = [WC.DEBUG].concat(t);
        this.uploadLog.apply(this, n);
      }
    }, {
      key: "setLogLevel",
      value: function setLogLevel(e) {
        e = Math.min(Math.max(0, e), 4), this.logLevel = e;
      }
    }, {
      key: "enableLogUpload",
      value: function enableLogUpload() {
        NC("UPLOAD_LOG", !0);
      }
    }, {
      key: "disableLogUpload",
      value: function disableLogUpload() {
        NC("UPLOAD_LOG", !1), this.uploadLogUploadingList = [], this.uploadLogWaitingList = [];
      }
    }, {
      key: "setProxyServer",
      value: function setProxyServer(e) {
        this.proxyServerURL = e;
      }
    }, {
      key: "prefix",
      value: function prefix(e) {
        return new BC(this).prefix(e);
      }
    }, {
      key: "log",
      value: function log() {
        var _this35 = this;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        if (Date.now() - HC < 100) return void setTimeout(function () {
          _this35.log.apply(_this35, t);
        }, Date.now() - HC);
        var n = Math.max(0, Math.min(4, t[0]));
        if (t[0] = jC() + " Agora-SDK [".concat(KC(n), "]:"), this.appendLogToWaitingList.apply(this, [n].concat(t)), n < this.logLevel) return;
        var s = jC() + " %cAgora-SDK [".concat(KC(n), "]:");
        var r = [];
        if (!DC("USE_NEW_LOG")) switch (n) {
          case WC.DEBUG:
            r = [s, "color: #64B5F6;"].concat(t.slice(1)), console.log.apply(console, r);
            break;

          case WC.INFO:
            r = [s, "color: #1E88E5; font-weight: bold;"].concat(t.slice(1)), console.log.apply(console, r);
            break;

          case WC.WARNING:
            r = [s, "color: #FB8C00; font-weight: bold;"].concat(t.slice(1)), console.warn.apply(console, r);
            break;

          case WC.ERROR:
            r = [s, "color: #B00020; font-weight: bold;"].concat(t.slice(1)), console.error.apply(console, r);
        }
      }
    }, {
      key: "uploadLog",
      value: function uploadLog() {
        var _this36 = this;

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        if (Date.now() - HC < 100) return void setTimeout(function () {
          _this36.uploadLog.apply(_this36, t);
        }, Date.now() - HC);
        var n = Math.max(0, Math.min(4, t[0]));
        t[0] = jC() + " Agora-SDK [".concat(KC(n), "]:"), this.appendLogToWaitingList.apply(this, [n].concat(t));
      }
    }, {
      key: "appendLogToWaitingList",
      value: function appendLogToWaitingList(e) {
        if (!DC("UPLOAD_LOG")) return;

        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          i[n - 1] = arguments[n];
        }

        Array.isArray(i[0]) ? i[0][0] = GC() + " Agora-SDK [".concat(KC(e), "]:") : i[0] = GC() + " Agora-SDK [".concat(KC(e), "]:");
        var s = "";
        i.forEach(function (e) {
          "object" == _typeof(e) && (e = JSON.stringify(e)), s += "".concat(e, " ");
        }), this.uploadLogWaitingList.push({
          payload_str: s,
          log_level: e,
          log_item_id: this.currentLogID++
        }), "uploading" === this.uploadState && 0 === this.uploadLogUploadingList.length && this.uploadLogInterval();
      }
    }, {
      key: "startUpload",
      value: function startUpload() {
        this.uploadState = "uploading", 0 === this.uploadLogUploadingList.length && this.uploadLogInterval();
      }
    }, {
      key: "uploadLogs",
      value: function () {
        var _uploadLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var _this37 = this;

          var e, t;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  e = this.uploadLogUploadingList, t = {
                    sdk_version: yC,
                    process_id: DC("PROCESS_ID"),
                    payload: JSON.stringify(e)
                  };
                  return _context7.abrupt("return", Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    var e, _t27;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return EC.post(_this37.url || (_this37.proxyServerURL ? "https://".concat(_this37.proxyServerURL, "/ls/?h=").concat(DC("LOG_UPLOAD_SERVER"), "&p=443&d=upload/v1") : "https://".concat(DC("LOG_UPLOAD_SERVER"), "/upload/v1")), t, {
                              responseType: "text"
                            });

                          case 2:
                            e = _context6.sent;

                            if (!("OK" !== e.data)) {
                              _context6.next = 6;
                              break;
                            }

                            _t27 = new Error("unexpected upload log response");
                            throw _t27.response = e, _t27;

                          case 6:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  })), function () {
                    return _this37.uploadLogUploadingList = [], !1;
                  }, function (e) {
                    return e.response ? FC.reportLogUploadError({
                      status: e.response.status,
                      data: e.response.data,
                      headers: e.response.headers,
                      message: e.message
                    }) : e.request ? FC.reportLogUploadError({
                      status: e.request.status,
                      message: e.message
                    }) : FC.reportLogUploadError({
                      status: -1,
                      message: e.message
                    }), !0;
                  }, {
                    timeout: DC("UPLOAD_LOG_REQUEST_RETRY_INTERVAL"),
                    maxRetryTimeout: DC("UPLOAD_LOG_REQUEST_MAX_RETRY_INTERVAL")
                  }));

                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function uploadLogs() {
          return _uploadLogs.apply(this, arguments);
        }

        return uploadLogs;
      }()
    }, {
      key: "uploadLogInterval",
      value: function uploadLogInterval() {
        var _this38 = this;

        0 === this.uploadLogUploadingList.length && 0 === this.uploadLogWaitingList.length || (0 === this.uploadLogUploadingList.length && (this.uploadLogUploadingList = this.uploadLogWaitingList.splice(0, DC("UPLOAD_LOG_LENGTH_EACH_TIME"))), this.uploadLogs().then(function () {
          _this38.uploadErrorCount = 0, _this38.uploadLogWaitingList.length > 0 && window.setTimeout(function () {
            return _this38.uploadLogInterval();
          }, DC("UPLOAD_LOG_INTERVAL"));
        }).catch(function (e) {
          _this38.uploadErrorCount += 1, _this38.uploadErrorCount < 2 ? window.setTimeout(function () {
            return _this38.uploadLogInterval();
          }, DC("UPLOAD_LOG_TWICE_RETRY_INTERVAL_V1")) : window.setTimeout(function () {
            return _this38.uploadLogInterval();
          }, DC("UPLOAD_LOG_RETRY_INTERVAL_V1"));
        }));
      }
    }]);

    return _class5;
  }())();
  var qC, JC;

  function zC(e) {
    return WT(e.reportId, "params.reportId", 0, 100, !1), WT(e.category, "params.category", 0, 100, !1), WT(e.event, "params.event", 0, 100, !1), WT(e.label, "params.label", 0, 100, !1), jT(e.value, "params.value", Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, !1), !0;
  }

  !function (e) {
    e.FREE = "free", e.UPLOADING = "uploading";
  }(qC || (qC = {})), function (e) {
    e[e.MISC = 0] = "MISC", e[e.INTERNAL_EVENT = 1] = "INTERNAL_EVENT", e[e.PUBLIC_EVENT = 2] = "PUBLIC_EVENT", e[e.WEB_EVENT = 3] = "WEB_EVENT", e[e.INTERNAL_API = 4] = "INTERNAL_API", e[e.WEB_API = 5] = "WEB_API", e[e.PUBLIC_API = 6] = "PUBLIC_API";
  }(JC || (JC = {}));
  var XC = {
    sid: "",
    lts: 0,
    success: null,
    cname: null,
    uid: null,
    peer: null,
    cid: null,
    elapse: null,
    extend: null,
    vid: 0
  };
  var QC, ZC, $C, eI;

  function tI(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function iI(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? tI(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : tI(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  !function (e) {
    e.PUBLISH = "publish", e.SUBSCRIBE = "subscribe", e.WS_COMPRESSOR_INIT = "ws_compressor_init", e.SESSION_INIT = "session_init", e.JOIN_CHOOSE_SERVER = "join_choose_server", e.REQ_USER_ACCOUNT = "req_user_account", e.JOIN_GATEWAY = "join_gateway", e.REJOIN_GATEWAY = "rejoin_gateway", e.STREAM_SWITCH = "stream_switch", e.REQUEST_PROXY_WORKER_MANAGER = "request_proxy_worker_manager", e.REQUEST_PROXY_APPCENTER = "request_proxy_appcenter", e.FIRST_VIDEO_RECEIVED = "first_video_received", e.FIRST_AUDIO_RECEIVED = "first_audio_received", e.FIRST_VIDEO_DECODE = "first_video_decode", e.FIRST_AUDIO_DECODE = "first_audio_decode", e.ON_ADD_AUDIO_STREAM = "on_add_audio_stream", e.ON_ADD_VIDEO_STREAM = "on_add_video_stream", e.ON_UPDATE_STREAM = "on_update_stream", e.ON_REMOVE_STREAM = "on_remove_stream", e.USER_ANALYTICS = "req_user_analytics", e.PC_STATS = "pc_stats", e.UPDATE_REMOTE_RTPCAPABILITIES = "update_remote_rtpCapabilities";
  }(QC || (QC = {})), function (e) {
    e.SESSION = "io.agora.pb.Wrtc.Session", e.JOIN_CHOOSE_SERVER = "io.agora.pb.Wrtc.JoinChooseServer", e.REQ_USER_ACCOUNT = "io.agora.pb.Wrtc.ReqUserAccount", e.JOIN_GATEWAY = "io.agora.pb.Wrtc.JoinGateway", e.RE_JOIN_GATEWAY = "io.agora.pb.Wrtc.ReJoinGateway", e.PUBLISH = "io.agora.pb.Wrtc.Publish", e.SUBSCRIBE = "io.agora.pb.Wrtc.Subscribe", e.WS_COMPRESSOR_INIT = "io.agora.pb.Wrtc.WsCompressorInit", e.STREAM_SWITCH = "io.agora.pb.Wrtc.StreamSwitch", e.AUDIO_SENDING_STOPPED = "io.agora.pb.Wrtc.AudioSendingStopped", e.VIDEO_SENDING_STOPPED = "io.agora.pb.Wrtc.VideoSendingStopped", e.REQUEST_PROXY_APPCENTER = "io.agora.pb.Wrtc.RequestProxyAppCenter", e.REQUEST_PROXY_WORKER_MANAGER = "io.agora.pb.Wrtc.RequestProxyWorkerManager", e.API_INVOKE = "io.agora.pb.Wrtc.ApiInvoke", e.FIRST_VIDEO_RECEIVED = "io.agora.pb.Wrtc.FirstVideoReceived", e.FIRST_AUDIO_RECEIVED = "io.agora.pb.Wrtc.FirstAudioReceived", e.FIRST_VIDEO_DECODE = "io.agora.pb.Wrtc.FirstVideoDecode", e.FIRST_AUDIO_DECODE = "io.agora.pb.Wrtc.FirstAudioDecode", e.ON_ADD_AUDIO_STREAM = "io.agora.pb.Wrtc.OnAddAudioStream", e.ON_ADD_VIDEO_STREAM = "io.agora.pb.Wrtc.OnAddVideoStream", e.ON_UPDATE_STREAM = "io.agora.pb.Wrtc.OnUpdateStream", e.ON_REMOVE_STREAM = "io.agora.pb.Wrtc.OnRemoveStream", e.JOIN_CHANNEL_TIMEOUT = "io.agora.pb.Wrtc.JoinChannelTimeout", e.PEER_PUBLISH_STATUS = "io.agora.pb.Wrtc.PeerPublishStatus", e.WORKER_EVENT = "io.agora.pb.Wrtc.WorkerEvent", e.AP_WORKER_EVENT = "io.agora.pb.Wrtc.APWorkerEvent", e.JOIN_WEB_PROXY_AP = "io.agora.pb.Wrtc.JoinWebProxyAP", e.WEBSOCKET_QUIT = "io.agora.pb.Wrtc.WebSocketQuit", e.USER_ANALYTICS = "io.agora.pb.Wrtc.UserAnalytics", e.AUTOPLAY_FAILED = "io.agora.pb.Wrtc.AutoplayFailed", e.PC_STATS = "io.agora.pb.Wrtc.PCStats", e.UPDATE_REMOTE_RTPCAPABILITIES = "io.agora.pb.Wrtc.UpdateRemoteRTPCapabilities";
  }(ZC || (ZC = {})), function (e) {
    e[e.WORKER_EVENT = 156] = "WORKER_EVENT", e[e.AP_WORKER_EVENT = 160] = "AP_WORKER_EVENT";
  }($C || ($C = {})), function (e) {
    e[e.SESSION = 26] = "SESSION", e[e.JOIN_CHOOSE_SERVER = 27] = "JOIN_CHOOSE_SERVER", e[e.REQ_USER_ACCOUNT = 196] = "REQ_USER_ACCOUNT", e[e.JOIN_GATEWAY = 28] = "JOIN_GATEWAY", e[e.PUBLISH = 30] = "PUBLISH", e[e.SUBSCRIBE = 29] = "SUBSCRIBE", e[e.WS_COMPRESSOR_INIT = 9430] = "WS_COMPRESSOR_INIT", e[e.STREAM_SWITCH = 32] = "STREAM_SWITCH", e[e.AUDIO_SENDING_STOPPED = 33] = "AUDIO_SENDING_STOPPED", e[e.VIDEO_SENDING_STOPPED = 34] = "VIDEO_SENDING_STOPPED", e[e.REQUEST_PROXY_APPCENTER = 35] = "REQUEST_PROXY_APPCENTER", e[e.REQUEST_PROXY_WORKER_MANAGER = 36] = "REQUEST_PROXY_WORKER_MANAGER", e[e.API_INVOKE = 41] = "API_INVOKE", e[e.FIRST_VIDEO_RECEIVED = 348] = "FIRST_VIDEO_RECEIVED", e[e.FIRST_AUDIO_RECEIVED = 349] = "FIRST_AUDIO_RECEIVED", e[e.FIRST_VIDEO_DECODE = 350] = "FIRST_VIDEO_DECODE", e[e.FIRST_AUDIO_DECODE = 351] = "FIRST_AUDIO_DECODE", e[e.ON_ADD_AUDIO_STREAM = 352] = "ON_ADD_AUDIO_STREAM", e[e.ON_ADD_VIDEO_STREAM = 353] = "ON_ADD_VIDEO_STREAM", e[e.ON_UPDATE_STREAM = 356] = "ON_UPDATE_STREAM", e[e.ON_REMOVE_STREAM = 355] = "ON_REMOVE_STREAM", e[e.JOIN_CHANNEL_TIMEOUT = 407] = "JOIN_CHANNEL_TIMEOUT", e[e.PEER_PUBLISH_STATUS = 408] = "PEER_PUBLISH_STATUS", e[e.WORKER_EVENT = 156] = "WORKER_EVENT", e[e.AP_WORKER_EVENT = 160] = "AP_WORKER_EVENT", e[e.JOIN_WEB_PROXY_AP = 700] = "JOIN_WEB_PROXY_AP", e[e.WEBSOCKET_QUIT = 671] = "WEBSOCKET_QUIT", e[e.USER_ANALYTICS = 1e4] = "USER_ANALYTICS", e[e.AUTOPLAY_FAILED = 9178] = "AUTOPLAY_FAILED";
  }(eI || (eI = {}));

  var nI = /*#__PURE__*/function () {
    function nI() {
      var _this39 = this;

      _classCallCheck(this, nI);

      nh(this, "baseInfoMap", new Map()), nh(this, "proxyServer", void 0), nh(this, "eventUploadTimer", void 0), nh(this, "setSessionIdTimer", void 0), nh(this, "url", void 0), nh(this, "backupUrl", void 0), nh(this, "_appId", void 0), nh(this, "keyEventUploadPendingItems", []), nh(this, "normalEventUploadPendingItems", []), nh(this, "apiInvokeUploadPendingItems", []), nh(this, "apiInvokeCount", 0), nh(this, "ltsList", []), nh(this, "lastSendNormalEventTime", Date.now()), nh(this, "customReportCounterTimer", void 0), nh(this, "customReportCount", 0), nh(this, "extApiInvoke", /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
          var _iterator, _step, _t28, _e23;

          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _iterator = _createForOfIteratorHelper(e);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      _t28 = _step.value;
                      _e23 = iI(iI({}, _t28), {}, {
                        sid: null,
                        invokeId: ++_this39.apiInvokeCount,
                        tag: og.TRACER
                      });

                      _this39.sendApiInvoke(_e23);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref8.apply(this, arguments);
        };
      }()), this.eventUploadTimer = window.setInterval(this.doSend.bind(this), DC("EVENT_REPORT_SEND_INTERVAL")), this.setSessionIdTimer = window.setInterval(this.appendSessionId.bind(this), DC("EVENT_REPORT_SEND_INTERVAL"));
    }

    _createClass(nI, [{
      key: "getBaseInfoBySessionId",
      value: function getBaseInfoBySessionId(e) {
        return this.baseInfoMap.get(e);
      }
    }, {
      key: "adjustSessionStartTime",
      value: function adjustSessionStartTime(e) {
        if (!this.baseInfoMap.has(e) && !this.baseInfoMap.get(e)) return void YC.error("adjust session ".concat(e, " start time, sid is not exist or info is undefined"));
        var t = this.baseInfoMap.get(e),
            i = Date.now(),
            n = t.startTime;
        t.startTime = i, YC.debug("rewrite session ".concat(e, " startTime: ").concat(i, " , ").concat(i - n, "ms")), this.baseInfoMap.set(e, t);
      }
    }, {
      key: "setAppId",
      value: function setAppId(e) {
        this._appId = e;
      }
    }, {
      key: "reportApiInvoke",
      value: function reportApiInvoke(e, t, i) {
        var _this40 = this;

        t.timeout = t.timeout || 6e4, t.reportResult = void 0 === t.reportResult || t.reportResult;
        var n = Date.now();
        this.apiInvokeCount += 1;

        var s = this.apiInvokeCount,
            r = function r() {
          return {
            tag: t.tag,
            invokeId: s,
            sid: e,
            name: t.name,
            apiInvokeTime: n,
            options: t.options,
            states: t.states || null
          };
        },
            o = !!DC("SHOW_REPORT_INVOKER_LOG");

        o && YC.info("".concat(t.name, " start"), t.options);
        var a = !1;
        Ug(t.timeout).then(function () {
          a || (_this40.sendApiInvoke(iI(iI({}, r()), {}, {
            error: xT.API_INVOKE_TIMEOUT,
            success: !1
          })), YC.debug("".concat(t.name, " timeout")));
        });
        var c = new VT(xT.UNEXPECTED_ERROR, "".concat(t.name, ": this api invoke is end"));
        return {
          onSuccess: function onSuccess(e) {
            var n = function n() {
              if (a) throw c;
              return a = !0, _this40.sendApiInvoke(iI(iI({}, r()), {}, {
                success: !0
              }, t.reportResult && {
                result: e
              })), o && YC.info("".concat(t.name, " onSuccess")), e;
            };

            return i ? jg(n, t.name + "Success", i, function () {
              return a = !0;
            }) : n();
          },
          onError: function onError(e) {
            var n = function n() {
              if (a) throw e;
              a = !0, _this40.sendApiInvoke(iI(iI({}, r()), {}, {
                success: !1,
                error: e
              })), o && YC.info("".concat(t.name, " onFailure"), e.toString());
            };

            return i ? jg(n, t.name + "Error", i, function () {
              return a = !0;
            }) : n();
          }
        };
      }
    }, {
      key: "sessionInit",
      value: function sessionInit(e, t) {
        if (this.baseInfoMap.has(e)) return;
        var i = Date.now(),
            n = this.createBaseInfo(e, i);
        n.cname = t.cname;
        var s = Object.assign({}, {
          willUploadConsoleLog: DC("UPLOAD_LOG"),
          maxTouchPoints: navigator.maxTouchPoints,
          areaVersion: AC ? "global" : "oversea",
          areas: DC("AREAS") && DC("AREAS").join(",")
        }, t.extend),
            r = t.stringUid,
            o = t.channelProfile,
            a = t.channelMode,
            c = t.isABTestSuccess,
            d = t.lsid,
            l = t.clientRole,
            u = Date.now(),
            h = iI(iI({}, n), {}, {
          eventType: QC.SESSION_INIT,
          appid: t.appid,
          browser: navigator.userAgent,
          build: wC,
          lts: u,
          elapse: u - i,
          extend: JSON.stringify(s),
          mode: t.mode,
          process: DC("PROCESS_ID"),
          appType: DC("APP_TYPE"),
          success: !0,
          version: yC,
          stringUid: r,
          channelProfile: o,
          channelMode: a,
          isABTestSuccess: c,
          lsid: d,
          clientType: 20,
          clientRole: l,
          serviceId: DC("PROCESS_ID"),
          extensionID: DC("PLUGIN_INFO").join(",") || ""
        });
        this.send({
          type: ZC.SESSION,
          data: h
        }, !0);
      }
    }, {
      key: "joinChooseServer",
      value: function joinChooseServer(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.JOIN_CHOOSE_SERVER,
          lts: s,
          eventElapse: s - t.lts,
          chooseServerAddr: t.csAddr,
          errorCode: t.ec,
          elapse: s - i.startTime,
          success: t.succ,
          chooseServerAddrList: JSON.stringify(t.serverList),
          uid: t.uid ? parseInt(t.uid) : null,
          cid: t.cid ? parseInt(t.cid) : null,
          chooseServerIp: t.csIp || "",
          opid: t.opid,
          unilbsServerIds: t.unilbsServerIds,
          extend: t.extend || void 0,
          isHttp3: t.isHttp3
        });
        this.send({
          type: ZC.JOIN_CHOOSE_SERVER,
          data: r
        }, !0);
      }
    }, {
      key: "reqUserAccount",
      value: function reqUserAccount(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.REQ_USER_ACCOUNT,
          lts: s,
          success: t.success,
          serverAddress: t.serverAddr,
          stringUid: t.stringUid,
          uid: t.uid,
          errorCode: t.errorCode,
          elapse: s - i.startTime,
          eventElapse: s - t.lts,
          extend: JSON.stringify(t.extend)
        });
        this.send({
          type: ZC.REQ_USER_ACCOUNT,
          data: r
        }, !0);
      }
    }, {
      key: "joinGateway",
      value: function joinGateway(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info;
        t.vid && (n.vid = t.vid), n.uid = t.uid, n.cid = t.cid;
        var s = Date.now(),
            r = t.firstSuccess,
            o = t.avoidJoinStartTime,
            a = t.isProxy,
            c = t.addr,
            d = s - (r && o ? o : i.startTime),
            l = iI(iI({}, n), {}, {
          eventType: QC.JOIN_GATEWAY,
          lts: s,
          gatewayAddr: t.addr,
          success: t.succ,
          errorCode: t.ec,
          elapse: d,
          eventElapse: s - t.lts,
          firstSuccess: r,
          signalChannel: t.signalChannel
        }),
            u = l.success ? 1 : 0;
        if (t.succ && (i.lastJoinSuccessTime = s), r) this.send({
          type: ZC.JOIN_GATEWAY,
          data: l
        }, !0);else {
          var _e24;

          if (c) {
            if (a) {
              var _t30 = c.match(/h=(\d{1,3}-){3}\d{1,3}/g),
                  _i26 = c.match(/p=[0-9]{1,6}/g);

              _e24 = {
                isSuccess: u,
                gatewayIp: _t30 && _t30.length ? _t30[0].split("=")[1].replace(/-/g, ".") : "",
                port: _i26 && _i26.length ? _i26[0].split("=")[1] : "",
                isProxy: a ? 1 : 0
              };
            } else {
              var _t31 = c.match(/wss:\/\/(\d{1,3}-){3}\d{1,3}/g),
                  _i27 = c.match(/(:|p=)[0-9]{1,6}/g);

              _e24 = {
                isSuccess: u,
                gatewayIp: _t31 && _t31.length ? _t31[0].split("//")[1].replace(/-/g, ".") : "",
                port: _i27 && _i27.length ? _i27[0].split(/:|p=/g)[1] : "",
                isProxy: a ? 1 : 0
              };
            }
          } else _e24 = {
            isSuccess: u,
            gatewayIp: "",
            port: "",
            isProxy: a ? 1 : 0
          };
          delete l.success, delete l.eventType, delete l.firstSuccess, l.vid = Number(l.vid);

          var _t29 = Object.assign({}, l, _e24, {
            eventType: QC.REJOIN_GATEWAY
          });

          this.send({
            type: ZC.RE_JOIN_GATEWAY,
            data: _t29
          }, !0);
        }
      }
    }, {
      key: "joinChannelTimeout",
      value: function joinChannelTimeout(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = Date.now(),
            s = iI(iI({}, i.info), {}, {
          lts: n,
          timeout: t,
          elapse: n - i.startTime
        });
        this.send({
          type: ZC.JOIN_CHANNEL_TIMEOUT,
          data: s
        }, !0);
      }
    }, {
      key: "publish",
      value: function publish(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.PUBLISH,
          lts: s,
          eventElapse: t.eventElapse,
          elapse: s - i.startTime,
          success: t.succ,
          errorCode: t.ec,
          videoName: t.videoName,
          audioName: t.audioName,
          screenName: t.screenName,
          screenshare: t.screenshare,
          audio: t.audio,
          video: t.video,
          p2pid: t.p2pid,
          publishRequestid: t.publishRequestid
        });
        this.send({
          type: ZC.PUBLISH,
          data: r
        }, !0);
      }
    }, {
      key: "subscribe",
      value: function subscribe(e, t, i) {
        var n = this.baseInfoMap.get(e);
        if (!n) return;
        var s = n.info,
            r = Date.now(),
            o = iI(iI({}, s), {}, {
          eventType: QC.SUBSCRIBE,
          lts: r,
          eventElapse: t.eventElapse,
          elapse: r - n.startTime,
          success: t.succ,
          errorCode: t.ec,
          video: t.video,
          audio: t.audio,
          subscribeRequestid: t.subscribeRequestid,
          p2pid: t.p2pid
        }, i && {
          extend: JSON.stringify({
            isMassSubscribe: !0
          })
        });
        "string" == typeof t.peerid ? o.peerSuid = t.peerid : o.peer = t.peerid, this.send({
          type: ZC.SUBSCRIBE,
          data: o
        }, !0);
      }
    }, {
      key: "wsCompressorInit",
      value: function wsCompressorInit(e) {
        var t;

        var i = _toConsumableArray(uh(t = this.baseInfoMap).call(t)),
            n = i.length ? i[0] : "UnableToGetSid",
            s = this.baseInfoMap.get(n);

        if (!s) return;
        var r = s.info,
            o = Date.now(),
            a = iI(iI({}, r), {}, {
          eventType: QC.WS_COMPRESSOR_INIT,
          lts: o,
          eventElapse: e.eventElapse,
          elapse: o - s.startTime,
          status: e.status ? 1 : 2
        });
        this.send({
          type: ZC.WS_COMPRESSOR_INIT,
          data: a
        }, !0);
      }
    }, {
      key: "firstRemoteVideoDecode",
      value: function firstRemoteVideoDecode(e, t, i, n) {
        var s = this.baseInfoMap.get(e);
        if (!s) return;
        var r = s.info,
            o = Date.now(),
            a = iI(iI(iI({}, r), n), {}, {
          elapse: o - s.startTime,
          eventType: t,
          lts: o,
          firstDecodeFrame: Math.max(o - s.startTime, 0),
          apEnd: Math.max(n.apEnd - s.startTime, 0),
          apStart: Math.max(n.apStart - s.startTime, 0),
          joinGwEnd: Math.max(n.joinGwEnd - s.startTime, 0),
          joinGwStart: Math.max(n.joinGwStart - s.startTime, 0),
          pcEnd: Math.max(n.pcEnd - s.startTime, 0),
          pcStart: Math.max(n.pcStart - s.startTime, 0),
          subscriberEnd: Math.max(n.subscriberEnd - s.startTime, 0),
          subscriberStart: Math.max(n.subscriberStart - s.startTime, 0),
          videoAddNotify: Math.max(n.videoAddNotify - s.startTime, 0)
        });
        this.send({
          type: i,
          data: a
        }, !0);
      }
    }, {
      key: "firstRemoteFrame",
      value: function firstRemoteFrame(e, t, i, n) {
        var s = this.baseInfoMap.get(e);
        if (!s) return;
        var r = s.info,
            o = Date.now(),
            a = iI(iI(iI({}, r), n), {}, {
          elapse: o - s.startTime,
          eventType: t,
          lts: o
        });
        this.send({
          type: i,
          data: a
        }, !0);
      }
    }, {
      key: "pcStats",
      value: function pcStats(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI(iI({}, n), t), {}, {
          vid: void 0 === n.vid ? 0 : Number(n.vid),
          elapse: s - i.startTime,
          eventType: QC.PC_STATS,
          lts: s
        });
        this.send({
          type: ZC.PC_STATS,
          data: r
        }, !0);
      }
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function updateRemoteRTPCapabilities(e, t) {
        if (e) {
          var _i28 = this.baseInfoMap.get(e);

          if (!_i28) return;

          var _n19 = _i28.info,
              _s10 = Date.now(),
              _r4 = iI(iI(iI({}, _n19), t), {}, {
            vid: void 0 === _n19.vid ? 0 : Number(_n19.vid),
            eventType: QC.UPDATE_REMOTE_RTPCAPABILITIES,
            lts: _s10
          });

          this.send({
            type: ZC.UPDATE_REMOTE_RTPCAPABILITIES,
            data: _r4
          }, !0);
        }
      }
    }, {
      key: "onGatewayStream",
      value: function onGatewayStream(e, t, i, n) {
        var s = this.baseInfoMap.get(e);
        if (!s) return;
        var r = s.info,
            o = Date.now(),
            a = iI(iI(iI({}, r), n), {}, {
          eventType: t,
          lts: o
        });
        this.send({
          type: i,
          data: a
        }, !0);
      }
    }, {
      key: "streamSwitch",
      value: function streamSwitch(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.STREAM_SWITCH,
          lts: s,
          isDual: t.isdual,
          elapse: s - i.startTime,
          success: t.succ
        });
        this.send({
          type: ZC.STREAM_SWITCH,
          data: r
        }, !0);
      }
    }, {
      key: "requestProxyAppCenter",
      value: function requestProxyAppCenter(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.REQUEST_PROXY_APPCENTER,
          lts: s,
          eventElapse: s - t.lts,
          elapse: s - i.startTime,
          APAddr: t.APAddr,
          workerManagerList: t.workerManagerList,
          response: t.response,
          errorCode: t.ec,
          success: t.succ
        });
        this.send({
          type: ZC.REQUEST_PROXY_APPCENTER,
          data: r
        }, !0);
      }
    }, {
      key: "requestProxyWorkerManager",
      value: function requestProxyWorkerManager(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          eventType: QC.REQUEST_PROXY_WORKER_MANAGER,
          lts: s,
          eventElapse: s - t.lts,
          elapse: s - i.startTime,
          workerManagerAddr: t.workerManagerAddr,
          response: t.response,
          errorCode: t.ec,
          success: t.succ
        });
        this.send({
          type: ZC.REQUEST_PROXY_WORKER_MANAGER,
          data: r
        }, !0);
      }
    }, {
      key: "setProxyServer",
      value: function setProxyServer(e) {
        this.proxyServer = e, e ? YC.debug("reportProxyServerurl: ".concat(e)) : YC.debug("disable reportProxyServerurl: ".concat(e));
      }
    }, {
      key: "peerPublishStatus",
      value: function peerPublishStatus(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI({}, n), {}, {
          subscribeElapse: t.subscribeElapse,
          peer: t.peer,
          peerPublishDuration: Math.max(t.audioPublishDuration, t.videoPublishDuration),
          audiotag: t.audioPublishDuration > 0 ? 1 : -1,
          videotag: t.videoPublishDuration > 0 ? 1 : -1,
          lts: s,
          elapse: s - i.startTime,
          joinChannelSuccessElapse: s - (i.lastJoinSuccessTime || s),
          peerPublishDurationVideo: t.videoPublishDuration,
          peerPublishDurationAudio: t.audioPublishDuration
        });
        this.send({
          type: ZC.PEER_PUBLISH_STATUS,
          data: r
        }, !0);
      }
    }, {
      key: "workerEvent",
      value: function workerEvent(e, t) {
        var _this41 = this;

        var i = this.baseInfoMap.get(e);
        if (!i) return;

        var n = i.info,
            s = Date.now(),
            r = function (e, t, i) {
          var n = e[t];
          if (!n || "string" != typeof n) return [e];
          e[t] = "";
          var s = Lg(JSON.stringify(e));
          var r = 0;
          var o = [];
          var a = 0;

          for (var _c4 = 0; _c4 < n.length; _c4++) {
            a += n.charCodeAt(_c4) <= 127 ? 1 : 3, a <= i - s || (o[o.length] = Ig(Ig({}, e), {}, _defineProperty({}, t, n.substring(r, _c4))), r = _c4, a = n.charCodeAt(_c4) <= 127 ? 1 : 3);
          }

          return r !== n.length - 1 && (o[o.length] = Ig(Ig({}, e), {}, _defineProperty({}, t, n.substring(r)))), o;
        }(iI(iI(iI({}, n), t), {}, {
          elapse: s - i.startTime,
          lts: s,
          productType: "WebRTC"
        }), "payload", 1300);

        r.forEach(function (e) {
          return _this41.send({
            type: ZC.WORKER_EVENT,
            data: e
          }, !0);
        });
      }
    }, {
      key: "apworkerEvent",
      value: function apworkerEvent(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI(iI({}, n), t), {}, {
          elapse: s - i.startTime,
          lts: s
        });
        this.send({
          type: ZC.AP_WORKER_EVENT,
          data: r
        }, !0);
      }
    }, {
      key: "joinWebProxyAP",
      value: function joinWebProxyAP(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI(iI({}, n), t), {}, {
          elapse: s - i.startTime,
          lts: s,
          extend: t.extend || void 0
        });
        this.send({
          type: ZC.JOIN_WEB_PROXY_AP,
          data: r
        }, !0);
      }
    }, {
      key: "WebSocketQuit",
      value: function WebSocketQuit(e, t) {
        var i = this.baseInfoMap.get(e);
        if (!i) return;
        var n = i.info,
            s = Date.now(),
            r = iI(iI(iI({}, n), t), {}, {
          elapse: s - i.startTime,
          lts: s
        });
        this.send({
          type: ZC.WEBSOCKET_QUIT,
          data: r
        }, !0);
      }
    }, {
      key: "sendCustomReportMessage",
      value: function () {
        var _sendCustomReportMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
          var _this42 = this;

          var i, n;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!(this.customReportCount += t.length, this.customReportCount > DC("CUSTOM_REPORT_LIMIT"))) {
                    _context9.next = 2;
                    break;
                  }

                  throw new VT(xT.CUSTOM_REPORT_FREQUENCY_TOO_HIGH);

                case 2:
                  this.customReportCounterTimer || (this.customReportCounterTimer = window.setInterval(function () {
                    _this42.customReportCount = 0;
                  }, 5e3));
                  i = Date.now(), n = t.map(function (t) {
                    return {
                      type: ZC.USER_ANALYTICS,
                      data: iI(iI({
                        sid: e
                      }, t), {}, {
                        lts: i
                      })
                    };
                  });
                  _context9.prev = 4;

                  if (!DC("NEW_REPORT_SERVER")) {
                    _context9.next = 10;
                    break;
                  }

                  _context9.next = 8;
                  return this.postDataToStatsCollector2(n);

                case 8:
                  _context9.next = 12;
                  break;

                case 10:
                  _context9.next = 12;
                  return this.postDataToStatsCollector(n);

                case 12:
                  _context9.next = 17;
                  break;

                case 14:
                  _context9.prev = 14;
                  _context9.t0 = _context9["catch"](4);
                  throw YC.error("send custom report message failed", _context9.t0.toString()), new VT(xT.CUSTOM_REPORT_SEND_FAILED, _context9.t0.message);

                case 17:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this, [[4, 14]]);
        }));

        function sendCustomReportMessage(_x8, _x9) {
          return _sendCustomReportMessage.apply(this, arguments);
        }

        return sendCustomReportMessage;
      }()
    }, {
      key: "sendApiInvoke",
      value: function sendApiInvoke(e) {
        var t = DC("NOT_REPORT_EVENT");
        if (e.tag && bn(t) && bn(t).call(t, e.tag)) return !1;
        if (null === e.sid) return this.apiInvokeUploadPendingItems.push(e), !1;
        var i = this.baseInfoMap.get(e.sid);
        if (!i) return this.apiInvokeUploadPendingItems.push(e), !1;
        var _i$info = i.info,
            n = _i$info.cname,
            s = _i$info.uid,
            r = _i$info.cid;
        var o;
        if (e.lts = e.lts || Date.now(), e.error) if (e.error instanceof VT) {
          var _e$error = e.error,
              _t32 = _e$error.code,
              _i29 = _e$error.message;
          o = _t32 || _i29 || e.error.toString();
        } else o = e.error.toString();
        var a = {
          invokeId: e.invokeId,
          sid: e.sid,
          cname: n,
          cid: r,
          uid: s,
          lts: e.lts,
          success: e.success,
          elapse: e.lts - i.startTime,
          execElapse: e.lts - e.apiInvokeTime,
          apiName: e.name,
          options: e.options ? JSON.stringify(e.options) : void 0,
          execStates: e.states ? JSON.stringify(e.states) : void 0,
          execResult: e.result ? JSON.stringify(e.result) : void 0,
          errorCode: e.error ? o : void 0,
          errorMsg: e.error ? JSON.stringify(e.error) : void 0
        };
        return this.send({
          type: ZC.API_INVOKE,
          data: a
        }, !1), !0;
      }
    }, {
      key: "appendSessionId",
      value: function appendSessionId() {
        var _this43 = this;

        nI.__CLIENT_LIST__.forEach(function (e) {
          if (e._sessionId) {
            var _t33 = _this43.apiInvokeUploadPendingItems.length;

            for (var _i30 = 0; _i30 < _t33; _i30++) {
              var _t34 = _this43.apiInvokeUploadPendingItems.shift();

              _t34 && (_t34.sid = e._sessionId, _this43.sendApiInvoke(Object.assign({}, _t34)));
            }
          }
        });
      }
    }, {
      key: "send",
      value: function send(e, t) {
        if (t) return this.keyEventUploadPendingItems.push(e), void this.sendItems(this.keyEventUploadPendingItems, !0);
        this.normalEventUploadPendingItems.push(e), this.normalEventUploadPendingItems.length > DC("NORMAL_EVENT_QUEUE_CAPACITY") && this.normalEventUploadPendingItems.splice(0, 1), this.normalEventUploadPendingItems.length >= 10 && this.sendItems(this.normalEventUploadPendingItems, !1);
      }
    }, {
      key: "doSend",
      value: function doSend() {
        this.keyEventUploadPendingItems.length > 0 && this.sendItems(this.keyEventUploadPendingItems, !0), this.normalEventUploadPendingItems.length > 0 && Date.now() - this.lastSendNormalEventTime >= 5e3 && this.sendItems(this.normalEventUploadPendingItems, !1);
      }
    }, {
      key: "sendItems",
      value: function sendItems(e, t) {
        var _this44 = this;

        var i = [],
            n = [];

        for (; e.length;) {
          var _t35 = e.shift();

          i.length < 20 ? i.push(_t35) : n.push(_t35);
        }

        e.push.apply(e, n);

        for (var _i31 = 0, _arr2 = [].concat(i); _i31 < _arr2.length; _i31++) {
          var _e25 = _arr2[_i31];
          var s;
          if (-1 !== this.ltsList.indexOf(_e25.data.lts)) _e25.data.lts = this.ltsList[this.ltsList.length - 1] + 1, this.ltsList.push(_e25.data.lts);else this.ltsList.push(_e25.data.lts), Zh(s = this.ltsList).call(s, function (e, t) {
            return e - t;
          });
        }

        t || (this.lastSendNormalEventTime = Date.now());
        return DC("ENABLE_EVENT_REPORT") ? (i.length && (DC("NEW_REPORT_SERVER") ? this.postDataToStatsCollector2(i) : this.postDataToStatsCollector(i)).catch(function (e) {
          return function (i) {
            DC("EVENT_REPORT_RETRY") && (t ? _this44.keyEventUploadPendingItems = _this44.keyEventUploadPendingItems.concat(e) : (_this44.normalEventUploadPendingItems = _this44.normalEventUploadPendingItems.concat(e), _this44.normalEventUploadPendingItems.length > DC("NORMAL_EVENT_QUEUE_CAPACITY") && (_this44.normalEventUploadPendingItems.splice(0, _this44.normalEventUploadPendingItems.length - DC("NORMAL_EVENT_QUEUE_CAPACITY")), YC.warning("report: drop normal events"))));
          };
        }(i)), e) : e;
      }
    }, {
      key: "postDataToStatsCollector2",
      value: function () {
        var _postDataToStatsCollector = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
          var t, i, n, _s11;

          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.t0 = Rg.networkState === ug.OFFLINE;

                  if (!_context10.t0) {
                    _context10.next = 4;
                    break;
                  }

                  _context10.next = 4;
                  return tT.race([Rg.onlineWaiter, Ug(2 * Jg.maxRetryTimeout)]);

                case 4:
                  t = function t(e) {
                    var t = new Uint8Array();
                    return e.forEach(function (e) {
                      var i = ZT(JSON.stringify(e.data)),
                          n = new ArrayBuffer(5),
                          s = function (e) {
                        var t = 0;
                        return Object.entries(ZC).forEach(function (i) {
                          var _i32 = _slicedToArray(i, 2),
                              n = _i32[0],
                              s = _i32[1];

                          s === e.type && (t = EventNameToID[n]);
                        }), t;
                      }(e),
                          r = new DataView(n);

                      r.setUint16(0, i.byteLength, !0), r.setUint8(2, 255 & s), r.setUint8(3, s >>> 8 & 255), r.setUint8(4, s >>> 16 & 255), t = $T(t, new Uint8Array(n)), t = $T(t, i);
                    }), t;
                  }, i = "event";
                  n = this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(DC("NEW_REPORT_SERVER_DOMAINS")[0], "&p=443&d=").concat(i) : "https://".concat(DC("NEW_REPORT_SERVER_DOMAINS")[0], "/").concat(i);
                  _s11 = 0;

                case 7:
                  if (!(_s11 < 2)) {
                    _context10.next = 23;
                    break;
                  }

                  1 === _s11 && (n = this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(DC("NEW_REPORT_SERVER_DOMAINS")[1], "&p=443&d=").concat(i) : "https://".concat(DC("NEW_REPORT_SERVER_DOMAINS")[1], "/").concat(i));
                  _context10.prev = 9;
                  _context10.next = 12;
                  return RC(n, {
                    timeout: 1e4,
                    data: t(e),
                    headers: iI(iI({
                      biz: "webrtc",
                      sendts: Math.round(Date.now() / 1e3),
                      debug: "false"
                    }, this._appId && {
                      appid: this._appId
                    }), {}, {
                      "Content-Type": "application/octet-stream"
                    })
                  }, !0);

                case 12:
                  _context10.next = 19;
                  break;

                case 14:
                  _context10.prev = 14;
                  _context10.t1 = _context10["catch"](9);

                  if (!(1 === _s11)) {
                    _context10.next = 18;
                    break;
                  }

                  throw _context10.t1;

                case 18:
                  return _context10.abrupt("continue", 20);

                case 19:
                  return _context10.abrupt("return");

                case 20:
                  _s11 += 1;
                  _context10.next = 7;
                  break;

                case 23:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[9, 14]]);
        }));

        function postDataToStatsCollector2(_x10) {
          return _postDataToStatsCollector.apply(this, arguments);
        }

        return postDataToStatsCollector2;
      }()
    }, {
      key: "postDataToStatsCollector",
      value: function () {
        var _postDataToStatsCollector2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
          var _this45 = this;

          var t,
              i,
              n,
              s,
              _e26,
              _args11 = arguments;

          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  t = _args11.length > 1 && void 0 !== _args11[1] && _args11[1];
                  i = {
                    msgType: "EventMessages",
                    sentTs: Math.round(Date.now() / 1e3),
                    payloads: e.map(function (e) {
                      return JSON.stringify(e);
                    }),
                    vid: function (e) {
                      var t = e && e.data.sid && _this45.baseInfoMap.get(e.data.sid);

                      return t && t.info.vid && +t.info.vid || 0;
                    }(e[0])
                  };
                  _context11.t0 = Rg.networkState === ug.OFFLINE;

                  if (!_context11.t0) {
                    _context11.next = 6;
                    break;
                  }

                  _context11.next = 6;
                  return tT.race([Rg.onlineWaiter, Ug(2 * Jg.maxRetryTimeout)]);

                case 6:
                  n = t ? "/events/proto-raws" : "/events/messages";
                  s = this.url || (this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(DC("EVENT_REPORT_DOMAIN"), "&p=").concat(DC("STATS_COLLECTOR_PORT"), "&d=").concat(n) : "https://".concat(DC("EVENT_REPORT_DOMAIN"), ":").concat(DC("STATS_COLLECTOR_PORT")).concat(n));
                  _e26 = 0;

                case 9:
                  if (!(_e26 < 2)) {
                    _context11.next = 30;
                    break;
                  }

                  1 === _e26 && (s = this.backupUrl || (this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(DC("EVENT_REPORT_BACKUP_DOMAIN"), "&p=").concat(DC("STATS_COLLECTOR_PORT"), "&d=").concat(n) : "https://".concat(DC("EVENT_REPORT_BACKUP_DOMAIN"), ":").concat(DC("STATS_COLLECTOR_PORT")).concat(n)));
                  _context11.prev = 11;

                  if (!t) {
                    _context11.next = 17;
                    break;
                  }

                  _context11.next = 15;
                  return CC(s, {
                    timeout: 1e4,
                    data: i
                  });

                case 15:
                  _context11.next = 19;
                  break;

                case 17:
                  _context11.next = 19;
                  return RC(s, {
                    timeout: 1e4,
                    data: i
                  });

                case 19:
                  _context11.next = 26;
                  break;

                case 21:
                  _context11.prev = 21;
                  _context11.t1 = _context11["catch"](11);

                  if (!(1 === _e26)) {
                    _context11.next = 25;
                    break;
                  }

                  throw _context11.t1;

                case 25:
                  return _context11.abrupt("continue", 27);

                case 26:
                  return _context11.abrupt("return");

                case 27:
                  _e26 += 1;
                  _context11.next = 9;
                  break;

                case 30:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this, [[11, 21]]);
        }));

        function postDataToStatsCollector(_x11) {
          return _postDataToStatsCollector2.apply(this, arguments);
        }

        return postDataToStatsCollector;
      }()
    }, {
      key: "createBaseInfo",
      value: function createBaseInfo(e, t) {
        var i = Object.assign({}, XC);
        return i.sid = e, this.baseInfoMap.set(e, {
          info: i,
          startTime: t
        }), i;
      }
    }, {
      key: "reportResourceTiming",
      value: function reportResourceTiming(e, t) {
        var i = performance.getEntriesByName(e),
            n = i[i.length - 1];
        n && this.reportApiInvoke(t, {
          name: "Client.resourceTiming",
          options: n,
          tag: og.TRACER
        }).onSuccess();
      }
    }]);

    return nI;
  }();

  function sI() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return function (t, i, n) {
      var s = n.value;

      if ("function" == typeof s) {
        var _r5 = e.className || t.__className__ || ("AgoraRTCClient" === t.constructor.name ? "Client" : t.constructor.name);

        n.value = function () {
          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          var a = n;
          if (e.argsMap) try {
            a = e.argsMap.apply(e, [this].concat(n));
          } catch (e) {
            YC.warning(e), a = [];
          }

          try {
            JSON.stringify(a);
          } catch (e) {
            YC.warning("arguments for method ".concat(_r5, ".").concat(String(i), " not serializable for apiInvoke.")), a = [];
          }

          var c = (e.report || rI).reportApiInvoke(this._sessionId || null, {
            name: "".concat(_r5, ".").concat(String(i)),
            options: a,
            tag: og.TRACER,
            reportResult: e.reportResult
          }, e.throttleTime);

          try {
            var _t36 = s.apply(this, n);

            return _t36 instanceof tT ? _t36.then(function (t) {
              return c.onSuccess(e.reportResult && t), t;
            }).catch(function (e) {
              throw c.onError(e), e;
            }) : (c.onSuccess(e.reportResult && _t36), _t36);
          } catch (e) {
            throw c.onError(e), e;
          }
        };
      }

      return n;
    };
  }

  nh(nI, "__CLIENT_LIST__", []);
  var rI = new nI();
  FC.on("REPORT_LOG_UPLOAD", function (e) {
    e.networkState = Rg.networkState, rI.reportApiInvoke(null, {
      name: "logUploadError",
      options: e,
      tag: og.TRACER
    });
  });

  var oI = ["CHINA", "GLOBAL"],
      aI = function () {
    var e = "us".concat("erna", "me"),
        t = "pa".concat("sswo", "rd"),
        i = ["t", "s", "t"];
    i.splice(1, 0, "e");
    var n = i.join(""),
        s = [];

    for (var _e27 = 0; _e27 < 6; _e27++) {
      s.push("1");
    }

    var r = s.join(""),
        o = {};
    return o[e] = n, o[t] = r, Object.assign(o, {
      turnServerURL: "",
      tcpport: 3433,
      udpport: 3478,
      forceturn: !1
    });
  }();

  window.DEFAULT_TURN_CONFIG = aI, AC || (OC.WEBCS_DOMAIN = ["ap-web-1-oversea.agora.io", "ap-web-1-north-america.agora.io"], OC.WEBCS_DOMAIN_BACKUP_LIST = ["ap-web-2-oversea.agora.io", "ap-web-2-north-america.agora.io"], OC.PROXY_CS = ["proxy-ap-web-oversea.agora.io", "proxy-ap-web-america.agora.io"], OC.CDS_AP = ["cds-ap-web-oversea.agora.io", "cds-ap-web-america.agora.io", "cds-ap-web-america2.agora.io"], OC.ACCOUNT_REGISTER = ["sua-ap-web-oversea.agora.io", "sua-ap-web-america.agora.io", "sua-ap-web-america2.agora.io"], OC.UAP_AP = ["uap-ap-web-oversea.agora.io", "uap-ap-web-america.agora.io", "uap-ap-web-america2.agora.io"], OC.LOG_UPLOAD_SERVER = "logservice-oversea.agora.io", OC.EVENT_REPORT_DOMAIN = "statscollector-1-oversea.agora.io", OC.EVENT_REPORT_BACKUP_DOMAIN = "statscollector-2-oversea.agora.io", OC.PROXY_SERVER_TYPE3 = "webrtc-cloud-proxy.agora.io", OC.AREAS = ["NORTH_AMERICA", "OVERSEA"]);
  var cI = [[0, 1, 2, 3, 4, 5, 5], [0, 2, 2, 3, 4, 5, 5], [0, 3, 3, 3, 4, 5, 5], [0, 4, 4, 4, 4, 5, 5], [0, 5, 5, 5, 5, 5, 5]],
      dI = [];

  function lI(e, t) {
    return !!t && dI.some(function (i) {
      return i.uid === e && i.channelName === t;
    });
  }

  nI.__CLIENT_LIST__ = dI;

  var uI,
      hI,
      pI,
      _I,
      EI,
      mI,
      fI,
      TI,
      gI,
      SI,
      RI,
      CI,
      II,
      vI,
      yI,
      AI,
      bI,
      wI = Ji("Array").values,
      OI = ln,
      NI = Ze,
      DI = l,
      PI = wI,
      LI = Array.prototype,
      kI = {
    DOMTokenList: !0,
    NodeList: !0
  },
      MI = i(function (e) {
    var t = e.values;
    return e === LI || DI(LI, e) && t === LI.values || NI(kI, OI(e)) ? PI : t;
  });

  function UI(e, t, i, n) {
    var s,
        r = arguments.length,
        o = r < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, i) : n;
    if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) o = Reflect.decorate(e, t, i, n);else for (var a = e.length - 1; a >= 0; a--) {
      (s = e[a]) && (o = (r < 3 ? s(o) : r > 3 ? s(t, i, o) : s(t, i)) || o);
    }
    return r > 3 && o && Object.defineProperty(t, i, o), o;
  }

  function xI(e, t) {
    if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
  }

  !function (e) {
    e.L1T1 = "L1T1", e.L1T2 = "L1T2", e.L1T3 = "L1T3", e.L2T1_KEY = "L2T1_KEY", e.L2T2_KEY = "L2T2_KEY", e.L2T3_KEY = "L2T3_KEY", e.L3T1_KEY = "L3T1_KEY", e.L3T2_KEY = "L3T2_KEY", e.L3T3_KEY = "L3T3_KEY";
  }(uI || (uI = {})), function (e) {
    e.CERTIFICATE = "certificate", e.CODEC = "codec", e.CANDIDATE_PAIR = "candidate-pair", e.LOCAL_CANDIDATE = "local-candidate", e.REMOTE_CANDIDATE = "remote-candidate", e.INBOUND = "inbound-rtp", e.TRACK = "track", e.OUTBOUND = "outbound-rtp", e.PC = "peer-connection", e.REMOTE_INBOUND = "remote-inbound-rtp", e.REMOTE_OUTBOUND = "remote-outbound-rtp", e.TRANSPORT = "transport", e.CSRC = "csrc", e.DATA_CHANNEL = "data-channel", e.STREAM = "stream", e.SENDER = "sender", e.RECEIVER = "receiver";
  }(hI || (hI = {})), function (e) {
    e[e.ACCESS_POINT = 101] = "ACCESS_POINT", e[e.UNILBS = 201] = "UNILBS", e[e.STRING_UID_ALLOCATOR = 901] = "STRING_UID_ALLOCATOR";
  }(pI || (pI = {})), function (e) {
    e[e.IIIEGAL_APPID = 1] = "IIIEGAL_APPID", e[e.IIIEGAL_UID = 2] = "IIIEGAL_UID", e[e.INTERNAL_ERROR = 3] = "INTERNAL_ERROR";
  }(_I || (_I = {})), function (e) {
    e[e.INVALID_VENDOR_KEY = 5] = "INVALID_VENDOR_KEY", e[e.INVALID_CHANNEL_NAME = 7] = "INVALID_CHANNEL_NAME", e[e.INTERNAL_ERROR = 8] = "INTERNAL_ERROR", e[e.NO_AUTHORIZED = 9] = "NO_AUTHORIZED", e[e.DYNAMIC_KEY_TIMEOUT = 10] = "DYNAMIC_KEY_TIMEOUT", e[e.NO_ACTIVE_STATUS = 11] = "NO_ACTIVE_STATUS", e[e.DYNAMIC_KEY_EXPIRED = 13] = "DYNAMIC_KEY_EXPIRED", e[e.STATIC_USE_DYNAMIC_KEY = 14] = "STATIC_USE_DYNAMIC_KEY", e[e.DYNAMIC_USE_STATIC_KEY = 15] = "DYNAMIC_USE_STATIC_KEY", e[e.USER_OVERLOAD = 16] = "USER_OVERLOAD", e[e.FORBIDDEN_REGION = 18] = "FORBIDDEN_REGION", e[e.CANNOT_MEET_AREA_DEMAND = 19] = "CANNOT_MEET_AREA_DEMAND";
  }(EI || (EI = {})), function (e) {
    e[e.NO_FLAG_SET = 100] = "NO_FLAG_SET", e[e.FLAG_SET_BUT_EMPTY = 101] = "FLAG_SET_BUT_EMPTY", e[e.INVALID_FALG_SET = 102] = "INVALID_FALG_SET", e[e.FLAG_SET_BUT_NO_RE = 103] = "FLAG_SET_BUT_NO_RE", e[e.INVALID_SERVICE_ID = 104] = "INVALID_SERVICE_ID", e[e.NO_SERVICE_AVAILABLE = 200] = "NO_SERVICE_AVAILABLE", e[e.NO_SERVICE_AVAILABLE_P2P = 201] = "NO_SERVICE_AVAILABLE_P2P", e[e.NO_SERVICE_AVAILABLE_VOICE = 202] = "NO_SERVICE_AVAILABLE_VOICE", e[e.NO_SERVICE_AVAILABLE_WEBRTC = 203] = "NO_SERVICE_AVAILABLE_WEBRTC", e[e.NO_SERVICE_AVAILABLE_CDS = 204] = "NO_SERVICE_AVAILABLE_CDS", e[e.NO_SERVICE_AVAILABLE_CDN = 205] = "NO_SERVICE_AVAILABLE_CDN", e[e.NO_SERVICE_AVAILABLE_TDS = 206] = "NO_SERVICE_AVAILABLE_TDS", e[e.NO_SERVICE_AVAILABLE_REPORT = 207] = "NO_SERVICE_AVAILABLE_REPORT", e[e.NO_SERVICE_AVAILABLE_APP_CENTER = 208] = "NO_SERVICE_AVAILABLE_APP_CENTER", e[e.NO_SERVICE_AVAILABLE_ENV0 = 209] = "NO_SERVICE_AVAILABLE_ENV0", e[e.NO_SERVICE_AVAILABLE_VOET = 210] = "NO_SERVICE_AVAILABLE_VOET", e[e.NO_SERVICE_AVAILABLE_STRING_UID = 211] = "NO_SERVICE_AVAILABLE_STRING_UID", e[e.NO_SERVICE_AVAILABLE_WEBRTC_UNILBS = 212] = "NO_SERVICE_AVAILABLE_WEBRTC_UNILBS", e[e.NO_SERVICE_AVAILABLE_UNILBS_FLV = 213] = "NO_SERVICE_AVAILABLE_UNILBS_FLV";
  }(mI || (mI = {})), function (e) {
    e[e.K_TIMESTAMP_EXPIRED = 2] = "K_TIMESTAMP_EXPIRED", e[e.K_CHANNEL_PERMISSION_INVALID = 3] = "K_CHANNEL_PERMISSION_INVALID", e[e.K_CERTIFICATE_INVALID = 4] = "K_CERTIFICATE_INVALID", e[e.K_CHANNEL_NAME_EMPTY = 5] = "K_CHANNEL_NAME_EMPTY", e[e.K_CHANNEL_NOT_FOUND = 6] = "K_CHANNEL_NOT_FOUND", e[e.K_TICKET_INVALID = 7] = "K_TICKET_INVALID", e[e.K_CHANNEL_CONFLICTED = 8] = "K_CHANNEL_CONFLICTED", e[e.K_SERVICE_NOT_READY = 9] = "K_SERVICE_NOT_READY", e[e.K_SERVICE_TOO_HEAVY = 10] = "K_SERVICE_TOO_HEAVY", e[e.K_UID_BANNED = 14] = "K_UID_BANNED", e[e.K_IP_BANNED = 15] = "K_IP_BANNED", e[e.K_CHANNEL_BANNED = 16] = "K_CHANNEL_BANNED", e[e.K_AUTO_REBALANCE = 28] = "K_AUTO_REBALANCE", e[e.WARN_NO_AVAILABLE_CHANNEL = 103] = "WARN_NO_AVAILABLE_CHANNEL", e[e.WARN_LOOKUP_CHANNEL_TIMEOUT = 104] = "WARN_LOOKUP_CHANNEL_TIMEOUT", e[e.WARN_LOOKUP_CHANNEL_REJECTED = 105] = "WARN_LOOKUP_CHANNEL_REJECTED", e[e.WARN_OPEN_CHANNEL_TIMEOUT = 106] = "WARN_OPEN_CHANNEL_TIMEOUT", e[e.WARN_OPEN_CHANNEL_REJECTED = 107] = "WARN_OPEN_CHANNEL_REJECTED", e[e.WARN_REQUEST_DEFERRED = 108] = "WARN_REQUEST_DEFERRED", e[e.ERR_DYNAMIC_KEY_TIMEOUT = 109] = "ERR_DYNAMIC_KEY_TIMEOUT", e[e.ERR_NO_AUTHORIZED = 110] = "ERR_NO_AUTHORIZED", e[e.ERR_VOM_SERVICE_UNAVAILABLE = 111] = "ERR_VOM_SERVICE_UNAVAILABLE", e[e.ERR_NO_CHANNEL_AVAILABLE_CODE = 112] = "ERR_NO_CHANNEL_AVAILABLE_CODE", e[e.ERR_MASTER_VOCS_UNAVAILABLE = 114] = "ERR_MASTER_VOCS_UNAVAILABLE", e[e.ERR_INTERNAL_ERROR = 115] = "ERR_INTERNAL_ERROR", e[e.ERR_NO_ACTIVE_STATUS = 116] = "ERR_NO_ACTIVE_STATUS", e[e.ERR_INVALID_UID = 117] = "ERR_INVALID_UID", e[e.ERR_DYNAMIC_KEY_EXPIRED = 118] = "ERR_DYNAMIC_KEY_EXPIRED", e[e.ERR_STATIC_USE_DYANMIC_KE = 119] = "ERR_STATIC_USE_DYANMIC_KE", e[e.ERR_DYNAMIC_USE_STATIC_KE = 120] = "ERR_DYNAMIC_USE_STATIC_KE", e[e.ERR_NO_VOCS_AVAILABLE = 2e3] = "ERR_NO_VOCS_AVAILABLE", e[e.ERR_NO_VOS_AVAILABLE = 2001] = "ERR_NO_VOS_AVAILABLE", e[e.ERR_JOIN_CHANNEL_TIMEOUT = 2002] = "ERR_JOIN_CHANNEL_TIMEOUT", e[e.ERR_REPEAT_JOIN_CHANNEL = 2003] = "ERR_REPEAT_JOIN_CHANNEL", e[e.ERR_JOIN_BY_MULTI_IP = 2004] = "ERR_JOIN_BY_MULTI_IP", e[e.ERR_NOT_JOINED = 2011] = "ERR_NOT_JOINED", e[e.ERR_REPEAT_JOIN_REQUEST = 2012] = "ERR_REPEAT_JOIN_REQUEST", e[e.ERR_INVALID_VENDOR_KEY = 2013] = "ERR_INVALID_VENDOR_KEY", e[e.ERR_INVALID_CHANNEL_NAME = 2014] = "ERR_INVALID_CHANNEL_NAME", e[e.ERR_INVALID_STRINGUID = 2015] = "ERR_INVALID_STRINGUID", e[e.ERR_TOO_MANY_USERS = 2016] = "ERR_TOO_MANY_USERS", e[e.ERR_SET_CLIENT_ROLE_TIMEOUT = 2017] = "ERR_SET_CLIENT_ROLE_TIMEOUT", e[e.ERR_SET_CLIENT_ROLE_NO_PERMISSION = 2018] = "ERR_SET_CLIENT_ROLE_NO_PERMISSION", e[e.ERR_SET_CLIENT_ROLE_ALREADY_IN_USE = 2019] = "ERR_SET_CLIENT_ROLE_ALREADY_IN_USE", e[e.ERR_PUBLISH_REQUEST_INVALID = 2020] = "ERR_PUBLISH_REQUEST_INVALID", e[e.ERR_SUBSCRIBE_REQUEST_INVALID = 2021] = "ERR_SUBSCRIBE_REQUEST_INVALID", e[e.ERR_NOT_SUPPORTED_MESSAGE = 2022] = "ERR_NOT_SUPPORTED_MESSAGE", e[e.ERR_ILLEAGAL_PLUGIN = 2023] = "ERR_ILLEAGAL_PLUGIN", e[e.ERR_REJOIN_TOKEN_INVALID = 2024] = "ERR_REJOIN_TOKEN_INVALID", e[e.ERR_REJOIN_USER_NOT_JOINED = 2025] = "ERR_REJOIN_USER_NOT_JOINED", e[e.ERR_INVALID_OPTIONAL_INFO = 2027] = "ERR_INVALID_OPTIONAL_INFO", e[e.ILLEGAL_AES_PASSWORD = 2028] = "ILLEGAL_AES_PASSWORD", e[e.ILLEGAL_CLIENT_ROLE_LEVEL = 2029] = "ILLEGAL_CLIENT_ROLE_LEVEL", e[e.ERR_TOO_MANY_BROADCASTERS = 2031] = "ERR_TOO_MANY_BROADCASTERS", e[e.ERR_TOO_MANY_SUBSCRIBERS = 2032] = "ERR_TOO_MANY_SUBSCRIBERS", e[e.ERR_LICENSE_MISSING = 32769] = "ERR_LICENSE_MISSING", e[e.ERR_LICENSE_EXPIRED = 32771] = "ERR_LICENSE_EXPIRED", e[e.ERR_LICENSE_MINUTES_EXCEEDED = 32773] = "ERR_LICENSE_MINUTES_EXCEEDED", e[e.ERR_LICENSE_PERIOD_INVALID = 32774] = "ERR_LICENSE_PERIOD_INVALID", e[e.ERR_LICENSE_MULTIPLE_SDK_SERVICE = 32778] = "ERR_LICENSE_MULTIPLE_SDK_SERVICE", e[e.ERR_LICENSE_ILLEGAL = 32783] = "ERR_LICENSE_ILLEGAL", e[e.ERR_TEST_RECOVER = 9e3] = "ERR_TEST_RECOVER", e[e.ERR_TEST_TRYNEXT = 9001] = "ERR_TEST_TRYNEXT", e[e.ERR_TEST_RETRY = 9002] = "ERR_TEST_RETRY";
  }(fI || (fI = {})), function (e) {
    e.CONNECTING = "connecting", e.CONNECTED = "connected", e.RECONNECTING = "reconnecting", e.CLOSED = "closed";
  }(TI || (TI = {})), function (e) {
    e.WS_CONNECTED = "ws_connected", e.WS_RECONNECTING = "ws_reconnecting", e.WS_CLOSED = "ws_closed", e.WS_RECONNECT_WAITTING_FINISH = "ws_reconnect_waitting_finish", e.WS_RECONNECT_CREATE_CONNECTION = "ws_reconnect_create_connection", e.ON_BINARY_DATA = "on_binary_data", e.REQUEST_RECOVER = "request_recover", e.REQUEST_JOIN_INFO = "request_join_info", e.REQUEST_REJOIN_INFO = "req_rejoin_info", e.IS_P2P_DISCONNECTED = "is_p2p_dis", e.DISCONNECT_P2P = "dis_p2p", e.ABORT_P2P_EXECUTION = "abort_p2p_execution", e.NEED_RENEW_SESSION = "need-sid", e.REPORT_JOIN_GATEWAY = "report_join_gateway", e.REQUEST_TIMEOUT = "request_timeout", e.REQUEST_SUCCESS = "request_success", e.JOIN_RESPONSE = "join_response", e.DATACHANNEL_PRECONNECT = "datachannel_preconnect", e.DATACHANNEL_CONNECTING = "datachannel_connecting", e.DATACHANNEL_FAILBACK = "datachannel_failback", e.P2P_CONNECTION = "p2p_connection", e.P2P_REMOTE_CANDIDATE_UPDATE = "p2p_remote_candidate_update", e.P2P_SUBSCRIBE = "p2p_subscribe", e.P2P_UNSUBSCRIBE = "p2p_unsubscribe", e.P2P_EXCHANGE_SDP = "p2p_exchange_sdp", e.P2P_ON_ADD_VIDEO_STREAM = "p2p_on_add_video_stream", e.P2P_ON_ADD_AUDIO_STREAM = "p2p_on_add_audio_stream";
  }(gI || (gI = {})), function (e) {
    e.PING = "ping", e.PING_BACK = "ping_back", e.JOIN = "join_v3", e.REJOIN = "rejoin_v3", e.LEAVE = "leave", e.SET_CLIENT_ROLE = "set_client_role", e.PUBLISH = "publish", e.PUBLISH_DATASTREAM = "publish_datastream", e.UNPUBLISH = "unpublish", e.UNPUBLISH_DATASTREAM = "unpublish_datastream", e.SUBSCRIBE = "subscribe", e.PRE_SUBSCRIBE = "pre_subscribe", e.SUBSCRIBE_DATASTREAM = "subscribe_datastream", e.SUBSCRIBE_STREAMS = "subscribe_streams", e.UNSUBSCRIBE = "unsubscribe", e.UNSUBSCRIBE_DATASTREAM = "unsubscribe_datastream", e.UNSUBSCRIBE_STREAMS = "unsubscribe_streams", e.SUBSCRIBE_CHANGE = "subscribe_change", e.TRAFFIC_STATS = "traffic_stats", e.RENEW_TOKEN = "renew_token", e.SWITCH_VIDEO_STREAM = "switch_video_stream", e.DEFAULT_VIDEO_STREAM = "default_video_stream", e.SET_FALLBACK_OPTION = "set_fallback_option", e.GATEWAY_INFO = "gateway_info", e.CONTROL = "control", e.SEND_METADATA = "send_metadata", e.DATA_STREAM = "data_stream", e.PICK_SVC_LAYER = "pick_svc_layer", e.RESTART_ICE = "restart_ice", e.CONNECT_PC = "connect_pc", e.SET_VIDEO_PROFILE = "set_video_profile", e.SET_PARAMETER = "set_parameter", e.SET_RTM2_FLAG = "set_rtm2_flag";
  }(SI || (SI = {})), function (e) {
    e.WRTC_STATS = "wrtc_stats", e.WS_INFLATE_DATA_LENGTH = "ws_inflate_data_length", e.DENOISER_STATS = "denoiser_stats", e.EXTENSION_USAGE_STATS = "extension_usage_stats";
  }(RI || (RI = {})), function (e) {
    e.ON_USER_ONLINE = "on_user_online", e.ON_USER_OFFLINE = "on_user_offline", e.ON_STREAM_FALLBACK_UPDATE = "on_stream_fallback_update", e.ON_PUBLISH_STREAM = "on_publish_stream", e.ON_UPLINK_STATS = "on_uplink_stats", e.ON_P2P_LOST = "on_p2p_lost", e.ON_REMOVE_STREAM = "on_remove_stream", e.ON_ADD_AUDIO_STREAM = "on_add_audio_stream", e.ON_ADD_VIDEO_STREAM = "on_add_video_stream", e.ON_TOKEN_PRIVILEGE_WILL_EXPIRE = "on_token_privilege_will_expire", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "on_token_privilege_did_expire", e.ON_USER_BANNED = "on_user_banned", e.ON_USER_LICENSE_BANNED = "on_user_license_banned", e.ON_NOTIFICATION = "on_notification", e.ON_CRYPT_ERROR = "on_crypt_error", e.MUTE_AUDIO = "mute_audio", e.MUTE_VIDEO = "mute_video", e.UNMUTE_AUDIO = "unmute_audio", e.UNMUTE_VIDEO = "unmute_video", e.ON_P2P_OK = "on_p2p_ok", e.RECEIVE_METADATA = "receive_metadata", e.ON_DATA_STREAM = "on_data_stream", e.ON_RTP_CAPABILITY_CHANGE = "on_rtp_capability_change", e.ON_REMOTE_DATASTREAM_UPDATE = "on_remote_datastream_update", e.ON_REMOTE_FULL_DATASTREAM_INFO = "on_remote_full_datastream_info", e.ENABLE_LOCAL_VIDEO = "enable_local_video", e.DISABLE_LOCAL_VIDEO = "disable_local_video", e.ENABLE_LOCAL_AUDIO = "enable_local_audio", e.DISABLE_LOCAL_AUDIO = "disable_local_audio", e.ON_PUBLISHED_USER_LIST = "on_published_user_list";
  }(CI || (CI = {})), function (e) {
    e.CONNECTION_STATE_CHANGE = "CONNECTION_STATE_CHANGE", e.NEED_ANSWER = "NEED_ANSWER", e.NEED_RENEGOTIATE = "NEED_RENEGOTIATE", e.P2P_LOST = "P2P_LOST", e.GATEWAY_P2P_LOST = "GATEWAY_P2P_LOST", e.NEED_UNPUB = "NEED_UNPUB", e.NEED_UNSUB = "NEED_UNSUB", e.NEED_UPLOAD = "NEED_UPLOAD", e.NEED_CONTROL = "NEED_CONTROL", e.START_RECONNECT = "START_RECONNECT", e.END_RECONNECT = "END_RECONNECT", e.NEED_SIGNAL_RTT = "NEED_SIGNAL_RTT";
  }(II || (II = {})), function (e) {
    e.SEND_ONLY = "SEND_ONLY", e.RECEIVE_ONLY = "RECEIVE_ONLY";
  }(vI || (vI = {})), function (e) {
    e.CONNECTED = "websocket:connected", e.RECONNECTING = "websocket:reconnecting", e.WILL_RECONNECT = "websocket:will_reconnect", e.CLOSED = "websocket:closed", e.FAILED = "websocket:failed", e.ON_MESSAGE = "websocket:on_message", e.REQUEST_NEW_URLS = "websocket:request_new_urls", e.RECONNECT_WAITTING_FINISH = "websocket:reconnect_waitting_finish", e.RECONNECT_CREATE_CONNECTION = "websocket:reconnect_create_connection", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "websocket:on_token_privilege_did_expire";
  }(yI || (yI = {}));

  var VI = /*#__PURE__*/function (_VT) {
    _inherits(VI, _VT);

    var _super4 = _createSuper(VI);

    function VI(e) {
      var _this46;

      _classCallCheck(this, VI);

      _this46 = _super4.call(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", arguments.length > 2 ? arguments[2] : void 0), nh(_assertThisInitialized(_this46), "name", "AgoraRTCException");
      return _this46;
    }

    _createClass(VI, [{
      key: "print",
      value: function print() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "error";
        return _get(_getPrototypeOf(VI.prototype), "print", this).call(this, e, YC);
      }
    }, {
      key: "throw",
      value: function _throw() {
        _get(_getPrototypeOf(VI.prototype), "throw", this).call(this, YC);
      }
    }]);

    return VI;
  }(VT);

  function FI(e) {
    if ("string" != typeof e || !/^[a-zA-Z0-9 \!\#\$\%\&\(\)\+\-\:\;\<\=\.\>\?\@\[\]\^\_\{\}\|\~\,]{1,64}$/.test(e)) throw YC.error("Invalid Channel Name ".concat(e)), new VI(xT.INVALID_PARAMS, "The length must be within 64 bytes. The supported characters: a-z,A-Z,0-9,space,!, #, $, %, &, (, ), +, -, :, ;, <, =, ., >, ?, @, [, ], ^, _,  {, }, |, ~, ,");
  }

  function BI(e) {
    if (!(t = e, "number" == typeof t && Math.floor(t) === t && 0 <= t && t <= 4294967295 || YT(e, 1, 255))) throw new VI(xT.INVALID_PARAMS, "[String uid] Length of the string: [1,255]. ASCII characters only. [Number uid] The value range is [0,10000]");
    var t;
    "string" == typeof e && YC.warn("You input a string as the user ID, to ensure better end-user experience, Agora highly suggests not using a string as the user ID.");
  }

  !function (e) {
    e.TRANSCODE = "mix_streaming", e.RAW = "raw_streaming", e.INJECT = "inject_streaming";
  }(AI || (AI = {})), function (e) {
    e[e.INJECT_STREAM_STATUS_START_SUCCESS = 0] = "INJECT_STREAM_STATUS_START_SUCCESS", e[e.INJECT_STREAM_STATUS_START_ALREADY_EXISTS = 1] = "INJECT_STREAM_STATUS_START_ALREADY_EXISTS", e[e.INJECT_STREAM_STATUS_START_UNAUTHORIZED = 2] = "INJECT_STREAM_STATUS_START_UNAUTHORIZED", e[e.INJECT_STREAM_STATUS_START_TIMEOUT = 3] = "INJECT_STREAM_STATUS_START_TIMEOUT", e[e.INJECT_STREAM_STATUS_START_FAILED = 4] = "INJECT_STREAM_STATUS_START_FAILED", e[e.INJECT_STREAM_STATUS_STOP_SUCCESS = 5] = "INJECT_STREAM_STATUS_STOP_SUCCESS", e[e.INJECT_STREAM_STATUS_STOP_NOT_FOUND = 6] = "INJECT_STREAM_STATUS_STOP_NOT_FOUND", e[e.INJECT_STREAM_STATUS_STOP_UNAUTHORIZED = 7] = "INJECT_STREAM_STATUS_STOP_UNAUTHORIZED", e[e.INJECT_STREAM_STATUS_STOP_TIMEOUT = 8] = "INJECT_STREAM_STATUS_STOP_TIMEOUT", e[e.INJECT_STREAM_STATUS_STOP_FAILED = 9] = "INJECT_STREAM_STATUS_STOP_FAILED", e[e.INJECT_STREAM_STATUS_BROKEN = 10] = "INJECT_STREAM_STATUS_BROKEN";
  }(bI || (bI = {}));
  var jI = {
    alpha: 1,
    height: 640,
    width: 360,
    x: 0,
    y: 0,
    zOrder: 0,
    audioChannel: 0
  },
      GI = {
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    zOrder: 255,
    alpha: 1
  };

  function WI(e, t) {
    WT(e.url, "".concat(t, ".url"), 1, 1e3, !1), KT(e.x) || jT(e.x, "".concat(t, ".x"), 0, 1e4), KT(e.y) || jT(e.y, "".concat(t, ".y"), 0, 1e4), KT(e.width) || jT(e.width, "".concat(t, ".width"), 0, 1e4), KT(e.height) || jT(e.height, "".concat(t, ".height"), 0, 1e4), KT(e.zOrder) || jT(e.zOrder, "".concat(t, ".zOrder"), 0, 255), KT(e.alpha) || jT(e.alpha, "".concat(t, ".alpha"), 0, 1, !1);
  }

  var HI = {
    audioBitrate: 48,
    audioChannels: 1,
    audioSampleRate: 48e3,
    backgroundColor: 0,
    height: 360,
    lowLatency: !1,
    videoBitrate: 400,
    videoCodecProfile: 100,
    videoCodecType: 1,
    videoFrameRate: 15,
    videoGop: 30,
    width: 640,
    images: [],
    userConfigs: [],
    userConfigExtraInfo: ""
  },
      KI = {
    audioBitrate: 48,
    audioChannels: 2,
    audioVolume: 100,
    audioSampleRate: 48e3,
    height: 0,
    width: 0,
    videoBitrate: 400,
    videoFramerate: 15,
    videoGop: 30
  };
  var YI, qI, JI, zI, XI, QI, ZI, $I, ev, tv, iv, nv, sv, rv;

  function ov(e) {
    if (!e.channelName) throw new VI(xT.INVALID_PARAMS, "invalid channelName in info");
    if ("number" != typeof e.uid) throw new VI(xT.INVALID_PARAMS, "invalid uid in info, uid must be a number");
    return e.token && WT(e.token, "info.token", 1, 2047), BI(e.uid), FI(e.channelName), !0;
  }

  !function (e) {
    e.WARNING = "@live_uap-warning", e.ERROR = "@line_uap-error", e.PUBLISH_STREAM_STATUS = "@live_uap-publish-status", e.INJECT_STREAM_STATUS = "@live_uap-inject-status", e.WORKER_STATUS = "@live_uap-worker-status", e.REQUEST_NEW_ADDRESS = "@live_uap-request-address";
  }(YI || (YI = {})), function (e) {
    e.REQUEST_WORKER_MANAGER_LIST = "@live_req_worker_manager";
  }(qI || (qI = {})), function (e) {
    e[e.LIVE_STREAM_RESPONSE_SUCCEED = 200] = "LIVE_STREAM_RESPONSE_SUCCEED", e[e.LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM = 454] = "LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM", e[e.LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR = 450] = "LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR", e[e.LIVE_STREAM_RESPONSE_BAD_STREAM = 451] = "LIVE_STREAM_RESPONSE_BAD_STREAM", e[e.LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR = 400] = "LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR", e[e.LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST = 404] = "LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST", e[e.LIVE_STREAM_RESPONSE_NOT_AUTHORIZED = 456] = "LIVE_STREAM_RESPONSE_NOT_AUTHORIZED", e[e.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE = 457] = "LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE", e[e.LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN = 429] = "LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN", e[e.LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH = 452] = "LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH", e[e.LIVE_STREAM_RESPONSE_NOT_SUPPORTED = 453] = "LIVE_STREAM_RESPONSE_NOT_SUPPORTED", e[e.LIVE_STREAM_RESPONSE_MAX_STREAM_NUM = 455] = "LIVE_STREAM_RESPONSE_MAX_STREAM_NUM", e[e.LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR = 500] = "LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR", e[e.LIVE_STREAM_RESPONSE_WORKER_LOST = 501] = "LIVE_STREAM_RESPONSE_WORKER_LOST", e[e.LIVE_STREAM_RESPONSE_RESOURCE_LIMIT = 502] = "LIVE_STREAM_RESPONSE_RESOURCE_LIMIT", e[e.LIVE_STREAM_RESPONSE_WORKER_QUIT = 503] = "LIVE_STREAM_RESPONSE_WORKER_QUIT", e[e.ERROR_FAIL_SEND_MESSAGE = 504] = "ERROR_FAIL_SEND_MESSAGE", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE = 30] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT = 31] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH = 32] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH", e[e.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN = 33] = "PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN";
  }(JI || (JI = {})), function (e) {
    e.CONNECT_FAILED = "connect failed", e.CONNECT_TIMEOUT = "connect timeout", e.WS_DISCONNECTED = "websocket disconnected", e.REQUEST_TIMEOUT = "request timeout", e.REQUEST_FAILED = "request failed", e.WAIT_STATUS_TIMEOUT = "wait status timeout", e.WAIT_STATUS_ERROR = "wait status error", e.BAD_STATE = "bad state", e.WS_ABORT = "ws abort", e.AP_REQUEST_TIMEOUT = "AP request timeout", e.AP_JSON_PARSE_ERROR = "AP json parse error", e.AP_REQUEST_ERROR = "AP request error", e.AP_REQUEST_ABORT = "AP request abort";
  }(zI || (zI = {})), function (e) {
    e[e.SetSdkProfile = 0] = "SetSdkProfile", e[e.SetSourceChannel = 1] = "SetSourceChannel", e[e.SetSourceUserId = 2] = "SetSourceUserId", e[e.SetDestChannel = 3] = "SetDestChannel", e[e.StartPacketTransfer = 4] = "StartPacketTransfer", e[e.StopPacketTransfer = 5] = "StopPacketTransfer", e[e.UpdateDestChannel = 6] = "UpdateDestChannel", e[e.Reconnect = 7] = "Reconnect", e[e.SetVideoProfile = 8] = "SetVideoProfile";
  }(XI || (XI = {})), function (e) {
    e.NETWORK_DISCONNECTED = "NETWORK_DISCONNECTED", e.NETWORK_CONNECTED = "NETWORK_CONNECTED", e.PACKET_JOINED_SRC_CHANNEL = "PACKET_JOINED_SRC_CHANNEL", e.PACKET_JOINED_DEST_CHANNEL = "PACKET_JOINED_DEST_CHANNEL", e.PACKET_SENT_TO_DEST_CHANNEL = "PACKET_SENT_TO_DEST_CHANNEL", e.PACKET_RECEIVED_VIDEO_FROM_SRC = "PACKET_RECEIVED_VIDEO_FROM_SRC", e.PACKET_RECEIVED_AUDIO_FROM_SRC = "PACKET_RECEIVED_AUDIO_FROM_SRC", e.PACKET_UPDATE_DEST_CHANNEL = "PACKET_UPDATE_DEST_CHANNEL", e.PACKET_UPDATE_DEST_CHANNEL_REFUSED = "PACKET_UPDATE_DEST_CHANNEL_REFUSED", e.PACKET_UPDATE_DEST_CHANNEL_NOT_CHANGE = "PACKET_UPDATE_DEST_CHANNEL_NOT_CHANGE";
  }(QI || (QI = {})), function (e) {
    e.RELAY_STATE_IDLE = "RELAY_STATE_IDLE", e.RELAY_STATE_CONNECTING = "RELAY_STATE_CONNECTING", e.RELAY_STATE_RUNNING = "RELAY_STATE_RUNNING", e.RELAY_STATE_FAILURE = "RELAY_STATE_FAILURE";
  }(ZI || (ZI = {})), function (e) {
    e.RELAY_OK = "RELAY_OK", e.SERVER_CONNECTION_LOST = "SERVER_CONNECTION_LOST", e.SRC_TOKEN_EXPIRED = "SRC_TOKEN_EXPIRED", e.DEST_TOKEN_EXPIRED = "DEST_TOKEN_EXPIRED";
  }($I || ($I = {})), function (e) {
    e.High = "high", e.Low = "low", e.Audio = "audio", e.Screen = "screen", e.ScreenLow = "screen_low";
  }(ev || (ev = {})), function (e) {
    e.DISCONNECT = "disconnect", e.CONNECTION_STATE_CHANGE = "connection-state-change", e.NETWORK_QUALITY = "network-quality", e.STREAM_TYPE_CHANGE = "stream-type-change", e.IS_P2P_DISCONNECTED = "is-p2p-dis", e.DISCONNECT_P2P = "dis-p2p", e.REQUEST_NEW_GATEWAY_LIST = "req-gate-url", e.NEED_RENEW_SESSION = "need-sid", e.REQUEST_P2P_CONNECTION_PARAMS = "request-p2p-connection-params", e.JOIN_RESPONSE = "join-response", e.REQUEST_DC_CONNECTION_PARAMS = "request-dc-connection-params", e.RESET_CONNECTION_EVENTS = "reset-connection-events", e.DATACHANNEL_PRECONNECT = "datachannel_preconnect", e.DATACHANNEL_FAILBACK = "datachannel_failback", e.RESET_SIGNAL = "reset-signal";
  }(tv || (tv = {})), function (e) {
    e.P2P_DISCONNECTED = "P2P_DISCONNECTED", e.A_ROUND_WS_FAILED = "A_ROUND_WS_FAILED", e.TIMEOUT = "TIMEOUT", e.UNKNOWN_REASON = "UNKNOWN_REASON";
  }(iv || (iv = {})), function (e) {
    e[e.Nothing = 0] = "Nothing", e[e.Audio = 1] = "Audio", e[e.LwoVideo = 2] = "LwoVideo", e[e.Video = 4] = "Video", e[e.Data = 8] = "Data", e[e.DataStream0 = 256] = "DataStream0", e[e.DataStream1 = 512] = "DataStream1", e[e.DataStream2 = 1024] = "DataStream2", e[e.DataStream3 = 2048] = "DataStream3", e[e.DataStream4 = 4096] = "DataStream4", e[e.DataStream5 = 8192] = "DataStream5", e[e.DataStream6 = 16384] = "DataStream6", e[e.DataStream7 = 32768] = "DataStream7";
  }(nv || (nv = {})), function (e) {
    e[e.websocket = 0] = "websocket", e[e.datachannel = 1] = "datachannel";
  }(sv || (sv = {})), function (e) {
    e.CHINA = "CHINA", e.ASIA = "ASIA", e.NORTH_AMERICA = "NORTH_AMERICA", e.EUROPE = "EUROPE", e.JAPAN = "JAPAN", e.INDIA = "INDIA", e.KOREA = "KOREA", e.HKMC = "HKMC", e.US = "US", e.OCEANIA = "OCEANIA", e.SOUTH_AMERICA = "SOUTH_AMERICA", e.AFRICA = "AFRICA", e.OVERSEA = "OVERSEA", e.GLOBAL = "GLOBAL", e.EXTENSIONS = "EXTENSIONS";
  }(rv || (rv = {}));
  var av = [rv.AFRICA, rv.ASIA, rv.CHINA, rv.EUROPE, rv.GLOBAL, rv.INDIA, rv.JAPAN, rv.NORTH_AMERICA, rv.OCEANIA, rv.OVERSEA, rv.SOUTH_AMERICA];
  var cv;
  !function (e) {
    e.CHINA = "CN", e.ASIA = "AS", e.NORTH_AMERICA = "NA", e.EUROPE = "EU", e.JAPAN = "JP", e.INDIA = "IN", e.KOREA = "KR", e.HKMC = "HK", e.US = "US", e.OCEANIA = "OC", e.SOUTH_AMERICA = "SA", e.AFRICA = "AF", e.OVERSEA = "OVERSEA", e.GLOBAL = "GLOBAL", e.EXTENSIONS = "GLOBAL";
  }(cv || (cv = {}));
  var dv = {
    CHINA: {},
    ASIA: {
      CODE: cv.ASIA,
      WEBCS_DOMAIN: ["ap-web-1-asia.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-asia.agora.io"],
      PROXY_CS: ["proxy-ap-web-asia.agora.io"],
      CDS_AP: ["cds-ap-web-asia.agora.io", "cds-ap-web-asia2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-asia.agora.io", "sua-ap-web-asia2.agora.io"],
      UAP_AP: ["uap-ap-web-asia.agora.io", "uap-ap-web-asia2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-asia.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-asia.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-asia.agora.io"],
      PROXY_SERVER_TYPE3: ["southeast-asia.webrtc-cloud-proxy.sd-rtn.com"]
    },
    NORTH_AMERICA: {
      CODE: cv.NORTH_AMERICA,
      WEBCS_DOMAIN: ["ap-web-1-north-america.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-north-america.agora.io"],
      PROXY_CS: ["proxy-ap-web-america.agora.io"],
      CDS_AP: ["cds-ap-web-america.agora.io", "cds-ap-web-america2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-america.agora.io", "sua-ap-web-america2.agora.io"],
      UAP_AP: ["uap-ap-web-america.agora.io", "uap-ap-web-america2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-north-america.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-north-america.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-north-america.agora.io"],
      PROXY_SERVER_TYPE3: ["east-usa.webrtc-cloud-proxy.sd-rtn.com"]
    },
    EUROPE: {
      CODE: cv.EUROPE,
      WEBCS_DOMAIN: ["ap-web-1-europe.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-europe.agora.io"],
      PROXY_CS: ["proxy-ap-web-europe.agora.io"],
      CDS_AP: ["cds-ap-web-europe.agora.io", "cds-ap-web-europe2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-europe.agora.io", "sua-ap-web-europe.agora.io"],
      UAP_AP: ["uap-ap-web-europe.agora.io", "uap-ap-web-europe2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-europe.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-europe.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-europe.agora.io"],
      PROXY_SERVER_TYPE3: ["europe.webrtc-cloud-proxy.sd-rtn.com"]
    },
    JAPAN: {
      CODE: cv.JAPAN,
      WEBCS_DOMAIN: ["ap-web-1-japan.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-japan.agora.io"],
      PROXY_CS: ["proxy-ap-web-japan.agora.io"],
      CDS_AP: ["cds-ap-web-japan.agora.io", "cds-ap-web-japan2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-japan.agora.io", "sua-ap-web-japan2.agora.io"],
      UAP_AP: ["uap-ap-web-japan.agora.io", "uap-ap-web-japan2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-japan.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-japan.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-japan.agora.io"],
      PROXY_SERVER_TYPE3: ["japan.webrtc-cloud-proxy.sd-rtn.com"]
    },
    INDIA: {
      CODE: cv.INDIA,
      WEBCS_DOMAIN: ["ap-web-1-india.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-india.agora.io"],
      PROXY_CS: ["proxy-ap-web-india.agora.io"],
      CDS_AP: ["cds-ap-web-india.agora.io", "cds-ap-web-india2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-india.agora.io", "sua-ap-web-india2.agora.io"],
      UAP_AP: ["uap-ap-web-india.agora.io", "uap-ap-web-india2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-india.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-india.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-india.agora.io"],
      PROXY_SERVER_TYPE3: ["india.webrtc-cloud-proxy.sd-rtn.com"]
    },
    KOREA: {
      CODE: cv.KOREA,
      WEBCS_DOMAIN: ["ap-web-1-korea.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-korea.agora.io"],
      PROXY_CS: ["proxy-ap-web-korea.agora.io"],
      CDS_AP: ["cds-ap-web-korea.agora.io", "cds-ap-web-korea2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-korea.agora.io", "sua-ap-web-korea2.agora.io"],
      UAP_AP: ["uap-ap-web-korea.agora.io", "uap-ap-web-korea2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-korea.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-korea.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-korea.agora.io"],
      PROXY_SERVER_TYPE3: ["korea.webrtc-cloud-proxy.sd-rtn.com"]
    },
    HKMC: {
      CODE: cv.HKMC,
      WEBCS_DOMAIN: ["ap-web-1-hkmc.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-hkmc.agora.io"],
      PROXY_CS: ["proxy-ap-web-hkmc.agora.io"],
      CDS_AP: ["cds-ap-web-hkmc.agora.io", "cds-ap-web-hkmc2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-hkmc.agora.io", "sua-ap-web-hkmc2.agora.io"],
      UAP_AP: ["uap-ap-web-hkmc.agora.io", "uap-ap-web-hkmc2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-hkmc.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-hkmc.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-hkmc.agora.io"],
      PROXY_SERVER_TYPE3: ["hkmc.webrtc-cloud-proxy.sd-rtn.com"]
    },
    US: {
      CODE: cv.US,
      WEBCS_DOMAIN: ["ap-web-1-us.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-us.agora.io"],
      PROXY_CS: ["proxy-ap-web-us.agora.io"],
      CDS_AP: ["cds-ap-web-us.agora.io", "cds-ap-web-us2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-us.agora.io", "sua-ap-web-us2.agora.io"],
      UAP_AP: ["uap-ap-web-us.agora.io", "uap-ap-web-us2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-us.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-us.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-us.agora.io"],
      PROXY_SERVER_TYPE3: ["us.webrtc-cloud-proxy.sd-rtn.com"]
    },
    OVERSEA: {
      CODE: cv.OVERSEA,
      WEBCS_DOMAIN: ["ap-web-1-oversea.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-oversea.agora.io"],
      PROXY_CS: ["proxy-ap-web-oversea.agora.io"],
      CDS_AP: ["cds-ap-web-oversea.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-oversea.agora.io"],
      UAP_AP: ["uap-ap-web-oversea.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-oversea.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oversea.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-oversea.agora.io"],
      PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.agora.io"]
    },
    GLOBAL: {
      CODE: cv.GLOBAL,
      WEBCS_DOMAIN: ["webrtc2-ap-web-1.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-ap-web-3.agora.io"],
      PROXY_CS: ["ap-proxy-1.agora.io", "ap-proxy-2.agora.io"],
      CDS_AP: ["cds-ap-web-1.agora.io", "cds-ap-web-3.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-1.agora.io", "sua-ap-web-3.agora.io"],
      UAP_AP: ["uap-ap-web-1.agora.io", "uap-ap-web-3.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice.agora.io"],
      PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.sd-rtn.com"]
    },
    OCEANIA: {
      CODE: cv.OCEANIA,
      WEBCS_DOMAIN: ["ap-web-1-oceania.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-oceania.agora.io"],
      PROXY_CS: ["proxy-ap-web-oceania.agora.io"],
      CDS_AP: ["cds-ap-web-oceania.agora.io", "cds-ap-web-oceania2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-oceania.agora.io", "sua-ap-web-oceania2.agora.io"],
      UAP_AP: ["uap-ap-web-oceania.agora.io", "uap-ap-web-oceania2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-oceania.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oceania.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-oceania.agora.io"],
      PROXY_SERVER_TYPE3: ["oceania.webrtc-cloud-proxy.sd-rtn.com"]
    },
    SOUTH_AMERICA: {
      CODE: cv.SOUTH_AMERICA,
      WEBCS_DOMAIN: ["ap-web-1-south-america.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-south-america.agora.io"],
      PROXY_CS: ["proxy-ap-web-south-america.agora.io"],
      CDS_AP: ["cds-ap-web-south-america.agora.io", "cds-ap-web-south-america2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-south-america.agora.io", "sua-ap-web-south-america2.agora.io"],
      UAP_AP: ["uap-ap-web-south-america.agora.io", "uap-ap-web-south-america2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-south-america.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-south-america.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-south-america.agora.io"],
      PROXY_SERVER_TYPE3: ["south-america.webrtc-cloud-proxy.sd-rtn.com"]
    },
    AFRICA: {
      CODE: cv.AFRICA,
      WEBCS_DOMAIN: ["ap-web-1-africa.agora.io"],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-africa.agora.io"],
      PROXY_CS: ["proxy-ap-web-africa.agora.io"],
      CDS_AP: ["cds-ap-web-africa.agora.io", "cds-ap-web-africa2.agora.io"],
      ACCOUNT_REGISTER: ["sua-ap-web-africa.agora.io", "sua-ap-web-africa2.agora.io"],
      UAP_AP: ["uap-ap-web-africa.agora.io", "uap-ap-web-africa2.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-africa.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-africa.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-south-africa.agora.io"],
      PROXY_SERVER_TYPE3: ["africa.webrtc-cloud-proxy.sd-rtn.com"]
    },
    EXTENSIONS: {}
  };

  var lv, uv, hv, pv, _v, Ev, mv, fv, Tv, gv, Sv, Rv, Cv, Iv, vv, yv, Av, bv, wv, Ov, Nv, Dv, Pv, Lv;

  AC && (dv.CHINA = {
    CODE: cv.CHINA,
    WEBCS_DOMAIN: ["webrtc2-2.ap.sd-rtn.com"],
    WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-4.ap.sd-rtn.com"],
    PROXY_CS: ["proxy-web.ap.sd-rtn.com"],
    CDS_AP: ["cds-web-2.ap.sd-rtn.com", "cds-web-4.ap.sd-rtn.com"],
    ACCOUNT_REGISTER: ["sua-web-2.ap.sd-rtn.com", "sua-web-4.ap.sd-rtn.com"],
    UAP_AP: ["uap-web-2.ap.sd-rtn.com", "uap-web-4.ap.sd-rtn.com"],
    EVENT_REPORT_DOMAIN: ["web-3.statscollector.sd-rtn.com"],
    EVENT_REPORT_BACKUP_DOMAIN: ["web-4.statscollector.sd-rtn.com"],
    LOG_UPLOAD_SERVER: ["logservice-china.agora.io"],
    PROXY_SERVER_TYPE3: ["east-cn.webrtc-cloud-proxy.sd-rtn.com"]
  }), function (e) {
    e.UPDATE_BITRATE_LIMIT = "update_bitrate_limit";
  }(lv || (lv = {}));

  var kv = /*#__PURE__*/function (_ig3) {
    _inherits(kv, _ig3);

    var _super5 = _createSuper(kv);

    function kv(e, t) {
      var _this47;

      _classCallCheck(this, kv);

      _this47 = _super5.call(this), nh(_assertThisInitialized(_this47), "onICEConnectionStateChange", void 0), nh(_assertThisInitialized(_this47), "onConnectionStateChange", void 0), nh(_assertThisInitialized(_this47), "onDTLSTransportStateChange", void 0), nh(_assertThisInitialized(_this47), "onDTLSTransportError", void 0), nh(_assertThisInitialized(_this47), "onICETransportStateChange", void 0), nh(_assertThisInitialized(_this47), "onFirstAudioReceived", void 0), nh(_assertThisInitialized(_this47), "onFirstVideoReceived", void 0), nh(_assertThisInitialized(_this47), "onFirstAudioDecoded", void 0), nh(_assertThisInitialized(_this47), "onFirstVideoDecoded", void 0), nh(_assertThisInitialized(_this47), "onFirstVideoDecodedTimeout", void 0), nh(_assertThisInitialized(_this47), "onSelectedLocalCandidateChanged", void 0), nh(_assertThisInitialized(_this47), "onSelectedRemoteCandidateChanged", void 0);
      return _this47;
    }

    return _createClass(kv);
  }(ig);

  var Mv = /*#__PURE__*/function (_kv) {
    _inherits(Mv, _kv);

    var _super6 = _createSuper(Mv);

    function Mv(e, t) {
      _classCallCheck(this, Mv);

      return _super6.call(this, e, t);
    }

    return _createClass(Mv);
  }(kv);

  !function (e) {
    e.SEND = "sendonly", e.RECV = "recvonly", e.SENDRECV = "sendrecv", e.INACTIVE = "inactive";
  }(uv || (uv = {})), function (e) {
    e.VIDEO = "video", e.AUDIO = "audio";
  }(hv || (hv = {})), function (e) {
    e[e.UDP = 0] = "UDP", e[e.TCP = 1] = "TCP", e[e.RELAY = 2] = "RELAY";
  }(pv || (pv = {})), function (e) {
    e[e.FIRST_CONNECTION = 0] = "FIRST_CONNECTION", e[e.TCP_RESTART = 1] = "TCP_RESTART", e[e.RELAY_RESTART = 2] = "RELAY_RESTART", e[e.OLD_FIRST_CONNECTION = 10] = "OLD_FIRST_CONNECTION", e[e.OLD_RESTART = 11] = "OLD_RESTART", e[e.DISCONNECTED_OR_FAILED = 20] = "DISCONNECTED_OR_FAILED";
  }(_v || (_v = {})), function (e) {
    e.LocalVideoTrack = "videoTrack", e.LocalAudioTrack = "audioTrack", e.LocalVideoLowTrack = "videoLowTrack";
  }(Ev || (Ev = {})), function (e) {
    e.New = "new", e.Connected = "connected", e.Reconnecting = "reconnecting", e.Disconnected = "disconnected";
  }(mv || (mv = {})), function (e) {
    e.StateChange = "stateChange", e.IceConnectionStateChange = "iceConnectionStateChange", e.RequestMuteLocal = "requestMuteLocal", e.RequestUnmuteLocal = "requestUnmuteLocal", e.RequestRePublish = "requestRePublish", e.RequestRePublishDataChannel = "requestRePublishDataChannel", e.RequestReSubscribe = "requestReSubscribe", e.RequestUploadStats = "requestUploadStats", e.RequestUpload = "requestUpload", e.MediaReconnectStart = "MediaReconnectStart", e.MediaReconnectEnd = "MediaReconnectEnd", e.NeedSignalRTT = "NeedSignalRTT", e.RequestRestartICE = "RequestRestartIce", e.PeerConnectionStateChange = "PeerConnectionStateChange", e.RequestReconnect = "RequestReconnect", e.RequestReconnectPC = "RequestReconnectPC", e.RequestUnpublishForReconnectPC = "RequestUnpublishForReconnectPC", e.P2PLost = "P2PLost", e.UpdateVideoEncoder = "UpdateVideoEncoder", e.ConnectionTypeChange = "ConnectionTypeChange", e.RequestLowStreamParameter = "RequestLowStreamParameter", e.QueryClientConnectionState = "QueryClientConnectionState", e.LocalCandidate = "LocalCandidate", e.RequestP2PMuteLocal = "requestP2PMuteLocal", e.RequestP2PUnPublish = "RequestP2PUnPublish", e.RequestP2PUnmuteRemote = "RequestP2PUnmuteRemote", e.RequestP2PMuteRemote = "RequestP2PMuteRemote", e.RequestP2PRestartICE = "RequestP2PRestartICE";
  }(fv || (fv = {})), function (e) {
    e.MUTE_LOCAL_VIDEO = "mute_local_video", e.MUTE_LOCAL_AUDIO = "mute_local_audio", e.UNMUTE_LOCAL_VIDEO = "unmute_local_video", e.UNMUTE_LOCAL_AUDIO = "unmute_local_audio", e.MUTE_REMOTE_VIDEO = "mute_remote_video", e.MUTE_REMOTE_AUDIO = "mute_remote_audio", e.UNMUTE_REMOTE_VIDEO = "unmute_remote_video", e.UNMUTE_REMOTE_AUDIO = "unmute_remote_audio";
  }(Tv || (Tv = {})), function (e) {
    e.CONNECTING = "CONNECTING", e.RECONNECTING = "RECONNECTING", e.CONNECTED = "CONNECTED", e.CLOSED = "CLOSED";
  }(gv || (gv = {})), function (e) {
    e[e.CONNECT_AP = 0] = "CONNECT_AP", e[e.AP_CONNECTED = 1] = "AP_CONNECTED", e[e.CONNECT_WORKER_MANAGER = 2] = "CONNECT_WORKER_MANAGER", e[e.WORKER_MANAGER_CONNECTED = 3] = "WORKER_MANAGER_CONNECTED", e[e.GET_WORKER_MANAGER_RESPONSE = 4] = "GET_WORKER_MANAGER_RESPONSE", e[e.CONNECT_WORKER = 5] = "CONNECT_WORKER", e[e.WORKER_CONNECTED = 6] = "WORKER_CONNECTED", e[e.CLOSED = 7] = "CLOSED";
  }(Sv || (Sv = {})), function (e) {
    e.CONNECTION_STATE_CHANGE = "connection-state-change", e.STATE_CHANGE = "state-change", e.INSPECT_RESULT = "inspect-result", e.CLIENT_LOCAL_VIDEO_TRACK = "client-local-video-track", e.REQUEST_NEW_WORKER_URL = "request-new-worker-url";
  }(Rv || (Rv = {})), function (e) {
    e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.MULTI_IP = "MULTI_IP", e.TIMEOUT = "TIMEOUT", e.OFFLINE = "OFFLINE", e.LEAVE = "LEAVE", e.P2P_FAILED = "P2P_FAILED", e.FALLBACK = "FALLBACK";
  }(Cv || (Cv = {})), function (e) {
    e.CONNECTED = "transmitter:connected", e.RECONNECTING = "transmitter:reconnecting", e.WILL_RECONNECT = "transmitter:will_reconnect", e.CLOSED = "transmitter:closed", e.FAILED = "transmitter:failed", e.ON_MESSAGE = "transmitter:on_message", e.REQUEST_NEW_URLS = "transmitter:request_new_urls", e.RECONNECT_WAITTING_FINISH = "transmitter:reconnect_waitting_finish", e.RECONNECT_CREATE_CONNECTION = "transmitter:reconnect_create_connection", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "transmitter:on_token_privilege_did_expire", e.TO_CONNECT_DATACHANNEL = "transmitter:to_connect_datachannel", e.FAILBACK = "transmitter:failback";
  }(Iv || (Iv = {})), function (e) {
    e.CAMERA_CHANGED = "camera-changed", e.MICROPHONE_CHANGED = "microphone-changed", e.PLAYBACK_DEVICE_CHANGED = "playback-device-changed", e.AUDIO_AUTOPLAY_FAILED = "audio-autoplay-failed", e.AUTOPLAY_FAILED = "autoplay-failed", e.AUDIO_CONTEXT_STATE_CHANGED = "audio-context-state-changed", e.SECURITY_POLICY_VIOLATION = "security-policy-violation";
  }(vv || (vv = {})), function (e) {
    e[e.APP_TYPE_INVALID_VALUE = -1] = "APP_TYPE_INVALID_VALUE", e[e.APP_TYPE_NATIVE = 0] = "APP_TYPE_NATIVE", e[e.APP_TYPE_NATIVE_COCOS = 1] = "APP_TYPE_NATIVE_COCOS", e[e.APP_TYPE_NATIVE_UNITY = 2] = "APP_TYPE_NATIVE_UNITY", e[e.APP_TYPE_NATIVE_ELECTRON = 3] = "APP_TYPE_NATIVE_ELECTRON", e[e.APP_TYPE_NATIVE_FLUTTER = 4] = "APP_TYPE_NATIVE_FLUTTER", e[e.APP_TYPE_NATIVE_UNREAL = 5] = "APP_TYPE_NATIVE_UNREAL", e[e.APP_TYPE_NATIVE_XAMARIN = 6] = "APP_TYPE_NATIVE_XAMARIN", e[e.APP_TYPE_NATIVE_API_CLOUD = 7] = "APP_TYPE_NATIVE_API_CLOUD", e[e.APP_TYPE_NATIVE_REACT_NATIVE = 8] = "APP_TYPE_NATIVE_REACT_NATIVE", e[e.APP_TYPE_NATIVE_PYTHON = 9] = "APP_TYPE_NATIVE_PYTHON", e[e.APP_TYPE_NATIVE_COCOS_CREATOR = 10] = "APP_TYPE_NATIVE_COCOS_CREATOR", e[e.APP_TYPE_NATIVE_RUST = 11] = "APP_TYPE_NATIVE_RUST", e[e.APP_TYPE_NATIVE_C_SHARP = 12] = "APP_TYPE_NATIVE_C_SHARP", e[e.APP_TYPE_NATIVE_CEF = 13] = "APP_TYPE_NATIVE_CEF", e[e.APP_TYPE_NATIVE_UNI_APP = 14] = "APP_TYPE_NATIVE_UNI_APP", e[e.APP_TYPE_WEBRTC = 1e3] = "APP_TYPE_WEBRTC", e[e.APP_TYPE_WEBRTC_REACT = 1001] = "APP_TYPE_WEBRTC_REACT", e[e.APP_TYPE_WEBRTC_VUE = 1002] = "APP_TYPE_WEBRTC_VUE", e[e.APP_TYPE_WEBRTC_ANGULAR = 1003] = "APP_TYPE_WEBRTC_ANGULAR";
  }(yv || (yv = {})), function (e) {
    e.CONNECTING = "CONNECTING", e.RECONNECTING = "RECONNECTING", e.CONNECTED = "CONNECTED", e.CLOSED = "CLOSED";
  }(Av || (Av = {})), function (e) {
    e.CONNECTION_STATE_CHANGE = "connection-state-change", e.STATE_CHANGE = "state-change", e.INSPECT_RESULT = "inspect-result", e.CLIENT_LOCAL_VIDEO_TRACK = "client-local-video-track", e.REQUEST_NEW_WORKER_URL = "request-new-worker-url";
  }(bv || (bv = {})), function (e) {
    e[e.CONNECT_AP = 0] = "CONNECT_AP", e[e.AP_CONNECTED = 1] = "AP_CONNECTED", e[e.CONNECT_WORKER_MANAGER = 2] = "CONNECT_WORKER_MANAGER", e[e.WORKER_MANAGER_CONNECTED = 3] = "WORKER_MANAGER_CONNECTED", e[e.GET_WORKER_MANAGER_RESPONSE = 4] = "GET_WORKER_MANAGER_RESPONSE", e[e.CONNECT_WORKER = 5] = "CONNECT_WORKER", e[e.WORKER_CONNECTED = 6] = "WORKER_CONNECTED", e[e.CLOSED = 7] = "CLOSED";
  }(wv || (wv = {})), function (e) {
    e.CALL = "call", e.CANDIDATE = "candidate", e.PUBLISH = "publish", e.UNPUBLISH = "unpublish", e.CONTROL = "control", e.RESTART_ICE = "restart_ice", e.ACK = "ack", e.RESPONSE = "response", e.JOIN = "join", e.CHECK = "check";
  }(Ov || (Ov = {})), function (e) {
    e.ABORT = "abort";
  }(Nv || (Nv = {})), function (e) {
    e.MUTE_LOCAL_AUDIO = "mute_local_audio", e.MUTE_LOCAL_VIDEO = "mute_local_video", e.UNMUTE_LOCAL_AUDIO = "unmute_local_audio", e.UNMUTE_LOCAL_VIDEO = "unmute_local_video";
  }(Dv || (Dv = {})), function (e) {
    e[e.SUCCESS = 1] = "SUCCESS", e[e.FAILED = 0] = "FAILED";
  }(Pv || (Pv = {})), function (e) {
    e.P2P_TOKEN_TIMEOUT = "p2p_token_timeout", e.P2P_TOKEN_CHANGED = "p2p_token_changed";
  }(Lv || (Lv = {}));
  var Uv = (_Uv = {}, _defineProperty(_Uv, pI.ACCESS_POINT, (_pI$ACCESS_POINT = {}, _defineProperty(_pI$ACCESS_POINT, mI.NO_FLAG_SET, {
    desc: "flag is zero",
    retry: !1
  }), _defineProperty(_pI$ACCESS_POINT, mI.FLAG_SET_BUT_EMPTY, {
    desc: "flag is empty",
    retry: !1
  }), _defineProperty(_pI$ACCESS_POINT, mI.INVALID_FALG_SET, {
    desc: "invalid flag",
    retry: !1
  }), _defineProperty(_pI$ACCESS_POINT, mI.FLAG_SET_BUT_NO_RE, {
    desc: "flag set unilbs but no request",
    retry: !1
  }), _defineProperty(_pI$ACCESS_POINT, mI.INVALID_SERVICE_ID, {
    desc: "invalid service id",
    retry: !1
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE, {
    desc: "no service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_P2P, {
    desc: "no unilbs p2p service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_VOICE, {
    desc: "no unilbs voice service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_WEBRTC, {
    desc: "no unilbs webrtc service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_CDS, {
    desc: "no cds service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_CDN, {
    desc: "no cdn dispatcher service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_TDS, {
    desc: "no tds service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_REPORT, {
    desc: "no unilbs report service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_APP_CENTER, {
    desc: "no app center service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_ENV0, {
    desc: "no unilbs sig env0 service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_VOET, {
    desc: "no unilbs voet service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_STRING_UID, {
    desc: "no string uid service available",
    retry: !0
  }), _defineProperty(_pI$ACCESS_POINT, mI.NO_SERVICE_AVAILABLE_WEBRTC_UNILBS, {
    desc: "no webrtc unilbs service available",
    retry: !0
  }), _pI$ACCESS_POINT)), _defineProperty(_Uv, pI.UNILBS, (_pI$UNILBS = {}, _defineProperty(_pI$UNILBS, EI.INVALID_VENDOR_KEY, {
    desc: "invalid vendor key, can not find appid",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.INVALID_CHANNEL_NAME, {
    desc: "invalid channel name",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.INTERNAL_ERROR, {
    desc: "unilbs internal error",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.NO_AUTHORIZED, {
    desc: "invalid token, authorized failed",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.DYNAMIC_KEY_TIMEOUT, {
    desc: "dynamic key or token timeout",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.NO_ACTIVE_STATUS, {
    desc: "no active status",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.DYNAMIC_KEY_EXPIRED, {
    desc: "dynamic key expired",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.STATIC_USE_DYNAMIC_KEY, {
    desc: "static use dynamic key",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.DYNAMIC_USE_STATIC_KEY, {
    desc: "dynamic use static key",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.USER_OVERLOAD, {
    desc: "amount of users over load",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.FORBIDDEN_REGION, {
    desc: "the request is forbidden in this area",
    retry: !1
  }), _defineProperty(_pI$UNILBS, EI.CANNOT_MEET_AREA_DEMAND, {
    desc: "unable to allocate services in this area",
    retry: !1
  }), _pI$UNILBS)), _defineProperty(_Uv, pI.STRING_UID_ALLOCATOR, (_pI$STRING_UID_ALLOCA = {}, _defineProperty(_pI$STRING_UID_ALLOCA, _I.IIIEGAL_APPID, {
    desc: "invalid appid",
    retry: !1
  }), _defineProperty(_pI$STRING_UID_ALLOCA, _I.IIIEGAL_UID, {
    desc: "invalid string uid",
    retry: !1
  }), _defineProperty(_pI$STRING_UID_ALLOCA, _I.INTERNAL_ERROR, {
    desc: "string uid allocator internal error",
    retry: !0
  }), _pI$STRING_UID_ALLOCA)), _Uv);

  function xv(e) {
    var t = Uv[Math.floor(e / 1e4)];
    if (!t) return {
      desc: "unkonw error",
      retry: !1
    };
    var i = t[e % 1e4];

    if (!i) {
      if (Math.floor(e / 1e4) === pI.ACCESS_POINT) {
        var _t37 = e % 1e4;

        if ("1" === _t37.toString()[0]) return {
          desc: e.toString(),
          retry: !1
        };
        if ("2" === _t37.toString()[0]) return {
          desc: e.toString(),
          retry: !0
        };
      }

      return {
        desc: "unkonw error",
        retry: !1
      };
    }

    return i;
  }

  var Vv = (_Vv = {}, _defineProperty(_Vv, fI.K_TIMESTAMP_EXPIRED, {
    desc: "K_TIMESTAMP_EXPIRED",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_CHANNEL_PERMISSION_INVALID, {
    desc: "K_CHANNEL_PERMISSION_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_CERTIFICATE_INVALID, {
    desc: "K_CERTIFICATE_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_CHANNEL_NAME_EMPTY, {
    desc: "K_CHANNEL_NAME_EMPTY",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_CHANNEL_NOT_FOUND, {
    desc: "K_CHANNEL_NOT_FOUND",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_TICKET_INVALID, {
    desc: "K_TICKET_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_CHANNEL_CONFLICTED, {
    desc: "K_CHANNEL_CONFLICTED",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_SERVICE_NOT_READY, {
    desc: "K_SERVICE_NOT_READY",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.K_SERVICE_TOO_HEAVY, {
    desc: "K_SERVICE_TOO_HEAVY",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.K_UID_BANNED, {
    desc: "K_UID_BANNED",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_IP_BANNED, {
    desc: "K_IP_BANNED",
    action: "failed"
  }), _defineProperty(_Vv, fI.K_AUTO_REBALANCE, {
    desc: "k_AUTO_REBALANCE",
    action: "recover"
  }), _defineProperty(_Vv, fI.ERR_INVALID_VENDOR_KEY, {
    desc: "ERR_INVALID_VENDOR_KEY",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_INVALID_CHANNEL_NAME, {
    desc: "ERR_INVALID_CHANNEL_NAME",
    action: "failed"
  }), _defineProperty(_Vv, fI.WARN_NO_AVAILABLE_CHANNEL, {
    desc: "WARN_NO_AVAILABLE_CHANNEL",
    action: "failed"
  }), _defineProperty(_Vv, fI.WARN_LOOKUP_CHANNEL_TIMEOUT, {
    desc: "WARN_LOOKUP_CHANNEL_TIMEOUT",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.WARN_LOOKUP_CHANNEL_REJECTED, {
    desc: "WARN_LOOKUP_CHANNEL_REJECTED",
    action: "failed"
  }), _defineProperty(_Vv, fI.WARN_OPEN_CHANNEL_TIMEOUT, {
    desc: "WARN_OPEN_CHANNEL_TIMEOUT",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.WARN_OPEN_CHANNEL_REJECTED, {
    desc: "WARN_OPEN_CHANNEL_REJECTED",
    action: "failed"
  }), _defineProperty(_Vv, fI.WARN_REQUEST_DEFERRED, {
    desc: "WARN_REQUEST_DEFERRED",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_DYNAMIC_KEY_TIMEOUT, {
    desc: "ERR_DYNAMIC_KEY_TIMEOUT",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_NO_AUTHORIZED, {
    desc: "ERR_NO_AUTHORIZED",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_VOM_SERVICE_UNAVAILABLE, {
    desc: "ERR_VOM_SERVICE_UNAVAILABLE",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_NO_CHANNEL_AVAILABLE_CODE, {
    desc: "ERR_NO_CHANNEL_AVAILABLE_CODE",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_MASTER_VOCS_UNAVAILABLE, {
    desc: "ERR_MASTER_VOCS_UNAVAILABLE",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_INTERNAL_ERROR, {
    desc: "ERR_INTERNAL_ERROR",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_NO_ACTIVE_STATUS, {
    desc: "ERR_NO_ACTIVE_STATUS",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_INVALID_UID, {
    desc: "ERR_INVALID_UID",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_DYNAMIC_KEY_EXPIRED, {
    desc: "ERR_DYNAMIC_KEY_EXPIRED",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_STATIC_USE_DYANMIC_KE, {
    desc: "ERR_STATIC_USE_DYANMIC_KE",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_DYNAMIC_USE_STATIC_KE, {
    desc: "ERR_DYNAMIC_USE_STATIC_KE",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_NO_VOCS_AVAILABLE, {
    desc: "ERR_NO_VOCS_AVAILABLE",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_NO_VOS_AVAILABLE, {
    desc: "ERR_NO_VOS_AVAILABLE",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_JOIN_CHANNEL_TIMEOUT, {
    desc: "ERR_JOIN_CHANNEL_TIMEOUT",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_JOIN_BY_MULTI_IP, {
    desc: "ERR_JOIN_BY_MULTI_IP",
    action: "recover"
  }), _defineProperty(_Vv, fI.ERR_NOT_JOINED, {
    desc: "ERR_NOT_JOINED",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_REPEAT_JOIN_REQUEST, {
    desc: "ERR_REPEAT_JOIN_REQUEST",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_REPEAT_JOIN_CHANNEL, {
    desc: "ERR_REPEAT_JOIN_CHANNEL",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_INVALID_STRINGUID, {
    desc: "ERR_INVALID_STRINGUID",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_TOO_MANY_USERS, {
    desc: "ERR_TOO_MANY_USERS",
    action: "tryNext"
  }), _defineProperty(_Vv, fI.ERR_SET_CLIENT_ROLE_TIMEOUT, {
    desc: "ERR_SET_CLIENT_ROLE_TIMEOUT",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_SET_CLIENT_ROLE_NO_PERMISSION, {
    desc: "ERR_SET_CLIENT_ROLE_TIMEOUT",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_SET_CLIENT_ROLE_ALREADY_IN_USE, {
    desc: "ERR_SET_CLIENT_ROLE_ALREADY_IN_USE",
    action: "success"
  }), _defineProperty(_Vv, fI.ERR_PUBLISH_REQUEST_INVALID, {
    desc: "ERR_PUBLISH_REQUEST_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_SUBSCRIBE_REQUEST_INVALID, {
    desc: "ERR_SUBSCRIBE_REQUEST_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_NOT_SUPPORTED_MESSAGE, {
    desc: "ERR_NOT_SUPPORTED_MESSAGE",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_ILLEAGAL_PLUGIN, {
    desc: "ERR_ILLEAGAL_PLUGIN",
    action: "failed"
  }), _defineProperty(_Vv, fI.ILLEGAL_CLIENT_ROLE_LEVEL, {
    desc: "ILLEGAL_CLIENT_ROLE_LEVEL",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_REJOIN_TOKEN_INVALID, {
    desc: "ERR_REJOIN_TOKEN_INVALID",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_REJOIN_USER_NOT_JOINED, {
    desc: "ERR_REJOIN_NOT_JOINED",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_INVALID_OPTIONAL_INFO, {
    desc: "ERR_INVALID_OPTIONAL_INFO",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_TEST_RECOVER, {
    desc: "ERR_TEST_RECOVER",
    action: "recover"
  }), _defineProperty(_Vv, fI.ERR_TEST_TRYNEXT, {
    desc: "ERR_TEST_TRYNEXT",
    action: "recover"
  }), _defineProperty(_Vv, fI.ERR_TEST_RETRY, {
    desc: "ERR_TEST_RETRY",
    action: "recover"
  }), _defineProperty(_Vv, fI.ILLEGAL_AES_PASSWORD, {
    desc: "ERR_TEST_RETRY",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_TOO_MANY_BROADCASTERS, {
    desc: "ERR_TOO_MANY_BROADCASTERS",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_TOO_MANY_SUBSCRIBERS, {
    desc: "ERR_TOO_MANY_SUBSCRIBERS",
    action: "failed"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_ILLEGAL, {
    desc: "ERR_LICENSE_ILLEGAL",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_MISSING, {
    desc: "ERR_LICENSE_MISSING",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_EXPIRED, {
    desc: "ERR_LICENSE_EXPIRED",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_MINUTES_EXCEEDED, {
    desc: "ERR_LICENSE_MINUTES_EXCEEDED",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_PERIOD_INVALID, {
    desc: "ERR_LICENSE_PERIOD_INVALID",
    action: "quit"
  }), _defineProperty(_Vv, fI.ERR_LICENSE_MULTIPLE_SDK_SERVICE, {
    desc: "ERR_LICENSE_MULTIPLE_SDK_SERVICE",
    action: "quit"
  }), _Vv);

  function Fv(e) {
    var t = Vv[e];
    return t || {
      desc: "UNKNOW_ERROR_".concat(e),
      action: "failed"
    };
  }

  function Bv(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function jv(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Bv(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Bv(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function Gv(e) {
    return e.every(function (e) {
      return e.readyState === WebSocket.CLOSED || e.readyState === WebSocket.CLOSING;
    });
  }

  function Wv(e, t) {
    if ("string" == typeof e) return e;
    var i = e.proxy,
        n = e.host,
        s = e.port;

    if (t) {
      var _e28 = DC("JOIN_GATEWAY_FALLBACK_PORT") || 443;

      return 443 === _e28 ? "wss://".concat(n, "/ws/?p=").concat(Number(s) + 150) : "wss://".concat(n, ":").concat(_e28, "/ws/?p=").concat(Number(s) + 150);
    }

    return i ? "wss://".concat(i, "/ws/?h=").concat(n, "&p=").concat(s) : "wss://".concat(n, ":").concat(s);
  }

  var Hv = /wss:\/\/(.+)\/ws\/\?h=(.+)&p=([0-9]+)\/?/,
      Kv = /wss:\/\/(.+)\/ws\/\?p=([0-9]+)\/?/,
      Yv = /wss:\/\/(.+):([0-9]+)\/?/,
      qv = /wss:\/\/(.[^\/]+)\/?/;
  var Jv = 0;

  var zv = /*#__PURE__*/function () {
    function zv(e, t) {
      _classCallCheck(this, zv);

      nh(this, "id", 0), nh(this, "store", void 0), nh(this, "recordIndex", void 0), nh(this, "websockets", []), nh(this, "try443PortDuration", 2e3), nh(this, "forceCloseWSDuration", 5e3), nh(this, "try443PortTimeout", null), nh(this, "forceCloseTimeout", null), nh(this, "isTry443PortFailed", !1), nh(this, "isNormalPortFailed", !1), nh(this, "useDoubleDomain", !1), nh(this, "useProxy", !1), nh(this, "startTime", Date.now()), this.id = ++Jv, this.try443PortDuration = DC("JOIN_GATEWAY_TRY_443PORT_DURATION") || 2e3, this.forceCloseWSDuration = e || 5e3, this.store = t;
    }

    _createClass(zv, [{
      key: "closeAllWebsockets",
      value: function closeAllWebsockets() {
        this.websockets.forEach(function (e) {
          e.onopen = null, e.onclose = null, e.onmessage = null, e.close();
        }), this.websockets.length = 0;
      }
    }, {
      key: "clearTimeout",
      value: function (_clearTimeout) {
        function clearTimeout() {
          return _clearTimeout.apply(this, arguments);
        }

        clearTimeout.toString = function () {
          return _clearTimeout.toString();
        };

        return clearTimeout;
      }(function () {
        this.forceCloseTimeout && clearTimeout(this.forceCloseTimeout), this.try443PortTimeout && clearTimeout(this.try443PortTimeout);
      })
    }, {
      key: "logger",
      value: function logger() {
        var e;
        var t = Date.now() - this.startTime;

        for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++) {
          n[s] = arguments[s];
        }

        YC.debug.apply(YC, ["[choose-best-ws ".concat(null === (e = this.store) || void 0 === e ? void 0 : e.clientId, " ").concat(this.id, "] ").concat(t, "ms:")].concat(n));
      }
    }, {
      key: "createWebSocket",
      value: function createWebSocket(e, t, i) {
        var _this48 = this,
            _this$websockets;

        this.logger("createWebSocket:", e, {
          isTry443Port: t,
          hasTimeoutDetection: i
        });
        var n = DC("GATEWAY_DOMAINS"),
            s = Date.now(),
            r = [],
            o = n.find(function (t) {
          var i;
          return bn(i = e.host).call(i, t);
        });
        o || (this.useDoubleDomain = !1);
        var a = [];
        if (this.useDoubleDomain) n.forEach(function (i) {
          a.push(Wv(jv(jv({}, e), {}, {
            host: e.host.replace(o, i)
          }), t));
        });else {
          var _i33 = jv({}, e);

          if (t && o) {
            var _e29 = n.find(function (e) {
              return e !== o;
            });

            _e29 && (_i33.host = _i33.host.replace(o, _e29));
          }

          a.push(Wv(_i33, t));
        }

        try {
          a.forEach(function (e) {
            var t = new WebSocket(e);
            t.binaryType = "arraybuffer", r.push(t), _this48.logger("ws is connecting:", t.url);
          });
        } catch (n) {
          if (this.logger("ws create failed"), r.forEach(function (e) {
            return e.close();
          }), r.length = 0, this.useDoubleDomain) return this.useDoubleDomain = !1, this.createWebSocket(e, t, i);
          if (!t && 443 !== Number(e.port)) return this.createWebSocket(e, !0, i);
          throw new VI(xT.WS_ERR, "init websocket failed! Error: ".concat(n.toString()));
        }

        var c = nT();
        this.store && this.store.recordJoinChannelService({
          urls: r.map(function (e) {
            return e.url;
          }),
          service: "gateway"
        }, this.recordIndex), r.forEach(function (e) {
          e.onopen = function () {
            _this48.logger("onopen: ws ".concat(e.url, " open cost ").concat(Date.now() - s, "ms")), _this48.websockets.forEach(function (t) {
              t !== e && (t.onopen = null, t.onclose = null, t.onmessage = null, t.close(), _this48.logger("close backup websocket: ".concat(t.url)));
            }), _this48.websockets.length = 0, c.resolve(e);
          }, e.onclose = function (i) {
            _this48.logger("onclose: ws ".concat(e.url, " closed cost ").concat(Date.now() - s, "ms state: ").concat(e.readyState)), t ? _this48.isTry443PortFailed = Gv(r) : _this48.isNormalPortFailed = Gv(r), _this48.logger("443: ".concat(_this48.useProxy ? "not try" : _this48.isTry443PortFailed ? "failed" : "trying", " 47xx: ").concat(_this48.isNormalPortFailed ? "failed" : "trying")), (t && _this48.isTry443PortFailed || !t && (_this48.isTry443PortFailed || _this48.useProxy) && _this48.isNormalPortFailed) && (_this48.logger("onclose: all websocket is closed, ".concat(i.reason)), c.reject({
              code: i.code,
              reason: iv.A_ROUND_WS_FAILED
            }));
          }, e.onmessage = function (t) {
            return _this48.logger("".concat(e.url, " onmessage: ").concat(t.data));
          };
        }), (_this$websockets = this.websockets).push.apply(_this$websockets, r);
        return i || function () {
          var i = function i() {
            _this48.logger("5s timeout close un-opens, isWebsocket created: ", c.isResolved), _this48.websockets.forEach(function (e) {
              return e.readyState !== WebSocket.OPEN && e.close();
            });
          };

          if (t || _this48.useProxy) return _this48.logger("add 5s timeout at ".concat(t ? "try-443" : "proxy", " condition")), _this48.forceCloseTimeout = window.setTimeout(i, _this48.forceCloseWSDuration);
          _this48.try443PortTimeout = window.setTimeout(function () {
            if (_this48.logger("2s timeout, isWebsocket created: ", c.isResolved), c.isResolved) return i();
            pT().os === aT.MAC_OS && RT() && i(), _this48.createWebSocket(e, !0, !0).then(function (e) {
              return c.resolve(e);
            }).catch(function (e) {
              _this48.isNormalPortFailed && c.reject(e), _this48.logger("try 443 port to create ws failed");
            }), _this48.forceCloseTimeout = window.setTimeout(i, _this48.forceCloseWSDuration);
          }, _this48.try443PortDuration);
        }(), c.promise;
      }
    }, {
      key: "chooseBestWebsocket",
      value: function chooseBestWebsocket(e, t, i, n) {
        var _this49 = this;

        return this.useDoubleDomain = !!t, "string" == typeof e && (e = function (e) {
          var _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16;

          var t, i, n;
          return (_ref9 = e.match(Hv) || [], _ref10 = _slicedToArray(_ref9, 4), t = _ref10[1], i = _ref10[2], n = _ref10[3], _ref9), t || (_ref11 = e.match(Kv) || [], _ref12 = _slicedToArray(_ref11, 3), i = _ref12[1], n = _ref12[2], _ref11), i && n || (_ref13 = e.match(Yv) || [], _ref14 = _slicedToArray(_ref13, 3), i = _ref14[1], n = _ref14[2], _ref13), i && n || (_ref15 = e.match(qv) || [], _ref16 = _slicedToArray(_ref15, 2), i = _ref16[1], _ref15), i || YC.warning("un-destructible url: ", e), {
            proxy: t,
            host: i,
            port: n || "443"
          };
        }(e)), this.recordIndex = n, this.useProxy = !!e.proxy, i && this.useProxy && (YC.warn("cannot use 443 only when use proxy"), i = !1), this.createWebSocket(e, !!i, !1).finally(function () {
          return _this49.clearTimeout();
        });
      }
    }]);

    return zv;
  }();

  function Xv(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  var Qv = /*#__PURE__*/function (_ig4) {
    _inherits(Qv, _ig4);

    var _super7 = _createSuper(Qv);

    function Qv(e, t) {
      var _this50;

      _classCallCheck(this, Qv);

      var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          r = arguments.length > 5 ? arguments[5] : void 0;
      _this50 = _super7.call(this), nh(_assertThisInitialized(_this50), "connectionID", 0), nh(_assertThisInitialized(_this50), "currentURLIndex", 0), nh(_assertThisInitialized(_this50), "urls", []), nh(_assertThisInitialized(_this50), "_reconnectMode", "tryNext"), nh(_assertThisInitialized(_this50), "reconnectReason", void 0), nh(_assertThisInitialized(_this50), "_initMutex", new Yg("websocket")), nh(_assertThisInitialized(_this50), "name", void 0), nh(_assertThisInitialized(_this50), "_state", "closed"), nh(_assertThisInitialized(_this50), "reconnectInterrupter", void 0), nh(_assertThisInitialized(_this50), "websocket", void 0), nh(_assertThisInitialized(_this50), "retryConfig", void 0), nh(_assertThisInitialized(_this50), "reconnectCount", 0), nh(_assertThisInitialized(_this50), "forceCloseTimeout", 5e3), nh(_assertThisInitialized(_this50), "onlineReconnectListener", void 0), nh(_assertThisInitialized(_this50), "useCompress", void 0), nh(_assertThisInitialized(_this50), "tryDoubleDomain", !1), nh(_assertThisInitialized(_this50), "use443PortOnly", !1), nh(_assertThisInitialized(_this50), "wsInflateLength", 0), nh(_assertThisInitialized(_this50), "wsDeflateLength", 0), nh(_assertThisInitialized(_this50), "closeEstablishingWs", function () {}), nh(_assertThisInitialized(_this50), "store", void 0), nh(_assertThisInitialized(_this50), "joinGatewayRecordIndex", void 0), _this50.store = r, _this50.name = e, _this50.retryConfig = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Xv(Object(i), !0).forEach(function (t) {
            nh(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Xv(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }

        return e;
      }({}, t), _this50.useCompress = i, _this50.tryDoubleDomain = n, _this50.use443PortOnly = s;
      var o = t.timeout,
          a = t.timeoutFactor,
          c = Math.max(300, Math.floor(3 * o / 5)),
          d = Math.max(1.2, Math.floor(8 * a) / 10);
      ug.ONLINE && (_this50.retryConfig.timeout = c, _this50.retryConfig.timeoutFactor = d), Rg.on(hg.NETWORK_STATE_CHANGE, function (e, t) {
        e !== t && (_this50.resetReconnectCount("network state change: ".concat(t, " -> ").concat(e)), e === ug.ONLINE ? (_this50.retryConfig.timeout = c, _this50.retryConfig.timeoutFactor = d) : (_this50.retryConfig.timeout = o, _this50.retryConfig.timeoutFactor = a));
      });
      return _this50;
    }

    _createClass(Qv, [{
      key: "url",
      get: function get() {
        return this.websocket && this.websocket.url || null;
      }
    }, {
      key: "reconnectMode",
      get: function get() {
        return this._reconnectMode;
      },
      set: function set(e) {
        var t;
        bn(t = ["tryNext", "recover"]).call(t, e) && this.resetReconnectCount(e), this._reconnectMode = e;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        e !== this._state && (this._state = e, "reconnecting" === this._state ? this.emit(yI.RECONNECTING, this.reconnectReason) : "connected" === this._state ? this.emit(yI.CONNECTED) : "closed" === this._state ? this.emit(yI.CLOSED) : "failed" === this._state && this.emit(yI.FAILED));
      }
    }, {
      key: "resetReconnectCount",
      value: function resetReconnectCount(e) {
        YC.debug("websocket reset reconnect count, reason: " + e), this.reconnectCount = 0;
      }
    }, {
      key: "getConnection",
      value: function getConnection() {
        return this.websocket || void 0;
      }
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
          var t,
              i,
              _e30,
              _t38,
              _args12 = arguments;

          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = _args12.length > 1 && void 0 !== _args12[1] ? _args12[1] : 5e3;
                  _context12.next = 3;
                  return this._initMutex.lock();

                case 3:
                  i = _context12.sent;
                  this.forceCloseTimeout = t, this.urls = e, this.state = "connecting";
                  _context12.prev = 5;
                  _e30 = nT(), _t38 = this.urls[this.currentURLIndex];
                  this.createWebSocketConnection(_t38).then(_e30.resolve).catch(_e30.reject);
                  this.once(yI.CLOSED, function () {
                    _e30.reject(new VT(xT.WS_DISCONNECT));
                  });
                  this.once(yI.CONNECTED, _e30.resolve);
                  _context12.next = 12;
                  return _e30.promise;

                case 12:
                  _context12.next = 16;
                  break;

                case 14:
                  _context12.prev = 14;
                  _context12.t0 = _context12["catch"](5);

                case 16:
                  _context12.prev = 16;
                  i();
                  return _context12.finish(16);

                case 19:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this, [[5, 14, 16, 19]]);
        }));

        function init(_x12) {
          return _init.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "close",
      value: function close(e, t) {
        if (this.currentURLIndex = 0, this.resetReconnectCount("close"), this.reconnectInterrupter && this.reconnectInterrupter(), this.websocket) {
          this.websocket.onclose = null, this.websocket.onopen = null, this.websocket.onmessage = null;
          var _e31 = this.websocket;
          t ? setTimeout(function () {
            return _e31.close();
          }, 500) : _e31.close(), this.websocket = void 0;
        }

        this.state = e ? "failed" : "closed", this.closeEstablishingWs && this.closeEstablishingWs();
      }
    }, {
      key: "reconnect",
      value: function reconnect(e, t) {
        if (!this.websocket) return void YC.warning("[".concat(this.name, "] can not reconnect, no websocket"));
        void 0 !== e && (this.reconnectMode = e), YC.debug("[".concat(this.name, "] reconnect is triggered initiative")), "number" == typeof this.joinGatewayRecordIndex && this.store && this.store.recordJoinChannelService({
          status: "error",
          errors: [new Error(t)]
        }, this.joinGatewayRecordIndex);
        var i = this.websocket.onclose;
        this.websocket.onclose = null, this.websocket.close(), i && i.bind(this.websocket)({
          code: 9999,
          reason: t
        });
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(e) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) throw new VT(xT.WS_ABORT, "websocket is not ready");

        try {
          t || (e = JSON.stringify(e)), this.websocket.send(e);
        } catch (e) {
          throw new VT(xT.WS_ERR, "send websocket message error" + e.toString());
        }
      }
    }, {
      key: "setWsInflateData",
      value: function setWsInflateData(e) {
        this.wsDeflateLength = this.wsDeflateLength + e.originLength, this.wsInflateLength = this.wsInflateLength + e.compressedLength;
      }
    }, {
      key: "getWsInflateData",
      value: function getWsInflateData() {
        var e = this.wsInflateLength,
            t = this.wsDeflateLength;
        return this.clearWsInflateData(), {
          wsInflateLength: e,
          wsDeflateLength: t
        };
      }
    }, {
      key: "clearWsInflateData",
      value: function clearWsInflateData() {
        this.wsInflateLength = 0, this.wsDeflateLength = 0;
      }
    }, {
      key: "createWebSocketConnection",
      value: function () {
        var _createWebSocketConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
          var _this51 = this;

          var t, i, n, s, r, o, a, c, _t40, _t41, _n21, _r6, _o6, _c5;

          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  i = nT();
                  this.connectionID += 1, this.joinGatewayRecordIndex = void 0;
                  n = function n(e) {
                    var t;
                    null === (t = _this51.store) || void 0 === t || t.signalChannelOpen(), YC.debug("[".concat(_this51.name, "] websocket opened:"), e), _this51.reconnectMode = "retry", _this51.state = "connected", _this51.resetReconnectCount("opened"), i.resolve();
                  }, s = /*#__PURE__*/function () {
                    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e) {
                      var t, _t39, _n20;

                      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                        while (1) {
                          switch (_context13.prev = _context13.next) {
                            case 0:
                              if (!(YC.debug("[".concat(_this51.name, "] websocket close ").concat(null === (t = _this51.websocket) || void 0 === t ? void 0 : t.url, ", code: ").concat(e.code, ", reason: ").concat(e.reason, ", current mode: ").concat(_this51.reconnectMode)), _this51.reconnectCount >= _this51.retryConfig.maxRetryCount)) {
                                _context13.next = 4;
                                break;
                              }

                              i.reject(new VT(xT.WS_DISCONNECT, "websocket close: ".concat(e.code))), _this51.close();
                              _context13.next = 14;
                              break;

                            case 4:
                              "connected" === _this51.state && (_this51.reconnectReason = e.reason, _this51.state = "reconnecting");
                              _t39 = gg(_this51, yI.WILL_RECONNECT, _this51.reconnectMode, e.reason) || _this51.reconnectMode;
                              _context13.next = 8;
                              return _this51.reconnectWithAction(_t39);

                            case 8:
                              _n20 = _context13.sent;

                              if (!("closed" === _this51.state)) {
                                _context13.next = 11;
                                break;
                              }

                              return _context13.abrupt("return", void YC.debug("[".concat(_this51.connectionID, "] ws is closed, no need to reconnect")));

                            case 11:
                              if (_n20) {
                                _context13.next = 13;
                                break;
                              }

                              return _context13.abrupt("return", (i.reject(new VT(xT.WS_DISCONNECT, "websocket reconnect failed: ".concat(e.code))), _this51.close(!0)));

                            case 13:
                              i.resolve();

                            case 14:
                            case "end":
                              return _context13.stop();
                          }
                        }
                      }, _callee13);
                    }));

                    return function s(_x14) {
                      return _ref17.apply(this, arguments);
                    };
                  }(), r = function r(e) {
                    _this51.emit(yI.ON_MESSAGE, e);
                  }, o = function o(e) {
                    YC.warn("[".concat(_this51.connectionID, "] ws open error ").concat(e));
                  };
                  this.websocket && (this.websocket.onclose = null, this.websocket.close()), DC("GATEWAY_WSS_ADDRESS") && this.name.startsWith("gateway") && (e = DC("GATEWAY_WSS_ADDRESS")), YC.debug("[".concat(this.name, "] start connect, url:"), e);
                  a = null === (t = this.store) || void 0 === t ? void 0 : t.recordJoinChannelService({
                    startTs: Date.now(),
                    status: "pending",
                    service: "gateway"
                  });
                  _context14.prev = 5;
                  _context14.next = 8;
                  return this.chooseBestWebsocketConnection(e);

                case 8:
                  _t40 = _context14.sent;
                  this.websocket = _t40, n && n(this.websocket.url), this.websocket.onclose = s, this.websocket.onmessage = r, this.websocket.onerror = o, null === (c = this.store) || void 0 === c || c.recordJoinChannelService({
                    endTs: Date.now(),
                    status: "success"
                  }, a), this.joinGatewayRecordIndex = a;
                  _context14.next = 16;
                  break;

                case 12:
                  _context14.prev = 12;
                  _context14.t0 = _context14["catch"](5);
                  _t41 = "closed" === this.state, _n21 = _context14.t0 instanceof VT, _r6 = _n21 && _context14.t0.code === xT.WS_ABORT, _o6 = _n21 && _context14.t0.code === xT.WS_ERR, _c5 = _n21 ? _context14.t0.message : _context14.t0 && (_context14.t0.reason || _context14.t0.toString());
                  YC.warning("[choose-best-ws] chooseBestWebsocket error: ".concat(_c5)), this.store && this.store.recordJoinChannelService({
                    endTs: Date.now(),
                    status: _r6 ? "aborted" : "error",
                    errors: [_context14.t0]
                  }, a), _t41 || _o6 ? (i.reject(_t41 ? new VT(xT.WS_DISCONNECT, "websocket is closed: ".concat(_c5)) : new VT(xT.WS_ERR, "init websocket failed: ".concat(_c5))), _o6 && YC.error("[".concat(this.name, "] init websocket failed: ").concat(_c5))) : s && s(_context14.t0);

                case 16:
                  return _context14.abrupt("return", i.promise);

                case 17:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this, [[5, 12]]);
        }));

        function createWebSocketConnection(_x13) {
          return _createWebSocketConnection.apply(this, arguments);
        }

        return createWebSocketConnection;
      }()
    }, {
      key: "reconnectWithAction",
      value: function () {
        var _reconnectWithAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e) {
          var _this52 = this;

          var t,
              i,
              _t42,
              n,
              s,
              _n22,
              _args16 = arguments;

          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  t = !(_args16.length > 1 && void 0 !== _args16[1]) || _args16[1];

                  if (!(this.reconnectCount >= this.retryConfig.maxRetryCount)) {
                    _context16.next = 3;
                    break;
                  }

                  return _context16.abrupt("return", !1);

                case 3:
                  if (!(0 === this.urls.length)) {
                    _context16.next = 5;
                    break;
                  }

                  return _context16.abrupt("return", !1);

                case 5:
                  if (!("closed" === this.state)) {
                    _context16.next = 7;
                    break;
                  }

                  return _context16.abrupt("return", !1);

                case 7:
                  YC.warning("[choose-best-ws] action: =>", e), this.onlineReconnectListener || Rg.isOnline || !Rg.onlineWaiter || (this.onlineReconnectListener = Rg.onlineWaiter.then(function () {
                    _this52.onlineReconnectListener = void 0;
                  }));
                  i = !0;

                  if (!(this.reconnectInterrupter = function () {
                    return i = !1;
                  }, t)) {
                    _context16.next = 14;
                    break;
                  }

                  _t42 = zg(this.reconnectCount, this.retryConfig);
                  YC.debug("[".concat(this.name, "] wait ").concat(_t42, "ms to reconnect websocket, mode: ").concat(e));
                  _context16.next = 14;
                  return tT.race([Ug(_t42), this.onlineReconnectListener || new tT(function () {})]);

                case 14:
                  if (!("closed" === this._state || !i)) {
                    _context16.next = 16;
                    break;
                  }

                  return _context16.abrupt("return", !1);

                case 16:
                  this.reconnectCount += 1;

                  n = /*#__PURE__*/function () {
                    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e, t) {
                      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                        while (1) {
                          switch (_context15.prev = _context15.next) {
                            case 0:
                              _this52.emit(yI.RECONNECT_CREATE_CONNECTION, t);

                              _context15.next = 3;
                              return _this52.createWebSocketConnection(e);

                            case 3:
                            case "end":
                              return _context15.stop();
                          }
                        }
                      }, _callee15);
                    }));

                    return function n(_x16, _x17) {
                      return _ref18.apply(this, arguments);
                    };
                  }();

                  _context16.prev = 18;

                  if (!("retry" === e)) {
                    _context16.next = 25;
                    break;
                  }

                  this.emit(yI.RECONNECT_WAITTING_FINISH, e);
                  _context16.next = 23;
                  return n(this.urls[this.currentURLIndex], e);

                case 23:
                  _context16.next = 45;
                  break;

                case 25:
                  if (!("tryNext" === e)) {
                    _context16.next = 34;
                    break;
                  }

                  if (!(this.currentURLIndex += 1, this.currentURLIndex >= this.urls.length)) {
                    _context16.next = 28;
                    break;
                  }

                  return _context16.abrupt("return", this.reconnectWithAction("recover", !1));

                case 28:
                  YC.debug("[".concat(this.name, "] websocket url length: ").concat(this.urls.length, " current index: ").concat(this.currentURLIndex));
                  this.emit(yI.RECONNECT_WAITTING_FINISH, e);
                  _context16.next = 32;
                  return n(this.urls[this.currentURLIndex], e);

                case 32:
                  _context16.next = 45;
                  break;

                case 34:
                  _context16.t0 = "recover" === e;

                  if (!_context16.t0) {
                    _context16.next = 45;
                    break;
                  }

                  YC.debug("[".concat(this.name, "] request new urls"));
                  this.resetReconnectCount("recover mode");
                  this.emit(yI.RECONNECT_WAITTING_FINISH, e);
                  _context16.next = 41;
                  return fg(this, yI.REQUEST_NEW_URLS);

                case 41:
                  this.urls = _context16.sent;
                  this.currentURLIndex = 0;
                  _context16.next = 45;
                  return n(this.urls[this.currentURLIndex], e);

                case 45:
                  _context16.next = 52;
                  break;

                case 47:
                  _context16.prev = 47;
                  _context16.t1 = _context16["catch"](18);
                  YC.error("[".concat(this.name, "] reconnect failed ").concat(_context16.t1 && _context16.t1.toString()));
                  _n22 = null == _context16.t1 || null === (s = _context16.t1.data) || void 0 === s ? void 0 : s.desc;
                  return _context16.abrupt("return", Array.isArray(_n22) && bn(_n22).call(_n22, "dynamic key expired") ? (this.emit(yI.ON_TOKEN_PRIVILEGE_DID_EXPIRE), !1) : this.reconnectWithAction(e, t));

                case 52:
                  return _context16.abrupt("return", !0);

                case 53:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this, [[18, 47]]);
        }));

        function reconnectWithAction(_x15) {
          return _reconnectWithAction.apply(this, arguments);
        }

        return reconnectWithAction;
      }()
    }]);

    return Qv;
  }(ig);

  var Zv = /*#__PURE__*/function (_Qv) {
    _inherits(Zv, _Qv);

    var _super8 = _createSuper(Zv);

    function Zv(e, t) {
      _classCallCheck(this, Zv);

      return _super8.call(this, e, t, arguments.length > 2 && void 0 !== arguments[2] && arguments[2], arguments.length > 3 && void 0 !== arguments[3] && arguments[3], arguments.length > 4 && void 0 !== arguments[4] && arguments[4], arguments.length > 5 ? arguments[5] : void 0);
    }

    _createClass(Zv, [{
      key: "chooseBestWebsocketConnection",
      value: function () {
        var _chooseBestWebsocketConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(e, t) {
          var _this53 = this;

          var i, n, s;
          return _regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  i = nT(), n = function (e, t) {
                    return new zv(e, t);
                  }(this.forceCloseTimeout, this.store);

                  this.closeEstablishingWs = function () {
                    YC.debug("[choose-best-ws] close establishing websockets"), n.closeAllWebsockets(), i.reject(new VT(xT.WS_ABORT, "choose best websocket aborted"));
                  };

                  s = DC("GATEWAY_DOMAINS");
                  return _context17.abrupt("return", (YC.debug("[choose-best-ws] currentDomain: ", e, ", domains: ", s, "total: ".concat(this.urls.length), "current: ".concat(this.currentURLIndex + 1)), n.chooseBestWebsocket(e, this.tryDoubleDomain, this.use443PortOnly, t).then(i.resolve).catch(i.reject), i.promise.finally(function () {
                    _this53.closeEstablishingWs = void 0;
                  })));

                case 4:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this);
        }));

        function chooseBestWebsocketConnection(_x18, _x19) {
          return _chooseBestWebsocketConnection.apply(this, arguments);
        }

        return chooseBestWebsocketConnection;
      }()
    }]);

    return Zv;
  }(Qv);

  var $v = /*#__PURE__*/function (_Qv2) {
    _inherits($v, _Qv2);

    var _super9 = _createSuper($v);

    function $v(e, t) {
      _classCallCheck(this, $v);

      return _super9.call(this, e, t, arguments.length > 2 && void 0 !== arguments[2] && arguments[2], arguments.length > 3 && void 0 !== arguments[3] && arguments[3], arguments.length > 4 && void 0 !== arguments[4] && arguments[4], arguments.length > 5 ? arguments[5] : void 0);
    }

    _createClass($v, [{
      key: "chooseBestWebsocketConnection",
      value: function () {
        var _chooseBestWebsocketConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(e, t) {
          var _this54 = this;

          return _regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  return _context18.abrupt("return", new tT(function (i, n) {
                    var s = !1;
                    var r = [];

                    _this54.closeEstablishingWs = function () {
                      YC.debug("[choose-best-ws] close establishing websockets"), r.forEach(function (e) {
                        e.onclose = null, e.onopen = null, e.onmessage = null, e.close();
                      }), n(new VT(xT.WS_ABORT, "choose best websocket aborted"));
                    };

                    var o = DC("GATEWAY_DOMAINS");
                    var a;
                    var c = e.indexOf("?h="),
                        d = o.find(function (t) {
                      return -1 !== c ? bn(e).call(e, t, c) : bn(e).call(e, t);
                    });
                    YC.debug("[choose-best-ws] currentDomain: ", d, ", domains: ", o);
                    var l = !_this54.tryDoubleDomain || !d;

                    if (!l && d) {
                      var u;

                      var _h2 = Date.now();

                      try {
                        o.forEach(function (t) {
                          var i = -1 === c ? e.replace(d, t) : e.substr(0, c) + e.substr(c).replace(d, t),
                              n = new WebSocket(i);
                          n.binaryType = "arraybuffer", r.push(n), YC.debug("[choose-best-ws] ws is connecting:", n.url);
                        });
                      } catch (e) {
                        for (YC.debug("[choose-best-ws] ws create failed, fallback to single url"), r.forEach(function (e) {
                          return e.close();
                        }); r.length;) {
                          r.pop();
                        }

                        l = !0;
                      }

                      null === (u = _this54.store) || void 0 === u || u.recordJoinChannelService({
                        urls: r.map(function (e) {
                          return e.url;
                        }),
                        service: "gateway"
                      }, t), r.forEach(function (e) {
                        e.onopen = function () {
                          if (s) return;

                          var t = Date.now() - _h2;

                          YC.debug("[choose-best-ws] ws open cost ".concat(t, "ms")), r.filter(function (t) {
                            return t !== e;
                          }).forEach(function (e) {
                            YC.debug("[choose-best-ws]close backup websocket: ".concat(e.url)), e.close();
                          }), s = !0, i(e);
                        }, e.onclose = function (e) {
                          if (a = e, s) return;
                          r.find(function (e) {
                            return !(e.readyState === WebSocket.CLOSED || e.readyState === WebSocket.CLOSING);
                          }) || (YC.debug("[choose-best-ws] all websocket is closed"), s = !0, n(a));
                        }, e.onmessage = function (t) {
                          YC.debug("[choose-best-ws]".concat(e.url, " onmessage: ").concat(t.data));
                        };
                      }), Ug(_this54.forceCloseTimeout).then(function () {
                        r.forEach(function (e) {
                          e.readyState !== WebSocket.OPEN && e.close();
                        });
                      });
                    }

                    if (l) {
                      var h;

                      var _s12;

                      YC.debug("[choose-best-ws] use single url: ", e), null === (h = _this54.store) || void 0 === h || h.recordJoinChannelService({
                        urls: [e],
                        service: "gateway"
                      }, t);

                      try {
                        _s12 = new WebSocket(e), r.push(_s12), _s12.binaryType = "arraybuffer";
                      } catch (e) {
                        var _t43 = new VT(xT.WS_ERR, "init websocket failed! Error: ".concat(e.toString()));

                        return YC.error("[".concat(_this54.name, "]").concat(_t43)), void n(_t43);
                      }

                      _s12.onopen = function () {
                        i(_s12);
                      }, _s12.onclose = function (e) {
                        n(e);
                      }, _s12.onmessage = function (e) {
                        YC.debug("[choose-best-ws]".concat(_s12.url, " onmessage: ").concat(e.data));
                      }, Ug(_this54.forceCloseTimeout).then(function () {
                        _s12 && _s12.readyState !== WebSocket.OPEN && _s12.close();
                      });
                    }
                  }).then(function (e) {
                    return _this54.closeEstablishingWs = void 0, e;
                  }).catch(function (e) {
                    throw _this54.closeEstablishingWs = void 0, e;
                  }));

                case 1:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));

        function chooseBestWebsocketConnection(_x20, _x21) {
          return _chooseBestWebsocketConnection2.apply(this, arguments);
        }

        return chooseBestWebsocketConnection;
      }()
    }]);

    return $v;
  }(Qv);

  var ey = /*#__PURE__*/function (_ig5) {
    _inherits(ey, _ig5);

    var _super10 = _createSuper(ey);

    function ey(e, t) {
      var _this55;

      _classCallCheck(this, ey);

      _this55 = _super10.call(this), nh(_assertThisInitialized(_this55), "_disconnectedReason", void 0), nh(_assertThisInitialized(_this55), "_websocketReconnectReason", void 0), nh(_assertThisInitialized(_this55), "_connectionState", TI.CLOSED), nh(_assertThisInitialized(_this55), "reconnectToken", void 0), nh(_assertThisInitialized(_this55), "websocket", void 0), nh(_assertThisInitialized(_this55), "openConnectionTime", void 0), nh(_assertThisInitialized(_this55), "clientId", void 0), nh(_assertThisInitialized(_this55), "lastMsgTime", Date.now()), nh(_assertThisInitialized(_this55), "uploadCache", []), nh(_assertThisInitialized(_this55), "uploadCacheInterval", void 0), nh(_assertThisInitialized(_this55), "rttRolling", new dS(5)), nh(_assertThisInitialized(_this55), "pingpongTimer", void 0), nh(_assertThisInitialized(_this55), "wsInflateDataTimer", void 0), nh(_assertThisInitialized(_this55), "pingpongTimeoutCount", 0), nh(_assertThisInitialized(_this55), "joinResponse", void 0), nh(_assertThisInitialized(_this55), "multiIpOption", void 0), nh(_assertThisInitialized(_this55), "initError", void 0), nh(_assertThisInitialized(_this55), "spec", void 0), nh(_assertThisInitialized(_this55), "store", void 0), nh(_assertThisInitialized(_this55), "onWebsocketMessage", function (e) {
        if (e.data instanceof ArrayBuffer) return void _this55.emit(gI.ON_BINARY_DATA, e.data);
        var t = JSON.parse(e.data);

        if (_this55.lastMsgTime = Date.now(), Object.prototype.hasOwnProperty.call(t, "_id")) {
          var _e32 = "res-@".concat(t._id);

          _this55.emit(_e32, t._result, t._message);
        } else if (Object.prototype.hasOwnProperty.call(t, "_type")) {
          if (_this55.emit(t._type, t._message), t._type === CI.ON_NOTIFICATION && _this55.handleNotification(t._message), t._type === CI.ON_USER_BANNED) switch (t._message.error_code) {
            case 14:
              _this55.close(cg.UID_BANNED);

              break;

            case 15:
              _this55.close(cg.IP_BANNED);

              break;

            case 16:
              _this55.close(cg.CHANNEL_BANNED);

          }
          if (t._type === CI.ON_USER_LICENSE_BANNED) switch (t._message.error_code) {
            case fI.ERR_LICENSE_MISSING:
              _this55.close(cg.LICENSE_MISSING);

              break;

            case fI.ERR_LICENSE_EXPIRED:
              _this55.close(cg.LICENSE_EXPIRED);

              break;

            case fI.ERR_LICENSE_MINUTES_EXCEEDED:
              _this55.close(cg.LICENSE_MINUTES_EXCEEDED);

              break;

            case fI.ERR_LICENSE_PERIOD_INVALID:
              _this55.close(cg.LICENSE_PERIOD_INVALID);

              break;

            case fI.ERR_LICENSE_MULTIPLE_SDK_SERVICE:
              _this55.close(cg.LICENSE_MULTIPLE_SDK_SERVICE);

              break;

            case fI.ERR_LICENSE_ILLEGAL:
              _this55.close(cg.LICENSE_ILLEGAL);

              break;

            default:
              _this55.close();

          }
        }
      }), _this55.clientId = e.clientId, _this55.spec = e, _this55.store = t, _this55.websocket = new Zv("gateway-".concat(_this55.clientId), _this55.spec.retryConfig, !0, DC("JOIN_GATEWAY_USE_DUAL_DOMAIN"), DC("JOIN_GATEWAY_USE_443PORT_ONLY"), t), _this55.handleWebsocketEvents(), window.addEventListener("offline", function () {
        _this55.connectionState === TI.CONNECTED && _this55.reconnect("retry", lg.OFFLINE);
      });
      return _this55;
    }

    _createClass(ey, [{
      key: "connectionState",
      get: function get() {
        return this._connectionState;
      },
      set: function set(e) {
        e !== this._connectionState && (this._connectionState = e, e === TI.CONNECTED ? this.emit(gI.WS_CONNECTED) : e === TI.RECONNECTING ? this.emit(gI.WS_RECONNECTING, this._websocketReconnectReason) : e === TI.CLOSED && this.emit(gI.WS_CLOSED, this._disconnectedReason));
      }
    }, {
      key: "currentURLIndex",
      get: function get() {
        return this.websocket.currentURLIndex;
      }
    }, {
      key: "url",
      get: function get() {
        return this.websocket && this.websocket.url || null;
      }
    }, {
      key: "rtt",
      get: function get() {
        return this.rttRolling.mean();
      }
    }, {
      key: "request",
      value: function () {
        var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e, t, i, n) {
          var _this56 = this;

          var s, r, o, a, c, d, l, u, h;
          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  s = xg(6, ""), r = {
                    _id: s,
                    _type: e,
                    _message: t
                  }, o = this.websocket.connectionID, a = function a() {
                    return new tT(function (t, i) {
                      if (_this56.connectionState === TI.CONNECTED) return t();

                      var n = function n() {
                        _this56.off(gI.WS_CLOSED, s), t();
                      },
                          s = function s() {
                        _this56.off(gI.WS_CONNECTED, n), i(new VI(xT.WS_ABORT));
                      };

                      _this56.once(gI.WS_CONNECTED, n), _this56.once(gI.WS_CLOSED, s), e !== SI.PUBLISH && e !== SI.SUBSCRIBE && e !== SI.UNSUBSCRIBE && e !== SI.UNPUBLISH && e !== SI.CONTROL && e !== SI.RESTART_ICE || _this56.once(gI.DISCONNECT_P2P, function () {
                        i(new VI(xT.DISCONNECT_P2P));
                      }), e !== SI.PUBLISH && e !== SI.RESTART_ICE || _this56.once(gI.ABORT_P2P_EXECUTION, function () {
                        i(new VI(xT.DISCONNECT_P2P));
                      });
                    });
                  };
                  _context19.t0 = this.connectionState !== TI.CONNECTING && this.connectionState !== TI.RECONNECTING || e === SI.JOIN || e === SI.REJOIN;

                  if (_context19.t0) {
                    _context19.next = 5;
                    break;
                  }

                  _context19.next = 5;
                  return a();

                case 5:
                  this.websocket.sendMessage(r, !0);

                  if (!n) {
                    _context19.next = 8;
                    break;
                  }

                  return _context19.abrupt("return");

                case 8:
                  c = new tT(function (i, n) {
                    var r = !1;

                    var a = function a(n, s) {
                      r = !0, i({
                        isSuccess: "success" === n,
                        message: s || {}
                      }), _this56.off(gI.WS_CLOSED, c), _this56.off(gI.WS_RECONNECTING, c), _this56.emit(gI.REQUEST_SUCCESS, e, t);
                    };

                    _this56.once("res-@".concat(s), a);

                    var c = function c() {
                      n(new VI(xT.WS_ABORT, "type: ".concat(e))), _this56.off(gI.WS_CLOSED, c), _this56.off(gI.WS_RECONNECTING, c), _this56.off("res-@".concat(s), a);
                    };

                    _this56.once(gI.WS_CLOSED, c), _this56.once(gI.WS_RECONNECTING, c), Ug(DC("SIGNAL_REQUEST_TIMEOUT")).then(function () {
                      _this56.websocket.connectionID !== o || r || (YC.warning("[".concat(_this56.clientId, "] ws request timeout, type: ").concat(e)), _this56.emit(gI.REQUEST_TIMEOUT, e, t));
                    });
                  });
                  d = null;
                  _context19.prev = 10;
                  _context19.next = 13;
                  return c;

                case 13:
                  d = _context19.sent;
                  _context19.next = 35;
                  break;

                case 16:
                  _context19.prev = 16;
                  _context19.t1 = _context19["catch"](10);

                  if (!(this.connectionState === TI.CLOSED || e === SI.LEAVE)) {
                    _context19.next = 20;
                    break;
                  }

                  throw new VI(xT.WS_ABORT);

                case 20:
                  if (!(!this.spec.forceWaitGatewayResponse || i)) {
                    _context19.next = 24;
                    break;
                  }

                  _context19.t2 = _context19.t1.throw();
                  _context19.next = 34;
                  break;

                case 24:
                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context19.next = 28;
                    break;
                  }

                  _context19.t3 = null;
                  _context19.next = 33;
                  break;

                case 28:
                  _context19.next = 30;
                  return a();

                case 30:
                  _context19.next = 32;
                  return this.request(e, t);

                case 32:
                  _context19.t3 = _context19.sent;

                case 33:
                  _context19.t2 = _context19.t3;

                case 34:
                  return _context19.abrupt("return", _context19.t2);

                case 35:
                  if (!d.isSuccess) {
                    _context19.next = 37;
                    break;
                  }

                  return _context19.abrupt("return", d.message);

                case 37:
                  l = Number(d.message.error_code || d.message.code), u = Fv(l), h = new VI(xT.UNEXPECTED_RESPONSE, "".concat(u.desc, ": ").concat(d.message.error_str), {
                    code: l,
                    data: d.message
                  });

                  if (!("success" === u.action)) {
                    _context19.next = 42;
                    break;
                  }

                  _context19.t4 = d.message;
                  _context19.next = 67;
                  break;

                case 42:
                  YC.warning("[".concat(this.clientId, "] [").concat(this.websocket.connectionID, "] unexpected response from type ").concat(e, ", error_code: ").concat(l, ", message: ").concat(u.desc, ", action: ").concat(u.action));

                  if (!(l === fI.ERR_TOO_MANY_BROADCASTERS)) {
                    _context19.next = 47;
                    break;
                  }

                  _context19.t5 = e === SI.JOIN || e === SI.REJOIN ? (this.initError = h, this.close(), h.throw()) : h.throw();
                  _context19.next = 66;
                  break;

                case 47:
                  if (!("failed" === u.action)) {
                    _context19.next = 51;
                    break;
                  }

                  _context19.t6 = h.throw();
                  _context19.next = 65;
                  break;

                case 51:
                  if (!("quit" === u.action)) {
                    _context19.next = 55;
                    break;
                  }

                  _context19.t7 = (this.initError = h, this.close(), h.throw());
                  _context19.next = 64;
                  break;

                case 55:
                  l === fI.ERR_JOIN_BY_MULTI_IP ? (this.multiIpOption = d.message.option, YC.warning("[".concat(this.clientId, "] detect multi ip, recover")), this.reconnect("recover", lg.MULTI_IP)) : this.reconnect(u.action, lg.SERVER_ERROR);

                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context19.next = 60;
                    break;
                  }

                  _context19.t8 = null;
                  _context19.next = 63;
                  break;

                case 60:
                  _context19.next = 62;
                  return this.request(e, t);

                case 62:
                  _context19.t8 = _context19.sent;

                case 63:
                  _context19.t7 = _context19.t8;

                case 64:
                  _context19.t6 = _context19.t7;

                case 65:
                  _context19.t5 = _context19.t6;

                case 66:
                  _context19.t4 = _context19.t5;

                case 67:
                  return _context19.abrupt("return", _context19.t4);

                case 68:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19, this, [[10, 16]]);
        }));

        function request(_x22, _x23, _x24, _x25) {
          return _request.apply(this, arguments);
        }

        return request;
      }()
    }, {
      key: "waitMessage",
      value: function waitMessage(e, t) {
        var _this57 = this;

        return new tT(function (i) {
          var n = function n(s) {
            (!t || t(s)) && (_this57.off(e, n), i(s));
          };

          _this57.on(e, n);
        });
      }
    }, {
      key: "uploadWRTCStats",
      value: function uploadWRTCStats(e) {
        if (!this.store.sessionId) return void YC.warn("[".concat(this.clientId, "] no session id when upload wrtc stats"));
        var t = {
          lts: Date.now(),
          sid: this.store.sessionId,
          uid: this.store.intUid,
          stats: e
        };
        this.upload(RI.WRTC_STATS, t);
      }
    }, {
      key: "upload",
      value: function upload(e, t) {
        var _this58 = this;

        var i = {
          _type: e,
          _message: t
        };

        try {
          this.websocket.sendMessage(i);
        } catch (e) {
          var _t44 = DC("MAX_UPLOAD_CACHE") || 50;

          this.uploadCache.push(i), this.uploadCache.length > _t44 && this.uploadCache.splice(0, 1), this.uploadCache.length > 0 && !this.uploadCacheInterval && (this.uploadCacheInterval = window.setInterval(function () {
            if (_this58.connectionState !== TI.CONNECTED) return;

            var e = _this58.uploadCache.splice(0, 1)[0];

            0 === _this58.uploadCache.length && (window.clearInterval(_this58.uploadCacheInterval), _this58.uploadCacheInterval = void 0), _this58.upload(e._type, e._message);
          }, DC("UPLOAD_CACHE_INTERVAL") || 2e3));
        }
      }
    }, {
      key: "send",
      value: function send(e, t) {
        var i = {
          _type: e,
          _message: t
        };
        this.websocket.sendMessage(i);
      }
    }, {
      key: "init",
      value: function init(e, t) {
        var _this59 = this;

        return this.initError = void 0, this.multiIpOption = void 0, this.joinResponse = void 0, this.reconnectToken = void 0, this.openConnectionTime = void 0, new tT(function (t, i) {
          _this59.once(gI.WS_CONNECTED, function () {
            return t(_this59.joinResponse);
          }), _this59.once(gI.WS_CLOSED, function () {
            return i(_this59.initError || new VI(xT.WS_ABORT));
          }), _this59.connectionState = TI.CONNECTING, _this59.websocket.init(e).catch(i), _this59.wsInflateDataTimer && window.clearInterval(_this59.wsInflateDataTimer), _this59.wsInflateDataTimer = window.setInterval(function () {
            _this59.handleWsInflateData();
          }, 2e4);
        });
      }
    }, {
      key: "close",
      value: function close(e) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.wsInflateDataTimer && (this.handleWsInflateData(), window.clearInterval(this.wsInflateDataTimer), this.wsInflateDataTimer = void 0), this.reconnectToken = void 0, this.joinResponse = void 0, this._disconnectedReason = e || cg.LEAVE, this.connectionState = TI.CLOSED, YC.debug("[".concat(this.clientId, "] ") + "will close websocket in signal"), this.websocket.close(), e === cg.FALLBACK && (this.websocket.removeAllListeners(), this.websocket = new Zv("gateway-".concat(this.clientId), this.spec.retryConfig, !0, DC("JOIN_GATEWAY_USE_DUAL_DOMAIN"), DC("JOIN_GATEWAY_USE_443PORT_ONLY"), this.store), this.handleWebsocketEvents());
      }
    }, {
      key: "join",
      value: function () {
        var _join = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
          var _e33, t;

          return _regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  if (this.joinResponse) {
                    _context20.next = 11;
                    break;
                  }

                  this.emit(gI.ABORT_P2P_EXECUTION);
                  _context20.next = 4;
                  return fg(this, gI.REQUEST_JOIN_INFO);

                case 4:
                  _e33 = _context20.sent;
                  _context20.next = 7;
                  return this.request(SI.JOIN, _e33);

                case 7:
                  t = _context20.sent;

                  if (t) {
                    _context20.next = 10;
                    break;
                  }

                  return _context20.abrupt("return", (this.emit(gI.REPORT_JOIN_GATEWAY, iv.TIMEOUT, this.url || ""), !1));

                case 10:
                  this.joinResponse = t, this.emit(gI.JOIN_RESPONSE, this.joinResponse), this.reconnectToken = this.joinResponse.rejoin_token;

                case 11:
                  return _context20.abrupt("return", (this.connectionState = TI.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), !0));

                case 12:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20, this);
        }));

        function join() {
          return _join.apply(this, arguments);
        }

        return join;
      }()
    }, {
      key: "rejoin",
      value: function () {
        var _rejoin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
          var _this60 = this;

          var e, t;
          return _regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  if (this.reconnectToken) {
                    _context21.next = 2;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "can not rejoin, no rejoin token");

                case 2:
                  e = Sg(this, gI.REQUEST_REJOIN_INFO);
                  e.token = this.reconnectToken;
                  _context21.next = 6;
                  return this.request(SI.REJOIN, e);

                case 6:
                  t = _context21.sent;
                  return _context21.abrupt("return", !!t && (this.connectionState = TI.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), t.peers && t.peers.forEach(function (e) {
                    _this60.emit(CI.ON_USER_ONLINE, {
                      uid: e.uid
                    }), e.audio && _this60.emit(CI.ON_ADD_AUDIO_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id,
                      audio: !0,
                      ssrcId: e.audio_ssrc
                    }), e.video && _this60.emit(CI.ON_ADD_VIDEO_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id,
                      video: !0,
                      ssrcId: e.video_ssrc
                    }), e.audio_mute ? _this60.emit(CI.MUTE_AUDIO, {
                      uid: e.uid
                    }) : _this60.emit(CI.UNMUTE_AUDIO, {
                      uid: e.uid
                    }), e.video_mute ? _this60.emit(CI.MUTE_VIDEO, {
                      uid: e.uid
                    }) : _this60.emit(CI.UNMUTE_VIDEO, {
                      uid: e.uid
                    }), e.audio_enable_local ? _this60.emit(CI.ENABLE_LOCAL_AUDIO, {
                      uid: e.uid
                    }) : _this60.emit(CI.DISABLE_LOCAL_AUDIO, {
                      uid: e.uid
                    }), e.video_enable_local ? _this60.emit(CI.ENABLE_LOCAL_VIDEO, {
                      uid: e.uid
                    }) : _this60.emit(CI.DISABLE_LOCAL_VIDEO, {
                      uid: e.uid
                    }), e.audio || e.video || _this60.emit(CI.ON_REMOVE_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id
                    });
                  }), !0));

                case 8:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21, this);
        }));

        function rejoin() {
          return _rejoin.apply(this, arguments);
        }

        return rejoin;
      }()
    }, {
      key: "reconnect",
      value: function reconnect(e, t) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.websocket.reconnect(e, t);
      }
    }, {
      key: "handleNotification",
      value: function handleNotification(e) {
        YC.debug("[".concat(this.clientId, "] receive notification: "), e);
        var t = Fv(e.code);

        if ("success" !== t.action) {
          if ("failed" !== t.action) return "quit" === t.action ? ("ERR_REPEAT_JOIN_CHANNEL" === t.desc && this.close(cg.UID_BANNED), void this.close()) : void this.reconnect(t.action, lg.SERVER_ERROR);
          YC.error("[".concat(this.clientId, "] ignore error: "), t.desc);
        }
      }
    }, {
      key: "handlePingPong",
      value: function handlePingPong() {
        var _this61 = this;

        if (!this.websocket || "connected" !== this.websocket.state) return;
        this.pingpongTimeoutCount > 0 && this.rttRolling.add(3e3), this.pingpongTimeoutCount += 1;
        var e = DC("PING_PONG_TIME_OUT"),
            t = Date.now();
        this.pingpongTimeoutCount >= e && (YC.warning("[".concat(this.clientId, "] PING-PONG Timeout. Last Socket Message: ").concat(t - this.lastMsgTime, "ms")), t - this.lastMsgTime > DC("WEBSOCKET_TIMEOUT_MIN")) ? this.reconnect("retry", lg.TIMEOUT) : this.request(SI.PING, void 0, !0).then(function () {
          _this61.pingpongTimeoutCount = 0;
          var e = Date.now() - t;
          _this61.rttRolling.add(e), DC("REPORT_STATS") && _this61.send(SI.PING_BACK, {
            pingpongElapse: e
          });
        }).catch(function (e) {});
      }
    }, {
      key: "handleWsInflateData",
      value: function handleWsInflateData() {
        var _this$websocket$getWs = this.websocket.getWsInflateData(),
            e = _this$websocket$getWs.wsInflateLength,
            t = _this$websocket$getWs.wsDeflateLength;

        0 !== e && 0 !== t && this.upload(RI.WS_INFLATE_DATA_LENGTH, {
          ws_deflate_length: t,
          ws_inflate_length: e
        });
      }
    }, {
      key: "handleWebsocketEvents",
      value: function handleWebsocketEvents() {
        var _this62 = this;

        this.websocket.on(yI.RECONNECT_WAITTING_FINISH, function (e) {
          _this62.emit(gI.WS_RECONNECT_WAITTING_FINISH, e);
        }), this.websocket.on(yI.RECONNECT_CREATE_CONNECTION, function (e) {
          _this62.emit(gI.WS_RECONNECT_CREATE_CONNECTION, e);
        }), this.websocket.on(yI.ON_MESSAGE, this.onWebsocketMessage), this.websocket.on(yI.CLOSED, function () {
          _this62.connectionState = TI.CLOSED;
        }), this.websocket.on(yI.FAILED, function () {
          _this62._disconnectedReason = cg.NETWORK_ERROR, _this62.connectionState = TI.CLOSED;
        }), this.websocket.on(yI.RECONNECTING, function (e) {
          _this62._websocketReconnectReason = e, _this62.joinResponse = void 0, _this62.connectionState === TI.CONNECTED ? _this62.connectionState = TI.RECONNECTING : _this62.connectionState = TI.CONNECTING;
        }), this.websocket.on(yI.WILL_RECONNECT, function (e, t, i) {
          var n = Sg(_this62, gI.IS_P2P_DISCONNECTED),
              s = n || "retry" !== e;
          n && "retry" === e && (YC.debug("".concat(_this62.clientId, " reconnect mode is retry, but p2p lost, change to tryNext")), e = "tryNext", t = iv.P2P_DISCONNECTED), s && (YC.debug("".concat(_this62.clientId, " will renewSession, reconnect mode: ").concat(e)), _this62.emit(gI.REPORT_JOIN_GATEWAY, t || iv.UNKNOWN_REASON, _this62.url || ""), _this62.reconnectToken = void 0, _this62.emit(gI.NEED_RENEW_SESSION), _this62.emit(gI.DISCONNECT_P2P)), i(e);
        }), this.websocket.on(yI.CONNECTED, function () {
          _this62.openConnectionTime = Date.now(), _this62.reconnectToken ? _this62.rejoin().catch(function (e) {
            YC.warning("[".concat(_this62.clientId, "] rejoin failed ").concat(e)), _this62.reconnect("tryNext", lg.SERVER_ERROR);
          }) : _this62.join().catch(function (e) {
            if (_this62.emit(gI.REPORT_JOIN_GATEWAY, e.message || e.code || iv.UNKNOWN_REASON, _this62.url || ""), e instanceof VI && e.code === xT.UNEXPECTED_RESPONSE && e.data.code === fI.ERR_NO_AUTHORIZED) return YC.warning("[".concat(_this62.clientId, "] reconnect no authorized, recover")), void _this62.reconnect("recover", lg.SERVER_ERROR);
            YC.error("[".concat(_this62.clientId, "] join gateway request failed"), e.toString()), _this62.spec.forceWaitGatewayResponse ? _this62.reconnect("tryNext", lg.SERVER_ERROR) : (_this62.initError = e, _this62.close());
          });
        }), this.websocket.on(yI.REQUEST_NEW_URLS, function (e, t) {
          fg(_this62, gI.REQUEST_RECOVER, _this62.multiIpOption).then(e).catch(t);
        }), this.websocket.on(yI.ON_TOKEN_PRIVILEGE_DID_EXPIRE, function () {
          _this62.emit(CI.ON_TOKEN_PRIVILEGE_DID_EXPIRE);
        });
      }
    }]);

    return ey;
  }(ig);

  var ty = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
      iy = z,
      ny = pn,
      sy = ty,
      ry = d("".replace),
      oy = RegExp("^[" + sy + "]+"),
      ay = RegExp("(^|[^" + sy + "])[" + sy + "]+$"),
      cy = function cy(e) {
    return function (t) {
      var i = ny(iy(t));
      return 1 & e && (i = ry(i, oy, "")), 2 & e && (i = ry(i, ay, "$1")), i;
    };
  },
      dy = {
    start: cy(1),
    end: cy(2),
    trim: cy(3)
  },
      ly = Jd.PROPER,
      uy = n,
      hy = ty,
      py = dy.trim;

  wi({
    target: "String",
    proto: !0,
    forced: function (e) {
      return uy(function () {
        return !!hy[e]() || "​᠎" !== "​᠎"[e]() || ly && hy[e].name !== e;
      });
    }("trim")
  }, {
    trim: function trim() {
      return py(this);
    }
  });

  var _y,
      Ey,
      my = Ji("String").trim,
      fy = l,
      Ty = my,
      gy = String.prototype,
      Sy = i(function (e) {
    var t = e.trim;
    return "string" == typeof e || e === gy || fy(gy, e) && t === gy.trim ? Ty : t;
  });

  function Ry(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Cy(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ry(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Ry(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function Iy(e) {
    return e.match(/^[\.\:\d]+$/) ? "".concat(e.replace(/[^\d]/g, "-"), ".").concat(DC("TURN_DOMAIN")) : (YC.info("Unidentified as ip: ".concat(e, ", use as host")), e);
  }

  function vy(e, t) {
    e.addresses || (e.addresses = []);

    var i = function (e, t) {
      if (DC("CONNECT_GATEWAY_WITHOUT_DOMAIN")) return e.map(function (e) {
        var t = e.ip,
            i = e.port;
        return {
          address: "".concat(t, ":").concat(i)
        };
      });
      var i = DC("GATEWAY_DOMAINS");
      var n = i[1] && bn(t).call(t, i[1]) ? 1 : 0;
      return e.map(function (e) {
        var t = e.domain_prefix,
            s = e.port,
            r = e.ip;
        if (t) return {
          address: "".concat(t, ".").concat(i[n++ % i.length], ":").concat(s)
        };
        var o = /^[\.\:\d]+$/.test(r),
            a = o ? "".concat(r.replace(/[^\d]/g, "-"), ".").concat(i[n++ % i.length], ":").concat(s) : "".concat(r, ":").concat(s);
        return o || YC.info("Unidentified as ip: ".concat(r, ", use as host")), {
          ip: r,
          port: s,
          address: a
        };
      });
    }(e.addresses, t),
        n = Array.isArray(e.detail) && e.detail[18];

    if (n && "string" == typeof n) {
      var _e34 = n.split(";");

      for (var _t45 = 0; _t45 < _e34.length; _t45++) {
        var s;

        var _n23 = Sy(s = _e34[_t45]).call(s);

        i[_t45] && _n23 && (i[_t45].ip6 = _n23);
      }
    }

    return {
      gatewayAddrs: i,
      uid: e.uid,
      cid: e.cid,
      cert: e.cert,
      vid: e.detail && e.detail[8],
      uni_lbs_ip: e.detail && e.detail[1],
      res: e,
      csIp: e.detail && e.detail[502]
    };
  }

  function yy(e) {
    return "number" == typeof e ? e : e.exact || e.ideal || e.max || e.min || 0;
  }

  function Ay(e) {
    var t = e._encoderConfig;
    if (!t) return {};
    var i = {
      resolution: t.width && t.height ? "".concat(yy(t.width), "x").concat(yy(t.height)) : void 0,
      maxVideoBW: t.bitrateMax,
      minVideoBW: t.bitrateMin
    };
    return "number" == typeof t.frameRate ? (i.maxFrameRate = t.frameRate, i.minFrameRate = t.frameRate) : t.frameRate && (i.maxFrameRate = t.frameRate.max || t.frameRate.ideal || t.frameRate.exact || t.frameRate.min, i.minFrameRate = t.frameRate.min || t.frameRate.ideal || t.frameRate.exact || t.frameRate.max), i;
  }

  function by(e) {
    return e >= 0 && e < .17 ? 1 : e >= .17 && e < .36 ? 2 : e >= .36 && e < .59 ? 3 : e >= .59 && e <= 1 ? 4 : e > 1 ? 5 : 0;
  }

  function wy(e, t) {
    var i, n, s;

    switch (t) {
      case _y.CHOOSE_SERVER:
        n = 4096, s = "choose server";
        break;

      case _y.CLOUD_PROXY:
        n = 1048576, s = "proxy";
        break;

      case _y.CLOUD_PROXY_5:
        n = 4194304, s = "proxy5";
        break;

      case _y.CLOUD_PROXY_FALLBACK:
        n = 4194310, s = "proxy fallback";
        break;

      default:
        throw new VI(xT.UNEXPECTED_ERROR, "multi unlibs response transformer get unknown service id", {
          csIp: e.detail && e.detail[502],
          retry: !1
        });
    }

    if (e.response_body.forEach(function (t) {
      t.buffer && t.buffer.flag === n && (i = {
        code: t.buffer.code,
        addresses: (t.buffer.edges_services || []).map(function (e) {
          return Cy(Cy({}, e), {}, {
            ticket: t.buffer.cert
          });
        }),
        server_ts: e.enter_ts,
        uid: t.buffer.uid,
        cid: t.buffer.cid,
        cname: t.buffer.cname,
        detail: Cy(Cy({}, t.buffer.detail), e.detail),
        flag: t.buffer.flag,
        opid: e.opid,
        cert: t.buffer.cert
      });
    }), !i) throw new VI(xT.MULTI_UNILBS_RESPONSE_ERROR, "cannot parse response ".concat(s, " from multi unilbs response"), {
      csIp: e.detail && e.detail[502]
    });
    return i;
  }

  function Oy(_x26, _x27) {
    return _Oy.apply(this, arguments);
  }

  function _Oy() {
    _Oy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee469(e, t) {
      return _regeneratorRuntime.wrap(function _callee469$(_context469) {
        while (1) {
          switch (_context469.prev = _context469.next) {
            case 0:
              _context469.next = 2;
              return tT.all(e.addresses.map( /*#__PURE__*/function () {
                var _ref115 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee468(e) {
                  return _regeneratorRuntime.wrap(function _callee468$(_context468) {
                    while (1) {
                      switch (_context468.prev = _context468.next) {
                        case 0:
                          _context468.t0 = Iy(e.ip);
                          _context468.t1 = e.port;
                          _context468.t2 = e.port;
                          _context468.t3 = t && DC("ENCRYPT_PROXY_USERNAME_AND_PSW") && window.isSecureContext ? t.toString() : aI.username;

                          if (!(t && DC("ENCRYPT_PROXY_USERNAME_AND_PSW") && window.isSecureContext)) {
                            _context468.next = 10;
                            break;
                          }

                          _context468.next = 7;
                          return tg(t.toString());

                        case 7:
                          _context468.t4 = _context468.sent;
                          _context468.next = 11;
                          break;

                        case 10:
                          _context468.t4 = aI.password;

                        case 11:
                          _context468.t5 = _context468.t4;
                          return _context468.abrupt("return", {
                            address: _context468.t0,
                            tcpport: _context468.t1,
                            udpport: _context468.t2,
                            username: _context468.t3,
                            password: _context468.t5
                          });

                        case 13:
                        case "end":
                          return _context468.stop();
                      }
                    }
                  }, _callee468);
                }));

                return function (_x734) {
                  return _ref115.apply(this, arguments);
                };
              }()));

            case 2:
              return _context469.abrupt("return", _context469.sent);

            case 3:
            case "end":
              return _context469.stop();
          }
        }
      }, _callee469);
    }));
    return _Oy.apply(this, arguments);
  }

  function Ny(e, t) {
    var i = t._videoHeight || t.getMediaStreamTrack(!0).getSettings().height;
    return i ? Math.max(i / yy(e.height), 1) : (YC.warning("can't get ori-track's height, default scale down 4 times for low stream"), 4);
  }

  function Dy(e) {
    var t = e.candidateType,
        i = e.relayProtocol,
        n = e.type,
        s = e.address,
        r = e.port,
        o = e.protocol;
    return "local-candidate" === n ? {
      candidateType: t,
      relayProtocol: i,
      protocol: o
    } : {
      candidateType: t,
      relayProtocol: i,
      address: s,
      port: r,
      protocol: o
    };
  }

  function Py(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  !function (e) {
    e[e.CHOOSE_SERVER = 11] = "CHOOSE_SERVER", e[e.CLOUD_PROXY = 18] = "CLOUD_PROXY", e[e.CLOUD_PROXY_5 = 20] = "CLOUD_PROXY_5", e[e.CLOUD_PROXY_FALLBACK = 26] = "CLOUD_PROXY_FALLBACK";
  }(_y || (_y = {}));

  var Ly = /*#__PURE__*/function (_ig6) {
    _inherits(Ly, _ig6);

    var _super11 = _createSuper(Ly);

    function Ly(e, t, i, n) {
      var _this63;

      _classCallCheck(this, Ly);

      _this63 = _super11.call(this), nh(_assertThisInitialized(_this63), "connectionID", 0), nh(_assertThisInitialized(_this63), "currentURLIndex", 0), nh(_assertThisInitialized(_this63), "reconnectReason", void 0), nh(_assertThisInitialized(_this63), "_reconnectMode", "tryNext"), nh(_assertThisInitialized(_this63), "_name", void 0), nh(_assertThisInitialized(_this63), "_state", "closed"), nh(_assertThisInitialized(_this63), "_retryConfig", void 0), nh(_assertThisInitialized(_this63), "_reconnectCount", 0), nh(_assertThisInitialized(_this63), "_forceCloseTimeout", 5e3), nh(_assertThisInitialized(_this63), "_onlineReconnectListener", void 0), nh(_assertThisInitialized(_this63), "_closeEstablishingTransmitter", function () {}), nh(_assertThisInitialized(_this63), "_store", void 0), nh(_assertThisInitialized(_this63), "_joinChannelServiceRecordIndex", void 0), nh(_assertThisInitialized(_this63), "_useCompress", void 0), nh(_assertThisInitialized(_this63), "_inflateLength", 0), nh(_assertThisInitialized(_this63), "_deflateLength", 0), _this63._store = n, _this63._name = e, _this63._retryConfig = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Py(Object(i), !0).forEach(function (t) {
            nh(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Py(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }

        return e;
      }({}, t), _this63._useCompress = i;
      return _this63;
    }

    _createClass(Ly, [{
      key: "url",
      get: function get() {
        return this._url ? this._url : null;
      }
    }, {
      key: "reconnectMode",
      get: function get() {
        return this._reconnectMode;
      },
      set: function set(e) {
        var t;
        bn(t = ["tryNext", "recover"]).call(t, e) && this.resetReconnectCount(e), this._reconnectMode = e;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        e !== this._state && (this._state = e, "reconnecting" === this._state ? this.emit(Iv.RECONNECTING, this.reconnectReason) : "connected" === this._state ? this.emit(Iv.CONNECTED) : "closed" === this._state ? this.emit(Iv.CLOSED) : "failed" === this._state && this.emit(Iv.FAILED));
      }
    }, {
      key: "resetReconnectCount",
      value: function resetReconnectCount(e) {
        YC.debug("".concat(this._name, " reset reconnect count, reason: ").concat(e)), this._reconnectCount = 0;
      }
    }, {
      key: "close",
      value: function close(e, t) {
        if (this.currentURLIndex = 0, this.resetReconnectCount("close"), this._reconnectInterrupter && this._reconnectInterrupter(), this._transmitter) {
          this._transmitter.onclose = null, this._transmitter.onopen = null, this._transmitter.onmessage = null;
          var _e35 = this._transmitter;
          t ? setTimeout(function () {
            return _e35.close();
          }, 500) : _e35.close(), this._transmitter = void 0;
        }

        this.state = e ? "failed" : "closed", this._closeEstablishingTransmitter && this._closeEstablishingTransmitter();
      }
    }, {
      key: "reconnect",
      value: function reconnect(e, t) {
        if (!this._transmitter) return void YC.warning("[".concat(this._name, "] can not reconnect, no websocket"));
        var i;
        (void 0 !== e && (this.reconnectMode = e), YC.debug("[".concat(this._name, "] reconnect is triggered initiative")), "number" == typeof this._joinChannelServiceRecordIndex) && (null === (i = this._store) || void 0 === i || i.recordJoinChannelService({
          status: "error",
          errors: [new Error(t)]
        }, this._joinChannelServiceRecordIndex));
        var n = this._transmitter.onclose;
        this._transmitter.onclose = null, this._transmitter.close(), n && n.bind(this._transmitter)({
          code: 9999,
          reason: t
        });
      }
    }, {
      key: "getInflateData",
      value: function getInflateData() {
        var e = this._inflateLength,
            t = this._deflateLength;
        return this.clearInflateData(), {
          inflateLength: e,
          deflateLength: t
        };
      }
    }, {
      key: "setInflateData",
      value: function setInflateData(e) {
        this._deflateLength = this._deflateLength + e.originLength, this._inflateLength = this._inflateLength + e.compressedLength;
      }
    }, {
      key: "clearInflateData",
      value: function clearInflateData() {
        this._inflateLength = 0, this._deflateLength = 0;
      }
    }]);

    return Ly;
  }(ig);

  !function (e) {
    e[e.Default = 0] = "Default", e[e.Ack = 1] = "Ack";
  }(Ey || (Ey = {}));

  var ky = /*#__PURE__*/function () {
    function ky(e, t, i) {
      _classCallCheck(this, ky);

      nh(this, "version", 1), nh(this, "initialRTO", void 0), nh(this, "maxBatchAckCount", void 0), nh(this, "maxRTO", void 0), nh(this, "initialRTT", void 0), nh(this, "ID", void 0), nh(this, "rtt", void 0), nh(this, "packetNumber", 1), nh(this, "rtoRatioMap", new Map()), nh(this, "timeoutMap", new Map()), nh(this, "unorderedPacketQueue", []), nh(this, "batchAckPacketQueue", []), nh(this, "lastOrderedPacketNumber", 0), nh(this, "batchAckTimer", void 0), nh(this, "sendImpl", void 0), nh(this, "receiveImpl", void 0), this.sendImpl = e, this.receiveImpl = t, this.ID = xg(7, "transmitter-"), this.initialRTO = void 0 !== (null == i ? void 0 : i.initialRTO) ? i.initialRTO : DC("TRANSMITTER_INITIAL_RTO"), this.initialRTT = void 0 !== (null == i ? void 0 : i.initialRTT) ? i.initialRTT : DC("TRANSMITTER_INITIAL_RTT"), this.rtt = void 0 !== (null == i ? void 0 : i.initialRTT) ? i.initialRTT : DC("TRANSMITTER_INITIAL_RTT"), this.maxBatchAckCount = void 0 !== (null == i ? void 0 : i.maxBatchAckCount) ? i.maxBatchAckCount : DC("TRANSMITTER_MAX_BATCH_ACK_COUNT"), this.maxRTO = void 0 !== (null == i ? void 0 : i.maxRTO) ? i.maxRTO : DC("TRANSMITTER_MAX_RTO");
    }

    _createClass(ky, [{
      key: "packetize",
      value: function packetize(e, t) {
        return {
          type: Ey.Default,
          version: this.version,
          packetNumber: t,
          payload: e
        };
      }
    }, {
      key: "serialize",
      value: function serialize(e) {
        switch (e.type) {
          case Ey.Default:
            {
              var t;

              if ("string" == typeof e.payload) {
                t = new TextEncoder().encode(e.payload);
              } else t = e.payload;

              var _i34 = new ArrayBuffer(t.length + 15),
                  _n24 = new DataView(_i34);

              _n24.setUint16(0, e.version), _n24.setUint8(2, e.type), _n24.setUint32(3, e.packetNumber), JT(_n24, 7, BigInt(e.sendTs));
              return new Uint8Array(_n24.buffer).set(t, 15), _i34;
            }

          case Ey.Ack:
            {
              var _t46 = new ArrayBuffer(16),
                  _i35 = new DataView(_t46);

              return _i35.setUint16(0, e.version), _i35.setUint8(2, e.type), _i35.setUint32(3, e.maxAckPacketNumber), _i35.setUint8(7, e.shift), JT(_i35, 8, BigInt(e.ackSendTs)), _t46;
            }
        }
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        var t = new DataView(e),
            i = t.getUint16(0),
            n = t.getUint8(2);

        switch (n) {
          case Ey.Default:
            {
              var s = t.getUint32(3),
                  _r7 = qT(t, 7),
                  _o7 = e.slice(15),
                  _a3 = new TextDecoder().decode(_o7);

              return {
                version: i,
                type: n,
                packetNumber: s,
                sendTs: Number(_r7),
                payload: _a3
              };
            }

          case Ey.Ack:
            {
              var _e36 = t.getUint32(3),
                  _s13 = t.getUint8(7),
                  _r8 = qT(t, 8);

              return {
                version: i,
                type: n,
                maxAckPacketNumber: _e36,
                shift: _s13,
                ackSendTs: Number(_r8)
              };
            }

          default:
            throw YC.error("[".concat(this.ID, "] Unrecognized packet type ").concat(n)), new Error("Unrecognized packet type ".concat(n));
        }
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(e) {
        var _this64 = this;

        var t = this.packetize(e, this.packetNumber);
        this.packetNumber = 4294967295 === this.packetNumber ? 1 : this.packetNumber + 1;
        var i = this.calculateRTO(t),
            n = window.setTimeout(function () {
          _this64.resendMessage(t);
        }, i);
        this.timeoutMap.set(t.packetNumber, n), this.sendPacket(t);
      }
    }, {
      key: "onData",
      value: function onData(e) {
        var t = this.deserialize(e);
        t.type === Ey.Default ? this.ack(t) : t.type === Ey.Ack && (this.updateRTT(t, Math.round(performance.now())), this.clearRTO(t));
      }
    }, {
      key: "close",
      value: function close() {
        this.rtt = this.initialRTT, this.packetNumber = 1, Array.from(this.timeoutMap.entries()).forEach(function (e) {
          var _e37 = _slicedToArray(e, 2),
              t = _e37[0],
              i = _e37[1];

          window.clearTimeout(i);
        }), this.timeoutMap = new Map(), this.rtoRatioMap = new Map(), this.unorderedPacketQueue = [], this.batchAckPacketQueue = [], this.lastOrderedPacketNumber = 0, void 0 !== this.batchAckTimer && window.clearTimeout(this.batchAckTimer);
      }
    }, {
      key: "resendMessage",
      value: function resendMessage(e) {
        var _this65 = this;

        var t = this.calculateRTO(e),
            i = window.setTimeout(function () {
          _this65.resendMessage(e);
        }, t);
        this.timeoutMap.set(e.packetNumber, i), this.sendPacket(e);
      }
    }, {
      key: "calculateRTO",
      value: function calculateRTO(e) {
        var t = this.rtoRatioMap.get(e.packetNumber);
        if (void 0 === t) return this.rtoRatioMap.set(e.packetNumber, 1), this.initialRTO;
        {
          var _i36 = 9 * this.rtt / 8 * t;

          return this.rtoRatioMap.set(e.packetNumber, t + 1), _i36 > this.maxRTO ? this.maxRTO : _i36;
        }
      }
    }, {
      key: "updateRTT",
      value: function updateRTT(e, t) {
        var i = e.ackSendTs;
        this.rtt = this.rtt * (7 / 8) + (t - i - this.rtt) / 8;
      }
    }, {
      key: "ack",
      value: function ack(e) {
        var _this66 = this;

        if (e.packetNumber === this.lastOrderedPacketNumber + 1) for (this.batchAckPacketQueue.length >= this.maxBatchAckCount && this.batchAck(), this.batchAckTimer ? this.batchAckPacketQueue.push(e) : (this.batchAckPacketQueue.push(e), this.batchAckTimer = window.setTimeout(function () {
          _this66.batchAck();
        }, this.rtt / 8)), this.lastOrderedPacketNumber += 1, this.receiveImpl(e.payload);;) {
          var _e38 = this.unorderedPacketQueue[0];

          if (!_e38) {
            this.unorderedPacketQueue.shift();
            break;
          }

          this.batchAckTimer && this.batchAck(), this.receiveImpl(_e38.payload), this.unorderedPacketQueue.shift(), this.lastOrderedPacketNumber += 1;
        } else if (e.packetNumber <= this.lastOrderedPacketNumber) {
          var t = {
            ackSendTs: e.sendTs,
            maxAckPacketNumber: e.packetNumber,
            shift: 0,
            type: Ey.Ack,
            version: this.version
          };
          this.sendPacket(t);
        } else if (e.packetNumber > this.lastOrderedPacketNumber) {
          this.unorderedPacketQueue[e.packetNumber - this.lastOrderedPacketNumber - 2] = e;
          var _t47 = {
            ackSendTs: e.sendTs,
            maxAckPacketNumber: e.packetNumber,
            shift: 0,
            type: Ey.Ack,
            version: this.version
          };
          this.sendPacket(_t47);
        }
      }
    }, {
      key: "batchAck",
      value: function batchAck() {
        window.clearTimeout(this.batchAckTimer), this.batchAckTimer = void 0;
        var e = {
          ackSendTs: this.batchAckPacketQueue[this.batchAckPacketQueue.length - 1].sendTs,
          maxAckPacketNumber: this.batchAckPacketQueue[this.batchAckPacketQueue.length - 1].packetNumber,
          shift: this.batchAckPacketQueue.length - 1,
          type: Ey.Ack,
          version: this.version
        };
        this.sendPacket(e), this.batchAckPacketQueue = [];
      }
    }, {
      key: "sendPacket",
      value: function sendPacket(e) {
        e.type === Ey.Default && (e.sendTs = Math.round(performance.now()));
        var t = this.serialize(e);
        this.sendImpl(t);
      }
    }, {
      key: "clearRTO",
      value: function clearRTO(e) {
        for (var t = e.maxAckPacketNumber - e.shift; t <= e.maxAckPacketNumber; t++) {
          var _e39 = this.timeoutMap.get(t);

          void 0 !== _e39 && window.clearTimeout(_e39), this.timeoutMap.delete(t), this.rtoRatioMap.delete(t);
        }
      }
    }]);

    return ky;
  }();

  var My = /*#__PURE__*/function (_Ly) {
    _inherits(My, _Ly);

    var _super12 = _createSuper(My);

    function My(e, t) {
      var _this67;

      _classCallCheck(this, My);

      _this67 = _super12.call(this, e, t, arguments.length > 2 && void 0 !== arguments[2] && arguments[2], arguments.length > 3 ? arguments[3] : void 0), nh(_assertThisInitialized(_this67), "_initMutex", void 0), nh(_assertThisInitialized(_this67), "_reconnectInterrupter", void 0), nh(_assertThisInitialized(_this67), "_url", void 0), nh(_assertThisInitialized(_this67), "_transmitter", void 0), nh(_assertThisInitialized(_this67), "_addresses", void 0), nh(_assertThisInitialized(_this67), "_reliableTransmission", void 0), _this67._initMutex = new Yg("datachannel");
      var i = t.timeout,
          n = t.timeoutFactor,
          s = Math.max(300, Math.floor(3 * i / 5)),
          r = Math.max(1.2, Math.floor(8 * n) / 10);
      ug.ONLINE && (_this67._retryConfig.timeout = s, _this67._retryConfig.timeoutFactor = r), Rg.on(hg.NETWORK_STATE_CHANGE, function (e, t) {
        e !== t && (_this67.resetReconnectCount("network state change: ".concat(t, " -> ").concat(e)), e === ug.ONLINE ? (_this67._retryConfig.timeout = s, _this67._retryConfig.timeoutFactor = r) : (_this67._retryConfig.timeout = i, _this67._retryConfig.timeoutFactor = n));
      });
      return _this67;
    }

    _createClass(My, [{
      key: "getConnection",
      value: function getConnection() {
        if (this._reliableTransmission) return this._reliableTransmission;
      }
    }, {
      key: "init",
      value: function () {
        var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e) {
          var _this68 = this;

          var t,
              i,
              _args22 = arguments;
          return _regeneratorRuntime.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  t = _args22.length > 1 && void 0 !== _args22[1] ? _args22[1] : 5e3;
                  this._forceCloseTimeout = t;

                  i = function i(t, _i37) {
                    _this68._addresses = e, _this68.currentURLIndex = _this68._addresses.findIndex(function (e) {
                      return e.fingerprint || DC("FINGERPRINT");
                    });
                    var n = _this68._addresses[_this68.currentURLIndex];
                    _this68.state = "connecting", _this68.createTransmitterConnection(n).then(t).catch(_i37), _this68.once(Iv.CLOSED, function () {
                      return _i37(new VI(xT.WS_DISCONNECT));
                    }), _this68.once(Iv.CONNECTED, function () {
                      return t();
                    });
                  };

                  return _context22.abrupt("return", this._initMutex.lock().then(function (e) {
                    return new tT(function (e, t) {
                      i(e, t);
                    }).then(function () {
                      e();
                    }).catch(function () {
                      e();
                    });
                  }));

                case 4:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22, this);
        }));

        function init(_x28) {
          return _init2.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "sendMessage",
      value: function sendMessage(e) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!this._transmitter || !this._reliableTransmission) throw new VI(xT.WS_ABORT, "datachannel is not ready");

        try {
          t || (e = JSON.stringify(e)), this._reliableTransmission.sendMessage(e);
        } catch (e) {
          throw new VI(xT.WS_ERR, "send datachannel signal message error" + e.toString());
        }
      }
    }, {
      key: "unbindDcCloseEventListener",
      value: function unbindDcCloseEventListener() {
        this._transmitter && (this._transmitter.onclose = null);
      }
    }, {
      key: "sendMessageWithJSON",
      value: function sendMessageWithJSON(e) {
        var t = JSON.stringify(e);
        return {
          compressed: t,
          compressedLength: t.length,
          origin: e
        };
      }
    }, {
      key: "sendMessageWithUint8Array",
      value: function sendMessageWithUint8Array(e) {
        return {
          compressed: e,
          compressedLength: e.byteLength,
          origin: e
        };
      }
    }, {
      key: "createTransmitterConnection",
      value: function createTransmitterConnection(e) {
        var _this69 = this;

        return this.connectionID += 1, this._joinChannelServiceRecordIndex = void 0, this._url = "dc://".concat(e.ip, ":").concat(e.port), new tT(function (t, i) {
          var n;

          var s = function s() {
            YC.debug("[".concat(_this69._name, "] datachannel opened:"), _this69._url), _this69.reconnectMode = "retry", _this69.state = "connected", _this69.resetReconnectCount("opened"), t();
          },
              r = /*#__PURE__*/function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e) {
              var n, _n25, _s14;

              return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                  switch (_context23.prev = _context23.next) {
                    case 0:
                      if (!(null === (n = _this69._closeEstablishingTransmitter) || void 0 === n || n.call(_this69), YC.debug("[".concat(_this69._name, "] datachannel close ").concat(_this69._url, ", code: ").concat(e.code, ", reason: ").concat(e.reason, ", current mode: ").concat(_this69.reconnectMode)), _this69._reconnectCount < _this69._retryConfig.maxRetryCount)) {
                        _context23.next = 13;
                        break;
                      }

                      "connected" === _this69.state && (_this69.reconnectReason = e.reason, _this69.state = "reconnecting");
                      _n25 = gg(_this69, Iv.WILL_RECONNECT, _this69.reconnectMode) || _this69.reconnectMode;
                      _context23.next = 5;
                      return _this69.reconnectWithAction(_n25);

                    case 5:
                      _s14 = _context23.sent;

                      if (!("closed" === _this69.state)) {
                        _context23.next = 8;
                        break;
                      }

                      return _context23.abrupt("return", void YC.debug("[".concat(_this69.connectionID, "] dc is closed, no need to reconnect")));

                    case 8:
                      if (_s14) {
                        _context23.next = 10;
                        break;
                      }

                      return _context23.abrupt("return", (i(new VI(xT.WS_DISCONNECT, "datachannel reconnect failed: ".concat(e.code))), void _this69.close(!0)));

                    case 10:
                      t();
                      _context23.next = 14;
                      break;

                    case 13:
                      i(new VI(xT.WS_DISCONNECT, "datachannel close: ".concat(e.code))), _this69.close();

                    case 14:
                    case "end":
                      return _context23.stop();
                  }
                }
              }, _callee23);
            }));

            return function r(_x29) {
              return _ref19.apply(this, arguments);
            };
          }(),
              o = function o(e) {
            var t;
            null === (t = _this69._reliableTransmission) || void 0 === t || t.onData(e.data);
          };

          _this69._transmitter && (_this69._transmitter.onclose = null, _this69._transmitter.close()), _this69._reliableTransmission && (_this69._reliableTransmission.close(), _this69._reliableTransmission = void 0), YC.debug("[".concat(_this69._name, "] start connect, address: ").concat(JSON.stringify(e)));
          var a = null === (n = _this69._store) || void 0 === n ? void 0 : n.recordJoinChannelService({
            startTs: Date.now(),
            status: "pending",
            service: "gateway"
          }),
              c = Date.now();
          fg(_this69, Iv.TO_CONNECT_DATACHANNEL, e).then(function (e) {
            var t, i;
            if (!e) throw new Error("transmissonInfo not exist yet");
            var n = e.transmitter,
                d = e.close;
            _this69._transmitter = n, null === (t = _this69._store) || void 0 === t || t.signalChannelOpen();
            var l = Date.now() - c;
            YC.debug("[choose dc] dc open cost ".concat(l, "ms"));
            _this69._reliableTransmission = new ky(function (e) {
              var t;
              _this69._transmitter && "open" === _this69._transmitter.readyState && (null === (t = _this69._transmitter) || void 0 === t || t.send(e));
            }, function (e) {
              "string" == typeof e && _this69.emit(Iv.ON_MESSAGE, e);
            }), _this69._closeEstablishingTransmitter = function () {
              var e;
              null === (e = _this69._reliableTransmission) || void 0 === e || e.close(), _this69._reliableTransmission = void 0, d();
            }, s && s(), n.onclose = r, n.onmessage = o, null === (i = _this69._store) || void 0 === i || i.recordJoinChannelService({
              endTs: Date.now(),
              status: "success"
            }, a), _this69._joinChannelServiceRecordIndex = a;
          }).catch(function (e) {
            var t;

            if (null === (t = _this69._store) || void 0 === t || t.recordJoinChannelService({
              endTs: Date.now(),
              status: e instanceof VI && e.code === xT.WS_ABORT ? "aborted" : "error",
              errors: [e]
            }, a), "closed" !== _this69.state) {
              if (e instanceof VI && e.code === xT.WS_ERR) {
                var _t48 = new VI(xT.WS_ERR, "init datachannel failed! Error: ".concat(e.toString()));

                return YC.error("[".concat(_this69._name, "]").concat(_t48)), void i(_t48);
              }

              r && r(e);
            } else i(new VI(xT.WS_DISCONNECT, "datachannel is closed: ".concat(e.toString())));
          });
        });
      }
    }, {
      key: "reconnectWithAction",
      value: function () {
        var _reconnectWithAction2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e) {
          var _this70 = this;

          var t,
              i,
              _t49,
              n,
              _t50,
              _e40,
              _t51,
              s,
              r,
              _args25 = arguments;

          return _regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  t = !(_args25.length > 1 && void 0 !== _args25[1]) || _args25[1];

                  if (!(this._reconnectCount >= this._retryConfig.maxRetryCount)) {
                    _context25.next = 3;
                    break;
                  }

                  return _context25.abrupt("return", !1);

                case 3:
                  if (this._addresses) {
                    _context25.next = 5;
                    break;
                  }

                  return _context25.abrupt("return", !1);

                case 5:
                  if (!("closed" === this.state)) {
                    _context25.next = 7;
                    break;
                  }

                  return _context25.abrupt("return", !1);

                case 7:
                  this._onlineReconnectListener || Rg.networkState !== ug.OFFLINE || (this._onlineReconnectListener = Rg.onlineWaiter && Rg.onlineWaiter.then(function () {
                    _this70._onlineReconnectListener = void 0;
                  }));
                  i = !0;

                  if (!(this._reconnectInterrupter = function () {
                    i = !1;
                  }, t)) {
                    _context25.next = 14;
                    break;
                  }

                  _t49 = zg(this._reconnectCount, this._retryConfig);
                  YC.debug("[".concat(this._name, "] wait ").concat(_t49, "ms to reconnect datachannel, mode: ").concat(e));
                  _context25.next = 14;
                  return tT.race([Ug(_t49), this._onlineReconnectListener || new tT(function () {})]);

                case 14:
                  if (!("closed" === this.state || !i)) {
                    _context25.next = 16;
                    break;
                  }

                  return _context25.abrupt("return", !1);

                case 16:
                  this._reconnectCount += 1;

                  n = /*#__PURE__*/function () {
                    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e, t) {
                      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                        while (1) {
                          switch (_context24.prev = _context24.next) {
                            case 0:
                              _this70.emit(Iv.RECONNECT_CREATE_CONNECTION, t);

                              _context24.next = 3;
                              return _this70.createTransmitterConnection(e);

                            case 3:
                            case "end":
                              return _context24.stop();
                          }
                        }
                      }, _callee24);
                    }));

                    return function n(_x31, _x32) {
                      return _ref20.apply(this, arguments);
                    };
                  }();

                  _context25.prev = 18;

                  if (!("retry" === e)) {
                    _context25.next = 26;
                    break;
                  }

                  _t50 = this._addresses[this.currentURLIndex];
                  this.emit(Iv.RECONNECT_WAITTING_FINISH, e);
                  _context25.next = 24;
                  return n(_t50, e);

                case 24:
                  _context25.next = 50;
                  break;

                case 26:
                  if (!("tryNext" === e)) {
                    _context25.next = 49;
                    break;
                  }

                  this.currentURLIndex += 1;
                  _e40 = this.currentURLIndex;

                case 29:
                  if (!(_e40 < this._addresses.length)) {
                    _context25.next = 37;
                    break;
                  }

                  if (!(this._addresses[_e40].fingerprint || DC("FINGERPRINT"))) {
                    _context25.next = 33;
                    break;
                  }

                  this.currentURLIndex = _e40;
                  return _context25.abrupt("break", 37);

                case 33:
                  this.currentURLIndex += 1;

                case 34:
                  _e40++;
                  _context25.next = 29;
                  break;

                case 37:
                  if (!(this.currentURLIndex >= this._addresses.length)) {
                    _context25.next = 42;
                    break;
                  }

                  YC.debug("[".concat(this._name, "] the available addresses are exhausted, change to recover"));
                  _context25.next = 41;
                  return this.reconnectWithAction("recover", !1);

                case 41:
                  return _context25.abrupt("return", _context25.sent);

                case 42:
                  YC.debug("[".concat(this._name, "] datachannel url length: ").concat(this._addresses.length, " current index: ").concat(this.currentURLIndex));
                  _t51 = this._addresses[this.currentURLIndex];
                  this.emit(Iv.RECONNECT_WAITTING_FINISH, e);
                  _context25.next = 47;
                  return n(_t51, e);

                case 47:
                  _context25.next = 50;
                  break;

                case 49:
                  "recover" === e && (YC.debug("[".concat(this._name, "] start to failback to websocket")), this.resetReconnectCount("recover mode"), this.emit(Iv.RECONNECT_WAITTING_FINISH, e), this.emit(Iv.FAILBACK));

                case 50:
                  return _context25.abrupt("return", !0);

                case 53:
                  _context25.prev = 53;
                  _context25.t0 = _context25["catch"](18);
                  YC.error("[".concat(this._name, "] reconnect failed"), _context25.t0.toString());

                  if (!(null != _context25.t0 && null !== (s = _context25.t0.data) && void 0 !== s && s.desc && Array.isArray(_context25.t0.data.desc) && _context25.t0.data.desc.length && bn(r = _context25.t0.data.desc).call(r, "dynamic key expired"))) {
                    _context25.next = 60;
                    break;
                  }

                  _context25.t1 = (this.emit(Iv.ON_TOKEN_PRIVILEGE_DID_EXPIRE), !1);
                  _context25.next = 63;
                  break;

                case 60:
                  _context25.next = 62;
                  return this.reconnectWithAction(e, t);

                case 62:
                  _context25.t1 = _context25.sent;

                case 63:
                  return _context25.abrupt("return", _context25.t1);

                case 64:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25, this, [[18, 53]]);
        }));

        function reconnectWithAction(_x30) {
          return _reconnectWithAction2.apply(this, arguments);
        }

        return reconnectWithAction;
      }()
    }]);

    return My;
  }(Ly);

  var Uy = /*#__PURE__*/function (_ig7) {
    _inherits(Uy, _ig7);

    var _super13 = _createSuper(Uy);

    function Uy(e, t) {
      var _this71;

      _classCallCheck(this, Uy);

      _this71 = _super13.call(this), nh(_assertThisInitialized(_this71), "_disconnectedReason", void 0), nh(_assertThisInitialized(_this71), "_websocketReconnectReason", void 0), nh(_assertThisInitialized(_this71), "_connectionState", TI.CLOSED), nh(_assertThisInitialized(_this71), "reconnectToken", void 0), nh(_assertThisInitialized(_this71), "websocket", void 0), nh(_assertThisInitialized(_this71), "openConnectionTime", void 0), nh(_assertThisInitialized(_this71), "clientId", void 0), nh(_assertThisInitialized(_this71), "lastMsgTime", Date.now()), nh(_assertThisInitialized(_this71), "uploadCache", []), nh(_assertThisInitialized(_this71), "uploadCacheInterval", void 0), nh(_assertThisInitialized(_this71), "rttRolling", new dS(5)), nh(_assertThisInitialized(_this71), "pingpongTimer", void 0), nh(_assertThisInitialized(_this71), "inflateDataTimer", void 0), nh(_assertThisInitialized(_this71), "pingpongTimeoutCount", 0), nh(_assertThisInitialized(_this71), "joinResponse", void 0), nh(_assertThisInitialized(_this71), "multiIpOption", void 0), nh(_assertThisInitialized(_this71), "initError", void 0), nh(_assertThisInitialized(_this71), "spec", void 0), nh(_assertThisInitialized(_this71), "store", void 0), nh(_assertThisInitialized(_this71), "onWebsocketMessage", function (e) {
        if (e instanceof ArrayBuffer) return void _this71.emit(gI.ON_BINARY_DATA, e);
        var t = JSON.parse(e);

        if (_this71.lastMsgTime = Date.now(), Object.prototype.hasOwnProperty.call(t, "_id")) {
          var _e41 = "res-@".concat(t._id);

          _this71.emit(_e41, t._result, t._message);
        } else if (Object.prototype.hasOwnProperty.call(t, "_type") && (_this71.emit(t._type, t._message), t._type === CI.ON_NOTIFICATION && _this71.handleNotification(t._message), t._type === CI.ON_USER_BANNED)) switch (t._message.error_code) {
          case 14:
            _this71.close(cg.UID_BANNED);

            break;

          case 15:
            _this71.close(cg.IP_BANNED);

            break;

          case 16:
            _this71.close(cg.CHANNEL_BANNED);

        }
      }), _this71.clientId = e.clientId, _this71.spec = e, _this71.store = t, _this71.websocket = new My("gateway-".concat(_this71.clientId), _this71.spec.retryConfig, !0, t), _this71.handleWebsocketEvents(), window.addEventListener("offline", function () {
        _this71.connectionState === TI.CONNECTED && _this71.reconnect("retry", Cv.OFFLINE);
      });
      return _this71;
    }

    _createClass(Uy, [{
      key: "connectionState",
      get: function get() {
        return this._connectionState;
      },
      set: function set(e) {
        e !== this._connectionState && (this._connectionState = e, e === TI.CONNECTED ? this.emit(gI.WS_CONNECTED) : e === TI.RECONNECTING ? this.emit(gI.WS_RECONNECTING, this._websocketReconnectReason) : e === TI.CLOSED && this.emit(gI.WS_CLOSED, this._disconnectedReason));
      }
    }, {
      key: "currentURLIndex",
      get: function get() {
        return this.websocket.currentURLIndex;
      }
    }, {
      key: "url",
      get: function get() {
        return this.websocket ? this.websocket.url : null;
      }
    }, {
      key: "rtt",
      get: function get() {
        return this.rttRolling.mean();
      }
    }, {
      key: "request",
      value: function () {
        var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(e, t, i, n) {
          var _this72 = this;

          var s, r, o, a, c, d, l, u, h;
          return _regeneratorRuntime.wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  s = xg(6, ""), r = {
                    _id: s,
                    _type: e,
                    _message: t
                  }, o = this.websocket.connectionID, a = function a() {
                    return new tT(function (t, i) {
                      if (_this72.connectionState === TI.CONNECTED) return t();

                      var n = function n() {
                        _this72.off(gI.WS_CLOSED, s), t();
                      },
                          s = function s() {
                        _this72.off(gI.WS_CONNECTED, n), i(new VI(xT.WS_ABORT));
                      };

                      _this72.once(gI.WS_CONNECTED, n), _this72.once(gI.WS_CLOSED, s), e !== SI.PUBLISH && e !== SI.SUBSCRIBE && e !== SI.UNSUBSCRIBE && e !== SI.UNPUBLISH && e !== SI.CONTROL && e !== SI.RESTART_ICE || _this72.once(gI.DISCONNECT_P2P, function () {
                        i(new VI(xT.DISCONNECT_P2P));
                      }), e !== SI.PUBLISH && e !== SI.RESTART_ICE || _this72.once(gI.ABORT_P2P_EXECUTION, function () {
                        i(new VI(xT.DISCONNECT_P2P));
                      });
                    });
                  };
                  _context26.t0 = this.connectionState !== TI.CONNECTING && this.connectionState !== TI.RECONNECTING || e === SI.JOIN || e === SI.REJOIN;

                  if (_context26.t0) {
                    _context26.next = 5;
                    break;
                  }

                  _context26.next = 5;
                  return a();

                case 5:
                  e === SI.LEAVE && (this.websocket.unbindDcCloseEventListener(), n = !0);
                  this.websocket.sendMessage(r, !0, !1);

                  if (!n) {
                    _context26.next = 9;
                    break;
                  }

                  return _context26.abrupt("return");

                case 9:
                  c = new tT(function (i, n) {
                    var r = !1;

                    var a = function a(n, s) {
                      r = !0, i({
                        isSuccess: "success" === n,
                        message: s || {}
                      }), _this72.off(gI.WS_CLOSED, c), _this72.off(gI.WS_RECONNECTING, c), _this72.emit(gI.REQUEST_SUCCESS, e, t);
                    };

                    _this72.once("res-@".concat(s), a);

                    var c = function c() {
                      n(new VI(xT.WS_ABORT, "type: ".concat(e))), _this72.off(gI.WS_CLOSED, c), _this72.off(gI.WS_RECONNECTING, c), _this72.off("res-@".concat(s), a);
                    };

                    _this72.once(gI.WS_CLOSED, c), _this72.once(gI.WS_RECONNECTING, c), Ug(DC("SIGNAL_REQUEST_TIMEOUT")).then(function () {
                      _this72.websocket.connectionID !== o || r || (YC.warning("dc request timeout, type: ".concat(e)), _this72.emit(gI.REQUEST_TIMEOUT, e, t));
                    });
                  });
                  d = null;
                  _context26.prev = 11;
                  _context26.next = 14;
                  return c;

                case 14:
                  d = _context26.sent;
                  _context26.next = 36;
                  break;

                case 17:
                  _context26.prev = 17;
                  _context26.t1 = _context26["catch"](11);

                  if (!(this.connectionState === TI.CLOSED || e === SI.LEAVE)) {
                    _context26.next = 21;
                    break;
                  }

                  throw new VI(xT.WS_ABORT);

                case 21:
                  if (!(!this.spec.forceWaitGatewayResponse || i)) {
                    _context26.next = 25;
                    break;
                  }

                  _context26.t2 = _context26.t1.throw();
                  _context26.next = 35;
                  break;

                case 25:
                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context26.next = 29;
                    break;
                  }

                  _context26.t3 = null;
                  _context26.next = 34;
                  break;

                case 29:
                  _context26.next = 31;
                  return a();

                case 31:
                  _context26.next = 33;
                  return this.request(e, t);

                case 33:
                  _context26.t3 = _context26.sent;

                case 34:
                  _context26.t2 = _context26.t3;

                case 35:
                  return _context26.abrupt("return", _context26.t2);

                case 36:
                  if (!d.isSuccess) {
                    _context26.next = 38;
                    break;
                  }

                  return _context26.abrupt("return", d.message);

                case 38:
                  l = Number(d.message.error_code || d.message.code), u = Fv(l), h = new VI(xT.UNEXPECTED_RESPONSE, "".concat(u.desc, ": ").concat(d.message.error_str), {
                    code: l,
                    data: d.message
                  });

                  if (!("success" === u.action)) {
                    _context26.next = 43;
                    break;
                  }

                  _context26.t4 = d.message;
                  _context26.next = 68;
                  break;

                case 43:
                  YC.warning("[".concat(this.websocket.connectionID, "] unexpected response from type ").concat(e, ", error_code: ").concat(l, ", message: ").concat(u.desc, ", action: ").concat(u.action));

                  if (!(l === fI.ERR_TOO_MANY_BROADCASTERS)) {
                    _context26.next = 48;
                    break;
                  }

                  _context26.t5 = e === SI.JOIN || e === SI.REJOIN ? (this.initError = h, this.close(), h.throw()) : h.throw();
                  _context26.next = 67;
                  break;

                case 48:
                  if (!("failed" === u.action)) {
                    _context26.next = 52;
                    break;
                  }

                  _context26.t6 = h.throw();
                  _context26.next = 66;
                  break;

                case 52:
                  if (!("quit" === u.action)) {
                    _context26.next = 56;
                    break;
                  }

                  _context26.t7 = (this.initError = h, this.close(), h.throw());
                  _context26.next = 65;
                  break;

                case 56:
                  l === fI.ERR_JOIN_BY_MULTI_IP ? (this.multiIpOption = d.message.option, YC.warning("[".concat(this.clientId, "] detect multi ip, recover")), this.reconnect("recover", Cv.MULTI_IP)) : this.reconnect(u.action, Cv.SERVER_ERROR);

                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context26.next = 61;
                    break;
                  }

                  _context26.t8 = null;
                  _context26.next = 64;
                  break;

                case 61:
                  _context26.next = 63;
                  return this.request(e, t);

                case 63:
                  _context26.t8 = _context26.sent;

                case 64:
                  _context26.t7 = _context26.t8;

                case 65:
                  _context26.t6 = _context26.t7;

                case 66:
                  _context26.t5 = _context26.t6;

                case 67:
                  _context26.t4 = _context26.t5;

                case 68:
                  return _context26.abrupt("return", _context26.t4);

                case 69:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26, this, [[11, 17]]);
        }));

        function request(_x33, _x34, _x35, _x36) {
          return _request2.apply(this, arguments);
        }

        return request;
      }()
    }, {
      key: "waitMessage",
      value: function waitMessage(e, t) {
        var _this73 = this;

        return new tT(function (i) {
          var n = function n(s) {
            (!t || t(s)) && (_this73.off(e, n), i(s));
          };

          _this73.on(e, n);
        });
      }
    }, {
      key: "uploadWRTCStats",
      value: function uploadWRTCStats(e) {
        if (!this.store.sessionId) return void YC.warn("[".concat(this.clientId, "] no session id when upload wrtc stats"));
        var t = {
          lts: Date.now(),
          sid: this.store.sessionId,
          uid: this.store.intUid,
          stats: e
        };
        this.upload(RI.WRTC_STATS, t);
      }
    }, {
      key: "upload",
      value: function upload(e, t) {
        var _this74 = this;

        var i = {
          _type: e,
          _message: t
        };

        try {
          this.websocket.sendMessage(i);
        } catch (e) {
          var _t52 = DC("MAX_UPLOAD_CACHE") || 50;

          this.uploadCache.push(i), this.uploadCache.length > _t52 && this.uploadCache.splice(0, 1), this.uploadCache.length > 0 && !this.uploadCacheInterval && (this.uploadCacheInterval = window.setInterval(function () {
            if (_this74.connectionState !== TI.CONNECTED) return;

            var e = _this74.uploadCache.splice(0, 1)[0];

            0 === _this74.uploadCache.length && (window.clearInterval(_this74.uploadCacheInterval), _this74.uploadCacheInterval = void 0), _this74.upload(e._type, e._message);
          }, DC("UPLOAD_CACHE_INTERVAL") || 2e3));
        }
      }
    }, {
      key: "send",
      value: function send(e, t) {
        var i = {
          _type: e,
          _message: t
        };
        this.websocket.sendMessage(i);
      }
    }, {
      key: "init",
      value: function init(e, t) {
        var _this75 = this;

        return this.initError = void 0, this.multiIpOption = void 0, this.joinResponse = void 0, this.reconnectToken = void 0, this.openConnectionTime = void 0, new tT(function (i, n) {
          _this75.once(gI.WS_CONNECTED, function () {
            return i(_this75.joinResponse);
          }), _this75.once(gI.WS_CLOSED, function () {
            return n(_this75.initError || new VI(xT.WS_ABORT));
          }), _this75.connectionState = TI.CONNECTING, _this75.websocket.init(e).catch(n), _this75.websocket.once(Iv.FAILBACK, function () {
            void 0 === _this75.openConnectionTime && n(new VI(xT.INIT_DATACHANNEL_TIMEOUT));
          }), _this75.inflateDataTimer && window.clearInterval(_this75.inflateDataTimer), _this75.inflateDataTimer = window.setInterval(function () {
            _this75.handleInflateData();
          }, 2e4), setTimeout(function () {
            t && void 0 === _this75.openConnectionTime && (YC.debug("[".concat(_this75.clientId, "] init datachannel timeout while join with failback to websocket")), n(new VI(xT.INIT_DATACHANNEL_TIMEOUT)));
          }, DC("DC_JOIN_WITH_FAILBACK"));
        });
      }
    }, {
      key: "close",
      value: function close(e) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.inflateDataTimer && (this.handleInflateData(), window.clearInterval(this.inflateDataTimer), this.inflateDataTimer = void 0), this.reconnectToken = void 0, this.joinResponse = void 0, this._disconnectedReason = e || cg.LEAVE, this.connectionState = TI.CLOSED, YC.debug("[".concat(this.clientId, "] ") + "will close datachannel in signal"), this.websocket.close(), e === cg.FALLBACK && (this.websocket.removeAllListeners(), this.websocket = new My("gateway-".concat(this.clientId), this.spec.retryConfig, !0, this.store), this.handleWebsocketEvents());
      }
    }, {
      key: "join",
      value: function () {
        var _join2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
          var _e42, t;

          return _regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  if (this.joinResponse) {
                    _context27.next = 11;
                    break;
                  }

                  this.emit(gI.ABORT_P2P_EXECUTION);
                  _context27.next = 4;
                  return fg(this, gI.DATACHANNEL_CONNECTING);

                case 4:
                  _e42 = _context27.sent;
                  _context27.next = 7;
                  return this.request(SI.JOIN, _e42);

                case 7:
                  t = _context27.sent;

                  if (t) {
                    _context27.next = 10;
                    break;
                  }

                  return _context27.abrupt("return", (this.emit(gI.REPORT_JOIN_GATEWAY, xT.TIMEOUT, this.url || ""), !1));

                case 10:
                  this.joinResponse = t, this.emit(gI.JOIN_RESPONSE, this.joinResponse), this.reconnectToken = this.joinResponse.rejoin_token;

                case 11:
                  return _context27.abrupt("return", (this.connectionState = TI.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), !0));

                case 12:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27, this);
        }));

        function join() {
          return _join2.apply(this, arguments);
        }

        return join;
      }()
    }, {
      key: "rejoin",
      value: function () {
        var _rejoin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
          var _this76 = this;

          var e, t;
          return _regeneratorRuntime.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  if (this.reconnectToken) {
                    _context28.next = 2;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "can not rejoin, no rejoin token");

                case 2:
                  e = Sg(this, gI.REQUEST_REJOIN_INFO);
                  e.token = this.reconnectToken;
                  _context28.next = 6;
                  return this.request(SI.REJOIN, e);

                case 6:
                  t = _context28.sent;
                  return _context28.abrupt("return", !!t && (this.connectionState = TI.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), t.peers && t.peers.forEach(function (e) {
                    _this76.emit(CI.ON_USER_ONLINE, {
                      uid: e.uid
                    }), e.audio && _this76.emit(CI.ON_ADD_AUDIO_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id,
                      audio: !0,
                      ssrcId: e.audio_ssrc
                    }), e.video && _this76.emit(CI.ON_ADD_VIDEO_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id,
                      video: !0,
                      ssrcId: e.video_ssrc
                    }), e.audio_mute ? _this76.emit(CI.MUTE_AUDIO, {
                      uid: e.uid
                    }) : _this76.emit(CI.UNMUTE_AUDIO, {
                      uid: e.uid
                    }), e.video_mute ? _this76.emit(CI.MUTE_VIDEO, {
                      uid: e.uid
                    }) : _this76.emit(CI.UNMUTE_VIDEO, {
                      uid: e.uid
                    }), e.audio_enable_local ? _this76.emit(CI.ENABLE_LOCAL_AUDIO, {
                      uid: e.uid
                    }) : _this76.emit(CI.DISABLE_LOCAL_AUDIO, {
                      uid: e.uid
                    }), e.video_enable_local ? _this76.emit(CI.ENABLE_LOCAL_VIDEO, {
                      uid: e.uid
                    }) : _this76.emit(CI.DISABLE_LOCAL_VIDEO, {
                      uid: e.uid
                    }), e.audio || e.video || _this76.emit(CI.ON_REMOVE_STREAM, {
                      uid: e.uid,
                      uint_id: e.uint_id
                    });
                  }), !0));

                case 8:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28, this);
        }));

        function rejoin() {
          return _rejoin2.apply(this, arguments);
        }

        return rejoin;
      }()
    }, {
      key: "reconnect",
      value: function reconnect(e, t) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.websocket.reconnect(e, t);
      }
    }, {
      key: "handleNotification",
      value: function handleNotification(e) {
        YC.debug("[".concat(this.clientId, "] receive notification: "), e);
        var t = Fv(e.code);

        if ("success" !== t.action) {
          if ("failed" !== t.action) return "quit" === t.action ? ("ERR_REPEAT_JOIN_CHANNEL" === t.desc && this.close(cg.UID_BANNED), void this.close()) : void this.reconnect(t.action, Cv.SERVER_ERROR);
          YC.error("[".concat(this.clientId, "] ignore error: "), t.desc);
        }
      }
    }, {
      key: "handlePingPong",
      value: function handlePingPong() {
        var _this77 = this;

        if (!this.websocket || "connected" !== this.websocket.state) return;
        this.pingpongTimeoutCount > 0 && this.rttRolling.add(3e3), this.pingpongTimeoutCount += 1;
        var e = DC("PING_PONG_TIME_OUT"),
            t = Date.now();
        this.pingpongTimeoutCount >= e && (YC.warning("PINGPONG Timeout. Last Socket Message: ".concat(t - this.lastMsgTime, "ms")), t - this.lastMsgTime > DC("WEBSOCKET_TIMEOUT_MIN")) ? this.reconnect("retry", Cv.TIMEOUT) : this.request(SI.PING, void 0, !0).then(function () {
          _this77.pingpongTimeoutCount = 0;
          var e = Date.now() - t;
          _this77.rttRolling.add(e), DC("REPORT_STATS") && _this77.send(SI.PING_BACK, {
            pingpongElapse: e
          });
        }).catch(function (e) {});
      }
    }, {
      key: "handleInflateData",
      value: function handleInflateData() {
        var _this$websocket$getIn = this.websocket.getInflateData(),
            e = _this$websocket$getIn.inflateLength,
            t = _this$websocket$getIn.deflateLength;

        0 !== e && 0 !== t && this.upload(RI.WS_INFLATE_DATA_LENGTH, {
          ws_deflate_length: t,
          ws_inflate_length: e
        });
      }
    }, {
      key: "handleWebsocketEvents",
      value: function handleWebsocketEvents() {
        var _this78 = this;

        this.websocket.on(Iv.RECONNECT_WAITTING_FINISH, function (e) {
          _this78.emit(gI.WS_RECONNECT_WAITTING_FINISH, e);
        }), this.websocket.on(Iv.RECONNECT_CREATE_CONNECTION, function (e) {
          _this78.emit(gI.WS_RECONNECT_CREATE_CONNECTION, e);
        }), this.websocket.on(Iv.ON_MESSAGE, this.onWebsocketMessage), this.websocket.on(Iv.CLOSED, function () {
          _this78.connectionState = TI.CLOSED;
        }), this.websocket.on(Iv.FAILED, function () {
          _this78._disconnectedReason = cg.NETWORK_ERROR, _this78.connectionState = TI.CLOSED;
        }), this.websocket.on(Iv.RECONNECTING, function (e) {
          _this78._websocketReconnectReason = e, _this78.joinResponse = void 0, _this78.connectionState === TI.CONNECTED ? _this78.connectionState = TI.RECONNECTING : _this78.connectionState = TI.CONNECTING;
        }), this.websocket.on(Iv.WILL_RECONNECT, function (e, t) {
          if (Sg(_this78, gI.IS_P2P_DISCONNECTED) && "retry" === e) return YC.debug("".concat(_this78.clientId, " reconnect mode is retry, but p2p lost, change to tryNext")), _this78.reconnectToken = void 0, _this78.emit(gI.NEED_RENEW_SESSION), _this78.emit(gI.DISCONNECT_P2P), t("tryNext");
          "retry" !== e && (YC.debug("".concat(_this78.clientId, " websockt will_connect event, renewSession reconnectMode is ").concat(e)), _this78.reconnectToken = void 0, _this78.emit(gI.NEED_RENEW_SESSION), _this78.emit(gI.DISCONNECT_P2P)), t(e);
        }), this.websocket.on(Iv.CONNECTED, function () {
          _this78.openConnectionTime = Date.now(), _this78.reconnectToken ? _this78.rejoin().catch(function (e) {
            YC.warning("[".concat(_this78.clientId, "] rejoin failed ").concat(e)), _this78.reconnect("tryNext", Cv.SERVER_ERROR);
          }) : _this78.join().catch(function (e) {
            if (_this78.emit(gI.REPORT_JOIN_GATEWAY, e.message || e.code, _this78.url || ""), e instanceof VI && e.code === xT.UNEXPECTED_RESPONSE && e.data.code === fI.ERR_NO_AUTHORIZED) return YC.warning("[".concat(_this78.clientId, "] reconnect no authorized, recover")), void _this78.reconnect("recover", Cv.SERVER_ERROR);
            YC.error("[".concat(_this78.clientId, "] join gateway request failed"), e.toString()), _this78.spec.forceWaitGatewayResponse ? _this78.reconnect("tryNext", Cv.SERVER_ERROR) : (_this78.initError = e, _this78.close());
          });
        }), this.websocket.on(Iv.REQUEST_NEW_URLS, function (e, t) {
          fg(_this78, gI.REQUEST_RECOVER, _this78.multiIpOption).then(e).catch(t);
        }), this.websocket.on(Iv.ON_TOKEN_PRIVILEGE_DID_EXPIRE, function () {
          _this78.emit(CI.ON_TOKEN_PRIVILEGE_DID_EXPIRE);
        }), this.websocket.on(Iv.TO_CONNECT_DATACHANNEL, /*#__PURE__*/function () {
          var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee29$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    return _context29.abrupt("return", fg(_this78, gI.DATACHANNEL_PRECONNECT, e).then(t).catch(i));

                  case 1:
                  case "end":
                    return _context29.stop();
                }
              }
            }, _callee29);
          }));

          return function (_x37, _x38, _x39) {
            return _ref21.apply(this, arguments);
          };
        }()), this.websocket.on(Iv.FAILBACK, function () {
          void 0 !== _this78.openConnectionTime && _this78.emit(gI.DATACHANNEL_FAILBACK);
        });
      }
    }]);

    return Uy;
  }(ig);

  var xy = /*#__PURE__*/function (_ig8) {
    _inherits(xy, _ig8);

    var _super14 = _createSuper(xy);

    function xy(e, t) {
      var _this79;

      _classCallCheck(this, xy);

      _this79 = _super14.call(this), nh(_assertThisInitialized(_this79), "signal", void 0), nh(_assertThisInitialized(_this79), "token", void 0), nh(_assertThisInitialized(_this79), "tokenTimeout", void 0), nh(_assertThisInitialized(_this79), "tokenInterval", void 0), nh(_assertThisInitialized(_this79), "_sequence", 0), nh(_assertThisInitialized(_this79), "userMap", new Map()), nh(_assertThisInitialized(_this79), "encoder", new TextEncoder()), _this79.signal = e, _this79.token = t;

      var i = function i() {
        _this79.signal.connectionState === TI.CONNECTED && _this79.check(), 0 === _this79.userMap.size ? _this79.tokenInterval = window.setTimeout(i, 1e3) : _this79.tokenInterval = window.setTimeout(i, 3 * DC("P2P_TOKEN_INTERVAL"));
      };

      i();
      return _this79;
    }

    _createClass(xy, [{
      key: "send",
      value: function () {
        var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e, t, i, n, s) {
          var _this80 = this;

          var r, o, a, c, d, l;
          return _regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  if (!(0 === this.userMap.size)) {
                    _context30.next = 2;
                    break;
                  }

                  return _context30.abrupt("return");

                case 2:
                  c = Array.from(MI(r = this.userMap).call(r))[0].token;
                  "string" != typeof t && (t = JSON.stringify(t)), n = null !== (o = n) && void 0 !== o ? o : xg(6, ""), s = null !== (a = s) && void 0 !== a ? a : this._sequence++;
                  d = {
                    _id: n,
                    _type: e,
                    _seq: s,
                    _message: t,
                    token: "".concat(this.token, "_").concat(c)
                  };
                  DC("SHOW_P2P_LOG") && YC.debug("send message", d, "noNeedResponse : ".concat(i));
                  this.splitMessage(JSON.stringify(d)).forEach(function (e) {
                    _this80.signal.request(SI.DATA_STREAM, {
                      payload: Pg(_this80.encoder.encode(e))
                    });
                  });
                  l = new tT(function (t, s) {
                    var r = window.setTimeout(function () {
                      _this80.off("res-@".concat(n, "_ack"), o), _this80.off("res-@".concat(n), c), _this80.off(Nv.ABORT, a), YC.debug("[external-signal] request timeout, type: ".concat(e, ", requestId: ").concat(n)), 0 === _this80.userMap.size ? s(new VT(xT.INVALID_REMOTE_USER)) : s(new VT(xT.TIMEOUT));
                    }, DC("EXTERNAL_SIGNAL_REQUEST_TIMEOUT")),
                        o = function o() {
                      r && window.clearTimeout(r), _this80.off(Nv.ABORT, a), i && t();
                    },
                        a = function a() {
                      r && window.clearTimeout(r), _this80.off("res-@".concat(n, "_ack"), o), _this80.off("res-@".concat(n), c), s(new VT(xT.EXTERNAL_SIGNAL_ABORT, "type: ".concat(e, ", requestId: ").concat(n)));
                    };

                    _this80.once(Nv.ABORT, a), _this80.once("res-@".concat(n, "_ack"), o);

                    var c = function c(i, _c6) {
                      l = !0, r && window.clearTimeout(r), _this80.off("res-@".concat(n, "_ack"), o), _this80.off(Nv.ABORT, a), "success" === i ? t(_c6) : s(new VT(xT.P2P_MESSAGE_FAILED, "request ".concat(e, " failed, requestId: ").concat(n)));
                    };

                    var l = !1;
                    i || (_this80.once("res-@".concat(n), c), Ug(DC("SIGNAL_REQUEST_TIMEOUT")).then(function () {
                      l || YC.warning("external_signal request timeout, type: ".concat(e, ", requestId: ").concat(n, ", ").concat(d));
                    }));
                  });
                  _context30.prev = 8;
                  _context30.next = 11;
                  return l;

                case 11:
                  return _context30.abrupt("return", _context30.sent);

                case 14:
                  _context30.prev = 14;
                  _context30.t0 = _context30["catch"](8);

                  if (!(_context30.t0.code === xT.TIMEOUT)) {
                    _context30.next = 20;
                    break;
                  }

                  _context30.next = 19;
                  return this.send(e, t, i, n, s);

                case 19:
                  return _context30.abrupt("return", _context30.sent);

                case 20:
                  throw _context30.t0;

                case 21:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30, this, [[8, 14]]);
        }));

        function send(_x40, _x41, _x42, _x43, _x44) {
          return _send.apply(this, arguments);
        }

        return send;
      }()
    }, {
      key: "onMessage",
      value: function onMessage(e) {
        var t;
        var _e43 = e,
            i = _e43._uid;
        var n,
            s = this.userMap.get(i);
        if (s) n = s.splitMessageMap;else {
          if (this.userMap.size > 0 || !("_type" in e) || e._type !== Ov.CHECK) return;
          var _e44 = e,
              _t53 = _e44.token;
          n = new Map(), s = {
            uid: i,
            isStart: !0,
            token: _t53,
            splitMessageMap: n,
            nextExpectedSequenceNumber: 0,
            receivedMessagesMap: new Map()
          }, this.userMap.set(i, s), this.signal.emit(CI.ON_USER_ONLINE, {
            uid: i
          }), this.handleUserOnline();
        }

        if ("id" in e && "total" in e) {
          var r;

          var _e45 = e,
              _t54 = _e45.id,
              _s15 = _e45.total,
              _o8 = null !== (r = n.get(_t54)) && void 0 !== r ? r : [];

          if (_o8.push(e), n.has(_t54) || n.set(_t54, _o8), _o8.length !== _s15) return;
          {
            var _s16 = Zh(_o8).call(_o8, function (e, t) {
              return e.index - t.index;
            }).map(function (e) {
              return e.payload;
            }).join("");

            n.delete(_t54), (e = JSON.parse(_s16))._uid = i;
          }
        }

        var _e46 = e,
            o = _e46._type,
            a = _e46.token;
        if (bn(t = [Ov.ACK, Ov.CHECK]).call(t, o)) return o === Ov.CHECK && this.handleCheckToken(s, a), void this.receiveMessage(e);
        a === "".concat(s.token, "_").concat(this.token) ? this.handleReceivedMessage(e) : YC.debug('Receive unexpected message", '.concat(a, ", cur_token: ").concat(s.token, "_").concat(this.token), e);
      }
    }, {
      key: "check",
      value: function check() {
        var e = {
          _id: xg(6, ""),
          token: this.token,
          _type: Ov.CHECK
        };
        DC("SHOW_P2P_LOG") && YC.debug("send message", e), this.signal.request(SI.DATA_STREAM, {
          payload: Pg(this.encoder.encode(JSON.stringify(e)))
        });
      }
    }, {
      key: "ack",
      value: function ack(e) {
        var t = {
          _id: e,
          _type: Ov.ACK,
          token: this.token
        };
        DC("SHOW_P2P_LOG") && YC.debug("send message", t), this.signal.request(SI.DATA_STREAM, {
          payload: Pg(this.encoder.encode(JSON.stringify(t)))
        });
      }
    }, {
      key: "response",
      value: function response(e, t, i) {
        this.send(Ov.RESPONSE, JSON.stringify({
          success: !i,
          message: t
        }), !0, e);
      }
    }, {
      key: "handleReceivedMessage",
      value: function handleReceivedMessage(e) {
        var _this81 = this;

        var t = function t() {
          _this81.userMap.forEach(function (e) {
            var t = e.receivedMessagesMap,
                i = e.nextExpectedSequenceNumber;

            for (; t.has(i);) {
              var _n26 = t.get(i);

              t.delete(i), _this81.receiveMessage(_n26), e.nextExpectedSequenceNumber++;
            }
          });
        };

        if (!e) return void t();
        var i = e._uid,
            n = e._seq,
            s = this.userMap.get(i),
            r = s.receivedMessagesMap,
            o = s.isStart,
            a = s.nextExpectedSequenceNumber;
        if (n < a) return this.ack(e._id), void YC.debug("[external-signal] receive old message, seq: ".concat(n, ", ").concat(e._message));
        r.set(n, e), o && n === a && (this.receiveMessage(e), r.delete(a), s.nextExpectedSequenceNumber++, t());
      }
    }, {
      key: "receiveMessage",
      value: function receiveMessage(e) {
        var _this82 = this;

        var t = e._id,
            i = e._type,
            n = e._message,
            s = e._uid;

        if (DC("SHOW_P2P_LOG") && YC.debug("receive message", e), t) {
          var r;

          switch (e._type !== Ov.ACK && (n && (r = JSON.parse(n)), this.ack(e._id)), e._type) {
            case Ov.CANDIDATE:
            case Ov.CONTROL:
              this.signal.emit(i, r, s);
              break;

            case Ov.PUBLISH:
            case Ov.UNPUBLISH:
            case Ov.RESTART_ICE:
            case Ov.CALL:
              r.uid = s, fg(this.signal, i, r).then(function (t) {
                _this82.response(e._id, t);
              }).catch(function () {
                _this82.response(e._id, void 0, !0);
              });
              break;

            case Ov.ACK:
              this.getListeners("res-@".concat(t, "_ack")).length > 0 && this.emit("res-@".concat(t, "_ack"));
              break;

            case Ov.RESPONSE:
              {
                var _r9 = r,
                    _e47 = _r9.success,
                    _i38 = _r9.message;
                this.emit("res-@".concat(t), _e47 ? "success" : "failed", _i38);
                break;
              }
          }
        }
      }
    }, {
      key: "splitMessage",
      value: function splitMessage(e) {
        if (e.length < xy.MAX_MESSAGE_SIZE) return [e];

        var t = [],
            _JSON$parse = JSON.parse(e),
            i = _JSON$parse.remoteToken,
            n = xg(6, "");

        var s = 0,
            r = 800;
        var o = Math.ceil(e.length / r);

        for (; e.length > 0;) {
          s++;
          var a = {
            id: n,
            index: s,
            total: o,
            payload: e.slice(0, r),
            token: "".concat(this.token, "_").concat(i)
          };
          JSON.stringify(a).length > xy.MAX_MESSAGE_SIZE ? r -= 50 : (t.push(a), e = e.slice(r));
        }

        return t.map(function (e) {
          return JSON.stringify(e);
        });
      }
    }, {
      key: "handleCheckToken",
      value: function handleCheckToken(e, t) {
        var _this83 = this;

        return e.token !== t ? (YC.debug("token changed, from ".concat(e.token, " to ").concat(t)), this.reset(e.uid, t), !1) : (this.tokenTimeout && (window.clearTimeout(this.tokenTimeout), this.tokenTimeout = void 0), this.tokenTimeout = window.setTimeout(function () {
          YC.debug("token timeout, ".concat(t)), _this83.reset(e.uid);
        }, DC("MAX_P2P_TIMEOUT")), !0);
      }
    }, {
      key: "handleUserOnline",
      value: function () {
        var _handleUserOnline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _context31.next = 2;
                  return fg(this.signal, Ov.CALL, void 0);

                case 2:
                  e = _context31.sent;
                  _context31.next = 5;
                  return this.send(Ov.CALL, e);

                case 5:
                  t = _context31.sent;
                  this.signal.emit(gI.P2P_CONNECTION, t, !0);

                case 7:
                case "end":
                  return _context31.stop();
              }
            }
          }, _callee31, this);
        }));

        function handleUserOnline() {
          return _handleUserOnline.apply(this, arguments);
        }

        return handleUserOnline;
      }()
    }, {
      key: "reset",
      value: function () {
        var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  i = this.userMap.get(e);
                  i && (this.emit(Nv.ABORT), this.signal.emit(CI.ON_USER_OFFLINE, {
                    uid: i.uid,
                    reason: Lv.P2P_TOKEN_CHANGED
                  }), this._sequence = 0, this.userMap.clear(), t || (YC.debug("change local token from ".concat(t, " to ").concat(t)), this.token = xg(6, "")));

                case 2:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32, this);
        }));

        function reset(_x45, _x46) {
          return _reset.apply(this, arguments);
        }

        return reset;
      }()
    }, {
      key: "clear",
      value: function clear() {
        this._sequence = 0, this.userMap.clear(), this.tokenInterval && window.clearTimeout(this.tokenInterval), this.tokenInterval = void 0, this.tokenTimeout && window.clearTimeout(this.tokenTimeout), this.tokenTimeout = void 0, this.emit(Nv.ABORT);
      }
    }]);

    return xy;
  }(ig);

  nh(xy, "MAX_SIZE", 1), nh(xy, "MAX_MESSAGE_SIZE", 1024);

  var Vy = /*#__PURE__*/function (_ig9) {
    _inherits(Vy, _ig9);

    var _super15 = _createSuper(Vy);

    function Vy(e, t) {
      var _this84;

      _classCallCheck(this, Vy);

      _this84 = _super15.call(this), nh(_assertThisInitialized(_this84), "_disconnectedReason", void 0), nh(_assertThisInitialized(_this84), "_websocketReconnectReason", void 0), nh(_assertThisInitialized(_this84), "_connectionState", TI.CLOSED), nh(_assertThisInitialized(_this84), "reconnectToken", void 0), nh(_assertThisInitialized(_this84), "p2pToken", void 0), nh(_assertThisInitialized(_this84), "websocket", void 0), nh(_assertThisInitialized(_this84), "openConnectionTime", void 0), nh(_assertThisInitialized(_this84), "clientId", void 0), nh(_assertThisInitialized(_this84), "lastMsgTime", Date.now()), nh(_assertThisInitialized(_this84), "uploadCache", []), nh(_assertThisInitialized(_this84), "uploadCacheInterval", void 0), nh(_assertThisInitialized(_this84), "rttRolling", new dS(5)), nh(_assertThisInitialized(_this84), "pingpongTimer", void 0), nh(_assertThisInitialized(_this84), "pingpongTimeoutCount", 0), nh(_assertThisInitialized(_this84), "joinResponse", void 0), nh(_assertThisInitialized(_this84), "multiIpOption", void 0), nh(_assertThisInitialized(_this84), "initError", void 0), nh(_assertThisInitialized(_this84), "spec", void 0), nh(_assertThisInitialized(_this84), "store", void 0), nh(_assertThisInitialized(_this84), "_external_signal", void 0), nh(_assertThisInitialized(_this84), "onWebsocketMessage", function (e) {
        if (e.data instanceof ArrayBuffer) return void _this84.emit(gI.ON_BINARY_DATA, e.data);
        var t = JSON.parse(e.data);

        if (_this84.lastMsgTime = Date.now(), Object.prototype.hasOwnProperty.call(t, "_id")) {
          var _e48 = "res-@".concat(t._id);

          _this84.emit(_e48, t._result, t._message);
        } else if (Object.prototype.hasOwnProperty.call(t, "_type")) {
          switch (t._type) {
            case CI.ON_DATA_STREAM:
              return void _this84.handleDataStream(t._message);

            case CI.MUTE_AUDIO:
            case CI.MUTE_VIDEO:
            case CI.ON_P2P_LOST:
            case CI.ON_USER_ONLINE:
              return;

            case CI.ON_USER_OFFLINE:
              var _e49 = t._message.uid;
              return YC.debug("[".concat(_this84.clientId, "] user-offline uid: ").concat(_e49)), void _this84._external_signal.reset(_e49);
          }

          if (_this84.emit(t._type, t._message), t._type === CI.ON_NOTIFICATION && _this84.handleNotification(t._message), t._type === CI.ON_USER_BANNED) switch (t._message.error_code) {
            case 14:
              _this84.close(cg.UID_BANNED);

              break;

            case 15:
              _this84.close(cg.IP_BANNED);

              break;

            case 16:
              _this84.close(cg.CHANNEL_BANNED);

          }
          if (t._type === CI.ON_USER_LICENSE_BANNED) switch (t._message.error_code) {
            case fI.ERR_LICENSE_MISSING:
              _this84.close(cg.LICENSE_MISSING);

              break;

            case fI.ERR_LICENSE_EXPIRED:
              _this84.close(cg.LICENSE_EXPIRED);

              break;

            case fI.ERR_LICENSE_MINUTES_EXCEEDED:
              _this84.close(cg.LICENSE_MINUTES_EXCEEDED);

              break;

            case fI.ERR_LICENSE_PERIOD_INVALID:
              _this84.close(cg.LICENSE_PERIOD_INVALID);

              break;

            case fI.ERR_LICENSE_MULTIPLE_SDK_SERVICE:
              _this84.close(cg.LICENSE_MULTIPLE_SDK_SERVICE);

              break;

            case fI.ERR_LICENSE_ILLEGAL:
              _this84.close(cg.LICENSE_ILLEGAL);

              break;

            default:
              _this84.close();

          }
        }
      }), _this84.clientId = e.clientId, _this84.spec = e, _this84.store = t, _this84.websocket = new Zv("gateway-".concat(_this84.clientId), _this84.spec.retryConfig, !0, DC("JOIN_GATEWAY_USE_DUAL_DOMAIN"), DC("JOIN_GATEWAY_USE_443PORT_ONLY"), t), _this84.handleWebsocketEvents(), window.addEventListener("offline", function () {
        _this84.connectionState === TI.CONNECTED && _this84.reconnect("retry", lg.OFFLINE);
      }), _this84.p2pToken = xg(6, ""), _this84._external_signal = new xy(_assertThisInitialized(_this84), _this84.p2pToken);
      return _this84;
    }

    _createClass(Vy, [{
      key: "connectionState",
      get: function get() {
        return this._connectionState;
      },
      set: function set(e) {
        e !== this._connectionState && (this._connectionState = e, e === TI.CONNECTED ? this.emit(gI.WS_CONNECTED) : e === TI.RECONNECTING ? this.emit(gI.WS_RECONNECTING, this._websocketReconnectReason) : e === TI.CLOSED && this.emit(gI.WS_CLOSED, this._disconnectedReason));
      }
    }, {
      key: "currentURLIndex",
      get: function get() {
        return this.websocket.currentURLIndex;
      }
    }, {
      key: "url",
      get: function get() {
        return this.websocket && this.websocket.url || null;
      }
    }, {
      key: "rtt",
      get: function get() {
        return this.rttRolling.mean();
      }
    }, {
      key: "request",
      value: function () {
        var _request3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e, t, i, n) {
          var _this85 = this;

          var s, r, o, a, c, d, l, u, h;
          return _regeneratorRuntime.wrap(function _callee33$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  s = xg(6, ""), r = {
                    _id: s,
                    _type: e,
                    _message: t
                  }, o = this.websocket.connectionID, a = function a() {
                    return new tT(function (e, t) {
                      if (_this85.connectionState === TI.CONNECTED) return e();

                      var i = function i() {
                        _this85.off(gI.WS_CLOSED, n), e();
                      },
                          n = function n() {
                        _this85.off(gI.WS_CONNECTED, i), t(new VT(xT.WS_ABORT));
                      };

                      _this85.once(gI.WS_CONNECTED, i), _this85.once(gI.WS_CLOSED, n);
                    });
                  };
                  _context33.t0 = this.connectionState !== TI.CONNECTING && this.connectionState !== TI.RECONNECTING || e === SI.JOIN || e === SI.REJOIN;

                  if (_context33.t0) {
                    _context33.next = 5;
                    break;
                  }

                  _context33.next = 5;
                  return a();

                case 5:
                  this.websocket.sendMessage(r, !0);

                  if (!n) {
                    _context33.next = 8;
                    break;
                  }

                  return _context33.abrupt("return");

                case 8:
                  c = new tT(function (i, n) {
                    var r = !1;

                    var a = function a(n, s) {
                      r = !0, i({
                        isSuccess: "success" === n,
                        message: s || {}
                      }), _this85.off(gI.WS_CLOSED, c), _this85.off(gI.WS_RECONNECTING, c), _this85.emit(gI.REQUEST_SUCCESS, e, t);
                    };

                    _this85.once("res-@".concat(s), a);

                    var c = function c() {
                      n(new VT(xT.WS_ABORT, "type: ".concat(e))), _this85.off(gI.WS_CLOSED, c), _this85.off(gI.WS_RECONNECTING, c), _this85.off("res-@".concat(s), a);
                    };

                    _this85.once(gI.WS_CLOSED, c), _this85.once(gI.WS_RECONNECTING, c), Ug(DC("SIGNAL_REQUEST_TIMEOUT")).then(function () {
                      _this85.websocket.connectionID !== o || r || (YC.warning("[".concat(_this85.clientId, "] ws request timeout, type: ").concat(e)), _this85.emit(gI.REQUEST_TIMEOUT, e, t));
                    });
                  });
                  d = null;
                  _context33.prev = 10;
                  _context33.next = 13;
                  return c;

                case 13:
                  d = _context33.sent;
                  _context33.next = 35;
                  break;

                case 16:
                  _context33.prev = 16;
                  _context33.t1 = _context33["catch"](10);

                  if (!(this.connectionState === TI.CLOSED || e === SI.LEAVE)) {
                    _context33.next = 20;
                    break;
                  }

                  throw new VT(xT.WS_ABORT);

                case 20:
                  if (!(!this.spec.forceWaitGatewayResponse || i)) {
                    _context33.next = 24;
                    break;
                  }

                  _context33.t2 = _context33.t1.throw();
                  _context33.next = 34;
                  break;

                case 24:
                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context33.next = 28;
                    break;
                  }

                  _context33.t3 = null;
                  _context33.next = 33;
                  break;

                case 28:
                  _context33.next = 30;
                  return a();

                case 30:
                  _context33.next = 32;
                  return this.request(e, t);

                case 32:
                  _context33.t3 = _context33.sent;

                case 33:
                  _context33.t2 = _context33.t3;

                case 34:
                  return _context33.abrupt("return", _context33.t2);

                case 35:
                  if (!d.isSuccess) {
                    _context33.next = 37;
                    break;
                  }

                  return _context33.abrupt("return", d.message);

                case 37:
                  l = Number(d.message.error_code || d.message.code), u = Fv(l), h = new VT(xT.UNEXPECTED_RESPONSE, "".concat(u.desc, ": ").concat(d.message.error_str), {
                    code: l,
                    data: d.message
                  });

                  if (!("success" === u.action)) {
                    _context33.next = 42;
                    break;
                  }

                  _context33.t4 = d.message;
                  _context33.next = 67;
                  break;

                case 42:
                  YC.warning("[".concat(this.clientId, "] [").concat(this.websocket.connectionID, "] unexpected response from type ").concat(e, ", error_code: ").concat(l, ", message: ").concat(u.desc, ", action: ").concat(u.action));

                  if (!(l === fI.ERR_TOO_MANY_BROADCASTERS)) {
                    _context33.next = 47;
                    break;
                  }

                  _context33.t5 = e === SI.JOIN || e === SI.REJOIN ? (this.initError = h, this.close(), h.throw()) : h.throw();
                  _context33.next = 66;
                  break;

                case 47:
                  if (!("failed" === u.action)) {
                    _context33.next = 51;
                    break;
                  }

                  _context33.t6 = h.throw();
                  _context33.next = 65;
                  break;

                case 51:
                  if (!("quit" === u.action)) {
                    _context33.next = 55;
                    break;
                  }

                  _context33.t7 = (this.initError = h, this.close(), h.throw());
                  _context33.next = 64;
                  break;

                case 55:
                  l === fI.ERR_JOIN_BY_MULTI_IP ? (this.multiIpOption = d.message.option, YC.warning("[".concat(this.clientId, "] detect multi ip, recover")), this.reconnect("recover", lg.MULTI_IP)) : this.reconnect(u.action, lg.SERVER_ERROR);

                  if (!(e === SI.JOIN || e === SI.REJOIN)) {
                    _context33.next = 60;
                    break;
                  }

                  _context33.t8 = null;
                  _context33.next = 63;
                  break;

                case 60:
                  _context33.next = 62;
                  return this.request(e, t);

                case 62:
                  _context33.t8 = _context33.sent;

                case 63:
                  _context33.t7 = _context33.t8;

                case 64:
                  _context33.t6 = _context33.t7;

                case 65:
                  _context33.t5 = _context33.t6;

                case 66:
                  _context33.t4 = _context33.t5;

                case 67:
                  return _context33.abrupt("return", _context33.t4);

                case 68:
                case "end":
                  return _context33.stop();
              }
            }
          }, _callee33, this, [[10, 16]]);
        }));

        function request(_x47, _x48, _x49, _x50) {
          return _request3.apply(this, arguments);
        }

        return request;
      }()
    }, {
      key: "waitMessage",
      value: function waitMessage(e, t) {
        var _this86 = this;

        return new tT(function (i) {
          var n = function n(s) {
            (!t || t(s)) && (_this86.off(e, n), i(s));
          };

          _this86.on(e, n);
        });
      }
    }, {
      key: "uploadWRTCStats",
      value: function uploadWRTCStats(e) {
        if (!this.store.sessionId) return void YC.warn("[".concat(this.clientId, "] no session id when upload wrtc stats"));
        var t = {
          lts: Date.now(),
          sid: this.store.sessionId,
          uid: this.store.intUid,
          stats: e
        };
        this.upload(RI.WRTC_STATS, t);
      }
    }, {
      key: "upload",
      value: function upload(e, t) {
        var _this87 = this;

        var i = {
          _type: e,
          _message: t
        };

        try {
          this.websocket.sendMessage(i);
        } catch (e) {
          var _t55 = DC("MAX_UPLOAD_CACHE") || 50;

          this.uploadCache.push(i), this.uploadCache.length > _t55 && this.uploadCache.splice(0, 1), this.uploadCache.length > 0 && !this.uploadCacheInterval && (this.uploadCacheInterval = window.setInterval(function () {
            if (_this87.connectionState !== TI.CONNECTED) return;

            var e = _this87.uploadCache.splice(0, 1)[0];

            0 === _this87.uploadCache.length && (window.clearInterval(_this87.uploadCacheInterval), _this87.uploadCacheInterval = void 0), _this87.upload(e._type, e._message);
          }, DC("UPLOAD_CACHE_INTERVAL") || 2e3));
        }
      }
    }, {
      key: "send",
      value: function send(e, t) {
        var i = {
          _type: e,
          _message: t
        };
        this.websocket.sendMessage(i);
      }
    }, {
      key: "sendExtensionMessage",
      value: function () {
        var _sendExtensionMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(e, t, i) {
          return _regeneratorRuntime.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  _context34.next = 2;
                  return this._external_signal.send(e, t, i);

                case 2:
                  return _context34.abrupt("return", _context34.sent);

                case 3:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34, this);
        }));

        function sendExtensionMessage(_x51, _x52, _x53) {
          return _sendExtensionMessage.apply(this, arguments);
        }

        return sendExtensionMessage;
      }()
    }, {
      key: "init",
      value: function init(e) {
        var _this88 = this;

        return this.initError = void 0, this.multiIpOption = void 0, this.joinResponse = void 0, this.reconnectToken = void 0, this.openConnectionTime = void 0, new tT(function (t, i) {
          _this88.once(gI.WS_CONNECTED, function () {
            return t(_this88.joinResponse);
          }), _this88.once(gI.WS_CLOSED, function () {
            return i(_this88.initError || new VT(xT.WS_ABORT));
          }), _this88.connectionState = TI.CONNECTING, _this88.websocket.init(e).catch(i);
        });
      }
    }, {
      key: "close",
      value: function close(e) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.reconnectToken = void 0, this.joinResponse = void 0, this._external_signal.clear(), this._disconnectedReason = e || cg.LEAVE, this.connectionState = TI.CLOSED, YC.debug("[".concat(this.clientId, "] ") + "will close websocket in signal"), this.websocket.close(), e === cg.FALLBACK && (this.websocket.removeAllListeners(), this.websocket = new Zv("gateway-".concat(this.clientId), this.spec.retryConfig, !0, DC("JOIN_GATEWAY_USE_DUAL_DOMAIN"), DC("JOIN_GATEWAY_USE_443PORT_ONLY"), this.store), this.handleWebsocketEvents()), this.p2pToken = xg(6, ""), this._external_signal.clear(), this._external_signal = new xy(this, this.p2pToken);
      }
    }, {
      key: "join",
      value: function () {
        var _join3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
          var _e50, t;

          return _regeneratorRuntime.wrap(function _callee35$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  if (this.joinResponse) {
                    _context35.next = 11;
                    break;
                  }

                  this.emit(gI.ABORT_P2P_EXECUTION);
                  _context35.next = 4;
                  return fg(this, gI.REQUEST_JOIN_INFO);

                case 4:
                  _e50 = _context35.sent;
                  _context35.next = 7;
                  return this.request(SI.JOIN, _e50);

                case 7:
                  t = _context35.sent;

                  if (t) {
                    _context35.next = 10;
                    break;
                  }

                  return _context35.abrupt("return", (this.emit(gI.REPORT_JOIN_GATEWAY, xT.TIMEOUT, this.url || ""), !1));

                case 10:
                  this.joinResponse = t, this.emit(gI.JOIN_RESPONSE, this.joinResponse), this.reconnectToken = this.joinResponse.rejoin_token;

                case 11:
                  return _context35.abrupt("return", (this.connectionState = TI.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), !0));

                case 12:
                case "end":
                  return _context35.stop();
              }
            }
          }, _callee35, this);
        }));

        function join() {
          return _join3.apply(this, arguments);
        }

        return join;
      }()
    }, {
      key: "reconnect",
      value: function reconnect(e, t) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.websocket.reconnect(e, t);
      }
    }, {
      key: "handleDataStream",
      value: function handleDataStream(e) {
        try {
          var t;

          var _i39 = Dg(e.payload),
              _n27 = new TextDecoder().decode(_i39),
              s = JSON.parse(_n27);

          "total" in s && "id" in s || bn(t = Object.values(Ov)).call(t, s._type) ? (s._uid = e.uid, this._external_signal.onMessage(s)) : this.emit(CI.ON_DATA_STREAM, e);
        } catch (t) {
          this.emit(CI.ON_DATA_STREAM, e);
        }
      }
    }, {
      key: "handleNotification",
      value: function handleNotification(e) {
        YC.debug("[".concat(this.clientId, "] receive notification: "), e);
        var t = Fv(e.code);

        if ("success" !== t.action) {
          if ("failed" !== t.action) return "quit" === t.action ? ("ERR_REPEAT_JOIN_CHANNEL" === t.desc && this.close(cg.UID_BANNED), void this.close()) : void this.reconnect(t.action, lg.SERVER_ERROR);
          YC.error("[".concat(this.clientId, "] ignore error: "), t.desc);
        }
      }
    }, {
      key: "handlePingPong",
      value: function handlePingPong() {
        var _this89 = this;

        if (!this.websocket || "connected" !== this.websocket.state) return;
        this.pingpongTimeoutCount > 0 && this.rttRolling.add(3e3), this.pingpongTimeoutCount += 1;
        var e = DC("PING_PONG_TIME_OUT"),
            t = Date.now();
        this.pingpongTimeoutCount >= e && (YC.warning("[".concat(this.clientId, "] PINGPONG Timeout. Last Socket Message: ").concat(t - this.lastMsgTime, "ms")), t - this.lastMsgTime > DC("WEBSOCKET_TIMEOUT_MIN")) ? this.reconnect("retry", lg.TIMEOUT) : this.request(SI.PING, void 0, !0).then(function () {
          _this89.pingpongTimeoutCount = 0;
          var e = Date.now() - t;
          _this89.rttRolling.add(e), DC("REPORT_STATS") && _this89.send(SI.PING_BACK, {
            pingpongElapse: e
          });
        }).catch(function (e) {});
      }
    }, {
      key: "handleWebsocketEvents",
      value: function handleWebsocketEvents() {
        var _this90 = this;

        this.websocket.on(yI.RECONNECT_WAITTING_FINISH, function (e) {
          _this90.emit(gI.WS_RECONNECT_WAITTING_FINISH, e);
        }), this.websocket.on(yI.RECONNECT_CREATE_CONNECTION, function (e) {
          _this90.emit(gI.WS_RECONNECT_CREATE_CONNECTION, e);
        }), this.websocket.on(yI.ON_MESSAGE, this.onWebsocketMessage), this.websocket.on(yI.CLOSED, function () {
          _this90.connectionState = TI.CLOSED;
        }), this.websocket.on(yI.FAILED, function () {
          _this90._disconnectedReason = cg.NETWORK_ERROR, _this90.connectionState = TI.CLOSED;
        }), this.websocket.on(yI.RECONNECTING, function (e) {
          _this90._websocketReconnectReason = e, _this90.joinResponse = void 0, _this90.connectionState === TI.CONNECTED ? _this90.connectionState = TI.RECONNECTING : _this90.connectionState = TI.CONNECTING;
        }), this.websocket.on(yI.WILL_RECONNECT, function (e, t, i) {
          "retry" !== e ? (YC.debug("".concat(_this90.clientId, " websocket will_connect event, renewSession reconnectMode is ").concat(e)), _this90.reconnectToken = void 0, _this90.emit(gI.NEED_RENEW_SESSION)) : YC.debug("".concat(_this90.clientId, " reconnect mode is retry, no need to renew session")), i(e);
        }), this.websocket.on(yI.CONNECTED, function () {
          _this90.openConnectionTime = Date.now(), _this90.join().catch(function (e) {
            if (_this90.emit(gI.REPORT_JOIN_GATEWAY, e.message || e.code, _this90.url || ""), e instanceof VT && e.code === xT.UNEXPECTED_RESPONSE && e.data.code === fI.ERR_NO_AUTHORIZED) return YC.warning("[".concat(_this90.clientId, "] reconnect no authorized, recover")), void _this90.reconnect("recover", lg.SERVER_ERROR);
            YC.error("[".concat(_this90.clientId, "] join gateway request failed"), e.toString()), _this90.spec.forceWaitGatewayResponse ? _this90.reconnect("tryNext", lg.SERVER_ERROR) : (_this90.initError = e, _this90.close());
          });
        }), this.websocket.on(yI.REQUEST_NEW_URLS, function (e, t) {
          fg(_this90, gI.REQUEST_RECOVER, _this90.multiIpOption).then(e).catch(t);
        }), this.websocket.on(yI.ON_TOKEN_PRIVILEGE_DID_EXPIRE, function () {
          _this90.emit(CI.ON_TOKEN_PRIVILEGE_DID_EXPIRE);
        });
      }
    }]);

    return Vy;
  }(ig);

  function Fy(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function By(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Fy(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Fy(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var jy = new Map();

  var Gy = /*#__PURE__*/function (_ig10) {
    _inherits(Gy, _ig10);

    var _super16 = _createSuper(Gy);

    function Gy(e, t) {
      var _this91;

      _classCallCheck(this, Gy);

      _this91 = _super16.call(this), nh(_assertThisInitialized(_this91), "store", void 0), nh(_assertThisInitialized(_this91), "joinInfo", void 0), nh(_assertThisInitialized(_this91), "key", void 0), nh(_assertThisInitialized(_this91), "ntpOffset", 0), nh(_assertThisInitialized(_this91), "signal", void 0), nh(_assertThisInitialized(_this91), "role", void 0), nh(_assertThisInitialized(_this91), "inChannelInfo", {
        joinAt: null,
        duration: 0
      }), nh(_assertThisInitialized(_this91), "spec", void 0), nh(_assertThisInitialized(_this91), "_state", "DISCONNECTED"), nh(_assertThisInitialized(_this91), "_statsCollector", void 0), nh(_assertThisInitialized(_this91), "_disconnectedReason", void 0), nh(_assertThisInitialized(_this91), "isSignalRecover", !1), nh(_assertThisInitialized(_this91), "hasChangeBGPAddress", !1), nh(_assertThisInitialized(_this91), "trafficStatsInterval", void 0), nh(_assertThisInitialized(_this91), "networkQualityInterval", void 0), nh(_assertThisInitialized(_this91), "_joinGatewayStartTime", 0), nh(_assertThisInitialized(_this91), "_signalTimeout", !1), nh(_assertThisInitialized(_this91), "_clientRoleOptions", void 0), nh(_assertThisInitialized(_this91), "_isProactiveJoin", !1), _this91.store = e, _this91.spec = t, _this91.signal = _this91.store.useP2P ? new Vy(By(By({}, t), {}, {
        retryConfig: t.websocketRetryConfig
      }), e) : _this91.store.useDataChannel ? new Uy(By(By({}, t), {}, {
        retryConfig: t.websocketRetryConfig
      }), e) : new ey(By(By({}, t), {}, {
        retryConfig: t.websocketRetryConfig
      }), e), _this91._statsCollector = t.statsCollector, _this91.role = t.role || "audience", _this91._clientRoleOptions = t.clientRoleOptions, _this91.handleSignalEvents();
      return _this91;
    }

    _createClass(Gy, [{
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        if (e === this._state) return;
        var t = this._state;
        this._state = e, "DISCONNECTED" === e && this._disconnectedReason ? this.emit(tv.CONNECTION_STATE_CHANGE, e, t, this._disconnectedReason) : this.emit(tv.CONNECTION_STATE_CHANGE, e, t);
      }
    }, {
      key: "joinGatewayStartTime",
      get: function get() {
        return this._joinGatewayStartTime;
      },
      set: function set(e) {
        YC.debug("[".concat(this.store.clientId, "] set joinGatewayStartTime at ").concat(e)), this._joinGatewayStartTime = e;
      }
    }, {
      key: "join",
      value: function () {
        var _join4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e, t, i) {
          var _this92 = this;

          var _t56, n, s, _t57, r, o, _t58, _n28;

          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  if (this.signal instanceof Uy) {
                    _t56 = !1;
                    "disabled" !== e.cloudProxyServer ? (YC.debug("[".concat(this.store.clientId, "] Dc is not supported, because cloudProxyServer are not supported (").concat(e.cloudProxyServer, ")")), _t56 = !0) : "".concat(e.apResponse.cid, "_").concat(e.apResponse.cert).length > 255 || "".concat(e.apResponse.cid, "_").concat(e.apResponse.cert).length < 22 ? (YC.debug("[".concat(this.store.clientId, "] Dc is not supported, because ticket length is incorrect, it has to be between 22 and 255")), _t56 = !0) : e.apResponse.addresses.some(function (e) {
                      return e.fingerprint;
                    }) || DC("FINGERPRINT") || (YC.debug("[".concat(this.store.clientId, "] Dc is not supported, because fingerprint does not exist")), _t56 = !0), _t56 && this.resetSignal();
                  }

                  this.store.joinGatewayStart(), "disabled" !== e.cloudProxyServer && (this.hasChangeBGPAddress = !0);
                  n = Date.now();
                  s = jy.get(e.cname);

                  if (!(s || (s = new Map(), jy.set(e.cname, s)), this._isProactiveJoin = !0, s.has(e.uid))) {
                    _context36.next = 7;
                    break;
                  }

                  _t57 = new VI(xT.UID_CONFLICT);
                  throw rI.joinGateway(e.sid, {
                    lts: n,
                    succ: !1,
                    ec: _t57.message,
                    addr: null,
                    uid: e.uid,
                    cid: e.cid,
                    firstSuccess: this._isProactiveJoin,
                    avoidJoinStartTime: this.store.avoidJoinStart,
                    isProxy: !!e.proxyServer,
                    signalChannel: this.signal instanceof Uy ? "1" : "0"
                  }), this._isProactiveJoin = !1, _t57;

                case 7:
                  s.set(e.uid, !0), this.joinInfo = e, this.key = t;
                  r = 0;
                  this.joinGatewayStartTime = n;
                  o = e.proxyServer;
                  _context36.prev = 11;

                  if (!(YC.debug("[".concat(this.store.clientId, "] use ").concat(this.signal instanceof Uy ? "datachannel" : "websocket", " join uid ").concat(r)), this.signal instanceof Uy)) {
                    _context36.next = 18;
                    break;
                  }

                  _context36.next = 15;
                  return this.signal.init(e.apResponse.addresses, i);

                case 15:
                  _t58 = _context36.sent;
                  _context36.next = 22;
                  break;

                case 18:
                  _n28 = e.gatewayAddrs.map(function (t) {
                    var i = t.address;

                    var _i$split = i.split(":"),
                        _i$split2 = _slicedToArray(_i$split, 2),
                        n = _i$split2[0],
                        s = _i$split2[1],
                        r = {
                      host: n,
                      port: s
                    };

                    return e.proxyServer && (r.proxy = e.proxyServer), r;
                  });
                  _context36.next = 21;
                  return this.signal.init(_n28, i);

                case 21:
                  _t58 = _context36.sent;

                case 22:
                  r = _t58.uid, YC.debug("[".concat(this.store.clientId, "] ").concat(this.signal instanceof Uy ? "datachannel" : "websocket", " join uid ").concat(r, " cost ").concat(Date.now() - this.joinGatewayStartTime));
                  _context36.next = 32;
                  break;

                case 25:
                  _context36.prev = 25;
                  _context36.t0 = _context36["catch"](11);

                  if (!(_context36.t0 && _context36.t0.code === xT.INIT_WEBSOCKET_TIMEOUT)) {
                    _context36.next = 29;
                    break;
                  }

                  throw YC.warning("[".concat(this.store.clientId, "] User join failed"), _context36.t0.toString()), _context36.t0;

                case 29:
                  if (!(_context36.t0 && _context36.t0.code === xT.INIT_DATACHANNEL_TIMEOUT)) {
                    _context36.next = 31;
                    break;
                  }

                  throw YC.warning("[".concat(this.store.clientId, "] User join datachannel failed"), _context36.t0.toString()), this.resetSignal(), _context36.t0;

                case 31:
                  throw YC.error("[".concat(this.store.clientId, "] User join failed"), _context36.t0.toString()), rI.joinGateway(e.sid, {
                    lts: n,
                    succ: !1,
                    ec: _context36.t0.message,
                    addr: this.signal.url,
                    uid: e.uid,
                    cid: e.cid,
                    firstSuccess: this._isProactiveJoin,
                    avoidJoinStartTime: this.store.avoidJoinStart,
                    isProxy: !!o,
                    signalChannel: this.signal instanceof Uy ? "1" : "0"
                  }), this._isProactiveJoin = !1, s.delete(e.uid), this.signal.close(), _context36.t0;

                case 32:
                  return _context36.abrupt("return", (this.state = "CONNECTED", this.inChannelInfo.joinAt = Date.now(), YC.debug("[".concat(this.store.clientId, "] Connected to gateway server")), this.trafficStatsInterval = window.setInterval(function () {
                    _this92.updateTrafficStats().catch(function (e) {
                      YC.warning("[".concat(_this92.store.clientId, "] get traffic stats error"), e.toString());
                    });
                  }, 3e3), this.networkQualityInterval = window.setInterval(function () {
                    navigator && void 0 !== navigator.onLine && !navigator.onLine ? _this92.emit(tv.NETWORK_QUALITY, {
                      downlinkNetworkQuality: 6,
                      uplinkNetworkQuality: 6
                    }) : _this92._signalTimeout ? _this92.emit(tv.NETWORK_QUALITY, {
                      downlinkNetworkQuality: 5,
                      uplinkNetworkQuality: 5
                    }) : "CONNECTED" === _this92.state && _this92._statsCollector.trafficStats ? _this92.emit(tv.NETWORK_QUALITY, {
                      uplinkNetworkQuality: by(_this92._statsCollector.trafficStats.B_unq),
                      downlinkNetworkQuality: by(_this92._statsCollector.trafficStats.B_dnq)
                    }) : _this92.emit(tv.NETWORK_QUALITY, {
                      uplinkNetworkQuality: 0,
                      downlinkNetworkQuality: 0
                    });
                  }, 2e3), this.store.joinGatewayEnd(), r));

                case 33:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36, this, [[11, 25]]);
        }));

        function join(_x54, _x55, _x56) {
          return _join4.apply(this, arguments);
        }

        return join;
      }()
    }, {
      key: "leave",
      value: function () {
        var _leave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
          var e,
              t,
              _args37 = arguments;
          return _regeneratorRuntime.wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  e = _args37.length > 0 && void 0 !== _args37[0] && _args37[0], t = _args37.length > 1 ? _args37[1] : void 0;

                  if (!("DISCONNECTED" !== this.state)) {
                    _context37.next = 14;
                    break;
                  }

                  t !== cg.FALLBACK && (this.state = "DISCONNECTING");
                  _context37.prev = 3;
                  _context37.t0 = e || this.signal.connectionState !== TI.CONNECTED;

                  if (_context37.t0) {
                    _context37.next = 8;
                    break;
                  }

                  _context37.next = 8;
                  return function (e, t) {
                    return t === 1 / 0 ? e : tT.race([e, Mg(t)]);
                  }(this.signal.request(SI.LEAVE, void 0, !0), 3e3);

                case 8:
                  _context37.next = 13;
                  break;

                case 10:
                  _context37.prev = 10;
                  _context37.t1 = _context37["catch"](3);
                  YC.warning("[".concat(this.store.clientId, "] leave request failed, ignore"), _context37.t1);

                case 13:
                  this.signal.close(t), t !== cg.FALLBACK && (this.state = "DISCONNECTED"), this.reset();

                case 14:
                case "end":
                  return _context37.stop();
              }
            }
          }, _callee37, this, [[3, 10]]);
        }));

        function leave() {
          return _leave.apply(this, arguments);
        }

        return leave;
      }()
    }, {
      key: "publish",
      value: function () {
        var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(e, t, i) {
          var n;
          return _regeneratorRuntime.wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context38.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));

                case 2:
                  n = {
                    state: "offer",
                    p2p_id: this.store.p2pId,
                    ortc: t,
                    mode: this.spec.mode,
                    extend: DC("PUB_EXTEND"),
                    twcc: !!DC("PUBLISH_TWCC"),
                    rtx: !!DC("USE_PUB_RTX")
                  };
                  _context38.prev = 3;
                  _context38.next = 6;
                  return this.signal.request(SI.PUBLISH, n, !0);

                case 6:
                  return _context38.abrupt("return", _context38.sent._message);

                case 9:
                  _context38.prev = 9;
                  _context38.t0 = _context38["catch"](3);

                  if (!(i && _context38.t0.data && _context38.t0.data.code === fI.ERR_PUBLISH_REQUEST_INVALID)) {
                    _context38.next = 16;
                    break;
                  }

                  YC.warning("[".concat(this.store.clientId, "] receive publish error code, retry"), _context38.t0.toString());
                  _context38.next = 15;
                  return this.tryUnpubBeforeRepub(e, t);

                case 15:
                  return _context38.abrupt("return", this.publish(e, t, !1));

                case 16:
                  throw _context38.t0;

                case 17:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee38, this, [[3, 9]]);
        }));

        function publish(_x57, _x58, _x59) {
          return _publish.apply(this, arguments);
        }

        return publish;
      }()
    }, {
      key: "publishDataChannel",
      value: function () {
        var _publishDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(e, t, i) {
          var n, s;
          return _regeneratorRuntime.wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context39.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));

                case 2:
                  s = {
                    stream_id: t.streamId,
                    ordered: t.ordered ? 1 : 0,
                    max_retrans_times: null !== (n = t.maxRetransmits) && void 0 !== n ? n : 10,
                    channel_id: t.channelId,
                    metadata: t.metadata
                  };
                  _context39.prev = 3;
                  _context39.next = 6;
                  return this.signal.request(SI.PUBLISH_DATASTREAM, s, !0);

                case 6:
                  _context39.next = 16;
                  break;

                case 8:
                  _context39.prev = 8;
                  _context39.t0 = _context39["catch"](3);

                  if (!(i && _context39.t0.data && _context39.t0.data.code === fI.ERR_PUBLISH_REQUEST_INVALID)) {
                    _context39.next = 15;
                    break;
                  }

                  YC.warning("[".concat(this.store.clientId, "] receive publish datachannels error code, retry"), _context39.t0.toString());
                  _context39.next = 14;
                  return this.tryUnpubDataChannelBeforeRepub(e, t);

                case 14:
                  return _context39.abrupt("return", this.publishDataChannel(e, t, !1));

                case 15:
                  throw _context39.t0;

                case 16:
                case "end":
                  return _context39.stop();
              }
            }
          }, _callee39, this, [[3, 8]]);
        }));

        function publishDataChannel(_x60, _x61, _x62) {
          return _publishDataChannel.apply(this, arguments);
        }

        return publishDataChannel;
      }()
    }, {
      key: "unpublish",
      value: function () {
        var _unpublish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e, t) {
          return _regeneratorRuntime.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  _context40.prev = 0;

                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context40.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));

                case 3:
                  _context40.next = 5;
                  return this.signal.request(SI.UNPUBLISH, {
                    stream_id: t,
                    ortc: e
                  }, !0);

                case 5:
                  _context40.next = 10;
                  break;

                case 7:
                  _context40.prev = 7;
                  _context40.t0 = _context40["catch"](0);
                  YC.warning("[".concat(this.store.clientId, "] unpublish warning: "), _context40.t0);

                case 10:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40, this, [[0, 7]]);
        }));

        function unpublish(_x63, _x64) {
          return _unpublish.apply(this, arguments);
        }

        return unpublish;
      }()
    }, {
      key: "unpublishDataChannel",
      value: function () {
        var _unpublishDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(e) {
          var _this93 = this;

          return _regeneratorRuntime.wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  _context41.prev = 0;

                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context41.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));

                case 3:
                  _context41.next = 5;
                  return tT.all(e.map(function (e) {
                    return _this93.signal.request(SI.UNPUBLISH_DATASTREAM, {
                      channel_id: e
                    }, !0);
                  }));

                case 5:
                  _context41.next = 10;
                  break;

                case 7:
                  _context41.prev = 7;
                  _context41.t0 = _context41["catch"](0);
                  YC.warning("unpublish datachannels warning: ", _context41.t0);

                case 10:
                case "end":
                  return _context41.stop();
              }
            }
          }, _callee41, this, [[0, 7]]);
        }));

        function unpublishDataChannel(_x65) {
          return _unpublishDataChannel.apply(this, arguments);
        }

        return unpublishDataChannel;
      }()
    }, {
      key: "presubscribe",
      value: function () {
        var _presubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(e, t, i) {
          var n;
          return _regeneratorRuntime.wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context42.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not presubscribe when connection state is ".concat(this.state));

                case 2:
                  n = {
                    stream_id: e,
                    stream_type: t,
                    mode: this.spec.mode,
                    codec: this.spec.codec,
                    p2p_id: this.store.p2pId,
                    twcc: !!DC("SUBSCRIBE_TWCC"),
                    rtx: !!DC("USE_SUB_RTX") || void 0,
                    extend: DC("SUB_EXTEND"),
                    svc: Array.isArray(DC("SVC")) && 0 !== DC("SVC").length ? DC("SVC") : void 0
                  };
                  _context42.prev = 3;
                  _context42.next = 6;
                  return this.signal.request(SI.PRE_SUBSCRIBE, n, !0);

                case 6:
                  return _context42.abrupt("return", _context42.sent);

                case 9:
                  _context42.prev = 9;
                  _context42.t0 = _context42["catch"](3);

                  if (!(i && _context42.t0.data && _context42.t0.data.code === fI.ERR_SUBSCRIBE_REQUEST_INVALID)) {
                    _context42.next = 13;
                    break;
                  }

                  return _context42.abrupt("return", (YC.warning("[".concat(this.store.clientId, "] pre-subscribe error, retry"), _context42.t0.toString()), this.presubscribe(e, t, !1)));

                case 13:
                  throw _context42.t0;

                case 14:
                case "end":
                  return _context42.stop();
              }
            }
          }, _callee42, this, [[3, 9]]);
        }));

        function presubscribe(_x66, _x67, _x68) {
          return _presubscribe.apply(this, arguments);
        }

        return presubscribe;
      }()
    }, {
      key: "subscribe",
      value: function () {
        var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e, t, i) {
          var n;
          return _regeneratorRuntime.wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context43.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not subscribe when connection state is ".concat(this.state));

                case 2:
                  n = {
                    stream_id: e,
                    stream_type: t.stream_type,
                    mode: this.spec.mode,
                    codec: this.spec.codec,
                    p2p_id: this.store.p2pId,
                    twcc: !!DC("SUBSCRIBE_TWCC"),
                    rtx: !!DC("USE_SUB_RTX"),
                    extend: DC("SUB_EXTEND"),
                    ssrcId: t.ssrcId,
                    svc: Array.isArray(DC("SVC")) && 0 !== DC("SVC").length ? DC("SVC") : void 0
                  };
                  _context43.prev = 3;
                  _context43.next = 6;
                  return this.signal.request(SI.SUBSCRIBE, n, !0);

                case 6:
                  return _context43.abrupt("return", _context43.sent._message);

                case 9:
                  _context43.prev = 9;
                  _context43.t0 = _context43["catch"](3);

                  if (!(i && _context43.t0.data && _context43.t0.data.code === fI.ERR_SUBSCRIBE_REQUEST_INVALID)) {
                    _context43.next = 18;
                    break;
                  }

                  YC.warning("[".concat(this.store.clientId, "] receiver subscribe error code, retry"), _context43.t0.toString());
                  _context43.next = 15;
                  return this.tryUnsubBeforeResub(e, t);

                case 15:
                  _context43.next = 17;
                  return this.subscribe(e, t, !1);

                case 17:
                  return _context43.abrupt("return", _context43.sent);

                case 18:
                  throw _context43.t0;

                case 19:
                case "end":
                  return _context43.stop();
              }
            }
          }, _callee43, this, [[3, 9]]);
        }));

        function subscribe(_x69, _x70, _x71) {
          return _subscribe.apply(this, arguments);
        }

        return subscribe;
      }()
    }, {
      key: "subscribeDataChannel",
      value: function () {
        var _subscribeDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(e, t, i) {
          var n;
          return _regeneratorRuntime.wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context44.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not subscribe datachannel when connection state is ".concat(this.state));

                case 2:
                  n = {
                    uid: e,
                    stream_id: t.id,
                    channel_id: t.datachannelId
                  };
                  _context44.prev = 3;
                  _context44.next = 6;
                  return this.signal.request(SI.SUBSCRIBE_DATASTREAM, n, !0);

                case 6:
                  return _context44.abrupt("return", void _context44.sent);

                case 9:
                  _context44.prev = 9;
                  _context44.t0 = _context44["catch"](3);

                  if (!(i && _context44.t0.data && _context44.t0.data.code === fI.ERR_SUBSCRIBE_REQUEST_INVALID)) {
                    _context44.next = 18;
                    break;
                  }

                  YC.warning("[".concat(this.store.clientId, "] receiver subscribe datachannel error code, retry"), _context44.t0.toString());
                  _context44.next = 15;
                  return this.tryUnsubDataChannelBeforeResub(e, t);

                case 15:
                  _context44.next = 17;
                  return this.subscribeDataChannel(e, t, !1);

                case 17:
                  return _context44.abrupt("return", _context44.sent);

                case 18:
                  throw _context44.t0;

                case 19:
                case "end":
                  return _context44.stop();
              }
            }
          }, _callee44, this, [[3, 9]]);
        }));

        function subscribeDataChannel(_x72, _x73, _x74) {
          return _subscribeDataChannel.apply(this, arguments);
        }

        return subscribeDataChannel;
      }()
    }, {
      key: "subscribeAll",
      value: function () {
        var _subscribeAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee45$(_context45) {
            while (1) {
              switch (_context45.prev = _context45.next) {
                case 0:
                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context45.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not massSubscribe when connection state is ".concat(this.state));

                case 2:
                  i = {
                    p2p_id: this.store.p2pId,
                    users: e,
                    dtx: !1,
                    rtx: !!DC("USE_SUB_RTX")
                  };
                  _context45.prev = 3;
                  _context45.next = 6;
                  return this.signal.request(SI.SUBSCRIBE_STREAMS, i, !0);

                case 6:
                  return _context45.abrupt("return", _context45.sent);

                case 9:
                  _context45.prev = 9;
                  _context45.t0 = _context45["catch"](3);

                  if (!(t && _context45.t0.data && _context45.t0.data.code === fI.ERR_SUBSCRIBE_REQUEST_INVALID)) {
                    _context45.next = 18;
                    break;
                  }

                  YC.warning("[".concat(this.store.clientId, "] receiver massSubscribe error code, retry"), _context45.t0.toString());
                  _context45.next = 15;
                  return this.tryMassUnsubBeforeResub(e);

                case 15:
                  _context45.next = 17;
                  return this.subscribeAll(e, !1);

                case 17:
                  return _context45.abrupt("return", _context45.sent);

                case 18:
                  throw _context45.t0;

                case 19:
                case "end":
                  return _context45.stop();
              }
            }
          }, _callee45, this, [[3, 9]]);
        }));

        function subscribeAll(_x75, _x76) {
          return _subscribeAll.apply(this, arguments);
        }

        return subscribeAll;
      }()
    }, {
      key: "setVideoProfile",
      value: function () {
        var _setVideoProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee46$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  t = function (e) {
                    if (!(e.bitrateMax && e.bitrateMin && e.frameRate && e.height && e.width)) return;
                    var t = e.frameRate,
                        i = e.width,
                        n = e.height,
                        s = !0;
                    return "number" != typeof t && (t = t.exact || t.ideal || t.max || t.min || 0, t || (s = !1)), "number" != typeof i && (i = i.exact || i.ideal || i.max || i.min || 0, i || (s = !1)), "number" != typeof n && (n = n.exact || n.ideal || n.max || n.min || 0, t || (s = !1)), s ? {
                      stream_type: 0,
                      width: i,
                      height: n,
                      fps: t,
                      start_bps: 1e3 * e.bitrateMax,
                      min_bps: 1e3 * e.bitrateMin,
                      target_bps: 1e3 * e.bitrateMax
                    } : void 0;
                  }(e);

                  if (!t) {
                    _context46.next = 3;
                    break;
                  }

                  return _context46.abrupt("return", this.signal.request(SI.SET_VIDEO_PROFILE, t));

                case 3:
                  YC.debug("[".concat(this.store.clientId, "] encoder config is not complete, do not report to gateway"));

                case 4:
                case "end":
                  return _context46.stop();
              }
            }
          }, _callee46, this);
        }));

        function setVideoProfile(_x77) {
          return _setVideoProfile.apply(this, arguments);
        }

        return setVideoProfile;
      }()
    }, {
      key: "unsubscribe",
      value: function () {
        var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(e, t) {
          return _regeneratorRuntime.wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  _context47.prev = 0;
                  _context47.next = 3;
                  return this.signal.request(SI.UNSUBSCRIBE, {
                    p2p_id: this.store.p2pId,
                    ortc: e,
                    stream_id: t
                  }, !0);

                case 3:
                  _context47.next = 8;
                  break;

                case 5:
                  _context47.prev = 5;
                  _context47.t0 = _context47["catch"](0);
                  YC.warning("[".concat(this.store.clientId, "] unsubscribe warning: "), _context47.t0);

                case 8:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47, this, [[0, 5]]);
        }));

        function unsubscribe(_x78, _x79) {
          return _unsubscribe.apply(this, arguments);
        }

        return unsubscribe;
      }()
    }, {
      key: "unsubscribeDataChannel",
      value: function () {
        var _unsubscribeDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(e, t) {
          var _this94 = this;

          return _regeneratorRuntime.wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  _context48.prev = 0;

                  if (!("CONNECTED" !== this.state && "RECONNECTING" !== this.state)) {
                    _context48.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));

                case 3:
                  _context48.next = 5;
                  return tT.all(e.map(function (e) {
                    return _this94.signal.request(SI.UNSUBSCRIBE_DATASTREAM, {
                      stream_id: e,
                      uid: t
                    }, !0);
                  }));

                case 5:
                  _context48.next = 10;
                  break;

                case 7:
                  _context48.prev = 7;
                  _context48.t0 = _context48["catch"](0);
                  YC.warning("unsubscribeDataChannel warning: ", _context48.t0);

                case 10:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48, this, [[0, 7]]);
        }));

        function unsubscribeDataChannel(_x80, _x81) {
          return _unsubscribeDataChannel.apply(this, arguments);
        }

        return unsubscribeDataChannel;
      }()
    }, {
      key: "massUnsubscribe",
      value: function () {
        var _massUnsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(e) {
          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  _context49.prev = 0;
                  _context49.next = 3;
                  return this.signal.request(SI.UNSUBSCRIBE_STREAMS, e, !0);

                case 3:
                  _context49.next = 8;
                  break;

                case 5:
                  _context49.prev = 5;
                  _context49.t0 = _context49["catch"](0);
                  YC.warning("[".concat(this.store.clientId, "] massUnsubscribeAll warning: "), _context49.t0);

                case 8:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49, this, [[0, 5]]);
        }));

        function massUnsubscribe(_x82) {
          return _massUnsubscribe.apply(this, arguments);
        }

        return massUnsubscribe;
      }()
    }, {
      key: "reconnectPC",
      value: function () {
        var _reconnectPC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(e) {
          var t, i, n;
          return _regeneratorRuntime.wrap(function _callee50$(_context50) {
            while (1) {
              switch (_context50.prev = _context50.next) {
                case 0:
                  t = e.iceParameters, i = e.dtlsParameters, n = e.rtpCapabilities;
                  _context50.next = 3;
                  return this.signal.request(SI.CONNECT_PC, {
                    p2p_id: this.store.p2pId,
                    stream_id: this.store.uid,
                    ortc: {
                      iceParameters: t,
                      dtlsParameters: i,
                      rtpCapabilities: n
                    }
                  }, !0);

                case 3:
                  _context50.t0 = _context50.sent;
                  _context50.t1 = this.getCurrentGatewayAddress();
                  return _context50.abrupt("return", {
                    gatewayEstablishParams: _context50.t0,
                    gatewayAddress: _context50.t1
                  });

                case 6:
                case "end":
                  return _context50.stop();
              }
            }
          }, _callee50, this);
        }));

        function reconnectPC(_x83) {
          return _reconnectPC.apply(this, arguments);
        }

        return reconnectPC;
      }()
    }, {
      key: "getGatewayInfo",
      value: function getGatewayInfo() {
        return this.signal.request(SI.GATEWAY_INFO);
      }
    }, {
      key: "renewToken",
      value: function () {
        var _renewToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(e) {
          return _regeneratorRuntime.wrap(function _callee51$(_context51) {
            while (1) {
              switch (_context51.prev = _context51.next) {
                case 0:
                  _context51.next = 2;
                  return this.signal.request(SI.RENEW_TOKEN, e);

                case 2:
                  this.key = e.token;

                case 3:
                case "end":
                  return _context51.stop();
              }
            }
          }, _callee51, this);
        }));

        function renewToken(_x84) {
          return _renewToken.apply(this, arguments);
        }

        return renewToken;
      }()
    }, {
      key: "setClientRole",
      value: function () {
        var _setClientRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(e, t) {
          var i, n;
          return _regeneratorRuntime.wrap(function _callee52$(_context52) {
            while (1) {
              switch (_context52.prev = _context52.next) {
                case 0:
                  if (!(t && (this._clientRoleOptions = Object.assign({}, t)), "CONNECTED" !== this.state)) {
                    _context52.next = 2;
                    break;
                  }

                  return _context52.abrupt("return", void (this.role = e));

                case 2:
                  n = 0;
                  "audience" === e ? this._clientRoleOptions && this._clientRoleOptions.delay ? (i = this._clientRoleOptions.delay, n = 1) : n = this._clientRoleOptions && this._clientRoleOptions.level ? this._clientRoleOptions.level : 2 : n = 0;
                  _context52.next = 6;
                  return this.signal.request(SI.SET_CLIENT_ROLE, {
                    role: e,
                    level: n,
                    delay: i,
                    client_ts: Date.now()
                  });

                case 6:
                  this.role = e;

                case 7:
                case "end":
                  return _context52.stop();
              }
            }
          }, _callee52, this);
        }));

        function setClientRole(_x85, _x86) {
          return _setClientRole.apply(this, arguments);
        }

        return setClientRole;
      }()
    }, {
      key: "setRemoteVideoStreamType",
      value: function () {
        var _setRemoteVideoStreamType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(e, t) {
          return _regeneratorRuntime.wrap(function _callee53$(_context53) {
            while (1) {
              switch (_context53.prev = _context53.next) {
                case 0:
                  _context53.next = 2;
                  return this.signal.request(SI.SWITCH_VIDEO_STREAM, {
                    stream_id: e,
                    stream_type: t
                  });

                case 2:
                case "end":
                  return _context53.stop();
              }
            }
          }, _callee53, this);
        }));

        function setRemoteVideoStreamType(_x87, _x88) {
          return _setRemoteVideoStreamType.apply(this, arguments);
        }

        return setRemoteVideoStreamType;
      }()
    }, {
      key: "setDefaultRemoteVideoStreamType",
      value: function () {
        var _setDefaultRemoteVideoStreamType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(e) {
          return _regeneratorRuntime.wrap(function _callee54$(_context54) {
            while (1) {
              switch (_context54.prev = _context54.next) {
                case 0:
                  _context54.next = 2;
                  return this.signal.request(SI.DEFAULT_VIDEO_STREAM, {
                    stream_type: e
                  });

                case 2:
                case "end":
                  return _context54.stop();
              }
            }
          }, _callee54, this);
        }));

        function setDefaultRemoteVideoStreamType(_x89) {
          return _setDefaultRemoteVideoStreamType.apply(this, arguments);
        }

        return setDefaultRemoteVideoStreamType;
      }()
    }, {
      key: "setStreamFallbackOption",
      value: function () {
        var _setStreamFallbackOption = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(e, t) {
          return _regeneratorRuntime.wrap(function _callee55$(_context55) {
            while (1) {
              switch (_context55.prev = _context55.next) {
                case 0:
                  _context55.next = 2;
                  return this.signal.request(SI.SET_FALLBACK_OPTION, {
                    stream_id: e,
                    fallback_type: t
                  });

                case 2:
                case "end":
                  return _context55.stop();
              }
            }
          }, _callee55, this);
        }));

        function setStreamFallbackOption(_x90, _x91) {
          return _setStreamFallbackOption.apply(this, arguments);
        }

        return setStreamFallbackOption;
      }()
    }, {
      key: "pickSVCLayer",
      value: function () {
        var _pickSVCLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(e, t) {
          return _regeneratorRuntime.wrap(function _callee56$(_context56) {
            while (1) {
              switch (_context56.prev = _context56.next) {
                case 0:
                  _context56.next = 2;
                  return this.signal.request(SI.PICK_SVC_LAYER, {
                    stream_id: e,
                    spatial_layer: t.spatialLayer,
                    temporal_layer: t.temporalLayer
                  });

                case 2:
                case "end":
                  return _context56.stop();
              }
            }
          }, _callee56, this);
        }));

        function pickSVCLayer(_x92, _x93) {
          return _pickSVCLayer.apply(this, arguments);
        }

        return pickSVCLayer;
      }()
    }, {
      key: "setRTM2Flag",
      value: function () {
        var _setRTM2Flag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(e) {
          return _regeneratorRuntime.wrap(function _callee57$(_context57) {
            while (1) {
              switch (_context57.prev = _context57.next) {
                case 0:
                  _context57.next = 2;
                  return this.signal.request(SI.SET_RTM2_FLAG, {
                    rtm2_flag: e
                  });

                case 2:
                case "end":
                  return _context57.stop();
              }
            }
          }, _callee57, this);
        }));

        function setRTM2Flag(_x94) {
          return _setRTM2Flag.apply(this, arguments);
        }

        return setRTM2Flag;
      }()
    }, {
      key: "sendExtensionMessage",
      value: function () {
        var _sendExtensionMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(e, t, i) {
          return _regeneratorRuntime.wrap(function _callee58$(_context58) {
            while (1) {
              switch (_context58.prev = _context58.next) {
                case 0:
                  if (!(this.signal instanceof Vy)) {
                    _context58.next = 2;
                    break;
                  }

                  return _context58.abrupt("return", this.signal.sendExtensionMessage(e, t, i));

                case 2:
                case "end":
                  return _context58.stop();
              }
            }
          }, _callee58, this);
        }));

        function sendExtensionMessage(_x95, _x96, _x97) {
          return _sendExtensionMessage2.apply(this, arguments);
        }

        return sendExtensionMessage;
      }()
    }, {
      key: "getInChannelInfo",
      value: function getInChannelInfo() {
        return this.inChannelInfo.joinAt && (this.inChannelInfo.duration = Date.now() - this.inChannelInfo.joinAt), By({}, this.inChannelInfo);
      }
    }, {
      key: "getGatewayVersion",
      value: function () {
        var _getGatewayVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
          return _regeneratorRuntime.wrap(function _callee59$(_context59) {
            while (1) {
              switch (_context59.prev = _context59.next) {
                case 0:
                  _context59.next = 2;
                  return this.signal.request(SI.GATEWAY_INFO);

                case 2:
                  return _context59.abrupt("return", _context59.sent.version);

                case 3:
                case "end":
                  return _context59.stop();
              }
            }
          }, _callee59, this);
        }));

        function getGatewayVersion() {
          return _getGatewayVersion.apply(this, arguments);
        }

        return getGatewayVersion;
      }()
    }, {
      key: "reset",
      value: function reset() {
        if (this.inChannelInfo.joinAt && (this.inChannelInfo.duration = Date.now() - this.inChannelInfo.joinAt, this.inChannelInfo.joinAt = null), this.trafficStatsInterval && (window.clearInterval(this.trafficStatsInterval), this.trafficStatsInterval = void 0), this.joinInfo) {
          var _e51 = jy.get(this.joinInfo.cname);

          _e51 && _e51.delete(this.joinInfo.uid);
        }

        this.joinInfo = void 0, this.key = void 0, this.networkQualityInterval && (window.clearInterval(this.networkQualityInterval), this.networkQualityInterval = void 0);
      }
    }, {
      key: "updateTurnConfigFromSignal",
      value: function updateTurnConfigFromSignal() {
        if (!this.joinInfo) return;

        var e = function (e) {
          var t;
          return t = e.startsWith("dc") ? e.match(/(dc\:\/\/)?([^:]+):(\d+)/) : e.match(/(wss\:\/\/)?([^:]+):(\d+)/), t ? {
            username: aI.username,
            password: aI.password,
            turnServerURL: t[2],
            tcpport: parseInt(t[3]) + 30,
            udpport: parseInt(t[3]) + 30,
            forceturn: !1
          } : null;
        }(("disabled" === this.joinInfo.cloudProxyServer ? this.signal.url : this.joinInfo.gatewayAddrs[this.signal.currentURLIndex].address) || "");

        this.joinInfo.turnServer.serversFromGateway = [], e && "off" !== this.joinInfo.turnServer.mode && "disabled" === this.joinInfo.cloudProxyServer && this.joinInfo.turnServer.serversFromGateway.push(By(By({}, aI), {}, {
          turnServerURL: e.turnServerURL,
          tcpport: e.tcpport,
          udpport: e.udpport,
          username: this.joinInfo.uid.toString(),
          password: this.joinInfo.token
        }));
      }
    }, {
      key: "updateTrafficStats",
      value: function () {
        var _updateTrafficStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
          var _this95 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee60$(_context60) {
            while (1) {
              switch (_context60.prev = _context60.next) {
                case 0:
                  if (!("CONNECTED" !== this.state)) {
                    _context60.next = 2;
                    break;
                  }

                  return _context60.abrupt("return");

                case 2:
                  _context60.next = 4;
                  return this.signal.request(SI.TRAFFIC_STATS, void 0, !0);

                case 4:
                  e = _context60.sent;
                  e.timestamp = Date.now(), null != e.ntp_offset && (this.ntpOffset = e.ntp_offset), e.peer_delay.forEach(function (e) {
                    var t = _this95._statsCollector.trafficStats && _this95._statsCollector.trafficStats.peer_delay.find(function (t) {
                      return t.peer_uid === e.peer_uid;
                    });

                    t && t.B_st !== e.B_st && Ag(function () {
                      _this95.emit(tv.STREAM_TYPE_CHANGE, e.peer_uid, e.B_st);
                    });
                  }), this._statsCollector.updateTrafficStats(e);

                case 6:
                case "end":
                  return _context60.stop();
              }
            }
          }, _callee60, this);
        }));

        function updateTrafficStats() {
          return _updateTrafficStats.apply(this, arguments);
        }

        return updateTrafficStats;
      }()
    }, {
      key: "getJoinMessage",
      value: function getJoinMessage(e) {
        if (!this.joinInfo || !this.key) throw new VI(xT.UNEXPECTED_ERROR, "can not generate join message, no join info");
        var t = Object.assign({}, this.joinInfo.apResponse);
        var i = DC("REPORT_APP_SCENARIO");
        if ("string" != typeof i) try {
          i = JSON.stringify(i);
        } catch (e) {
          i = void 0;
        }
        i && i.length > 128 && (i = void 0);
        var n = By({
          license: this.joinInfo.license,
          p2p_id: this.store.p2pId,
          session_id: this.joinInfo.sid,
          app_id: this.joinInfo.appId,
          channel_key: this.key,
          channel_name: this.joinInfo.cname,
          sdk_version: yC,
          browser: navigator.userAgent,
          process_id: DC("PROCESS_ID"),
          mode: this.store.useP2P ? "p2p" : this.spec.mode,
          codec: this.spec.codec,
          role: this.role,
          has_changed_gateway: this.hasChangeBGPAddress,
          ap_response: t,
          extend: DC("JOIN_EXTEND"),
          details: {
            6: this.joinInfo.stringUid,
            cservice_map: "proxy3" === this.joinInfo.cloudProxyServer ? "1" : "proxy5" === this.joinInfo.cloudProxyServer ? "2" : void 0
          },
          features: {
            rejoin: !0
          },
          optionalInfo: this.joinInfo.optionalInfo,
          appScenario: i,
          attributes: {
            userAttributes: {
              enablePublishedUserList: DC("ENABLE_PUBLISHED_USER_LIST"),
              maxSubscription: DC("MAX_SUBSCRIPTION"),
              subscribeAudioFilterTopN: "number" == typeof DC("SUBSCRIBE_AUDIO_FILTER_TOPN") ? DC("SUBSCRIBE_AUDIO_FILTER_TOPN") : void 0,
              enablePublishAudioFilter: "boolean" == typeof DC("ENABLE_PUBLISH_AUDIO_FILTER") ? DC("ENABLE_PUBLISH_AUDIO_FILTER") : void 0,
              enableUserLicenseCheck: "boolean" == typeof DC("ENABLE_USER_LICENSE_CHECK") ? DC("ENABLE_USER_LICENSE_CHECK") : void 0,
              enableRTX: !0 === DC("USE_PUB_RTX") || !0 === DC("USE_SUB_RTX") || void 0,
              disableFEC: DC("DISABLE_FEC"),
              enableNTPReport: !!DC("ENABLE_NTP_REPORT") || void 0,
              enableInstantVideo: !!DC("ENABLE_INSTANT_VIDEO") || void 0,
              enableDataStream2: "boolean" == typeof DC("ENABLE_DATASTREAM_2") ? DC("ENABLE_DATASTREAM_2") : void 0,
              rtm2Flag: "number" == typeof this.joinInfo.rtmFlag ? this.joinInfo.rtmFlag : void 0,
              enableUserAutoRebalanceCheck: !!DC("ENABLE_USER_AUTO_REBALANCE_CHECK"),
              enableXR: "boolean" == typeof DC("USE_XR") ? DC("USE_XR") : void 0
            }
          },
          join_ts: this.joinGatewayStartTime
        }, e);
        return this.joinInfo.stringUid && (n.string_uid = this.joinInfo.stringUid), this.joinInfo.aesmode && this.joinInfo.aespassword && (n.aes_mode = this.joinInfo.aesmode, DC("ENCRYPT_AES") ? (n.aes_secret = this.joinInfo.aespassword, n.aes_encrypt = !0) : n.aes_secret = this.joinInfo.aespassword, this.joinInfo.aessalt && (n.aes_salt = this.joinInfo.aessalt)), t.addresses[this.signal.websocket.currentURLIndex] && (n.ap_response.ticket = t.addresses[this.signal.websocket.currentURLIndex].ticket, delete t.addresses), void 0 !== this.joinInfo.defaultVideoStream && (n.default_video_stream = this.joinInfo.defaultVideoStream), n;
      }
    }, {
      key: "getRejoinMessage",
      value: function getRejoinMessage() {
        if (!this.joinInfo) throw new VI(xT.UNEXPECTED_ERROR, "can not generate rejoin message, no join info");
        return {
          session_id: this.joinInfo.sid,
          channel_name: this.joinInfo.cname,
          cid: this.joinInfo.cid,
          uid: this.joinInfo.uid,
          vid: Number(this.joinInfo.vid)
        };
      }
    }, {
      key: "handleSignalEvents",
      value: function handleSignalEvents() {
        var _this96 = this;

        this.signal.on(gI.WS_RECONNECT_WAITTING_FINISH, function (e) {
          var t;
          bn(t = ["tryNext", "recover"]).call(t, e) && _this96.joinInfo && rI.adjustSessionStartTime(_this96.joinInfo.sid);
        }), this.signal.on(gI.WS_RECONNECT_CREATE_CONNECTION, function (e) {
          _this96.joinGatewayStartTime = Date.now();
        }), this.signal.on(gI.WS_RECONNECTING, function (e) {
          _this96.joinInfo && rI.WebSocketQuit(_this96.joinInfo.sid, {
            lts: Date.now(),
            succ: -1,
            cname: _this96.joinInfo.cname,
            uid: _this96.joinInfo.uid,
            cid: _this96.joinInfo.cid,
            errorCode: e || lg.NETWORK_ERROR
          }), _this96.joinInfo && (_this96.state = "RECONNECTING", rI.sessionInit(_this96.joinInfo.sid, {
            lts: new Date().getTime(),
            extend: _this96.isSignalRecover ? {
              recover: !0
            } : {
              rejoin: !0
            },
            cname: _this96.joinInfo.cname,
            appid: _this96.joinInfo.appId,
            mode: _this96.spec.mode,
            stringUid: _this96.joinInfo.stringUid,
            channelProfile: "live" === _this96.spec.mode ? 1 : 0,
            channelMode: 0,
            lsid: _this96.joinInfo.sid,
            clientRole: "audience" === _this96.role ? 2 : 1
          }), _this96.isSignalRecover = !1, _this96.joinGatewayStartTime = Date.now());
        }), this.signal.on(gI.WS_CLOSED, function (e) {
          var t;

          switch (e) {
            case cg.LEAVE:
              t = lg.LEAVE;
              break;

            case cg.UID_BANNED:
            case cg.IP_BANNED:
            case cg.CHANNEL_BANNED:
            case cg.SERVER_ERROR:
              t = lg.SERVER_ERROR;
              break;

            case cg.FALLBACK:
              t = lg.FALLBACK;
              break;

            case cg.LICENSE_MISSING:
            case cg.LICENSE_EXPIRED:
            case cg.LICENSE_MINUTES_EXCEEDED:
            case cg.LICENSE_PERIOD_INVALID:
            case cg.LICENSE_MULTIPLE_SDK_SERVICE:
            case cg.LICENSE_ILLEGAL:
            case cg.TOKEN_EXPIRE:
              t = e;
              break;

            default:
              t = lg.NETWORK_ERROR;
          }

          YC.debug("[".concat(_this96.store.clientId, "] [signal] websocket closed, reason: ").concat(t || "undefined -> " + lg.NETWORK_ERROR)), _this96.joinInfo && rI.WebSocketQuit(_this96.joinInfo.sid, {
            lts: Date.now(),
            succ: e === cg.LEAVE ? 1 : -1,
            cname: _this96.joinInfo.cname,
            uid: _this96.joinInfo.uid,
            cid: _this96.joinInfo.cid,
            errorCode: t
          }), _this96._disconnectedReason = e, e !== cg.FALLBACK && (_this96.state = "DISCONNECTED"), _this96.reset();
        }), this.signal.on(gI.WS_CONNECTED, function () {
          if (_this96.updateTurnConfigFromSignal(), _this96.state = "CONNECTED", _this96.joinInfo && ("audience" === _this96.role && _this96._clientRoleOptions && (_this96._clientRoleOptions.level || _this96._clientRoleOptions.delay) && (YC.debug("[".concat(_this96.store.clientId, "] patch to send set client role, role: ").concat(_this96.role, ", mode: ").concat(_this96.spec.mode, ", level: ").concat(_this96._clientRoleOptions.level, ", delay: ").concat(_this96._clientRoleOptions.delay)), _this96.setClientRole(_this96.role, _this96._clientRoleOptions)), rI.joinGateway(_this96.joinInfo.sid, {
            lts: _this96.joinGatewayStartTime,
            succ: !0,
            ec: null,
            vid: _this96.joinInfo.vid,
            addr: _this96.signal.url,
            uid: _this96.joinInfo.uid,
            cid: _this96.joinInfo.cid,
            firstSuccess: _this96._isProactiveJoin,
            avoidJoinStartTime: _this96.store.avoidJoinStart,
            isProxy: !!_this96.joinInfo.proxyServer,
            signalChannel: _this96.signal instanceof Uy ? "1" : "0"
          }), _this96._isProactiveJoin = !1, _this96.joinInfo.useLocalAccessPoint && 1 === _this96.joinInfo.setLocalAPVersion)) {
            var _e52 = _this96.signal.url && _this96.signal.url.match(/wss\:\/\/([^:]+):(\d+)/);

            if (!_e52) return void YC.error("[".concat(_this96.store.clientId, "] set local access point after joined failed: ").concat(_e52));
            NC("EVENT_REPORT_DOMAIN", _e52[1]), NC("EVENT_REPORT_BACKUP_DOMAIN", _e52[1]), NC("LOG_UPLOAD_SERVER", "".concat(_e52[1], ":6444"));
          }
        }), this.signal.on(CI.ON_UPLINK_STATS, function (e) {
          _this96._statsCollector.updateUplinkStats(e);
        }), this.signal.on(gI.REQUEST_RECOVER, function (e, t, i) {
          if (!_this96.joinInfo) return i(new VI(xT.UNEXPECTED_ERROR, "gateway: can not recover, no join info"));
          e && (_this96.joinInfo.multiIP = e, _this96.hasChangeBGPAddress = !0), _this96.isSignalRecover = !0, fg(_this96, tv.REQUEST_NEW_GATEWAY_LIST).then(t).catch(i);
        }), this.signal.on(gI.REQUEST_JOIN_INFO, /*#__PURE__*/function () {
          var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(e) {
            var t, _yield$fg, i, n, s;

            return _regeneratorRuntime.wrap(function _callee61$(_context61) {
              while (1) {
                switch (_context61.prev = _context61.next) {
                  case 0:
                    if (!(_this96.updateTurnConfigFromSignal(), _this96.store.useP2P)) {
                      _context61.next = 2;
                      break;
                    }

                    return _context61.abrupt("return", void e(_this96.getJoinMessage({
                      ortc: {}
                    })));

                  case 2:
                    _context61.next = 4;
                    return fg(_this96, tv.REQUEST_P2P_CONNECTION_PARAMS, {
                      turnServer: null === (t = _this96.joinInfo) || void 0 === t ? void 0 : t.turnServer
                    });

                  case 4:
                    _yield$fg = _context61.sent;
                    i = _yield$fg.iceParameters;
                    n = _yield$fg.dtlsParameters;
                    s = _yield$fg.rtpCapabilities;
                    e(_this96.getJoinMessage({
                      ortc: {
                        iceParameters: i,
                        dtlsParameters: n,
                        rtpCapabilities: s,
                        version: "2"
                      }
                    }));

                  case 9:
                  case "end":
                    return _context61.stop();
                }
              }
            }, _callee61);
          }));

          return function (_x98) {
            return _ref22.apply(this, arguments);
          };
        }()), this.signal.on(gI.REQUEST_REJOIN_INFO, function (e) {
          e(_this96.getRejoinMessage());
        }), this.signal.on(gI.REPORT_JOIN_GATEWAY, function (e, t) {
          _this96.joinInfo && (rI.joinGateway(_this96.joinInfo.sid, {
            lts: _this96.joinGatewayStartTime,
            succ: !1,
            ec: e,
            addr: t,
            uid: _this96.joinInfo.uid,
            cid: _this96.joinInfo.cid,
            firstSuccess: _this96._isProactiveJoin,
            avoidJoinStartTime: _this96.store.avoidJoinStart,
            isProxy: !!_this96.joinInfo.proxyServer,
            signalChannel: _this96.signal instanceof Uy ? "1" : "0"
          }), _this96._isProactiveJoin = !1);
        }), this.signal.on(gI.IS_P2P_DISCONNECTED, function (e) {
          e(Sg(_this96, tv.IS_P2P_DISCONNECTED));
        }), this.signal.on(gI.DISCONNECT_P2P, function () {
          _this96.emit(tv.DISCONNECT_P2P);
        }), this.signal.on(gI.NEED_RENEW_SESSION, function () {
          _this96.emit(tv.NEED_RENEW_SESSION);
        }), this.signal.on(gI.REQUEST_SUCCESS, function () {
          _this96._signalTimeout = !1;
        }), this.signal.on(gI.REQUEST_TIMEOUT, function () {
          _this96._signalTimeout = !0;
        }), this.signal.on(gI.JOIN_RESPONSE, function (e) {
          var t = _this96.getCurrentGatewayAddress();

          _this96.emit(tv.JOIN_RESPONSE, e, t);
        }), this.signal.on(gI.DATACHANNEL_PRECONNECT, /*#__PURE__*/function () {
          var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(e, t, i) {
            var n;
            return _regeneratorRuntime.wrap(function _callee62$(_context62) {
              while (1) {
                switch (_context62.prev = _context62.next) {
                  case 0:
                    _this96.updateTurnConfigFromSignal();

                    n = _this96.getCurrentGatewayAddress();
                    return _context62.abrupt("return", fg(_this96, tv.DATACHANNEL_PRECONNECT, e, n).then(t).catch(i));

                  case 3:
                  case "end":
                    return _context62.stop();
                }
              }
            }, _callee62);
          }));

          return function (_x99, _x100, _x101) {
            return _ref23.apply(this, arguments);
          };
        }()), this.signal.on(gI.DATACHANNEL_CONNECTING, /*#__PURE__*/function () {
          var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(e) {
            var _yield$fg2, t, i, n;

            return _regeneratorRuntime.wrap(function _callee63$(_context63) {
              while (1) {
                switch (_context63.prev = _context63.next) {
                  case 0:
                    _context63.next = 2;
                    return fg(_this96, tv.REQUEST_DC_CONNECTION_PARAMS);

                  case 2:
                    _yield$fg2 = _context63.sent;
                    t = _yield$fg2.iceParameters;
                    i = _yield$fg2.dtlsParameters;
                    n = _yield$fg2.rtpCapabilities;
                    e(_this96.getJoinMessage({
                      ortc: {
                        iceParameters: t,
                        dtlsParameters: i,
                        rtpCapabilities: n,
                        version: "2"
                      }
                    }));

                  case 7:
                  case "end":
                    return _context63.stop();
                }
              }
            }, _callee63);
          }));

          return function (_x102) {
            return _ref24.apply(this, arguments);
          };
        }()), this.signal.on(gI.DATACHANNEL_FAILBACK, function () {
          YC.warning("[".concat(_this96.store.clientId, "] User join datachannel failed")), _this96.reset(), _this96.resetSignal(), _this96.emit(tv.DATACHANNEL_FAILBACK);
        });
      }
    }, {
      key: "tryUnsubBeforeResub",
      value: function () {
        var _tryUnsubBeforeResub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(e, t) {
          return _regeneratorRuntime.wrap(function _callee64$(_context64) {
            while (1) {
              switch (_context64.prev = _context64.next) {
                case 0:
                  _context64.prev = 0;
                  _context64.next = 3;
                  return this.signal.request(SI.UNSUBSCRIBE, {
                    p2p_id: this.store.p2pId,
                    stream_id: e,
                    ortc: [t]
                  }, !0);

                case 3:
                  _context64.next = 8;
                  break;

                case 5:
                  _context64.prev = 5;
                  _context64.t0 = _context64["catch"](0);
                  throw YC.warning("[".concat(this.store.clientId, "] tryUnsubBeforeResub warning"), _context64.t0), _context64.t0;

                case 8:
                case "end":
                  return _context64.stop();
              }
            }
          }, _callee64, this, [[0, 5]]);
        }));

        function tryUnsubBeforeResub(_x103, _x104) {
          return _tryUnsubBeforeResub.apply(this, arguments);
        }

        return tryUnsubBeforeResub;
      }()
    }, {
      key: "tryUnsubDataChannelBeforeResub",
      value: function () {
        var _tryUnsubDataChannelBeforeResub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(e, t) {
          return _regeneratorRuntime.wrap(function _callee65$(_context65) {
            while (1) {
              switch (_context65.prev = _context65.next) {
                case 0:
                  _context65.prev = 0;
                  _context65.next = 3;
                  return this.signal.request(SI.UNSUBSCRIBE, {
                    stream_id: t.id
                  }, !0);

                case 3:
                  _context65.next = 8;
                  break;

                case 5:
                  _context65.prev = 5;
                  _context65.t0 = _context65["catch"](0);
                  throw YC.warning("unsubscribe datachannel warning", _context65.t0), _context65.t0;

                case 8:
                case "end":
                  return _context65.stop();
              }
            }
          }, _callee65, this, [[0, 5]]);
        }));

        function tryUnsubDataChannelBeforeResub(_x105, _x106) {
          return _tryUnsubDataChannelBeforeResub.apply(this, arguments);
        }

        return tryUnsubDataChannelBeforeResub;
      }()
    }, {
      key: "tryUnpubBeforeRepub",
      value: function () {
        var _tryUnpubBeforeRepub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(e, t) {
          return _regeneratorRuntime.wrap(function _callee66$(_context66) {
            while (1) {
              switch (_context66.prev = _context66.next) {
                case 0:
                  _context66.prev = 0;
                  _context66.next = 3;
                  return this.signal.request(SI.UNPUBLISH, {
                    stream_id: e,
                    ortc: t
                  }, !0);

                case 3:
                  _context66.next = 8;
                  break;

                case 5:
                  _context66.prev = 5;
                  _context66.t0 = _context66["catch"](0);
                  throw YC.warning("[".concat(this.store.clientId, "] tryUnpubBeforeRepub warning: "), _context66.t0), _context66.t0;

                case 8:
                case "end":
                  return _context66.stop();
              }
            }
          }, _callee66, this, [[0, 5]]);
        }));

        function tryUnpubBeforeRepub(_x107, _x108) {
          return _tryUnpubBeforeRepub.apply(this, arguments);
        }

        return tryUnpubBeforeRepub;
      }()
    }, {
      key: "tryUnpubDataChannelBeforeRepub",
      value: function () {
        var _tryUnpubDataChannelBeforeRepub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(e, t) {
          return _regeneratorRuntime.wrap(function _callee67$(_context67) {
            while (1) {
              switch (_context67.prev = _context67.next) {
                case 0:
                  _context67.prev = 0;
                  _context67.next = 3;
                  return this.signal.request(SI.UNPUBLISH_DATASTREAM, {
                    channnel_id: t.channelId
                  }, !0);

                case 3:
                  _context67.next = 8;
                  break;

                case 5:
                  _context67.prev = 5;
                  _context67.t0 = _context67["catch"](0);
                  throw YC.warning("unpublish datastream warning: ", _context67.t0), _context67.t0;

                case 8:
                case "end":
                  return _context67.stop();
              }
            }
          }, _callee67, this, [[0, 5]]);
        }));

        function tryUnpubDataChannelBeforeRepub(_x109, _x110) {
          return _tryUnpubDataChannelBeforeRepub.apply(this, arguments);
        }

        return tryUnpubDataChannelBeforeRepub;
      }()
    }, {
      key: "tryMassUnsubBeforeResub",
      value: function () {
        var _tryMassUnsubBeforeResub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee68$(_context68) {
            while (1) {
              switch (_context68.prev = _context68.next) {
                case 0:
                  t = {
                    users: e.map(function (e) {
                      return {
                        stream_id: e.stream_id,
                        stream_type: e.stream_type
                      };
                    })
                  };
                  _context68.prev = 1;
                  _context68.next = 4;
                  return this.signal.request(SI.UNSUBSCRIBE_STREAMS, t, !0);

                case 4:
                  _context68.next = 9;
                  break;

                case 6:
                  _context68.prev = 6;
                  _context68.t0 = _context68["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] tryMassUnsubBeforeResub warning"), _context68.t0), _context68.t0;

                case 9:
                case "end":
                  return _context68.stop();
              }
            }
          }, _callee68, this, [[1, 6]]);
        }));

        function tryMassUnsubBeforeResub(_x111) {
          return _tryMassUnsubBeforeResub.apply(this, arguments);
        }

        return tryMassUnsubBeforeResub;
      }()
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee69$(_context69) {
            while (1) {
              switch (_context69.prev = _context69.next) {
                case 0:
                  i = {
                    action: e.find(function (e) {
                      return e.stream_type === ev.Audio;
                    }) ? "mute_local_audio" : "mute_local_video",
                    p2p_id: this.store.p2pId,
                    ortc: e,
                    stream_id: t
                  };
                  _context69.prev = 1;
                  _context69.next = 4;
                  return this.signal.request(SI.CONTROL, i, !0, !0);

                case 4:
                  _context69.next = 9;
                  break;

                case 6:
                  _context69.prev = 6;
                  _context69.t0 = _context69["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] gateway muteLocal warning: "), _context69.t0), _context69.t0;

                case 9:
                case "end":
                  return _context69.stop();
              }
            }
          }, _callee69, this, [[1, 6]]);
        }));

        function muteLocal(_x112, _x113) {
          return _muteLocal.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee70$(_context70) {
            while (1) {
              switch (_context70.prev = _context70.next) {
                case 0:
                  i = {
                    action: e.find(function (e) {
                      return e.stream_type === ev.Audio;
                    }) ? "unmute_local_audio" : "unmute_local_video",
                    p2p_id: this.store.p2pId,
                    ortc: e,
                    stream_id: t
                  };
                  _context70.prev = 1;
                  _context70.next = 4;
                  return this.signal.request(SI.CONTROL, i, !0, !0);

                case 4:
                  _context70.next = 9;
                  break;

                case 6:
                  _context70.prev = 6;
                  _context70.t0 = _context70["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] gateway unmuteLocal warning: "), _context70.t0), _context70.t0;

                case 9:
                case "end":
                  return _context70.stop();
              }
            }
          }, _callee70, this, [[1, 6]]);
        }));

        function unmuteLocal(_x114, _x115) {
          return _unmuteLocal.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee71$(_context71) {
            while (1) {
              switch (_context71.prev = _context71.next) {
                case 0:
                  i = {
                    action: e === hv.AUDIO ? "mute_remote_audio" : "mute_remote_video",
                    p2p_id: this.store.p2pId,
                    stream_id: t
                  };
                  _context71.prev = 1;
                  _context71.next = 4;
                  return this.signal.request(SI.CONTROL, i, !0, !0);

                case 4:
                  _context71.next = 9;
                  break;

                case 6:
                  _context71.prev = 6;
                  _context71.t0 = _context71["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] gateway muteRemote warning: "), _context71.t0), _context71.t0;

                case 9:
                case "end":
                  return _context71.stop();
              }
            }
          }, _callee71, this, [[1, 6]]);
        }));

        function muteRemote(_x116, _x117) {
          return _muteRemote.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee72$(_context72) {
            while (1) {
              switch (_context72.prev = _context72.next) {
                case 0:
                  i = {
                    action: e === hv.AUDIO ? "unmute_remote_audio" : "unmute_remote_video",
                    p2p_id: this.store.p2pId,
                    stream_id: t
                  };
                  _context72.prev = 1;
                  _context72.next = 4;
                  return this.signal.request(SI.CONTROL, i, !0, !0);

                case 4:
                  _context72.next = 9;
                  break;

                case 6:
                  _context72.prev = 6;
                  _context72.t0 = _context72["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] gateway unmuteRemote warning: "), _context72.t0), _context72.t0;

                case 9:
                case "end":
                  return _context72.stop();
              }
            }
          }, _callee72, this, [[1, 6]]);
        }));

        function unmuteRemote(_x118, _x119) {
          return _unmuteRemote.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "uploadWRTCStats",
      value: function uploadWRTCStats(e) {
        this.signal.uploadWRTCStats(e);
      }
    }, {
      key: "upload",
      value: function upload(e, t) {
        this.signal.upload(e, t);
      }
    }, {
      key: "getSignalRTT",
      value: function getSignalRTT() {
        return this.signal.rtt;
      }
    }, {
      key: "restartICE",
      value: function () {
        var _restartICE = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee73$(_context73) {
            while (1) {
              switch (_context73.prev = _context73.next) {
                case 0:
                  t = {
                    p2p_id: this.store.p2pId,
                    stream_id: this.store.uid,
                    ortc: e
                  };
                  _context73.prev = 1;
                  _context73.next = 4;
                  return this.signal.request(SI.RESTART_ICE, t, !0);

                case 4:
                  return _context73.abrupt("return", _context73.sent);

                case 7:
                  _context73.prev = 7;
                  _context73.t0 = _context73["catch"](1);
                  throw YC.warning("[".concat(this.store.clientId, "] P2PChannel.restartICE warning: "), _context73.t0), _context73.t0;

                case 10:
                case "end":
                  return _context73.stop();
              }
            }
          }, _callee73, this, [[1, 7]]);
        }));

        function restartICE(_x120) {
          return _restartICE.apply(this, arguments);
        }

        return restartICE;
      }()
    }, {
      key: "reconnect",
      value: function reconnect() {
        "CONNECTED" === this.state && this.signal.reconnect(void 0, lg.P2P_FAILED);
      }
    }, {
      key: "getCurrentGatewayAddress",
      value: function getCurrentGatewayAddress() {
        var e;
        if (!DC("GATEWAY_WSS_ADDRESS")) return null !== (e = this.joinInfo) && void 0 !== e && e.gatewayAddrs ? this.joinInfo.gatewayAddrs[this.signal.currentURLIndex] : void 0;
      }
    }, {
      key: "setPublishAudioFilterEnabled",
      value: function () {
        var _setPublishAudioFilterEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(e) {
          return _regeneratorRuntime.wrap(function _callee74$(_context74) {
            while (1) {
              switch (_context74.prev = _context74.next) {
                case 0:
                  _context74.next = 2;
                  return this.signal.request(SI.SET_PARAMETER, {
                    enablePublishAudioFilter: e
                  });

                case 2:
                case "end":
                  return _context74.stop();
              }
            }
          }, _callee74, this);
        }));

        function setPublishAudioFilterEnabled(_x121) {
          return _setPublishAudioFilterEnabled.apply(this, arguments);
        }

        return setPublishAudioFilterEnabled;
      }()
    }, {
      key: "resetSignal",
      value: function resetSignal() {
        this.signal && (this.signal.removeAllListeners(), this.signal.close(cg.FALLBACK)), this.store.useDataChannel = !1, this.signal = new ey(By(By({}, this.spec), {}, {
          retryConfig: this.spec.websocketRetryConfig
        }), this.store), this.handleSignalEvents(), this.emit(tv.RESET_SIGNAL, sv.websocket);
      }
    }]);

    return Gy;
  }(ig);

  var Wy = 0,
      Hy = 0;

  function Ky(e, t, i, n) {
    return new tT(function (s, r) {
      t.timeout = t.timeout || DC("HTTP_CONNECT_TIMEOUT"), t.responseType = t.responseType || "json", t.data && !i ? (t.data = JSON.stringify(t.data), Wy += Lg(t.data)) : i && (t.data.size ? Wy += t.data.size : t.data instanceof FormData ? Wy += kg(t.data) : Wy += Lg(JSON.stringify(t.data))), t.headers = t.headers || {}, t.headers["Content-Type"] = t.headers["Content-Type"] || "application/json", t.method = "POST", t.url = e, EC.request(t).then(function (e) {
        "string" == typeof e.data ? Hy += Lg(e.data) : e.data instanceof ArrayBuffer || e.data instanceof Uint8Array ? Hy += e.data.byteLength : Hy += Lg(JSON.stringify(e.data)), n && s({
          data: e.data,
          headers: e.headers
        }), s(e.data);
      }).catch(function (e) {
        EC.isCancel(e) ? r(new VI(xT.OPERATION_ABORTED, "cancel token canceled")) : "ECONNABORTED" === e.code ? r(new VI(xT.NETWORK_TIMEOUT, e.message)) : e.response ? r(new VI(xT.NETWORK_RESPONSE_ERROR, e.response.status)) : r(new VI(xT.NETWORK_ERROR, e.message));
      });
    });
  }
  /*! formdata-polyfill. MIT License. Jimmy W?rting <https://jimmy.warting.se/opensource> */


  !function () {
    var e;

    function i(e) {
      var t = 0;
      return function () {
        return t < e.length ? {
          done: !1,
          value: e[t++]
        } : {
          done: !0
        };
      };
    }

    var n = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, i) {
      return e == Array.prototype || e == Object.prototype || (e[t] = i.value), e;
    };

    var s,
        r = function (e) {
      e = ["object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis, e, "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window, "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self, "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t];

      for (var i = 0; i < e.length; ++i) {
        var n = e[i];
        if (n && n.Math == Math) return n;
      }

      throw Error("Cannot find global object");
    }(this);

    function o(e, t) {
      if (t) e: {
        var i = r;
        e = e.split(".");

        for (var s = 0; s < e.length - 1; s++) {
          var o = e[s];
          if (!(o in i)) break e;
          i = i[o];
        }

        (t = t(s = i[e = e[e.length - 1]])) != s && null != t && n(i, e, {
          configurable: !0,
          writable: !0,
          value: t
        });
      }
    }

    function a(e) {
      return (e = {
        next: e
      })[Symbol.iterator] = function () {
        return this;
      }, e;
    }

    function c(e) {
      var t = "undefined" != typeof Symbol && Symbol.iterator && e[Symbol.iterator];
      return t ? t.call(e) : {
        next: i(e)
      };
    }

    if (o("Symbol", function (e) {
      function t(e, t) {
        this.A = e, n(this, "description", {
          configurable: !0,
          writable: !0,
          value: t
        });
      }

      if (e) return e;

      t.prototype.toString = function () {
        return this.A;
      };

      var i = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_",
          s = 0;
      return function e(n) {
        if (this instanceof e) throw new TypeError("Symbol is not a constructor");
        return new t(i + (n || "") + "_" + s++, n);
      };
    }), o("Symbol.iterator", function (e) {
      if (e) return e;
      e = Symbol("Symbol.iterator");

      for (var t = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), s = 0; s < t.length; s++) {
        var o = r[t[s]];
        "function" == typeof o && "function" != typeof o.prototype[e] && n(o.prototype, e, {
          configurable: !0,
          writable: !0,
          value: function value() {
            return a(i(this));
          }
        });
      }

      return e;
    }), "function" == typeof Object.setPrototypeOf) s = Object.setPrototypeOf;else {
      var d;

      e: {
        var l = {};

        try {
          l.__proto__ = {
            a: !0
          }, d = l.a;
          break e;
        } catch (e) {}

        d = !1;
      }

      s = d ? function (e, t) {
        if (e.__proto__ = t, e.__proto__ !== t) throw new TypeError(e + " is not extensible");
        return e;
      } : null;
    }
    var u = s;

    function h() {
      this.m = !1, this.j = null, this.v = void 0, this.h = 1, this.u = this.C = 0, this.l = null;
    }

    function p(e) {
      if (e.m) throw new TypeError("Generator is already running");
      e.m = !0;
    }

    function _(e, t) {
      return e.h = 3, {
        value: t
      };
    }

    function E(e) {
      this.g = new h(), this.G = e;
    }

    function m(e, t, i, n) {
      try {
        var s = t.call(e.g.j, i);
        if (!(s instanceof Object)) throw new TypeError("Iterator result " + s + " is not an object");
        if (!s.done) return e.g.m = !1, s;
        var r = s.value;
      } catch (t) {
        return e.g.j = null, e.g.s(t), f(e);
      }

      return e.g.j = null, n.call(e.g, r), f(e);
    }

    function f(e) {
      for (; e.g.h;) {
        try {
          var t = e.G(e.g);
          if (t) return e.g.m = !1, {
            value: t.value,
            done: !1
          };
        } catch (t) {
          e.g.v = void 0, e.g.s(t);
        }
      }

      if (e.g.m = !1, e.g.l) {
        if (t = e.g.l, e.g.l = null, t.F) throw t.D;
        return {
          value: t.return,
          done: !0
        };
      }

      return {
        value: void 0,
        done: !0
      };
    }

    function T(e) {
      this.next = function (t) {
        return e.o(t);
      }, this.throw = function (t) {
        return e.s(t);
      }, this.return = function (t) {
        return function (e, t) {
          p(e.g);
          var i = e.g.j;
          return i ? m(e, "return" in i ? i.return : function (e) {
            return {
              value: e,
              done: !0
            };
          }, t, e.g.return) : (e.g.return(t), f(e));
        }(e, t);
      }, this[Symbol.iterator] = function () {
        return this;
      };
    }

    function g(e, t) {
      return t = new T(new E(t)), u && e.prototype && u(t, e.prototype), t;
    }

    if (h.prototype.o = function (e) {
      this.v = e;
    }, h.prototype.s = function (e) {
      this.l = {
        D: e,
        F: !0
      }, this.h = this.C || this.u;
    }, h.prototype.return = function (e) {
      this.l = {
        return: e
      }, this.h = this.u;
    }, E.prototype.o = function (e) {
      return p(this.g), this.g.j ? m(this, this.g.j.next, e, this.g.o) : (this.g.o(e), f(this));
    }, E.prototype.s = function (e) {
      return p(this.g), this.g.j ? m(this, this.g.j.throw, e, this.g.o) : (this.g.s(e), f(this));
    }, o("Array.prototype.entries", function (e) {
      return e || function () {
        return function (e, t) {
          e instanceof String && (e += "");
          var i = 0,
              n = !1,
              s = {
            next: function next() {
              if (!n && i < e.length) {
                var s = i++;
                return {
                  value: t(s, e[s]),
                  done: !1
                };
              }

              return n = !0, {
                done: !0,
                value: void 0
              };
            }
          };
          return s[Symbol.iterator] = function () {
            return s;
          }, s;
        }(this, function (e, t) {
          return [e, t];
        });
      };
    }), "undefined" != typeof Blob && ("undefined" == typeof FormData || !FormData.prototype.keys)) {
      var S = function S(e, t) {
        for (var i = 0; i < e.length; i++) {
          t(e[i]);
        }
      },
          R = function R(e) {
        return e.replace(/\r?\n|\r/g, "\r\n");
      },
          C = function C(e, t, i) {
        return t instanceof Blob ? (i = void 0 !== i ? String(i + "") : "string" == typeof t.name ? t.name : "blob", t.name === i && "[object Blob]" !== Object.prototype.toString.call(t) || (t = new File([t], i)), [String(e), t]) : [String(e), String(t)];
      },
          I = function I(e, t) {
        if (e.length < t) throw new TypeError(t + " argument required, but only " + e.length + " present.");
      },
          v = "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis : "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? window : "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) ? self : this,
          y = v.FormData,
          A = v.XMLHttpRequest && v.XMLHttpRequest.prototype.send,
          b = v.Request && v.fetch,
          w = v.navigator && v.navigator.sendBeacon,
          O = v.Element && v.Element.prototype,
          N = v.Symbol && Symbol.toStringTag;

      N && (Blob.prototype[N] || (Blob.prototype[N] = "Blob"), "File" in v && !File.prototype[N] && (File.prototype[N] = "File"));

      try {
        new File([], "");
      } catch (e) {
        v.File = function (e, t, i) {
          return e = new Blob(e, i || {}), Object.defineProperties(e, {
            name: {
              value: t
            },
            lastModified: {
              value: +(i && void 0 !== i.lastModified ? new Date(i.lastModified) : new Date())
            },
            toString: {
              value: function value() {
                return "[object File]";
              }
            }
          }), N && Object.defineProperty(e, N, {
            value: "File"
          }), e;
        };
      }

      var D = function D(e) {
        return e.replace(/\n/g, "%0A").replace(/\r/g, "%0D").replace(/"/g, "%22");
      },
          P = function P(e) {
        this.i = [];
        var t = this;
        e && S(e.elements, function (e) {
          if (e.name && !e.disabled && "submit" !== e.type && "button" !== e.type && !e.matches("form fieldset[disabled] *")) if ("file" === e.type) {
            var i = e.files && e.files.length ? e.files : [new File([], "", {
              type: "application/octet-stream"
            })];
            S(i, function (i) {
              t.append(e.name, i);
            });
          } else "select-multiple" === e.type || "select-one" === e.type ? S(e.options, function (i) {
            !i.disabled && i.selected && t.append(e.name, i.value);
          }) : "checkbox" === e.type || "radio" === e.type ? e.checked && t.append(e.name, e.value) : (i = "textarea" === e.type ? R(e.value) : e.value, t.append(e.name, i));
        });
      };

      if ((e = P.prototype).append = function (e, t, i) {
        I(arguments, 2), this.i.push(C(e, t, i));
      }, e.delete = function (e) {
        I(arguments, 1);
        var t = [];
        e = String(e), S(this.i, function (i) {
          i[0] !== e && t.push(i);
        }), this.i = t;
      }, e.entries = function e() {
        var t,
            i = this;
        return g(e, function (e) {
          if (1 == e.h && (t = 0), 3 != e.h) return t < i.i.length ? e = _(e, i.i[t]) : (e.h = 0, e = void 0), e;
          t++, e.h = 2;
        });
      }, e.forEach = function (e, t) {
        I(arguments, 1);

        for (var i = c(this), n = i.next(); !n.done; n = i.next()) {
          var s = c(n.value);
          n = s.next().value, s = s.next().value, e.call(t, s, n, this);
        }
      }, e.get = function (e) {
        I(arguments, 1);
        var t = this.i;
        e = String(e);

        for (var i = 0; i < t.length; i++) {
          if (t[i][0] === e) return t[i][1];
        }

        return null;
      }, e.getAll = function (e) {
        I(arguments, 1);
        var t = [];
        return e = String(e), S(this.i, function (i) {
          i[0] === e && t.push(i[1]);
        }), t;
      }, e.has = function (e) {
        I(arguments, 1), e = String(e);

        for (var t = 0; t < this.i.length; t++) {
          if (this.i[t][0] === e) return !0;
        }

        return !1;
      }, e.keys = function e() {
        var t,
            i,
            n,
            s,
            r = this;
        return g(e, function (e) {
          if (1 == e.h && (t = c(r), i = t.next()), 3 != e.h) return i.done ? void (e.h = 0) : (n = i.value, s = c(n), _(e, s.next().value));
          i = t.next(), e.h = 2;
        });
      }, e.set = function (e, t, i) {
        I(arguments, 2), e = String(e);
        var n = [],
            s = C(e, t, i),
            r = !0;
        S(this.i, function (t) {
          t[0] === e ? r && (r = !n.push(s)) : n.push(t);
        }), r && n.push(s), this.i = n;
      }, e.values = function e() {
        var t,
            i,
            n,
            s,
            r = this;
        return g(e, function (e) {
          if (1 == e.h && (t = c(r), i = t.next()), 3 != e.h) return i.done ? void (e.h = 0) : (n = i.value, (s = c(n)).next(), _(e, s.next().value));
          i = t.next(), e.h = 2;
        });
      }, P.prototype._asNative = function () {
        for (var e = new y(), t = c(this), i = t.next(); !i.done; i = t.next()) {
          var n = c(i.value);
          i = n.next().value, n = n.next().value, e.append(i, n);
        }

        return e;
      }, P.prototype._blob = function () {
        var e = "----formdata-polyfill-" + Math.random(),
            t = [],
            i = "--" + e + '\r\nContent-Disposition: form-data; name="';
        return this.forEach(function (e, n) {
          return "string" == typeof e ? t.push(i + D(R(n)) + '"\r\n\r\n' + R(e) + "\r\n") : t.push(i + D(R(n)) + '"; filename="' + D(e.name) + '"\r\nContent-Type: ' + (e.type || "application/octet-stream") + "\r\n\r\n", e, "\r\n");
        }), t.push("--" + e + "--"), new Blob(t, {
          type: "multipart/form-data; boundary=" + e
        });
      }, P.prototype[Symbol.iterator] = function () {
        return this.entries();
      }, P.prototype.toString = function () {
        return "[object FormData]";
      }, O && !O.matches && (O.matches = O.matchesSelector || O.mozMatchesSelector || O.msMatchesSelector || O.oMatchesSelector || O.webkitMatchesSelector || function (e) {
        for (var t = (e = (this.document || this.ownerDocument).querySelectorAll(e)).length; 0 <= --t && e.item(t) !== this;) {
          ;
        }

        return -1 < t;
      }), N && (P.prototype[N] = "FormData"), A) {
        var L = v.XMLHttpRequest.prototype.setRequestHeader;
        v.XMLHttpRequest.prototype.setRequestHeader = function (e, t) {
          L.call(this, e, t), "content-type" === e.toLowerCase() && (this.B = !0);
        }, v.XMLHttpRequest.prototype.send = function (e) {
          e instanceof P ? (e = e._blob(), this.B || this.setRequestHeader("Content-Type", e.type), A.call(this, e)) : A.call(this, e);
        };
      }

      b && (v.fetch = function (e, t) {
        return t && t.body && t.body instanceof P && (t.body = t.body._blob()), b.call(this, e, t);
      }), w && (v.navigator.sendBeacon = function (e, t) {
        return t instanceof P && (t = t._asNative()), w.call(this, e, t);
      }), v.FormData = P;
    }
  }();

  var Yy = function Yy() {
    var e = DC("AREAS");
    0 === e.length && e.push(rv.GLOBAL);
    return cS(e).call(e, function (e, t, i) {
      var n = qy(t);
      return n ? 0 === i ? n : "".concat(e, ",").concat(n) : e;
    }, "");
  },
      qy = function qy(e) {
    return e === rv.OVERSEA ? "".concat(cv.ASIA, ",").concat(cv.EUROPE, ",").concat(cv.AFRICA, ",").concat(cv.NORTH_AMERICA, ",").concat(cv.SOUTH_AMERICA, ",").concat(cv.OCEANIA) : cv[e];
  },
      Jy = function Jy(e) {
    var t = {
      CODE: "",
      WEBCS_DOMAIN: [],
      WEBCS_DOMAIN_BACKUP_LIST: [],
      PROXY_CS: [],
      CDS_AP: [],
      ACCOUNT_REGISTER: [],
      UAP_AP: [],
      EVENT_REPORT_DOMAIN: [],
      EVENT_REPORT_BACKUP_DOMAIN: [],
      LOG_UPLOAD_SERVER: [],
      PROXY_SERVER_TYPE3: []
    };
    return e.map(function (e) {
      var i = dv[e],
          n = Object.keys(i);
      n && n.map(function (e) {
        "CODE" !== e && (t[e] = t[e].concat(i[e]));
      });
    }), t;
  },
      zy = {
    GLOBAL: {
      ASIA: [rv.CHINA, rv.JAPAN, rv.INDIA, rv.KOREA, rv.HKMC],
      EUROPE: [],
      NORTH_AMERICA: [rv.US],
      SOUTH_AMERICA: [],
      OCEANIA: [],
      AFRICA: []
    }
  },
      Xy = Object.keys(zy[rv.GLOBAL]),
      Qy = [rv.CHINA, rv.NORTH_AMERICA, rv.EUROPE, rv.ASIA, rv.JAPAN, rv.INDIA, rv.OCEANIA, rv.SOUTH_AMERICA, rv.AFRICA, rv.KOREA, rv.HKMC, rv.US],
      Zy = function Zy(e, t) {
    var i = [];

    if (bn(e).call(e, rv.GLOBAL)) {
      var r = [rv.GLOBAL, rv.OVERSEA],
          o = Object.keys(dv);
      if (t === rv.GLOBAL) throw new VI(xT.INVALID_PARAMS, "GLOBAL is an invalid excludedArea value");
      if (t === rv.CHINA) i = [rv.OVERSEA];else if (s = t, bn(Xy).call(Xy, s)) {
        var _e53 = (n = t, zy[rv.GLOBAL][n] || []),
            _s17 = [].concat(r, [t], _toConsumableArray(_e53));

        i = o.filter(function (e) {
          return !bn(_s17).call(_s17, e);
        });
      } else if (function (e) {
        var t = !1;
        return Xy.forEach(function (i) {
          var n;
          bn(n = zy[rv.GLOBAL][i]).call(n, e) && (t = !0);
        }), t;
      }(t)) {
        var _e54 = function (e) {
          var t;
          return Xy.forEach(function (i) {
            var n;
            bn(n = zy[rv.GLOBAL][i]).call(n, e) && (t = i);
          }), t;
        }(t),
            _n29 = [].concat(r, [_e54, t]);

        i = o.filter(function (e) {
          return !bn(_n29).call(_n29, e);
        });
      } else i = e;

      i = function (e) {
        var t = [];
        return Qy.forEach(function (i) {
          bn(e).call(e, i) && t.push(i);
        }), t.concat(e.filter(function (e) {
          return !bn(Qy).call(Qy, e);
        }));
      }(i);
    } else i = e;

    var n, s;
    return i;
  };

  function $y(e) {
    var t, i;
    if (!e && bn(t = DC("AREAS")).call(t, rv.EXTENSIONS)) return YC.debug("update area from ap : reset"), void eA(oI, !0);
    if (!bn(i = DC("AREAS")).call(i, rv.GLOBAL) || !e) return;
    var n = dv.EXTENSIONS;
    n && (n = {
      CODE: qy(rv.EXTENSIONS),
      WEBCS_DOMAIN: ["ap-web-1-".concat(e, ".agora.io")],
      WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-".concat(e, ".ap.sd-rtn.com")],
      PROXY_CS: ["proxy-ap-web-".concat(e, ".agora.io")],
      CDS_AP: ["cds-ap-web-1-".concat(e, ".agora.io"), "cds-ap-web-2-".concat(e, ".ap.sd-rtn.com")],
      ACCOUNT_REGISTER: ["sua-ap-web-1-".concat(e, ".agora.io"), "sua-ap-web-2-".concat(e, ".ap.sd-rtn.com")],
      UAP_AP: ["uap-ap-web-1-".concat(e, ".agora.io"), "uap-ap-web-2-".concat(e, ".ap.sd-rtn.com")],
      EVENT_REPORT_DOMAIN: ["statscollector-1-".concat(e, ".agora.io")],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-".concat(e, ".agora.io")],
      LOG_UPLOAD_SERVER: ["logservice-".concat(e, ".agora.io")],
      PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy-".concat(e, ".agora.io")]
    }, YC.debug("update area from ap success: ".concat(e, ",config is "), n), NC("AREAS", [rv.EXTENSIONS], !0), Object.keys(n).map(function (e) {
      if ("LOG_UPLOAD_SERVER" === e || "EVENT_REPORT_DOMAIN" === e || "EVENT_REPORT_BACKUP_DOMAIN" === e || "PROXY_SERVER_TYPE3" === e) {
        NC(e, n[e][0]);
      } else NC(e, n[e]);
    }));
  }

  function eA(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    var i = rI.reportApiInvoke(null, {
      name: rg.SET_AREA,
      options: e,
      tag: og.TRACER
    });

    try {
      var n = [];

      if ("string" == typeof e && (n = [e]), Array.isArray(e) && (e.forEach(function (e) {
        if (!bn(av).call(av, e)) throw new VI(xT.INVALID_PARAMS, "invalid area code");
      }), n = e), "[object Object]" === Object.prototype.toString.call(e)) {
        var _t59 = e.areaCode,
            _i40 = e.excludedArea;
        if (!_t59) throw new VI(xT.INVALID_PARAMS, "area code is needed");
        var _s18 = _t59;
        "string" == typeof _t59 && (_s18 = [_t59]), n = _i40 ? Zy(_s18, _i40) : _s18;
      }

      if (!t) {
        if (PC.AREAS) {
          var _e55 = new VI(xT.PROHIBITED_OPERATION, "setArea is prohibited because of config-distribute");

          return i.onError(_e55), void YC.warning("setArea is prohibited because of config-distribute");
        }

        if (bn(n).call(n, rv.GLOBAL) && DC("AREAS") === rv.EXTENSIONS) {
          var _e56 = new VI(xT.PROHIBITED_OPERATION, "setArea is prohibited because of ap extensions");

          return i.onError(_e56), void YC.warning("setArea is prohibited because of ap extensions");
        }
      }

      NC("AREAS", n, t);
      var s = Jy(n);
      Object.keys(s).map(function (e) {
        if ("LOG_UPLOAD_SERVER" === e || "EVENT_REPORT_DOMAIN" === e || "EVENT_REPORT_BACKUP_DOMAIN" === e || "PROXY_SERVER_TYPE3" === e) {
          NC(e, s[e][0]);
        } else NC(e, s[e]);
      }), YC.debug("set area success:", n.join(","));
    } catch (e) {
      throw i.onError(e), e;
    }

    i.onSuccess();
  }

  function tA(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function iA(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? tA(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : tA(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var nA = 1;

  function sA(e, t, i, n, s) {
    nA += 1;
    var r = {
      sid: i.sid,
      command: "convergeAllocateEdge",
      uid: "666",
      appId: i.appId,
      ts: Math.floor(Date.now() / 1e3),
      seq: nA,
      requestId: nA,
      version: yC,
      cname: i.cname
    },
        o = {
      service_name: t,
      json_body: JSON.stringify(r)
    };
    var a,
        c,
        d = e[0];
    return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75() {
      var e, _t60, i, _e57, _e58, s;

      return _regeneratorRuntime.wrap(function _callee75$(_context75) {
        while (1) {
          switch (_context75.prev = _context75.next) {
            case 0:
              a = Date.now();
              _context75.next = 3;
              return Ky(d, {
                data: o,
                cancelToken: n,
                headers: {
                  "X-Packet-Service-Type": "0",
                  "X-Packet-URI": "61"
                }
              });

            case 3:
              e = _context75.sent;

              if (!(c = Date.now() - a, 0 !== e.code)) {
                _context75.next = 7;
                break;
              }

              _t60 = new VI(xT.UNEXPECTED_RESPONSE, "live streaming ap error, code" + e.code, {
                retry: !0,
                responseTime: c
              });
              throw YC.error(_t60.toString()), _t60;

            case 7:
              i = JSON.parse(e.json_body);

              if (!(200 !== i.code)) {
                _context75.next = 11;
                break;
              }

              _e57 = new VI(xT.UNEXPECTED_RESPONSE, "live streaming app center error, code: ".concat(i.code, ", reason: ").concat(i.reason), {
                code: i.code,
                responseTime: c
              });
              throw YC.error(_e57.toString()), _e57;

            case 11:
              if (!(!i.servers || 0 === i.servers.length)) {
                _context75.next = 14;
                break;
              }

              _e58 = new VI(xT.UNEXPECTED_RESPONSE, "live streaming app center empty server", {
                code: i.code,
                responseTime: c
              });
              throw YC.error(_e58.toString()), _e58;

            case 14:
              s = function (e, t) {
                return {
                  addressList: e.servers.map(function (e) {
                    return "wss://".concat(e.address.replace(/\./g, "-"), ".").concat(DC("WORKER_DOMAIN"), ":").concat(e.wss, "?serviceName=").concat(encodeURIComponent(t));
                  }),
                  workerToken: e.workerToken,
                  vid: e.vid
                };
              }(i, t);

              return _context75.abrupt("return", (DC("LIVE_STREAMING_ADDRESS") && (s.addressList = DC("LIVE_STREAMING_ADDRESS") instanceof Array ? DC("LIVE_STREAMING_ADDRESS") : [DC("LIVE_STREAMING_ADDRESS")]), iA(iA({}, s), {}, {
                responseTime: c
              })));

            case 16:
            case "end":
              return _context75.stop();
          }
        }
      }, _callee75);
    })), function (n, s) {
      return rI.apworkerEvent(i.sid, {
        success: !0,
        sc: 200,
        serviceName: t,
        responseDetail: JSON.stringify(n.addressList),
        firstSuccess: 0 === s,
        responseTime: c,
        serverIp: e[s % e.length]
      }), !1;
    }, function (n, s) {
      return rI.apworkerEvent(i.sid, {
        success: !1,
        sc: n.data && n.data.code || 200,
        serviceName: t,
        responseTime: c,
        serverIp: e[s % e.length]
      }), !!(n.code !== xT.OPERATION_ABORTED && n.code !== xT.UNEXPECTED_RESPONSE || n.data && n.data.retry) && (d = e[(s + 1) % e.length], !0);
    }, s);
  }

  var rA = 1;

  function oA(e, t, i, n) {
    var s = e.url,
        r = e.areaCode;
    var o = Date.now();
    var a;

    var _uA = uA(t, r, [_y.CHOOSE_SERVER]),
        _uA2 = _slicedToArray(_uA, 2),
        c = _uA2[0],
        d = _uA2[1];

    var l = Rg.networkState;
    return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76() {
      var _yield$Ky, e, r, d;

      return _regeneratorRuntime.wrap(function _callee76$(_context76) {
        while (1) {
          switch (_context76.prev = _context76.next) {
            case 0:
              _context76.t0 = l && Rg.networkState === ug.OFFLINE && Rg.onlineWaiter;

              if (!_context76.t0) {
                _context76.next = 4;
                break;
              }

              _context76.next = 4;
              return tT.race([Rg.onlineWaiter, Ug(n && n.maxRetryTimeout || Jg.maxRetryTimeout)]);

            case 4:
              l = Rg.networkState;
              _context76.next = 7;
              return Ky(s, {
                data: c,
                cancelToken: i,
                headers: {
                  "Content-Type": "multipart/form-data;"
                }
              }, !0, !0);

            case 7:
              _yield$Ky = _context76.sent;
              e = _yield$Ky.data;
              r = _yield$Ky.headers;
              a = "1" === r.http3 ? 1 : -1, rI.reportResourceTiming(s, t.sid), cA(e, s, t, o, [_y.CHOOSE_SERVER], a);
              d = wy(e, _y.CHOOSE_SERVER);
              return _context76.abrupt("return", (dA(d), vy(d, s)));

            case 13:
            case "end":
              return _context76.stop();
          }
        }
      }, _callee76);
    })), function (e) {
      return e && rI.joinChooseServer(t.sid, {
        lts: o,
        succ: !0,
        csAddr: s,
        opid: d,
        serverList: e.gatewayAddrs.map(function (e) {
          return e.address;
        }),
        ec: null,
        cid: e.cid.toString(),
        uid: e.uid.toString(),
        csIp: e.csIp,
        unilbsServerIds: [_y.CHOOSE_SERVER].toString(),
        isHttp3: a
      }), !1;
    }, function (e) {
      return e.code !== xT.OPERATION_ABORTED && (e.code === xT.CAN_NOT_GET_GATEWAY_SERVER ? e.data.retry : (rI.joinChooseServer(t.sid, {
        lts: o,
        succ: !1,
        csAddr: s,
        serverList: null,
        opid: d,
        ec: e.code,
        csIp: e.data && e.data.csIp,
        unilbsServerIds: [_y.CHOOSE_SERVER].toString(),
        extend: JSON.stringify({
          networkState: l
        }),
        isHttp3: a
      }), YC.warning("[".concat(t.clientId, "] Choose server network error, retry"), e), !0));
    }, n);
  }

  function aA(e, t, i, n) {
    var s,
        r = e.url,
        o = e.areaCode,
        a = e.serviceIds;

    var c = Date.now(),
        _uA3 = uA(t, o, a),
        _uA4 = _slicedToArray(_uA3, 2),
        d = _uA4[0],
        l = _uA4[1];

    var u;
    return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77() {
      var _yield$Ky2, e, o, l, h;

      return _regeneratorRuntime.wrap(function _callee77$(_context77) {
        while (1) {
          switch (_context77.prev = _context77.next) {
            case 0:
              _context77.t0 = u && Rg.networkState === ug.OFFLINE && Rg.onlineWaiter;

              if (!_context77.t0) {
                _context77.next = 4;
                break;
              }

              _context77.next = 4;
              return tT.race([Rg.onlineWaiter, Ug(n && n.maxRetryTimeout || Jg.maxRetryTimeout)]);

            case 4:
              u = Rg.networkState;
              _context77.next = 7;
              return Ky(r, {
                data: d,
                cancelToken: i,
                headers: {
                  "Content-Type": "multipart/form-data;"
                }
              }, !0, !0);

            case 7:
              _yield$Ky2 = _context77.sent;
              e = _yield$Ky2.data;
              o = _yield$Ky2.headers;
              s = "1" === o.http3 ? 1 : -1, rI.reportResourceTiming(r, t.sid), cA(e, r, t, c, a, s);
              l = wy(e, _y.CHOOSE_SERVER), h = wy(e, "proxy5" === t.cloudProxyServer ? _y.CLOUD_PROXY_5 : "proxy3" === t.cloudProxyServer || "proxy4" === t.cloudProxyServer ? _y.CLOUD_PROXY : _y.CLOUD_PROXY_FALLBACK);
              return _context77.abrupt("return", (dA(l), {
                gatewayInfo: vy(l, r),
                proxyInfo: h,
                url: r
              }));

            case 13:
            case "end":
              return _context77.stop();
          }
        }
      }, _callee77);
    })), function (e) {
      return e.gatewayInfo && rI.joinChooseServer(t.sid, {
        lts: c,
        succ: !0,
        csAddr: r,
        serverList: e.gatewayInfo.gatewayAddrs.map(function (e) {
          return e.address;
        }),
        ec: null,
        opid: l,
        cid: e.gatewayInfo.cid.toString(),
        uid: e.gatewayInfo.uid.toString(),
        csIp: e.gatewayInfo.csIp,
        unilbsServerIds: a.toString(),
        isHttp3: s
      }), e.proxyInfo && rI.joinWebProxyAP(t.sid, {
        lts: c,
        sucess: 1,
        apServerAddr: r,
        turnServerAddrList: e.proxyInfo.addresses.map(function (e) {
          return e.ip;
        }).join(","),
        errorCode: null,
        eventType: t.cloudProxyServer,
        unilbsServerIds: a.toString()
      }), !1;
    }, function (e) {
      return e.code !== xT.OPERATION_ABORTED && (e.code === xT.CAN_NOT_GET_GATEWAY_SERVER ? e.data.retry : (rI.joinWebProxyAP(t.sid, {
        lts: c,
        sucess: 0,
        apServerAddr: r,
        turnServerAddrList: null,
        errorCode: e.code,
        eventType: t.cloudProxyServer,
        unilbsServerIds: a.toString(),
        extend: JSON.stringify({
          networkState: u
        })
      }), YC.warning("[".concat(t.clientId, "] multi unilbs network error, retry"), e), !0));
    }, n);
  }

  var cA = function cA(e, t, i, n, s, r) {
    var o = [],
        a = function a(o) {
      4096 === o.flag ? rI.joinChooseServer(i.sid, {
        lts: n,
        succ: !1,
        csAddr: t,
        opid: e.opid,
        serverList: null,
        ec: o.error.message,
        csIp: o.error.data && o.error.data.csIp,
        unilbsServerIds: s.toString(),
        isHttp3: r
      }) : 1048576 !== o.flag && 4194304 !== o.flag && 4194310 !== o.flag || rI.joinWebProxyAP(i.sid, {
        lts: n,
        sucess: 0,
        apServerAddr: t,
        turnServerAddrList: null,
        errorCode: o.error.code,
        eventType: i.cloudProxyServer,
        unilbsServerIds: s.toString()
      });
    };

    if (e.response_body.forEach(function (t) {
      var i = t.buffer.code;
      if (23 === t.uri && 0 === i && !t.buffer.edges_services) if (4194310 === t.buffer.flag) YC.warning("no edge services in ap response of proxy fallback, will not set proxy in iceServers"), t.buffer.edges_services = [];else {
        var _i41 = {
          error: new VI(xT.CAN_NOT_GET_GATEWAY_SERVER, "no edge services in ap response", {
            retry: !0,
            csIp: e.detail[502]
          }),
          flag: t.buffer.flag
        };
        o.push(_i41), a(_i41);
      }

      if (0 !== i) {
        var _n30 = xv(i),
            _s19 = {
          error: new VI(xT.CAN_NOT_GET_GATEWAY_SERVER, _n30.desc, {
            desc: _n30.desc,
            retry: _n30.retry,
            csIp: e.detail[502]
          }),
          flag: t.buffer.flag
        };

        4194310 === t.buffer.flag ? YC.warning(_s19.error.toString()) : o.push(_s19), a(_s19);
      }
    }), o.length) throw YC.warning("[".concat(i.clientId, "] multi unilbs ").concat(t, " failed, ").concat(o.map(function (e) {
      return "flag: ".concat(e.flag, ", message: ").concat(e.error.message, ", retry: ").concat(e.error.data.retry);
    }).join(" | "))), new VI(xT.CAN_NOT_GET_GATEWAY_SERVER, o.map(function (e) {
      return "flag: ".concat(e.flag, ", message: ").concat(e.error.message);
    }).join(" | "), {
      retry: !!o.find(function (e) {
        return e.error.data.retry;
      }),
      csIp: e.detail[502],
      desc: _toConsumableArray(new Set(o.map(function (e) {
        var t;
        return null == e || null === (t = e.error) || void 0 === t || null === (t = t.data) || void 0 === t ? void 0 : t.desc;
      }).filter(function (e) {
        return !!e;
      })))
    });
  },
      dA = function dA(e) {
    var t, i, n, s;
    if (e.addresses && 0 === e.addresses.length && 0 === e.code) throw new VI(xT.CAN_NOT_GET_GATEWAY_SERVER, "void gateway address", {
      retry: !0,
      csIp: e.detail && e.detail[502]
    });
    DC("AP_AREA") && (null !== (n = e.detail) && void 0 !== n && n[23] && "string" == typeof (null === (s = e.detail) || void 0 === s ? void 0 : s[23]) ? $y(e.detail[23].toLowerCase()) : $y());

    if (null !== (t = e.detail) && void 0 !== t && t[19] && "string" == typeof (null === (i = e.detail) || void 0 === i ? void 0 : i[19])) {
      var _t61 = e.detail[19],
          _i42 = null == _t61 ? void 0 : _t61.split(";");

      for (var _t62 = 0; _t62 < _i42.length; _t62++) {
        var r;

        var _n31 = Sy(r = _i42[_t62]).call(r);

        e.addresses[_t62] && _i42 && (e.addresses[_t62].fingerprint = _n31);
      }
    }

    if (DC("GATEWAY_ADDRESS") && DC("GATEWAY_ADDRESS").length > 0) {
      YC.debug("assign gateway address to", DC("GATEWAY_ADDRESS"));

      var _t63 = DC("GATEWAY_ADDRESS").map(function (t) {
        var i, n;
        var s = null !== (i = null === (n = e.addresses.find(function (e) {
          return e.ip === t.ip && e.port === t.port;
        })) || void 0 === n ? void 0 : n.fingerprint) && void 0 !== i ? i : "";
        return {
          ip: t.ip,
          port: t.port,
          ticket: e.addresses[0] && e.addresses[0].ticket,
          fingerprint: s
        };
      });

      e.addresses = _t63;
    }
  },
      lA = function lA(e, t) {
    if (e.response_body && e.response_body.length) {
      var _t64 = e.response_body[0];

      if (0 !== _t64.buffer.code) {
        var _e59 = xv(_t64.buffer.code);

        throw new VI(xT.UPDATE_TICKET_FAILED, "[".concat(_t64.buffer.code, "]: ").concat(_e59.desc), {
          retry: _e59.retry
        });
      }

      return _t64.buffer.ticket;
    }

    throw YC.debug("update ticket request received ap response without response body:", t), new VI(xT.UPDATE_TICKET_FAILED, "cannot find response body from ap response", {
      retry: !1
    });
  },
      uA = function uA(e, t, i) {
    var n = Math.floor(Math.random() * Math.pow(10, 12)),
        s = {
      appid: e.appId,
      client_ts: Date.now(),
      opid: n,
      sid: e.sid,
      request_bodies: [{
        uri: 22,
        buffer: {
          cname: e.cname,
          detail: iA({
            6: e.stringUid,
            11: t,
            12: DC("USE_NEW_TOKEN") ? "1" : void 0,
            22: t
          }, e.apRTM ? {
            26: "RTM2"
          } : {}),
          key: e.token,
          service_ids: i,
          uid: e.uid || 0
        }
      }]
    };
    s.request_bodies.forEach(function (t) {
      e.multiIP && e.multiIP.gateway_ip && (t.buffer.detail[5] = JSON.stringify({
        vocs_ip: [e.multiIP.uni_lbs_ip],
        vos_ip: [e.multiIP.gateway_ip]
      }));
    });
    var r = new FormData();
    return r.append("request", JSON.stringify(s)), [r, n];
  },
      hA = function hA(e, t) {
    var i = Math.floor(Math.random() * Math.pow(10, 12)),
        n = {
      appid: e.appId,
      client_ts: Date.now(),
      opid: i,
      sid: e.sid,
      request_bodies: [{
        uri: 28,
        buffer: {
          cname: e.cname,
          detail: {
            1: "",
            6: e.stringUid,
            12: "1"
          },
          token: e.token,
          service_ids: t,
          uid: e.uid || 0,
          edges_services: e.apResponse.addresses.map(function (e) {
            return {
              ip: e.ip,
              port: e.port
            };
          })
        }
      }]
    },
        s = new FormData();
    return s.append("request", JSON.stringify(n)), [s, i];
  };

  var pA = 0;

  function _A(e) {
    return tT.all(e.map(function (e) {
      return e.then(function (e) {
        throw e;
      }, function (e) {
        return e;
      });
    })).then(function (e) {
      throw e;
    }, function (e) {
      return e;
    });
  }

  var EA = /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(e) {
      var t, i, n, s, r, o, a, c, d, l;
      return _regeneratorRuntime.wrap(function _callee79$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              t = e.fragementLength, i = e.referenceList, n = e.asyncMapHandler, s = e.allFailedhandler, r = e.promisesCollector, o = 0;
              a = t;
              d = 0;

              l = /*#__PURE__*/function () {
                var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78() {
                  var e;
                  return _regeneratorRuntime.wrap(function _callee78$(_context78) {
                    while (1) {
                      switch (_context78.prev = _context78.next) {
                        case 0:
                          e = function () {
                            var e = o * a,
                                t = e + a;
                            return i.slice(e, t).map(n);
                          }();

                          r && r.push.apply(r, _toConsumableArray(e));
                          _context78.prev = 2;
                          _context78.next = 5;
                          return _A(e);

                        case 5:
                          c = _context78.sent;
                          _context78.next = 15;
                          break;

                        case 8:
                          _context78.prev = 8;
                          _context78.t0 = _context78["catch"](2);

                          if (!(d += a, o++, !(d >= i.length))) {
                            _context78.next = 14;
                            break;
                          }

                          _context78.next = 13;
                          return l();

                        case 13:
                          return _context78.abrupt("return", void _context78.sent);

                        case 14:
                          s(_context78.t0);

                        case 15:
                          e.forEach(function (e) {
                            return e.cancel();
                          });

                        case 16:
                        case "end":
                          return _context78.stop();
                      }
                    }
                  }, _callee78, null, [[2, 8]]);
                }));

                return function l() {
                  return _ref29.apply(this, arguments);
                };
              }();

              _context79.next = 6;
              return l();

            case 6:
              return _context79.abrupt("return", c);

            case 7:
            case "end":
              return _context79.stop();
          }
        }
      }, _callee79);
    }));

    return function EA(_x122) {
      return _ref28.apply(this, arguments);
    };
  }();

  function mA(_x123, _x124, _x125, _x126) {
    return _mA.apply(this, arguments);
  }

  function _mA() {
    _mA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee473(e, t, i, n) {
      var s;
      return _regeneratorRuntime.wrap(function _callee473$(_context473) {
        while (1) {
          switch (_context473.prev = _context473.next) {
            case 0:
              s = function () {
                var _ref116 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee472(e, t, i, n) {
                  var s, r, o, a;
                  return _regeneratorRuntime.wrap(function _callee472$(_context472) {
                    while (1) {
                      switch (_context472.prev = _context472.next) {
                        case 0:
                          s = null;
                          r = [], o = /*#__PURE__*/function () {
                            var _ref117 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee470() {
                              var s, o, a;
                              return _regeneratorRuntime.wrap(function _callee470$(_context470) {
                                while (1) {
                                  switch (_context470.prev = _context470.next) {
                                    case 0:
                                      s = DC("WEBCS_DOMAIN").slice(0, DC("AJAX_REQUEST_CONCURRENT")).map(function (t) {
                                        return {
                                          url: e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(t + "/api/v2/transpond/webrtc?v=2") : "https://".concat(t, "/api/v2/transpond/webrtc?v=2"),
                                          areaCode: Yy()
                                        };
                                      });
                                      o = n.recordJoinChannelService({
                                        startTs: Date.now(),
                                        status: "pending",
                                        service: "chooseServer",
                                        urls: s.map(function (e) {
                                          return e.url;
                                        })
                                      });
                                      _context470.next = 4;
                                      return EA({
                                        fragementLength: DC("FRAGEMENT_LENGTH"),
                                        referenceList: s,
                                        asyncMapHandler: function asyncMapHandler(n) {
                                          return YC.debug("[".concat(e.clientId, "] Connect to choose_server:"), n.url), oA(n, e, t, i);
                                        },
                                        allFailedhandler: function allFailedhandler(e) {
                                          throw n.recordJoinChannelService({
                                            endTs: Date.now(),
                                            status: "error",
                                            errors: e
                                          }, o), e[0];
                                        },
                                        promisesCollector: r
                                      });

                                    case 4:
                                      a = _context470.sent;
                                      return _context470.abrupt("return", (n.recordJoinChannelService({
                                        endTs: Date.now(),
                                        status: "success"
                                      }, o), a));

                                    case 6:
                                    case "end":
                                      return _context470.stop();
                                  }
                                }
                              }, _callee470);
                            }));

                            return function o() {
                              return _ref117.apply(this, arguments);
                            };
                          }(), a = /*#__PURE__*/function () {
                            var _ref118 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee471() {
                              var o, a, c;
                              return _regeneratorRuntime.wrap(function _callee471$(_context471) {
                                while (1) {
                                  switch (_context471.prev = _context471.next) {
                                    case 0:
                                      _context471.next = 2;
                                      return Ug(1e3);

                                    case 2:
                                      if (!(null !== s)) {
                                        _context471.next = 4;
                                        break;
                                      }

                                      return _context471.abrupt("return", s);

                                    case 4:
                                      o = DC("WEBCS_DOMAIN_BACKUP_LIST").map(function (t) {
                                        return {
                                          url: e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(t + "/api/v2/transpond/webrtc?v=2") : "https://".concat(t, "/api/v2/transpond/webrtc?v=2"),
                                          areaCode: Yy()
                                        };
                                      });
                                      a = n.recordJoinChannelService({
                                        endTs: void 0,
                                        startTs: Date.now(),
                                        status: "pending",
                                        service: "chooseServer",
                                        urls: o.map(function (e) {
                                          return e.url;
                                        })
                                      });
                                      _context471.next = 8;
                                      return EA({
                                        fragementLength: DC("FRAGEMENT_LENGTH"),
                                        referenceList: o,
                                        asyncMapHandler: function asyncMapHandler(n) {
                                          return YC.debug("[".concat(e.clientId, "] Connect to backup choose_server:"), n.url), oA(n, e, t, i);
                                        },
                                        allFailedhandler: function allFailedhandler(e) {
                                          throw n.recordJoinChannelService({
                                            endTs: Date.now(),
                                            status: "error",
                                            errors: e
                                          }, a), e[0];
                                        },
                                        promisesCollector: r
                                      });

                                    case 8:
                                      c = _context471.sent;
                                      return _context471.abrupt("return", (n.recordJoinChannelService({
                                        endTs: Date.now(),
                                        status: "success"
                                      }, a), c));

                                    case 10:
                                    case "end":
                                      return _context471.stop();
                                  }
                                }
                              }, _callee471);
                            }));

                            return function a() {
                              return _ref118.apply(this, arguments);
                            };
                          }();
                          _context472.prev = 2;
                          _context472.next = 5;
                          return _A([o(), a()]);

                        case 5:
                          s = _context472.sent;
                          r.length && r.forEach(function (e) {
                            return e.cancel && "function" == typeof e.cancel && e.cancel();
                          });
                          return _context472.abrupt("return", s);

                        case 10:
                          _context472.prev = 10;
                          _context472.t0 = _context472["catch"](2);
                          throw _context472.t0[0];

                        case 13:
                        case "end":
                          return _context472.stop();
                      }
                    }
                  }, _callee472, null, [[2, 10]]);
                }));

                return function (_x735, _x736, _x737, _x738) {
                  return _ref116.apply(this, arguments);
                };
              }()(e, t, i, n);

              _context473.next = 3;
              return s;

            case 3:
              _context473.t0 = _context473.sent;
              return _context473.abrupt("return", {
                gatewayInfo: _context473.t0
              });

            case 5:
            case "end":
              return _context473.stop();
          }
        }
      }, _callee473);
    }));
    return _mA.apply(this, arguments);
  }

  function fA(_x127, _x128, _x129, _x130, _x131) {
    return _fA.apply(this, arguments);
  }

  function _fA() {
    _fA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee474(e, t, i, n, s) {
      var r, _yield$SA, _n159, _r73, _a35, o, _t344, _i185, _s109, _c10, _yield$SA2, a, c, d, l, u, _t345, _i186, _n160, _s110;

      return _regeneratorRuntime.wrap(function _callee474$(_context474) {
        while (1) {
          switch (_context474.prev = _context474.next) {
            case 0:
              r = e.cloudProxyServer;

              if (!("disabled" === r)) {
                _context474.next = 29;
                break;
              }

              if (n) {
                _context474.next = 4;
                break;
              }

              return _context474.abrupt("return");

            case 4:
              if (!e.useLocalAccessPoint) {
                _context474.next = 8;
                break;
              }

              _context474.next = 7;
              return mA(e, t, i, s);

            case 7:
              return _context474.abrupt("return", _context474.sent);

            case 8:
              if (!DC("JOIN_WITH_FALLBACK_MEDIA_PROXY")) {
                _context474.next = 26;
                break;
              }

              _context474.next = 11;
              return SA(e, t, i, s);

            case 11:
              _yield$SA = _context474.sent;
              _n159 = _yield$SA.gatewayInfo;
              _r73 = _yield$SA.proxyInfo;

              if (!(e.turnServer && "auto" !== e.turnServer.mode)) {
                _context474.next = 16;
                break;
              }

              return _context474.abrupt("return", {
                gatewayInfo: _n159
              });

            case 16:
              _a35 = _r73.map(function (e) {
                return {
                  turnServerURL: e.address,
                  tcpport: e.tcpport || aI.tcpport,
                  udpport: e.udpport || aI.udpport,
                  username: e.username || aI.username,
                  password: e.password || aI.password,
                  forceturn: !1,
                  security: !0
                };
              });

              if (!s.useP2P) {
                _context474.next = 25;
                break;
              }

              _t344 = null !== (o = e.uid) && void 0 !== o ? o : _n159.uid;
              _i185 = "glb:".concat(_t344.toString());
              _context474.next = 22;
              return tg(_i185);

            case 22:
              _s109 = _context474.sent;
              _c10 = _r73.map(function (e) {
                return {
                  turnServerURL: e.address,
                  tcpport: e.tcpport || aI.tcpport,
                  udpport: e.udpport || aI.udpport,
                  username: _i185,
                  password: _s109,
                  forceturn: !1,
                  security: !0
                };
              });

              _a35.push.apply(_a35, _toConsumableArray(_c10));

            case 25:
              return _context474.abrupt("return", (e.turnServer = {
                mode: "manual",
                servers: _a35
              }, {
                gatewayInfo: _n159
              }));

            case 26:
              _context474.next = 28;
              return mA(e, t, i, s);

            case 28:
              return _context474.abrupt("return", _context474.sent);

            case 29:
              _context474.next = 31;
              return SA(e, t, i, s);

            case 31:
              _yield$SA2 = _context474.sent;
              a = _yield$SA2.proxyInfo;
              c = _yield$SA2.gatewayInfo;
              d = {
                gatewayInfo: c
              };
              l = a.map(function (e) {
                return {
                  turnServerURL: e.address,
                  tcpport: "proxy3" === r ? void 0 : e.tcpport ? e.tcpport : aI.tcpport,
                  udpport: "proxy4" === r ? void 0 : e.udpport ? e.udpport : aI.udpport,
                  username: e.username || aI.username,
                  password: e.password || aI.password,
                  forceturn: "proxy4" !== r,
                  security: "proxy5" === r
                };
              });

              if (!s.useP2P) {
                _context474.next = 44;
                break;
              }

              _t345 = null !== (u = e.uid) && void 0 !== u ? u : c.uid;
              _i186 = "glb:".concat(_t345.toString());
              _context474.next = 41;
              return tg(_i186);

            case 41:
              _n160 = _context474.sent;
              _s110 = a.map(function (e) {
                return {
                  turnServerURL: e.address,
                  tcpport: "proxy3" === r ? void 0 : e.tcpport || aI.tcpport,
                  udpport: "proxy4" === r ? void 0 : e.udpport || aI.udpport,
                  username: _i186,
                  password: _n160,
                  forceturn: "proxy4" !== r,
                  security: "proxy5" === r
                };
              });
              l.push.apply(l, _toConsumableArray(_s110));

            case 44:
              return _context474.abrupt("return", (e.turnServer = {
                mode: "manual",
                servers: l
              }, YC.debug("[".concat(e.clientId, "] set proxy server: ").concat(e.proxyServer, ", mode: ").concat(r)), d));

            case 45:
            case "end":
              return _context474.stop();
          }
        }
      }, _callee474);
    }));
    return _fA.apply(this, arguments);
  }

  function TA(_x132, _x133, _x134, _x135, _x136) {
    return _TA.apply(this, arguments);
  }

  function _TA() {
    _TA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee476(e, t, i, n, s) {
      var r, o, a, _r74;

      return _regeneratorRuntime.wrap(function _callee476$(_context476) {
        while (1) {
          switch (_context476.prev = _context476.next) {
            case 0:
              r = DC("ACCOUNT_REGISTER").slice(0, DC("AJAX_REQUEST_CONCURRENT"));
              o = [];
              o = t.proxyServer ? r.map(function (e) {
                return "https://".concat(t.proxyServer, "/ap/?url=").concat(e + "/api/v1");
              }) : r.map(function (e) {
                return "https://".concat(e, "/api/v1");
              });
              a = null == s ? void 0 : s.recordJoinChannelService({
                startTs: Date.now(),
                status: "pending",
                service: "stringUID",
                urls: o
              });
              _context476.prev = 4;
              _context476.next = 7;
              return function () {
                var _ref119 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee475(e, t, i, n, s) {
                  var r, o, a, c, _e411;

                  return _regeneratorRuntime.wrap(function _callee475$(_context475) {
                    while (1) {
                      switch (_context475.prev = _context475.next) {
                        case 0:
                          r = Date.now(), o = {
                            sid: i.sid,
                            opid: 10,
                            appid: i.appId,
                            string_uid: t
                          };
                          a = e[0];
                          _context475.next = 4;
                          return Xg(function () {
                            return Ky(a + "".concat(-1 === a.indexOf("?") ? "?" : "&", "action=stringuid"), {
                              data: o,
                              cancelToken: n,
                              headers: {
                                "X-Packet-Service-Type": 0,
                                "X-Packet-URI": 72
                              }
                            });
                          }, function (i, n) {
                            if (0 === i.code) {
                              if (i.uid <= 0 || i.uid >= Math.pow(2, 32)) throw YC.error("Invalid Uint Uid ".concat(t, " => ").concat(i.uid), i), rI.reqUserAccount(o.sid, {
                                lts: r,
                                success: !1,
                                serverAddr: a,
                                stringUid: o.string_uid,
                                uid: i.uid,
                                errorCode: xT.INVALID_UINT_UID_FROM_STRING_UID,
                                extend: o
                              }), new VI(xT.INVALID_UINT_UID_FROM_STRING_UID);
                              return rI.reqUserAccount(o.sid, {
                                lts: r,
                                success: !0,
                                serverAddr: a,
                                stringUid: o.string_uid,
                                uid: i.uid,
                                errorCode: null,
                                extend: o
                              }), !1;
                            }

                            var s = xv(i.code);
                            return s.retry && (a = e[(n + 1) % e.length]), rI.reqUserAccount(o.sid, {
                              lts: r,
                              success: !1,
                              serverAddr: a,
                              stringUid: o.string_uid,
                              uid: i.uid,
                              errorCode: s.desc,
                              extend: o
                            }), s.retry;
                          }, function (t, i) {
                            return t.code !== xT.OPERATION_ABORTED && (rI.reqUserAccount(o.sid, {
                              lts: r,
                              success: !1,
                              serverAddr: a,
                              stringUid: o.string_uid,
                              uid: null,
                              errorCode: t.code,
                              extend: o
                            }), a = e[(i + 1) % e.length], !0);
                          }, s);

                        case 4:
                          c = _context475.sent;

                          if (!(0 !== c.code)) {
                            _context475.next = 8;
                            break;
                          }

                          _e411 = xv(c.code);
                          throw new VI(xT.UNEXPECTED_RESPONSE, _e411.desc);

                        case 8:
                          return _context475.abrupt("return", c);

                        case 9:
                        case "end":
                          return _context475.stop();
                      }
                    }
                  }, _callee475);
                }));

                return function (_x739, _x740, _x741, _x742, _x743) {
                  return _ref119.apply(this, arguments);
                };
              }()(o, e, t, i, n);

            case 7:
              _r74 = _context476.sent;
              return _context476.abrupt("return", (null == s || s.recordJoinChannelService({
                status: "success",
                endTs: Date.now()
              }, a), _r74.uid));

            case 11:
              _context476.prev = 11;
              _context476.t0 = _context476["catch"](4);
              throw null == s || s.recordJoinChannelService({
                status: "error",
                endTs: Date.now(),
                errors: [_context476.t0]
              }, a), _context476.t0;

            case 14:
            case "end":
              return _context476.stop();
          }
        }
      }, _callee476, null, [[4, 11]]);
    }));
    return _TA.apply(this, arguments);
  }

  function gA(_x137, _x138, _x139) {
    return _gA.apply(this, arguments);
  }

  function _gA() {
    _gA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee477(e, t, i) {
      var n, s, r, o;
      return _regeneratorRuntime.wrap(function _callee477$(_context477) {
        while (1) {
          switch (_context477.prev = _context477.next) {
            case 0:
              n = DC("CDS_AP").slice(0, DC("AJAX_REQUEST_CONCURRENT")).map(function (t) {
                return e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(t + "/api/v1") : "https://".concat(t, "/api/v1?action=config");
              }).map(function (n) {
                return function (e, t, i, n) {
                  var s = pT(),
                      r = {
                    flag: 64,
                    cipher_method: 0,
                    features: {
                      device: s.name,
                      system: s.os,
                      system_general: navigator.userAgent,
                      vendor: t.appId,
                      version: yC,
                      cname: t.cname,
                      sid: t.sid,
                      session_id: t.sid,
                      detail: "",
                      proxyServer: t.proxyServer
                    }
                  };
                  return Xg(function () {
                    return Ky(e, {
                      data: r,
                      timeout: 1e3,
                      cancelToken: i,
                      headers: {
                        "X-Packet-Service-Type": 0,
                        "X-Packet-URI": 54
                      }
                    });
                  }, void 0, function (e) {
                    return e.code !== xT.OPERATION_ABORTED;
                  }, n);
                }(n, e, t, i);
              });
              s = null, r = null, o = {};
              _context477.prev = 2;
              _context477.next = 5;
              return _A(n);

            case 5:
              s = _context477.sent;
              _context477.next = 13;
              break;

            case 8:
              _context477.prev = 8;
              _context477.t0 = _context477["catch"](2);

              if (!(_context477.t0.code === xT.OPERATION_ABORTED)) {
                _context477.next = 12;
                break;
              }

              throw _context477.t0;

            case 12:
              r = _context477.t0;

            case 13:
              n.forEach(function (e) {
                return e.cancel();
              });
              if (rI.reportApiInvoke(e.sid, {
                name: rg.REQUEST_CONFIG_DISTRIBUTE,
                options: {
                  error: r,
                  res: s
                }
              }).onSuccess(), s && s.test_tags) try {
                o = function (e) {
                  if (!e.test_tags) return {};
                  var t = e.test_tags,
                      i = Object.keys(t),
                      n = {};
                  return i.forEach(function (e) {
                    var i;
                    var s = Sy(i = e.slice(4)).call(i),
                        r = JSON.parse(t[e])[1];
                    n[s] = r;
                  }), n;
                }(s);
              } catch (e) {}
              return _context477.abrupt("return", o);

            case 16:
            case "end":
              return _context477.stop();
          }
        }
      }, _callee477, null, [[2, 8]]);
    }));
    return _gA.apply(this, arguments);
  }

  function SA(_x140, _x141, _x142, _x143) {
    return _SA.apply(this, arguments);
  }

  function _SA() {
    _SA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee480(e, t, i, n) {
      var s, r, o, a, c, d, l, u, h, _yield$_A, _t346;

      return _regeneratorRuntime.wrap(function _callee480$(_context480) {
        while (1) {
          switch (_context480.prev = _context480.next) {
            case 0:
              s = DC("PROXY_SERVER_TYPE3"), r = function r(e, t, i) {
                var n = i || s;
                return Array.isArray(n) && (n = t % 2 == 0 ? s[1] : s[0]), "https://".concat(n, "/ap/?url=").concat(e);
              };
              o = null;
              a = [], c = /*#__PURE__*/function () {
                var _ref120 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee478() {
                  var s, o, c;
                  return _regeneratorRuntime.wrap(function _callee478$(_context478) {
                    while (1) {
                      switch (_context478.prev = _context478.next) {
                        case 0:
                          s = DC("WEBCS_DOMAIN").slice(0, DC("AJAX_REQUEST_CONCURRENT")).map(function (t, i) {
                            var n;
                            return n = "disabled" === e.cloudProxyServer && e.proxyServer ? r("".concat(t, "/api/v2/transpond/webrtc?v=2"), i, e.proxyServer) : "disabled" === e.cloudProxyServer || "fallback" === e.cloudProxyServer ? "https://".concat(t, "/api/v2/transpond/webrtc?v=2") : r("".concat(t, "/api/v2/transpond/webrtc?v=2"), i), {
                              url: n,
                              areaCode: Yy(),
                              serviceIds: [_y.CHOOSE_SERVER, "proxy5" === e.cloudProxyServer ? _y.CLOUD_PROXY_5 : "proxy3" === e.cloudProxyServer || "proxy4" === e.cloudProxyServer ? _y.CLOUD_PROXY : _y.CLOUD_PROXY_FALLBACK]
                            };
                          });
                          o = n.recordJoinChannelService({
                            startTs: Date.now(),
                            status: "pending",
                            service: "chooseServer",
                            urls: s.map(function (e) {
                              return e.url;
                            })
                          });
                          _context478.next = 4;
                          return EA({
                            fragementLength: DC("FRAGEMENT_LENGTH"),
                            referenceList: s,
                            asyncMapHandler: function asyncMapHandler(n) {
                              return YC.debug("[".concat(e.clientId, "] Connect to choose_server:"), n.url), aA(n, e, t, i);
                            },
                            allFailedhandler: function allFailedhandler(e) {
                              throw n.recordJoinChannelService({
                                endTs: Date.now(),
                                status: "error",
                                errors: e
                              }, o), e[0];
                            },
                            promisesCollector: a
                          });

                        case 4:
                          c = _context478.sent;
                          return _context478.abrupt("return", (n.recordJoinChannelService({
                            endTs: Date.now(),
                            status: "success"
                          }, o), c));

                        case 6:
                        case "end":
                          return _context478.stop();
                      }
                    }
                  }, _callee478);
                }));

                return function c() {
                  return _ref120.apply(this, arguments);
                };
              }(), d = /*#__PURE__*/function () {
                var _ref121 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee479() {
                  var s, c, d;
                  return _regeneratorRuntime.wrap(function _callee479$(_context479) {
                    while (1) {
                      switch (_context479.prev = _context479.next) {
                        case 0:
                          _context479.next = 2;
                          return Ug(1e3);

                        case 2:
                          if (!(null !== o)) {
                            _context479.next = 4;
                            break;
                          }

                          return _context479.abrupt("return", o);

                        case 4:
                          s = DC("WEBCS_DOMAIN_BACKUP_LIST").map(function (t, i) {
                            var n;
                            return n = "disabled" === e.cloudProxyServer && e.proxyServer ? r("".concat(t, "/api/v2/transpond/webrtc?v=2"), i, e.proxyServer) : "disabled" === e.cloudProxyServer || "fallback" === e.cloudProxyServer ? "https://".concat(t, "/api/v2/transpond/webrtc?v=2") : r("".concat(t, "/api/v2/transpond/webrtc?v=2"), i), {
                              url: n,
                              areaCode: Yy(),
                              serviceIds: [_y.CHOOSE_SERVER, "proxy5" === e.cloudProxyServer ? _y.CLOUD_PROXY_5 : "proxy3" === e.cloudProxyServer || "proxy4" === e.cloudProxyServer ? _y.CLOUD_PROXY : _y.CLOUD_PROXY_FALLBACK]
                            };
                          });
                          c = n.recordJoinChannelService({
                            startTs: Date.now(),
                            status: "pending",
                            service: "chooseServer",
                            urls: s.map(function (e) {
                              return e.url;
                            })
                          });
                          _context479.next = 8;
                          return EA({
                            fragementLength: DC("FRAGEMENT_LENGTH"),
                            referenceList: s,
                            asyncMapHandler: function asyncMapHandler(n) {
                              return YC.debug("[".concat(e.clientId, "] Connect to backup choose_server:"), n.url), aA(n, e, t, i);
                            },
                            allFailedhandler: function allFailedhandler(e) {
                              throw n.recordJoinChannelService({
                                endTs: Date.now(),
                                status: "error",
                                errors: e
                              }, c), e[0];
                            },
                            promisesCollector: a
                          });

                        case 8:
                          d = _context479.sent;
                          return _context479.abrupt("return", (n.recordJoinChannelService({
                            endTs: Date.now(),
                            status: "success"
                          }, c), d));

                        case 10:
                        case "end":
                          return _context479.stop();
                      }
                    }
                  }, _callee479);
                }));

                return function d() {
                  return _ref121.apply(this, arguments);
                };
              }();
              _context480.prev = 3;
              _context480.next = 6;
              return _A([c(), d()]);

            case 6:
              _yield$_A = _context480.sent;
              l = _yield$_A.gatewayInfo;
              u = _yield$_A.proxyInfo;
              h = _yield$_A.url;
              _context480.next = 15;
              break;

            case 12:
              _context480.prev = 12;
              _context480.t0 = _context480["catch"](3);
              throw _context480.t0[0];

            case 15:
              if (!(a.length && a.forEach(function (e) {
                return e.cancel && "function" == typeof e.cancel && e.cancel();
              }), !l || !u)) {
                _context480.next = 17;
                break;
              }

              throw new VI(xT.UNEXPECTED_ERROR, "missing gateway or proxy response").print();

            case 17:
              if (e.apUrl = h, "disabled" !== e.cloudProxyServer && Array.isArray(s) && h) {
                _t346 = /^https?:\/\/(.+?)(\/.*)?$/.exec(h)[1];
                bn(s).call(s, _t346) && (e.proxyServer = _t346, YC.setProxyServer(_t346), rI.setProxyServer(_t346));
              }

              _context480.t1 = l;
              _context480.next = 21;
              return Oy(u, l.uid);

            case 21:
              _context480.t2 = _context480.sent;
              o = {
                gatewayInfo: _context480.t1,
                proxyInfo: _context480.t2
              };
              return _context480.abrupt("return", o);

            case 24:
            case "end":
              return _context480.stop();
          }
        }
      }, _callee480, null, [[3, 12]]);
    }));
    return _SA.apply(this, arguments);
  }

  function RA(_x144, _x145, _x146, _x147) {
    return _RA.apply(this, arguments);
  }

  function _RA() {
    _RA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee481(e, t, i, n) {
      var s;
      return _regeneratorRuntime.wrap(function _callee481$(_context481) {
        while (1) {
          switch (_context481.prev = _context481.next) {
            case 0:
              s = DC("UAP_AP").slice(0, DC("AJAX_REQUEST_CONCURRENT")).map(function (e) {
                return t.proxyServer ? "https://".concat(t.proxyServer, "/ap/?url=").concat(e + "/api/v1?action=uap") : "https://".concat(e, "/api/v1?action=uap");
              });
              _context481.next = 3;
              return sA(s, e, t, i, n);

            case 3:
              return _context481.abrupt("return", _context481.sent);

            case 4:
            case "end":
              return _context481.stop();
          }
        }
      }, _callee481);
    }));
    return _RA.apply(this, arguments);
  }

  function CA(_x148, _x149, _x150) {
    return _CA.apply(this, arguments);
  }

  function _CA() {
    _CA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee483(e, t, i) {
      var n, _e415;

      return _regeneratorRuntime.wrap(function _callee483$(_context483) {
        while (1) {
          switch (_context483.prev = _context483.next) {
            case 0:
              n = DC("UAP_AP").slice(0, DC("AJAX_REQUEST_CONCURRENT")).map(function (t) {
                return e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(t + "/api/v1?action=uap") : "https://".concat(t, "/api/v1?action=uap");
              }).map(function (n) {
                return function (e, t, i, n) {
                  var s = {
                    command: "convergeAllocateEdge",
                    sid: t.sid,
                    appId: t.appId,
                    token: t.token,
                    ts: Date.now(),
                    version: yC,
                    cname: t.cname,
                    uid: t.uid.toString(),
                    requestId: rA,
                    seq: rA
                  };
                  rA += 1;
                  var r = {
                    service_name: "tele_channel",
                    json_body: JSON.stringify(s)
                  };
                  return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee482() {
                    var t, _e412, n, _e413, _e414;

                    return _regeneratorRuntime.wrap(function _callee482$(_context482) {
                      while (1) {
                        switch (_context482.prev = _context482.next) {
                          case 0:
                            _context482.next = 2;
                            return Ky(e, {
                              data: r,
                              cancelToken: i,
                              headers: {
                                "X-Packet-Service-Type": 0,
                                "X-Packet-URI": 61
                              }
                            });

                          case 2:
                            t = _context482.sent;

                            if (!(0 !== t.code)) {
                              _context482.next = 6;
                              break;
                            }

                            _e412 = new VI(xT.UNEXPECTED_RESPONSE, "cross channel ap error, code" + t.code, {
                              retry: !0
                            });
                            throw YC.error(_e412.toString()), _e412;

                          case 6:
                            n = JSON.parse(t.json_body);

                            if (!(200 !== n.code)) {
                              _context482.next = 10;
                              break;
                            }

                            _e413 = new VI(xT.UNEXPECTED_RESPONSE, "cross channel app center error, code: ".concat(n.code, ", reason: ").concat(n.reason));
                            throw YC.error(_e413.toString()), _e413;

                          case 10:
                            if (!(!n.servers || 0 === n.servers.length)) {
                              _context482.next = 13;
                              break;
                            }

                            _e414 = new VI(xT.UNEXPECTED_RESPONSE, "cross channel app center empty server");
                            throw YC.error(_e414.toString()), _e414;

                          case 13:
                            return _context482.abrupt("return", {
                              vid: n.vid,
                              workerToken: n.workerToken,
                              addressList: (DC("CHANNEL_MEDIA_RELAY_SERVERS") || n.servers).map(function (e) {
                                return "wss://".concat(e.address.replace(/\./g, "-"), ".").concat(DC("WORKER_DOMAIN"), ":").concat(e.wss);
                              })
                            });

                          case 14:
                          case "end":
                            return _context482.stop();
                        }
                      }
                    }, _callee482);
                  })), void 0, function (e) {
                    return !!(e.code !== xT.OPERATION_ABORTED && e.code !== xT.UNEXPECTED_RESPONSE || e.data && e.data.retry);
                  }, n);
                }(n, e, t, i);
              });
              _context483.prev = 1;
              _context483.next = 4;
              return _A(n);

            case 4:
              _e415 = _context483.sent;
              return _context483.abrupt("return", (n.forEach(function (e) {
                return e.cancel();
              }), _e415));

            case 8:
              _context483.prev = 8;
              _context483.t0 = _context483["catch"](1);
              throw _context483.t0[0];

            case 11:
            case "end":
              return _context483.stop();
          }
        }
      }, _callee483, null, [[1, 8]]);
    }));
    return _CA.apply(this, arguments);
  }

  function IA(_x151, _x152, _x153) {
    return _IA.apply(this, arguments);
  }

  function _IA() {
    _IA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee486(e, t, i) {
      var n, s, r;
      return _regeneratorRuntime.wrap(function _callee486$(_context486) {
        while (1) {
          switch (_context486.prev = _context486.next) {
            case 0:
              n = null;
              s = [], r = /*#__PURE__*/function () {
                var _ref123 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee485(r) {
                  var o;
                  return _regeneratorRuntime.wrap(function _callee485$(_context485) {
                    while (1) {
                      switch (_context485.prev = _context485.next) {
                        case 0:
                          o = DC(r ? "WEBCS_DOMAIN_BACKUP_LIST" : "WEBCS_DOMAIN").map(function (t) {
                            return e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(t + "/api/v2/transpond/webrtc?v=2") : "https://".concat(t, "/api/v2/transpond/webrtc?v=2");
                          });
                          _context485.t0 = r;

                          if (!_context485.t0) {
                            _context485.next = 6;
                            break;
                          }

                          _context485.next = 5;
                          return Ug(1e3);

                        case 5:
                          _context485.t0 = null !== n;

                        case 6:
                          if (!_context485.t0) {
                            _context485.next = 10;
                            break;
                          }

                          _context485.t1 = n;
                          _context485.next = 13;
                          break;

                        case 10:
                          _context485.next = 12;
                          return EA({
                            fragementLength: DC("FRAGEMENT_LENGTH"),
                            referenceList: o,
                            asyncMapHandler: function asyncMapHandler(n) {
                              return YC.debug("[".concat(e.clientId, "] update ticket, Connect to ").concat(r ? "backup" : "", " choose_server:"), n), function (e, t, i, n) {
                                var _hA = hA(t, [_y.CHOOSE_SERVER]),
                                    _hA2 = _slicedToArray(_hA, 1),
                                    s = _hA2[0];

                                var r = Rg.networkState;
                                return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee484() {
                                  var t;
                                  return _regeneratorRuntime.wrap(function _callee484$(_context484) {
                                    while (1) {
                                      switch (_context484.prev = _context484.next) {
                                        case 0:
                                          _context484.t0 = r && Rg.networkState === ug.OFFLINE && Rg.onlineWaiter;

                                          if (!_context484.t0) {
                                            _context484.next = 4;
                                            break;
                                          }

                                          _context484.next = 4;
                                          return tT.race([Rg.onlineWaiter, Ug(n && n.maxRetryTimeout || Jg.maxRetryTimeout)]);

                                        case 4:
                                          r = Rg.networkState;
                                          _context484.next = 7;
                                          return Ky(e, {
                                            data: s,
                                            cancelToken: i,
                                            headers: {
                                              "Content-Type": "multipart/form-data;"
                                            }
                                          }, !0);

                                        case 7:
                                          t = _context484.sent;
                                          return _context484.abrupt("return", lA(t, e));

                                        case 9:
                                        case "end":
                                          return _context484.stop();
                                      }
                                    }
                                  }, _callee484);
                                })), function () {
                                  return !1;
                                }, function (e) {
                                  return e.code !== xT.OPERATION_ABORTED && (e.code === xT.UPDATE_TICKET_FAILED ? e.data.retry : (YC.warning("[".concat(t.clientId, "] update ticket network error, retry"), e), !0));
                                }, n);
                              }(n, e, t, i);
                            },
                            allFailedhandler: function allFailedhandler(e) {
                              throw e[0];
                            },
                            promisesCollector: s
                          });

                        case 12:
                          _context485.t1 = _context485.sent;

                        case 13:
                          return _context485.abrupt("return", _context485.t1);

                        case 14:
                        case "end":
                          return _context485.stop();
                      }
                    }
                  }, _callee485);
                }));

                return function (_x744) {
                  return _ref123.apply(this, arguments);
                };
              }();
              _context486.prev = 2;
              _context486.next = 5;
              return _A([r(!1), r(!0)]);

            case 5:
              n = _context486.sent;
              s.length && s.forEach(function (e) {
                return e.cancel && "function" == typeof e.cancel && e.cancel();
              });
              return _context486.abrupt("return", n);

            case 10:
              _context486.prev = 10;
              _context486.t0 = _context486["catch"](2);
              throw _context486.t0[0];

            case 13:
            case "end":
              return _context486.stop();
          }
        }
      }, _callee486, null, [[2, 10]]);
    }));
    return _IA.apply(this, arguments);
  }

  function vA(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function yA(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? vA(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : vA(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var AA = /*#__PURE__*/function (_ig11) {
    _inherits(AA, _ig11);

    var _super17 = _createSuper(AA);

    function AA() {
      var _this97;

      _classCallCheck(this, AA);

      _this97 = _super17.call(this), nh(_assertThisInitialized(_this97), "configs", void 0), nh(_assertThisInitialized(_this97), "joinInfo", void 0), nh(_assertThisInitialized(_this97), "cancelToken", void 0), nh(_assertThisInitialized(_this97), "retryConfig", {
        timeout: 3e3,
        timeoutFactor: 1.5,
        maxRetryCount: 1,
        maxRetryTimeout: 1e4
      }), nh(_assertThisInitialized(_this97), "interval", void 0), nh(_assertThisInitialized(_this97), "mutex", new Yg("config-distribute")), nh(_assertThisInitialized(_this97), "mutableParamsRead", !1);
      return _this97;
    }

    _createClass(AA, [{
      key: "isSuccess",
      get: function get() {
        return !!this.configs;
      }
    }, {
      key: "startGetConfigDistribute",
      value: function startGetConfigDistribute(e, t) {
        var _this98 = this;

        this.joinInfo = e, this.cancelToken = t, this.interval && this.stopGetConfigDistribute(), DC("ENABLE_CONFIG_DISTRIBUTE") && (this.updateConfigDistribute(), this.interval = window.setInterval(function () {
          _this98.updateConfigDistribute();
        }, DC("CONFIG_DISTRIBUTE_INTERVAL")));
      }
    }, {
      key: "stopGetConfigDistribute",
      value: function stopGetConfigDistribute() {
        this.interval && clearInterval(this.interval), this.interval = void 0, this.joinInfo = void 0, this.cancelToken = void 0;
      }
    }, {
      key: "awaitConfigDistributeComplete",
      value: function () {
        var _awaitConfigDistributeComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80() {
          return _regeneratorRuntime.wrap(function _callee80$(_context80) {
            while (1) {
              switch (_context80.prev = _context80.next) {
                case 0:
                  if (this.mutex.isLocked) {
                    _context80.next = 2;
                    break;
                  }

                  return _context80.abrupt("return");

                case 2:
                  _context80.next = 4;
                  return this.mutex.lock();

                case 4:
                  _context80.t0 = _context80.sent;
                  (0, _context80.t0)();

                case 6:
                case "end":
                  return _context80.stop();
              }
            }
          }, _callee80, this);
        }));

        function awaitConfigDistributeComplete() {
          return _awaitConfigDistributeComplete.apply(this, arguments);
        }

        return awaitConfigDistributeComplete;
      }()
    }, {
      key: "updateConfigDistribute",
      value: function () {
        var _updateConfigDistribute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81() {
          var e, t, _t65;

          return _regeneratorRuntime.wrap(function _callee81$(_context81) {
            while (1) {
              switch (_context81.prev = _context81.next) {
                case 0:
                  if (!this.mutableParamsRead) {
                    this.mutableParamsRead = !0;
                    rI.reportApiInvoke(null, {
                      options: void 0,
                      name: rg.LOAD_CONFIG_FROM_LOCALSTORAGE,
                      tag: og.TRACER
                    }).onSuccess(JSON.stringify(PC));
                  }

                  if (!(!this.joinInfo || !this.cancelToken || !this.retryConfig)) {
                    _context81.next = 3;
                    break;
                  }

                  return _context81.abrupt("return", void YC.debug("[config-distribute] get config distribute interrupted have no joininfo"));

                case 3:
                  _context81.next = 5;
                  return this.mutex.lock();

                case 5:
                  t = _context81.sent;
                  _context81.prev = 6;
                  _context81.next = 9;
                  return gA(this.joinInfo, this.cancelToken, this.retryConfig);

                case 9:
                  e = _context81.sent;
                  YC.debug("[config-distribute] get config distribute", JSON.stringify(e));
                  e.limit_bitrate && this.handleBitrateLimit(e.limit_bitrate);
                  this.cacheGlobalParameterConfig(e);
                  this.configs = e;
                  _context81.next = 20;
                  break;

                case 16:
                  _context81.prev = 16;
                  _context81.t0 = _context81["catch"](6);
                  _t65 = new VI(xT.NETWORK_RESPONSE_ERROR, _context81.t0);
                  YC.warning("[config-distribute] ".concat(_t65.toString()));

                case 20:
                  _context81.prev = 20;
                  t();
                  return _context81.finish(20);

                case 23:
                case "end":
                  return _context81.stop();
              }
            }
          }, _callee81, this, [[6, 16, 20, 23]]);
        }));

        function updateConfigDistribute() {
          return _updateConfigDistribute.apply(this, arguments);
        }

        return updateConfigDistribute;
      }()
    }, {
      key: "getBitrateLimit",
      value: function getBitrateLimit() {
        return this.configs ? this.configs.limit_bitrate : void 0;
      }
    }, {
      key: "handleBitrateLimit",
      value: function handleBitrateLimit(e) {
        var t;
        (t = e) && t.uplink && t.id && void 0 !== t.uplink.max_bitrate && void 0 !== t.uplink.min_bitrate && (this.configs && this.configs.limit_bitrate ? this.configs && this.configs.limit_bitrate && this.configs.limit_bitrate.id !== e.id && this.emit(lv.UPDATE_BITRATE_LIMIT, e) : this.emit(lv.UPDATE_BITRATE_LIMIT, e));
      }
    }, {
      key: "getLowStreamConfigDistribute",
      value: function getLowStreamConfigDistribute() {
        return this.configs && this.configs.limit_bitrate && yA({}, this.configs.limit_bitrate.low_stream_uplink);
      }
    }, {
      key: "cacheGlobalParameterConfig",
      value: function cacheGlobalParameterConfig(e) {
        var t;
        var i = Zh(t = Object.keys(e).filter(function (e) {
          return /^webrtc_ng_global_parameter/.test(e);
        })).call(t);

        for (var _t66 = 0; _t66 < i.length; _t66++) {
          for (var _n32 = i.length - 1; _n32 > _t66; _n32--) {
            var _t67 = i[_n32];

            if ("number" == typeof e[_t67].__priority) {
              var s = e[_t67].__priority,
                  r = i[_n32 - 1];

              if ("number" == typeof e[r].__priority) {
                if (!(s > e[r].__priority)) continue;
                {
                  var _e60 = _t67;
                  i[_n32] = i[_n32 - 1], i[_n32 - 1] = _e60;
                }
              } else {
                var _e61 = _t67;
                i[_n32] = i[_n32 - 1], i[_n32 - 1] = _e61;
              }
            }
          }
        }

        var n = {};
        i.forEach(function (t) {
          var i = e[t],
              s = i.__expires;
          Object.keys(i).forEach(function (e) {
            "__priority" === e || "__expires" === e || Object.prototype.hasOwnProperty.call(n, e) || (n[e] = yA({
              value: i[e]
            }, s && {
              expires: s
            }));
          });
        });

        try {
          !function (e) {
            try {
              var _t69 = Date.now();

              Object.keys(e).forEach(function (i) {
                switch (i) {
                  case "ENABLE_EVENT_REPORT":
                  case "UPLOAD_LOG":
                    if (Object.prototype.hasOwnProperty.call(OC, i)) {
                      var _e$i = e[i],
                          _n33 = _e$i.value,
                          _s20 = _e$i.expires;
                      if (_s20 && _s20 <= _t69) return;
                      PC[i] = _n33, OC[i] = _n33, YC.debug("Update global parameters from config distribute", i, _n33);
                    }

                }
              });
            } catch (t) {
              YC.error("Error update config immediately: ".concat(e), t.message);
            }
          }(n);

          var _e62 = JSON.stringify(n),
              _t68 = window.btoa(_e62);

          window.localStorage.setItem("websdk_ng_global_parameter", _t68), YC.debug("Caching global parameters ".concat(_e62));
        } catch (e) {
          YC.error("Error caching global parameters:", e.message);
        }
      }
    }]);

    return AA;
  }(ig);

  var bA = {
    getDisplayMedia: !1,
    getStreamFromExtension: !1,
    supportUnifiedPlan: !1,
    supportMinBitrate: !1,
    supportSetRtpSenderParameters: !1,
    supportDualStream: !0,
    webAudioMediaStreamDest: !1,
    supportReplaceTrack: !1,
    supportWebGL: !1,
    webAudioWithAEC: !1,
    supportRequestFrame: !1,
    supportShareAudio: !1,
    supportDualStreamEncoding: !1,
    supportDataChannel: !1,
    supportPCSetConfiguration: !1,
    supportWebRTCEncodedTransform: !1,
    supportWebRTCInsertableStream: !1
  };

  function wA() {
    return bA;
  }

  var OA;

  function NA(e, t, i) {
    return {
      sampleRate: e,
      stereo: t,
      bitrate: i
    };
  }

  function DA(e, t, i, n, s) {
    return {
      width: e,
      height: t,
      frameRate: i,
      bitrateMin: n,
      bitrateMax: s
    };
  }

  function PA(e, t, i, n, s) {
    return {
      width: {
        max: e
      },
      height: {
        max: t
      },
      frameRate: i,
      bitrateMin: n,
      bitrateMax: s
    };
  }

  function LA(e, t) {
    return {
      numSpatialLayers: e,
      numTemporalLayers: t
    };
  }

  !function (e) {
    e.IOS_15_16_INTERRUPTION_START = "ios15_16-interruption-start", e.IOS_15_16_INTERRUPTION_END = "ios15_16-interruption-end", e.IOS_INTERRUPTION_START = "ios-interruption-start", e.IOS_INTERRUPTION_END = "ios-interruption-end", e.STATE_CHANGE = "state-change";
  }(OA || (OA = {}));
  var kA = {
    "90p": DA(160, 90),
    "90p_1": DA(160, 90),
    "120p": DA(160, 120, 15, 30, 65),
    "120p_1": DA(160, 120, 15, 30, 65),
    "120p_3": DA(120, 120, 15, 30, 50),
    "120p_4": DA(212, 120),
    "180p": DA(320, 180, 15, 30, 140),
    "180p_1": DA(320, 180, 15, 30, 140),
    "180p_3": DA(180, 180, 15, 30, 100),
    "180p_4": DA(240, 180, 15, 30, 120),
    "240p": DA(320, 240, 15, 40, 200),
    "240p_1": DA(320, 240, 15, 40, 200),
    "240p_3": DA(240, 240, 15, 40, 140),
    "240p_4": DA(424, 240, 15, 40, 220),
    "360p": DA(640, 360, 15, 80, 400),
    "360p_1": DA(640, 360, 15, 80, 400),
    "360p_3": DA(360, 360, 15, 80, 260),
    "360p_4": DA(640, 360, 30, 80, 600),
    "360p_6": DA(360, 360, 30, 80, 400),
    "360p_7": DA(480, 360, 15, 80, 320),
    "360p_8": DA(480, 360, 30, 80, 490),
    "360p_9": DA(640, 360, 15, 80, 800),
    "360p_10": DA(640, 360, 24, 80, 800),
    "360p_11": DA(640, 360, 24, 80, 1e3),
    "480p": DA(640, 480, 15, 100, 500),
    "480p_1": DA(640, 480, 15, 100, 500),
    "480p_2": DA(640, 480, 30, 100, 1e3),
    "480p_3": DA(480, 480, 15, 100, 400),
    "480p_4": DA(640, 480, 30, 100, 750),
    "480p_6": DA(480, 480, 30, 100, 600),
    "480p_8": DA(848, 480, 15, 100, 610),
    "480p_9": DA(848, 480, 30, 100, 930),
    "480p_10": DA(640, 480, 10, 100, 400),
    "720p": DA(1280, 720, 15, 120, 1130),
    "720p_auto": DA(1280, 720, 30, 900, 3e3),
    "720p_1": DA(1280, 720, 15, 120, 1130),
    "720p_2": DA(1280, 720, 30, 120, 2e3),
    "720p_3": DA(1280, 720, 30, 120, 1710),
    "720p_5": DA(960, 720, 15, 120, 910),
    "720p_6": DA(960, 720, 30, 120, 1380),
    "1080p": DA(1920, 1080, 15, 120, 2080),
    "1080p_1": DA(1920, 1080, 15, 120, 2080),
    "1080p_2": DA(1920, 1080, 30, 120, 3e3),
    "1080p_3": DA(1920, 1080, 30, 120, 3150),
    "1080p_5": DA(1920, 1080, 60, 120, 4780),
    "1440p": DA(2560, 1440, 30, 120, 4850),
    "1440p_1": DA(2560, 1440, 30, 120, 4850),
    "1440p_2": DA(2560, 1440, 60, 120, 7350),
    "4k": DA(3840, 2160, 30, 120, 8910),
    "4k_1": DA(3840, 2160, 30, 120, 8910),
    "4k_3": DA(3840, 2160, 60, 120, 13500)
  },
      MA = [{
    scaleResolutionDownBy: 2,
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrateMin: 300,
    bitrateMax: 900
  }, {
    scaleResolutionDownBy: 1.333333,
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrateMin: 600,
    bitrateMax: 2e3
  }, {
    scaleResolutionDownBy: 1,
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrateMin: 900,
    bitrateMax: 3e3
  }],
      UA = {
    "480p": PA(640, 480, 5),
    "480p_1": PA(640, 480, 5),
    "480p_2": PA(640, 480, 30),
    "480p_3": PA(640, 480, 15),
    "720p": PA(1280, 720, 5),
    "720p_auto": DA(1280, 720, 30, 900, 3e3),
    "720p_1": PA(1280, 720, 5),
    "720p_2": PA(1280, 720, 30),
    "720p_3": PA(1280, 720, 15),
    "1080p": PA(1920, 1080, 5),
    "1080p_1": PA(1920, 1080, 5),
    "1080p_2": PA(1920, 1080, 30),
    "1080p_3": PA(1920, 1080, 15)
  },
      xA = {
    "1SL1TL": LA(1, 1),
    "3SL3TL": LA(3, 3),
    "2SL3TL": LA(2, 3)
  };

  function VA(e) {
    return e || (e = "480p_1"), "string" == typeof e ? Object.assign({}, kA[e]) : e;
  }

  function FA(e) {
    return "string" == typeof e ? Object.assign({}, UA[e]) : e;
  }

  function BA(e) {
    return "string" == typeof e ? Object.assign({}, xA[e]) : e;
  }

  var jA = {
    speech_low_quality: NA(16e3, !1),
    speech_standard: NA(32e3, !1, 18),
    music_standard: NA(48e3, !1),
    standard_stereo: NA(48e3, !0, 56),
    high_quality: NA(48e3, !1, 128),
    high_quality_stereo: NA(48e3, !0, 192)
  };

  function GA(e) {
    return "string" == typeof e ? Object.assign({}, jA[e]) : e;
  }

  var WA = [];

  function HA(e) {
    return BT(e, "mediaSource", ["screen", "window", "application"]), !0;
  }

  var KA, YA, qA, JA, zA, XA, QA, ZA, $A, eb;
  !function (e) {
    e.NEED_RENEGOTIATE = "@need_renegotiate", e.NEED_REPLACE_TRACK = "@need_replace_track", e.NEED_CLOSE = "@need_close", e.NEED_ENABLE_TRACK = "@need_enable_track", e.NEED_DISABLE_TRACK = "@need_disable_track", e.NEED_SESSION_ID = "@need_sid", e.SET_OPTIMIZATION_MODE = "@set_optimization_mode", e.GET_STATS = "@get_stats", e.GET_RTC_STATS = "@get_rtc_stats", e.GET_LOW_VIDEO_TRACK = "@get_low_video_track", e.NEED_RESET_REMOTE_SDP = "@need_reset_remote_sdp", e.NEED_UPDATE_VIDEO_ENCODER = "@need_update_video_encoder", e.NEED_MUTE_TRACK = "@need_mute_track", e.NEED_UNMUTE_TRACK = "@need_unmute_track";
  }(KA || (KA = {})), function (e) {
    e.SCREEN_TRACK = "screen_track", e.CUSTOM_TRACK = "custome_track", e.LOW_STREAM = "low_stream";
  }(YA || (YA = {})), function (e) {
    e[e.HIGH_STREAM = 0] = "HIGH_STREAM", e[e.LOW_STREAM = 1] = "LOW_STREAM";
  }(qA || (qA = {})), function (e) {
    e[e.HIGH_STREAM = 0] = "HIGH_STREAM", e[e.LOW_STREAM = 1] = "LOW_STREAM";
  }(JA || (JA = {})), function (e) {
    e[e.DISABLE = 0] = "DISABLE", e[e.LOW_STREAM = 1] = "LOW_STREAM", e[e.AUDIO_ONLY = 2] = "AUDIO_ONLY";
  }(zA || (zA = {})), function (e) {
    e.TRANSCEIVER_UPDATED = "transceiver-updated";
  }(XA || (XA = {})), function (e) {
    e.SOURCE_STATE_CHANGE = "source-state-change", e.TRACK_ENDED = "track-ended", e.BEAUTY_EFFECT_OVERLOAD = "beauty-effect-overload", e.VIDEO_ELEMENT_VISIBLE_STATUS = "video-element-visible-status", e.CLOSED = "closed";
  }(QA || (QA = {})), function (e) {
    e.FIRST_FRAME_DECODED = "first-frame-decoded", e.VIDEO_ELEMENT_VISIBLE_STATUS = "video-element-visible-status";
  }(ZA || (ZA = {})), function (e) {
    e.AUDIO_SOURCE_STATE_CHANGE = "audio_source_state_change", e.RECEIVE_TRACK_BUFFER = "receive_track_buffer", e.ON_AUDIO_BUFFER = "on_audio_buffer", e.UPDATE_SOURCE = "update_source";
  }($A || ($A = {})), function (e) {
    e.UPDATE_TRACK_SOURCE = "update-track-source";
  }(eb || (eb = {}));
  var tb = {
    sendVolumeLevel: 0,
    sendBitrate: 0,
    sendBytes: 0,
    sendPackets: 0,
    sendPacketsLost: 0,
    sendJitterMs: 0,
    sendRttMs: 0,
    currentPacketLossRate: 0
  },
      ib = {
    sendBytes: 0,
    sendBitrate: 0,
    sendPackets: 0,
    sendPacketsLost: 0,
    sendJitterMs: 0,
    sendRttMs: 0,
    sendResolutionHeight: 0,
    sendResolutionWidth: 0,
    captureResolutionHeight: 0,
    captureResolutionWidth: 0,
    targetSendBitrate: 0,
    totalDuration: 0,
    totalFreezeTime: 0,
    currentPacketLossRate: 0
  },
      nb = {
    transportDelay: 0,
    end2EndDelay: 0,
    receiveBitrate: 0,
    receiveLevel: 0,
    receiveBytes: 0,
    receiveDelay: 0,
    receivePackets: 0,
    receivePacketsLost: 0,
    totalDuration: 0,
    totalFreezeTime: 0,
    freezeRate: 0,
    packetLossRate: 0,
    currentPacketLossRate: 0,
    publishDuration: -1
  },
      sb = {
    uplinkNetworkQuality: 0,
    downlinkNetworkQuality: 0
  },
      rb = {
    transportDelay: 0,
    end2EndDelay: 0,
    receiveBitrate: 0,
    receiveBytes: 0,
    receiveDelay: 0,
    receivePackets: 0,
    receivePacketsLost: 0,
    receiveResolutionHeight: 0,
    receiveResolutionWidth: 0,
    totalDuration: 0,
    totalFreezeTime: 0,
    freezeRate: 0,
    packetLossRate: 0,
    currentPacketLossRate: 0,
    publishDuration: -1
  };
  var ob, ab, cb, db, lb;
  !function (e) {
    e.ON_TRACK = "on_track", e.ON_NODE = "on_node";
  }(ob || (ob = {})), function (e) {
    e.REQUEST_UPDATE_CONSTRAINTS = "request_update_constraints", e.REQUEST_CONSTRAINTS = "request_constraints";
  }(ab || (ab = {})), function (e) {
    e.IDLE = "IDLE", e.INITING = "INITING", e.INITEND = "INITEND";
  }(cb || (cb = {})), function (e) {
    e.STATE_CHANGE = "state_change", e.RECORDING_DEVICE_CHANGED = "recordingDeviceChanged", e.PLAYOUT_DEVICE_CHANGED = "playoutDeviceChanged", e.CAMERA_DEVICE_CHANGED = "cameraDeviceChanged";
  }(db || (db = {})), function (e) {
    e.NONE = "none", e.INIT = "init", e.CANPLAY = "canplay", e.PLAYING = "playing", e.PAUSED = "paused", e.SUSPEND = "suspend", e.STALLED = "stalled", e.WAITING = "waiting", e.ERROR = "error", e.DESTROYED = "destroyed", e.ABORT = "abort", e.ENDED = "ended", e.EMPTIED = "emptied", e.LOADEDDATA = "loadeddata";
  }(lb || (lb = {}));
  var ub = {
    uninit: 100,
    none: 110,
    init: 120,
    loadeddata: 130,
    canplay: 200,
    playing: 210,
    paused: 220,
    suspend: 300,
    stalled: 310,
    waiting: 320,
    error: 330,
    destroyed: 340,
    abort: 350,
    ended: 360,
    emptied: 370
  };
  var hb;
  !function (e) {
    e.OPEN = "open", e.MESSAGE = "message", e.CLOSE = "close", e.CLOSING = "closing", e.ERROR = "error";
  }(hb || (hb = {}));

  var pb = /*#__PURE__*/function (_ig12) {
    _inherits(pb, _ig12);

    var _super18 = _createSuper(pb);

    function pb(e, t) {
      var _this99;

      _classCallCheck(this, pb);

      _this99 = _super18.call(this), nh(_assertThisInitialized(_this99), "_ID", void 0), nh(_assertThisInitialized(_this99), "_rtpTransceiver", void 0), nh(_assertThisInitialized(_this99), "_lowRtpTransceiver", void 0), nh(_assertThisInitialized(_this99), "_hints", []), nh(_assertThisInitialized(_this99), "_isClosed", !1), nh(_assertThisInitialized(_this99), "_originMediaStreamTrack", void 0), nh(_assertThisInitialized(_this99), "_mediaStreamTrack", void 0), nh(_assertThisInitialized(_this99), "_external", {}), _this99._ID = t || xg(8, "track-"), _this99._originMediaStreamTrack = e, _this99._mediaStreamTrack = e, function (e) {
        bn(WA).call(WA, e) || WA.push(e);
      }(_assertThisInitialized(_this99));
      return _this99;
    }

    _createClass(pb, [{
      key: "toString",
      value: function toString() {
        return this._ID;
      }
    }, {
      key: "getTrackId",
      value: function getTrackId() {
        return this._ID;
      }
    }, {
      key: "getMediaStreamTrack",
      value: function getMediaStreamTrack(e) {
        if (!e) {
          var _e63 = rI.reportApiInvoke(null, {
            name: rg.GET_MEDIA_STREAM_TRACK,
            options: [],
            tag: og.TRACER
          });

          this._mediaStreamTrack && "string" == typeof this._mediaStreamTrack.label ? _e63.onSuccess(this._mediaStreamTrack.label) : _e63.onSuccess("");
        }

        return this._mediaStreamTrack;
      }
    }, {
      key: "getRTCRtpTransceiver",
      value: function getRTCRtpTransceiver(e) {
        return e === qA.LOW_STREAM ? this._lowRtpTransceiver : this._rtpTransceiver;
      }
    }, {
      key: "getMediaStreamTrackSettings",
      value: function getMediaStreamTrackSettings() {
        return this.getMediaStreamTrack(!0).getSettings();
      }
    }, {
      key: "close",
      value: function close() {
        this._isClosed = !0, this._lowRtpTransceiver = void 0, this._rtpTransceiver = void 0, function (e) {
          var t = WA.indexOf(e);
          -1 !== t && WA.splice(t, 1);
        }(this), this.emit(QA.CLOSED);
      }
    }, {
      key: "_updateRtpTransceiver",
      value: function _updateRtpTransceiver(e, t) {
        if (t === qA.LOW_STREAM) {
          if (this._lowRtpTransceiver === e) return;
          this._lowRtpTransceiver = e;
        } else {
          if (this._rtpTransceiver === e) return;
          this._rtpTransceiver = e;
        }

        this.emit(XA.TRANSCEIVER_UPDATED, e, t);
      }
    }]);

    return pb;
  }(ig);

  var _b = /*#__PURE__*/function (_pb) {
    _inherits(_b, _pb);

    var _super19 = _createSuper(_b);

    function _b(e, t) {
      var _this100;

      _classCallCheck(this, _b);

      _this100 = _super19.call(this, e, t), nh(_assertThisInitialized(_this100), "_enabled", !0), nh(_assertThisInitialized(_this100), "_muted", !1), nh(_assertThisInitialized(_this100), "_isExternalTrack", !1), nh(_assertThisInitialized(_this100), "_isClosed", !1), nh(_assertThisInitialized(_this100), "_enabledMutex", void 0), nh(_assertThisInitialized(_this100), "processor", void 0), nh(_assertThisInitialized(_this100), "_handleTrackEnded", function () {
        _this100.onTrackEnded();
      }), _this100._enabledMutex = new Yg("".concat(_this100.getTrackId())), e.addEventListener("ended", _this100._handleTrackEnded);
      return _this100;
    }

    _createClass(_b, [{
      key: "isExternalTrack",
      get: function get() {
        return this._isExternalTrack;
      }
    }, {
      key: "muted",
      get: function get() {
        return this._muted;
      }
    }, {
      key: "enabled",
      get: function get() {
        return this._enabled;
      }
    }, {
      key: "processorContext",
      get: function get() {
        return this._processorContext;
      },
      set: function set(e) {
        this._processorContext = e;
      }
    }, {
      key: "getTrackLabel",
      value: function getTrackLabel() {
        var e, t;
        return null !== (e = null === (t = this._originMediaStreamTrack) || void 0 === t ? void 0 : t.label) && void 0 !== e ? e : "";
      }
    }, {
      key: "close",
      value: function close() {
        this._isClosed || (this.stop(), this._originMediaStreamTrack.stop(), this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack.stop(), this._mediaStreamTrack = null), this._originMediaStreamTrack = null, this._enabledMutex = null, YC.debug("[".concat(this.getTrackId(), "] close")), this.emit(KA.NEED_CLOSE), _get(_getPrototypeOf(_b.prototype), "close", this).call(this));
      }
    }, {
      key: "_updateOriginMediaStreamTrack",
      value: function () {
        var _updateOriginMediaStreamTrack2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(e, t) {
          var i,
              _args82 = arguments;
          return _regeneratorRuntime.wrap(function _callee82$(_context82) {
            while (1) {
              switch (_context82.prev = _context82.next) {
                case 0:
                  i = _args82.length > 2 && void 0 !== _args82[2] && _args82[2];
                  this._isExternalTrack = i;
                  _context82.t0 = e !== this._originMediaStreamTrack;

                  if (!_context82.t0) {
                    _context82.next = 13;
                    break;
                  }

                  this._originMediaStreamTrack && (this._originMediaStreamTrack.removeEventListener("ended", this._handleTrackEnded), t && this._originMediaStreamTrack.stop());
                  e.addEventListener("ended", this._handleTrackEnded);
                  this._originMediaStreamTrack = e;
                  this._muted && (this._originMediaStreamTrack.enabled = !1);
                  this._mediaStreamTrack = this._originMediaStreamTrack;

                  this._updatePlayerSource();

                  _context82.next = 12;
                  return Tg(this, KA.NEED_REPLACE_TRACK, this);

                case 12:
                  this.processor && this.processor.updateInput({
                    track: this._originMediaStreamTrack,
                    context: this.processorContext
                  });

                case 13:
                case "end":
                  return _context82.stop();
              }
            }
          }, _callee82, this);
        }));

        function _updateOriginMediaStreamTrack(_x154, _x155) {
          return _updateOriginMediaStreamTrack2.apply(this, arguments);
        }

        return _updateOriginMediaStreamTrack;
      }()
    }, {
      key: "_getDefaultPlayerConfig",
      value: function _getDefaultPlayerConfig() {
        return {};
      }
    }, {
      key: "onTrackEnded",
      value: function onTrackEnded() {
        YC.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(QA.TRACK_ENDED);
      }
    }, {
      key: "stateCheck",
      value: function stateCheck(e, t) {
        if (YC.debug("check track state, [muted: ".concat(this._muted, ", enabled: ").concat(this._enabled, "] to [").concat(e, ": ").concat(t, "]")), FT(t, e), this._enabled && this._muted && "enabled" === e && !1 === t) throw new VT(xT.TRACK_STATE_UNREACHABLE, "cannot set enabled while the track is muted").print("error", YC);
        if (!this._enabled && !this._muted && "muted" === e && !0 === t) throw new VT(xT.TRACK_STATE_UNREACHABLE, "cannot set muted while the track is disabled").print("error", YC);
      }
    }, {
      key: "getProcessorStats",
      value: function getProcessorStats() {
        return this.processorContext.gatherStats();
      }
    }, {
      key: "getProcessorUsage",
      value: function getProcessorUsage() {
        return this.processorContext.gatherUsage();
      }
    }]);

    return _b;
  }(pb);

  function Eb(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  var mb = window.AudioContext || window.webkitAudioContext;
  var fb = null;
  var Tb = new ( /*#__PURE__*/function (_ig13) {
    _inherits(_class6, _ig13);

    var _super20 = _createSuper(_class6);

    function _class6() {
      var _this101;

      _classCallCheck(this, _class6);

      _this101 = _super20.apply(this, arguments), nh(_assertThisInitialized(_this101), "prevState", void 0), nh(_assertThisInitialized(_this101), "curState", void 0), nh(_assertThisInitialized(_this101), "currentTime", void 0), nh(_assertThisInitialized(_this101), "currentTimeStuckAt", void 0), nh(_assertThisInitialized(_this101), "interruptDetectorTrack", void 0), nh(_assertThisInitialized(_this101), "onLocalAudioTrackMute", function () {
        YC.info("ios15-interruption-start"), _this101.emit(OA.IOS_15_16_INTERRUPTION_START);
      }), nh(_assertThisInitialized(_this101), "onLocalAudioTrackUnmute", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83() {
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                YC.info("ios15-interruption-end");

                if (!("running" !== _this101.curState || _this101.duringInterruption)) {
                  _context83.next = 5;
                  break;
                }

                YC.info("ios15-interruption-end-canceled");
                _context83.next = 10;
                break;

              case 5:
                _context83.t0 = fb;

                if (!_context83.t0) {
                  _context83.next = 9;
                  break;
                }

                _context83.next = 9;
                return fb.suspend();

              case 9:
                _this101.emit(OA.IOS_15_16_INTERRUPTION_END);

              case 10:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83);
      })));
      return _this101;
    }

    _createClass(_class6, [{
      key: "duringInterruption",
      get: function get() {
        return "running" === this.prevState && "interrupted" === this.curState;
      }
    }, {
      key: "bindInterruptDetectorTrack",
      value: function bindInterruptDetectorTrack(e) {
        YC.debug("webaudio bindInterruptDetectorTrack ".concat(e.getTrackId())), this.interruptDetectorTrack || (this.interruptDetectorTrack = e, this.interruptDetectorTrack._mediaStreamTrack.onmute = this.onLocalAudioTrackMute, this.interruptDetectorTrack._mediaStreamTrack.onunmute = this.onLocalAudioTrackUnmute);
      }
    }, {
      key: "unbindInterruptDetectorTrack",
      value: function unbindInterruptDetectorTrack(e) {
        YC.debug("webaudio unbindInterruptDetectorTrack ".concat(e.getTrackId())), this.interruptDetectorTrack && this.interruptDetectorTrack === e && (this.interruptDetectorTrack._mediaStreamTrack && (this.interruptDetectorTrack._mediaStreamTrack.onmute = null, this.interruptDetectorTrack._mediaStreamTrack.onunmute = null), this.interruptDetectorTrack = void 0);
      }
    }]);

    return _class6;
  }(ig))();

  function gb() {
    if (!mb) return void YC.error("your browser is not support web audio");
    YC.info("create audio context");

    var e = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Eb(Object(i), !0).forEach(function (t) {
          nh(e, t, i[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Eb(Object(i)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
        });
      }

      return e;
    }({}, DC("WEBAUDIO_INIT_OPTIONS"));

    YC.debug("audio context init option:", JSON.stringify(e)), fb = new mb(e), Tb.curState = fb.state, fb.onstatechange = function () {
      Tb.prevState = Tb.curState, Tb.curState = fb ? fb.state : void 0;
      var e = Tb.prevState,
          t = Tb.curState,
          i = "running" === t,
          n = "interrupted" === t,
          s = "running" === e,
          r = "suspended" === e,
          o = "interrupted" === e,
          a = pT().osVersion;
      (CT() || DT()) && s && n && (YC.info("ios".concat(a, "-interruption-start")), Tb.emit(OA.IOS_INTERRUPTION_START)), (CT() || DT()) && (r || o) && i && (YC.info("ios".concat(a, "-interruption-end")), Tb.emit(OA.IOS_INTERRUPTION_END)), e !== t && Tb.emit(OA.STATE_CHANGE, t, e);
    }, setInterval(function () {
      var e;
      var t = null === (e = fb) || void 0 === e ? void 0 : e.currentTime;
      if (Tb.currentTime !== t) Tb.currentTimeStuckAt && (YC.debug("AudioContext current time resume at ".concat(t)), Tb.currentTimeStuckAt = void 0), Tb.currentTime = t;else {
        if (t !== Tb.currentTimeStuckAt) {
          rI.reportApiInvoke(null, {
            name: "WEB_AUDIO_CURRENT_TIME_STUCK",
            options: {
              currentTime: t
            },
            tag: og.TRACER
          }).onSuccess(), YC.warning("AudioContext current time stuck at ".concat(t));
        }

        Tb.currentTimeStuckAt = t;
      }
    }, 5e3), function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(e) {
        var t, i, n, s, r, o, a, c, d, l, u, h, p, _, _t72, _n36;

        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                _ = function _ref32() {
                  u(!0);
                };

                p = function _p2() {
                  i.removeEventListener("playing", p), i.removeEventListener("abort", p), i.removeEventListener("error", p), r = !1, u(!1);
                };

                h = function _h3(e) {
                  if (s !== e) {
                    s = e;

                    for (var _i44 = 0, _n35 = t; _i44 < _n35.length; _i44++) {
                      var _t71 = _n35[_i44];
                      e ? window.addEventListener(_t71, _, {
                        capture: !0,
                        passive: !0
                      }) : window.removeEventListener(_t71, _, {
                        capture: !0,
                        passive: !0
                      });
                    }
                  }
                };

                u = function _u2(e) {
                  if (!r) if (i.paused) {
                    if (e) {
                      var _e64;

                      h(!1), r = !0;

                      try {
                        _e64 = i.play(), _e64 ? _e64.then(p, p) : (i.addEventListener("playing", p), i.addEventListener("abort", p), i.addEventListener("error", p));
                      } catch (e) {
                        p();
                      }
                    } else h(!0);
                  } else h(!1);
                };

                l = function _l2() {
                  o(!0);
                };

                d = function _d3() {
                  o(!1);
                };

                c = function _c7() {
                  o(!0);
                };

                a = function _a4(e) {
                  if (n !== e) {
                    n = e;

                    for (var _i43 = 0, _n34 = t; _i43 < _n34.length; _i43 += 1) {
                      var _t70 = _n34[_i43];
                      e ? window.addEventListener(_t70, l, {
                        capture: !0,
                        passive: !0
                      }) : window.removeEventListener(_t70, l, {
                        capture: !0,
                        passive: !0
                      });
                    }
                  }
                };

                o = function _o9(t) {
                  "running" === e.state ? a(!1) : CT() || DT() ? "suspended" === e.state && (a(!0), t && e.resume().then(d, d)) : "closed" !== e.state && (a(!0), t && e.resume().then(d, d));
                };

                t = ["click", "contextmenu", "auxclick", "dblclick", "mousedown", "mouseup", "touchend", "keydown", "keyup"];
                n = !1, s = !1, r = !1;

                if (CT()) {
                  _t72 = e.createMediaStreamDestination(), _n36 = document.createElement("div");
                  _n36.innerHTML = "<audio x-webkit-airplay='deny'></audio>", i = _n36.children.item(0), i.controls = !1, i.disableRemotePlayback = !0, i.preload = "auto", i.srcObject = _t72.stream, u(!0);
                }

                Tb.on(OA.STATE_CHANGE, c), o(!1);

              case 13:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84);
      }));

      return function (_x156) {
        return _ref31.apply(this, arguments);
      };
    }()(fb);
  }

  function Sb() {
    if (!fb) {
      if (gb(), !fb) throw new VT(xT.NOT_SUPPORTED, "can not create audio context");
      return fb;
    }

    return fb;
  }

  function Rb() {
    return !!fb;
  }

  function Cb(e) {
    if (function () {
      if (null !== Ib) return Ib;
      var e = Sb(),
          t = e.createBufferSource(),
          i = e.createGain(),
          n = e.createGain();
      t.connect(i), t.connect(n), t.disconnect(i);
      var s = !1;

      try {
        t.disconnect(i);
      } catch (e) {
        s = !0;
      }

      return t.disconnect(), Ib = s, s;
    }()) return;
    var t = e.connect,
        i = e.disconnect;
    e.connect = function (i, n, s) {
      var r;
      return e._inputNodes || (e._inputNodes = []), bn(r = e._inputNodes).call(r, i) || (i instanceof AudioNode ? (e._inputNodes.push(i), t.call(e, i, n, s)) : t.call(e, i, n)), e;
    }, e.disconnect = function (n, s, r) {
      i.call(e), n ? vg(e._inputNodes, n) : e._inputNodes = [];

      var _iterator2 = _createForOfIteratorHelper(e._inputNodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _i45 = _step2.value;
          t.call(e, _i45);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }

  var Ib = null;

  function vb(e, t) {
    var i = !1;
    var n = 1 / t;

    if (DC("DISABLE_WEBAUDIO")) {
      var _t73 = window.setInterval(function () {
        i ? window.clearInterval(_t73) : e(performance.now() / 1e3);
      }, 1e3 * n);
    } else {
      var _t74 = Sb();

      var _s21 = _t74.createGain();

      _s21.gain.value = 0, _s21.connect(_t74.destination);

      var _r10 = function _r10() {
        if (i) return void (_s21 = null);

        var o = _t74.createOscillator();

        o.onended = _r10, o.connect(_s21), o.start(0), o.stop(_t74.currentTime + n), e(_t74.currentTime);
      };

      _r10();
    }

    return function () {
      i = !0;
    };
  }

  var yb = /*#__PURE__*/function () {
    function yb() {
      _classCallCheck(this, yb);

      nh(this, "context", void 0), nh(this, "analyserNode", void 0), nh(this, "sourceNode", void 0), this.context = Sb(), this.analyserNode = this.context.createAnalyser(), this.analyserNode.fftSize = 2048, this.analyserNode.smoothingTimeConstant = .4;
    }

    _createClass(yb, [{
      key: "updateSource",
      value: function updateSource(e) {
        if (e !== this.sourceNode) {
          if (this.sourceNode) try {
            this.sourceNode.disconnect(this.analyserNode);
          } catch (e) {}
          this.sourceNode = e, null == e || e.connect(this.analyserNode);
        }
      }
    }, {
      key: "getVolumeLevel",
      value: function getVolumeLevel() {
        if (!this.sourceNode) return 0;
        if (!this.context || CT() || DT() || "running" !== this.context.state && this.context.resume(), !this.analyserNode) return 0;
        var e = new Float32Array(this.analyserNode.fftSize);
        if (this.analyserNode.getFloatTimeDomainData) this.analyserNode.getFloatTimeDomainData(e);else {
          var _t75 = new Uint8Array(this.analyserNode.fftSize);

          this.analyserNode.getByteTimeDomainData(_t75);

          for (var _i46 = 0; _i46 < e.length; ++_i46) {
            e[_i46] = _t75[_i46] / 128 - 1;
          }
        }
        var t = cS(e).call(e, function (e, t) {
          return e + t * t;
        }, 0) / e.length;
        return Math.max(10 * Math.log10(t) + 100, 0) / 100;
      }
    }, {
      key: "getAnalyserNode",
      value: function getAnalyserNode() {
        return this.analyserNode;
      }
    }, {
      key: "rebuildAnalyser",
      value: function rebuildAnalyser() {
        try {
          var e, t;
          null === (e = this.sourceNode) || void 0 === e || e.disconnect(this.analyserNode), this.analyserNode = this.context.createAnalyser(), this.analyserNode.fftSize = 2048, this.analyserNode.smoothingTimeConstant = .4, null === (t = this.sourceNode) || void 0 === t || t.connect(this.analyserNode);
        } catch (e) {
          YC.warning("rebuild analyser node failed.");
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.updateSource(void 0);
      }
    }]);

    return yb;
  }();

  var Ab = /*#__PURE__*/function (_ig14) {
    _inherits(Ab, _ig14);

    var _super21 = _createSuper(Ab);

    function Ab() {
      var _this102;

      _classCallCheck(this, Ab);

      _this102 = _super21.call(this), nh(_assertThisInitialized(_this102), "outputNode", void 0), nh(_assertThisInitialized(_this102), "outputTrack", void 0), nh(_assertThisInitialized(_this102), "isPlayed", !1), nh(_assertThisInitialized(_this102), "context", void 0), nh(_assertThisInitialized(_this102), "audioBufferNode", void 0), nh(_assertThisInitialized(_this102), "destNode", void 0), nh(_assertThisInitialized(_this102), "audioOutputLevel", 0), nh(_assertThisInitialized(_this102), "volumeLevelAnalyser", void 0), nh(_assertThisInitialized(_this102), "_processedNode", void 0), nh(_assertThisInitialized(_this102), "playNode", void 0), nh(_assertThisInitialized(_this102), "isDestroyed", !1), nh(_assertThisInitialized(_this102), "onNoAudioInput", void 0), nh(_assertThisInitialized(_this102), "isNoAudioInput", !1), nh(_assertThisInitialized(_this102), "_noAudioInputCount", 0), _this102.context = Sb(), _this102.playNode = _this102.context.destination, _this102.outputNode = _this102.context.createGain(), Cb(_this102.outputNode), _this102.volumeLevelAnalyser = new yb();
      return _this102;
    }

    _createClass(Ab, [{
      key: "processSourceNode",
      get: function get() {
        return this.sourceNode;
      }
    }, {
      key: "processedNode",
      get: function get() {
        return this._processedNode;
      },
      set: function set(e) {
        var t;

        if (!this.isDestroyed && this._processedNode !== e) {
          try {
            var i;
            null === (i = this.sourceNode) || void 0 === i || i.disconnect(this.outputNode);
          } catch (e) {}

          null === (t = this._processedNode) || void 0 === t || t.disconnect(), this._processedNode = e, this.connect();
        }
      }
    }, {
      key: "startGetAudioBuffer",
      value: function startGetAudioBuffer(e) {
        var _this103 = this;

        this.audioBufferNode || (this.audioBufferNode = this.context.createScriptProcessor(e), this.outputNode.connect(this.audioBufferNode), this.audioBufferNode.connect(this.context.destination), this.audioBufferNode.onaudioprocess = function (e) {
          _this103.emit($A.ON_AUDIO_BUFFER, function (e) {
            for (var _t76 = 0; _t76 < e.outputBuffer.numberOfChannels; _t76 += 1) {
              var _i47 = e.outputBuffer.getChannelData(_t76);

              for (var _e65 = 0; _e65 < _i47.length; _e65 += 1) {
                _i47[_e65] = 0;
              }
            }

            return e.inputBuffer;
          }(e));
        });
      }
    }, {
      key: "stopGetAudioBuffer",
      value: function stopGetAudioBuffer() {
        this.audioBufferNode && (this.audioBufferNode.onaudioprocess = null, this.outputNode.disconnect(this.audioBufferNode), this.audioBufferNode = void 0);
      }
    }, {
      key: "createOutputTrack",
      value: function createOutputTrack() {
        if (!wA().webAudioMediaStreamDest) throw new VT(xT.NOT_SUPPORTED, "your browser is not support audio processor");
        return this.destNode && this.outputTrack || (this.destNode = this.context.createMediaStreamDestination(), this.outputNode.connect(this.destNode), this.outputTrack = this.destNode.stream.getAudioTracks()[0]), this.outputTrack;
      }
    }, {
      key: "play",
      value: function play(e) {
        "running" !== this.context.state && Ag(function () {
          Tb.emit("autoplay-failed");
        }), this.isPlayed = !0, this.playNode = e || this.context.destination, this.outputNode.connect(this.playNode);
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.isPlayed) try {
          this.outputNode.disconnect(this.playNode);
        } catch (e) {}
        this.isPlayed = !1;
      }
    }, {
      key: "getAccurateVolumeLevel",
      value: function getAccurateVolumeLevel() {
        return this.volumeLevelAnalyser.getVolumeLevel();
      }
    }, {
      key: "checkHasAudioInput",
      value: function () {
        var _checkHasAudioInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85() {
          var e,
              t,
              i,
              n,
              _e66,
              _args85 = arguments;

          return _regeneratorRuntime.wrap(function _callee85$(_context85) {
            while (1) {
              switch (_context85.prev = _context85.next) {
                case 0:
                  e = _args85.length > 0 && void 0 !== _args85[0] ? _args85[0] : 0;

                  if (!(e > 5)) {
                    _context85.next = 3;
                    break;
                  }

                  return _context85.abrupt("return", (this.isNoAudioInput = !0, this.onNoAudioInput && this.onNoAudioInput(), !1));

                case 3:
                  CT() || DT() ? "suspended" === this.context.state && this.context.resume() : "running" !== this.context.state && this.context.resume();
                  t = this.volumeLevelAnalyser.getAnalyserNode();
                  t.getFloatTimeDomainData ? (i = new Float32Array(t.fftSize), t.getFloatTimeDomainData(i)) : (i = new Uint8Array(t.fftSize), t.getByteTimeDomainData(i));
                  n = !1;

                  for (_e66 = 0; _e66 < i.length; _e66++) {
                    0 !== i[_e66] && (n = !0);
                  }

                  if (!n) {
                    _context85.next = 12;
                    break;
                  }

                  _context85.t0 = (this.isNoAudioInput = !1, !0);
                  _context85.next = 20;
                  break;

                case 12:
                  _context85.next = 14;
                  return Ug(200);

                case 14:
                  _context85.next = 16;
                  return this.checkHasAudioInput(e ? e + 1 : 1);

                case 16:
                  _context85.t1 = _context85.sent;

                  if (!_context85.t1) {
                    _context85.next = 19;
                    break;
                  }

                  _context85.t1 = n;

                case 19:
                  _context85.t0 = _context85.t1;

                case 20:
                  return _context85.abrupt("return", _context85.t0);

                case 21:
                case "end":
                  return _context85.stop();
              }
            }
          }, _callee85, this);
        }));

        function checkHasAudioInput() {
          return _checkHasAudioInput.apply(this, arguments);
        }

        return checkHasAudioInput;
      }()
    }, {
      key: "getAudioVolume",
      value: function getAudioVolume() {
        return this.outputNode.gain.value;
      }
    }, {
      key: "setVolume",
      value: function setVolume(e) {
        this.outputNode.gain.setValueAtTime(e, this.context.currentTime);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.disconnect(), this.stop(), this.isDestroyed = !0, this.onNoAudioInput = void 0;
      }
    }, {
      key: "disconnect",
      value: function disconnect() {
        var e, t;
        null === (e = this.processedNode) || void 0 === e || e.disconnect(), null === (t = this.sourceNode) || void 0 === t || t.disconnect(), this.outputNode && this.outputNode.disconnect();
      }
    }, {
      key: "connect",
      value: function connect() {
        var e;
        this.processedNode ? null === (e = this.processedNode) || void 0 === e || e.connect(this.outputNode) : this.sourceNode && this.sourceNode.connect(this.outputNode);
        this.volumeLevelAnalyser.updateSource(this.outputNode);
      }
    }]);

    return Ab;
  }(ig);

  var bb = /*#__PURE__*/function (_Ab) {
    _inherits(bb, _Ab);

    var _super22 = _createSuper(bb);

    function bb(e, t, i) {
      var _this104;

      _classCallCheck(this, bb);

      var n;
      if (_this104 = _super22.call(this), nh(_assertThisInitialized(_this104), "sourceNode", void 0), nh(_assertThisInitialized(_this104), "track", void 0), nh(_assertThisInitialized(_this104), "clonedTrack", void 0), nh(_assertThisInitialized(_this104), "audioElement", void 0), nh(_assertThisInitialized(_this104), "isCurrentTrackCloned", !1), nh(_assertThisInitialized(_this104), "isRemoteTrack", !1), nh(_assertThisInitialized(_this104), "originVolumeLevelAnalyser", void 0), nh(_assertThisInitialized(_this104), "rebuildWebAudio", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86() {
        var e, t, i;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                YC.debug("ready to rebuild web audio, state:", _this104.context.state);
                _context86.t0 = _this104.isNoAudioInput;

                if (!_context86.t0) {
                  _context86.next = 5;
                  break;
                }

                _context86.next = 5;
                return _this104.checkHasAudioInput();

              case 5:
                if (!(!_this104.isNoAudioInput || _this104.isDestroyed)) {
                  _context86.next = 7;
                  break;
                }

                return _context86.abrupt("return", (document.body.removeEventListener("click", _this104.rebuildWebAudio, !0), void YC.debug("rebuild web audio success, current volume status", _this104.getAccurateVolumeLevel())));

              case 7:
                _this104.context.resume().then(function () {
                  return YC.info("resume success");
                }), YC.debug("rebuild web audio because of ios 12 bugs"), _this104.disconnect();
                e = _this104.track;
                _this104.track = _this104.track.clone(), _this104.isCurrentTrackCloned ? e.stop() : _this104.isCurrentTrackCloned = !0;
                t = new MediaStream([_this104.track]);
                _this104.sourceNode = _this104.context.createMediaStreamSource(t), Cb(_this104.sourceNode), _this104.volumeLevelAnalyser.rebuildAnalyser();
                i = _this104.outputNode.gain.value;
                _this104.outputNode = _this104.context.createGain(), _this104.outputNode.gain.setValueAtTime(i, _this104.context.currentTime), Cb(_this104.outputNode), _this104.emit($A.UPDATE_SOURCE), _this104.connect(), _this104.audioElement.srcObject = t, _this104.isPlayed && _this104.play(_this104.playNode), _this104.checkHasAudioInput();

              case 14:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86);
      }))), "audio" !== e.kind) throw new VT(xT.UNEXPECTED_ERROR);
      _this104.track = e;
      var s = new MediaStream([_this104.track]);

      if (_this104.isRemoteTrack = !!t, _this104.sourceNode = _this104.context.createMediaStreamSource(s), Cb(_this104.sourceNode), i) {
        var _e67 = i.clone();

        _e67.enabled = !0, _this104.clonedTrack = _e67, YC.debug("create an unmuted track ".concat(_e67.id, " from the original track ").concat(i.id, " to get the volume"));

        var _t77 = _this104.context.createMediaStreamSource(new MediaStream([_e67]));

        Cb(_t77), _this104.originVolumeLevelAnalyser = new yb(), _this104.originVolumeLevelAnalyser.updateSource(_t77);
      }

      _this104.connect(), _this104.audioElement = document.createElement("audio"), _this104.audioElement.srcObject = s;
      var r = pT();
      t && r.os === aT.IOS && Number(null === (n = r.osVersion) || void 0 === n ? void 0 : n.split(".")[0]) < 15 && (Tb.on(OA.STATE_CHANGE, function () {
        "suspended" === _this104.context.state ? document.body.addEventListener("click", _this104.rebuildWebAudio, !0) : "running" === _this104.context.state && _this104.rebuildWebAudio();
      }), _this104.checkHasAudioInput().then(function (e) {
        e || document.body.addEventListener("click", _this104.rebuildWebAudio, !0);
      }));
      return _possibleConstructorReturn(_this104);
    }

    _createClass(bb, [{
      key: "isFreeze",
      get: function get() {
        return !1;
      }
    }, {
      key: "updateTrack",
      value: function updateTrack(e) {
        this.sourceNode.disconnect(), this.track = e, this.isCurrentTrackCloned = !1;
        var t = new MediaStream([e]);
        this.sourceNode = this.context.createMediaStreamSource(t), Cb(this.sourceNode), this.processedNode || this.sourceNode.connect(this.outputNode), this.emit($A.UPDATE_SOURCE), this.audioElement.srcObject = t;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        var e;
        this.audioElement.srcObject = null, this.audioElement.remove(), Tb.off("state-change", this.rebuildWebAudio), null === (e = this.originVolumeLevelAnalyser) || void 0 === e || e.destroy(), this.clonedTrack = void 0, _get(_getPrototypeOf(bb.prototype), "destroy", this).call(this);
      }
    }, {
      key: "createMediaStreamSourceNode",
      value: function createMediaStreamSourceNode(e) {
        return this.context.createMediaStreamSource(new MediaStream([e]));
      }
    }, {
      key: "updateOriginTrack",
      value: function updateOriginTrack(e) {
        var t = e.clone();
        t.enabled = !0, this.clonedTrack && (this.clonedTrack.stop(), this.clonedTrack = t), YC.debug("create an unmuted track ".concat(t.id, " from the original track ").concat(e.id, " to get the volume"));
        var i = this.context.createMediaStreamSource(new MediaStream([t]));
        Cb(i), this.originVolumeLevelAnalyser && this.originVolumeLevelAnalyser.updateSource(i);
      }
    }, {
      key: "getOriginVolumeLevel",
      value: function getOriginVolumeLevel() {
        return this.originVolumeLevelAnalyser ? this.originVolumeLevelAnalyser.getVolumeLevel() : this.getAccurateVolumeLevel();
      }
    }]);

    return bb;
  }(Ab);

  function wb(_x157, _x158, _x159) {
    return _wb.apply(this, arguments);
  }

  function _wb() {
    _wb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee487(e, t, i) {
      var n, s;
      return _regeneratorRuntime.wrap(function _callee487$(_context487) {
        while (1) {
          switch (_context487.prev = _context487.next) {
            case 0:
              n = function n(e, t) {
                return e ? "number" != typeof e ? e.max || e.exact || e.ideal || e.min || t : e : t;
              }, s = {
                audio: !!i && {
                  mandatory: {
                    chromeMediaSource: "desktop"
                  }
                },
                video: {
                  mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: e,
                    maxHeight: n(t.height, 1080),
                    maxWidth: n(t.width, 1920)
                  }
                }
              };
              t.frameRate && "number" != typeof t.frameRate ? (s.video.mandatory.maxFrameRate = t.frameRate.max, s.video.mandatory.minFrameRate = t.frameRate.min) : "number" == typeof t.frameRate && (s.video.mandatory.maxFrameRate = t.frameRate);
              _context487.next = 4;
              return navigator.mediaDevices.getUserMedia(s);

            case 4:
              return _context487.abrupt("return", _context487.sent);

            case 5:
            case "end":
              return _context487.stop();
          }
        }
      }, _callee487);
    }));
    return _wb.apply(this, arguments);
  }

  function Ob(_x160, _x161) {
    return _Ob.apply(this, arguments);
  }

  function _Ob() {
    _Ob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee488(e, t) {
      var i, _yield, n, s;

      return _regeneratorRuntime.wrap(function _callee488$(_context488) {
        while (1) {
          switch (_context488.prev = _context488.next) {
            case 0:
              _context488.next = 2;
              return Nb(e.mediaSource);

            case 2:
              i = _context488.sent;
              _context488.next = 5;
              return function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return new tT(function (i, n) {
                  var s = document.createElement("div");
                  s.innerText = "share screen", s.setAttribute("style", "text-align: center; height: 25px; line-height: 25px; border-radius: 4px 4px 0 0; background: #D4D2D4; border-bottom:  solid 1px #B9B8B9;");
                  var r = document.createElement("div");
                  r.setAttribute("style", "width: 100%; height: 500px; padding: 15px 25px ; box-sizing: border-box;");
                  var o = document.createElement("div");
                  o.innerText = "Agora Web Screensharing wants to share the contents of your screen with webdemo.agorabeckon.com. Choose what you'd like to share.", o.setAttribute("style", "height: 12%;");
                  var a = document.createElement("div");
                  a.setAttribute("style", "width: 100%; height: 80%; background: #FFF; border:  solid 1px #CBCBCB; display: flex; flex-wrap: wrap; justify-content: space-around; overflow-y: scroll; padding: 0 15px; box-sizing: border-box;");
                  var c = document.createElement("div");
                  c.setAttribute("style", "display: flex; justify-content: space-between; padding: 16px 0;");
                  var d = document.createElement("button");
                  d.innerHTML = "cancel", d.setAttribute("style", "width: 85px;"), d.onclick = function () {
                    document.body.removeChild(h);
                    var e = new Error("NotAllowedError");
                    e.name = "NotAllowedError", n(e);
                  };
                  var l = t;
                  var u = document.createElement("div");

                  if (t) {
                    var _e416 = document.createElement("input");

                    _e416.setAttribute("type", "checkbox");

                    var _t347 = document.createElement("span");

                    _e416.setAttribute("style", "margin-right: 6px;"), _t347.innerText = "Share audio", _e416.checked = l, _e416.onchange = function () {
                      l = _e416.checked;
                    }, u.appendChild(_e416), u.appendChild(_t347);
                  }

                  c.appendChild(u), c.appendChild(d), r.appendChild(o), r.appendChild(a), r.appendChild(c);
                  var h = document.createElement("div");
                  h.setAttribute("style", "position: fixed; z-index: 99999999; top: 50%; left: 50%; width: 620px; height: 525px; background: #ECECEC; border-radius: 4px; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%);"), h.appendChild(s), h.appendChild(r), document.body.appendChild(h), e.map(function (e) {
                    if (e.id) {
                      var _t348 = document.createElement("div");

                      _t348.setAttribute("style", "width: 30%; height: 160px; padding: 20px 0; text-align: center;box-sizing: content-box;");

                      var _n161 = e.thumbnail;

                      try {
                        var _n161$getSize = _n161.getSize(),
                            _e417 = _n161$getSize.width;

                        _e417 > 1920 && (_n161 = _n161.resize({
                          width: 1920
                        }));
                      } catch (e) {
                        throw e && e.message.startsWith("Illegal invocation") && console.error("Operate thumbnail error, please try to set contextIsolation: false. (https://github.com/electron/electron/issues/34953)"), e;
                      }

                      _t348.innerHTML = '<div style="height: 120px; display: table-cell; vertical-align: middle;"><img style="width: 100%; background: #333333; box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);" src=' + _n161.toDataURL() + ' /></div><span style="\theight: 40px; line-height: 40px; display: inline-block; width: 70%; word-break: keep-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' + e.name.replace(/[\u00A0-\u9999<>\&]/g, function (e) {
                        return "&#" + e.charCodeAt(0) + ";";
                      }) + "</span>", _t348.onclick = function () {
                        document.body.removeChild(h), i({
                          sourceId: e.id,
                          audio: l
                        });
                      }, a.appendChild(_t348);
                    }
                  });
                });
              }(i, t);

            case 5:
              _yield = _context488.sent;
              n = _yield.sourceId;
              s = _yield.audio;
              _context488.next = 10;
              return wb(n, e, s);

            case 10:
              return _context488.abrupt("return", _context488.sent);

            case 11:
            case "end":
              return _context488.stop();
          }
        }
      }, _callee488);
    }));
    return _Ob.apply(this, arguments);
  }

  function Nb(_x162) {
    return _Nb.apply(this, arguments);
  }

  function _Nb() {
    _Nb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee489(e) {
      var t, i, n, s;
      return _regeneratorRuntime.wrap(function _callee489$(_context489) {
        while (1) {
          switch (_context489.prev = _context489.next) {
            case 0:
              t = ["window", "screen"];
              "application" !== e && "window" !== e || (t = ["window"]), "screen" === e && (t = ["screen"]);
              i = sg();

              if (i) {
                _context489.next = 5;
                break;
              }

              throw console.error("failed to fetch electron, please mount it to window"), new VT(xT.ELECTRON_IS_NULL);

            case 5:
              n = null;

              try {
                n = (null === (s = i.desktopCapturer) || void 0 === s ? void 0 : s.getSources({
                  types: t
                })) || i.ipcRenderer.invoke("DESKTOP_CAPTURER_GET_SOURCES", {
                  types: t
                });
              } catch (e) {
                n = null;
              }

              n && n.then || (n = new tT(function (e, n) {
                i.desktopCapturer.getSources({
                  types: t
                }, function (t, i) {
                  t ? n(t) : e(i);
                });
              }));
              _context489.prev = 8;
              _context489.next = 11;
              return n;

            case 11:
              return _context489.abrupt("return", _context489.sent);

            case 14:
              _context489.prev = 14;
              _context489.t0 = _context489["catch"](8);
              throw new VT(xT.ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR, _context489.t0.toString());

            case 17:
            case "end":
              return _context489.stop();
          }
        }
      }, _callee489, null, [[8, 14]]);
    }));
    return _Nb.apply(this, arguments);
  }

  function Db(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  var Pb = new Yg("safari");
  var Lb = !1,
      kb = !1;

  function Mb(_x163, _x164) {
    return _Mb.apply(this, arguments);
  }

  function _Mb() {
    _Mb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee490(e, t) {
      var i, n, _n162;

      return _regeneratorRuntime.wrap(function _callee490$(_context490) {
        while (1) {
          switch (_context490.prev = _context490.next) {
            case 0:
              i = 0, n = null;

            case 1:
              if (!(i < 2)) {
                _context490.next = 23;
                break;
              }

              _context490.prev = 2;
              _context490.next = 5;
              return Ub(e, t, i > 0);

            case 5:
              n = _context490.sent;
              return _context490.abrupt("break", 23);

            case 9:
              _context490.prev = 9;
              _context490.t0 = _context490["catch"](2);

              if (!(_context490.t0 instanceof VT)) {
                _context490.next = 13;
                break;
              }

              throw YC.error("[".concat(t, "] ").concat(_context490.t0.toString())), _context490.t0;

            case 13:
              _n162 = xb(_context490.t0.name || _context490.t0.code || _context490.t0, _context490.t0.message);

              if (!(_n162.code === xT.MEDIA_OPTION_INVALID)) {
                _context490.next = 20;
                break;
              }

              YC.debug("[".concat(t, "] detect media option invalid, retry"));
              i += 1;
              _context490.next = 19;
              return Ug(500);

            case 19:
              return _context490.abrupt("continue", 21);

            case 20:
              throw YC.error("[".concat(t, "] ").concat(_n162.toString())), _n162;

            case 21:
              _context490.next = 1;
              break;

            case 23:
              if (n) {
                _context490.next = 25;
                break;
              }

              throw new VT(xT.UNEXPECTED_ERROR, "can not find stream after getUserMedia");

            case 25:
              return _context490.abrupt("return", n);

            case 26:
            case "end":
              return _context490.stop();
          }
        }
      }, _callee490, null, [[2, 9]]);
    }));
    return _Mb.apply(this, arguments);
  }

  function Ub(_x165, _x166, _x167) {
    return _Ub.apply(this, arguments);
  }

  function _Ub() {
    _Ub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee491(e, t, i) {
      var n, s, _i187, r, _i188, _e$screen, _n163, _o57, _a36, _c11, _d23, _i189, o, a, c, d, l, u;

      return _regeneratorRuntime.wrap(function _callee491$(_context491) {
        while (1) {
          switch (_context491.prev = _context491.next) {
            case 0:
              if (!(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
                _context491.next = 2;
                break;
              }

              throw new VT(xT.NOT_SUPPORTED, "can not find getUserMedia");

            case 2:
              i && (e.video && (delete e.video.width, delete e.video.height), e.screen && (delete e.screen.width, delete e.screen.height));
              n = wA(), s = new MediaStream();

              if (!(e.audioSource && s.addTrack(e.audioSource), e.videoSource && s.addTrack(e.videoSource), !e.audio && !e.video && !e.screen)) {
                _context491.next = 6;
                break;
              }

              return _context491.abrupt("return", (YC.debug("Using Video Source/ Audio Source"), s));

            case 6:
              if (!e.screen) {
                _context491.next = 62;
                break;
              }

              if (!sg()) {
                _context491.next = 25;
                break;
              }

              if (!e.screen.sourceId) {
                _context491.next = 17;
                break;
              }

              _context491.t0 = Vb;
              _context491.t1 = s;
              _context491.next = 13;
              return wb(e.screen.sourceId, e.screen, e.screenAudio);

            case 13:
              _context491.t2 = _context491.sent;
              (0, _context491.t0)(_context491.t1, _context491.t2);
              _context491.next = 23;
              break;

            case 17:
              _context491.t3 = Vb;
              _context491.t4 = s;
              _context491.next = 21;
              return Ob(e.screen, e.screenAudio);

            case 21:
              _context491.t5 = _context491.sent;
              (0, _context491.t3)(_context491.t4, _context491.t5);

            case 23:
              _context491.next = 62;
              break;

            case 25:
              if (!(gT() && e.screen.extensionId && e.screen.mandatory)) {
                _context491.next = 41;
                break;
              }

              if (n.getStreamFromExtension) {
                _context491.next = 28;
                break;
              }

              throw new VT(xT.NOT_SUPPORTED, "This browser does not support screen sharing");

            case 28:
              YC.debug("[".concat(t, '] Screen access on chrome stable, looking for extension"'));
              _context491.next = 31;
              return o = e.screen.extensionId, a = t, new tT(function (e, t) {
                try {
                  chrome.runtime.sendMessage(o, {
                    getStream: !0
                  }, function (i) {
                    if (!i || !i.streamId) return YC.error("[".concat(a, "] No response from Chrome Plugin. Plugin not installed properly"), i), void t(new VT(xT.CHROME_PLUGIN_NO_RESPONSE, "No response from Chrome Plugin. Plugin not installed properly"));
                    e(i.streamId);
                  });
                } catch (e) {
                  YC.error("[".concat(a, "] AgoraRTC screensharing plugin is not accessible(").concat(o, ")"), e.toString()), t(new VT(xT.CHROME_PLUGIN_NOT_INSTALL));
                }
              });

            case 31:
              _i187 = _context491.sent;
              e.screen.mandatory.chromeMediaSourceId = _i187;
              _context491.t6 = Vb;
              _context491.t7 = s;
              _context491.next = 37;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  mandatory: e.screen.mandatory
                }
              });

            case 37:
              _context491.t8 = _context491.sent;
              (0, _context491.t6)(_context491.t7, _context491.t8);
              _context491.next = 62;
              break;

            case 41:
              if (!n.getDisplayMedia) {
                _context491.next = 51;
                break;
              }

              e.screen.mediaSource && HA(e.screen.mediaSource);
              _i188 = {
                width: e.screen.width,
                height: e.screen.height,
                frameRate: e.screen.frameRate,
                displaySurface: null !== (r = e.screen.displaySurface) && void 0 !== r ? r : "screen" === e.screen.mediaSource ? "monitor" : e.screen.mediaSource
              }, _e$screen = e.screen, _n163 = _e$screen.selfBrowserSurface, _o57 = _e$screen.surfaceSwitching, _a36 = _e$screen.systemAudio, _c11 = {
                selfBrowserSurface: _n163,
                surfaceSwitching: _o57,
                systemAudio: _a36
              };
              !_n163 && delete _c11.selfBrowserSurface, !_o57 && delete _c11.surfaceSwitching, !_a36 && delete _c11.systemAudio, YC.debug("[".concat(t, "] getDisplayMedia:"), JSON.stringify({
                video: _i188,
                audio: !!e.screenAudio,
                controls: _c11
              }));
              _context491.next = 47;
              return navigator.mediaDevices.getDisplayMedia(function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var i = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? Db(Object(i), !0).forEach(function (t) {
                    nh(e, t, i[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Db(Object(i)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                  });
                }

                return e;
              }({
                video: _i188,
                audio: !!e.screenAudio
              }, _c11));

            case 47:
              _d23 = _context491.sent;
              Vb(s, _d23);
              _context491.next = 62;
              break;

            case 51:
              if (RT()) {
                _context491.next = 53;
                break;
              }

              throw YC.error("[".concat(t, "] This browser does not support screenSharing")), new VT(xT.NOT_SUPPORTED, "This browser does not support screen sharing");

            case 53:
              e.screen.mediaSource && HA(e.screen.mediaSource);
              _i189 = {
                video: {
                  mediaSource: e.screen.mediaSource,
                  width: e.screen.width,
                  height: e.screen.height,
                  frameRate: e.screen.frameRate
                }
              };
              YC.debug("[".concat(t, "] getUserMedia: ").concat(JSON.stringify(_i189)));
              _context491.t9 = Vb;
              _context491.t10 = s;
              _context491.next = 60;
              return navigator.mediaDevices.getUserMedia(_i189);

            case 60:
              _context491.t11 = _context491.sent;
              (0, _context491.t9)(_context491.t10, _context491.t11);

            case 62:
              if (!(!e.video && !e.audio)) {
                _context491.next = 64;
                break;
              }

              return _context491.abrupt("return", s);

            case 64:
              c = {
                video: e.video,
                audio: e.audio
              }, d = DC("MEDIA_DEVICE_CONSTRAINTS");
              if (d) try {
                "string" == typeof d && (d = JSON.parse(d)), c = Wg(c, d);
              } catch (e) {}
              YC.debug("[".concat(t, "] GetUserMedia"), JSON.stringify(c)), pT();
              u = null;
              _context491.t12 = ST() || CT() || mT();

              if (!_context491.t12) {
                _context491.next = 73;
                break;
              }

              _context491.next = 72;
              return Pb.lock();

            case 72:
              u = _context491.sent;

            case 73:
              _context491.prev = 73;
              _context491.next = 76;
              return navigator.mediaDevices.getUserMedia(c);

            case 76:
              l = _context491.sent;
              _context491.next = 82;
              break;

            case 79:
              _context491.prev = 79;
              _context491.t13 = _context491["catch"](73);
              throw u && u(), _context491.t13;

            case 82:
              return _context491.abrupt("return", (c.audio && (Lb = !0), c.video && (kb = !0), Vb(s, l), u && u(), s));

            case 83:
            case "end":
              return _context491.stop();
          }
        }
      }, _callee491, null, [[73, 79]]);
    }));
    return _Ub.apply(this, arguments);
  }

  function xb(e, t) {
    switch (e) {
      case "Starting video failed":
      case "OverconstrainedError":
      case "TrackStartError":
        return new VT(xT.MEDIA_OPTION_INVALID, "".concat(e, ": ").concat(t));

      case "NotFoundError":
      case "DevicesNotFoundError":
        return new VT(xT.DEVICE_NOT_FOUND, "".concat(e, ": ").concat(t));

      case "NotSupportedError":
        return new VT(xT.NOT_SUPPORTED, "".concat(e, ": ").concat(t));

      case "NotReadableError":
        return new VT(xT.NOT_READABLE, "".concat(e, ": ").concat(t));

      case "InvalidStateError":
      case "NotAllowedError":
      case "PERMISSION_DENIED":
      case "PermissionDeniedError":
        return new VT(xT.PERMISSION_DENIED, "".concat(e, ": ").concat(t));

      case "ConstraintNotSatisfiedError":
        return new VT(xT.CONSTRAINT_NOT_SATISFIED, "".concat(e, ": ").concat(t));

      default:
        return YC.error("getUserMedia unexpected error", e), new VT(xT.UNEXPECTED_ERROR, "".concat(e, ": ").concat(t));
    }
  }

  function Vb(e, t) {
    var i = e.getVideoTracks()[0],
        n = e.getAudioTracks()[0],
        s = t.getVideoTracks()[0],
        r = t.getAudioTracks()[0];
    r && (n && e.removeTrack(n), e.addTrack(r)), s && (i && e.removeTrack(i), e.addTrack(s));
  }

  var Fb = new ( /*#__PURE__*/function (_ig15) {
    _inherits(_class7, _ig15);

    var _super23 = _createSuper(_class7);

    function _class7() {
      var _this105;

      _classCallCheck(this, _class7);

      _this105 = _super23.call(this), nh(_assertThisInitialized(_this105), "_state", cb.IDLE), nh(_assertThisInitialized(_this105), "isAccessMicrophonePermission", !1), nh(_assertThisInitialized(_this105), "isAccessCameraPermission", !1), nh(_assertThisInitialized(_this105), "lastAccessMicrophonePermission", !1), nh(_assertThisInitialized(_this105), "lastAccessCameraPermission", !1), nh(_assertThisInitialized(_this105), "checkdeviceMatched", !1), nh(_assertThisInitialized(_this105), "deviceInfoMap", new Map()), _this105.init().then(function () {
        navigator.mediaDevices.addEventListener && navigator.mediaDevices.addEventListener("devicechange", _this105.updateDevicesInfo.bind(_assertThisInitialized(_this105))), window.setInterval(function () {
          (DC("ENUMERATE_DEVICES_INTERVAL") || (MT() || _T() === aT.HARMONY_OS) && kT()) && _this105.updateDevicesInfo();
        }, DC("ENUMERATE_DEVICES_INTERVAL_TIME"));
      }).catch(function (e) {
        return YC.error(e.toString());
      });
      return _this105;
    }

    _createClass(_class7, [{
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        e !== this._state && (this.emit(db.STATE_CHANGE, e), this._state = e);
      }
    }, {
      key: "enumerateDevices",
      value: function () {
        var _enumerateDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(e, t) {
          var i,
              n,
              s,
              r,
              o,
              a,
              c,
              d,
              _t78,
              _t79,
              _t80,
              _e68,
              _args87 = arguments;

          return _regeneratorRuntime.wrap(function _callee87$(_context87) {
            while (1) {
              switch (_context87.prev = _context87.next) {
                case 0:
                  i = _args87.length > 2 && void 0 !== _args87[2] && _args87[2];

                  if (!(!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices)) {
                    _context87.next = 3;
                    break;
                  }

                  return _context87.abrupt("return", new VT(xT.NOT_SUPPORTED, "enumerateDevices() not supported.").throw());

                case 3:
                  _context87.next = 5;
                  return navigator.mediaDevices.enumerateDevices();

                case 5:
                  n = _context87.sent;
                  s = this.checkMediaDeviceInfoIsOk(n);
                  r = !this.isAccessMicrophonePermission && e, o = !this.isAccessCameraPermission && t;
                  s.audio && (r = !1), s.video && (o = !1);
                  a = null, c = null, d = null;

                  if (!(!i && (r || o))) {
                    _context87.next = 65;
                    break;
                  }

                  if (!Pb.isLocked) {
                    _context87.next = 18;
                    break;
                  }

                  YC.debug("[device manager] wait GUM lock");
                  _context87.next = 15;
                  return Pb.lock();

                case 15:
                  _context87.t0 = _context87.sent;
                  (0, _context87.t0)();
                  YC.debug("[device manager] GUM unlock");

                case 18:
                  if (!(Lb && (r = !1, this.isAccessMicrophonePermission = !0), kb && (o = !1, this.isAccessCameraPermission = !0), YC.debug("[device manager] check media device permissions", e, t, r, o), r && o)) {
                    _context87.next = 34;
                    break;
                  }

                  _context87.prev = 19;
                  _context87.next = 22;
                  return navigator.mediaDevices.getUserMedia({
                    audio: !0,
                    video: !0
                  });

                case 22:
                  d = _context87.sent;
                  _context87.next = 31;
                  break;

                case 25:
                  _context87.prev = 25;
                  _context87.t1 = _context87["catch"](19);
                  _t78 = xb(_context87.t1.name || _context87.t1.code || _context87.t1, _context87.t1.message);

                  if (!(_t78.code === xT.PERMISSION_DENIED)) {
                    _context87.next = 30;
                    break;
                  }

                  throw _t78;

                case 30:
                  YC.warning("getUserMedia failed in getDevices", _t78);

                case 31:
                  this.isAccessCameraPermission = !0, this.isAccessMicrophonePermission = !0;
                  _context87.next = 64;
                  break;

                case 34:
                  if (!r) {
                    _context87.next = 50;
                    break;
                  }

                  _context87.prev = 35;
                  _context87.next = 38;
                  return navigator.mediaDevices.getUserMedia({
                    audio: e
                  });

                case 38:
                  a = _context87.sent;
                  _context87.next = 47;
                  break;

                case 41:
                  _context87.prev = 41;
                  _context87.t2 = _context87["catch"](35);
                  _t79 = xb(_context87.t2.name || _context87.t2.code || _context87.t2, _context87.t2.message);

                  if (!(_t79.code === xT.PERMISSION_DENIED)) {
                    _context87.next = 46;
                    break;
                  }

                  throw _t79;

                case 46:
                  YC.warning("getUserMedia failed in getDevices", _t79);

                case 47:
                  this.isAccessMicrophonePermission = !0;
                  _context87.next = 64;
                  break;

                case 50:
                  if (!o) {
                    _context87.next = 64;
                    break;
                  }

                  _context87.prev = 51;
                  _context87.next = 54;
                  return navigator.mediaDevices.getUserMedia({
                    video: t
                  });

                case 54:
                  c = _context87.sent;
                  _context87.next = 63;
                  break;

                case 57:
                  _context87.prev = 57;
                  _context87.t3 = _context87["catch"](51);
                  _t80 = xb(_context87.t3.name || _context87.t3.code || _context87.t3, _context87.t3.message);

                  if (!(_t80.code === xT.PERMISSION_DENIED)) {
                    _context87.next = 62;
                    break;
                  }

                  throw _t80;

                case 62:
                  YC.warning("getUserMedia failed in getDevices", _t80);

                case 63:
                  this.isAccessCameraPermission = !0;

                case 64:
                  YC.debug("[device manager] mic permission", e, "cam permission", t);

                case 65:
                  _context87.prev = 65;
                  _context87.next = 68;
                  return navigator.mediaDevices.enumerateDevices();

                case 68:
                  _e68 = _context87.sent;
                  return _context87.abrupt("return", (a && a.getTracks().forEach(function (e) {
                    return e.stop();
                  }), c && c.getTracks().forEach(function (e) {
                    return e.stop();
                  }), d && d.getTracks().forEach(function (e) {
                    return e.stop();
                  }), a = null, c = null, d = null, _e68));

                case 72:
                  _context87.prev = 72;
                  _context87.t4 = _context87["catch"](65);
                  a && a.getTracks().forEach(function (e) {
                    return e.stop();
                  }), c && c.getTracks().forEach(function (e) {
                    return e.stop();
                  }), d && d.getTracks().forEach(function (e) {
                    return e.stop();
                  }), a = null, c = null, d = null;
                  return _context87.abrupt("return", new VT(xT.ENUMERATE_DEVICES_FAILED, _context87.t4.toString()).throw());

                case 76:
                case "end":
                  return _context87.stop();
              }
            }
          }, _callee87, this, [[19, 25], [35, 41], [51, 57], [65, 72]]);
        }));

        function enumerateDevices(_x168, _x169) {
          return _enumerateDevices.apply(this, arguments);
        }

        return enumerateDevices;
      }()
    }, {
      key: "getRecordingDevices",
      value: function () {
        var _getRecordingDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88() {
          var e,
              _args88 = arguments;
          return _regeneratorRuntime.wrap(function _callee88$(_context88) {
            while (1) {
              switch (_context88.prev = _context88.next) {
                case 0:
                  e = _args88.length > 0 && void 0 !== _args88[0] && _args88[0];
                  _context88.next = 3;
                  return this.enumerateDevices(!0, !1, e);

                case 3:
                  return _context88.abrupt("return", _context88.sent.filter(function (e) {
                    return "audioinput" === e.kind;
                  }));

                case 4:
                case "end":
                  return _context88.stop();
              }
            }
          }, _callee88, this);
        }));

        function getRecordingDevices() {
          return _getRecordingDevices.apply(this, arguments);
        }

        return getRecordingDevices;
      }()
    }, {
      key: "getCamerasDevices",
      value: function () {
        var _getCamerasDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89() {
          var e,
              _args89 = arguments;
          return _regeneratorRuntime.wrap(function _callee89$(_context89) {
            while (1) {
              switch (_context89.prev = _context89.next) {
                case 0:
                  e = _args89.length > 0 && void 0 !== _args89[0] && _args89[0];
                  _context89.next = 3;
                  return this.enumerateDevices(!1, !0, e);

                case 3:
                  return _context89.abrupt("return", _context89.sent.filter(function (e) {
                    return "videoinput" === e.kind;
                  }));

                case 4:
                case "end":
                  return _context89.stop();
              }
            }
          }, _callee89, this);
        }));

        function getCamerasDevices() {
          return _getCamerasDevices.apply(this, arguments);
        }

        return getCamerasDevices;
      }()
    }, {
      key: "getSpeakers",
      value: function () {
        var _getSpeakers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90() {
          var e,
              _args90 = arguments;
          return _regeneratorRuntime.wrap(function _callee90$(_context90) {
            while (1) {
              switch (_context90.prev = _context90.next) {
                case 0:
                  e = _args90.length > 0 && void 0 !== _args90[0] && _args90[0];
                  _context90.next = 3;
                  return this.enumerateDevices(!0, !1, e);

                case 3:
                  return _context90.abrupt("return", _context90.sent.filter(function (e) {
                    return "audiooutput" === e.kind;
                  }));

                case 4:
                case "end":
                  return _context90.stop();
              }
            }
          }, _callee90, this);
        }));

        function getSpeakers() {
          return _getSpeakers.apply(this, arguments);
        }

        return getSpeakers;
      }()
    }, {
      key: "searchDeviceIdByName",
      value: function searchDeviceIdByName(e) {
        var t = null;
        return this.deviceInfoMap.forEach(function (i) {
          i.device.label === e && (t = i.device.deviceId);
        }), t;
      }
    }, {
      key: "getDeviceById",
      value: function () {
        var _getDeviceById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee91$(_context91) {
            while (1) {
              switch (_context91.prev = _context91.next) {
                case 0:
                  _context91.next = 2;
                  return this.enumerateDevices(!0, !0, !0);

                case 2:
                  t = _context91.sent.find(function (t) {
                    return t.deviceId === e;
                  });

                  if (t) {
                    _context91.next = 5;
                    break;
                  }

                  throw new VT(xT.DEVICE_NOT_FOUND, "deviceId: ".concat(e));

                case 5:
                  return _context91.abrupt("return", t);

                case 6:
                case "end":
                  return _context91.stop();
              }
            }
          }, _callee91, this);
        }));

        function getDeviceById(_x170) {
          return _getDeviceById.apply(this, arguments);
        }

        return getDeviceById;
      }()
    }, {
      key: "init",
      value: function () {
        var _init3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92() {
          return _regeneratorRuntime.wrap(function _callee92$(_context92) {
            while (1) {
              switch (_context92.prev = _context92.next) {
                case 0:
                  this.state = cb.INITING;
                  _context92.prev = 1;
                  _context92.next = 4;
                  return this.updateDevicesInfo();

                case 4:
                  this.state = cb.INITEND;
                  _context92.next = 11;
                  break;

                case 7:
                  _context92.prev = 7;
                  _context92.t0 = _context92["catch"](1);

                  if (YC.warning("Device Detection functionality cannot start properly.", _context92.t0.toString()), this.state = cb.IDLE, !("boolean" == typeof isSecureContext ? isSecureContext : "https:" === location.protocol || "file:" === location.protocol || "localhost" === location.hostname || "127.0.0.1" === location.hostname || "::1" === location.hostname)) {
                    new VT(xT.WEB_SECURITY_RESTRICT, "Your context is limited by web security, please try using https protocol or localhost.").throw();
                  }

                  throw _context92.t0;

                case 11:
                case "end":
                  return _context92.stop();
              }
            }
          }, _callee92, this, [[1, 7]]);
        }));

        function init() {
          return _init3.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "updateDevicesInfo",
      value: function () {
        var _updateDevicesInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93() {
          var _this106 = this;

          var e, t, i, _t81, _i48, n;

          return _regeneratorRuntime.wrap(function _callee93$(_context93) {
            while (1) {
              switch (_context93.prev = _context93.next) {
                case 0:
                  _context93.next = 2;
                  return this.enumerateDevices(!0, !0, !0);

                case 2:
                  e = _context93.sent;
                  t = Date.now();
                  i = [];

                  if (e[0] && e[0].label && !1 === this.checkdeviceMatched) {
                    this.checkdeviceMatched = !0;
                    _t81 = e.find(function (e) {
                      return "audioinput" === e.kind && "default" === e.deviceId;
                    }), _i48 = e.find(function (e) {
                      return "audiooutput" === e.kind && "default" === e.deviceId;
                    });
                    _t81 && _i48 ? _i48.groupId === _t81.groupId ? YC.debug("[device-check] default input ".concat(_t81.label, " and output ").concat(_i48.label, " is the same group")) : YC.warning("[device-check] default input ".concat(_t81.label, " and output ").concat(_i48.label, " is not the same group")) : YC.debug("[device-check] default input or output not found");
                  }

                  n = this.checkMediaDeviceInfoIsOk(e);

                  if (!(e.forEach(function (e) {
                    if (!e.deviceId) return;

                    var n = _this106.deviceInfoMap.get("".concat(e.kind, "_").concat(e.deviceId));

                    if ("ACTIVE" !== (n ? n.state : "INACTIVE")) {
                      var _n37 = {
                        initAt: t,
                        updateAt: t,
                        device: e,
                        state: "ACTIVE"
                      };
                      _this106.deviceInfoMap.set("".concat(e.kind, "_").concat(e.deviceId), _n37), i.push(_n37);
                    }

                    n && (n.updateAt = t);
                  }), this.deviceInfoMap.forEach(function (e, n) {
                    "ACTIVE" === e.state && e.updateAt !== t && (e.state = "INACTIVE", i.push(e));
                  }), this.state !== cb.INITEND)) {
                    _context93.next = 9;
                    break;
                  }

                  return _context93.abrupt("return", (n.audio && (this.lastAccessMicrophonePermission = !0, this.isAccessMicrophonePermission = !0), void (n.video && (this.lastAccessCameraPermission = !0, this.isAccessCameraPermission = !0))));

                case 9:
                  i.forEach(function (e) {
                    switch (e.device.kind) {
                      case "audioinput":
                        _this106.lastAccessMicrophonePermission && _this106.isAccessMicrophonePermission && _this106.emit(db.RECORDING_DEVICE_CHANGED, e);
                        break;

                      case "videoinput":
                        _this106.lastAccessCameraPermission && _this106.isAccessCameraPermission && _this106.emit(db.CAMERA_DEVICE_CHANGED, e);
                        break;

                      case "audiooutput":
                        _this106.lastAccessMicrophonePermission && _this106.isAccessMicrophonePermission && _this106.emit(db.PLAYOUT_DEVICE_CHANGED, e);
                    }
                  }), n.audio && (this.lastAccessMicrophonePermission = !0, this.isAccessMicrophonePermission = !0), n.video && (this.lastAccessCameraPermission = !0, this.isAccessCameraPermission = !0);

                case 10:
                case "end":
                  return _context93.stop();
              }
            }
          }, _callee93, this);
        }));

        function updateDevicesInfo() {
          return _updateDevicesInfo.apply(this, arguments);
        }

        return updateDevicesInfo;
      }()
    }, {
      key: "checkMediaDeviceInfoIsOk",
      value: function checkMediaDeviceInfoIsOk(e) {
        var t = e.filter(function (e) {
          return "audioinput" === e.kind;
        }),
            i = e.filter(function (e) {
          return "videoinput" === e.kind;
        }),
            n = {
          audio: !1,
          video: !1
        };

        var _iterator3 = _createForOfIteratorHelper(t),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e69 = _step3.value;

            if (_e69.label && _e69.deviceId) {
              n.audio = !0;
              break;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(i),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _e70 = _step4.value;

            if (_e70.label && _e70.deviceId) {
              n.video = !0;
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return n;
      }
    }]);

    return _class7;
  }(ig))();
  var Bb = !1;
  var jb = new ( /*#__PURE__*/function (_ig16) {
    _inherits(_class8, _ig16);

    var _super24 = _createSuper(_class8);

    function _class8() {
      var _this107;

      _classCallCheck(this, _class8);

      _this107 = _super24.apply(this, arguments), nh(_assertThisInitialized(_this107), "onAutoplayFailed", void 0), nh(_assertThisInitialized(_this107), "onAudioAutoplayFailed", void 0);
      return _this107;
    }

    return _createClass(_class8);
  }(ig))();

  function Gb() {
    if (pT(), !Bb) {
      var e = function e(t) {
        t.preventDefault(), Bb = !1, UT() ? document.body.removeEventListener("click", e, !0) : (document.body.removeEventListener("touchstart", e, !0), document.body.removeEventListener("mousedown", e, !0));
      };

      Bb = !0, UT() ? document.body.addEventListener("click", e, !0) : (document.body.addEventListener("touchstart", e, !0), document.body.addEventListener("mousedown", e, !0)), YC.info("detect media autoplay failed, document: https://docs.agora.io/cn/Voice/autoplay_policy_web_ng?platform=Web"), jb.onAutoplayFailed ? jb.onAutoplayFailed() : jb.onAudioAutoplayFailed ? YC.warning("AgoraRTC.onAudioAutoplayFailed has been deprecated in favor of AgoraRTC.onAutoplayFailed.\n\n  Please refer to the Agora document to migrate the newer API, https://docs.agora.io/en/Voice/autoplay_policy_web_ng?platform=Web .") : YC.warning("We have detected a media autoplay failed event, and found out that you haven't implemented AgoraRTC.onAutoplayFailed callback yet.\n\n  It will cause audio/video element not playing automatically on some browsers without user interaction, possibly hurting user experiences.\n\n  Please refer to the Agora document to properly handle autoplay failed event, https://docs.agora.io/en/Voice/autoplay_policy_web_ng?platform=Web ."), jb.emit("autoplay-failed");
    }
  }

  function Wb(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Hb(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Wb(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Wb(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function Kb(e, t, i, n) {
    if (!e) return;
    var s = rI.getBaseInfoBySessionId(e);
    if (!s) return;
    var r = s.info,
        o = Date.now(),
        a = Hb(Hb({}, r), {}, {
      vid: void 0 === r.vid ? 0 : Number(r.vid),
      lts: o,
      elapse: o - s.startTime,
      cbRegistered: jb.onAutoplayFailed || jb.onAudioAutoplayFailed ? 1 : -1,
      errorMsg: i,
      mediaType: t,
      trackId: n,
      extend: void 0
    });
    rI.send({
      type: ZC.AUTOPLAY_FAILED,
      data: a
    }, !0);
  }

  var Yb = ["play", "playing", "loadeddata", "canplay", "pause", "stalled", "suspend", "waiting", "abort", "emptied", "ended", "error"],
      qb = new ( /*#__PURE__*/function () {
    function _class9() {
      var _this108 = this;

      _classCallCheck(this, _class9);

      nh(this, "onAutoplayFailed", void 0), nh(this, "elementMap", new Map()), nh(this, "elementStateMap", new Map()), nh(this, "elementsNeedToResume", []), nh(this, "sinkIdMap", new Map()), nh(this, "autoResumeAfterInterruption", function (e) {
        Array.from(_this108.elementMap.entries()).forEach(function (t) {
          var _t82 = _slicedToArray(t, 2),
              i = _t82[0],
              n = _t82[1];

          var s = _this108.elementStateMap.get(i),
              r = n.srcObject.getAudioTracks()[0],
              o = r && r.readyState;

          if (YC.debug("resume after interrupted, ele: ".concat(s, " audio: ").concat(o, " ").concat(e)), "live" === o) {
            if (e) return n.pause(), void n.play();
            if ("running" === Tb.curState) return wT() ? (n.pause(), void n.play()) : void (s && "paused" === s && n.play());
          }
        });
      }), nh(this, "autoResumeAfterInterruptionOnIOS15_16", function () {
        Array.from(_this108.elementMap.entries()).forEach(function (e) {
          var _e71 = _slicedToArray(e, 2),
              t = _e71[0],
              i = _e71[1];

          var n = i.srcObject.getAudioTracks()[0];
          n && "live" === n.readyState && (YC.debug("auto resume after interruption inside autoResumeAfterInterruptionOnIOS15"), i.pause(), i.play());
        });
      }), this.autoResumeAudioElement(), Tb.on(OA.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), Tb.on(OA.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16), Tb.on(OA.STATE_CHANGE, function () {
        CT() && "suspended" === Tb.prevState && "running" === Tb.curState && _this108.autoResumeAfterInterruption();
      });
    }

    _createClass(_class9, [{
      key: "setSinkID",
      value: function () {
        var _setSinkID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee94$(_context94) {
            while (1) {
              switch (_context94.prev = _context94.next) {
                case 0:
                  i = this.elementMap.get(e);

                  if (!(this.sinkIdMap.set(e, t), i)) {
                    _context94.next = 10;
                    break;
                  }

                  _context94.prev = 2;
                  _context94.next = 5;
                  return i.setSinkId(t);

                case 5:
                  _context94.next = 10;
                  break;

                case 7:
                  _context94.prev = 7;
                  _context94.t0 = _context94["catch"](2);
                  throw new VT(xT.PERMISSION_DENIED, "can not set sink id: " + _context94.t0.toString());

                case 10:
                case "end":
                  return _context94.stop();
              }
            }
          }, _callee94, this, [[2, 7]]);
        }));

        function setSinkID(_x171, _x172) {
          return _setSinkID.apply(this, arguments);
        }

        return setSinkID;
      }()
    }, {
      key: "play",
      value: function play(e, t, i, n) {
        var _this109 = this;

        if (this.elementMap.has(t)) return;
        var s = document.createElement("audio");
        s.autoplay = !0, s.srcObject = new MediaStream([e]), this.bindAudioElementEvents(t, s), this.elementMap.set(t, s), this.elementStateMap.set(t, lb.INIT), this.setVolume(t, i);
        var r = this.sinkIdMap.get(t);
        if (r) try {
          s.setSinkId(r).catch(function (e) {
            YC.warning("[".concat(t, "] set sink id failed"), e.toString());
          });
        } catch (e) {
          YC.warning("[".concat(t, "] set sink id failed"), e.toString());
        }
        var o = s.play();
        o && o.then && o.catch(function (e) {
          n && Kb(n, "audio", e.message, t), YC.warning("audio element play warning", e.toString()), _this109.elementMap.has(t) && "NotAllowedError" === e.name && (YC.warning("detected audio element autoplay failed"), _this109.elementsNeedToResume.push(s), Ag(function () {
            _this109.onAutoplayFailed && _this109.onAutoplayFailed(), Gb();
          }));
        });
      }
    }, {
      key: "updateTrack",
      value: function updateTrack(e, t) {
        var i = this.elementMap.get(e);
        i && (i.srcObject = new MediaStream([t]));
      }
    }, {
      key: "isPlaying",
      value: function isPlaying(e) {
        return this.elementMap.has(e) && "playing" === this.elementStateMap.get(e);
      }
    }, {
      key: "setVolume",
      value: function setVolume(e, t) {
        var i = this.elementMap.get(e);
        i && (t = Math.max(0, Math.min(100, t)), i.volume = t / 100);
      }
    }, {
      key: "stop",
      value: function stop(e) {
        var t = this.elementMap.get(e);
        if (this.sinkIdMap.delete(e), !t) return;
        var i = this.elementsNeedToResume.indexOf(t);
        this.elementsNeedToResume.splice(i, 1), t.srcObject = null, t.remove(), this.elementMap.delete(e), this.elementStateMap.delete(e);
      }
    }, {
      key: "bindAudioElementEvents",
      value: function bindAudioElementEvents(e, t) {
        var _this110 = this;

        Yb.forEach(function (i) {
          t.addEventListener(i, function (i) {
            var n = _this110.elementStateMap.get(e),
                s = "pause" === i.type ? "paused" : i.type;

            if (YC.debug("[".concat(e, "] audio-element-status change ").concat(n, " => ").concat(s)), "error" === i.type) {
              var _i49 = null == t ? void 0 : t.error;

              _i49 && YC.error("[".concat(e, "] media error, code: ").concat(_i49.code, ", message: ").concat(_i49.message));
            }

            _this110.elementStateMap.set(e, s);
          });
        });
      }
    }, {
      key: "getPlayerState",
      value: function getPlayerState(e) {
        return this.elementStateMap.get(e) || "uninit";
      }
    }, {
      key: "autoResumeAudioElement",
      value: function autoResumeAudioElement() {
        var _this111 = this;

        var e = function e() {
          _this111.elementsNeedToResume.forEach(function (e) {
            e.play().then(function (e) {
              YC.debug("Auto resume audio element success");
            }).catch(function (e) {
              YC.warning("Auto resume audio element failed!", e);
            });
          }), _this111.elementsNeedToResume = [];
        };

        new tT(function (e) {
          document.body ? e() : window.addEventListener("load", function () {
            return e();
          });
        }).then(function () {
          UT() ? document.body.addEventListener("click", e, !0) : (document.body.addEventListener("touchstart", e, !0), document.body.addEventListener("mousedown", e, !0));
        });
      }
    }]);

    return _class9;
  }())();

  function Jb() {
    return function (e, t, i) {
      var n = i.value;
      return "function" == typeof n && (i.value = function () {
        this._isClosed && new VT(xT.INVALID_OPERATION, "[".concat(this.getTrackId(), "] cannot operate a closed track")).print("warning", YC);

        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
          t[i] = arguments[i];
        }

        var s = n.apply(this, t);
        return s instanceof tT ? new tT(function (e, t) {
          s.then(e).catch(t);
        }) : s;
      }), i;
    };
  }

  function zb(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Xb(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? zb(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : zb(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var Qb = /*#__PURE__*/function (_ig17) {
    _inherits(Qb, _ig17);

    var _super25 = _createSuper(Qb);

    function Qb(e) {
      var _this112;

      _classCallCheck(this, Qb);

      _this112 = _super25.call(this), nh(_assertThisInitialized(_this112), "name", "VideoProcessorDestination"), nh(_assertThisInitialized(_this112), "ID", "0"), nh(_assertThisInitialized(_this112), "_source", void 0), nh(_assertThisInitialized(_this112), "videoContext", void 0), nh(_assertThisInitialized(_this112), "inputTrack", void 0), _this112.videoContext = e;
      return _this112;
    }

    _createClass(Qb, [{
      key: "kind",
      get: function get() {
        return "video";
      }
    }, {
      key: "enabled",
      get: function get() {
        return !0;
      }
    }, {
      key: "pipe",
      value: function pipe() {
        throw new VT(xT.NOT_SUPPORTED, "VideoProcessor cannot pipe to any other Processor");
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        throw new VT(xT.NOT_SUPPORTED, "VideoProcessor cannot unpipe to any other Processor");
      }
    }, {
      key: "enable",
      value: function enable() {}
    }, {
      key: "disable",
      value: function disable() {}
    }, {
      key: "updateInput",
      value: function updateInput(e) {
        if (e.context !== this.videoContext) throw new Error("ProcessorContext passed to VideoTrack.processorDestination doesn't match it's belonging VideoTrack's context.\nProbably you are making pipeline like this:\nvideoTrack1.pipe(processor).pipe(videoTrack2.processorDestination).");
        e.track && e.track !== this.inputTrack && (this.videoContext.chained = !0, this.inputTrack = e.track, this.emit(ob.ON_TRACK, e.track));
      }
    }, {
      key: "reset",
      value: function reset() {
        this.inputTrack = void 0, this.videoContext.chained = !1, this.emit(ob.ON_TRACK, void 0);
      }
    }]);

    return Qb;
  }(ig);

  var Zb = /*#__PURE__*/function (_ig18) {
    _inherits(Zb, _ig18);

    var _super26 = _createSuper(Zb);

    function Zb(e, t) {
      var _this113;

      _classCallCheck(this, Zb);

      _this113 = _super26.call(this), nh(_assertThisInitialized(_this113), "constraintsMap", new Map()), nh(_assertThisInitialized(_this113), "statsRegistry", []), nh(_assertThisInitialized(_this113), "usageRegistry", []), nh(_assertThisInitialized(_this113), "trackId", void 0), nh(_assertThisInitialized(_this113), "direction", void 0), nh(_assertThisInitialized(_this113), "_chained", !1), _this113.trackId = e, _this113.direction = t;
      return _this113;
    }

    _createClass(Zb, [{
      key: "chained",
      get: function get() {
        return this._chained;
      },
      set: function set(e) {
        this._chained = e;
      }
    }, {
      key: "getConstraints",
      value: function () {
        var _getConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95() {
          return _regeneratorRuntime.wrap(function _callee95$(_context95) {
            while (1) {
              switch (_context95.prev = _context95.next) {
                case 0:
                  _context95.next = 2;
                  return fg(this, ab.REQUEST_CONSTRAINTS);

                case 2:
                  return _context95.abrupt("return", _context95.sent);

                case 3:
                case "end":
                  return _context95.stop();
              }
            }
          }, _callee95, this);
        }));

        function getConstraints() {
          return _getConstraints.apply(this, arguments);
        }

        return getConstraints;
      }()
    }, {
      key: "requestApplyConstraints",
      value: function () {
        var _requestApplyConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee96$(_context96) {
            while (1) {
              switch (_context96.prev = _context96.next) {
                case 0:
                  return _context96.abrupt("return", (YC.info("processor ".concat(t.name, " requestApplyConstraints for ").concat(this.trackId)), e && this.constraintsMap.set(t, e), Tg(this, ab.REQUEST_UPDATE_CONSTRAINTS, Array.from(MI(i = this.constraintsMap).call(i)))));

                case 1:
                case "end":
                  return _context96.stop();
              }
            }
          }, _callee96, this);
        }));

        function requestApplyConstraints(_x173, _x174) {
          return _requestApplyConstraints.apply(this, arguments);
        }

        return requestApplyConstraints;
      }()
    }, {
      key: "requestRevertConstraints",
      value: function () {
        var _requestRevertConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee97$(_context97) {
            while (1) {
              switch (_context97.prev = _context97.next) {
                case 0:
                  if (!this.constraintsMap.has(e)) {
                    _context97.next = 2;
                    break;
                  }

                  return _context97.abrupt("return", (YC.info("processor ".concat(e.name, " requestRevertConstraints for ").concat(this.trackId)), this.constraintsMap.delete(e), Tg(this, ab.REQUEST_UPDATE_CONSTRAINTS, Array.from(MI(t = this.constraintsMap).call(t)))));

                case 2:
                case "end":
                  return _context97.stop();
              }
            }
          }, _callee97, this);
        }));

        function requestRevertConstraints(_x175) {
          return _requestRevertConstraints.apply(this, arguments);
        }

        return requestRevertConstraints;
      }()
    }, {
      key: "registerStats",
      value: function registerStats(e, t, i) {
        this.statsRegistry.find(function (i) {
          return i.processorID === e.ID && i.processorName === e.name && i.type === t;
        }) || this.statsRegistry.push({
          processorName: e.name,
          processorID: e.ID,
          type: t,
          cb: i
        });
      }
    }, {
      key: "unregisterStats",
      value: function unregisterStats(e, t) {
        var i = this.statsRegistry.findIndex(function (i) {
          return i.processorID === e.ID && i.processorName === e.name && i.type === t;
        });
        -1 !== i && this.statsRegistry.splice(i, 1);
      }
    }, {
      key: "gatherStats",
      value: function gatherStats() {
        var e = [];

        var _iterator5 = _createForOfIteratorHelper(this.statsRegistry),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _step5$value = _step5.value,
                _t83 = _step5$value.processorID,
                i = _step5$value.processorName,
                _n38 = _step5$value.type,
                _s22 = _step5$value.cb;

            try {
              var _r11 = _s22();

              e.push({
                processorID: _t83,
                processorName: i,
                type: _n38,
                stats: _r11
              });
            } catch (e) {
              YC.error(new VT(xT.UNEXPECTED_ERROR, e.message));
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return e;
      }
    }, {
      key: "registerUsage",
      value: function registerUsage(e, t) {
        this.usageRegistry.find(function (t) {
          return t.processorID === e.ID && t.processorName === e.name;
        }) || this.usageRegistry.push({
          processorID: e.ID,
          processorName: e.name,
          cb: t
        });
      }
    }, {
      key: "unregisterUsage",
      value: function unregisterUsage(e) {
        var t = this.usageRegistry.findIndex(function (t) {
          return t.processorID === e.ID && t.processorName === e.name;
        });
        -1 !== t && this.usageRegistry.splice(t, 1);
      }
    }, {
      key: "gatherUsage",
      value: function () {
        var _gatherUsage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98() {
          var e, _iterator6, _step6, _t84, i;

          return _regeneratorRuntime.wrap(function _callee98$(_context98) {
            while (1) {
              switch (_context98.prev = _context98.next) {
                case 0:
                  e = [];

                  if (this.chained) {
                    _context98.next = 3;
                    break;
                  }

                  return _context98.abrupt("return", []);

                case 3:
                  _iterator6 = _createForOfIteratorHelper(this.usageRegistry);
                  _context98.prev = 4;

                  _iterator6.s();

                case 6:
                  if ((_step6 = _iterator6.n()).done) {
                    _context98.next = 23;
                    break;
                  }

                  _t84 = _step6.value.cb;
                  _context98.prev = 8;
                  i = _t84();
                  _context98.t0 = i instanceof tT;

                  if (!_context98.t0) {
                    _context98.next = 15;
                    break;
                  }

                  _context98.next = 14;
                  return i;

                case 14:
                  i = _context98.sent;

                case 15:
                  e.push(Xb(Xb({}, i), {}, {
                    direction: this.direction
                  }));
                  _context98.next = 21;
                  break;

                case 18:
                  _context98.prev = 18;
                  _context98.t1 = _context98["catch"](8);
                  YC.error("gather extension usage error", _context98.t1);

                case 21:
                  _context98.next = 6;
                  break;

                case 23:
                  _context98.next = 28;
                  break;

                case 25:
                  _context98.prev = 25;
                  _context98.t2 = _context98["catch"](4);

                  _iterator6.e(_context98.t2);

                case 28:
                  _context98.prev = 28;

                  _iterator6.f();

                  return _context98.finish(28);

                case 31:
                  return _context98.abrupt("return", e);

                case 32:
                case "end":
                  return _context98.stop();
              }
            }
          }, _callee98, this, [[4, 25, 28, 31], [8, 18]]);
        }));

        function gatherUsage() {
          return _gatherUsage.apply(this, arguments);
        }

        return gatherUsage;
      }()
    }, {
      key: "getDirection",
      value: function getDirection() {
        return this.direction;
      }
    }]);

    return Zb;
  }(ig);

  var $b = /*#__PURE__*/function (_ig19) {
    _inherits($b, _ig19);

    var _super27 = _createSuper($b);

    function $b(e) {
      var _this114;

      _classCallCheck(this, $b);

      _this114 = _super27.call(this), nh(_assertThisInitialized(_this114), "name", "AudioProcessorDestination"), nh(_assertThisInitialized(_this114), "ID", "0"), nh(_assertThisInitialized(_this114), "inputTrack", void 0), nh(_assertThisInitialized(_this114), "inputNode", void 0), nh(_assertThisInitialized(_this114), "audioProcessorContext", void 0), nh(_assertThisInitialized(_this114), "_source", void 0), _this114.audioProcessorContext = e;
      return _this114;
    }

    _createClass($b, [{
      key: "kind",
      get: function get() {
        return "audio";
      }
    }, {
      key: "enabled",
      get: function get() {
        return !0;
      }
    }, {
      key: "pipe",
      value: function pipe() {
        throw new VT(xT.NOT_SUPPORTED, "AudioProcessorDestination cannot pipe to any other Processor");
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        throw new VT(xT.NOT_SUPPORTED, "AudioProcessor cannot unpipe to any other Processor");
      }
    }, {
      key: "enable",
      value: function enable() {}
    }, {
      key: "disable",
      value: function disable() {}
    }, {
      key: "reset",
      value: function reset() {
        this.inputTrack = void 0, this.inputNode = void 0, this.audioProcessorContext.chained = !1, this.emit(ob.ON_TRACK, void 0), this.emit(ob.ON_NODE, void 0);
      }
    }, {
      key: "updateInput",
      value: function updateInput(e) {
        if (e.context !== this.audioProcessorContext) throw new Error("ProcessorContext passed to AudioTrack.processorDestination doesn't match it's belonging AudioTrack's context.\n        Probably you are making pipeline like this: audioTrack1.pipe(processor).pipe(audioTrack2.processorDestination).");
        e.track && this.inputTrack !== e.track && (this.audioProcessorContext.chained = !0, this.inputTrack = e.track, this.emit(ob.ON_TRACK, this.inputTrack)), e.node && this.inputNode !== e.node && (this.audioProcessorContext.chained = !0, this.inputNode = e.node, this.emit(ob.ON_NODE, this.inputNode));
      }
    }]);

    return $b;
  }(ig);

  var ew = /*#__PURE__*/function (_ig20) {
    _inherits(ew, _ig20);

    var _super28 = _createSuper(ew);

    function ew(e, t, i) {
      var _this115;

      _classCallCheck(this, ew);

      _this115 = _super28.call(this), nh(_assertThisInitialized(_this115), "constraintsMap", new Map()), nh(_assertThisInitialized(_this115), "statsRegistry", []), nh(_assertThisInitialized(_this115), "audioContext", void 0), nh(_assertThisInitialized(_this115), "trackId", void 0), nh(_assertThisInitialized(_this115), "direction", void 0), nh(_assertThisInitialized(_this115), "usageRegistry", []), nh(_assertThisInitialized(_this115), "_chained", !1), _this115.audioContext = e, _this115.trackId = t, _this115.direction = i;
      return _this115;
    }

    _createClass(ew, [{
      key: "chained",
      get: function get() {
        return this._chained;
      },
      set: function set(e) {
        this._chained = e;
      }
    }, {
      key: "getConstraints",
      value: function () {
        var _getConstraints2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99() {
          return _regeneratorRuntime.wrap(function _callee99$(_context99) {
            while (1) {
              switch (_context99.prev = _context99.next) {
                case 0:
                  return _context99.abrupt("return", fg(this, ab.REQUEST_CONSTRAINTS));

                case 1:
                case "end":
                  return _context99.stop();
              }
            }
          }, _callee99, this);
        }));

        function getConstraints() {
          return _getConstraints2.apply(this, arguments);
        }

        return getConstraints;
      }()
    }, {
      key: "getAudioContext",
      value: function getAudioContext() {
        return this.audioContext;
      }
    }, {
      key: "requestApplyConstraints",
      value: function () {
        var _requestApplyConstraints2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee100$(_context100) {
            while (1) {
              switch (_context100.prev = _context100.next) {
                case 0:
                  return _context100.abrupt("return", (YC.info("processor ".concat(t.name, " requestApplyConstraints for ").concat(this.trackId)), e && this.constraintsMap.set(t, e), Tg(this, ab.REQUEST_UPDATE_CONSTRAINTS, Array.from(MI(i = this.constraintsMap).call(i)))));

                case 1:
                case "end":
                  return _context100.stop();
              }
            }
          }, _callee100, this);
        }));

        function requestApplyConstraints(_x176, _x177) {
          return _requestApplyConstraints2.apply(this, arguments);
        }

        return requestApplyConstraints;
      }()
    }, {
      key: "requestRevertConstraints",
      value: function () {
        var _requestRevertConstraints2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee101$(_context101) {
            while (1) {
              switch (_context101.prev = _context101.next) {
                case 0:
                  if (!this.constraintsMap.has(e)) {
                    _context101.next = 2;
                    break;
                  }

                  return _context101.abrupt("return", (this.constraintsMap.delete(e), Tg(this, ab.REQUEST_UPDATE_CONSTRAINTS, Array.from(MI(t = this.constraintsMap).call(t)))));

                case 2:
                case "end":
                  return _context101.stop();
              }
            }
          }, _callee101, this);
        }));

        function requestRevertConstraints(_x178) {
          return _requestRevertConstraints2.apply(this, arguments);
        }

        return requestRevertConstraints;
      }()
    }, {
      key: "registerStats",
      value: function registerStats(e, t, i) {
        this.statsRegistry.find(function (i) {
          return i.processorID === e.ID && i.processorName === e.name && i.type === t;
        }) || this.statsRegistry.push({
          processorName: e.name,
          processorID: e.ID,
          type: t,
          cb: i
        });
      }
    }, {
      key: "unregisterStats",
      value: function unregisterStats(e, t) {
        var i = this.statsRegistry.findIndex(function (i) {
          return i.processorID === e.ID && i.processorName === e.name && i.type === t;
        });
        -1 !== i && this.statsRegistry.splice(i, 1);
      }
    }, {
      key: "gatherStats",
      value: function gatherStats() {
        var e = [];

        var _iterator7 = _createForOfIteratorHelper(this.statsRegistry),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _step7$value = _step7.value,
                _t85 = _step7$value.processorID,
                i = _step7$value.processorName,
                _n39 = _step7$value.type,
                _s23 = _step7$value.cb;

            try {
              var _r12 = _s23();

              e.push({
                processorID: _t85,
                processorName: i,
                type: _n39,
                stats: _r12
              });
            } catch (e) {
              YC.error(new VT(xT.UNEXPECTED_ERROR, e.message));
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        return e;
      }
    }, {
      key: "registerUsage",
      value: function registerUsage(e, t) {
        this.usageRegistry.find(function (t) {
          return t.processorID === e.ID && t.processorName === e.name;
        }) || this.usageRegistry.push({
          processorID: e.ID,
          processorName: e.name,
          cb: t
        });
      }
    }, {
      key: "unregisterUsage",
      value: function unregisterUsage(e) {
        var t = this.usageRegistry.findIndex(function (t) {
          return t.processorID === e.ID && t.processorName === e.name;
        });
        -1 !== t && this.usageRegistry.splice(t, 1);
      }
    }, {
      key: "gatherUsage",
      value: function () {
        var _gatherUsage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102() {
          var e, _iterator8, _step8, _t86, i;

          return _regeneratorRuntime.wrap(function _callee102$(_context102) {
            while (1) {
              switch (_context102.prev = _context102.next) {
                case 0:
                  e = [];

                  if (this.chained) {
                    _context102.next = 3;
                    break;
                  }

                  return _context102.abrupt("return", []);

                case 3:
                  _iterator8 = _createForOfIteratorHelper(this.usageRegistry);
                  _context102.prev = 4;

                  _iterator8.s();

                case 6:
                  if ((_step8 = _iterator8.n()).done) {
                    _context102.next = 23;
                    break;
                  }

                  _t86 = _step8.value.cb;
                  _context102.prev = 8;
                  i = _t86();
                  _context102.t0 = i instanceof tT;

                  if (!_context102.t0) {
                    _context102.next = 15;
                    break;
                  }

                  _context102.next = 14;
                  return i;

                case 14:
                  i = _context102.sent;

                case 15:
                  e.push(Xb(Xb({}, i), {}, {
                    direction: this.direction
                  }));
                  _context102.next = 21;
                  break;

                case 18:
                  _context102.prev = 18;
                  _context102.t1 = _context102["catch"](8);
                  YC.error("gather extension usage error", _context102.t1);

                case 21:
                  _context102.next = 6;
                  break;

                case 23:
                  _context102.next = 28;
                  break;

                case 25:
                  _context102.prev = 25;
                  _context102.t2 = _context102["catch"](4);

                  _iterator8.e(_context102.t2);

                case 28:
                  _context102.prev = 28;

                  _iterator8.f();

                  return _context102.finish(28);

                case 31:
                  return _context102.abrupt("return", e);

                case 32:
                case "end":
                  return _context102.stop();
              }
            }
          }, _callee102, this, [[4, 25, 28, 31], [8, 18]]);
        }));

        function gatherUsage() {
          return _gatherUsage2.apply(this, arguments);
        }

        return gatherUsage;
      }()
    }, {
      key: "getDirection",
      value: function getDirection() {
        return this.direction;
      }
    }]);

    return ew;
  }(ig);

  var tw = /*#__PURE__*/function (_ig21) {
    _inherits(tw, _ig21);

    var _super29 = _createSuper(tw);

    function tw() {
      var _this116;

      _classCallCheck(this, tw);

      _this116 = _super29.call(this), nh(_assertThisInitialized(_this116), "context", void 0), nh(_assertThisInitialized(_this116), "processSourceNode", void 0), nh(_assertThisInitialized(_this116), "outputTrack", void 0), nh(_assertThisInitialized(_this116), "processedNode", void 0), nh(_assertThisInitialized(_this116), "clonedTrack", void 0), nh(_assertThisInitialized(_this116), "outputNode", void 0), _this116.outputNode = new iw();
      return _this116;
    }

    _createClass(tw, [{
      key: "isPlayed",
      get: function get() {
        return !0;
      }
    }, {
      key: "isFreeze",
      get: function get() {
        return !1;
      }
    }, {
      key: "setVolume",
      value: function setVolume() {}
    }, {
      key: "createOutputTrack",
      value: function createOutputTrack() {
        throw new VT(xT.NOT_SUPPORTED, "can not create output MediaStreamTrack when WebAudio disabled");
      }
    }, {
      key: "getOriginVolumeLevel",
      value: function getOriginVolumeLevel() {
        return 0;
      }
    }, {
      key: "getAccurateVolumeLevel",
      value: function getAccurateVolumeLevel() {
        return 0;
      }
    }, {
      key: "stopGetAudioBuffer",
      value: function stopGetAudioBuffer() {}
    }, {
      key: "startGetAudioBuffer",
      value: function startGetAudioBuffer() {}
    }, {
      key: "play",
      value: function play() {}
    }, {
      key: "stop",
      value: function stop() {}
    }, {
      key: "destroy",
      value: function destroy() {}
    }, {
      key: "updateTrack",
      value: function updateTrack() {}
    }, {
      key: "updateOriginTrack",
      value: function updateOriginTrack() {}
    }, {
      key: "createMediaStreamSourceNode",
      value: function createMediaStreamSourceNode() {}
    }]);

    return tw;
  }(ig);

  var iw = /*#__PURE__*/function () {
    function iw() {
      _classCallCheck(this, iw);
    }

    _createClass(iw, [{
      key: "disconnect",
      value: function disconnect() {}
    }, {
      key: "connect",
      value: function connect() {}
    }]);

    return iw;
  }();

  var nw = null;

  var sw = /*#__PURE__*/function () {
    function sw() {
      var _this117 = this;

      _classCallCheck(this, sw);

      nh(this, "state", "open"), nh(this, "trigger", void 0), nh(this, "tasks", []), YC.debug("[macro-task-queue] is created."), this.trigger = window.setTimeout(function () {
        _this117.state = "closed", YC.debug("[macro-task-queue] will be closed, all remaining tasks will execute. [".concat(_this117.tasks.map(function (e) {
          return e.key;
        }), "]")), _this117.trigger = void 0, _this117.tasks.forEach(function (e) {
          var t = e.func;
          return t();
        }), _this117.tasks.length = 0, YC.debug("[macro-task-queue] is closed.");
      });
    }

    _createClass(sw, [{
      key: "enqueue",
      value: function enqueue(e, t) {
        "closed" !== this.state && (this.tasks.push({
          key: e,
          func: t
        }), YC.debug("[macro-task-queue] is queued, current queue ".concat(this.tasks.length, ". ").concat("string" == typeof e ? e : "")));
      }
    }, {
      key: "runTask",
      value: function runTask(e) {
        if ("closed" === this.state) return;
        var t = this.tasks.findIndex(function (t) {
          return t.key === e;
        });

        if (-1 !== t) {
          var i = this.tasks.splice(t, 1);
          YC.debug("[macro-task-queue] is unqueued, current queue ".concat(this.tasks.length, ". ").concat("string" == typeof e ? e : "")), i[0].func();
        }
      }
    }, {
      key: "release",
      value: function release() {
        this.trigger && (this.state = "closed", clearTimeout(this.trigger), this.trigger = void 0, this.tasks.length = 0, YC.debug("[macro-task-queue] is closed."));
      }
    }]);

    return sw;
  }();

  function rw(e) {
    return function (t, i, n) {
      var s;

      var r = null !== (s = n.value) && void 0 !== s ? s : n.get,
          o = function o() {
        nw && "open" === nw.state && nw.runTask(e);

        for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) {
          i[n] = arguments[n];
        }

        return null == r ? void 0 : r.apply.apply(r, [this].concat(i));
      };

      return n.value ? n.value = o : n.get = o, n;
    };
  }

  function ow(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function aw(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ow(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ow(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var cw = /*#__PURE__*/function (_b2) {
    _inherits(cw, _b2);

    var _super30 = _createSuper(cw);

    function cw(e, t, i, n, s) {
      var _this118;

      _classCallCheck(this, cw);

      _this118 = _super30.call(this, e, i), nh(_assertThisInitialized(_this118), "trackMediaType", "audio"), nh(_assertThisInitialized(_this118), "_encoderConfig", void 0), nh(_assertThisInitialized(_this118), "_trackSource", void 0), nh(_assertThisInitialized(_this118), "_enabled", !0), nh(_assertThisInitialized(_this118), "_volume", 100), nh(_assertThisInitialized(_this118), "_useAudioElement", !1), nh(_assertThisInitialized(_this118), "_bypassWebAudio", !1), nh(_assertThisInitialized(_this118), "processor", void 0), nh(_assertThisInitialized(_this118), "_processorContext", void 0), nh(_assertThisInitialized(_this118), "_processorDestination", void 0), nh(_assertThisInitialized(_this118), "_getOriginVolumeLevel", void 0), _this118._encoderConfig = t, _this118._getOriginVolumeLevel = !!n;

      var r = function r() {
        _this118.processorContext = new ew(_this118._source.context, _this118.getTrackId(), "local"), _this118.processorDestination = new $b(_this118.processorContext), _this118.bindProcessorDestinationEvents(), _this118._source.on($A.UPDATE_SOURCE, function () {
          _this118.processor && _this118.processor.updateInput({
            node: _this118._source.processSourceNode,
            context: _this118.processorContext
          });
        });
      },
          o = s && ST() && !Rb();

      if (DC("DISABLE_WEBAUDIO") ? (_this118._source = new tw(), _this118._useAudioElement = !0, _this118._bypassWebAudio = !0) : o ? _this118._source = new tw() : (_this118._source = new bb(e, !1, _this118._getOriginVolumeLevel ? e : void 0), DC("LOCAL_AUDIO_TRACK_USES_WEB_AUDIO") || (_this118._useAudioElement = !0)), r(), !DC("DISABLE_WEBAUDIO") && o) {
        (nw || (nw = new sw()), nw).enqueue("INIT_WEBAUDIO", function () {
          _this118._source = new bb(e, !1, _this118._getOriginVolumeLevel ? e : void 0), DC("LOCAL_AUDIO_TRACK_USES_WEB_AUDIO") || (_this118._useAudioElement = !0), r(), _this118.emit(eb.UPDATE_TRACK_SOURCE);
        });
      }

      return _this118;
    }

    _createClass(cw, [{
      key: "_source",
      get: function get() {
        return this._trackSource;
      },
      set: function set(e) {
        this._trackSource = e;
      }
    }, {
      key: "processorContext",
      get: function get() {
        return this._processorContext;
      },
      set: function set(e) {
        this._processorContext = e;
      }
    }, {
      key: "processorDestination",
      get: function get() {
        return this._processorDestination;
      },
      set: function set(e) {
        this._processorDestination = e;
      }
    }, {
      key: "isPlaying",
      get: function get() {
        return this._useAudioElement ? qb.isPlaying(this.getTrackId()) : this._source.isPlayed;
      }
    }, {
      key: "__className__",
      get: function get() {
        return "LocalAudioTrack";
      }
    }, {
      key: "setVolume",
      value: function setVolume(e) {
        var _this119 = this;

        jT(e, "volume", 0, 1e3), this._volume = e, this._source.setVolume(e / 100), this._useAudioElement && qb.setVolume(this.getTrackId(), e);

        try {
          if (this._bypassWebAudio) return void YC.debug("[".concat(this.getTrackId(), "] setVolume returned because no pass through WebAudio."));

          var _e72 = this._source.createOutputTrack();

          this._mediaStreamTrack !== _e72 && (this._mediaStreamTrack = _e72, Tg(this, KA.NEED_REPLACE_TRACK, this).then(function () {
            YC.debug("[".concat(_this119.getTrackId(), "] replace web audio track success"));
          }).catch(function (e) {
            YC.warning("[".concat(_this119.getTrackId(), "] replace web audio track failed"), e);
          }));
        } catch (e) {}
      }
    }, {
      key: "getVolumeLevel",
      value: function getVolumeLevel() {
        return this._muted && this.enabled && this._getOriginVolumeLevel ? this._source.getOriginVolumeLevel() : this._source.getAccurateVolumeLevel();
      }
    }, {
      key: "setPlaybackDevice",
      value: function () {
        var _setPlaybackDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(e) {
          return _regeneratorRuntime.wrap(function _callee103$(_context103) {
            while (1) {
              switch (_context103.prev = _context103.next) {
                case 0:
                  if (!(!this._useAudioElement || !gT() && DC("RESTRICTION_SET_PLAYBACK_DEVICE"))) {
                    _context103.next = 2;
                    break;
                  }

                  throw new VT(xT.NOT_SUPPORTED, "your browser does not support setting the audio output device");

                case 2:
                  _context103.next = 4;
                  return qb.setSinkID(this.getTrackId(), e);

                case 4:
                case "end":
                  return _context103.stop();
              }
            }
          }, _callee103, this);
        }));

        function setPlaybackDevice(_x179) {
          return _setPlaybackDevice.apply(this, arguments);
        }

        return setPlaybackDevice;
      }()
    }, {
      key: "setEnabled",
      value: function () {
        var _setEnabled2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(e, t, i) {
          return _regeneratorRuntime.wrap(function _callee104$(_context104) {
            while (1) {
              switch (_context104.prev = _context104.next) {
                case 0:
                  return _context104.abrupt("return", this._setEnabled(e, t, i));

                case 1:
                case "end":
                  return _context104.stop();
              }
            }
          }, _callee104, this);
        }));

        function setEnabled(_x180, _x181, _x182) {
          return _setEnabled2.apply(this, arguments);
        }

        return setEnabled;
      }()
    }, {
      key: "_setEnabled",
      value: function () {
        var _setEnabled3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(e, t, i) {
          return _regeneratorRuntime.wrap(function _callee105$(_context105) {
            while (1) {
              switch (_context105.prev = _context105.next) {
                case 0:
                  if (i) {
                    _context105.next = 4;
                    break;
                  }

                  if (!(e === this._enabled)) {
                    _context105.next = 3;
                    break;
                  }

                  return _context105.abrupt("return");

                case 3:
                  this.stateCheck("enabled", e);

                case 4:
                  if (!(YC.info("[".concat(this.getTrackId(), "] start setEnabled"), e), e)) {
                    _context105.next = 18;
                    break;
                  }

                  this._originMediaStreamTrack.enabled = !0;
                  _context105.prev = 6;
                  i || (this._enabled = !0);
                  _context105.next = 10;
                  return Tg(this, KA.NEED_ENABLE_TRACK, this);

                case 10:
                  YC.info("[".concat(this.getTrackId(), "] setEnabled to ").concat(e, " success"));
                  _context105.next = 16;
                  break;

                case 13:
                  _context105.prev = 13;
                  _context105.t0 = _context105["catch"](6);
                  throw i || (this._enabled = !1), YC.error("[".concat(this.getTrackId(), "] setEnabled to true error"), _context105.t0.toString()), _context105.t0;

                case 16:
                  _context105.next = 27;
                  break;

                case 18:
                  this._originMediaStreamTrack.enabled = !1, i || (this._enabled = !1);
                  _context105.prev = 19;
                  _context105.next = 22;
                  return Tg(this, KA.NEED_DISABLE_TRACK, this);

                case 22:
                  _context105.next = 27;
                  break;

                case 24:
                  _context105.prev = 24;
                  _context105.t1 = _context105["catch"](19);
                  throw i || (this._enabled = !0), YC.error("[".concat(this.getTrackId(), "] setEnabled to false error"), _context105.t1.toString()), _context105.t1;

                case 27:
                case "end":
                  return _context105.stop();
              }
            }
          }, _callee105, this, [[6, 13], [19, 24]]);
        }));

        function _setEnabled(_x183, _x184, _x185) {
          return _setEnabled3.apply(this, arguments);
        }

        return _setEnabled;
      }()
    }, {
      key: "setMuted",
      value: function () {
        var _setMuted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(e) {
          return _regeneratorRuntime.wrap(function _callee106$(_context106) {
            while (1) {
              switch (_context106.prev = _context106.next) {
                case 0:
                  _context106.t0 = e !== this._muted;

                  if (!_context106.t0) {
                    _context106.next = 13;
                    break;
                  }

                  this.stateCheck("muted", e);
                  this._muted = e;
                  this._originMediaStreamTrack.enabled = !e;
                  YC.debug("[".concat(this.getTrackId(), "] start set muted: ").concat(e));

                  if (!e) {
                    _context106.next = 11;
                    break;
                  }

                  _context106.next = 9;
                  return Tg(this, KA.NEED_MUTE_TRACK, this);

                case 9:
                  _context106.next = 13;
                  break;

                case 11:
                  _context106.next = 13;
                  return Tg(this, KA.NEED_UNMUTE_TRACK, this);

                case 13:
                case "end":
                  return _context106.stop();
              }
            }
          }, _callee106, this);
        }));

        function setMuted(_x186) {
          return _setMuted.apply(this, arguments);
        }

        return setMuted;
      }()
    }, {
      key: "getStats",
      value: function getStats() {
        Ng(function () {
          YC.warning("[deprecated] LocalAudioTrack.getStats will be removed in the future, use AgoraRTCClient.getLocalAudioStats instead");
        }, "localAudioTrackGetStatsWarning");
        var e = gg(this, KA.GET_STATS);
        return e || aw({}, tb);
      }
    }, {
      key: "setAudioFrameCallback",
      value: function setAudioFrameCallback(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 4096;
        if (!e) return this._source.removeAllListeners($A.ON_AUDIO_BUFFER), void this._source.stopGetAudioBuffer();
        this._source.startGetAudioBuffer(t), this._source.removeAllListeners($A.ON_AUDIO_BUFFER), this._source.on($A.ON_AUDIO_BUFFER, function (t) {
          return e(t);
        });
      }
    }, {
      key: "play",
      value: function play() {
        YC.debug("[".concat(this.getTrackId(), "] start audio playback")), this._useAudioElement ? (YC.debug("[".concat(this.getTrackId(), "] start audio playback in element")), qb.play(this._mediaStreamTrack, this.getTrackId(), this._volume)) : this._source.play();
      }
    }, {
      key: "stop",
      value: function stop() {
        YC.debug("[".concat(this.getTrackId(), "] stop audio playback")), this._useAudioElement ? qb.stop(this.getTrackId()) : this._source.stop();
      }
    }, {
      key: "close",
      value: function close() {
        _get(_getPrototypeOf(cw.prototype), "close", this).call(this), this.unbindProcessorDestinationEvents(), this.unbindProcessorContextEvents(), this.unpipe(), this.processorDestination._source && this.processorDestination._source.unpipe(), this._source.destroy();
      }
    }, {
      key: "_updatePlayerSource",
      value: function _updatePlayerSource() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        YC.debug("[".concat(this.getTrackId(), "] update player source track")), e && this._source.updateTrack(this._mediaStreamTrack), this._useAudioElement && qb.updateTrack(this.getTrackId(), this._mediaStreamTrack);
      }
    }, {
      key: "_updateOriginMediaStreamTrack",
      value: function () {
        var _updateOriginMediaStreamTrack3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(e, t) {
          return _regeneratorRuntime.wrap(function _callee107$(_context107) {
            while (1) {
              switch (_context107.prev = _context107.next) {
                case 0:
                  _context107.t0 = this._originMediaStreamTrack !== e;

                  if (!_context107.t0) {
                    _context107.next = 16;
                    break;
                  }

                  this._originMediaStreamTrack && (this._originMediaStreamTrack.removeEventListener("ended", this._handleTrackEnded), t && this._originMediaStreamTrack.stop());
                  e.addEventListener("ended", this._handleTrackEnded);
                  this._originMediaStreamTrack = e;
                  this._muted && (this._originMediaStreamTrack.enabled = !1);
                  this.processor && this.processor.updateInput({
                    track: e,
                    context: this.processorContext
                  });

                  if (!(this._mediaStreamTrack !== this._source.outputTrack)) {
                    _context107.next = 14;
                    break;
                  }

                  this._mediaStreamTrack = this._originMediaStreamTrack;

                  this._updatePlayerSource();

                  _context107.next = 12;
                  return Tg(this, KA.NEED_REPLACE_TRACK, this);

                case 12:
                  _context107.next = 15;
                  break;

                case 14:
                  this._source.updateTrack(this._originMediaStreamTrack);

                case 15:
                  this._getOriginVolumeLevel && this._source.updateOriginTrack(e);

                case 16:
                case "end":
                  return _context107.stop();
              }
            }
          }, _callee107, this);
        }));

        function _updateOriginMediaStreamTrack(_x187, _x188) {
          return _updateOriginMediaStreamTrack3.apply(this, arguments);
        }

        return _updateOriginMediaStreamTrack;
      }()
    }, {
      key: "renewMediaStreamTrack",
      value: function renewMediaStreamTrack(e) {
        return tT.resolve(void 0);
      }
    }, {
      key: "pipe",
      value: function pipe(e) {
        if (this._bypassWebAudio) throw new VT(xT.INVALID_OPERATION, "Can not process AudioTrack when bypassWebAudio set to true.");
        if (this.processor === e) return e;
        if (e._source) throw new VT(xT.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({
          track: this._originMediaStreamTrack,
          node: this._source.processSourceNode,
          context: this.processorContext
        }), e;
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        var e;
        if (!this.processor) return;
        var t = this.processor;
        null === (e = this._source.processSourceNode) || void 0 === e || e.disconnect(), this.processor._source = !1, this.processor = void 0, t.reset();
      }
    }, {
      key: "bindProcessorDestinationEvents",
      value: function bindProcessorDestinationEvents() {
        var _this120 = this;

        this.processorDestination.on(ob.ON_TRACK, /*#__PURE__*/function () {
          var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(e) {
            return _regeneratorRuntime.wrap(function _callee108$(_context108) {
              while (1) {
                switch (_context108.prev = _context108.next) {
                  case 0:
                    if (!e) {
                      _context108.next = 10;
                      break;
                    }

                    _context108.t0 = e !== _this120._mediaStreamTrack;

                    if (!_context108.t0) {
                      _context108.next = 8;
                      break;
                    }

                    _this120._mediaStreamTrack = e;

                    _this120._updatePlayerSource(!1);

                    _this120._source.processedNode = _this120._source.createMediaStreamSourceNode(e);
                    _context108.next = 8;
                    return Tg(_this120, KA.NEED_REPLACE_TRACK, _this120);

                  case 8:
                    _context108.next = 16;
                    break;

                  case 10:
                    _context108.t1 = _this120._mediaStreamTrack !== _this120._originMediaStreamTrack;

                    if (!_context108.t1) {
                      _context108.next = 16;
                      break;
                    }

                    _this120._mediaStreamTrack = _this120._originMediaStreamTrack;

                    _this120._updatePlayerSource();

                    _context108.next = 16;
                    return Tg(_this120, KA.NEED_REPLACE_TRACK, _this120);

                  case 16:
                  case "end":
                    return _context108.stop();
                }
              }
            }, _callee108);
          }));

          return function (_x189) {
            return _ref34.apply(this, arguments);
          };
        }()), this.processorDestination.on(ob.ON_NODE, function (e) {
          _this120._source.processedNode = e;
        });
      }
    }, {
      key: "unbindProcessorDestinationEvents",
      value: function unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(ob.ON_TRACK), this.processorDestination.removeAllListeners(ob.ON_NODE);
      }
    }, {
      key: "unbindProcessorContextEvents",
      value: function unbindProcessorContextEvents() {
        this.processorContext.removeAllListeners(ab.REQUEST_UPDATE_CONSTRAINTS), this.processorContext.removeAllListeners(ab.REQUEST_CONSTRAINTS);
      }
    }]);

    return cw;
  }(_b);

  UI([rw("INIT_WEBAUDIO"), xI("design:type", Object), xI("design:paramtypes", [Object])], cw.prototype, "_source", null), UI([rw("INIT_WEBAUDIO"), xI("design:type", ew), xI("design:paramtypes", [ew])], cw.prototype, "processorContext", null), UI([rw("INIT_WEBAUDIO"), xI("design:type", $b), xI("design:paramtypes", [$b])], cw.prototype, "processorDestination", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    },
    throttleTime: 300
  }), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", void 0)], cw.prototype, "setVolume", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], cw.prototype, "setPlaybackDevice", null), UI([qg("LocalAudioTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Object, Boolean]), xI("design:returntype", tT)], cw.prototype, "setEnabled", null), UI([qg("LocalAudioTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean]), xI("design:returntype", tT)], cw.prototype, "setMuted", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", Object)], cw.prototype, "getStats", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", [Object, Number]), xI("design:returntype", void 0)], cw.prototype, "setAudioFrameCallback", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], cw.prototype, "play", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], cw.prototype, "stop", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], cw.prototype, "close", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t.name];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", Object)], cw.prototype, "pipe", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], cw.prototype, "unpipe", null);

  var dw = /*#__PURE__*/function (_cw) {
    _inherits(dw, _cw);

    var _super31 = _createSuper(dw);

    function dw(e, t, i, n) {
      var _this121;

      _classCallCheck(this, dw);

      _this121 = _super31.call(this, e, t.encoderConfig ? GA(t.encoderConfig) : {}, n, DC("GET_VOLUME_OF_MUTED_AUDIO_TRACK"), !0), nh(_assertThisInitialized(_this121), "_config", void 0), nh(_assertThisInitialized(_this121), "_deviceName", "default"), nh(_assertThisInitialized(_this121), "_constraints", void 0), nh(_assertThisInitialized(_this121), "_originalConstraints", void 0), nh(_assertThisInitialized(_this121), "_enabled", !0), _this121._config = t, _this121._constraints = i, _this121._originalConstraints = i, _this121._deviceName = e.label, "boolean" == typeof t.bypassWebAudio && (_this121._bypassWebAudio = t.bypassWebAudio), (wT() || OT()) && Tb.bindInterruptDetectorTrack(_assertThisInitialized(_this121)), _this121.on(eb.UPDATE_TRACK_SOURCE, function () {
        _this121.bindProcessorContextEvents();
      }), Rb() && _this121.bindProcessorContextEvents();
      return _this121;
    }

    _createClass(dw, [{
      key: "__className__",
      get: function get() {
        return "MicrophoneAudioTrack";
      }
    }, {
      key: "setDevice",
      value: function () {
        var _setDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(e) {
          var _t87, i, _n40, _t88;

          return _regeneratorRuntime.wrap(function _callee109$(_context109) {
            while (1) {
              switch (_context109.prev = _context109.next) {
                case 0:
                  if (!(YC.info("[".concat(this.getTrackId(), "] start set device to ").concat(e)), this._enabled)) {
                    _context109.next = 35;
                    break;
                  }

                  _context109.prev = 1;
                  _context109.next = 4;
                  return Fb.getDeviceById(e);

                case 4:
                  _t87 = _context109.sent;
                  i = {};
                  i.audio = aw({}, this._constraints), i.audio.deviceId = {
                    exact: e
                  }, this._originMediaStreamTrack.stop();
                  _n40 = null;
                  _context109.prev = 8;
                  _context109.next = 11;
                  return Mb(i, this.getTrackId());

                case 11:
                  _n40 = _context109.sent;
                  _context109.next = 23;
                  break;

                case 14:
                  _context109.prev = 14;
                  _context109.t0 = _context109["catch"](8);
                  YC.error("[".concat(this.getTrackId(), "] setDevice failed"), _context109.t0.toString());
                  _context109.next = 19;
                  return Mb({
                    audio: this._constraints
                  }, this.getTrackId());

                case 19:
                  _n40 = _context109.sent;
                  _context109.next = 22;
                  return this._updateOriginMediaStreamTrack(_n40.getAudioTracks()[0], !1);

                case 22:
                  throw _context109.t0;

                case 23:
                  _context109.next = 25;
                  return this._updateOriginMediaStreamTrack(_n40.getAudioTracks()[0], !1);

                case 25:
                  this._deviceName = _t87.label;
                  this._config.microphoneId = e;
                  this._constraints.deviceId = {
                    exact: e
                  };
                  _context109.next = 33;
                  break;

                case 30:
                  _context109.prev = 30;
                  _context109.t1 = _context109["catch"](1);
                  throw YC.error("[".concat(this.getTrackId(), "] setDevice error"), _context109.t1.toString()), _context109.t1;

                case 33:
                  _context109.next = 45;
                  break;

                case 35:
                  _context109.prev = 35;
                  _context109.next = 38;
                  return Fb.getDeviceById(e);

                case 38:
                  _t88 = _context109.sent;
                  this._deviceName = _t88.label, this._config.microphoneId = e, this._constraints.deviceId = {
                    exact: e
                  };
                  _context109.next = 45;
                  break;

                case 42:
                  _context109.prev = 42;
                  _context109.t2 = _context109["catch"](35);
                  throw YC.error("[".concat(this.getTrackId(), "] setDevice error"), _context109.t2.toString()), _context109.t2;

                case 45:
                  YC.info("[".concat(this.getTrackId(), "] set device to ").concat(e, " success"));

                case 46:
                case "end":
                  return _context109.stop();
              }
            }
          }, _callee109, this, [[1, 30], [8, 14], [35, 42]]);
        }));

        function setDevice(_x190) {
          return _setDevice.apply(this, arguments);
        }

        return setDevice;
      }()
    }, {
      key: "setEnabled",
      value: function () {
        var _setEnabled4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(e, t, i) {
          var n, s, r, _e73;

          return _regeneratorRuntime.wrap(function _callee110$(_context110) {
            while (1) {
              switch (_context110.prev = _context110.next) {
                case 0:
                  if (!t) {
                    _context110.next = 5;
                    break;
                  }

                  YC.debug("[".concat(this.getTrackId(), "] setEnabled false (do not close microphone)"));
                  _context110.next = 4;
                  return _get(_getPrototypeOf(dw.prototype), "_setEnabled", this).call(this, e);

                case 4:
                  return _context110.abrupt("return", _context110.sent);

                case 5:
                  if (i) {
                    _context110.next = 9;
                    break;
                  }

                  if (!(e === this._enabled)) {
                    _context110.next = 8;
                    break;
                  }

                  return _context110.abrupt("return");

                case 8:
                  this.stateCheck("enabled", e);

                case 9:
                  if (!(YC.info("[".concat(this.getTrackId(), "] start setEnabled"), e), !e)) {
                    _context110.next = 20;
                    break;
                  }

                  this._originMediaStreamTrack.onended = null, this._originMediaStreamTrack.stop(), null === (n = this._source.clonedTrack) || void 0 === n || n.stop(), i || (this._enabled = !1);
                  _context110.prev = 11;
                  _context110.next = 14;
                  return Tg(this, KA.NEED_DISABLE_TRACK, this);

                case 14:
                  _context110.next = 19;
                  break;

                case 16:
                  _context110.prev = 16;
                  _context110.t0 = _context110["catch"](11);
                  throw YC.error("[".concat(this.getTrackId(), "] setEnabled false failed"), _context110.t0.toString()), _context110.t0;

                case 19:
                  return _context110.abrupt("return");

                case 20:
                  s = aw({}, this._constraints), r = Fb.searchDeviceIdByName(this._deviceName);
                  r && !s.deviceId && (s.deviceId = r);
                  _context110.prev = 22;
                  i || (this._enabled = !0);
                  _context110.next = 26;
                  return Mb({
                    audio: this._constraints
                  }, this.getTrackId());

                case 26:
                  _e73 = _context110.sent;
                  _context110.next = 29;
                  return this._updateOriginMediaStreamTrack(_e73.getAudioTracks()[0], !1);

                case 29:
                  _context110.next = 31;
                  return Tg(this, KA.NEED_ENABLE_TRACK, this);

                case 31:
                  _context110.next = 36;
                  break;

                case 33:
                  _context110.prev = 33;
                  _context110.t1 = _context110["catch"](22);
                  throw i || (this._enabled = !1), YC.error("[".concat(this.getTrackId(), "] setEnabled true failed"), _context110.t1.toString()), _context110.t1;

                case 36:
                  YC.info("[".concat(this.getTrackId(), "] setEnabled success"));

                case 37:
                case "end":
                  return _context110.stop();
              }
            }
          }, _callee110, this, [[11, 16], [22, 33]]);
        }));

        function setEnabled(_x191, _x192, _x193) {
          return _setEnabled4.apply(this, arguments);
        }

        return setEnabled;
      }()
    }, {
      key: "close",
      value: function close() {
        _get(_getPrototypeOf(dw.prototype), "close", this).call(this), (wT() || OT()) && Tb.unbindInterruptDetectorTrack(this);
      }
    }, {
      key: "onTrackEnded",
      value: function onTrackEnded() {
        var _this122 = this;

        if ((CT() || DT()) && this._enabled && !this._isClosed && Tb.duringInterruption) {
          var e = /*#__PURE__*/function () {
            var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111() {
              return _regeneratorRuntime.wrap(function _callee111$(_context111) {
                while (1) {
                  switch (_context111.prev = _context111.next) {
                    case 0:
                      Tb.off(OA.IOS_INTERRUPTION_END, e);
                      _context111.t0 = _this122._enabled && !_this122._isClosed;

                      if (!_context111.t0) {
                        _context111.next = 8;
                        break;
                      }

                      YC.debug("[".concat(_this122.getTrackId(), "] try capture microphone media device for interrupted iOS device."));
                      _context111.next = 6;
                      return _this122.setEnabled(!1);

                    case 6:
                      _context111.next = 8;
                      return _this122.setEnabled(!0);

                    case 8:
                    case "end":
                      return _context111.stop();
                  }
                }
              }, _callee111);
            }));

            return function e() {
              return _ref35.apply(this, arguments);
            };
          }();

          Tb.on(OA.IOS_INTERRUPTION_END, e);
        } else YC.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(QA.TRACK_ENDED);
      }
    }, {
      key: "renewMediaStreamTrack",
      value: function () {
        var _renewMediaStreamTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(e) {
          var t, i, _e74;

          return _regeneratorRuntime.wrap(function _callee112$(_context112) {
            while (1) {
              switch (_context112.prev = _context112.next) {
                case 0:
                  t = e || this._constraints, i = Fb.searchDeviceIdByName(this._deviceName);

                  if (!(i && !t.deviceId && (t.deviceId = i), this._constraints = t, this._enabled)) {
                    _context112.next = 8;
                    break;
                  }

                  this._originMediaStreamTrack.stop();

                  _context112.next = 5;
                  return Mb({
                    audio: this._constraints
                  }, this.getTrackId());

                case 5:
                  _e74 = _context112.sent;
                  _context112.next = 8;
                  return this._updateOriginMediaStreamTrack(_e74.getAudioTracks()[0], !0);

                case 8:
                case "end":
                  return _context112.stop();
              }
            }
          }, _callee112, this);
        }));

        function renewMediaStreamTrack(_x194) {
          return _renewMediaStreamTrack.apply(this, arguments);
        }

        return renewMediaStreamTrack;
      }()
    }, {
      key: "bindProcessorContextEvents",
      value: function bindProcessorContextEvents() {
        var _this123 = this;

        this.processorContext.on(ab.REQUEST_UPDATE_CONSTRAINTS, /*#__PURE__*/function () {
          var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(e, t, i) {
            var _i50;

            return _regeneratorRuntime.wrap(function _callee113$(_context113) {
              while (1) {
                switch (_context113.prev = _context113.next) {
                  case 0:
                    _context113.prev = 0;
                    _i50 = Object.assign.apply(Object, [{}, _this123._originalConstraints].concat(_toConsumableArray(e)));
                    _context113.next = 4;
                    return _this123.renewMediaStreamTrack(_i50);

                  case 4:
                    t();
                    _context113.next = 10;
                    break;

                  case 7:
                    _context113.prev = 7;
                    _context113.t0 = _context113["catch"](0);
                    i(_context113.t0);

                  case 10:
                  case "end":
                    return _context113.stop();
                }
              }
            }, _callee113, null, [[0, 7]]);
          }));

          return function (_x195, _x196, _x197) {
            return _ref36.apply(this, arguments);
          };
        }()), this.processorContext.on(ab.REQUEST_CONSTRAINTS, /*#__PURE__*/function () {
          var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(e) {
            return _regeneratorRuntime.wrap(function _callee114$(_context114) {
              while (1) {
                switch (_context114.prev = _context114.next) {
                  case 0:
                    e(_this123._originMediaStreamTrack.getSettings());

                  case 1:
                  case "end":
                    return _context114.stop();
                }
              }
            }, _callee114);
          }));

          return function (_x198) {
            return _ref37.apply(this, arguments);
          };
        }());
      }
    }]);

    return dw;
  }(cw);

  UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], dw.prototype, "setDevice", null), UI([qg("MicrophoneAudioTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t, i) {
      return [e.getTrackId(), t, i];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Boolean, Boolean]), xI("design:returntype", tT)], dw.prototype, "setEnabled", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], dw.prototype, "close", null);

  var lw = /*#__PURE__*/function (_cw2) {
    _inherits(lw, _cw2);

    var _super32 = _createSuper(lw);

    function lw(e, t, i, n) {
      var _this124;

      _classCallCheck(this, lw);

      _this124 = _super32.call(this, t.createOutputTrack(), i, n), nh(_assertThisInitialized(_this124), "source", void 0), nh(_assertThisInitialized(_this124), "_bufferSource", void 0), _this124.source = e, _this124._bufferSource = t, _this124._bufferSource.on($A.AUDIO_SOURCE_STATE_CHANGE, function (e) {
        _this124.safeEmit(QA.SOURCE_STATE_CHANGE, e);
      });

      try {
        _this124._mediaStreamTrack = _this124._source.createOutputTrack();
      } catch (e) {}

      return _this124;
    }

    _createClass(lw, [{
      key: "__className__",
      get: function get() {
        return "BufferSourceAudioTrack";
      }
    }, {
      key: "currentState",
      get: function get() {
        return this._bufferSource.currentState;
      }
    }, {
      key: "duration",
      get: function get() {
        return this._bufferSource.duration;
      }
    }, {
      key: "playbackSpeed",
      get: function get() {
        return this._bufferSource.playbackSpeed;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this._bufferSource.currentTime;
      }
    }, {
      key: "startProcessAudioBuffer",
      value: function startProcessAudioBuffer(e) {
        e && this._bufferSource.updateOptions(e), this._bufferSource.startProcessAudioBuffer();
      }
    }, {
      key: "pauseProcessAudioBuffer",
      value: function pauseProcessAudioBuffer() {
        this._bufferSource.pauseProcessAudioBuffer();
      }
    }, {
      key: "seekAudioBuffer",
      value: function seekAudioBuffer(e) {
        this._bufferSource.seekAudioBuffer(e);
      }
    }, {
      key: "resumeProcessAudioBuffer",
      value: function resumeProcessAudioBuffer() {
        this._bufferSource.resumeProcessAudioBuffer();
      }
    }, {
      key: "stopProcessAudioBuffer",
      value: function stopProcessAudioBuffer() {
        this._bufferSource.stopProcessAudioBuffer();
      }
    }, {
      key: "close",
      value: function close() {
        this.source = null, this._bufferSource.destroy(), _get(_getPrototypeOf(lw.prototype), "close", this).call(this);
      }
    }, {
      key: "setAudioBufferPlaybackSpeed",
      value: function setAudioBufferPlaybackSpeed(e) {
        jT(e, "speed", 0), this._bufferSource.setAudioBufferPlaybackSpeed(e);
      }
    }]);

    return lw;
  }(cw);

  UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t, e.duration];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", void 0)], lw.prototype, "startProcessAudioBuffer", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], lw.prototype, "pauseProcessAudioBuffer", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", void 0)], lw.prototype, "seekAudioBuffer", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], lw.prototype, "resumeProcessAudioBuffer", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], lw.prototype, "stopProcessAudioBuffer", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], lw.prototype, "close", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", void 0)], lw.prototype, "setAudioBufferPlaybackSpeed", null);

  var uw = /*#__PURE__*/function (_cw3) {
    _inherits(uw, _cw3);

    var _super33 = _createSuper(uw);

    function uw() {
      var _this125;

      _classCallCheck(this, uw);

      var e = Sb().createMediaStreamDestination();
      _this125 = _super33.call(this, e.stream.getAudioTracks()[0], void 0, xg(8, "track-mix-")), nh(_assertThisInitialized(_this125), "trackList", void 0), nh(_assertThisInitialized(_this125), "destNode", void 0);

      try {
        _this125._mediaStreamTrack = _this125._source.createOutputTrack();
      } catch (e) {}

      _this125.destNode = e, _this125.trackList = [];
      return _this125;
    }

    _createClass(uw, [{
      key: "__className__",
      get: function get() {
        return "MixingAudioTrack";
      }
    }, {
      key: "isActive",
      get: function get() {
        var _iterator9 = _createForOfIteratorHelper(this.trackList),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var e = _step9.value;
            if (e._enabled && !e._isClosed && !e.muted) return !0;
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        return !1;
      }
    }, {
      key: "hasAudioTrack",
      value: function hasAudioTrack(e) {
        return -1 !== this.trackList.indexOf(e);
      }
    }, {
      key: "addAudioTrack",
      value: function addAudioTrack(e) {
        -1 === this.trackList.indexOf(e) ? (YC.debug("add ".concat(e.getTrackId(), " to mixing track")), e._source.outputNode.connect(this.destNode), this.trackList.push(e), this.updateEncoderConfig()) : YC.debug("track ".concat(e.getTrackId(), " is already added"));
      }
    }, {
      key: "removeAudioTrack",
      value: function removeAudioTrack(e) {
        if (-1 !== this.trackList.indexOf(e)) {
          YC.debug("remove ".concat(e.getTrackId(), " from mixing track"));

          try {
            e._source.outputNode.disconnect(this.destNode);
          } catch (e) {}

          vg(this.trackList, e), this.updateEncoderConfig();
        }
      }
    }, {
      key: "updateEncoderConfig",
      value: function updateEncoderConfig() {
        var e = {};
        this.trackList.forEach(function (t) {
          t._encoderConfig && ((t._encoderConfig.bitrate || 0) > (e.bitrate || 0) && (e.bitrate = t._encoderConfig.bitrate), (t._encoderConfig.sampleRate || 0) > (e.sampleRate || 0) && (e.sampleRate = t._encoderConfig.sampleRate), (t._encoderConfig.sampleSize || 0) > (e.sampleSize || 0) && (e.sampleSize = t._encoderConfig.sampleSize), t._encoderConfig.stereo && (e.stereo = !0));
        }), this._encoderConfig = e;
      }
    }, {
      key: "_updateRtpTransceiver",
      value: function _updateRtpTransceiver(e) {
        this._rtpTransceiver !== e && (this._rtpTransceiver = e, this.trackList.forEach(function (t) {
          t instanceof uw ? t.emit(XA.TRANSCEIVER_UPDATED, e) : t._updateRtpTransceiver(e);
        }));
      }
    }]);

    return uw;
  }(cw);

  function hw(e) {
    var t = {};
    e.facingMode && (t.facingMode = e.facingMode), e.cameraId && (t.deviceId = {
      exact: e.cameraId
    });
    var i = VA(e.encoderConfig);
    return null != i.width && (t.width = i.width), null != i.height && (t.height = i.height), !LT() && i.frameRate && (t.frameRate = i.frameRate), pT().name === cT.EDGE && "object" == _typeof(t.frameRate) && (t.frameRate.max = 60), RT() && (t.frameRate = {
      ideal: 30,
      max: 30
    }), t;
  }

  function pw(e) {
    var t = {};

    if (LT() || (void 0 !== e.AGC && (t.autoGainControl = e.AGC), void 0 !== e.AEC && (t.echoCancellation = e.AEC), void 0 !== e.ANS && (t.noiseSuppression = e.ANS, gT() && e.ANS && (t.googHighpassFilter = e.ANS))), e.encoderConfig) {
      var i = GA(e.encoderConfig);
      t.channelCount = i.stereo ? 2 : 1, t.sampleRate = i.sampleRate, t.sampleSize = i.sampleSize;
    }

    return e.microphoneId && (t.deviceId = {
      exact: e.microphoneId
    }), MT() && (t.sampleRate = void 0), t;
  }

  var _w = /*#__PURE__*/function (_Ab2) {
    _inherits(_w, _Ab2);

    var _super34 = _createSuper(_w);

    function _w(e) {
      var _this126;

      _classCallCheck(this, _w);

      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      _this126 = _super34.call(this), nh(_assertThisInitialized(_this126), "audioBuffer", void 0), nh(_assertThisInitialized(_this126), "sourceNode", void 0), nh(_assertThisInitialized(_this126), "startPlayTime", 0), nh(_assertThisInitialized(_this126), "startPlayOffset", 0), nh(_assertThisInitialized(_this126), "pausePlayTime", 0), nh(_assertThisInitialized(_this126), "options", void 0), nh(_assertThisInitialized(_this126), "currentLoopCount", 0), nh(_assertThisInitialized(_this126), "currentPlaybackSpeed", 100), nh(_assertThisInitialized(_this126), "_currentState", "stopped"), _this126.audioBuffer = e, _this126.options = t, _this126.startPlayOffset = _this126.options.startPlayTime || 0;
      return _this126;
    }

    _createClass(_w, [{
      key: "currentState",
      get: function get() {
        return this._currentState;
      },
      set: function set(e) {
        e !== this._currentState && (this._currentState = e, this.safeEmit($A.AUDIO_SOURCE_STATE_CHANGE, this._currentState));
      }
    }, {
      key: "createWebAudioDiagram",
      value: function createWebAudioDiagram() {
        return this.context.createGain();
      }
    }, {
      key: "duration",
      get: function get() {
        return this.audioBuffer ? this.audioBuffer.duration : 0;
      }
    }, {
      key: "playbackSpeed",
      get: function get() {
        return this.currentPlaybackSpeed;
      }
    }, {
      key: "currentTime",
      get: function get() {
        return this.audioBuffer ? "stopped" === this.currentState ? 0 : "paused" === this.currentState ? this.pausePlayTime : ((this.context.currentTime - this.startPlayTime) * (this.playbackSpeed / 100) + this.startPlayOffset) % this.audioBuffer.duration : 0;
      }
    }, {
      key: "updateOptions",
      value: function updateOptions(e) {
        "stopped" === this.currentState ? (this.options = e, this.startPlayOffset = this.options.startPlayTime || 0) : YC.warning("can not set audio source options");
      }
    }, {
      key: "startProcessAudioBuffer",
      value: function startProcessAudioBuffer() {
        this.sourceNode && this.stopProcessAudioBuffer(), this.sourceNode = this.createSourceNode(), this.startSourceNode(), this.currentState = "playing";
      }
    }, {
      key: "pauseProcessAudioBuffer",
      value: function pauseProcessAudioBuffer() {
        this.sourceNode && "playing" === this.currentState && (this.pausePlayTime = this.currentTime, this.sourceNode.onended = null, this.sourceNode.stop(), this.sourceNode.buffer = null, this.sourceNode = this.createSourceNode(), this.currentState = "paused");
      }
    }, {
      key: "seekAudioBuffer",
      value: function seekAudioBuffer(e) {
        this.sourceNode && (this.sourceNode.onended = null, "playing" === this.currentState && this.sourceNode.stop(), this.sourceNode = this.createSourceNode(), "playing" === this.currentState ? (this.startPlayOffset = e, this.startSourceNode()) : "paused" === this.currentState && (this.pausePlayTime = e));
      }
    }, {
      key: "resumeProcessAudioBuffer",
      value: function resumeProcessAudioBuffer() {
        "paused" === this.currentState && this.sourceNode && (this.startPlayOffset = this.pausePlayTime, this.pausePlayTime = 0, this.startSourceNode(), this.currentState = "playing");
      }
    }, {
      key: "stopProcessAudioBuffer",
      value: function stopProcessAudioBuffer() {
        if (this.sourceNode) {
          this.sourceNode.onended = null;

          try {
            this.sourceNode.stop();
          } catch (e) {}

          this.reset();
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.audioBuffer = null, _get(_getPrototypeOf(_w.prototype), "destroy", this).call(this);
      }
    }, {
      key: "setAudioBufferPlaybackSpeed",
      value: function setAudioBufferPlaybackSpeed(e) {
        this.sourceNode && ("playing" === this.currentState && (this.startPlayOffset = this.currentTime, this.startPlayTime = this.context.currentTime), this.sourceNode.playbackRate.value = e / 100), this.currentPlaybackSpeed = e;
      }
    }, {
      key: "startSourceNode",
      value: function startSourceNode() {
        this.sourceNode && this.sourceNode.buffer && (this.sourceNode.start(0, this.startPlayOffset), this.startPlayTime = this.context.currentTime, this.sourceNode.onended = this.handleSourceNodeEnded.bind(this));
      }
    }, {
      key: "createSourceNode",
      value: function createSourceNode() {
        var e = this.context.createBufferSource();
        return e.buffer = this.audioBuffer, e.loop = !!this.options.loop, e.connect(this.outputNode), e.playbackRate.value = this.currentPlaybackSpeed / 100, e;
      }
    }, {
      key: "handleSourceNodeEnded",
      value: function handleSourceNodeEnded() {
        if (this.currentLoopCount += 1, this.options.cycle && this.options.cycle > this.currentLoopCount) return this.startPlayOffset = 0, this.sourceNode = void 0, void this.startProcessAudioBuffer();
        this.reset();
      }
    }, {
      key: "reset",
      value: function reset() {
        this.startPlayOffset = this.options.startPlayTime || 0, this.currentState = "stopped", this.sourceNode && (this.sourceNode.disconnect(), this.sourceNode = void 0), this.currentLoopCount = 0;
      }
    }]);

    return _w;
  }(Ab);

  var Ew = new Map();

  function mw(_x199, _x200) {
    return _mw.apply(this, arguments);
  }

  function _mw() {
    _mw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee492(e, t) {
      var i, _t349, _t350, n;

      return _regeneratorRuntime.wrap(function _callee492$(_context492) {
        while (1) {
          switch (_context492.prev = _context492.next) {
            case 0:
              i = null;

              if (!("string" == typeof e)) {
                _context492.next = 16;
                break;
              }

              _t349 = Ew.get(e);

              if (!_t349) {
                _context492.next = 5;
                break;
              }

              return _context492.abrupt("return", (YC.debug("use cached audio resource: ", e), _t349));

            case 5:
              _context492.prev = 5;
              _context492.next = 8;
              return Xg(function () {
                return EC.get(e, {
                  responseType: "arraybuffer"
                });
              }, void 0, void 0, {
                maxRetryCount: 3
              });

            case 8:
              i = _context492.sent.data;
              _context492.next = 14;
              break;

            case 11:
              _context492.prev = 11;
              _context492.t0 = _context492["catch"](5);
              throw new VT(xT.FETCH_AUDIO_FILE_FAILED, _context492.t0.toString());

            case 14:
              _context492.next = 20;
              break;

            case 16:
              _t350 = new tT(function (t, i) {
                var n = new FileReader();
                n.onload = function (e) {
                  e.target ? t(e.target.result) : i(new VT(xT.READ_LOCAL_AUDIO_FILE_ERROR));
                }, n.onerror = function () {
                  i(new VT(xT.READ_LOCAL_AUDIO_FILE_ERROR));
                }, n.readAsArrayBuffer(e);
              });
              _context492.next = 19;
              return _t350;

            case 19:
              i = _context492.sent;

            case 20:
              _context492.next = 22;
              return function (e) {
                var t = Sb();
                return new tT(function (i, n) {
                  t.decodeAudioData(e, function (e) {
                    i(e);
                  }, function (e) {
                    n(new VT(xT.DECODE_AUDIO_FILE_FAILED, e.toString()));
                  });
                });
              }(i);

            case 22:
              n = _context492.sent;
              return _context492.abrupt("return", ("string" == typeof e && t && Ew.set(e, n), n));

            case 24:
            case "end":
              return _context492.stop();
          }
        }
      }, _callee492, null, [[5, 11]]);
    }));
    return _mw.apply(this, arguments);
  }

  var fw = function fw(e) {
    var t = document.createElement("canvas");
    return t.width = 2, t.height = 2, new tT(function (i, n) {
      t.toBlob( /*#__PURE__*/function () {
        var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(e) {
          var _n41;

          return _regeneratorRuntime.wrap(function _callee115$(_context115) {
            while (1) {
              switch (_context115.prev = _context115.next) {
                case 0:
                  if (!(t.remove(), e)) {
                    _context115.next = 7;
                    break;
                  }

                  _context115.next = 3;
                  return Tw(e);

                case 3:
                  _n41 = _context115.sent;
                  i({
                    buffer: _n41,
                    width: t.width,
                    height: t.height
                  });
                  _context115.next = 8;
                  break;

                case 7:
                  n(new VT(xT.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED));

                case 8:
                case "end":
                  return _context115.stop();
              }
            }
          }, _callee115);
        }));

        return function (_x201) {
          return _ref38.apply(this, arguments);
        };
      }(), e, 1);
    });
  },
      Tw = /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee116$(_context116) {
        while (1) {
          switch (_context116.prev = _context116.next) {
            case 0:
              _context116.next = 2;
              return e.arrayBuffer();

            case 2:
              t = _context116.sent;
              return _context116.abrupt("return", new Uint8Array(t));

            case 4:
            case "end":
              return _context116.stop();
          }
        }
      }, _callee116);
    }));

    return function Tw(_x202) {
      return _ref39.apply(this, arguments);
    };
  }();

  var gw = new ( /*#__PURE__*/function (_ig22) {
    _inherits(_class10, _ig22);

    var _super35 = _createSuper(_class10);

    function _class10() {
      var _this127;

      _classCallCheck(this, _class10);

      _this127 = _super35.call(this), nh(_assertThisInitialized(_this127), "_lastHiddenTime", 0), nh(_assertThisInitialized(_this127), "_lastVisibleTime", 0), document.addEventListener("visibilitychange", function () {
        "hidden" === document.visibilityState ? _this127._lastHiddenTime = performance.now() : _this127._lastVisibleTime = performance.now(), YC.debug("document visibility went ".concat(document.visibilityState)), _this127.emit("VISIBILITY_CHANGE", document.visibilityState);
      });
      return _this127;
    }

    _createClass(_class10, [{
      key: "visibility",
      get: function get() {
        return document.visibilityState;
      }
    }, {
      key: "lastHiddenTime",
      get: function get() {
        return this._lastHiddenTime;
      }
    }, {
      key: "lastVisibleTime",
      get: function get() {
        return this._lastVisibleTime;
      }
    }]);

    return _class10;
  }(ig))();

  function Sw(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Rw(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sw(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Sw(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var Cw = /*#__PURE__*/function () {
    function Cw(e) {
      var _this128 = this;

      _classCallCheck(this, Cw);

      nh(this, "trackId", void 0), nh(this, "config", void 0), nh(this, "onFirstVideoFrameDecoded", void 0), nh(this, "freezeTimeCounterList", []), nh(this, "renderFreezeAccTime", 0), nh(this, "isKeepLastFrame", !1), nh(this, "timeUpdatedCount", 0), nh(this, "freezeTime", 0), nh(this, "playbackTime", 0), nh(this, "lastTimeUpdatedTime", 0), nh(this, "autoplayFailed", !1), nh(this, "videoTrack", void 0), nh(this, "videoElement", void 0), nh(this, "cacheVideoElement", void 0), nh(this, "videoElementCheckInterval", void 0), nh(this, "_videoElementStatus", lb.NONE), nh(this, "isGettingVideoDimensions", !1), nh(this, "startGetVideoDimensions", function () {
        var e = function e() {
          if (_this128.isGettingVideoDimensions = !0, _this128.videoElement.videoWidth * _this128.videoElement.videoHeight > 4) return YC.debug("[".concat(_this128.trackId, "] current video dimensions:"), _this128.videoElement.videoWidth, _this128.videoElement.videoHeight), void (_this128.isGettingVideoDimensions = !1);
          setTimeout(e, 500);
        };

        !_this128.isGettingVideoDimensions && e();
      }), nh(this, "autoResumeAfterInterruption", function () {
        _this128.videoTrack && "live" === _this128.videoTrack.readyState && "running" === Tb.curState && (YC.debug("[track-".concat(_this128.trackId, "] video element paused, auto resume for ").concat(ET())), NT() ? (_this128.videoElement.srcObject = null, _this128.videoElement.srcObject = new MediaStream([_this128.videoTrack]), _this128.videoElement.play()) : (_this128.videoElement.pause(), _this128.videoElement.play()));
      }), nh(this, "handleVideoEvents", function (e) {
        switch (e.type) {
          case "play":
          case "playing":
            _this128.startGetVideoDimensions(), _this128.videoElementStatus = lb.PLAYING;
            break;

          case "loadeddata":
            if (_this128.onFirstVideoFrameDecoded && _this128.onFirstVideoFrameDecoded(), _this128.cacheVideoElement) {
              try {
                _this128.cacheVideoElement.srcObject = null, _this128.cacheVideoElement.remove();
              } catch (e) {}

              _this128.cacheVideoElement = void 0;
            }

            break;

          case "canplay":
            _this128.videoElementStatus = lb.CANPLAY;
            break;

          case "stalled":
            _this128.videoElementStatus = lb.STALLED;
            break;

          case "suspend":
            _this128.videoElementStatus = lb.SUSPEND;
            break;

          case "pause":
            _this128.videoElementStatus = lb.PAUSED, CT() || DT() || ST() && _this128.autoplayFailed || !_this128.videoTrack || "live" !== _this128.videoTrack.readyState || (YC.debug("[track-".concat(_this128.trackId, "] video element paused, auto resume")), _this128.videoElement.play());
            break;

          case "waiting":
            _this128.videoElementStatus = lb.WAITING;
            break;

          case "abort":
            _this128.videoElementStatus = lb.ABORT;
            break;

          case "ended":
            _this128.videoElementStatus = lb.ENDED;
            break;

          case "emptied":
            _this128.videoElementStatus = lb.EMPTIED;
            break;

          case "error":
            {
              _this128.videoElementStatus = lb.ERROR;
              var _e75 = _this128.videoElement.error;
              _e75 && YC.error("[".concat(_this128.trackId, "] media error, code: ").concat(_e75.code, ", message: ").concat(_e75.message));
              break;
            }

          case "timeupdate":
            {
              var _e76 = performance.now();

              if (_this128.timeUpdatedCount += 1, _this128.timeUpdatedCount < 10) return void (_this128.lastTimeUpdatedTime = _e76);

              var _t89 = _e76 - _this128.lastTimeUpdatedTime,
                  i = _this128.lastTimeUpdatedTime;

              if (_this128.lastTimeUpdatedTime = _e76, gw.lastVisibleTime < gw.lastHiddenTime || i < gw.lastHiddenTime || i < gw.lastVisibleTime) return;

              for (_t89 > DC("VIDEO_FREEZE_DURATION") && (_this128.freezeTime += _t89), _this128.playbackTime += _t89; _this128.playbackTime >= 6e3;) {
                _this128.playbackTime -= 6e3;

                var _e77 = Math.min(6e3, _this128.freezeTime);

                _this128.freezeTimeCounterList.push(_e77), _this128.freezeTime = Math.max(0, _this128.freezeTime - 6e3);
              }

              break;
            }
        }
      }), nh(this, "autoResumeAfterInterruptionOnIOS15_16", function () {
        _this128.videoTrack && "live" === _this128.videoTrack.readyState && (YC.debug("[track-".concat(_this128.trackId, "] video element paused, auto resume for ").concat(ET())), NT() ? (_this128.videoElement.srcObject = null, _this128.videoElement.srcObject = new MediaStream([_this128.videoTrack]), _this128.videoElement.play()) : (_this128.videoElement.pause(), _this128.videoElement.play()));
      }), this.trackId = e.trackId, this.config = e, e.element instanceof HTMLVideoElement ? this.videoElement = e.element : this.videoElement = document.createElement("video"), Tb.on(OA.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), Tb.on(OA.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16);
    }

    _createClass(Cw, [{
      key: "videoElementStatus",
      get: function get() {
        return this._videoElementStatus;
      },
      set: function set(e) {
        e !== this._videoElementStatus && (YC.debug("[".concat(this.trackId, "] video-element-status change ").concat(this._videoElementStatus, " => ").concat(e)), this._videoElementStatus = e);
      }
    }, {
      key: "getVideoElement",
      value: function getVideoElement() {
        return this.videoElement;
      }
    }, {
      key: "getContainerElement",
      value: function getContainerElement() {
        var e;
        return null !== (e = this.videoElement.parentElement) && void 0 !== e ? e : void 0;
      }
    }, {
      key: "updateConfig",
      value: function updateConfig(e) {
        this.config = e, this.trackId = e.trackId, e.element !== this.videoElement && (this.destroy(), this.videoElement = e.element), this.videoTrack && this.initVideoElement();
      }
    }, {
      key: "updateVideoTrack",
      value: function updateVideoTrack(e) {
        this.videoTrack !== e && (this.videoTrack = e, this.initVideoElement());
      }
    }, {
      key: "play",
      value: function play(e) {
        var _this129 = this;

        var t = this.videoElement.play();
        t && t.catch && t.catch(function (t) {
          e && Kb(e, "video", t.message, _this129.trackId), "NotAllowedError" === t.name ? (YC.warning("detected video element autoplay failed", t), _this129.autoplayFailed = !0, _this129.handleAutoPlayFailed()) : YC.warning("[".concat(_this129.trackId, "] play warning: "), t);
        });
        var i = pT();

        if (("Safari" === i.name && 15 === Number(i.version) || wT()) && t && t.then) {
          var _e78 = function _e78() {
            _this129.config.mirror && (_this129.videoElement.style.transform = "rotateY(180deg)");
          };

          t.then(_e78).catch(_e78);
        }
      }
    }, {
      key: "getCurrentFrame",
      value: function getCurrentFrame() {
        var e = document.createElement("canvas");
        e.width = this.videoElement.videoWidth, e.height = this.videoElement.videoHeight;
        var t = e.getContext("2d");
        if (!t) return YC.error("create canvas context failed!"), new ImageData(2, 2);
        t.drawImage(this.videoElement, 0, 0, e.width, e.height);
        var i = t.getImageData(0, 0, e.width, e.height);
        return e.remove(), i;
      }
    }, {
      key: "getCurrentFrameToUint8Array",
      value: function () {
        var _getCurrentFrameToUint8Array = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(e) {
          var t,
              i,
              n,
              _args118 = arguments;
          return _regeneratorRuntime.wrap(function _callee118$(_context118) {
            while (1) {
              switch (_context118.prev = _context118.next) {
                case 0:
                  t = _args118.length > 1 && void 0 !== _args118[1] ? _args118[1] : 1;
                  i = document.createElement("canvas");
                  i.width = this.videoElement.videoWidth, i.height = this.videoElement.videoHeight;
                  n = i.getContext("2d");

                  if (!n) {
                    _context118.next = 8;
                    break;
                  }

                  _context118.t0 = (n.drawImage(this.videoElement, 0, 0, i.width, i.height), new tT(function (n, s) {
                    i.toBlob( /*#__PURE__*/function () {
                      var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(e) {
                        var _t90;

                        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
                          while (1) {
                            switch (_context117.prev = _context117.next) {
                              case 0:
                                if (!(i.remove(), e)) {
                                  _context117.next = 7;
                                  break;
                                }

                                _context117.next = 3;
                                return Tw(e);

                              case 3:
                                _t90 = _context117.sent;
                                n({
                                  buffer: _t90,
                                  width: i.width,
                                  height: i.height
                                });
                                _context117.next = 8;
                                break;

                              case 7:
                                s(new VT(xT.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED));

                              case 8:
                              case "end":
                                return _context117.stop();
                            }
                          }
                        }, _callee117);
                      }));

                      return function (_x204) {
                        return _ref40.apply(this, arguments);
                      };
                    }(), e, t < 0 ? .1 : t > 1 ? 1 : t);
                  }));
                  _context118.next = 11;
                  break;

                case 8:
                  _context118.next = 10;
                  return fw(e);

                case 10:
                  _context118.t0 = _context118.sent;

                case 11:
                  return _context118.abrupt("return", _context118.t0);

                case 12:
                case "end":
                  return _context118.stop();
              }
            }
          }, _callee118, this);
        }));

        function getCurrentFrameToUint8Array(_x203) {
          return _getCurrentFrameToUint8Array.apply(this, arguments);
        }

        return getCurrentFrameToUint8Array;
      }()
    }, {
      key: "destroy",
      value: function destroy() {
        Tb.off(OA.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), Tb.off(OA.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16), this.videoElement.srcObject = null, this.resetVideoElement(), this.freezeTimeCounterList = [];
      }
    }, {
      key: "initVideoElement",
      value: function initVideoElement() {
        var _this130 = this;

        if (this.videoElementStatus = lb.INIT, !this.videoElementCheckInterval && (Iw.forEach(function (e) {
          _this130.videoElement.addEventListener(e, _this130.handleVideoEvents);
        }), this.videoElementCheckInterval = window.setInterval(function () {
          (function (e) {
            return e !== document.body && document.body.contains(e);
          })(_this130.videoElement) || (_this130.videoElementStatus = lb.DESTROYED);
        }, 1e3), DC("ENABLE_VIDEO_FRAME_CALLBACK"))) {
          var e, t;

          var _i51;

          var _n42 = function _n42(e, t) {
            if (_this130.videoElementStatus === lb.PLAYING) {
              if (_i51) {
                var _e79 = t.presentationTime - _i51.presentationTime;

                _e79 > DC("VIDEO_FREEZE_DURATION") && gw.lastVisibleTime >= gw.lastHiddenTime && _i51.timestamp > gw.lastVisibleTime && _i51.timestamp > gw.lastHiddenTime && (_this130.renderFreezeAccTime += _e79);
              }

              _i51 = Rw(Rw({}, t), {}, {
                timestamp: e
              });
            }

            var s, r;
            DC("ENABLE_VIDEO_FRAME_CALLBACK") && (null === (s = (r = _this130.videoElement).requestVideoFrameCallback) || void 0 === s || s.call(r, _n42));
          };

          null === (e = (t = this.videoElement).requestVideoFrameCallback) || void 0 === e || e.call(t, _n42);
        }

        this.videoElement.controls = !1, this.videoElement.setAttribute("playsinline", ""), MT() && (this.videoElement.poster = "noposter");
        var i = pT();

        if ("Safari" === i.name && 15 === Number(i.version) || wT() || !this.config.mirror || (this.videoElement.style.transform = "rotateY(180deg)"), this.config.fit ? this.videoElement.style.objectFit = this.config.fit : this.videoElement.style.objectFit = "cover", this.videoElement.setAttribute("muted", ""), this.videoElement.muted = !0, this.videoElement.srcObject && this.videoElement.srcObject instanceof MediaStream) {
          this.videoElement.srcObject.getVideoTracks()[0] !== this.videoTrack && (this.videoElement.srcObject = this.videoTrack ? new MediaStream([this.videoTrack]) : null, RT() && this.videoElement.load());
        } else this.videoElement.srcObject = this.videoTrack ? new MediaStream([this.videoTrack]) : null, RT() && this.videoElement.load();

        var n = this.videoElement.play();
        void 0 !== n && n.catch(function (e) {
          YC.debug("[".concat(_this130.trackId, "] playback interrupted"), e.toString());
        });
      }
    }, {
      key: "resetVideoElement",
      value: function resetVideoElement() {
        var _this131 = this;

        Iw.forEach(function (e) {
          _this131.videoElement && _this131.videoElement.removeEventListener(e, _this131.handleVideoEvents);
        }), this.videoElementCheckInterval && (window.clearInterval(this.videoElementCheckInterval), this.videoElementCheckInterval = void 0), this.videoElementStatus = lb.NONE;
      }
    }, {
      key: "handleAutoPlayFailed",
      value: function handleAutoPlayFailed() {
        var _this132 = this;

        var e = function e(t) {
          t.preventDefault(), _this132.videoElement.play().then(function () {
            YC.debug("[".concat(_this132.trackId, "] Video element for trackId:").concat(_this132.trackId, " autoplay resumed."));
          }).catch(function (e) {
            YC.error(e);
          }), _this132.autoplayFailed = !1, UT() ? document.body.removeEventListener("click", e, !0) : (document.body.removeEventListener("touchstart", e, !0), document.body.removeEventListener("mousedown", e, !0));
        };

        UT() ? document.body.addEventListener("click", e, !0) : (document.body.addEventListener("touchstart", e, !0), document.body.addEventListener("mousedown", e, !0)), Gb();
      }
    }]);

    return Cw;
  }();

  var Iw = ["play", "playing", "loadeddata", "canplay", "pause", "stalled", "suspend", "waiting", "abort", "emptied", "ended", "timeupdate", "error"];

  var vw = /*#__PURE__*/function (_Cw) {
    _inherits(vw, _Cw);

    var _super36 = _createSuper(vw);

    function vw(e) {
      var _this133;

      _classCallCheck(this, vw);

      _this133 = _super36.call(this, e), nh(_assertThisInitialized(_this133), "container", void 0), nh(_assertThisInitialized(_this133), "slot", void 0), _this133.slot = e.element, _this133.updateConfig(e);
      return _this133;
    }

    _createClass(vw, [{
      key: "updateConfig",
      value: function updateConfig(e) {
        this.config = e, this.trackId = e.trackId;
        var t = e.element;
        t !== this.slot && (this.destroy(), this.slot = t), this.createElements();
      }
    }, {
      key: "updateVideoTrack",
      value: function updateVideoTrack(e) {
        this.videoTrack !== e && (this.videoTrack = e, this.createElements());
      }
    }, {
      key: "play",
      value: function play(e) {
        var t;
        null !== (t = this.container) && void 0 !== t && t.contains(this.videoElement) && _get(_getPrototypeOf(vw.prototype), "play", this).call(this, e);
      }
    }, {
      key: "getCurrentFrame",
      value: function getCurrentFrame() {
        var e;
        return null !== (e = this.container) && void 0 !== e && e.contains(this.videoElement) ? _get(_getPrototypeOf(vw.prototype), "getCurrentFrame", this).call(this) : new ImageData(2, 2);
      }
    }, {
      key: "getCurrentFrameToUint8Array",
      value: function () {
        var _getCurrentFrameToUint8Array2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(e) {
          var t,
              i,
              _args119 = arguments;
          return _regeneratorRuntime.wrap(function _callee119$(_context119) {
            while (1) {
              switch (_context119.prev = _context119.next) {
                case 0:
                  i = _args119.length > 1 && void 0 !== _args119[1] ? _args119[1] : 1;

                  if (!(null !== (t = this.container) && void 0 !== t && t.contains(this.videoElement))) {
                    _context119.next = 7;
                    break;
                  }

                  _context119.next = 4;
                  return _get(_getPrototypeOf(vw.prototype), "getCurrentFrameToUint8Array", this).call(this, e, i);

                case 4:
                  _context119.t0 = _context119.sent;
                  _context119.next = 10;
                  break;

                case 7:
                  _context119.next = 9;
                  return fw(e);

                case 9:
                  _context119.t0 = _context119.sent;

                case 10:
                  return _context119.abrupt("return", _context119.t0);

                case 11:
                case "end":
                  return _context119.stop();
              }
            }
          }, _callee119, this);
        }));

        function getCurrentFrameToUint8Array(_x205) {
          return _getCurrentFrameToUint8Array2.apply(this, arguments);
        }

        return getCurrentFrameToUint8Array;
      }()
    }, {
      key: "destroy",
      value: function destroy() {
        if (_get(_getPrototypeOf(vw.prototype), "destroy", this).call(this), this.videoElement.remove(), this.videoElement = document.createElement("video"), this.container) {
          try {
            this.container.remove(), this.slot.removeChild(this.container);
          } catch (e) {}

          this.container = void 0;
        }
      }
    }, {
      key: "createElements",
      value: function createElements() {
        this.container || (this.container = document.createElement("div")), this.container.id = "agora-video-player-".concat(this.trackId), this.container.style.width = "100%", this.container.style.height = "100%", this.container.style.position = "relative", this.container.style.overflow = "hidden", this.videoTrack ? (this.container.style.backgroundColor = "black", DC("KEEP_LAST_FRAME") && this.isKeepLastFrame && this.videoElement.paused && this.resetVideoElement(), this.mountedVideoElement()) : this.unmountedVideoElement(), this.slot.appendChild(this.container);
      }
    }, {
      key: "mountedVideoElement",
      value: function mountedVideoElement() {
        var e;
        !this.container || null !== (e = this.container) && void 0 !== e && e.contains(this.videoElement) || this.container.appendChild(this.videoElement), _get(_getPrototypeOf(vw.prototype), "initVideoElement", this).call(this), this.videoElement.id = "video_".concat(this.trackId), this.videoElement.className = "agora_video_player", this.videoElement.style.width = "100%", this.videoElement.style.height = "100%", this.videoElement.style.position = "absolute", this.videoElement.style.left = "0", this.videoElement.style.top = "0";
      }
    }, {
      key: "unmountedVideoElement",
      value: function unmountedVideoElement() {
        var e;

        if (null !== (e = this.container) && void 0 !== e && e.contains(this.videoElement)) {
          _get(_getPrototypeOf(vw.prototype), "resetVideoElement", this).call(this);

          try {
            this.container && this.container.removeChild(this.videoElement);
          } catch (e) {}

          this.videoElement = document.createElement("video");
        }
      }
    }, {
      key: "resetVideoElement",
      value: function resetVideoElement() {
        var e;
        null !== (e = this.container) && void 0 !== e && e.contains(this.videoElement) && (_get(_getPrototypeOf(vw.prototype), "resetVideoElement", this).call(this), this.cacheVideoElement = this.videoElement, this.videoElement = document.createElement("video"));
      }
    }, {
      key: "getContainerElement",
      value: function getContainerElement() {
        return this.container;
      }
    }]);

    return vw;
  }(Cw);

  function yw(e) {
    return new tT(function (t, i) {
      var n = !1;
      var s = document.createElement("video");
      s.setAttribute("autoplay", ""), s.setAttribute("muted", ""), s.muted = !0, s.autoplay = !0, s.setAttribute("playsinline", ""), s.setAttribute("style", "position: fixed; top: 0; left: 0; width: 1px; height: 1px"), document.body.appendChild(s);
      var r = CT() ? "canplay" : "playing";
      s.addEventListener(r, function () {
        var e = s.videoWidth,
            i = s.videoHeight;
        !e && RT() || (n = !0, s.srcObject = null, s.remove(), t([e, i]));
      }), s.srcObject = new MediaStream([e]), s.play().catch(Fg), setTimeout(function () {
        n || (s.srcObject = null, s.remove(), t([s.videoWidth, s.videoHeight]));
      }, 4e3);
    });
  }

  var Aw = /*#__PURE__*/function () {
    var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(e, t, i) {
      var n, s, r;
      return _regeneratorRuntime.wrap(function _callee120$(_context120) {
        while (1) {
          switch (_context120.prev = _context120.next) {
            case 0:
              n = function (e) {
                var t = [];

                for (var _i52 = 0; _i52 < e.length; _i52 += 2) {
                  t.push(parseInt(e.slice(_i52, _i52 + 2), 16));
                }

                return Uint8Array.from(t);
              }(function (e) {
                var t = "0123456789abcdef";

                function i(e) {
                  var i,
                      n = "";

                  for (i = 0; i <= 3; i++) {
                    n += t.charAt(e >> 8 * i + 4 & 15) + t.charAt(e >> 8 * i & 15);
                  }

                  return n;
                }

                function n(e, t) {
                  var i = (65535 & e) + (65535 & t);
                  return (e >> 16) + (t >> 16) + (i >> 16) << 16 | 65535 & i;
                }

                function s(e, t, i, s, r, o) {
                  return n(function (e, t) {
                    return e << t | e >>> 32 - t;
                  }(n(n(t, e), n(s, o)), r), i);
                }

                function r(e, t, i, n, r, o, a) {
                  return s(t & i | ~t & n, e, t, r, o, a);
                }

                function o(e, t, i, n, r, o, a) {
                  return s(t & n | i & ~n, e, t, r, o, a);
                }

                function a(e, t, i, n, r, o, a) {
                  return s(t ^ i ^ n, e, t, r, o, a);
                }

                function c(e, t, i, n, r, o, a) {
                  return s(i ^ (t | ~n), e, t, r, o, a);
                }

                var d = function (e) {
                  var t;
                  var i = 1 + (e.length + 8 >> 6),
                      n = new Array(16 * i);

                  for (t = 0; t < 16 * i; t++) {
                    n[t] = 0;
                  }

                  for (t = 0; t < e.length; t++) {
                    n[t >> 2] |= e.charCodeAt(t) << t % 4 * 8;
                  }

                  return n[t >> 2] |= 128 << t % 4 * 8, n[16 * i - 2] = 8 * e.length, n;
                }(e);

                var l,
                    u,
                    h,
                    p,
                    _,
                    E = 1732584193,
                    m = -271733879,
                    f = -1732584194,
                    T = 271733878;

                for (l = 0; l < d.length; l += 16) {
                  u = E, h = m, p = f, _ = T, E = r(E, m, f, T, d[l + 0], 7, -680876936), T = r(T, E, m, f, d[l + 1], 12, -389564586), f = r(f, T, E, m, d[l + 2], 17, 606105819), m = r(m, f, T, E, d[l + 3], 22, -1044525330), E = r(E, m, f, T, d[l + 4], 7, -176418897), T = r(T, E, m, f, d[l + 5], 12, 1200080426), f = r(f, T, E, m, d[l + 6], 17, -1473231341), m = r(m, f, T, E, d[l + 7], 22, -45705983), E = r(E, m, f, T, d[l + 8], 7, 1770035416), T = r(T, E, m, f, d[l + 9], 12, -1958414417), f = r(f, T, E, m, d[l + 10], 17, -42063), m = r(m, f, T, E, d[l + 11], 22, -1990404162), E = r(E, m, f, T, d[l + 12], 7, 1804603682), T = r(T, E, m, f, d[l + 13], 12, -40341101), f = r(f, T, E, m, d[l + 14], 17, -1502002290), m = r(m, f, T, E, d[l + 15], 22, 1236535329), E = o(E, m, f, T, d[l + 1], 5, -165796510), T = o(T, E, m, f, d[l + 6], 9, -1069501632), f = o(f, T, E, m, d[l + 11], 14, 643717713), m = o(m, f, T, E, d[l + 0], 20, -373897302), E = o(E, m, f, T, d[l + 5], 5, -701558691), T = o(T, E, m, f, d[l + 10], 9, 38016083), f = o(f, T, E, m, d[l + 15], 14, -660478335), m = o(m, f, T, E, d[l + 4], 20, -405537848), E = o(E, m, f, T, d[l + 9], 5, 568446438), T = o(T, E, m, f, d[l + 14], 9, -1019803690), f = o(f, T, E, m, d[l + 3], 14, -187363961), m = o(m, f, T, E, d[l + 8], 20, 1163531501), E = o(E, m, f, T, d[l + 13], 5, -1444681467), T = o(T, E, m, f, d[l + 2], 9, -51403784), f = o(f, T, E, m, d[l + 7], 14, 1735328473), m = o(m, f, T, E, d[l + 12], 20, -1926607734), E = a(E, m, f, T, d[l + 5], 4, -378558), T = a(T, E, m, f, d[l + 8], 11, -2022574463), f = a(f, T, E, m, d[l + 11], 16, 1839030562), m = a(m, f, T, E, d[l + 14], 23, -35309556), E = a(E, m, f, T, d[l + 1], 4, -1530992060), T = a(T, E, m, f, d[l + 4], 11, 1272893353), f = a(f, T, E, m, d[l + 7], 16, -155497632), m = a(m, f, T, E, d[l + 10], 23, -1094730640), E = a(E, m, f, T, d[l + 13], 4, 681279174), T = a(T, E, m, f, d[l + 0], 11, -358537222), f = a(f, T, E, m, d[l + 3], 16, -722521979), m = a(m, f, T, E, d[l + 6], 23, 76029189), E = a(E, m, f, T, d[l + 9], 4, -640364487), T = a(T, E, m, f, d[l + 12], 11, -421815835), f = a(f, T, E, m, d[l + 15], 16, 530742520), m = a(m, f, T, E, d[l + 2], 23, -995338651), E = c(E, m, f, T, d[l + 0], 6, -198630844), T = c(T, E, m, f, d[l + 7], 10, 1126891415), f = c(f, T, E, m, d[l + 14], 15, -1416354905), m = c(m, f, T, E, d[l + 5], 21, -57434055), E = c(E, m, f, T, d[l + 12], 6, 1700485571), T = c(T, E, m, f, d[l + 3], 10, -1894986606), f = c(f, T, E, m, d[l + 10], 15, -1051523), m = c(m, f, T, E, d[l + 1], 21, -2054922799), E = c(E, m, f, T, d[l + 8], 6, 1873313359), T = c(T, E, m, f, d[l + 15], 10, -30611744), f = c(f, T, E, m, d[l + 6], 15, -1560198380), m = c(m, f, T, E, d[l + 13], 21, 1309151649), E = c(E, m, f, T, d[l + 4], 6, -145523070), T = c(T, E, m, f, d[l + 11], 10, -1120210379), f = c(f, T, E, m, d[l + 2], 15, 718787259), m = c(m, f, T, E, d[l + 9], 21, -343485551), E = n(E, u), m = n(m, h), f = n(f, p), T = n(T, _);
                }

                return i(E) + i(m) + i(f) + i(T);
              }("" + t + i)).slice(0, 16);

              s = n.slice(0, 12);
              _context120.next = 4;
              return window.crypto.subtle.importKey("raw", n, "AES-GCM", !0, ["encrypt"]);

            case 4:
              r = _context120.sent;
              _context120.t0 = Uint8Array;
              _context120.next = 8;
              return window.crypto.subtle.encrypt({
                name: "AES-GCM",
                iv: s
              }, r, e);

            case 8:
              _context120.t1 = _context120.sent;
              return _context120.abrupt("return", new _context120.t0(_context120.t1));

            case 10:
            case "end":
              return _context120.stop();
          }
        }
      }, _callee120);
    }));

    return function Aw(_x206, _x207, _x208) {
      return _ref41.apply(this, arguments);
    };
  }(),
      bw = /*#__PURE__*/function () {
    var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(e, t, i) {
      return _regeneratorRuntime.wrap(function _callee121$(_context121) {
        while (1) {
          switch (_context121.prev = _context121.next) {
            case 0:
              _context121.next = 2;
              return Aw(e.buffer, t, i);

            case 2:
              return _context121.abrupt("return", _context121.sent);

            case 3:
            case "end":
              return _context121.stop();
          }
        }
      }, _callee121);
    }));

    return function bw(_x209, _x210, _x211) {
      return _ref42.apply(this, arguments);
    };
  }();

  function ww(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Ow(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ww(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ww(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var Nw = /*#__PURE__*/function (_b3) {
    _inherits(Nw, _b3);

    var _super37 = _createSuper(Nw);

    function Nw(e, t, i, n, s, r) {
      var _this134;

      _classCallCheck(this, Nw);

      if (_this134 = _super37.call(this, e, s), nh(_assertThisInitialized(_this134), "trackMediaType", "video"), nh(_assertThisInitialized(_this134), "_player", void 0), nh(_assertThisInitialized(_this134), "isUseScaleResolutionDownBy", !1), nh(_assertThisInitialized(_this134), "_videoVisibleTimer", null), nh(_assertThisInitialized(_this134), "_statsTimer", null), nh(_assertThisInitialized(_this134), "_previousVideoVisibleStatus", void 0), nh(_assertThisInitialized(_this134), "_clearPreviousVideoVisibleStatus", function () {
        return _this134._previousVideoVisibleStatus = void 0;
      }), nh(_assertThisInitialized(_this134), "_encoderConfig", void 0), nh(_assertThisInitialized(_this134), "_scalabilityMode", {
        numSpatialLayers: 1,
        numTemporalLayers: 1
      }), nh(_assertThisInitialized(_this134), "_optimizationMode", void 0), nh(_assertThisInitialized(_this134), "_videoHeight", void 0), nh(_assertThisInitialized(_this134), "_videoWidth", void 0), nh(_assertThisInitialized(_this134), "_forceBitrateLimit", void 0), nh(_assertThisInitialized(_this134), "_enabled", !0), nh(_assertThisInitialized(_this134), "processorDestination", void 0), nh(_assertThisInitialized(_this134), "_processorContext", void 0), ST()) {
        var _e$getSettings = e.getSettings(),
            _t91 = _e$getSettings.width,
            _i53 = _e$getSettings.height;

        _this134._videoWidth = _t91, _this134._videoHeight = _i53;
      } else _this134.updateMediaStreamTrackResolution();

      if (_this134._encoderConfig = t, _this134._scalabilityMode = i, _this134._optimizationMode = n, _this134._hints = r || [], -1 === _this134._hints.indexOf(YA.SCREEN_TRACK)) _this134.updateBitrateFromProfile();else if (function (e, t, i) {
        var n = pT();
        return !(n.name !== e || !n.osVersion) && (i ? Number(n.version) >= t && Number(n.version) <= i : Number(n.version) === t);
      }(cT.CHROME, 115) && -1 !== _T().indexOf("Windows")) {
        var _t92 = function (e, t) {
          if ("VideoFrame" in window && "TransformStream" in window && wA().supportWebRTCInsertableStream) {
            var _i54 = new MediaStreamTrackProcessor(e),
                _n43 = new MediaStreamTrackGenerator({
              kind: "video"
            });

            var _s24,
                _r13,
                _o10 = Date.now();

            var _a5 = function _a5() {
              c && (clearInterval(c), c = void 0), _s24 && (_s24.close(), _s24 = void 0), e.stop(), _r13 = void 0, _n43.removeEventListener("ended", _a5);
            };

            var c = window.setInterval(function () {
              if (_r13 && _s24 && Date.now() - _o10 > (null != t ? t : 1e3)) try {
                "live" === _n43.readyState ? _r13.enqueue(_s24.clone()) : _a5();
              } catch (e) {
                _a5();
              }
            }, null != t ? t : 1e3);

            var _d4 = new TransformStream({
              transform: function transform(e, t) {
                "live" === _n43.readyState ? (_r13 = t, _o10 = Date.now(), void 0 === _s24 ? (_s24 = e, t.enqueue(e.clone())) : (t.enqueue(_s24), _s24 = e)) : e.close();
              }
            });

            return _n43.addEventListener("ended", _a5), _i54.readable.pipeThrough(_d4).pipeTo(_n43.writable), _n43;
          }
        }(e);

        _t92 && (YC.info("local screen video track begin to inject frame"), _this134._mediaStreamTrack = _t92);
      }
      t && -1 !== _this134._hints.indexOf(YA.CUSTOM_TRACK) && _this134.setEncoderConfiguration(t), _this134.processorContext = new Zb(_this134.getTrackId(), "local"), _this134.processorDestination = new Qb(_this134.processorContext), _this134.bindProcessorDestinationEvents();
      return _possibleConstructorReturn(_this134);
    }

    _createClass(Nw, [{
      key: "isPlaying",
      get: function get() {
        return !(!this._player || this._player.videoElementStatus !== lb.PLAYING);
      }
    }, {
      key: "processorContext",
      get: function get() {
        return this._processorContext;
      },
      set: function set(e) {
        this._processorContext = e;
      }
    }, {
      key: "__className__",
      get: function get() {
        return "LocalVideoTrack";
      }
    }, {
      key: "play",
      value: function play(e) {
        var _this135 = this;

        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

        if ("string" == typeof e) {
          var _t93 = document.getElementById(e);

          _t93 ? e = _t93 : (YC.warning("[".concat(this.getTrackId(), '] can not find "#').concat(e, '" element, use document.body')), e = document.body);
        }

        YC.debug("[".concat(this.getTrackId(), "] start video playback in ").concat(e instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement"), JSON.stringify(t));
        var i = Ow(Ow(Ow({}, this._getDefaultPlayerConfig()), t), {}, {
          trackId: this.getTrackId(),
          element: e
        });
        this._player ? this._player.updateConfig(i) : (e instanceof HTMLVideoElement ? this._player = new Cw(i) : this._player = new vw(i), this._player.updateVideoTrack(this._mediaStreamTrack)), this._player.play(), this._videoVisibleTimer && window.clearInterval(this._videoVisibleTimer), this._clearPreviousVideoVisibleStatus(), this._videoVisibleTimer = window.setInterval(function () {
          try {
            var _e80 = _this135.getVideoElementVisibleStatus();

            _this135.safeEmit(QA.VIDEO_ELEMENT_VISIBLE_STATUS, _e80);
          } catch (e) {}
        }, DC("CHECK_VIDEO_VISIBLE_INTERVAL"));
      }
    }, {
      key: "stop",
      value: function stop() {
        this._player && (this._videoVisibleTimer && (window.clearInterval(this._videoVisibleTimer), this._videoVisibleTimer = null), this._statsTimer && (this.isUseScaleResolutionDownBy = !1, window.clearInterval(this._statsTimer), this._statsTimer = null), this._clearPreviousVideoVisibleStatus(), this._player.destroy(), this._player = void 0, YC.debug("[".concat(this.getTrackId(), "] stop video playback")));
      }
    }, {
      key: "setEnabled",
      value: function () {
        var _setEnabled5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(e, t) {
          return _regeneratorRuntime.wrap(function _callee122$(_context122) {
            while (1) {
              switch (_context122.prev = _context122.next) {
                case 0:
                  if (t) {
                    _context122.next = 4;
                    break;
                  }

                  if (!(e === this._enabled)) {
                    _context122.next = 3;
                    break;
                  }

                  return _context122.abrupt("return");

                case 3:
                  this.stateCheck("enabled", e);

                case 4:
                  if (!(YC.info("[".concat(this.getTrackId(), "] start setEnabled"), e), !e)) {
                    _context122.next = 15;
                    break;
                  }

                  this._originMediaStreamTrack.enabled = !1;
                  _context122.prev = 6;
                  _context122.next = 9;
                  return Tg(this, KA.NEED_DISABLE_TRACK, this);

                case 9:
                  _context122.next = 14;
                  break;

                case 11:
                  _context122.prev = 11;
                  _context122.t0 = _context122["catch"](6);
                  throw YC.error("[".concat(this.getTrackId(), "] setEnabled to false error"), _context122.t0.toString()), _context122.t0;

                case 14:
                  return _context122.abrupt("return", (t || (this._enabled = !1), void YC.info("[".concat(this.getTrackId(), "] setEnabled to false success"))));

                case 15:
                  this._originMediaStreamTrack.enabled = !0;
                  _context122.prev = 16;
                  _context122.next = 19;
                  return Tg(this, KA.NEED_ENABLE_TRACK, this);

                case 19:
                  _context122.next = 24;
                  break;

                case 21:
                  _context122.prev = 21;
                  _context122.t1 = _context122["catch"](16);
                  throw YC.error("[".concat(this.getTrackId(), "] setEnabled to true error"), _context122.t1.toString()), _context122.t1;

                case 24:
                  YC.info("[".concat(this.getTrackId(), "] setEnabled to true success")), t || (this._enabled = !0);

                case 25:
                case "end":
                  return _context122.stop();
              }
            }
          }, _callee122, this, [[6, 11], [16, 21]]);
        }));

        function setEnabled(_x212, _x213) {
          return _setEnabled5.apply(this, arguments);
        }

        return setEnabled;
      }()
    }, {
      key: "setMuted",
      value: function () {
        var _setMuted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(e) {
          return _regeneratorRuntime.wrap(function _callee123$(_context123) {
            while (1) {
              switch (_context123.prev = _context123.next) {
                case 0:
                  _context123.t0 = e !== this._muted;

                  if (!_context123.t0) {
                    _context123.next = 13;
                    break;
                  }

                  this.stateCheck("muted", e);
                  this._muted = e;
                  this._originMediaStreamTrack.enabled = !e;
                  YC.debug("[".concat(this.getTrackId(), "] start set muted: ").concat(e));

                  if (!e) {
                    _context123.next = 11;
                    break;
                  }

                  _context123.next = 9;
                  return Tg(this, KA.NEED_MUTE_TRACK, this);

                case 9:
                  _context123.next = 13;
                  break;

                case 11:
                  _context123.next = 13;
                  return Tg(this, KA.NEED_UNMUTE_TRACK, this);

                case 13:
                case "end":
                  return _context123.stop();
              }
            }
          }, _callee123, this);
        }));

        function setMuted(_x214) {
          return _setMuted2.apply(this, arguments);
        }

        return setMuted;
      }()
    }, {
      key: "setEncoderConfiguration",
      value: function () {
        var _setEncoderConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(e, t) {
          var _t94, _t95;

          return _regeneratorRuntime.wrap(function _callee124$(_context124) {
            while (1) {
              switch (_context124.prev = _context124.next) {
                case 0:
                  if (this._enabled) {
                    _context124.next = 2;
                    break;
                  }

                  throw new VT(xT.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");

                case 2:
                  if (!("720p_auto" === e ? this.startMonitorStats() : this._statsTimer && (window.clearInterval(this._statsTimer), this._statsTimer = null), e = VA(e), this._forceBitrateLimit && (e.bitrateMax = this._forceBitrateLimit.max_bitrate ? this._forceBitrateLimit.max_bitrate : e.bitrateMax, e.bitrateMin = this._forceBitrateLimit.min_bitrate ? this._forceBitrateLimit.min_bitrate : e.bitrateMin), e.width || e.height || e.frameRate)) {
                    _context124.next = 15;
                    break;
                  }

                  _t94 = hw({
                    encoderConfig: e
                  });
                  (ST() || CT() || DT()) && (_t94.deviceId = void 0), YC.debug("[".concat(this.getTrackId(), "] setEncoderConfiguration applyConstraints"), JSON.stringify(e), JSON.stringify(_t94));
                  _context124.prev = 5;
                  _context124.next = 8;
                  return this._originMediaStreamTrack.applyConstraints(_t94);

                case 8:
                  this.updateMediaStreamTrackResolution();
                  _context124.next = 15;
                  break;

                case 11:
                  _context124.prev = 11;
                  _context124.t0 = _context124["catch"](5);
                  _t95 = new VT(xT.UNEXPECTED_ERROR, _context124.t0.toString());
                  throw YC.error("[".concat(this.getTrackId(), "] applyConstraints error"), _t95.toString()), _t95;

                case 15:
                  this._encoderConfig = e, -1 === this._hints.indexOf(YA.SCREEN_TRACK) && this.updateBitrateFromProfile();
                  _context124.prev = 16;
                  _context124.next = 19;
                  return Tg(this, KA.NEED_UPDATE_VIDEO_ENCODER, this);

                case 19:
                  _context124.next = 24;
                  break;

                case 21:
                  _context124.prev = 21;
                  _context124.t1 = _context124["catch"](16);
                  return _context124.abrupt("return", _context124.t1.throw(YC));

                case 24:
                case "end":
                  return _context124.stop();
              }
            }
          }, _callee124, this, [[5, 11], [16, 21]]);
        }));

        function setEncoderConfiguration(_x215, _x216) {
          return _setEncoderConfiguration.apply(this, arguments);
        }

        return setEncoderConfiguration;
      }()
    }, {
      key: "getStats",
      value: function getStats() {
        Ng(function () {
          YC.warning("[deprecated] LocalVideoTrack.getStats will be removed in the future, use AgoraRTCClient.getLocalVideoStats instead");
        }, "localVideoTrackGetStatsWarning");
        var e = gg(this, KA.GET_STATS);
        return e || Ow({}, ib);
      }
    }, {
      key: "setBeautyEffect",
      value: function () {
        var _setBeautyEffect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(e) {
          return _regeneratorRuntime.wrap(function _callee125$(_context125) {
            while (1) {
              switch (_context125.prev = _context125.next) {
                case 0:
                  YC.error("LocalVideoTrack.setBeautyEffect was deprecated, please migrate to agora-extension-beauty-effect");

                case 1:
                case "end":
                  return _context125.stop();
              }
            }
          }, _callee125);
        }));

        function setBeautyEffect(_x217) {
          return _setBeautyEffect.apply(this, arguments);
        }

        return setBeautyEffect;
      }()
    }, {
      key: "getCurrentFrameData",
      value: function getCurrentFrameData() {
        return this._player ? this._player.getCurrentFrame() : new ImageData(2, 2);
      }
    }, {
      key: "getCurrentFrameImage",
      value: function () {
        var _getCurrentFrameImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(e) {
          var t,
              _args126 = arguments;
          return _regeneratorRuntime.wrap(function _callee126$(_context126) {
            while (1) {
              switch (_context126.prev = _context126.next) {
                case 0:
                  t = _args126.length > 1 && void 0 !== _args126[1] ? _args126[1] : 1;

                  if (!this._player) {
                    _context126.next = 5;
                    break;
                  }

                  _context126.t0 = this._player.getCurrentFrameToUint8Array(e, t);
                  _context126.next = 8;
                  break;

                case 5:
                  _context126.next = 7;
                  return fw(e);

                case 7:
                  _context126.t0 = _context126.sent;

                case 8:
                  return _context126.abrupt("return", _context126.t0);

                case 9:
                case "end":
                  return _context126.stop();
              }
            }
          }, _callee126, this);
        }));

        function getCurrentFrameImage(_x218) {
          return _getCurrentFrameImage.apply(this, arguments);
        }

        return getCurrentFrameImage;
      }()
    }, {
      key: "setBitrateLimit",
      value: function () {
        var _setBitrateLimit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(e) {
          return _regeneratorRuntime.wrap(function _callee127$(_context127) {
            while (1) {
              switch (_context127.prev = _context127.next) {
                case 0:
                  if (!(YC.debug("[".concat(this.getTrackId(), "] set bitrate limit, ").concat(JSON.stringify(e))), e)) {
                    _context127.next = 10;
                    break;
                  }

                  this._forceBitrateLimit = e, this._encoderConfig && (this._encoderConfig.bitrateMax ? this._encoderConfig.bitrateMax = this._encoderConfig.bitrateMax < e.max_bitrate ? this._encoderConfig.bitrateMax : e.max_bitrate : this._encoderConfig.bitrateMax = e.max_bitrate, this._encoderConfig.bitrateMin, this._encoderConfig.bitrateMin = e.min_bitrate);
                  _context127.prev = 2;
                  _context127.next = 5;
                  return Tg(this, KA.NEED_UPDATE_VIDEO_ENCODER, this);

                case 5:
                  _context127.next = 10;
                  break;

                case 7:
                  _context127.prev = 7;
                  _context127.t0 = _context127["catch"](2);
                  return _context127.abrupt("return", _context127.t0.throw(YC));

                case 10:
                case "end":
                  return _context127.stop();
              }
            }
          }, _callee127, this, [[2, 7]]);
        }));

        function setBitrateLimit(_x219) {
          return _setBitrateLimit.apply(this, arguments);
        }

        return setBitrateLimit;
      }()
    }, {
      key: "setOptimizationMode",
      value: function () {
        var _setOptimizationMode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee128$(_context128) {
            while (1) {
              switch (_context128.prev = _context128.next) {
                case 0:
                  if (!("motion" !== e && "detail" !== e && "balanced" !== e)) {
                    _context128.next = 2;
                    break;
                  }

                  return _context128.abrupt("return", void YC.error(xT.INVALID_PARAMS, "optimization mode must be motion, detail or balanced"));

                case 2:
                  t = this._optimizationMode;
                  _context128.prev = 3;
                  this._optimizationMode = e;
                  _context128.next = 7;
                  return Tg(this, KA.SET_OPTIMIZATION_MODE, this);

                case 7:
                  _context128.next = 12;
                  break;

                case 9:
                  _context128.prev = 9;
                  _context128.t0 = _context128["catch"](3);
                  throw this._optimizationMode = t, YC.error("[".concat(this.getTrackId(), "] set optimization mode failed"), _context128.t0.toString()), _context128.t0;

                case 12:
                  YC.info("[".concat(this.getTrackId(), "] set optimization mode success (").concat(e, ")"));

                case 13:
                case "end":
                  return _context128.stop();
              }
            }
          }, _callee128, this, [[3, 9]]);
        }));

        function setOptimizationMode(_x220) {
          return _setOptimizationMode.apply(this, arguments);
        }

        return setOptimizationMode;
      }()
    }, {
      key: "setScalabiltyMode",
      value: function setScalabiltyMode(e) {
        if (1 === e.numSpatialLayers && 1 !== e.numTemporalLayers) return YC.error(xT.INVALID_PARAMS, "scalability mode currently not supported, no SVC."), void (this._scalabilityMode = {
          numSpatialLayers: 1,
          numTemporalLayers: 1
        });
        this._scalabilityMode = e, YC.info("[".concat(this.getTrackId(), "] set scalability mode success (").concat(e, ")"));
      }
    }, {
      key: "updateMediaStreamTrackResolution",
      value: function updateMediaStreamTrackResolution() {
        var _this136 = this;

        yw(this._originMediaStreamTrack).then(function (e) {
          var _e81 = _slicedToArray(e, 2),
              t = _e81[0],
              i = _e81[1];

          _this136._videoHeight = i, _this136._videoWidth = t;
        }).catch(Fg);
      }
    }, {
      key: "_updatePlayerSource",
      value: function _updatePlayerSource() {
        this._player && this._player.updateVideoTrack(this._mediaStreamTrack);
      }
    }, {
      key: "_getDefaultPlayerConfig",
      value: function _getDefaultPlayerConfig() {
        return {
          fit: "contain"
        };
      }
    }, {
      key: "setSenderConfiguration",
      value: function () {
        var _setSenderConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(e) {
          return _regeneratorRuntime.wrap(function _callee129$(_context129) {
            while (1) {
              switch (_context129.prev = _context129.next) {
                case 0:
                  if (this._enabled) {
                    _context129.next = 2;
                    break;
                  }

                  throw new VT(xT.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");

                case 2:
                  YC.debug("[".concat(this.getTrackId(), "] setSenderConfiguration applyConstraints"), JSON.stringify(e)), e = VA(e), this._forceBitrateLimit && (e.bitrateMax = this._forceBitrateLimit.max_bitrate ? this._forceBitrateLimit.max_bitrate : e.bitrateMax, e.bitrateMin = this._forceBitrateLimit.min_bitrate ? this._forceBitrateLimit.min_bitrate : e.bitrateMin), this._encoderConfig = e, -1 === this._hints.indexOf(YA.SCREEN_TRACK) && this.updateBitrateFromProfile();
                  _context129.prev = 3;
                  _context129.next = 6;
                  return Tg(this, KA.NEED_UPDATE_VIDEO_ENCODER, this);

                case 6:
                  _context129.next = 11;
                  break;

                case 8:
                  _context129.prev = 8;
                  _context129.t0 = _context129["catch"](3);
                  return _context129.abrupt("return", _context129.t0.throw(YC));

                case 11:
                case "end":
                  return _context129.stop();
              }
            }
          }, _callee129, this, [[3, 8]]);
        }));

        function setSenderConfiguration(_x221) {
          return _setSenderConfiguration.apply(this, arguments);
        }

        return setSenderConfiguration;
      }()
    }, {
      key: "updateBitrateFromProfile",
      value: function updateBitrateFromProfile() {
        if (!this._encoderConfig) return;

        var _this$getMediaStreamT = this.getMediaStreamTrackSettings(),
            e = _this$getMediaStreamT.width,
            t = _this$getMediaStreamT.height,
            i = _this$getMediaStreamT.frameRate;

        if (!e || !t || !i) return;

        var _ref43 = function (e, t, i, n) {
          var s;
          var r = 200 * Math.pow(i / 15, .6) * Math.pow(e * t / 640 / 360, .75),
              o = r;
          if ("STANDARD_BITRATE" === n) s = 4 * r;else {
            if ("COMPATIABLE_BITRATE" !== n) return;
            s = 2 * r;
          }
          return [Math.floor(s), Math.floor(o)];
        }(e, t, i, DC("BITRATE_ADAPTER_TYPE")) || [void 0, void 0],
            _ref44 = _slicedToArray(_ref43, 2),
            n = _ref44[0],
            s = _ref44[1];

        this._encoderConfig.bitrateMin || this._encoderConfig.bitrateMax || (this._encoderConfig.bitrateMin = s, this._encoderConfig.bitrateMax = n, YC.debug("[".concat(this.getTrackId(), "] update bitrate from profile, [w: ").concat(e, ", h: ").concat(t, ", fps: ").concat(i, "] => [brMax: ").concat(n, ", brMin: ").concat(s, "]")));
      }
    }, {
      key: "getVideoElementVisibleStatus",
      value: function getVideoElementVisibleStatus() {
        try {
          var e, t;
          var i = null == this || null === (e = this._player) || void 0 === e ? void 0 : e.getContainerElement(),
              _n44 = {
            track: this,
            element: null == this || null === (t = this._player) || void 0 === t ? void 0 : t.getVideoElement(),
            slot: null == i ? void 0 : i.parentElement
          },
              _s25 = _n44.element,
              _r14 = _n44.slot;

          if (this.isPlaying && _s25 instanceof HTMLVideoElement && _r14 instanceof HTMLElement) {
            var _e82 = QT.checkOneElementVisible(_s25),
                _t96 = Object.assign({}, _e82);

            if (_t96.visible !== this._previousVideoVisibleStatus) {
              this._previousVideoVisibleStatus = _t96.visible;

              var _e83 = rI.reportApiInvoke(null, {
                tag: og.TRACER,
                name: rg.LOCAL_VIDEO_TRACK_GET_VIDEO_VISIBLE,
                options: [this.getTrackId()]
              });

              _t96.visible ? _e83.onSuccess("Video is visible") : _e83.onSuccess("Invisible because of ".concat(_t96.reason));
            }

            return _t96;
          }

          return;
        } catch (e) {
          throw new VT(xT.GET_VIDEO_ELEMENT_VISIBLE_ERROR, e.message);
        }
      }
    }, {
      key: "renewMediaStreamTrack",
      value: function () {
        var _renewMediaStreamTrack2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130(e) {
          return _regeneratorRuntime.wrap(function _callee130$(_context130) {
            while (1) {
              switch (_context130.prev = _context130.next) {
                case 0:
                case "end":
                  return _context130.stop();
              }
            }
          }, _callee130);
        }));

        function renewMediaStreamTrack(_x222) {
          return _renewMediaStreamTrack2.apply(this, arguments);
        }

        return renewMediaStreamTrack;
      }()
    }, {
      key: "pipe",
      value: function pipe(e) {
        if (this.processor === e) return e;
        if (e._source) throw new VT(xT.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({
          track: this._originMediaStreamTrack,
          context: this.processorContext
        }), e;
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        if (!this.processor) return;
        var e = this.processor;
        this.processor._source = void 0, this.processor = void 0, e.reset();
      }
    }, {
      key: "close",
      value: function close() {
        _get(_getPrototypeOf(Nw.prototype), "close", this).call(this), this.unbindProcessorDestinationEvents(), this.unbindProcessorContextEvents(), this.unpipe(), this.processorDestination._source && this.processorDestination._source.unpipe();
      }
    }, {
      key: "clone",
      value: function clone(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = this._encoderConfig;
        e && (i = Ow(Ow({}, i), VA(e))), i = wg(i);
        var n = xg(8, "track-video-cloned-"),
            s = new Nw(t ? this._mediaStreamTrack.clone() : this._mediaStreamTrack, i, wg(this._scalabilityMode), this._optimizationMode, n, wg(this._hints));
        return e && i && s.setEncoderConfiguration(i), YC.debug("clone video track from ".concat(this.getTrackId(), " to ").concat(n, ", clone ").concat(t)), s;
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131(e, t) {
          return _regeneratorRuntime.wrap(function _callee131$(_context131) {
            while (1) {
              switch (_context131.prev = _context131.next) {
                case 0:
                  if (e instanceof MediaStreamTrack) {
                    _context131.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_PARAMS, "track should be an instance of MediaStreamTrack");

                case 2:
                  if (!("video" !== e.kind)) {
                    _context131.next = 4;
                    break;
                  }

                  throw new VT(xT.INVALID_PARAMS, "track should be a video MediaStreamTrack");

                case 4:
                  _context131.next = 6;
                  return this._updateOriginMediaStreamTrack(e, t, !0);

                case 6:
                  this.updateMediaStreamTrackResolution();

                case 7:
                case "end":
                  return _context131.stop();
              }
            }
          }, _callee131, this);
        }));

        function replaceTrack(_x223, _x224) {
          return _replaceTrack.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "startMonitorStats",
      value: function startMonitorStats() {
        var _this137 = this;

        if (!ST() && !CT()) return;
        this._statsTimer && window.clearInterval(this._statsTimer);
        var e = 2,
            t = MA[e];
        var i = -1;
        var n = Date.now();

        var s = function s(e) {
          e > 2 || e < 0 || (n = Date.now(), t = MA[e], _this137.setSenderConfiguration(t));
        };

        this.isUseScaleResolutionDownBy = !0, this._statsTimer = window.setInterval(function () {
          var r = _this137.getStats(),
              o = gg(_this137, KA.GET_RTC_STATS);

          if (r.sendPackets > 0 && o) {
            -1 === i && (i = Date.now());

            var _a6 = Date.now();

            if (_a6 - i < 1e3 || _a6 - n < DC("PROFILE_SWITCH_INTERVAL")) return;

            var c = r.sendFrameRate,
                _d5 = .6 * t.frameRate,
                _l3 = .9 * t.frameRate;

            "number" == typeof c && c > 0 && c < _d5 ? e > 0 && (e--, s(e), YC.debug("[".concat(_this137.getTrackId(), "] step down for fps ").concat(c, ", switchProfile to ").concat(e))) : o.OutgoingAvailableBandwidth < t.bitrateMin ? e > 0 && (e--, s(e), YC.debug("[".concat(_this137.getTrackId(), "] step down for OutgoingAvailableBandwidth ").concat(o.OutgoingAvailableBandwidth, ", bitrateMin ").concat(t.bitrateMin, ", switchProfile to ").concat(e))) : "number" == typeof c && c > _l3 && e < MA.length - 1 && o.OutgoingAvailableBandwidth > 1.2 * MA[e + 1].bitrateMin && (e++, s(e), YC.debug("[".concat(_this137.getTrackId(), "] step up for fps ").concat(c, ", OutgoingAvailableBandwidth ").concat(o.OutgoingAvailableBandwidth, ", switchProfile to ").concat(e)));
          }
        }, DC("CHECK_LOCAL_STATS_INTERVAL"));
      }
    }, {
      key: "bindProcessorDestinationEvents",
      value: function bindProcessorDestinationEvents() {
        var _this138 = this;

        this.processorDestination.on(ob.ON_TRACK, /*#__PURE__*/function () {
          var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132(e) {
            return _regeneratorRuntime.wrap(function _callee132$(_context132) {
              while (1) {
                switch (_context132.prev = _context132.next) {
                  case 0:
                    if (!e) {
                      _context132.next = 9;
                      break;
                    }

                    _context132.t0 = e !== _this138._mediaStreamTrack;

                    if (!_context132.t0) {
                      _context132.next = 7;
                      break;
                    }

                    _this138._mediaStreamTrack = e;

                    _this138._updatePlayerSource();

                    _context132.next = 7;
                    return Tg(_this138, KA.NEED_REPLACE_TRACK, _this138);

                  case 7:
                    _context132.next = 15;
                    break;

                  case 9:
                    _context132.t1 = _this138._mediaStreamTrack !== _this138._originMediaStreamTrack;

                    if (!_context132.t1) {
                      _context132.next = 15;
                      break;
                    }

                    _this138._mediaStreamTrack = _this138._originMediaStreamTrack;

                    _this138._updatePlayerSource();

                    _context132.next = 15;
                    return Tg(_this138, KA.NEED_REPLACE_TRACK, _this138);

                  case 15:
                  case "end":
                    return _context132.stop();
                }
              }
            }, _callee132);
          }));

          return function (_x225) {
            return _ref45.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "unbindProcessorDestinationEvents",
      value: function unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(ob.ON_TRACK);
      }
    }, {
      key: "unbindProcessorContextEvents",
      value: function unbindProcessorContextEvents() {
        this.processorContext.removeAllListeners(ab.REQUEST_UPDATE_CONSTRAINTS), this.processorContext.removeAllListeners(ab.REQUEST_CONSTRAINTS);
      }
    }]);

    return Nw;
  }(_b);

  UI([sI({
    argsMap: function argsMap(e, t, i) {
      return [e.getTrackId(), "string" == typeof t ? t : t instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement", i];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Object, Object]), xI("design:returntype", void 0)], Nw.prototype, "play", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Nw.prototype, "stop", null), UI([qg("LocalVideoTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Boolean]), xI("design:returntype", tT)], Nw.prototype, "setEnabled", null), UI([qg("LocalVideoTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean]), xI("design:returntype", tT)], Nw.prototype, "setMuted", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Object, Boolean]), xI("design:returntype", tT)], Nw.prototype, "setEncoderConfiguration", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", Object)], Nw.prototype, "getStats", null), UI([sI({
    argsMap: function argsMap(e, t, i) {
      return [e.getTrackId(), t, i];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Object]), xI("design:returntype", tT)], Nw.prototype, "setBeautyEffect", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", ImageData)], Nw.prototype, "getCurrentFrameData", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", [String, Number]), xI("design:returntype", tT)], Nw.prototype, "getCurrentFrameImage", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], Nw.prototype, "setBitrateLimit", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Nw.prototype, "setOptimizationMode", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", void 0)], Nw.prototype, "setScalabiltyMode", null), UI([Jb(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Nw.prototype, "updateMediaStreamTrackResolution", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t.name];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", Object)], Nw.prototype, "pipe", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Nw.prototype, "unpipe", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Nw.prototype, "close", null), UI([sI({
    argsMap: function argsMap(e, t, i) {
      return [e.getTrackId(), t.label, i];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [MediaStreamTrack, Boolean]), xI("design:returntype", tT)], Nw.prototype, "replaceTrack", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Nw.prototype, "startMonitorStats", null);

  var Dw = /*#__PURE__*/function (_Nw) {
    _inherits(Dw, _Nw);

    var _super38 = _createSuper(Dw);

    function Dw(e, t, i, n, s, r) {
      var _this139;

      _classCallCheck(this, Dw);

      _this139 = _super38.call(this, e, VA(t.encoderConfig), n, s, r), nh(_assertThisInitialized(_this139), "_config", void 0), nh(_assertThisInitialized(_this139), "_originalConstraints", void 0), nh(_assertThisInitialized(_this139), "_constraints", void 0), nh(_assertThisInitialized(_this139), "_enabled", !0), nh(_assertThisInitialized(_this139), "_deviceName", "default"), nh(_assertThisInitialized(_this139), "tryResumeVideoForIOS15_16WeChat", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133() {
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                _context133.t0 = (wT() || OT()) && !function () {
                  var e = pT();
                  if (e.os !== aT.IOS || !e.osVersion) return !1;
                  var t = e.osVersion.split(".");
                  return 15 === Number(t[0]) && Number(t[1]) >= 2;
                }() && PT() && _this139._enabled && !_this139._isClosed;

                if (!_context133.t0) {
                  _context133.next = 5;
                  break;
                }

                YC.debug("[".concat(_this139.getTrackId(), "] try capture camera media device for interrupted iOS 15 device on WeChat."));
                _context133.next = 5;
                return _this139.renewMediaStreamTrack();

              case 5:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133);
      }))), _this139._config = t, _this139._originalConstraints = i, _this139._constraints = i, _this139._deviceName = e.label, _this139._encoderConfig = VA(_this139._config.encoderConfig), Tb.on(OA.IOS_15_16_INTERRUPTION_END, _this139.tryResumeVideoForIOS15_16WeChat), Tb.on(OA.IOS_INTERRUPTION_END, _this139.tryResumeVideoForIOS15_16WeChat), _this139.bindProcessorContextEvents();
      return _this139;
    }

    _createClass(Dw, [{
      key: "__className__",
      get: function get() {
        return "CameraVideoTrack";
      }
    }, {
      key: "setDevice",
      value: function () {
        var _setDevice2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee134(e) {
          return _regeneratorRuntime.wrap(function _callee134$(_context134) {
            while (1) {
              switch (_context134.prev = _context134.next) {
                case 0:
                  return _context134.abrupt("return", "string" == typeof e ? this._setDeviceById(e) : e.deviceId ? this._setDeviceById(e.deviceId) : e.facingMode ? this._setDeviceByFacingModel(e.facingMode) : void 0);

                case 1:
                case "end":
                  return _context134.stop();
              }
            }
          }, _callee134, this);
        }));

        function setDevice(_x226) {
          return _setDevice2.apply(this, arguments);
        }

        return setDevice;
      }()
    }, {
      key: "_setDeviceById",
      value: function () {
        var _setDeviceById2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee135(e) {
          var _t97, i, _n45, _t98;

          return _regeneratorRuntime.wrap(function _callee135$(_context135) {
            while (1) {
              switch (_context135.prev = _context135.next) {
                case 0:
                  if (!(YC.info("[".concat(this.getTrackId(), "] set device to ").concat(e)), this._enabled)) {
                    _context135.next = 36;
                    break;
                  }

                  _context135.prev = 1;
                  _context135.next = 4;
                  return Fb.getDeviceById(e);

                case 4:
                  _t97 = _context135.sent;
                  i = {};
                  i.video = Ow({}, this._constraints), i.video.deviceId = {
                    exact: e
                  }, i.video.facingMode = void 0, this._originMediaStreamTrack.stop();
                  _n45 = null;
                  _context135.prev = 8;
                  _context135.next = 11;
                  return Mb(i, this.getTrackId());

                case 11:
                  _n45 = _context135.sent;
                  _context135.next = 23;
                  break;

                case 14:
                  _context135.prev = 14;
                  _context135.t0 = _context135["catch"](8);
                  YC.error("[".concat(this.getTrackId(), "] setDevice failed"), _context135.t0.toString());
                  _context135.next = 19;
                  return Mb({
                    video: this._constraints
                  }, this.getTrackId());

                case 19:
                  _n45 = _context135.sent;
                  _context135.next = 22;
                  return this._updateOriginMediaStreamTrack(_n45.getVideoTracks()[0], !1);

                case 22:
                  throw _context135.t0;

                case 23:
                  _context135.next = 25;
                  return this._updateOriginMediaStreamTrack(_n45.getVideoTracks()[0], !1);

                case 25:
                  this.updateMediaStreamTrackResolution();
                  this._deviceName = _t97.label;
                  this._config.cameraId = e;
                  this._constraints.deviceId = {
                    exact: e
                  };
                  _context135.next = 34;
                  break;

                case 31:
                  _context135.prev = 31;
                  _context135.t1 = _context135["catch"](1);
                  throw YC.error("[".concat(this.getTrackId(), "] setDevice error"), _context135.t1.toString()), _context135.t1;

                case 34:
                  _context135.next = 46;
                  break;

                case 36:
                  _context135.prev = 36;
                  _context135.next = 39;
                  return Fb.getDeviceById(e);

                case 39:
                  _t98 = _context135.sent;
                  this._deviceName = _t98.label, this._config.cameraId = e, this._constraints.deviceId = {
                    exact: e
                  };
                  _context135.next = 46;
                  break;

                case 43:
                  _context135.prev = 43;
                  _context135.t2 = _context135["catch"](36);
                  throw YC.error("[".concat(this.getTrackId(), "] setDevice error"), _context135.t2.toString()), _context135.t2;

                case 46:
                  YC.info("[".concat(this.getTrackId(), "] setDevice success"));

                case 47:
                case "end":
                  return _context135.stop();
              }
            }
          }, _callee135, this, [[1, 31], [8, 14], [36, 43]]);
        }));

        function _setDeviceById(_x227) {
          return _setDeviceById2.apply(this, arguments);
        }

        return _setDeviceById;
      }()
    }, {
      key: "_setDeviceByFacingModel",
      value: function () {
        var _setDeviceByFacingModel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee136(e) {
          var t, _e84;

          return _regeneratorRuntime.wrap(function _callee136$(_context136) {
            while (1) {
              switch (_context136.prev = _context136.next) {
                case 0:
                  YC.info("[".concat(this.getTrackId(), "] set facingMode ").concat(e));
                  t = {
                    video: Ow(Ow({}, this._constraints), {}, {
                      deviceId: void 0,
                      facingMode: {
                        exact: e
                      }
                    })
                  };

                  if (!this._enabled) {
                    _context136.next = 23;
                    break;
                  }

                  this._originMediaStreamTrack.stop();

                  _e84 = null;
                  _context136.prev = 5;
                  _context136.next = 8;
                  return Mb(t, this.getTrackId());

                case 8:
                  _e84 = _context136.sent;
                  _context136.next = 20;
                  break;

                case 11:
                  _context136.prev = 11;
                  _context136.t0 = _context136["catch"](5);
                  YC.error("[".concat(this.getTrackId(), "] setDeviceByFacingModel failed"), _context136.t0.toString());
                  _context136.next = 16;
                  return Mb({
                    video: this._constraints
                  }, this.getTrackId());

                case 16:
                  _e84 = _context136.sent;
                  _context136.next = 19;
                  return this._updateOriginMediaStreamTrack(_e84.getVideoTracks()[0], !1);

                case 19:
                  throw _context136.t0;

                case 20:
                  _context136.next = 22;
                  return this._updateOriginMediaStreamTrack(_e84.getVideoTracks()[0], !1);

                case 22:
                  this.updateMediaStreamTrackResolution();

                case 23:
                  this._deviceName = "", this._config.facingMode = e, this._config.cameraId = void 0, this._constraints = Ow({}, t.video), YC.info("[".concat(this.getTrackId(), "] setDeviceByFacingModel success"));

                case 24:
                case "end":
                  return _context136.stop();
              }
            }
          }, _callee136, this, [[5, 11]]);
        }));

        function _setDeviceByFacingModel(_x228) {
          return _setDeviceByFacingModel2.apply(this, arguments);
        }

        return _setDeviceByFacingModel;
      }()
    }, {
      key: "setEnabled",
      value: function () {
        var _setEnabled6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee137(e, t) {
          var _e85;

          return _regeneratorRuntime.wrap(function _callee137$(_context137) {
            while (1) {
              switch (_context137.prev = _context137.next) {
                case 0:
                  if (t) {
                    _context137.next = 4;
                    break;
                  }

                  if (!(e === this._enabled)) {
                    _context137.next = 3;
                    break;
                  }

                  return _context137.abrupt("return");

                case 3:
                  this.stateCheck("enabled", e);

                case 4:
                  if (!(YC.info("[".concat(this.getTrackId(), "] start setEnabled"), e), e)) {
                    _context137.next = 25;
                    break;
                  }

                  _context137.prev = 5;

                  if (!this.isExternalTrack) {
                    _context137.next = 10;
                    break;
                  }

                  this._originMediaStreamTrack.enabled = !0;
                  _context137.next = 15;
                  break;

                case 10:
                  _context137.next = 12;
                  return Mb({
                    video: this._constraints
                  }, this.getTrackId());

                case 12:
                  _e85 = _context137.sent;
                  _context137.next = 15;
                  return this._updateOriginMediaStreamTrack(_e85.getVideoTracks()[0], !1);

                case 15:
                  _context137.next = 17;
                  return Tg(this, KA.NEED_ENABLE_TRACK, this);

                case 17:
                  _context137.next = 22;
                  break;

                case 19:
                  _context137.prev = 19;
                  _context137.t0 = _context137["catch"](5);
                  throw YC.error("[".concat(this.getTrackId(), "] setEnabled true error"), _context137.t0.toString()), _context137.t0;

                case 22:
                  this.updateMediaStreamTrackResolution(), YC.info("[".concat(this.getTrackId(), "] setEnabled to true success")), t || (this._enabled = !0);
                  _context137.next = 35;
                  break;

                case 25:
                  this.isExternalTrack ? this._originMediaStreamTrack.enabled = !1 : (this._originMediaStreamTrack.onended = null, this._originMediaStreamTrack.stop()), t || (this._enabled = !1);
                  _context137.prev = 26;
                  _context137.next = 29;
                  return Tg(this, KA.NEED_DISABLE_TRACK, this);

                case 29:
                  _context137.next = 34;
                  break;

                case 31:
                  _context137.prev = 31;
                  _context137.t1 = _context137["catch"](26);
                  throw YC.error("[".concat(this.getTrackId(), "] setEnabled to false error"), _context137.t1.toString()), _context137.t1;

                case 34:
                  YC.info("[".concat(this.getTrackId(), "] setEnabled to false success"));

                case 35:
                case "end":
                  return _context137.stop();
              }
            }
          }, _callee137, this, [[5, 19], [26, 31]]);
        }));

        function setEnabled(_x229, _x230) {
          return _setEnabled6.apply(this, arguments);
        }

        return setEnabled;
      }()
    }, {
      key: "setEncoderConfiguration",
      value: function () {
        var _setEncoderConfiguration2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee138(e, t) {
          var i, n, _t99;

          return _regeneratorRuntime.wrap(function _callee138$(_context138) {
            while (1) {
              switch (_context138.prev = _context138.next) {
                case 0:
                  if (this._enabled) {
                    _context138.next = 2;
                    break;
                  }

                  throw new VT(xT.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");

                case 2:
                  "720p_auto" === e ? this.startMonitorStats() : this._statsTimer && (window.clearInterval(this._statsTimer), this._statsTimer = null), e = VA(e), this._forceBitrateLimit && (e.bitrateMax = this._forceBitrateLimit.max_bitrate ? this._forceBitrateLimit.max_bitrate : e.bitrateMax, e.bitrateMin = this._forceBitrateLimit.min_bitrate ? this._forceBitrateLimit.min_bitrate : e.bitrateMin);
                  i = bg(this._config);
                  i.encoderConfig = e;
                  n = hw(i);
                  (ST() || CT() || DT()) && (n.deviceId = void 0), YC.debug("[".concat(this.getTrackId(), "] setEncoderConfiguration applyConstraints"), JSON.stringify(e), JSON.stringify(n));
                  _context138.prev = 7;
                  _context138.next = 10;
                  return this._originMediaStreamTrack.applyConstraints(n);

                case 10:
                  this.updateMediaStreamTrackResolution();
                  _context138.next = 17;
                  break;

                case 13:
                  _context138.prev = 13;
                  _context138.t0 = _context138["catch"](7);
                  _t99 = new VT(xT.UNEXPECTED_ERROR, _context138.t0.toString());
                  throw YC.error("[".concat(this.getTrackId(), "] applyConstraints error"), _t99.toString()), _t99;

                case 17:
                  this._config = i, this._constraints = n, this._originalConstraints = n, this._encoderConfig = e, -1 === this._hints.indexOf(YA.SCREEN_TRACK) && this.updateBitrateFromProfile();
                  _context138.prev = 18;
                  _context138.next = 21;
                  return Tg(this, KA.NEED_UPDATE_VIDEO_ENCODER, this);

                case 21:
                  _context138.next = 26;
                  break;

                case 23:
                  _context138.prev = 23;
                  _context138.t1 = _context138["catch"](18);
                  return _context138.abrupt("return", _context138.t1.throw(YC));

                case 26:
                case "end":
                  return _context138.stop();
              }
            }
          }, _callee138, this, [[7, 13], [18, 23]]);
        }));

        function setEncoderConfiguration(_x231, _x232) {
          return _setEncoderConfiguration2.apply(this, arguments);
        }

        return setEncoderConfiguration;
      }()
    }, {
      key: "_getDefaultPlayerConfig",
      value: function _getDefaultPlayerConfig() {
        return {
          mirror: !0,
          fit: "cover"
        };
      }
    }, {
      key: "onTrackEnded",
      value: function onTrackEnded() {
        var _this140 = this;

        if ((CT() || DT()) && this._enabled && !this._isClosed && Tb.duringInterruption) {
          var e = /*#__PURE__*/function () {
            var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee139() {
              return _regeneratorRuntime.wrap(function _callee139$(_context139) {
                while (1) {
                  switch (_context139.prev = _context139.next) {
                    case 0:
                      Tb.off(OA.IOS_INTERRUPTION_END, e);
                      _context139.t0 = _this140._enabled && !_this140._isClosed;

                      if (!_context139.t0) {
                        _context139.next = 8;
                        break;
                      }

                      YC.debug("[".concat(_this140.getTrackId(), "] try capture camera media device for interrupted iOS device."));
                      _context139.next = 6;
                      return _this140.setEnabled(!1);

                    case 6:
                      _context139.next = 8;
                      return _this140.setEnabled(!0);

                    case 8:
                    case "end":
                      return _context139.stop();
                  }
                }
              }, _callee139);
            }));

            return function e() {
              return _ref47.apply(this, arguments);
            };
          }();

          Tb.on(OA.IOS_INTERRUPTION_END, e);
        } else YC.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(QA.TRACK_ENDED);
      }
    }, {
      key: "renewMediaStreamTrack",
      value: function () {
        var _renewMediaStreamTrack3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee140(e) {
          var t, i, _e86;

          return _regeneratorRuntime.wrap(function _callee140$(_context140) {
            while (1) {
              switch (_context140.prev = _context140.next) {
                case 0:
                  t = e || this._constraints, i = Fb.searchDeviceIdByName(this._deviceName);

                  if (!(i && !t.deviceId && (t.deviceId = {
                    exact: i
                  }), this._enabled)) {
                    _context140.next = 9;
                    break;
                  }

                  _context140.next = 4;
                  return Mb({
                    video: t
                  }, this.getTrackId());

                case 4:
                  _e86 = _context140.sent;
                  this._constraints = t;
                  _context140.next = 8;
                  return this._updateOriginMediaStreamTrack(_e86.getVideoTracks()[0], !0);

                case 8:
                  this.updateMediaStreamTrackResolution();

                case 9:
                case "end":
                  return _context140.stop();
              }
            }
          }, _callee140, this);
        }));

        function renewMediaStreamTrack(_x233) {
          return _renewMediaStreamTrack3.apply(this, arguments);
        }

        return renewMediaStreamTrack;
      }()
    }, {
      key: "close",
      value: function close() {
        _get(_getPrototypeOf(Dw.prototype), "close", this).call(this), Tb.off(OA.IOS_15_16_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat), Tb.off(OA.IOS_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat);
      }
    }, {
      key: "clone",
      value: function clone(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = this._encoderConfig;
        e && (i = Ow(Ow({}, i), VA(e))), i = wg(i);
        var n = xg(8, "track-cam-cloned-"),
            s = new Dw(t ? this._mediaStreamTrack.clone() : this._mediaStreamTrack, wg(Ow(Ow({}, this._config), {}, {
          encoderConfig: i
        })), wg(this._constraints), wg(this._scalabilityMode), this._optimizationMode, n);
        return e && i && s.setEncoderConfiguration(i), YC.debug("clone track from ".concat(this.getTrackId(), " to ").concat(n, ", clone ").concat(t)), s;
      }
    }, {
      key: "bindProcessorContextEvents",
      value: function bindProcessorContextEvents() {
        var _this141 = this;

        this.processorContext.on(ab.REQUEST_UPDATE_CONSTRAINTS, /*#__PURE__*/function () {
          var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee141(e, t, i) {
            var _i55;

            return _regeneratorRuntime.wrap(function _callee141$(_context141) {
              while (1) {
                switch (_context141.prev = _context141.next) {
                  case 0:
                    _context141.prev = 0;
                    _i55 = Object.assign.apply(Object, [{}, _this141._originalConstraints].concat(_toConsumableArray(e)));
                    _context141.next = 4;
                    return _this141.renewMediaStreamTrack(_i55);

                  case 4:
                    t();
                    _context141.next = 10;
                    break;

                  case 7:
                    _context141.prev = 7;
                    _context141.t0 = _context141["catch"](0);
                    i(_context141.t0);

                  case 10:
                  case "end":
                    return _context141.stop();
                }
              }
            }, _callee141, null, [[0, 7]]);
          }));

          return function (_x234, _x235, _x236) {
            return _ref48.apply(this, arguments);
          };
        }()), this.processorContext.on(ab.REQUEST_CONSTRAINTS, /*#__PURE__*/function () {
          var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee142(e) {
            return _regeneratorRuntime.wrap(function _callee142$(_context142) {
              while (1) {
                switch (_context142.prev = _context142.next) {
                  case 0:
                    e(_this141._originMediaStreamTrack.getSettings());

                  case 1:
                  case "end":
                    return _context142.stop();
                }
              }
            }, _callee142);
          }));

          return function (_x237) {
            return _ref49.apply(this, arguments);
          };
        }());
      }
    }]);

    return Dw;
  }(Nw);

  function Pw(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Lw(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Pw(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Pw(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function kw(e, t, i, n) {
    i.optimizationMode && (n && n.width && n.height ? (i.encoderConfig = Lw(Lw({}, n), {}, {
      bitrateMin: n.bitrateMin,
      bitrateMax: n.bitrateMax
    }), "motion" !== i.optimizationMode && "detail" !== i.optimizationMode || (t.contentHint = i.optimizationMode, t.contentHint === i.optimizationMode ? YC.debug("[".concat(e, "] set content hint to"), i.optimizationMode) : YC.debug("[".concat(e, "] set content hint failed")))) : YC.warning("[".concat(e, "] can not apply optimization mode bitrate config, no encoderConfig")));
  }

  function Mw(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Uw(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Mw(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Mw(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], Dw.prototype, "setDevice", null), UI([qg("CameraVideoTrack", "_enabledMutex"), sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Boolean]), xI("design:returntype", tT)], Dw.prototype, "setEnabled", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), Jb(), xI("design:type", Function), xI("design:paramtypes", [Object, Boolean]), xI("design:returntype", tT)], Dw.prototype, "setEncoderConfiguration", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Dw.prototype, "close", null);

  var xw = /*#__PURE__*/function (_pb2) {
    _inherits(xw, _pb2);

    var _super39 = _createSuper(xw);

    function xw(e, t, i, n) {
      var _this142;

      _classCallCheck(this, xw);

      _this142 = _super39.call(this, e, "track-".concat(e.kind, "-").concat(t, "-").concat(n.clientId, "_").concat(xg(5, ""))), nh(_assertThisInitialized(_this142), "_userId", void 0), nh(_assertThisInitialized(_this142), "_uintId", void 0), nh(_assertThisInitialized(_this142), "_isDestroyed", !1), nh(_assertThisInitialized(_this142), "store", void 0), nh(_assertThisInitialized(_this142), "processor", void 0), _this142._userId = t, _this142._uintId = i, _this142.store = n;
      return _this142;
    }

    _createClass(xw, [{
      key: "getUserId",
      value: function getUserId() {
        return this._userId;
      }
    }, {
      key: "_updateOriginMediaStreamTrack",
      value: function _updateOriginMediaStreamTrack(e) {
        this._originMediaStreamTrack = e, this._mediaStreamTrack = e, this._updatePlayerSource(), this.processor && this.processor.updateInput({
          track: this._originMediaStreamTrack,
          context: this.processorContext
        });
      }
    }, {
      key: "_destroy",
      value: function _destroy() {
        this._isDestroyed = !0, YC.info("[".concat(this.getTrackId(), "] is destroyed")), this.stop(), _get(_getPrototypeOf(xw.prototype), "close", this).call(this);
      }
    }, {
      key: "getProcessorStats",
      value: function getProcessorStats() {
        return this.processorContext.gatherStats();
      }
    }, {
      key: "getProcessorUsage",
      value: function getProcessorUsage() {
        return this.processorContext.gatherUsage();
      }
    }]);

    return xw;
  }(pb);

  var Vw = /*#__PURE__*/function (_xw) {
    _inherits(Vw, _xw);

    var _super40 = _createSuper(Vw);

    function Vw(e, t, i, n) {
      var _this143;

      _classCallCheck(this, Vw);

      _this143 = _super40.call(this, e, t, i, n), nh(_assertThisInitialized(_this143), "_videoVisibleTimer", null), nh(_assertThisInitialized(_this143), "_previousVideoVisibleStatus", void 0), nh(_assertThisInitialized(_this143), "_clearPreviousVideoVisibleStatus", function () {
        return _this143._previousVideoVisibleStatus = void 0;
      }), nh(_assertThisInitialized(_this143), "trackMediaType", "video"), nh(_assertThisInitialized(_this143), "_videoWidth", void 0), nh(_assertThisInitialized(_this143), "_videoHeight", void 0), nh(_assertThisInitialized(_this143), "_player", void 0), nh(_assertThisInitialized(_this143), "processorDestination", void 0), nh(_assertThisInitialized(_this143), "processorContext", void 0), _this143.updateMediaStreamTrackResolution(), _this143.processorContext = new Zb(_this143.getTrackId(), "remote"), _this143.processorDestination = new Qb(_this143.processorContext), _this143.bindProcessorDestinationEvents();
      return _this143;
    }

    _createClass(Vw, [{
      key: "isPlaying",
      get: function get() {
        return !(!this._player || this._player.videoElementStatus !== lb.PLAYING);
      }
    }, {
      key: "__className__",
      get: function get() {
        return "RemoteVideoTrack";
      }
    }, {
      key: "getStats",
      value: function getStats() {
        Ng(function () {
          YC.warning("[deprecated] RemoteVideoTrack.getStats will be removed in the future, use AgoraRTCClient.getRemoteVideoStats instead");
        }, "remoteVideoTrackGetStatsWarning");
        return gg(this, KA.GET_STATS) || Uw({}, rb);
      }
    }, {
      key: "play",
      value: function play(e) {
        var _this144 = this;

        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

        if ("string" == typeof e) {
          var _t100 = document.getElementById(e);

          _t100 ? e = _t100 : (YC.warning("[".concat(this.getTrackId(), '] can not find "#').concat(e, '" element, use document.body')), e = document.body);
        }

        YC.debug("[".concat(this.getTrackId(), "] start video playback in ").concat(e instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement"), JSON.stringify(t));
        var i = Uw(Uw({
          fit: "cover"
        }, t), {}, {
          trackId: this.getTrackId(),
          element: e
        });
        this._player ? this._player.updateConfig(i) : (e instanceof HTMLVideoElement ? this._player = new Cw(i) : this._player = new vw(i), this._player.updateVideoTrack(this._mediaStreamTrack), this._player.onFirstVideoFrameDecoded = function () {
          _this144.store.subscribe(_this144.getUserId(), "video", void 0, void 0, Date.now()), _this144.safeEmit(ZA.FIRST_FRAME_DECODED);
        }), this._player.play(this.store.sessionId || void 0), this._videoVisibleTimer && window.clearInterval(this._videoVisibleTimer), this._clearPreviousVideoVisibleStatus(), this._videoVisibleTimer = window.setInterval(function () {
          try {
            var _e87 = _this144.getVideoElementVisibleStatus();

            _this144.safeEmit(ZA.VIDEO_ELEMENT_VISIBLE_STATUS, _e87);
          } catch (e) {}
        }, DC("CHECK_VIDEO_VISIBLE_INTERVAL"));
      }
    }, {
      key: "stop",
      value: function stop() {
        this._player && (this._videoVisibleTimer && (window.clearInterval(this._videoVisibleTimer), this._videoVisibleTimer = null), this._clearPreviousVideoVisibleStatus(), this._player.destroy(), this._player = void 0, YC.debug("[".concat(this.getTrackId(), "] stop video playback")));
      }
    }, {
      key: "getCurrentFrameData",
      value: function getCurrentFrameData() {
        return this._player ? this._player.getCurrentFrame() : new ImageData(2, 2);
      }
    }, {
      key: "updateMediaStreamTrackResolution",
      value: function updateMediaStreamTrackResolution() {
        var _this145 = this;

        yw(this._originMediaStreamTrack).then(function (e) {
          var _e88 = _slicedToArray(e, 2),
              t = _e88[0],
              i = _e88[1];

          _this145._videoHeight = i, _this145._videoWidth = t;
        }).catch(Fg);
      }
    }, {
      key: "_updatePlayerSource",
      value: function _updatePlayerSource() {
        YC.debug("[".concat(this.getTrackId(), "] update player source track")), this._player && this._player.updateVideoTrack(this._mediaStreamTrack);
      }
    }, {
      key: "getVideoElementVisibleStatus",
      value: function getVideoElementVisibleStatus() {
        try {
          var e, t;
          var i = null == this || null === (e = this._player) || void 0 === e ? void 0 : e.getContainerElement(),
              _n46 = {
            track: this,
            element: null == this || null === (t = this._player) || void 0 === t ? void 0 : t.getVideoElement(),
            slot: null == i ? void 0 : i.parentElement
          },
              _s26 = _n46.element,
              _r15 = _n46.slot;

          if (this.isPlaying && _s26 instanceof HTMLVideoElement && _r15 instanceof HTMLElement) {
            var _e89 = QT.checkOneElementVisible(_s26),
                _t101 = Object.assign({}, _e89);

            if (_t101.visible !== this._previousVideoVisibleStatus) {
              this._previousVideoVisibleStatus = _t101.visible;

              var _e90 = rI.reportApiInvoke(null, {
                tag: og.TRACER,
                name: rg.REMOTE_VIDEO_TRACK_GET_VIDEO_VISIBLE,
                options: [this.getTrackId()]
              });

              _t101.visible ? _e90.onSuccess("Video is visible") : _e90.onSuccess("Invisible because of ".concat(_t101.reason));
            }

            return _t101;
          }

          return;
        } catch (e) {
          throw new VT(xT.GET_VIDEO_ELEMENT_VISIBLE_ERROR, e.message);
        }
      }
    }, {
      key: "pipe",
      value: function pipe(e) {
        if (this.processor === e) return e;
        if (e._source) throw new VT(xT.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({
          track: this._originMediaStreamTrack,
          context: this.processorContext
        }), e;
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        if (!this.processor) return;
        var e = this.processor;
        this.processor._source = void 0, this.processor = void 0, e.reset();
      }
    }, {
      key: "bindProcessorDestinationEvents",
      value: function bindProcessorDestinationEvents() {
        var _this146 = this;

        this.processorDestination.on(ob.ON_TRACK, /*#__PURE__*/function () {
          var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee143(e) {
            return _regeneratorRuntime.wrap(function _callee143$(_context143) {
              while (1) {
                switch (_context143.prev = _context143.next) {
                  case 0:
                    e ? e !== _this146._mediaStreamTrack && (_this146._mediaStreamTrack = e, _this146._updatePlayerSource()) : _this146._mediaStreamTrack !== _this146._originMediaStreamTrack && (_this146._mediaStreamTrack = _this146._originMediaStreamTrack, _this146._updatePlayerSource());

                  case 1:
                  case "end":
                    return _context143.stop();
                }
              }
            }, _callee143);
          }));

          return function (_x238) {
            return _ref50.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "unbindProcessorDestinationEvents",
      value: function unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(ob.ON_TRACK);
      }
    }, {
      key: "_destroy",
      value: function _destroy() {
        _get(_getPrototypeOf(Vw.prototype), "_destroy", this).call(this), this.unbindProcessorDestinationEvents();
      }
    }]);

    return Vw;
  }(xw);

  UI([sI({
    argsMap: function argsMap(e, t, i) {
      return [e.getTrackId(), "string" == typeof t ? t : t instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement", i];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object, Object]), xI("design:returntype", void 0)], Vw.prototype, "play", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Vw.prototype, "stop", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t.name];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", Object)], Vw.prototype, "pipe", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Vw.prototype, "unpipe", null);

  var Fw = /*#__PURE__*/function (_xw2) {
    _inherits(Fw, _xw2);

    var _super41 = _createSuper(Fw);

    function Fw(e, t, i, n) {
      var _this147;

      _classCallCheck(this, Fw);

      _this147 = _super41.call(this, e, t, i, n), nh(_assertThisInitialized(_this147), "trackMediaType", "audio"), nh(_assertThisInitialized(_this147), "_source", void 0), nh(_assertThisInitialized(_this147), "_useAudioElement", !0), nh(_assertThisInitialized(_this147), "_volume", 100), nh(_assertThisInitialized(_this147), "processorContext", void 0), nh(_assertThisInitialized(_this147), "processorDestination", void 0), nh(_assertThisInitialized(_this147), "_played", !1), nh(_assertThisInitialized(_this147), "_bypassWebAudio", !1), DC("DISABLE_WEBAUDIO") ? (_this147._source = new tw(), _this147._bypassWebAudio = !0, _this147._useAudioElement = !0) : (_this147._source = new bb(e, !0), DC("REMOTE_AUDIO_TRACK_USES_WEB_AUDIO") && (_this147._useAudioElement = !1)), _this147._source.once($A.RECEIVE_TRACK_BUFFER, function () {
        _this147.safeEmit(ZA.FIRST_FRAME_DECODED);
      }), _this147.processorContext = new ew(_this147._source.context, _this147.getTrackId(), "remote"), _this147.processorDestination = new $b(_this147.processorContext), _this147.bindProcessorDestinationEvents(), _this147._source.on($A.UPDATE_SOURCE, function () {
        _this147.processor && _this147.processor.updateInput({
          node: _this147._source.processSourceNode,
          context: _this147.processorContext
        });
      });
      return _this147;
    }

    _createClass(Fw, [{
      key: "isPlaying",
      get: function get() {
        return this._useAudioElement ? qb.isPlaying(this.getTrackId()) : this._source.isPlayed;
      }
    }, {
      key: "__className__",
      get: function get() {
        return "RemoteAudioTrack";
      }
    }, {
      key: "setAudioFrameCallback",
      value: function setAudioFrameCallback(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 4096;
        if (!e) return this._source.removeAllListeners($A.ON_AUDIO_BUFFER), void this._source.stopGetAudioBuffer();
        this._source.startGetAudioBuffer(t), this._source.removeAllListeners($A.ON_AUDIO_BUFFER), this._source.on($A.ON_AUDIO_BUFFER, function (t) {
          return e(t);
        });
      }
    }, {
      key: "setVolume",
      value: function setVolume(e) {
        this._volume = e, this._useAudioElement ? qb.setVolume(this.getTrackId(), e) : this._source.setVolume(e / 100);
      }
    }, {
      key: "setPlaybackDevice",
      value: function () {
        var _setPlaybackDevice2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee144(e) {
          return _regeneratorRuntime.wrap(function _callee144$(_context144) {
            while (1) {
              switch (_context144.prev = _context144.next) {
                case 0:
                  if (!(!this._useAudioElement || !gT() && DC("RESTRICTION_SET_PLAYBACK_DEVICE"))) {
                    _context144.next = 2;
                    break;
                  }

                  throw new VT(xT.NOT_SUPPORTED, "your browser does not support setting the audio output device");

                case 2:
                  _context144.next = 4;
                  return qb.setSinkID(this.getTrackId(), e);

                case 4:
                case "end":
                  return _context144.stop();
              }
            }
          }, _callee144, this);
        }));

        function setPlaybackDevice(_x239) {
          return _setPlaybackDevice2.apply(this, arguments);
        }

        return setPlaybackDevice;
      }()
    }, {
      key: "getVolumeLevel",
      value: function getVolumeLevel() {
        return this._source.getAccurateVolumeLevel();
      }
    }, {
      key: "getStats",
      value: function getStats() {
        Ng(function () {
          YC.warning("[deprecated] RemoteAudioTrack.getStats will be removed in the future, use AgoraRTCClient.getRemoteAudioStats instead");
        }, "remoteAudioTrackGetStatsWarning");
        return gg(this, KA.GET_STATS) || Uw({}, nb);
      }
    }, {
      key: "play",
      value: function play() {
        YC.debug("[".concat(this.getTrackId(), "] start audio playback")), this._played = !0, this._useAudioElement ? (YC.debug("[".concat(this.getTrackId(), "] use audio element to play")), qb.play(this._mediaStreamTrack, this.getTrackId(), this._volume, this.store.sessionId || void 0)) : this._source.play();
      }
    }, {
      key: "stop",
      value: function stop() {
        YC.debug("[".concat(this.getTrackId(), "] stop audio playback")), this._played = !1, this._useAudioElement ? qb.stop(this.getTrackId()) : this._source.stop();
      }
    }, {
      key: "_destroy",
      value: function _destroy() {
        _get(_getPrototypeOf(Fw.prototype), "_destroy", this).call(this), this._played = !1, this.unbindProcessorDestinationEvents(), this._source.destroy();
      }
    }, {
      key: "_isFreeze",
      value: function _isFreeze() {
        return this._source.isFreeze;
      }
    }, {
      key: "_updatePlayerSource",
      value: function _updatePlayerSource() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        YC.debug("[".concat(this.getTrackId(), "] update player source track")), e && this._source.updateTrack(this._mediaStreamTrack), this._useAudioElement && qb.updateTrack(this.getTrackId(), this._mediaStreamTrack);
      }
    }, {
      key: "pipe",
      value: function pipe(e) {
        if (this._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "can not pipe extension when WebAudio disabled");
        if (this.processor === e) return e;
        if (e._source) throw new VT(xT.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({
          track: this._originMediaStreamTrack,
          node: this._source.processSourceNode,
          context: this.processorContext
        }), e;
      }
    }, {
      key: "unpipe",
      value: function unpipe() {
        var e;
        if (this._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "can not unpipe extension when WebAudio disabled");
        if (!this.processor) return;
        var t = this.processor;
        null === (e = this._source.processSourceNode) || void 0 === e || e.disconnect(), this.processor._source = !1, this.processor = void 0, t.reset();
      }
    }, {
      key: "bindProcessorDestinationEvents",
      value: function bindProcessorDestinationEvents() {
        var _this148 = this;

        this.processorDestination.on(ob.ON_TRACK, /*#__PURE__*/function () {
          var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee145(e) {
            return _regeneratorRuntime.wrap(function _callee145$(_context145) {
              while (1) {
                switch (_context145.prev = _context145.next) {
                  case 0:
                    e ? e !== _this148._mediaStreamTrack && (_this148._mediaStreamTrack = e, _this148._updatePlayerSource(!1), _this148._source.processedNode = _this148._source.createMediaStreamSourceNode(e)) : _this148._mediaStreamTrack !== _this148._originMediaStreamTrack && (_this148._mediaStreamTrack = _this148._originMediaStreamTrack, _this148._updatePlayerSource());

                  case 1:
                  case "end":
                    return _context145.stop();
                }
              }
            }, _callee145);
          }));

          return function (_x240) {
            return _ref51.apply(this, arguments);
          };
        }()), this.processorDestination.on(ob.ON_NODE, function (e) {
          _this148._source.processedNode = e;
          var t = !e;
          _this148._useAudioElement !== t && (_this148._played ? (_this148.stop(), _this148._useAudioElement = t, _this148.play()) : _this148._useAudioElement = t);
        });
      }
    }, {
      key: "unbindProcessorDestinationEvents",
      value: function unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(ob.ON_TRACK), this.processorDestination.removeAllListeners(ob.ON_NODE);
      }
    }]);

    return Fw;
  }(xw);

  UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    },
    throttleTime: 300
  }), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", void 0)], Fw.prototype, "setVolume", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Fw.prototype, "setPlaybackDevice", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Fw.prototype, "play", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Fw.prototype, "stop", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [e.getTrackId(), t.name];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", Object)], Fw.prototype, "pipe", null), UI([sI({
    argsMap: function argsMap(e) {
      return [e.getTrackId()];
    }
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Fw.prototype, "unpipe", null);

  function Bw(e) {
    var t = e.length;

    for (; --t >= 0;) {
      e[t] = 0;
    }
  }

  var jw = 256,
      Gw = 286,
      Ww = 30,
      Hw = 15,
      Kw = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]),
      Yw = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]),
      qw = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
      Jw = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
      zw = new Array(576);
  Bw(zw);
  var Xw = new Array(60);
  Bw(Xw);
  var Qw = new Array(512);
  Bw(Qw);
  var Zw = new Array(256);
  Bw(Zw);
  var $w = new Array(29);
  Bw($w);
  var eO = new Array(Ww);

  function tO(e, t, i, n, s) {
    this.static_tree = e, this.extra_bits = t, this.extra_base = i, this.elems = n, this.max_length = s, this.has_stree = e && e.length;
  }

  var iO, nO, sO;

  function rO(e, t) {
    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
  }

  Bw(eO);

  var oO = function oO(e) {
    return e < 256 ? Qw[e] : Qw[256 + (e >>> 7)];
  },
      aO = function aO(e, t) {
    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
  },
      cO = function cO(e, t, i) {
    e.bi_valid > 16 - i ? (e.bi_buf |= t << e.bi_valid & 65535, aO(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += i - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += i);
  },
      dO = function dO(e, t, i) {
    cO(e, i[2 * t], i[2 * t + 1]);
  },
      lO = function lO(e, t) {
    var i = 0;

    do {
      i |= 1 & e, e >>>= 1, i <<= 1;
    } while (--t > 0);

    return i >>> 1;
  },
      uO = function uO(e, t, i) {
    var n = new Array(16);
    var s,
        r,
        o = 0;

    for (s = 1; s <= Hw; s++) {
      o = o + i[s - 1] << 1, n[s] = o;
    }

    for (r = 0; r <= t; r++) {
      var _t102 = e[2 * r + 1];
      0 !== _t102 && (e[2 * r] = lO(n[_t102]++, _t102));
    }
  },
      hO = function hO(e) {
    var t;

    for (t = 0; t < Gw; t++) {
      e.dyn_ltree[2 * t] = 0;
    }

    for (t = 0; t < Ww; t++) {
      e.dyn_dtree[2 * t] = 0;
    }

    for (t = 0; t < 19; t++) {
      e.bl_tree[2 * t] = 0;
    }

    e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
  },
      pO = function pO(e) {
    e.bi_valid > 8 ? aO(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
  },
      _O = function _O(e, t, i, n) {
    var s = 2 * t,
        r = 2 * i;
    return e[s] < e[r] || e[s] === e[r] && n[t] <= n[i];
  },
      EO = function EO(e, t, i) {
    var n = e.heap[i];
    var s = i << 1;

    for (; s <= e.heap_len && (s < e.heap_len && _O(t, e.heap[s + 1], e.heap[s], e.depth) && s++, !_O(t, n, e.heap[s], e.depth));) {
      e.heap[i] = e.heap[s], i = s, s <<= 1;
    }

    e.heap[i] = n;
  },
      mO = function mO(e, t, i) {
    var n,
        s,
        r,
        o,
        a = 0;
    if (0 !== e.sym_next) do {
      n = 255 & e.pending_buf[e.sym_buf + a++], n += (255 & e.pending_buf[e.sym_buf + a++]) << 8, s = e.pending_buf[e.sym_buf + a++], 0 === n ? dO(e, s, t) : (r = Zw[s], dO(e, r + jw + 1, t), o = Kw[r], 0 !== o && (s -= $w[r], cO(e, s, o)), n--, r = oO(n), dO(e, r, i), o = Yw[r], 0 !== o && (n -= eO[r], cO(e, n, o)));
    } while (a < e.sym_next);
    dO(e, 256, t);
  },
      fO = function fO(e, t) {
    var i = t.dyn_tree,
        n = t.stat_desc.static_tree,
        s = t.stat_desc.has_stree,
        r = t.stat_desc.elems;
    var o,
        a,
        c,
        d = -1;

    for (e.heap_len = 0, e.heap_max = 573, o = 0; o < r; o++) {
      0 !== i[2 * o] ? (e.heap[++e.heap_len] = d = o, e.depth[o] = 0) : i[2 * o + 1] = 0;
    }

    for (; e.heap_len < 2;) {
      c = e.heap[++e.heap_len] = d < 2 ? ++d : 0, i[2 * c] = 1, e.depth[c] = 0, e.opt_len--, s && (e.static_len -= n[2 * c + 1]);
    }

    for (t.max_code = d, o = e.heap_len >> 1; o >= 1; o--) {
      EO(e, i, o);
    }

    c = r;

    do {
      o = e.heap[1], e.heap[1] = e.heap[e.heap_len--], EO(e, i, 1), a = e.heap[1], e.heap[--e.heap_max] = o, e.heap[--e.heap_max] = a, i[2 * c] = i[2 * o] + i[2 * a], e.depth[c] = (e.depth[o] >= e.depth[a] ? e.depth[o] : e.depth[a]) + 1, i[2 * o + 1] = i[2 * a + 1] = c, e.heap[1] = c++, EO(e, i, 1);
    } while (e.heap_len >= 2);

    e.heap[--e.heap_max] = e.heap[1], function (e, t) {
      var i = t.dyn_tree,
          n = t.max_code,
          s = t.stat_desc.static_tree,
          r = t.stat_desc.has_stree,
          o = t.stat_desc.extra_bits,
          a = t.stat_desc.extra_base,
          c = t.stat_desc.max_length;

      var d,
          l,
          u,
          h,
          p,
          _,
          E = 0;

      for (h = 0; h <= Hw; h++) {
        e.bl_count[h] = 0;
      }

      for (i[2 * e.heap[e.heap_max] + 1] = 0, d = e.heap_max + 1; d < 573; d++) {
        l = e.heap[d], h = i[2 * i[2 * l + 1] + 1] + 1, h > c && (h = c, E++), i[2 * l + 1] = h, l > n || (e.bl_count[h]++, p = 0, l >= a && (p = o[l - a]), _ = i[2 * l], e.opt_len += _ * (h + p), r && (e.static_len += _ * (s[2 * l + 1] + p)));
      }

      if (0 !== E) {
        do {
          for (h = c - 1; 0 === e.bl_count[h];) {
            h--;
          }

          e.bl_count[h]--, e.bl_count[h + 1] += 2, e.bl_count[c]--, E -= 2;
        } while (E > 0);

        for (h = c; 0 !== h; h--) {
          for (l = e.bl_count[h]; 0 !== l;) {
            u = e.heap[--d], u > n || (i[2 * u + 1] !== h && (e.opt_len += (h - i[2 * u + 1]) * i[2 * u], i[2 * u + 1] = h), l--);
          }
        }
      }
    }(e, t), uO(i, d, e.bl_count);
  },
      TO = function TO(e, t, i) {
    var n,
        s,
        r = -1,
        o = t[1],
        a = 0,
        c = 7,
        d = 4;

    for (0 === o && (c = 138, d = 3), t[2 * (i + 1) + 1] = 65535, n = 0; n <= i; n++) {
      s = o, o = t[2 * (n + 1) + 1], ++a < c && s === o || (a < d ? e.bl_tree[2 * s] += a : 0 !== s ? (s !== r && e.bl_tree[2 * s]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, a = 0, r = s, 0 === o ? (c = 138, d = 3) : s === o ? (c = 6, d = 3) : (c = 7, d = 4));
    }
  },
      gO = function gO(e, t, i) {
    var n,
        s,
        r = -1,
        o = t[1],
        a = 0,
        c = 7,
        d = 4;

    for (0 === o && (c = 138, d = 3), n = 0; n <= i; n++) {
      if (s = o, o = t[2 * (n + 1) + 1], !(++a < c && s === o)) {
        if (a < d) do {
          dO(e, s, e.bl_tree);
        } while (0 != --a);else 0 !== s ? (s !== r && (dO(e, s, e.bl_tree), a--), dO(e, 16, e.bl_tree), cO(e, a - 3, 2)) : a <= 10 ? (dO(e, 17, e.bl_tree), cO(e, a - 3, 3)) : (dO(e, 18, e.bl_tree), cO(e, a - 11, 7));
        a = 0, r = s, 0 === o ? (c = 138, d = 3) : s === o ? (c = 6, d = 3) : (c = 7, d = 4);
      }
    }
  };

  var SO = !1;

  var RO = function RO(e, t, i, n) {
    cO(e, 0 + (n ? 1 : 0), 3), pO(e), aO(e, i), aO(e, ~i), i && e.pending_buf.set(e.window.subarray(t, t + i), e.pending), e.pending += i;
  };

  var CO = function CO(e) {
    SO || (function () {
      var e, t, i, n, s;
      var r = new Array(16);

      for (i = 0, n = 0; n < 28; n++) {
        for ($w[n] = i, e = 0; e < 1 << Kw[n]; e++) {
          Zw[i++] = n;
        }
      }

      for (Zw[i - 1] = n, s = 0, n = 0; n < 16; n++) {
        for (eO[n] = s, e = 0; e < 1 << Yw[n]; e++) {
          Qw[s++] = n;
        }
      }

      for (s >>= 7; n < Ww; n++) {
        for (eO[n] = s << 7, e = 0; e < 1 << Yw[n] - 7; e++) {
          Qw[256 + s++] = n;
        }
      }

      for (t = 0; t <= Hw; t++) {
        r[t] = 0;
      }

      for (e = 0; e <= 143;) {
        zw[2 * e + 1] = 8, e++, r[8]++;
      }

      for (; e <= 255;) {
        zw[2 * e + 1] = 9, e++, r[9]++;
      }

      for (; e <= 279;) {
        zw[2 * e + 1] = 7, e++, r[7]++;
      }

      for (; e <= 287;) {
        zw[2 * e + 1] = 8, e++, r[8]++;
      }

      for (uO(zw, 287, r), e = 0; e < Ww; e++) {
        Xw[2 * e + 1] = 5, Xw[2 * e] = lO(e, 5);
      }

      iO = new tO(zw, Kw, 257, Gw, Hw), nO = new tO(Xw, Yw, 0, Ww, Hw), sO = new tO(new Array(0), qw, 0, 19, 7);
    }(), SO = !0), e.l_desc = new rO(e.dyn_ltree, iO), e.d_desc = new rO(e.dyn_dtree, nO), e.bl_desc = new rO(e.bl_tree, sO), e.bi_buf = 0, e.bi_valid = 0, hO(e);
  },
      IO = function IO(e, t, i, n) {
    var s,
        r,
        o = 0;
    e.level > 0 ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
      var t,
          i = 4093624447;

      for (t = 0; t <= 31; t++, i >>>= 1) {
        if (1 & i && 0 !== e.dyn_ltree[2 * t]) return 0;
      }

      if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;

      for (t = 32; t < jw; t++) {
        if (0 !== e.dyn_ltree[2 * t]) return 1;
      }

      return 0;
    }(e)), fO(e, e.l_desc), fO(e, e.d_desc), o = function (e) {
      var t;

      for (TO(e, e.dyn_ltree, e.l_desc.max_code), TO(e, e.dyn_dtree, e.d_desc.max_code), fO(e, e.bl_desc), t = 18; t >= 3 && 0 === e.bl_tree[2 * Jw[t] + 1]; t--) {
        ;
      }

      return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
    }(e), s = e.opt_len + 3 + 7 >>> 3, r = e.static_len + 3 + 7 >>> 3, r <= s && (s = r)) : s = r = i + 5, i + 4 <= s && -1 !== t ? RO(e, t, i, n) : 4 === e.strategy || r === s ? (cO(e, 2 + (n ? 1 : 0), 3), mO(e, zw, Xw)) : (cO(e, 4 + (n ? 1 : 0), 3), function (e, t, i, n) {
      var s;

      for (cO(e, t - 257, 5), cO(e, i - 1, 5), cO(e, n - 4, 4), s = 0; s < n; s++) {
        cO(e, e.bl_tree[2 * Jw[s] + 1], 3);
      }

      gO(e, e.dyn_ltree, t - 1), gO(e, e.dyn_dtree, i - 1);
    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), mO(e, e.dyn_ltree, e.dyn_dtree)), hO(e), n && pO(e);
  },
      vO = function vO(e, t, i) {
    return e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = i, 0 === t ? e.dyn_ltree[2 * i]++ : (e.matches++, t--, e.dyn_ltree[2 * (Zw[i] + jw + 1)]++, e.dyn_dtree[2 * oO(t)]++), e.sym_next === e.sym_end;
  },
      yO = {
    _tr_init: CO,
    _tr_stored_block: RO,
    _tr_flush_block: IO,
    _tr_tally: vO,
    _tr_align: function _tr_align(e) {
      cO(e, 2, 3), dO(e, 256, zw), function (e) {
        16 === e.bi_valid ? (aO(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
      }(e);
    }
  };

  var AO = function AO(e, t, i, n) {
    var s = 65535 & e | 0,
        r = e >>> 16 & 65535 | 0,
        o = 0;

    for (; 0 !== i;) {
      o = i > 2e3 ? 2e3 : i, i -= o;

      do {
        s = s + t[n++] | 0, r = r + s | 0;
      } while (--o);

      s %= 65521, r %= 65521;
    }

    return s | r << 16 | 0;
  };

  var bO = new Uint32Array(function () {
    var e,
        t = [];

    for (var i = 0; i < 256; i++) {
      e = i;

      for (var n = 0; n < 8; n++) {
        e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
      }

      t[i] = e;
    }

    return t;
  }());

  var wO = function wO(e, t, i, n) {
    var s = bO,
        r = n + i;
    e ^= -1;

    for (var _i56 = n; _i56 < r; _i56++) {
      e = e >>> 8 ^ s[255 & (e ^ t[_i56])];
    }

    return -1 ^ e;
  },
      OO = {
    2: "need dictionary",
    1: "stream end",
    0: "",
    "-1": "file error",
    "-2": "stream error",
    "-3": "data error",
    "-4": "insufficient memory",
    "-5": "buffer error",
    "-6": "incompatible version"
  },
      NO = {
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    Z_BINARY: 0,
    Z_TEXT: 1,
    Z_UNKNOWN: 2,
    Z_DEFLATED: 8
  };

  var DO = yO._tr_init,
      PO = yO._tr_stored_block,
      LO = yO._tr_flush_block,
      kO = yO._tr_tally,
      MO = yO._tr_align,
      UO = NO.Z_NO_FLUSH,
      xO = NO.Z_PARTIAL_FLUSH,
      VO = NO.Z_FULL_FLUSH,
      FO = NO.Z_FINISH,
      BO = NO.Z_BLOCK,
      jO = NO.Z_OK,
      GO = NO.Z_STREAM_END,
      WO = NO.Z_STREAM_ERROR,
      HO = NO.Z_DATA_ERROR,
      KO = NO.Z_BUF_ERROR,
      YO = NO.Z_DEFAULT_COMPRESSION,
      qO = NO.Z_FILTERED,
      JO = NO.Z_HUFFMAN_ONLY,
      zO = NO.Z_RLE,
      XO = NO.Z_FIXED,
      QO = NO.Z_DEFAULT_STRATEGY,
      ZO = NO.Z_UNKNOWN,
      $O = NO.Z_DEFLATED,
      eN = 286,
      tN = 30,
      iN = 19,
      nN = 2 * eN + 1,
      sN = 15,
      rN = 258,
      oN = 262,
      aN = 42,
      cN = 113,
      dN = 666,
      lN = function lN(e, t) {
    return e.msg = OO[t], t;
  },
      uN = function uN(e) {
    return 2 * e - (e > 4 ? 9 : 0);
  },
      hN = function hN(e) {
    var t = e.length;

    for (; --t >= 0;) {
      e[t] = 0;
    }
  },
      pN = function pN(e) {
    var t,
        i,
        n,
        s = e.w_size;
    t = e.hash_size, n = t;

    do {
      i = e.head[--n], e.head[n] = i >= s ? i - s : 0;
    } while (--t);

    t = s, n = t;

    do {
      i = e.prev[--n], e.prev[n] = i >= s ? i - s : 0;
    } while (--t);
  };

  var _N = function _N(e, t, i) {
    return (t << e.hash_shift ^ i) & e.hash_mask;
  };

  var EN = function EN(e) {
    var t = e.state;
    var i = t.pending;
    i > e.avail_out && (i = e.avail_out), 0 !== i && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + i), e.next_out), e.next_out += i, t.pending_out += i, e.total_out += i, e.avail_out -= i, t.pending -= i, 0 === t.pending && (t.pending_out = 0));
  },
      mN = function mN(e, t) {
    LO(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, EN(e.strm);
  },
      fN = function fN(e, t) {
    e.pending_buf[e.pending++] = t;
  },
      TN = function TN(e, t) {
    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
  },
      gN = function gN(e, t, i, n) {
    var s = e.avail_in;
    return s > n && (s = n), 0 === s ? 0 : (e.avail_in -= s, t.set(e.input.subarray(e.next_in, e.next_in + s), i), 1 === e.state.wrap ? e.adler = AO(e.adler, t, s, i) : 2 === e.state.wrap && (e.adler = wO(e.adler, t, s, i)), e.next_in += s, e.total_in += s, s);
  },
      SN = function SN(e, t) {
    var i,
        n,
        s = e.max_chain_length,
        r = e.strstart,
        o = e.prev_length,
        a = e.nice_match;
    var c = e.strstart > e.w_size - oN ? e.strstart - (e.w_size - oN) : 0,
        d = e.window,
        l = e.w_mask,
        u = e.prev,
        h = e.strstart + rN;
    var p = d[r + o - 1],
        _ = d[r + o];
    e.prev_length >= e.good_match && (s >>= 2), a > e.lookahead && (a = e.lookahead);

    do {
      if (i = t, d[i + o] === _ && d[i + o - 1] === p && d[i] === d[r] && d[++i] === d[r + 1]) {
        r += 2, i++;

        do {} while (d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && d[++r] === d[++i] && r < h);

        if (n = rN - (h - r), r = h - rN, n > o) {
          if (e.match_start = t, o = n, n >= a) break;
          p = d[r + o - 1], _ = d[r + o];
        }
      }
    } while ((t = u[t & l]) > c && 0 != --s);

    return o <= e.lookahead ? o : e.lookahead;
  },
      RN = function RN(e) {
    var t = e.w_size;
    var i, n, s;

    do {
      if (n = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - oN) && (e.window.set(e.window.subarray(t, t + t - n), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), pN(e), n += t), 0 === e.strm.avail_in) break;
      if (i = gN(e.strm, e.window, e.strstart + e.lookahead, n), e.lookahead += i, e.lookahead + e.insert >= 3) for (s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = _N(e, e.ins_h, e.window[s + 1]); e.insert && (e.ins_h = _N(e, e.ins_h, e.window[s + 3 - 1]), e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < 3));) {
        ;
      }
    } while (e.lookahead < oN && 0 !== e.strm.avail_in);
  },
      CN = function CN(e, t) {
    var i,
        n,
        s,
        r = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5,
        o = 0,
        a = e.strm.avail_in;

    do {
      if (i = 65535, s = e.bi_valid + 42 >> 3, e.strm.avail_out < s) break;
      if (s = e.strm.avail_out - s, n = e.strstart - e.block_start, i > n + e.strm.avail_in && (i = n + e.strm.avail_in), i > s && (i = s), i < r && (0 === i && t !== FO || t === UO || i !== n + e.strm.avail_in)) break;
      o = t === FO && i === n + e.strm.avail_in ? 1 : 0, PO(e, 0, 0, o), e.pending_buf[e.pending - 4] = i, e.pending_buf[e.pending - 3] = i >> 8, e.pending_buf[e.pending - 2] = ~i, e.pending_buf[e.pending - 1] = ~i >> 8, EN(e.strm), n && (n > i && (n = i), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + n), e.strm.next_out), e.strm.next_out += n, e.strm.avail_out -= n, e.strm.total_out += n, e.block_start += n, i -= n), i && (gN(e.strm, e.strm.output, e.strm.next_out, i), e.strm.next_out += i, e.strm.avail_out -= i, e.strm.total_out += i);
    } while (0 === o);

    return a -= e.strm.avail_in, a && (a >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= a && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - a, e.strm.next_in), e.strstart), e.strstart += a, e.insert += a > e.w_size - e.insert ? e.w_size - e.insert : a), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), o ? 4 : t !== UO && t !== FO && 0 === e.strm.avail_in && e.strstart === e.block_start ? 2 : (s = e.window_size - e.strstart, e.strm.avail_in > s && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, s += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), s > e.strm.avail_in && (s = e.strm.avail_in), s && (gN(e.strm, e.window, e.strstart, s), e.strstart += s, e.insert += s > e.w_size - e.insert ? e.w_size - e.insert : s), e.high_water < e.strstart && (e.high_water = e.strstart), s = e.bi_valid + 42 >> 3, s = e.pending_buf_size - s > 65535 ? 65535 : e.pending_buf_size - s, r = s > e.w_size ? e.w_size : s, n = e.strstart - e.block_start, (n >= r || (n || t === FO) && t !== UO && 0 === e.strm.avail_in && n <= s) && (i = n > s ? s : n, o = t === FO && 0 === e.strm.avail_in && i === n ? 1 : 0, PO(e, e.block_start, i, o), e.block_start += i, EN(e.strm)), o ? 3 : 1);
  },
      IN = function IN(e, t) {
    var i, n;

    for (;;) {
      if (e.lookahead < oN) {
        if (RN(e), e.lookahead < oN && t === UO) return 1;
        if (0 === e.lookahead) break;
      }

      if (i = 0, e.lookahead >= 3 && (e.ins_h = _N(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== i && e.strstart - i <= e.w_size - oN && (e.match_length = SN(e, i)), e.match_length >= 3) {
        if (n = kO(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
          e.match_length--;

          do {
            e.strstart++, e.ins_h = _N(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
          } while (0 != --e.match_length);

          e.strstart++;
        } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = _N(e, e.ins_h, e.window[e.strstart + 1]);
      } else n = kO(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
      if (n && (mN(e, !1), 0 === e.strm.avail_out)) return 1;
    }

    return e.insert = e.strstart < 2 ? e.strstart : 2, t === FO ? (mN(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (mN(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
  },
      vN = function vN(e, t) {
    var i, n, s;

    for (;;) {
      if (e.lookahead < oN) {
        if (RN(e), e.lookahead < oN && t === UO) return 1;
        if (0 === e.lookahead) break;
      }

      if (i = 0, e.lookahead >= 3 && (e.ins_h = _N(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== i && e.prev_length < e.max_lazy_match && e.strstart - i <= e.w_size - oN && (e.match_length = SN(e, i), e.match_length <= 5 && (e.strategy === qO || 3 === e.match_length && e.strstart - e.match_start > 4096) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
        s = e.strstart + e.lookahead - 3, n = kO(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;

        do {
          ++e.strstart <= s && (e.ins_h = _N(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
        } while (0 != --e.prev_length);

        if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (mN(e, !1), 0 === e.strm.avail_out)) return 1;
      } else if (e.match_available) {
        if (n = kO(e, 0, e.window[e.strstart - 1]), n && mN(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
      } else e.match_available = 1, e.strstart++, e.lookahead--;
    }

    return e.match_available && (n = kO(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, t === FO ? (mN(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (mN(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
  };

  function yN(e, t, i, n, s) {
    this.good_length = e, this.max_lazy = t, this.nice_length = i, this.max_chain = n, this.func = s;
  }

  var AN = [new yN(0, 0, 0, 0, CN), new yN(4, 4, 8, 4, IN), new yN(4, 5, 16, 8, IN), new yN(4, 6, 32, 32, IN), new yN(4, 4, 16, 16, vN), new yN(8, 16, 32, 32, vN), new yN(8, 16, 128, 128, vN), new yN(8, 32, 128, 256, vN), new yN(32, 128, 258, 1024, vN), new yN(32, 258, 258, 4096, vN)];

  function bN() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = $O, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(2 * nN), this.dyn_dtree = new Uint16Array(2 * (2 * tN + 1)), this.bl_tree = new Uint16Array(2 * (2 * iN + 1)), hN(this.dyn_ltree), hN(this.dyn_dtree), hN(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(sN + 1), this.heap = new Uint16Array(2 * eN + 1), hN(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * eN + 1), hN(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }

  var wN = function wN(e) {
    if (!e) return 1;
    var t = e.state;
    return !t || t.strm !== e || t.status !== aN && 57 !== t.status && 69 !== t.status && 73 !== t.status && 91 !== t.status && 103 !== t.status && t.status !== cN && t.status !== dN ? 1 : 0;
  },
      ON = function ON(e) {
    if (wN(e)) return lN(e, WO);
    e.total_in = e.total_out = 0, e.data_type = ZO;
    var t = e.state;
    return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = 2 === t.wrap ? 57 : t.wrap ? aN : cN, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = -2, DO(t), jO;
  },
      NN = function NN(e) {
    var t = ON(e);
    var i;
    return t === jO && ((i = e.state).window_size = 2 * i.w_size, hN(i.head), i.max_lazy_match = AN[i.level].max_lazy, i.good_match = AN[i.level].good_length, i.nice_match = AN[i.level].nice_length, i.max_chain_length = AN[i.level].max_chain, i.strstart = 0, i.block_start = 0, i.lookahead = 0, i.insert = 0, i.match_length = i.prev_length = 2, i.match_available = 0, i.ins_h = 0), t;
  },
      DN = function DN(e, t, i, n, s, r) {
    if (!e) return WO;
    var o = 1;
    if (t === YO && (t = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), s < 1 || s > 9 || i !== $O || n < 8 || n > 15 || t < 0 || t > 9 || r < 0 || r > XO || 8 === n && 1 !== o) return lN(e, WO);
    8 === n && (n = 9);
    var a = new bN();
    return e.state = a, a.strm = e, a.status = aN, a.wrap = o, a.gzhead = null, a.w_bits = n, a.w_size = 1 << a.w_bits, a.w_mask = a.w_size - 1, a.hash_bits = s + 7, a.hash_size = 1 << a.hash_bits, a.hash_mask = a.hash_size - 1, a.hash_shift = ~~((a.hash_bits + 3 - 1) / 3), a.window = new Uint8Array(2 * a.w_size), a.head = new Uint16Array(a.hash_size), a.prev = new Uint16Array(a.w_size), a.lit_bufsize = 1 << s + 6, a.pending_buf_size = 4 * a.lit_bufsize, a.pending_buf = new Uint8Array(a.pending_buf_size), a.sym_buf = a.lit_bufsize, a.sym_end = 3 * (a.lit_bufsize - 1), a.level = t, a.strategy = r, a.method = i, NN(e);
  };

  var PN = function PN(e, t) {
    if (wN(e) || t > BO || t < 0) return e ? lN(e, WO) : WO;
    var i = e.state;
    if (!e.output || 0 !== e.avail_in && !e.input || i.status === dN && t !== FO) return lN(e, 0 === e.avail_out ? KO : WO);
    var n = i.last_flush;

    if (i.last_flush = t, 0 !== i.pending) {
      if (EN(e), 0 === e.avail_out) return i.last_flush = -1, jO;
    } else if (0 === e.avail_in && uN(t) <= uN(n) && t !== FO) return lN(e, KO);

    if (i.status === dN && 0 !== e.avail_in) return lN(e, KO);

    if (i.status === aN && 0 === i.wrap && (i.status = cN), i.status === aN) {
      var _t103 = $O + (i.w_bits - 8 << 4) << 8,
          _n47 = -1;

      if (_n47 = i.strategy >= JO || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3, _t103 |= _n47 << 6, 0 !== i.strstart && (_t103 |= 32), _t103 += 31 - _t103 % 31, TN(i, _t103), 0 !== i.strstart && (TN(i, e.adler >>> 16), TN(i, 65535 & e.adler)), e.adler = 1, i.status = cN, EN(e), 0 !== i.pending) return i.last_flush = -1, jO;
    }

    if (57 === i.status) if (e.adler = 0, fN(i, 31), fN(i, 139), fN(i, 8), i.gzhead) fN(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), fN(i, 255 & i.gzhead.time), fN(i, i.gzhead.time >> 8 & 255), fN(i, i.gzhead.time >> 16 & 255), fN(i, i.gzhead.time >> 24 & 255), fN(i, 9 === i.level ? 2 : i.strategy >= JO || i.level < 2 ? 4 : 0), fN(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (fN(i, 255 & i.gzhead.extra.length), fN(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = wO(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69;else if (fN(i, 0), fN(i, 0), fN(i, 0), fN(i, 0), fN(i, 0), fN(i, 9 === i.level ? 2 : i.strategy >= JO || i.level < 2 ? 4 : 0), fN(i, 3), i.status = cN, EN(e), 0 !== i.pending) return i.last_flush = -1, jO;

    if (69 === i.status) {
      if (i.gzhead.extra) {
        var _t104 = i.pending,
            _n48 = (65535 & i.gzhead.extra.length) - i.gzindex;

        for (; i.pending + _n48 > i.pending_buf_size;) {
          var _s28 = i.pending_buf_size - i.pending;

          if (i.pending_buf.set(i.gzhead.extra.subarray(i.gzindex, i.gzindex + _s28), i.pending), i.pending = i.pending_buf_size, i.gzhead.hcrc && i.pending > _t104 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _t104, _t104)), i.gzindex += _s28, EN(e), 0 !== i.pending) return i.last_flush = -1, jO;
          _t104 = 0, _n48 -= _s28;
        }

        var _s27 = new Uint8Array(i.gzhead.extra);

        i.pending_buf.set(_s27.subarray(i.gzindex, i.gzindex + _n48), i.pending), i.pending += _n48, i.gzhead.hcrc && i.pending > _t104 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _t104, _t104)), i.gzindex = 0;
      }

      i.status = 73;
    }

    if (73 === i.status) {
      if (i.gzhead.name) {
        var _t105,
            _n49 = i.pending;

        do {
          if (i.pending === i.pending_buf_size) {
            if (i.gzhead.hcrc && i.pending > _n49 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _n49, _n49)), EN(e), 0 !== i.pending) return i.last_flush = -1, jO;
            _n49 = 0;
          }

          _t105 = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, fN(i, _t105);
        } while (0 !== _t105);

        i.gzhead.hcrc && i.pending > _n49 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _n49, _n49)), i.gzindex = 0;
      }

      i.status = 91;
    }

    if (91 === i.status) {
      if (i.gzhead.comment) {
        var _t106,
            _n50 = i.pending;

        do {
          if (i.pending === i.pending_buf_size) {
            if (i.gzhead.hcrc && i.pending > _n50 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _n50, _n50)), EN(e), 0 !== i.pending) return i.last_flush = -1, jO;
            _n50 = 0;
          }

          _t106 = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, fN(i, _t106);
        } while (0 !== _t106);

        i.gzhead.hcrc && i.pending > _n50 && (e.adler = wO(e.adler, i.pending_buf, i.pending - _n50, _n50));
      }

      i.status = 103;
    }

    if (103 === i.status) {
      if (i.gzhead.hcrc) {
        if (i.pending + 2 > i.pending_buf_size && (EN(e), 0 !== i.pending)) return i.last_flush = -1, jO;
        fN(i, 255 & e.adler), fN(i, e.adler >> 8 & 255), e.adler = 0;
      }

      if (i.status = cN, EN(e), 0 !== i.pending) return i.last_flush = -1, jO;
    }

    if (0 !== e.avail_in || 0 !== i.lookahead || t !== UO && i.status !== dN) {
      var _n51 = 0 === i.level ? CN(i, t) : i.strategy === JO ? function (e, t) {
        var i;

        for (;;) {
          if (0 === e.lookahead && (RN(e), 0 === e.lookahead)) {
            if (t === UO) return 1;
            break;
          }

          if (e.match_length = 0, i = kO(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, i && (mN(e, !1), 0 === e.strm.avail_out)) return 1;
        }

        return e.insert = 0, t === FO ? (mN(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (mN(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
      }(i, t) : i.strategy === zO ? function (e, t) {
        var i, n, s, r;
        var o = e.window;

        for (;;) {
          if (e.lookahead <= rN) {
            if (RN(e), e.lookahead <= rN && t === UO) return 1;
            if (0 === e.lookahead) break;
          }

          if (e.match_length = 0, e.lookahead >= 3 && e.strstart > 0 && (s = e.strstart - 1, n = o[s], n === o[++s] && n === o[++s] && n === o[++s])) {
            r = e.strstart + rN;

            do {} while (n === o[++s] && n === o[++s] && n === o[++s] && n === o[++s] && n === o[++s] && n === o[++s] && n === o[++s] && n === o[++s] && s < r);

            e.match_length = rN - (r - s), e.match_length > e.lookahead && (e.match_length = e.lookahead);
          }

          if (e.match_length >= 3 ? (i = kO(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (i = kO(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), i && (mN(e, !1), 0 === e.strm.avail_out)) return 1;
        }

        return e.insert = 0, t === FO ? (mN(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (mN(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
      }(i, t) : AN[i.level].func(i, t);

      if (3 !== _n51 && 4 !== _n51 || (i.status = dN), 1 === _n51 || 3 === _n51) return 0 === e.avail_out && (i.last_flush = -1), jO;
      if (2 === _n51 && (t === xO ? MO(i) : t !== BO && (PO(i, 0, 0, !1), t === VO && (hN(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), EN(e), 0 === e.avail_out)) return i.last_flush = -1, jO;
    }

    return t !== FO ? jO : i.wrap <= 0 ? GO : (2 === i.wrap ? (fN(i, 255 & e.adler), fN(i, e.adler >> 8 & 255), fN(i, e.adler >> 16 & 255), fN(i, e.adler >> 24 & 255), fN(i, 255 & e.total_in), fN(i, e.total_in >> 8 & 255), fN(i, e.total_in >> 16 & 255), fN(i, e.total_in >> 24 & 255)) : (TN(i, e.adler >>> 16), TN(i, 65535 & e.adler)), EN(e), i.wrap > 0 && (i.wrap = -i.wrap), 0 !== i.pending ? jO : GO);
  },
      LN = function LN(e, t) {
    var i = t.length;
    if (wN(e)) return WO;
    var n = e.state,
        s = n.wrap;
    if (2 === s || 1 === s && n.status !== aN || n.lookahead) return WO;

    if (1 === s && (e.adler = AO(e.adler, t, i, 0)), n.wrap = 0, i >= n.w_size) {
      0 === s && (hN(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0);

      var _e91 = new Uint8Array(n.w_size);

      _e91.set(t.subarray(i - n.w_size, i), 0), t = _e91, i = n.w_size;
    }

    var r = e.avail_in,
        o = e.next_in,
        a = e.input;

    for (e.avail_in = i, e.next_in = 0, e.input = t, RN(n); n.lookahead >= 3;) {
      var _e92 = n.strstart,
          _t107 = n.lookahead - 2;

      do {
        n.ins_h = _N(n, n.ins_h, n.window[_e92 + 3 - 1]), n.prev[_e92 & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = _e92, _e92++;
      } while (--_t107);

      n.strstart = _e92, n.lookahead = 2, RN(n);
    }

    return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = 2, n.match_available = 0, e.next_in = o, e.input = a, e.avail_in = r, n.wrap = s, jO;
  },
      kN = {
    deflateInit: function deflateInit(e, t) {
      return DN(e, t, $O, 15, 8, QO);
    },
    deflateInit2: DN,
    deflateReset: NN,
    deflateResetKeep: ON,
    deflateSetHeader: function deflateSetHeader(e, t) {
      return wN(e) || 2 !== e.state.wrap ? WO : (e.state.gzhead = t, jO);
    },
    deflate: PN,
    deflateEnd: function deflateEnd(e) {
      if (wN(e)) return WO;
      var t = e.state.status;
      return e.state = null, t === cN ? lN(e, HO) : jO;
    },
    deflateSetDictionary: LN,
    deflateInfo: "pako deflate (from Nodeca project)"
  };

  var MN = function MN(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  };

  var UN = {
    assign: function assign(e) {
      var t = Array.prototype.slice.call(arguments, 1);

      for (; t.length;) {
        var i = t.shift();

        if (i) {
          if ("object" != _typeof(i)) throw new TypeError(i + "must be non-object");

          for (var _t108 in i) {
            MN(i, _t108) && (e[_t108] = i[_t108]);
          }
        }
      }

      return e;
    },
    flattenChunks: function flattenChunks(e) {
      var t = 0;

      for (var _i57 = 0, _n52 = e.length; _i57 < _n52; _i57++) {
        t += e[_i57].length;
      }

      var i = new Uint8Array(t);

      for (var _t109 = 0, _n53 = 0, _s29 = e.length; _t109 < _s29; _t109++) {
        var _s30 = e[_t109];
        i.set(_s30, _n53), _n53 += _s30.length;
      }

      return i;
    }
  };
  var xN = !0;

  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch (e) {
    xN = !1;
  }

  var VN = new Uint8Array(256);

  for (var e = 0; e < 256; e++) {
    VN[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
  }

  VN[254] = VN[254] = 1;
  var FN = {
    string2buf: function string2buf(e) {
      if ("function" == typeof TextEncoder && TextEncoder.prototype.encode) return new TextEncoder().encode(e);
      var t,
          i,
          n,
          s,
          r,
          o = e.length,
          a = 0;

      for (s = 0; s < o; s++) {
        i = e.charCodeAt(s), 55296 == (64512 & i) && s + 1 < o && (n = e.charCodeAt(s + 1), 56320 == (64512 & n) && (i = 65536 + (i - 55296 << 10) + (n - 56320), s++)), a += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
      }

      for (t = new Uint8Array(a), r = 0, s = 0; r < a; s++) {
        i = e.charCodeAt(s), 55296 == (64512 & i) && s + 1 < o && (n = e.charCodeAt(s + 1), 56320 == (64512 & n) && (i = 65536 + (i - 55296 << 10) + (n - 56320), s++)), i < 128 ? t[r++] = i : i < 2048 ? (t[r++] = 192 | i >>> 6, t[r++] = 128 | 63 & i) : i < 65536 ? (t[r++] = 224 | i >>> 12, t[r++] = 128 | i >>> 6 & 63, t[r++] = 128 | 63 & i) : (t[r++] = 240 | i >>> 18, t[r++] = 128 | i >>> 12 & 63, t[r++] = 128 | i >>> 6 & 63, t[r++] = 128 | 63 & i);
      }

      return t;
    },
    buf2string: function buf2string(e, t) {
      var i = t || e.length;
      if ("function" == typeof TextDecoder && TextDecoder.prototype.decode) return new TextDecoder().decode(e.subarray(0, t));
      var n, s;
      var r = new Array(2 * i);

      for (s = 0, n = 0; n < i;) {
        var _t110 = e[n++];

        if (_t110 < 128) {
          r[s++] = _t110;
          continue;
        }

        var _o11 = VN[_t110];
        if (_o11 > 4) r[s++] = 65533, n += _o11 - 1;else {
          for (_t110 &= 2 === _o11 ? 31 : 3 === _o11 ? 15 : 7; _o11 > 1 && n < i;) {
            _t110 = _t110 << 6 | 63 & e[n++], _o11--;
          }

          _o11 > 1 ? r[s++] = 65533 : _t110 < 65536 ? r[s++] = _t110 : (_t110 -= 65536, r[s++] = 55296 | _t110 >> 10 & 1023, r[s++] = 56320 | 1023 & _t110);
        }
      }

      return function (e, t) {
        if (t < 65534 && e.subarray && xN) return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
        var i = "";

        for (var _n54 = 0; _n54 < t; _n54++) {
          i += String.fromCharCode(e[_n54]);
        }

        return i;
      }(r, s);
    },
    utf8border: function utf8border(e, t) {
      (t = t || e.length) > e.length && (t = e.length);
      var i = t - 1;

      for (; i >= 0 && 128 == (192 & e[i]);) {
        i--;
      }

      return i < 0 || 0 === i ? t : i + VN[e[i]] > t ? i : t;
    }
  };

  var BN = function BN() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  };

  var jN = Object.prototype.toString,
      GN = NO.Z_NO_FLUSH,
      WN = NO.Z_SYNC_FLUSH,
      HN = NO.Z_FULL_FLUSH,
      KN = NO.Z_FINISH,
      YN = NO.Z_OK,
      qN = NO.Z_STREAM_END,
      JN = NO.Z_DEFAULT_COMPRESSION,
      zN = NO.Z_DEFAULT_STRATEGY,
      XN = NO.Z_DEFLATED;

  function QN(e) {
    this.options = UN.assign({
      level: JN,
      method: XN,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: zN
    }, e || {});
    var t = this.options;
    t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new BN(), this.strm.avail_out = 0;
    var i = kN.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
    if (i !== YN) throw new Error(OO[i]);

    if (t.header && kN.deflateSetHeader(this.strm, t.header), t.dictionary) {
      var _e93;

      if (_e93 = "string" == typeof t.dictionary ? FN.string2buf(t.dictionary) : "[object ArrayBuffer]" === jN.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, i = kN.deflateSetDictionary(this.strm, _e93), i !== YN) throw new Error(OO[i]);
      this._dict_set = !0;
    }
  }

  function ZN(e, t) {
    var i = new QN(t);
    if (i.push(e, !0), i.err) throw i.msg || OO[i.err];
    return i.result;
  }

  QN.prototype.push = function (e, t) {
    var i = this.strm,
        n = this.options.chunkSize;
    var s, r;
    if (this.ended) return !1;

    for (r = t === ~~t ? t : !0 === t ? KN : GN, "string" == typeof e ? i.input = FN.string2buf(e) : "[object ArrayBuffer]" === jN.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;;) {
      if (0 === i.avail_out && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), (r === WN || r === HN) && i.avail_out <= 6) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;else {
        if (s = kN.deflate(i, r), s === qN) return i.next_out > 0 && this.onData(i.output.subarray(0, i.next_out)), s = kN.deflateEnd(this.strm), this.onEnd(s), this.ended = !0, s === YN;

        if (0 !== i.avail_out) {
          if (r > 0 && i.next_out > 0) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;else if (0 === i.avail_in) break;
        } else this.onData(i.output);
      }
    }

    return !0;
  }, QN.prototype.onData = function (e) {
    this.chunks.push(e);
  }, QN.prototype.onEnd = function (e) {
    e === YN && (this.result = UN.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
  };
  var $N = {
    Deflate: QN,
    deflate: ZN,
    deflateRaw: function deflateRaw(e, t) {
      return (t = t || {}).raw = !0, ZN(e, t);
    },
    gzip: function gzip(e, t) {
      return (t = t || {}).gzip = !0, ZN(e, t);
    },
    constants: NO
  };
  var eD = 16209;

  var tD = function tD(e, t) {
    var i, n, s, r, o, a, c, d, l, u, h, p, _, E, m, f, T, g, S, R, C, I, v, y;

    var A = e.state;
    i = e.next_in, v = e.input, n = i + (e.avail_in - 5), s = e.next_out, y = e.output, r = s - (t - e.avail_out), o = s + (e.avail_out - 257), a = A.dmax, c = A.wsize, d = A.whave, l = A.wnext, u = A.window, h = A.hold, p = A.bits, _ = A.lencode, E = A.distcode, m = (1 << A.lenbits) - 1, f = (1 << A.distbits) - 1;

    e: do {
      p < 15 && (h += v[i++] << p, p += 8, h += v[i++] << p, p += 8), T = _[h & m];

      t: for (;;) {
        if (g = T >>> 24, h >>>= g, p -= g, g = T >>> 16 & 255, 0 === g) y[s++] = 65535 & T;else {
          if (!(16 & g)) {
            if (0 == (64 & g)) {
              T = _[(65535 & T) + (h & (1 << g) - 1)];
              continue t;
            }

            if (32 & g) {
              A.mode = 16191;
              break e;
            }

            e.msg = "invalid literal/length code", A.mode = eD;
            break e;
          }

          S = 65535 & T, g &= 15, g && (p < g && (h += v[i++] << p, p += 8), S += h & (1 << g) - 1, h >>>= g, p -= g), p < 15 && (h += v[i++] << p, p += 8, h += v[i++] << p, p += 8), T = E[h & f];

          i: for (;;) {
            if (g = T >>> 24, h >>>= g, p -= g, g = T >>> 16 & 255, !(16 & g)) {
              if (0 == (64 & g)) {
                T = E[(65535 & T) + (h & (1 << g) - 1)];
                continue i;
              }

              e.msg = "invalid distance code", A.mode = eD;
              break e;
            }

            if (R = 65535 & T, g &= 15, p < g && (h += v[i++] << p, p += 8, p < g && (h += v[i++] << p, p += 8)), R += h & (1 << g) - 1, R > a) {
              e.msg = "invalid distance too far back", A.mode = eD;
              break e;
            }

            if (h >>>= g, p -= g, g = s - r, R > g) {
              if (g = R - g, g > d && A.sane) {
                e.msg = "invalid distance too far back", A.mode = eD;
                break e;
              }

              if (C = 0, I = u, 0 === l) {
                if (C += c - g, g < S) {
                  S -= g;

                  do {
                    y[s++] = u[C++];
                  } while (--g);

                  C = s - R, I = y;
                }
              } else if (l < g) {
                if (C += c + l - g, g -= l, g < S) {
                  S -= g;

                  do {
                    y[s++] = u[C++];
                  } while (--g);

                  if (C = 0, l < S) {
                    g = l, S -= g;

                    do {
                      y[s++] = u[C++];
                    } while (--g);

                    C = s - R, I = y;
                  }
                }
              } else if (C += l - g, g < S) {
                S -= g;

                do {
                  y[s++] = u[C++];
                } while (--g);

                C = s - R, I = y;
              }

              for (; S > 2;) {
                y[s++] = I[C++], y[s++] = I[C++], y[s++] = I[C++], S -= 3;
              }

              S && (y[s++] = I[C++], S > 1 && (y[s++] = I[C++]));
            } else {
              C = s - R;

              do {
                y[s++] = y[C++], y[s++] = y[C++], y[s++] = y[C++], S -= 3;
              } while (S > 2);

              S && (y[s++] = y[C++], S > 1 && (y[s++] = y[C++]));
            }

            break;
          }
        }
        break;
      }
    } while (i < n && s < o);

    S = p >> 3, i -= S, p -= S << 3, h &= (1 << p) - 1, e.next_in = i, e.next_out = s, e.avail_in = i < n ? n - i + 5 : 5 - (i - n), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), A.hold = h, A.bits = p;
  };

  var iD = 15,
      nD = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]),
      sD = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]),
      rD = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]),
      oD = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);

  var aD = function aD(e, t, i, n, s, r, o, a) {
    var c = a.bits;

    var d,
        l,
        u,
        h,
        p,
        _,
        E = 0,
        m = 0,
        f = 0,
        T = 0,
        g = 0,
        S = 0,
        R = 0,
        C = 0,
        I = 0,
        v = 0,
        y = null;

    var A = new Uint16Array(16),
        b = new Uint16Array(16);
    var w,
        O,
        N,
        D = null;

    for (E = 0; E <= iD; E++) {
      A[E] = 0;
    }

    for (m = 0; m < n; m++) {
      A[t[i + m]]++;
    }

    for (g = c, T = iD; T >= 1 && 0 === A[T]; T--) {
      ;
    }

    if (g > T && (g = T), 0 === T) return s[r++] = 20971520, s[r++] = 20971520, a.bits = 1, 0;

    for (f = 1; f < T && 0 === A[f]; f++) {
      ;
    }

    for (g < f && (g = f), C = 1, E = 1; E <= iD; E++) {
      if (C <<= 1, C -= A[E], C < 0) return -1;
    }

    if (C > 0 && (0 === e || 1 !== T)) return -1;

    for (b[1] = 0, E = 1; E < iD; E++) {
      b[E + 1] = b[E] + A[E];
    }

    for (m = 0; m < n; m++) {
      0 !== t[i + m] && (o[b[t[i + m]]++] = m);
    }

    if (0 === e ? (y = D = o, _ = 20) : 1 === e ? (y = nD, D = sD, _ = 257) : (y = rD, D = oD, _ = 0), v = 0, m = 0, E = f, p = r, S = g, R = 0, u = -1, I = 1 << g, h = I - 1, 1 === e && I > 852 || 2 === e && I > 592) return 1;

    for (;;) {
      w = E - R, o[m] + 1 < _ ? (O = 0, N = o[m]) : o[m] >= _ ? (O = D[o[m] - _], N = y[o[m] - _]) : (O = 96, N = 0), d = 1 << E - R, l = 1 << S, f = l;

      do {
        l -= d, s[p + (v >> R) + l] = w << 24 | O << 16 | N | 0;
      } while (0 !== l);

      for (d = 1 << E - 1; v & d;) {
        d >>= 1;
      }

      if (0 !== d ? (v &= d - 1, v += d) : v = 0, m++, 0 == --A[E]) {
        if (E === T) break;
        E = t[i + o[m]];
      }

      if (E > g && (v & h) !== u) {
        for (0 === R && (R = g), p += f, S = E - R, C = 1 << S; S + R < T && (C -= A[S + R], !(C <= 0));) {
          S++, C <<= 1;
        }

        if (I += 1 << S, 1 === e && I > 852 || 2 === e && I > 592) return 1;
        u = v & h, s[u] = g << 24 | S << 16 | p - r | 0;
      }
    }

    return 0 !== v && (s[p + v] = E - R << 24 | 64 << 16 | 0), a.bits = g, 0;
  };

  var cD = NO.Z_FINISH,
      dD = NO.Z_BLOCK,
      lD = NO.Z_TREES,
      uD = NO.Z_OK,
      hD = NO.Z_STREAM_END,
      pD = NO.Z_NEED_DICT,
      _D = NO.Z_STREAM_ERROR,
      ED = NO.Z_DATA_ERROR,
      mD = NO.Z_MEM_ERROR,
      fD = NO.Z_BUF_ERROR,
      TD = NO.Z_DEFLATED,
      gD = 16180,
      SD = 16190,
      RD = 16191,
      CD = 16192,
      ID = 16194,
      vD = 16199,
      yD = 16200,
      AD = 16206,
      bD = 16209,
      wD = function wD(e) {
    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
  };

  function OD() {
    this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }

  var ND = function ND(e) {
    if (!e) return 1;
    var t = e.state;
    return !t || t.strm !== e || t.mode < gD || t.mode > 16211 ? 1 : 0;
  },
      DD = function DD(e) {
    if (ND(e)) return _D;
    var t = e.state;
    return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = gD, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(852), t.distcode = t.distdyn = new Int32Array(592), t.sane = 1, t.back = -1, uD;
  },
      PD = function PD(e) {
    if (ND(e)) return _D;
    var t = e.state;
    return t.wsize = 0, t.whave = 0, t.wnext = 0, DD(e);
  },
      LD = function LD(e, t) {
    var i;
    if (ND(e)) return _D;
    var n = e.state;
    return t < 0 ? (i = 0, t = -t) : (i = 5 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? _D : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = i, n.wbits = t, PD(e));
  },
      kD = function kD(e, t) {
    if (!e) return _D;
    var i = new OD();
    e.state = i, i.strm = e, i.window = null, i.mode = gD;
    var n = LD(e, t);
    return n !== uD && (e.state = null), n;
  };

  var MD,
      UD,
      xD = !0;

  var VD = function VD(e) {
    if (xD) {
      MD = new Int32Array(512), UD = new Int32Array(32);
      var _t111 = 0;

      for (; _t111 < 144;) {
        e.lens[_t111++] = 8;
      }

      for (; _t111 < 256;) {
        e.lens[_t111++] = 9;
      }

      for (; _t111 < 280;) {
        e.lens[_t111++] = 7;
      }

      for (; _t111 < 288;) {
        e.lens[_t111++] = 8;
      }

      for (aD(1, e.lens, 0, 288, MD, 0, e.work, {
        bits: 9
      }), _t111 = 0; _t111 < 32;) {
        e.lens[_t111++] = 5;
      }

      aD(2, e.lens, 0, 32, UD, 0, e.work, {
        bits: 5
      }), xD = !1;
    }

    e.lencode = MD, e.lenbits = 9, e.distcode = UD, e.distbits = 5;
  },
      FD = function FD(e, t, i, n) {
    var s;
    var r = e.state;
    return null === r.window && (r.wsize = 1 << r.wbits, r.wnext = 0, r.whave = 0, r.window = new Uint8Array(r.wsize)), n >= r.wsize ? (r.window.set(t.subarray(i - r.wsize, i), 0), r.wnext = 0, r.whave = r.wsize) : (s = r.wsize - r.wnext, s > n && (s = n), r.window.set(t.subarray(i - n, i - n + s), r.wnext), (n -= s) ? (r.window.set(t.subarray(i - n, i), 0), r.wnext = n, r.whave = r.wsize) : (r.wnext += s, r.wnext === r.wsize && (r.wnext = 0), r.whave < r.wsize && (r.whave += s))), 0;
  };

  var BD = function BD(e, t) {
    var i,
        n,
        s,
        r,
        o,
        a,
        c,
        d,
        l,
        u,
        h,
        p,
        _,
        E,
        m,
        f,
        T,
        g,
        S,
        R,
        C,
        I,
        v = 0;

    var y = new Uint8Array(4);
    var A, b;
    var w = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
    if (ND(e) || !e.output || !e.input && 0 !== e.avail_in) return _D;
    i = e.state, i.mode === RD && (i.mode = CD), o = e.next_out, s = e.output, c = e.avail_out, r = e.next_in, n = e.input, a = e.avail_in, d = i.hold, l = i.bits, u = a, h = c, I = uD;

    e: for (;;) {
      switch (i.mode) {
        case gD:
          if (0 === i.wrap) {
            i.mode = CD;
            break;
          }

          for (; l < 16;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if (2 & i.wrap && 35615 === d) {
            0 === i.wbits && (i.wbits = 15), i.check = 0, y[0] = 255 & d, y[1] = d >>> 8 & 255, i.check = wO(i.check, y, 2, 0), d = 0, l = 0, i.mode = 16181;
            break;
          }

          if (i.head && (i.head.done = !1), !(1 & i.wrap) || (((255 & d) << 8) + (d >> 8)) % 31) {
            e.msg = "incorrect header check", i.mode = bD;
            break;
          }

          if ((15 & d) !== TD) {
            e.msg = "unknown compression method", i.mode = bD;
            break;
          }

          if (d >>>= 4, l -= 4, C = 8 + (15 & d), 0 === i.wbits && (i.wbits = C), C > 15 || C > i.wbits) {
            e.msg = "invalid window size", i.mode = bD;
            break;
          }

          i.dmax = 1 << i.wbits, i.flags = 0, e.adler = i.check = 1, i.mode = 512 & d ? 16189 : RD, d = 0, l = 0;
          break;

        case 16181:
          for (; l < 16;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if (i.flags = d, (255 & i.flags) !== TD) {
            e.msg = "unknown compression method", i.mode = bD;
            break;
          }

          if (57344 & i.flags) {
            e.msg = "unknown header flags set", i.mode = bD;
            break;
          }

          i.head && (i.head.text = d >> 8 & 1), 512 & i.flags && 4 & i.wrap && (y[0] = 255 & d, y[1] = d >>> 8 & 255, i.check = wO(i.check, y, 2, 0)), d = 0, l = 0, i.mode = 16182;

        case 16182:
          for (; l < 32;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          i.head && (i.head.time = d), 512 & i.flags && 4 & i.wrap && (y[0] = 255 & d, y[1] = d >>> 8 & 255, y[2] = d >>> 16 & 255, y[3] = d >>> 24 & 255, i.check = wO(i.check, y, 4, 0)), d = 0, l = 0, i.mode = 16183;

        case 16183:
          for (; l < 16;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          i.head && (i.head.xflags = 255 & d, i.head.os = d >> 8), 512 & i.flags && 4 & i.wrap && (y[0] = 255 & d, y[1] = d >>> 8 & 255, i.check = wO(i.check, y, 2, 0)), d = 0, l = 0, i.mode = 16184;

        case 16184:
          if (1024 & i.flags) {
            for (; l < 16;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            i.length = d, i.head && (i.head.extra_len = d), 512 & i.flags && 4 & i.wrap && (y[0] = 255 & d, y[1] = d >>> 8 & 255, i.check = wO(i.check, y, 2, 0)), d = 0, l = 0;
          } else i.head && (i.head.extra = null);

          i.mode = 16185;

        case 16185:
          if (1024 & i.flags && (p = i.length, p > a && (p = a), p && (i.head && (C = i.head.extra_len - i.length, i.head.extra || (i.head.extra = new Uint8Array(i.head.extra_len)), i.head.extra.set(n.subarray(r, r + p), C)), 512 & i.flags && 4 & i.wrap && (i.check = wO(i.check, n, p, r)), a -= p, r += p, i.length -= p), i.length)) break e;
          i.length = 0, i.mode = 16186;

        case 16186:
          if (2048 & i.flags) {
            if (0 === a) break e;
            p = 0;

            do {
              C = n[r + p++], i.head && C && i.length < 65536 && (i.head.name += String.fromCharCode(C));
            } while (C && p < a);

            if (512 & i.flags && 4 & i.wrap && (i.check = wO(i.check, n, p, r)), a -= p, r += p, C) break e;
          } else i.head && (i.head.name = null);

          i.length = 0, i.mode = 16187;

        case 16187:
          if (4096 & i.flags) {
            if (0 === a) break e;
            p = 0;

            do {
              C = n[r + p++], i.head && C && i.length < 65536 && (i.head.comment += String.fromCharCode(C));
            } while (C && p < a);

            if (512 & i.flags && 4 & i.wrap && (i.check = wO(i.check, n, p, r)), a -= p, r += p, C) break e;
          } else i.head && (i.head.comment = null);

          i.mode = 16188;

        case 16188:
          if (512 & i.flags) {
            for (; l < 16;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            if (4 & i.wrap && d !== (65535 & i.check)) {
              e.msg = "header crc mismatch", i.mode = bD;
              break;
            }

            d = 0, l = 0;
          }

          i.head && (i.head.hcrc = i.flags >> 9 & 1, i.head.done = !0), e.adler = i.check = 0, i.mode = RD;
          break;

        case 16189:
          for (; l < 32;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          e.adler = i.check = wD(d), d = 0, l = 0, i.mode = SD;

        case SD:
          if (0 === i.havedict) return e.next_out = o, e.avail_out = c, e.next_in = r, e.avail_in = a, i.hold = d, i.bits = l, pD;
          e.adler = i.check = 1, i.mode = RD;

        case RD:
          if (t === dD || t === lD) break e;

        case CD:
          if (i.last) {
            d >>>= 7 & l, l -= 7 & l, i.mode = AD;
            break;
          }

          for (; l < 3;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          switch (i.last = 1 & d, d >>>= 1, l -= 1, 3 & d) {
            case 0:
              i.mode = 16193;
              break;

            case 1:
              if (VD(i), i.mode = vD, t === lD) {
                d >>>= 2, l -= 2;
                break e;
              }

              break;

            case 2:
              i.mode = 16196;
              break;

            case 3:
              e.msg = "invalid block type", i.mode = bD;
          }

          d >>>= 2, l -= 2;
          break;

        case 16193:
          for (d >>>= 7 & l, l -= 7 & l; l < 32;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if ((65535 & d) != (d >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", i.mode = bD;
            break;
          }

          if (i.length = 65535 & d, d = 0, l = 0, i.mode = ID, t === lD) break e;

        case ID:
          i.mode = 16195;

        case 16195:
          if (p = i.length, p) {
            if (p > a && (p = a), p > c && (p = c), 0 === p) break e;
            s.set(n.subarray(r, r + p), o), a -= p, r += p, c -= p, o += p, i.length -= p;
            break;
          }

          i.mode = RD;
          break;

        case 16196:
          for (; l < 14;) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if (i.nlen = 257 + (31 & d), d >>>= 5, l -= 5, i.ndist = 1 + (31 & d), d >>>= 5, l -= 5, i.ncode = 4 + (15 & d), d >>>= 4, l -= 4, i.nlen > 286 || i.ndist > 30) {
            e.msg = "too many length or distance symbols", i.mode = bD;
            break;
          }

          i.have = 0, i.mode = 16197;

        case 16197:
          for (; i.have < i.ncode;) {
            for (; l < 3;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            i.lens[w[i.have++]] = 7 & d, d >>>= 3, l -= 3;
          }

          for (; i.have < 19;) {
            i.lens[w[i.have++]] = 0;
          }

          if (i.lencode = i.lendyn, i.lenbits = 7, A = {
            bits: i.lenbits
          }, I = aD(0, i.lens, 0, 19, i.lencode, 0, i.work, A), i.lenbits = A.bits, I) {
            e.msg = "invalid code lengths set", i.mode = bD;
            break;
          }

          i.have = 0, i.mode = 16198;

        case 16198:
          for (; i.have < i.nlen + i.ndist;) {
            for (; v = i.lencode[d & (1 << i.lenbits) - 1], m = v >>> 24, f = v >>> 16 & 255, T = 65535 & v, !(m <= l);) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            if (T < 16) d >>>= m, l -= m, i.lens[i.have++] = T;else {
              if (16 === T) {
                for (b = m + 2; l < b;) {
                  if (0 === a) break e;
                  a--, d += n[r++] << l, l += 8;
                }

                if (d >>>= m, l -= m, 0 === i.have) {
                  e.msg = "invalid bit length repeat", i.mode = bD;
                  break;
                }

                C = i.lens[i.have - 1], p = 3 + (3 & d), d >>>= 2, l -= 2;
              } else if (17 === T) {
                for (b = m + 3; l < b;) {
                  if (0 === a) break e;
                  a--, d += n[r++] << l, l += 8;
                }

                d >>>= m, l -= m, C = 0, p = 3 + (7 & d), d >>>= 3, l -= 3;
              } else {
                for (b = m + 7; l < b;) {
                  if (0 === a) break e;
                  a--, d += n[r++] << l, l += 8;
                }

                d >>>= m, l -= m, C = 0, p = 11 + (127 & d), d >>>= 7, l -= 7;
              }

              if (i.have + p > i.nlen + i.ndist) {
                e.msg = "invalid bit length repeat", i.mode = bD;
                break;
              }

              for (; p--;) {
                i.lens[i.have++] = C;
              }
            }
          }

          if (i.mode === bD) break;

          if (0 === i.lens[256]) {
            e.msg = "invalid code -- missing end-of-block", i.mode = bD;
            break;
          }

          if (i.lenbits = 9, A = {
            bits: i.lenbits
          }, I = aD(1, i.lens, 0, i.nlen, i.lencode, 0, i.work, A), i.lenbits = A.bits, I) {
            e.msg = "invalid literal/lengths set", i.mode = bD;
            break;
          }

          if (i.distbits = 6, i.distcode = i.distdyn, A = {
            bits: i.distbits
          }, I = aD(2, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, A), i.distbits = A.bits, I) {
            e.msg = "invalid distances set", i.mode = bD;
            break;
          }

          if (i.mode = vD, t === lD) break e;

        case vD:
          i.mode = yD;

        case yD:
          if (a >= 6 && c >= 258) {
            e.next_out = o, e.avail_out = c, e.next_in = r, e.avail_in = a, i.hold = d, i.bits = l, tD(e, h), o = e.next_out, s = e.output, c = e.avail_out, r = e.next_in, n = e.input, a = e.avail_in, d = i.hold, l = i.bits, i.mode === RD && (i.back = -1);
            break;
          }

          for (i.back = 0; v = i.lencode[d & (1 << i.lenbits) - 1], m = v >>> 24, f = v >>> 16 & 255, T = 65535 & v, !(m <= l);) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if (f && 0 == (240 & f)) {
            for (g = m, S = f, R = T; v = i.lencode[R + ((d & (1 << g + S) - 1) >> g)], m = v >>> 24, f = v >>> 16 & 255, T = 65535 & v, !(g + m <= l);) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            d >>>= g, l -= g, i.back += g;
          }

          if (d >>>= m, l -= m, i.back += m, i.length = T, 0 === f) {
            i.mode = 16205;
            break;
          }

          if (32 & f) {
            i.back = -1, i.mode = RD;
            break;
          }

          if (64 & f) {
            e.msg = "invalid literal/length code", i.mode = bD;
            break;
          }

          i.extra = 15 & f, i.mode = 16201;

        case 16201:
          if (i.extra) {
            for (b = i.extra; l < b;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            i.length += d & (1 << i.extra) - 1, d >>>= i.extra, l -= i.extra, i.back += i.extra;
          }

          i.was = i.length, i.mode = 16202;

        case 16202:
          for (; v = i.distcode[d & (1 << i.distbits) - 1], m = v >>> 24, f = v >>> 16 & 255, T = 65535 & v, !(m <= l);) {
            if (0 === a) break e;
            a--, d += n[r++] << l, l += 8;
          }

          if (0 == (240 & f)) {
            for (g = m, S = f, R = T; v = i.distcode[R + ((d & (1 << g + S) - 1) >> g)], m = v >>> 24, f = v >>> 16 & 255, T = 65535 & v, !(g + m <= l);) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            d >>>= g, l -= g, i.back += g;
          }

          if (d >>>= m, l -= m, i.back += m, 64 & f) {
            e.msg = "invalid distance code", i.mode = bD;
            break;
          }

          i.offset = T, i.extra = 15 & f, i.mode = 16203;

        case 16203:
          if (i.extra) {
            for (b = i.extra; l < b;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            i.offset += d & (1 << i.extra) - 1, d >>>= i.extra, l -= i.extra, i.back += i.extra;
          }

          if (i.offset > i.dmax) {
            e.msg = "invalid distance too far back", i.mode = bD;
            break;
          }

          i.mode = 16204;

        case 16204:
          if (0 === c) break e;

          if (p = h - c, i.offset > p) {
            if (p = i.offset - p, p > i.whave && i.sane) {
              e.msg = "invalid distance too far back", i.mode = bD;
              break;
            }

            p > i.wnext ? (p -= i.wnext, _ = i.wsize - p) : _ = i.wnext - p, p > i.length && (p = i.length), E = i.window;
          } else E = s, _ = o - i.offset, p = i.length;

          p > c && (p = c), c -= p, i.length -= p;

          do {
            s[o++] = E[_++];
          } while (--p);

          0 === i.length && (i.mode = yD);
          break;

        case 16205:
          if (0 === c) break e;
          s[o++] = i.length, c--, i.mode = yD;
          break;

        case AD:
          if (i.wrap) {
            for (; l < 32;) {
              if (0 === a) break e;
              a--, d |= n[r++] << l, l += 8;
            }

            if (h -= c, e.total_out += h, i.total += h, 4 & i.wrap && h && (e.adler = i.check = i.flags ? wO(i.check, s, h, o - h) : AO(i.check, s, h, o - h)), h = c, 4 & i.wrap && (i.flags ? d : wD(d)) !== i.check) {
              e.msg = "incorrect data check", i.mode = bD;
              break;
            }

            d = 0, l = 0;
          }

          i.mode = 16207;

        case 16207:
          if (i.wrap && i.flags) {
            for (; l < 32;) {
              if (0 === a) break e;
              a--, d += n[r++] << l, l += 8;
            }

            if (4 & i.wrap && d !== (4294967295 & i.total)) {
              e.msg = "incorrect length check", i.mode = bD;
              break;
            }

            d = 0, l = 0;
          }

          i.mode = 16208;

        case 16208:
          I = hD;
          break e;

        case bD:
          I = ED;
          break e;

        case 16210:
          return mD;

        default:
          return _D;
      }
    }

    return e.next_out = o, e.avail_out = c, e.next_in = r, e.avail_in = a, i.hold = d, i.bits = l, (i.wsize || h !== e.avail_out && i.mode < bD && (i.mode < AD || t !== cD)) && FD(e, e.output, e.next_out, h - e.avail_out), u -= e.avail_in, h -= e.avail_out, e.total_in += u, e.total_out += h, i.total += h, 4 & i.wrap && h && (e.adler = i.check = i.flags ? wO(i.check, s, h, e.next_out - h) : AO(i.check, s, h, e.next_out - h)), e.data_type = i.bits + (i.last ? 64 : 0) + (i.mode === RD ? 128 : 0) + (i.mode === vD || i.mode === ID ? 256 : 0), (0 === u && 0 === h || t === cD) && I === uD && (I = fD), I;
  },
      jD = {
    inflateReset: PD,
    inflateReset2: LD,
    inflateResetKeep: DD,
    inflateInit: function inflateInit(e) {
      return kD(e, 15);
    },
    inflateInit2: kD,
    inflate: BD,
    inflateEnd: function inflateEnd(e) {
      if (ND(e)) return _D;
      var t = e.state;
      return t.window && (t.window = null), e.state = null, uD;
    },
    inflateGetHeader: function inflateGetHeader(e, t) {
      if (ND(e)) return _D;
      var i = e.state;
      return 0 == (2 & i.wrap) ? _D : (i.head = t, t.done = !1, uD);
    },
    inflateSetDictionary: function inflateSetDictionary(e, t) {
      var i = t.length;
      var n, s, r;
      return ND(e) ? _D : (n = e.state, 0 !== n.wrap && n.mode !== SD ? _D : n.mode === SD && (s = 1, s = AO(s, t, i, 0), s !== n.check) ? ED : (r = FD(e, t, i, i), r ? (n.mode = 16210, mD) : (n.havedict = 1, uD)));
    },
    inflateInfo: "pako inflate (from Nodeca project)"
  };

  var GD = function GD() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  };

  var WD = Object.prototype.toString,
      HD = NO.Z_NO_FLUSH,
      KD = NO.Z_FINISH,
      YD = NO.Z_OK,
      qD = NO.Z_STREAM_END,
      JD = NO.Z_NEED_DICT,
      zD = NO.Z_STREAM_ERROR,
      XD = NO.Z_DATA_ERROR,
      QD = NO.Z_MEM_ERROR;

  function ZD(e) {
    this.options = UN.assign({
      chunkSize: 65536,
      windowBits: 15,
      to: ""
    }, e || {});
    var t = this.options;
    t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new BN(), this.strm.avail_out = 0;
    var i = jD.inflateInit2(this.strm, t.windowBits);
    if (i !== YD) throw new Error(OO[i]);
    if (this.header = new GD(), jD.inflateGetHeader(this.strm, this.header), t.dictionary && ("string" == typeof t.dictionary ? t.dictionary = FN.string2buf(t.dictionary) : "[object ArrayBuffer]" === WD.call(t.dictionary) && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (i = jD.inflateSetDictionary(this.strm, t.dictionary), i !== YD))) throw new Error(OO[i]);
  }

  function $D(e, t) {
    var i = new ZD(t);
    if (i.push(e), i.err) throw i.msg || OO[i.err];
    return i.result;
  }

  ZD.prototype.push = function (e, t) {
    var i = this.strm,
        n = this.options.chunkSize,
        s = this.options.dictionary;
    var r, o, a;
    if (this.ended) return !1;

    for (o = t === ~~t ? t : !0 === t ? KD : HD, "[object ArrayBuffer]" === WD.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;;) {
      for (0 === i.avail_out && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), r = jD.inflate(i, o), r === JD && s && (r = jD.inflateSetDictionary(i, s), r === YD ? r = jD.inflate(i, o) : r === XD && (r = JD)); i.avail_in > 0 && r === qD && i.state.wrap > 0 && 0 !== e[i.next_in];) {
        jD.inflateReset(i), r = jD.inflate(i, o);
      }

      switch (r) {
        case zD:
        case XD:
        case JD:
        case QD:
          return this.onEnd(r), this.ended = !0, !1;
      }

      if (a = i.avail_out, i.next_out && (0 === i.avail_out || r === qD)) if ("string" === this.options.to) {
        var _e94 = FN.utf8border(i.output, i.next_out),
            _t112 = i.next_out - _e94,
            _s31 = FN.buf2string(i.output, _e94);

        i.next_out = _t112, i.avail_out = n - _t112, _t112 && i.output.set(i.output.subarray(_e94, _e94 + _t112), 0), this.onData(_s31);
      } else this.onData(i.output.length === i.next_out ? i.output : i.output.subarray(0, i.next_out));

      if (r !== YD || 0 !== a) {
        if (r === qD) return r = jD.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, !0;
        if (0 === i.avail_in) break;
      }
    }

    return !0;
  }, ZD.prototype.onData = function (e) {
    this.chunks.push(e);
  }, ZD.prototype.onEnd = function (e) {
    e === YD && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = UN.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
  };
  var eP = {
    Inflate: ZD,
    inflate: $D,
    inflateRaw: function inflateRaw(e, t) {
      return (t = t || {}).raw = !0, $D(e, t);
    },
    ungzip: $D,
    constants: NO
  };
  var tP = $N.Deflate,
      iP = $N.deflate,
      nP = $N.deflateRaw,
      sP = $N.gzip,
      rP = eP.Inflate,
      oP = eP.inflate,
      aP = eP.inflateRaw,
      cP = eP.ungzip;
  var dP,
      lP = iP,
      uP = oP;
  !function (e) {
    e[e.ONE_BYTE = 0] = "ONE_BYTE", e[e.TWO_BYTE = 1] = "TWO_BYTE";
  }(dP || (dP = {}));

  var hP = /*#__PURE__*/function () {
    function hP() {
      _classCallCheck(this, hP);

      nh(this, "_sequence", 0), nh(this, "_startTime", Date.now()), nh(this, "isUseOneByte", !0);
    }

    _createClass(hP, [{
      key: "startTime",
      get: function get() {
        var e = Date.now() - this._startTime;

        return e < Math.pow(2, 16) ? e : (this._startTime += Math.pow(2, 16), this.startTime);
      }
    }, {
      key: "sequence",
      get: function get() {
        return this._sequence < Math.pow(2, 32) ? this._sequence++ : (this._sequence -= Math.pow(2, 32), this.sequence);
      }
    }, {
      key: "serialize",
      value: function serialize(e) {
        var t = {
          commonPacketHeader: {
            length: 0,
            reserved: 0,
            extension: 0,
            sequence: this.sequence
          },
          commonStreamHeader: this.startTime,
          extension: void 0,
          payload: e
        };

        if (e.byteLength > 128) {
          var _i58 = new Uint8Array(4);

          _i58.set([1, 0, 0, 0]);

          var _n55 = {
            id: 0,
            length: 4,
            data: _i58.buffer
          },
              _s32 = {
            profile: this.isUseOneByte ? 0 : 1,
            length: this.isUseOneByte ? 5 : 6,
            datas: [_n55]
          };
          t.commonPacketHeader.extension = 1, t.extension = _s32, t.payload = this.compress(e), t.commonPacketHeader.length = 8 + (t.extension.length + 2) + t.payload.byteLength;
        } else t.commonPacketHeader.length = 8 + t.payload.byteLength;

        DC("SHOW_DATASTREAM2_LOG") && YC.debug("send data header: ".concat(JSON.stringify(t.commonPacketHeader)));
        var i = new ArrayBuffer(t.commonPacketHeader.length),
            n = new Uint8Array(i),
            s = new DataView(i);
        var r = 0;

        if (s.setUint16(r, t.commonPacketHeader.extension << 15 | t.commonPacketHeader.reserved << 14 | t.commonPacketHeader.length, !0), r += 2, s.setUint32(r, t.commonPacketHeader.sequence, !0), r += 4, s.setUint16(r, t.commonStreamHeader, !0), r += 2, t.extension) {
          var _e95 = this.serializeExtension(t.extension);

          n.set(new Uint8Array(_e95), r), r += _e95.byteLength;
        }

        if (n.set(new Uint8Array(t.payload), r), r += t.payload.byteLength, r !== t.commonPacketHeader.length) throw Error("serialize error!");
        return i;
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        if (e.byteLength < 4) return new ArrayBuffer(0);
        var t = new DataView(e);
        var i = 0;
        var n = t.getUint16(i, !0);
        i += 2;
        var s = {
          length: 16383 & n,
          reserved: (16384 & n) >> 14,
          extension: (32768 & n) >> 15,
          sequence: t.getUint16(i + 2, !0) << 16 | t.getUint16(i, !0)
        };
        var r, o;

        if (i += 4, DC("SHOW_DATASTREAM2_LOG") && YC.debug("receive data header: ".concat(JSON.stringify(s))), t.getUint16(i, !0), i += 2, s.extension) {
          o = this.deserializeExtension(e.slice(i)), i += 2 + o.length, r = e.slice(i);

          var _t113 = !1;

          if (o.datas.length > 0) {
            var _e96 = o.datas.find(function (e) {
              return 0 === e.id;
            });

            if (_e96) {
              _t113 = 1 == (1 & new DataView(_e96.data).getUint32(0, !0));
            }
          }

          r = _t113 ? this.decompress(r) : r;
        } else r = e.slice(8);

        return r;
      }
    }, {
      key: "serializeExtension",
      value: function serializeExtension(e) {
        var t = e.profile,
            i = e.length,
            n = e.datas,
            s = new ArrayBuffer(i + 2),
            r = new Uint8Array(s),
            o = new DataView(s);
        var a = 0;
        if (o.setUint8(a++, t), o.setUint8(a++, i), n.forEach(function (e) {
          t ? (o.setUint8(a++, e.id), o.setUint8(a++, e.length), r.set(new Uint8Array(e.data), a), a += e.data.byteLength) : (o.setUint8(a++, e.id | e.length << 4), r.set(new Uint8Array(e.data), a), a += e.data.byteLength);
        }), a !== i + 2) throw Error("serialize extension error, is ".concat(a, "!==").concat(i + 2));
        return s;
      }
    }, {
      key: "deserializeExtension",
      value: function deserializeExtension(e) {
        var t = new DataView(e);
        var i = 0;
        var n = t.getUint8(i);
        i++;
        var s = t.getUint8(i);
        i++;
        var r = n === dP.TWO_BYTE,
            o = [],
            a = new DataView(e, 2);
        var c = 0;

        for (; c < s;) {
          var _e97 = 0,
              _t114 = 0,
              _i59 = new ArrayBuffer(0);

          r ? (_e97 = a.getUint8(c), c++, _t114 = a.getUint8(c), c++) : (_e97 = 15 & a.getUint8(c), _t114 = a.getUint8(c) >> 4, c++), _t114 > 0 && (_i59 = a.buffer.slice(c + 2, c + 2 + _t114), c += _i59.byteLength), o.push({
            id: _e97,
            length: _t114,
            data: _i59
          });
        }

        if (c !== s) throw Error("parse error");
        return {
          profile: n,
          length: s,
          datas: o
        };
      }
    }, {
      key: "decompress",
      value: function decompress(e) {
        return uP(new Uint8Array(e));
      }
    }, {
      key: "compress",
      value: function compress(e) {
        return lP(new Uint8Array(e));
      }
    }]);

    return hP;
  }();

  var pP = /*#__PURE__*/function (_ig23) {
    _inherits(pP, _ig23);

    var _super42 = _createSuper(pP);

    function pP(e, t) {
      var _this149;

      _classCallCheck(this, pP);

      _this149 = _super42.call(this), nh(_assertThisInitialized(_this149), "_version", 1), nh(_assertThisInitialized(_this149), "_type", 3), nh(_assertThisInitialized(_this149), "_config", void 0), nh(_assertThisInitialized(_this149), "_originDataChannel", void 0), nh(_assertThisInitialized(_this149), "_dataStreamPacketHeader", new ArrayBuffer(4)), nh(_assertThisInitialized(_this149), "_dataStreamPacketHandler", void 0), nh(_assertThisInitialized(_this149), "_datachannelEventMap", new Map()), _this149._config = e, t && (_this149._originDataChannel = t, _this149._bandDataChannelEvents(t)), _this149._initPacketHeader(), _this149._dataStreamPacketHandler = new hP();
      return _this149;
    }

    _createClass(pP, [{
      key: "id",
      get: function get() {
        return this._config.id;
      }
    }, {
      key: "ordered",
      get: function get() {
        return this._config.ordered;
      }
    }, {
      key: "maxRetransmits",
      get: function get() {
        return DC("DATASTREAM_MAX_RETRANSMITS");
      }
    }, {
      key: "metadata",
      get: function get() {
        return this._config.metadata;
      }
    }, {
      key: "readyState",
      get: function get() {
        var e, t;
        return null !== (e = null === (t = this._originDataChannel) || void 0 === t ? void 0 : t.readyState) && void 0 !== e ? e : "connecting";
      }
    }, {
      key: "_originDataChannelId",
      get: function get() {
        var e, t;
        return null !== (e = null === (t = this._originDataChannel) || void 0 === t ? void 0 : t.id) && void 0 !== e ? e : null;
      }
    }, {
      key: "getChannelId",
      value: function getChannelId() {
        return this.id;
      }
    }, {
      key: "getConfig",
      value: function getConfig() {
        return this._config;
      }
    }, {
      key: "_close",
      value: function _close() {
        this._originDataChannel && (this._unbindDataChannelEvents(this._originDataChannel), this._originDataChannel = void 0);
      }
    }, {
      key: "_waitTillOpen",
      value: function () {
        var _waitTillOpen2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee146() {
          var _this150 = this;

          return _regeneratorRuntime.wrap(function _callee146$(_context146) {
            while (1) {
              switch (_context146.prev = _context146.next) {
                case 0:
                  return _context146.abrupt("return", new tT(function (e, t) {
                    if (_this150._originDataChannel) {
                      "open" === _this150._originDataChannel.readyState && e();
                      var i = setTimeout(function () {
                        var e;
                        t(new VT(xT.DATACHANNEL_CONNECTION_TIMEOUT, "Cannot create datachannel, id: ".concat(null === (e = _this150._originDataChannel) || void 0 === e ? void 0 : e.id)));
                      }, 1e4);
                      _this150._originDataChannel.onopen = function () {
                        clearTimeout(i), _this150._originDataChannel && _this150._bandDataChannelEvents(_this150._originDataChannel), e();
                      }, _this150._originDataChannel.onerror = function () {
                        throw clearTimeout(i), new VT(xT.DATACHANNEL_CONNECTION_TIMEOUT);
                      };
                    } else t(new VT(xT.DATACHANNEL_CONNECTION_TIMEOUT, "cannot find dataChannel"));
                  }));

                case 1:
                case "end":
                  return _context146.stop();
              }
            }
          }, _callee146);
        }));

        function _waitTillOpen() {
          return _waitTillOpen2.apply(this, arguments);
        }

        return _waitTillOpen;
      }()
    }, {
      key: "_updateOriginDataChannel",
      value: function _updateOriginDataChannel(e) {
        this._originDataChannel = e, this._bandDataChannelEvents(e);
      }
    }, {
      key: "_initPacketHeader",
      value: function _initPacketHeader() {
        var e = new DataView(this._dataStreamPacketHeader);
        e.setUint16(0, this._version), e.setUint8(2, this._type), e.setUint8(3, this._config.id);
      }
    }, {
      key: "_bandDataChannelEvents",
      value: function _bandDataChannelEvents(e) {
        var _this151 = this;

        this._unbindDataChannelEvents(e), [hb.OPEN, hb.CLOSE, hb.ERROR].forEach(function (t) {
          var i = function i() {
            _this151.emit(t);
          };

          _this151._datachannelEventMap.set(t, i), e.addEventListener(t, i);
        });
      }
    }, {
      key: "_unbindDataChannelEvents",
      value: function _unbindDataChannelEvents(e) {
        Array.from(this._datachannelEventMap.entries()).forEach(function (t) {
          var _t115 = _slicedToArray(t, 2),
              i = _t115[0],
              n = _t115[1];

          e.removeEventListener(i, n);
        }), this._datachannelEventMap.clear();
      }
    }]);

    return pP;
  }(ig);

  var _P = /*#__PURE__*/function (_pP) {
    _inherits(_P, _pP);

    var _super43 = _createSuper(_P);

    function _P(e) {
      var _this152;

      _classCallCheck(this, _P);

      _this152 = _super43.call(this, e), nh(_assertThisInitialized(_this152), "_messageListener", void 0), _this152._messageListener = function (e) {
        if (e.data.byteLength < _this152._dataStreamPacketHeader.byteLength) throw Error("invalid byteLength: the byte length must exceed " + _this152._dataStreamPacketHeader.byteLength);
        var t = e.data.slice(0, _this152._dataStreamPacketHeader.byteLength),
            i = new DataView(t).getUint8(3);
        if (i !== _this152.id) return void (DC("SHOW_DATASTREAM2_LOG") && YC.debug("invalid datachannel id: ".concat(i, " !== ").concat(_this152.id)));
        var n = e.data.slice(_this152._dataStreamPacketHeader.byteLength);
        n = _this152._dataStreamPacketHandler.deserialize(n), _this152.emit(hb.MESSAGE, n);
      };
      return _this152;
    }

    _createClass(_P, [{
      key: "_updateOriginDataChannel",
      value: function _updateOriginDataChannel(e) {
        _get(_getPrototypeOf(_P.prototype), "_updateOriginDataChannel", this).call(this, e), this._bandRemoteDataChannelEvents();
      }
    }, {
      key: "_close",
      value: function _close() {
        this._originDataChannel && (this._originDataChannel.removeEventListener("message", this._messageListener), _get(_getPrototypeOf(_P.prototype), "_close", this).call(this));
      }
    }, {
      key: "_bandRemoteDataChannelEvents",
      value: function _bandRemoteDataChannelEvents() {
        this._originDataChannel && this._originDataChannel.addEventListener("message", this._messageListener);
      }
    }]);

    return _P;
  }(pP);

  var EP = /*#__PURE__*/function (_pP2) {
    _inherits(EP, _pP2);

    var _super44 = _createSuper(EP);

    function EP() {
      _classCallCheck(this, EP);

      return _super44.apply(this, arguments);
    }

    _createClass(EP, [{
      key: "send",
      value: function send(e) {
        if (this._originDataChannel) {
          var _t116 = e;
          _t116 = this._dataStreamPacketHandler.serialize(e);
          var i = new Uint8Array(this._dataStreamPacketHeader.byteLength + _t116.byteLength);
          i.set(new Uint8Array(this._dataStreamPacketHeader), 0), i.set(new Uint8Array(_t116), this._dataStreamPacketHeader.byteLength), this._originDataChannel.send(i.buffer);
        }
      }
    }]);

    return EP;
  }(pP);

  !function () {
    var e = pT();
    bA.getDisplayMedia = function (e) {
      if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) return !0;
      return !1;
    }(), bA.getStreamFromExtension = e.name === cT.CHROME && Number(e.version) > 34, bA.supportUnifiedPlan = function () {
      if (!window.RTCRtpTransceiver) return !1;
      if (!("currentDirection" in RTCRtpTransceiver.prototype)) return !1;
      var e = new RTCPeerConnection();
      var t = !1;

      try {
        e.addTransceiver("audio"), t = !0;
      } catch (e) {}

      return e.close(), t;
    }(), bA.supportMinBitrate = e.name === cT.CHROME || e.name === cT.EDGE, bA.supportSetRtpSenderParameters = function () {
      var e = pT();
      if (!window.RTCRtpSender || !window.RTCRtpSender.prototype.setParameters || !window.RTCRtpSender.prototype.getParameters) return !1;
      return !!kT() || !(!ST() && !mT()) || e.name === cT.FIREFOX && Number(e.version) >= 64;
    }(), e.name === cT.SAFARI && (Number(e.version) >= 14 ? bA.supportDualStream = !0 : bA.supportDualStream = !1), bA.webAudioMediaStreamDest = function () {
      var e = pT();
      if (e.name === cT.SAFARI && Number(e.version) < 12) return !1;
      return !0;
    }(), bA.supportReplaceTrack = function () {
      if (!window.RTCRtpSender) return !1;
      if ("function" == typeof RTCRtpSender.prototype.replaceTrack) return !0;
      return !1;
    }(), bA.supportWebGL = "undefined" != typeof WebGLRenderingContext, bA.supportRequestFrame = !!window.CanvasCaptureMediaStreamTrack, kT() || (bA.webAudioWithAEC = !0), bA.supportShareAudio = function () {
      var e = pT();
      if ((e.os === aT.WIN_10 || e.os === aT.WIN_81 || e.os === aT.WIN_7 || e.os === aT.LINUX || e.os === aT.MAC_OS || e.os === aT.CHROMIUM_OS) && e.name === cT.CHROME && Number(e.version) >= 74) return !0;
      return !1;
    }(), bA.supportDataChannel = function () {
      if (IT(76) || function (e) {
        var t = pT();
        return !(t.name !== cT.FIREFOX || !t.osVersion) && Number(t.version) >= e;
      }(68) || function (e) {
        var t = pT();
        return !(t.name !== cT.SAFARI || !t.osVersion) && Number(t.version) >= e;
      }(14)) return !0;
      return !1;
    }(), bA.supportPCSetConfiguration = function () {
      var e = window.RTCPeerConnection;
      return !RT() && !!e && e.prototype.setConfiguration instanceof Function;
    }(), bA.supportWebRTCEncodedTransform = function () {
      var e = pT();
      return "Chrome" === e.name && Number(e.version) >= 86;
    }(), bA.supportWebRTCInsertableStream = function () {
      var e = pT();
      return (e.name === cT.CHROME || e.name === cT.EDGE) && Number(e.version) >= 94 && "MediaStreamTrackGenerator" in window && "MediaStreamTrackProcessor" in window;
    }(), Ag(function () {
      bA.supportDualStreamEncoding = function () {
        var e = pT();
        if (DC("DISABLE_WEBAUDIO")) return !0;
        return "Safari" === e.name && Number(e.version) >= 14 || !!("Chrome" === e.name && /Windows/i.test(e.os || "") && Number(e.version) >= 100 && DC("CHROME_DUAL_STREAM_USE_ENCODING"));
      }(), YC.info("browser compatibility", JSON.stringify(bA), JSON.stringify(e));
    });
  }();

  var mP = /*#__PURE__*/function (_ig24) {
    _inherits(mP, _ig24);

    var _super45 = _createSuper(mP);

    function mP() {
      var _this153;

      _classCallCheck(this, mP);

      _this153 = _super45.apply(this, arguments), nh(_assertThisInitialized(_this153), "resultStorage", new Map());
      return _this153;
    }

    _createClass(mP, [{
      key: "setLocalAudioStats",
      value: function setLocalAudioStats(e, t, i) {
        this.record("AUDIO_INPUT_LEVEL_TOO_LOW", e, this.checkAudioInputLevel(i, t)), this.record("SEND_AUDIO_BITRATE_TOO_LOW", e, this.checkSendAudioBitrate(i, t));
      }
    }, {
      key: "setLocalVideoStats",
      value: function setLocalVideoStats(e, t, i) {
        this.record("SEND_VIDEO_BITRATE_TOO_LOW", e, this.checkSendVideoBitrate(i, t)), this.record("FRAMERATE_INPUT_TOO_LOW", e, this.checkFramerateInput(i, t)), this.record("FRAMERATE_SENT_TOO_LOW", e, this.checkFramerateSent(i));
      }
    }, {
      key: "setRemoteAudioStats",
      value: function setRemoteAudioStats(e, t) {
        var i = e.getUserId();
        this.record("AUDIO_OUTPUT_LEVEL_TOO_LOW", i, this.checkAudioOutputLevel(t));
      }
    }, {
      key: "setRemoteVideoStats",
      value: function setRemoteVideoStats(e, t) {
        var i = e.getUserId();
        this.record("RECV_VIDEO_DECODE_FAILED", i, this.checkVideoDecode(t));
      }
    }, {
      key: "record",
      value: function record(e, t, i) {
        if (DC("STATS_UPDATE_INTERVAL") > 500) return;
        this.resultStorage.has(e) || this.resultStorage.set(e, {
          result: [],
          isPrevNormal: !0
        });
        var n = this.resultStorage.get(e);

        if (n && (n.result.push(i), n.result.length >= 5)) {
          var s;

          var _i60 = bn(s = n.result).call(s, !0);

          n.isPrevNormal && !_i60 && this.emit("exception", fP[e], e, t), !n.isPrevNormal && _i60 && this.emit("exception", fP[e] + 2e3, e + "_RECOVER", t), n.isPrevNormal = _i60, n.result = [];
        }
      }
    }, {
      key: "checkAudioOutputLevel",
      value: function checkAudioOutputLevel(e) {
        return !(e.receiveBitrate > 0 && 0 === e.receiveLevel);
      }
    }, {
      key: "checkAudioInputLevel",
      value: function checkAudioInputLevel(e, t) {
        return t instanceof uw && !t.isActive || !!t.muted || 0 !== e.sendVolumeLevel;
      }
    }, {
      key: "checkFramerateInput",
      value: function checkFramerateInput(e, t) {
        var i = null;
        t._encoderConfig && t._encoderConfig.frameRate && (i = yy(t._encoderConfig.frameRate));
        var n = e.captureFrameRate;
        return !i || !n || !(i > 10 && n < 5 || i < 10 && i >= 5 && n <= 1);
      }
    }, {
      key: "checkFramerateSent",
      value: function checkFramerateSent(e) {
        return !(e.captureFrameRate && e.sendFrameRate && e.captureFrameRate > 5 && e.sendFrameRate <= 1);
      }
    }, {
      key: "checkSendVideoBitrate",
      value: function checkSendVideoBitrate(e, t) {
        return !!t.muted || 0 !== e.sendBitrate;
      }
    }, {
      key: "checkSendAudioBitrate",
      value: function checkSendAudioBitrate(e, t) {
        return t instanceof uw && !t.isActive || !!t.muted || 0 !== e.sendBitrate;
      }
    }, {
      key: "checkVideoDecode",
      value: function checkVideoDecode(e) {
        return 0 === e.receiveBitrate || 0 !== e.decodeFrameRate;
      }
    }]);

    return mP;
  }(ig);

  var fP = {
    FRAMERATE_INPUT_TOO_LOW: 1001,
    FRAMERATE_SENT_TOO_LOW: 1002,
    SEND_VIDEO_BITRATE_TOO_LOW: 1003,
    RECV_VIDEO_DECODE_FAILED: 1005,
    AUDIO_INPUT_LEVEL_TOO_LOW: 2001,
    AUDIO_OUTPUT_LEVEL_TOO_LOW: 2002,
    SEND_AUDIO_BITRATE_TOO_LOW: 2003
  };
  var TP = new ( /*#__PURE__*/function () {
    function _class11() {
      _classCallCheck(this, _class11);
    }

    _createClass(_class11, [{
      key: "markSubscribeStart",
      value: function markSubscribeStart(e, t) {
        performance.mark("agora-web-sdk/".concat(e, "/subscribe-").concat(t));
      }
    }, {
      key: "markPublishStart",
      value: function markPublishStart(e, t) {
        performance.mark("agora-web-sdk/".concat(e, "/publish-").concat(t));
      }
    }, {
      key: "measureFromSubscribeStart",
      value: function measureFromSubscribeStart(e, t) {
        var i = performance.getEntriesByName("agora-web-sdk/".concat(e, "/subscribe-").concat(t));

        if (i.length > 0) {
          var _e98 = i[i.length - 1];
          return Math.round(performance.now() - _e98.startTime);
        }

        return 0;
      }
    }, {
      key: "measureFromPublishStart",
      value: function measureFromPublishStart(e, t) {
        var i = performance.getEntriesByName("agora-web-sdk/".concat(e, "/publish-").concat(t));

        if (i.length > 0) {
          var _e99 = i[i.length - 1];
          return Math.round(performance.now() - _e99.startTime);
        }

        return 0;
      }
    }]);

    return _class11;
  }())();

  function gP(e, t) {
    this.v = e, this.k = t;
  }

  function SP(e) {
    return new gP(e, 0);
  }

  var RP = eT,
      CP = sm;
  wi({
    target: "Promise",
    stat: !0,
    forced: !0
  }, {
    withResolvers: function withResolvers() {
      var e = CP.f(this);
      return {
        promise: e.promise,
        resolve: e.resolve,
        reject: e.reject
      };
    }
  });
  var IP = sm,
      vP = FE;
  wi({
    target: "Promise",
    stat: !0,
    forced: !0
  }, {
    try: function _try(e) {
      var t = IP.f(this),
          i = vP(e);
      return (i.error ? t.reject : t.resolve)(i.value), t.promise;
    }
  });
  var yP = i(RP),
      AP = Fo.f("asyncIterator"),
      bP = i(AP);

  function wP(e) {
    var t, i;

    function n(t, i) {
      try {
        var r = e[t](i),
            o = r.value,
            a = o instanceof gP;
        yP.resolve(a ? o.v : o).then(function (i) {
          if (a) {
            var c = "return" === t ? "return" : "next";
            if (!o.k || i.done) return n(c, i);
            i = e[c](i).value;
          }

          s(r.done ? "return" : "normal", i);
        }, function (e) {
          n("throw", e);
        });
      } catch (e) {
        s("throw", e);
      }
    }

    function s(e, s) {
      switch (e) {
        case "return":
          t.resolve({
            value: s,
            done: !0
          });
          break;

        case "throw":
          t.reject(s);
          break;

        default:
          t.resolve({
            value: s,
            done: !1
          });
      }

      (t = t.next) ? n(t.key, t.arg) : i = null;
    }

    this._invoke = function (e, s) {
      return new yP(function (r, o) {
        var a = {
          key: e,
          arg: s,
          resolve: r,
          reject: o,
          next: null
        };
        i ? i = i.next = a : (t = i = a, n(e, s));
      });
    }, "function" != typeof e.return && (this.return = void 0);
  }

  function OP(e) {
    return function () {
      return new wP(e.apply(this, arguments));
    };
  }

  wP.prototype["function" == typeof Uu && bP || "@@asyncIterator"] = function () {
    return this;
  }, wP.prototype.next = function (e) {
    return this._invoke("next", e);
  }, wP.prototype.throw = function (e) {
    return this._invoke("throw", e);
  }, wP.prototype.return = function (e) {
    return this._invoke("return", e);
  };
  var NP = i(ie.Object.getOwnPropertySymbols),
      DP = wi,
      PP = Ki.indexOf,
      LP = Rh,
      kP = v([].indexOf),
      MP = !!kP && 1 / kP([1], 1, -0) < 0;
  DP({
    target: "Array",
    proto: !0,
    forced: MP || !LP("indexOf")
  }, {
    indexOf: function indexOf(e) {
      var t = arguments.length > 1 ? arguments[1] : void 0;
      return MP ? kP(this, e, t) || 0 : PP(this, e, t);
    }
  });
  var UP = Ji("Array").indexOf,
      xP = l,
      VP = UP,
      FP = Array.prototype,
      BP = i(function (e) {
    var t = e.indexOf;
    return e === FP || xP(FP, e) && t === FP.indexOf ? VP : t;
  }),
      jP = ze,
      GP = Yr;
  wi({
    target: "Object",
    stat: !0,
    forced: n(function () {
      GP(1);
    })
  }, {
    keys: function keys(e) {
      return GP(jP(e));
    }
  });
  var WP = i(ie.Object.keys);

  function HP(e, t) {
    if (null == e) return {};

    var i,
        n,
        s = function (e, t) {
      if (null == e) return {};
      var i,
          n,
          s = {},
          r = WP(e);

      for (n = 0; n < r.length; n++) {
        i = r[n], BP(t).call(t, i) >= 0 || (s[i] = e[i]);
      }

      return s;
    }(e, t);

    if (NP) {
      var r = NP(e);

      for (n = 0; n < r.length; n++) {
        i = r[n], BP(t).call(t, i) >= 0 || Object.prototype.propertyIsEnumerable.call(e, i) && (s[i] = e[i]);
      }
    }

    return s;
  }

  var KP = {
    exports: {}
  };
  !function (e, t) {
    e.exports = function () {
      var e = {
        8: function _(e, t, i) {
          i.r(t), i.d(t, {
            Parser: function Parser() {
              return C;
            },
            Printer: function Printer() {
              return b;
            },
            parse: function parse() {
              return D;
            },
            print: function print() {
              return P;
            }
          });
          var n = "\n",
              s = "".concat("\r").concat(n),
              r = " ";
          var o;

          function a(e) {
            return e >= "0" && e <= "9";
          }

          function c(e) {
            return e >= "!" && e <= "~";
          }

          function d(e) {
            return c(e) || e >= "" && e <= "ÿ";
          }

          function l(e) {
            return "!" === e || e >= "#" && e <= "'" || e >= "*" && e <= "+" || e >= "-" && e <= "." || e >= "0" && e <= "9" || e >= "A" && e <= "Z" || e >= "^" && e <= "~";
          }

          function u(e) {
            return e >= "1" && e <= "9";
          }

          function h(e) {
            return e >= "A" && e <= "Z" || e >= "a" && e <= "z";
          }

          function p(e) {
            return "d" === e || "h" === e || "m" === e || "s" === e;
          }

          function _(e) {
            return e > "" && e < "\t" || e > "\v" && e < "\f" || e > "" && e < "ÿ";
          }

          function E(e) {
            return h(e) || a(e) || "+" === e || "/" === e;
          }

          function m(e) {
            return a(e) || h(e) || "+" === e || "/" === e || "-" === e || "_" === e;
          }

          function f(e) {
            return h(e) || a(e) || "+" === e || "/" === e;
          }

          function T(e, t) {
            var i = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              t && (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), i.push.apply(i, n);
            }

            return i;
          }

          function g(e) {
            for (var t = 1; t < arguments.length; t++) {
              var i = null != arguments[t] ? arguments[t] : {};
              t % 2 ? T(Object(i), !0).forEach(function (t) {
                S(e, t, i[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : T(Object(i)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
              });
            }

            return e;
          }

          function S(e, t, i) {
            return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }

          !function (e) {
            e.VERSION = "v", e.ORIGIN = "o", e.SESSION_NAME = "s", e.INFORMATION = "i", e.URI = "u", e.EMAIL = "e", e.PHONE = "p", e.CONNECTION = "c", e.BANDWIDTH = "b", e.TIME = "t", e.REPEAT = "r", e.ZONE_ADJUSTMENTS = "z", e.KEY = "k", e.ATTRIBUTE = "a", e.MEDIA = "m";
          }(o || (o = {}));

          var R = /*#__PURE__*/function () {
            function R() {
              _classCallCheck(this, R);
            }

            _createClass(R, [{
              key: "consumeText",
              value: function consumeText(e, t) {
                var i = t;

                for (; i < e.length;) {
                  var _t117 = e[i];
                  if ("\0" === _t117 || "\r" === _t117 || _t117 === n) break;
                  i += 1;
                }

                if (i - t == 0) throw new Error("Invalid text, at ".concat(e));
                return i;
              }
            }, {
              key: "consumeUnicastAddress",
              value: function consumeUnicastAddress(e, t, i) {
                return this.consumeTill(e, t, r);
              }
            }, {
              key: "consumeOneOrMore",
              value: function consumeOneOrMore(e, t, i) {
                var n = t;

                for (; i(e[n]);) {
                  n++;
                }

                if (n - t == 0) throw new Error("Invalid rule at ".concat(t, "."));
                return n;
              }
            }, {
              key: "consumeSpace",
              value: function consumeSpace(e, t) {
                if (e[t] === r) return t + 1;
                throw new Error("Invalid space at ".concat(t, "."));
              }
            }, {
              key: "consumeIP4Address",
              value: function consumeIP4Address(e, t) {
                var i = t;

                for (var _t118 = 0; _t118 < 4; _t118++) {
                  if (i = this.consumeDecimalUChar(e, i), 3 !== _t118) {
                    if ("." !== e[i]) throw new Error("Invalid IP4 address.");
                    i++;
                  }
                }

                return i;
              }
            }, {
              key: "consumeDecimalUChar",
              value: function consumeDecimalUChar(e, t) {
                var i = t;

                for (var _t119 = 0; _t119 < 3 && a(e[i]); _t119++, i++) {
                  ;
                }

                if (i - t == 0) throw new Error("Invalid decimal uchar.");
                var n = parseInt(e.slice(t, i));
                if (n >= 0 && n <= 255) return i;
                throw new Error("Invalid decimal uchar");
              }
            }, {
              key: "consumeIP6Address",
              value: function consumeIP6Address(e, t) {
                var i = this.consumeHexpart(e, t);
                return ":" === e[i] ? (i += 1, i = this.consumeIP4Address(e, i), i) : i;
              }
            }, {
              key: "consumeHexpart",
              value: function consumeHexpart(e, t) {
                var i = t;

                if (":" === e[i] && ":" === e[i + 1]) {
                  i += 2;

                  try {
                    i = this.consumeHexseq(e, i);
                  } catch (e) {}

                  return i;
                }

                if (i = this.consumeHexseq(e, i), ":" === e[i] && ":" === e[i + 1]) {
                  i += 2;

                  try {
                    i = this.consumeHexseq(e, i);
                  } catch (e) {}

                  return i;
                }

                return i;
              }
            }, {
              key: "consumeHexseq",
              value: function consumeHexseq(e, t) {
                var i = t;

                for (; i = this.consumeHex4(e, i), ":" === e[i] && ":" !== e[i + 1];) {
                  i += 1;
                }

                return i;
              }
            }, {
              key: "consumeHex4",
              value: function consumeHex4(e, t) {
                var i = 0;

                for (; i < 4; i++) {
                  if (!((n = e[t + i]) >= "0" && n <= "9" || n >= "a" && n <= "f" || n >= "A" && n <= "F")) {
                    if (0 === i) throw new Error("Invalid hex 4");
                    break;
                  }
                }

                var n;
                return t + i;
              }
            }, {
              key: "consumeFQDN",
              value: function consumeFQDN(e, t) {
                var i = t;

                for (; a(e[i]) || h(e[i]) || "-" === e[i] || "." === e[i];) {
                  i += 1;
                }

                if (i - t < 4) throw new Error("Invalid FQDN");
                return i;
              }
            }, {
              key: "consumeExtnAddr",
              value: function consumeExtnAddr(e, t) {
                return this.consumeOneOrMore(e, t, d);
              }
            }, {
              key: "consumeMulticastAddress",
              value: function consumeMulticastAddress(e, t, i) {
                switch (i) {
                  case "IP4":
                  case "ip4":
                    return this.consumeIP4MulticastAddress(e, t);

                  case "IP6":
                  case "ip6":
                    return this.consumeIP6MulticastAddress(e, t);

                  default:
                    try {
                      return this.consumeFQDN(e, t);
                    } catch (i) {
                      return this.consumeExtnAddr(e, t);
                    }

                }
              }
            }, {
              key: "consumeIP6MulticastAddress",
              value: function consumeIP6MulticastAddress(e, t) {
                var i = this.consumeHexpart(e, t);
                return "/" === e[i] ? this.consumeInteger(e, i + 1) : i;
              }
            }, {
              key: "consumeIP4MulticastAddress",
              value: function consumeIP4MulticastAddress(e, t) {
                var i = t + 3;
                var n = e.slice(t, i),
                    s = parseInt(n);
                if (s < 224 || s > 239) throw new Error("Invalid IP4 multicast address, IPv4 multicast addresses may be in the range 224.0.0.0 to 239.255.255.255.");

                for (var _t120 = 0; _t120 < 3; _t120++) {
                  if ("." !== e[i]) throw new Error("Invalid IP4 multicast address.");
                  i += 1, i = this.consumeDecimalUChar(e, i);
                }

                return "/" === e[i] && (i += 1), i = this.consumeTTL(e, i), "/" === e[i] && (i = this.consumeInteger(e, i)), i;
              }
            }, {
              key: "consumeInteger",
              value: function consumeInteger(e, t) {
                if (!u(e[t])) throw new Error("Invalid integer.");

                for (t += 1; a(e[t]);) {
                  t += 1;
                }

                return t;
              }
            }, {
              key: "consumeTTL",
              value: function consumeTTL(e, t) {
                if ("0" === e[t]) return t + 1;
                if (!u(e[t])) throw new Error("Invalid TTL.");
                t += 1;

                for (var _i61 = 0; _i61 < 2 && a(e[t]); _i61++) {
                  t += 1;
                }

                return t;
              }
            }, {
              key: "consumeToken",
              value: function consumeToken(e, t) {
                return this.consumeOneOrMore(e, t, l);
              }
            }, {
              key: "consumeTime",
              value: function consumeTime(e, t) {
                var i = t;
                if ("0" === e[i]) return i + 1;

                for (u(e[i]) && (i += 1); a(e[i]);) {
                  i++;
                }

                if (i - t < 10) throw new Error("Invalid time");
                return i;
              }
            }, {
              key: "consumeAddress",
              value: function consumeAddress(e, t) {
                return this.consumeTill(e, t, r);
              }
            }, {
              key: "consumeTypedTime",
              value: function consumeTypedTime(e, t) {
                var i = t;
                return i = this.consumeOneOrMore(e, i, a), p(e[i]) ? i + 1 : i;
              }
            }, {
              key: "consumeRepeatInterval",
              value: function consumeRepeatInterval(e, t) {
                if (!u(e[t])) throw new Error("Invalid repeat interval");

                for (t += 1; a(e[t]);) {
                  t += 1;
                }

                return p(e[t]) && (t += 1), t;
              }
            }, {
              key: "consumePort",
              value: function consumePort(e, t) {
                return this.consumeOneOrMore(e, t, a);
              }
            }, {
              key: "consume",
              value: function consume(e, t, i) {
                for (var _n56 = 0; _n56 < i.length; _n56++) {
                  if (t + _n56 >= e.length) throw new Error("consume exceeding value length");
                  if (e[t + _n56] !== i[_n56]) throw new Error("consume ".concat(i, " failed at ").concat(_n56));
                }

                return t + i.length;
              }
            }, {
              key: "consumeTill",
              value: function consumeTill(e, t, i) {
                var n = t;

                for (; n < e.length && ("string" != typeof i || e[n] !== i) && ("function" != typeof i || !i(e[n]));) {
                  n++;
                }

                return n;
              }
            }]);

            return R;
          }();

          var C = /*#__PURE__*/function (_R2) {
            _inherits(C, _R2);

            var _super46 = _createSuper(C);

            function C() {
              var _this154;

              _classCallCheck(this, C);

              _this154 = _super46.call(this), S(_assertThisInitialized(_this154), "records", []), S(_assertThisInitialized(_this154), "currentLine", 0);
              return _this154;
            }

            _createClass(C, [{
              key: "parse",
              value: function parse(e) {
                var t = this.probeEOL(e);
                this.records = e.split(t).filter(function (e) {
                  return !!e.trim();
                }).map(this.parseLine), this.currentLine = 0;

                var i = this.parseVersion(),
                    n = this.parseOrigin(),
                    s = this.parseSessionName(),
                    r = this.parseInformation(),
                    o = this.parseUri(),
                    a = this.parseEmail(),
                    c = this.parsePhone(),
                    d = this.parseConnection(),
                    l = this.parseBandWidth(),
                    u = this.parseTimeFields(),
                    h = this.parseKey(),
                    p = this.parseSessionAttribute(),
                    _ = this.parseMediaDescription();

                if (this.currentLine !== this.records.length) throw new Error("parsing failed, non exhaustive sdp lines.");
                return {
                  version: i,
                  origin: n,
                  sessionName: s,
                  information: r,
                  uri: o,
                  emails: a,
                  phones: c,
                  connection: d,
                  bandwidths: l,
                  timeFields: u,
                  key: h,
                  attributes: p,
                  mediaDescriptions: _
                };
              }
            }, {
              key: "getCurrentRecord",
              value: function getCurrentRecord() {
                var e = this.records[this.currentLine];
                if (!e) throw new Error("Record doesn't exit.");
                return e;
              }
            }, {
              key: "probeEOL",
              value: function probeEOL(e) {
                for (var _t121 = 0; _t121 < e.length; _t121++) {
                  if (e[_t121] === n) return "\r" === e[_t121 - 1] ? s : n;
                }

                throw new Error("Invalid newline character.");
              }
            }, {
              key: "parseLine",
              value: function parseLine(e, t) {
                if (e.length < 2) throw new Error("Invalid sdp line, sdp line should be of form <type>=<value>.");
                var i = e[0];
                if ("=" !== e[1]) throw new Error('Invalid sdp line, <type> should be a single character followed by an "=" sign.');
                return {
                  type: i,
                  value: e.slice(2),
                  line: t,
                  cur: 0
                };
              }
            }, {
              key: "parseSessionAttribute",
              value: function parseSessionAttribute() {
                var e = new v();

                for (; this.currentLine < this.records.length;) {
                  var _t122 = this.getCurrentRecord();

                  if (_t122.type !== o.ATTRIBUTE) break;
                  var _i62 = {
                    attField: this.extractOneOrMore(_t122, function (e) {
                      return l(e) && ":" !== e;
                    }),
                    _cur: 0
                  };
                  ":" === _t122.value[_t122.cur] && (_t122.cur += 1, _i62.attValue = this.extractOneOrMore(_t122, _)), e.parse(_i62), this.currentLine++;
                }

                return e.digest();
              }
            }, {
              key: "parseMediaAttributes",
              value: function parseMediaAttributes(e) {
                var t = new y(e);

                for (; this.currentLine < this.records.length;) {
                  var _e100 = this.getCurrentRecord();

                  if (_e100.type !== o.ATTRIBUTE) break;
                  var _i63 = {
                    attField: this.extractOneOrMore(_e100, function (e) {
                      return l(e) && ":" !== e;
                    }),
                    _cur: 0
                  };
                  ":" === _e100.value[_e100.cur] && (_e100.cur += 1, _i63.attValue = this.extractOneOrMore(_e100, _)), t.parse(_i63), this.currentLine++;
                }

                return t.digest();
              }
            }, {
              key: "parseKey",
              value: function parseKey() {
                var e = this.getCurrentRecord();

                if (e.type === o.KEY) {
                  if ("prompt" === e.value || "clear:" === e.value || "base64:" === e.value || "uri:" === e.value) return e.value;
                  throw this.currentLine++, new Error("Invalid key.");
                }
              }
            }, {
              key: "parseZone",
              value: function parseZone() {
                var e = this.getCurrentRecord();

                if (e.type === o.ZONE_ADJUSTMENTS) {
                  var _t123 = [];

                  for (;;) {
                    try {
                      var _i64 = this.extract(e, this.consumeTime);

                      this.consumeSpaceForRecord(e);

                      var _n57 = !1;

                      "-" === e.value[e.cur] && (_n57 = !0, e.cur += 1);

                      var _s33 = this.extract(e, this.consumeTypedTime);

                      _t123.push({
                        time: _i64,
                        typedTime: _s33,
                        back: _n57
                      });
                    } catch (e) {
                      break;
                    }
                  }

                  if (0 === _t123.length) throw new Error("Invalid zone adjustments");
                  return this.currentLine++, _t123;
                }

                return [];
              }
            }, {
              key: "parseRepeat",
              value: function parseRepeat() {
                var e = [];

                for (;;) {
                  var _t124 = this.getCurrentRecord();

                  if (_t124.type !== o.REPEAT) break;
                  {
                    var _i65 = this.extract(_t124, this.consumeRepeatInterval),
                        _n58 = this.parseTypedTime(_t124);

                    e.push({
                      repeatInterval: _i65,
                      typedTimes: _n58
                    }), this.currentLine++;
                  }
                }

                return e;
              }
            }, {
              key: "parseTypedTime",
              value: function parseTypedTime(e) {
                var t = [];

                for (;;) {
                  try {
                    this.consumeSpaceForRecord(e), t.push(this.extract(e, this.consumeTypedTime));
                  } catch (e) {
                    break;
                  }
                }

                if (0 === t.length) throw new Error("Invalid typed time.");
                return t;
              }
            }, {
              key: "parseTime",
              value: function parseTime() {
                var e = this.getCurrentRecord(),
                    t = this.extract(e, this.consumeTime);
                this.consumeSpaceForRecord(e);
                var i = this.extract(e, this.consumeTime);
                return this.currentLine++, {
                  startTime: t,
                  stopTime: i
                };
              }
            }, {
              key: "parseBandWidth",
              value: function parseBandWidth() {
                var e = [];

                for (; this.currentLine < this.records.length;) {
                  var _t125 = this.getCurrentRecord();

                  if (_t125.type !== o.BANDWIDTH) break;
                  {
                    var _i66 = this.extractOneOrMore(_t125, l);

                    if (":" !== _t125.value[_t125.cur]) throw new Error("Invalid bandwidth field.");
                    _t125.cur++;

                    var _n59 = this.extractOneOrMore(_t125, a);

                    e.push({
                      bwtype: _i66,
                      bandwidth: _n59
                    }), this.currentLine++;
                  }
                }

                return e;
              }
            }, {
              key: "parseVersion",
              value: function parseVersion() {
                var e = this.getCurrentRecord();
                if (e.type !== o.VERSION) throw new Error("first sdp record must be version");
                var t = e.value.slice(0, this.consumeOneOrMore(e.value, 0, a));
                if (t.length !== e.value.length) throw new Error('invalid proto version, "v='.concat(e.value, '"'));
                return this.currentLine++, t;
              }
            }, {
              key: "parseOrigin",
              value: function parseOrigin() {
                var e = this.getCurrentRecord();
                if (e.type !== o.ORIGIN) throw new Error("second line of sdp must be origin");
                var t = this.extractOneOrMore(e, d);
                this.consumeSpaceForRecord(e);
                var i = this.extractOneOrMore(e, a);
                this.consumeSpaceForRecord(e);
                var n = this.extractOneOrMore(e, a);
                this.consumeSpaceForRecord(e);
                var s = this.extractOneOrMore(e, l);
                this.consumeSpaceForRecord(e);
                var r = this.extractOneOrMore(e, l);
                this.consumeSpaceForRecord(e);
                var c = this.extract(e, this.consumeUnicastAddress);
                return this.currentLine++, {
                  username: t,
                  sessId: i,
                  sessVersion: n,
                  nettype: s,
                  addrtype: r,
                  unicastAddress: c
                };
              }
            }, {
              key: "parseSessionName",
              value: function parseSessionName() {
                var e = this.getCurrentRecord();

                if (e.type === o.SESSION_NAME) {
                  var _t126 = this.extract(e, this.consumeText);

                  return this.currentLine++, _t126;
                }
              }
            }, {
              key: "parseInformation",
              value: function parseInformation() {
                var e = this.getCurrentRecord();
                if (e.type !== o.INFORMATION) return;
                var t = this.extract(e, this.consumeText);
                return this.currentLine++, t;
              }
            }, {
              key: "parseUri",
              value: function parseUri() {
                var e = this.getCurrentRecord();
                if (e.type === o.URI) return this.currentLine++, e.value;
              }
            }, {
              key: "parseEmail",
              value: function parseEmail() {
                var e = [];

                for (;;) {
                  var _t127 = this.getCurrentRecord();

                  if (_t127.type !== o.EMAIL) break;
                  e.push(_t127.value), this.currentLine++;
                }

                return e;
              }
            }, {
              key: "parsePhone",
              value: function parsePhone() {
                var e = [];

                for (;;) {
                  var _t128 = this.getCurrentRecord();

                  if (_t128.type !== o.PHONE) break;
                  e.push(_t128.value), this.currentLine++;
                }

                return e;
              }
            }, {
              key: "parseConnection",
              value: function parseConnection() {
                var e = this.getCurrentRecord();

                if (e.type === o.CONNECTION) {
                  var _t129 = this.extractOneOrMore(e, l);

                  this.consumeSpaceForRecord(e);

                  var _i67 = this.extractOneOrMore(e, l);

                  this.consumeSpaceForRecord(e);

                  var _n60 = this.extract(e, this.consumeAddress);

                  return this.currentLine++, {
                    nettype: _t129,
                    addrtype: _i67,
                    address: _n60
                  };
                }
              }
            }, {
              key: "parseMedia",
              value: function parseMedia() {
                var e = this.getCurrentRecord(),
                    t = this.extract(e, this.consumeToken);
                this.consumeSpaceForRecord(e);
                var i = this.extract(e, this.consumePort);
                "/" === e.value[e.cur] && (e.cur += 1, i += this.extract(e, this.consumeInteger)), this.consumeSpaceForRecord(e);
                var n = [];

                for (n.push(this.extract(e, this.consumeToken)); "/" === e.value[e.cur];) {
                  e.cur += 1, n.push(this.extract(e, this.consumeToken));
                }

                if (0 === n.length) throw new Error("Invalid proto");
                var s = this.parseFmt(e);
                return this.currentLine++, {
                  mediaType: t,
                  port: i,
                  protos: n,
                  fmts: s
                };
              }
            }, {
              key: "parseTimeFields",
              value: function parseTimeFields() {
                var e = [];

                for (; this.getCurrentRecord().type === o.TIME;) {
                  var _t130 = this.parseTime(),
                      _i68 = this.parseRepeat(),
                      _n61 = this.parseZone();

                  e.push({
                    time: _t130,
                    repeats: _i68,
                    zones: _n61
                  });
                }

                return e;
              }
            }, {
              key: "parseMediaDescription",
              value: function parseMediaDescription() {
                var e = [];

                for (; this.currentLine < this.records.length && this.getCurrentRecord().type === o.MEDIA;) {
                  var _t131 = this.parseMedia(),
                      _i69 = this.parseInformation(),
                      _n62 = this.parseConnections(),
                      _s34 = this.parseBandWidth(),
                      _r16 = this.parseKey(),
                      _o12 = this.parseMediaAttributes(_t131);

                  e.push({
                    media: _t131,
                    information: _i69,
                    connections: _n62,
                    bandwidths: _s34,
                    key: _r16,
                    attributes: _o12
                  });
                }

                return e;
              }
            }, {
              key: "parseConnections",
              value: function parseConnections() {
                var e = [];

                for (; this.currentLine < this.records.length && this.getCurrentRecord().type === o.CONNECTION;) {
                  e.push(this.parseConnection());
                }

                return e;
              }
            }, {
              key: "parseFmt",
              value: function parseFmt(e) {
                var t = [];

                for (;;) {
                  try {
                    this.consumeSpaceForRecord(e), t.push(this.extract(e, this.consumeToken));
                  } catch (e) {
                    break;
                  }
                }

                if (0 === t.length) throw new Error("Invalid fmts");
                return t;
              }
            }, {
              key: "extract",
              value: function extract(e, t) {
                for (var _len2 = arguments.length, i = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                  i[_key2 - 2] = arguments[_key2];
                }

                var n = t.call.apply(t, [this, e.value, e.cur].concat(i)),
                    s = e.value.slice(e.cur, n);
                return e.cur = n, s;
              }
            }, {
              key: "extractOneOrMore",
              value: function extractOneOrMore(e, t) {
                var i = this.consumeOneOrMore(e.value, e.cur, t),
                    n = e.value.slice(e.cur, i);
                return e.cur = i, n;
              }
            }, {
              key: "consumeSpaceForRecord",
              value: function consumeSpaceForRecord(e) {
                if (e.value[e.cur] !== r) throw new Error("Invalid space at ".concat(e.cur, "."));
                e.cur += 1;
              }
            }]);

            return C;
          }(R);

          var I = /*#__PURE__*/function (_R3) {
            _inherits(I, _R3);

            var _super47 = _createSuper(I);

            function I() {
              var _this155;

              _classCallCheck(this, I);

              for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                e[_key3] = arguments[_key3];
              }

              _this155 = _super47.call.apply(_super47, [this].concat(e)), S(_assertThisInitialized(_this155), "attributes", void 0), S(_assertThisInitialized(_this155), "digested", !1);
              return _this155;
            }

            _createClass(I, [{
              key: "extractOneOrMore",
              value: function extractOneOrMore(e, t, i) {
                var n = this.consumeOneOrMore(e.attValue, e._cur, t),
                    s = e.attValue.slice(e._cur, n),
                    _ref52 = i || [],
                    _ref53 = _slicedToArray(_ref52, 2),
                    r = _ref53[0],
                    o = _ref53[1];

                if ("number" == typeof r && s.length < r) throw new Error("error in length, should be more or equal than ".concat(r, " characters."));
                if ("number" == typeof o && s.length > o) throw new Error("error in length, should be less or equal than ".concat(o, " characters."));
                return e._cur = n, s;
              }
            }, {
              key: "consumeAttributeSpace",
              value: function consumeAttributeSpace(e) {
                if (e.attValue[e._cur] !== r) throw new Error("Invalid space at ".concat(e._cur, "."));
                e._cur += 1;
              }
            }, {
              key: "extract",
              value: function extract(e, t) {
                if (!e.attValue) throw new Error("Nothing to extract from attValue.");

                for (var _len4 = arguments.length, i = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
                  i[_key4 - 2] = arguments[_key4];
                }

                var n = t.call.apply(t, [this, e.attValue, e._cur].concat(i)),
                    s = e.attValue.slice(e._cur, n);
                return e._cur = n, s;
              }
            }, {
              key: "atEnd",
              value: function atEnd(e) {
                if (!e.attValue) throw new Error();
                return e._cur >= e.attValue.length;
              }
            }, {
              key: "peekChar",
              value: function peekChar(e) {
                if (!e.attValue) throw new Error();
                return e.attValue[e._cur];
              }
            }, {
              key: "peek",
              value: function peek(e, t) {
                if (!e.attValue) throw new Error();

                for (var _i70 = 0; _i70 < t.length; _i70++) {
                  if (t[_i70] !== e.attValue[e._cur + _i70]) return !1;
                }

                return !0;
              }
            }, {
              key: "parseIceUfrag",
              value: function parseIceUfrag(e) {
                if (this.attributes.iceUfrag) throw new Error("Invalid ice-ufrag, should be only a single line if 'a=ice-ufrag'");
                this.attributes.iceUfrag = this.extractOneOrMore(e, E, [4, 256]);
              }
            }, {
              key: "parseIcePwd",
              value: function parseIcePwd(e) {
                if (this.attributes.icePwd) throw new Error("Invalid ice-pwd, should be only a single line if 'a=ice-pwd'");
                this.attributes.icePwd = this.extractOneOrMore(e, E, [22, 256]);
              }
            }, {
              key: "parseIceOptions",
              value: function parseIceOptions(e) {
                if (this.attributes.iceOptions) throw new Error("Invalid ice-options, should be only one 'ice-options' line");
                var t = [];

                for (; !this.atEnd(e);) {
                  t.push(this.extractOneOrMore(e, E));

                  try {
                    this.consumeAttributeSpace(e);
                  } catch (t) {
                    if (this.atEnd(e)) break;
                    throw t;
                  }
                }

                this.attributes.iceOptions = t;
              }
            }, {
              key: "parseFingerprint",
              value: function parseFingerprint(e) {
                var t = this.extract(e, this.consumeToken);
                this.consumeAttributeSpace(e);
                var i = this.extract(e, this.consumeTill);
                this.attributes.fingerprints.push({
                  hashFunction: t,
                  fingerprint: i
                });
              }
            }, {
              key: "parseExtmap",
              value: function parseExtmap(e) {
                var t = this.extractOneOrMore(e, a);
                var i;
                "/" === this.peekChar(e) && (this.extract(e, this.consume, "/"), i = this.extract(e, this.consumeToken)), this.consumeAttributeSpace(e);
                var n = this.extract(e, this.consumeTill, r),
                    s = g(g({
                  entry: parseInt(t, 10)
                }, i && {
                  direction: i
                }), {}, {
                  extensionName: n
                });
                this.peekChar(e) === r && (this.consumeAttributeSpace(e), s.extensionAttributes = this.extract(e, this.consumeTill)), this.attributes.extmaps.push(s);
              }
            }, {
              key: "parseSetup",
              value: function parseSetup(e) {
                if (this.attributes.setup) throw new Error("must only be one single 'a=setup' line.");
                var t = this.extract(e, this.consumeTill);
                if ("active" !== t && "passive" !== t && "actpass" !== t && "holdconn" !== t) throw new Error("role must be one of 'active', 'passive', 'actpass', 'holdconn'.");
                this.attributes.setup = t;
              }
            }]);

            return I;
          }(R);

          var v = /*#__PURE__*/function (_I2) {
            _inherits(v, _I2);

            var _super48 = _createSuper(v);

            function v() {
              var _this156;

              _classCallCheck(this, v);

              for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                e[_key5] = arguments[_key5];
              }

              _this156 = _super48.call.apply(_super48, [this].concat(e)), S(_assertThisInitialized(_this156), "attributes", {
                unrecognized: [],
                groups: [],
                extmaps: [],
                fingerprints: [],
                identities: []
              });
              return _this156;
            }

            _createClass(v, [{
              key: "parse",
              value: function parse(e) {
                if (this.digested) throw new Error("already digested");

                try {
                  switch (e.attField) {
                    case "group":
                      this.parseGroup(e);
                      break;

                    case "ice-lite":
                      this.parseIceLite();
                      break;

                    case "ice-ufrag":
                      this.parseIceUfrag(e);
                      break;

                    case "ice-pwd":
                      this.parseIcePwd(e);
                      break;

                    case "ice-options":
                      this.parseIceOptions(e);
                      break;

                    case "fingerprint":
                      this.parseFingerprint(e);
                      break;

                    case "setup":
                      this.parseSetup(e);
                      break;

                    case "tls-id":
                      this.parseTlsId(e);
                      break;

                    case "identity":
                      this.parseIdentity(e);
                      break;

                    case "extmap":
                      this.parseExtmap(e);
                      break;

                    case "msid-semantic":
                      this.parseMsidSemantic(e);
                      break;

                    default:
                      e.ignored = !0, this.attributes.unrecognized.push(e);
                  }
                } catch (t) {
                  throw console.error("parsing session attribute ".concat(e.attField, ' error, "a=').concat(e.attField, ":").concat(e.attValue, '"')), t;
                }

                if (!e.ignored && e.attValue && !this.atEnd(e)) throw new Error("attribute parsing error");
              }
            }, {
              key: "digest",
              value: function digest() {
                return this.digested = !0, this.attributes;
              }
            }, {
              key: "parseGroup",
              value: function parseGroup(e) {
                var t = this.extract(e, this.consumeToken),
                    i = [];

                for (; !this.atEnd(e) && this.peekChar(e) === r;) {
                  this.consumeAttributeSpace(e), i.push(this.extract(e, this.consumeToken));
                }

                this.attributes.groups.push({
                  semantic: t,
                  identificationTag: i
                });
              }
            }, {
              key: "parseIceLite",
              value: function parseIceLite() {
                if (this.attributes.iceLite) throw new Error("Invalid ice-lite, should be only a single line of 'a=ice-lite'");
                this.attributes.iceLite = !0;
              }
            }, {
              key: "parseTlsId",
              value: function parseTlsId(e) {
                if (this.attributes.tlsId) throw new Error("must be only one tld-id line");
                this.attributes.tlsId = this.extractOneOrMore(e, m);
              }
            }, {
              key: "parseIdentity",
              value: function parseIdentity(e) {
                var t = this.extractOneOrMore(e, f),
                    i = [];

                for (; !this.atEnd(e) && this.peekChar(e) === r;) {
                  this.consumeAttributeSpace(e);

                  var _t132 = this.extract(e, this.consumeToken);

                  this.extract(e, this.consume, "=");

                  var _n63 = this.extractOneOrMore(e, function (e) {
                    return e !== r && _(e);
                  });

                  i.push({
                    name: _t132,
                    value: _n63
                  });
                }

                this.attributes.identities.push({
                  assertionValue: t,
                  extensions: i
                });
              }
            }, {
              key: "parseMsidSemantic",
              value: function parseMsidSemantic(e) {
                this.peekChar(e) === r && this.consumeAttributeSpace(e);
                var t = {
                  semantic: this.extract(e, this.consumeToken),
                  identifierList: []
                };

                for (;;) {
                  try {
                    this.consumeAttributeSpace(e);
                  } catch (e) {
                    break;
                  }

                  if ("*" === this.peekChar(e)) {
                    this.extract(e, this.consume, "*"), t.applyForAll = !0;
                    break;
                  }

                  {
                    var _i71 = this.extract(e, this.consumeTill, r);

                    t.identifierList.push(_i71);
                  }
                }

                this.attributes.msidSemantic = t;
              }
            }]);

            return v;
          }(I);

          var y = /*#__PURE__*/function (_I3) {
            _inherits(y, _I3);

            var _super49 = _createSuper(y);

            function y(e) {
              var _this157;

              _classCallCheck(this, y);

              _this157 = _super49.call(this), S(_assertThisInitialized(_this157), "attributes", void 0), -1 !== e.protos.indexOf("RTP") || e.protos.indexOf("rtp"), _this157.attributes = {
                unrecognized: [],
                candidates: [],
                extmaps: [],
                fingerprints: [],
                imageattr: [],
                msids: [],
                remoteCandidatesList: [],
                rids: [],
                ssrcs: [],
                ssrcGroups: [],
                rtcpFeedbackWildcards: [],
                payloads: []
              };
              return _this157;
            }

            _createClass(y, [{
              key: "parse",
              value: function parse(e) {
                if (this.digested) throw new Error("already digested");

                try {
                  switch (e.attField) {
                    case "extmap":
                      this.parseExtmap(e);
                      break;

                    case "setup":
                      this.parseSetup(e);
                      break;

                    case "ice-ufrag":
                      this.parseIceUfrag(e);
                      break;

                    case "ice-pwd":
                      this.parseIcePwd(e);
                      break;

                    case "ice-options":
                      this.parseIceOptions(e);
                      break;

                    case "candidate":
                      this.parseCandidate(e);
                      break;

                    case "remote-candidate":
                      this.parseRemoteCandidate(e);
                      break;

                    case "end-of-candidates":
                      this.parseEndOfCandidates();
                      break;

                    case "fingerprint":
                      this.parseFingerprint(e);
                      break;

                    case "rtpmap":
                      this.parseRtpmap(e);
                      break;

                    case "ptime":
                      this.parsePtime(e);
                      break;

                    case "maxptime":
                      this.parseMaxPtime(e);
                      break;

                    case "sendrecv":
                    case "recvonly":
                    case "sendonly":
                    case "inactive":
                      this.parseDirection(e);
                      break;

                    case "ssrc":
                      this.parseSSRC(e);
                      break;

                    case "fmtp":
                      this.parseFmtp(e);
                      break;

                    case "rtcp-fb":
                      this.parseRtcpFb(e);
                      break;

                    case "rtcp-mux":
                      this.parseRTCPMux();
                      break;

                    case "rtcp-mux-only":
                      this.parseRTCPMuxOnly();
                      break;

                    case "rtcp-rsize":
                      this.parseRTCPRsize();
                      break;

                    case "rtcp":
                      this.parseRTCP(e);
                      break;

                    case "mid":
                      this.parseMid(e);
                      break;

                    case "msid":
                      this.parseMsid(e);
                      break;

                    case "imageattr":
                      this.parseImageAttr(e);
                      break;

                    case "rid":
                      this.parseRid(e);
                      break;

                    case "simulcast":
                      this.parseSimulcast(e);
                      break;

                    case "sctp-port":
                      this.parseSctpPort(e);
                      break;

                    case "max-message-size":
                      this.parseMaxMessageSize(e);
                      break;

                    case "ssrc-group":
                      this.parseSSRCGroup(e);
                      break;

                    default:
                      e.ignored = !0, this.attributes.unrecognized.push(e);
                  }
                } catch (t) {
                  throw console.error("parsing media attribute ".concat(e.attField, ' error, "a=').concat(e.attField, ":").concat(e.attValue, '"')), t;
                }

                if (!e.ignored && e.attValue && !this.atEnd(e)) throw new Error("attribute parsing error");
              }
            }, {
              key: "parseCandidate",
              value: function parseCandidate(e) {
                var t = this.extractOneOrMore(e, E, [1, 32]);
                this.consumeAttributeSpace(e);
                var i = this.extractOneOrMore(e, a, [1, 5]);
                this.consumeAttributeSpace(e);
                var n = this.extract(e, this.consumeToken);
                this.consumeAttributeSpace(e);
                var s = this.extractOneOrMore(e, a, [1, 10]);
                this.consumeAttributeSpace(e);
                var o = this.extract(e, this.consumeAddress);
                this.consumeAttributeSpace(e);
                var d = this.extract(e, this.consumePort);
                this.consumeAttributeSpace(e), this.extract(e, this.consume, "typ"), this.consumeAttributeSpace(e);
                var l = {
                  foundation: t,
                  componentId: i,
                  transport: n,
                  priority: s,
                  connectionAddress: o,
                  port: d,
                  type: this.extract(e, this.consumeToken),
                  extension: {}
                };

                for (this.peek(e, " raddr") && (this.extract(e, this.consume, " raddr"), this.consumeAttributeSpace(e), l.relAddr = this.extract(e, this.consumeAddress)), this.peek(e, " rport") && (this.extract(e, this.consume, " rport"), this.consumeAttributeSpace(e), l.relPort = this.extract(e, this.consumePort)); this.peekChar(e) === r;) {
                  this.consumeAttributeSpace(e);

                  var _t133 = this.extract(e, this.consumeToken);

                  this.consumeAttributeSpace(e), l.extension[_t133] = this.extractOneOrMore(e, c);
                }

                this.attributes.candidates.push(l);
              }
            }, {
              key: "parseRemoteCandidate",
              value: function parseRemoteCandidate(e) {
                var t = [];

                for (;;) {
                  var _i72 = this.extractOneOrMore(e, a, [1, 5]);

                  this.consumeAttributeSpace(e);

                  var _n64 = this.extract(e, this.consumeAddress);

                  this.consumeAttributeSpace(e);

                  var _s35 = this.extract(e, this.consumePort);

                  t.push({
                    componentId: _i72,
                    connectionAddress: _n64,
                    port: _s35
                  });

                  try {
                    this.consumeAttributeSpace(e);
                  } catch (e) {
                    break;
                  }
                }

                this.attributes.remoteCandidatesList.push(t);
              }
            }, {
              key: "parseEndOfCandidates",
              value: function parseEndOfCandidates() {
                if (this.attributes.endOfCandidates) throw new Error("must be only one line of end-of-candidates");
                this.attributes.endOfCandidates = !0;
              }
            }, {
              key: "parseRtpmap",
              value: function parseRtpmap(e) {
                var t = this.extract(e, this.consumeToken);
                this.consumeAttributeSpace(e);
                var i = this.extract(e, this.consumeTill, "/");
                this.extract(e, this.consume, "/");
                var n = {
                  encodingName: i,
                  clockRate: this.extractOneOrMore(e, a)
                };
                this.atEnd(e) || "/" !== this.peekChar(e) || (this.extract(e, this.consume, "/"), n.encodingParameters = parseInt(this.extract(e, this.consumeTill), 10));
                var s = this.attributes.payloads.find(function (e) {
                  return e.payloadType === parseInt(t, 10);
                });
                s ? s.rtpMap = n : this.attributes.payloads.push({
                  payloadType: parseInt(t, 10),
                  rtpMap: n,
                  rtcpFeedbacks: []
                });
              }
            }, {
              key: "parsePtime",
              value: function parsePtime(e) {
                if (this.attributes.ptime) throw new Error("must be only one line of ptime");
                this.attributes.ptime = this.extract(e, this.consumeTill);
              }
            }, {
              key: "parseMaxPtime",
              value: function parseMaxPtime(e) {
                if (this.attributes.maxPtime) throw new Error("must be only one line of ptime");
                this.attributes.maxPtime = this.extract(e, this.consumeTill);
              }
            }, {
              key: "parseDirection",
              value: function parseDirection(e) {
                if (this.attributes.direction) throw new Error("must be only one line of direction info");
                this.attributes.direction = e.attField;
              }
            }, {
              key: "parseSSRC",
              value: function parseSSRC(e) {
                var t = this.extractOneOrMore(e, a);
                this.consumeAttributeSpace(e);
                var i = this.extract(e, this.consumeTill, ":");
                var n;
                ":" === this.peekChar(e) && (this.extract(e, this.consume, ":"), n = this.extract(e, this.consumeTill));
                var s = this.attributes.ssrcs.find(function (e) {
                  return e.ssrcId === parseInt(t, 10);
                });
                s ? s.attributes[i] = n : this.attributes.ssrcs.push({
                  ssrcId: parseInt(t, 10),
                  attributes: _defineProperty({}, i, n)
                });
              }
            }, {
              key: "parseFmtp",
              value: function parseFmtp(e) {
                var t = this.extract(e, this.consumeTill, r);
                this.consumeAttributeSpace(e);
                var i = this.extract(e, this.consumeTill),
                    n = {};
                i.split(";").forEach(function (e) {
                  var _e$split3 = e.split("="),
                      _e$split4 = _slicedToArray(_e$split3, 2),
                      t = _e$split4[0],
                      i = _e$split4[1];

                  t = t.trim();
                  var s = "string" == typeof i ? i.trim() : null;
                  "string" == typeof t && t.length > 0 && (n[t] = s);
                });
                var s = this.attributes.payloads.find(function (e) {
                  return e.payloadType === parseInt(t, 10);
                });
                s ? s.fmtp = {
                  parameters: n
                } : this.attributes.payloads.push({
                  payloadType: parseInt(t, 10),
                  rtcpFeedbacks: [],
                  fmtp: {
                    parameters: n
                  }
                });
              }
            }, {
              key: "parseFmtParameters",
              value: function parseFmtParameters(e) {
                var t = {},
                    i = this.extract(e, this.consumeTill, "=");
                e._cur++;
                var n = this.extract(e, this.consumeTill, ";");

                for (t[i] = n; ";" === e.attValue[e._cur];) {
                  var _i73 = this.extract(e, this.consumeTill, "=");

                  e._cur++;

                  var _n65 = this.extract(e, this.consumeTill, ";");

                  t[_i73] = _n65;
                }

                return t;
              }
            }, {
              key: "parseRtcpFb",
              value: function parseRtcpFb(e) {
                var t = "";
                t = "*" === this.peekChar(e) ? this.extract(e, this.consume, "*") : this.extract(e, this.consumeTill, r), this.consumeAttributeSpace(e);
                var i = this.extract(e, this.consumeTill, r);
                var n;
                if ("trr-int" === i) n = {
                  type: i,
                  interval: this.extract(e, this.consumeTill)
                };else {
                  var _t134 = {
                    type: i
                  };
                  this.peekChar(e) === r && (this.consumeAttributeSpace(e), _t134.parameter = this.extract(e, this.consumeToken), this.peekChar(e) === r && (_t134.additional = this.extract(e, this.consumeTill))), n = _t134;
                }
                if ("*" === t) this.attributes.rtcpFeedbackWildcards.push(n);else {
                  var _e101 = this.attributes.payloads.find(function (e) {
                    return e.payloadType === parseInt(t, 10);
                  });

                  _e101 ? _e101.rtcpFeedbacks.push(n) : this.attributes.payloads.push({
                    payloadType: parseInt(t, 10),
                    rtcpFeedbacks: [n]
                  });
                }
              }
            }, {
              key: "parseRTCPMux",
              value: function parseRTCPMux() {
                if (this.attributes.rtcpMux) throw new Error("must be single line of rtcp-mux");
                this.attributes.rtcpMux = !0;
              }
            }, {
              key: "parseRTCPMuxOnly",
              value: function parseRTCPMuxOnly() {
                if (this.attributes.rtcpMuxOnly) throw new Error("must be single line of rtcp-only");
                this.attributes.rtcpMuxOnly = !0;
              }
            }, {
              key: "parseRTCPRsize",
              value: function parseRTCPRsize() {
                if (this.attributes.rtcpRsize) throw new Error("must be single line of rtcp-rsize");
                this.attributes.rtcpRsize = !0;
              }
            }, {
              key: "parseRTCP",
              value: function parseRTCP(e) {
                if (this.attributes.rtcp) throw new Error("must be single line of rtcp");
                var t = {
                  port: this.extract(e, this.consumePort)
                };
                this.peekChar(e) === r && (this.consumeAttributeSpace(e), t.netType = this.extractOneOrMore(e, l), this.consumeAttributeSpace(e), t.addressType = this.extractOneOrMore(e, l), this.consumeAttributeSpace(e), t.address = this.extract(e, this.consumeAddress)), this.attributes.rtcp = t;
              }
            }, {
              key: "parseMsid",
              value: function parseMsid(e) {
                var t = {
                  id: this.extractOneOrMore(e, l, [1, 64])
                };
                this.peekChar(e) === r && (this.consumeAttributeSpace(e), t.appdata = this.extractOneOrMore(e, l, [1, 64])), this.attributes.msids.push(t);
              }
            }, {
              key: "parseImageAttr",
              value: function parseImageAttr(e) {
                this.attributes.imageattr.push(e.attValue);
              }
            }, {
              key: "parseRid",
              value: function parseRid(e) {
                var t = this.extractOneOrMore(e, function (e) {
                  return h(e) || a(e) || "_" === e || "-" === e;
                });
                this.consumeAttributeSpace(e);
                var i = {
                  id: t,
                  direction: this.extract(e, this.consumeToken),
                  params: []
                };

                if (this.peekChar(e) === r) {
                  if (this.consumeAttributeSpace(e), this.peek(e, "pt=")) {
                    this.extract(e, this.consume, "pt=");
                    var _t135 = [];

                    for (;;) {
                      var _i74 = this.extract(e, this.consumeToken);

                      _t135.push(_i74);

                      try {
                        this.extract(e, this.consume, ",");
                      } catch (e) {
                        break;
                      }
                    }

                    i.payloads = _t135, this.peekChar(e) === r && this.extract(e, this.consume, r);
                  }

                  for (;;) {
                    var _t136 = this.extract(e, this.consumeToken);

                    switch (_t136) {
                      case "depend":
                        {
                          var _n66 = {
                            type: _t136,
                            rids: this.extract(e, this.consume, "=").split(",")
                          };
                          i.params.push(_n66);
                          break;
                        }

                      default:
                        {
                          var _n67 = {
                            type: _t136
                          };
                          "=" === this.peekChar(e) && (this.extract(e, this.consume, "="), _n67.val = this.extract(e, this.consumeTill, ";")), i.params.push(_n67);
                        }
                    }

                    try {
                      this.extract(e, this.consume, ";");
                    } catch (e) {
                      break;
                    }
                  }
                }

                this.attributes.rids.push(i);
              }
            }, {
              key: "parseSimulcast",
              value: function parseSimulcast(e) {
                if (this.attributes.simulcast) throw new Error("must be single line of simulcast");
                this.attributes.simulcast = e.attValue, this.extract(e, this.consumeTill);
              }
            }, {
              key: "parseSctpPort",
              value: function parseSctpPort(e) {
                this.attributes.sctpPort = this.extractOneOrMore(e, a, [1, 5]);
              }
            }, {
              key: "parseMaxMessageSize",
              value: function parseMaxMessageSize(e) {
                this.attributes.maxMessageSize = this.extractOneOrMore(e, a, [1, void 0]);
              }
            }, {
              key: "digest",
              value: function digest() {
                return this.digested = !0, this.attributes;
              }
            }, {
              key: "parseMid",
              value: function parseMid(e) {
                this.attributes.mid = this.extract(e, this.consumeToken);
              }
            }, {
              key: "parseSSRCGroup",
              value: function parseSSRCGroup(e) {
                var t = this.extract(e, this.consumeToken),
                    i = [];

                for (;;) {
                  try {
                    this.consumeAttributeSpace(e);

                    var _t137 = this.extract(e, this.consumeInteger);

                    i.push(parseInt(_t137, 10));
                  } catch (e) {
                    break;
                  }
                }

                this.attributes.ssrcGroups.push({
                  semantic: t,
                  ssrcIds: i
                });
              }
            }]);

            return y;
          }(I);

          function A(e, t, i) {
            return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }

          var b = /*#__PURE__*/function () {
            function b() {
              _classCallCheck(this, b);

              A(this, "eol", s);
            }

            _createClass(b, [{
              key: "print",
              value: function print(e, t) {
                var i = "";
                return t && (this.eol = t), i += this.printVersion(e.version), i += this.printOrigin(e.origin), i += this.printSessionName(e.sessionName), i += this.printInformation(e.information), i += this.printUri(e.uri), i += this.printEmail(e.emails), i += this.printPhone(e.phones), i += this.printConnection(e.connection), i += this.printBandwidth(e.bandwidths), i += this.printTimeFields(e.timeFields), i += this.printKey(e.key), i += this.printSessionAttributes(e.attributes), i += this.printMediaDescription(e.mediaDescriptions), i;
              }
            }, {
              key: "printVersion",
              value: function printVersion(e) {
                return "v=".concat(e).concat(this.eol);
              }
            }, {
              key: "printOrigin",
              value: function printOrigin(e) {
                return "o=".concat(e.username, " ").concat(e.sessId, " ").concat(e.sessVersion, " ").concat(e.nettype, " ").concat(e.addrtype, " ").concat(e.unicastAddress).concat(this.eol);
              }
            }, {
              key: "printSessionName",
              value: function printSessionName(e) {
                return e ? "s=".concat(e).concat(this.eol) : "";
              }
            }, {
              key: "printInformation",
              value: function printInformation(e) {
                return e ? "i=".concat(e).concat(this.eol) : "";
              }
            }, {
              key: "printUri",
              value: function printUri(e) {
                return e ? "u=".concat(e).concat(this.eol) : "";
              }
            }, {
              key: "printEmail",
              value: function printEmail(e) {
                var t = "";

                var _iterator10 = _createForOfIteratorHelper(e),
                    _step10;

                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _i75 = _step10.value;
                    t += "e=".concat(_i75).concat(this.eol);
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }

                return t;
              }
            }, {
              key: "printPhone",
              value: function printPhone(e) {
                var t = "";

                var _iterator11 = _createForOfIteratorHelper(e),
                    _step11;

                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    var _i76 = _step11.value;
                    t += "e=".concat(_i76).concat(this.eol);
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }

                return t;
              }
            }, {
              key: "printConnection",
              value: function printConnection(e) {
                return e ? "c=".concat(e.nettype, " ").concat(e.addrtype, " ").concat(e.address).concat(this.eol) : "";
              }
            }, {
              key: "printBandwidth",
              value: function printBandwidth(e) {
                var t = "";

                var _iterator12 = _createForOfIteratorHelper(e),
                    _step12;

                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    var _i77 = _step12.value;
                    t += "b=".concat(_i77.bwtype, ":").concat(_i77.bandwidth).concat(this.eol);
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }

                return t;
              }
            }, {
              key: "printTimeFields",
              value: function printTimeFields(e) {
                var t = "";

                var _iterator13 = _createForOfIteratorHelper(e),
                    _step13;

                try {
                  for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                    var _i78 = _step13.value;
                    t += "t=".concat(_i78.time.startTime, " ").concat(_i78.time.startTime).concat(this.eol);

                    var _iterator14 = _createForOfIteratorHelper(_i78.repeats),
                        _step14;

                    try {
                      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                        var _e102 = _step14.value;
                        t += "r=".concat(_e102.repeatInterval, " ").concat(_e102.typedTimes.join(" ")).concat(this.eol);
                      }
                    } catch (err) {
                      _iterator14.e(err);
                    } finally {
                      _iterator14.f();
                    }

                    _i78.zoneAdjustments && (t += "z=", t += "z=".concat(_i78.zoneAdjustments.map(function (e) {
                      return "".concat(e.time, " ").concat(e.back ? "-" : "", " ").concat(e.typedTime);
                    }).join(" ")).concat(this.eol), t += this.eol);
                  }
                } catch (err) {
                  _iterator13.e(err);
                } finally {
                  _iterator13.f();
                }

                return t;
              }
            }, {
              key: "printKey",
              value: function printKey(e) {
                return e ? "k=".concat(e).concat(this.eol) : "";
              }
            }, {
              key: "printAttributes",
              value: function printAttributes(e) {
                var t = "";

                var _iterator15 = _createForOfIteratorHelper(e),
                    _step15;

                try {
                  for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                    var _i79 = _step15.value;
                    t += "a=".concat(_i79.attField).concat(_i79.attValue ? ":".concat(_i79.attValue) : "").concat(this.eol);
                  }
                } catch (err) {
                  _iterator15.e(err);
                } finally {
                  _iterator15.f();
                }

                return t;
              }
            }, {
              key: "printMediaDescription",
              value: function printMediaDescription(e) {
                var t = "";

                var _iterator16 = _createForOfIteratorHelper(e),
                    _step16;

                try {
                  for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                    var _i80 = _step16.value;
                    t += this.printMedia(_i80.media), t += this.printInformation(_i80.information), t += this.printConnections(_i80.connections), t += this.printBandwidth(_i80.bandwidths), t += this.printKey(_i80.key), t += this.printMediaAttributes(_i80);
                  }
                } catch (err) {
                  _iterator16.e(err);
                } finally {
                  _iterator16.f();
                }

                return t;
              }
            }, {
              key: "printConnections",
              value: function printConnections(e) {
                var t = "";

                var _iterator17 = _createForOfIteratorHelper(e),
                    _step17;

                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    var _i81 = _step17.value;
                    t += this.printConnection(_i81);
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }

                return t;
              }
            }, {
              key: "printMedia",
              value: function printMedia(e) {
                return "m=".concat(e.mediaType, " ").concat(e.port, " ").concat(e.protos.join("/"), " ").concat(e.fmts.join(" ")).concat(this.eol);
              }
            }, {
              key: "printSessionAttributes",
              value: function printSessionAttributes(e) {
                return new O(this.eol).print(e);
              }
            }, {
              key: "printMediaAttributes",
              value: function printMediaAttributes(e) {
                return new N(this.eol).print(e);
              }
            }]);

            return b;
          }();

          var w = /*#__PURE__*/function () {
            function w(e) {
              _classCallCheck(this, w);

              A(this, "eol", void 0), this.eol = e;
            }

            _createClass(w, [{
              key: "printIceUfrag",
              value: function printIceUfrag(e) {
                return void 0 === e ? "" : "a=ice-ufrag:".concat(e).concat(this.eol);
              }
            }, {
              key: "printIcePwd",
              value: function printIcePwd(e) {
                return void 0 === e ? "" : "a=ice-pwd:".concat(e).concat(this.eol);
              }
            }, {
              key: "printIceOptions",
              value: function printIceOptions(e) {
                return void 0 === e ? "" : "a=ice-options:".concat(e.join(r)).concat(this.eol);
              }
            }, {
              key: "printFingerprints",
              value: function printFingerprints(e) {
                return e.length > 0 ? e.map(function (e) {
                  return "a=fingerprint:".concat(e.hashFunction).concat(r).concat(e.fingerprint);
                }).join(this.eol) + this.eol : "";
              }
            }, {
              key: "printExtmap",
              value: function printExtmap(e) {
                var _this158 = this;

                return e.map(function (e) {
                  return "a=extmap:".concat(e.entry).concat(e.direction ? "/".concat(e.direction) : "").concat(r).concat(e.extensionName).concat(e.extensionAttributes ? "".concat(r).concat(e.extensionAttributes) : "").concat(_this158.eol);
                }).join("");
              }
            }, {
              key: "printSetup",
              value: function printSetup(e) {
                return void 0 === e ? "" : "a=setup:".concat(e).concat(this.eol);
              }
            }, {
              key: "printUnrecognized",
              value: function printUnrecognized(e) {
                var _this159 = this;

                return e.map(function (e) {
                  return "a=".concat(e.attField).concat(e.attValue ? ":".concat(e.attValue) : "").concat(_this159.eol);
                }).join("");
              }
            }]);

            return w;
          }();

          var O = /*#__PURE__*/function (_w2) {
            _inherits(O, _w2);

            var _super50 = _createSuper(O);

            function O() {
              _classCallCheck(this, O);

              return _super50.apply(this, arguments);
            }

            _createClass(O, [{
              key: "print",
              value: function print(e) {
                var t = "";
                return t += this.printGroups(e.groups), t += this.printMsidSemantic(e.msidSemantic), t += this.printIceLite(e.iceLite), t += this.printIceUfrag(e.iceUfrag), t += this.printIcePwd(e.icePwd), t += this.printIceOptions(e.iceOptions), t += this.printFingerprints(e.fingerprints), t += this.printSetup(e.setup), t += this.printTlsId(e.tlsId), t += this.printIdentity(e.identities), t += this.printExtmap(e.extmaps), t += this.printUnrecognized(e.unrecognized), t;
              }
            }, {
              key: "printGroups",
              value: function printGroups(e) {
                var _this160 = this;

                var t = "";
                return e.length > 0 && (t += e.map(function (e) {
                  return "a=group:".concat(e.semantic).concat(e.identificationTag.map(function (e) {
                    return "".concat(r).concat(e);
                  }).join("")).concat(_this160.eol);
                }).join("")), t;
              }
            }, {
              key: "printIceLite",
              value: function printIceLite(e) {
                return void 0 === e ? "" : "a=ice-lite" + this.eol;
              }
            }, {
              key: "printTlsId",
              value: function printTlsId(e) {
                return e ? "a=tls-id:".concat(e).concat(this.eol) : "";
              }
            }, {
              key: "printIdentity",
              value: function printIdentity(e) {
                return 0 === e.length ? "" : e.map(function (e) {
                  return "a=identity:".concat(e.assertionValue).concat(e.extensions.map(function (e) {
                    return "".concat(r).concat(e.name).concat(e.value ? "=".concat(e.value) : "");
                  }));
                }).join(this.eol) + this.eol;
              }
            }, {
              key: "printMsidSemantic",
              value: function printMsidSemantic(e) {
                if (!e) return "";
                var t = "a=msid-semantic:".concat(e.semantic);
                return e.applyForAll ? t += "".concat(r, "*") : e.identifierList.length > 0 && (t += e.identifierList.map(function (e) {
                  return "".concat(r).concat(e);
                })), t + this.eol;
              }
            }]);

            return O;
          }(w);

          var N = /*#__PURE__*/function (_w3) {
            _inherits(N, _w3);

            var _super51 = _createSuper(N);

            function N() {
              _classCallCheck(this, N);

              return _super51.apply(this, arguments);
            }

            _createClass(N, [{
              key: "print",
              value: function print(e) {
                var t = e.attributes;
                var i = "";
                return i += this.printRTCP(t.rtcp), i += this.printIceUfrag(t.iceUfrag), i += this.printIcePwd(t.icePwd), i += this.printIceOptions(t.iceOptions), i += this.printCandidates(t.candidates), i += this.printRemoteCandidatesList(t.remoteCandidatesList), i += this.printEndOfCandidates(t.endOfCandidates), i += this.printFingerprints(t.fingerprints), i += this.printSetup(t.setup), i += this.printMid(t.mid), i += this.printExtmap(t.extmaps), i += this.printRTPRelated(t), i += this.printPtime(t.ptime), i += this.printMaxPtime(t.maxPtime), i += this.printDirection(t.direction), i += this.printSSRCGroups(t.ssrcGroups), i += this.printSSRC(t.ssrcs), i += this.printRTCPMux(t.rtcpMux), i += this.printRTCPMuxOnly(t.rtcpMuxOnly), i += this.printRTCPRsize(t.rtcpRsize), i += this.printMSId(t.msids), i += this.printImageattr(t.imageattr), i += this.printRid(t.rids), i += this.printSimulcast(t.simulcast), i += this.printSCTPPort(t.sctpPort), i += this.printMaxMessageSize(t.maxMessageSize), i += this.printUnrecognized(t.unrecognized), i;
              }
            }, {
              key: "printCandidates",
              value: function printCandidates(e) {
                var _this161 = this;

                return e.map(function (e) {
                  return "a=candidate:".concat(e.foundation).concat(r).concat(e.componentId).concat(r).concat(e.transport).concat(r).concat(e.priority).concat(r).concat(e.connectionAddress).concat(r).concat(e.port).concat(r, "typ").concat(r).concat(e.type).concat(e.relAddr ? "".concat(r, "raddr").concat(r).concat(e.relAddr) : "").concat(e.relPort ? "".concat(r, "rport").concat(r).concat(e.relPort) : "").concat(Object.keys(e.extension).map(function (t) {
                    return "".concat(r).concat(t).concat(r).concat(e.extension[t]);
                  }).join("")).concat(_this161.eol);
                }).join("");
              }
            }, {
              key: "printRemoteCandidatesList",
              value: function printRemoteCandidatesList(e) {
                var _this162 = this;

                return e.map(function (e) {
                  return "a=remote-candidates:".concat(e.join(r)).concat(_this162.eol);
                }).join("");
              }
            }, {
              key: "printEndOfCandidates",
              value: function printEndOfCandidates(e) {
                return void 0 === e ? "" : "a=end-of-candidates" + this.eol;
              }
            }, {
              key: "printRTPRelated",
              value: function printRTPRelated(e) {
                var _this163 = this;

                if (!e.payloads) return "";
                var t = e.payloads;
                var i = "";
                i += e.rtcpFeedbackWildcards.map(function (e) {
                  return _this163.printRTCPFeedback("*", e);
                }).join("");

                var _iterator18 = _createForOfIteratorHelper(t),
                    _step18;

                try {
                  var _loop = function _loop() {
                    var e = _step18.value;
                    i += _this163.printRtpMap(e.payloadType, e.rtpMap), i += _this163.printFmtp(e.payloadType, e.fmtp), i += e.rtcpFeedbacks.map(function (t) {
                      return _this163.printRTCPFeedback(e.payloadType, t);
                    }).join("");
                  };

                  for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator18.e(err);
                } finally {
                  _iterator18.f();
                }

                return i;
              }
            }, {
              key: "printFmtp",
              value: function printFmtp(e, t) {
                if (!t) return "";
                var i = Object.keys(t.parameters);
                return 1 === i.length && null === t.parameters[i[0]] ? "a=fmtp:".concat(e).concat(r).concat(i[0]).concat(this.eol) : "a=fmtp:".concat(e).concat(r).concat(Object.keys(t.parameters).map(function (e) {
                  return "".concat(e, "=").concat(t.parameters[e]);
                }).join(";")).concat(this.eol);
              }
            }, {
              key: "printRtpMap",
              value: function printRtpMap(e, t) {
                return t ? "a=rtpmap:".concat(e).concat(r).concat(t.encodingName, "/").concat(t.clockRate).concat(t.encodingParameters ? "/".concat(t.encodingParameters) : "").concat(this.eol) : "";
              }
            }, {
              key: "printRTCPFeedback",
              value: function printRTCPFeedback(e, t) {
                var i = "a=rtcp-fb:".concat(e).concat(r),
                    n = t;
                return "trr-int" === n.type ? i += "ttr-int".concat(r).concat(n.interval) : (i += "".concat(n.type), n.parameter && (i += "".concat(r).concat(n.parameter), n.additional && (i += "".concat(r).concat(n.additional)))), i + this.eol;
              }
            }, {
              key: "printPtime",
              value: function printPtime(e) {
                return void 0 === e ? "" : "a=ptime:".concat(e).concat(this.eol);
              }
            }, {
              key: "printMaxPtime",
              value: function printMaxPtime(e) {
                return void 0 === e ? "" : "a=maxptime:".concat(e).concat(this.eol);
              }
            }, {
              key: "printDirection",
              value: function printDirection(e) {
                return void 0 === e ? "" : "a=".concat(e).concat(this.eol);
              }
            }, {
              key: "printSSRC",
              value: function printSSRC(e) {
                var _this164 = this;

                return e.map(function (e) {
                  return Object.keys(e.attributes).map(function (t) {
                    return "a=ssrc:".concat(e.ssrcId.toString(10)).concat(r).concat(t).concat(e.attributes[t] ? ":".concat(e.attributes[t]) : "").concat(_this164.eol);
                  }).join("");
                }).join("");
              }
            }, {
              key: "printRTCPMux",
              value: function printRTCPMux(e) {
                return void 0 === e ? "" : "a=rtcp-mux".concat(this.eol);
              }
            }, {
              key: "printRTCPMuxOnly",
              value: function printRTCPMuxOnly(e) {
                return void 0 === e ? "" : "a=rtcp-mux-only".concat(this.eol);
              }
            }, {
              key: "printRTCPRsize",
              value: function printRTCPRsize(e) {
                return void 0 === e ? "" : "a=rtcp-rsize".concat(this.eol);
              }
            }, {
              key: "printRTCP",
              value: function printRTCP(e) {
                if (void 0 === e) return "";
                var t = "a=rtcp:".concat(e.port);
                return e.netType && (t += "".concat(r).concat(e.netType)), e.addressType && (t += "".concat(r).concat(e.addressType)), e.address && (t += "".concat(r).concat(e.address)), t + this.eol;
              }
            }, {
              key: "printMSId",
              value: function printMSId(e) {
                var _this165 = this;

                return e.map(function (e) {
                  return "a=msid:".concat(e.id).concat(e.appdata ? "".concat(r).concat(e.appdata) : "").concat(_this165.eol);
                }).join("");
              }
            }, {
              key: "printImageattr",
              value: function printImageattr(e) {
                var _this166 = this;

                return e.map(function (e) {
                  return "a=imageattr:".concat(e).concat(_this166.eol);
                }).join("");
              }
            }, {
              key: "printRid",
              value: function printRid(e) {
                var _this167 = this;

                return e.map(function (e) {
                  var t = "a=rid:".concat(e.id).concat(r).concat(e.direction);
                  return e.payloads && (t += "".concat(r, "pt=").concat(e.payloads.join(","))), e.params.length > 0 && (t += "".concat(r).concat(e.params.map(function (e) {
                    return "depend" === e.type ? "depend=".concat(e.rids.join(",")) : "".concat(e.type, "=").concat(e.val);
                  }).join(";"))), t + _this167.eol;
                }).join("");
              }
            }, {
              key: "printSimulcast",
              value: function printSimulcast(e) {
                return void 0 === e ? "" : "a=simulcast:".concat(e).concat(this.eol);
              }
            }, {
              key: "printSCTPPort",
              value: function printSCTPPort(e) {
                return void 0 === e ? "" : "a=sctp-port:".concat(e).concat(this.eol);
              }
            }, {
              key: "printMaxMessageSize",
              value: function printMaxMessageSize(e) {
                return void 0 === e ? "" : "a=max-message-size:".concat(e).concat(this.eol);
              }
            }, {
              key: "printMid",
              value: function printMid(e) {
                return void 0 === e ? "" : "a=mid:".concat(e).concat(this.eol);
              }
            }, {
              key: "printSSRCGroups",
              value: function printSSRCGroups(e) {
                var _this168 = this;

                return e.map(function (e) {
                  return "a=ssrc-group:".concat(e.semantic).concat(e.ssrcIds.map(function (e) {
                    return "".concat(r).concat(e.toString(10));
                  }).join("")).concat(_this168.eol);
                }).join("");
              }
            }]);

            return N;
          }(w);

          function D(e) {
            return new C().parse(e);
          }

          function P(e, t) {
            return new b().print(e, t);
          }
        }
      },
          t = {};

      function i(n) {
        if (t[n]) return t[n].exports;
        var s = t[n] = {
          exports: {}
        };
        return e[n](s, s.exports, i), s.exports;
      }

      return i.d = function (e, t) {
        for (var n in t) {
          i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
          });
        }
      }, i.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, i.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, i(8);
    }();
  }(KP);
  var YP = KP.exports;

  function qP(e) {
    if (Array.isArray(e)) return e.map(function (e) {
      return e;
    });
    if (!JP(e)) return e;
    var t = {};

    for (var i in e) {
      var _n68 = e[i];
      JP(_n68) || Array.isArray(_n68) ? t[i] = qP(_n68) : t[i] = _n68;
    }

    return t;
  }

  function JP(e) {
    return !("object" != _typeof(e) || Array.isArray(e) || !e);
  }

  var zP = /*#__PURE__*/function () {
    function zP(e) {
      _classCallCheck(this, zP);

      nh(this, "input", []), nh(this, "size", void 0), this.size = e;
    }

    _createClass(zP, [{
      key: "add",
      value: function add(e) {
        this.input.push(e), this.input.length > this.size && this.input.splice(0, 1);
      }
    }, {
      key: "diffMean",
      value: function diffMean() {
        return 0 === this.input.length ? 0 : (this.input[this.input.length - 1] - this.input[0]) / this.input.length;
      }
    }]);

    return zP;
  }();

  var XP = {
    address: "unknown",
    candidateType: "unknown",
    id: "unknown",
    port: 0,
    priority: 0,
    protocol: "unknown",
    type: "unknown"
  },
      QP = {
    timestamp: 0,
    bitrate: {
      actualEncoded: 0,
      transmit: 0
    },
    sendPacketLossRate: 0,
    recvPacketLossRate: 0,
    videoRecv: [],
    videoSend: [],
    audioRecv: [],
    audioSend: [],
    selectedCandidatePair: {
      id: "unknown",
      localCandidate: XP,
      remoteCandidate: XP
    }
  },
      ZP = {
    firsCount: 0,
    nacksCount: 0,
    plisCount: 0,
    framesDecodeCount: 0,
    framesDecodeInterval: 0,
    framesDecodeFreezeTime: 0,
    decodeFrameRate: 0,
    bytes: 0,
    packetsLost: 0,
    packetLostRate: 0,
    packets: 0,
    ssrc: 0,
    qpSumPerFrame: 0
  },
      $P = {
    firsCount: 0,
    nacksCount: 0,
    plisCount: 0,
    frameCount: 0,
    bytes: 0,
    packets: 0,
    packetsLost: 0,
    packetLostRate: 0,
    ssrc: 0,
    rttMs: 0,
    jitterMs: 0,
    qpSumPerFrame: 0
  },
      eL = {
    bytes: 0,
    packets: 0,
    packetsLost: 0,
    packetLostRate: 0,
    ssrc: 0,
    rttMs: 0,
    jitterMs: 0
  },
      tL = {
    jitterBufferMs: 0,
    jitterMs: 0,
    bytes: 0,
    packetsLost: 0,
    packetLostRate: 0,
    packets: 0,
    ssrc: 0,
    receivedFrames: 0,
    droppedFrames: 0,
    concealedSamples: 0
  };

  function iL(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function nL(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? iL(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : iL(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var sL = /*#__PURE__*/function () {
    function sL(e, t) {
      var _this169 = this;

      _classCallCheck(this, sL);

      nh(this, "onFirstVideoReceived", void 0), nh(this, "onFirstVideoDecoded", void 0), nh(this, "onFirstAudioReceived", void 0), nh(this, "onFirstVideoDecodedTimeout", void 0), nh(this, "onFirstAudioDecoded", void 0), nh(this, "onSelectedLocalCandidateChanged", void 0), nh(this, "onSelectedRemoteCandidateChanged", void 0), nh(this, "videoIsReady", !1), nh(this, "videoIsReady2", {}), nh(this, "pc", void 0), nh(this, "options", void 0), nh(this, "intervalTimer", void 0), nh(this, "stats", qP(QP)), nh(this, "isFirstVideoReceived", {}), nh(this, "isFirstVideoDecoded", {}), nh(this, "isFirstAudioReceived", {}), nh(this, "isFirstAudioDecoded", {}), nh(this, "isFirstVideoDecodedTimeout", {}), nh(this, "lossRateWindowStats", []), this.pc = e, this.options = t, this.intervalTimer = window.setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee147() {
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                _this169.updateStats();

              case 1:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147);
      })), this.options.updateInterval);
    }

    _createClass(sL, [{
      key: "getStats",
      value: function getStats() {
        return this.stats;
      }
    }, {
      key: "getSelectedCandidatePair",
      value: function getSelectedCandidatePair() {
        return new tT(function (e) {
          e({
            local: nL({}, XP),
            remote: nL({}, XP)
          });
        });
      }
    }, {
      key: "setVideoIsReady",
      value: function setVideoIsReady(e) {
        this.videoIsReady = e;
      }
    }, {
      key: "setVideoIsReady2",
      value: function setVideoIsReady2(e, t) {
        this.videoIsReady2[e] = t;
      }
    }, {
      key: "getVideoIsReady",
      value: function getVideoIsReady(e) {
        return this.videoIsReady2[e] || !1;
      }
    }, {
      key: "setIsFirstAudioDecoded",
      value: function setIsFirstAudioDecoded(e) {}
    }, {
      key: "destroy",
      value: function destroy() {
        window.clearInterval(this.intervalTimer), this.pc = void 0;
      }
    }, {
      key: "calcLossRate",
      value: function calcLossRate(e) {
        var _this170 = this;

        this.lossRateWindowStats.push(e), this.lossRateWindowStats.length > this.options.lossRateInterval && this.lossRateWindowStats.splice(0, 1);
        var t = this.lossRateWindowStats.length,
            i = ["videoSend", "audioSend", "videoRecv", "audioRecv"];
        var n = 0,
            s = 0,
            r = 0,
            o = 0;

        var _loop2 = function _loop2() {
          var a = _i82[_i83];
          e[a].forEach(function (e, i) {
            if (!_this170.lossRateWindowStats[t - 1][a][i] || !_this170.lossRateWindowStats[0][a][i]) return;
            var c = _this170.lossRateWindowStats[t - 1][a][i].packets - _this170.lossRateWindowStats[0][a][i].packets,
                d = _this170.lossRateWindowStats[t - 1][a][i].packetsLost - _this170.lossRateWindowStats[0][a][i].packetsLost;
            "videoSend" === a || "audioSend" === a ? (n += c, r += d) : (s += c, o += d), Number.isNaN(c) || Number.isNaN(c) ? e.packetLostRate = 0 : e.packetLostRate = c <= 0 || d <= 0 ? 0 : d / (c + d);
          });
        };

        for (var _i83 = 0, _i82 = i; _i83 < _i82.length; _i83++) {
          _loop2();
        }

        e.sendPacketLossRate = n <= 0 || r <= 0 ? 0 : r / (n + r), e.recvPacketLossRate = s <= 0 || o <= 0 ? 0 : o / (s + o);
      }
    }]);

    return sL;
  }();

  function rL(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function oL(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? rL(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : rL(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var aL = /*#__PURE__*/function (_sL) {
    _inherits(aL, _sL);

    var _super52 = _createSuper(aL);

    function aL() {
      var _this171;

      _classCallCheck(this, aL);

      _this171 = _super52.apply(this, arguments), nh(_assertThisInitialized(_this171), "_stats", QP), nh(_assertThisInitialized(_this171), "lastDecodeVideoReceiverStats", new Map());
      return _this171;
    }

    _createClass(aL, [{
      key: "updateStats",
      value: function () {
        var _updateStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee148() {
          var e, t, i, n;
          return _regeneratorRuntime.wrap(function _callee148$(_context148) {
            while (1) {
              switch (_context148.prev = _context148.next) {
                case 0:
                  _context148.next = 2;
                  return this._getStats();

                case 2:
                  e = _context148.sent;
                  t = this.statsResponsesToObjects(e);
                  this._stats = qP(QP);
                  i = t.filter(function (e) {
                    return "ssrc" === e.type;
                  });
                  this.processSSRCStats(i);
                  n = t.find(function (e) {
                    return "VideoBwe" === e.type;
                  });
                  n && this.processBandwidthStats(n), this._stats.timestamp = Date.now(), this.calcLossRate(this._stats), this.stats = this._stats;

                case 9:
                case "end":
                  return _context148.stop();
              }
            }
          }, _callee148, this);
        }));

        function updateStats() {
          return _updateStats.apply(this, arguments);
        }

        return updateStats;
      }()
    }, {
      key: "processBandwidthStats",
      value: function processBandwidthStats(e) {
        this._stats.bitrate = {
          actualEncoded: Number(e.googActualEncBitrate),
          targetEncoded: Number(e.googTargetEncBitrate),
          retransmit: Number(e.googRetransmitBitrate),
          transmit: Number(e.googTransmitBitrate)
        }, this._stats.sendBandwidth = Number(e.googAvailableSendBandwidth);
      }
    }, {
      key: "processSSRCStats",
      value: function processSSRCStats(e) {
        var _this172 = this;

        e.forEach(function (e) {
          var t;
          var i = bn(t = e.id).call(t, "send");

          switch ("".concat(e.mediaType, "_").concat(i ? "send" : "recv")) {
            case "video_send":
              {
                var _t138 = qP($P);

                _t138.codec = e.googCodecName, _t138.adaptionChangeReason = "none", e.googCpuLimitedResolution && (_t138.adaptionChangeReason = "cpu"), e.googBandwidthLimitedResolution && (_t138.adaptionChangeReason = "bandwidth"), _t138.avgEncodeMs = Number(e.googAvgEncodeMs), _t138.inputFrame = {
                  width: Number(e.googFrameWidthInput) || Number(e.googFrameWidthSent),
                  height: Number(e.googFrameHeightInput) || Number(e.googFrameHeightSent),
                  frameRate: Number(e.googFrameRateInput)
                }, _t138.sentFrame = {
                  width: Number(e.googFrameWidthSent),
                  height: Number(e.googFrameHeightSent),
                  frameRate: Number(e.googFrameRateInput)
                }, _t138.firsCount = Number(e.googFirReceived), _t138.nacksCount = Number(e.googNacksReceived), _t138.plisCount = Number(e.googPlisReceived), _t138.frameCount = Number(e.framesEncoded), _t138.bytes = Number(e.bytesSent), _t138.packets = Number(e.packetsSent), _t138.packetsLost = Number(e.packetsLost), _t138.ssrc = Number(e.ssrc), _t138.rttMs = Number(e.googRtt || 0), _this172._stats.videoSend.push(_t138), _this172._stats.rtt = _t138.rttMs;
                break;
              }

            case "video_recv":
              {
                var _t139 = qP(ZP),
                    _i84 = _this172.lastDecodeVideoReceiverStats.get(Number(e.ssrc));

                if (_t139.codec = e.googCodecName, _t139.targetDelayMs = Number(e.googTargetDelayMs), _t139.renderDelayMs = Number(e.googRenderDelayMs), _t139.currentDelayMs = Number(e.googCurrentDelayMs), _t139.minPlayoutDelayMs = Number(e.googMinPlayoutDelayMs), _t139.decodeMs = Number(e.googDecodeMs), _t139.maxDecodeMs = Number(e.googMaxDecodeMs), _t139.receivedFrame = {
                  width: Number(e.googFrameWidthReceived),
                  height: Number(e.googFrameHeightReceived),
                  frameRate: Number(e.googFrameRateReceived)
                }, _t139.decodedFrame = {
                  width: Number(e.googFrameWidthReceived),
                  height: Number(e.googFrameHeightReceived),
                  frameRate: Number(e.googFrameRateDecoded)
                }, _t139.decodeFrameRate = Number(e.googFrameRateDecoded), _t139.outputFrame = {
                  width: Number(e.googFrameWidthReceived),
                  height: Number(e.googFrameHeightReceived),
                  frameRate: Number(e.googFrameRateOutput)
                }, _t139.jitterBufferMs = Number(e.googJitterBufferMs), _t139.firsCount = Number(e.googFirsSent), _t139.nacksCount = Number(e.googNacksSent), _t139.plisCount = Number(e.googPlisSent), _t139.framesDecodeCount = Number(e.framesDecoded), _t139.bytes = Number(e.bytesReceived), _t139.packets = Number(e.packetsReceived), _t139.packetsLost = Number(e.packetsLost), _t139.ssrc = Number(e.ssrc), _t139.packets > 0 && !_this172.isFirstVideoReceived[_t139.ssrc] && (_this172.onFirstVideoReceived && _this172.onFirstVideoReceived(_t139.ssrc), _this172.isFirstVideoReceived[_t139.ssrc] = !0), _t139.framesDecodeCount > 0 && !_this172.isFirstVideoDecoded[_t139.ssrc] && (_this172.onFirstVideoDecoded && _this172.onFirstVideoDecoded(_t139.ssrc, _t139.decodedFrame.width, _t139.decodedFrame.height), _this172.isFirstVideoDecoded[_t139.ssrc] = !0), _i84) {
                  var _n69 = _i84.stats,
                      _s36 = Date.now() - _i84.lts;

                  _t139.framesDecodeFreezeTime = _n69.framesDecodeFreezeTime, _t139.framesDecodeInterval = _n69.framesDecodeInterval, _t139.framesDecodeCount > _n69.framesDecodeCount && _this172.isFirstVideoDecoded[_t139.ssrc] ? (_i84.lts = Date.now(), _t139.framesDecodeInterval = _s36, _t139.framesDecodeInterval >= _this172.options.freezeRateLimit && (_this172.getVideoIsReady(parseInt(e.ssrc, 10)) ? _t139.framesDecodeFreezeTime += _t139.framesDecodeInterval : _this172.setVideoIsReady2(parseInt(e.ssrc, 10), !0))) : _t139.framesDecodeCount < _i84.stats.framesDecodeCount && (_t139.framesDecodeInterval = 0);
                }

                _this172.lastDecodeVideoReceiverStats.set(_t139.ssrc, {
                  stats: oL({}, _t139),
                  lts: Date.now()
                }), _this172._stats.videoRecv.push(_t139);
                break;
              }

            case "audio_recv":
              {
                var _t140 = qP(tL);

                _t140.codec = e.googCodecName, _t140.outputLevel = Math.abs(Number(e.audioOutputLevel)) / 32767, _t140.decodingCNG = Number(e.googDecodingCNG), _t140.decodingCTN = Number(e.googDecodingCTN), _t140.decodingCTSG = Number(e.googDecodingCTSG), _t140.decodingNormal = Number(e.googDecodingNormal), _t140.decodingPLC = Number(e.googDecodingPLC), _t140.decodingPLCCNG = Number(e.googDecodingPLCCNG), _t140.expandRate = Number(e.googExpandRate), _t140.accelerateRate = Number(e.googAccelerateRate), _t140.preemptiveExpandRate = Number(e.googPreemptiveExpandRate), _t140.secondaryDecodedRate = Number(e.googSecondaryDecodedRate), _t140.speechExpandRate = Number(e.googSpeechExpandRate), _t140.preferredJitterBufferMs = Number(e.googPreferredJitterBufferMs), _t140.jitterBufferMs = Number(e.googJitterBufferMs), _t140.jitterMs = Number(e.googJitterReceived), _t140.bytes = Number(e.bytesReceived), _t140.packets = Number(e.packetsReceived), _t140.packetsLost = Number(e.packetsLost), _t140.ssrc = Number(e.ssrc), _t140.receivedFrames = Number(e.googDecodingCTN) || Number(e.packetsReceived), _t140.droppedFrames = Number(e.googDecodingPLC) + Number(e.googDecodingPLCCNG) || Number(e.packetsLost), _t140.receivedFrames > 0 && !_this172.isFirstAudioReceived[_t140.ssrc] && (_this172.onFirstAudioReceived && _this172.onFirstAudioReceived(_t140.ssrc), _this172.isFirstAudioReceived[_t140.ssrc] = !0), _t140.decodingNormal > 0 && !_this172.isFirstAudioDecoded[_t140.ssrc] && (_this172.onFirstAudioDecoded && _this172.onFirstAudioDecoded(_t140.ssrc), _this172.isFirstAudioDecoded[_t140.ssrc] = !0), _this172._stats.audioRecv.push(_t140);
                break;
              }

            case "audio_send":
              {
                var _t141 = qP(eL);

                _t141.codec = e.googCodecName, _t141.inputLevel = Math.abs(Number(e.audioInputLevel)) / 32767, _t141.aecReturnLoss = Number(e.googEchoCancellationReturnLoss || 0), _t141.aecReturnLossEnhancement = Number(e.googEchoCancellationReturnLossEnhancement || 0), _t141.residualEchoLikelihood = Number(e.googResidualEchoLikelihood || 0), _t141.residualEchoLikelihoodRecentMax = Number(e.googResidualEchoLikelihoodRecentMax || 0), _t141.bytes = Number(e.bytesSent), _t141.packets = Number(e.packetsSent), _t141.packetsLost = Number(e.packetsLost), _t141.ssrc = Number(e.ssrc), _t141.rttMs = Number(e.googRtt || 0), _this172._stats.rtt = _t141.rttMs, _this172._stats.audioSend.push(_t141);
                break;
              }
          }
        });
      }
    }, {
      key: "_getStats",
      value: function _getStats() {
        var _this173 = this;

        return new tT(function (e, t) {
          _this173.pc.getStats(e, t);
        });
      }
    }, {
      key: "statsResponsesToObjects",
      value: function statsResponsesToObjects(e) {
        var t = [];
        return e.result().forEach(function (e) {
          var i = {
            id: e.id,
            timestamp: e.timestamp.valueOf().toString(),
            type: e.type
          };
          e.names().forEach(function (t) {
            i[t] = e.stat(t);
          }), t.push(i);
        }), t;
      }
    }]);

    return aL;
  }(sL);

  function cL(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function dL(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? cL(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : cL(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var lL = /*#__PURE__*/function (_sL2) {
    _inherits(lL, _sL2);

    var _super53 = _createSuper(lL);

    function lL() {
      var _this174;

      _classCallCheck(this, lL);

      _this174 = _super53.apply(this, arguments), nh(_assertThisInitialized(_this174), "_stats", QP), nh(_assertThisInitialized(_this174), "report", void 0), nh(_assertThisInitialized(_this174), "lastDecodeVideoReceiverStats", new Map()), nh(_assertThisInitialized(_this174), "lastVideoFramesRecv", new Map()), nh(_assertThisInitialized(_this174), "lastVideoFramesSent", new Map()), nh(_assertThisInitialized(_this174), "lastVideoFramesDecode", new Map()), nh(_assertThisInitialized(_this174), "lastVideoJBDelay", new Map()), nh(_assertThisInitialized(_this174), "lastAudioJBDelay", new Map()), nh(_assertThisInitialized(_this174), "mediaBytesSent", new Map()), nh(_assertThisInitialized(_this174), "mediaBytesRetransmit", new Map()), nh(_assertThisInitialized(_this174), "mediaBytesTargetEncode", new Map()), nh(_assertThisInitialized(_this174), "lastEncoderMs", new Map());
      return _this174;
    }

    _createClass(lL, [{
      key: "updateStats",
      value: function () {
        var _updateStats2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee149() {
          var _this175 = this;

          return _regeneratorRuntime.wrap(function _callee149$(_context149) {
            while (1) {
              switch (_context149.prev = _context149.next) {
                case 0:
                  _context149.next = 2;
                  return this.pc.getStats();

                case 2:
                  this.report = _context149.sent;
                  this._stats = qP(QP);
                  this.report.forEach(function (e) {
                    switch (e.type) {
                      case hI.OUTBOUND:
                      case hI.INBOUND:
                        {
                          var _t142 = e.mediaType || e.kind,
                              i = !_t142 && "frameWidth" in e,
                              _n70 = !_t142 && !("frameWidth" in e);

                          e.type === hI.OUTBOUND ? "audio" === _t142 || _n70 ? _this175.processAudioOutboundStats(e) : ("video" === _t142 || i) && _this175.processVideoOutboundStats(e) : e.type === hI.INBOUND && ("audio" === _t142 || _n70 ? _this175.processAudioInboundStats(e) : ("video" === _t142 || i) && _this175.processVideoInboundStats(e));
                          break;
                        }

                      case hI.TRANSPORT:
                        {
                          var _t143 = _this175.report.get(e.selectedCandidatePairId);

                          _t143 && _this175.processCandidatePairStats(_t143);
                          break;
                        }

                      case hI.CANDIDATE_PAIR:
                        e.selected && _this175.processCandidatePairStats(e);
                    }
                  });
                  this.updateSendBitrate();
                  this._stats.timestamp = Date.now();
                  this.calcLossRate(this._stats);
                  this.stats = this._stats;

                case 9:
                case "end":
                  return _context149.stop();
              }
            }
          }, _callee149, this);
        }));

        function updateStats() {
          return _updateStats2.apply(this, arguments);
        }

        return updateStats;
      }()
    }, {
      key: "getSelectedCandidatePair",
      value: function () {
        var _getSelectedCandidatePair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee150() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee150$(_context150) {
            while (1) {
              switch (_context150.prev = _context150.next) {
                case 0:
                  _context150.next = 2;
                  return this.pc.getStats();

                case 2:
                  e = _context150.sent;
                  t = {
                    local: dL({}, XP),
                    remote: dL({}, XP)
                  };
                  return _context150.abrupt("return", (e.forEach(function (i) {
                    var n;

                    if (i.type === hI.TRANSPORT && (n = e.get(i.selectedCandidatePairId)), i.type === hI.CANDIDATE_PAIR && i.selected && (n = i), n) {
                      var _i85 = function _i85(e, t) {
                        e.type = t.type, e.id = t.id, t.address && (e.address = t.address), t.candidateType && (e.candidateType = t.candidateType), t.port && (e.port = t.port), t.priority && (e.priority = t.priority), t.protocol && (e.protocol = t.protocol), t.relayProtocol && (e.relayProtocol = t.relayProtocol);
                      };

                      if (n.localCandidateId) {
                        var _s37 = e.get(n.localCandidateId);

                        _s37 && _i85(t.local, _s37);
                      }

                      if (n.remoteCandidateId) {
                        var _s38 = e.get(n.remoteCandidateId);

                        _s38 && _i85(t.remote, _s38);
                      }
                    }
                  }), t));

                case 5:
                case "end":
                  return _context150.stop();
              }
            }
          }, _callee150, this);
        }));

        function getSelectedCandidatePair() {
          return _getSelectedCandidatePair.apply(this, arguments);
        }

        return getSelectedCandidatePair;
      }()
    }, {
      key: "processCandidatePairStats",
      value: function processCandidatePairStats(e) {
        if (this._stats.sendBandwidth = e.availableOutgoingBitrate || 0, e.currentRoundTripTime && (this._stats.rtt = 1e3 * e.currentRoundTripTime), this._stats.videoSend.forEach(function (t) {
          e.currentRoundTripTime && (t.rttMs = 1e3 * e.currentRoundTripTime);
        }), this._stats.audioSend.forEach(function (t) {
          e.currentRoundTripTime && (t.rttMs = 1e3 * e.currentRoundTripTime);
        }), this._stats.selectedCandidatePair.id = e.id, e.localCandidateId) {
          var _t144 = this.report.get(e.localCandidateId);

          _t144 && this.processCandidateStats(_t144);
        }

        if (e.remoteCandidateId) {
          var _t145 = this.report.get(e.remoteCandidateId);

          _t145 && this.processCandidateStats(_t145);
        }
      }
    }, {
      key: "processCandidateStats",
      value: function processCandidateStats(e) {
        var t;
        e.type === hI.LOCAL_CANDIDATE && (t = this._stats.selectedCandidatePair.localCandidate), e.type === hI.REMOTE_CANDIDATE && (t = this._stats.selectedCandidatePair.remoteCandidate), t && (t.type = e.type, t.id = e.id, e.address && (t.address = e.address), e.candidateType && (t.candidateType = e.candidateType), e.port && (t.port = e.port), e.priority && (t.priority = e.priority), e.protocol && (t.protocol = e.protocol), e.relayProtocol && (t.relayProtocol = e.relayProtocol), e.type === hI.LOCAL_CANDIDATE && this.stats.selectedCandidatePair.localCandidate.id !== t.id && this.onSelectedLocalCandidateChanged && this.onSelectedLocalCandidateChanged(dL({}, t), dL({}, this.stats.selectedCandidatePair.localCandidate)), e.type === hI.REMOTE_CANDIDATE && this.stats.selectedCandidatePair.remoteCandidate.id !== t.id && this.onSelectedRemoteCandidateChanged && this.onSelectedRemoteCandidateChanged(dL({}, t), dL({}, this.stats.selectedCandidatePair.remoteCandidate)));
      }
    }, {
      key: "processAudioInboundStats",
      value: function processAudioInboundStats(e) {
        var t = this._stats.audioRecv.find(function (t) {
          return t.ssrc === e.ssrc;
        });

        t || (t = qP(tL), this._stats.audioRecv.push(t)), t.ssrc = e.ssrc, t.packets = e.packetsReceived, t.packetsLost = e.packetsLost, t.bytes = e.bytesReceived, t.jitterMs = 1e3 * e.jitter, this.processAudioTrackReceiverStats(e, e.trackId, t), e.codecId && (t.codec = this.getCodecFromCodecStats(e.codecId)), t.receivedFrames || (t.receivedFrames = e.packetsReceived), t.droppedFrames || (t.droppedFrames = e.packetsLost), t.receivedFrames > 0 && !this.isFirstAudioReceived[t.ssrc] && (this.onFirstAudioReceived && this.onFirstAudioReceived(t.ssrc), this.isFirstAudioReceived[t.ssrc] = !0), t.outputLevel && t.outputLevel > 0 && !this.isFirstAudioDecoded[t.ssrc] && (this.onFirstAudioDecoded && this.onFirstAudioDecoded(t.ssrc), this.isFirstAudioDecoded[t.ssrc] = !0), "number" == typeof e.concealedSamples && (t.concealedSamples = e.concealedSamples);
      }
    }, {
      key: "processVideoInboundStats",
      value: function processVideoInboundStats(e) {
        var t = this._stats.videoRecv.find(function (t) {
          return t.ssrc === e.ssrc;
        });

        t || (t = qP(ZP), this._stats.videoRecv.push(t)), t.ssrc = e.ssrc, t.packets = e.packetsReceived, t.packetsLost = e.packetsLost, t.bytes = e.bytesReceived, t.firsCount = e.firCount, t.nacksCount = e.nackCount, t.plisCount = e.pliCount, t.framesDecodeCount = e.framesDecoded, t.totalInterFrameDelay = e.totalInterFrameDelay, t.totalSquaredInterFrameDelay = e.totalSquaredInterFrameDelay;
        var i = this.lastDecodeVideoReceiverStats.get(t.ssrc),
            n = this.lastVideoFramesDecode.get(t.ssrc),
            s = Date.now();

        if (t.framesDecodeCount > 0 && !this.isFirstVideoDecoded[t.ssrc]) {
          var _e103 = t.decodedFrame ? t.decodedFrame.width : 0,
              _i86 = t.decodedFrame ? t.decodedFrame.height : 0;

          this.onFirstVideoDecoded && this.onFirstVideoDecoded(t.ssrc, _e103, _i86), this.isFirstVideoDecoded[t.ssrc] = !0;
        }

        if (i) {
          var _n71 = i.stats,
              _r17 = s - i.lts;

          t.framesDecodeFreezeTime = _n71.framesDecodeFreezeTime, t.framesDecodeInterval = _n71.framesDecodeInterval, !this.isFirstVideoDecoded[t.ssrc] && _r17 > this.options.firstVideoDecodedTimeout && !this.isFirstVideoDecodedTimeout[t.ssrc] && (this.onFirstVideoDecodedTimeout && this.onFirstVideoDecodedTimeout(t.ssrc), this.isFirstVideoDecodedTimeout[t.ssrc] = !0), t.framesDecodeCount > _n71.framesDecodeCount && this.isFirstVideoDecoded[t.ssrc] ? (i.lts = Date.now(), t.framesDecodeInterval = _r17, t.framesDecodeInterval >= this.options.freezeRateLimit && (this.getVideoIsReady(parseInt(e.ssrc)) ? t.framesDecodeFreezeTime += t.framesDecodeInterval : this.setVideoIsReady2(parseInt(e.ssrc, 10), !0))) : t.framesDecodeCount < _n71.framesDecodeCount && (t.framesDecodeInterval = 0), e.framesDecoded && e.qpSum && (i.stats.framesDecodeCount > e.framesDecoded ? t.qpSumPerFrame = e.qpSum / e.framesDecoded : t.qpSumPerFrame = (e.qpSum - i.qpSum) / (e.framesDecoded - i.stats.framesDecodeCount));
        }

        n && s - n.lts >= 800 ? (t.decodeFrameRate = Math.round((t.framesDecodeCount - n.count) / ((s - n.lts) / 1e3)), this.lastVideoFramesDecode.set(t.ssrc, {
          count: t.framesDecodeCount,
          lts: s,
          rate: t.decodeFrameRate
        })) : n ? t.decodeFrameRate = n.rate : this.lastVideoFramesDecode.set(t.ssrc, {
          count: t.framesDecodeCount,
          lts: s,
          rate: 0
        }), e.totalDecodeTime && (t.decodeMs = 1e3 * e.totalDecodeTime), this.processVideoTrackReceiverStats(e, e.trackId, t), e.codecId && (t.codec = this.getCodecFromCodecStats(e.codecId)), e.framerateMean && (t.framesRateFirefox = e.framerateMean), t.packets > 0 && !this.isFirstVideoReceived[t.ssrc] && (this.onFirstVideoReceived && this.onFirstVideoReceived(t.ssrc), this.isFirstVideoReceived[t.ssrc] = !0), this.lastDecodeVideoReceiverStats.set(t.ssrc, {
          stats: dL({}, t),
          lts: i ? i.lts : Date.now(),
          qpSum: e.qpSum
        });
      }
    }, {
      key: "processVideoOutboundStats",
      value: function processVideoOutboundStats(e) {
        var t = this._stats.videoSend.find(function (t) {
          return t.ssrc === e.ssrc;
        });

        t || (t = qP($P), this._stats.videoSend.push(t));
        var i = this.mediaBytesSent.get(e.ssrc);
        if (i) i.add(e.bytesSent);else {
          var _t146 = new zP(10);

          _t146.add(e.bytesSent), this.mediaBytesSent.set(e.ssrc, _t146);
        }

        if (void 0 !== e.retransmittedBytesSent) {
          var _t147 = this.mediaBytesRetransmit.get(e.ssrc);

          if (_t147) _t147.add(e.retransmittedBytesSent);else {
            var _t148 = new zP(10);

            _t148.add(e.retransmittedBytesSent), this.mediaBytesRetransmit.set(e.ssrc, _t148);
          }
        }

        if (e.totalEncodedBytesTarget) {
          var _t149 = this.mediaBytesTargetEncode.get(e.ssrc);

          if (_t149) _t149.add(e.totalEncodedBytesTarget);else {
            var _t150 = new zP(10);

            _t150.add(e.totalEncodedBytesTarget), this.mediaBytesTargetEncode.set(e.ssrc, _t150);
          }
        }

        if (t.ssrc = e.ssrc, t.bytes = e.bytesSent, t.packets = e.packetsSent, t.firsCount = e.firCount, t.nacksCount = e.nackCount, t.plisCount = e.pliCount, t.frameCount = e.framesEncoded, t.adaptionChangeReason = e.qualityLimitationReason, t.scalabilityMode = e.scalabilityMode, e.totalEncodeTime && e.framesEncoded) {
          var _i87 = this.lastEncoderMs.get(e.ssrc);

          if (!_i87 || _i87.lastFrameCount > e.framesEncoded) t.avgEncodeMs = 1e3 * e.totalEncodeTime / e.framesEncoded;else {
            var _n72 = e.framesEncoded - _i87.lastFrameCount,
                _s39 = e.totalEncodeTime - _i87.lastEncoderTime;

            t.avgEncodeMs = 1e3 * _s39 / _n72;
          }
        }

        if (e.framesEncoded && e.qpSum) {
          var _i88 = this.lastEncoderMs.get(e.ssrc);

          !_i88 || _i88.lastFrameCount > e.framesEncoded ? t.qpSumPerFrame = e.qpSum / e.framesEncoded : t.qpSumPerFrame = (e.qpSum - _i88.lastQpSum) / (e.framesEncoded - _i88.lastFrameCount);
        }

        if (this.lastEncoderMs.set(e.ssrc, {
          lastFrameCount: e.framesEncoded,
          lastEncoderTime: e.totalEncodeTime,
          lastQpSum: e.qpSum,
          lts: Date.now()
        }), e.codecId && (t.codec = this.getCodecFromCodecStats(e.codecId)), e.mediaSourceId && this.processVideoMediaSource(e.mediaSourceId, t), this.processVideoTrackSenderStats(e, e.trackId, t), e.remoteId) this.processRemoteInboundStats(e.remoteId, t);else {
          var _i89 = this.findRemoteStatsId(e.ssrc, hI.REMOTE_INBOUND);

          _i89 && this.processRemoteInboundStats(_i89, t);
        }
      }
    }, {
      key: "processAudioOutboundStats",
      value: function processAudioOutboundStats(e) {
        var t = this._stats.audioSend.find(function (t) {
          return t.ssrc === e.ssrc;
        });

        if (t || (t = qP(eL), this._stats.audioSend.push(t)), t.ssrc = e.ssrc, t.packets = e.packetsSent, t.bytes = e.bytesSent, e.mediaSourceId && this.processAudioMediaSource(e.mediaSourceId, t), e.codecId && (t.codec = this.getCodecFromCodecStats(e.codecId)), this.processAudioTrackSenderStats(e, e.trackId, t), e.remoteId) this.processRemoteInboundStats(e.remoteId, t);else {
          var i = this.findRemoteStatsId(e.ssrc, hI.REMOTE_INBOUND);
          i && this.processRemoteInboundStats(i, t);
        }
      }
    }, {
      key: "findRemoteStatsId",
      value: function findRemoteStatsId(e, t) {
        var i;
        var n = Array.from(MI(i = this.report).call(i)).find(function (i) {
          return i.type === t && i.ssrc === e;
        });
        return n ? n.id : null;
      }
    }, {
      key: "processVideoMediaSource",
      value: function processVideoMediaSource(e, t) {
        var i = this.report.get(e);
        i && i.width && i.height && i.framesPerSecond && (t.inputFrame = {
          width: i.width,
          height: i.height,
          frameRate: i.framesPerSecond
        });
      }
    }, {
      key: "processAudioMediaSource",
      value: function processAudioMediaSource(e, t) {
        var i = this.report.get(e);
        i && (t.inputLevel = i.audioLevel);
      }
    }, {
      key: "processVideoTrackSenderStats",
      value: function processVideoTrackSenderStats(e, t, i) {
        var n, s, r, o;
        var a = t ? this.report.get(t) : void 0,
            c = null !== (n = null == a ? void 0 : a.framesSent) && void 0 !== n ? n : e.framesSent;
        if ("number" != typeof c) return;
        var d = null !== (s = null == a ? void 0 : a.frameWidth) && void 0 !== s ? s : e.frameWidth,
            l = null !== (r = null == a ? void 0 : a.frameHeight) && void 0 !== r ? r : e.frameHeight,
            u = null !== (o = null == a ? void 0 : a.framesPerSecond) && void 0 !== o ? o : e.framesPerSecond;

        if ("number" == typeof d && "number" == typeof l || (d = 0, l = 0), null == u) {
          var _e104 = Date.now(),
              _t151 = this.lastVideoFramesSent.get(i.ssrc);

          _t151 && _e104 - _t151.lts >= 800 ? (u = Math.round((c - _t151.count) / ((_e104 - _t151.lts) / 1e3)), this.lastVideoFramesSent.set(i.ssrc, {
            count: c,
            lts: _e104,
            rate: u
          })) : _t151 ? u = _t151.rate : this.lastVideoFramesSent.set(i.ssrc, {
            count: c,
            lts: _e104,
            rate: 0
          });
        }

        i.sentFrame = {
          width: d,
          height: l,
          frameRate: Math.max(0, u)
        };
      }
    }, {
      key: "processVideoTrackReceiverStats",
      value: function processVideoTrackReceiverStats(e, t, i) {
        var n, s, r, o, a;
        var c = t ? this.report.get(t) : void 0,
            d = null !== (n = null == c ? void 0 : c.framesReceived) && void 0 !== n ? n : e.framesReceived,
            l = null !== (s = null == c ? void 0 : c.frameWidth) && void 0 !== s ? s : e.frameWidth,
            u = null !== (r = null == c ? void 0 : c.frameHeight) && void 0 !== r ? r : e.frameHeight,
            h = null !== (o = null == c ? void 0 : c.jitterBufferDelay) && void 0 !== o ? o : e.jitterBufferDelay,
            p = null !== (a = null == c ? void 0 : c.jitterBufferEmittedCount) && void 0 !== a ? a : e.jitterBufferEmittedCount;

        if ("number" == typeof d) {
          var _e105 = this.lastVideoFramesRecv.get(i.ssrc),
              _t152 = Date.now();

          i.framesReceivedCount = d;
          var _n73 = 0;
          _e105 && _t152 - _e105.lts >= 800 ? (_n73 = Math.round((d - _e105.count) / ((_t152 - _e105.lts) / 1e3)), this.lastVideoFramesRecv.set(i.ssrc, {
            count: d,
            lts: _t152,
            rate: _n73
          })) : _e105 ? _n73 = _e105.rate : this.lastVideoFramesRecv.set(i.ssrc, {
            count: d,
            lts: _t152,
            rate: 0
          }), i.receivedFrame = {
            width: l || 0,
            height: u || 0,
            frameRate: _n73 || 0
          }, i.decodedFrame = {
            width: l || 0,
            height: u || 0,
            frameRate: i.decodeFrameRate || 0
          }, i.outputFrame = {
            width: l || 0,
            height: u || 0,
            frameRate: i.decodeFrameRate || 0
          };
        }

        if (h && p) {
          var _e106 = this.lastVideoJBDelay.get(i.ssrc) || {
            jitterBufferDelay: 0,
            jitterBufferEmittedCount: 0,
            jitterBufferMs: 0
          };

          var _t153 = _e106.jitterBufferMs;

          var _n74 = p - _e106.jitterBufferEmittedCount;

          _n74 > 0 && (_t153 = 1e3 * (h - _e106.jitterBufferDelay) / _n74), i.jitterBufferMs = _t153, i.currentDelayMs = Math.round(_t153), this.lastVideoJBDelay.set(i.ssrc, {
            jitterBufferDelay: h,
            jitterBufferEmittedCount: p,
            jitterBufferMs: i.currentDelayMs
          });
        }
      }
    }, {
      key: "processAudioTrackSenderStats",
      value: function processAudioTrackSenderStats(e, t, i) {
        var n, s, r, o;
        var a = t ? this.report.get(t) : void 0,
            c = null !== (n = null !== (s = null == a ? void 0 : a.echoReturnLoss) && void 0 !== s ? s : e.echoReturnLoss) && void 0 !== n ? n : 0,
            d = null !== (r = null !== (o = null == a ? void 0 : a.echoReturnLossEnhancement) && void 0 !== o ? o : e.echoReturnLossEnhancement) && void 0 !== r ? r : 0;
        i.aecReturnLoss = c, i.aecReturnLossEnhancement = d;
      }
    }, {
      key: "processAudioTrackReceiverStats",
      value: function processAudioTrackReceiverStats(e, t, i) {
        var n, s, r, o, a, c, d;

        var l = t ? this.report.get(t) : void 0,
            u = null !== (n = null == l ? void 0 : l.removedSamplesForAcceleration) && void 0 !== n ? n : e.removedSamplesForAcceleration,
            h = null !== (s = null == l ? void 0 : l.totalSamplesReceived) && void 0 !== s ? s : e.totalSamplesReceived,
            p = null !== (r = null == l ? void 0 : l.jitterBufferDelay) && void 0 !== r ? r : e.jitterBufferDelay,
            _ = null !== (o = null == l ? void 0 : l.jitterBufferEmittedCount) && void 0 !== o ? o : e.jitterBufferEmittedCount,
            E = null !== (a = null == l ? void 0 : l.audioLevel) && void 0 !== a ? a : null == e ? void 0 : e.audioLevel,
            m = null !== (c = null == l ? void 0 : l.totalSamplesDuration) && void 0 !== c ? c : null == e ? void 0 : e.totalSamplesDuration,
            f = null !== (d = null == l ? void 0 : l.concealedSamples) && void 0 !== d ? d : e.concealedSamples;

        if (u && h && (i.accelerateRate = u / h), p && _) {
          var _e107 = this.lastAudioJBDelay.get(i.ssrc) || {
            jitterBufferDelay: 0,
            jitterBufferEmittedCount: 0,
            jitterBufferMs: 0
          };

          var _t154 = _e107.jitterBufferMs;

          var _n75 = _ - _e107.jitterBufferEmittedCount;

          _n75 > 0 && (_t154 = 1e3 * (p - _e107.jitterBufferDelay) / _n75), i.jitterBufferMs = Math.round(_t154), this.lastAudioJBDelay.set(i.ssrc, {
            jitterBufferDelay: p,
            jitterBufferEmittedCount: _,
            jitterBufferMs: i.jitterBufferMs
          });
        }

        i.outputLevel = E;
        var T = 1920;
        m && h && (T = h / m / 50, i.receivedFrames = Math.round(h / T)), f && (i.droppedFrames = Math.round(f / T));
      }
    }, {
      key: "processRemoteInboundStats",
      value: function processRemoteInboundStats(e, t) {
        var i = this.report.get(e);
        i && (t.packetsLost = i.packetsLost, i.roundTripTime && (t.rttMs = 1e3 * i.roundTripTime), i.jitter && (t.jitterMs = 1e3 * i.jitter), i.timestamp && (t.timestamp = i.timestamp));
      }
    }, {
      key: "getCodecFromCodecStats",
      value: function getCodecFromCodecStats(e) {
        var t = this.report.get(e);
        if (!t) return "";
        var i = t.mimeType.match(/\/(.*)$/);
        return i && i[1] ? i[1] : "";
      }
    }, {
      key: "updateSendBitrate",
      value: function updateSendBitrate() {
        var e = 0,
            t = null,
            i = null;
        this.mediaBytesSent.forEach(function (t) {
          e += t.diffMean();
        }), this.mediaBytesRetransmit.forEach(function (e) {
          t = null === t ? e.diffMean() : t + e.diffMean();
        }), this.mediaBytesTargetEncode.forEach(function (e) {
          i = null === i ? e.diffMean() : i + e.diffMean();
        });
        var n = null !== t ? e - t : e;
        this._stats.bitrate = {
          actualEncoded: 8 * n / (this.options.updateInterval / 1e3),
          transmit: 8 * e / (this.options.updateInterval / 1e3)
        }, null !== t && (this._stats.bitrate.retransmit = 8 * t / (this.options.updateInterval / 1e3)), null !== i && (this._stats.bitrate.targetEncoded = 8 * i / (this.options.updateInterval / 1e3));
      }
    }]);

    return lL;
  }(sL);

  var uL = /*#__PURE__*/function (_sL3) {
    _inherits(uL, _sL3);

    var _super54 = _createSuper(uL);

    function uL() {
      _classCallCheck(this, uL);

      return _super54.apply(this, arguments);
    }

    _createClass(uL, [{
      key: "updateStats",
      value: function updateStats() {
        return tT.resolve();
      }
    }]);

    return uL;
  }(sL);

  function hL(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 250,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 8,
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 500,
        s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1e4;

    var r = function () {
      var e = navigator.userAgent.toLocaleLowerCase().match(/chrome\/[\d]*/i);
      return e && e[0] ? Number(e[0].split("/")[1]) : null;
    }();

    return r ? r < 76 ? new aL(e, {
      updateInterval: t,
      lossRateInterval: i,
      freezeRateLimit: n,
      firstVideoDecodedTimeout: s
    }) : new lL(e, {
      updateInterval: t,
      lossRateInterval: i,
      freezeRateLimit: n,
      firstVideoDecodedTimeout: s
    }) : function (e) {
      return !!window.RTCStatsReport && e.getStats() instanceof tT;
    }(e) ? new lL(e, {
      updateInterval: t,
      lossRateInterval: i,
      freezeRateLimit: n,
      firstVideoDecodedTimeout: s
    }) : new uL(e, {
      updateInterval: t,
      lossRateInterval: i,
      freezeRateLimit: n,
      firstVideoDecodedTimeout: s
    });
  }

  function pL(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function _L(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? pL(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : pL(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function EL(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        n = arguments.length > 3 ? arguments[3] : void 0;
    var s = t.filterRTX,
        r = t.filterVideoFec,
        o = t.filterAudioFec,
        a = t.filterAudioCodec,
        c = t.filterVideoCodec,
        d = i.useXR;

    var l = [],
        u = [],
        h = [],
        p = [],
        _ = !1,
        E = !1;

    if (YP.parse(e).mediaDescriptions.forEach(function (e) {
      n && n !== e.attributes.direction || ("video" !== e.media.mediaType || _ || (u = e.attributes.payloads, p = e.attributes.extmaps, _ = !0), "audio" !== e.media.mediaType || E || (l = e.attributes.payloads, h = e.attributes.extmaps, E = !0));
    }), !p || 0 === u.length) throw new Error("Cannot get video capabilities from SDP.");
    if (!h || 0 === l.length) throw new Error("Cannot get audio capabilities from SDP.");
    u.forEach(function (e) {
      var t;
      null !== (t = e.rtpMap) && void 0 !== t && t.clockRate && (e.rtpMap.clockRate = parseInt(e.rtpMap.clockRate)), d && e.rtcpFeedbacks.push({
        type: "rrtr"
      });
    }), l.forEach(function (e) {
      var t;
      null !== (t = e.rtpMap) && void 0 !== t && t.clockRate && (e.rtpMap.clockRate = parseInt(e.rtpMap.clockRate)), d && e.rtcpFeedbacks.push({
        type: "rrtr"
      });
    }), s && (l = l.filter(function (e) {
      var t;
      return "rtx" !== (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLowerCase());
    }), u = u.filter(function (e) {
      var t;
      return "rtx" !== (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLowerCase());
    })), r && (u = u.filter(function (e) {
      var t;
      return !/(red)|(ulpfec)|(flexfec)/i.test((null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName) || "");
    })), o && (l = l.filter(function (e) {
      var t;
      return !/(red)|(ulpfec)|(flexfec)/i.test((null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName) || "");
    })), a && (null == a ? void 0 : a.length) > 0 && (l = l.filter(function (e) {
      var t;
      return bn(a).call(a, (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLowerCase()) || "");
    })), c && (null == c ? void 0 : c.length) > 0 && (u = u.filter(function (e) {
      var t;
      return bn(c).call(c, (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLowerCase()) || "");
    }));
    var m = DC("UNSUPPORTED_VIDEO_CODEC");
    return m && m.length > 0 && (u = u.filter(function (e) {
      return !(e.rtpMap && bn(m).call(m, e.rtpMap.encodingName.toLowerCase()));
    })), {
      audioCodecs: l,
      videoCodecs: u,
      audioExtensions: h,
      videoExtensions: p
    };
  }

  function mL(e) {
    var t = YP.parse(e);
    var i, n;

    var _iterator19 = _createForOfIteratorHelper(t.mediaDescriptions),
        _step19;

    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var _e108 = _step19.value;

        if (!i) {
          var _t155 = _e108.attributes.iceUfrag,
              _n76 = _e108.attributes.icePwd;
          if (!_t155 || !_n76) throw new Error("Cannot get iceUfrag or icePwd from SDP.");
          i = {
            iceUfrag: _t155,
            icePwd: _n76
          };
        }

        if (!n) {
          var _t156 = _e108.attributes.fingerprints;
          _t156.length > 0 && (n = {
            fingerprints: _t156
          });
        }
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }

    if (!n && t.attributes.fingerprints.length > 0 && (n = {
      fingerprints: t.attributes.fingerprints
    }), !n || !i) throw new Error("Cannot get iceParameters or dtlsParameters from SDP.");
    return {
      iceParameters: i,
      dtlsParameters: n
    };
  }

  function fL(e, t) {
    var i = [],
        n = e.attributes.ssrcGroups.filter(function (e) {
      return "FID" === e.semantic;
    }),
        s = e.attributes.ssrcGroups.find(function (e) {
      return "SIM" === e.semantic;
    }),
        r = e.attributes.ssrcs;
    if (s) s.ssrcIds.forEach(function (e) {
      var s;
      var r = null === (s = n.find(function (t) {
        return t.ssrcIds[0] === e;
      })) || void 0 === s ? void 0 : s.ssrcIds[1];
      i.push({
        ssrcId: e,
        rtx: t ? r : void 0
      });
    });else if (n.length > 0) {
      var _e109 = n[0].ssrcIds[0],
          _s40 = n[0].ssrcIds[1];
      i.push({
        ssrcId: _e109,
        rtx: t ? _s40 : void 0
      });
    } else {
      if (0 === r.length) throw new Error("No ssrcs found on local media description.");
      i.push({
        ssrcId: r[0].ssrcId
      });
    }
    return i;
  }

  function TL(e, t) {
    var i = e.cname;
    var n;
    t && t.ip && "number" == typeof t.port ? (n = [{
      foundation: "udpcandidate",
      componentId: "1",
      transport: "udp",
      priority: "2103266323",
      connectionAddress: t.ip,
      port: t.port.toString(),
      type: "host",
      extension: {}
    }], YC.debug("Using remote candidate from AP ".concat(t.ip, ":").concat(t.port)), t.ip6 && (n.push({
      foundation: "udpcandidate",
      componentId: "1",
      transport: "udp",
      priority: "2103266323",
      connectionAddress: t.ip6,
      port: t.port.toString(),
      type: "host",
      extension: {}
    }), YC.debug("Using IPV6 remote candidate from AP ".concat(t.ip6, ":").concat(t.port)))) : n = e.iceParameters.candidates.map(function (e) {
      return {
        foundation: e.foundation,
        componentId: "1",
        transport: e.protocol,
        priority: e.priority.toString(),
        connectionAddress: e.ip,
        port: e.port.toString(),
        type: e.type,
        extension: {}
      };
    });
    var s = {
      fingerprints: e.dtlsParameters.fingerprints.map(function (e) {
        return {
          hashFunction: e.algorithm,
          fingerprint: e.fingerprint
        };
      })
    },
        r = {
      iceUfrag: e.iceParameters.iceUfrag,
      icePwd: e.iceParameters.icePwd
    };
    var o;

    switch (e.dtlsParameters.role) {
      case "server":
        o = "passive";
        break;

      case "client":
        o = "active";
        break;

      case "auto":
        o = "actpass";
    }

    return {
      dtlsParameters: s,
      iceParameters: r,
      candidates: n,
      rtpCapabilities: OL(e.rtpCapabilities),
      setup: o,
      cname: i
    };
  }

  function gL(e, t, i) {
    var n = [],
        s = [];
    return e.forEach(function (e) {
      var r = e.ssrcId,
          o = e.rtx;
      var a = xg(8, "track-"),
          c = {
        ssrcId: r,
        attributes: _L({
          label: a,
          mslabel: i = i || xg(10, ""),
          msid: "".concat(i, " ").concat(a)
        }, t && {
          cname: t
        })
      };

      if (n.push(c), void 0 !== o) {
        var _e110 = {
          ssrcId: o,
          attributes: _L({
            label: a,
            mslabel: i,
            msid: "".concat(i, " ").concat(a)
          }, t && {
            cname: t
          })
        };
        n.push(_e110), s.push({
          semantic: "FID",
          ssrcIds: [r, o]
        });
      }
    }), e.length > 1 && s.push({
      semantic: "SIM",
      ssrcIds: e.map(function (e) {
        var t = e.ssrcId;
        return t;
      })
    }), {
      ssrcs: n,
      ssrcGroups: s
    };
  }

  function SL(e, t) {
    t instanceof cw && e.attributes.payloads.forEach(function (e) {
      var i;
      var n = null === (i = e.rtpMap) || void 0 === i ? void 0 : i.encodingName.toLowerCase();
      if (!n || -1 === ["opus", "pcmu", "pcma", "g722"].indexOf(n)) return;
      e.fmtp || (e.fmtp = {
        parameters: {}
      }), e.fmtp.parameters.minptime = "10", e.fmtp.parameters.useinbandfec = "1";
      var s = t._encoderConfig;
      s && "pcmu" !== n && "pcma" !== n && "g722" !== n && (s.bitrate && !RT() && (e.fmtp.parameters.maxaveragebitrate = "".concat(Math.floor(1e3 * s.bitrate))), s.sampleRate && (e.fmtp.parameters.maxplaybackrate = "".concat(s.sampleRate), e.fmtp.parameters["sprop-maxcapturerate"] = "".concat(s.sampleRate)), s.stereo && (e.fmtp.parameters.stereo = "1", e.fmtp.parameters["sprop-stereo"] = "1"));
    });
  }

  function RL(e) {
    var t = e.attributes.unrecognized.findIndex(function (e) {
      return "x-google-flag" === e.attField && "conference" === e.attValue;
    });
    -1 !== t && e.attributes.unrecognized.splice(t, 1);
  }

  function CL(e, t) {
    var i;
    if (!(t instanceof Nw && t._encoderConfig && -1 === t._hints.indexOf(YA.SCREEN_TRACK))) return;
    var n = t._encoderConfig;
    wA().supportMinBitrate && n.bitrateMin && e.attributes.payloads.forEach(function (e) {
      var t, i;
      bn(t = ["h264", "h265", "vp8", "vp9", "av1"]).call(t, (null === (i = e.rtpMap) || void 0 === i ? void 0 : i.encodingName.toLowerCase()) || "") && (e.fmtp || (e.fmtp = {
        parameters: {}
      }), e.fmtp.parameters["x-google-min-bitrate"] = "".concat(n.bitrateMin));
    }), wA().supportMinBitrate && !bn(i = t._hints).call(i, YA.LOW_STREAM) && n.bitrateMax && e.attributes.payloads.forEach(function (e) {
      var t, i;
      bn(t = ["h264", "h265", "vp8", "vp9", "av1"]).call(t, (null === (i = e.rtpMap) || void 0 === i ? void 0 : i.encodingName.toLowerCase()) || "") && (e.fmtp || (e.fmtp = {
        parameters: {}
      }), e.fmtp.parameters["x-google-start-bitrate"] = "".concat(DC("X_GOOGLE_START_BITRATE") || Math.floor(n.bitrateMax)));
    });
  }

  function IL(e) {
    if ("video" !== e.media.mediaType) return;
    var t = pT();
    if (t.name !== cT.SAFARI && t.os !== aT.IOS) return;
    var i = e.attributes.extmaps.findIndex(function (e) {
      return /video-orientation/g.test(e.extensionName);
    });
    -1 !== i && e.attributes.extmaps.splice(i, 1);
  }

  function vL(e, t, i) {
    if (!t) return;
    var n, s;

    if ("video" === e.media.mediaType ? (n = i.videoExtensions, s = i.videoCodecs) : (n = i.audioExtensions, s = i.audioCodecs), !0 === t.twcc) {
      var _t157 = n.find(function (e) {
        return "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" === e.extensionName;
      });

      if (_t157) {
        e.attributes.extmaps.find(function (e) {
          return "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" === e.extensionName;
        }) || e.attributes.extmaps.push({
          entry: _t157.entry,
          extensionName: "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01"
        });

        var _i90 = function (e, t) {
          return t.filter(function (t) {
            return !!e.find(function (e) {
              return e.payloadType === t.payloadType && !!e.rtcpFeedbacks.find(function (e) {
                return "transport-cc" === e.type;
              });
            });
          });
        }(s, e.attributes.payloads);

        _i90.forEach(function (e) {
          e.rtcpFeedbacks.find(function (e) {
            return "transport-cc" === e.type;
          }) || e.rtcpFeedbacks.push({
            type: "transport-cc"
          });
        });
      }
    } else if (!1 === t.twcc) {
      var _t158 = e.attributes.extmaps.findIndex(function (e) {
        return "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" === e.extensionName;
      });

      -1 !== _t158 && e.attributes.extmaps.splice(_t158, 1), e.attributes.payloads.forEach(function (e) {
        var t = e.rtcpFeedbacks.findIndex(function (e) {
          return "transport-cc" === e.type;
        });
        -1 !== t && e.rtcpFeedbacks.splice(t, 1);
      });
    }

    if (!0 === t.remb) {
      var _t159 = n.find(function (e) {
        return "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" === e.extensionName;
      });

      if (_t159) {
        e.attributes.extmaps.find(function (e) {
          return "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" === e.extensionName;
        }) || e.attributes.extmaps.push({
          entry: _t159.entry,
          extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time"
        });

        var _i91 = function (e, t) {
          return t.filter(function (t) {
            return !!e.find(function (e) {
              return e.payloadType === t.payloadType && !!e.rtcpFeedbacks.find(function (e) {
                return "goog-remb" === e.type;
              });
            });
          });
        }(s, e.attributes.payloads);

        _i91.forEach(function (e) {
          e.rtcpFeedbacks.find(function (e) {
            return "goog-remb" === e.type;
          }) || e.rtcpFeedbacks.push({
            type: "goog-remb"
          });
        });
      }
    } else if (!1 === t.remb) {
      var _t160 = e.attributes.extmaps.findIndex(function (e) {
        return "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" === e.extensionName;
      });

      -1 !== _t160 && e.attributes.extmaps.splice(_t160, 1), e.attributes.payloads.forEach(function (e) {
        var t = e.rtcpFeedbacks.findIndex(function (e) {
          return "goog-remb" === e.type;
        });
        -1 !== t && e.rtcpFeedbacks.splice(t, 1);
      });
    }
  }

  function yL(e, t, i) {
    if (RT()) return;
    if ("video" !== e.media.mediaType) return;
    if (!(t instanceof Nw)) return;
    if ("vp9" !== i && "vp8" !== i) return;
    if ("vp8" === i && !DC("SIMULCAST")) return;
    if (void 0 === t._scalabilityMode || t._scalabilityMode.numSpatialLayers <= 1) return;
    var n = "vp8" === i ? 2 : t._scalabilityMode.numSpatialLayers,
        s = e.attributes.ssrcs[0],
        r = e.attributes.ssrcGroups.find(function (e) {
      return "FID" === e.semantic && e.ssrcIds[0] === s.ssrcId;
    }),
        o = {
      semantic: "SIM",
      ssrcIds: [s.ssrcId]
    };

    for (var _t161 = 1; _t161 < n; _t161++) {
      e.attributes.ssrcs.push({
        ssrcId: s.ssrcId + _t161,
        attributes: bg(s.attributes)
      }), o.ssrcIds.push(s.ssrcId + _t161), r && (e.attributes.ssrcs.push({
        ssrcId: r.ssrcIds[1] + _t161,
        attributes: bg(s.attributes)
      }), e.attributes.ssrcGroups.push({
        semantic: "FID",
        ssrcIds: [s.ssrcId + _t161, r.ssrcIds[1] + _t161]
      }));
    }

    e.attributes.ssrcGroups.unshift(o);
  }

  function AL() {
    return _AL.apply(this, arguments);
  }

  function _AL() {
    _AL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee493() {
      var e,
          t,
          i,
          n,
          _ref125,
          s,
          r,
          o,
          _args493 = arguments;

      return _regeneratorRuntime.wrap(function _callee493$(_context493) {
        while (1) {
          switch (_context493.prev = _context493.next) {
            case 0:
              e = _args493.length > 0 && void 0 !== _args493[0] ? _args493[0] : {}, t = _args493.length > 1 && void 0 !== _args493[1] ? _args493[1] : {};
              i = new RTCPeerConnection();
              i.addTransceiver("video", {
                direction: "sendonly"
              }), i.addTransceiver("audio", {
                direction: "sendonly"
              }), i.addTransceiver("video", {
                direction: "recvonly"
              }), i.addTransceiver("audio", {
                direction: "recvonly"
              });
              _context493.next = 5;
              return i.createOffer();

            case 5:
              n = _context493.sent.sdp;

              _ref125 = function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = arguments.length > 2 ? arguments[2] : void 0;
                var n = EL(i, e, t, "sendonly"),
                    s = EL(i, e, t, "recvonly"),
                    r = {
                  audioCodecs: [],
                  audioExtensions: [],
                  videoCodecs: [],
                  videoExtensions: []
                },
                    o = {
                  audioCodecs: [],
                  audioExtensions: [],
                  videoCodecs: [],
                  videoExtensions: []
                },
                    a = {
                  audioCodecs: [],
                  audioExtensions: [],
                  videoCodecs: [],
                  videoExtensions: []
                };

                if (wL(n, s, "videoExtensions", r, o, a), wL(n, s, "videoCodecs", r, o, a), wL(n, s, "audioExtensions", r, o, a), wL(n, s, "audioCodecs", r, o, a), DC("RAISE_H264_BASELINE_PRIORITY")) {
                  var _e418 = a.videoCodecs.findIndex(function (e) {
                    var t, i;
                    return "h264" === (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLocaleLowerCase()) && "42001f" === (null === (i = e.fmtp) || void 0 === i ? void 0 : i.parameters["profile-level-id"]);
                  });

                  if (-1 !== _e418) {
                    var _t351 = a.videoCodecs.findIndex(function (e) {
                      var t;
                      return "h264" === (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLocaleLowerCase());
                    });

                    if (_t351 < _e418) {
                      YC.debug("raising H264 baseline profile priority");
                      var _i190 = a.videoCodecs[_e418];
                      a.videoCodecs.splice(_e418, 1), a.videoCodecs.splice(_t351, 0, _i190);
                    }

                    -1 !== _t351 && (o.videoCodecs = o.videoCodecs.filter(function (e) {
                      var t, i;
                      return !("h264" === (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLocaleLowerCase()) && "42001f" !== (null === (i = e.fmtp) || void 0 === i ? void 0 : i.parameters["profile-level-id"]));
                    })), -1 !== _t351 && DC("FILTER_SEND_H264_BASELINE") && (r.videoCodecs = r.videoCodecs.filter(function (e) {
                      var t, i;
                      return !("h264" === (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLocaleLowerCase()) && "42001f" !== (null === (i = e.fmtp) || void 0 === i ? void 0 : i.parameters["profile-level-id"]));
                    }));
                  }
                }

                return {
                  send: r,
                  recv: o,
                  sendrecv: a
                };
              }(e, t, n);

              s = _ref125.send;
              r = _ref125.recv;
              o = _ref125.sendrecv;

              try {
                i.close();
              } catch (e) {}

              return _context493.abrupt("return", {
                send: s,
                recv: r,
                sendrecv: o
              });

            case 12:
            case "end":
              return _context493.stop();
          }
        }
      }, _callee493);
    }));
    return _AL.apply(this, arguments);
  }

  function bL() {
    var e = {
      audioCodecs: [],
      videoCodecs: [],
      audioExtensions: [],
      videoExtensions: []
    },
        t = EL(arguments.length > 2 ? arguments[2] : void 0, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, "recvonly"),
        i = {
      audioCodecs: [],
      audioExtensions: [],
      videoCodecs: [],
      videoExtensions: []
    },
        n = {
      audioCodecs: [],
      audioExtensions: [],
      videoCodecs: [],
      videoExtensions: []
    },
        s = {
      audioCodecs: [],
      audioExtensions: [],
      videoCodecs: [],
      videoExtensions: []
    };

    if (wL(e, t, "videoExtensions", i, n, s), wL(e, t, "videoCodecs", i, n, s), wL(e, t, "audioExtensions", i, n, s), wL(e, t, "audioCodecs", i, n, s), DC("RAISE_H264_BASELINE_PRIORITY")) {
      var _e111 = s.videoCodecs.findIndex(function (e) {
        return e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase() && e.fmtp && "42001f" === e.fmtp.parameters["profile-level-id"];
      });

      if (-1 !== _e111) {
        var _t162 = s.videoCodecs.findIndex(function (e) {
          return e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase();
        });

        if (_t162 < _e111) {
          YC.debug("raising H264 baseline profile priority");
          var _i92 = s.videoCodecs[_e111];
          s.videoCodecs.splice(_e111, 1), s.videoCodecs.splice(_t162, 0, _i92);
        }

        -1 !== _t162 && (n.videoCodecs = n.videoCodecs.filter(function (e) {
          return !(e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase() && e.fmtp && "42001f" !== e.fmtp.parameters["profile-level-id"]);
        }));
      }
    }

    return {
      send: i,
      recv: n,
      sendrecv: s
    };
  }

  function wL(e, t, i, n, s, r) {
    if ("videoExtensions" === i || "audioExtensions" === i) {
      var _o13 = [];
      return e[i].forEach(function (e) {
        t[i].some(function (t, i) {
          if (e.entry === t.entry && e.extensionName === t.extensionName) return _o13.push(i), !0;
        }) ? r[i].push(e) : n[i].push(e);
      }), void t[i].forEach(function (e, t) {
        -1 === _o13.indexOf(t) && s[i].push(e);
      });
    }

    if ("videoCodecs" === i || "audioCodecs" === i) {
      var _o14 = [];
      return e[i].forEach(function (e) {
        t[i].some(function (t, i) {
          if (e.payloadType === t.payloadType && JSON.stringify(e) === JSON.stringify(t)) return _o14.push(i), !0;
        }) ? r[i].push(e) : n[i].push(e);
      }), void t[i].forEach(function (e, t) {
        -1 === _o14.indexOf(t) && s[i].push(e);
      });
    }
  }

  function OL(e) {
    var t = e.send,
        i = e.recv,
        n = e.sendrecv;

    if (!n) {
      if (!t || !i) throw new Error("cannot merge rtp capabilities because one of send or recv is empty!");
      return {
        send: t,
        recv: i
      };
    }

    var s, r;
    return t ? (s = {
      audioCodecs: [],
      audioExtensions: [],
      videoCodecs: [],
      videoExtensions: []
    }, s.audioCodecs = [].concat(_toConsumableArray(t.audioCodecs), _toConsumableArray(n.audioCodecs)), s.videoCodecs = [].concat(_toConsumableArray(t.videoCodecs), _toConsumableArray(n.videoCodecs)), s.audioExtensions = [].concat(_toConsumableArray(t.audioExtensions), _toConsumableArray(n.audioExtensions)), s.videoExtensions = [].concat(_toConsumableArray(t.videoExtensions), _toConsumableArray(n.videoExtensions))) : s = n, i ? (r = {
      audioCodecs: [],
      audioExtensions: [],
      videoCodecs: [],
      videoExtensions: []
    }, r.audioCodecs = [].concat(_toConsumableArray(i.audioCodecs), _toConsumableArray(n.audioCodecs)), r.videoCodecs = [].concat(_toConsumableArray(i.videoCodecs), _toConsumableArray(n.videoCodecs)), r.audioExtensions = [].concat(_toConsumableArray(i.audioExtensions), _toConsumableArray(n.audioExtensions)), r.videoExtensions = [].concat(_toConsumableArray(i.videoExtensions), _toConsumableArray(n.videoExtensions))) : r = n, {
      send: s,
      recv: r
    };
  }

  function NL(e) {
    if ("audio" !== e.media.mediaType) return;
    e.attributes.payloads.filter(function (e) {
      var t;
      return "opus" === (null === (t = e.rtpMap) || void 0 === t ? void 0 : t.encodingName.toLowerCase());
    }).forEach(function (e) {
      e.fmtp || (e.fmtp = {
        parameters: {}
      }), e.fmtp.parameters.stereo = "1", e.fmtp.parameters["sprop-stereo"] = "1";
    });
  }

  function DL(e) {
    e.mediaDescriptions.forEach(function (e) {
      "video" !== e.media.mediaType && "audio" !== e.media.mediaType || e.attributes.payloads.forEach(function (e) {
        -1 === e.rtcpFeedbacks.findIndex(function (e) {
          return "rrtr" === e.type;
        }) && e.rtcpFeedbacks.push({
          type: "rrtr"
        });
      });
    });
  }

  function PL(e, t, i, n) {
    var s = [];

    if (e === hv.VIDEO) {
      if (DC("H264_PROFILE_LEVEL_ID") && "h264" === n && (s = t.videoCodecs.filter(function (e) {
        var t;
        return bn(t = e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "").call(t, n) && e && e.fmtp && e.fmtp.parameters["profile-level-id"] === DC("H264_PROFILE_LEVEL_ID");
      })), !Array.isArray(s) || 0 === s.length) {
        var _e112 = [];
        var _r18 = [],
            _o15 = [];
        i.videoCodecs.forEach(function (t) {
          var i, s, a;
          bn(i = t.rtpMap && t.rtpMap.encodingName.toLowerCase() || "").call(i, n) && _e112.push(t), bn(s = t.rtpMap && t.rtpMap.encodingName.toLowerCase() || "").call(s, "vp8") && _r18.push(t), bn(a = t.rtpMap && t.rtpMap.encodingName.toLowerCase() || "").call(a, "h264") && _o15.push(t);
        }), 0 === _e112.length && (0 !== _r18.length ? (_e112 = _r18, YC.warning("codec ".concat(n, " not included in rtpCapabilities, fallback to default payloads: vp8"))) : 0 !== _o15.length && (_e112 = _o15, YC.warning("codec ".concat(n, " not included in rtpCapabilities, fallback to default payloads: h264")))), 0 !== _e112.length && (s = t.videoCodecs.filter(function (t) {
          return _e112.some(function (e) {
            return e.payloadType === t.payloadType;
          });
        }));
      }

      if (DC("USE_PUB_RTX")) {
        var _e113 = s.map(function (e) {
          return e.payloadType.toString();
        }),
            _i93 = t.videoCodecs.filter(function (t) {
          return t.rtpMap && "rtx" === t.rtpMap.encodingName && bn(_e113).call(_e113, t.fmtp && t.fmtp.parameters.apt || "");
        });

        s = [].concat(_toConsumableArray(s), _toConsumableArray(_i93));
      }

      0 === s.length && (YC.warning("codec ".concat(n, " not included in rtpCapabilities, fallback to default payloads: ").concat(t.videoCodecs[0].rtpMap && t.videoCodecs[0].rtpMap.encodingName)), s = t.videoCodecs);
    } else s = t.audioCodecs.filter(function (e) {
      var t;
      return bn(t = e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "").call(t, n);
    }), 0 === s.length && (YC.warning("codec ".concat(n, " not included in rtpCapabilities, fallback to opus")), s = t.audioCodecs.filter(function (e) {
      var t;
      return bn(t = e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "").call(t, "opus");
    }));

    return s;
  }

  var LL = /*#__PURE__*/function () {
    function LL(e) {
      _classCallCheck(this, LL);

      nh(this, "sessionDesc", void 0), nh(this, "_localCapabilities", void 0), nh(this, "_rtpCapabilities", void 0), nh(this, "_candidates", void 0), nh(this, "_iceParameters", void 0), nh(this, "_dtlsParameters", void 0), nh(this, "setup", void 0), nh(this, "currentMidIndex", void 0), nh(this, "cname", "o/i14u9pJrxRKAsu"), nh(this, "firefoxSsrcMidMap", new Map()), e = bg(e);
      var _e114 = e,
          t = _e114.remoteIceParameters,
          i = _e114.remoteDtlsParameters,
          n = _e114.candidates,
          s = _e114.remoteRTPCapabilities,
          r = _e114.localCapabilities,
          o = _e114.direction,
          a = _e114.setup,
          c = _e114.videoCodec,
          d = _e114.audioCodec;
      var l;
      this.setup = a, l = o === vI.RECEIVE_ONLY ? YP.parse("v=0\no=- 0 0 IN IP4 127.0.0.1\ns=AgoraGateway\nt=0 0\na=group:BUNDLE 0 1\na=msid-semantic: WMS\na=extmap-allow-mixed\nm=video 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendonly\na=rtcp-mux\na=rtcp-rsize\na=mid:0\nm=audio 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendonly\na=rtcp-mux\na=rtcp-rsize\na=mid:1\n") : YP.parse("v=0\no=- 0 0 IN IP4 127.0.0.1\ns=AgoraGateway\nt=0 0\na=group:BUNDLE 0 1\na=msid-semantic: WMS\na=extmap-allow-mixed\nm=video 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=recvonly\na=rtcp-mux\na=rtcp-rsize\na=mid:0\nm=audio 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=recvonly\na=rtcp-mux\na=rtcp-rsize\na=mid:1\n"), this._rtpCapabilities = s, this._candidates = n, this._iceParameters = t, this._dtlsParameters = i, this._localCapabilities = r;

      var u = o === vI.RECEIVE_ONLY ? this.rtpCapabilities.send : this.rtpCapabilities.recv,
          h = o === vI.RECEIVE_ONLY ? this._localCapabilities.recv : this._localCapabilities.send,
          p = o === vI.RECEIVE_ONLY ? s.send.videoCodecs : PL(hv.VIDEO, u, h, c),
          _ = o === vI.RECEIVE_ONLY ? s.send.audioCodecs : PL(hv.AUDIO, u, h, d);

      var _iterator20 = _createForOfIteratorHelper(l.mediaDescriptions),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _e115 = _step20.value;

          if (_e115.attributes.iceUfrag = t.iceUfrag, _e115.attributes.icePwd = t.icePwd, _e115.attributes.fingerprints = i.fingerprints, _e115.attributes.candidates = n, _e115.attributes.setup = this.setup, "application" === _e115.media.mediaType && (_e115.attributes.sctpPort = "5000"), "video" === _e115.media.mediaType && (_e115.media.fmts = p.map(function (e) {
            return e.payloadType.toString(10);
          }), _e115.attributes.payloads = p, _e115.attributes.extmaps = u.videoExtensions, DC("PRELOAD_MEDIA_COUNT") > 0)) {
            var _gL = gL([{
              ssrcId: 4e4,
              rtx: DC("USE_SUB_RTX") ? 40001 : void 0
            }], this.cname),
                _t163 = _gL.ssrcs,
                _i94 = _gL.ssrcGroups;

            _e115.attributes.ssrcs = _t163, _e115.attributes.ssrcGroups = _i94;
          }

          if ("audio" === _e115.media.mediaType && (_e115.media.fmts = _.map(function (e) {
            return e.payloadType.toString(10);
          }), _e115.attributes.payloads = _, _e115.attributes.extmaps = u.audioExtensions, NL(_e115), DC("PRELOAD_MEDIA_COUNT") > 0)) {
            var _gL2 = gL([{
              ssrcId: 2e4
            }], this.cname),
                _t164 = _gL2.ssrcs,
                _i95 = _gL2.ssrcGroups;

            _e115.attributes.ssrcs = _t164, _e115.attributes.ssrcGroups = _i95;
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      this.sessionDesc = l, this.currentMidIndex = l.mediaDescriptions.length - 1;
    }

    _createClass(LL, [{
      key: "localCapabilities",
      get: function get() {
        return bg(this._localCapabilities);
      }
    }, {
      key: "rtpCapabilities",
      get: function get() {
        return bg(this._rtpCapabilities);
      }
    }, {
      key: "candidates",
      get: function get() {
        return bg(this._candidates);
      }
    }, {
      key: "iceParameters",
      get: function get() {
        return bg(this._iceParameters);
      }
    }, {
      key: "dtlsParameters",
      get: function get() {
        return bg(this._dtlsParameters);
      }
    }, {
      key: "toString",
      value: function toString() {
        return YP.print(this.sessionDesc);
      }
    }, {
      key: "hasMid",
      value: function hasMid(e) {
        var _this176 = this;

        return Array.isArray(e) ? e.every(function (e) {
          return _this176.hasMid(e);
        }) : this.sessionDesc.mediaDescriptions.some(function (t) {
          return t.attributes.mid === e;
        });
      }
    }, {
      key: "send",
      value: function send(e, t, i, n, s) {
        i = i.replace(/ /g, "-");

        var _gL3 = gL(t, this.cname, DC("SYNC_GROUP") ? i : void 0),
            r = _gL3.ssrcs,
            o = _gL3.ssrcGroups,
            a = this.findPreloadMediaDesc(r);

        if (a) {
          if (RT() && this.firefoxSsrcMidMap.set(r[0].ssrcId, a.attributes.mid), s && (s.twcc || s.remb)) {
            var _e116 = this.sessionDesc.mediaDescriptions.indexOf(a);

            return this.sessionDesc.mediaDescriptions[_e116] = this.mungSendMediaDesc(a, s), {
              mid: a.attributes.mid,
              needExchangeSDP: !0
            };
          }

          return {
            mid: a.attributes.mid,
            needExchangeSDP: !1
          };
        }

        {
          var _t165 = this.findAvailableMediaIndex(e, r, n);

          var _i96;

          return -1 === _t165 ? (_i96 = this.createOrRecycleSendMedia(e, r, o, "sendonly", n, s), this.updateBundleMids()) : (_i96 = bg(this.sessionDesc.mediaDescriptions[_t165]), _i96.attributes.direction = "sendonly", _i96.attributes.ssrcs = r, _i96.attributes.ssrcGroups = o, this.sessionDesc.mediaDescriptions[_t165] = this.mungSendMediaDesc(_i96, s)), RT() && this.firefoxSsrcMidMap.set(r[0].ssrcId, _i96.attributes.mid), {
            needExchangeSDP: !0,
            mid: _i96.attributes.mid
          };
        }
      }
    }, {
      key: "stopSending",
      value: function stopSending(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return t.attributes.mid && -1 !== e.indexOf(t.attributes.mid);
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.stopSending.");
        t.forEach(function (e) {
          e.attributes.ssrcs = [];
        }), this.updateBundleMids();
      }
    }, {
      key: "receive",
      value: function receive(e, t, i) {
        var _this177 = this;

        var n = [];
        return e.forEach(function (e) {
          var s = e._mediaStreamTrack.kind,
              r = _this177.findAvailableRecvMediaIndex(s);

          var o,
              a = !1;
          -1 === r ? (a = !0, o = _this177.createOrRecycleRecvMedia(e, [], "recvonly", t, i), _this177.updateBundleMids()) : (o = bg(_this177.sessionDesc.mediaDescriptions[r]), o.attributes.direction = "recvonly"), n.push({
            mid: o.attributes.mid,
            needCreateTransceiver: a
          });
        }), n;
      }
    }, {
      key: "stopReceiving",
      value: function stopReceiving(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return -1 !== e.indexOf(t.attributes.mid);
        });
        if (t.length !== e.length) throw new Error("MediaDescriptions' length doesn't match mids's length when calling RemoteSDP.receive.");
        t.forEach(function (e) {
          e.media.port = "0", e.attributes.direction = "inactive";
        }), this.updateBundleMids();
      }
    }, {
      key: "addRemoteCandidate",
      value: function addRemoteCandidate(e) {
        var _this178 = this;

        var _RTCIceCandidate = new RTCIceCandidate(e),
            t = _RTCIceCandidate.foundation,
            i = _RTCIceCandidate.protocol,
            n = _RTCIceCandidate.address,
            s = _RTCIceCandidate.port,
            r = _RTCIceCandidate.type,
            o = _RTCIceCandidate.relatedAddress,
            a = _RTCIceCandidate.relatedPort,
            c = _RTCIceCandidate.priority,
            d = {
          foundation: null != t ? t : "",
          componentId: "1",
          transport: null != i ? i : "",
          priority: c ? c + "" : "",
          connectionAddress: null != n ? n : "",
          port: s ? s + "" : "",
          type: r ? r + "" : "",
          relAddr: null != o ? o : "",
          relPort: a ? a + "" : "",
          extension: {}
        };

        this.candidates.some(function (e) {
          return e.priority === d.priority && e.connectionAddress === d.connectionAddress && e.port === d.port;
        }) || (this._candidates.push(d), this.sessionDesc.mediaDescriptions.forEach(function (e) {
          e.attributes.candidates = _this178.candidates;
        }));
      }
    }, {
      key: "clearRemoteCandidate",
      value: function clearRemoteCandidate() {
        this._candidates = [], this.sessionDesc.mediaDescriptions[0].attributes.candidates = this._candidates;
      }
    }, {
      key: "createOrRecycleRecvMedia",
      value: function createOrRecycleRecvMedia(e, t, i, n, s) {
        var r = e._mediaStreamTrack.kind,
            o = this.rtpCapabilities.recv,
            a = PL(r, o, this.localCapabilities.send, r === hv.AUDIO ? s : n),
            c = r === hv.VIDEO ? o.videoExtensions : o.audioExtensions,
            d = "".concat(++this.currentMidIndex);
        var l = {
          media: {
            mediaType: r,
            port: "9",
            protos: ["UDP", "TLS", "RTP", "SAVPF"],
            fmts: a.map(function (e) {
              return e.payloadType.toString(10);
            })
          },
          connections: [{
            nettype: "IN",
            addrtype: "IP4",
            address: "127.0.0.1"
          }],
          bandwidths: [],
          attributes: {
            iceUfrag: this.iceParameters.iceUfrag,
            icePwd: this.iceParameters.icePwd,
            unrecognized: [],
            candidates: [],
            extmaps: c,
            fingerprints: this.dtlsParameters.fingerprints,
            imageattr: [],
            msids: [],
            remoteCandidatesList: [],
            rids: [],
            ssrcs: t,
            ssrcGroups: [],
            rtcpFeedbackWildcards: [],
            payloads: a,
            rtcp: {
              port: "9",
              netType: "IN",
              addressType: "IP4",
              address: "0.0.0.0"
            },
            setup: this.setup,
            direction: i,
            rtcpMux: !0,
            rtcpRsize: !0,
            mid: "".concat(d)
          }
        };
        l = this.mungRecvMediaDsec(l, e);
        var u = this.findFirstClosedMedia(r);

        if (u) {
          var _e117 = this.sessionDesc.mediaDescriptions.indexOf(u);

          this.sessionDesc.mediaDescriptions[_e117] = l;
        } else this.sessionDesc.mediaDescriptions.push(l);

        return l;
      }
    }, {
      key: "muteRemote",
      value: function muteRemote(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return bn(e).call(e, t.attributes.mid || "");
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        t.forEach(function (e) {
          e.attributes.direction = "inactive";
        });
      }
    }, {
      key: "unmuteRemote",
      value: function unmuteRemote(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return bn(e).call(e, t.attributes.mid || "");
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        t.forEach(function (e) {
          e.attributes.direction = "recvonly";
        });
      }
    }, {
      key: "findAvailableMediaIndex",
      value: function findAvailableMediaIndex(e, t, i) {
        var _this179 = this;

        return this.sessionDesc.mediaDescriptions.findIndex(function (n) {
          var s = n.media.mediaType === e && "0" !== n.media.port && ("sendonly" === n.attributes.direction || "sendrecv" === n.attributes.direction) && 0 === n.attributes.ssrcs.length;

          if (RT()) {
            if (s) {
              var _e118 = _this179.firefoxSsrcMidMap.get(t[0].ssrcId);

              return !(_e118 || "0" !== n.attributes.mid && "1" !== n.attributes.mid) || !(!_e118 || _e118 !== n.attributes.mid);
            }

            return !1;
          }

          return s && n.attributes.mid === i;
        });
      }
    }, {
      key: "findAvailableRecvMediaIndex",
      value: function findAvailableRecvMediaIndex(e) {
        return this.sessionDesc.mediaDescriptions.findIndex(function (t) {
          var i = t.media.mediaType === e && "0" !== t.media.port && ("recvonly" === t.attributes.direction || "sendrecv" === t.attributes.direction);
          return "0" !== t.attributes.mid && "1" !== t.attributes.mid && i;
        });
      }
    }, {
      key: "predictReceivingMids",
      value: function predictReceivingMids(e) {
        var t = [];

        for (var i = 0; i < e; i++) {
          t.push((this.currentMidIndex + i + 1).toString(10));
        }

        return t;
      }
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        e = bg(e), this._iceParameters = e, this.sessionDesc.mediaDescriptions.forEach(function (t) {
          t.attributes.iceUfrag = e.iceUfrag, t.attributes.icePwd = e.icePwd;
        });
      }
    }, {
      key: "createOrRecycleSendMedia",
      value: function createOrRecycleSendMedia(e, t, i, n, s, r) {
        var o = this.rtpCapabilities.send,
            a = e === hv.VIDEO ? o.videoCodecs : o.audioCodecs,
            c = e === hv.VIDEO ? o.videoExtensions : o.audioExtensions;
        RT() && (s = "".concat(++this.currentMidIndex));
        var d = {
          media: {
            mediaType: e,
            port: "9",
            protos: ["UDP", "TLS", "RTP", "SAVPF"],
            fmts: a.map(function (e) {
              return e.payloadType.toString(10);
            })
          },
          connections: [{
            nettype: "IN",
            addrtype: "IP4",
            address: "127.0.0.1"
          }],
          bandwidths: [],
          attributes: {
            iceUfrag: this.iceParameters.iceUfrag,
            icePwd: this.iceParameters.icePwd,
            unrecognized: [],
            candidates: [],
            extmaps: c,
            fingerprints: this.dtlsParameters.fingerprints,
            imageattr: [],
            msids: [],
            remoteCandidatesList: [],
            rids: [],
            ssrcs: t,
            ssrcGroups: i,
            rtcpFeedbackWildcards: [],
            payloads: a,
            rtcp: {
              port: "9",
              netType: "IN",
              addressType: "IP4",
              address: "0.0.0.0"
            },
            setup: this.setup,
            direction: n,
            rtcpMux: !0,
            rtcpRsize: !0,
            mid: s
          }
        };
        d = this.mungSendMediaDesc(d, r);
        var l = this.findFirstClosedMedia(e);

        if (l) {
          var _e119 = this.sessionDesc.mediaDescriptions.indexOf(l);

          this.sessionDesc.mediaDescriptions[_e119] = d;
        } else this.sessionDesc.mediaDescriptions.push(d);

        return d;
      }
    }, {
      key: "mungRecvMediaDsec",
      value: function mungRecvMediaDsec(e, t, i) {
        var n = bg(e);
        return RL(n), SL(n, t), CL(n, t), IL(n), vL(n, i, this.localCapabilities.send), n;
      }
    }, {
      key: "mungSendMediaDesc",
      value: function mungSendMediaDesc(e, t) {
        var i = bg(e);
        return vL(i, t, this.localCapabilities.recv), NL(i), i;
      }
    }, {
      key: "updateRecvMedia",
      value: function updateRecvMedia(e, t) {
        var i = this.sessionDesc.mediaDescriptions.findIndex(function (t) {
          return t.attributes.mid === e;
        });

        if (-1 !== i) {
          var _e120 = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[i], t);

          this.sessionDesc.mediaDescriptions[i] = _e120;
        }
      }
    }, {
      key: "updateBundleMids",
      value: function updateBundleMids() {
        this.sessionDesc.attributes.groups[0].identificationTag = this.sessionDesc.mediaDescriptions.filter(function (e) {
          return "0" !== e.media.port;
        }).map(function (e) {
          return e.attributes.mid;
        });
      }
    }, {
      key: "findPreloadMediaDesc",
      value: function findPreloadMediaDesc(e) {
        return this.sessionDesc.mediaDescriptions.find(function (t) {
          var i;
          return (null === (i = t.attributes) || void 0 === i || null === (i = i.ssrcs[0]) || void 0 === i ? void 0 : i.ssrcId) === e[0].ssrcId;
        });
      }
    }, {
      key: "findFirstClosedMedia",
      value: function findFirstClosedMedia(e) {
        return this.sessionDesc.mediaDescriptions.find(function (t) {
          return RT() ? "0" === t.media.port && t.media.mediaType === e : "0" === t.media.port;
        });
      }
    }]);

    return LL;
  }();

  var kL = ["sdp"];

  function ML(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function UL(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ML(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ML(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var xL = /*#__PURE__*/function (_kv2) {
    _inherits(e, _kv2);

    var _super55 = _createSuper(e);

    function e(t, i, n) {
      var _this180;

      _classCallCheck(this, e);

      _this180 = _super55.call(this, t, i), nh(_assertThisInitialized(_this180), "direction", void 0), nh(_assertThisInitialized(_this180), "name", void 0), nh(_assertThisInitialized(_this180), "store", void 0), nh(_assertThisInitialized(_this180), "spec", void 0), nh(_assertThisInitialized(_this180), "peerConnection", void 0), nh(_assertThisInitialized(_this180), "initialOffer", void 0), nh(_assertThisInitialized(_this180), "transport", void 0), nh(_assertThisInitialized(_this180), "statsFilter", void 0), nh(_assertThisInitialized(_this180), "localCandidateCount", 0), nh(_assertThisInitialized(_this180), "allCandidatesReceived", !1), nh(_assertThisInitialized(_this180), "localCandidateAddress", null), nh(_assertThisInitialized(_this180), "useXR", DC("USE_XR")), nh(_assertThisInitialized(_this180), "filter", {
        filterRTX: !DC("USE_PUB_RTX") && !DC("USE_SUB_RTX"),
        filterVideoFec: DC("FILTER_VIDEO_FEC"),
        filterAudioFec: DC("FILTER_AUDIO_FEC")
      }), nh(_assertThisInitialized(_this180), "extension", {
        useXR: _this180.useXR
      }), nh(_assertThisInitialized(_this180), "_isInRestartIce", !1), nh(_assertThisInitialized(_this180), "mutex", new Yg("P2PConnection-mutex")), nh(_assertThisInitialized(_this180), "onLocalCandidate", void 0), nh(_assertThisInitialized(_this180), "remoteSDP", void 0), nh(_assertThisInitialized(_this180), "pendingCandidates", []), nh(_assertThisInitialized(_this180), "localCapabilities", void 0), nh(_assertThisInitialized(_this180), "isReady", !1), nh(_assertThisInitialized(_this180), "restartCnt", 0), nh(_assertThisInitialized(_this180), "curTurnServerIndex", 0), _this180.store = i, _this180.spec = t, _this180.peerConnection = new RTCPeerConnection(e.resolvePCConfiguration(t, i.p2pTransport), {
        optional: [{
          googDscp: !0
        }]
      }), _this180.direction = null != n ? n : vI.SEND_ONLY, _this180.name = _this180.direction === vI.SEND_ONLY ? "sendP2PConnection" : "recvP2PConnection", _this180.statsFilter = hL(_this180.peerConnection, DC("STATS_UPDATE_INTERVAL"), void 0, RT() ? 1200 : void 0), _this180.bindPCEvents(), _this180.bindStatsEvents(), _this180.store.p2pId = _this180.store.p2pId + 1;
      return _this180;
    }

    _createClass(e, [{
      key: "currentLocalDescription",
      get: function get() {
        return this.peerConnection.currentLocalDescription;
      }
    }, {
      key: "currentRemoteDescription",
      get: function get() {
        return this.peerConnection.currentRemoteDescription;
      }
    }, {
      key: "peerConnectionState",
      get: function get() {
        return this.peerConnection.connectionState;
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.peerConnection.iceConnectionState;
      }
    }, {
      key: "dtlsTransportState",
      get: function get() {
        var _e121, t;

        return null !== (_e121 = null === (t = this.peerConnection.getReceivers()[0]) || void 0 === t || null === (t = t.transport) || void 0 === t ? void 0 : t.state) && void 0 !== _e121 ? _e121 : null;
      }
    }, {
      key: "localCodecs",
      get: function get() {
        return [];
      }
    }, {
      key: "isInRestartIce",
      get: function get() {
        return this._isInRestartIce;
      },
      set: function set(_e122) {
        this._isInRestartIce = _e122;
      }
    }, {
      key: "establish",
      value: function () {
        var _establish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee151(_e123) {
          var _t166, _t167, i, _n77, _s41, _r19, _o16, _a7, _e195, _t169;

          return _regeneratorRuntime.wrap(function _callee151$(_context151) {
            while (1) {
              switch (_context151.prev = _context151.next) {
                case 0:
                  _context151.prev = 0;
                  _context151.next = 3;
                  return AL(this.filter, this.extension);

                case 3:
                  _t166 = _context151.sent;

                  if (!(this.localCapabilities = OL(_t166), _e123)) {
                    _context151.next = 24;
                    break;
                  }

                  _t167 = _e123.sdp, i = HP(_e123, kL), _n77 = function () {
                    var e = {
                      audioCodecs: [],
                      videoCodecs: [],
                      audioExtensions: [],
                      videoExtensions: []
                    },
                        t = EL(arguments.length > 2 ? arguments[2] : void 0, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, "sendonly"),
                        i = {
                      audioCodecs: [],
                      audioExtensions: [],
                      videoCodecs: [],
                      videoExtensions: []
                    },
                        n = {
                      audioCodecs: [],
                      audioExtensions: [],
                      videoCodecs: [],
                      videoExtensions: []
                    },
                        s = {
                      audioCodecs: [],
                      audioExtensions: [],
                      videoCodecs: [],
                      videoExtensions: []
                    };

                    if (wL(t, e, "videoExtensions", i, n, s), wL(t, e, "videoCodecs", i, n, s), wL(t, e, "audioExtensions", i, n, s), wL(t, e, "audioCodecs", i, n, s), DC("RAISE_H264_BASELINE_PRIORITY")) {
                      var _e194 = s.videoCodecs.findIndex(function (e) {
                        return e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase() && e.fmtp && "42001f" === e.fmtp.parameters["profile-level-id"];
                      });

                      if (-1 !== _e194) {
                        var _t168 = s.videoCodecs.findIndex(function (e) {
                          return e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase();
                        });

                        if (_t168 < _e194) {
                          YC.debug("raising H264 baseline profile priority");
                          var _i97 = s.videoCodecs[_e194];
                          s.videoCodecs.splice(_e194, 1), s.videoCodecs.splice(_t168, 0, _i97);
                        }

                        -1 !== _t168 && DC("FILTER_SEND_H264_BASELINE") && (i.videoCodecs = i.videoCodecs.filter(function (e) {
                          return !(e.rtpMap && "h264" === e.rtpMap.encodingName.toLocaleLowerCase() && e.fmtp && "42001f" !== e.fmtp.parameters["profile-level-id"]);
                        }));
                      }
                    }

                    return {
                      send: i,
                      recv: n,
                      sendrecv: s
                    };
                  }(this.filter, this.extension, _t167);
                  this.remoteSDP = new LL({
                    remoteIceParameters: i.iceParameters,
                    remoteDtlsParameters: i.dtlsParameters,
                    candidates: [],
                    remoteRTPCapabilities: _n77,
                    localCapabilities: this.localCapabilities,
                    direction: this.direction,
                    setup: "actpass",
                    videoCodec: this.store.codec,
                    audioCodec: this.store.audioCodec
                  });
                  _context151.next = 9;
                  return this.setRemoteDescription({
                    type: "offer",
                    sdp: this.remoteSDP.toString()
                  });

                case 9:
                  this.isReady = !0;
                  _context151.next = 12;
                  return this.peerConnection.createAnswer();

                case 12:
                  _s41 = _context151.sent;

                  if (_s41.sdp) {
                    _context151.next = 15;
                    break;
                  }

                  throw new Error("Cannot get answer sdp when trying to establish PeerConnection.");

                case 15:
                  _r19 = mL(_s41.sdp);
                  _context151.next = 18;
                  return this.peerConnection.setLocalDescription(_s41);

                case 18:
                  _context151.next = 20;
                  return bL(this.filter, this.extension, _s41.sdp);

                case 20:
                  _o16 = _context151.sent;
                  this.localCapabilities = OL(_o16);
                  _a7 = this.peerConnection.getTransceivers()[0];
                  return _context151.abrupt("return", (null != _a7 && _a7.receiver && _a7.receiver.transport && this.tryBindTransportEvents(_a7.receiver.transport), UL(UL({}, _r19), {}, {
                    sdp: _s41.sdp
                  })));

                case 24:
                  this.peerConnection.addTransceiver("video", {
                    direction: "sendonly"
                  }), this.peerConnection.addTransceiver("audio", {
                    direction: "sendonly"
                  });
                  _context151.next = 27;
                  return this.peerConnection.createOffer();

                case 27:
                  _e195 = _context151.sent;

                  if (_e195.sdp) {
                    _context151.next = 30;
                    break;
                  }

                  throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");

                case 30:
                  _t169 = mL(_e195.sdp);
                  return _context151.abrupt("return", (this.initialOffer = _e195, UL(UL({}, _t169), {}, {
                    sdp: _e195.sdp
                  })));

                case 34:
                  _context151.prev = 34;
                  _context151.t0 = _context151["catch"](0);
                  throw new VT(xT.GET_LOCAL_CONNECTION_PARAMS_FAILED, _context151.t0.toString());

                case 37:
                case "end":
                  return _context151.stop();
              }
            }
          }, _callee151, this, [[0, 34]]);
        }));

        function establish(_x241) {
          return _establish.apply(this, arguments);
        }

        return establish;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee152(_e126) {
          var _t170, i, _n78, _s42, _r20;

          return _regeneratorRuntime.wrap(function _callee152$(_context152) {
            while (1) {
              switch (_context152.prev = _context152.next) {
                case 0:
                  _context152.prev = 0;

                  if (this.initialOffer) {
                    _context152.next = 3;
                    break;
                  }

                  throw new Error("Cannot establish P2PConnection without initial offer.");

                case 3:
                  _context152.next = 5;
                  return this.peerConnection.setLocalDescription(this.initialOffer);

                case 5:
                  _t170 = _e126.sdp;
                  i = _e126.iceParameters;
                  _n78 = _e126.dtlsParameters;
                  _context152.next = 10;
                  return bL(this.filter, this.extension, _t170);

                case 10:
                  _s42 = _context152.sent;
                  this.remoteSDP = new LL({
                    remoteIceParameters: i,
                    remoteDtlsParameters: _n78,
                    candidates: [],
                    remoteRTPCapabilities: _s42,
                    localCapabilities: this.localCapabilities,
                    direction: this.direction,
                    setup: "active",
                    videoCodec: this.store.codec,
                    audioCodec: this.store.audioCodec
                  });
                  _context152.next = 14;
                  return this.setRemoteDescription({
                    type: "answer",
                    sdp: this.remoteSDP.toString()
                  });

                case 14:
                  _r20 = this.peerConnection.getTransceivers()[0];
                  null != _r20 && _r20.sender && _r20.sender.transport && this.tryBindTransportEvents(_r20.sender.transport);
                  _context152.next = 21;
                  break;

                case 18:
                  _context152.prev = 18;
                  _context152.t0 = _context152["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(_context152.t0.toString()));

                case 21:
                case "end":
                  return _context152.stop();
              }
            }
          }, _callee152, this, [[0, 18]]);
        }));

        function connect(_x242) {
          return _connect.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "addRemoteCandidate",
      value: function () {
        var _addRemoteCandidate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee153(_e128) {
          var _this181 = this;

          return _regeneratorRuntime.wrap(function _callee153$(_context153) {
            while (1) {
              switch (_context153.prev = _context153.next) {
                case 0:
                  _context153.prev = 0;
                  _e128 && this.pendingCandidates.push(_e128), this.peerConnection.remoteDescription && this.isReady && (this.pendingCandidates.forEach(function (_e129) {
                    _this181.peerConnection.addIceCandidate(_e129);
                  }), this.pendingCandidates = []);
                  _context153.next = 7;
                  break;

                case 4:
                  _context153.prev = 4;
                  _context153.t0 = _context153["catch"](0);
                  throw new VT(xT.ADD_CANDIDATE_FAILED, "P2PConnection.addRemoteCandidate failed; ".concat(_context153.t0.toString()));

                case 7:
                case "end":
                  return _context153.stop();
              }
            }
          }, _callee153, this, [[0, 4]]);
        }));

        function addRemoteCandidate(_x243) {
          return _addRemoteCandidate.apply(this, arguments);
        }

        return addRemoteCandidate;
      }()
    }, {
      key: "send",
      value: function send(_e131, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee154() {
          var s, _r21, _o17, _a8, c, _d6, _l4, _u3, _h4, _t172, _p3, _2;

          return _regeneratorRuntime.wrap(function _callee154$(_context154) {
            while (1) {
              switch (_context154.prev = _context154.next) {
                case 0:
                  _context154.next = 2;
                  return SP(n.mutex.lock("From P2PConnection.send"));

                case 2:
                  s = _context154.sent;
                  _context154.prev = 3;

                  if (n.remoteSDP) {
                    _context154.next = 6;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.send before remote SDP created");

                case 6:
                  _r21 = [], _o17 = n.remoteSDP.receive(_e131, t, i);

                  _e131.forEach(function (e, t) {
                    if (_o17[t].needCreateTransceiver) {
                      var _t171 = n.peerConnection.addTransceiver(e._mediaStreamTrack, {
                        direction: "sendonly"
                      });

                      _r21.push(_t171), e._updateRtpTransceiver(_t171);
                    } else {
                      var _i98 = n.peerConnection.getTransceivers().find(function (e) {
                        return e.mid === _o17[t].mid;
                      });

                      if (!_i98) throw new Error("cannot find transceiver when sendPeerconnection send, mid is ".concat(_o17[t].mid));
                      _r21.push(_i98), e._updateRtpTransceiver(_i98);
                    }
                  });

                  _context154.t0 = RT() && !0 === DC("SIMULCAST");

                  if (!_context154.t0) {
                    _context154.next = 12;
                    break;
                  }

                  _context154.next = 12;
                  return SP(n.applySimulcastForFirefox(_r21, _e131));

                case 12:
                  _a8 = _o17.map(function (e) {
                    return e.mid;
                  });
                  _context154.next = 15;
                  return SP(n.peerConnection.createOffer());

                case 15:
                  c = _context154.sent;
                  _d6 = n.mungSendOfferSDP(c.sdp, _e131, _a8);
                  _l4 = YP.parse(_d6);
                  _u3 = _a8.map(function (e) {
                    var t = _l4.mediaDescriptions.find(function (t) {
                      return t.attributes.mid === e;
                    });

                    if (!t) throw new Error("Cannot extract ssrc from mediaDescription.");
                    return fL(t, DC("USE_PUB_RTX"));
                  });
                  _h4 = _r21.map(function (e, t) {
                    var i = _a8[t];
                    return {
                      localSSRC: _u3[t],
                      id: i
                    };
                  });
                  _context154.next = 22;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _d6
                  }));

                case 22:
                  _context154.prev = 22;
                  _context154.next = 25;
                  return _h4;

                case 25:
                  _context154.next = 37;
                  break;

                case 27:
                  _context154.prev = 27;
                  _context154.t1 = _context154["catch"](22);
                  _t172 = n.remoteSDP.toString();
                  _context154.next = 32;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _d6
                  }));

                case 32:
                  _context154.next = 34;
                  return SP(n.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _t172
                  }));

                case 34:
                  _context154.next = 36;
                  return SP(n.stopSending(_a8, !0));

                case 36:
                  throw _context154.t1;

                case 37:
                  _context154.next = 39;
                  return SP(n.applySimulcastEncodings(_r21, _e131));

                case 39:
                  _context154.next = 41;
                  return SP(n.applySendEncodings(_r21, _e131));

                case 41:
                  _p3 = n.remoteSDP.toString(), _2 = n.logSDPExchange(_d6, "offer", "local", "send");
                  null == _2 || _2(_p3);
                  _context154.next = 45;
                  return SP(n.setRemoteDescription({
                    type: "answer",
                    sdp: _p3
                  }));

                case 45:
                  return _context154.abrupt("return", _r21.map(function (e, t) {
                    var i = _a8[t];
                    return {
                      localSSRC: _u3[t],
                      id: i
                    };
                  }));

                case 48:
                  _context154.prev = 48;
                  _context154.t2 = _context154["catch"](3);
                  throw _context154.t2 instanceof VT ? _context154.t2 : new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(_context154.t2.toString()));

                case 51:
                  _context154.prev = 51;
                  s();
                  return _context154.finish(51);

                case 54:
                case "end":
                  return _context154.stop();
              }
            }
          }, _callee154, null, [[3, 48, 51, 54], [22, 27]]);
        }))();
      }
    }, {
      key: "stopSending",
      value: function () {
        var _stopSending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee155(_e132, t) {
          var i, _t173, _n79, _s43, _r22;

          return _regeneratorRuntime.wrap(function _callee155$(_context155) {
            while (1) {
              switch (_context155.prev = _context155.next) {
                case 0:
                  if (!t) {
                    _context155.next = 4;
                    break;
                  }

                  _context155.t0 = void 0;
                  _context155.next = 7;
                  break;

                case 4:
                  _context155.next = 6;
                  return this.mutex.lock("From P2PConnection.stopSending");

                case 6:
                  _context155.t0 = _context155.sent;

                case 7:
                  i = _context155.t0;
                  _context155.prev = 8;

                  if (this.remoteSDP) {
                    _context155.next = 11;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");

                case 11:
                  _t173 = this.peerConnection.getTransceivers().filter(function (t) {
                    return -1 !== _e132.indexOf(t.mid);
                  });

                  if (!(_t173.length !== _e132.length)) {
                    _context155.next = 14;
                    break;
                  }

                  throw new Error("Transceivers' length (".concat(_t173.length, ") doesn't match mids' length (").concat(_e132.length, ") when trying to call P2PConnection.stopSending."));

                case 14:
                  _t173.map(function (_e133) {
                    var t;
                    _e133.direction = "inactive", null === (t = _e133.stop) || void 0 === t || t.call(_e133);
                  });

                  _context155.next = 17;
                  return this.peerConnection.createOffer();

                case 17:
                  _n79 = _context155.sent;
                  _s43 = this.logSDPExchange(_n79.sdp || "", "offer", "local", "stopSending");
                  _context155.next = 21;
                  return this.peerConnection.setLocalDescription(_n79);

                case 21:
                  this.remoteSDP.stopReceiving(_e132);
                  _r22 = this.remoteSDP.toString();
                  null == _s43 || _s43(_r22);
                  _context155.next = 26;
                  return this.setRemoteDescription({
                    type: "answer",
                    sdp: _r22
                  });

                case 26:
                  _context155.next = 31;
                  break;

                case 28:
                  _context155.prev = 28;
                  _context155.t1 = _context155["catch"](8);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(_context155.t1.toString()));

                case 31:
                  _context155.prev = 31;
                  i && i();
                  return _context155.finish(31);

                case 34:
                case "end":
                  return _context155.stop();
              }
            }
          }, _callee155, this, [[8, 28, 31, 34]]);
        }));

        function stopSending(_x244, _x245) {
          return _stopSending.apply(this, arguments);
        }

        return stopSending;
      }()
    }, {
      key: "receive",
      value: function () {
        var _receive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee156(_e135, t, i, n) {
          var _this$remoteSDP$send, _s44, _r23, _t174, _i99, _n80, _r24, _o18;

          return _regeneratorRuntime.wrap(function _callee156$(_context156) {
            while (1) {
              switch (_context156.prev = _context156.next) {
                case 0:
                  _context156.prev = 0;

                  if (this.remoteSDP) {
                    _context156.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.receive ".concat(_e135, " before remoteSDP created."));

                case 3:
                  _this$remoteSDP$send = this.remoteSDP.send(_e135, t, i, n), _s44 = _this$remoteSDP$send.mid, _r23 = _this$remoteSDP$send.needExchangeSDP;

                  if (!_r23) {
                    _context156.next = 18;
                    break;
                  }

                  _t174 = this.remoteSDP.toString(), _i99 = this.logSDPExchange(_t174, "offer", "remote", "receive");
                  _context156.next = 8;
                  return this.setRemoteDescription({
                    type: "offer",
                    sdp: _t174
                  });

                case 8:
                  _context156.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _n80 = _context156.sent;
                  _r24 = this.mungReceiveAnswerSDP(_n80.sdp, _s44, _e135);
                  null == _i99 || _i99(_r24 || "");
                  _context156.next = 15;
                  return this.peerConnection.setLocalDescription({
                    type: "answer",
                    sdp: _r24
                  });

                case 15:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(_e135, " by exchanging SDP."));
                  _context156.next = 19;
                  break;

                case 18:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(_e135, " no need to exchange SDP."));

                case 19:
                  _o18 = this.peerConnection.getTransceivers().find(function (_e136) {
                    return _e136.mid === _s44;
                  });

                  if (!(!_o18 || null === _o18.mid)) {
                    _context156.next = 22;
                    break;
                  }

                  throw new Error("Cannot get transceiver after setLocalDescription.");

                case 22:
                  return _context156.abrupt("return", {
                    track: _o18.receiver.track,
                    mid: _o18.mid,
                    transceiver: _o18
                  });

                case 25:
                  _context156.prev = 25;
                  _context156.t0 = _context156["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context156.t0.toString()));

                case 28:
                case "end":
                  return _context156.stop();
              }
            }
          }, _callee156, this, [[0, 25]]);
        }));

        function receive(_x246, _x247, _x248, _x249) {
          return _receive.apply(this, arguments);
        }

        return receive;
      }()
    }, {
      key: "mockReceive",
      value: function () {
        var _mockReceive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee157(_e138, t, i, n) {
          var _this$remoteSDP$send2, _s45, _r25, _t175, _i100, _n81, _r26;

          return _regeneratorRuntime.wrap(function _callee157$(_context157) {
            while (1) {
              switch (_context157.prev = _context157.next) {
                case 0:
                  _context157.prev = 0;

                  if (this.remoteSDP) {
                    _context157.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.receive ".concat(_e138, " before remoteSDP created."));

                case 3:
                  _this$remoteSDP$send2 = this.remoteSDP.send(_e138, t, i, n), _s45 = _this$remoteSDP$send2.mid, _r25 = _this$remoteSDP$send2.needExchangeSDP;

                  if (!_r25) {
                    _context157.next = 18;
                    break;
                  }

                  _t175 = this.remoteSDP.toString(), _i100 = this.logSDPExchange(_t175, "offer", "remote", "receive");
                  _context157.next = 8;
                  return this.setRemoteDescription({
                    type: "offer",
                    sdp: _t175
                  });

                case 8:
                  _context157.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _n81 = _context157.sent;
                  _r26 = this.mungReceiveAnswerSDP(_n81.sdp, _s45, _e138);
                  null == _i100 || _i100(_r26 || "");
                  _context157.next = 15;
                  return this.peerConnection.setLocalDescription({
                    type: "answer",
                    sdp: _r26
                  });

                case 15:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(_e138, " by exchanging SDP."));
                  _context157.next = 19;
                  break;

                case 18:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(_e138, " no need to exchange SDP."));

                case 19:
                  _context157.next = 24;
                  break;

                case 21:
                  _context157.prev = 21;
                  _context157.t0 = _context157["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context157.t0.toString()));

                case 24:
                case "end":
                  return _context157.stop();
              }
            }
          }, _callee157, this, [[0, 21]]);
        }));

        function mockReceive(_x250, _x251, _x252, _x253) {
          return _mockReceive.apply(this, arguments);
        }

        return mockReceive;
      }()
    }, {
      key: "stopReceiving",
      value: function () {
        var _stopReceiving = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee158(_e140) {
          var _t176, i, _n82;

          return _regeneratorRuntime.wrap(function _callee158$(_context158) {
            while (1) {
              switch (_context158.prev = _context158.next) {
                case 0:
                  _context158.prev = 0;

                  if (this.remoteSDP) {
                    _context158.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");

                case 3:
                  this.remoteSDP.stopSending(_e140);
                  _t176 = this.remoteSDP.toString(), i = this.logSDPExchange(_t176, "offer", "remote", "stopReceiving");
                  _context158.next = 7;
                  return this.setRemoteDescription({
                    type: "offer",
                    sdp: _t176
                  });

                case 7:
                  _context158.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n82 = _context158.sent;
                  null == i || i(_n82.sdp || "");
                  _context158.next = 13;
                  return this.peerConnection.setLocalDescription(_n82);

                case 13:
                  _context158.next = 18;
                  break;

                case 15:
                  _context158.prev = 15;
                  _context158.t0 = _context158["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(_context158.t0.toString()));

                case 18:
                case "end":
                  return _context158.stop();
              }
            }
          }, _callee158, this, [[0, 15]]);
        }));

        function stopReceiving(_x254) {
          return _stopReceiving.apply(this, arguments);
        }

        return stopReceiving;
      }()
    }, {
      key: "restartICE",
      value: function () {
        var _restartICE2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee159(t) {
          var _e196, _mL, _t177, _e197, _mL2, _t178;

          return _regeneratorRuntime.wrap(function _callee159$(_context159) {
            while (1) {
              switch (_context159.prev = _context159.next) {
                case 0:
                  _context159.prev = 0;

                  if (!(this.store.p2pTransport === bC.Auto && (this.store.p2pTransport = bC.SdRtn, wA().supportPCSetConfiguration && this.peerConnection.setConfiguration(e.resolvePCConfiguration(this.spec, this.store.p2pTransport))), this.restartCnt > 3 && (this.restartCnt = 0, wA().supportPCSetConfiguration && this.peerConnection.setConfiguration(e.resolvePCConfiguration(this.spec, this.store.p2pTransport, ++this.curTurnServerIndex))), !t)) {
                    _context159.next = 15;
                    break;
                  }

                  this.restartCnt++, this.isReady = !1;
                  _context159.next = 5;
                  return this.peerConnection.createOffer({
                    iceRestart: !0
                  });

                case 5:
                  _e196 = _context159.sent;

                  if (_e196.sdp) {
                    _context159.next = 8;
                    break;
                  }

                  throw new Error("Cannot restartICE because restart offer SDP does not exist.");

                case 8:
                  _mL = mL(_e196.sdp), _t177 = _mL.iceParameters;
                  this.store.descriptionStart();
                  _context159.t0 = this.direction === vI.SEND_ONLY;

                  if (!_context159.t0) {
                    _context159.next = 14;
                    break;
                  }

                  _context159.next = 14;
                  return this.peerConnection.setLocalDescription(_e196);

                case 14:
                  return _context159.abrupt("return", _t177);

                case 15:
                  if (this.remoteSDP) {
                    _context159.next = 17;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");

                case 17:
                  if (!(this.remoteSDP.restartICE(t), this.store.descriptionStart(), this.direction === vI.RECEIVE_ONLY)) {
                    _context159.next = 30;
                    break;
                  }

                  this.restartCnt++;
                  _context159.next = 21;
                  return this.setRemoteDescription({
                    type: "offer",
                    sdp: this.remoteSDP.toString()
                  });

                case 21:
                  _context159.next = 23;
                  return this.peerConnection.createAnswer();

                case 23:
                  _e197 = _context159.sent;

                  if (_e197.sdp) {
                    _context159.next = 26;
                    break;
                  }

                  throw new Error("Cannot get answer sdp when trying to iceRestart.");

                case 26:
                  _mL2 = mL(_e197.sdp), _t178 = _mL2.iceParameters;
                  _context159.next = 29;
                  return this.peerConnection.setLocalDescription(_e197);

                case 29:
                  return _context159.abrupt("return", _t178);

                case 30:
                  _context159.next = 32;
                  return this.setRemoteDescription({
                    type: "answer",
                    sdp: this.remoteSDP.toString()
                  });

                case 32:
                  this.isReady = !0;
                  _context159.next = 38;
                  break;

                case 35:
                  _context159.prev = 35;
                  _context159.t1 = _context159["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(_context159.t1.toString()));

                case 38:
                case "end":
                  return _context159.stop();
              }
            }
          }, _callee159, this, [[0, 35]]);
        }));

        function restartICE(_x255) {
          return _restartICE2.apply(this, arguments);
        }

        return restartICE;
      }()
    }, {
      key: "close",
      value: function close() {
        var _e145;

        this.peerConnection.close(), this.peerConnection.onicecandidate = null, null === (_e145 = this.onConnectionStateChange) || void 0 === _e145 || _e145.call(this, "closed"), this.tryUnbindTransportEvents(), this.unbindPCEvents(), this.unbindStatsEvents(), this.transport = void 0, this.statsFilter.destroy();
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return this.statsFilter.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(_e146) {
        return this.statsFilter.getVideoIsReady(_e146);
      }
    }, {
      key: "updateEncoderConfig",
      value: function () {
        var _updateEncoderConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee160(_e147, t) {
          var i, _n83, _s46, _r27;

          return _regeneratorRuntime.wrap(function _callee160$(_context160) {
            while (1) {
              switch (_context160.prev = _context160.next) {
                case 0:
                  _context160.prev = 0;

                  if (this.remoteSDP) {
                    _context160.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");

                case 3:
                  _context160.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  i = _context160.sent;
                  _n83 = this.mungSendOfferSDP(i.sdp, [t], [_e147]);
                  this.remoteSDP.updateRecvMedia(_e147, t);
                  _s46 = this.remoteSDP.toString(), _r27 = this.logSDPExchange(_n83, "offer", "local", "updateEncoderConfig");
                  _context160.next = 11;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _n83
                  });

                case 11:
                  null == _r27 || _r27(_s46);
                  _context160.next = 14;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s46
                  });

                case 14:
                  _context160.next = 19;
                  break;

                case 16:
                  _context160.prev = 16;
                  _context160.t0 = _context160["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, _context160.t0.toString());

                case 19:
                case "end":
                  return _context160.stop();
              }
            }
          }, _callee160, this, [[0, 16]]);
        }));

        function updateEncoderConfig(_x256, _x257) {
          return _updateEncoderConfig.apply(this, arguments);
        }

        return updateEncoderConfig;
      }()
    }, {
      key: "updateSendParameters",
      value: function () {
        var _updateSendParameters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee161(_e149, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee161$(_context161) {
            while (1) {
              switch (_context161.prev = _context161.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid === _e149;
                  });
                  _context161.t0 = 1 === i.length;

                  if (!_context161.t0) {
                    _context161.next = 12;
                    break;
                  }

                  if (!this.isVP8Simulcast(t)) {
                    _context161.next = 10;
                    break;
                  }

                  _context161.t1 = RT();

                  if (_context161.t1) {
                    _context161.next = 8;
                    break;
                  }

                  _context161.next = 8;
                  return this.applySimulcastEncodings(i, [t]);

                case 8:
                  _context161.next = 12;
                  break;

                case 10:
                  _context161.next = 12;
                  return this.applySendEncodings(i, [t]);

                case 12:
                case "end":
                  return _context161.stop();
              }
            }
          }, _callee161, this);
        }));

        function updateSendParameters(_x258, _x259) {
          return _updateSendParameters.apply(this, arguments);
        }

        return updateSendParameters;
      }()
    }, {
      key: "setStatsRemoteVideoIsReady",
      value: function setStatsRemoteVideoIsReady(_e150, t) {
        this.statsFilter.setVideoIsReady2(_e150, t);
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee162(_e151, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee162$(_context162) {
            while (1) {
              switch (_context162.prev = _context162.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().find(function (_e152) {
                    return _e152.mid === t;
                  });
                  _context162.t0 = i;

                  if (!_context162.t0) {
                    _context162.next = 5;
                    break;
                  }

                  _context162.next = 5;
                  return i.sender.replaceTrack(_e151._mediaStreamTrack);

                case 5:
                case "end":
                  return _context162.stop();
              }
            }
          }, _callee162, this);
        }));

        function replaceTrack(_x260, _x261) {
          return _replaceTrack2.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "getSelectedCandidatePair",
      value: function () {
        var _getSelectedCandidatePair2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee163() {
          var _e153, _t179, _t179$getSelectedCand, i, _n84;

          return _regeneratorRuntime.wrap(function _callee163$(_context163) {
            while (1) {
              switch (_context163.prev = _context163.next) {
                case 0:
                  _e153 = this.peerConnection.getReceivers();

                  if (!(_e153.length > 0 && _e153[0].transport && _e153[0].transport.iceTransport && _e153[0].transport.iceTransport.getSelectedCandidatePair && _e153[0].transport.iceTransport.getSelectedCandidatePair())) {
                    _context163.next = 4;
                    break;
                  }

                  _t179 = _e153[0].transport.iceTransport, _t179$getSelectedCand = _t179.getSelectedCandidatePair(), i = _t179$getSelectedCand.local, _n84 = _t179$getSelectedCand.remote;
                  return _context163.abrupt("return", {
                    local: UL(UL({}, XP), {}, {
                      candidateType: i.type,
                      protocol: i.protocol,
                      address: i.address,
                      port: i.port
                    }),
                    remote: UL(UL({}, XP), {}, {
                      candidateType: _n84.type,
                      protocol: _n84.protocol,
                      address: _n84.address,
                      port: _n84.port
                    })
                  });

                case 4:
                  return _context163.abrupt("return", this.statsFilter.getSelectedCandidatePair());

                case 5:
                case "end":
                  return _context163.stop();
              }
            }
          }, _callee163, this);
        }));

        function getSelectedCandidatePair() {
          return _getSelectedCandidatePair2.apply(this, arguments);
        }

        return getSelectedCandidatePair;
      }()
    }, {
      key: "bindPCEvents",
      value: function bindPCEvents() {
        var _this182 = this;

        this.peerConnection.oniceconnectionstatechange = function () {
          var _e154, t;

          bn(_e154 = ["connected", "completed"]).call(_e154, _this182.peerConnection.iceConnectionState) && (_this182.isReady = !1), null === (t = _this182.onICEConnectionStateChange) || void 0 === t || t.call(_this182, _this182.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = function () {
          var _e155;

          "connected" === _this182.peerConnection.connectionState && (_this182.restartCnt = 0), null === (_e155 = _this182.onConnectionStateChange) || void 0 === _e155 || _e155.call(_this182, _this182.peerConnection.connectionState);
        }, this.startICECandidate();
      }
    }, {
      key: "startICECandidate",
      value: function startICECandidate() {
        var _this183 = this;

        this.peerConnection.onicecandidate || (this.localCandidateCount = 0, this.peerConnection.onicecandidate = function (_e156) {
          if (_e156.candidate) {
            var t;
            if (_e156.candidate.candidate) _this183.localCandidateAddress = _e156.candidate.address, null === (t = _this183.onLocalCandidate) || void 0 === t || t.call(_this183, _e156.candidate.toJSON());
            _this183.localCandidateCount += 1;
          } else _this183.allCandidatesReceived = !0, YC.debug("[".concat(_this183.store.clientId, "] [pc-").concat(_this183.store.p2pId, "] local candidate count"), _this183.localCandidateCount);
        });
      }
    }, {
      key: "unbindPCEvents",
      value: function unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
    }, {
      key: "tryBindTransportEvents",
      value: function tryBindTransportEvents(_e161) {
        var _this184 = this;

        if (_e161) {
          this.transport = _e161, _e161.onstatechange = function () {
            var t;
            null != _e161 && _e161.state && (null === (t = _this184.onDTLSTransportStateChange) || void 0 === t || t.call(_this184, _e161.state));
          }, _e161.onerror = function (_e162) {
            var t;
            null === (t = _this184.onDTLSTransportError) || void 0 === t || t.call(_this184, "error" in _e162 ? _e162.error : _e162);
          };
          var _t180 = _e161.iceTransport;
          _t180 && (_t180.onstatechange = function () {
            var t = null == _e161 ? void 0 : _e161.iceTransport.state;
            var i;
            t && (null === (i = _this184.onICETransportStateChange) || void 0 === i || i.call(_this184, t));
          }, _t180.getSelectedCandidatePair && (_t180.onselectedcandidatepairchange = function () {
            if (_t180.getSelectedCandidatePair()) {
              var _t180$getSelectedCand = _t180.getSelectedCandidatePair(),
                  _e198 = _t180$getSelectedCand.local,
                  i = _t180$getSelectedCand.remote;

              YC.info("[".concat(_this184.store.clientId, "] [pc-").concat(_this184.store.p2pId, "] selectedcandidatepairchange: local ").concat(JSON.stringify({
                candidateType: _e198.type,
                protocol: _e198.protocol
              }), ", remote ").concat(JSON.stringify({
                candidateType: i.type,
                protocol: i.protocol,
                address: i.address,
                port: i.port
              }), " )"));
            }
          }));
        }
      }
    }, {
      key: "tryUnbindTransportEvents",
      value: function tryUnbindTransportEvents() {
        this.transport && (this.transport.onstatechange = null, this.transport.onerror = null, this.transport.iceTransport && (this.transport.iceTransport.onstatechange = null));
      }
    }, {
      key: "updateRtpSenderEncodings",
      value: function () {
        var _updateRtpSenderEncodings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee164(_e164, t) {
          var i, n, s, r, _e164$_encoderConfig, _t181, _i101, _n85, o, _e199, a, c;

          return _regeneratorRuntime.wrap(function _callee164$(_context164) {
            while (1) {
              switch (_context164.prev = _context164.next) {
                case 0:
                  if (!t) {
                    t = this.peerConnection.getSenders().find(function (t) {
                      return t.track === _e164._mediaStreamTrack;
                    });
                  }

                  if (t) {
                    _context164.next = 3;
                    break;
                  }

                  return _context164.abrupt("return", YC.warn("[".concat(_e164.getTrackId(), "] no rtpSender found}")));

                case 3:
                  if (!this.isVP8Simulcast(_e164)) {
                    _context164.next = 5;
                    break;
                  }

                  return _context164.abrupt("return", YC.warn("[updateRtpSenderEncodings] Track is VP8 simulcast, please apply simulcast encodings"));

                case 5:
                  if (wA().supportSetRtpSenderParameters) {
                    _context164.next = 7;
                    break;
                  }

                  return _context164.abrupt("return", YC.warn("[updateRtpSenderEncodings] Browser not support set rtp-sender parameters"));

                case 7:
                  n = {}, s = {};
                  _context164.t0 = _e164._optimizationMode;
                  _context164.next = _context164.t0 === "motion" ? 11 : _context164.t0 === "detail" ? 13 : 15;
                  break;

                case 11:
                  n.degradationPreference = "maintain-framerate";
                  return _context164.abrupt("break", 16);

                case 13:
                  n.degradationPreference = "maintain-resolution";
                  return _context164.abrupt("break", 16);

                case 15:
                  n.degradationPreference = "balanced";

                case 16:
                  if (_e164._encoderConfig) {
                    _e164$_encoderConfig = _e164._encoderConfig, _t181 = _e164$_encoderConfig.bitrateMax, _i101 = _e164$_encoderConfig.frameRate, _n85 = _e164$_encoderConfig.scaleResolutionDownBy;
                    _t181 && (s.maxBitrate = 1e3 * _t181), bn(r = _e164._hints).call(r, YA.LOW_STREAM) && (_i101 && (s.maxFramerate = yy(_i101)), _n85 && _n85 >= 1 && (s.scaleResolutionDownBy = _n85));
                  }

                  if (DC("DSCP_TYPE") && kT()) {
                    _e199 = DC("DSCP_TYPE");
                    bn(o = ["very-low", "low", "medium", "high"]).call(o, _e199) && (s.networkPriority = _e199);
                  }

                  a = t.getParameters(), c = null === (i = a.encodings) || void 0 === i ? void 0 : i[0];
                  RT() && !c && (n.encodings = [s]);
                  c && Object.assign(c, s);
                  Object.assign(a, n);
                  YC.debug("[".concat(_e164.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(a.encodings)));
                  _context164.next = 25;
                  return t.setParameters(a);

                case 25:
                case "end":
                  return _context164.stop();
              }
            }
          }, _callee164, this);
        }));

        function updateRtpSenderEncodings(_x262, _x263) {
          return _updateRtpSenderEncodings.apply(this, arguments);
        }

        return updateRtpSenderEncodings;
      }()
    }, {
      key: "applySendEncodings",
      value: function () {
        var _applySendEncodings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee165(_e166, t) {
          var i, _n86, _s47;

          return _regeneratorRuntime.wrap(function _callee165$(_context165) {
            while (1) {
              switch (_context165.prev = _context165.next) {
                case 0:
                  _context165.prev = 0;

                  if (wA().supportSetRtpSenderParameters) {
                    _context165.next = 3;
                    break;
                  }

                  return _context165.abrupt("return");

                case 3:
                  if (!(_e166.length !== t.length)) {
                    _context165.next = 5;
                    break;
                  }

                  return _context165.abrupt("return");

                case 5:
                  i = 0;

                case 6:
                  if (!(i < _e166.length)) {
                    _context165.next = 15;
                    break;
                  }

                  _n86 = _e166[i], _s47 = t[i];
                  _context165.t0 = _s47 instanceof Nw && !this.isVP8Simulcast(_s47);

                  if (!_context165.t0) {
                    _context165.next = 12;
                    break;
                  }

                  _context165.next = 12;
                  return this.updateRtpSenderEncodings(_s47, _n86.sender);

                case 12:
                  i++;
                  _context165.next = 6;
                  break;

                case 15:
                  _context165.next = 20;
                  break;

                case 17:
                  _context165.prev = 17;
                  _context165.t1 = _context165["catch"](0);
                  YC.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));

                case 20:
                case "end":
                  return _context165.stop();
              }
            }
          }, _callee165, this, [[0, 17]]);
        }));

        function applySendEncodings(_x264, _x265) {
          return _applySendEncodings.apply(this, arguments);
        }

        return applySendEncodings;
      }()
    }, {
      key: "mungSendOfferSDP",
      value: function mungSendOfferSDP(_e168, t, i) {
        var _this185 = this;

        var n = YP.parse(_e168);
        return t.forEach(function (_e169, t) {
          var s = i[t],
              r = n.mediaDescriptions.find(function (_e170) {
            return _e170.attributes.mid === s;
          });
          r && (SL(r, _e169), yL(r, _e169, _this185.store.codec));
        }), YP.print(n);
      }
    }, {
      key: "bindStatsEvents",
      value: function bindStatsEvents() {
        var _this186 = this;

        this.statsFilter.onFirstAudioReceived = function (_e171) {
          var t;
          null === (t = _this186.onFirstAudioReceived) || void 0 === t || t.call(_this186, _e171);
        }, this.statsFilter.onFirstVideoReceived = function (_e172) {
          var t;
          null === (t = _this186.onFirstVideoReceived) || void 0 === t || t.call(_this186, _e172);
        }, this.statsFilter.onFirstAudioDecoded = function (_e173) {
          var t;
          null === (t = _this186.onFirstAudioDecoded) || void 0 === t || t.call(_this186, _e173);
        }, this.statsFilter.onFirstVideoDecoded = function (_e174, t, i) {
          var n;
          null === (n = _this186.onFirstVideoDecoded) || void 0 === n || n.call(_this186, _e174, t, i);
        }, this.statsFilter.onSelectedLocalCandidateChanged = function (_e175, t) {
          var i;
          null === (i = _this186.onSelectedLocalCandidateChanged) || void 0 === i || i.call(_this186, _e175, t);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = function (_e176, t) {
          var i;
          null === (i = _this186.onSelectedRemoteCandidateChanged) || void 0 === i || i.call(_this186, _e176, t);
        }, this.statsFilter.onFirstVideoDecodedTimeout = function (_e177) {
          var t;
          null === (t = _this186.onFirstVideoDecodedTimeout) || void 0 === t || t.call(_this186, _e177);
        };
      }
    }, {
      key: "unbindStatsEvents",
      value: function unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0, this.statsFilter.onFirstVideoDecodedTimeout = void 0;
      }
    }, {
      key: "applySimulcastForFirefox",
      value: function () {
        var _applySimulcastForFirefox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee166(_e178, t) {
          var _a9, i, n, s, r, o, c, _d7, _e200, _t182, _i102;

          return _regeneratorRuntime.wrap(function _callee166$(_context166) {
            while (1) {
              switch (_context166.prev = _context166.next) {
                case 0:
                  if (!(_e178.length === t.length)) {
                    _context166.next = 13;
                    break;
                  }

                  _a9 = 0;

                case 2:
                  if (!(_a9 < _e178.length)) {
                    _context166.next = 13;
                    break;
                  }

                  c = _e178[_a9], _d7 = t[_a9];

                  if (!(_d7 instanceof Nw && !bn(i = _d7._hints).call(i, YA.LOW_STREAM) && null !== (n = _d7._encoderConfig) && void 0 !== n && n.bitrateMax && (null === (s = _d7._encoderConfig) || void 0 === s ? void 0 : s.bitrateMax) > 200 && null !== (r = _d7._scalabilityMode) && void 0 !== r && r.numSpatialLayers && (null === (o = _d7._scalabilityMode) || void 0 === o ? void 0 : o.numSpatialLayers) > 1 && "vp8" === this.store.codec)) {
                    _context166.next = 10;
                    break;
                  }

                  _e200 = {}, _t182 = {
                    high: 1e3 * (_d7._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _e200.encodings = [{
                    rid: "m",
                    active: !0,
                    maxBitrate: _t182.medium,
                    scaleResolutionDownBy: 4
                  }, {
                    rid: "h",
                    active: !0,
                    maxBitrate: _t182.high
                  }];
                  _i102 = c.sender.getParameters();
                  _context166.next = 10;
                  return c.sender.setParameters(Object.assign(_i102, _e200));

                case 10:
                  _a9++;
                  _context166.next = 2;
                  break;

                case 13:
                case "end":
                  return _context166.stop();
              }
            }
          }, _callee166, this);
        }));

        function applySimulcastForFirefox(_x266, _x267) {
          return _applySimulcastForFirefox.apply(this, arguments);
        }

        return applySimulcastForFirefox;
      }()
    }, {
      key: "applySimulcastEncodings",
      value: function () {
        var _applySimulcastEncodings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee167(_e180, t) {
          var i, _n87, _t183, _s48, _r28, _o19;

          return _regeneratorRuntime.wrap(function _callee167$(_context167) {
            while (1) {
              switch (_context167.prev = _context167.next) {
                case 0:
                  if (!(!RT() && _e180.length === t.length)) {
                    _context167.next = 13;
                    break;
                  }

                  i = 0;

                case 2:
                  if (!(i < _e180.length)) {
                    _context167.next = 13;
                    break;
                  }

                  _n87 = t[i];

                  if (!(_n87 instanceof Nw && this.isVP8Simulcast(_n87))) {
                    _context167.next = 10;
                    break;
                  }

                  _t183 = _e180[i], _s48 = {}, _r28 = {
                    high: 1e3 * (_n87._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _s48.encodings = [{
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "high",
                    priority: "high",
                    maxBitrate: _r28.high
                  }, {
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "low",
                    priority: "low",
                    maxBitrate: _r28.medium,
                    scaleResolutionDownBy: 4
                  }];
                  _o19 = _t183.sender.getParameters();
                  _context167.next = 10;
                  return _t183.sender.setParameters(Object.assign(_o19, _s48));

                case 10:
                  i++;
                  _context167.next = 2;
                  break;

                case 13:
                case "end":
                  return _context167.stop();
              }
            }
          }, _callee167, this);
        }));

        function applySimulcastEncodings(_x268, _x269) {
          return _applySimulcastEncodings.apply(this, arguments);
        }

        return applySimulcastEncodings;
      }()
    }, {
      key: "isVP8Simulcast",
      value: function isVP8Simulcast(_e181) {
        var t, i, n, s, r;
        return !!(_e181 instanceof Nw && DC("SIMULCAST") && "vp8" === this.store.codec && !bn(t = _e181._hints).call(t, YA.LOW_STREAM) && null !== (i = _e181._encoderConfig) && void 0 !== i && i.bitrateMax && (null === (n = _e181._encoderConfig) || void 0 === n ? void 0 : n.bitrateMax) > 200 && null !== (s = _e181._scalabilityMode) && void 0 !== s && s.numSpatialLayers && (null === (r = _e181._scalabilityMode) || void 0 === r ? void 0 : r.numSpatialLayers) > 1);
      }
    }, {
      key: "logSDPExchange",
      value: function logSDPExchange(_e182, t, i, n) {
        var _this187 = this;

        if (DC("SDP_LOGGING")) return YC.upload("[".concat(this.store.clientId, "] exchanging ").concat(i, " ").concat(t, " SDP during P2PConnection.").concat(n, "\n"), _e182), "offer" === t ? function (_e183) {
          _this187.logSDPExchange(_e183, "answer", "local" === i ? "remote" : "local", n);
        } : void 0;
      }
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee168(_e184) {
          var _t184, i, _n88, _s49;

          return _regeneratorRuntime.wrap(function _callee168$(_context168) {
            while (1) {
              switch (_context168.prev = _context168.next) {
                case 0:
                  _context168.prev = 0;

                  if (this.remoteSDP) {
                    _context168.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");

                case 3:
                  _t184 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== _e184.indexOf(t.mid);
                  });

                  if (!(_t184.length !== _e184.length)) {
                    _context168.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t184.map(function (_e185) {
                    _e185.direction = "inactive";
                  });

                  _context168.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context168.sent;
                  _n88 = this.logSDPExchange(i.sdp || "", "offer", "local", "muteLocal");
                  _context168.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.muteRemote(_e184);
                  _s49 = this.remoteSDP.toString();
                  null == _n88 || _n88(_s49);
                  _context168.next = 18;
                  return this.setRemoteDescription({
                    type: "answer",
                    sdp: _s49
                  });

                case 18:
                  _context168.next = 23;
                  break;

                case 20:
                  _context168.prev = 20;
                  _context168.t0 = _context168["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(_context168.t0.toString()));

                case 23:
                case "end":
                  return _context168.stop();
              }
            }
          }, _callee168, this, [[0, 20]]);
        }));

        function muteLocal(_x270) {
          return _muteLocal2.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee170(_e187) {
          var _t185, i, _n89, _s50;

          return _regeneratorRuntime.wrap(function _callee170$(_context170) {
            while (1) {
              switch (_context170.prev = _context170.next) {
                case 0:
                  _context170.prev = 0;

                  if (this.remoteSDP) {
                    _context170.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");

                case 3:
                  _t185 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== _e187.indexOf(t.mid);
                  });

                  if (!(_t185.length !== _e187.length)) {
                    _context170.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t185.map( /*#__PURE__*/function () {
                    var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee169(_e188) {
                      return _regeneratorRuntime.wrap(function _callee169$(_context169) {
                        while (1) {
                          switch (_context169.prev = _context169.next) {
                            case 0:
                              _e188.direction = "sendonly";

                            case 1:
                            case "end":
                              return _context169.stop();
                          }
                        }
                      }, _callee169);
                    }));

                    return function (_x272) {
                      return _ref55.apply(this, arguments);
                    };
                  }());

                  _context170.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context170.sent;
                  _n89 = this.logSDPExchange(i.sdp || "", "offer", "local", "unmuteLocal");
                  _context170.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.unmuteRemote(_e187);
                  _s50 = this.remoteSDP.toString();
                  null == _n89 || _n89(_s50);
                  _context170.next = 18;
                  return this.setRemoteDescription({
                    type: "answer",
                    sdp: _s50
                  });

                case 18:
                  _context170.next = 23;
                  break;

                case 20:
                  _context170.prev = 20;
                  _context170.t0 = _context170["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(_context170.t0.toString()));

                case 23:
                case "end":
                  return _context170.stop();
              }
            }
          }, _callee170, this, [[0, 20]]);
        }));

        function unmuteLocal(_x271) {
          return _unmuteLocal2.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "getRemoteSSRC",
      value: function () {
        var _getRemoteSSRC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee171(_e190, t) {
          var i, n, s, _i103;

          return _regeneratorRuntime.wrap(function _callee171$(_context171) {
            while (1) {
              switch (_context171.prev = _context171.next) {
                case 0:
                  if (!(t = null !== (i = t) && void 0 !== i ? i : null === (n = this.currentRemoteDescription) || void 0 === n ? void 0 : n.sdp)) {
                    _context171.next = 3;
                    break;
                  }

                  _i103 = null === (s = YP.parse(t).mediaDescriptions.find(function (t) {
                    return t.attributes.mid === _e190;
                  })) || void 0 === s ? void 0 : s.attributes.ssrcs;
                  return _context171.abrupt("return", null == _i103 ? void 0 : _i103[0].ssrcId);

                case 3:
                case "end":
                  return _context171.stop();
              }
            }
          }, _callee171, this);
        }));

        function getRemoteSSRC(_x273, _x274) {
          return _getRemoteSSRC.apply(this, arguments);
        }

        return getRemoteSSRC;
      }()
    }, {
      key: "setRemoteDescription",
      value: function () {
        var _setRemoteDescription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee172(_e191) {
          var t;
          return _regeneratorRuntime.wrap(function _callee172$(_context172) {
            while (1) {
              switch (_context172.prev = _context172.next) {
                case 0:
                  _context172.next = 2;
                  return this.peerConnection.setRemoteDescription(_e191);

                case 2:
                  bn(t = ["connected", "completed"]).call(t, this.peerConnection.iceConnectionState) || (this.isReady = !0, this.addRemoteCandidate());

                case 3:
                case "end":
                  return _context172.stop();
              }
            }
          }, _callee172, this);
        }));

        function setRemoteDescription(_x275) {
          return _setRemoteDescription.apply(this, arguments);
        }

        return setRemoteDescription;
      }()
    }, {
      key: "mungReceiveAnswerSDP",
      value: function mungReceiveAnswerSDP(_e192, t, i) {
        var n = YP.parse(_e192),
            s = n.mediaDescriptions.find(function (_e193) {
          return _e193.attributes.mid === t;
        });
        return s && (i === hv.AUDIO && "audio" === s.media.mediaType && NL(s), this.useXR && DL(n)), YP.print(n);
      }
    }], [{
      key: "resolvePCConfiguration",
      value: function resolvePCConfiguration(t, i) {
        var _s$iceServers, _s$iceServers2;

        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        var s = {
          iceServers: []
        };
        var r;
        t.iceServers ? s.iceServers = t.iceServers : t.turnServer && "off" !== t.turnServer.mode && (_g(t.turnServer.servers) ? s.iceServers = t.turnServer.servers : (s.iceServers && (_s$iceServers = s.iceServers).push.apply(_s$iceServers, _toConsumableArray(e.turnServerConfigToIceServers(t.turnServer.servers, i, n))), DC("USE_TURN_SERVER_OF_GATEWAY") && s.iceServers && t.turnServer.serversFromGateway && (_s$iceServers2 = s.iceServers).push.apply(_s$iceServers2, _toConsumableArray(e.turnServerConfigToIceServers(t.turnServer.serversFromGateway, i, n))), bn(r = [bC.Relay, bC.SdRtn]).call(r, i) && (s.iceTransportPolicy = "relay"), DC("FORCE_TURN_TCP") ? s.iceTransportPolicy = "relay" : t.turnServer.servers.concat(t.turnServer.serversFromGateway || []).forEach(function (_e157) {
          _e157.forceturn && (s.iceTransportPolicy = "relay");
        })));
        return DC("ENABLE_ENCODED_TRANSFORM") && wA().supportWebRTCEncodedTransform && (s.encodedInsertableStreams = !0), YC.debug("P2PConnection p2pTransport is ".concat(i)), s;
      }
    }, {
      key: "turnServerConfigToIceServers",
      value: function turnServerConfigToIceServers(_e158, t) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;

        var n = [],
            s = _e158.filter(function (_e159) {
          return _e159.tcpport;
        });

        YC.debug("P2PConnection turnServers is ".concat(s, ", current index is ").concat(i));
        var r = s.length > i ? s[i] : s[0];

        switch (t) {
          case bC.SdRtn:
            var _t186 = _e158.filter(function (_e160) {
              var t;
              return bn(t = _e160.username).call(t, "glb:") && _e160.turnServerURL == _e160.turnServerURL;
            }),
                _s51 = _t186.length > i ? _t186[i] : _t186[0];

            _s51 && (n.push({
              username: _s51.username,
              credential: _s51.password,
              credentialType: "password",
              urls: "turn:".concat(Iy(_s51.turnServerURL), ":").concat(_s51.tcpport, "?transport=udp")
            }), n.push({
              username: _s51.username,
              credential: _s51.password,
              credentialType: "password",
              urls: "turns:".concat(Iy(_s51.turnServerURL), ":").concat(_s51.tcpport, "?transport=tcp")
            }));
            break;

          case bC.Relay:
            r && (n.push({
              username: r.username,
              credential: r.password,
              credentialType: "password",
              urls: "turn:".concat(r.turnServerURL, ":").concat(r.tcpport, "?transport=udp")
            }), n.push({
              username: r.username,
              credential: r.password,
              credentialType: "password",
              urls: "turns:".concat(Iy(r.turnServerURL), ":").concat(r.tcpport, "?transport=tcp")
            }));
            break;

          default:
            r && (n.push({
              username: r.username,
              credential: r.password,
              credentialType: "password",
              urls: "turn:".concat(r.turnServerURL, ":").concat(r.tcpport, "?transport=udp")
            }), n.push({
              username: r.username,
              credential: r.password,
              credentialType: "password",
              urls: "turns:".concat(Iy(r.turnServerURL), ":").concat(r.tcpport, "?transport=tcp")
            }), n.push({
              username: r.username,
              credential: r.password,
              credentialType: "password",
              urls: "stun:".concat(r.turnServerURL, ":").concat(r.tcpport)
            }));
        }

        return n;
      }
    }]);

    return e;
  }(kv);

  function VL(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee173() {
      var e,
          i,
          s,
          r,
          o,
          _args173 = arguments;
      return _regeneratorRuntime.wrap(function _callee173$(_context173) {
        while (1) {
          switch (_context173.prev = _context173.next) {
            case 0:
              e = this.mutex;
              _context173.next = 3;
              return e.lock("From P2PConnection.".concat(t));

            case 3:
              i = _context173.sent;
              _context173.prev = 4;

              for (s = _args173.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args173[o];
              }

              _context173.next = 8;
              return n.apply(this, r);

            case 8:
              return _context173.abrupt("return", _context173.sent);

            case 9:
              _context173.prev = 9;
              i();
              return _context173.finish(9);

            case 12:
            case "end":
              return _context173.stop();
          }
        }
      }, _callee173, this, [[4,, 9, 12]]);
    })), i;
  }

  function FL(e, t) {
    var i = document.createElement("video"),
        n = document.createElement("canvas");
    i.setAttribute("style", "display:none"), n.setAttribute("style", "display:none"), i.setAttribute("muted", ""), i.muted = !0, i.setAttribute("autoplay", ""), i.autoplay = !0, i.setAttribute("playsinline", ""), n.width = yy(t.width), n.height = yy(t.height);
    var s = yy(t.framerate || 15);
    document.body.append(i), document.body.append(n);
    var r = e._mediaStreamTrack;
    i.srcObject = new MediaStream([r]), i.play();
    var o = n.getContext("2d");
    if (!o) throw new VI(xT.UNEXPECTED_ERROR, "can not get canvas context");
    var a = wA(),
        c = n.captureStream(a.supportRequestFrame ? 0 : s).getVideoTracks()[0];
    c.canvas || (c.canvas = n), n.startCapture = function () {
      if (!i) return n.stopCapture && n.stopCapture();

      if (i.paused && i.play(), i.videoHeight > 2 && i.videoWidth > 2) {
        var _e201 = i.videoWidth,
            _t187 = i.videoHeight / _e201,
            _s52 = n.width * _t187;

        Math.abs(_s52 - n.height) >= 2 && (YC.debug("adjust low stream resolution", "".concat(n.width, "x").concat(n.height, " -> ").concat(n.width, "x").concat(_s52)), n.height = _s52);
      }

      o.drawImage(i, 0, 0, n.width, n.height), c.requestFrame && c.requestFrame(), r !== e._mediaStreamTrack && (r = e._mediaStreamTrack, i.srcObject = new MediaStream([r]));
    }, n.stopCapture = vb(function () {
      return n.startCapture && n.startCapture();
    }, s);
    var d = c.stop;
    return c.stop = function () {
      d.call(c), i && (i.remove(), i.srcObject = null, i = null), n && (n.width = 0, n.remove(), n.stopCapture && n.stopCapture(), n.startCapture = void 0, n.stopCapture = void 0, n = null), YC.debug("clean low stream renderer");
    }, c;
  }

  var BL, jL, GL, WL, HL, KL, YL, qL, JL, zL, XL;
  UI([VL, xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], xL.prototype, "establish", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], xL.prototype, "connect", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, String]), xI("design:returntype", tT)], xL.prototype, "receive", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, String]), xI("design:returntype", tT)], xL.prototype, "mockReceive", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], xL.prototype, "stopReceiving", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], xL.prototype, "restartICE", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], xL.prototype, "close", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], xL.prototype, "updateEncoderConfig", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], xL.prototype, "updateSendParameters", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [_b, String]), xI("design:returntype", tT)], xL.prototype, "replaceTrack", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], xL.prototype, "muteLocal", null), UI([VL, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], xL.prototype, "unmuteLocal", null), function (e) {
    e[e.HEIGHT = 2033] = "HEIGHT", e[e.FRAME_RATE = 2034] = "FRAME_RATE", e[e.WIDTH = 2035] = "WIDTH";
  }(BL || (BL = {})), function (e) {
    e[e.HEIGHT = 2072] = "HEIGHT", e[e.FRAME_RATE = 2074] = "FRAME_RATE", e[e.WIDTH = 2076] = "WIDTH";
  }(jL || (jL = {})), function (e) {
    e[e.FRAME_RATE = 2002] = "FRAME_RATE", e[e.WIDTH = 2003] = "WIDTH", e[e.HEIGHT = 2004] = "HEIGHT", e[e.PACKAGE_LOST = 2005] = "PACKAGE_LOST", e[e.AVG_ENCODE = 2007] = "AVG_ENCODE", e[e.NACKS = 2009] = "NACKS", e[e.PLIS = 2010] = "PLIS", e[e.FIRS = 2011] = "FIRS", e[e.BITRATE = 2012] = "BITRATE", e[e.PACKAGE_RATE = 2031] = "PACKAGE_RATE", e[e.ADAPTATION = 2032] = "ADAPTATION", e[e.ACTUAL_ENCODED = 2060] = "ACTUAL_ENCODED", e[e.BANDWIDTH = 2061] = "BANDWIDTH", e[e.RETRANSMIT = 2062] = "RETRANSMIT", e[e.TARGET_ENCODED = 2064] = "TARGET_ENCODED", e[e.TRANSMIT = 2066] = "TRANSMIT", e[e.FREEZE = 2082] = "FREEZE", e[e.DISABLED = 2095] = "DISABLED", e[e.PLAYER_STATUS = 2128] = "PLAYER_STATUS", e[e.QP_SUM = 2143] = "QP_SUM";
  }(GL || (GL = {})), function (e) {
    e[e.BITRATE = 2069] = "BITRATE", e[e.PACKAGE_LOST = 2070] = "PACKAGE_LOST", e[e.PACKAGE_RATE = 2071] = "PACKAGE_RATE", e[e.HEIGHT = 2073] = "HEIGHT", e[e.FRAME_RATE = 2075] = "FRAME_RATE", e[e.WIDTH = 2077] = "WIDTH";
  }(WL || (WL = {})), function (e) {
    e[e.JITTER = -1] = "JITTER", e[e.PACKAGE_LOST = 2014] = "PACKAGE_LOST", e[e.WIDTH = 2018] = "WIDTH", e[e.HEIGHT = 2019] = "HEIGHT", e[e.FRAME_RATE = 2020] = "FRAME_RATE", e[e.JITTER_BUFFER = 2023] = "JITTER_BUFFER", e[e.CURRENT_DELAY = 2024] = "CURRENT_DELAY", e[e.NACKS = 2026] = "NACKS", e[e.PLIS = 2027] = "PLIS", e[e.FIRS = 2028] = "FIRS", e[e.BITRATE = 2029] = "BITRATE", e[e.PACKAGE_RATE = 2078] = "PACKAGE_RATE", e[e.FREEZE = 2084] = "FREEZE", e[e.DISABLED = 2101] = "DISABLED", e[e.PLAYER_STATUS = 2129] = "PLAYER_STATUS", e[e.QP_SUM = 2144] = "QP_SUM", e[e.I_FRAME_DELAY = 2149] = "I_FRAME_DELAY";
  }(HL || (HL = {})), function (e) {
    e[e.FRAME_RATE_DECODE = 2021] = "FRAME_RATE_DECODE", e[e.FRAME_RATE_RENDER = 2022] = "FRAME_RATE_RENDER", e[e.FREEZE_TIME = 2109] = "FREEZE_TIME", e[e.FREEZE_TIME_RENDER = 2147] = "FREEZE_TIME_RENDER";
  }(KL || (KL = {})), function (e) {
    e[e.PCM_LEVEL = 2104] = "PCM_LEVEL";
  }(YL || (YL = {})), function (e) {
    e[e.PACKAGE_LOST = -1] = "PACKAGE_LOST", e[e.LEVEL = 2038] = "LEVEL", e[e.BITRATE = 2039] = "BITRATE", e[e.PACKAGE_RATE = 2040] = "PACKAGE_RATE", e[e.AEC_RETURN_LOSS = 2041] = "AEC_RETURN_LOSS", e[e.AEC_RETURN_LOSS_ENH = 2042] = "AEC_RETURN_LOSS_ENH", e[e.FREEZE = 2081] = "FREEZE", e[e.DISABLED = 2096] = "DISABLED";
  }(qL || (qL = {})), function (e) {
    e[e.BITRATE = 2044] = "BITRATE", e[e.PACKAGE_LOST = 2045] = "PACKAGE_LOST", e[e.PACKAGE_RATE = 2046] = "PACKAGE_RATE", e[e.CURRENT_DELAY = 2047] = "CURRENT_DELAY", e[e.JITTER_BUFFER = 2054] = "JITTER_BUFFER", e[e.JITTER = 2055] = "JITTER", e[e.FREEZE = 2083] = "FREEZE", e[e.DISABLED = 2102] = "DISABLED", e[e.PCM_LEVEL = 2105] = "PCM_LEVEL", e[e.PLAYER_STATUS = 2130] = "PLAYER_STATUS", e[e.CONCEALED_SAMPLES = 2148] = "CONCEALED_SAMPLES";
  }(JL || (JL = {})), function (e) {
    e[e.FREEZE_TIME = -1] = "FREEZE_TIME", e[e.LEVEL = 2043] = "LEVEL";
  }(zL || (zL = {})), function (e) {
    e[e.RTT = 2006] = "RTT", e[e.CONN_TYPE = 801] = "CONN_TYPE";
  }(XL || (XL = {}));
  var QL = 1e3,
      ZL = 3;

  function $L(e, t, i) {
    null != i && Number.isFinite(i) && (e[t] = Math.round(Math.max(0, i)));
  }

  function ek(e) {
    var _t188;

    var t = (_t188 = {}, _defineProperty(_t188, XL.CONN_TYPE, 0), _defineProperty(_t188, XL.RTT, e.rtt), _t188);

    switch (e.selectedCandidatePair.localCandidate.candidateType) {
      case "relay":
        {
          var i = e.selectedCandidatePair.localCandidate.relayProtocol;
          "udp" === i && (t[XL.CONN_TYPE] = 1), "tcp" === i && (t[XL.CONN_TYPE] = 3), "tls" === i && (t[XL.CONN_TYPE] = 4);
          break;
        }

      case "srflx":
        t[XL.CONN_TYPE] = 2;
    }

    return t;
  }

  var tk = /*#__PURE__*/function (_ig25) {
    _inherits(tk, _ig25);

    var _super56 = _createSuper(tk);

    function tk(e) {
      var _this188;

      _classCallCheck(this, tk);

      _this188 = _super56.call(this), nh(_assertThisInitialized(_this188), "store", void 0), nh(_assertThisInitialized(_this188), "uploadWRTCStatsTimer", void 0), nh(_assertThisInitialized(_this188), "uploadOutboundDenoiserStatsTimer", void 0), nh(_assertThisInitialized(_this188), "uploadExtStatsTimer", void 0), nh(_assertThisInitialized(_this188), "uploadExtUsageStatsTimer", void 0), nh(_assertThisInitialized(_this188), "uploadInboundExtStatsTimer", void 0), nh(_assertThisInitialized(_this188), "requestStats", void 0), nh(_assertThisInitialized(_this188), "requestTransportStats", void 0), nh(_assertThisInitialized(_this188), "requestLocalMedia", void 0), nh(_assertThisInitialized(_this188), "requestRemoteMedia", void 0), nh(_assertThisInitialized(_this188), "requestAllTracks", void 0), nh(_assertThisInitialized(_this188), "requestVideoIsReady", void 0), nh(_assertThisInitialized(_this188), "requestUploadStats", void 0), nh(_assertThisInitialized(_this188), "requestUpload", void 0), nh(_assertThisInitialized(_this188), "uploadOutboundStarted", !1), nh(_assertThisInitialized(_this188), "uploadInboundStarted", !1), nh(_assertThisInitialized(_this188), "uploadTransportStarted", !1), nh(_assertThisInitialized(_this188), "uploadExtensionUsageStarted", !1), nh(_assertThisInitialized(_this188), "lastRecvStats", void 0), nh(_assertThisInitialized(_this188), "lastSendStats", void 0), nh(_assertThisInitialized(_this188), "lastFullRecvStats", void 0), nh(_assertThisInitialized(_this188), "lastFullSendStats", void 0), nh(_assertThisInitialized(_this188), "needUploadRenderFreezeTime", !0), _this188.store = e;
      return _this188;
    }

    _createClass(tk, [{
      key: "uploadWRTCStats",
      value: function uploadWRTCStats(e) {
        if (!this.requestStats || !this.requestUploadStats) return;
        var t, i;

        if (this.uploadTransportStarted && (t = this.requestStats(), this.store.useP2P && (i = this.requestStats(!0))), !t && this.uploadOutboundStarted && (t = this.requestStats()), !i && this.uploadInboundStarted && (i = this.requestStats(!0)), t || i) {
          var _n90 = {};

          if (this.uploadTransportStarted && t) {
            var _s53 = this.getTransportStats(t, i, e);

            _s53 && (_n90.misc = [_s53]);
          }

          if (this.uploadOutboundStarted && t) {
            var _i104 = this.getOutboundStats(t, e ? this.lastSendStats : this.lastFullSendStats, e);

            _i104 && (_n90.outbound = [_i104]);
          }

          if (this.uploadInboundStarted && i) {
            var _t189 = this.getInboundStats(i, e ? this.lastRecvStats : this.lastFullRecvStats, e);

            _t189 && (_n90.inbound = _t189);
          }

          this.requestUploadStats(_n90);
        }

        this.lastRecvStats = i, this.lastSendStats = t, e || (this.lastFullRecvStats = i, this.lastFullSendStats = t);
      }
    }, {
      key: "startUploadWRTCStats",
      value: function startUploadWRTCStats() {
        var _this189 = this;

        if (this.uploadWRTCStatsTimer) return;
        var e = 1;
        this.uploadWRTCStatsTimer = window.setInterval(function () {
          if (!_this189.uploadTransportStarted && !_this189.uploadInboundStarted && !_this189.uploadOutboundStarted) return _this189.stopUploadWRTCStats();
          _this189.uploadWRTCStats(e !== ZL), ++e === ZL + 1 && (e = 1);
        }, QL);
      }
    }, {
      key: "stopUploadWRTCStats",
      value: function stopUploadWRTCStats() {
        window.clearInterval(this.uploadWRTCStatsTimer), this.uploadWRTCStatsTimer = void 0, this.lastSendStats && (this.lastSendStats.videoSend = [], this.lastSendStats.audioSend = [], this.lastSendStats = void 0), this.lastRecvStats && (this.lastRecvStats.videoRecv = [], this.lastRecvStats.audioRecv = [], this.lastRecvStats = void 0);
      }
    }, {
      key: "getTransportStats",
      value: function getTransportStats(e, t, i) {
        var _addition;

        if (!this.requestStats) return;
        if (i) return null == e.rtt ? void 0 : {
          addition: (_addition = {}, _defineProperty(_addition, XL.RTT, e.rtt), _defineProperty(_addition, XL.CONN_TYPE, void 0), _addition)
        };
        var n = ek(e);

        if (this.store.useP2P) {
          if (t) {
            var _e202 = ek(t);

            n[XL.CONN_TYPE] += _e202[XL.CONN_TYPE] << 3;
          }

          n[XL.CONN_TYPE] += 110;
        } else n[XL.CONN_TYPE] += 100;

        return {
          addition: n
        };
      }
    }, {
      key: "getOutboundStats",
      value: function getOutboundStats(e, t, i) {
        if (!this.requestUploadStats || !this.requestLocalMedia) return;
        var n = this.requestLocalMedia();
        if (!n || 0 === n.length) return;
        var s, r, o;
        return n.forEach(function (n) {
          var _n91 = _slicedToArray(n, 2),
              a = _n91[0],
              _n91$ = _n91[1],
              c = _n91$.track,
              d = _n91$.ssrcs;

          switch (a) {
            case Ev.LocalVideoLowTrack:
            case Ev.LocalVideoTrack:
              if (a === Ev.LocalVideoTrack) {
                var _n92 = function (e, t, i, n, s) {
                  var r = t.videoSend.find(function (t) {
                    return t.ssrc === e;
                  });
                  if (!r) return;
                  var o = {},
                      a = r.sentFrame,
                      c = r.inputFrame;

                  if (c && a) {
                    var _e203 = c.frameRate,
                        _t190 = a.frameRate;
                    o[GL.FREEZE] = function (e, t) {
                      var i = !0;
                      return i = !(e <= 5) && (e <= 10 ? t < 3 : e <= 20 ? t < 4 : t < 5), i;
                    }(_e203, _t190) ? 1 : 0;
                  }

                  if ($L(o, GL.QP_SUM, r.qpSumPerFrame), s) return o;

                  switch (a && ($L(o, GL.HEIGHT, a.height), $L(o, GL.WIDTH, a.width), $L(o, GL.FRAME_RATE, a.frameRate)), o[GL.DISABLED] = n._originMediaStreamTrack && !n._originMediaStreamTrack.enabled || n._mediaStreamTrack && !n._mediaStreamTrack.enabled ? 1 : 0, r.adaptionChangeReason) {
                    case "none":
                      o[GL.ADAPTATION] = 0;
                      break;

                    case "cpu":
                      o[GL.ADAPTATION] = 1;
                      break;

                    case "bandwidth":
                      o[GL.ADAPTATION] = 2;
                      break;

                    case "other":
                      o[GL.ADAPTATION] = 3;
                  }

                  o[GL.PLAYER_STATUS] = ub[n._player ? n._player.videoElementStatus : "uninit"], $L(o, GL.NACKS, r.nacksCount), $L(o, GL.PLIS, r.plisCount), $L(o, GL.FIRS, r.firsCount), $L(o, GL.AVG_ENCODE, r.avgEncodeMs);
                  var d = i && i.videoSend.find(function (t) {
                    return t.ssrc === e;
                  });

                  if (d) {
                    var _e204 = s ? QL : QL * ZL;

                    d.timestamp && r.timestamp && (_e204 = r.timestamp - d.timestamp), null != d.packets && null != r.packets && $L(o, GL.PACKAGE_RATE, 1e3 * (r.packets - d.packets) / _e204), null != r.packetsLost && null != d.packetsLost && $L(o, GL.PACKAGE_LOST, r.packetsLost - d.packetsLost), null != d.bytes && null != r.bytes && $L(o, GL.BITRATE, 8 * (r.bytes - d.bytes) / _e204);
                  }

                  return o;
                }(d[0].ssrcId, e, t, c, i),
                    _s54 = i ? null : function (e, t, i) {
                  var n = t.videoSend.find(function (t) {
                    return t.ssrc === e;
                  });
                  if (!n) return null;
                  var s = {},
                      r = n.inputFrame,
                      o = r && r.height || i && i._videoHeight || 0,
                      a = r && r.width || i && i._videoWidth || 0,
                      c = r && r.frameRate || 0;
                  return $L(s, BL.HEIGHT, o), $L(s, BL.WIDTH, a), $L(s, BL.FRAME_RATE, c), s;
                }(d[0].ssrcId, e, c),
                    _o20 = i ? null : function (e) {
                  var t = {};
                  return $L(t, GL.RETRANSMIT, e.bitrate.retransmit), $L(t, GL.TARGET_ENCODED, e.bitrate.targetEncoded), $L(t, GL.ACTUAL_ENCODED, e.bitrate.actualEncoded), $L(t, GL.TRANSMIT, e.bitrate.transmit), $L(t, GL.BANDWIDTH, e.sendBandwidth), t;
                }(e);

                r = Object.assign({}, _n92, _s54, _o20);
              } else o = i ? void 0 : function (e, t, i) {
                var n = t.videoSend.find(function (t) {
                  return t.ssrc === e;
                });
                if (!n) return;
                var s = {},
                    r = n.sentFrame;

                if (r && ($L(s, WL.HEIGHT, r.height), $L(s, WL.WIDTH, r.width), $L(s, WL.FRAME_RATE, r.frameRate)), i) {
                  var _t191 = i.videoSend.find(function (t) {
                    return t.ssrc === e;
                  });

                  if (_t191) {
                    var _e205 = QL * ZL;

                    _t191.timestamp && n.timestamp && (_e205 = n.timestamp - _t191.timestamp), null != _t191.packets && null != n.packets && $L(s, WL.PACKAGE_RATE, 1e3 * (n.packets - _t191.packets) / _e205), null != n.packetsLost && null != _t191.packetsLost && $L(s, WL.PACKAGE_LOST, n.packetsLost - _t191.packetsLost), null != _t191.bytes && null != n.bytes && $L(s, WL.BITRATE, 8 * (n.bytes - _t191.bytes) / _e205);
                  }
                }

                return s;
              }(d[0].ssrcId, e, t);

              break;

            case Ev.LocalAudioTrack:
              s = i ? void 0 : function (e, t, i, n) {
                var s = t.audioSend.find(function (t) {
                  return t.ssrc === e;
                });
                if (!s) return;
                var r = {};
                r[qL.DISABLED] = n._originMediaStreamTrack && !n._originMediaStreamTrack.enabled || n._mediaStreamTrack && !n._mediaStreamTrack.enabled ? 1 : 0;

                var o = n._source.getAccurateVolumeLevel(),
                    a = s.inputLevel;

                $L(r, qL.LEVEL, 100 * (null == a ? o : a)), $L(r, YL.PCM_LEVEL, 100 * o), $L(r, qL.AEC_RETURN_LOSS, s.aecReturnLoss), $L(r, qL.AEC_RETURN_LOSS_ENH, s.aecReturnLossEnhancement), r[qL.FREEZE] = 0;
                var c = i && i.audioSend.find(function (t) {
                  return t.ssrc === e;
                });

                if (c) {
                  var _e206 = QL * ZL;

                  c.timestamp && s.timestamp && (_e206 = s.timestamp - c.timestamp), null != c.bytes && null != s.bytes && $L(r, qL.BITRATE, 8 * (s.bytes - c.bytes) / _e206), null != c.packets && null != s.packets && $L(r, qL.PACKAGE_RATE, 1e3 * (s.packets - c.packets) / _e206);
                }

                return r;
              }(d[0].ssrcId, e, t, c);
          }
        }), {
          high: r,
          low: o,
          audio: s
        };
      }
    }, {
      key: "getInboundStats",
      value: function getInboundStats(e, t, i) {
        var _this190 = this;

        if (!this.requestRemoteMedia) return;
        var n = this.requestRemoteMedia() || [],
            s = [];
        return n.forEach(function (n) {
          var _n93 = _slicedToArray(n, 2),
              r = _n93[0],
              o = _n93[1];

          var a = {
            peer: r.uid
          };

          if (o.has(hv.VIDEO) && r.videoTrack) {
            var _n94 = r._videoSSRC && _this190.requestVideoIsReady && _this190.requestVideoIsReady(r._videoSSRC) || !1,
                _s55 = r.videoTrack ? function (e, t, i, n, s, r, o) {
              var a = t.videoRecv.find(function (t) {
                return t.ssrc === e;
              });
              if (!a) return;
              var c = {},
                  d = a.receivedFrame,
                  l = a.outputFrame,
                  u = a.decodeFrameRate,
                  h = i && i.videoRecv.find(function (t) {
                return t.ssrc === e;
              });

              if (c[HL.FREEZE] = s && uk.isRemoteVideoFreeze(n, a, h) ? 1 : 0, $L(c, KL.FRAME_RATE_DECODE, u), $L(c, HL.QP_SUM, a.qpSumPerFrame), a.framesRateFirefox && $L(c, HL.FRAME_RATE, a.framesRateFirefox), d && $L(c, HL.FRAME_RATE, d.frameRate), h) {
                var _e207 = t.timestamp - i.timestamp || (o ? QL : ZL * QL);

                null != a.packetsLost && null != h.packetsLost && $L(c, HL.PACKAGE_LOST, a.packetsLost - h.packetsLost), null != h.bytes && null != a.bytes && $L(c, HL.BITRATE, 8 * (a.bytes - h.bytes) / _e207), null != h.packets && null != a.packets && $L(c, HL.PACKAGE_RATE, 1e3 * (a.packets - h.packets) / _e207);
              }

              if (o) return c;

              if (d ? ($L(c, HL.HEIGHT, d.height), $L(c, HL.WIDTH, d.width)) : n && ($L(c, HL.HEIGHT, n._videoHeight || 0), $L(c, HL.WIDTH, n._videoWidth || 0)), l && $L(c, KL.FRAME_RATE_RENDER, l.frameRate), $L(c, HL.JITTER_BUFFER, a.jitterBufferMs), $L(c, HL.CURRENT_DELAY, a.currentDelayMs), $L(c, HL.FIRS, a.firsCount), $L(c, HL.NACKS, a.nacksCount), $L(c, HL.PLIS, a.plisCount), n) {
                c[HL.DISABLED] = n._originMediaStreamTrack.enabled && n._mediaStreamTrack.enabled ? 0 : 1;
                var _e208 = n._player;

                if (_e208) {
                  var _t192 = _e208.freezeTimeCounterList,
                      _i105 = _e208.renderFreezeAccTime;

                  if (_t192 && _t192.length > 0 && $L(c, KL.FREEZE_TIME, _t192.splice(0, 1)[0]), r && "visible" === gw.visibility) {
                    var _t193 = Math.min(6e3, _i105);

                    _e208.renderFreezeAccTime = Math.max(0, _i105 - _t193), $L(c, KL.FREEZE_TIME_RENDER, _t193);
                  }
                }
              }

              if (c[HL.PLAYER_STATUS] = ub[n._player ? n._player.videoElementStatus : "uninit"], h && void 0 !== a.totalInterFrameDelay && void 0 !== a.totalSquaredInterFrameDelay && void 0 !== h.totalInterFrameDelay && void 0 !== h.totalSquaredInterFrameDelay) {
                var _e209 = a.totalInterFrameDelay - h.totalInterFrameDelay,
                    _t194 = a.totalSquaredInterFrameDelay - h.totalSquaredInterFrameDelay,
                    _i106 = a.framesDecodeCount - h.framesDecodeCount,
                    _n95 = _e209 / _i106 * 1e3,
                    _s56 = Math.round(1e3 * Math.sqrt((_t194 - Math.pow(_e209, 2) / _i106) / _i106));

                !isNaN(_s56) && _n95 + _s56 > Math.max(3 * _n95, _n95 + 150) && (c[HL.I_FRAME_DELAY] = _s56);
              }

              return c;
            }(r._videoSSRC, e, t, r.videoTrack, !0 === _n94, _this190.needUploadRenderFreezeTime, i) : void 0;

            _s55 && (a.video = _s55);
          }

          if (o.has(hv.AUDIO) && r.audioTrack) {
            var _n96 = r.audioTrack ? function (e, t, i, n, s) {
              var r = t.audioRecv.find(function (t) {
                return t.ssrc === e;
              });
              if (!r) return;
              var o = {},
                  a = i && i.audioRecv.find(function (t) {
                return t.ssrc === e;
              }),
                  c = r.receivedFrames,
                  d = r.droppedFrames;
              var l, u;

              if ($L(o, JL.JITTER, r.jitterMs), null != c && null != d && (o[JL.FREEZE] = (u = d, 0 === (l = c) || 100 * u / l > 20 ? 1 : 0)), a) {
                var _e210 = t.timestamp - i.timestamp || (s ? QL : QL * ZL);

                null != r.packets && null != a.packets && $L(o, JL.PACKAGE_RATE, 1e3 * (r.packets - a.packets) / _e210), null != a.bytes && null != r.bytes && $L(o, JL.BITRATE, 8 * (r.bytes - a.bytes) / _e210), null != r.packetsLost && null != a.packetsLost && $L(o, JL.PACKAGE_LOST, r.packetsLost - a.packetsLost);
              }

              if (s) return o;

              var h = n._source.getAccurateVolumeLevel(),
                  p = r.outputLevel;

              if ($L(o, zL.LEVEL, 100 * (null == p ? h : p)), $L(o, JL.PCM_LEVEL, 100 * h), n && (o[JL.DISABLED] = n._originMediaStreamTrack.enabled && n._mediaStreamTrack.enabled ? 0 : 1), $L(o, JL.JITTER_BUFFER, r.jitterBufferMs), $L(o, JL.CURRENT_DELAY, r.jitterBufferMs), o[JL.PLAYER_STATUS] = ub[qb.getPlayerState(n.getTrackId())], a) {
                var _e211 = r.concealedSamples - a.concealedSamples;

                _e211 > 0 && $L(o, JL.CONCEALED_SAMPLES, _e211);
              }

              return o;
            }(r._audioSSRC, e, t, r.audioTrack, i) : void 0;

            _n96 && (a.audio = _n96);
          }

          (a.video || a.audio) && s.push(a);
        }), this.needUploadRenderFreezeTime = !this.needUploadRenderFreezeTime, s;
      }
    }, {
      key: "startUploadTransportStats",
      value: function startUploadTransportStats() {
        this.uploadTransportStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats();
      }
    }, {
      key: "stopUploadTransportStats",
      value: function stopUploadTransportStats() {
        this.uploadTransportStarted = !1;
      }
    }, {
      key: "startUploadOutboundStats",
      value: function startUploadOutboundStats() {
        var _this191 = this;

        this.uploadOutboundStarted || (this.uploadOutboundStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats(), this.uploadOutboundDenoiserStatsTimer && window.clearInterval(this.uploadOutboundDenoiserStatsTimer), this.uploadOutboundDenoiserStatsTimer = window.setInterval(function () {
          if (!_this191.requestAllTracks || !_this191.requestUpload) return;
          var e = (_this191.requestAllTracks() || []).find(function (e) {
            return e instanceof dw;
          });

          if (e && e._external.getDenoiserStats) {
            var _t195 = e._external.getDenoiserStats();

            _t195 && _this191.requestUpload(RI.DENOISER_STATS, _t195);
          }
        }, 2e3), this.uploadExtStatsTimer && window.clearInterval(this.uploadExtStatsTimer), this.uploadExtStatsTimer = window.setInterval(function () {
          if (!_this191.requestAllTracks || !_this191.requestUpload) return;

          _this191.requestAllTracks().forEach(function (e) {
            e.getProcessorStats().forEach(function (e) {
              _this191.requestUpload && _this191.requestUpload(e.type, e.stats);
            });
          });
        }, 2e3));
      }
    }, {
      key: "stopUploadOutboundStats",
      value: function stopUploadOutboundStats() {
        this.uploadOutboundStarted && (this.uploadOutboundStarted = !1, this.lastSendStats && (this.lastSendStats.videoSend = [], this.lastSendStats.audioSend = [], this.lastSendStats = void 0), this.uploadOutboundDenoiserStatsTimer && window.clearInterval(this.uploadOutboundDenoiserStatsTimer), this.uploadOutboundDenoiserStatsTimer = void 0);
      }
    }, {
      key: "startUploadInboundStats",
      value: function startUploadInboundStats() {
        var _this192 = this;

        this.uploadInboundStarted || (this.uploadInboundStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats(), this.uploadInboundExtStatsTimer && window.clearInterval(this.uploadInboundExtStatsTimer), this.uploadInboundExtStatsTimer = window.setInterval(function () {
          if (!_this192.requestUpload || !_this192.requestRemoteMedia) return;
          (_this192.requestRemoteMedia() || []).forEach(function (e) {
            var _e212 = _slicedToArray(e, 2),
                t = _e212[0],
                i = _e212[1];

            if (i.has(hv.VIDEO) && t.videoTrack) {
              t.videoTrack.getProcessorStats().forEach(function (e) {
                _this192.requestUpload && _this192.requestUpload(e.type, e.stats);
              });
            }

            if (i.has(hv.AUDIO) && t.audioTrack) {
              t.audioTrack.getProcessorStats().forEach(function (e) {
                _this192.requestUpload && _this192.requestUpload(e.type, e.stats);
              });
            }
          });
        }, 2e3));
      }
    }, {
      key: "stopUploadInboundStats",
      value: function stopUploadInboundStats() {
        this.uploadInboundStarted && (this.uploadInboundStarted = !1, this.lastRecvStats && (this.lastRecvStats.videoRecv = [], this.lastRecvStats.audioRecv = [], this.lastRecvStats = void 0));
      }
    }, {
      key: "startUploadExtensionUsageStats",
      value: function startUploadExtensionUsageStats() {
        var _this193 = this;

        if (this.uploadExtensionUsageStarted) return;
        this.uploadExtensionUsageStarted = !0, this.uploadExtUsageStatsTimer && window.clearInterval(this.uploadExtUsageStatsTimer);
        var e = new Map();
        this.uploadExtUsageStatsTimer = window.setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee174() {
          var t, i, n, s, _iterator21, _step21, _e214, r, _iterator22, _step22, _step22$value, _e215, _t196, o, a;

          return _regeneratorRuntime.wrap(function _callee174$(_context174) {
            while (1) {
              switch (_context174.prev = _context174.next) {
                case 0:
                  t = Date.now(), i = {
                    connectionInterval: DC("EXTENSION_USAGE_UPLOAD_INTERVAL") / 1e3,
                    details: [],
                    lts: t
                  };
                  n = [];
                  s = _this193.requestAllTracks && _this193.requestAllTracks() || [];
                  _iterator21 = _createForOfIteratorHelper(s);
                  _context174.prev = 4;

                  _iterator21.s();

                case 6:
                  if ((_step21 = _iterator21.n()).done) {
                    _context174.next = 17;
                    break;
                  }

                  _e214 = _step21.value;
                  _context174.t0 = !_e214.muted && _e214.enabled;

                  if (!_context174.t0) {
                    _context174.next = 15;
                    break;
                  }

                  _context174.t1 = n;
                  _context174.next = 13;
                  return _e214.getProcessorUsage();

                case 13:
                  _context174.t2 = _context174.sent;
                  n = _context174.t1.concat.call(_context174.t1, _context174.t2);

                case 15:
                  _context174.next = 6;
                  break;

                case 17:
                  _context174.next = 22;
                  break;

                case 19:
                  _context174.prev = 19;
                  _context174.t3 = _context174["catch"](4);

                  _iterator21.e(_context174.t3);

                case 22:
                  _context174.prev = 22;

                  _iterator21.f();

                  return _context174.finish(22);

                case 25:
                  r = _this193.requestRemoteMedia && _this193.requestRemoteMedia() || [];
                  _iterator22 = _createForOfIteratorHelper(r);
                  _context174.prev = 27;

                  _iterator22.s();

                case 29:
                  if ((_step22 = _iterator22.n()).done) {
                    _context174.next = 47;
                    break;
                  }

                  _step22$value = _slicedToArray(_step22.value, 2), _e215 = _step22$value[0], _t196 = _step22$value[1];
                  _context174.t4 = _t196.has(hv.VIDEO) && _e215.videoTrack;

                  if (!_context174.t4) {
                    _context174.next = 38;
                    break;
                  }

                  _context174.t5 = n;
                  _context174.next = 36;
                  return _e215.videoTrack.getProcessorUsage();

                case 36:
                  _context174.t6 = _context174.sent;
                  n = _context174.t5.concat.call(_context174.t5, _context174.t6);

                case 38:
                  _context174.t7 = _t196.has(hv.AUDIO) && _e215.audioTrack;

                  if (!_context174.t7) {
                    _context174.next = 45;
                    break;
                  }

                  _context174.t8 = n;
                  _context174.next = 43;
                  return _e215.audioTrack.getProcessorUsage();

                case 43:
                  _context174.t9 = _context174.sent;
                  n = _context174.t8.concat.call(_context174.t8, _context174.t9);

                case 45:
                  _context174.next = 29;
                  break;

                case 47:
                  _context174.next = 52;
                  break;

                case 49:
                  _context174.prev = 49;
                  _context174.t10 = _context174["catch"](27);

                  _iterator22.e(_context174.t10);

                case 52:
                  _context174.prev = 52;

                  _iterator22.f();

                  return _context174.finish(52);

                case 55:
                  if (!(0 === n.length)) {
                    _context174.next = 57;
                    break;
                  }

                  return _context174.abrupt("return");

                case 57:
                  i.details = function (e, t) {
                    var i = {};

                    var _iterator23 = _createForOfIteratorHelper(e),
                        _step23;

                    try {
                      for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                        var _step23$value = _step23.value,
                            _o21 = _step23$value.id,
                            _a10 = _step23$value.value,
                            c = _step23$value.level,
                            _d8 = _step23$value.direction;
                        var n;

                        var _e213 = null !== (n = t.get(_o21)) && void 0 !== n ? n : 0,
                            _l5 = 2 === _a10 ? _e213 + DC("EXTENSION_USAGE_UPLOAD_INTERVAL") / 1e3 : _e213;

                        var s, r;
                        t.set(_o21, _l5), i[_o21] ? (2 === _a10 && (i[_o21].value = _a10), c > i[_o21].level && (i[_o21].level = c), "remote" === _d8 && (i[_o21].remoteUidCount += 1), i[_o21].totalTs = null !== (s = t.get(_o21)) && void 0 !== s ? s : 0) : i[_o21] = {
                          value: _a10,
                          level: c,
                          remoteUidCount: "local" === _d8 ? 0 : 1,
                          totalTs: null !== (r = t.get(_o21)) && void 0 !== r ? r : 0
                        };
                      }
                    } catch (err) {
                      _iterator23.e(err);
                    } finally {
                      _iterator23.f();
                    }

                    return Object.keys(i).map(function (e) {
                      var _i$e = i[e],
                          t = _i$e.level,
                          n = _i$e.value,
                          s = _i$e.totalTs;
                      return {
                        id: e,
                        level: t,
                        value: n,
                        totalTs: s
                      };
                    });
                  }(n, e);

                  o = Date.now(), a = o > t ? o : t + 1;
                  _this193.requestUpload && _this193.requestUpload(RI.EXTENSION_USAGE_STATS, {
                    usageStats: i,
                    sendTs: a
                  });

                case 60:
                case "end":
                  return _context174.stop();
              }
            }
          }, _callee174, null, [[4, 19, 22, 25], [27, 49, 52, 55]]);
        })), DC("EXTENSION_USAGE_UPLOAD_INTERVAL"));
      }
    }, {
      key: "stopUploadExtensionUsageStats",
      value: function stopUploadExtensionUsageStats() {
        this.uploadExtensionUsageStarted && (this.uploadExtensionUsageStarted = !1, this.uploadExtUsageStatsTimer && window.clearInterval(this.uploadExtUsageStatsTimer), this.uploadExtUsageStatsTimer = void 0);
      }
    }]);

    return tk;
  }(ig);

  var ik = /*#__PURE__*/function () {
    function ik(e, t) {
      _classCallCheck(this, ik);

      nh(this, "uid", void 0), nh(this, "_uintid", void 0), nh(this, "_trust_in_room_", !0), nh(this, "_trust_audio_enabled_state_", !0), nh(this, "_trust_video_enabled_state_", !0), nh(this, "_trust_audio_mute_state_", !0), nh(this, "_trust_video_mute_state_", !0), nh(this, "_audio_muted_", !1), nh(this, "_video_muted_", !1), nh(this, "_audio_enabled_", !0), nh(this, "_video_enabled_", !0), nh(this, "_audio_added_", !1), nh(this, "_video_added_", !1), nh(this, "_is_pre_created", !1), nh(this, "_video_pre_subscribed", !1), nh(this, "_audio_pre_subscribed", !1), nh(this, "_trust_video_stream_added_state_", !0), nh(this, "_trust_audio_stream_added_state_", !0), nh(this, "_audioTrack", void 0), nh(this, "_videoTrack", void 0), nh(this, "_dataChannels", []), nh(this, "_audioSSRC", void 0), nh(this, "_videoSSRC", void 0), nh(this, "_audioOrtc", void 0), nh(this, "_videoOrtc", void 0), nh(this, "_cname", void 0), nh(this, "_rtxSsrcId", void 0), nh(this, "_videoMid", void 0), nh(this, "_audioMid", void 0), this.uid = e, this._uintid = t;
    }

    _createClass(ik, [{
      key: "hasVideo",
      get: function get() {
        return this._video_enabled_ && !this._video_muted_ && this._video_added_;
      }
    }, {
      key: "hasAudio",
      get: function get() {
        return this._audio_enabled_ && !this._audio_muted_ && this._audio_added_;
      }
    }, {
      key: "audioTrack",
      get: function get() {
        if (this.hasAudio || this._audio_pre_subscribed) return this._audioTrack;
      }
    }, {
      key: "videoTrack",
      get: function get() {
        if (this.hasVideo || this._video_pre_subscribed) return this._videoTrack;
      }
    }, {
      key: "dataChannels",
      get: function get() {
        return this._dataChannels;
      }
    }]);

    return ik;
  }();

  var nk;

  function sk(e, t) {
    var i;
    var n;

    switch (t) {
      case Ev.LocalAudioTrack:
        n = ev.Audio;
        break;

      case Ev.LocalVideoTrack:
        n = bn(i = e._hints).call(i, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
        break;

      case Ev.LocalVideoLowTrack:
        n = ev.Low;
    }

    return n;
  }

  function rk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function ok(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? rk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : rk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  !function (e) {
    e.SEND_ONLY = "SEND_ONLY", e.RECEIVE_ONLY = "RECEIVE_ONLY";
  }(nk || (nk = {}));

  var ak = /*#__PURE__*/function (_ig26) {
    _inherits(ak, _ig26);

    var _super57 = _createSuper(ak);

    function ak(e, t) {
      var _this194;

      _classCallCheck(this, ak);

      _this194 = _super57.call(this), nh(_assertThisInitialized(_this194), "store", void 0), nh(_assertThisInitialized(_this194), "statsUploader", void 0), nh(_assertThisInitialized(_this194), "sendConnection", void 0), nh(_assertThisInitialized(_this194), "recvConnection", void 0), nh(_assertThisInitialized(_this194), "localTrackMap", new Map()), nh(_assertThisInitialized(_this194), "remoteUserMap", new Map()), nh(_assertThisInitialized(_this194), "localDataChannels", []), nh(_assertThisInitialized(_this194), "pendingLocalTracks", []), nh(_assertThisInitialized(_this194), "pendingRemoteTracks", []), nh(_assertThisInitialized(_this194), "statsCollector", void 0), nh(_assertThisInitialized(_this194), "dtlsFailedCount", 0), nh(_assertThisInitialized(_this194), "sendMutex", new Yg("P2PChannel2-send-mutex")), nh(_assertThisInitialized(_this194), "recvMutex", new Yg("P2PChannel2-recv-mutex")), nh(_assertThisInitialized(_this194), "_state", mv.Disconnected), nh(_assertThisInitialized(_this194), "_restartStates", ["disconnected", "failed"]), nh(_assertThisInitialized(_this194), "reconnectInterval", void 0), nh(_assertThisInitialized(_this194), "uploadUnplinkStarted", !1), nh(_assertThisInitialized(_this194), "uploadDownlinkStarted", !1), nh(_assertThisInitialized(_this194), "uplinkStateUploadInterval", void 0), nh(_assertThisInitialized(_this194), "downlinkStatsUploadInterval", void 0), nh(_assertThisInitialized(_this194), "handleMuteLocalTrack", /*#__PURE__*/function () {
        var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee175(e, t, i) {
          var n, _o22, _a11, c, s, r, _d9, _l6;

          return _regeneratorRuntime.wrap(function _callee175$(_context175) {
            while (1) {
              switch (_context175.prev = _context175.next) {
                case 0:
                  _context175.next = 2;
                  return _this194.sendMutex.lock("Locking from P2PChannel2.handleMuteLocalTrack");

                case 2:
                  n = _context175.sent;
                  _context175.prev = 3;

                  if (!(!_this194.sendConnection || _this194.state !== mv.Connected)) {
                    _context175.next = 6;
                    break;
                  }

                  return _context175.abrupt("return", void i(new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before sendConnection established.")));

                case 6:
                  _o22 = _this194.filterTobeMutedTracks(e);

                  if (!(0 === _o22.length)) {
                    _context175.next = 9;
                    break;
                  }

                  return _context175.abrupt("return", void t());

                case 9:
                  _a11 = _o22.find(function (e) {
                    return "videoLowTrack" === e[0];
                  });

                  if (_a11) {
                    _a11[1].track._originMediaStreamTrack.stop();
                  }

                  _context175.next = 13;
                  return _this194.sendConnection.muteLocal(_o22.map(function (e) {
                    var _e216 = _slicedToArray(e, 2),
                        t = _e216[1].id;

                    return t;
                  }));

                case 13:
                  c = !1;
                  if ("video" === e.trackMediaType) c = !(null === (s = _this194.localTrackMap.get(Ev.LocalAudioTrack)) || void 0 === s || !s.track._muted);else c = void 0 === (null === (r = _this194.localTrackMap.get(Ev.LocalVideoTrack)) || void 0 === r ? void 0 : r.id);
                  _d9 = _this194.createMuteMessage(_o22);
                  _context175.next = 18;
                  return Tg(_assertThisInitialized(_this194), fv.RequestMuteLocal, _d9);

                case 18:
                  _l6 = "video" === e.trackMediaType ? Dv.MUTE_LOCAL_VIDEO : Dv.MUTE_LOCAL_AUDIO;
                  _context175.next = 21;
                  return Tg(_assertThisInitialized(_this194), fv.RequestP2PMuteLocal, {
                    action: _l6,
                    message: _d9,
                    isMuteAll: c
                  });

                case 21:
                  t();
                  _context175.next = 27;
                  break;

                case 24:
                  _context175.prev = 24;
                  _context175.t0 = _context175["catch"](3);
                  i(_context175.t0);

                case 27:
                  _context175.prev = 27;
                  n();
                  return _context175.finish(27);

                case 30:
                case "end":
                  return _context175.stop();
              }
            }
          }, _callee175, null, [[3, 24, 27, 30]]);
        }));

        return function (_x276, _x277, _x278) {
          return _ref58.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this194), "handleUnmuteLocalTrack", /*#__PURE__*/function () {
        var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee176(e, t, i) {
          var n, _s57, _r29, _o23;

          return _regeneratorRuntime.wrap(function _callee176$(_context176) {
            while (1) {
              switch (_context176.prev = _context176.next) {
                case 0:
                  _context176.next = 2;
                  return _this194.sendMutex.lock("Locking from P2PChannel2.handleUnmuteLocalTrack");

                case 2:
                  n = _context176.sent;
                  _context176.prev = 3;

                  if (!(!_this194.sendConnection || _this194.state !== mv.Connected)) {
                    _context176.next = 6;
                    break;
                  }

                  return _context176.abrupt("return", void i(new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel2.handleUnmuteLocalTrack before sendConnection established.")));

                case 6:
                  _s57 = _this194.filterTobeUnmutedTracks(e);

                  if (!(0 === _s57.length)) {
                    _context176.next = 9;
                    break;
                  }

                  return _context176.abrupt("return", void t());

                case 9:
                  _context176.next = 11;
                  return _this194.sendConnection.unmuteLocal(_s57.map(function (e) {
                    var _e217 = _slicedToArray(e, 2),
                        t = _e217[1].id;

                    return t;
                  }));

                case 11:
                  _r29 = _this194.createUnmuteMessage(_s57), _o23 = "video" === e.trackMediaType ? Dv.UNMUTE_LOCAL_VIDEO : Dv.UNMUTE_LOCAL_AUDIO;
                  _context176.next = 14;
                  return Tg(_assertThisInitialized(_this194), fv.RequestP2PMuteLocal, {
                    action: _o23,
                    message: _r29
                  });

                case 14:
                  t();
                  _context176.next = 20;
                  break;

                case 17:
                  _context176.prev = 17;
                  _context176.t0 = _context176["catch"](3);
                  i(_context176.t0);

                case 20:
                  _context176.prev = 20;
                  n();
                  return _context176.finish(20);

                case 23:
                case "end":
                  return _context176.stop();
              }
            }
          }, _callee176, null, [[3, 17, 20, 23]]);
        }));

        return function (_x279, _x280, _x281) {
          return _ref59.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this194), "handleUpdateVideoEncoder", /*#__PURE__*/function () {
        var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee177(e, t, i) {
          var n, _i107, _s58, _r30;

          return _regeneratorRuntime.wrap(function _callee177$(_context177) {
            while (1) {
              switch (_context177.prev = _context177.next) {
                case 0:
                  _context177.next = 2;
                  return _this194.sendMutex.lock("Locking from P2PChannel2.handleSetVideoEncoder");

                case 2:
                  n = _context177.sent;
                  _context177.prev = 3;
                  _i107 = _this194.localTrackMap.get(Ev.LocalVideoTrack);

                  if (!(!_this194.sendConnection || !_i107 || _i107.track !== e || _this194.state !== mv.Connected)) {
                    _context177.next = 7;
                    break;
                  }

                  return _context177.abrupt("return", void t());

                case 7:
                  _s58 = _i107.id, _r30 = _i107.track;
                  _context177.t0 = _s58;

                  if (!_context177.t0) {
                    _context177.next = 15;
                    break;
                  }

                  _context177.next = 12;
                  return _this194.sendConnection.updateSendParameters(_s58, _r30);

                case 12:
                  _context177.next = 14;
                  return _this194.sendConnection.updateEncoderConfig(_s58, _r30);

                case 14:
                  _this194.emit(fv.UpdateVideoEncoder, _r30);

                case 15:
                  t();
                  _context177.next = 21;
                  break;

                case 18:
                  _context177.prev = 18;
                  _context177.t1 = _context177["catch"](3);
                  i(_context177.t1);

                case 21:
                  _context177.prev = 21;
                  n();
                  return _context177.finish(21);

                case 24:
                case "end":
                  return _context177.stop();
              }
            }
          }, _callee177, null, [[3, 18, 21, 24]]);
        }));

        return function (_x282, _x283, _x284) {
          return _ref60.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this194), "handleSetOptimizationMode", /*#__PURE__*/function () {
        var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee178(e, t, i) {
          var n, _i108, _s59, _r31;

          return _regeneratorRuntime.wrap(function _callee178$(_context178) {
            while (1) {
              switch (_context178.prev = _context178.next) {
                case 0:
                  _context178.next = 2;
                  return _this194.sendMutex.lock("Locking from P2PChannel2.handleSetOptimizationMode");

                case 2:
                  n = _context178.sent;
                  _context178.prev = 3;
                  _i108 = _this194.localTrackMap.get(Ev.LocalVideoTrack);

                  if (!(!_this194.sendConnection || !_i108 || _i108.track !== e || _this194.state !== mv.Connected)) {
                    _context178.next = 7;
                    break;
                  }

                  return _context178.abrupt("return");

                case 7:
                  _s59 = _i108.id, _r31 = _i108.track;
                  _context178.t0 = _s59;

                  if (!_context178.t0) {
                    _context178.next = 12;
                    break;
                  }

                  _context178.next = 12;
                  return _this194.sendConnection.updateSendParameters(_s59, _r31);

                case 12:
                  t();
                  _context178.next = 18;
                  break;

                case 15:
                  _context178.prev = 15;
                  _context178.t1 = _context178["catch"](3);
                  i(_context178.t1);

                case 18:
                  _context178.prev = 18;
                  n();
                  return _context178.finish(18);

                case 21:
                case "end":
                  return _context178.stop();
              }
            }
          }, _callee178, null, [[3, 15, 18, 21]]);
        }));

        return function (_x285, _x286, _x287) {
          return _ref61.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this194), "handleReplaceTrack", /*#__PURE__*/function () {
        var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee179(e, t, i, n) {
          var s, r, _i109, _t198, _i110, o;

          return _regeneratorRuntime.wrap(function _callee179$(_context179) {
            while (1) {
              switch (_context179.prev = _context179.next) {
                case 0:
                  YC.debug("[".concat(_this194.store.clientId, "] P2PChannel2 handleReplaceTrack for [track-id-").concat(e.getTrackId(), "]"));
                  _context179.t0 = "boolean" == typeof n && n;

                  if (_context179.t0) {
                    _context179.next = 6;
                    break;
                  }

                  _context179.next = 5;
                  return _this194.sendMutex.lock("From P2PChannel2.handleReplaceTrack");

                case 5:
                  s = _context179.sent;

                case 6:
                  _context179.prev = 6;
                  _i109 = Array.from(_this194.localTrackMap.entries()).find(function (t) {
                    var _t197 = _slicedToArray(t, 2),
                        i = _t197[1].track;

                    return e === i;
                  });

                  if (!(!_this194.sendConnection || !_i109 || void 0 === _i109[1].id || _this194.state !== mv.Connected)) {
                    _context179.next = 10;
                    break;
                  }

                  return _context179.abrupt("return", void t());

                case 10:
                  _context179.next = 12;
                  return null === (r = _this194.sendConnection) || void 0 === r ? void 0 : r.replaceTrack(e, _i109[1].id);

                case 12:
                  if (!(_i109[0] === Ev.LocalVideoTrack && wA().supportDualStreamEncoding)) {
                    _context179.next = 21;
                    break;
                  }

                  _t198 = _this194.localTrackMap.get(Ev.LocalVideoLowTrack);

                  if (!_t198) {
                    _context179.next = 21;
                    break;
                  }

                  _i110 = e._mediaStreamTrack.clone();

                  _t198.track._originMediaStreamTrack.stop();

                  _t198.track._mediaStreamTrack = _i110;
                  _t198.track._originMediaStreamTrack = _i110;
                  _context179.next = 21;
                  return new tT(function (e, i) {
                    _this194.handleReplaceTrack(_t198.track, e, i, !0);
                  });

                case 21:
                  t();
                  _context179.next = 27;
                  break;

                case 24:
                  _context179.prev = 24;
                  _context179.t1 = _context179["catch"](6);
                  i(_context179.t1);

                case 27:
                  _context179.prev = 27;
                  null === (o = s) || void 0 === o || o();
                  return _context179.finish(27);

                case 30:
                case "end":
                  return _context179.stop();
              }
            }
          }, _callee179, null, [[6, 24, 27, 30]]);
        }));

        return function (_x288, _x289, _x290, _x291) {
          return _ref62.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this194), "handleGetLocalVideoStats", function (e) {
        e(_this194.statsCollector.getLocalVideoTrackStats());
      }), nh(_assertThisInitialized(_this194), "handleGetLocalAudioStats", function (e) {
        e(_this194.statsCollector.getLocalAudioTrackStats());
      }), nh(_assertThisInitialized(_this194), "handleGetRemoteVideoStats", function (e) {
        return _this194.statsCollector.getRemoteVideoTrackStats(e.uid)[e.uid];
      }), nh(_assertThisInitialized(_this194), "handleGetRemoteAudioStats", function (e) {
        return _this194.statsCollector.getRemoteAudioTrackStats(e.uid)[e.uid];
      }), _this194.store = e, _this194.statsCollector = t, _this194.statsCollector.addP2PChannel(_assertThisInitialized(_this194)), _this194.statsUploader = new tk(e), _this194.bindStatsUploaderEvents(), _this194.reconnectInterval = window.setInterval(function () {
        [_this194.sendConnection, _this194.recvConnection].forEach(function (e) {
          e && ("disconnected" !== e.iceConnectionState && "failed" !== e.iceConnectionState || _this194.handleDisconnect(e.direction));
        });
      }, DC("ICE_RESTART_INTERVAL"));
      return _this194;
    }

    _createClass(ak, [{
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        var t = this._state;
        this._state = e, this.emit(fv.StateChange, t, this._state);
      }
    }, {
      key: "startP2PConnection",
      value: function () {
        var _startP2PConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee180(e, t) {
          return _regeneratorRuntime.wrap(function _callee180$(_context180) {
            while (1) {
              switch (_context180.prev = _context180.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support startP2PConnection.");

                case 1:
                case "end":
                  return _context180.stop();
              }
            }
          }, _callee180);
        }));

        function startP2PConnection(_x292, _x293) {
          return _startP2PConnection.apply(this, arguments);
        }

        return startP2PConnection;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee181(e, t, i, n, s, r) {
          return _regeneratorRuntime.wrap(function _callee181$(_context181) {
            while (1) {
              switch (_context181.prev = _context181.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support connect.");

                case 1:
                case "end":
                  return _context181.stop();
              }
            }
          }, _callee181);
        }));

        function connect(_x294, _x295, _x296, _x297, _x298, _x299) {
          return _connect2.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "startP2P",
      value: function () {
        var _startP2P = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee182(e, t) {
          var i, _n97, _t199;

          return _regeneratorRuntime.wrap(function _callee182$(_context182) {
            while (1) {
              switch (_context182.prev = _context182.next) {
                case 0:
                  _context182.prev = 0;

                  if (!t) {
                    _context182.next = 12;
                    break;
                  }

                  this.recvConnection && (YC.warning("[".concat(this.store.clientId, "] P2PChannel.startP2P reset recvConnection.")), this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection));
                  _context182.next = 5;
                  return this.recvMutex.lock("From P2PChannel.startP2P");

                case 5:
                  i = _context182.sent;
                  this.recvConnection = new xL(e, this.store, vI.RECEIVE_ONLY);
                  this.bindConnectionEvents(this.recvConnection);
                  _context182.next = 10;
                  return this.recvConnection.establish(t);

                case 10:
                  _n97 = _context182.sent;
                  return _context182.abrupt("return", {
                    iceParameters: _n97.iceParameters,
                    dtlsParameters: _n97.dtlsParameters,
                    sdp: _n97.sdp
                  });

                case 12:
                  this.state = mv.New;
                  this.sendConnection && (YC.warning("[".concat(this.store.clientId, "] P2PChannel.startP2P reset sendConnection.")), this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection));
                  _context182.next = 16;
                  return this.sendMutex.lock("From P2PChannel.startP2P");

                case 16:
                  i = _context182.sent;
                  this.sendConnection = new xL(e, this.store);
                  this.store.peerConnectionStart();
                  this.bindConnectionEvents(this.sendConnection);
                  _context182.next = 22;
                  return this.sendConnection.establish();

                case 22:
                  _t199 = _context182.sent;
                  return _context182.abrupt("return", {
                    iceParameters: _t199.iceParameters,
                    dtlsParameters: _t199.dtlsParameters,
                    sdp: _t199.sdp
                  });

                case 24:
                  _context182.prev = 24;
                  i && i();
                  return _context182.finish(24);

                case 27:
                case "end":
                  return _context182.stop();
              }
            }
          }, _callee182, this, [[0,, 24, 27]]);
        }));

        function startP2P(_x300, _x301) {
          return _startP2P.apply(this, arguments);
        }

        return startP2P;
      }()
    }, {
      key: "p2pConnect",
      value: function () {
        var _p2pConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee183(e) {
          return _regeneratorRuntime.wrap(function _callee183$(_context183) {
            while (1) {
              switch (_context183.prev = _context183.next) {
                case 0:
                  if (this.sendConnection) {
                    _context183.next = 2;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel2.p2pConnect before P2PChannel2.startP2PConnection .");

                case 2:
                  this.store.peerConnectionStart();
                  _context183.next = 5;
                  return this.sendConnection.connect(e);

                case 5:
                  this.statsUploader.startUploadTransportStats();
                  this.statsUploader.startUploadExtensionUsageStats();
                  this.state = mv.Connected;

                case 8:
                case "end":
                  return _context183.stop();
              }
            }
          }, _callee183, this);
        }));

        function p2pConnect(_x302) {
          return _p2pConnect.apply(this, arguments);
        }

        return p2pConnect;
      }()
    }, {
      key: "addRemoteCandidate",
      value: function () {
        var _addRemoteCandidate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee184(e, t) {
          return _regeneratorRuntime.wrap(function _callee184$(_context184) {
            while (1) {
              switch (_context184.prev = _context184.next) {
                case 0:
                  if (!(t === vI.RECEIVE_ONLY)) {
                    _context184.next = 7;
                    break;
                  }

                  if (this.sendConnection) {
                    _context184.next = 3;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel2.connect before P2PChannel2.addRemoteCandidate .");

                case 3:
                  _context184.next = 5;
                  return this.sendConnection.addRemoteCandidate(e);

                case 5:
                  _context184.next = 11;
                  break;

                case 7:
                  if (this.recvConnection) {
                    _context184.next = 9;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel2.connect before P2PChannel2.addRemoteCandidate .");

                case 9:
                  _context184.next = 11;
                  return this.recvConnection.addRemoteCandidate(e);

                case 11:
                case "end":
                  return _context184.stop();
              }
            }
          }, _callee184, this);
        }));

        function addRemoteCandidate(_x303, _x304) {
          return _addRemoteCandidate2.apply(this, arguments);
        }

        return addRemoteCandidate;
      }()
    }, {
      key: "publish",
      value: function publish(e, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee185() {
          var s, _t200, _r32, _o24, _a12, c;

          return _regeneratorRuntime.wrap(function _callee185$(_context185) {
            while (1) {
              switch (_context185.prev = _context185.next) {
                case 0:
                  _context185.next = 2;
                  return SP(n.sendMutex.lock("From P2PChannel.publish"));

                case 2:
                  s = _context185.sent;
                  _context185.prev = 3;

                  if (!(!n.sendConnection || n.state !== mv.Connected)) {
                    _context185.next = 8;
                    break;
                  }

                  n.throwIfTrackTypeNotMatch(e);
                  _t200 = e.filter(function (e) {
                    return -1 === n.pendingLocalTracks.indexOf(e);
                  });
                  return _context185.abrupt("return", void (n.pendingLocalTracks = n.pendingLocalTracks.concat(_t200)));

                case 8:
                  n.store.pubId = n.store.pubId + 1, TP.markPublishStart(n.store.clientId, n.store.pubId);
                  _r32 = n.filterTobePublishedTracks(e, t, i);

                  if (!(0 === _r32.length)) {
                    _context185.next = 14;
                    break;
                  }

                  _context185.next = 13;
                  return SP(n.tryToUnmuteAudio(e));

                case 13:
                  return _context185.abrupt("return", void _context185.sent);

                case 14:
                  _r32.forEach(function (e) {
                    var t = e.track,
                        i = e.type;
                    var s = Date.now();
                    n.store.publish(t.getTrackId(), i === Ev.LocalAudioTrack ? "audio" : "video", s);
                  }), n.bindLocalTrackEvents(_r32);
                  _context185.next = 17;
                  return SP(n.sendConnection.send(_r32.map(function (e) {
                    var t = e.track;
                    return t;
                  }), n.store.codec, n.store.audioCodec));

                case 17:
                  _o24 = _context185.sent;
                  _context185.next = 20;
                  return SP(_o24.next());

                case 20:
                  _a12 = _context185.sent.value;
                  c = n.createGatewayPublishMessage(_r32, _a12);
                  _context185.prev = 22;
                  _context185.next = 25;
                  return c;

                case 25:
                  _context185.next = 30;
                  break;

                case 27:
                  _context185.prev = 27;
                  _context185.t0 = _context185["catch"](22);
                  throw _o24.throw(_context185.t0), (null == _context185.t0 ? void 0 : _context185.t0.code) === xT.WS_ABORT && _r32.forEach(function (e) {
                    var t = e.track;
                    -1 === n.pendingLocalTracks.indexOf(t) && n.pendingLocalTracks.push(t);
                  }), n.unbindLocalTrackEvents(_r32), _context185.t0;

                case 30:
                  _context185.next = 32;
                  return SP(_o24.next());

                case 32:
                  _r32.forEach(function (e) {
                    var t = e.type;
                    n.statsCollector.addLocalStats(t);
                  });

                  n.statsUploader.startUploadOutboundStats();
                  n.assignLocalTracks(_r32, _a12);

                  _r32.forEach(function (e) {
                    var t = e.track,
                        i = e.type;
                    var s = Date.now();
                    n.store.publish(t.getTrackId(), i === Ev.LocalAudioTrack ? "audio" : "video", void 0, s);
                  });

                  n.startUploadUplinkState();

                case 37:
                  _context185.prev = 37;
                  s();
                  return _context185.finish(37);

                case 40:
                case "end":
                  return _context185.stop();
              }
            }
          }, _callee185, null, [[3,, 37, 40], [22, 27]]);
        }))();
      }
    }, {
      key: "unpublish",
      value: function () {
        var _unpublish2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee186(e) {
          var _this195 = this;

          var t, i, n;
          return _regeneratorRuntime.wrap(function _callee186$(_context186) {
            while (1) {
              switch (_context186.prev = _context186.next) {
                case 0:
                  if (!(!this.sendConnection || this.state !== mv.Connected)) {
                    _context186.next = 2;
                    break;
                  }

                  return _context186.abrupt("return", void (0 === e.length ? this.pendingLocalTracks.length = 0 : this.pendingLocalTracks = this.pendingLocalTracks.filter(function (t) {
                    return !bn(e).call(e, t);
                  })));

                case 2:
                  t = this.filterTobeUnpublishedTracks(e);

                  if (!(0 === t.length)) {
                    _context186.next = 5;
                    break;
                  }

                  return _context186.abrupt("return");

                case 5:
                  i = t.find(function (e) {
                    return "videoLowTrack" === e[0];
                  });

                  if (i) {
                    i[1].track.close();
                  }

                  n = this.createGatewayUnpublishMessage(t);
                  _context186.next = 10;
                  return this.sendConnection.stopSending(t.map(function (e) {
                    var _e218 = _slicedToArray(e, 2),
                        t = _e218[1].id;

                    return t;
                  }));

                case 10:
                  this.withdrawLocalTracks(t);
                  this.unbindLocalTrackEvents(t.map(function (e) {
                    var _e219 = _slicedToArray(e, 2),
                        t = _e219[0],
                        i = _e219[1].track;

                    return {
                      type: t,
                      track: i
                    };
                  }));
                  t.forEach(function (e) {
                    var _e220 = _slicedToArray(e, 1),
                        t = _e220[0];

                    _this195.statsCollector.removeLocalStats(t);
                  });
                  0 === this.localTrackMap.size && (this.statsUploader.stopUploadOutboundStats(), this.stopUploadUplinkState());

                  if (!(this.sendConnection && this.state === mv.Connected)) {
                    _context186.next = 17;
                    break;
                  }

                  if (i) {
                    i[1].track.close();
                  }

                  return _context186.abrupt("return", n);

                case 17:
                  e.forEach(function (e) {
                    var t = _this195.pendingLocalTracks.indexOf(e);

                    -1 !== t && _this195.pendingLocalTracks.splice(t, 1);
                  });

                case 18:
                case "end":
                  return _context186.stop();
              }
            }
          }, _callee186, this);
        }));

        function unpublish(_x305) {
          return _unpublish2.apply(this, arguments);
        }

        return unpublish;
      }()
    }, {
      key: "startUploadUplinkState",
      value: function startUploadUplinkState() {
        var _this196 = this;

        if (this.uploadUnplinkStarted) return;
        this.uploadUnplinkStarted = !0, this.uplinkStateUploadInterval && window.clearInterval(this.uplinkStateUploadInterval);

        var e = function e() {
          var e = [],
              t = [];
          Array.from(_this196.localTrackMap.entries()).forEach(function (i) {
            var _i111 = _slicedToArray(i, 2),
                n = _i111[0],
                _i111$ = _i111[1],
                s = _i111$.track,
                r = _i111$.ssrcs;

            var o = {
              stream_type: sk(s, n),
              ssrcs: r
            };
            s._muted || !s._enabled ? e.push(o) : t.push(o);
          }), e.length > 0 && e.forEach(function (e) {
            Tg(_this196, fv.RequestMuteLocal, [e]);
          }), t.length > 0 && t.forEach(function (e) {
            Tg(_this196, fv.RequestUnmuteLocal, [e]);
          });
        };

        e(), this.uplinkStateUploadInterval = window.setInterval(function () {
          e();
        }, 3e3);
      }
    }, {
      key: "stopUploadUplinkState",
      value: function stopUploadUplinkState() {
        this.uploadUnplinkStarted && (this.uploadUnplinkStarted = !1, this.uplinkStateUploadInterval && window.clearInterval(this.uplinkStateUploadInterval));
      }
    }, {
      key: "publishLowStream",
      value: function publishLowStream(e) {
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee187() {
          return _regeneratorRuntime.wrap(function _callee187$(_context187) {
            while (1) {
              switch (_context187.prev = _context187.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support publishLowStream.");

                case 1:
                case "end":
                  return _context187.stop();
              }
            }
          }, _callee187);
        }))();
      }
    }, {
      key: "republish",
      value: function () {
        var _republish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee188() {
          return _regeneratorRuntime.wrap(function _callee188$(_context188) {
            while (1) {
              switch (_context188.prev = _context188.next) {
                case 0:
                  _context188.t0 = this.pendingLocalTracks.length > 0;

                  if (!_context188.t0) {
                    _context188.next = 7;
                    break;
                  }

                  YC.debug("[".concat(this.store.clientId, "] Emit P2PChannelEvents.RequestRePublish to republish tracks."));
                  _context188.next = 5;
                  return fg(this, fv.RequestRePublish, this.pendingLocalTracks);

                case 5:
                  this.emit(fv.MediaReconnectEnd, this.store.uid);
                  this.pendingLocalTracks = [];

                case 7:
                case "end":
                  return _context188.stop();
              }
            }
          }, _callee188, this);
        }));

        function republish() {
          return _republish.apply(this, arguments);
        }

        return republish;
      }()
    }, {
      key: "unpublishLowStream",
      value: function () {
        var _unpublishLowStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee189() {
          return _regeneratorRuntime.wrap(function _callee189$(_context189) {
            while (1) {
              switch (_context189.prev = _context189.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support unpublishLowStream.");

                case 1:
                case "end":
                  return _context189.stop();
              }
            }
          }, _callee189);
        }));

        function unpublishLowStream() {
          return _unpublishLowStream.apply(this, arguments);
        }

        return unpublishLowStream;
      }()
    }, {
      key: "subscribe",
      value: function () {
        var _subscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee190(e, t, i, n) {
          var s, _yield$this$recvConne, r, o, a, c, d;

          return _regeneratorRuntime.wrap(function _callee190$(_context190) {
            while (1) {
              switch (_context190.prev = _context190.next) {
                case 0:
                  if (this.recvConnection) {
                    _context190.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot subscribe remote user when recvConnection disconnected.");

                case 2:
                  if (!(null !== (s = this.remoteUserMap.get(e)) && void 0 !== s && s.has(t))) {
                    _context190.next = 4;
                    break;
                  }

                  return _context190.abrupt("return");

                case 4:
                  _context190.next = 6;
                  return this.recvConnection.receive(t, [{
                    ssrcId: i
                  }], String(e.uid), n);

                case 6:
                  _yield$this$recvConne = _context190.sent;
                  r = _yield$this$recvConne.track;
                  o = _yield$this$recvConne.mid;
                  a = _yield$this$recvConne.transceiver;
                  t === hv.AUDIO ? (e._audioTrack ? e._audioTrack._updateOriginMediaStreamTrack(r) : (e._audioTrack = new Fw(r, e.uid, e._uintid, this.store), YC.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote audio track: ").concat(e._audioTrack.getTrackId()))), a && e._audioTrack._updateRtpTransceiver(a), this.bindRemoteTrackEvents(e, e._audioTrack)) : (e._videoSSRC = i, e._videoTrack ? e._videoTrack._updateOriginMediaStreamTrack(r) : (e._videoTrack = new Vw(r, e.uid, e._uintid, this.store), YC.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote video track: ").concat(e._videoTrack.getTrackId()))), a && e._videoTrack._updateRtpTransceiver(a), this.bindRemoteTrackEvents(e, e._videoTrack));
                  c = this.remoteUserMap.get(e);
                  c ? c.set(t, o) : this.remoteUserMap.set(e, new Map([[t, o]])), this.statsCollector.addRemoteStats(e.uid), this.statsUploader.startUploadInboundStats(), this.startUploadDownlinkState();
                  d = this.pendingRemoteTracks.findIndex(function (i) {
                    var n = i.user,
                        s = i.kind;
                    return n.uid === e.uid && t === s;
                  });
                  -1 !== d && (this.pendingRemoteTracks.splice(d, 1), this.emit(fv.MediaReconnectEnd, e.uid));

                case 15:
                case "end":
                  return _context190.stop();
              }
            }
          }, _callee190, this);
        }));

        function subscribe(_x306, _x307, _x308, _x309) {
          return _subscribe2.apply(this, arguments);
        }

        return subscribe;
      }()
    }, {
      key: "mockSubscribe",
      value: function () {
        var _mockSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee191(e, t, i, n) {
          return _regeneratorRuntime.wrap(function _callee191$(_context191) {
            while (1) {
              switch (_context191.prev = _context191.next) {
                case 0:
                  if (this.recvConnection) {
                    _context191.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot subscribe remote user when recvConnection disconnected.");

                case 2:
                  _context191.next = 4;
                  return this.recvConnection.mockReceive(t, [{
                    ssrcId: i
                  }], String(e.uid), n);

                case 4:
                case "end":
                  return _context191.stop();
              }
            }
          }, _callee191, this);
        }));

        function mockSubscribe(_x310, _x311, _x312, _x313) {
          return _mockSubscribe.apply(this, arguments);
        }

        return mockSubscribe;
      }()
    }, {
      key: "unsubscribe",
      value: function () {
        var _unsubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee192(e, t, i) {
          var _this197 = this;

          var n, s;
          return _regeneratorRuntime.wrap(function _callee192$(_context192) {
            while (1) {
              switch (_context192.prev = _context192.next) {
                case 0:
                  n = this.pendingRemoteTracks.filter(function (i) {
                    var n = i.user,
                        s = i.kind;
                    return void 0 !== t ? n.uid === e.uid && t === s : n.uid === e.uid;
                  });

                  if (!(n.forEach(function (e) {
                    var t = _this197.pendingRemoteTracks.indexOf(e);

                    _this197.pendingRemoteTracks.splice(t, 1);
                  }), this.recvConnection || i || n.forEach(function (t) {
                    var i = t.kind;
                    var n;
                    if (i === hv.AUDIO) null === (n = e._audioTrack) || void 0 === n || n._destroy(), e._audioTrack = void 0;else if (i === hv.VIDEO) {
                      var s;
                      null === (s = e._videoTrack) || void 0 === s || s._destroy(), e._videoTrack = void 0;
                    }
                  }), !this.recvConnection)) {
                    _context192.next = 3;
                    break;
                  }

                  return _context192.abrupt("return");

                case 3:
                  s = this.filterTobeUnSubscribedTracks(e, t);
                  _context192.t0 = 0 !== s.length;

                  if (!_context192.t0) {
                    _context192.next = 12;
                    break;
                  }

                  _context192.next = 8;
                  return this.recvConnection.stopReceiving(s.map(function (e) {
                    var _e221 = _slicedToArray(e, 2),
                        t = _e221[1].id;

                    return t;
                  }));

                case 8:
                  this.withdrawRemoteTracks(s);
                  0 === this.remoteUserMap.size && (this.statsUploader.stopUploadInboundStats(), this.stopUploadDownlinkState());
                  s.forEach(function (e) {
                    var _e222 = _slicedToArray(e, 2),
                        t = _e222[0],
                        n = _e222[1].kind;

                    var s, r;
                    n === hv.VIDEO && t._videoSSRC && (null === (s = _this197.recvConnection) || void 0 === s || s.setStatsRemoteVideoIsReady(t._videoSSRC, !1));
                    if (n === hv.VIDEO) _this197.unbindRemoteTrackEvents(t._videoTrack), i || (null === (r = t._videoTrack) || void 0 === r || r._destroy(), t._videoTrack = void 0);else if (n === hv.AUDIO) {
                      var o;
                      if (_this197.unbindRemoteTrackEvents(t._audioTrack), !i) null === (o = t._audioTrack) || void 0 === o || o._destroy(), t._audioTrack = void 0;
                    }
                  });
                  s.forEach(function (e) {
                    var _e223 = _slicedToArray(e, 2),
                        t = _e223[1].kind;

                    Tg(_this197, fv.RequestP2PMuteRemote, t);
                  });

                case 12:
                case "end":
                  return _context192.stop();
              }
            }
          }, _callee192, this);
        }));

        function unsubscribe(_x314, _x315, _x316) {
          return _unsubscribe2.apply(this, arguments);
        }

        return unsubscribe;
      }()
    }, {
      key: "startUploadDownlinkState",
      value: function startUploadDownlinkState() {
        var _this198 = this;

        if (this.uploadDownlinkStarted) return;
        this.uploadDownlinkStarted = !0, this.downlinkStatsUploadInterval && window.clearInterval(this.downlinkStatsUploadInterval);

        var e = function e() {
          return Array.from(_this198.remoteUserMap.entries()).forEach(function (e) {
            var _e224 = _slicedToArray(e, 2),
                t = _e224[1];

            [hv.VIDEO, hv.AUDIO].forEach(function (e) {
              t.has(e) ? Tg(_this198, fv.RequestP2PUnmuteRemote, e) : Tg(_this198, fv.RequestP2PMuteRemote, e);
            });
          });
        };

        e(), this.downlinkStatsUploadInterval = window.setInterval(function () {
          e();
        }, 3e3);
      }
    }, {
      key: "stopUploadDownlinkState",
      value: function stopUploadDownlinkState() {
        this.uploadDownlinkStarted && (this.uploadDownlinkStarted = !1, this.downlinkStatsUploadInterval && window.clearInterval(this.downlinkStatsUploadInterval));
      }
    }, {
      key: "getAllDataChannels",
      value: function getAllDataChannels() {
        return this.localDataChannels;
      }
    }, {
      key: "massSubscribe",
      value: function () {
        var _massSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee193(e) {
          return _regeneratorRuntime.wrap(function _callee193$(_context193) {
            while (1) {
              switch (_context193.prev = _context193.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support massSubscribe.");

                case 1:
                case "end":
                  return _context193.stop();
              }
            }
          }, _callee193);
        }));

        function massSubscribe(_x317) {
          return _massSubscribe.apply(this, arguments);
        }

        return massSubscribe;
      }()
    }, {
      key: "massSubscribeNoLock",
      value: function () {
        var _massSubscribeNoLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee194(e) {
          return _regeneratorRuntime.wrap(function _callee194$(_context194) {
            while (1) {
              switch (_context194.prev = _context194.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support massSubscribeNoLock.");

                case 1:
                case "end":
                  return _context194.stop();
              }
            }
          }, _callee194);
        }));

        function massSubscribeNoLock(_x318) {
          return _massSubscribeNoLock.apply(this, arguments);
        }

        return massSubscribeNoLock;
      }()
    }, {
      key: "massUnsubscribe",
      value: function () {
        var _massUnsubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee195(e) {
          return _regeneratorRuntime.wrap(function _callee195$(_context195) {
            while (1) {
              switch (_context195.prev = _context195.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support massUnsubscribe.");

                case 1:
                case "end":
                  return _context195.stop();
              }
            }
          }, _callee195);
        }));

        function massUnsubscribe(_x319) {
          return _massUnsubscribe2.apply(this, arguments);
        }

        return massUnsubscribe;
      }()
    }, {
      key: "massUnsubscribeNoLock",
      value: function () {
        var _massUnsubscribeNoLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee196(e) {
          return _regeneratorRuntime.wrap(function _callee196$(_context196) {
            while (1) {
              switch (_context196.prev = _context196.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "p2p mode does not support massUnsubscribeNoLock.");

                case 1:
                case "end":
                  return _context196.stop();
              }
            }
          }, _callee196);
        }));

        function massUnsubscribeNoLock(_x320) {
          return _massUnsubscribeNoLock.apply(this, arguments);
        }

        return massUnsubscribeNoLock;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee197(e, t) {
          var i, n;
          return _regeneratorRuntime.wrap(function _callee197$(_context197) {
            while (1) {
              switch (_context197.prev = _context197.next) {
                case 0:
                  if (this.recvConnection) {
                    _context197.next = 2;
                    break;
                  }

                  return _context197.abrupt("return");

                case 2:
                  i = this.remoteUserMap.get(e);

                  if (i) {
                    _context197.next = 5;
                    break;
                  }

                  return _context197.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel2.muteRemote has no remote user ").concat(e.uid, ".")));

                case 5:
                  if (i.get(t)) {
                    _context197.next = 7;
                    break;
                  }

                  return _context197.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel2.muteRemote has no remote user ").concat(e.uid, " media type ").concat(t, ".")));

                case 7:
                  n = t === hv.VIDEO ? e._videoSSRC : e._audioSSRC;
                  void 0 !== n && this.recvConnection.setStatsRemoteVideoIsReady(n, !1);

                case 9:
                case "end":
                  return _context197.stop();
              }
            }
          }, _callee197, this);
        }));

        function muteRemote(_x321, _x322) {
          return _muteRemote2.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee198(e, t) {
          return _regeneratorRuntime.wrap(function _callee198$(_context198) {
            while (1) {
              switch (_context198.prev = _context198.next) {
                case 0:
                  return _context198.abrupt("return", this.unmuteRemoteNoLock(e, t));

                case 1:
                case "end":
                  return _context198.stop();
              }
            }
          }, _callee198, this);
        }));

        function unmuteRemote(_x323, _x324) {
          return _unmuteRemote2.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "unmuteRemoteNoLock",
      value: function () {
        var _unmuteRemoteNoLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee199(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee199$(_context199) {
            while (1) {
              switch (_context199.prev = _context199.next) {
                case 0:
                  if (this.recvConnection) {
                    _context199.next = 2;
                    break;
                  }

                  return _context199.abrupt("return");

                case 2:
                  i = this.remoteUserMap.get(e);

                  if (i) {
                    _context199.next = 5;
                    break;
                  }

                  return _context199.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel2.unmuteRemote has no remote user ").concat(e.uid, ".")));

                case 5:
                  i.get(t) || YC.warning("[".concat(this.store.clientId, "] P2PChannel2.unmuteRemote has no remote user ").concat(e.uid, " media type ").concat(t, "."));

                case 6:
                case "end":
                  return _context199.stop();
              }
            }
          }, _callee199, this);
        }));

        function unmuteRemoteNoLock(_x325, _x326) {
          return _unmuteRemoteNoLock.apply(this, arguments);
        }

        return unmuteRemoteNoLock;
      }()
    }, {
      key: "getAllTracks",
      value: function getAllTracks(e) {
        var t = this.localTrackMap.get(Ev.LocalAudioTrack);

        if ((null == t ? void 0 : t.track) instanceof uw) {
          var i = t.track;
          return Array.from(this.localTrackMap.entries()).filter(function (e) {
            var _e225 = _slicedToArray(e, 1),
                t = _e225[0];

            return t !== Ev.LocalAudioTrack;
          }).filter(function (t) {
            var _t201 = _slicedToArray(t, 1),
                i = _t201[0];

            return !(e && i === Ev.LocalVideoLowTrack);
          }).map(function (e) {
            var _e226 = _slicedToArray(e, 2),
                t = _e226[1].track;

            return t;
          }).concat(i.trackList);
        }

        return Array.from(this.localTrackMap.entries()).filter(function (t) {
          var _t202 = _slicedToArray(t, 1),
              i = _t202[0];

          return !(e && i === Ev.LocalVideoLowTrack);
        }).map(function (e) {
          var _e227 = _slicedToArray(e, 2),
              t = _e227[1].track;

          return t;
        });
      }
    }, {
      key: "reportPublishEvent",
      value: function reportPublishEvent(e, t, i, n, s) {
        if (e) {
          var _i112 = this.localTrackMap.get(Ev.LocalAudioTrack),
              _r33 = n ? this.localTrackMap.get(Ev.LocalVideoLowTrack) : this.localTrackMap.get(Ev.LocalVideoTrack);

          rI.publish(this.store.sessionId, {
            eventElapse: TP.measureFromPublishStart(this.store.clientId, this.store.pubId),
            succ: e,
            ec: t,
            audioName: null == _i112 ? void 0 : _i112.track.getTrackLabel(),
            videoName: null == _r33 ? void 0 : _r33.track.getTrackLabel(),
            screenshare: -1 !== (null == _r33 ? void 0 : _r33.track._hints.indexOf(YA.SCREEN_TRACK)),
            audio: !!_i112,
            video: !!_r33,
            p2pid: this.store.p2pId,
            publishRequestid: this.store.pubId,
            extend: s
          });
        } else {
          var r;
          i || (i = []);

          var _o25 = i.find(function (e) {
            return e instanceof cw;
          }),
              _a13 = n ? null === (r = this.localTrackMap.get(Ev.LocalVideoTrack)) || void 0 === r ? void 0 : r.track : i.find(function (e) {
            return e instanceof Nw;
          });

          rI.publish(this.store.sessionId, {
            eventElapse: TP.measureFromPublishStart(this.store.clientId, this.store.pubId),
            succ: e,
            ec: t,
            audioName: null == _o25 ? void 0 : _o25.getTrackLabel(),
            videoName: null == _a13 ? void 0 : _a13.getTrackLabel(),
            screenshare: -1 !== (null == _a13 ? void 0 : _a13._hints.indexOf(YA.SCREEN_TRACK)),
            audio: !!_o25,
            video: !!_a13,
            p2pid: this.store.p2pId,
            publishRequestid: this.store.pubId,
            extend: s
          });
        }
      }
    }, {
      key: "reportSubscribeEvent",
      value: function reportSubscribeEvent(e, t, i, n) {
        var s = n === hv.VIDEO ? i._videoSSRC : i._audioSSRC;
        s && rI.subscribe(this.store.sessionId, {
          succ: e,
          ec: t,
          video: n === hv.VIDEO,
          audio: n === hv.AUDIO,
          peerid: i.uid,
          subscribeRequestid: n === hv.VIDEO ? i._videoSSRC : i._audioSSRC,
          p2pid: this.store.p2pId,
          eventElapse: TP.measureFromSubscribeStart(this.store.clientId, s)
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        YC.debug("[".concat(this.store.clientId, "] P2PChannel2.reset")), this.sendMutex = new Yg("P2PChannel2-send-mutex"), this.sendMutex = new Yg("P2PChannel2-recv-mutex"), this.sendConnection && (this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection), this.sendConnection = void 0), this.recvConnection && (this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection), this.recvConnection = void 0), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), this.statsUploader.stopUploadExtensionUsageStats(), this.stopUploadUplinkState(), this.stopUploadDownlinkState(), this.unbindLocalTrackEvents(), this.unbindAllRemoteTrackEvents(), this.unbindRtpTransceiver();
        var e = this.localTrackMap.get(Ev.LocalAudioTrack);

        if ((null == e ? void 0 : e.track) instanceof uw) {
          if (e.track.trackList.length > 0) {
            var _t203 = e.track;
            e.track.trackList.forEach(function (e) {
              _t203.removeAudioTrack(e);
            });
          }

          e.track.close();
        }

        this.localTrackMap.clear(), this.remoteUserMap.clear(), this.statsCollector.removeRemoteStats(), this.statsCollector.removeLocalStats(), this.dtlsFailedCount = 0, this.pendingLocalTracks = [], this.pendingRemoteTracks = [], this.reconnectInterval && (window.clearInterval(this.reconnectInterval), this.reconnectInterval = void 0), this.state = mv.Disconnected;
      }
    }, {
      key: "getStats",
      value: function getStats(e) {
        var t, i;
        return e ? null === (i = this.recvConnection) || void 0 === i ? void 0 : i.getStats() : null === (t = this.sendConnection) || void 0 === t ? void 0 : t.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        var t;
        return (null === (t = this.recvConnection) || void 0 === t ? void 0 : t.getRemoteVideoIsReady(e)) || !1;
      }
    }, {
      key: "getLocalAudioVolume",
      value: function getLocalAudioVolume() {
        var e = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e) return e.track.getVolumeLevel();
      }
    }, {
      key: "getLocalVideoSize",
      value: function getLocalVideoSize() {
        var e = this.localTrackMap.get(Ev.LocalVideoTrack);
        if (e) return {
          width: e.track._videoWidth || 0,
          height: e.track._videoHeight || 0
        };
      }
    }, {
      key: "getEncoderConfig",
      value: function getEncoderConfig(e) {
        var t = this.localTrackMap.get(e);
        return t && t.track instanceof Nw || t && t.track instanceof cw ? t.track._encoderConfig : void 0;
      }
    }, {
      key: "getLocalMedia",
      value: function getLocalMedia(e) {
        return this.localTrackMap.get(e);
      }
    }, {
      key: "hasLocalMedia",
      value: function hasLocalMedia() {
        return this.localTrackMap.size > 0;
      }
    }, {
      key: "hasRemoteMedia",
      value: function hasRemoteMedia(e, t) {
        if (!e) return this.remoteUserMap.size > 0;
        var i = this.remoteUserMap.get(e);
        return !!i && (!t || i.has(t));
      }
    }, {
      key: "hasRemoteMediaWithLock",
      value: function () {
        var _hasRemoteMediaWithLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee200(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee200$(_context200) {
            while (1) {
              switch (_context200.prev = _context200.next) {
                case 0:
                  if (e) {
                    _context200.next = 2;
                    break;
                  }

                  return _context200.abrupt("return", this.remoteUserMap.size > 0);

                case 2:
                  i = this.remoteUserMap.get(e);
                  return _context200.abrupt("return", !!i && (!t || i.has(t)));

                case 4:
                case "end":
                  return _context200.stop();
              }
            }
          }, _callee200, this);
        }));

        function hasRemoteMediaWithLock(_x327, _x328) {
          return _hasRemoteMediaWithLock.apply(this, arguments);
        }

        return hasRemoteMediaWithLock;
      }()
    }, {
      key: "getRemoteMedia",
      value: function getRemoteMedia(e) {
        var t;
        var i = Array.from(uh(t = this.remoteUserMap).call(t)).find(function (t) {
          return t.uid === e;
        });
        return i ? {
          audioTrack: i.audioTrack,
          audioSSRC: i._audioSSRC,
          videoTrack: i.videoTrack,
          videoSSRC: i._videoSSRC
        } : {};
      }
    }, {
      key: "getAudioLevels",
      value: function getAudioLevels() {
        var e = Array.from(this.remoteUserMap.entries()).map(function (e) {
          var _e228 = _slicedToArray(e, 1),
              t = _e228[0];

          return {
            uid: t.uid,
            level: t.audioTrack ? 100 * t.audioTrack._source.getAccurateVolumeLevel() : 0
          };
        });
        var t = this.localTrackMap.get(Ev.LocalAudioTrack);
        return t && e.push({
          level: 100 * t.track._source.getAccurateVolumeLevel(),
          uid: this.store.uid
        }), e = Zh(e).call(e, function (e, t) {
          return e.level - t.level;
        }), e;
      }
    }, {
      key: "disconnectForReconnect",
      value: function () {
        var _disconnectForReconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee201() {
          var _this199 = this;

          return _regeneratorRuntime.wrap(function _callee201$(_context201) {
            while (1) {
              switch (_context201.prev = _context201.next) {
                case 0:
                  this.sendConnection && this.recvConnection && (YC.debug("[".concat(this.store.clientId, "] P2PChannel2.disconnectForReconnect closing P2PConnection")), this.state = mv.Reconnecting, DC("KEEP_LAST_FRAME") && 0 !== this.remoteUserMap.size && Array.from(this.remoteUserMap.entries()).forEach(function (e) {
                    var _e229 = _slicedToArray(e, 1),
                        t = _e229[0];

                    var i;
                    t._videoTrack && t._videoTrack._player && (null === (i = t._videoTrack._player.getVideoElement()) || void 0 === i || i.pause(), t._videoTrack._player.isKeepLastFrame = !0, t._videoTrack._originMediaStreamTrack.stop());
                  }), this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection), this.sendConnection = void 0, this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection), this.recvConnection = void 0, 0 !== this.localTrackMap.size && (Array.from(this.localTrackMap.entries()).forEach(function (e) {
                    var t;

                    var _e230 = _slicedToArray(e, 2),
                        i = _e230[0],
                        n = _e230[1].track;

                    switch (i) {
                      case Ev.LocalVideoTrack:
                        bn(t = n._hints).call(t, YA.LOW_STREAM) ? n.close() : _this199.pendingLocalTracks.push(n);
                        break;

                      case Ev.LocalAudioTrack:
                        n instanceof uw ? _this199.pendingLocalTracks = _this199.pendingLocalTracks.concat(n.trackList) : _this199.pendingLocalTracks.push(n);

                      case Ev.LocalVideoLowTrack:
                    }
                  }), this.emit(fv.MediaReconnectStart, this.store.uid)), this.unbindLocalTrackEvents(), this.localTrackMap.clear(), 0 !== this.remoteUserMap.size && Array.from(this.remoteUserMap.entries()).forEach(function (e) {
                    var _e231 = _slicedToArray(e, 2),
                        t = _e231[0],
                        i = _e231[1];

                    Array.from(uh(i).call(i)).forEach(function (e) {
                      _this199.setPendingRemoteMedia(t, e);
                    }), _this199.emit(fv.MediaReconnectStart, t.uid);
                  }), this.unbindAllRemoteTrackEvents(), this.remoteUserMap.clear(), this.stopUploadUplinkState(), this.stopUploadDownlinkState(), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), YC.debug("[".concat(this.store.clientId, "] P2PChannel2 disconnected, waiting to reconnect.")));

                case 1:
                case "end":
                  return _context201.stop();
              }
            }
          }, _callee201, this);
        }));

        function disconnectForReconnect() {
          return _disconnectForReconnect.apply(this, arguments);
        }

        return disconnectForReconnect;
      }()
    }, {
      key: "hasPendingRemoteMedia",
      value: function hasPendingRemoteMedia(e, t) {
        var _iterator24 = _createForOfIteratorHelper(this.pendingRemoteTracks),
            _step24;

        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var i = _step24.value;
            var _n98 = i.user,
                _s60 = i.kind;
            if ((e instanceof ik ? e.uid : e) === _n98.uid && t === _s60) return !0;
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }

        return !1;
      }
    }, {
      key: "setPendingRemoteMedia",
      value: function setPendingRemoteMedia(e, t) {
        this.hasPendingRemoteMedia(e, t) || this.pendingRemoteTracks.push({
          user: e,
          kind: t
        });
      }
    }, {
      key: "restartICE",
      value: function () {
        var _restartICE3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee202(e, t) {
          var i, n, _e232, _e233, _t204;

          return _regeneratorRuntime.wrap(function _callee202$(_context202) {
            while (1) {
              switch (_context202.prev = _context202.next) {
                case 0:
                  if (!(e === vI.SEND_ONLY)) {
                    _context202.next = 9;
                    break;
                  }

                  if (this.sendConnection) {
                    _context202.next = 3;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before sendConnection established.");

                case 3:
                  _context202.next = 5;
                  return this.sendMutex.lock("From P2PChannel.restartICE");

                case 5:
                  i = _context202.sent;
                  n = this.sendConnection;
                  _context202.next = 15;
                  break;

                case 9:
                  if (this.recvConnection) {
                    _context202.next = 11;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before recvConnection established.");

                case 11:
                  _context202.next = 13;
                  return this.recvMutex.lock("From P2PChannel.restartICE");

                case 13:
                  i = _context202.sent;
                  n = this.recvConnection;

                case 15:
                  _context202.prev = 15;

                  if (!t) {
                    _context202.next = 21;
                    break;
                  }

                  _context202.next = 19;
                  return n.restartICE(t);

                case 19:
                  _e232 = _context202.sent;
                  return _context202.abrupt("return", (n.isInRestartIce = !1, _e232));

                case 21:
                  _context202.next = 23;
                  return n.restartICE();

                case 23:
                  _e233 = _context202.sent;

                  if (!_e233) {
                    _context202.next = 31;
                    break;
                  }

                  _context202.next = 27;
                  return fg(this, fv.RequestP2PRestartICE, {
                    direction: vI.RECEIVE_ONLY,
                    iceParameter: _e233
                  });

                case 27:
                  _t204 = _context202.sent;
                  _context202.next = 30;
                  return n.restartICE(_t204);

                case 30:
                  n.isInRestartIce = !1;

                case 31:
                  _context202.prev = 31;
                  i();
                  return _context202.finish(31);

                case 34:
                case "end":
                  return _context202.stop();
              }
            }
          }, _callee202, this, [[15,, 31, 34]]);
        }));

        function restartICE(_x329, _x330) {
          return _restartICE3.apply(this, arguments);
        }

        return restartICE;
      }()
    }, {
      key: "getUplinkNetworkQuality",
      value: function getUplinkNetworkQuality() {
        if (!this.sendConnection) return 0;
        var e = this.sendConnection.getStats(),
            t = this.localTrackMap.get(Ev.LocalVideoTrack),
            i = this.localTrackMap.get(Ev.LocalAudioTrack),
            n = e.videoSend.find(function (e) {
          var i;
          return e.ssrc === (null == t || null === (i = t.ssrcs) || void 0 === i ? void 0 : i[0].ssrcId);
        }),
            s = e.audioSend.find(function (e) {
          var t;
          return e.ssrc === (null == i || null === (t = i.ssrcs) || void 0 === t ? void 0 : t[0].ssrcId);
        });
        if (!n || !s) return 1;
        var r = gg(this, fv.NeedSignalRTT),
            o = n ? n.rttMs : void 0,
            a = s ? s.rttMs : void 0,
            c = o && a ? (o + a) / 2 : o || a,
            d = (c && r ? (c + r) / 2 : c || r) || 0,
            l = 100 * e.sendPacketLossRate * .7 / 50 + .3 * d / 1500,
            u = l < .17 ? 1 : l < .36 ? 2 : l < .59 ? 3 : l < .1 ? 4 : 5,
            h = null == t ? void 0 : t.track;

        if (h && h._encoderConfig && -1 === h._hints.indexOf(YA.SCREEN_TRACK)) {
          var _t205 = h._encoderConfig.bitrateMax,
              _i113 = e.bitrate.actualEncoded;

          if (_t205 && _i113) {
            var _e234 = (1e3 * _t205 - _i113) / (1e3 * _t205);

            return cI[_e234 < .15 ? 0 : _e234 < .3 ? 1 : _e234 < .45 ? 2 : _e234 < .6 ? 3 : 4][u];
          }
        }

        return u;
      }
    }, {
      key: "getDownlinkNetworkQuality",
      value: function getDownlinkNetworkQuality() {
        var _this200 = this;

        if (!this.recvConnection) return 0;
        var e = this.recvConnection.getStats();
        var t = 0;
        return Array.from(this.remoteUserMap.entries()).forEach(function (i) {
          var _i114 = _slicedToArray(i, 1),
              n = _i114[0];

          var s = n._audioSSRC,
              r = n._videoSSRC,
              o = e.audioRecv.find(function (e) {
            return e.ssrc === s;
          }),
              a = e.videoRecv.find(function (e) {
            return e.ssrc === r;
          });
          if (!o && !a) return void (t += 1);
          var c = gg(_this200, fv.NeedSignalRTT),
              d = e.rtt,
              l = (d && c ? (d + c) / 2 : d || c) || 0,
              u = o ? o.jitterMs : void 0,
              h = e.recvPacketLossRate;
          var p = .7 * h * 100 / 50 + .3 * l / 1500;
          u && (p = .6 * h * 100 / 50 + .2 * l / 1500 + .2 * u / 400);
          t += p < .1 ? 1 : p < .17 ? 2 : p < .36 ? 3 : p < .59 ? 4 : 5;
        }), this.remoteUserMap.size > 0 ? Math.round(t / this.remoteUserMap.size) : t;
      }
    }, {
      key: "muteLocalTrack",
      value: function () {
        var _muteLocalTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee203(e) {
          var _this201 = this;

          return _regeneratorRuntime.wrap(function _callee203$(_context203) {
            while (1) {
              switch (_context203.prev = _context203.next) {
                case 0:
                  return _context203.abrupt("return", new tT(function (t, i) {
                    _this201.handleMuteLocalTrack(e, t, i);
                  }));

                case 1:
                case "end":
                  return _context203.stop();
              }
            }
          }, _callee203);
        }));

        function muteLocalTrack(_x331) {
          return _muteLocalTrack.apply(this, arguments);
        }

        return muteLocalTrack;
      }()
    }, {
      key: "filterTobePublishedTracks",
      value: function filterTobePublishedTracks(e, t, i) {
        var n = [],
            s = wA(),
            r = this.getAllTracks();
        e = yg(e = e.filter(function (e) {
          return -1 === r.indexOf(e);
        }));
        var o = !1,
            a = !1;

        var _iterator25 = _createForOfIteratorHelper(e),
            _step25;

        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var _r34 = _step25.value;

            if (_r34 instanceof Nw && (this.localTrackMap.has(Ev.LocalVideoTrack) || o ? new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS).throw() : (n.push({
              track: _r34,
              type: Ev.LocalVideoTrack
            }), o = !0), t)) {
              var _e235 = this.getLowVideoTrack(_r34, i);

              n.push({
                track: _e235,
                type: Ev.LocalVideoLowTrack
              });
            }

            if (_r34 instanceof cw) {
              var _e236 = this.localTrackMap.get(Ev.LocalAudioTrack);

              if (_e236) {
                if (!(_e236.track instanceof uw)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
                if (_r34._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");
                _e236.track.addAudioTrack(_r34), this.bindLocalAudioTrackEvents(_r34, !0);
              } else if (a) {
                var _e237 = n.find(function (e) {
                  var t = e.type;
                  return t === Ev.LocalAudioTrack;
                });

                if (!(_e237.track instanceof uw)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
                if (_r34._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");

                _e237.track.addAudioTrack(_r34);
              } else {
                if (!s.webAudioMediaStreamDest || _r34 instanceof uw || _r34._bypassWebAudio) n.push({
                  track: _r34,
                  type: Ev.LocalAudioTrack
                });else {
                  var _e238 = new uw();

                  _e238.addAudioTrack(_r34), n.push({
                    track: _e238,
                    type: Ev.LocalAudioTrack
                  });
                }
                a = !0;
              }
            }
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }

        return n;
      }
    }, {
      key: "filterTobeUnpublishedTracks",
      value: function filterTobeUnpublishedTracks(e) {
        var t = [],
            i = this.getAllTracks();
        e = yg(e = e.filter(function (e) {
          return -1 !== i.indexOf(e);
        }));

        var _iterator26 = _createForOfIteratorHelper(e),
            _step26;

        try {
          for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
            var _i115 = _step26.value;

            if (_i115 instanceof cw) {
              var _e239 = this.localTrackMap.get(Ev.LocalAudioTrack);

              if (!_e239) continue;
              _e239.track instanceof uw ? (_e239.track.removeAudioTrack(_i115), this.unbindLocalAudioTrackEvents(_i115), 0 === _e239.track.trackList.length && (t.push([Ev.LocalAudioTrack, _e239]), _e239.track.close())) : t.push([Ev.LocalAudioTrack, _e239]);
            }

            if (_i115 instanceof Nw) {
              var _e240 = this.localTrackMap.get(Ev.LocalVideoTrack);

              if (!_e240) continue;
              t.push([Ev.LocalVideoTrack, _e240]);

              var _i116 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

              _i116 && t.push([Ev.LocalVideoLowTrack, _i116]);
            }
          }
        } catch (err) {
          _iterator26.e(err);
        } finally {
          _iterator26.f();
        }

        return t;
      }
    }, {
      key: "bindLocalTrackEvents",
      value: function bindLocalTrackEvents(e) {
        var _this202 = this;

        e.forEach(function (e) {
          var t = e.track,
              i = e.type;

          switch (i) {
            case Ev.LocalVideoTrack:
              t.addListener(KA.GET_STATS, _this202.handleGetLocalVideoStats), t.addListener(KA.NEED_DISABLE_TRACK, _this202.handleMuteLocalTrack), t.addListener(KA.NEED_ENABLE_TRACK, _this202.handleUnmuteLocalTrack), t.addListener(KA.NEED_UPDATE_VIDEO_ENCODER, _this202.handleUpdateVideoEncoder), t.addListener(KA.SET_OPTIMIZATION_MODE, _this202.handleSetOptimizationMode), t.addListener(KA.NEED_REPLACE_TRACK, _this202.handleReplaceTrack), t.addListener(KA.NEED_MUTE_TRACK, _this202.handleMuteLocalTrack), t.addListener(KA.NEED_UNMUTE_TRACK, _this202.handleUnmuteLocalTrack);
              break;

            case Ev.LocalAudioTrack:
              _this202.bindLocalAudioTrackEvents(t);

            case Ev.LocalVideoLowTrack:
          }
        });
      }
    }, {
      key: "bindLocalAudioTrackEvents",
      value: function bindLocalAudioTrackEvents(e, t) {
        var _this203 = this;

        e instanceof uw ? e.trackList.forEach(function (e) {
          e.addListener(KA.NEED_DISABLE_TRACK, _this203.handleMuteLocalTrack), e.addListener(KA.NEED_ENABLE_TRACK, _this203.handleUnmuteLocalTrack), e.addListener(KA.GET_STATS, _this203.handleGetLocalAudioStats), e.addListener(KA.NEED_MUTE_TRACK, _this203.handleMuteLocalTrack), e.addListener(KA.NEED_UNMUTE_TRACK, _this203.handleUnmuteLocalTrack);
        }) : (e.addListener(KA.GET_STATS, this.handleGetLocalAudioStats), e.addListener(KA.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.addListener(KA.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.addListener(KA.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.addListener(KA.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack), t || e.addListener(KA.NEED_REPLACE_TRACK, this.handleReplaceTrack));
      }
    }, {
      key: "unbindLocalTrackEvents",
      value: function unbindLocalTrackEvents(e) {
        var _this204 = this;

        e || (e = Array.from(this.localTrackMap.entries()).map(function (e) {
          var _e241 = _slicedToArray(e, 2),
              t = _e241[0],
              i = _e241[1].track;

          return {
            track: i,
            type: t
          };
        })), e.forEach(function (e) {
          var t = e.track,
              i = e.type;

          switch (i) {
            case Ev.LocalVideoTrack:
              t.off(KA.GET_STATS, _this204.handleGetLocalVideoStats), t.off(KA.NEED_DISABLE_TRACK, _this204.handleMuteLocalTrack), t.off(KA.NEED_ENABLE_TRACK, _this204.handleUnmuteLocalTrack), t.off(KA.NEED_UPDATE_VIDEO_ENCODER, _this204.handleUpdateVideoEncoder), t.off(KA.SET_OPTIMIZATION_MODE, _this204.handleSetOptimizationMode), t.off(KA.NEED_REPLACE_TRACK, _this204.handleReplaceTrack), t.off(KA.NEED_MUTE_TRACK, _this204.handleMuteLocalTrack), t.off(KA.NEED_UNMUTE_TRACK, _this204.handleUnmuteLocalTrack);
              break;

            case Ev.LocalAudioTrack:
              _this204.unbindLocalAudioTrackEvents(t);

            case Ev.LocalVideoLowTrack:
          }
        });
      }
    }, {
      key: "unbindLocalAudioTrackEvents",
      value: function unbindLocalAudioTrackEvents(e) {
        var _this205 = this;

        e instanceof uw ? e.trackList.forEach(function (e) {
          e.off(KA.NEED_DISABLE_TRACK, _this205.handleMuteLocalTrack), e.off(KA.NEED_ENABLE_TRACK, _this205.handleUnmuteLocalTrack), e.off(KA.GET_STATS, _this205.handleGetLocalAudioStats), e.off(KA.NEED_MUTE_TRACK, _this205.handleMuteLocalTrack), e.off(KA.NEED_UNMUTE_TRACK, _this205.handleUnmuteLocalTrack);
        }) : (e.off(KA.GET_STATS, this.handleGetLocalAudioStats), e.off(KA.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.off(KA.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.off(KA.NEED_REPLACE_TRACK, this.handleReplaceTrack), e.off(KA.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.off(KA.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack));
      }
    }, {
      key: "bindRemoteTrackEvents",
      value: function bindRemoteTrackEvents(e, t) {
        var _this206 = this;

        t instanceof Vw && t.addListener(KA.GET_STATS, function (t) {
          t(_this206.handleGetRemoteVideoStats(e));
        }), t instanceof Fw && t.addListener(KA.GET_STATS, function (t) {
          t(_this206.handleGetRemoteAudioStats(e));
        });
      }
    }, {
      key: "unbindRemoteTrackEvents",
      value: function unbindRemoteTrackEvents(e) {
        e && e.removeAllListeners(KA.GET_STATS);
      }
    }, {
      key: "unbindAllRemoteTrackEvents",
      value: function unbindAllRemoteTrackEvents() {
        var _this207 = this;

        Array.from(this.remoteUserMap.entries()).forEach(function (e) {
          var _e242 = _slicedToArray(e, 2),
              t = _e242[0],
              i = _e242[1];

          i.has(hv.AUDIO) && _this207.unbindRemoteTrackEvents(t._audioTrack), i.has(hv.VIDEO) && _this207.unbindRemoteTrackEvents(t._videoTrack);
        });
      }
    }, {
      key: "createGatewayPublishMessage",
      value: function createGatewayPublishMessage(e, t) {
        return e.map(function (e, i) {
          var n;
          var s,
              r = e.track,
              o = e.type;

          switch (o) {
            case Ev.LocalAudioTrack:
              s = ev.Audio;
              break;

            case Ev.LocalVideoTrack:
              s = bn(n = r._hints).call(n, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalVideoLowTrack:
              s = ev.Low;
          }

          return {
            kind: o === Ev.LocalAudioTrack ? hv.AUDIO : hv.VIDEO,
            stream_type: s,
            mid: t[i].id,
            ssrcs: t[i].localSSRC,
            isMuted: r.muted || !r.enabled
          };
        });
      }
    }, {
      key: "createGatewayUnpublishMessage",
      value: function createGatewayUnpublishMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e243 = _slicedToArray(e, 2),
              n = _e243[0],
              _e243$ = _e243[1],
              s = _e243$.track,
              r = _e243$.ssrcs,
              o = _e243$.id;

          switch (n) {
            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "assignLocalTracks",
      value: function assignLocalTracks(e, t) {
        var _this208 = this;

        e.forEach(function (e, i) {
          var n = e.track,
              s = e.type;

          _this208.localTrackMap.set(s, {
            track: n,
            id: t[i].id,
            ssrcs: t[i].localSSRC
          });
        });
      }
    }, {
      key: "withdrawLocalTracks",
      value: function withdrawLocalTracks(e) {
        var _this209 = this;

        e.forEach(function (e) {
          var _e244 = _slicedToArray(e, 1),
              t = _e244[0];

          _this209.localTrackMap.delete(t);
        });
      }
    }, {
      key: "bindConnectionEvents",
      value: function bindConnectionEvents(e) {
        var _this210 = this;

        e.onConnectionStateChange = /*#__PURE__*/function () {
          var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee204(t) {
            var i;
            return _regeneratorRuntime.wrap(function _callee204$(_context204) {
              while (1) {
                switch (_context204.prev = _context204.next) {
                  case 0:
                    YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: ").concat(e.name, ".onConnectionStateChange(").concat(t, ")"));

                    _this210.emit(fv.PeerConnectionStateChange, t);

                    "connected" !== t || _this210.store.keyMetrics.peerConnectionEnd || _this210.store.peerConnectionEnd();
                    "connected" === t && (e.isInRestartIce = !1);
                    _context204.t0 = bn(i = _this210._restartStates).call(i, t) && !e.isInRestartIce;

                    if (!_context204.t0) {
                      _context204.next = 11;
                      break;
                    }

                    _context204.t1 = "disconnected" === t;

                    if (!_context204.t1) {
                      _context204.next = 10;
                      break;
                    }

                    _context204.next = 10;
                    return Ug(800);

                  case 10:
                    "disconnected" !== e.iceConnectionState && "failed" !== e.iceConnectionState || _this210.handleDisconnect(e.direction);

                  case 11:
                  case "end":
                    return _context204.stop();
                }
              }
            }, _callee204);
          }));

          return function (_x332) {
            return _ref63.apply(this, arguments);
          };
        }(), e.onICEConnectionStateChange = function (e) {
          "connected" !== e || _this210.store.keyMetrics.iceConnectionEnd || _this210.store.iceConnectionEnd(), YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.onICEConnectionStateChange(").concat(e, ")")), rI.reportApiInvoke(_this210.store.sessionId, {
            name: "ICEConnectionStateChange",
            options: e,
            tag: og.TRACER
          }).onSuccess(), _this210.emit(fv.IceConnectionStateChange, e);
        }, e.onICETransportStateChange = function (e) {
          YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.onICETransportStateChange(").concat(e, ")"));
        }, e.onDTLSTransportStateChange = function (e) {
          YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.onDTLSTransportStateChange(").concat(e, ")"));
        }, e.onDTLSTransportError = function (e) {
          YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.onDTLSTransportError(").concat(e, ")"));
        }, e.onFirstAudioDecoded = function (e) {
          var t;
          var i = Array.from(uh(t = _this210.remoteUserMap).call(t)).find(function (t) {
            return t._audioSSRC === e;
          });
          var n;
          i && (_this210.store.subscribe(i.uid, "audio", void 0, void 0, void 0, Date.now()), null === (n = i.audioTrack) || void 0 === n || n.emit(ZA.FIRST_FRAME_DECODED), rI.firstRemoteFrame(_this210.store.sessionId, QC.FIRST_AUDIO_DECODE, ZC.FIRST_AUDIO_DECODE, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this210.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this210.store.p2pId
          }));
        }, e.onFirstAudioReceived = function (e) {
          var t;
          var i = Array.from(uh(t = _this210.remoteUserMap).call(t)).find(function (t) {
            return t._audioSSRC === e;
          });
          i && rI.firstRemoteFrame(_this210.store.sessionId, QC.FIRST_AUDIO_RECEIVED, ZC.FIRST_AUDIO_RECEIVED, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this210.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this210.store.p2pId
          });
        }, e.onFirstVideoDecoded = function (e, t, i) {
          _this210.reportVideoFirstFrameDecoded(e, t, i);
        }, e.onFirstVideoReceived = function (e) {
          var t;
          var i = Array.from(uh(t = _this210.remoteUserMap).call(t)).find(function (t) {
            return t._videoSSRC === e;
          });
          i && rI.firstRemoteFrame(_this210.store.sessionId, QC.FIRST_VIDEO_RECEIVED, ZC.FIRST_VIDEO_RECEIVED, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this210.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this210.store.p2pId
          });
        }, e.onSelectedLocalCandidateChanged = function (e, t) {
          var i = "relay" === e.candidateType,
              n = "relay" === t.candidateType;
          "unknown" !== t.candidateType && i === n || _this210.emit(fv.ConnectionTypeChange, i), YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.SelectedLocalCandidateChanged(").concat(JSON.stringify(Dy(t)), " -> ").concat(JSON.stringify(Dy(e)), ")"));
        }, e.onSelectedRemoteCandidateChanged = function (e, t) {
          YC.info("[".concat(_this210.store.clientId, "] [p2pId: ").concat(_this210.store.p2pId, "]: P2PConnection.SelectedRemoteCandidateChanged(").concat(JSON.stringify(Dy(t)), " -> ").concat(JSON.stringify(Dy(e)), ")"));
        }, e.onFirstVideoDecodedTimeout = function (e) {
          _this210.reportVideoFirstFrameDecoded(e, void 0, void 0, !0);
        }, e.onLocalCandidate = function (t) {
          _this210.emit(fv.LocalCandidate, {
            candidate: t,
            direction: e.direction
          });
        };
      }
    }, {
      key: "unbindConnectionEvents",
      value: function unbindConnectionEvents(e) {
        e.onConnectionStateChange = void 0, e.onICEConnectionStateChange = void 0, e.onICETransportStateChange = void 0, e.onDTLSTransportStateChange = void 0, e.onDTLSTransportError = void 0, e.onFirstAudioDecoded = void 0, e.onFirstAudioReceived = void 0, e.onFirstVideoDecoded = void 0, e.onFirstVideoReceived = void 0, e.onSelectedLocalCandidateChanged = void 0, e.onSelectedRemoteCandidateChanged = void 0, e.onFirstVideoDecodedTimeout = void 0, e.onLocalCandidate = void 0;
      }
    }, {
      key: "handleDisconnect",
      value: function () {
        var _handleDisconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee205(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee205$(_context205) {
            while (1) {
              switch (_context205.prev = _context205.next) {
                case 0:
                  t = e === vI.SEND_ONLY ? this.sendConnection : this.recvConnection;
                  t && !t.isInRestartIce && (t.isInRestartIce = !0, YC.debug("[".concat(this.store.clientId, "] [P2PChannel-").concat(t.name, "] start use restartICE")), e === vI.SEND_ONLY ? this.restartICE(e) : fg(this, fv.RequestP2PRestartICE, {
                    direction: vI.SEND_ONLY
                  }));

                case 2:
                case "end":
                  return _context205.stop();
              }
            }
          }, _callee205, this);
        }));

        function handleDisconnect(_x333) {
          return _handleDisconnect.apply(this, arguments);
        }

        return handleDisconnect;
      }()
    }, {
      key: "filterTobeMutedTracks",
      value: function filterTobeMutedTracks(e) {
        var t = [];
        if (-1 === this.getAllTracks().indexOf(e)) return t;
        var i = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e instanceof cw && (null == i ? void 0 : i.track) instanceof uw) return i.track.isActive || t.push([Ev.LocalAudioTrack, i]), t;
        var n = Array.from(this.localTrackMap.entries()).find(function (t) {
          var _t206 = _slicedToArray(t, 2),
              i = _t206[1].track;

          return e === i;
        });

        if (n && (t.push(n), n[0] === Ev.LocalVideoTrack)) {
          var _e245 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

          _e245 && t.push([Ev.LocalVideoLowTrack, _e245]);
        }

        return t;
      }
    }, {
      key: "filterTobeUnmutedTracks",
      value: function filterTobeUnmutedTracks(e) {
        var t = [],
            i = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e instanceof cw && (null == i ? void 0 : i.track) instanceof uw) return i.track.isActive && t.push([Ev.LocalAudioTrack, i]), t;
        var n = Array.from(this.localTrackMap.entries()).find(function (t) {
          var _t207 = _slicedToArray(t, 2),
              i = _t207[1].track;

          return e === i;
        });
        if (n) if (n[0] === Ev.LocalVideoTrack) {
          t.push(n);

          var _e246 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

          _e246 && t.push([Ev.LocalVideoLowTrack, _e246]);
        } else t.push(n);
        return t;
      }
    }, {
      key: "createMuteMessage",
      value: function createMuteMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e247 = _slicedToArray(e, 2),
              n = _e247[0],
              _e247$ = _e247[1],
              s = _e247$.track,
              r = _e247$.ssrcs,
              o = _e247$.id;

          switch (n) {
            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "createUnmuteMessage",
      value: function createUnmuteMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e248 = _slicedToArray(e, 2),
              n = _e248[0],
              _e248$ = _e248[1],
              s = _e248$.track,
              r = _e248$.ssrcs,
              o = _e248$.id;

          switch (n) {
            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "filterTobeUnSubscribedTracks",
      value: function filterTobeUnSubscribedTracks(e, t) {
        var i = [],
            n = this.remoteUserMap.get(e);
        if (!n) return i;

        if (t) {
          var _s61 = n.get(t);

          if (!_s61) return i;
          i.push([e, {
            kind: t,
            id: _s61
          }]);
        } else Array.from(n.entries()).forEach(function (t) {
          var _t208 = _slicedToArray(t, 2),
              n = _t208[0],
              s = _t208[1];

          i.push([e, {
            kind: n,
            id: s
          }]);
        });

        return i;
      }
    }, {
      key: "createUnsubscribeMessage",
      value: function createUnsubscribeMessage(e) {
        var t = [];
        return e.forEach(function (e) {
          var _e249 = _slicedToArray(e, 2),
              i = _e249[0],
              _e249$ = _e249[1],
              n = _e249$.kind,
              s = _e249$.id;

          switch (n) {
            case hv.VIDEO:
              return void (i._videoSSRC && t.push({
                stream_type: hv.VIDEO,
                ssrcId: i._videoSSRC
              }));

            case hv.AUDIO:
              return void (i._audioSSRC && t.push({
                stream_type: hv.AUDIO,
                ssrcId: i._audioSSRC
              }));
          }
        }), t;
      }
    }, {
      key: "withdrawRemoteTracks",
      value: function withdrawRemoteTracks(e) {
        var _this211 = this;

        e.forEach(function (e) {
          var _e250 = _slicedToArray(e, 2),
              t = _e250[0],
              i = _e250[1].kind;

          var n = _this211.remoteUserMap.get(t);

          n && (n.delete(i), 0 === Array.from(n.entries()).length && _this211.remoteUserMap.delete(t));
        });
      }
    }, {
      key: "updateBitrateLimit",
      value: function () {
        var _updateBitrateLimit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee206(e) {
          var t, i;
          return _regeneratorRuntime.wrap(function _callee206$(_context206) {
            while (1) {
              switch (_context206.prev = _context206.next) {
                case 0:
                  t = this.localTrackMap.get(Ev.LocalVideoTrack), i = this.localTrackMap.get(Ev.LocalVideoLowTrack);
                  _context206.t0 = t;

                  if (!_context206.t0) {
                    _context206.next = 5;
                    break;
                  }

                  _context206.next = 5;
                  return t.track.setBitrateLimit(e.uplink);

                case 5:
                  _context206.t1 = i && e.low_stream_uplink;

                  if (!_context206.t1) {
                    _context206.next = 9;
                    break;
                  }

                  _context206.next = 9;
                  return i.track.setBitrateLimit({
                    max_bitrate: e.low_stream_uplink.bitrate,
                    min_bitrate: e.low_stream_uplink.bitrate || 0
                  });

                case 9:
                case "end":
                  return _context206.stop();
              }
            }
          }, _callee206, this);
        }));

        function updateBitrateLimit(_x334) {
          return _updateBitrateLimit.apply(this, arguments);
        }

        return updateBitrateLimit;
      }()
    }, {
      key: "isP2PDisconnected",
      value: function isP2PDisconnected() {
        if (this.sendConnection && this.recvConnection) {
          var _e251 = this.sendConnection.peerConnectionState,
              _t209 = this.recvConnection.peerConnectionState;
          return "connected" !== _e251 && "connected" !== _t209;
        }

        return !0;
      }
    }, {
      key: "tryToUnmuteAudio",
      value: function () {
        var _tryToUnmuteAudio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee207(e) {
          var _t210, i, _n99;

          return _regeneratorRuntime.wrap(function _callee207$(_context207) {
            while (1) {
              switch (_context207.prev = _context207.next) {
                case 0:
                  _t210 = 0;

                case 1:
                  if (!(_t210 < e.length)) {
                    _context207.next = 13;
                    break;
                  }

                  if (!(e[_t210] instanceof cw)) {
                    _context207.next = 10;
                    break;
                  }

                  i = this.filterTobeUnmutedTracks(e[_t210]);

                  if (!(0 === i.length)) {
                    _context207.next = 6;
                    break;
                  }

                  return _context207.abrupt("continue", 10);

                case 6:
                  _n99 = this.createUnmuteMessage(i);
                  _context207.next = 9;
                  return Tg(this, fv.RequestUnmuteLocal, _n99);

                case 9:
                  return _context207.abrupt("return", void _context207.sent);

                case 10:
                  _t210++;
                  _context207.next = 1;
                  break;

                case 13:
                case "end":
                  return _context207.stop();
              }
            }
          }, _callee207, this);
        }));

        function tryToUnmuteAudio(_x335) {
          return _tryToUnmuteAudio.apply(this, arguments);
        }

        return tryToUnmuteAudio;
      }()
    }, {
      key: "bindStatsUploaderEvents",
      value: function bindStatsUploaderEvents() {
        var _this212 = this;

        this.statsUploader.requestStats = function (e) {
          return _this212.getStats(e);
        }, this.statsUploader.requestLocalMedia = function () {
          return Array.from(_this212.localTrackMap.entries()).filter(function (e) {
            var _e252 = _slicedToArray(e, 2),
                t = _e252[1].ssrcs;

            return !!t;
          });
        }, this.statsUploader.requestRemoteMedia = function () {
          return Array.from(_this212.remoteUserMap.entries());
        }, this.statsUploader.requestVideoIsReady = function (e) {
          var t;
          return !(null === (t = _this212.recvConnection) || void 0 === t || !t.getRemoteVideoIsReady(e));
        }, this.statsUploader.requestUpload = function (e, t) {
          return _this212.emit(fv.RequestUpload, e, t);
        }, this.statsUploader.requestUploadStats = function (e) {
          return _this212.emit(fv.RequestUploadStats, e);
        }, this.statsUploader.requestAllTracks = function () {
          return _this212.getAllTracks();
        };
      }
    }, {
      key: "unbindStatsUploaderEvents",
      value: function unbindStatsUploaderEvents() {
        this.statsUploader.requestStats = void 0, this.statsUploader.requestLocalMedia = void 0, this.statsUploader.requestRemoteMedia = void 0, this.statsUploader.requestVideoIsReady = void 0;
      }
    }, {
      key: "requestReconnect",
      value: function () {
        var _requestReconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee208() {
          return _regeneratorRuntime.wrap(function _callee208$(_context208) {
            while (1) {
              switch (_context208.prev = _context208.next) {
                case 0:
                  this.dtlsFailedCount += 1;
                  _context208.next = 3;
                  return Ug(zg(this.dtlsFailedCount, Jg));

                case 3:
                  this.emit(fv.RequestReconnect);

                case 4:
                case "end":
                  return _context208.stop();
              }
            }
          }, _callee208, this);
        }));

        function requestReconnect() {
          return _requestReconnect.apply(this, arguments);
        }

        return requestReconnect;
      }()
    }, {
      key: "reconnectP2P",
      value: function () {
        var _reconnectP2P = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee209() {
          return _regeneratorRuntime.wrap(function _callee209$(_context209) {
            while (1) {
              switch (_context209.prev = _context209.next) {
                case 0:
                case "end":
                  return _context209.stop();
              }
            }
          }, _callee209);
        }));

        function reconnectP2P() {
          return _reconnectP2P.apply(this, arguments);
        }

        return reconnectP2P;
      }()
    }, {
      key: "canPublishLowStream",
      value: function canPublishLowStream() {
        return this.localTrackMap.has(Ev.LocalVideoTrack) || this.pendingLocalTracks.some(function (e) {
          return e instanceof Nw;
        });
      }
    }, {
      key: "throwIfTrackTypeNotMatch",
      value: function throwIfTrackTypeNotMatch(e) {
        if (e.filter(function (e) {
          return e instanceof Nw;
        }).length > 1) throw new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
        if (e.filter(function (e) {
          return e instanceof cw;
        }).length > 1 && (e.some(function (e) {
          return e instanceof cw && e._bypassWebAudio;
        }) || !wA().webAudioMediaStreamDest)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");

        var _iterator27 = _createForOfIteratorHelper(e),
            _step27;

        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var _t211 = _step27.value;
            if (_t211 instanceof Nw && this.pendingLocalTracks.some(function (e) {
              return e instanceof Nw;
            })) throw new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
            if (_t211 instanceof cw && this.pendingLocalTracks.some(function (e) {
              return e instanceof cw;
            }) && (!wA().webAudioMediaStreamDest || _t211._bypassWebAudio || this.pendingLocalTracks.some(function (e) {
              return e instanceof cw && e._bypassWebAudio;
            }))) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }
    }, {
      key: "getLowVideoTrack",
      value: function getLowVideoTrack(e, t) {
        var i = !DC("DISABLE_DUAL_STREAM_USE_ENCODING") && wA().supportDualStreamEncoding,
            n = ok(ok({}, {
          width: 160,
          height: 120,
          framerate: 15,
          bitrate: 50
        }), t);
        var s;
        s = i ? e._mediaStreamTrack.clone() : FL(e, n);
        var r = xg(8, "track-low-"),
            o = new Nw(s, ok(ok({}, i && {
          scaleResolutionDownBy: Ny(n, e)
        }), {}, {
          frameRate: n.framerate,
          bitrateMax: n.bitrate,
          bitrateMin: n.bitrate
        }), void 0, void 0, r);
        return o.on(XA.TRANSCEIVER_UPDATED, function (t) {
          e._updateRtpTransceiver(t, qA.LOW_STREAM);
        }), o._hints.push(YA.LOW_STREAM), e.addListener(KA.NEED_CLOSE, function () {
          o.close();
        }), o;
      }
    }, {
      key: "globalLock",
      value: function () {
        var _globalLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee210() {
          return _regeneratorRuntime.wrap(function _callee210$(_context210) {
            while (1) {
              switch (_context210.prev = _context210.next) {
                case 0:
                  return _context210.abrupt("return", this.recvMutex.lock("From P2PChannel2.globalLock"));

                case 1:
                case "end":
                  return _context210.stop();
              }
            }
          }, _callee210, this);
        }));

        function globalLock() {
          return _globalLock.apply(this, arguments);
        }

        return globalLock;
      }()
    }, {
      key: "reportVideoFirstFrameDecoded",
      value: function reportVideoFirstFrameDecoded(e, t, i, n) {
        var s;
        var r = Array.from(uh(s = this.remoteUserMap).call(s)).find(function (t) {
          return t._videoSSRC === e;
        });

        if (r) {
          n || this.store.subscribe(r.uid, "video", void 0, void 0, void 0, void 0, Date.now());

          var _s62 = this.store.keyMetrics,
              _o26 = _s62.subscribe.find(function (e) {
            return e.userId === r.uid && "video" === e.type;
          });

          rI.firstRemoteVideoDecode(this.store.sessionId, QC.FIRST_VIDEO_DECODE, ZC.FIRST_VIDEO_DECODE, {
            peer: r._uintid,
            videowidth: t,
            videoheight: i,
            subscribeElapse: TP.measureFromSubscribeStart(this.store.clientId, e),
            subscribeRequestid: e,
            p2pid: this.store.p2pId,
            apEnd: _s62.requestAPEnd || 0,
            apStart: _s62.requestAPStart || 0,
            joinGwEnd: _s62.joinGatewayEnd || 0,
            joinGwStart: _s62.joinGatewayStart || 0,
            pcEnd: _s62.peerConnectionEnd || 0,
            pcStart: _s62.peerConnectionStart || 0,
            subscriberEnd: (null == _o26 ? void 0 : _o26.subscribeEnd) || 0,
            subscriberStart: (null == _o26 ? void 0 : _o26.subscribeStart) || 0,
            videoAddNotify: (null == _o26 ? void 0 : _o26.streamAdded) || 0,
            state: n ? 1 : 0
          });
        }
      }
    }, {
      key: "remoteMediaSsrcChanged",
      value: function () {
        var _remoteMediaSsrcChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee211(e, t, i) {
          var n, s, r;
          return _regeneratorRuntime.wrap(function _callee211$(_context211) {
            while (1) {
              switch (_context211.prev = _context211.next) {
                case 0:
                  if (this.recvConnection) {
                    _context211.next = 2;
                    break;
                  }

                  return _context211.abrupt("return", !1);

                case 2:
                  n = this.remoteUserMap.get(e);

                  if (n) {
                    _context211.next = 5;
                    break;
                  }

                  return _context211.abrupt("return", !1);

                case 5:
                  s = n.get(t);

                  if (s) {
                    _context211.next = 8;
                    break;
                  }

                  return _context211.abrupt("return", !1);

                case 8:
                  _context211.next = 10;
                  return this.recvConnection.getRemoteSSRC(s);

                case 10:
                  r = _context211.sent;
                  return _context211.abrupt("return", void 0 !== r && r !== i);

                case 12:
                case "end":
                  return _context211.stop();
              }
            }
          }, _callee211, this);
        }));

        function remoteMediaSsrcChanged(_x336, _x337, _x338) {
          return _remoteMediaSsrcChanged.apply(this, arguments);
        }

        return remoteMediaSsrcChanged;
      }()
    }, {
      key: "resetConnection",
      value: function resetConnection(e) {
        YC.debug("[".concat(this.store.clientId, "] [P2PChannel2] reset connection to ").concat(e)), this.state === mv.Connected ? (YC.debug("[".concat(this.store.clientId, "] [P2PChannel2] fallback to websocket but P2PChannel2 state still connected, disconnect first")), this.disconnectForReconnect()) : (this.sendConnection && (this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection), this.sendConnection = void 0), this.recvConnection && (this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection), this.recvConnection = void 0));
      }
    }, {
      key: "publishDataChannel",
      value: function () {
        var _publishDataChannel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee212(e) {
          return _regeneratorRuntime.wrap(function _callee212$(_context212) {
            while (1) {
              switch (_context212.prev = _context212.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context212.stop();
              }
            }
          }, _callee212);
        }));

        function publishDataChannel(_x339) {
          return _publishDataChannel2.apply(this, arguments);
        }

        return publishDataChannel;
      }()
    }, {
      key: "unpublishDataChannel",
      value: function () {
        var _unpublishDataChannel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee213(e) {
          return _regeneratorRuntime.wrap(function _callee213$(_context213) {
            while (1) {
              switch (_context213.prev = _context213.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context213.stop();
              }
            }
          }, _callee213);
        }));

        function unpublishDataChannel(_x340) {
          return _unpublishDataChannel2.apply(this, arguments);
        }

        return unpublishDataChannel;
      }()
    }, {
      key: "subscribeDataChannel",
      value: function () {
        var _subscribeDataChannel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee214(e, t) {
          return _regeneratorRuntime.wrap(function _callee214$(_context214) {
            while (1) {
              switch (_context214.prev = _context214.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context214.stop();
              }
            }
          }, _callee214);
        }));

        function subscribeDataChannel(_x341, _x342) {
          return _subscribeDataChannel2.apply(this, arguments);
        }

        return subscribeDataChannel;
      }()
    }, {
      key: "unsubscribeDataChannel",
      value: function () {
        var _unsubscribeDataChannel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee215(e, t) {
          return _regeneratorRuntime.wrap(function _callee215$(_context215) {
            while (1) {
              switch (_context215.prev = _context215.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context215.stop();
              }
            }
          }, _callee215);
        }));

        function unsubscribeDataChannel(_x343, _x344) {
          return _unsubscribeDataChannel2.apply(this, arguments);
        }

        return unsubscribeDataChannel;
      }()
    }, {
      key: "hasPendingRemoteDataChannel",
      value: function hasPendingRemoteDataChannel(e, t) {
        throw new VT(xT.NOT_SUPPORTED);
      }
    }, {
      key: "setPendingRemoteDataChannel",
      value: function setPendingRemoteDataChannel(e, t) {
        throw new VT(xT.NOT_SUPPORTED);
      }
    }, {
      key: "preConnect",
      value: function () {
        var _preConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee216(e, t, i, n, s, r) {
          return _regeneratorRuntime.wrap(function _callee216$(_context216) {
            while (1) {
              switch (_context216.prev = _context216.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context216.stop();
              }
            }
          }, _callee216);
        }));

        function preConnect(_x345, _x346, _x347, _x348, _x349, _x350) {
          return _preConnect.apply(this, arguments);
        }

        return preConnect;
      }()
    }, {
      key: "getEstablishParams",
      value: function getEstablishParams() {
        throw new VT(xT.NOT_SUPPORTED);
      }
    }, {
      key: "reSubscribe",
      value: function () {
        var _reSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee217(e) {
          return _regeneratorRuntime.wrap(function _callee217$(_context217) {
            while (1) {
              switch (_context217.prev = _context217.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context217.stop();
              }
            }
          }, _callee217);
        }));

        function reSubscribe(_x351) {
          return _reSubscribe.apply(this, arguments);
        }

        return reSubscribe;
      }()
    }, {
      key: "updateVideoStreamParameter",
      value: function () {
        var _updateVideoStreamParameter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee218(e, t) {
          return _regeneratorRuntime.wrap(function _callee218$(_context218) {
            while (1) {
              switch (_context218.prev = _context218.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED);

                case 1:
                case "end":
                  return _context218.stop();
              }
            }
          }, _callee218);
        }));

        function updateVideoStreamParameter(_x352, _x353) {
          return _updateVideoStreamParameter.apply(this, arguments);
        }

        return updateVideoStreamParameter;
      }()
    }, {
      key: "unbindRtpTransceiver",
      value: function unbindRtpTransceiver() {
        0 !== this.localTrackMap.size && Array.from(this.localTrackMap.entries()).forEach(function (e) {
          var _e253 = _slicedToArray(e, 2),
              t = _e253[0],
              i = _e253[1].track;

          t === Ev.LocalVideoLowTrack ? i._updateRtpTransceiver(void 0, qA.LOW_STREAM) : i._updateRtpTransceiver(void 0);
        });
      }
    }]);

    return ak;
  }(ig);

  function ck(e) {
    return function (t, i, n) {
      var s = t[i];
      if ("function" != typeof s) throw new Error("Cannot use mutex on object property.");
      return n.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee219() {
        var t,
            n,
            r,
            _e254,
            _e255,
            _e256,
            _t212,
            _args219 = arguments;

        return _regeneratorRuntime.wrap(function _callee219$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                for (t = _args219.length, n = new Array(t), r = 0; r < t; r++) {
                  n[r] = _args219[r];
                }

                _context219.t0 = e;
                _context219.next = _context219.t0 === nk.SEND_ONLY ? 4 : _context219.t0 === nk.RECEIVE_ONLY ? 14 : 24;
                break;

              case 4:
                _context219.next = 6;
                return this.sendMutex.lock("From P2PChannel2.".concat(i));

              case 6:
                _e254 = _context219.sent;
                _context219.prev = 7;
                _context219.next = 10;
                return s.apply(this, n);

              case 10:
                return _context219.abrupt("return", _context219.sent);

              case 11:
                _context219.prev = 11;

                _e254();

                return _context219.finish(11);

              case 14:
                _context219.next = 16;
                return this.recvMutex.lock("From P2PChannel2.".concat(i));

              case 16:
                _e255 = _context219.sent;
                _context219.prev = 17;
                _context219.next = 20;
                return s.apply(this, n);

              case 20:
                return _context219.abrupt("return", _context219.sent);

              case 21:
                _context219.prev = 21;

                _e255();

                return _context219.finish(21);

              case 24:
                _context219.next = 26;
                return this.sendMutex.lock("From P2PChannel2.".concat(i));

              case 26:
                _e256 = _context219.sent;
                _context219.next = 29;
                return this.recvMutex.lock("From P2PChannel2.".concat(i));

              case 29:
                _t212 = _context219.sent;
                _context219.prev = 30;
                _context219.next = 33;
                return s.apply(this, n);

              case 33:
                return _context219.abrupt("return", _context219.sent);

              case 34:
                _context219.prev = 34;
                _e256(), _t212();
                return _context219.finish(34);

              case 37:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee219, this, [[7,, 11, 14], [17,, 21, 24], [30,, 34, 37]]);
      })), n;
    };
  }

  function dk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function lk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? dk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : dk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  UI([ck(nk.SEND_ONLY), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], ak.prototype, "p2pConnect", null), UI([ck(nk.SEND_ONLY), xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], ak.prototype, "unpublish", null), UI([ck(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], ak.prototype, "unpublishLowStream", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String, Number, String]), xI("design:returntype", tT)], ak.prototype, "subscribe", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String, Number, String]), xI("design:returntype", tT)], ak.prototype, "mockSubscribe", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String, Boolean]), xI("design:returntype", tT)], ak.prototype, "unsubscribe", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], ak.prototype, "muteRemote", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], ak.prototype, "unmuteRemote", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], ak.prototype, "hasRemoteMediaWithLock", null), UI([ck(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], ak.prototype, "disconnectForReconnect", null), UI([ck(nk.RECEIVE_ONLY), xI("design:type", Function), xI("design:paramtypes", [ik, String, Number]), xI("design:returntype", tT)], ak.prototype, "remoteMediaSsrcChanged", null);

  var uk = /*#__PURE__*/function () {
    function uk(e) {
      var _this213 = this;

      _classCallCheck(this, uk);

      nh(this, "store", void 0), nh(this, "onStatsException", void 0), nh(this, "onUploadPublishDuration", void 0), nh(this, "onStatsChanged", void 0), nh(this, "localStats", new Map()), nh(this, "remoteStats", new Map()), nh(this, "updateStatsInterval", void 0), nh(this, "trafficStats", void 0), nh(this, "trafficStatsPeerList", []), nh(this, "uplinkStats", void 0), nh(this, "exceptionMonitor", void 0), nh(this, "p2pChannel", void 0), nh(this, "scalabilityMode", uI.L1T1), nh(this, "updateStats", function () {
        _this213.p2pChannel && (_this213.updateRemoteStats(_this213.p2pChannel), _this213.updateLocalStats(_this213.p2pChannel));
      }), this.store = e, this.updateStatsInterval = window.setInterval(this.updateStats, 1e3), this.exceptionMonitor = new mP(), this.exceptionMonitor.on("exception", function (e, t, i) {
        _this213.onStatsException && _this213.onStatsException(e, t, i);
      });
    }

    _createClass(uk, [{
      key: "reset",
      value: function reset() {
        this.localStats = new Map(), this.remoteStats = new Map(), this.trafficStats = void 0, this.trafficStatsPeerList = [], this.uplinkStats = void 0;
      }
    }, {
      key: "getLocalAudioTrackStats",
      value: function getLocalAudioTrackStats() {
        return this.localStats.get(Ev.LocalAudioTrack) || lk({}, tb);
      }
    }, {
      key: "getLocalVideoTrackStats",
      value: function getLocalVideoTrackStats() {
        return this.localStats.get(Ev.LocalVideoTrack) || lk({}, ib);
      }
    }, {
      key: "getRemoteAudioTrackStats",
      value: function getRemoteAudioTrackStats(e) {
        var _this214 = this;

        var t = function (_t213) {
          function t(_x354, _x355) {
            return _t213.apply(this, arguments);
          }

          t.toString = function () {
            return _t213.toString();
          };

          return t;
        }(function (e, t) {
          if (!_this214.trafficStats) return t;

          var i = _this214.trafficStats.peer_delay.find(function (t) {
            return t.peer_uid === e;
          });

          return i && (t.publishDuration = i.B_ppad + (Date.now() - _this214.trafficStats.timestamp)), t;
        }),
            i = {};

        if (e) {
          var n;

          var _s63 = null === (n = this.remoteStats.get(e)) || void 0 === n ? void 0 : n.audioStats;

          _s63 && (i[e] = t(e, _s63));
        } else Array.from(this.remoteStats.entries()).forEach(function (e) {
          var _e257 = _slicedToArray(e, 2),
              n = _e257[0],
              s = _e257[1].audioStats;

          s && (i[n] = t(n, s));
        });

        return i;
      }
    }, {
      key: "getRemoteNetworkQualityStats",
      value: function getRemoteNetworkQualityStats(e) {
        var t = {};

        if (e) {
          var i;

          var _n100 = null === (i = this.remoteStats.get(e)) || void 0 === i ? void 0 : i.networkStats;

          _n100 && (t[e] = _n100);
        } else Array.from(this.remoteStats.entries()).forEach(function (e) {
          var _e258 = _slicedToArray(e, 2),
              i = _e258[0],
              n = _e258[1].networkStats;

          n && (t[i] = n);
        });

        return t;
      }
    }, {
      key: "getRemoteVideoTrackStats",
      value: function getRemoteVideoTrackStats(e) {
        var _this215 = this;

        var t = function (_t214) {
          function t(_x356, _x357) {
            return _t214.apply(this, arguments);
          }

          t.toString = function () {
            return _t214.toString();
          };

          return t;
        }(function (e, t) {
          if (!_this215.trafficStats) return t;

          var i = _this215.trafficStats.peer_delay.find(function (t) {
            return t.peer_uid === e;
          });

          return i && (t.publishDuration = i.B_ppvd + (Date.now() - _this215.trafficStats.timestamp)), t;
        }),
            i = {};

        if (e) {
          var n;

          var _s64 = null === (n = this.remoteStats.get(e)) || void 0 === n ? void 0 : n.videoStats;

          _s64 && (i[e] = t(e, _s64));
        } else Array.from(this.remoteStats.entries()).forEach(function (e) {
          var _e259 = _slicedToArray(e, 2),
              n = _e259[0],
              s = _e259[1].videoStats;

          s && (i[n] = t(n, s));
        });

        return i;
      }
    }, {
      key: "getRTCStats",
      value: function getRTCStats() {
        var e = 0,
            t = 0,
            i = 0,
            n = 0;
        var s = this.localStats.get(Ev.LocalAudioTrack);
        s && (e += s.sendBytes, t += s.sendBitrate);
        var r = this.localStats.get(Ev.LocalVideoTrack);
        r && (e += r.sendBytes, t += r.sendBitrate);
        var o = this.localStats.get(Ev.LocalVideoLowTrack);
        o && (e += o.sendBytes, t += o.sendBitrate), this.remoteStats.forEach(function (e) {
          var t = e.audioStats,
              s = e.videoStats;
          t && (i += t.receiveBytes, n += t.receiveBitrate), s && (i += s.receiveBytes, n += s.receiveBitrate);
        });
        var a = 1;
        return this.trafficStats && (a += this.trafficStats.peer_delay.length), {
          Duration: 0,
          UserCount: a,
          SendBitrate: t,
          SendBytes: e,
          RecvBytes: i,
          RecvBitrate: n,
          OutgoingAvailableBandwidth: this.uplinkStats ? this.uplinkStats.B_uab / 1e3 : 0,
          RTT: this.trafficStats ? 2 * this.trafficStats.B_acd : 0
        };
      }
    }, {
      key: "addLocalStats",
      value: function addLocalStats(e) {
        this.localStats.set(e, void 0);
      }
    }, {
      key: "removeLocalStats",
      value: function removeLocalStats(e) {
        e ? this.localStats.delete(e) : this.localStats.clear();
      }
    }, {
      key: "addRemoteStats",
      value: function addRemoteStats(e) {
        this.remoteStats.set(e, {});
      }
    }, {
      key: "removeRemoteStats",
      value: function removeRemoteStats(e) {
        e ? this.remoteStats.delete(e) : this.remoteStats.clear();
      }
    }, {
      key: "addP2PChannel",
      value: function addP2PChannel(e) {
        this.p2pChannel = e;
      }
    }, {
      key: "updateTrafficStats",
      value: function updateTrafficStats(e) {
        var _this216 = this;

        e.peer_delay = e.peer_delay.filter(function (e) {
          return void 0 !== e.B_ppad || void 0 !== e.B_ppvd;
        });
        e.peer_delay.filter(function (e) {
          return -1 === _this216.trafficStatsPeerList.indexOf(e.peer_uid);
        }).forEach(function (e) {
          var t;
          var i = null === (t = _this216.p2pChannel) || void 0 === t ? void 0 : t.getRemoteMedia(e.peer_uid),
              n = null != i && i.videoSSRC ? TP.measureFromSubscribeStart(_this216.store.clientId, i.videoSSRC) : 0,
              s = null != i && i.audioSSRC ? TP.measureFromSubscribeStart(_this216.store.clientId, i.audioSSRC) : 0;
          void 0 !== e.B_ppad && void 0 !== e.B_ppvd && (_this216.onUploadPublishDuration && _this216.onUploadPublishDuration(e.peer_uid, e.B_ppad, e.B_ppvd, n > s ? n : s), _this216.trafficStatsPeerList.push(e.peer_uid));
        }), this.trafficStats = e;
      }
    }, {
      key: "updateUplinkStats",
      value: function updateUplinkStats(e) {
        this.uplinkStats && this.uplinkStats.B_fir !== e.B_fir && YC.debug("[".concat(this.store.clientId, "]: Period fir changes to ").concat(e.B_fir)), this.uplinkStats = e;
      }
    }, {
      key: "isLocalVideoFreeze",
      value: function isLocalVideoFreeze(e) {
        return !(!e.inputFrame || !e.sentFrame) && e.inputFrame.frameRate > 5 && e.sentFrame.frameRate < 3;
      }
    }, {
      key: "updateLocalStats",
      value: function updateLocalStats(e) {
        var _this217 = this;

        Array.from(this.localStats.entries()).forEach(function (t) {
          var _t215 = _slicedToArray(t, 2),
              i = _t215[0],
              n = _t215[1];

          switch (i) {
            case Ev.LocalVideoTrack:
            case Ev.LocalVideoLowTrack:
              {
                var _t216 = n,
                    _r35 = lk({}, ib),
                    _o27 = e.getStats(),
                    _a14 = e.getLocalMedia(i);

                if (_o27) {
                  var _i117 = _o27.videoSend.find(function (e) {
                    return e.ssrc === (null == _a14 ? void 0 : _a14.ssrcs[0].ssrcId);
                  });

                  if (_i117) {
                    var _n101 = e.getLocalVideoSize(),
                        _s65 = e.getEncoderConfig(Ev.LocalVideoTrack);

                    "H264" !== _i117.codec && "H265" !== _i117.codec && "VP8" !== _i117.codec && "VP9" !== _i117.codec && "AV1X" !== _i117.codec && "AV1" !== _i117.codec || (_r35.codecType = _i117.codec), _r35.sendBytes = _i117.bytes, _r35.sendBitrate = _t216 ? 8 * Math.max(0, _r35.sendBytes - _t216.sendBytes) : 0, _i117.inputFrame ? (_r35.captureFrameRate = _i117.inputFrame.frameRate, _r35.captureResolutionHeight = _i117.inputFrame.height, _r35.captureResolutionWidth = _i117.inputFrame.width) : _n101 && (_r35.captureResolutionWidth = _n101.width, _r35.captureResolutionHeight = _n101.height), _i117.sentFrame ? (_r35.sendFrameRate = _i117.sentFrame.frameRate, _r35.sendResolutionHeight = _i117.sentFrame.height, _r35.sendResolutionWidth = _i117.sentFrame.width) : _n101 && (_r35.sendResolutionWidth = _n101.width, _r35.sendResolutionHeight = _n101.height), _i117.avgEncodeMs && (_r35.encodeDelay = _i117.avgEncodeMs), _s65 && _s65.bitrateMax && (_r35.targetSendBitrate = 1e3 * _s65.bitrateMax), _r35.sendPackets = _i117.packets, _r35.sendPacketsLost = _i117.packetsLost, _r35.sendJitterMs = _i117.jitterMs, _r35.sendRttMs = _i117.rttMs, _r35.totalDuration = _t216 ? _t216.totalDuration + 1 : 1, _r35.totalFreezeTime = _t216 ? _t216.totalFreezeTime : 0, _this217.isLocalVideoFreeze(_i117) && (_r35.totalFreezeTime += 1), _i117.scalabilityMode && _this217.scalabilityMode !== _i117.scalabilityMode && (YC.debug("[".concat(_this217.store.clientId, "]: The scalabilityMode of the video sending stream is ").concat(_i117.scalabilityMode)), _this217.scalabilityMode = _i117.scalabilityMode);
                  }

                  _this217.trafficStats && (_r35.currentPacketLossRate = (_this217.trafficStats.B_pvlr4 || 0) / 100);
                }

                var s;
                if (_this217.localStats.set(i, _r35), (null == _t216 ? void 0 : _t216.sendResolutionWidth) !== _r35.sendResolutionWidth || (null == _t216 ? void 0 : _t216.sendResolutionHeight) !== _r35.sendResolutionHeight) null === (s = _this217.onStatsChanged) || void 0 === s || s.call(_this217, "resolution", {
                  width: _r35.sendResolutionWidth,
                  height: _r35.sendResolutionHeight
                });
                _r35 && _a14 && _this217.exceptionMonitor.setLocalVideoStats(_this217.store.uid, _a14.track, _r35);
                break;
              }

            case Ev.LocalAudioTrack:
              {
                var _t217 = n,
                    _s66 = lk({}, tb),
                    _r36 = e.getStats(),
                    _o28 = e.getLocalMedia(i);

                if (_r36) {
                  var _i118 = _r36.audioSend.find(function (e) {
                    return e.ssrc === (null == _o28 ? void 0 : _o28.ssrcs[0].ssrcId);
                  });

                  if (_i118) {
                    if ("opus" !== _i118.codec && "aac" !== _i118.codec && "PCMU" !== _i118.codec && "PCMA" !== _i118.codec && "G722" !== _i118.codec || (_s66.codecType = _i118.codec), _i118.inputLevel) _s66.sendVolumeLevel = Math.round(32767 * _i118.inputLevel);else {
                      var _t218 = e.getLocalAudioVolume();

                      _t218 && (_s66.sendVolumeLevel = Math.round(32767 * _t218));
                    }
                    _s66.sendBytes = _i118.bytes, _s66.sendPackets = _i118.packets, _s66.sendPacketsLost = _i118.packetsLost, _s66.sendJitterMs = _i118.jitterMs, _s66.sendRttMs = _i118.rttMs, _s66.sendBitrate = _t217 ? 8 * Math.max(0, _s66.sendBytes - _t217.sendBytes) : 0;
                  }
                }

                _this217.trafficStats && (_s66.currentPacketLossRate = (_this217.trafficStats.B_palr4 || 0) / 100), _this217.localStats.set(Ev.LocalAudioTrack, _s66), _s66 && _o28 && _this217.exceptionMonitor.setLocalAudioStats(_this217.store.uid, _o28.track, _s66);
                break;
              }
          }
        });
      }
    }, {
      key: "updateRemoteStats",
      value: function updateRemoteStats(e) {
        var _this218 = this;

        Array.from(this.remoteStats.entries()).forEach(function (t) {
          var i, n;

          var _t219 = _slicedToArray(t, 2),
              s = _t219[0],
              _t219$ = _t219[1],
              r = _t219$.videoStats,
              o = _t219$.audioStats,
              a = _t219$.videoPcStats;

          var c = o,
              d = r,
              l = a,
              u = lk({}, nb),
              h = lk({}, rb),
              p = lk({}, sb),
              _e$getRemoteMedia = e.getRemoteMedia(s),
              _ = _e$getRemoteMedia.audioTrack,
              E = _e$getRemoteMedia.videoTrack,
              m = _e$getRemoteMedia.audioSSRC,
              f = _e$getRemoteMedia.videoSSRC;

          var T;
          T = e instanceof ak ? e.getStats(!0) : e.getStats();

          var g = null === (i = T) || void 0 === i ? void 0 : i.audioRecv.find(function (e) {
            return e.ssrc === m;
          }),
              S = null === (n = T) || void 0 === n ? void 0 : n.videoRecv.find(function (e) {
            return e.ssrc === f;
          }),
              R = _this218.trafficStats && _this218.trafficStats.peer_delay.find(function (e) {
            return e.peer_uid === s;
          });

          if (g && ("opus" !== g.codec && "aac" !== g.codec && "PCMU" !== g.codec && "PCMA" !== g.codec && "G722" !== g.codec || (u.codecType = g.codec), g.outputLevel ? u.receiveLevel = Math.round(32767 * g.outputLevel) : _ && (u.receiveLevel = Math.round(32767 * _.getVolumeLevel())), u.receiveBytes = g.bytes, u.receivePackets = g.packets, u.receivePacketsLost = g.packetsLost, u.packetLossRate = u.receivePacketsLost / (u.receivePackets + u.receivePacketsLost), u.receiveBitrate = c ? 8 * Math.max(0, u.receiveBytes - c.receiveBytes) : 0, u.totalDuration = c ? c.totalDuration + 1 : 1, u.totalFreezeTime = c ? c.totalFreezeTime : 0, u.freezeRate = u.totalFreezeTime / u.totalDuration, u.receiveDelay = g.jitterBufferMs, u.totalDuration > 10 && uk.isRemoteAudioFreeze(_) && (u.totalFreezeTime += 1)), S) {
            "H264" !== S.codec && "H265" !== S.codec && "VP8" !== S.codec && "VP9" !== S.codec && "AV1X" !== S.codec && "AV1" !== S.codec || (h.codecType = S.codec), h.receiveBytes = S.bytes, h.receiveBitrate = d ? 8 * Math.max(0, h.receiveBytes - d.receiveBytes) : 0, h.decodeFrameRate = S.decodeFrameRate < 0 ? 0 : S.decodeFrameRate, h.renderFrameRate = S.decodeFrameRate < 0 ? 0 : S.decodeFrameRate, S.outputFrame && (h.renderFrameRate = S.outputFrame.frameRate), S.receivedFrame ? (h.receiveFrameRate = S.receivedFrame.frameRate, h.receiveResolutionHeight = S.receivedFrame.height, h.receiveResolutionWidth = S.receivedFrame.width) : E && (h.receiveResolutionHeight = E._videoHeight || 0, h.receiveResolutionWidth = E._videoWidth || 0), void 0 !== S.framesRateFirefox && (h.receiveFrameRate = Math.round(S.framesRateFirefox)), h.receivePackets = S.packets, h.receivePacketsLost = S.packetsLost, h.packetLossRate = h.receivePacketsLost / (h.receivePackets + h.receivePacketsLost), h.totalDuration = d ? d.totalDuration + 1 : 1, h.totalFreezeTime = d ? d.totalFreezeTime : 0, h.receiveDelay = S.jitterBufferMs || 0;

            var _t220 = !!f && e.getRemoteVideoIsReady(f);

            E && _t220 && uk.isRemoteVideoFreeze(E, S, l) && (h.totalFreezeTime += 1), h.freezeRate = h.totalFreezeTime / h.totalDuration;
          }

          R && (u.end2EndDelay = R.B_ad, h.end2EndDelay = R.B_vd, u.transportDelay = R.B_ed, h.transportDelay = R.B_ed, u.currentPacketLossRate = R.B_ealr4 / 100, h.currentPacketLossRate = R.B_evlr4 / 100, p.uplinkNetworkQuality = R.B_punq ? R.B_punq : 0, p.downlinkNetworkQuality = R.B_pdnq ? R.B_pdnq : 0), _this218.remoteStats.set(s, {
            audioStats: u,
            videoStats: h,
            videoPcStats: S,
            networkStats: p
          }), _ && _this218.exceptionMonitor.setRemoteAudioStats(_, u), E && _this218.exceptionMonitor.setRemoteVideoStats(E, h);
        });
      }
    }], [{
      key: "isRemoteVideoFreeze",
      value: function isRemoteVideoFreeze(e, t, i) {
        if (!e) return !1;
        var n = !!i && t.framesDecodeFreezeTime > i.framesDecodeFreezeTime,
            s = !i || t.framesDecodeCount > i.framesDecodeCount;
        return n || !s;
      }
    }, {
      key: "isRemoteAudioFreeze",
      value: function isRemoteAudioFreeze(e) {
        return !!e && e._isFreeze();
      }
    }]);

    return uk;
  }();

  function hk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function pk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? hk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : hk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var _k = /*#__PURE__*/function (_ig27) {
    _inherits(_k, _ig27);

    var _super58 = _createSuper(_k);

    function _k(e, t, i, n) {
      var _this219;

      _classCallCheck(this, _k);

      _this219 = _super58.call(this), nh(_assertThisInitialized(_this219), "spec", void 0), nh(_assertThisInitialized(_this219), "token", void 0), nh(_assertThisInitialized(_this219), "websocket", void 0), nh(_assertThisInitialized(_this219), "pingpongTimer", void 0), nh(_assertThisInitialized(_this219), "reconnectMode", "retry"), nh(_assertThisInitialized(_this219), "serviceMode", void 0), nh(_assertThisInitialized(_this219), "reqId", 0), nh(_assertThisInitialized(_this219), "commandReqId", 0), nh(_assertThisInitialized(_this219), "handleWebSocketOpen", function () {
        _this219.reconnectMode = "retry", _this219.startPingPong();
      }), nh(_assertThisInitialized(_this219), "handleWebSocketMessage", function (e) {
        if (!e.data) return;
        var t = JSON.parse(e.data);
        t.requestId ? _this219.emit("@".concat(t.requestId, "-").concat(t.sid), t) : _this219.serviceMode === AI.INJECT ? _this219.emit(YI.INJECT_STREAM_STATUS, t) : (rI.workerEvent(_this219.spec.sid, {
          actionType: "status",
          serverCode: t.code,
          workerType: _this219.serviceMode === AI.TRANSCODE ? 1 : 2
        }), _this219.emit(YI.PUBLISH_STREAM_STATUS, t));
      }), _this219.spec = t, _this219.token = e, _this219.serviceMode = n, _this219.websocket = new $v("live-streaming", i), _this219.websocket.on(yI.CONNECTED, _this219.handleWebSocketOpen), _this219.websocket.on(yI.ON_MESSAGE, _this219.handleWebSocketMessage), _this219.websocket.on(yI.REQUEST_NEW_URLS, function (e, t) {
        fg(_assertThisInitialized(_this219), YI.REQUEST_NEW_ADDRESS).then(e).catch(t);
      }), _this219.websocket.on(yI.RECONNECTING, function () {
        _this219.websocket.reconnectMode = _this219.reconnectMode;
      });
      return _this219;
    }

    _createClass(_k, [{
      key: "init",
      value: function init(e) {
        return this.websocket.init(e);
      }
    }, {
      key: "request",
      value: function () {
        var _request4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee220(e, t, i, n) {
          var _this220 = this;

          var s, r, o, a, c, d, l;
          return _regeneratorRuntime.wrap(function _callee220$(_context220) {
            while (1) {
              switch (_context220.prev = _context220.next) {
                case 0:
                  this.reqId += 1, "request" === e && (this.commandReqId += 1);
                  s = this.commandReqId, r = this.reqId;

                  if (!(!r || !this.websocket)) {
                    _context220.next = 4;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR);

                case 4:
                  o = pk({
                    command: e,
                    sdkVersion: "4.20.0" === yC ? "0.0.1" : yC,
                    seq: r,
                    requestId: r,
                    allocate: i,
                    cname: this.spec.cname,
                    appId: this.spec.appId,
                    sid: this.spec.sid,
                    uid: this.spec.uid.toString(),
                    ts: Math.floor(Date.now() / 1e3)
                  }, t);

                  if (!("closed" === this.websocket.state)) {
                    _context220.next = 7;
                    break;
                  }

                  throw new VI(xT.WS_DISCONNECT);

                case 7:
                  a = function a() {
                    return new tT(function (e, t) {
                      _this220.websocket.once(yI.CLOSED, function () {
                        return t(new VI(xT.WS_ABORT));
                      }), _this220.websocket.once(yI.CONNECTED, e);
                    });
                  };

                  _context220.t0 = "connected" !== this.websocket.state;

                  if (!_context220.t0) {
                    _context220.next = 12;
                    break;
                  }

                  _context220.next = 12;
                  return a();

                case 12:
                  o.clientRequest && (o.clientRequest.workerToken = this.token);
                  c = new tT(function (e, t) {
                    var i = function i() {
                      t(new VI(xT.WS_ABORT));
                    };

                    _this220.websocket.once(yI.RECONNECTING, i), _this220.websocket.once(yI.CLOSED, i), _this220.once("@".concat(r, "-").concat(_this220.spec.sid), function (t) {
                      e(t);
                    });
                  });
                  n && rI.workerEvent(this.spec.sid, pk(pk({}, n), {}, {
                    requestId: s,
                    actionType: "request",
                    payload: JSON.stringify(t.clientRequest),
                    serverCode: 0,
                    code: 0
                  }));
                  d = Date.now();
                  this.websocket.sendMessage(o);
                  l = null;
                  _context220.prev = 18;
                  _context220.next = 21;
                  return c;

                case 21:
                  l = _context220.sent;
                  _context220.next = 33;
                  break;

                case 24:
                  _context220.prev = 24;
                  _context220.t1 = _context220["catch"](18);

                  if (!("closed" === this.websocket.state)) {
                    _context220.next = 28;
                    break;
                  }

                  throw _context220.t1;

                case 28:
                  _context220.next = 30;
                  return a();

                case 30:
                  _context220.next = 32;
                  return this.request(e, t, i);

                case 32:
                  return _context220.abrupt("return", _context220.sent);

                case 33:
                  return _context220.abrupt("return", (n && rI.workerEvent(this.spec.sid, pk(pk({}, n), {}, {
                    requestId: s,
                    actionType: "response",
                    payload: JSON.stringify(l.serverResponse),
                    serverCode: l.code,
                    success: 200 === l.code,
                    responseTime: Date.now() - d
                  })), 200 !== l.code && this.handleResponseError(l), l));

                case 34:
                case "end":
                  return _context220.stop();
              }
            }
          }, _callee220, this, [[18, 24]]);
        }));

        function request(_x358, _x359, _x360, _x361) {
          return _request4.apply(this, arguments);
        }

        return request;
      }()
    }, {
      key: "tryNextAddress",
      value: function tryNextAddress() {
        this.reconnectMode = "tryNext", this.websocket.reconnect("tryNext");
      }
    }, {
      key: "close",
      value: function close() {
        var e = "4.20.0" === yC ? "0.0.1" : yC;
        this.reqId += 1, "connected" === this.websocket.state ? (this.websocket.sendMessage({
          command: "request",
          appId: this.spec.appId,
          cname: this.spec.cname,
          uid: this.spec.uid.toString(),
          sdkVersion: e,
          sid: this.spec.sid,
          seq: this.reqId,
          ts: Math.floor(Date.now() / 1e3),
          requestId: this.reqId,
          clientRequest: {
            command: "DestroyWorker"
          }
        }), this.websocket.close(!1, !0)) : this.websocket.close(!1), this.pingpongTimer && (window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0);
      }
    }, {
      key: "handleResponseError",
      value: function handleResponseError(e) {
        switch (e.code) {
          case JI.LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM:
            return void YC.warning("live stream response already exists stream");

          case JI.LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR:
          case JI.LIVE_STREAM_RESPONSE_BAD_STREAM:
          case JI.LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR:
            return new VI(xT.LIVE_STREAMING_INVALID_ARGUMENT, "", {
              code: e.code
            }).throw();

          case JI.LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST:
            if ("UnpublishStream" === e.serverResponse.command || "UninjectStream" === e.serverResponse.command) return;
            throw new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream response wm worker not exist", {
              retry: !0
            });

          case JI.LIVE_STREAM_RESPONSE_NOT_AUTHORIZED:
            return new VI(xT.LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED, "", {
              code: e.code
            }).throw();

          case JI.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE:
            {
              var _t221 = new VI(xT.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE);

              return this.emit(YI.WARNING, _t221, e.serverResponse.url);
            }

          case JI.LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN:
            {
              var _t222 = new VI(xT.LIVE_STREAMING_WARN_FREQUENT_REQUEST);

              return this.emit(YI.WARNING, _t222, e.serverResponse.url);
            }

          case JI.LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH:
            throw new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream response wm worker not exist", {
              retry: !0
            });

          case JI.LIVE_STREAM_RESPONSE_NOT_SUPPORTED:
            return new VI(xT.LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED, "", {
              code: e.code
            }).throw();

          case JI.LIVE_STREAM_RESPONSE_MAX_STREAM_NUM:
            {
              var _t223 = new VI(xT.LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT);

              return this.emit(YI.WARNING, _t223, e.serverResponse.url);
            }

          case JI.LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR:
            return new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "", {
              code: e.code
            }).throw();

          case JI.LIVE_STREAM_RESPONSE_RESOURCE_LIMIT:
            throw new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream resource limit", {
              retry: !0,
              changeAddress: !0
            });

          case JI.LIVE_STREAM_RESPONSE_WORKER_LOST:
          case JI.LIVE_STREAM_RESPONSE_WORKER_QUIT:
            if ("UnpublishStream" === e.serverResponse.command || "UninjectStream" === e.serverResponse.command) return;
            throw new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", {
              retry: !0,
              changeAddress: !0
            });

          case JI.ERROR_FAIL_SEND_MESSAGE:
            if ("UnpublishStream" === e.serverResponse.command || "UninjectStream" === e.serverResponse.command) return;
            if ("UpdateTranscoding" === e.serverResponse.command || "ControlStream" === e.serverResponse.command) return new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", {
              code: e.code
            }).throw();
            throw new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", {
              retry: !0,
              changeAddress: !0
            });

          case JI.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH:
            return new VI(xT.LIVE_STREAMING_CDN_ERROR, "", {
              code: e.code
            }).throw();
        }
      }
    }, {
      key: "startPingPong",
      value: function startPingPong() {
        var _this221 = this;

        this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(function () {
          "connected" === _this221.websocket.state && _this221.request("ping", {}).catch(Fg);
        }, 6e3);
      }
    }]);

    return _k;
  }(ig);

  function Ek(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function mk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ek(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Ek(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var fk = /*#__PURE__*/function (_ig28) {
    _inherits(fk, _ig28);

    var _super59 = _createSuper(fk);

    function fk(e) {
      var _this222;

      _classCallCheck(this, fk);

      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Jg,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Jg;
      _this222 = _super59.call(this), nh(_assertThisInitialized(_this222), "onLiveStreamWarning", void 0), nh(_assertThisInitialized(_this222), "onLiveStreamError", void 0), nh(_assertThisInitialized(_this222), "onInjectStatusChange", void 0), nh(_assertThisInitialized(_this222), "spec", void 0), nh(_assertThisInitialized(_this222), "retryTimeout", 1e4), nh(_assertThisInitialized(_this222), "connection", void 0), nh(_assertThisInitialized(_this222), "httpRetryConfig", void 0), nh(_assertThisInitialized(_this222), "wsRetryConfig", void 0), nh(_assertThisInitialized(_this222), "streamingTasks", new Map()), nh(_assertThisInitialized(_this222), "isStartingStreamingTask", !1), nh(_assertThisInitialized(_this222), "taskMutex", new Yg("live-streaming")), nh(_assertThisInitialized(_this222), "cancelToken", EC.CancelToken.source()), nh(_assertThisInitialized(_this222), "transcodingConfig", void 0), nh(_assertThisInitialized(_this222), "injectConfig", mk({}, KI)), nh(_assertThisInitialized(_this222), "injectLoopTimes", 0), nh(_assertThisInitialized(_this222), "uapResponse", void 0), nh(_assertThisInitialized(_this222), "lastTaskId", 1), nh(_assertThisInitialized(_this222), "statusError", new Map()), _this222.spec = e, _this222.httpRetryConfig = i, _this222.wsRetryConfig = t;
      return _this222;
    }

    _createClass(fk, [{
      key: "setTranscodingConfig",
      value: function () {
        var _setTranscodingConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee221(e) {
          var _this223 = this;

          var t, i, n, s, _e260;

          return _regeneratorRuntime.wrap(function _callee221$(_context221) {
            while (1) {
              switch (_context221.prev = _context221.next) {
                case 0:
                  t = mk(mk({}, HI), e);
                  66 !== t.videoCodecProfile && 77 !== t.videoCodecProfile && 100 !== t.videoCodecProfile && (YC.debug("[".concat(this.spec.clientId, "] set transcoding config, fix video codec profile: ").concat(t.videoCodecProfile, " -> 100")), t.videoCodecProfile = 100), t.transcodingUsers || (t.transcodingUsers = t.userConfigs), t.transcodingUsers && (t.transcodingUsers = t.transcodingUsers.map(function (e) {
                    return mk(mk(mk({}, jI), e), {}, {
                      zOrder: e.zOrder ? e.zOrder + 1 : 1
                    });
                  })), function (e) {
                    KT(e.width) || jT(e.width, "config.width", 0, 1e4), KT(e.height) || jT(e.height, "config.height", 0, 1e4), KT(e.videoBitrate) || jT(e.videoBitrate, "config.videoBitrate", 1, 1e6), KT(e.videoFrameRate) || jT(e.videoFrameRate, "config.videoFrameRate"), KT(e.lowLatency) || FT(e.lowLatency, "config.lowLatency"), KT(e.audioSampleRate) || BT(e.audioSampleRate, "config.audioSampleRate", [32e3, 44100, 48e3]), KT(e.audioBitrate) || jT(e.audioBitrate, "config.audioBitrate", 1, 128), KT(e.audioChannels) || BT(e.audioChannels, "config.audioChannels", [1, 2, 3, 4, 5]), KT(e.videoGop) || jT(e.videoGop, "config.videoGop"), KT(e.videoCodecProfile) || BT(e.videoCodecProfile, "config.videoCodecProfile", [66, 77, 100]), KT(e.userCount) || jT(e.userCount, "config.userCount", 0, 17), KT(e.backgroundColor) || jT(e.backgroundColor, "config.backgroundColor", 0, 16777215), KT(e.userConfigExtraInfo) || WT(e.userConfigExtraInfo, "config.userConfigExtraInfo", 0, 4096, !1), e.transcodingUsers && !KT(e.transcodingUsers) && (HT(e.transcodingUsers, "config.transcodingUsers"), e.transcodingUsers.forEach(function (e, t) {
                      BI(e.uid), KT(e.x) || jT(e.x, "transcodingUser[".concat(t, "].x"), 0, 1e4), KT(e.y) || jT(e.y, "transcodingUser[".concat(t, "].y"), 0, 1e4), KT(e.width) || jT(e.width, "transcodingUser[".concat(t, "].width"), 0, 1e4), KT(e.height) || jT(e.height, "transcodingUser[".concat(t, "].height"), 0, 1e4), KT(e.zOrder) || jT(e.zOrder - 1, "transcodingUser[".concat(t, "].zOrder"), 0, 100), KT(e.alpha) || jT(e.alpha, "transcodingUser[".concat(t, "].alpha"), 0, 1, !1);
                    })), KT(e.watermark) || WI(e.watermark, "watermark"), KT(e.backgroundImage) || WI(e.backgroundImage, "backgroundImage"), e.images && !KT(e.images) && (HT(e.images, "config.images"), e.images.forEach(function (e, t) {
                      WI(e, "images[".concat(t, "]"));
                    }));
                  }(t);
                  i = [];
                  t.images && i.push.apply(i, _toConsumableArray(t.images.map(function (e) {
                    return mk(mk(mk({}, GI), e), {}, {
                      zOrder: 255
                    });
                  }))), t.backgroundImage && (i.push(mk(mk(mk({}, GI), t.backgroundImage), {}, {
                    zOrder: 0
                  })), delete t.backgroundImage), t.watermark && (i.push(mk(mk(mk({}, GI), t.watermark), {}, {
                    zOrder: 255
                  })), delete t.watermark), t.images = i, t.transcodingUsers && (t.userConfigs = t.transcodingUsers.map(function (e) {
                    return mk({}, e);
                  }), t.userCount = t.transcodingUsers.length, delete t.transcodingUsers);
                  n = (t.userConfigs || []).map(function (e) {
                    return "number" == typeof e.uid ? tT.resolve(e.uid) : TA(e.uid, _this223.spec, _this223.cancelToken.token, _this223.httpRetryConfig);
                  });
                  _context221.next = 7;
                  return tT.all(n);

                case 7:
                  _context221.sent.forEach(function (e, i) {
                    t.userConfigs && t.userConfigs[i] && (t.userConfigs[i].uid = e);
                  });

                  this.transcodingConfig = t;

                  if (!this.connection) {
                    _context221.next = 22;
                    break;
                  }

                  _context221.prev = 10;
                  _context221.next = 13;
                  return this.connection.request("request", {
                    clientRequest: {
                      command: "UpdateTranscoding",
                      transcodingConfig: this.transcodingConfig
                    }
                  }, !1, {
                    command: "UpdateTranscoding",
                    workerType: 1,
                    requestByUser: !0,
                    tid: Array.from(MI(s = this.streamingTasks).call(s)).map(function (e) {
                      return e.taskId;
                    }).join("#")
                  });

                case 13:
                  _e260 = _context221.sent;
                  YC.debug("[".concat(this.spec.clientId, "] update live transcoding config success, code: ").concat(_e260.code, ", config:"), JSON.stringify(this.transcodingConfig));
                  _context221.next = 22;
                  break;

                case 17:
                  _context221.prev = 17;
                  _context221.t0 = _context221["catch"](10);

                  if (!(!_context221.t0.data || !_context221.t0.data.retry)) {
                    _context221.next = 21;
                    break;
                  }

                  throw _context221.t0;

                case 21:
                  _context221.t0.data.changeAddress && this.connection.tryNextAddress(), this.streamingTasks.forEach(function (t) {
                    YC.warning("[".concat(_this223.spec.clientId, "] live streaming receive error"), _context221.t0.toString(), "try to republish", t.url), _this223.startLiveStreamingTask(t.url, t.mode, _context221.t0).then(function () {
                      YC.debug("[".concat(_this223.spec.clientId, "] live streaming republish ").concat(t.url, " success"));
                    }).catch(function (e) {
                      YC.error("[".concat(_this223.spec.clientId, "] live streaming republish failed"), t.url, e.toString()), _this223.onLiveStreamError && _this223.onLiveStreamError(t.url, e);
                    });
                  });

                case 22:
                case "end":
                  return _context221.stop();
              }
            }
          }, _callee221, this, [[10, 17]]);
        }));

        function setTranscodingConfig(_x362) {
          return _setTranscodingConfig.apply(this, arguments);
        }

        return setTranscodingConfig;
      }()
    }, {
      key: "setInjectStreamConfig",
      value: function setInjectStreamConfig(e, t) {
        this.injectConfig = Object.assign({}, this.injectConfig, e), this.injectLoopTimes = t;
      }
    }, {
      key: "startLiveStreamingTask",
      value: function () {
        var _startLiveStreamingTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee222(e, t, i) {
          var _this224 = this;

          var n, s, r, o, _n102, _a15;

          return _regeneratorRuntime.wrap(function _callee222$(_context222) {
            while (1) {
              switch (_context222.prev = _context222.next) {
                case 0:
                  if (!(Array.from(MI(n = this.streamingTasks).call(n)).find(function (e) {
                    return e.mode === AI.INJECT;
                  }) && t === AI.INJECT)) {
                    _context222.next = 2;
                    break;
                  }

                  return _context222.abrupt("return", new VI(xT.LIVE_STREAMING_TASK_CONFLICT, "inject stream over limit").throw());

                case 2:
                  if (!(!this.transcodingConfig && t === AI.TRANSCODE)) {
                    _context222.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[LiveStreaming] no transcoding config found, can not start transcoding streaming task");

                case 4:
                  s = {
                    command: "PublishStream",
                    ts: Date.now(),
                    url: e,
                    uid: this.spec.uid.toString(),
                    autoDestroyTime: 100,
                    acceptImageTimeout: !0
                  };
                  YC.debug("[".concat(this.spec.clientId, "] start live streaming ").concat(e, ", mode: ").concat(t));
                  _context222.next = 8;
                  return this.taskMutex.lock();

                case 8:
                  r = _context222.sent;

                  if (!(!this.connection && i)) {
                    _context222.next = 11;
                    break;
                  }

                  return _context222.abrupt("return", void r());

                case 11:
                  if (!(this.streamingTasks.get(e) && !i)) {
                    _context222.next = 13;
                    break;
                  }

                  return _context222.abrupt("return", (r(), new VI(xT.LIVE_STREAMING_TASK_CONFLICT).throw()));

                case 13:
                  _context222.prev = 13;
                  _context222.t0 = this.connection;

                  if (_context222.t0) {
                    _context222.next = 19;
                    break;
                  }

                  _context222.next = 18;
                  return this.connect(t);

                case 18:
                  this.connection = _context222.sent;

                case 19:
                  _context222.next = 24;
                  break;

                case 21:
                  _context222.prev = 21;
                  _context222.t1 = _context222["catch"](13);
                  throw r(), _context222.t1;

                case 24:
                  _context222.t2 = t;
                  _context222.next = _context222.t2 === AI.TRANSCODE ? 27 : _context222.t2 === AI.RAW ? 29 : _context222.t2 === AI.INJECT ? 30 : 31;
                  break;

                case 27:
                  s.transcodingConfig = mk({}, this.transcodingConfig);
                  return _context222.abrupt("break", 31);

                case 29:
                  return _context222.abrupt("break", 31);

                case 30:
                  s = {
                    cname: this.spec.cname,
                    command: "InjectStream",
                    sid: this.spec.sid,
                    transcodingConfig: this.injectConfig,
                    ts: Date.now(),
                    url: e,
                    loopTimes: this.injectLoopTimes
                  };

                case 31:
                  this.uapResponse && this.uapResponse.vid && (s.vid = this.uapResponse.vid), this.isStartingStreamingTask = !0;
                  o = this.lastTaskId++;
                  _context222.prev = 33;
                  _n102 = new tT(function (t, n) {
                    Ug(_this224.retryTimeout).then(function () {
                      if (i) return n(i);

                      var t = _this224.statusError.get(e);

                      return t ? (_this224.statusError.delete(e), n(t)) : void 0;
                    });
                  });
                  _context222.next = 37;
                  return tT.race([this.connection.request("request", {
                    clientRequest: s
                  }, !0, {
                    url: e,
                    command: "PublishStream",
                    workerType: t === AI.TRANSCODE ? 1 : 2,
                    requestByUser: !i,
                    tid: o.toString()
                  }), _n102]);

                case 37:
                  _a15 = _context222.sent;
                  this.isStartingStreamingTask = !1, YC.debug("[".concat(this.spec.clientId, "] live streaming started, code: ").concat(_a15.code)), this.streamingTasks.set(e, {
                    clientRequest: s,
                    mode: t,
                    url: e,
                    taskId: o
                  }), r();
                  _context222.next = 56;
                  break;

                case 41:
                  _context222.prev = 41;
                  _context222.t3 = _context222["catch"](33);

                  if (!(r(), this.isStartingStreamingTask = !1, !_context222.t3.data || !_context222.t3.data.retry || i)) {
                    _context222.next = 45;
                    break;
                  }

                  throw _context222.t3;

                case 45:
                  if (!_context222.t3.data.changeAddress) {
                    _context222.next = 52;
                    break;
                  }

                  this.connection.tryNextAddress();
                  _context222.next = 49;
                  return this.startLiveStreamingTask(e, t, _context222.t3);

                case 49:
                  _context222.t4 = _context222.sent;
                  _context222.next = 55;
                  break;

                case 52:
                  _context222.next = 54;
                  return this.startLiveStreamingTask(e, t, _context222.t3);

                case 54:
                  _context222.t4 = _context222.sent;

                case 55:
                  return _context222.abrupt("return", _context222.t4);

                case 56:
                case "end":
                  return _context222.stop();
              }
            }
          }, _callee222, this, [[13, 21], [33, 41]]);
        }));

        function startLiveStreamingTask(_x363, _x364, _x365) {
          return _startLiveStreamingTask.apply(this, arguments);
        }

        return startLiveStreamingTask;
      }()
    }, {
      key: "stopLiveStreamingTask",
      value: function stopLiveStreamingTask(e) {
        var _this225 = this;

        return new tT(function (t, i) {
          var n = _this225.streamingTasks.get(e);

          if (!n || !_this225.connection) return new VI(xT.UNEXPECTED_ERROR, "can not find streaming task to stop").throw();
          var s = n.mode;
          n.abortTask = function () {
            YC.debug("[".concat(_this225.spec.clientId, "] stop live streaming success(worker exception)")), _this225.streamingTasks.delete(e), t();
          }, _this225.connection.request("request", {
            clientRequest: {
              command: s === AI.INJECT ? "UninjectStream" : "UnpublishStream",
              url: n.url
            }
          }, !1, {
            url: e,
            command: "UnPublishStream",
            workerType: s === AI.TRANSCODE ? 1 : 2,
            requestByUser: !0,
            tid: (_this225.lastTaskId++).toString()
          }).then(function (i) {
            YC.debug("[".concat(_this225.spec.clientId, "] stop live streaming success, code: ").concat(i.code)), _this225.streamingTasks.delete(e), 0 === _this225.streamingTasks.size && s !== AI.INJECT && (_this225.connection && _this225.connection.close(), _this225.connection = void 0), t(), s === AI.INJECT && _this225.onInjectStatusChange && _this225.onInjectStatusChange(bI.INJECT_STREAM_STATUS_STOP_SUCCESS, _this225.spec.uid, e);
          }).catch(i);
        });
      }
    }, {
      key: "controlInjectStream",
      value: function () {
        var _controlInjectStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee223(e, t, i, n) {
          var s;
          return _regeneratorRuntime.wrap(function _callee223$(_context223) {
            while (1) {
              switch (_context223.prev = _context223.next) {
                case 0:
                  s = this.streamingTasks.get(e);

                  if (!(!s || !this.connection || s.mode !== AI.INJECT)) {
                    _context223.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not find inject stream task to control");

                case 3:
                  _context223.next = 5;
                  return this.connection.request("request", {
                    clientRequest: {
                      command: "ControlStream",
                      url: e,
                      control: t,
                      audioVolume: i,
                      position: n
                    }
                  });

                case 5:
                  return _context223.abrupt("return", _context223.sent.serverResponse);

                case 6:
                case "end":
                  return _context223.stop();
              }
            }
          }, _callee223, this);
        }));

        function controlInjectStream(_x366, _x367, _x368, _x369) {
          return _controlInjectStream.apply(this, arguments);
        }

        return controlInjectStream;
      }()
    }, {
      key: "resetAllTask",
      value: function resetAllTask() {
        var _this226 = this;

        var e;
        var t = Array.from(MI(e = this.streamingTasks).call(e));
        this.terminate();

        var _loop3 = function _loop3() {
          var e = _t224[_i119];

          _this226.startLiveStreamingTask(e.url, e.mode).catch(function (t) {
            _this226.onLiveStreamError && _this226.onLiveStreamError(e.url, t);
          });
        };

        for (var _i119 = 0, _t224 = t; _i119 < _t224.length; _i119++) {
          _loop3();
        }
      }
    }, {
      key: "terminate",
      value: function terminate() {
        this.cancelToken && this.cancelToken.cancel(), this.streamingTasks = new Map(), this.isStartingStreamingTask = !1, this.statusError = new Map(), this.cancelToken = EC.CancelToken.source(), this.uapResponse = void 0, this.connection && this.connection.close(), this.connection = void 0;
      }
    }, {
      key: "connect",
      value: function () {
        var _connect3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee224(e) {
          var _this227 = this;

          var t;
          return _regeneratorRuntime.wrap(function _callee224$(_context224) {
            while (1) {
              switch (_context224.prev = _context224.next) {
                case 0:
                  if (!this.connection) {
                    _context224.next = 2;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "live streaming connection has already connected");

                case 2:
                  _context224.next = 4;
                  return fg(this, qI.REQUEST_WORKER_MANAGER_LIST, e);

                case 4:
                  t = _context224.sent;
                  this.uapResponse = t;
                  this.connection = new _k(t.workerToken, this.spec, this.wsRetryConfig, e);
                  this.connection.on(YI.WARNING, function (e, t) {
                    return _this227.onLiveStreamWarning && _this227.onLiveStreamWarning(t, e);
                  });
                  this.connection.on(YI.PUBLISH_STREAM_STATUS, function (e) {
                    return _this227.handlePublishStreamServer(e);
                  });
                  this.connection.on(YI.INJECT_STREAM_STATUS, function (e) {
                    return _this227.handleInjectStreamServerStatus(e);
                  });
                  this.connection.on(YI.REQUEST_NEW_ADDRESS, function (t, i) {
                    if (!_this227.connection) return i(new VI(xT.UNEXPECTED_ERROR, "can not get new live streaming address list"));
                    fg(_this227, qI.REQUEST_WORKER_MANAGER_LIST, e).then(function (e) {
                      _this227.uapResponse = e, t(e.addressList);
                    }).catch(i);
                  });
                  _context224.next = 13;
                  return this.connection.init(t.addressList);

                case 13:
                  return _context224.abrupt("return", this.connection);

                case 14:
                case "end":
                  return _context224.stop();
              }
            }
          }, _callee224, this);
        }));

        function connect(_x370) {
          return _connect3.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "handlePublishStreamServer",
      value: function handlePublishStreamServer(e) {
        var _this228 = this;

        var t = e.serverStatus && e.serverStatus.url || "empty_url",
            i = this.streamingTasks.get(t),
            n = e.reason;

        switch (e.code) {
          case JI.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE:
          case JI.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH:
            {
              var _n103 = new VI(xT.LIVE_STREAMING_CDN_ERROR, "", {
                code: e.code
              });

              if (i) return YC.error(_n103.toString()), this.onLiveStreamError && this.onLiveStreamError(t, _n103);
              if (!this.isStartingStreamingTask) return;
              this.statusError.set(t, _n103);
            }

          case JI.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE:
            {
              var _e261 = new VI(xT.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE, n);

              return this.onLiveStreamWarning && this.onLiveStreamWarning(t, _e261);
            }

          case JI.LIVE_STREAM_RESPONSE_WORKER_LOST:
          case JI.LIVE_STREAM_RESPONSE_WORKER_QUIT:
            {
              var s;
              if (!this.connection) return;
              this.connection.tryNextAddress();

              var _t225 = Array.from(MI(s = this.streamingTasks).call(s));

              var _loop4 = function _loop4() {
                var i = _t226[_i120];
                i.abortTask ? i.abortTask() : (YC.warning("[".concat(_this228.spec.clientId, "] publish stream status code"), e.code, "try to republish", i.url), _this228.startLiveStreamingTask(i.url, i.mode, new VI(xT.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "", {
                  code: e.code
                })).then(function () {
                  YC.debug("[".concat(_this228.spec.clientId, "] republish live stream success"), i.url);
                }).catch(function (e) {
                  YC.error(e.toString()), _this228.onLiveStreamError && _this228.onLiveStreamError(i.url, e);
                }));
              };

              for (var _i120 = 0, _t226 = _t225; _i120 < _t226.length; _i120++) {
                _loop4();
              }

              return;
            }
        }
      }
    }, {
      key: "handleInjectStreamServerStatus",
      value: function handleInjectStreamServerStatus(e) {
        var t = Number(e.uid),
            i = e.serverStatus && e.serverStatus.url;

        switch (e.code) {
          case 200:
            return void (this.onInjectStatusChange && this.onInjectStatusChange(bI.INJECT_STREAM_STATUS_START_SUCCESS, t, i));

          case 451:
            return this.onInjectStatusChange && this.onInjectStatusChange(bI.INJECT_STREAM_STATUS_START_ALREADY_EXISTS, t, i), void this.streamingTasks.delete(i);

          case 453:
            return this.onInjectStatusChange && this.onInjectStatusChange(bI.INJECT_STREAM_STATUS_START_UNAUTHORIZED, t, i), void this.streamingTasks.delete(i);

          case 470:
            return this.onInjectStatusChange && this.onInjectStatusChange(bI.INJECT_STREAM_STATUS_BROKEN, t, i), void this.streamingTasks.delete(i);

          case 499:
            return this.onInjectStatusChange && this.onInjectStatusChange(bI.INJECT_STREAM_STATUS_START_TIMEOUT, t, i), void this.streamingTasks.delete(i);

          default:
            return void YC.debug("inject stream server status", e);
        }
      }
    }, {
      key: "hasUrl",
      value: function hasUrl(e) {
        return this.streamingTasks.has(e);
      }
    }]);

    return fk;
  }(ig);

  var Tk = /*#__PURE__*/function () {
    function Tk() {
      _classCallCheck(this, Tk);

      nh(this, "destChannelMediaInfos", new Map()), nh(this, "srcChannelMediaInfo", void 0);
    }

    _createClass(Tk, [{
      key: "setSrcChannelInfo",
      value: function setSrcChannelInfo(e) {
        ov(e), this.srcChannelMediaInfo = e;
      }
    }, {
      key: "addDestChannelInfo",
      value: function addDestChannelInfo(e) {
        ov(e), this.destChannelMediaInfos.set(e.channelName, e);
      }
    }, {
      key: "removeDestChannelInfo",
      value: function removeDestChannelInfo(e) {
        FI(e), this.destChannelMediaInfos.delete(e);
      }
    }, {
      key: "getSrcChannelMediaInfo",
      value: function getSrcChannelMediaInfo() {
        return this.srcChannelMediaInfo;
      }
    }, {
      key: "getDestChannelMediaInfo",
      value: function getDestChannelMediaInfo() {
        return this.destChannelMediaInfos;
      }
    }]);

    return Tk;
  }();

  function gk(e) {
    if (!(e instanceof Tk)) {
      return new VI(xT.INVALID_PARAMS, "Config should be instance of [ChannelMediaRelayConfiguration]").throw();
    }

    var t = e.getSrcChannelMediaInfo(),
        i = e.getDestChannelMediaInfo();

    if (!t) {
      return new VI(xT.INVALID_PARAMS, "srcChannelMediaInfo should not be empty").throw();
    }

    if (0 === i.size) {
      return new VI(xT.INVALID_PARAMS, "destChannelMediaInfo should not be empty").throw();
    }
  }

  var Sk = /*#__PURE__*/function (_ig29) {
    _inherits(Sk, _ig29);

    var _super60 = _createSuper(Sk);

    function Sk(e, t, i) {
      var _this229;

      _classCallCheck(this, Sk);

      _this229 = _super60.call(this), nh(_assertThisInitialized(_this229), "ws", void 0), nh(_assertThisInitialized(_this229), "requestId", 1), nh(_assertThisInitialized(_this229), "heartBeatTimer", void 0), nh(_assertThisInitialized(_this229), "joinInfo", void 0), nh(_assertThisInitialized(_this229), "clientId", void 0), nh(_assertThisInitialized(_this229), "onOpen", function () {
        _this229.emit("open"), _this229.startHeartBeatCheck();
      }), nh(_assertThisInitialized(_this229), "onClose", function (e) {
        _this229.emit("close"), _this229.dispose();
      }), nh(_assertThisInitialized(_this229), "onMessage", function (e) {
        var t = JSON.parse(e.data);
        if (!t || "serverResponse" !== t.command || !t.requestId) return t && "serverStatus" === t.command && t.serverStatus && t.serverStatus.command ? (_this229.emit("status", t.serverStatus), void _this229.emit(t.serverStatus.command, t.serverStatus)) : void 0;

        _this229.emit("req_".concat(t.requestId), t);
      }), _this229.joinInfo = e, _this229.clientId = t, _this229.ws = new $v("cross-channel-".concat(_this229.clientId), i), _this229.ws.on(yI.RECONNECTING, function () {
        _this229.ws.reconnectMode = "retry", _this229.emit("reconnecting");
      }), _this229.ws.on(yI.CONNECTED, _this229.onOpen), _this229.ws.on(yI.ON_MESSAGE, _this229.onMessage), _this229.ws.on(yI.CLOSED, _this229.onClose);
      return _this229;
    }

    _createClass(Sk, [{
      key: "isConnect",
      value: function isConnect() {
        return "connected" === this.ws.state;
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(e) {
        var t = this.requestId++;
        return e.requestId = t, e.seq = t, this.ws.sendMessage(e), t;
      }
    }, {
      key: "waitStatus",
      value: function waitStatus(e) {
        var _this230 = this;

        return new tT(function (t, i) {
          var n = window.setTimeout(function () {
            i(new VI(xT.TIMEOUT, "wait status timeout, status: ".concat(e)));
          }, 5e3);
          _this230.once(e, function (s) {
            window.clearTimeout(n), s.state && 0 !== s.state ? i(new VI(xT.CROSS_CHANNEL_WAIT_STATUS_ERROR, "wait status error, status: ".concat(e))) : t(void 0);
          }), _this230.once("dispose", function () {
            window.clearTimeout(n), i(new VI(xT.WS_ABORT));
          });
        });
      }
    }, {
      key: "request",
      value: function () {
        var _request5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee225(e) {
          var _this231 = this;

          var t, i, n, s;
          return _regeneratorRuntime.wrap(function _callee225$(_context225) {
            while (1) {
              switch (_context225.prev = _context225.next) {
                case 0:
                  if (!("closed" === this.ws.state)) {
                    _context225.next = 2;
                    break;
                  }

                  throw new VI(xT.WS_DISCONNECT);

                case 2:
                  t = function t() {
                    return new tT(function (e, t) {
                      _this231.ws.once(yI.CLOSED, function () {
                        return t(new VI(xT.WS_ABORT));
                      }), _this231.ws.once(yI.CONNECTED, e);
                    });
                  };

                  _context225.t0 = "connected" !== this.ws.state;

                  if (!_context225.t0) {
                    _context225.next = 7;
                    break;
                  }

                  _context225.next = 7;
                  return t();

                case 7:
                  i = this.sendMessage(e);
                  n = new tT(function (e, t) {
                    var n = function n() {
                      t(new VI(xT.WS_ABORT));
                    };

                    _this231.ws.once(yI.RECONNECTING, n), _this231.ws.once(yI.CLOSED, n), _this231.once("req_".concat(i), e), Ug(3e3).then(function () {
                      _this231.removeAllListeners("req_".concat(i)), _this231.ws.off(yI.RECONNECTING, n), _this231.ws.off(yI.CLOSED, n), t(new VI(xT.TIMEOUT, "cross channel ws request timeout"));
                    });
                  });
                  _context225.next = 11;
                  return n;

                case 11:
                  s = _context225.sent;

                  if (!(!s || 200 !== s.code)) {
                    _context225.next = 14;
                    break;
                  }

                  throw new VI(xT.CROSS_CHANNEL_SERVER_ERROR_RESPONSE, "response: ".concat(JSON.stringify(s)));

                case 14:
                  return _context225.abrupt("return", s);

                case 15:
                case "end":
                  return _context225.stop();
              }
            }
          }, _callee225, this);
        }));

        function request(_x371) {
          return _request5.apply(this, arguments);
        }

        return request;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee226(e) {
          return _regeneratorRuntime.wrap(function _callee226$(_context226) {
            while (1) {
              switch (_context226.prev = _context226.next) {
                case 0:
                  this.ws.removeAllListeners(yI.REQUEST_NEW_URLS);
                  this.ws.on(yI.REQUEST_NEW_URLS, function (t) {
                    t(e);
                  });
                  _context226.next = 4;
                  return this.ws.init(e);

                case 4:
                case "end":
                  return _context226.stop();
              }
            }
          }, _callee226, this);
        }));

        function connect(_x372) {
          return _connect4.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "dispose",
      value: function dispose() {
        this.clearHeartBeatCheck(), this.emit("dispose"), this.removeAllListeners(), this.ws.close();
      }
    }, {
      key: "sendPing",
      value: function sendPing(e) {
        var t = this.requestId++;
        return e.requestId = t, this.ws.sendMessage(e), t;
      }
    }, {
      key: "startHeartBeatCheck",
      value: function startHeartBeatCheck() {
        var _this232 = this;

        this.heartBeatTimer && window.clearInterval(this.heartBeatTimer), this.heartBeatTimer = window.setInterval(function () {
          _this232.sendPing({
            command: "ping",
            appId: _this232.joinInfo.appId,
            cname: _this232.joinInfo.cname,
            uid: _this232.joinInfo.uid.toString(),
            sid: _this232.joinInfo.sid,
            ts: +new Date(),
            requestId: 0
          });
        }, 3e3);
      }
    }, {
      key: "clearHeartBeatCheck",
      value: function clearHeartBeatCheck() {
        window.clearInterval(this.heartBeatTimer), this.heartBeatTimer = void 0;
      }
    }]);

    return Sk;
  }(ig);

  var Rk = /*#__PURE__*/function (_ig30) {
    _inherits(Rk, _ig30);

    var _super61 = _createSuper(Rk);

    function Rk(e, t, i, n, s) {
      var _this233;

      _classCallCheck(this, Rk);

      _this233 = _super61.call(this), nh(_assertThisInitialized(_this233), "joinInfo", void 0), nh(_assertThisInitialized(_this233), "sid", void 0), nh(_assertThisInitialized(_this233), "clientId", void 0), nh(_assertThisInitialized(_this233), "cancelToken", EC.CancelToken.source()), nh(_assertThisInitialized(_this233), "workerToken", void 0), nh(_assertThisInitialized(_this233), "requestId", 0), nh(_assertThisInitialized(_this233), "signal", void 0), nh(_assertThisInitialized(_this233), "prevChannelMediaConfig", void 0), nh(_assertThisInitialized(_this233), "httpRetryConfig", void 0), nh(_assertThisInitialized(_this233), "_resolution", void 0), nh(_assertThisInitialized(_this233), "_state", ZI.RELAY_STATE_IDLE), nh(_assertThisInitialized(_this233), "errorCode", $I.RELAY_OK), nh(_assertThisInitialized(_this233), "onStatus", function (e) {
        YC.debug("[".concat(_this233.clientId, "] ChannelMediaStatus: ").concat(JSON.stringify(e))), e && e.command && ("onAudioPacketReceived" === e.command && _this233.emit("event", QI.PACKET_RECEIVED_AUDIO_FROM_SRC), "onVideoPacketReceived" === e.command && _this233.emit("event", QI.PACKET_RECEIVED_VIDEO_FROM_SRC), "onSrcTokenPrivilegeDidExpire" === e.command && (_this233.errorCode = $I.SRC_TOKEN_EXPIRED, _this233.state = ZI.RELAY_STATE_FAILURE), "onDestTokenPrivilegeDidExpire" === e.command && (_this233.errorCode = $I.DEST_TOKEN_EXPIRED, _this233.state = ZI.RELAY_STATE_FAILURE));
      }), nh(_assertThisInitialized(_this233), "onReconnect", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee227() {
        return _regeneratorRuntime.wrap(function _callee227$(_context227) {
          while (1) {
            switch (_context227.prev = _context227.next) {
              case 0:
                YC.debug("[".concat(_this233.clientId, "] ChannelMediaSocket disconnect, reconnecting")), _this233.emit("event", QI.NETWORK_DISCONNECTED), _this233.state = ZI.RELAY_STATE_IDLE, _this233.prevChannelMediaConfig && _this233.sendStartRelayMessage(_this233.prevChannelMediaConfig).catch(function (e) {
                  _this233.state !== ZI.RELAY_STATE_IDLE && (YC.error("auto restart channel media relay failed", e.toString()), _this233.errorCode = $I.SERVER_CONNECTION_LOST, _this233.state = ZI.RELAY_STATE_FAILURE);
                });

              case 1:
              case "end":
                return _context227.stop();
            }
          }
        }, _callee227);
      }))), _this233.joinInfo = e, _this233.clientId = t, _this233.sid = Vg(), _this233.signal = new Sk(_this233.joinInfo, _this233.clientId, i), _this233.httpRetryConfig = n, _this233._resolution = s;
      return _this233;
    }

    _createClass(Rk, [{
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        e !== this._state && (e !== ZI.RELAY_STATE_FAILURE && (this.errorCode = $I.RELAY_OK), this.emit("state", e, this.errorCode), this._state = e);
      }
    }, {
      key: "startChannelMediaRelay",
      value: function () {
        var _startChannelMediaRelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee228(e) {
          return _regeneratorRuntime.wrap(function _callee228$(_context228) {
            while (1) {
              switch (_context228.prev = _context228.next) {
                case 0:
                  if (!(this.state !== ZI.RELAY_STATE_IDLE)) {
                    _context228.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION);

                case 2:
                  this.state = ZI.RELAY_STATE_CONNECTING;
                  _context228.next = 5;
                  return this.connect();

                case 5:
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: connect success"));
                  _context228.prev = 6;
                  _context228.next = 9;
                  return this.sendStartRelayMessage(e);

                case 9:
                  _context228.next = 20;
                  break;

                case 11:
                  _context228.prev = 11;
                  _context228.t0 = _context228["catch"](6);

                  if (!(_context228.t0.data && _context228.t0.data.serverResponse && "SetSourceChannel" === _context228.t0.data.serverResponse.command)) {
                    _context228.next = 15;
                    break;
                  }

                  throw new VI(xT.CROSS_CHANNEL_FAILED_JOIN_SRC);

                case 15:
                  if (!(_context228.t0.data && _context228.t0.data.serverResponse && "SetDestChannelStatus" === _context228.t0.serverResponse.command)) {
                    _context228.next = 17;
                    break;
                  }

                  throw new VI(xT.CROSS_CHANNEL_FAILED_JOIN_DEST);

                case 17:
                  if (!(_context228.t0.data && _context228.t0.data.serverResponse && "StartPacketTransfer" === _context228.t0.serverResponse.command)) {
                    _context228.next = 19;
                    break;
                  }

                  throw new VI(xT.CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST);

                case 19:
                  throw _context228.t0;

                case 20:
                  this.prevChannelMediaConfig = e;

                case 21:
                case "end":
                  return _context228.stop();
              }
            }
          }, _callee228, this, [[6, 11]]);
        }));

        function startChannelMediaRelay(_x373) {
          return _startChannelMediaRelay.apply(this, arguments);
        }

        return startChannelMediaRelay;
      }()
    }, {
      key: "updateChannelMediaRelay",
      value: function () {
        var _updateChannelMediaRelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee229(e) {
          return _regeneratorRuntime.wrap(function _callee229$(_context229) {
            while (1) {
              switch (_context229.prev = _context229.next) {
                case 0:
                  if (!(this.state !== ZI.RELAY_STATE_RUNNING)) {
                    _context229.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION);

                case 2:
                  _context229.next = 4;
                  return this.sendUpdateMessage(e);

                case 4:
                  this.prevChannelMediaConfig = e;

                case 5:
                case "end":
                  return _context229.stop();
              }
            }
          }, _callee229, this);
        }));

        function updateChannelMediaRelay(_x374) {
          return _updateChannelMediaRelay.apply(this, arguments);
        }

        return updateChannelMediaRelay;
      }()
    }, {
      key: "setVideoProfile",
      value: function () {
        var _setVideoProfile2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee230(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee230$(_context230) {
            while (1) {
              switch (_context230.prev = _context230.next) {
                case 0:
                  if (!(this._resolution = e, this.state !== ZI.RELAY_STATE_RUNNING)) {
                    _context230.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION);

                case 2:
                  t = this.genMessage(XI.SetVideoProfile);
                  _context230.next = 5;
                  return this.signal.request(t);

                case 5:
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: setVideoProfile success"));

                case 6:
                case "end":
                  return _context230.stop();
              }
            }
          }, _callee230, this);
        }));

        function setVideoProfile(_x375) {
          return _setVideoProfile2.apply(this, arguments);
        }

        return setVideoProfile;
      }()
    }, {
      key: "stopChannelMediaRelay",
      value: function () {
        var _stopChannelMediaRelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee231() {
          return _regeneratorRuntime.wrap(function _callee231$(_context231) {
            while (1) {
              switch (_context231.prev = _context231.next) {
                case 0:
                  _context231.next = 2;
                  return this.sendStopRelayMessage();

                case 2:
                  YC.debug("[".concat(this.clientId, "] stopChannelMediaRelay: send stop message success"));
                  this.state = ZI.RELAY_STATE_IDLE;
                  this.dispose();

                case 5:
                case "end":
                  return _context231.stop();
              }
            }
          }, _callee231, this);
        }));

        function stopChannelMediaRelay() {
          return _stopChannelMediaRelay.apply(this, arguments);
        }

        return stopChannelMediaRelay;
      }()
    }, {
      key: "dispose",
      value: function dispose() {
        YC.debug("[".concat(this.clientId, "] disposeChannelMediaRelay")), this.cancelToken.cancel(), this.cancelToken = EC.CancelToken.source(), this.state = ZI.RELAY_STATE_IDLE, this.emit("dispose"), this.signal.dispose(), this.prevChannelMediaConfig = void 0;
      }
    }, {
      key: "connect",
      value: function () {
        var _connect5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee232() {
          var e;
          return _regeneratorRuntime.wrap(function _callee232$(_context232) {
            while (1) {
              switch (_context232.prev = _context232.next) {
                case 0:
                  _context232.next = 2;
                  return CA(this.joinInfo, this.cancelToken.token, this.httpRetryConfig);

                case 2:
                  e = _context232.sent;
                  this.workerToken = e.workerToken;
                  _context232.next = 6;
                  return this.signal.connect(e.addressList);

                case 6:
                  this.emit("event", QI.NETWORK_CONNECTED);
                  this.signal.on("status", this.onStatus);
                  this.signal.on("reconnecting", this.onReconnect);

                case 9:
                case "end":
                  return _context232.stop();
              }
            }
          }, _callee232, this);
        }));

        function connect() {
          return _connect5.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "sendStartRelayMessage",
      value: function () {
        var _sendStartRelayMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee233(e) {
          var t, i, n, s, r, o;
          return _regeneratorRuntime.wrap(function _callee233$(_context233) {
            while (1) {
              switch (_context233.prev = _context233.next) {
                case 0:
                  t = this.genMessage(XI.StopPacketTransfer);
                  _context233.next = 3;
                  return this.signal.request(t);

                case 3:
                  _context233.next = 5;
                  return this.signal.waitStatus("Normal Quit");

                case 5:
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: StopPacketTransfer success"));
                  i = this.genMessage(XI.SetSdkProfile, e);
                  _context233.next = 9;
                  return this.signal.request(i);

                case 9:
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSdkProfile success"));
                  n = this.genMessage(XI.SetSourceChannel, e);
                  _context233.next = 13;
                  return this.signal.request(n);

                case 13:
                  _context233.next = 15;
                  return this.signal.waitStatus("SetSourceChannelStatus");

                case 15:
                  this.emit("event", QI.PACKET_JOINED_SRC_CHANNEL);
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSourceChannel success"));
                  s = this.genMessage(XI.SetSourceUserId, e);
                  _context233.next = 20;
                  return this.signal.request(s);

                case 20:
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSourceUserId success"));
                  r = this.genMessage(XI.SetDestChannel, e);
                  _context233.next = 24;
                  return this.signal.request(r);

                case 24:
                  _context233.next = 26;
                  return this.signal.waitStatus("SetDestChannelStatus");

                case 26:
                  this.emit("event", QI.PACKET_JOINED_DEST_CHANNEL);
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetDestChannel success"));
                  o = this.genMessage(XI.StartPacketTransfer, e);
                  _context233.next = 31;
                  return this.signal.request(o);

                case 31:
                  this.emit("event", QI.PACKET_SENT_TO_DEST_CHANNEL);
                  this.state = ZI.RELAY_STATE_RUNNING;
                  YC.debug("[".concat(this.clientId, "] startChannelMediaRelay: StartPacketTransfer success"));
                  this.setVideoProfile(this._resolution);

                case 35:
                case "end":
                  return _context233.stop();
              }
            }
          }, _callee233, this);
        }));

        function sendStartRelayMessage(_x376) {
          return _sendStartRelayMessage.apply(this, arguments);
        }

        return sendStartRelayMessage;
      }()
    }, {
      key: "sendUpdateMessage",
      value: function () {
        var _sendUpdateMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee234(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee234$(_context234) {
            while (1) {
              switch (_context234.prev = _context234.next) {
                case 0:
                  t = this.genMessage(XI.UpdateDestChannel, e);
                  _context234.next = 3;
                  return this.signal.request(t);

                case 3:
                  this.emit("event", QI.PACKET_UPDATE_DEST_CHANNEL);
                  YC.debug("[".concat(this.clientId, "] sendUpdateMessage: UpdateDestChannel success"));

                case 5:
                case "end":
                  return _context234.stop();
              }
            }
          }, _callee234, this);
        }));

        function sendUpdateMessage(_x377) {
          return _sendUpdateMessage.apply(this, arguments);
        }

        return sendUpdateMessage;
      }()
    }, {
      key: "sendStopRelayMessage",
      value: function () {
        var _sendStopRelayMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee235() {
          var e;
          return _regeneratorRuntime.wrap(function _callee235$(_context235) {
            while (1) {
              switch (_context235.prev = _context235.next) {
                case 0:
                  e = this.genMessage(XI.StopPacketTransfer);
                  _context235.next = 3;
                  return this.signal.request(e);

                case 3:
                  YC.debug("[".concat(this.clientId, "] sendStopRelayMessage: StopPacketTransfer success"));

                case 4:
                case "end":
                  return _context235.stop();
              }
            }
          }, _callee235, this);
        }));

        function sendStopRelayMessage() {
          return _sendStopRelayMessage.apply(this, arguments);
        }

        return sendStopRelayMessage;
      }()
    }, {
      key: "genMessage",
      value: function genMessage(e, t) {
        var _this234 = this;

        var i = [],
            n = [],
            s = [];
        this.requestId += 1;
        var r = {
          appId: this.joinInfo.appId,
          cname: this.joinInfo.cname,
          uid: this.joinInfo.uid.toString(),
          sdkVersion: yC,
          sid: this.sid,
          ts: Date.now(),
          requestId: this.requestId,
          seq: this.requestId,
          allocate: !0,
          clientRequest: {}
        };
        "4.20.0" === r.sdkVersion && (r.sdkVersion = "0.0.1");
        var o = null,
            a = null;

        switch (e) {
          case XI.SetSdkProfile:
            return r.clientRequest = {
              command: "SetSdkProfile",
              type: "multi_channel"
            }, r;

          case XI.SetSourceChannel:
            if (a = t && t.getSrcChannelMediaInfo(), !a) throw new VI(xT.UNEXPECTED_ERROR, "can not find source config");
            return r.clientRequest = {
              command: "SetSourceChannel",
              uid: "0",
              channelName: a.channelName,
              token: a.token || this.joinInfo.appId
            }, r;

          case XI.SetSourceUserId:
            if (a = t && t.getSrcChannelMediaInfo(), !a) throw new VI(xT.UNEXPECTED_ERROR, "can not find source config");
            return r.clientRequest = {
              command: "SetSourceUserId",
              uid: a.uid + ""
            }, r;

          case XI.SetDestChannel:
            if (o = t && t.getDestChannelMediaInfo(), !o) throw new VI(xT.UNEXPECTED_ERROR, "can not find dest config");
            return o.forEach(function (e) {
              i.push(e.channelName), n.push(e.uid + ""), s.push(e.token || _this234.joinInfo.appId);
            }), r.clientRequest = {
              command: "SetDestChannel",
              channelName: i,
              uid: n,
              token: s
            }, r;

          case XI.StartPacketTransfer:
            return r.clientRequest = {
              command: "StartPacketTransfer"
            }, r;

          case XI.Reconnect:
            return r.clientRequest = {
              command: "Reconnect"
            }, r;

          case XI.StopPacketTransfer:
            return r.clientRequest = {
              command: "StopPacketTransfer"
            }, r;

          case XI.UpdateDestChannel:
            if (o = t && t.getDestChannelMediaInfo(), !o) throw new VI(xT.UNEXPECTED_ERROR, "can not find dest config");
            return o.forEach(function (e) {
              i.push(e.channelName), n.push(e.uid + ""), s.push(e.token || _this234.joinInfo.appId);
            }), r.clientRequest = {
              command: "UpdateDestChannel",
              channelName: i,
              uid: n,
              token: s
            }, r;

          case XI.SetVideoProfile:
            r.clientRequest = {
              command: "SetVideoProfile",
              width: this._resolution.width,
              height: this._resolution.height
            };
        }

        return r;
      }
    }]);

    return Rk;
  }(ig);

  function Ck(e) {
    var t = {},
        i = !1;

    function n(t, n) {
      return i = !0, {
        done: !1,
        value: new gP(n = new yP(function (i) {
          i(e[t](n));
        }), 1)
      };
    }

    return t[void 0 !== Uu && $u || "@@iterator"] = function () {
      return this;
    }, t.next = function (e) {
      return i ? (i = !1, e) : n("next", e);
    }, "function" == typeof e.throw && (t.throw = function (e) {
      if (i) throw i = !1, e;
      return n("throw", e);
    }), "function" == typeof e.return && (t.return = function (e) {
      return i ? (i = !1, e) : n("return", e);
    }), t;
  }

  var Ik = i(AP);

  function vk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function yk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? vk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : vk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function Ak(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function bk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ak(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Ak(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var wk = /*#__PURE__*/function (_Mv) {
    _inherits(wk, _Mv);

    var _super62 = _createSuper(wk);

    function wk(e, t) {
      var _this235;

      _classCallCheck(this, wk);

      _this235 = _super62.call(this, e, t), nh(_assertThisInitialized(_this235), "store", void 0), nh(_assertThisInitialized(_this235), "peerConnection", void 0), nh(_assertThisInitialized(_this235), "remoteSDP", void 0), nh(_assertThisInitialized(_this235), "initialOffer", void 0), nh(_assertThisInitialized(_this235), "statsFilter", void 0), nh(_assertThisInitialized(_this235), "useRTX", !1), nh(_assertThisInitialized(_this235), "localCapabilities", void 0), nh(_assertThisInitialized(_this235), "localCandidateCount", 0), nh(_assertThisInitialized(_this235), "allCandidatesReceived", !1), nh(_assertThisInitialized(_this235), "establishPromise", void 0), nh(_assertThisInitialized(_this235), "mutex", new Yg("P2PConnection-mutex")), _this235.store = t, _this235.peerConnection = new RTCPeerConnection(wk.resolvePCConfiguration(e), {
        optional: [{
          googDscp: !0
        }]
      }), _this235.statsFilter = hL(_this235.peerConnection, DC("STATS_UPDATE_INTERVAL"), void 0, RT() ? 1200 : void 0), _this235.bindPCEvents(), _this235.bindStatsEvents(), _this235.store.p2pId = _this235.store.p2pId + 1, _this235.establishPromise = _this235.establish();
      return _this235;
    }

    _createClass(wk, [{
      key: "peerConnectionState",
      get: function get() {
        return this.peerConnection.connectionState;
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.peerConnection.iceConnectionState;
      }
    }, {
      key: "currentLocalDescription",
      get: function get() {
        return this.peerConnection.currentLocalDescription;
      }
    }, {
      key: "currentRemoteDescription",
      get: function get() {
        return this.peerConnection.currentRemoteDescription;
      }
    }, {
      key: "localCodecs",
      get: function get() {
        return _toConsumableArray(new Set(this.localCapabilities && this.localCapabilities.videoCodecs.map(function (e) {
          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
        }).filter(function (e) {
          var t;
          return bn(t = Object.keys(xC)).call(t, e);
        })));
      }
    }, {
      key: "establish",
      value: function () {
        var _establish2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee236() {
          var _e262, _t227, i;

          return _regeneratorRuntime.wrap(function _callee236$(_context236) {
            while (1) {
              switch (_context236.prev = _context236.next) {
                case 0:
                  _context236.prev = 0;
                  _context236.next = 3;
                  return this.peerConnection.createOffer({
                    offerToReceiveAudio: !0,
                    offerToReceiveVideo: !0
                  });

                case 3:
                  _e262 = _context236.sent;

                  if (_e262.sdp) {
                    _context236.next = 6;
                    break;
                  }

                  throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");

                case 6:
                  _t227 = mL(_e262.sdp), i = EL(_e262.sdp, {
                    filterRTX: !this.useRTX,
                    filterVideoFec: DC("FILTER_VIDEO_FEC"),
                    filterAudioFec: DC("FILTER_AUDIO_FEC"),
                    filterAudioCodec: ["opus"]
                  });
                  return _context236.abrupt("return", (this.localCapabilities = i, this.initialOffer = _e262, bk(bk({}, _t227), {}, {
                    rtpCapabilities: {
                      send: {
                        audioCodecs: [],
                        audioExtensions: [],
                        videoCodecs: [],
                        videoExtensions: []
                      },
                      recv: {
                        audioCodecs: [],
                        audioExtensions: [],
                        videoCodecs: [],
                        videoExtensions: []
                      },
                      sendrecv: i
                    },
                    offerSDP: _e262.sdp
                  })));

                case 10:
                  _context236.prev = 10;
                  _context236.t0 = _context236["catch"](0);
                  throw new VT(xT.GET_LOCAL_CONNECTION_PARAMS_FAILED, _context236.t0.toString());

                case 13:
                case "end":
                  return _context236.stop();
              }
            }
          }, _callee236, this, [[0, 10]]);
        }));

        function establish() {
          return _establish2.apply(this, arguments);
        }

        return establish;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee237(e, t, i, n, s, r) {
          var _o29;

          return _regeneratorRuntime.wrap(function _callee237$(_context237) {
            while (1) {
              switch (_context237.prev = _context237.next) {
                case 0:
                  _context237.prev = 0;

                  if (this.initialOffer) {
                    _context237.next = 3;
                    break;
                  }

                  throw new Error("Cannot establish P2PConnection without initial offer.");

                case 3:
                  this.remoteSDP = new ( /*#__PURE__*/function () {
                    function _class12(e) {
                      _classCallCheck(this, _class12);

                      nh(this, "sessionDesc", void 0), nh(this, "localCapabilities", void 0), nh(this, "rtpCapabilities", void 0), nh(this, "candidates", void 0), nh(this, "iceParameters", void 0), nh(this, "dtlsParameters", void 0), nh(this, "setup", void 0), nh(this, "currentMidIndex", void 0), nh(this, "cname", void 0), e = bg(e);
                      var _e263 = e,
                          t = _e263.remoteIceParameters,
                          i = _e263.remoteDtlsParameters,
                          n = _e263.candidates,
                          s = _e263.remoteRTPCapabilities,
                          r = _e263.remoteSetup,
                          o = _e263.localCapabilities,
                          a = _e263.sdkCodec,
                          c = _e263.cname,
                          d = YP.parse("v=0\no=- 0 0 IN IP4 127.0.0.1\ns=AgoraGateway\nt=0 0\na=group:BUNDLE audio video\na=msid-semantic: WMS\na=ice-lite\nm=audio 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendrecv\na=rtcp-mux\na=rtcp-rsize\na=mid:audio\nm=video 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendrecv\na=rtcp-mux\na=rtcp-rsize\na=mid:video\n");
                      this.rtpCapabilities = s, this.candidates = n, this.iceParameters = t, this.dtlsParameters = i, this.setup = r, this.localCapabilities = o, this.cname = c;

                      for (var _e264 = 0; _e264 < d.mediaDescriptions.length; _e264++) {
                        var _o30 = d.mediaDescriptions[_e264];

                        if (_o30.attributes.iceUfrag = t.iceUfrag, _o30.attributes.icePwd = t.icePwd, _o30.attributes.fingerprints = i.fingerprints, _o30.attributes.candidates = n, _o30.attributes.setup = r, "video" === _o30.media.mediaType) {
                          _o30.media.fmts = s.videoCodecs.map(function (e) {
                            return e.payloadType.toString(10);
                          });

                          var _e265 = s.videoCodecs.filter(function (e) {
                            var t, i;
                            return null === (t = e.rtpMap) || void 0 === t ? void 0 : bn(i = t.encodingName.toLowerCase()).call(i, a);
                          });

                          0 === _e265.length && (_e265 = s.videoCodecs), _o30.attributes.payloads = _e265, _o30.attributes.extmaps = s.videoExtensions;
                        }

                        "audio" === _o30.media.mediaType && (_o30.media.fmts = s.audioCodecs.map(function (e) {
                          return e.payloadType.toString(10);
                        }), _o30.attributes.payloads = s.audioCodecs, _o30.attributes.extmaps = s.audioExtensions), d.mediaDescriptions[_e264] = this.mungMediaDesc(_o30);
                      }

                      this.sessionDesc = d, this.currentMidIndex = d.mediaDescriptions.length - 1;
                    }

                    _createClass(_class12, [{
                      key: "toString",
                      value: function toString() {
                        return YP.print(this.sessionDesc);
                      }
                    }, {
                      key: "send",
                      value: function send(e, t, i) {
                        var _gL4 = gL(t, this.cname),
                            n = _gL4.ssrcs,
                            s = _gL4.ssrcGroups,
                            r = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return e === hv.VIDEO ? "video" === t.media.mediaType : "audio" === t.media.mediaType;
                        }),
                            o = n[0].attributes.label,
                            a = n[0].attributes.mslabel;

                        return r.attributes.ssrcs = r.attributes.ssrcs.concat(n), r.attributes.ssrcGroups = r.attributes.ssrcGroups.concat(s), {
                          id: o,
                          mslabel: a
                        };
                      }
                    }, {
                      key: "batchSend",
                      value: function batchSend(e) {
                        var _this236 = this;

                        return e.map(function (e) {
                          var t = e.kind,
                              i = e.ssrcMsg;
                          return _this236.send(t, i, void 0);
                        });
                      }
                    }, {
                      key: "stopSending",
                      value: function stopSending(e) {
                        this.sessionDesc.mediaDescriptions.forEach(function (t) {
                          var i = [],
                              n = [],
                              s = [];
                          t.attributes.ssrcs.forEach(function (t) {
                            bn(e).call(e, t.attributes.label || "") ? s.push(t) : i.push(t);
                          }), t.attributes.ssrcGroups.forEach(function (e) {
                            var t;
                            bn(t = s.map(function (e) {
                              return e.ssrcId;
                            })).call(t, e.ssrcIds[0]) || n.push(e);
                          }), t.attributes.ssrcs = i, t.attributes.ssrcGroups = n;
                        });
                      }
                    }, {
                      key: "mute",
                      value: function mute(e) {
                        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return t.attributes.mid === e;
                        });
                        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.mute."));
                        t.attributes.direction = "inactive";
                      }
                    }, {
                      key: "unmute",
                      value: function unmute(e) {
                        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return t.attributes.mid === e;
                        });
                        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.unmute."));
                        t.attributes.direction = "sendonly";
                      }
                    }, {
                      key: "receive",
                      value: function receive(e, t, i) {
                        var _this237 = this;

                        e.forEach(function (e, t) {
                          var i = e._mediaStreamTrack,
                              n = _this237.sessionDesc.mediaDescriptions.findIndex(function (e) {
                            return e.attributes.mid === i.kind;
                          }),
                              s = _this237.mungRecvMediaDsec(_this237.sessionDesc.mediaDescriptions[n], e);

                          _this237.sessionDesc.mediaDescriptions[n] = s;
                        });
                      }
                    }, {
                      key: "stopReceiving",
                      value: function stopReceiving(e) {}
                    }, {
                      key: "updateCandidates",
                      value: function updateCandidates(e) {
                        var _this238 = this;

                        e === pv.TCP ? this.candidates.forEach(function (e) {
                          -1 === _this238.candidates.findIndex(function (t) {
                            return "tcp" === t.transport && t.connectionAddress === e.connectionAddress && t.port === e.port;
                          }) && _this238.candidates.push(yk(yk({}, e), {}, {
                            foundation: "tcpcandidate",
                            priority: Number(e.priority) - 1 + "",
                            transport: "tcp",
                            port: Number(e.port) + 90 + ""
                          }));
                        }) : this.candidates = this.candidates.filter(function (e) {
                          return "tcp" !== e.transport;
                        });

                        var _iterator28 = _createForOfIteratorHelper(this.sessionDesc.mediaDescriptions),
                            _step28;

                        try {
                          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                            var _e266 = _step28.value;
                            _e266.attributes.candidates = this.candidates;
                          }
                        } catch (err) {
                          _iterator28.e(err);
                        } finally {
                          _iterator28.f();
                        }
                      }
                    }, {
                      key: "restartICE",
                      value: function restartICE(e) {
                        e = bg(e), this.iceParameters = e, this.sessionDesc.mediaDescriptions.forEach(function (t) {
                          t.attributes.iceUfrag = e.iceUfrag, t.attributes.icePwd = e.icePwd;
                        });
                      }
                    }, {
                      key: "predictReceivingMids",
                      value: function predictReceivingMids(e) {
                        var t = [];

                        for (var _i121 = 0; _i121 < e; _i121++) {
                          t.push((this.currentMidIndex + _i121 + 1).toString(10));
                        }

                        return t;
                      }
                    }, {
                      key: "mungRecvMediaDsec",
                      value: function mungRecvMediaDsec(e, t) {
                        var i = bg(e);
                        return SL(i, t), CL(i, t), i;
                      }
                    }, {
                      key: "updateRecvMedia",
                      value: function updateRecvMedia(e, t) {
                        var i = this.sessionDesc.mediaDescriptions.findIndex(function (t) {
                          return t.attributes.mid === e;
                        });

                        if (-1 !== i) {
                          var _e267 = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[i], t);

                          this.sessionDesc.mediaDescriptions[i] = _e267;
                        }
                      }
                    }, {
                      key: "bumpMid",
                      value: function bumpMid(e) {
                        this.currentMidIndex += e;
                      }
                    }, {
                      key: "updateTrackLabel",
                      value: function updateTrackLabel(e, t, i) {
                        var n = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return e === hv.VIDEO ? "video" === t.attributes.mid : "audio" === t.attributes.mid;
                        });

                        if (n) {
                          var _e268 = n.attributes.ssrcs.find(function (e) {
                            return e.attributes.label === t;
                          });

                          var s;
                          _e268 && (_e268.attributes.label = i, null === (s = _e268.attributes.msid) || void 0 === s || s.replace(t, i));
                        }
                      }
                    }, {
                      key: "mungMediaDesc",
                      value: function mungMediaDesc(e) {
                        var t = bg(e);
                        return RL(t), function (e) {
                          var t = e.attributes.extmaps.find(function (e) {
                            return "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" === e.extensionName;
                          });
                          t && e.attributes.extmaps.splice(e.attributes.extmaps.indexOf(t), 1), e.attributes.payloads.forEach(function (e) {
                            var t = e.rtcpFeedbacks.findIndex(function (e) {
                              return "transport-cc" === e.type;
                            });
                            -1 !== t && e.rtcpFeedbacks.splice(t, 1);
                          });
                        }(t), t;
                      }
                    }, {
                      key: "getSSRC",
                      value: function getSSRC(e) {
                        var _iterator29 = _createForOfIteratorHelper(this.sessionDesc.mediaDescriptions),
                            _step29;

                        try {
                          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                            var _t228 = _step29.value;

                            var _iterator30 = _createForOfIteratorHelper(_t228.attributes.ssrcs),
                                _step30;

                            try {
                              for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                                var _i122 = _step30.value;
                                if (_i122.attributes.label === e) return [_i122];
                              }
                            } catch (err) {
                              _iterator30.e(err);
                            } finally {
                              _iterator30.f();
                            }
                          }
                        } catch (err) {
                          _iterator29.e(err);
                        } finally {
                          _iterator29.f();
                        }
                      }
                    }]);

                    return _class12;
                  }())({
                    remoteIceParameters: e,
                    remoteDtlsParameters: t,
                    candidates: i,
                    remoteRTPCapabilities: n.send,
                    remoteSetup: s,
                    localCapabilities: this.localCapabilities,
                    sdkCodec: this.store.codec,
                    cname: r
                  });
                  _o29 = this.remoteSDP.toString();
                  _context237.next = 7;
                  return this.peerConnection.setLocalDescription(this.initialOffer);

                case 7:
                  _context237.next = 9;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o29
                  });

                case 9:
                  _context237.next = 14;
                  break;

                case 11:
                  _context237.prev = 11;
                  _context237.t0 = _context237["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(_context237.t0.toString()));

                case 14:
                case "end":
                  return _context237.stop();
              }
            }
          }, _callee237, this, [[0, 11]]);
        }));

        function connect(_x378, _x379, _x380, _x381, _x382, _x383) {
          return _connect6.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function () {
        var _updateRemoteRTPCapabilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee238(e, t) {
          return _regeneratorRuntime.wrap(function _callee238$(_context238) {
            while (1) {
              switch (_context238.prev = _context238.next) {
                case 0:
                  throw new VT(xT.NOT_SUPPORTED, "Planb mode does not support createDataChannels.");

                case 1:
                case "end":
                  return _context238.stop();
              }
            }
          }, _callee238);
        }));

        function updateRemoteRTPCapabilities(_x384, _x385) {
          return _updateRemoteRTPCapabilities.apply(this, arguments);
        }

        return updateRemoteRTPCapabilities;
      }()
    }, {
      key: "send",
      value: function send(e, t) {
        var i = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee239() {
          var n, _s67, _r37, _o31, _a16, c, _d10, _l7;

          return _regeneratorRuntime.wrap(function _callee239$(_context239) {
            while (1) {
              switch (_context239.prev = _context239.next) {
                case 0:
                  _context239.next = 2;
                  return SP(i.mutex.lock());

                case 2:
                  n = _context239.sent;
                  _context239.prev = 3;

                  if (i.remoteSDP) {
                    _context239.next = 6;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.send before remote SDP created");

                case 6:
                  _s67 = e.map(function (e) {
                    return i.peerConnection.addTrack(e._mediaStreamTrack);
                  });
                  _context239.next = 9;
                  return SP(i.peerConnection.createOffer());

                case 9:
                  _r37 = _context239.sent;
                  _o31 = YP.parse(_r37.sdp);
                  _a16 = e.map(function (e) {
                    var t = e._mediaStreamTrack,
                        n = _o31.mediaDescriptions.find(function (e) {
                      return e.attributes.mid === t.kind;
                    });

                    if (!n) throw new Error("Cannot extract ssrc from mediaDescription.");
                    return function (e, t, i) {
                      var n = e.attributes.ssrcs.filter(function (e) {
                        return e.attributes.label === t;
                      }),
                          s = e.attributes.ssrcGroups;
                      if (0 === n.length) throw new Error("Cannot extract ssrc from plan-b SDP.");

                      if (s && n.length > 1) {
                        var _e269 = s.find(function (e) {
                          return -1 !== e.ssrcIds.indexOf(n[0].ssrcId);
                        });

                        return _e269 ? [{
                          ssrcId: _e269.ssrcIds[0],
                          rtx: i ? _e269.ssrcIds[1] : void 0
                        }] : [{
                          ssrcId: n[0].ssrcId
                        }];
                      }

                      return [{
                        ssrcId: n[0].ssrcId
                      }];
                    }(n, t.id, i.useRTX);
                  });
                  _context239.prev = 12;
                  _context239.next = 15;
                  return _a16;

                case 15:
                  c = _context239.sent;
                  _context239.next = 21;
                  break;

                case 18:
                  _context239.prev = 18;
                  _context239.t0 = _context239["catch"](12);
                  throw _s67.forEach(function (e) {
                    ST() && e.replaceTrack(null), i.peerConnection.removeTrack(e);
                  }), _context239.t0;

                case 21:
                  _d10 = i.mungSendOfferSDP(_r37.sdp, e);
                  i.remoteSDP.receive(e, t, c);
                  _l7 = i.remoteSDP.toString();
                  _context239.next = 26;
                  return SP(i.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _d10
                  }));

                case 26:
                  _context239.next = 28;
                  return SP(i.applySendEncodings(_s67, e));

                case 28:
                  _context239.next = 30;
                  return SP(i.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _l7
                  }));

                case 30:
                  return _context239.abrupt("return", e.map(function (e, t) {
                    var i = e._mediaStreamTrack.id;
                    return {
                      localSSRC: _a16[t],
                      id: i
                    };
                  }));

                case 33:
                  _context239.prev = 33;
                  _context239.t1 = _context239["catch"](3);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(_context239.t1.toString()));

                case 36:
                  _context239.prev = 36;
                  n();
                  return _context239.finish(36);

                case 39:
                case "end":
                  return _context239.stop();
              }
            }
          }, _callee239, null, [[3, 33, 36, 39], [12, 18]]);
        }))();
      }
    }, {
      key: "stopSending",
      value: function () {
        var _stopSending2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee240(e) {
          var _this239 = this;

          var _t229, i, _n104;

          return _regeneratorRuntime.wrap(function _callee240$(_context240) {
            while (1) {
              switch (_context240.prev = _context240.next) {
                case 0:
                  _context240.prev = 0;

                  if (this.remoteSDP) {
                    _context240.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");

                case 3:
                  _t229 = this.peerConnection.getSenders().filter(function (t) {
                    var i;
                    return -1 !== e.indexOf((null === (i = t.track) || void 0 === i ? void 0 : i.id) || "");
                  });

                  if (!(_t229.length !== e.length)) {
                    _context240.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length when trying to call P2PConnection.stopSending.");

                case 6:
                  _t229.map(function (e) {
                    ST() && e.replaceTrack(null), _this239.peerConnection.removeTrack(e);
                  });

                  _context240.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context240.sent;
                  _context240.next = 12;
                  return this.peerConnection.setLocalDescription(i);

                case 12:
                  this.remoteSDP.stopReceiving(e);
                  _n104 = this.remoteSDP.toString();
                  _context240.next = 16;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _n104
                  });

                case 16:
                  _context240.next = 21;
                  break;

                case 18:
                  _context240.prev = 18;
                  _context240.t0 = _context240["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(_context240.t0.toString()));

                case 21:
                case "end":
                  return _context240.stop();
              }
            }
          }, _callee240, this, [[0, 18]]);
        }));

        function stopSending(_x386) {
          return _stopSending2.apply(this, arguments);
        }

        return stopSending;
      }()
    }, {
      key: "receive",
      value: function () {
        var _receive2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee241(e, t, i, n) {
          var _this240 = this;

          var _this$remoteSDP$send3, _i123, _s68, _r38, _o32, _a17;

          return _regeneratorRuntime.wrap(function _callee241$(_context241) {
            while (1) {
              switch (_context241.prev = _context241.next) {
                case 0:
                  _context241.prev = 0;

                  if (this.remoteSDP) {
                    _context241.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.receive ".concat(e, " before remoteSDP created."));

                case 3:
                  _this$remoteSDP$send3 = this.remoteSDP.send(e, t, n), _i123 = _this$remoteSDP$send3.id, _s68 = _this$remoteSDP$send3.mslabel, _r38 = new tT(function (t, n) {
                    var r = setTimeout(function () {
                      n(new Error("Cannot receive track, id: ".concat(_i123)));
                    }, 1e4),
                        o = function o(n) {
                      var a = pT();

                      if (("Safari" === a.name && 11 === Number(a.version) || CT()) && n.track.id !== _i123 && n.streams[0].id === _s68) {
                        var c;
                        var _s69 = n.streams[0].getTracks()[0];
                        return null === (c = _this240.remoteSDP) || void 0 === c || c.updateTrackLabel(e, _i123, n.track.id), _this240.peerConnection.removeEventListener("track", o), clearTimeout(r), void t(_s69);
                      }

                      if (n.track.id === _i123) return _this240.peerConnection.removeEventListener("track", o), clearTimeout(r), void t(n.track);
                    };

                    _this240.peerConnection.addEventListener("track", o);
                  }), _o32 = this.remoteSDP.toString();
                  _context241.next = 6;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _o32
                  });

                case 6:
                  _context241.next = 8;
                  return this.peerConnection.createAnswer();

                case 8:
                  _a17 = _context241.sent;
                  _context241.next = 11;
                  return this.peerConnection.setLocalDescription(_a17);

                case 11:
                  _context241.next = 13;
                  return _r38;

                case 13:
                  _context241.t0 = _context241.sent;
                  _context241.t1 = _i123;
                  return _context241.abrupt("return", {
                    track: _context241.t0,
                    id: _context241.t1
                  });

                case 18:
                  _context241.prev = 18;
                  _context241.t2 = _context241["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context241.t2.toString()));

                case 21:
                case "end":
                  return _context241.stop();
              }
            }
          }, _callee241, this, [[0, 18]]);
        }));

        function receive(_x387, _x388, _x389, _x390) {
          return _receive2.apply(this, arguments);
        }

        return receive;
      }()
    }, {
      key: "stopReceiving",
      value: function () {
        var _stopReceiving2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee242(e) {
          var _t230, i;

          return _regeneratorRuntime.wrap(function _callee242$(_context242) {
            while (1) {
              switch (_context242.prev = _context242.next) {
                case 0:
                  _context242.prev = 0;

                  if (this.remoteSDP) {
                    _context242.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");

                case 3:
                  this.remoteSDP.stopSending(e);
                  _t230 = this.remoteSDP.toString();
                  _context242.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t230
                  });

                case 7:
                  _context242.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  i = _context242.sent;
                  _context242.next = 12;
                  return this.peerConnection.setLocalDescription(i);

                case 12:
                  _context242.next = 17;
                  break;

                case 14:
                  _context242.prev = 14;
                  _context242.t0 = _context242["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(_context242.t0.toString()));

                case 17:
                case "end":
                  return _context242.stop();
              }
            }
          }, _callee242, this, [[0, 14]]);
        }));

        function stopReceiving(_x391) {
          return _stopReceiving2.apply(this, arguments);
        }

        return stopReceiving;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee243(e) {
          return _regeneratorRuntime.wrap(function _callee243$(_context243) {
            while (1) {
              switch (_context243.prev = _context243.next) {
                case 0:
                case "end":
                  return _context243.stop();
              }
            }
          }, _callee243);
        }));

        function muteRemote(_x392) {
          return _muteRemote3.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee244(e) {
          return _regeneratorRuntime.wrap(function _callee244$(_context244) {
            while (1) {
              switch (_context244.prev = _context244.next) {
                case 0:
                case "end":
                  return _context244.stop();
              }
            }
          }, _callee244);
        }));

        function unmuteRemote(_x393) {
          return _unmuteRemote3.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee245(e) {
          var _t231;

          return _regeneratorRuntime.wrap(function _callee245$(_context245) {
            while (1) {
              switch (_context245.prev = _context245.next) {
                case 0:
                  _context245.prev = 0;

                  if (this.remoteSDP) {
                    _context245.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");

                case 3:
                  _t231 = this.peerConnection.getSenders().filter(function (t) {
                    var i;
                    return -1 !== e.indexOf((null === (i = t.track) || void 0 === i ? void 0 : i.id) || "");
                  });

                  if (!(_t231.length !== e.length)) {
                    _context245.next = 6;
                    break;
                  }

                  throw new Error("sender' length doesn't match mids' length.");

                case 6:
                  _t231.map(function (e) {
                    if (ST() && e.track) e.track.enabled = !1;else {
                      var _t232 = e.getParameters();

                      _t232.encodings.forEach(function (e) {
                        return e.active = !1;
                      }), e.setParameters(_t232);
                    }
                  });

                  _context245.next = 12;
                  break;

                case 9:
                  _context245.prev = 9;
                  _context245.t0 = _context245["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(_context245.t0.toString()));

                case 12:
                case "end":
                  return _context245.stop();
              }
            }
          }, _callee245, this, [[0, 9]]);
        }));

        function muteLocal(_x394) {
          return _muteLocal3.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee247(e) {
          var _t233, i, _n105;

          return _regeneratorRuntime.wrap(function _callee247$(_context247) {
            while (1) {
              switch (_context247.prev = _context247.next) {
                case 0:
                  _context247.prev = 0;

                  if (this.remoteSDP) {
                    _context247.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");

                case 3:
                  _t233 = this.peerConnection.getSenders().filter(function (t) {
                    var i;
                    return -1 !== e.indexOf((null === (i = t.track) || void 0 === i ? void 0 : i.id) || "");
                  });

                  if (!(_t233.length !== e.length)) {
                    _context247.next = 6;
                    break;
                  }

                  throw new Error("Senders' length doesn't match mids' length.");

                case 6:
                  _t233.map( /*#__PURE__*/function () {
                    var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee246(e) {
                      var _t234;

                      return _regeneratorRuntime.wrap(function _callee246$(_context246) {
                        while (1) {
                          switch (_context246.prev = _context246.next) {
                            case 0:
                              if (!(ST() && e.track)) {
                                _context246.next = 4;
                                break;
                              }

                              e.track.enabled = !0;
                              _context246.next = 8;
                              break;

                            case 4:
                              _t234 = e.getParameters();

                              _t234.encodings.forEach(function (e) {
                                return e.active = !0;
                              });

                              _context246.next = 8;
                              return e.setParameters(_t234);

                            case 8:
                            case "end":
                              return _context246.stop();
                          }
                        }
                      }, _callee246);
                    }));

                    return function (_x396) {
                      return _ref66.apply(this, arguments);
                    };
                  }());

                  _context247.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context247.sent;
                  _context247.next = 12;
                  return this.peerConnection.setLocalDescription(i);

                case 12:
                  _n105 = this.remoteSDP.toString();
                  _context247.next = 15;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _n105
                  });

                case 15:
                  _context247.next = 20;
                  break;

                case 17:
                  _context247.prev = 17;
                  _context247.t0 = _context247["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(_context247.t0.toString()));

                case 20:
                case "end":
                  return _context247.stop();
              }
            }
          }, _callee247, this, [[0, 17]]);
        }));

        function unmuteLocal(_x395) {
          return _unmuteLocal3.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee248() {
          var i, _i124, _n107, _n106, _s70, _yield$_s70$iceParame, _r39, _o33;

          return _regeneratorRuntime.wrap(function _callee248$(_context248) {
            while (1) {
              switch (_context248.prev = _context248.next) {
                case 0:
                  _context248.next = 2;
                  return SP(t.mutex.lock("From P2PConnection.restartICE"));

                case 2:
                  i = _context248.sent;
                  _context248.prev = 3;

                  if (t.remoteSDP) {
                    _context248.next = 6;
                    break;
                  }

                  throw new Error("Cannot restartICE before remoteSDP created.");

                case 6:
                  if (!wA().supportPCSetConfiguration) {
                    _context248.next = 11;
                    break;
                  }

                  _i124 = t.peerConnection.getConfiguration(), _n107 = e === pv.RELAY ? "relay" : "all";
                  _i124.iceTransportPolicy !== _n107 && (YC.debug("[".concat(t.store.clientId, "] restartICE change iceTransportPolicy from [").concat(_i124.iceTransportPolicy, "] to [").concat(_n107, "]")), _i124.iceTransportPolicy = _n107, t.peerConnection.setConfiguration(_i124));
                  _context248.next = 13;
                  break;

                case 11:
                  if (!(e === pv.RELAY)) {
                    _context248.next = 13;
                    break;
                  }

                  return _context248.abrupt("return");

                case 13:
                  e !== pv.RELAY && t.remoteSDP.updateCandidates(e);
                  _context248.next = 16;
                  return SP(t.peerConnection.createOffer({
                    iceRestart: !0
                  }));

                case 16:
                  _n106 = _context248.sent;

                  if (_n106.sdp) {
                    _context248.next = 19;
                    break;
                  }

                  throw new Error("Cannot restartICE because restart offer SDP does not exist.");

                case 19:
                  _s70 = mL(_n106.sdp);
                  _context248.next = 22;
                  return _s70.iceParameters;

                case 22:
                  _yield$_s70$iceParame = _context248.sent;
                  _r39 = _yield$_s70$iceParame.remoteIceParameters;
                  t.remoteSDP.restartICE(_r39);
                  _o33 = t.remoteSDP.toString();
                  _context248.next = 28;
                  return SP(t.peerConnection.setLocalDescription(_n106));

                case 28:
                  _context248.next = 30;
                  return SP(t.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o33
                  }));

                case 30:
                  _context248.next = 35;
                  break;

                case 32:
                  _context248.prev = 32;
                  _context248.t0 = _context248["catch"](3);
                  YC.warning("[".concat(t.store.clientId, "] restart ICE failed, abort operation"), _context248.t0);

                case 35:
                  _context248.prev = 35;
                  i();
                  return _context248.finish(35);

                case 38:
                case "end":
                  return _context248.stop();
              }
            }
          }, _callee248, null, [[3, 32, 35, 38]]);
        }))();
      }
    }, {
      key: "close",
      value: function close() {
        var e;
        this.peerConnection.close(), null === (e = this.onConnectionStateChange) || void 0 === e || e.call(this, "closed"), this.unbindPCEvents(), this.unbindStatsEvents(), this.removeAllListeners(), this.statsFilter.destroy();
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return this.statsFilter.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        return this.statsFilter.getVideoIsReady(e);
      }
    }, {
      key: "updateEncoderConfig",
      value: function () {
        var _updateEncoderConfig2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee249(e, t) {
          var _e270, i, _n108;

          return _regeneratorRuntime.wrap(function _callee249$(_context249) {
            while (1) {
              switch (_context249.prev = _context249.next) {
                case 0:
                  _context249.prev = 0;

                  if (this.remoteSDP) {
                    _context249.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");

                case 3:
                  _context249.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  _e270 = _context249.sent;
                  i = this.mungSendOfferSDP(_e270.sdp, [t]);
                  this.remoteSDP.updateRecvMedia(t._mediaStreamTrack.kind, t);
                  _n108 = this.remoteSDP.toString();
                  _context249.next = 11;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: i
                  });

                case 11:
                  _context249.next = 13;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _n108
                  });

                case 13:
                  _context249.next = 18;
                  break;

                case 15:
                  _context249.prev = 15;
                  _context249.t0 = _context249["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, _context249.t0.toString());

                case 18:
                case "end":
                  return _context249.stop();
              }
            }
          }, _callee249, this, [[0, 15]]);
        }));

        function updateEncoderConfig(_x397, _x398) {
          return _updateEncoderConfig2.apply(this, arguments);
        }

        return updateEncoderConfig;
      }()
    }, {
      key: "updateSendParameters",
      value: function () {
        var _updateSendParameters2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee250(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee250$(_context250) {
            while (1) {
              switch (_context250.prev = _context250.next) {
                case 0:
                  i = this.peerConnection.getSenders().filter(function (t) {
                    var i;
                    return (null === (i = t.track) || void 0 === i ? void 0 : i.id) === e;
                  });
                  _context250.t0 = 1 === i.length;

                  if (!_context250.t0) {
                    _context250.next = 5;
                    break;
                  }

                  _context250.next = 5;
                  return this.applySendEncodings(i, [t]);

                case 5:
                case "end":
                  return _context250.stop();
              }
            }
          }, _callee250, this);
        }));

        function updateSendParameters(_x399, _x400) {
          return _updateSendParameters2.apply(this, arguments);
        }

        return updateSendParameters;
      }()
    }, {
      key: "setStatsRemoteVideoIsReady",
      value: function setStatsRemoteVideoIsReady(e, t) {
        this.statsFilter.setVideoIsReady2(e, t);
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee251(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee251$(_context251) {
            while (1) {
              switch (_context251.prev = _context251.next) {
                case 0:
                  i = this.peerConnection.getSenders().find(function (e) {
                    var i;
                    return (null === (i = e.track) || void 0 === i ? void 0 : i.id) === t;
                  });
                  _context251.t0 = i;

                  if (!_context251.t0) {
                    _context251.next = 5;
                    break;
                  }

                  _context251.next = 5;
                  return i.replaceTrack(e._mediaStreamTrack);

                case 5:
                case "end":
                  return _context251.stop();
              }
            }
          }, _callee251, this);
        }));

        function replaceTrack(_x401, _x402) {
          return _replaceTrack3.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "createDataChannels",
      value: function createDataChannels(e, t) {
        throw new VT(xT.NOT_SUPPORTED, "Planb mode does not support createDataChannels.");
      }
    }, {
      key: "stopDataChannels",
      value: function stopDataChannels(e) {
        throw new VT(xT.NOT_SUPPORTED, "Planb mode does not support stopDataChannels.");
      }
    }, {
      key: "bindPCEvents",
      value: function bindPCEvents() {
        var _this241 = this;

        this.peerConnection.oniceconnectionstatechange = function () {
          var e;
          null === (e = _this241.onICEConnectionStateChange) || void 0 === e || e.call(_this241, _this241.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = function () {
          var e;
          null === (e = _this241.onConnectionStateChange) || void 0 === e || e.call(_this241, _this241.peerConnection.connectionState);
        }, this.peerConnection.onicecandidate = function (e) {
          e.candidate ? _this241.localCandidateCount += 1 : (_this241.peerConnection.onicecandidate = null, _this241.allCandidatesReceived = !0, YC.debug("[".concat(_this241.store.clientId, "] [pc-").concat(_this241.store.p2pId, "] local candidate count"), _this241.localCandidateCount));
        }, setTimeout(function () {
          _this241.allCandidatesReceived || (_this241.allCandidatesReceived = !0, YC.debug("[".concat(_this241.store.clientId, "] [pc-").concat(_this241.store.p2pId, "] onicecandidate timeout, local candidate count"), _this241.localCandidateCount));
        }, DC("CANDIDATE_TIMEOUT"));
      }
    }, {
      key: "unbindPCEvents",
      value: function unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
    }, {
      key: "updateRtpSenderEncodings",
      value: function () {
        var _updateRtpSenderEncodings2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee252(e, t) {
          var i, n, s, r, _e271, o, a;

          return _regeneratorRuntime.wrap(function _callee252$(_context252) {
            while (1) {
              switch (_context252.prev = _context252.next) {
                case 0:
                  if (!t) {
                    t = this.peerConnection.getSenders().find(function (t) {
                      var i;
                      return (null === (i = t.track) || void 0 === i ? void 0 : i.id) === e._mediaStreamTrack.id;
                    });
                  }

                  if (t) {
                    _context252.next = 3;
                    break;
                  }

                  return _context252.abrupt("return", YC.warn("[".concat(e.getTrackId(), "] no rtpSender found}")));

                case 3:
                  if (wA().supportSetRtpSenderParameters) {
                    _context252.next = 5;
                    break;
                  }

                  return _context252.abrupt("return", YC.warn("Browser not support set rtp-sender parameters"));

                case 5:
                  n = {}, s = {};

                  if (!(e instanceof Nw)) {
                    _context252.next = 15;
                    break;
                  }

                  _context252.t0 = e._optimizationMode;
                  _context252.next = _context252.t0 === "motion" ? 10 : _context252.t0 === "detail" ? 12 : 14;
                  break;

                case 10:
                  n.degradationPreference = "maintain-framerate";
                  return _context252.abrupt("break", 15);

                case 12:
                  n.degradationPreference = "maintain-resolution";
                  return _context252.abrupt("break", 15);

                case 14:
                  n.degradationPreference = "balanced";

                case 15:
                  if (DC("DSCP_TYPE") && kT()) {
                    _e271 = DC("DSCP_TYPE");
                    bn(r = ["very-low", "low", "medium", "high"]).call(r, _e271) && (s.networkPriority = _e271);
                  }

                  o = t.getParameters(), a = null === (i = o.encodings) || void 0 === i ? void 0 : i[0];
                  a && Object.assign(a, s);
                  Object.assign(o, n);
                  YC.debug("[".concat(e.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(o.encodings)));
                  _context252.next = 22;
                  return t.setParameters(o);

                case 22:
                case "end":
                  return _context252.stop();
              }
            }
          }, _callee252, this);
        }));

        function updateRtpSenderEncodings(_x403, _x404) {
          return _updateRtpSenderEncodings2.apply(this, arguments);
        }

        return updateRtpSenderEncodings;
      }()
    }, {
      key: "applySendEncodings",
      value: function () {
        var _applySendEncodings2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee253(e, t) {
          var i, _n109, _s71;

          return _regeneratorRuntime.wrap(function _callee253$(_context253) {
            while (1) {
              switch (_context253.prev = _context253.next) {
                case 0:
                  _context253.prev = 0;

                  if (wA().supportSetRtpSenderParameters) {
                    _context253.next = 3;
                    break;
                  }

                  return _context253.abrupt("return");

                case 3:
                  if (!(e.length !== t.length)) {
                    _context253.next = 5;
                    break;
                  }

                  return _context253.abrupt("return");

                case 5:
                  i = 0;

                case 6:
                  if (!(i < e.length)) {
                    _context253.next = 15;
                    break;
                  }

                  _n109 = e[i], _s71 = t[i];
                  _context253.t0 = _n109 && _s71;

                  if (!_context253.t0) {
                    _context253.next = 12;
                    break;
                  }

                  _context253.next = 12;
                  return this.updateRtpSenderEncodings(_s71, _n109);

                case 12:
                  i++;
                  _context253.next = 6;
                  break;

                case 15:
                  _context253.next = 20;
                  break;

                case 17:
                  _context253.prev = 17;
                  _context253.t1 = _context253["catch"](0);
                  YC.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));

                case 20:
                case "end":
                  return _context253.stop();
              }
            }
          }, _callee253, this, [[0, 17]]);
        }));

        function applySendEncodings(_x405, _x406) {
          return _applySendEncodings2.apply(this, arguments);
        }

        return applySendEncodings;
      }()
    }, {
      key: "mungSendOfferSDP",
      value: function mungSendOfferSDP(e, t) {
        var i = YP.parse(e);
        return t.forEach(function (e, t) {
          var n = e._mediaStreamTrack,
              s = i.mediaDescriptions.find(function (e) {
            return e.attributes.mid === n.kind;
          });
          s && SL(s, e);
        }), YP.print(i);
      }
    }, {
      key: "bindStatsEvents",
      value: function bindStatsEvents() {
        var _this242 = this;

        this.statsFilter.onFirstAudioReceived = function (e) {
          var t;
          null === (t = _this242.onFirstAudioReceived) || void 0 === t || t.call(_this242, e);
        }, this.statsFilter.onFirstVideoReceived = function (e) {
          var t;
          null === (t = _this242.onFirstVideoReceived) || void 0 === t || t.call(_this242, e);
        }, this.statsFilter.onFirstAudioDecoded = function (e) {
          var t;
          null === (t = _this242.onFirstAudioDecoded) || void 0 === t || t.call(_this242, e);
        }, this.statsFilter.onFirstVideoDecoded = function (e, t, i) {
          var n;
          null === (n = _this242.onFirstVideoDecoded) || void 0 === n || n.call(_this242, e, t, i);
        }, this.statsFilter.onSelectedLocalCandidateChanged = function (e, t) {
          var i;
          null === (i = _this242.onSelectedLocalCandidateChanged) || void 0 === i || i.call(_this242, e, t);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = function (e, t) {
          var i;
          null === (i = _this242.onSelectedRemoteCandidateChanged) || void 0 === i || i.call(_this242, e, t);
        };
      }
    }, {
      key: "unbindStatsEvents",
      value: function unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0;
      }
    }, {
      key: "batchReceive",
      value: function () {
        var _batchReceive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee254(e) {
          var _this243 = this;

          var _t235, i, _n110;

          return _regeneratorRuntime.wrap(function _callee254$(_context254) {
            while (1) {
              switch (_context254.prev = _context254.next) {
                case 0:
                  _context254.prev = 0;

                  if (this.remoteSDP) {
                    _context254.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.batchReceive before remoteSDP created.");

                case 3:
                  _t235 = this.remoteSDP.batchSend(e).map(function (t, i) {
                    var n = t.id,
                        s = t.mslabel;
                    var r = e[i].kind;
                    return new tT(function (e, t) {
                      var i = setTimeout(function () {
                        t(new Error("Cannot receive track, id: ".concat(n)));
                      }, 1e4),
                          o = function o(t) {
                        var a = pT();

                        if ("Safari" === a.name && 11 === Number(a.version) && t.track.id !== n && t.streams[0].id === s) {
                          var c;
                          var _s72 = t.streams[0].getTracks()[0];
                          return null === (c = _this243.remoteSDP) || void 0 === c || c.updateTrackLabel(r, n, t.track.id), _this243.peerConnection.removeEventListener("track", o), clearTimeout(i), void e({
                            track: _s72,
                            id: n
                          });
                        }

                        if (t.track.id === n) return _this243.peerConnection.removeEventListener("track", o), clearTimeout(i), void e({
                          track: t.track,
                          id: n
                        });
                      };

                      _this243.peerConnection.addEventListener("track", o);
                    });
                  }), i = this.remoteSDP.toString();
                  _context254.next = 6;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: i
                  });

                case 6:
                  _context254.next = 8;
                  return this.peerConnection.createAnswer();

                case 8:
                  _n110 = _context254.sent;
                  _context254.next = 11;
                  return this.peerConnection.setLocalDescription(_n110);

                case 11:
                  _context254.next = 13;
                  return tT.all(_t235);

                case 13:
                  return _context254.abrupt("return", _context254.sent);

                case 16:
                  _context254.prev = 16;
                  _context254.t0 = _context254["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context254.t0.toString()));

                case 19:
                case "end":
                  return _context254.stop();
              }
            }
          }, _callee254, this, [[0, 16]]);
        }));

        function batchReceive(_x407) {
          return _batchReceive.apply(this, arguments);
        }

        return batchReceive;
      }()
    }, {
      key: "getRemoteSSRC",
      value: function () {
        var _getRemoteSSRC2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee255(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee255$(_context255) {
            while (1) {
              switch (_context255.prev = _context255.next) {
                case 0:
                  if (this.remoteSDP) {
                    _context255.next = 2;
                    break;
                  }

                  return _context255.abrupt("return");

                case 2:
                  t = this.remoteSDP.getSSRC(e);
                  return _context255.abrupt("return", null == t ? void 0 : t[0].ssrcId);

                case 4:
                case "end":
                  return _context255.stop();
              }
            }
          }, _callee255, this);
        }));

        function getRemoteSSRC(_x408) {
          return _getRemoteSSRC2.apply(this, arguments);
        }

        return getRemoteSSRC;
      }()
    }, {
      key: "setConfiguration",
      value: function setConfiguration(e) {
        if (wA().supportPCSetConfiguration) {
          var _t236 = wk.resolvePCConfiguration(e);

          this.peerConnection.setConfiguration(_t236);
        }
      }
    }], [{
      key: "resolvePCConfiguration",
      value: function resolvePCConfiguration(e) {
        var _t$iceServers, _t$iceServers2;

        var t = {
          iceServers: [],
          sdpSemantics: "plan-b"
        };
        return e.iceServers ? t.iceServers = e.iceServers : e.turnServer && "off" !== e.turnServer.mode && (_g(e.turnServer.servers) ? t.iceServers = e.turnServer.servers : (t.iceServers && (_t$iceServers = t.iceServers).push.apply(_t$iceServers, _toConsumableArray(wk.turnServerConfigToIceServers(e.turnServer.servers))), DC("USE_TURN_SERVER_OF_GATEWAY") && t.iceServers && e.turnServer.serversFromGateway && (_t$iceServers2 = t.iceServers).push.apply(_t$iceServers2, _toConsumableArray(wk.turnServerConfigToIceServers(e.turnServer.serversFromGateway))), e.turnServer.servers.concat(e.turnServer.serversFromGateway || []).forEach(function (e) {
          e.forceturn && (t.iceTransportPolicy = "relay");
        }))), t;
      }
    }, {
      key: "turnServerConfigToIceServers",
      value: function turnServerConfigToIceServers(e) {
        var t = [];
        return e.forEach(function (e) {
          e.security ? e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turns:".concat(e.turnServerURL, ":").concat(e.tcpport, "?transport=tcp")
          }) : (e.udpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.udpport, "?transport=udp")
          }), e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.tcpport, "?transport=tcp")
          }));
        }), t;
      }
    }]);

    return wk;
  }(Mv);

  function Ok(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee256() {
      var e,
          i,
          s,
          r,
          o,
          _args256 = arguments;
      return _regeneratorRuntime.wrap(function _callee256$(_context256) {
        while (1) {
          switch (_context256.prev = _context256.next) {
            case 0:
              e = this.mutex;
              _context256.next = 3;
              return e.lock("Locking from P2PConnection.".concat(t));

            case 3:
              i = _context256.sent;
              _context256.prev = 4;

              for (s = _args256.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args256[o];
              }

              _context256.next = 8;
              return n.apply(this, r);

            case 8:
              return _context256.abrupt("return", _context256.sent);

            case 9:
              _context256.prev = 9;
              i();
              return _context256.finish(9);

            case 12:
            case "end":
              return _context256.stop();
          }
        }
      }, _callee256, this, [[4,, 9, 12]]);
    })), i;
  }

  function Nk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Dk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Nk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Nk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  UI([Ok, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], wk.prototype, "connect", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], wk.prototype, "stopSending", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, Object]), xI("design:returntype", tT)], wk.prototype, "receive", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], wk.prototype, "stopReceiving", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], wk.prototype, "muteRemote", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], wk.prototype, "unmuteRemote", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], wk.prototype, "muteLocal", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], wk.prototype, "unmuteLocal", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], wk.prototype, "close", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], wk.prototype, "updateEncoderConfig", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], wk.prototype, "updateSendParameters", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [_b, String]), xI("design:returntype", tT)], wk.prototype, "replaceTrack", null), UI([Ok, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], wk.prototype, "getRemoteSSRC", null);
  var Pk = "9",
      Lk = 4e4;

  function kk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Mk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? kk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : kk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var Uk = /*#__PURE__*/function (_Mv2) {
    _inherits(Uk, _Mv2);

    var _super63 = _createSuper(Uk);

    function Uk(e, t) {
      var _this244;

      _classCallCheck(this, Uk);

      _this244 = _super63.call(this, e, t), nh(_assertThisInitialized(_this244), "store", void 0), nh(_assertThisInitialized(_this244), "peerConnection", void 0), nh(_assertThisInitialized(_this244), "remoteSDP", void 0), nh(_assertThisInitialized(_this244), "initialOffer", void 0), nh(_assertThisInitialized(_this244), "transportEventReceiver", void 0), nh(_assertThisInitialized(_this244), "statsFilter", void 0), nh(_assertThisInitialized(_this244), "useXR", DC("USE_XR")), nh(_assertThisInitialized(_this244), "localCapabilities", void 0), nh(_assertThisInitialized(_this244), "remoteCodecs", void 0), nh(_assertThisInitialized(_this244), "localCandidateCount", 0), nh(_assertThisInitialized(_this244), "allCandidatesReceived", !1), nh(_assertThisInitialized(_this244), "dataStreamChannelMap", new Map()), nh(_assertThisInitialized(_this244), "establishPromise", void 0), nh(_assertThisInitialized(_this244), "mutex", new Yg("P2PConnection-mutex")), _this244.store = t, _this244.peerConnection = new RTCPeerConnection(Uk.resolvePCConfiguration(e), {
        optional: [{
          googDscp: !0
        }]
      }), _this244.statsFilter = hL(_this244.peerConnection, DC("STATS_UPDATE_INTERVAL"), void 0, RT() ? 1200 : void 0), _this244.bindPCEvents(), _this244.bindStatsEvents(), _this244.store.p2pId = _this244.store.p2pId + 1, _this244.establishPromise = _this244.establish();
      return _this244;
    }

    _createClass(Uk, [{
      key: "currentLocalDescription",
      get: function get() {
        return this.peerConnection.currentLocalDescription;
      }
    }, {
      key: "currentRemoteDescription",
      get: function get() {
        return this.peerConnection.currentRemoteDescription;
      }
    }, {
      key: "peerConnectionState",
      get: function get() {
        return this.peerConnection.connectionState;
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.peerConnection.iceConnectionState;
      }
    }, {
      key: "dtlsTransportState",
      get: function get() {
        var e, t;
        return null !== (e = null === (t = this.peerConnection.getReceivers()[0]) || void 0 === t || null === (t = t.transport) || void 0 === t ? void 0 : t.state) && void 0 !== e ? e : null;
      }
    }, {
      key: "localCodecs",
      get: function get() {
        return _toConsumableArray(new Set(this.localCapabilities && this.localCapabilities.send.videoCodecs.map(function (e) {
          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
        }).filter(function (e) {
          var t;
          return bn(t = Object.keys(xC)).call(t, e);
        })));
      }
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function () {
        var _updateRemoteRTPCapabilities2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee257(e, t) {
          var _e272, _t237, i;

          return _regeneratorRuntime.wrap(function _callee257$(_context257) {
            while (1) {
              switch (_context257.prev = _context257.next) {
                case 0:
                  if (!(this.remoteCodecs = t, !this.remoteSDP)) {
                    _context257.next = 2;
                    break;
                  }

                  return _context257.abrupt("return", void YC.debug("[P2PConnection] cannot updateRemoteRTPCapabilities before remote SDP created, local codecs: ".concat(this.localCodecs, ", codecs: ").concat(t)));

                case 2:
                  if (!this.remoteSDP.updateRemoteCodec(e, t, this.store.codec)) {
                    _context257.next = 15;
                    break;
                  }

                  _context257.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  _e272 = _context257.sent;
                  _t237 = this.logSDPExchange(_e272.sdp || "", "offer", "local", "muteLocal");
                  _context257.next = 9;
                  return this.peerConnection.setLocalDescription(_e272);

                case 9:
                  i = this.remoteSDP.toString();
                  null == _t237 || _t237(i);
                  _context257.next = 13;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: i
                  });

                case 13:
                  _context257.next = 16;
                  break;

                case 15:
                  YC.debug("[P2PConnection] updateRemoteRTPCapabilities no need to exchange SDP.");

                case 16:
                case "end":
                  return _context257.stop();
              }
            }
          }, _callee257, this);
        }));

        function updateRemoteRTPCapabilities(_x409, _x410) {
          return _updateRemoteRTPCapabilities2.apply(this, arguments);
        }

        return updateRemoteRTPCapabilities;
      }()
    }, {
      key: "establish",
      value: function () {
        var _establish3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee258() {
          var _e273, _t238, i;

          return _regeneratorRuntime.wrap(function _callee258$(_context258) {
            while (1) {
              switch (_context258.prev = _context258.next) {
                case 0:
                  _context258.prev = 0;
                  this.peerConnection.addTransceiver("video", {
                    direction: "recvonly"
                  }), this.peerConnection.addTransceiver("audio", {
                    direction: "recvonly"
                  });
                  _context258.next = 4;
                  return this.peerConnection.createOffer();

                case 4:
                  _e273 = _context258.sent;

                  if (_e273.sdp) {
                    _context258.next = 7;
                    break;
                  }

                  throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");

                case 7:
                  _t238 = mL(_e273.sdp);
                  _context258.next = 10;
                  return AL({
                    filterRTX: !DC("USE_PUB_RTX") && !DC("USE_SUB_RTX"),
                    filterVideoFec: DC("FILTER_VIDEO_FEC"),
                    filterAudioFec: DC("FILTER_AUDIO_FEC"),
                    filterVideoCodec: DC("FILTER_VIDEO_CODEC")
                  }, {
                    useXR: this.useXR
                  });

                case 10:
                  i = _context258.sent;
                  return _context258.abrupt("return", (this.localCapabilities = OL(i), this.initialOffer = _e273, Mk(Mk({}, _t238), {}, {
                    rtpCapabilities: i,
                    offerSDP: _e273.sdp
                  })));

                case 14:
                  _context258.prev = 14;
                  _context258.t0 = _context258["catch"](0);
                  throw new VT(xT.GET_LOCAL_CONNECTION_PARAMS_FAILED, _context258.t0.toString());

                case 17:
                case "end":
                  return _context258.stop();
              }
            }
          }, _callee258, this, [[0, 14]]);
        }));

        function establish() {
          return _establish3.apply(this, arguments);
        }

        return establish;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee259(e, t, i, n, s, r) {
          var _o34, _a18, c, _d11, _l8, _u4, _e287, _t242;

          return _regeneratorRuntime.wrap(function _callee259$(_context259) {
            while (1) {
              switch (_context259.prev = _context259.next) {
                case 0:
                  _context259.prev = 0;

                  if (this.initialOffer) {
                    _context259.next = 3;
                    break;
                  }

                  throw new Error("Cannot establish P2PConnection without initial offer.");

                case 3:
                  this.remoteSDP = new ( /*#__PURE__*/function () {
                    function _class13(e) {
                      _classCallCheck(this, _class13);

                      nh(this, "sessionDesc", void 0), nh(this, "_localCapabilities", void 0), nh(this, "_rtpCapabilities", void 0), nh(this, "_candidates", void 0), nh(this, "_iceParameters", void 0), nh(this, "_dtlsParameters", void 0), nh(this, "setup", void 0), nh(this, "currentMidIndex", void 0), nh(this, "cname", void 0), nh(this, "firefoxSsrcMidMap", new Map()), e = bg(e);
                      var _e274 = e,
                          t = _e274.remoteIceParameters,
                          i = _e274.remoteDtlsParameters,
                          n = _e274.candidates,
                          s = _e274.remoteRTPCapabilities,
                          r = _e274.remoteSetup,
                          o = _e274.localCapabilities,
                          a = _e274.cname,
                          c = YP.parse("v=0\no=- 0 0 IN IP4 127.0.0.1\ns=AgoraGateway\nt=0 0\na=group:BUNDLE 0 1\na=msid-semantic: WMS\na=ice-lite\nm=video 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendonly\na=rtcp-mux\na=rtcp-rsize\na=mid:0\nm=audio 9 UDP/TLS/RTP/SAVPF 0\nc=IN IP4 127.0.0.1\na=rtcp:9 IN IP4 0.0.0.0\na=sendonly\na=rtcp-mux\na=rtcp-rsize\na=mid:1\n");
                      this._rtpCapabilities = s, this._candidates = n, this._iceParameters = t, this._dtlsParameters = i, this._localCapabilities = o, this.setup = r, this.cname = a;
                      var d = this.rtpCapabilities.send;

                      var _iterator31 = _createForOfIteratorHelper(c.mediaDescriptions),
                          _step31;

                      try {
                        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                          var _e275 = _step31.value;

                          if (_e275.attributes.iceUfrag = t.iceUfrag, _e275.attributes.icePwd = t.icePwd, _e275.attributes.fingerprints = i.fingerprints, _e275.attributes.candidates = n, _e275.attributes.setup = r, "video" === _e275.media.mediaType && (_e275.media.fmts = d.videoCodecs.map(function (e) {
                            return e.payloadType.toString(10);
                          }), _e275.attributes.payloads = d.videoCodecs, _e275.attributes.extmaps = d.videoExtensions, DC("PRELOAD_MEDIA_COUNT") > 0)) {
                            var _gL5 = gL([{
                              ssrcId: Lk,
                              rtx: DC("USE_SUB_RTX") ? 40001 : void 0
                            }], this.cname),
                                _t239 = _gL5.ssrcs,
                                _i125 = _gL5.ssrcGroups;

                            _e275.attributes.ssrcs = _t239, _e275.attributes.ssrcGroups = _i125;
                          }

                          if ("audio" === _e275.media.mediaType && (_e275.media.fmts = d.audioCodecs.map(function (e) {
                            return e.payloadType.toString(10);
                          }), _e275.attributes.payloads = d.audioCodecs, _e275.attributes.extmaps = d.audioExtensions, NL(_e275), DC("PRELOAD_MEDIA_COUNT") > 0)) {
                            var _gL6 = gL([{
                              ssrcId: 2e4
                            }], this.cname),
                                _t240 = _gL6.ssrcs,
                                _i126 = _gL6.ssrcGroups;

                            _e275.attributes.ssrcs = _t240, _e275.attributes.ssrcGroups = _i126;
                          }
                        }
                      } catch (err) {
                        _iterator31.e(err);
                      } finally {
                        _iterator31.f();
                      }

                      this.sessionDesc = c, this.currentMidIndex = c.mediaDescriptions.length - 1;
                    }

                    _createClass(_class13, [{
                      key: "localCapabilities",
                      get: function get() {
                        return bg(this._localCapabilities);
                      }
                    }, {
                      key: "rtpCapabilities",
                      get: function get() {
                        return bg(this._rtpCapabilities);
                      }
                    }, {
                      key: "candidates",
                      get: function get() {
                        return bg(this._candidates);
                      }
                    }, {
                      key: "iceParameters",
                      get: function get() {
                        return bg(this._iceParameters);
                      }
                    }, {
                      key: "dtlsParameters",
                      get: function get() {
                        return bg(this._dtlsParameters);
                      }
                    }, {
                      key: "preloadRemoteMedia",
                      value: function preloadRemoteMedia() {
                        var e = DC("PRELOAD_MEDIA_COUNT");
                        this.rtpCapabilities;
                        var t = this.candidates,
                            i = this.dtlsParameters,
                            n = this.iceParameters,
                            s = this.rtpCapabilities.send;

                        for (var _r40 = 1; _r40 < e; _r40++) {
                          var _e276 = 2 * _r40 + 2e4,
                              _o35 = 2 * _r40 + Lk,
                              _gL7 = gL([{
                            ssrcId: _e276
                          }], this.cname),
                              _a19 = _gL7.ssrcs,
                              _c8 = _gL7.ssrcGroups,
                              _gL8 = gL([{
                            ssrcId: _o35,
                            rtx: DC("USE_SUB_RTX") ? _o35 + 1 : void 0
                          }], this.cname),
                              _d12 = _gL8.ssrcs,
                              _l9 = _gL8.ssrcGroups;

                          this.sessionDesc.mediaDescriptions.push({
                            media: {
                              mediaType: "video",
                              port: Pk,
                              protos: ["UDP", "TLS", "RTP", "SAVPF"],
                              fmts: s.videoCodecs.map(function (e) {
                                return e.payloadType.toString(10);
                              })
                            },
                            connections: [{
                              nettype: "IN",
                              addrtype: "IP4",
                              address: "127.0.0.1"
                            }],
                            bandwidths: [],
                            attributes: {
                              iceUfrag: n.iceUfrag,
                              icePwd: n.icePwd,
                              unrecognized: [],
                              candidates: t,
                              extmaps: s.videoExtensions,
                              fingerprints: i.fingerprints,
                              imageattr: [],
                              msids: [],
                              remoteCandidatesList: [],
                              rids: [],
                              ssrcs: _d12,
                              ssrcGroups: _l9,
                              rtcpFeedbackWildcards: [],
                              payloads: s.videoCodecs,
                              rtcp: {
                                port: "9",
                                netType: "IN",
                                addressType: "IP4",
                                address: "0.0.0.0"
                              },
                              setup: this.setup,
                              direction: "sendonly",
                              rtcpMux: !0,
                              rtcpRsize: !0,
                              mid: "".concat(2 * _r40)
                            }
                          }), this.sessionDesc.mediaDescriptions.push({
                            media: {
                              mediaType: "audio",
                              port: Pk,
                              protos: ["UDP", "TLS", "RTP", "SAVPF"],
                              fmts: s.audioCodecs.map(function (e) {
                                return e.payloadType.toString(10);
                              })
                            },
                            connections: [{
                              nettype: "IN",
                              addrtype: "IP4",
                              address: "127.0.0.1"
                            }],
                            bandwidths: [],
                            attributes: {
                              iceUfrag: n.iceUfrag,
                              icePwd: n.icePwd,
                              unrecognized: [],
                              candidates: t,
                              extmaps: s.audioExtensions,
                              fingerprints: i.fingerprints,
                              imageattr: [],
                              msids: [],
                              remoteCandidatesList: [],
                              rids: [],
                              ssrcs: _a19,
                              ssrcGroups: _c8,
                              rtcpFeedbackWildcards: [],
                              payloads: s.audioCodecs,
                              rtcp: {
                                port: "9",
                                netType: "IN",
                                addressType: "IP4",
                                address: "0.0.0.0"
                              },
                              setup: this.setup,
                              direction: "sendonly",
                              rtcpMux: !0,
                              rtcpRsize: !0,
                              mid: "".concat(2 * _r40 + 1)
                            }
                          }), this.currentMidIndex += 2;
                        }

                        this.updateBundleMids();
                      }
                    }, {
                      key: "toString",
                      value: function toString() {
                        return YP.print(this.sessionDesc);
                      }
                    }, {
                      key: "send",
                      value: function send(e, t, i, n) {
                        var _gL9 = gL(t, this.cname, DC("SYNC_GROUP") ? i : void 0),
                            s = _gL9.ssrcs,
                            r = _gL9.ssrcGroups,
                            o = this.findPreloadMediaDesc(s);

                        if (o) {
                          if (RT() && this.firefoxSsrcMidMap.set(s[0].ssrcId, o.attributes.mid), n && (n.twcc || n.remb)) {
                            var _e277 = this.sessionDesc.mediaDescriptions.indexOf(o);

                            return this.sessionDesc.mediaDescriptions[_e277] = this.mungSendMediaDesc(o, n), {
                              mid: o.attributes.mid,
                              needExchangeSDP: !0
                            };
                          }

                          return {
                            mid: o.attributes.mid,
                            needExchangeSDP: !1
                          };
                        }

                        {
                          var _t241 = this.findAvailableMediaIndex(e, s);

                          var _i127;

                          return -1 === _t241 || 1 === _t241 && (ST() || AT()) || 0 === _t241 && DC("USE_SUB_RTX") || bT() ? (_i127 = this.createOrRecycleSendMedia(e, s, r, "sendonly", n), this.updateBundleMids()) : (_i127 = bg(this.sessionDesc.mediaDescriptions[_t241]), _i127.attributes.direction = "sendonly", _i127.attributes.ssrcs = s, _i127.attributes.ssrcGroups = r, this.sessionDesc.mediaDescriptions[_t241] = this.mungSendMediaDesc(_i127, n)), RT() && this.firefoxSsrcMidMap.set(s[0].ssrcId, _i127.attributes.mid), {
                            mid: _i127.attributes.mid,
                            needExchangeSDP: !0
                          };
                        }
                      }
                    }, {
                      key: "sendDataChannel",
                      value: function sendDataChannel() {
                        var _this$createOrRecycle = this.createOrRecycleDataChannel(),
                            e = _this$createOrRecycle.mediaDesc,
                            t = _this$createOrRecycle.needExchangeSDP;

                        return this.updateBundleMids(), {
                          mid: e.attributes.mid,
                          needExchangeSDP: t
                        };
                      }
                    }, {
                      key: "batchSend",
                      value: function batchSend(e) {
                        var _this245 = this;

                        var t = e.map(function (e) {
                          var t = e.kind,
                              i = e.ssrcMsg,
                              n = e.mslabel;
                          return _this245.send(t, i, n);
                        }),
                            i = [];
                        var n = !1;
                        return t.forEach(function (e) {
                          var t = e.mid,
                              s = e.needExchangeSDP;
                          s && (n = !0), i.push(t);
                        }), {
                          mids: i,
                          needExchangeSDP: n
                        };
                      }
                    }, {
                      key: "stopSending",
                      value: function stopSending(e) {
                        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
                          return t.attributes.mid && -1 !== e.indexOf(t.attributes.mid);
                        });
                        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.stopSending.");
                        t.forEach(function (e) {
                          "0" === e.attributes.mid || RT() || bT() ? e.attributes.ssrcs = [] : (e.attributes.ssrcs = [], e.attributes.direction = "inactive", e.media.port = "0");
                        }), this.updateBundleMids();
                      }
                    }, {
                      key: "mute",
                      value: function mute(e) {
                        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return t.attributes.mid === e;
                        });
                        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.mute."));
                        t.attributes.direction = "inactive";
                      }
                    }, {
                      key: "unmute",
                      value: function unmute(e) {
                        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return t.attributes.mid === e;
                        });
                        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.unmute."));
                        t.attributes.direction = "sendonly";
                      }
                    }, {
                      key: "muteRemote",
                      value: function muteRemote(e) {
                        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
                          return bn(e).call(e, t.attributes.mid || "");
                        });
                        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
                        t.forEach(function (e) {
                          e.attributes.direction = "inactive";
                        });
                      }
                    }, {
                      key: "unmuteRemote",
                      value: function unmuteRemote(e) {
                        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
                          return bn(e).call(e, t.attributes.mid || "");
                        });
                        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
                        t.forEach(function (e) {
                          e.attributes.direction = "recvonly";
                        });
                      }
                    }, {
                      key: "receive",
                      value: function receive(e, t, i, n) {
                        var _this246 = this;

                        e.forEach(function (e, s) {
                          _this246.createOrRecycleRecvMedia(e, [], "recvonly", t, i, n[s]);
                        }), this.updateBundleMids();
                      }
                    }, {
                      key: "stopReceiving",
                      value: function stopReceiving(e) {
                        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
                          return -1 !== e.indexOf(t.attributes.mid);
                        });
                        if (t.length !== e.length) throw new Error("MediaDescriptions' length doesn't match mids's length when calling RemoteSDP.receive.");
                        t.forEach(function (e) {
                          e.media.port = "0", e.attributes.direction = "inactive";
                        }), this.updateBundleMids();
                      }
                    }, {
                      key: "updateCandidates",
                      value: function updateCandidates(e) {
                        var t = this._candidates.filter(function (e) {
                          return "udp" === e.transport;
                        });

                        if (e === pv.TCP) {
                          if (0 === t.length) return;

                          if (DC("TCP_CANDIDATE_ONLY")) {
                            var _e278 = this._candidates.filter(function (e) {
                              return "tcp" === e.transport;
                            });

                            t.forEach(function (t) {
                              -1 === _e278.findIndex(function (e) {
                                return e.connectionAddress === t.connectionAddress;
                              }) && _e278.push(Dk(Dk({}, t), {}, {
                                foundation: "tcpcandidate",
                                priority: Number(t.priority) - 1 + "",
                                transport: "tcp",
                                port: Number(t.port) + 90 + ""
                              }));
                            }), this._candidates = _e278;
                          } else {
                            var _e279 = [];
                            t.forEach(function (t) {
                              _e279.push(Dk(Dk({}, t), {}, {
                                foundation: "tcpcandidate",
                                priority: Number(t.priority) - 1 + "",
                                transport: "tcp",
                                port: Number(t.port) + 90 + ""
                              }));
                            }), this._candidates = [].concat(_toConsumableArray(t), _e279);
                          }
                        } else if (e === pv.RELAY) {
                          if (0 !== t.length) return;
                          {
                            var _e280 = this._candidates.filter(function (e) {
                              return "tcp" === e.transport;
                            });

                            _e280.forEach(function (e) {
                              t.push(Dk(Dk({}, e), {}, {
                                foundation: "udpcandidate",
                                priority: Number(e.priority) + 1 + "",
                                transport: "udp",
                                port: Number(e.port) - 90 + ""
                              }));
                            }), this._candidates = [].concat(_toConsumableArray(t), _toConsumableArray(_e280));
                          }
                        } else 0 === t.length ? (this._candidates.filter(function (e) {
                          return "tcp" === e.transport;
                        }).forEach(function (e) {
                          t.push(Dk(Dk({}, e), {}, {
                            foundation: "udpcandidate",
                            priority: Number(e.priority) + 1 + "",
                            transport: "udp",
                            port: Number(e.port) - 90 + ""
                          }));
                        }), this._candidates = t) : this._candidates = this._candidates.filter(function (e) {
                          return "tcp" !== e.transport;
                        });

                        var _iterator32 = _createForOfIteratorHelper(this.sessionDesc.mediaDescriptions),
                            _step32;

                        try {
                          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                            var _e281 = _step32.value;
                            _e281.attributes.candidates = this.candidates;
                          }
                        } catch (err) {
                          _iterator32.e(err);
                        } finally {
                          _iterator32.f();
                        }
                      }
                    }, {
                      key: "restartICE",
                      value: function restartICE(e) {
                        e = bg(e), this._iceParameters = e, this.sessionDesc.mediaDescriptions.forEach(function (t) {
                          t.attributes.iceUfrag = e.iceUfrag, t.attributes.icePwd = e.icePwd;
                        });
                      }
                    }, {
                      key: "predictReceivingMids",
                      value: function predictReceivingMids(e) {
                        var t = [];

                        for (var _i128 = 0; _i128 < e; _i128++) {
                          t.push((this.currentMidIndex + _i128 + 1).toString(10));
                        }

                        return t;
                      }
                    }, {
                      key: "findAvailableMediaIndex",
                      value: function findAvailableMediaIndex(e, t) {
                        var _this247 = this;

                        return this.sessionDesc.mediaDescriptions.findIndex(function (i) {
                          var n = i.media.mediaType === e && "0" !== i.media.port && ("sendonly" === i.attributes.direction || "sendrecv" === i.attributes.direction) && 0 === i.attributes.ssrcs.length;

                          if (RT()) {
                            if (n) {
                              var _e282 = _this247.firefoxSsrcMidMap.get(t[0].ssrcId);

                              return !(_e282 || "0" !== i.attributes.mid && "1" !== i.attributes.mid) || !(!_e282 || _e282 !== i.attributes.mid);
                            }

                            return !1;
                          }

                          return n;
                        });
                      }
                    }, {
                      key: "createOrRecycleDataChannel",
                      value: function createOrRecycleDataChannel() {
                        var _iterator33 = _createForOfIteratorHelper(this.sessionDesc.mediaDescriptions),
                            _step33;

                        try {
                          for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                            var _e283 = _step33.value;
                            if ("application" === _e283.media.mediaType) return {
                              mediaDesc: _e283,
                              needExchangeSDP: !1
                            };
                          }
                        } catch (err) {
                          _iterator33.e(err);
                        } finally {
                          _iterator33.f();
                        }

                        this.currentMidIndex += 1;
                        var e = "".concat(this.currentMidIndex),
                            t = {
                          media: {
                            mediaType: "application",
                            port: Pk,
                            protos: ["UDP", "DTLS", "SCTP"],
                            fmts: ["webrtc-datachannel"]
                          },
                          connections: [{
                            nettype: "IN",
                            addrtype: "IP4",
                            address: "127.0.0.1"
                          }],
                          bandwidths: [],
                          attributes: {
                            iceUfrag: this.iceParameters.iceUfrag,
                            icePwd: this.iceParameters.icePwd,
                            unrecognized: [],
                            candidates: this.candidates,
                            extmaps: [],
                            fingerprints: this.dtlsParameters.fingerprints,
                            imageattr: [],
                            msids: [],
                            remoteCandidatesList: [],
                            rids: [],
                            ssrcs: [],
                            ssrcGroups: [],
                            rtcpFeedbackWildcards: [],
                            payloads: [],
                            rtcp: {
                              port: "9",
                              netType: "IN",
                              addressType: "IP4",
                              address: "0.0.0.0"
                            },
                            setup: this.setup,
                            mid: "".concat(e),
                            sctpPort: "5000"
                          }
                        };
                        return this.sessionDesc.mediaDescriptions.push(t), {
                          mediaDesc: t,
                          needExchangeSDP: !0
                        };
                      }
                    }, {
                      key: "createOrRecycleRecvMedia",
                      value: function createOrRecycleRecvMedia(e, t, i, n, s, r) {
                        var o = e._mediaStreamTrack.kind,
                            a = this.rtpCapabilities.recv,
                            c = PL(o, a, this.localCapabilities.send, o === hv.VIDEO ? n : s),
                            d = o === hv.VIDEO ? a.videoExtensions : a.audioExtensions;
                        this.currentMidIndex += 1;
                        var l = "".concat(this.currentMidIndex);
                        var u = {
                          media: {
                            mediaType: o,
                            port: Pk,
                            protos: ["UDP", "TLS", "RTP", "SAVPF"],
                            fmts: c.map(function (e) {
                              return e.payloadType.toString(10);
                            })
                          },
                          connections: [{
                            nettype: "IN",
                            addrtype: "IP4",
                            address: "127.0.0.1"
                          }],
                          bandwidths: [],
                          attributes: {
                            iceUfrag: this.iceParameters.iceUfrag,
                            icePwd: this.iceParameters.icePwd,
                            unrecognized: [],
                            candidates: this.candidates,
                            extmaps: d,
                            fingerprints: this.dtlsParameters.fingerprints,
                            imageattr: [],
                            msids: [],
                            remoteCandidatesList: [],
                            rids: [],
                            ssrcs: t,
                            ssrcGroups: [],
                            rtcpFeedbackWildcards: [],
                            payloads: c,
                            rtcp: {
                              port: "9",
                              netType: "IN",
                              addressType: "IP4",
                              address: "0.0.0.0"
                            },
                            setup: this.setup,
                            direction: i,
                            rtcpMux: !0,
                            rtcpRsize: !0,
                            mid: "".concat(l)
                          }
                        };
                        u = this.mungRecvMediaDsec(u, e, r);
                        var h = this.findFirstClosedMedia(o);

                        if (h) {
                          var _e284 = this.sessionDesc.mediaDescriptions.indexOf(h);

                          this.sessionDesc.mediaDescriptions[_e284] = u;
                        } else this.sessionDesc.mediaDescriptions.push(u);

                        return u;
                      }
                    }, {
                      key: "updateRemoteCodec",
                      value: function updateRemoteCodec(e, t, i) {
                        var n = _toConsumableArray(new Set(this._rtpCapabilities.recv.videoCodecs.map(function (e) {
                          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
                        }).filter(function (e) {
                          var t;
                          return bn(t = Object.keys(xC)).call(t, e);
                        }))),
                            s = new Set(t);

                        if (n.every(function (e) {
                          return s.has(e);
                        })) return YC.debug("codecs has not changed, no need to updateRemoteCodec, codecs: ".concat(t)), !1;

                        var r = this._rtpCapabilities.recv.videoCodecs.filter(function (e) {
                          return t.some(function (t) {
                            var i;
                            return bn(i = e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "").call(i, t);
                          });
                        });

                        if (0 === r.length) return YC.debug("updateRemoteCodec failed, because cannot find matched codec, remoteCapabilities codecs: ".concat(n, " codecs: ").concat(t)), !1;

                        var o = _toConsumableArray(new Set(r.map(function (e) {
                          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
                        })));

                        var a;
                        if (YC.debug("updateRemoteCodec, from ".concat(n, " to ").concat(o)), 0 === e.length) a = this.sessionDesc.mediaDescriptions.filter(function (e) {
                          return "video" === e.media.mediaType && "recvonly" === e.attributes.direction;
                        });else if (a = this.sessionDesc.mediaDescriptions.filter(function (t) {
                          return t.attributes.mid && bn(e).call(e, t.attributes.mid) && "recvonly" === t.attributes.direction;
                        }), a.length !== e.length) return YC.debug("updateRemoteCodec failed, because cannot find mids, mids: ".concat(e, ", codecs: ").concat(t)), !1;
                        this._rtpCapabilities.recv.videoCodecs = r;
                        var c = this.localCapabilities.send,
                            d = this.rtpCapabilities.recv,
                            l = PL(hv.VIDEO, d, c, i);
                        return a.forEach(function (e) {
                          var t = l.map(function (e) {
                            return e.payloadType.toString(10);
                          });
                          YC.debug("updateRemoteCodec mid: ".concat(e.attributes.mid, ", from ").concat(e.attributes.payloads, " to ").concat(l)), e.attributes.payloads = l, e.media.fmts = t;
                        }), !0;
                      }
                    }, {
                      key: "createOrRecycleSendMedia",
                      value: function createOrRecycleSendMedia(e, t, i, n, s) {
                        var r = this.rtpCapabilities.send,
                            o = e === hv.VIDEO ? r.videoCodecs : r.audioCodecs,
                            a = e === hv.VIDEO ? r.videoExtensions : r.audioExtensions;
                        this.currentMidIndex += 1;
                        var c = "".concat(this.currentMidIndex);
                        var d = {
                          media: {
                            mediaType: e,
                            port: Pk,
                            protos: ["UDP", "TLS", "RTP", "SAVPF"],
                            fmts: o.map(function (e) {
                              return e.payloadType.toString(10);
                            })
                          },
                          connections: [{
                            nettype: "IN",
                            addrtype: "IP4",
                            address: "127.0.0.1"
                          }],
                          bandwidths: [],
                          attributes: {
                            iceUfrag: this.iceParameters.iceUfrag,
                            icePwd: this.iceParameters.icePwd,
                            unrecognized: [],
                            candidates: this.candidates,
                            extmaps: a,
                            fingerprints: this.dtlsParameters.fingerprints,
                            imageattr: [],
                            msids: [],
                            remoteCandidatesList: [],
                            rids: [],
                            ssrcs: t,
                            ssrcGroups: i,
                            rtcpFeedbackWildcards: [],
                            payloads: o,
                            rtcp: {
                              port: "9",
                              netType: "IN",
                              addressType: "IP4",
                              address: "0.0.0.0"
                            },
                            setup: this.setup,
                            direction: n,
                            rtcpMux: !0,
                            rtcpRsize: !0,
                            mid: "".concat(c)
                          }
                        };
                        d = this.mungSendMediaDesc(d, s);
                        var l = this.findFirstClosedMedia(e);

                        if (l) {
                          var _e285 = this.sessionDesc.mediaDescriptions.indexOf(l);

                          this.sessionDesc.mediaDescriptions[_e285] = d;
                        } else this.sessionDesc.mediaDescriptions.push(d);

                        return d;
                      }
                    }, {
                      key: "updateBundleMids",
                      value: function updateBundleMids() {
                        this.sessionDesc.attributes.groups[0].identificationTag = this.sessionDesc.mediaDescriptions.filter(function (e) {
                          return "0" !== e.media.port;
                        }).map(function (e) {
                          return e.attributes.mid;
                        });
                      }
                    }, {
                      key: "mungRecvMediaDsec",
                      value: function mungRecvMediaDsec(e, t, i) {
                        var n = bg(e);
                        return RL(n), SL(n, t), CL(n, t), IL(n), vL(n, i, this.localCapabilities.send), n;
                      }
                    }, {
                      key: "mungSendMediaDesc",
                      value: function mungSendMediaDesc(e, t) {
                        var i = bg(e);
                        return vL(i, t, this.localCapabilities.recv), NL(i), i;
                      }
                    }, {
                      key: "updateRecvMedia",
                      value: function updateRecvMedia(e, t) {
                        var i = this.sessionDesc.mediaDescriptions.findIndex(function (t) {
                          return t.attributes.mid === e;
                        });

                        if (-1 !== i) {
                          var _e286 = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[i], t);

                          this.sessionDesc.mediaDescriptions[i] = _e286;
                        }
                      }
                    }, {
                      key: "bumpMid",
                      value: function bumpMid(e) {
                        this.currentMidIndex += e;
                      }
                    }, {
                      key: "findFirstClosedMedia",
                      value: function findFirstClosedMedia(e) {
                        return this.sessionDesc.mediaDescriptions.find(function (t) {
                          return RT() ? "0" === t.media.port && t.media.mediaType === e : "0" === t.media.port;
                        });
                      }
                    }, {
                      key: "findPreloadMediaDesc",
                      value: function findPreloadMediaDesc(e) {
                        return this.sessionDesc.mediaDescriptions.find(function (t) {
                          var i;
                          return (null === (i = t.attributes) || void 0 === i || null === (i = i.ssrcs[0]) || void 0 === i ? void 0 : i.ssrcId) === e[0].ssrcId;
                        });
                      }
                    }, {
                      key: "getSSRC",
                      value: function getSSRC(e) {
                        var t;
                        return null === (t = this.sessionDesc.mediaDescriptions.find(function (t) {
                          return t.attributes.mid === e;
                        })) || void 0 === t ? void 0 : t.attributes.ssrcs;
                      }
                    }]);

                    return _class13;
                  }())({
                    remoteIceParameters: e,
                    remoteDtlsParameters: t,
                    candidates: i,
                    remoteRTPCapabilities: n,
                    remoteSetup: s,
                    localCapabilities: this.localCapabilities,
                    cname: r
                  }), Array.isArray(this.remoteCodecs) && this.remoteCodecs.length > 0 && this.remoteSDP.updateRemoteCodec([], this.remoteCodecs, this.store.codec);
                  _o34 = this.remoteSDP.toString(), _a18 = YP.parse(this.initialOffer.sdp), c = _a18.mediaDescriptions.find(function (e) {
                    return "audio" === e.media.mediaType;
                  });
                  c && NL(c), this.useXR && DL(_a18);
                  _d11 = YP.print(_a18), _l8 = this.logSDPExchange(_d11 || "", "offer", "local", "connect");
                  this.store.descriptionStart();
                  _context259.next = 10;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _d11
                  });

                case 10:
                  null == _l8 || _l8(_o34);
                  _context259.next = 13;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o34
                  });

                case 13:
                  _u4 = this.peerConnection.getTransceivers()[0];

                  if (!(null != _u4 && _u4.receiver && this.tryBindTransportEvents(_u4.receiver), DC("PRELOAD_MEDIA_COUNT") > 0)) {
                    _context259.next = 24;
                    break;
                  }

                  this.remoteSDP.preloadRemoteMedia();
                  _e287 = this.remoteSDP.toString();
                  _context259.next = 19;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _e287
                  });

                case 19:
                  _context259.next = 21;
                  return this.peerConnection.createAnswer();

                case 21:
                  _t242 = _context259.sent;
                  _context259.next = 24;
                  return this.peerConnection.setLocalDescription(_t242);

                case 24:
                  _context259.next = 29;
                  break;

                case 26:
                  _context259.prev = 26;
                  _context259.t0 = _context259["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(_context259.t0.toString()));

                case 29:
                case "end":
                  return _context259.stop();
              }
            }
          }, _callee259, this, [[0, 26]]);
        }));

        function connect(_x411, _x412, _x413, _x414, _x415, _x416) {
          return _connect7.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "send",
      value: function send(e, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee260() {
          var s, _r41, _o36, _a20, c, _d13, _l10, _u5, _r42, _h5, _p4;

          return _regeneratorRuntime.wrap(function _callee260$(_context260) {
            while (1) {
              switch (_context260.prev = _context260.next) {
                case 0:
                  _context260.next = 2;
                  return SP(n.mutex.lock("From P2PConnection.send"));

                case 2:
                  s = _context260.sent;
                  _context260.prev = 3;

                  if (n.remoteSDP) {
                    _context260.next = 6;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.send before remote SDP created");

                case 6:
                  _r41 = [];
                  e.forEach(function (e) {
                    var t = n.peerConnection.addTransceiver(e._mediaStreamTrack, {
                      direction: "sendonly"
                    });
                    _r41.push(t), e._updateRtpTransceiver(t);
                  });
                  _context260.t0 = RT() && !0 === DC("SIMULCAST");

                  if (!_context260.t0) {
                    _context260.next = 12;
                    break;
                  }

                  _context260.next = 12;
                  return SP(n.applySimulcastForFirefox(_r41, e));

                case 12:
                  _context260.next = 14;
                  return SP(n.peerConnection.createOffer());

                case 14:
                  _o36 = _context260.sent;
                  _a20 = n.remoteSDP.predictReceivingMids(e.length);
                  c = n.mungSendOfferSDP(_o36.sdp, e, _a20);
                  _d13 = YP.parse(c);
                  _l10 = _a20.map(function (e) {
                    var t = _d13.mediaDescriptions.find(function (t) {
                      return t.attributes.mid === e;
                    });

                    if (!t) throw new Error("Cannot extract ssrc from mediaDescription.");
                    return fL(t, DC("USE_PUB_RTX"));
                  });
                  _context260.prev = 19;
                  _context260.next = 22;
                  return _l10;

                case 22:
                  _u5 = _context260.sent;
                  _context260.next = 36;
                  break;

                case 25:
                  _context260.prev = 25;
                  _context260.t1 = _context260["catch"](19);
                  _u5 = [], n.remoteSDP.receive(e, t, i, _u5);
                  _r42 = n.remoteSDP.toString();
                  _context260.next = 31;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: c
                  }));

                case 31:
                  _context260.next = 33;
                  return SP(n.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _r42
                  }));

                case 33:
                  _context260.next = 35;
                  return SP(n.stopSending(_a20, !0));

                case 35:
                  throw _context260.t1;

                case 36:
                  n.remoteSDP.receive(e, t, i, _u5);
                  _h5 = n.remoteSDP.toString(), _p4 = n.logSDPExchange(c, "offer", "local", "send");
                  _context260.next = 40;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: c
                  }));

                case 40:
                  _context260.next = 42;
                  return SP(n.applySimulcastEncodings(_r41, e));

                case 42:
                  _context260.next = 44;
                  return SP(n.applySendEncodings(_r41, e));

                case 44:
                  null == _p4 || _p4(_h5);
                  _context260.next = 47;
                  return SP(n.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _h5
                  }));

                case 47:
                  return _context260.abrupt("return", _r41.map(function (e, t) {
                    var i = _a20[t];
                    return {
                      localSSRC: _l10[t],
                      id: i,
                      transceiver: e
                    };
                  }));

                case 50:
                  _context260.prev = 50;
                  _context260.t2 = _context260["catch"](3);
                  throw _context260.t2 instanceof VT ? _context260.t2 : new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(_context260.t2.toString()));

                case 53:
                  _context260.prev = 53;
                  s();
                  return _context260.finish(53);

                case 56:
                case "end":
                  return _context260.stop();
              }
            }
          }, _callee260, null, [[3, 50, 53, 56], [19, 25]]);
        }))();
      }
    }, {
      key: "createDataChannels",
      value: function () {
        var _createDataChannels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee261(e, t) {
          var i, _this$remoteSDP$sendD, _n111, _e288, _t243;

          return _regeneratorRuntime.wrap(function _callee261$(_context261) {
            while (1) {
              switch (_context261.prev = _context261.next) {
                case 0:
                  _context261.prev = 0;

                  if (this.remoteSDP) {
                    _context261.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.createDataChannels before remote SDP created");

                case 3:
                  i = this.dataStreamChannelMap.get(e);
                  i && "open" === i.readyState ? YC.debug("[P2PConnection] Channels are already available and can be reused directly.") : (i = this.peerConnection.createDataChannel("datastream-channel", {
                    ordered: !1,
                    maxRetransmits: DC("DATASTREAM_MAX_RETRANSMITS")
                  }), i.binaryType = "arraybuffer", this.dataStreamChannelMap.set(e, i)), t.forEach(function (e) {
                    e._updateOriginDataChannel(i);
                  });
                  _this$remoteSDP$sendD = this.remoteSDP.sendDataChannel(), _n111 = _this$remoteSDP$sendD.needExchangeSDP;

                  if (!_n111) {
                    _context261.next = 18;
                    break;
                  }

                  _e288 = this.remoteSDP.toString();
                  _context261.next = 10;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _e288
                  });

                case 10:
                  _context261.next = 12;
                  return this.peerConnection.createAnswer();

                case 12:
                  _t243 = _context261.sent;
                  _context261.next = 15;
                  return this.peerConnection.setLocalDescription(_t243);

                case 15:
                  YC.debug("[P2PConnection] createDataChannels by exchanging SDP.");
                  _context261.next = 19;
                  break;

                case 18:
                  YC.debug("[P2PConnection] createDataChannels no need to exchange SDP.");

                case 19:
                  return _context261.abrupt("return");

                case 22:
                  _context261.prev = 22;
                  _context261.t0 = _context261["catch"](0);
                  throw _context261.t0 instanceof VT ? _context261.t0 : new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.createDataChannels failed; ".concat(_context261.t0.toString()));

                case 25:
                case "end":
                  return _context261.stop();
              }
            }
          }, _callee261, this, [[0, 22]]);
        }));

        function createDataChannels(_x417, _x418) {
          return _createDataChannels.apply(this, arguments);
        }

        return createDataChannels;
      }()
    }, {
      key: "stopDataChannels",
      value: function () {
        var _stopDataChannels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee262(e) {
          var _t244;

          return _regeneratorRuntime.wrap(function _callee262$(_context262) {
            while (1) {
              switch (_context262.prev = _context262.next) {
                case 0:
                  _context262.prev = 0;
                  _t244 = this.dataStreamChannelMap.get(e);
                  return _context262.abrupt("return", (null == _t244 || _t244.close(), void this.dataStreamChannelMap.delete(e)));

                case 5:
                  _context262.prev = 5;
                  _context262.t0 = _context262["catch"](0);
                  throw _context262.t0 instanceof VT ? _context262.t0 : new VT(xT.DATACHANNEL_FAILED, "P2PConnection.stopDataChannels failed; ".concat(_context262.t0.toString()));

                case 8:
                case "end":
                  return _context262.stop();
              }
            }
          }, _callee262, this, [[0, 5]]);
        }));

        function stopDataChannels(_x419) {
          return _stopDataChannels.apply(this, arguments);
        }

        return stopDataChannels;
      }()
    }, {
      key: "stopSending",
      value: function () {
        var _stopSending3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee263(e, t) {
          var i, _t245, _n112, _s73, _r43;

          return _regeneratorRuntime.wrap(function _callee263$(_context263) {
            while (1) {
              switch (_context263.prev = _context263.next) {
                case 0:
                  if (!t) {
                    _context263.next = 4;
                    break;
                  }

                  _context263.t0 = void 0;
                  _context263.next = 7;
                  break;

                case 4:
                  _context263.next = 6;
                  return this.mutex.lock("From P2PConnection.stopSending");

                case 6:
                  _context263.t0 = _context263.sent;

                case 7:
                  i = _context263.t0;
                  _context263.prev = 8;

                  if (this.remoteSDP) {
                    _context263.next = 11;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");

                case 11:
                  _t245 = this.peerConnection.getTransceivers().filter(function (t) {
                    return -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t245.length !== e.length)) {
                    _context263.next = 14;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length when trying to call P2PConnection.stopSending.");

                case 14:
                  _t245.map(function (e) {
                    var t;
                    e.direction = "inactive", null === (t = e.stop) || void 0 === t || t.call(e);
                  });

                  _context263.next = 17;
                  return this.peerConnection.createOffer();

                case 17:
                  _n112 = _context263.sent;
                  _s73 = this.logSDPExchange(_n112.sdp || "", "offer", "local", "stopSending");
                  _context263.next = 21;
                  return this.peerConnection.setLocalDescription(_n112);

                case 21:
                  this.remoteSDP.stopReceiving(e);
                  _r43 = this.remoteSDP.toString();
                  null == _s73 || _s73(_r43);
                  _context263.next = 26;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _r43
                  });

                case 26:
                  _context263.next = 31;
                  break;

                case 28:
                  _context263.prev = 28;
                  _context263.t1 = _context263["catch"](8);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(_context263.t1.toString()));

                case 31:
                  _context263.prev = 31;
                  i && i();
                  return _context263.finish(31);

                case 34:
                case "end":
                  return _context263.stop();
              }
            }
          }, _callee263, this, [[8, 28, 31, 34]]);
        }));

        function stopSending(_x420, _x421) {
          return _stopSending3.apply(this, arguments);
        }

        return stopSending;
      }()
    }, {
      key: "receive",
      value: function () {
        var _receive3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee264(e, t, i, n) {
          var _this$remoteSDP$send4, _s74, _r44, _t246, _i129, _n113, _r45, _o37;

          return _regeneratorRuntime.wrap(function _callee264$(_context264) {
            while (1) {
              switch (_context264.prev = _context264.next) {
                case 0:
                  _context264.prev = 0;

                  if (this.remoteSDP) {
                    _context264.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.receive ".concat(e, " before remoteSDP created."));

                case 3:
                  _this$remoteSDP$send4 = this.remoteSDP.send(e, t, i, n), _s74 = _this$remoteSDP$send4.mid, _r44 = _this$remoteSDP$send4.needExchangeSDP;

                  if (!_r44) {
                    _context264.next = 18;
                    break;
                  }

                  _t246 = this.remoteSDP.toString(), _i129 = this.logSDPExchange(_t246, "offer", "remote", "receive");
                  _context264.next = 8;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t246
                  });

                case 8:
                  _context264.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _n113 = _context264.sent;
                  _r45 = this.mungReceiveAnswerSDP(_n113.sdp, _s74, e);
                  null == _i129 || _i129(_r45 || "");
                  _context264.next = 15;
                  return this.peerConnection.setLocalDescription({
                    type: "answer",
                    sdp: _r45
                  });

                case 15:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(e, " by exchanging SDP."));
                  _context264.next = 19;
                  break;

                case 18:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(e, " no need to exchange SDP."));

                case 19:
                  _o37 = this.peerConnection.getTransceivers().find(function (e) {
                    return e.mid === _s74;
                  });

                  if (_o37) {
                    _context264.next = 22;
                    break;
                  }

                  throw new Error("Cannot get transceiver after setLocalDescription.");

                case 22:
                  return _context264.abrupt("return", {
                    track: _o37.receiver.track,
                    id: _s74,
                    transceiver: _o37
                  });

                case 25:
                  _context264.prev = 25;
                  _context264.t0 = _context264["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context264.t0.toString()));

                case 28:
                case "end":
                  return _context264.stop();
              }
            }
          }, _callee264, this, [[0, 25]]);
        }));

        function receive(_x422, _x423, _x424, _x425) {
          return _receive3.apply(this, arguments);
        }

        return receive;
      }()
    }, {
      key: "batchReceive",
      value: function () {
        var _batchReceive2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee265(e) {
          var _this248 = this;

          var _this$remoteSDP$batch, _t247, i, _e289, _t248, _i130;

          return _regeneratorRuntime.wrap(function _callee265$(_context265) {
            while (1) {
              switch (_context265.prev = _context265.next) {
                case 0:
                  _context265.prev = 0;

                  if (this.remoteSDP) {
                    _context265.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.batchReceive before remoteSDP created.");

                case 3:
                  _this$remoteSDP$batch = this.remoteSDP.batchSend(e), _t247 = _this$remoteSDP$batch.mids, i = _this$remoteSDP$batch.needExchangeSDP;

                  if (!i) {
                    _context265.next = 17;
                    break;
                  }

                  _e289 = this.remoteSDP.toString(), _t248 = this.logSDPExchange(_e289, "offer", "remote", "receive");
                  _context265.next = 8;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _e289
                  });

                case 8:
                  _context265.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _i130 = _context265.sent;
                  null == _t248 || _t248(_i130.sdp || "");
                  _context265.next = 14;
                  return this.peerConnection.setLocalDescription(_i130);

                case 14:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] batchReceive by exchanging SDP."));
                  _context265.next = 18;
                  break;

                case 17:
                  YC.debug("[".concat(this.store.clientId, "] [P2PConnection] batchReceive no need to exchange SDP."));

                case 18:
                  return _context265.abrupt("return", _t247.map(function (e) {
                    var t = _this248.peerConnection.getTransceivers().find(function (t) {
                      return t.mid === e;
                    });

                    if (!t) throw new Error("Cannot get transceiver after setLocalDescription.");
                    return {
                      track: t.receiver.track,
                      id: e,
                      transceiver: t
                    };
                  }));

                case 21:
                  _context265.prev = 21;
                  _context265.t0 = _context265["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(_context265.t0.toString()));

                case 24:
                case "end":
                  return _context265.stop();
              }
            }
          }, _callee265, this, [[0, 21]]);
        }));

        function batchReceive(_x426) {
          return _batchReceive2.apply(this, arguments);
        }

        return batchReceive;
      }()
    }, {
      key: "stopReceiving",
      value: function () {
        var _stopReceiving3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee266(e) {
          var _t249, i, _n114;

          return _regeneratorRuntime.wrap(function _callee266$(_context266) {
            while (1) {
              switch (_context266.prev = _context266.next) {
                case 0:
                  _context266.prev = 0;

                  if (this.remoteSDP) {
                    _context266.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");

                case 3:
                  this.remoteSDP.stopSending(e);
                  _t249 = this.remoteSDP.toString(), i = this.logSDPExchange(_t249, "offer", "remote", "stopReceiving");
                  _context266.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t249
                  });

                case 7:
                  _context266.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n114 = _context266.sent;
                  null == i || i(_n114.sdp || "");
                  _context266.next = 13;
                  return this.peerConnection.setLocalDescription(_n114);

                case 13:
                  _context266.next = 18;
                  break;

                case 15:
                  _context266.prev = 15;
                  _context266.t0 = _context266["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(_context266.t0.toString()));

                case 18:
                case "end":
                  return _context266.stop();
              }
            }
          }, _callee266, this, [[0, 15]]);
        }));

        function stopReceiving(_x427) {
          return _stopReceiving3.apply(this, arguments);
        }

        return stopReceiving;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee267(e) {
          var _t250, i, _n115;

          return _regeneratorRuntime.wrap(function _callee267$(_context267) {
            while (1) {
              switch (_context267.prev = _context267.next) {
                case 0:
                  _context267.prev = 0;

                  if (this.remoteSDP) {
                    _context267.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.muteRemote mid=".concat(e, " before remote SDP created."));

                case 3:
                  this.remoteSDP.mute(e);
                  _t250 = this.remoteSDP.toString(), i = this.logSDPExchange(_t250, "offer", "remote", "muteRemote");
                  _context267.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t250
                  });

                case 7:
                  _context267.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n115 = _context267.sent;
                  null == i || i(_n115.sdp || "");
                  _context267.next = 13;
                  return this.peerConnection.setLocalDescription(_n115);

                case 13:
                  _context267.next = 18;
                  break;

                case 15:
                  _context267.prev = 15;
                  _context267.t0 = _context267["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.muteRemote failed; ".concat(_context267.t0.toString()));

                case 18:
                case "end":
                  return _context267.stop();
              }
            }
          }, _callee267, this, [[0, 15]]);
        }));

        function muteRemote(_x428) {
          return _muteRemote4.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee268(e) {
          var _t251, i, _n116;

          return _regeneratorRuntime.wrap(function _callee268$(_context268) {
            while (1) {
              switch (_context268.prev = _context268.next) {
                case 0:
                  _context268.prev = 0;

                  if (this.remoteSDP) {
                    _context268.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.unmuteRemote mid=".concat(e, " before remote SDP created."));

                case 3:
                  this.remoteSDP.unmute(e);
                  _t251 = this.remoteSDP.toString(), i = this.logSDPExchange(_t251, "offer", "remote", "unmuteRemote");
                  _context268.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t251
                  });

                case 7:
                  _context268.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n116 = _context268.sent;
                  null == i || i(_n116.sdp || "");
                  _context268.next = 13;
                  return this.peerConnection.setLocalDescription(_n116);

                case 13:
                  _context268.next = 18;
                  break;

                case 15:
                  _context268.prev = 15;
                  _context268.t0 = _context268["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteRemote failed; ".concat(_context268.t0.toString()));

                case 18:
                case "end":
                  return _context268.stop();
              }
            }
          }, _callee268, this, [[0, 15]]);
        }));

        function unmuteRemote(_x429) {
          return _unmuteRemote4.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee269(e) {
          var _t252, i, _n117, _s75;

          return _regeneratorRuntime.wrap(function _callee269$(_context269) {
            while (1) {
              switch (_context269.prev = _context269.next) {
                case 0:
                  _context269.prev = 0;

                  if (this.remoteSDP) {
                    _context269.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");

                case 3:
                  _t252 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t252.length !== e.length)) {
                    _context269.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t252.map(function (e) {
                    e.direction = "inactive";
                  });

                  _context269.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context269.sent;
                  _n117 = this.logSDPExchange(i.sdp || "", "offer", "local", "muteLocal");
                  _context269.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.muteRemote(e);
                  _s75 = this.remoteSDP.toString();
                  null == _n117 || _n117(_s75);
                  _context269.next = 18;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s75
                  });

                case 18:
                  _context269.next = 23;
                  break;

                case 20:
                  _context269.prev = 20;
                  _context269.t0 = _context269["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(_context269.t0.toString()));

                case 23:
                case "end":
                  return _context269.stop();
              }
            }
          }, _callee269, this, [[0, 20]]);
        }));

        function muteLocal(_x430) {
          return _muteLocal4.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee271(e) {
          var _t253, i, _n118, _s76;

          return _regeneratorRuntime.wrap(function _callee271$(_context271) {
            while (1) {
              switch (_context271.prev = _context271.next) {
                case 0:
                  _context271.prev = 0;

                  if (this.remoteSDP) {
                    _context271.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");

                case 3:
                  _t253 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t253.length !== e.length)) {
                    _context271.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t253.map( /*#__PURE__*/function () {
                    var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee270(e, t) {
                      return _regeneratorRuntime.wrap(function _callee270$(_context270) {
                        while (1) {
                          switch (_context270.prev = _context270.next) {
                            case 0:
                              e.direction = "sendonly";

                            case 1:
                            case "end":
                              return _context270.stop();
                          }
                        }
                      }, _callee270);
                    }));

                    return function (_x432, _x433) {
                      return _ref68.apply(this, arguments);
                    };
                  }());

                  _context271.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context271.sent;
                  _n118 = this.logSDPExchange(i.sdp || "", "offer", "local", "unmuteLocal");
                  _context271.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.unmuteRemote(e);
                  _s76 = this.remoteSDP.toString();
                  null == _n118 || _n118(_s76);
                  _context271.next = 18;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s76
                  });

                case 18:
                  _context271.next = 23;
                  break;

                case 20:
                  _context271.prev = 20;
                  _context271.t0 = _context271["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(_context271.t0.toString()));

                case 23:
                case "end":
                  return _context271.stop();
              }
            }
          }, _callee271, this, [[0, 20]]);
        }));

        function unmuteLocal(_x431) {
          return _unmuteLocal4.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee272() {
          var i, _i131, _n120, _n119, _s77, _yield$_s77$iceParame, _r46, _o38, _a21;

          return _regeneratorRuntime.wrap(function _callee272$(_context272) {
            while (1) {
              switch (_context272.prev = _context272.next) {
                case 0:
                  _context272.next = 2;
                  return SP(t.mutex.lock("From P2PConnection.restartICE"));

                case 2:
                  i = _context272.sent;
                  _context272.prev = 3;

                  if (t.remoteSDP) {
                    _context272.next = 6;
                    break;
                  }

                  throw new Error("Cannot restartICE before remoteSDP created.");

                case 6:
                  if (!wA().supportPCSetConfiguration) {
                    _context272.next = 11;
                    break;
                  }

                  _i131 = t.peerConnection.getConfiguration(), _n120 = e === pv.RELAY ? "relay" : "all";
                  _i131.iceTransportPolicy !== _n120 && (YC.debug("[".concat(t.store.clientId, "] restartICE change iceTransportPolicy from [").concat(_i131.iceTransportPolicy, "] to [").concat(_n120, "]")), _i131.iceTransportPolicy = _n120, t.peerConnection.setConfiguration(_i131));
                  _context272.next = 13;
                  break;

                case 11:
                  if (!(e === pv.RELAY)) {
                    _context272.next = 13;
                    break;
                  }

                  return _context272.abrupt("return");

                case 13:
                  t.remoteSDP.updateCandidates(e);
                  _context272.next = 16;
                  return SP(t.peerConnection.createOffer({
                    iceRestart: !0
                  }));

                case 16:
                  _n119 = _context272.sent;

                  if (_n119.sdp) {
                    _context272.next = 19;
                    break;
                  }

                  throw new Error("Cannot restartICE because restart offer SDP does not exist.");

                case 19:
                  _s77 = mL(_n119.sdp);
                  _context272.next = 22;
                  return _s77.iceParameters;

                case 22:
                  _yield$_s77$iceParame = _context272.sent;
                  _r46 = _yield$_s77$iceParame.remoteIceParameters;
                  t.remoteSDP.restartICE(_r46);
                  _o38 = t.remoteSDP.toString(), _a21 = t.logSDPExchange(_n119.sdp || "", "offer", "local", "restartICE");
                  t.store.descriptionStart();
                  _context272.next = 29;
                  return SP(t.peerConnection.setLocalDescription(_n119));

                case 29:
                  null == _a21 || _a21(_o38);
                  _context272.next = 32;
                  return SP(t.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o38
                  }));

                case 32:
                  _context272.next = 37;
                  break;

                case 34:
                  _context272.prev = 34;
                  _context272.t0 = _context272["catch"](3);
                  YC.warning("[".concat(t.store.clientId, "] restart ICE failed, abort operation"), _context272.t0);

                case 37:
                  _context272.prev = 37;
                  i();
                  return _context272.finish(37);

                case 40:
                case "end":
                  return _context272.stop();
              }
            }
          }, _callee272, null, [[3, 34, 37, 40]]);
        }))();
      }
    }, {
      key: "close",
      value: function close() {
        var e;
        this.peerConnection.close(), null === (e = this.onConnectionStateChange) || void 0 === e || e.call(this, "closed"), this.tryUnbindTransportEvents(), this.unbindPCEvents(), this.unbindStatsEvents(), this.removeAllListeners(), this.transportEventReceiver = void 0, this.statsFilter.destroy(), this.dataStreamChannelMap.clear();
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return this.statsFilter.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        return this.statsFilter.getVideoIsReady(e);
      }
    }, {
      key: "updateEncoderConfig",
      value: function () {
        var _updateEncoderConfig3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee273(e, t) {
          var i, _n121, _s78, _r47;

          return _regeneratorRuntime.wrap(function _callee273$(_context273) {
            while (1) {
              switch (_context273.prev = _context273.next) {
                case 0:
                  _context273.prev = 0;

                  if (this.remoteSDP) {
                    _context273.next = 3;
                    break;
                  }

                  throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");

                case 3:
                  _context273.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  i = _context273.sent;
                  _n121 = this.mungSendOfferSDP(i.sdp, [t], [e]);
                  this.remoteSDP.updateRecvMedia(e, t);
                  _s78 = this.remoteSDP.toString(), _r47 = this.logSDPExchange(_n121, "offer", "local", "updateEncoderConfig");
                  _context273.next = 11;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _n121
                  });

                case 11:
                  null == _r47 || _r47(_s78);
                  _context273.next = 14;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s78
                  });

                case 14:
                  _context273.next = 19;
                  break;

                case 16:
                  _context273.prev = 16;
                  _context273.t0 = _context273["catch"](0);
                  throw new VT(xT.EXCHANGE_SDP_FAILED, _context273.t0.toString());

                case 19:
                case "end":
                  return _context273.stop();
              }
            }
          }, _callee273, this, [[0, 16]]);
        }));

        function updateEncoderConfig(_x434, _x435) {
          return _updateEncoderConfig3.apply(this, arguments);
        }

        return updateEncoderConfig;
      }()
    }, {
      key: "updateSendParameters",
      value: function () {
        var _updateSendParameters3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee274(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee274$(_context274) {
            while (1) {
              switch (_context274.prev = _context274.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid === e;
                  });
                  _context274.t0 = 1 === i.length;

                  if (!_context274.t0) {
                    _context274.next = 12;
                    break;
                  }

                  if (!this.isVP8Simulcast(t)) {
                    _context274.next = 10;
                    break;
                  }

                  _context274.t1 = RT();

                  if (_context274.t1) {
                    _context274.next = 8;
                    break;
                  }

                  _context274.next = 8;
                  return this.applySimulcastEncodings(i, [t]);

                case 8:
                  _context274.next = 12;
                  break;

                case 10:
                  _context274.next = 12;
                  return this.applySendEncodings(i, [t]);

                case 12:
                case "end":
                  return _context274.stop();
              }
            }
          }, _callee274, this);
        }));

        function updateSendParameters(_x436, _x437) {
          return _updateSendParameters3.apply(this, arguments);
        }

        return updateSendParameters;
      }()
    }, {
      key: "setStatsRemoteVideoIsReady",
      value: function setStatsRemoteVideoIsReady(e, t) {
        this.statsFilter.setVideoIsReady2(e, t);
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee275(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee275$(_context275) {
            while (1) {
              switch (_context275.prev = _context275.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().find(function (e) {
                    return e.mid === t;
                  });
                  _context275.t0 = i;

                  if (!_context275.t0) {
                    _context275.next = 5;
                    break;
                  }

                  _context275.next = 5;
                  return i.sender.replaceTrack(e._mediaStreamTrack);

                case 5:
                case "end":
                  return _context275.stop();
              }
            }
          }, _callee275, this);
        }));

        function replaceTrack(_x438, _x439) {
          return _replaceTrack4.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "getSelectedCandidatePair",
      value: function () {
        var _getSelectedCandidatePair3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee276() {
          var e, _t254, _t254$getSelectedCand, i, _n122;

          return _regeneratorRuntime.wrap(function _callee276$(_context276) {
            while (1) {
              switch (_context276.prev = _context276.next) {
                case 0:
                  e = this.peerConnection.getReceivers();

                  if (!(e.length > 0 && e[0].transport && e[0].transport.iceTransport && e[0].transport.iceTransport.getSelectedCandidatePair && e[0].transport.iceTransport.getSelectedCandidatePair())) {
                    _context276.next = 4;
                    break;
                  }

                  _t254 = e[0].transport.iceTransport, _t254$getSelectedCand = _t254.getSelectedCandidatePair(), i = _t254$getSelectedCand.local, _n122 = _t254$getSelectedCand.remote;
                  return _context276.abrupt("return", {
                    local: Mk(Mk({}, XP), {}, {
                      candidateType: i.type,
                      protocol: i.protocol,
                      address: i.address,
                      port: i.port
                    }),
                    remote: Mk(Mk({}, XP), {}, {
                      candidateType: _n122.type,
                      protocol: _n122.protocol,
                      address: _n122.address,
                      port: _n122.port
                    })
                  });

                case 4:
                  return _context276.abrupt("return", this.statsFilter.getSelectedCandidatePair());

                case 5:
                case "end":
                  return _context276.stop();
              }
            }
          }, _callee276, this);
        }));

        function getSelectedCandidatePair() {
          return _getSelectedCandidatePair3.apply(this, arguments);
        }

        return getSelectedCandidatePair;
      }()
    }, {
      key: "bindPCEvents",
      value: function bindPCEvents() {
        var _this249 = this;

        this.peerConnection.oniceconnectionstatechange = function () {
          var e;
          null === (e = _this249.onICEConnectionStateChange) || void 0 === e || e.call(_this249, _this249.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = function () {
          var e;
          null === (e = _this249.onConnectionStateChange) || void 0 === e || e.call(_this249, _this249.peerConnection.connectionState);
        }, this.peerConnection.onicecandidate = function (e) {
          e.candidate ? _this249.localCandidateCount += 1 : (_this249.peerConnection.onicecandidate = null, _this249.allCandidatesReceived = !0, YC.debug("[".concat(_this249.store.clientId, "] [pc-").concat(_this249.store.p2pId, "] local candidate count"), _this249.localCandidateCount));
        }, setTimeout(function () {
          _this249.allCandidatesReceived || (_this249.allCandidatesReceived = !0, YC.debug("[".concat(_this249.store.clientId, "] [pc-").concat(_this249.store.p2pId, "] onicecandidate timeout, local candidate count"), _this249.localCandidateCount));
        }, DC("CANDIDATE_TIMEOUT"));
      }
    }, {
      key: "unbindPCEvents",
      value: function unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
    }, {
      key: "tryBindTransportEvents",
      value: function tryBindTransportEvents(e) {
        var _this250 = this;

        var t = e.transport;

        if (t) {
          this.transportEventReceiver = e, t.onstatechange = function () {
            var e;
            null != t && t.state && (null === (e = _this250.onDTLSTransportStateChange) || void 0 === e || e.call(_this250, t.state));
          }, t.onerror = function (e) {
            var t;
            null === (t = _this250.onDTLSTransportError) || void 0 === t || t.call(_this250, "error" in e ? e.error : e);
          };
          var i = t.iceTransport;
          i && (i.onstatechange = function () {
            var e = null == t ? void 0 : t.iceTransport.state;
            var i;
            e && (null === (i = _this250.onICETransportStateChange) || void 0 === i || i.call(_this250, e));
          }, i.getSelectedCandidatePair && (i.onselectedcandidatepairchange = function () {
            if (i.getSelectedCandidatePair()) {
              var _i$getSelectedCandida = i.getSelectedCandidatePair(),
                  _e290 = _i$getSelectedCandida.local,
                  _t255 = _i$getSelectedCandida.remote;

              YC.info("[".concat(_this250.store.clientId, "] [pc-").concat(_this250.store.p2pId, "] selectedcandidatepairchange: local ").concat(JSON.stringify({
                candidateType: _e290.type,
                protocol: _e290.protocol
              }), ", remote ").concat(JSON.stringify({
                candidateType: _t255.type,
                protocol: _t255.protocol,
                address: _t255.address,
                port: _t255.port
              }), " )"));
            }
          }));
        }
      }
    }, {
      key: "tryUnbindTransportEvents",
      value: function tryUnbindTransportEvents() {
        this.transportEventReceiver && this.transportEventReceiver.transport && (this.transportEventReceiver.transport.onstatechange = null, this.transportEventReceiver.transport.onerror = null, this.transportEventReceiver.transport.iceTransport && (this.transportEventReceiver.transport.iceTransport.onstatechange = null));
      }
    }, {
      key: "updateRtpSenderEncodings",
      value: function () {
        var _updateRtpSenderEncodings3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee277(e, t) {
          var i, n, s, r, _e$_encoderConfig, _t256, _i132, _n123, o, _e291, a, c;

          return _regeneratorRuntime.wrap(function _callee277$(_context277) {
            while (1) {
              switch (_context277.prev = _context277.next) {
                case 0:
                  if (!t) {
                    t = this.peerConnection.getSenders().find(function (t) {
                      return t.track === e._mediaStreamTrack;
                    });
                  }

                  if (t) {
                    _context277.next = 3;
                    break;
                  }

                  return _context277.abrupt("return", YC.warn("[".concat(e.getTrackId(), "] no rtpSender found}")));

                case 3:
                  if (!this.isVP8Simulcast(e)) {
                    _context277.next = 5;
                    break;
                  }

                  return _context277.abrupt("return", YC.warn("[updateRtpSenderEncodings] Track is VP8 simulcast, please apply simulcast encodings"));

                case 5:
                  if (wA().supportSetRtpSenderParameters) {
                    _context277.next = 7;
                    break;
                  }

                  return _context277.abrupt("return", YC.warn("[updateRtpSenderEncodings] Browser not support set rtp-sender parameters"));

                case 7:
                  n = {}, s = {};
                  _context277.t0 = e._optimizationMode;
                  _context277.next = _context277.t0 === "motion" ? 11 : _context277.t0 === "detail" ? 13 : 15;
                  break;

                case 11:
                  n.degradationPreference = "maintain-framerate";
                  return _context277.abrupt("break", 16);

                case 13:
                  n.degradationPreference = "maintain-resolution";
                  return _context277.abrupt("break", 16);

                case 15:
                  n.degradationPreference = "balanced";

                case 16:
                  if (e._encoderConfig) {
                    _e$_encoderConfig = e._encoderConfig, _t256 = _e$_encoderConfig.bitrateMax, _i132 = _e$_encoderConfig.frameRate, _n123 = _e$_encoderConfig.scaleResolutionDownBy;
                    _t256 && (s.maxBitrate = 1e3 * _t256), (bn(r = e._hints).call(r, YA.LOW_STREAM) || e.isUseScaleResolutionDownBy) && (_i132 && (s.maxFramerate = yy(_i132)), _n123 && _n123 >= 1 && (s.scaleResolutionDownBy = _n123));
                  }

                  if (DC("DSCP_TYPE") && kT()) {
                    _e291 = DC("DSCP_TYPE");
                    bn(o = ["very-low", "low", "medium", "high"]).call(o, _e291) && (s.networkPriority = _e291);
                  }

                  a = t.getParameters(), c = null === (i = a.encodings) || void 0 === i ? void 0 : i[0];
                  RT() && !c && (n.encodings = [s]);
                  c && Object.assign(c, s);
                  Object.assign(a, n);
                  YC.debug("[".concat(e.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(a.encodings)));
                  _context277.next = 25;
                  return t.setParameters(a);

                case 25:
                case "end":
                  return _context277.stop();
              }
            }
          }, _callee277, this);
        }));

        function updateRtpSenderEncodings(_x440, _x441) {
          return _updateRtpSenderEncodings3.apply(this, arguments);
        }

        return updateRtpSenderEncodings;
      }()
    }, {
      key: "applySendEncodings",
      value: function () {
        var _applySendEncodings3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee278(e, t) {
          var i, _n124, _s79;

          return _regeneratorRuntime.wrap(function _callee278$(_context278) {
            while (1) {
              switch (_context278.prev = _context278.next) {
                case 0:
                  _context278.prev = 0;

                  if (wA().supportSetRtpSenderParameters) {
                    _context278.next = 3;
                    break;
                  }

                  return _context278.abrupt("return");

                case 3:
                  if (!(e.length !== t.length)) {
                    _context278.next = 5;
                    break;
                  }

                  return _context278.abrupt("return");

                case 5:
                  i = 0;

                case 6:
                  if (!(i < e.length)) {
                    _context278.next = 15;
                    break;
                  }

                  _n124 = e[i], _s79 = t[i];
                  _context278.t0 = _s79 instanceof Nw && !this.isVP8Simulcast(_s79);

                  if (!_context278.t0) {
                    _context278.next = 12;
                    break;
                  }

                  _context278.next = 12;
                  return this.updateRtpSenderEncodings(_s79, _n124.sender);

                case 12:
                  i++;
                  _context278.next = 6;
                  break;

                case 15:
                  _context278.next = 20;
                  break;

                case 17:
                  _context278.prev = 17;
                  _context278.t1 = _context278["catch"](0);
                  YC.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));

                case 20:
                case "end":
                  return _context278.stop();
              }
            }
          }, _callee278, this, [[0, 17]]);
        }));

        function applySendEncodings(_x442, _x443) {
          return _applySendEncodings3.apply(this, arguments);
        }

        return applySendEncodings;
      }()
    }, {
      key: "mungSendOfferSDP",
      value: function mungSendOfferSDP(e, t, i) {
        var _this251 = this;

        var n = YP.parse(e);
        return t.forEach(function (e, t) {
          var s = i[t],
              r = n.mediaDescriptions.find(function (e) {
            return e.attributes.mid === s;
          });
          r && (SL(r, e), yL(r, e, _this251.store.codec));
        }), YP.print(n);
      }
    }, {
      key: "mungReceiveAnswerSDP",
      value: function mungReceiveAnswerSDP(e, t, i) {
        var n = YP.parse(e),
            s = n.mediaDescriptions.find(function (e) {
          return e.attributes.mid === t;
        });
        return s && (i === hv.AUDIO && "audio" === s.media.mediaType && NL(s), this.useXR && DL(n)), YP.print(n);
      }
    }, {
      key: "bindStatsEvents",
      value: function bindStatsEvents() {
        var _this252 = this;

        this.statsFilter.onFirstAudioReceived = function (e) {
          var t;
          null === (t = _this252.onFirstAudioReceived) || void 0 === t || t.call(_this252, e);
        }, this.statsFilter.onFirstVideoReceived = function (e) {
          var t;
          null === (t = _this252.onFirstVideoReceived) || void 0 === t || t.call(_this252, e);
        }, this.statsFilter.onFirstAudioDecoded = function (e) {
          var t;
          null === (t = _this252.onFirstAudioDecoded) || void 0 === t || t.call(_this252, e);
        }, this.statsFilter.onFirstVideoDecoded = function (e, t, i) {
          var n;
          null === (n = _this252.onFirstVideoDecoded) || void 0 === n || n.call(_this252, e, t, i);
        }, this.statsFilter.onSelectedLocalCandidateChanged = function (e, t) {
          var i;
          null === (i = _this252.onSelectedLocalCandidateChanged) || void 0 === i || i.call(_this252, e, t);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = function (e, t) {
          var i;
          null === (i = _this252.onSelectedRemoteCandidateChanged) || void 0 === i || i.call(_this252, e, t);
        }, this.statsFilter.onFirstVideoDecodedTimeout = function (e) {
          var t;
          null === (t = _this252.onFirstVideoDecodedTimeout) || void 0 === t || t.call(_this252, e);
        };
      }
    }, {
      key: "unbindStatsEvents",
      value: function unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0, this.statsFilter.onFirstVideoDecodedTimeout = void 0;
      }
    }, {
      key: "applySimulcastForFirefox",
      value: function () {
        var _applySimulcastForFirefox2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee279(e, t) {
          var _a22, i, n, s, r, o, c, _d14, _e292, _t257, _i133;

          return _regeneratorRuntime.wrap(function _callee279$(_context279) {
            while (1) {
              switch (_context279.prev = _context279.next) {
                case 0:
                  if (!(e.length === t.length)) {
                    _context279.next = 13;
                    break;
                  }

                  _a22 = 0;

                case 2:
                  if (!(_a22 < e.length)) {
                    _context279.next = 13;
                    break;
                  }

                  c = e[_a22], _d14 = t[_a22];

                  if (!(_d14 instanceof Nw && !bn(i = _d14._hints).call(i, YA.LOW_STREAM) && null !== (n = _d14._encoderConfig) && void 0 !== n && n.bitrateMax && (null === (s = _d14._encoderConfig) || void 0 === s ? void 0 : s.bitrateMax) > 200 && null !== (r = _d14._scalabilityMode) && void 0 !== r && r.numSpatialLayers && (null === (o = _d14._scalabilityMode) || void 0 === o ? void 0 : o.numSpatialLayers) > 1 && "vp8" === this.store.codec)) {
                    _context279.next = 10;
                    break;
                  }

                  _e292 = {}, _t257 = {
                    high: 1e3 * (_d14._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _e292.encodings = [{
                    rid: "m",
                    active: !0,
                    maxBitrate: _t257.medium,
                    scaleResolutionDownBy: 4
                  }, {
                    rid: "h",
                    active: !0,
                    maxBitrate: _t257.high
                  }];
                  _i133 = c.sender.getParameters();
                  _context279.next = 10;
                  return c.sender.setParameters(Object.assign(_i133, _e292));

                case 10:
                  _a22++;
                  _context279.next = 2;
                  break;

                case 13:
                case "end":
                  return _context279.stop();
              }
            }
          }, _callee279, this);
        }));

        function applySimulcastForFirefox(_x444, _x445) {
          return _applySimulcastForFirefox2.apply(this, arguments);
        }

        return applySimulcastForFirefox;
      }()
    }, {
      key: "applySimulcastEncodings",
      value: function () {
        var _applySimulcastEncodings2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee280(e, t) {
          var i, _n125, _t258, _s80, _r48, _o39;

          return _regeneratorRuntime.wrap(function _callee280$(_context280) {
            while (1) {
              switch (_context280.prev = _context280.next) {
                case 0:
                  if (!(!RT() && e.length === t.length)) {
                    _context280.next = 13;
                    break;
                  }

                  i = 0;

                case 2:
                  if (!(i < e.length)) {
                    _context280.next = 13;
                    break;
                  }

                  _n125 = t[i];

                  if (!(_n125 instanceof Nw && this.isVP8Simulcast(_n125))) {
                    _context280.next = 10;
                    break;
                  }

                  _t258 = e[i], _s80 = {}, _r48 = {
                    high: 1e3 * (_n125._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _s80.encodings = [{
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "high",
                    priority: "high",
                    maxBitrate: _r48.high
                  }, {
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "low",
                    priority: "low",
                    maxBitrate: _r48.medium,
                    scaleResolutionDownBy: 4
                  }];
                  _o39 = _t258.sender.getParameters();
                  _context280.next = 10;
                  return _t258.sender.setParameters(Object.assign(_o39, _s80));

                case 10:
                  i++;
                  _context280.next = 2;
                  break;

                case 13:
                case "end":
                  return _context280.stop();
              }
            }
          }, _callee280, this);
        }));

        function applySimulcastEncodings(_x446, _x447) {
          return _applySimulcastEncodings2.apply(this, arguments);
        }

        return applySimulcastEncodings;
      }()
    }, {
      key: "isVP8Simulcast",
      value: function isVP8Simulcast(e) {
        var t, i, n, s, r;
        return !!(e instanceof Nw && DC("SIMULCAST") && "vp8" === this.store.codec && !bn(t = e._hints).call(t, YA.LOW_STREAM) && null !== (i = e._encoderConfig) && void 0 !== i && i.bitrateMax && (null === (n = e._encoderConfig) || void 0 === n ? void 0 : n.bitrateMax) > 200 && null !== (s = e._scalabilityMode) && void 0 !== s && s.numSpatialLayers && (null === (r = e._scalabilityMode) || void 0 === r ? void 0 : r.numSpatialLayers) > 1);
      }
    }, {
      key: "logSDPExchange",
      value: function logSDPExchange(e, t, i, n) {
        var _this253 = this;

        if (DC("SDP_LOGGING")) return YC.upload("[".concat(this.store.clientId, "] exchanging ").concat(i, " ").concat(t, " SDP during P2PConnection.").concat(n, "\n"), e), "offer" === t ? function (e) {
          _this253.logSDPExchange(e, "answer", "local" === i ? "remote" : "local", n);
        } : void 0;
      }
    }, {
      key: "getRemoteSSRC",
      value: function () {
        var _getRemoteSSRC3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee281(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee281$(_context281) {
            while (1) {
              switch (_context281.prev = _context281.next) {
                case 0:
                  if (this.remoteSDP) {
                    _context281.next = 2;
                    break;
                  }

                  return _context281.abrupt("return");

                case 2:
                  t = this.remoteSDP.getSSRC(e);
                  return _context281.abrupt("return", null == t ? void 0 : t[0].ssrcId);

                case 4:
                case "end":
                  return _context281.stop();
              }
            }
          }, _callee281, this);
        }));

        function getRemoteSSRC(_x448) {
          return _getRemoteSSRC3.apply(this, arguments);
        }

        return getRemoteSSRC;
      }()
    }, {
      key: "setConfiguration",
      value: function setConfiguration(e) {
        if (wA().supportPCSetConfiguration) {
          var _t259 = Uk.resolvePCConfiguration(e);

          this.peerConnection.setConfiguration(_t259);
        }
      }
    }], [{
      key: "resolvePCConfiguration",
      value: function resolvePCConfiguration(e) {
        var _t$iceServers3, _t$iceServers4;

        var t = {
          iceServers: []
        };
        return e.iceServers ? t.iceServers = e.iceServers : e.turnServer && "off" !== e.turnServer.mode && (_g(e.turnServer.servers) ? t.iceServers = e.turnServer.servers : (t.iceServers && (_t$iceServers3 = t.iceServers).push.apply(_t$iceServers3, _toConsumableArray(Uk.turnServerConfigToIceServers(e.turnServer.servers))), DC("USE_TURN_SERVER_OF_GATEWAY") && t.iceServers && e.turnServer.serversFromGateway && (_t$iceServers4 = t.iceServers).push.apply(_t$iceServers4, _toConsumableArray(Uk.turnServerConfigToIceServers(e.turnServer.serversFromGateway))), DC("FORCE_TURN_TCP") ? t.iceTransportPolicy = "relay" : e.turnServer.servers.concat(e.turnServer.serversFromGateway || []).forEach(function (e) {
          e.forceturn && (t.iceTransportPolicy = "relay");
        }))), DC("ENABLE_ENCODED_TRANSFORM") && wA().supportWebRTCEncodedTransform && (t.encodedInsertableStreams = !0), t;
      }
    }, {
      key: "turnServerConfigToIceServers",
      value: function turnServerConfigToIceServers(e) {
        var t = [];
        return e.forEach(function (e) {
          e.security ? e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turns:".concat(Iy(e.turnServerURL), ":").concat(e.tcpport, "?transport=tcp")
          }) : (e.udpport && !DC("FORCE_TURN_TCP") && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.udpport, "?transport=udp")
          }), e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.tcpport, "?transport=tcp")
          }));
        }), t;
      }
    }]);

    return Uk;
  }(Mv);

  function xk(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee282() {
      var e,
          i,
          s,
          r,
          o,
          _args282 = arguments;
      return _regeneratorRuntime.wrap(function _callee282$(_context282) {
        while (1) {
          switch (_context282.prev = _context282.next) {
            case 0:
              e = this.mutex;
              _context282.next = 3;
              return e.lock("From P2PConnection.".concat(t));

            case 3:
              i = _context282.sent;
              _context282.prev = 4;

              for (s = _args282.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args282[o];
              }

              _context282.next = 8;
              return n.apply(this, r);

            case 8:
              return _context282.abrupt("return", _context282.sent);

            case 9:
              _context282.prev = 9;
              i();
              return _context282.finish(9);

            case 12:
            case "end":
              return _context282.stop();
          }
        }
      }, _callee282, this, [[4,, 9, 12]]);
    })), i;
  }

  function Vk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Fk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Vk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Vk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  UI([xk, xI("design:type", Function), xI("design:paramtypes", [Array, Array]), xI("design:returntype", tT)], Uk.prototype, "updateRemoteRTPCapabilities", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], Uk.prototype, "connect", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Object, Array]), xI("design:returntype", tT)], Uk.prototype, "createDataChannels", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, Object]), xI("design:returntype", tT)], Uk.prototype, "receive", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Uk.prototype, "batchReceive", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Uk.prototype, "stopReceiving", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Uk.prototype, "muteRemote", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Uk.prototype, "unmuteRemote", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Uk.prototype, "muteLocal", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Uk.prototype, "unmuteLocal", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Uk.prototype, "close", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], Uk.prototype, "updateEncoderConfig", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], Uk.prototype, "updateSendParameters", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [_b, String]), xI("design:returntype", tT)], Uk.prototype, "replaceTrack", null), UI([xk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Uk.prototype, "getRemoteSSRC", null);
  var Bk = "v=0\no=- 0 0 IN IP4 127.0.0.1\ns=AgoraGateway\nt=0 0\na=group:BUNDLE 0\na=msid-semantic: WMS\na=ice-lite\nm=application 9 UDP/DTLS/SCTP webrtc-datachannel\nc=IN IP4 127.0.0.1\na=mid:0\n",
      jk = "9",
      Gk = 2e4,
      Wk = 4e4;

  var Hk = /*#__PURE__*/function () {
    function Hk(e) {
      _classCallCheck(this, Hk);

      nh(this, "sessionDesc", void 0), nh(this, "_localCapabilities", void 0), nh(this, "_rtpCapabilities", void 0), nh(this, "_candidates", void 0), nh(this, "_iceParameters", void 0), nh(this, "_dtlsParameters", void 0), nh(this, "setup", void 0), nh(this, "currentMidIndex", void 0), nh(this, "cname", void 0), nh(this, "firefoxSsrcMidMap", new Map()), e = bg(e);
      var _e293 = e,
          t = _e293.remoteIceParameters,
          i = _e293.remoteDtlsParameters,
          n = _e293.candidates,
          s = _e293.remoteRTPCapabilities,
          r = _e293.remoteSetup,
          o = _e293.localCapabilities,
          a = _e293.cname,
          c = YP.parse(Bk);
      this._rtpCapabilities = s, this._candidates = n, this._iceParameters = t, this._dtlsParameters = i, this._localCapabilities = o, this.setup = r, this.cname = a;
      var d = this.rtpCapabilities.send;

      var _iterator34 = _createForOfIteratorHelper(c.mediaDescriptions),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _e294 = _step34.value;

          if (_e294.attributes.iceUfrag = t.iceUfrag, _e294.attributes.icePwd = t.icePwd, _e294.attributes.fingerprints = i.fingerprints, _e294.attributes.candidates = n, _e294.attributes.setup = r, "application" === _e294.media.mediaType && (_e294.attributes.sctpPort = "5000"), "video" === _e294.media.mediaType && (_e294.media.fmts = d.videoCodecs.map(function (e) {
            return e.payloadType.toString(10);
          }), _e294.attributes.payloads = d.videoCodecs, _e294.attributes.extmaps = d.videoExtensions, DC("PRELOAD_MEDIA_COUNT") > 0)) {
            var _gL10 = gL([{
              ssrcId: Wk,
              rtx: DC("USE_SUB_RTX") ? 40001 : void 0
            }], this.cname),
                _t260 = _gL10.ssrcs,
                _i134 = _gL10.ssrcGroups;

            _e294.attributes.ssrcs = _t260, _e294.attributes.ssrcGroups = _i134;
          }

          if ("audio" === _e294.media.mediaType && (_e294.media.fmts = d.audioCodecs.map(function (e) {
            return e.payloadType.toString(10);
          }), _e294.attributes.payloads = d.audioCodecs, _e294.attributes.extmaps = d.audioExtensions, NL(_e294), DC("PRELOAD_MEDIA_COUNT") > 0)) {
            var _gL11 = gL([{
              ssrcId: Gk
            }], this.cname),
                _t261 = _gL11.ssrcs,
                _i135 = _gL11.ssrcGroups;

            _e294.attributes.ssrcs = _t261, _e294.attributes.ssrcGroups = _i135;
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }

      this.sessionDesc = c, this.currentMidIndex = c.mediaDescriptions.length - 1;
    }

    _createClass(Hk, [{
      key: "localCapabilities",
      get: function get() {
        return bg(this._localCapabilities);
      }
    }, {
      key: "rtpCapabilities",
      get: function get() {
        return bg(this._rtpCapabilities);
      }
    }, {
      key: "candidates",
      get: function get() {
        return bg(this._candidates);
      }
    }, {
      key: "iceParameters",
      get: function get() {
        return bg(this._iceParameters);
      }
    }, {
      key: "dtlsParameters",
      get: function get() {
        return bg(this._dtlsParameters);
      }
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function updateRemoteRTPCapabilities(e) {
        var t = YP.parse(Bk);
        this._rtpCapabilities = e;
        var i = this.rtpCapabilities.send;

        var _iterator35 = _createForOfIteratorHelper(t.mediaDescriptions),
            _step35;

        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _e295 = _step35.value;

            if (_e295.attributes.iceUfrag = this._iceParameters.iceUfrag, _e295.attributes.icePwd = this._iceParameters.icePwd, _e295.attributes.fingerprints = this._dtlsParameters.fingerprints, _e295.attributes.candidates = this._candidates, _e295.attributes.setup = this.setup, "application" === _e295.media.mediaType && (_e295.attributes.sctpPort = "5000"), "video" === _e295.media.mediaType && (_e295.media.fmts = i.videoCodecs.map(function (e) {
              return e.payloadType.toString(10);
            }), _e295.attributes.payloads = i.videoCodecs, _e295.attributes.extmaps = i.videoExtensions, DC("PRELOAD_MEDIA_COUNT") > 0)) {
              var _gL12 = gL([{
                ssrcId: Wk,
                rtx: DC("USE_SUB_RTX") ? 40001 : void 0
              }], this.cname),
                  _t262 = _gL12.ssrcs,
                  _i136 = _gL12.ssrcGroups;

              _e295.attributes.ssrcs = _t262, _e295.attributes.ssrcGroups = _i136;
            }

            if ("audio" === _e295.media.mediaType && (_e295.media.fmts = i.audioCodecs.map(function (e) {
              return e.payloadType.toString(10);
            }), _e295.attributes.payloads = i.audioCodecs, _e295.attributes.extmaps = i.audioExtensions, DC("PRELOAD_MEDIA_COUNT") > 0)) {
              var _gL13 = gL([{
                ssrcId: Gk
              }], this.cname),
                  _t263 = _gL13.ssrcs,
                  _i137 = _gL13.ssrcGroups;

              _e295.attributes.ssrcs = _t263, _e295.attributes.ssrcGroups = _i137;
            }
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }

        this.sessionDesc = t, this.currentMidIndex = t.mediaDescriptions.length - 1;
      }
    }, {
      key: "preloadRemoteMedia",
      value: function preloadRemoteMedia(e) {
        this.rtpCapabilities;
        var t = this.candidates,
            i = this.dtlsParameters,
            n = this.iceParameters,
            s = this.rtpCapabilities.send;

        for (var _r49 = 1; _r49 < e; _r49++) {
          var _e296 = 2 * _r49 + Gk,
              _o40 = 2 * _r49 + Wk,
              _gL14 = gL([{
            ssrcId: _e296
          }], this.cname),
              _a23 = _gL14.ssrcs,
              c = _gL14.ssrcGroups,
              _gL15 = gL([{
            ssrcId: _o40,
            rtx: DC("USE_SUB_RTX") ? _o40 + 1 : void 0
          }], this.cname),
              _d15 = _gL15.ssrcs,
              _l11 = _gL15.ssrcGroups;

          this.sessionDesc.mediaDescriptions.push({
            media: {
              mediaType: "video",
              port: jk,
              protos: ["UDP", "TLS", "RTP", "SAVPF"],
              fmts: s.videoCodecs.map(function (e) {
                return e.payloadType.toString(10);
              })
            },
            connections: [{
              nettype: "IN",
              addrtype: "IP4",
              address: "127.0.0.1"
            }],
            bandwidths: [],
            attributes: {
              iceUfrag: n.iceUfrag,
              icePwd: n.icePwd,
              unrecognized: [],
              candidates: t,
              extmaps: s.videoExtensions,
              fingerprints: i.fingerprints,
              imageattr: [],
              msids: [],
              remoteCandidatesList: [],
              rids: [],
              ssrcs: _d15,
              ssrcGroups: _l11,
              rtcpFeedbackWildcards: [],
              payloads: s.videoCodecs,
              rtcp: {
                port: "9",
                netType: "IN",
                addressType: "IP4",
                address: "0.0.0.0"
              },
              setup: this.setup,
              direction: "sendonly",
              rtcpMux: !0,
              rtcpRsize: !0,
              mid: "".concat(2 * _r49 - 1)
            }
          }), this.sessionDesc.mediaDescriptions.push({
            media: {
              mediaType: "audio",
              port: jk,
              protos: ["UDP", "TLS", "RTP", "SAVPF"],
              fmts: s.audioCodecs.map(function (e) {
                return e.payloadType.toString(10);
              })
            },
            connections: [{
              nettype: "IN",
              addrtype: "IP4",
              address: "127.0.0.1"
            }],
            bandwidths: [],
            attributes: {
              iceUfrag: n.iceUfrag,
              icePwd: n.icePwd,
              unrecognized: [],
              candidates: t,
              extmaps: s.audioExtensions,
              fingerprints: i.fingerprints,
              imageattr: [],
              msids: [],
              remoteCandidatesList: [],
              rids: [],
              ssrcs: _a23,
              ssrcGroups: c,
              rtcpFeedbackWildcards: [],
              payloads: s.audioCodecs,
              rtcp: {
                port: "9",
                netType: "IN",
                addressType: "IP4",
                address: "0.0.0.0"
              },
              setup: this.setup,
              direction: "sendonly",
              rtcpMux: !0,
              rtcpRsize: !0,
              mid: "".concat(2 * _r49)
            }
          }), this.currentMidIndex += 2;
        }

        this.updateBundleMids();
      }
    }, {
      key: "toString",
      value: function toString() {
        return YP.print(this.sessionDesc);
      }
    }, {
      key: "send",
      value: function send(e, t, i, n) {
        var _gL16 = gL(t, this.cname, DC("SYNC_GROUP") ? i : void 0),
            s = _gL16.ssrcs,
            r = _gL16.ssrcGroups,
            o = this.findPreloadMediaDesc(s);

        if (o) {
          if (RT() && this.firefoxSsrcMidMap.set(s[0].ssrcId, o.attributes.mid), n && (n.twcc || n.remb)) {
            var _e297 = this.sessionDesc.mediaDescriptions.indexOf(o);

            return this.sessionDesc.mediaDescriptions[_e297] = this.mungSendMediaDesc(o, n), {
              mid: o.attributes.mid,
              needExchangeSDP: !0
            };
          }

          return {
            mid: o.attributes.mid,
            needExchangeSDP: !1
          };
        }

        {
          var _t264 = this.findAvailableMediaIndex(e, s);

          var _i138;

          return -1 === _t264 || ST() || CT() || AT() || 0 === _t264 && DC("USE_SUB_RTX") ? (_i138 = this.createOrRecycleSendMedia(e, s, r, "sendonly", n), this.updateBundleMids()) : (_i138 = bg(this.sessionDesc.mediaDescriptions[_t264]), _i138.attributes.direction = "sendonly", _i138.attributes.ssrcs = s, _i138.attributes.ssrcGroups = r, this.sessionDesc.mediaDescriptions[_t264] = this.mungSendMediaDesc(_i138, n)), RT() && this.firefoxSsrcMidMap.set(s[0].ssrcId, _i138.attributes.mid), {
            mid: _i138.attributes.mid,
            needExchangeSDP: !0
          };
        }
      }
    }, {
      key: "batchSend",
      value: function batchSend(e) {
        var _this254 = this;

        var t = e.map(function (e) {
          var t = e.kind,
              i = e.ssrcMsg,
              n = e.mslabel;
          return _this254.send(t, i, n);
        }),
            i = [];
        var n = !1;
        return t.forEach(function (e) {
          var t = e.mid,
              s = e.needExchangeSDP;
          s && (n = !0), i.push(t);
        }), {
          mids: i,
          needExchangeSDP: n
        };
      }
    }, {
      key: "stopSending",
      value: function stopSending(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return t.attributes.mid && -1 !== e.indexOf(t.attributes.mid);
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.stopSending.");
        t.forEach(function (e) {
          "0" === e.attributes.mid || RT() || ST() || CT() ? e.attributes.ssrcs = [] : (e.attributes.ssrcs = [], e.attributes.direction = "inactive", e.media.port = "0");
        }), this.updateBundleMids();
      }
    }, {
      key: "mute",
      value: function mute(e) {
        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
          return t.attributes.mid === e;
        });
        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.mute."));
        t.attributes.direction = "inactive";
      }
    }, {
      key: "unmute",
      value: function unmute(e) {
        var t = this.sessionDesc.mediaDescriptions.find(function (t) {
          return t.attributes.mid === e;
        });
        if (!t) throw new Error("mediaDescription not found with ".concat(e, " in remote SDP when calling RemoteSDP.unmute."));
        t.attributes.direction = "sendonly";
      }
    }, {
      key: "muteRemote",
      value: function muteRemote(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return bn(e).call(e, t.attributes.mid || "");
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        t.forEach(function (e) {
          e.attributes.direction = "inactive";
        });
      }
    }, {
      key: "unmuteRemote",
      value: function unmuteRemote(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return bn(e).call(e, t.attributes.mid || "");
        });
        if (t.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        t.forEach(function (e) {
          e.attributes.direction = "recvonly";
        });
      }
    }, {
      key: "receive",
      value: function receive(e, t, i, n) {
        var _this255 = this;

        e.forEach(function (e, s) {
          _this255.createOrRecycleRecvMedia(e, [], "recvonly", t, i, n[s]);
        }), this.updateBundleMids();
      }
    }, {
      key: "stopReceiving",
      value: function stopReceiving(e) {
        var t = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return -1 !== e.indexOf(t.attributes.mid);
        });
        if (t.length !== e.length) throw new Error("MediaDescriptions' length doesn't match mids's length when calling RemoteSDP.receive.");
        t.forEach(function (e) {
          e.media.port = "0", e.attributes.direction = "inactive";
        }), this.updateBundleMids();
      }
    }, {
      key: "updateCandidates",
      value: function updateCandidates(e) {
        var _this256 = this;

        e === pv.TCP ? this._candidates.forEach(function (e) {
          -1 === _this256._candidates.findIndex(function (t) {
            return "tcp" === t.transport && t.connectionAddress === e.connectionAddress && t.port === e.port;
          }) && _this256._candidates.push(Fk(Fk({}, e), {}, {
            foundation: "tcpcandidate",
            priority: Number(e.priority) - 1 + "",
            transport: "tcp",
            port: Number(e.port) + 90 + ""
          }));
        }) : this._candidates = this._candidates.filter(function (e) {
          return "tcp" !== e.transport;
        });

        var _iterator36 = _createForOfIteratorHelper(this.sessionDesc.mediaDescriptions),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _e298 = _step36.value;
            _e298.attributes.candidates = this.candidates;
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      }
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        e = bg(e), this._iceParameters = e, this.sessionDesc.mediaDescriptions.forEach(function (t) {
          t.attributes.iceUfrag = e.iceUfrag, t.attributes.icePwd = e.icePwd;
        });
      }
    }, {
      key: "predictReceivingMids",
      value: function predictReceivingMids(e) {
        var t = [];

        for (var i = 0; i < e; i++) {
          t.push((this.currentMidIndex + i + 1).toString(10));
        }

        return t;
      }
    }, {
      key: "findAvailableMediaIndex",
      value: function findAvailableMediaIndex(e, t) {
        var _this257 = this;

        return this.sessionDesc.mediaDescriptions.findIndex(function (i) {
          var n = i.media.mediaType === e && "0" !== i.media.port && ("sendonly" === i.attributes.direction || "sendrecv" === i.attributes.direction) && 0 === i.attributes.ssrcs.length;

          if (RT()) {
            if (n) {
              var _e299 = _this257.firefoxSsrcMidMap.get(t[0].ssrcId);

              return !(_e299 || "0" !== i.attributes.mid && "1" !== i.attributes.mid) || !(!_e299 || _e299 !== i.attributes.mid);
            }

            return !1;
          }

          return n;
        });
      }
    }, {
      key: "createOrRecycleRecvMedia",
      value: function createOrRecycleRecvMedia(e, t, i, n, s, r) {
        var o = e._mediaStreamTrack.kind,
            a = this.rtpCapabilities.recv,
            c = PL(o, a, this.localCapabilities.send, o === hv.VIDEO ? n : s),
            d = o === hv.VIDEO ? a.videoExtensions : a.audioExtensions;
        this.currentMidIndex += 1;
        var l = "".concat(this.currentMidIndex);
        var u = {
          media: {
            mediaType: o,
            port: jk,
            protos: ["UDP", "TLS", "RTP", "SAVPF"],
            fmts: c.map(function (e) {
              return e.payloadType.toString(10);
            })
          },
          connections: [{
            nettype: "IN",
            addrtype: "IP4",
            address: "127.0.0.1"
          }],
          bandwidths: [],
          attributes: {
            iceUfrag: this.iceParameters.iceUfrag,
            icePwd: this.iceParameters.icePwd,
            unrecognized: [],
            candidates: this.candidates,
            extmaps: d,
            fingerprints: this.dtlsParameters.fingerprints,
            imageattr: [],
            msids: [],
            remoteCandidatesList: [],
            rids: [],
            ssrcs: t,
            ssrcGroups: [],
            rtcpFeedbackWildcards: [],
            payloads: c,
            rtcp: {
              port: "9",
              netType: "IN",
              addressType: "IP4",
              address: "0.0.0.0"
            },
            setup: this.setup,
            direction: i,
            rtcpMux: !0,
            rtcpRsize: !0,
            mid: "".concat(l)
          }
        };
        u = this.mungRecvMediaDsec(u, e, r);
        var h = this.findFirstClosedMedia(o);

        if (h) {
          var _e300 = this.sessionDesc.mediaDescriptions.indexOf(h);

          this.sessionDesc.mediaDescriptions[_e300] = u;
        } else this.sessionDesc.mediaDescriptions.push(u);

        return u;
      }
    }, {
      key: "updateRemoteCodec",
      value: function updateRemoteCodec(e, t, i) {
        var n = _toConsumableArray(new Set(this._rtpCapabilities.recv.videoCodecs.map(function (e) {
          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
        }).filter(function (e) {
          var t;
          return bn(t = Object.keys(xC)).call(t, e);
        }))),
            s = new Set(t);

        if (n.every(function (e) {
          return s.has(e);
        })) return YC.debug("codecs has not changed, no need to updateRemoteCodec, codecs: ".concat(t)), !1;

        var r = this._rtpCapabilities.recv.videoCodecs.filter(function (e) {
          return t.some(function (t) {
            var i;
            return bn(i = e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "").call(i, t);
          });
        });

        if (0 === r.length) return YC.debug("updateRemoteCodec failed, because cannot find matched codec, remoteCapabilities codecs: ".concat(n, " codecs: ").concat(t)), !1;

        var o = _toConsumableArray(new Set(r.map(function (e) {
          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
        })));

        var a;
        if (YC.debug("updateRemoteCodec, from ".concat(n, " to ").concat(o)), 0 === e.length) a = this.sessionDesc.mediaDescriptions.filter(function (e) {
          return "video" === e.media.mediaType && "recvonly" === e.attributes.direction;
        });else if (a = this.sessionDesc.mediaDescriptions.filter(function (t) {
          return t.attributes.mid && bn(e).call(e, t.attributes.mid) && "recvonly" === t.attributes.direction;
        }), a.length !== e.length) return YC.debug("updateRemoteCodec failed, because cannot find mids, mids: ".concat(e, ", codecs: ").concat(t)), !1;
        this._rtpCapabilities.recv.videoCodecs = r;
        var c = this.localCapabilities.send,
            d = this.rtpCapabilities.recv,
            l = PL(hv.VIDEO, d, c, i);
        return a.forEach(function (e) {
          var t = l.map(function (e) {
            return e.payloadType.toString(10);
          });
          YC.debug("updateRemoteCodec mid: ".concat(e.attributes.mid, ", from ").concat(e.attributes.payloads, " to ").concat(l)), e.attributes.payloads = l, e.media.fmts = t;
        }), !0;
      }
    }, {
      key: "createOrRecycleSendMedia",
      value: function createOrRecycleSendMedia(e, t, i, n, s) {
        var r = this.rtpCapabilities.send,
            o = e === hv.VIDEO ? r.videoCodecs : r.audioCodecs,
            a = e === hv.VIDEO ? r.videoExtensions : r.audioExtensions;
        this.currentMidIndex += 1;
        var c = "".concat(this.currentMidIndex);
        var d = {
          media: {
            mediaType: e,
            port: jk,
            protos: ["UDP", "TLS", "RTP", "SAVPF"],
            fmts: o.map(function (e) {
              return e.payloadType.toString(10);
            })
          },
          connections: [{
            nettype: "IN",
            addrtype: "IP4",
            address: "127.0.0.1"
          }],
          bandwidths: [],
          attributes: {
            iceUfrag: this.iceParameters.iceUfrag,
            icePwd: this.iceParameters.icePwd,
            unrecognized: [],
            candidates: this.candidates,
            extmaps: a,
            fingerprints: this.dtlsParameters.fingerprints,
            imageattr: [],
            msids: [],
            remoteCandidatesList: [],
            rids: [],
            ssrcs: t,
            ssrcGroups: i,
            rtcpFeedbackWildcards: [],
            payloads: o,
            rtcp: {
              port: "9",
              netType: "IN",
              addressType: "IP4",
              address: "0.0.0.0"
            },
            setup: this.setup,
            direction: n,
            rtcpMux: !0,
            rtcpRsize: !0,
            mid: "".concat(c)
          }
        };
        d = this.mungSendMediaDesc(d, s);
        var l = this.findFirstClosedMedia(e);

        if (l) {
          var _e301 = this.sessionDesc.mediaDescriptions.indexOf(l);

          this.sessionDesc.mediaDescriptions[_e301] = d;
        } else this.sessionDesc.mediaDescriptions.push(d);

        return d;
      }
    }, {
      key: "updateBundleMids",
      value: function updateBundleMids() {
        this.sessionDesc.attributes.groups[0].identificationTag = this.sessionDesc.mediaDescriptions.filter(function (e) {
          return "0" !== e.media.port;
        }).map(function (e) {
          return e.attributes.mid;
        });
      }
    }, {
      key: "mungRecvMediaDsec",
      value: function mungRecvMediaDsec(e, t, i) {
        var n = bg(e);
        return RL(n), SL(n, t), CL(n, t), IL(n), vL(n, i, this.localCapabilities.send), n;
      }
    }, {
      key: "mungSendMediaDesc",
      value: function mungSendMediaDesc(e, t) {
        var i = bg(e);
        return vL(i, t, this.localCapabilities.recv), NL(i), i;
      }
    }, {
      key: "updateRecvMedia",
      value: function updateRecvMedia(e, t) {
        var i = this.sessionDesc.mediaDescriptions.findIndex(function (t) {
          return t.attributes.mid === e;
        });

        if (-1 !== i) {
          var _e302 = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[i], t);

          this.sessionDesc.mediaDescriptions[i] = _e302;
        }
      }
    }, {
      key: "bumpMid",
      value: function bumpMid(e) {
        this.currentMidIndex += e;
      }
    }, {
      key: "findFirstClosedMedia",
      value: function findFirstClosedMedia(e) {
        return this.sessionDesc.mediaDescriptions.find(function (t) {
          return RT() ? "0" === t.media.port && t.media.mediaType === e : "0" === t.media.port;
        });
      }
    }, {
      key: "findPreloadMediaDesc",
      value: function findPreloadMediaDesc(e) {
        return this.sessionDesc.mediaDescriptions.find(function (t) {
          var i;
          return (null === (i = t.attributes) || void 0 === i || null === (i = i.ssrcs[0]) || void 0 === i ? void 0 : i.ssrcId) === e[0].ssrcId;
        });
      }
    }, {
      key: "getSSRC",
      value: function getSSRC(e) {
        var t;
        return null === (t = this.sessionDesc.mediaDescriptions.find(function (t) {
          return t.attributes.mid === e;
        })) || void 0 === t ? void 0 : t.attributes.ssrcs;
      }
    }]);

    return Hk;
  }();

  function Kk(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Yk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Kk(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Kk(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var qk = /*#__PURE__*/function (_Mv3) {
    _inherits(qk, _Mv3);

    var _super64 = _createSuper(qk);

    function qk(e, t, i) {
      var _this258;

      _classCallCheck(this, qk);

      _this258 = _super64.call(this, e, t), nh(_assertThisInitialized(_this258), "store", void 0), nh(_assertThisInitialized(_this258), "peerConnection", void 0), nh(_assertThisInitialized(_this258), "remoteSDP", void 0), nh(_assertThisInitialized(_this258), "initialOffer", void 0), nh(_assertThisInitialized(_this258), "transportEventReceiver", void 0), nh(_assertThisInitialized(_this258), "statsFilter", void 0), nh(_assertThisInitialized(_this258), "useXR", DC("USE_XR")), nh(_assertThisInitialized(_this258), "localCapabilities", void 0), nh(_assertThisInitialized(_this258), "localCandidateCount", 0), nh(_assertThisInitialized(_this258), "allCandidatesReceived", !1), nh(_assertThisInitialized(_this258), "remoteCodecs", void 0), nh(_assertThisInitialized(_this258), "dataStreamChannelMap", new Map()), nh(_assertThisInitialized(_this258), "establishPromise", void 0), nh(_assertThisInitialized(_this258), "mutex", new Yg("NVExtentionsConnection-mutex")), nh(_assertThisInitialized(_this258), "rtcMedia", void 0), _this258.store = t, _this258.peerConnection = i, _this258.statsFilter = hL(_this258.peerConnection, DC("STATS_UPDATE_INTERVAL"), void 0, RT() ? 1200 : void 0), _this258.bindPCEvents(), _this258.bindStatsEvents(), _this258.store.p2pId = _this258.store.p2pId + 1, _this258.establishPromise = _this258.establish();
      return _this258;
    }

    _createClass(qk, [{
      key: "currentLocalDescription",
      get: function get() {
        return this.peerConnection.currentLocalDescription;
      }
    }, {
      key: "currentRemoteDescription",
      get: function get() {
        return this.peerConnection.currentRemoteDescription;
      }
    }, {
      key: "peerConnectionState",
      get: function get() {
        return this.peerConnection.connectionState;
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.peerConnection.iceConnectionState;
      }
    }, {
      key: "localCodecs",
      get: function get() {
        var e;
        return this.localCapabilities && (e = OL(this.localCapabilities)), _toConsumableArray(new Set(e && e.send.videoCodecs.map(function (e) {
          return e.rtpMap && e.rtpMap.encodingName.toLowerCase() || "";
        }).filter(function (e) {
          var t;
          return bn(t = Object.keys(xC)).call(t, e);
        })));
      }
    }, {
      key: "establish",
      value: function () {
        var _establish4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee283(e) {
          var _e303, _t265, i;

          return _regeneratorRuntime.wrap(function _callee283$(_context283) {
            while (1) {
              switch (_context283.prev = _context283.next) {
                case 0:
                  _context283.prev = 0;
                  _context283.next = 3;
                  return this.peerConnection.createOffer();

                case 3:
                  _e303 = _context283.sent;

                  if (_e303.sdp) {
                    _context283.next = 6;
                    break;
                  }

                  throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");

                case 6:
                  _t265 = mL(_e303.sdp);
                  _context283.next = 9;
                  return AL({
                    filterRTX: !DC("USE_PUB_RTX") && !DC("USE_SUB_RTX"),
                    filterVideoFec: DC("FILTER_VIDEO_FEC"),
                    filterAudioFec: DC("FILTER_AUDIO_FEC"),
                    filterVideoCodec: DC("FILTER_VIDEO_CODEC")
                  }, {
                    useXR: this.useXR
                  });

                case 9:
                  i = _context283.sent;
                  return _context283.abrupt("return", (this.localCapabilities = i, this.initialOffer = _e303, Yk(Yk({}, _t265), {}, {
                    rtpCapabilities: i,
                    offerSDP: _e303.sdp
                  })));

                case 13:
                  _context283.prev = 13;
                  _context283.t0 = _context283["catch"](0);
                  throw new VI(xT.GET_LOCAL_CONNECTION_PARAMS_FAILED, _context283.t0.toString());

                case 16:
                case "end":
                  return _context283.stop();
              }
            }
          }, _callee283, this, [[0, 13]]);
        }));

        function establish(_x449) {
          return _establish4.apply(this, arguments);
        }

        return establish;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee284(e, t, i, n, s, r) {
          var _o41, _a24, c, _d16, _l12;

          return _regeneratorRuntime.wrap(function _callee284$(_context284) {
            while (1) {
              switch (_context284.prev = _context284.next) {
                case 0:
                  _context284.prev = 0;

                  if (this.initialOffer) {
                    _context284.next = 3;
                    break;
                  }

                  throw new Error("Cannot establish NVConnection without initial offer.");

                case 3:
                  this.remoteSDP = new Hk({
                    remoteIceParameters: e,
                    remoteDtlsParameters: t,
                    candidates: i,
                    remoteRTPCapabilities: n,
                    remoteSetup: s,
                    localCapabilities: OL(this.localCapabilities),
                    cname: r
                  });
                  _o41 = this.remoteSDP.toString(), _a24 = YP.parse(this.initialOffer.sdp), c = _a24.mediaDescriptions.find(function (e) {
                    return "audio" === e.media.mediaType;
                  });
                  c && NL(c), this.useXR && DL(_a24);
                  _d16 = YP.print(_a24), _l12 = this.logSDPExchange(_d16 || "", "offer", "local", "connect");
                  _context284.next = 9;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _d16
                  });

                case 9:
                  null == _l12 || _l12(_o41);
                  _context284.next = 12;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o41
                  });

                case 12:
                  _context284.next = 17;
                  break;

                case 14:
                  _context284.prev = 14;
                  _context284.t0 = _context284["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NV.connect failed; ".concat(_context284.t0.toString()));

                case 17:
                case "end":
                  return _context284.stop();
              }
            }
          }, _callee284, this, [[0, 14]]);
        }));

        function connect(_x450, _x451, _x452, _x453, _x454, _x455) {
          return _connect8.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function () {
        var _updateRemoteRTPCapabilities3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee285(e, t) {
          var _e304, _t266, i;

          return _regeneratorRuntime.wrap(function _callee285$(_context285) {
            while (1) {
              switch (_context285.prev = _context285.next) {
                case 0:
                  if (!(this.remoteCodecs = t, !this.remoteSDP)) {
                    _context285.next = 2;
                    break;
                  }

                  return _context285.abrupt("return", void YC.debug("[P2PConnection] cannot updateRemoteRTPCapabilities before remote SDP created, local codecs: ".concat(this.localCodecs, ", codecs: ").concat(t)));

                case 2:
                  if (!this.remoteSDP.updateRemoteCodec(e, t, this.store.codec)) {
                    _context285.next = 15;
                    break;
                  }

                  _context285.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  _e304 = _context285.sent;
                  _t266 = this.logSDPExchange(_e304.sdp || "", "offer", "local", "muteLocal");
                  _context285.next = 9;
                  return this.peerConnection.setLocalDescription(_e304);

                case 9:
                  i = this.remoteSDP.toString();
                  null == _t266 || _t266(i);
                  _context285.next = 13;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: i
                  });

                case 13:
                  _context285.next = 16;
                  break;

                case 15:
                  YC.debug("[P2PConnection] updateRemoteRTPCapabilities no need to exchange SDP.");

                case 16:
                case "end":
                  return _context285.stop();
              }
            }
          }, _callee285, this);
        }));

        function updateRemoteRTPCapabilities(_x456, _x457) {
          return _updateRemoteRTPCapabilities3.apply(this, arguments);
        }

        return updateRemoteRTPCapabilities;
      }()
    }, {
      key: "updateRemoteConnect",
      value: function () {
        var _updateRemoteConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee286(e) {
          var t, i, n, s, r, o;
          return _regeneratorRuntime.wrap(function _callee286$(_context286) {
            while (1) {
              switch (_context286.prev = _context286.next) {
                case 0:
                  (null === (t = this.remoteSDP) || void 0 === t || t.updateRemoteRTPCapabilities(e), Array.isArray(this.remoteCodecs) && this.remoteCodecs.length > 0) && (null === (s = this.remoteSDP) || void 0 === s || s.updateRemoteCodec([], this.remoteCodecs, this.store.codec));
                  null === (i = this.remoteSDP) || void 0 === i || i.preloadRemoteMedia(2);
                  r = null === (n = this.remoteSDP) || void 0 === n ? void 0 : n.toString();
                  _context286.next = 5;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: r
                  });

                case 5:
                  _context286.next = 7;
                  return this.peerConnection.createAnswer();

                case 7:
                  o = _context286.sent;
                  _context286.next = 10;
                  return this.peerConnection.setLocalDescription(o);

                case 10:
                  YC.debug("[NVExtentionsConnection] updateRemoteRTPCapabilities by exchanging SDP.");

                case 11:
                case "end":
                  return _context286.stop();
              }
            }
          }, _callee286, this);
        }));

        function updateRemoteConnect(_x458) {
          return _updateRemoteConnect.apply(this, arguments);
        }

        return updateRemoteConnect;
      }()
    }, {
      key: "send",
      value: function send(e, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee287() {
          var s, _r50, _o42, _a25, c, _d17, _l13, _u6, _r51, _h6, _p5;

          return _regeneratorRuntime.wrap(function _callee287$(_context287) {
            while (1) {
              switch (_context287.prev = _context287.next) {
                case 0:
                  _context287.next = 2;
                  return SP(n.mutex.lock("From NVExtentionsConnection.send"));

                case 2:
                  s = _context287.sent;
                  _context287.prev = 3;

                  if (n.remoteSDP) {
                    _context287.next = 6;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.send before remote SDP created");

                case 6:
                  _r50 = [];
                  e.forEach(function (e) {
                    var t = n.peerConnection.addTransceiver(e._mediaStreamTrack, {
                      direction: "sendonly"
                    });

                    _r50.push(t);
                  });
                  _context287.t0 = RT() && !0 === DC("SIMULCAST");

                  if (!_context287.t0) {
                    _context287.next = 12;
                    break;
                  }

                  _context287.next = 12;
                  return SP(n.applySimulcastForFirefox(_r50, e));

                case 12:
                  _context287.next = 14;
                  return SP(n.peerConnection.createOffer());

                case 14:
                  _o42 = _context287.sent;
                  _a25 = n.remoteSDP.predictReceivingMids(e.length);
                  c = n.mungSendOfferSDP(_o42.sdp, e, _a25);
                  _d17 = YP.parse(c);
                  _l13 = _a25.map(function (e) {
                    var t = _d17.mediaDescriptions.find(function (t) {
                      return t.attributes.mid === e;
                    });

                    if (!t) throw new Error("Cannot extract ssrc from mediaDescription.");
                    return fL(t, DC("USE_PUB_RTX"));
                  });
                  _context287.prev = 19;
                  _context287.next = 22;
                  return _l13;

                case 22:
                  _u6 = _context287.sent;
                  _context287.next = 36;
                  break;

                case 25:
                  _context287.prev = 25;
                  _context287.t1 = _context287["catch"](19);
                  _u6 = [], n.remoteSDP.receive(e, t, i, _u6);
                  _r51 = n.remoteSDP.toString();
                  _context287.next = 31;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: c
                  }));

                case 31:
                  _context287.next = 33;
                  return SP(n.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _r51
                  }));

                case 33:
                  _context287.next = 35;
                  return SP(n.stopSending(_a25, !0));

                case 35:
                  throw _context287.t1;

                case 36:
                  n.remoteSDP.receive(e, t, i, _u6);
                  _h6 = n.remoteSDP.toString(), _p5 = n.logSDPExchange(c, "offer", "local", "send");
                  _context287.next = 40;
                  return SP(n.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: c
                  }));

                case 40:
                  _context287.next = 42;
                  return SP(n.applySimulcastEncodings(_r50, e));

                case 42:
                  _context287.next = 44;
                  return SP(n.applySendEncodings(_r50, e));

                case 44:
                  null == _p5 || _p5(_h6);
                  _context287.next = 47;
                  return SP(n.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _h6
                  }));

                case 47:
                  return _context287.abrupt("return", _r50.map(function (e, t) {
                    var i = _a25[t];
                    return {
                      localSSRC: _l13[t],
                      id: i,
                      transceiver: e
                    };
                  }));

                case 50:
                  _context287.prev = 50;
                  _context287.t2 = _context287["catch"](3);
                  throw _context287.t2 instanceof VI ? _context287.t2 : new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.send failed; ".concat(_context287.t2.toString()));

                case 53:
                  _context287.prev = 53;
                  s();
                  return _context287.finish(53);

                case 56:
                case "end":
                  return _context287.stop();
              }
            }
          }, _callee287, null, [[3, 50, 53, 56], [19, 25]]);
        }))();
      }
    }, {
      key: "stopSending",
      value: function () {
        var _stopSending4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee288(e, t) {
          var i, _t267, _n126, _s81, _r52;

          return _regeneratorRuntime.wrap(function _callee288$(_context288) {
            while (1) {
              switch (_context288.prev = _context288.next) {
                case 0:
                  if (!t) {
                    _context288.next = 4;
                    break;
                  }

                  _context288.t0 = void 0;
                  _context288.next = 7;
                  break;

                case 4:
                  _context288.next = 6;
                  return this.mutex.lock("From NVExtentionsConnection.stopSending");

                case 6:
                  _context288.t0 = _context288.sent;

                case 7:
                  i = _context288.t0;
                  _context288.prev = 8;

                  if (this.remoteSDP) {
                    _context288.next = 11;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.stopSending before remote SDP created");

                case 11:
                  _t267 = this.peerConnection.getTransceivers().filter(function (t) {
                    return -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t267.length !== e.length)) {
                    _context288.next = 14;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length when trying to call NVExtentionsConnection.stopSending.");

                case 14:
                  _t267.map(function (e) {
                    var t;
                    e.direction = "inactive", null === (t = e.stop) || void 0 === t || t.call(e);
                  });

                  _context288.next = 17;
                  return this.peerConnection.createOffer();

                case 17:
                  _n126 = _context288.sent;
                  _s81 = this.logSDPExchange(_n126.sdp || "", "offer", "local", "stopSending");
                  _context288.next = 21;
                  return this.peerConnection.setLocalDescription(_n126);

                case 21:
                  this.remoteSDP.stopReceiving(e);
                  _r52 = this.remoteSDP.toString();
                  null == _s81 || _s81(_r52);
                  _context288.next = 26;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _r52
                  });

                case 26:
                  _context288.next = 31;
                  break;

                case 28:
                  _context288.prev = 28;
                  _context288.t1 = _context288["catch"](8);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.stopSending failed; ".concat(_context288.t1.toString()));

                case 31:
                  _context288.prev = 31;
                  i && i();
                  return _context288.finish(31);

                case 34:
                case "end":
                  return _context288.stop();
              }
            }
          }, _callee288, this, [[8, 28, 31, 34]]);
        }));

        function stopSending(_x459, _x460) {
          return _stopSending4.apply(this, arguments);
        }

        return stopSending;
      }()
    }, {
      key: "createDataChannels",
      value: function () {
        var _createDataChannels2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee289(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee289$(_context289) {
            while (1) {
              switch (_context289.prev = _context289.next) {
                case 0:
                  _context289.prev = 0;

                  if (this.remoteSDP) {
                    _context289.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.createDataChannels before remote SDP created");

                case 3:
                  i = this.dataStreamChannelMap.get(e);
                  return _context289.abrupt("return", (i && "open" === i.readyState ? YC.debug("[P2PConnection] Channels are already available and can be reused directly.") : (i = this.peerConnection.createDataChannel("datastream-channel", {
                    ordered: !1,
                    maxRetransmits: DC("DATASTREAM_MAX_RETRANSMITS")
                  }), i.binaryType = "arraybuffer", this.dataStreamChannelMap.set(e, i)), void t.forEach(function (e) {
                    e._updateOriginDataChannel(i);
                  })));

                case 7:
                  _context289.prev = 7;
                  _context289.t0 = _context289["catch"](0);
                  throw _context289.t0 instanceof VI ? _context289.t0 : new VI(xT.DATACHANNEL_FAILED, "NVExtentionsConnection.createDataChannels failed; ".concat(_context289.t0.toString()));

                case 10:
                case "end":
                  return _context289.stop();
              }
            }
          }, _callee289, this, [[0, 7]]);
        }));

        function createDataChannels(_x461, _x462) {
          return _createDataChannels2.apply(this, arguments);
        }

        return createDataChannels;
      }()
    }, {
      key: "stopDataChannels",
      value: function () {
        var _stopDataChannels2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee290(e) {
          var _t268;

          return _regeneratorRuntime.wrap(function _callee290$(_context290) {
            while (1) {
              switch (_context290.prev = _context290.next) {
                case 0:
                  _context290.prev = 0;
                  _t268 = this.dataStreamChannelMap.get(e);
                  return _context290.abrupt("return", (null == _t268 || _t268.close(), void this.dataStreamChannelMap.delete(e)));

                case 5:
                  _context290.prev = 5;
                  _context290.t0 = _context290["catch"](0);
                  throw _context290.t0 instanceof VI ? _context290.t0 : new VI(xT.DATACHANNEL_FAILED, "NVExtentionsConnection.stopDataChannels failed; ".concat(_context290.t0.toString()));

                case 8:
                case "end":
                  return _context290.stop();
              }
            }
          }, _callee290, this, [[0, 5]]);
        }));

        function stopDataChannels(_x463) {
          return _stopDataChannels2.apply(this, arguments);
        }

        return stopDataChannels;
      }()
    }, {
      key: "receive",
      value: function () {
        var _receive4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee291(e, t, i, n) {
          var _this$remoteSDP$send5, _s82, _r53, _t269, _i139, _n127, _r54, _o43;

          return _regeneratorRuntime.wrap(function _callee291$(_context291) {
            while (1) {
              switch (_context291.prev = _context291.next) {
                case 0:
                  _context291.prev = 0;

                  if (this.remoteSDP) {
                    _context291.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.receive ".concat(e, " before remoteSDP created."));

                case 3:
                  _this$remoteSDP$send5 = this.remoteSDP.send(e, t, i, n), _s82 = _this$remoteSDP$send5.mid, _r53 = _this$remoteSDP$send5.needExchangeSDP;

                  if (!_r53) {
                    _context291.next = 18;
                    break;
                  }

                  _t269 = this.remoteSDP.toString(), _i139 = this.logSDPExchange(_t269, "offer", "remote", "receive");
                  _context291.next = 8;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t269
                  });

                case 8:
                  _context291.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _n127 = _context291.sent;
                  _r54 = this.mungReceiveAnswerSDP(_n127.sdp, _s82, e);
                  null == _i139 || _i139(_r54 || "");
                  _context291.next = 15;
                  return this.peerConnection.setLocalDescription({
                    type: "answer",
                    sdp: _r54
                  });

                case 15:
                  YC.debug("[NVExtentionsConnection] receive ".concat(e, " by exchanging SDP."));
                  _context291.next = 19;
                  break;

                case 18:
                  YC.debug("[NVExtentionsConnection] receive ".concat(e, " no need to exchange SDP."));

                case 19:
                  _o43 = this.peerConnection.getTransceivers().find(function (e) {
                    return e.mid === _s82;
                  });

                  if (_o43) {
                    _context291.next = 22;
                    break;
                  }

                  throw new Error("Cannot get transceiver after setLocalDescription.");

                case 22:
                  return _context291.abrupt("return", {
                    track: _o43.receiver.track,
                    id: _s82
                  });

                case 25:
                  _context291.prev = 25;
                  _context291.t0 = _context291["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.receive failed; ".concat(_context291.t0.toString()));

                case 28:
                case "end":
                  return _context291.stop();
              }
            }
          }, _callee291, this, [[0, 25]]);
        }));

        function receive(_x464, _x465, _x466, _x467) {
          return _receive4.apply(this, arguments);
        }

        return receive;
      }()
    }, {
      key: "batchReceive",
      value: function () {
        var _batchReceive3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee292(e) {
          var _this259 = this;

          var _this$remoteSDP$batch2, _t270, i, _e305, _t271, _i140;

          return _regeneratorRuntime.wrap(function _callee292$(_context292) {
            while (1) {
              switch (_context292.prev = _context292.next) {
                case 0:
                  _context292.prev = 0;

                  if (this.remoteSDP) {
                    _context292.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.batchReceive before remoteSDP created.");

                case 3:
                  _this$remoteSDP$batch2 = this.remoteSDP.batchSend(e), _t270 = _this$remoteSDP$batch2.mids, i = _this$remoteSDP$batch2.needExchangeSDP;

                  if (!i) {
                    _context292.next = 17;
                    break;
                  }

                  _e305 = this.remoteSDP.toString(), _t271 = this.logSDPExchange(_e305, "offer", "remote", "receive");
                  _context292.next = 8;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _e305
                  });

                case 8:
                  _context292.next = 10;
                  return this.peerConnection.createAnswer();

                case 10:
                  _i140 = _context292.sent;
                  null == _t271 || _t271(_i140.sdp || "");
                  _context292.next = 14;
                  return this.peerConnection.setLocalDescription(_i140);

                case 14:
                  YC.debug("[NVExtentionsConnection] batchReceive by exchanging SDP.");
                  _context292.next = 18;
                  break;

                case 17:
                  YC.debug("[NVExtentionsConnection] batchReceive no need to exchange SDP.");

                case 18:
                  return _context292.abrupt("return", _t270.map(function (e) {
                    var t = _this259.peerConnection.getTransceivers().find(function (t) {
                      return t.mid === e;
                    });

                    if (!t) throw new Error("Cannot get transceiver after setLocalDescription.");
                    return {
                      track: t.receiver.track,
                      id: e
                    };
                  }));

                case 21:
                  _context292.prev = 21;
                  _context292.t0 = _context292["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.receive failed; ".concat(_context292.t0.toString()));

                case 24:
                case "end":
                  return _context292.stop();
              }
            }
          }, _callee292, this, [[0, 21]]);
        }));

        function batchReceive(_x468) {
          return _batchReceive3.apply(this, arguments);
        }

        return batchReceive;
      }()
    }, {
      key: "stopReceiving",
      value: function () {
        var _stopReceiving4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee293(e) {
          var _t272, i, _n128;

          return _regeneratorRuntime.wrap(function _callee293$(_context293) {
            while (1) {
              switch (_context293.prev = _context293.next) {
                case 0:
                  _context293.prev = 0;

                  if (this.remoteSDP) {
                    _context293.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.stopReceiving before remote SDP created.");

                case 3:
                  this.remoteSDP.stopSending(e);
                  _t272 = this.remoteSDP.toString(), i = this.logSDPExchange(_t272, "offer", "remote", "stopReceiving");
                  _context293.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t272
                  });

                case 7:
                  _context293.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n128 = _context293.sent;
                  null == i || i(_n128.sdp || "");
                  _context293.next = 13;
                  return this.peerConnection.setLocalDescription(_n128);

                case 13:
                  _context293.next = 18;
                  break;

                case 15:
                  _context293.prev = 15;
                  _context293.t0 = _context293["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection stopReceiving failed; ".concat(_context293.t0.toString()));

                case 18:
                case "end":
                  return _context293.stop();
              }
            }
          }, _callee293, this, [[0, 15]]);
        }));

        function stopReceiving(_x469) {
          return _stopReceiving4.apply(this, arguments);
        }

        return stopReceiving;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee294(e) {
          var _t273, i, _n129;

          return _regeneratorRuntime.wrap(function _callee294$(_context294) {
            while (1) {
              switch (_context294.prev = _context294.next) {
                case 0:
                  _context294.prev = 0;

                  if (this.remoteSDP) {
                    _context294.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.muteRemote mid=".concat(e, " before remote SDP created."));

                case 3:
                  this.remoteSDP.mute(e);
                  _t273 = this.remoteSDP.toString(), i = this.logSDPExchange(_t273, "offer", "remote", "muteRemote");
                  _context294.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t273
                  });

                case 7:
                  _context294.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n129 = _context294.sent;
                  null == i || i(_n129.sdp || "");
                  _context294.next = 13;
                  return this.peerConnection.setLocalDescription(_n129);

                case 13:
                  _context294.next = 18;
                  break;

                case 15:
                  _context294.prev = 15;
                  _context294.t0 = _context294["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.muteRemote failed; ".concat(_context294.t0.toString()));

                case 18:
                case "end":
                  return _context294.stop();
              }
            }
          }, _callee294, this, [[0, 15]]);
        }));

        function muteRemote(_x470) {
          return _muteRemote5.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee295(e) {
          var _t274, i, _n130;

          return _regeneratorRuntime.wrap(function _callee295$(_context295) {
            while (1) {
              switch (_context295.prev = _context295.next) {
                case 0:
                  _context295.prev = 0;

                  if (this.remoteSDP) {
                    _context295.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.unmuteRemote mid=".concat(e, " before remote SDP created."));

                case 3:
                  this.remoteSDP.unmute(e);
                  _t274 = this.remoteSDP.toString(), i = this.logSDPExchange(_t274, "offer", "remote", "unmuteRemote");
                  _context295.next = 7;
                  return this.peerConnection.setRemoteDescription({
                    type: "offer",
                    sdp: _t274
                  });

                case 7:
                  _context295.next = 9;
                  return this.peerConnection.createAnswer();

                case 9:
                  _n130 = _context295.sent;
                  null == i || i(_n130.sdp || "");
                  _context295.next = 13;
                  return this.peerConnection.setLocalDescription(_n130);

                case 13:
                  _context295.next = 18;
                  break;

                case 15:
                  _context295.prev = 15;
                  _context295.t0 = _context295["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.unmuteRemote failed; ".concat(_context295.t0.toString()));

                case 18:
                case "end":
                  return _context295.stop();
              }
            }
          }, _callee295, this, [[0, 15]]);
        }));

        function unmuteRemote(_x471) {
          return _unmuteRemote5.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee296(e) {
          var _t275, i, _n131, _s83;

          return _regeneratorRuntime.wrap(function _callee296$(_context296) {
            while (1) {
              switch (_context296.prev = _context296.next) {
                case 0:
                  _context296.prev = 0;

                  if (this.remoteSDP) {
                    _context296.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.muteLocal before remote SDP created.");

                case 3:
                  _t275 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t275.length !== e.length)) {
                    _context296.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t275.map(function (e) {
                    e.direction = "inactive";
                  });

                  _context296.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context296.sent;
                  _n131 = this.logSDPExchange(i.sdp || "", "offer", "local", "muteLocal");
                  _context296.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.muteRemote(e);
                  _s83 = this.remoteSDP.toString();
                  null == _n131 || _n131(_s83);
                  _context296.next = 18;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s83
                  });

                case 18:
                  _context296.next = 23;
                  break;

                case 20:
                  _context296.prev = 20;
                  _context296.t0 = _context296["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.muteLocal failed; ".concat(_context296.t0.toString()));

                case 23:
                case "end":
                  return _context296.stop();
              }
            }
          }, _callee296, this, [[0, 20]]);
        }));

        function muteLocal(_x472) {
          return _muteLocal5.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee298(e) {
          var _t276, i, _n132, _s84;

          return _regeneratorRuntime.wrap(function _callee298$(_context298) {
            while (1) {
              switch (_context298.prev = _context298.next) {
                case 0:
                  _context298.prev = 0;

                  if (this.remoteSDP) {
                    _context298.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.unmuteLocal before remote SDP created.");

                case 3:
                  _t276 = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid && -1 !== e.indexOf(t.mid);
                  });

                  if (!(_t276.length !== e.length)) {
                    _context298.next = 6;
                    break;
                  }

                  throw new Error("Transceivers' length doesn't match mids' length.");

                case 6:
                  _t276.map( /*#__PURE__*/function () {
                    var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee297(e, t) {
                      return _regeneratorRuntime.wrap(function _callee297$(_context297) {
                        while (1) {
                          switch (_context297.prev = _context297.next) {
                            case 0:
                              e.direction = "sendonly";

                            case 1:
                            case "end":
                              return _context297.stop();
                          }
                        }
                      }, _callee297);
                    }));

                    return function (_x474, _x475) {
                      return _ref70.apply(this, arguments);
                    };
                  }());

                  _context298.next = 9;
                  return this.peerConnection.createOffer();

                case 9:
                  i = _context298.sent;
                  _n132 = this.logSDPExchange(i.sdp || "", "offer", "local", "unmuteLocal");
                  _context298.next = 13;
                  return this.peerConnection.setLocalDescription(i);

                case 13:
                  this.remoteSDP.unmuteRemote(e);
                  _s84 = this.remoteSDP.toString();
                  null == _n132 || _n132(_s84);
                  _context298.next = 18;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s84
                  });

                case 18:
                  _context298.next = 23;
                  break;

                case 20:
                  _context298.prev = 20;
                  _context298.t0 = _context298["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, "NVExtentionsConnection.unmuteLocal failed; ".concat(_context298.t0.toString()));

                case 23:
                case "end":
                  return _context298.stop();
              }
            }
          }, _callee298, this, [[0, 20]]);
        }));

        function unmuteLocal(_x473) {
          return _unmuteLocal5.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee299() {
          var i, _i141, _n134, _n133, _s85, _yield$_s85$iceParame, _r55, _o44, _a26;

          return _regeneratorRuntime.wrap(function _callee299$(_context299) {
            while (1) {
              switch (_context299.prev = _context299.next) {
                case 0:
                  _context299.next = 2;
                  return SP(t.mutex.lock("From NVExtentionsConnection.restartICE"));

                case 2:
                  i = _context299.sent;
                  _context299.prev = 3;

                  if (t.remoteSDP) {
                    _context299.next = 6;
                    break;
                  }

                  throw new Error("Cannot restartICE before remoteSDP created.");

                case 6:
                  if (!wA().supportPCSetConfiguration) {
                    _context299.next = 11;
                    break;
                  }

                  _i141 = t.peerConnection.getConfiguration(), _n134 = e === pv.RELAY ? "relay" : "all";
                  _i141.iceTransportPolicy !== _n134 && (YC.debug("restartICE change iceTransportPolicy from [".concat(_i141.iceTransportPolicy, "] to [").concat(_n134, "]")), _i141.iceTransportPolicy = _n134, t.peerConnection.setConfiguration(_i141));
                  _context299.next = 13;
                  break;

                case 11:
                  if (!(e === pv.RELAY)) {
                    _context299.next = 13;
                    break;
                  }

                  return _context299.abrupt("return");

                case 13:
                  e !== pv.RELAY && t.remoteSDP.updateCandidates(e);
                  _context299.next = 16;
                  return SP(t.peerConnection.createOffer({
                    iceRestart: !0
                  }));

                case 16:
                  _n133 = _context299.sent;

                  if (_n133.sdp) {
                    _context299.next = 19;
                    break;
                  }

                  throw new Error("Cannot restartICE because restart offer SDP does not exist.");

                case 19:
                  _s85 = mL(_n133.sdp);
                  _context299.next = 22;
                  return _s85.iceParameters;

                case 22:
                  _yield$_s85$iceParame = _context299.sent;
                  _r55 = _yield$_s85$iceParame.remoteIceParameters;
                  t.remoteSDP.restartICE(_r55);
                  _o44 = t.remoteSDP.toString(), _a26 = t.logSDPExchange(_n133.sdp || "", "offer", "local", "restartICE");
                  _context299.next = 28;
                  return SP(t.peerConnection.setLocalDescription(_n133));

                case 28:
                  null == _a26 || _a26(_o44);
                  _context299.next = 31;
                  return SP(t.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _o44
                  }));

                case 31:
                  _context299.next = 36;
                  break;

                case 33:
                  _context299.prev = 33;
                  _context299.t0 = _context299["catch"](3);
                  YC.warning("restart ICE failed, abort operation", _context299.t0);

                case 36:
                  _context299.prev = 36;
                  i();
                  return _context299.finish(36);

                case 39:
                case "end":
                  return _context299.stop();
              }
            }
          }, _callee299, null, [[3, 33, 36, 39]]);
        }))();
      }
    }, {
      key: "close",
      value: function close() {
        var e;
        null === (e = this.onConnectionStateChange) || void 0 === e || e.call(this, "closed"), this.unbindPCEvents(), this.unbindStatsEvents(), this.removeAllListeners(), this.transportEventReceiver = void 0, this.statsFilter.destroy(), this.dataStreamChannelMap.clear();
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return this.statsFilter.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        return this.statsFilter.getVideoIsReady(e);
      }
    }, {
      key: "updateEncoderConfig",
      value: function () {
        var _updateEncoderConfig4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee300(e, t) {
          var i, _n135, _s86, _r56;

          return _regeneratorRuntime.wrap(function _callee300$(_context300) {
            while (1) {
              switch (_context300.prev = _context300.next) {
                case 0:
                  _context300.prev = 0;

                  if (this.remoteSDP) {
                    _context300.next = 3;
                    break;
                  }

                  throw new Error("Cannot call NVExtentionsConnection.updateEncoderConfig before remote SDP created.");

                case 3:
                  _context300.next = 5;
                  return this.peerConnection.createOffer();

                case 5:
                  i = _context300.sent;
                  _n135 = this.mungSendOfferSDP(i.sdp, [t], [e]);
                  this.remoteSDP.updateRecvMedia(e, t);
                  _s86 = this.remoteSDP.toString(), _r56 = this.logSDPExchange(_n135, "offer", "local", "updateEncoderConfig");
                  _context300.next = 11;
                  return this.peerConnection.setLocalDescription({
                    type: "offer",
                    sdp: _n135
                  });

                case 11:
                  null == _r56 || _r56(_s86);
                  _context300.next = 14;
                  return this.peerConnection.setRemoteDescription({
                    type: "answer",
                    sdp: _s86
                  });

                case 14:
                  _context300.next = 19;
                  break;

                case 16:
                  _context300.prev = 16;
                  _context300.t0 = _context300["catch"](0);
                  throw new VI(xT.EXCHANGE_SDP_FAILED, _context300.t0.toString());

                case 19:
                case "end":
                  return _context300.stop();
              }
            }
          }, _callee300, this, [[0, 16]]);
        }));

        function updateEncoderConfig(_x476, _x477) {
          return _updateEncoderConfig4.apply(this, arguments);
        }

        return updateEncoderConfig;
      }()
    }, {
      key: "updateSendParameters",
      value: function () {
        var _updateSendParameters4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee301(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee301$(_context301) {
            while (1) {
              switch (_context301.prev = _context301.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().filter(function (t) {
                    return t.mid === e;
                  });
                  _context301.t0 = 1 === i.length;

                  if (!_context301.t0) {
                    _context301.next = 12;
                    break;
                  }

                  if (!this.isVP8Simulcast(t)) {
                    _context301.next = 10;
                    break;
                  }

                  _context301.t1 = RT();

                  if (_context301.t1) {
                    _context301.next = 8;
                    break;
                  }

                  _context301.next = 8;
                  return this.applySimulcastEncodings(i, [t]);

                case 8:
                  _context301.next = 12;
                  break;

                case 10:
                  _context301.next = 12;
                  return this.applySendEncodings(i, [t]);

                case 12:
                case "end":
                  return _context301.stop();
              }
            }
          }, _callee301, this);
        }));

        function updateSendParameters(_x478, _x479) {
          return _updateSendParameters4.apply(this, arguments);
        }

        return updateSendParameters;
      }()
    }, {
      key: "setStatsRemoteVideoIsReady",
      value: function setStatsRemoteVideoIsReady(e, t) {
        this.statsFilter.setVideoIsReady2(e, t);
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee302(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee302$(_context302) {
            while (1) {
              switch (_context302.prev = _context302.next) {
                case 0:
                  i = this.peerConnection.getTransceivers().find(function (e) {
                    return e.mid === t;
                  });
                  _context302.t0 = i;

                  if (!_context302.t0) {
                    _context302.next = 5;
                    break;
                  }

                  _context302.next = 5;
                  return i.sender.replaceTrack(e._mediaStreamTrack);

                case 5:
                case "end":
                  return _context302.stop();
              }
            }
          }, _callee302, this);
        }));

        function replaceTrack(_x480, _x481) {
          return _replaceTrack5.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "getP2PConnectionParams",
      value: function getP2PConnectionParams() {
        var e;
        if (null === (e = this.peerConnection.currentLocalDescription) || void 0 === e || !e.sdp || !this.localCapabilities) throw new Error();
        return Yk(Yk({}, mL(this.peerConnection.currentLocalDescription.sdp)), {}, {
          rtpCapabilities: this.localCapabilities
        });
      }
    }, {
      key: "bindPCEvents",
      value: function bindPCEvents() {
        var _this260 = this;

        this.peerConnection.oniceconnectionstatechange = function () {
          var e;
          null === (e = _this260.onICEConnectionStateChange) || void 0 === e || e.call(_this260, _this260.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = function () {
          var e;
          null === (e = _this260.onConnectionStateChange) || void 0 === e || e.call(_this260, _this260.peerConnection.connectionState);
        }, this.peerConnection.onicecandidate = function (e) {
          e.candidate ? _this260.localCandidateCount += 1 : (_this260.peerConnection.onicecandidate = null, _this260.allCandidatesReceived = !0, YC.debug("[pc-".concat(_this260.store.p2pId, "] local candidate count"), _this260.localCandidateCount));
        }, setTimeout(function () {
          _this260.allCandidatesReceived || (_this260.allCandidatesReceived = !0, YC.debug("[pc-".concat(_this260.store.p2pId, "] onicecandidate timeout, local candidate count"), _this260.localCandidateCount));
        }, DC("CANDIDATE_TIMEOUT"));
      }
    }, {
      key: "unbindPCEvents",
      value: function unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
    }, {
      key: "applySendEncodings",
      value: function () {
        var _applySendEncodings4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee303(e, t) {
          var _l14, _u7, _h7, i, n, s, _e306, _t277, r, o, a, c, d, _e307, _l15, _p6;

          return _regeneratorRuntime.wrap(function _callee303$(_context303) {
            while (1) {
              switch (_context303.prev = _context303.next) {
                case 0:
                  _context303.prev = 0;

                  if (wA().supportSetRtpSenderParameters) {
                    _context303.next = 3;
                    break;
                  }

                  return _context303.abrupt("return");

                case 3:
                  if (!(e.length !== t.length)) {
                    _context303.next = 5;
                    break;
                  }

                  return _context303.abrupt("return");

                case 5:
                  _l14 = 0;

                case 6:
                  if (!(_l14 < e.length)) {
                    _context303.next = 32;
                    break;
                  }

                  _u7 = e[_l14], _h7 = t[_l14];

                  if (!(_h7 && _h7 instanceof Nw)) {
                    _context303.next = 29;
                    break;
                  }

                  if (!this.isVP8Simulcast(_h7)) {
                    _context303.next = 11;
                    break;
                  }

                  return _context303.abrupt("continue", 29);

                case 11:
                  _e306 = {}, _t277 = {};
                  _context303.t0 = _h7._optimizationMode;
                  _context303.next = _context303.t0 === "motion" ? 15 : _context303.t0 === "detail" ? 17 : 19;
                  break;

                case 15:
                  _e306.degradationPreference = "maintain-framerate";
                  return _context303.abrupt("break", 20);

                case 17:
                  _e306.degradationPreference = "maintain-resolution";
                  return _context303.abrupt("break", 20);

                case 19:
                  _e306.degradationPreference = "balanced";

                case 20:
                  if (null !== (i = _h7._encoderConfig) && void 0 !== i && i.bitrateMax) _t277.maxBitrate = 1e3 * (null === (r = _h7._encoderConfig) || void 0 === r ? void 0 : r.bitrateMax);
                  if (bn(n = _h7._hints).call(n, YA.LOW_STREAM)) null !== (o = _h7._encoderConfig) && void 0 !== o && o.frameRate && (_t277.maxFramerate = yy(_h7._encoderConfig.frameRate)), null !== (a = _h7._encoderConfig) && void 0 !== a && a.scaleResolutionDownBy && (null === (c = _h7._encoderConfig) || void 0 === c ? void 0 : c.scaleResolutionDownBy) > 1 && (_t277.scaleResolutionDownBy = _h7._encoderConfig.scaleResolutionDownBy);

                  if (DC("DSCP_TYPE") && kT()) {
                    _e307 = DC("DSCP_TYPE");
                    bn(d = ["very-low", "low", "medium", "high"]).call(d, _e307) && (_t277.networkPriority = _e307);
                  }

                  _l15 = _u7.sender.getParameters(), _p6 = null === (s = _l15.encodings) || void 0 === s ? void 0 : s[0];
                  RT() && !_p6 && (_e306.encodings = [_t277]);
                  _p6 && Object.assign(_p6, _t277);
                  Object.assign(_l15, _e306);
                  _context303.next = 29;
                  return _u7.sender.setParameters(_l15);

                case 29:
                  _l14++;
                  _context303.next = 6;
                  break;

                case 32:
                  _context303.next = 37;
                  break;

                case 34:
                  _context303.prev = 34;
                  _context303.t1 = _context303["catch"](0);
                  YC.debug("Apply RTPSendEncodings failed.");

                case 37:
                case "end":
                  return _context303.stop();
              }
            }
          }, _callee303, this, [[0, 34]]);
        }));

        function applySendEncodings(_x482, _x483) {
          return _applySendEncodings4.apply(this, arguments);
        }

        return applySendEncodings;
      }()
    }, {
      key: "mungSendOfferSDP",
      value: function mungSendOfferSDP(e, t, i) {
        var _this261 = this;

        var n = YP.parse(e);
        return t.forEach(function (e, t) {
          var s = i[t],
              r = n.mediaDescriptions.find(function (e) {
            return e.attributes.mid === s;
          });
          r && (SL(r, e), yL(r, e, _this261.store.codec));
        }), YP.print(n);
      }
    }, {
      key: "mungReceiveAnswerSDP",
      value: function mungReceiveAnswerSDP(e, t, i) {
        var n = YP.parse(e),
            s = n.mediaDescriptions.find(function (e) {
          return e.attributes.mid === t;
        });
        return s && i === hv.AUDIO && "audio" === s.media.mediaType && NL(s), this.useXR && DL(n), YP.print(n);
      }
    }, {
      key: "bindStatsEvents",
      value: function bindStatsEvents() {
        var _this262 = this;

        this.statsFilter.onFirstAudioReceived = function (e) {
          var t;
          null === (t = _this262.onFirstAudioReceived) || void 0 === t || t.call(_this262, e);
        }, this.statsFilter.onFirstVideoReceived = function (e) {
          var t;
          null === (t = _this262.onFirstVideoReceived) || void 0 === t || t.call(_this262, e);
        }, this.statsFilter.onFirstAudioDecoded = function (e) {
          var t;
          null === (t = _this262.onFirstAudioDecoded) || void 0 === t || t.call(_this262, e);
        }, this.statsFilter.onFirstVideoDecoded = function (e, t, i) {
          var n;
          null === (n = _this262.onFirstVideoDecoded) || void 0 === n || n.call(_this262, e, t, i);
        }, this.statsFilter.onSelectedLocalCandidateChanged = function (e, t) {
          var i;
          null === (i = _this262.onSelectedLocalCandidateChanged) || void 0 === i || i.call(_this262, e, t);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = function (e, t) {
          var i;
          null === (i = _this262.onSelectedRemoteCandidateChanged) || void 0 === i || i.call(_this262, e, t);
        }, this.statsFilter.onFirstVideoDecodedTimeout = function (e) {
          var t;
          null === (t = _this262.onFirstVideoDecodedTimeout) || void 0 === t || t.call(_this262, e);
        };
      }
    }, {
      key: "unbindStatsEvents",
      value: function unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0, this.statsFilter.onFirstVideoDecodedTimeout = void 0;
      }
    }, {
      key: "applySimulcastForFirefox",
      value: function () {
        var _applySimulcastForFirefox3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee304(e, t) {
          var _a27, i, n, s, r, o, c, _d18, _e308, _t278, _i142;

          return _regeneratorRuntime.wrap(function _callee304$(_context304) {
            while (1) {
              switch (_context304.prev = _context304.next) {
                case 0:
                  if (!(e.length === t.length)) {
                    _context304.next = 13;
                    break;
                  }

                  _a27 = 0;

                case 2:
                  if (!(_a27 < e.length)) {
                    _context304.next = 13;
                    break;
                  }

                  c = e[_a27], _d18 = t[_a27];

                  if (!(_d18 instanceof Nw && !bn(i = _d18._hints).call(i, YA.LOW_STREAM) && null !== (n = _d18._encoderConfig) && void 0 !== n && n.bitrateMax && (null === (s = _d18._encoderConfig) || void 0 === s ? void 0 : s.bitrateMax) > 200 && null !== (r = _d18._scalabilityMode) && void 0 !== r && r.numSpatialLayers && (null === (o = _d18._scalabilityMode) || void 0 === o ? void 0 : o.numSpatialLayers) > 1 && "vp8" === this.store.codec)) {
                    _context304.next = 10;
                    break;
                  }

                  _e308 = {}, _t278 = {
                    high: 1e3 * (_d18._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _e308.encodings = [{
                    rid: "m",
                    active: !0,
                    maxBitrate: _t278.medium,
                    scaleResolutionDownBy: 4
                  }, {
                    rid: "h",
                    active: !0,
                    maxBitrate: _t278.high
                  }];
                  _i142 = c.sender.getParameters();
                  _context304.next = 10;
                  return c.sender.setParameters(Object.assign(_i142, _e308));

                case 10:
                  _a27++;
                  _context304.next = 2;
                  break;

                case 13:
                case "end":
                  return _context304.stop();
              }
            }
          }, _callee304, this);
        }));

        function applySimulcastForFirefox(_x484, _x485) {
          return _applySimulcastForFirefox3.apply(this, arguments);
        }

        return applySimulcastForFirefox;
      }()
    }, {
      key: "applySimulcastEncodings",
      value: function () {
        var _applySimulcastEncodings3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee305(e, t) {
          var i, _n136, _t279, _s87, _r57, _o45;

          return _regeneratorRuntime.wrap(function _callee305$(_context305) {
            while (1) {
              switch (_context305.prev = _context305.next) {
                case 0:
                  if (!(!RT() && e.length === t.length)) {
                    _context305.next = 13;
                    break;
                  }

                  i = 0;

                case 2:
                  if (!(i < e.length)) {
                    _context305.next = 13;
                    break;
                  }

                  _n136 = t[i];

                  if (!(_n136 instanceof Nw && this.isVP8Simulcast(_n136))) {
                    _context305.next = 10;
                    break;
                  }

                  _t279 = e[i], _s87 = {}, _r57 = {
                    high: 1e3 * (_n136._encoderConfig.bitrateMax - 50),
                    medium: 5e4
                  };
                  _s87.encodings = [{
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "high",
                    priority: "high",
                    maxBitrate: _r57.high
                  }, {
                    active: !0,
                    adaptivePtime: !1,
                    networkPriority: "low",
                    priority: "low",
                    maxBitrate: _r57.medium,
                    scaleResolutionDownBy: 4
                  }];
                  _o45 = _t279.sender.getParameters();
                  _context305.next = 10;
                  return _t279.sender.setParameters(Object.assign(_o45, _s87));

                case 10:
                  i++;
                  _context305.next = 2;
                  break;

                case 13:
                case "end":
                  return _context305.stop();
              }
            }
          }, _callee305, this);
        }));

        function applySimulcastEncodings(_x486, _x487) {
          return _applySimulcastEncodings3.apply(this, arguments);
        }

        return applySimulcastEncodings;
      }()
    }, {
      key: "isVP8Simulcast",
      value: function isVP8Simulcast(e) {
        var t, i, n, s, r;
        return !!(e instanceof Nw && DC("SIMULCAST") && "vp8" === this.store.codec && !bn(t = e._hints).call(t, YA.LOW_STREAM) && null !== (i = e._encoderConfig) && void 0 !== i && i.bitrateMax && (null === (n = e._encoderConfig) || void 0 === n ? void 0 : n.bitrateMax) > 200 && null !== (s = e._scalabilityMode) && void 0 !== s && s.numSpatialLayers && (null === (r = e._scalabilityMode) || void 0 === r ? void 0 : r.numSpatialLayers) > 1);
      }
    }, {
      key: "logSDPExchange",
      value: function logSDPExchange(e, t, i, n) {
        var _this263 = this;

        if (DC("SDP_LOGGING")) return YC.upload("exchanging ".concat(i, " ").concat(t, " SDP during NVExtentionsConnection.").concat(n, "\n"), e), "offer" === t ? function (e) {
          _this263.logSDPExchange(e, "answer", "local" === i ? "remote" : "local", n);
        } : void 0;
      }
    }, {
      key: "getRemoteSSRC",
      value: function () {
        var _getRemoteSSRC4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee306(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee306$(_context306) {
            while (1) {
              switch (_context306.prev = _context306.next) {
                case 0:
                  if (this.remoteSDP) {
                    _context306.next = 2;
                    break;
                  }

                  return _context306.abrupt("return");

                case 2:
                  t = this.remoteSDP.getSSRC(e);
                  return _context306.abrupt("return", null == t ? void 0 : t[0].ssrcId);

                case 4:
                case "end":
                  return _context306.stop();
              }
            }
          }, _callee306, this);
        }));

        function getRemoteSSRC(_x488) {
          return _getRemoteSSRC4.apply(this, arguments);
        }

        return getRemoteSSRC;
      }()
    }, {
      key: "setConfiguration",
      value: function setConfiguration(e) {
        if (wA().supportPCSetConfiguration) {
          var _t280 = qk.resolvePCConfiguration(e);

          this.peerConnection.setConfiguration(_t280);
        }
      }
    }], [{
      key: "resolvePCConfiguration",
      value: function resolvePCConfiguration(e) {
        var _t$iceServers5, _t$iceServers6;

        var t = {
          iceServers: []
        };
        return e.iceServers ? t.iceServers = e.iceServers : e.turnServer && "off" !== e.turnServer.mode && (_g(e.turnServer.servers) ? t.iceServers = e.turnServer.servers : (t.iceServers && (_t$iceServers5 = t.iceServers).push.apply(_t$iceServers5, _toConsumableArray(qk.turnServerConfigToIceServers(e.turnServer.servers))), DC("USE_TURN_SERVER_OF_GATEWAY") && t.iceServers && e.turnServer.serversFromGateway && (_t$iceServers6 = t.iceServers).push.apply(_t$iceServers6, _toConsumableArray(qk.turnServerConfigToIceServers(e.turnServer.serversFromGateway))), DC("FORCE_TURN_TCP") ? t.iceTransportPolicy = "relay" : e.turnServer.servers.concat(e.turnServer.serversFromGateway || []).forEach(function (e) {
          e.forceturn && (t.iceTransportPolicy = "relay");
        }))), t;
      }
    }, {
      key: "turnServerConfigToIceServers",
      value: function turnServerConfigToIceServers(e) {
        var t = [];
        return e.forEach(function (e) {
          e.security ? e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turns:".concat(Iy(e.turnServerURL), ":").concat(e.tcpport, "?transport=tcp")
          }) : (e.udpport && !DC("FORCE_TURN_TCP") && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.udpport, "?transport=udp")
          }), e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.tcpport, "?transport=tcp")
          }));
        }), t;
      }
    }]);

    return qk;
  }(Mv);

  function Jk(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee307() {
      var e,
          i,
          s,
          r,
          o,
          _args307 = arguments;
      return _regeneratorRuntime.wrap(function _callee307$(_context307) {
        while (1) {
          switch (_context307.prev = _context307.next) {
            case 0:
              e = this.mutex;
              _context307.next = 3;
              return e.lock("From NVExtentionsConnection.".concat(t));

            case 3:
              i = _context307.sent;
              _context307.prev = 4;

              for (s = _args307.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args307[o];
              }

              _context307.next = 8;
              return n.apply(this, r);

            case 8:
              return _context307.abrupt("return", _context307.sent);

            case 9:
              _context307.prev = 9;
              i();
              return _context307.finish(9);

            case 12:
            case "end":
              return _context307.stop();
          }
        }
      }, _callee307, this, [[4,, 9, 12]]);
    })), i;
  }

  function zk(e) {
    var t,
        i,
        n,
        s = 2;

    for ("undefined" != typeof Symbol && (i = Ik, n = Symbol.iterator); s--;) {
      if (i && null != (t = e[i])) return t.call(e);
      if (n && null != (t = e[n])) return new Xk(t.call(e));
      i = "@@asyncIterator", n = "@@iterator";
    }

    throw new TypeError("Object is not async iterable");
  }

  function Xk(e) {
    function t(e) {
      if (Object(e) !== e) return tT.reject(new TypeError(e + " is not an object."));
      var t = e.done;
      return tT.resolve(e.value).then(function (e) {
        return {
          value: e,
          done: t
        };
      });
    }

    return Xk = function Xk(e) {
      this.s = e, this.n = e.next;
    }, Xk.prototype = {
      s: null,
      n: null,
      next: function next() {
        return t(this.n.apply(this.s, arguments));
      },
      return: function _return(e) {
        var i = this.s.return;
        return void 0 === i ? tT.resolve({
          value: e,
          done: !0
        }) : t(i.apply(this.s, arguments));
      },
      throw: function _throw(e) {
        var i = this.s.return;
        return void 0 === i ? tT.reject(e) : t(i.apply(this.s, arguments));
      }
    }, new Xk(e);
  }

  UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], qk.prototype, "connect", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Array, Array]), xI("design:returntype", tT)], qk.prototype, "updateRemoteRTPCapabilities", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], qk.prototype, "updateRemoteConnect", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Object, Array]), xI("design:returntype", tT)], qk.prototype, "createDataChannels", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, Object]), xI("design:returntype", tT)], qk.prototype, "receive", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], qk.prototype, "batchReceive", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], qk.prototype, "stopReceiving", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], qk.prototype, "muteRemote", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], qk.prototype, "unmuteRemote", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], qk.prototype, "muteLocal", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], qk.prototype, "unmuteLocal", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], qk.prototype, "close", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], qk.prototype, "updateEncoderConfig", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], qk.prototype, "updateSendParameters", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [_b, String]), xI("design:returntype", tT)], qk.prototype, "replaceTrack", null), UI([Jk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], qk.prototype, "getRemoteSSRC", null);

  var Qk = /*#__PURE__*/function (_Mv4) {
    _inherits(Qk, _Mv4);

    var _super65 = _createSuper(Qk);

    function Qk(e, t) {
      var _this264;

      _classCallCheck(this, Qk);

      _this264 = _super65.call(this, e, t), nh(_assertThisInitialized(_this264), "store", void 0), nh(_assertThisInitialized(_this264), "peerConnection", void 0), nh(_assertThisInitialized(_this264), "cname", void 0), nh(_assertThisInitialized(_this264), "mutex", new Yg("DataChannelConnection-mutex")), nh(_assertThisInitialized(_this264), "dataChannel", void 0), nh(_assertThisInitialized(_this264), "_p2pConnection", void 0), nh(_assertThisInitialized(_this264), "establishPromise", void 0), nh(_assertThisInitialized(_this264), "_nvMedia", void 0), _this264.store = t, _this264.store.dcId = _this264.store.dcId + 1, _this264.peerConnection = new RTCPeerConnection(Qk.resolvePCConfiguration(e), {
        optional: [{
          googDscp: !0
        }]
      }), _this264.dataChannel = _this264.peerConnection.createDataChannel("agora-signal", {
        ordered: !1,
        maxPacketLifeTime: 50
      }), _this264.dataChannel.binaryType = "arraybuffer", _this264._p2pConnection = new qk(e, t, _this264.peerConnection), _this264.bindPCEvents(), _this264.establishPromise = _this264._p2pConnection.establishPromise;
      return _this264;
    }

    _createClass(Qk, [{
      key: "currentLocalDescription",
      get: function get() {
        return this.peerConnection.currentLocalDescription;
      }
    }, {
      key: "currentRemoteDescription",
      get: function get() {
        return this.peerConnection.currentRemoteDescription;
      }
    }, {
      key: "peerConnectionState",
      get: function get() {
        return this.peerConnection.connectionState;
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.peerConnection.iceConnectionState;
      }
    }, {
      key: "localCodecs",
      get: function get() {
        return this._p2pConnection.localCodecs;
      }
    }, {
      key: "establish",
      value: function () {
        var _establish5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee308() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee308$(_context308) {
            while (1) {
              switch (_context308.prev = _context308.next) {
                case 0:
                  t = null === (e = this._nvMedia) || void 0 === e ? void 0 : e.getLocalRtpCapabilities();
                  _context308.next = 3;
                  return this._p2pConnection.establish(t);

                case 3:
                  return _context308.abrupt("return", _context308.sent);

                case 4:
                case "end":
                  return _context308.stop();
              }
            }
          }, _callee308, this);
        }));

        function establish() {
          return _establish5.apply(this, arguments);
        }

        return establish;
      }()
    }, {
      key: "getP2PConnectionParams",
      value: function getP2PConnectionParams() {
        return this._p2pConnection.getP2PConnectionParams();
      }
    }, {
      key: "connect",
      value: function () {
        var _connect9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee309(e, t, i, n, s, r) {
          var _this265 = this;

          return _regeneratorRuntime.wrap(function _callee309$(_context309) {
            while (1) {
              switch (_context309.prev = _context309.next) {
                case 0:
                  this.cname = r;
                  _context309.next = 3;
                  return this._p2pConnection.connect(e, t, i, n, s, r);

                case 3:
                  _context309.next = 5;
                  return new tT(function (e, t) {
                    var n = setTimeout(function () {
                      _this265.closeSignal(), t(new VI(xT.DATACHANNEL_CONNECTION_TIMEOUT, "Datachannel connection timed out, candidates: ".concat(JSON.stringify(i))));
                    }, 2e3);
                    _this265.dataChannel.onopen = function () {
                      if ("open" === _this265.dataChannel.readyState) return clearTimeout(n), void e();
                    }, _this265.dataChannel.onerror = function (e) {
                      _this265.closeSignal(), t(e);
                    };
                  });

                case 5:
                  return _context309.abrupt("return", {
                    transmitter: this.dataChannel,
                    close: this.closeSignal.bind(this)
                  });

                case 6:
                case "end":
                  return _context309.stop();
              }
            }
          }, _callee309, this);
        }));

        function connect(_x489, _x490, _x491, _x492, _x493, _x494) {
          return _connect9.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function () {
        var _updateRemoteRTPCapabilities4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee310(e, t) {
          return _regeneratorRuntime.wrap(function _callee310$(_context310) {
            while (1) {
              switch (_context310.prev = _context310.next) {
                case 0:
                  return _context310.abrupt("return", this._p2pConnection.updateRemoteRTPCapabilities(e, t));

                case 1:
                case "end":
                  return _context310.stop();
              }
            }
          }, _callee310, this);
        }));

        function updateRemoteRTPCapabilities(_x495, _x496) {
          return _updateRemoteRTPCapabilities4.apply(this, arguments);
        }

        return updateRemoteRTPCapabilities;
      }()
    }, {
      key: "send",
      value: function send(e, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee311() {
          var s;
          return _regeneratorRuntime.wrap(function _callee311$(_context311) {
            while (1) {
              switch (_context311.prev = _context311.next) {
                case 0:
                  _context311.next = 2;
                  return SP(n.mutex.lock("From DataChannelConnection.send"));

                case 2:
                  s = _context311.sent;
                  _context311.prev = 3;
                  return _context311.delegateYield(Ck(zk(n._p2pConnection.send(e, t, i))), "t0", 5);

                case 5:
                  return _context311.abrupt("return", _context311.t0);

                case 6:
                  _context311.prev = 6;
                  s();
                  return _context311.finish(6);

                case 9:
                case "end":
                  return _context311.stop();
              }
            }
          }, _callee311, null, [[3,, 6, 9]]);
        }))();
      }
    }, {
      key: "stopSending",
      value: function () {
        var _stopSending5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee312(e, t) {
          return _regeneratorRuntime.wrap(function _callee312$(_context312) {
            while (1) {
              switch (_context312.prev = _context312.next) {
                case 0:
                  return _context312.abrupt("return", this._p2pConnection.stopSending(e, t));

                case 1:
                case "end":
                  return _context312.stop();
              }
            }
          }, _callee312, this);
        }));

        function stopSending(_x497, _x498) {
          return _stopSending5.apply(this, arguments);
        }

        return stopSending;
      }()
    }, {
      key: "createDataChannels",
      value: function () {
        var _createDataChannels3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee313(e, t) {
          return _regeneratorRuntime.wrap(function _callee313$(_context313) {
            while (1) {
              switch (_context313.prev = _context313.next) {
                case 0:
                  return _context313.abrupt("return", this._p2pConnection.createDataChannels(e, t));

                case 1:
                case "end":
                  return _context313.stop();
              }
            }
          }, _callee313, this);
        }));

        function createDataChannels(_x499, _x500) {
          return _createDataChannels3.apply(this, arguments);
        }

        return createDataChannels;
      }()
    }, {
      key: "stopDataChannels",
      value: function () {
        var _stopDataChannels3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee314(e) {
          return _regeneratorRuntime.wrap(function _callee314$(_context314) {
            while (1) {
              switch (_context314.prev = _context314.next) {
                case 0:
                  return _context314.abrupt("return", this._p2pConnection.stopDataChannels(e));

                case 1:
                case "end":
                  return _context314.stop();
              }
            }
          }, _callee314, this);
        }));

        function stopDataChannels(_x501) {
          return _stopDataChannels3.apply(this, arguments);
        }

        return stopDataChannels;
      }()
    }, {
      key: "receive",
      value: function () {
        var _receive5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee315(e, t, i, n) {
          return _regeneratorRuntime.wrap(function _callee315$(_context315) {
            while (1) {
              switch (_context315.prev = _context315.next) {
                case 0:
                  if (!this._nvMedia) {
                    _context315.next = 7;
                    break;
                  }

                  YC.debug("[DataChannelConnection] receive ".concat(e, " by DataChannel."));
                  _context315.next = 4;
                  return this._nvMedia.reveiveByRTCMedia(e, t, this.cname);

                case 4:
                  _context315.t0 = _context315.sent;
                  _context315.next = 11;
                  break;

                case 7:
                  YC.debug("[DataChannelConnection] receive ".concat(e, " by WebRTC."));
                  _context315.next = 10;
                  return this._p2pConnection.receive(e, t, i, n);

                case 10:
                  _context315.t0 = _context315.sent;

                case 11:
                  return _context315.abrupt("return", _context315.t0);

                case 12:
                case "end":
                  return _context315.stop();
              }
            }
          }, _callee315, this);
        }));

        function receive(_x502, _x503, _x504, _x505) {
          return _receive5.apply(this, arguments);
        }

        return receive;
      }()
    }, {
      key: "batchReceive",
      value: function () {
        var _batchReceive4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee316(e) {
          return _regeneratorRuntime.wrap(function _callee316$(_context316) {
            while (1) {
              switch (_context316.prev = _context316.next) {
                case 0:
                  _context316.t0 = _toConsumableArray;
                  _context316.next = 3;
                  return this._p2pConnection.batchReceive(e);

                case 3:
                  _context316.t1 = _context316.sent;
                  return _context316.abrupt("return", (0, _context316.t0)(_context316.t1));

                case 5:
                case "end":
                  return _context316.stop();
              }
            }
          }, _callee316, this);
        }));

        function batchReceive(_x506) {
          return _batchReceive4.apply(this, arguments);
        }

        return batchReceive;
      }()
    }, {
      key: "stopReceiving",
      value: function () {
        var _stopReceiving5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee317(e) {
          return _regeneratorRuntime.wrap(function _callee317$(_context317) {
            while (1) {
              switch (_context317.prev = _context317.next) {
                case 0:
                  _context317.next = 2;
                  return this._p2pConnection.stopReceiving(e);

                case 2:
                  return _context317.abrupt("return", _context317.sent);

                case 3:
                case "end":
                  return _context317.stop();
              }
            }
          }, _callee317, this);
        }));

        function stopReceiving(_x507) {
          return _stopReceiving5.apply(this, arguments);
        }

        return stopReceiving;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee318(e) {
          return _regeneratorRuntime.wrap(function _callee318$(_context318) {
            while (1) {
              switch (_context318.prev = _context318.next) {
                case 0:
                  _context318.next = 2;
                  return this._p2pConnection.muteRemote(e);

                case 2:
                  return _context318.abrupt("return", _context318.sent);

                case 3:
                case "end":
                  return _context318.stop();
              }
            }
          }, _callee318, this);
        }));

        function muteRemote(_x508) {
          return _muteRemote6.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee319(e) {
          return _regeneratorRuntime.wrap(function _callee319$(_context319) {
            while (1) {
              switch (_context319.prev = _context319.next) {
                case 0:
                  _context319.next = 2;
                  return this._p2pConnection.unmuteRemote(e);

                case 2:
                  return _context319.abrupt("return", _context319.sent);

                case 3:
                case "end":
                  return _context319.stop();
              }
            }
          }, _callee319, this);
        }));

        function unmuteRemote(_x509) {
          return _unmuteRemote6.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "muteLocal",
      value: function () {
        var _muteLocal6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee320(e) {
          return _regeneratorRuntime.wrap(function _callee320$(_context320) {
            while (1) {
              switch (_context320.prev = _context320.next) {
                case 0:
                  _context320.next = 2;
                  return this._p2pConnection.muteLocal(e);

                case 2:
                  return _context320.abrupt("return", _context320.sent);

                case 3:
                case "end":
                  return _context320.stop();
              }
            }
          }, _callee320, this);
        }));

        function muteLocal(_x510) {
          return _muteLocal6.apply(this, arguments);
        }

        return muteLocal;
      }()
    }, {
      key: "unmuteLocal",
      value: function () {
        var _unmuteLocal6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee321(e) {
          return _regeneratorRuntime.wrap(function _callee321$(_context321) {
            while (1) {
              switch (_context321.prev = _context321.next) {
                case 0:
                  _context321.next = 2;
                  return this._p2pConnection.unmuteLocal(e);

                case 2:
                  return _context321.abrupt("return", _context321.sent);

                case 3:
                case "end":
                  return _context321.stop();
              }
            }
          }, _callee321, this);
        }));

        function unmuteLocal(_x511) {
          return _unmuteLocal6.apply(this, arguments);
        }

        return unmuteLocal;
      }()
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee322() {
          return _regeneratorRuntime.wrap(function _callee322$(_context322) {
            while (1) {
              switch (_context322.prev = _context322.next) {
                case 0:
                  return _context322.delegateYield(Ck(zk(t._p2pConnection.restartICE(e))), "t0", 1);

                case 1:
                  return _context322.abrupt("return", _context322.t0);

                case 2:
                case "end":
                  return _context322.stop();
              }
            }
          }, _callee322);
        }))();
      }
    }, {
      key: "close",
      value: function close() {
        var e;
        null === (e = this._nvMedia) || void 0 === e || e.close(), this._p2pConnection.close(), this.unbindConnectionEvents(this._p2pConnection);
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return this._p2pConnection.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        return this._p2pConnection.getRemoteVideoIsReady(e);
      }
    }, {
      key: "updateRemoteConnect",
      value: function updateRemoteConnect(e) {
        var t;
        null === (t = this._nvMedia) || void 0 === t || t.setRemoteRtpCapabilities(e), this._p2pConnection.updateRemoteConnect(e);
      }
    }, {
      key: "updateEncoderConfig",
      value: function () {
        var _updateEncoderConfig5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee323(e, t) {
          return _regeneratorRuntime.wrap(function _callee323$(_context323) {
            while (1) {
              switch (_context323.prev = _context323.next) {
                case 0:
                  _context323.next = 2;
                  return this._p2pConnection.updateEncoderConfig(e, t);

                case 2:
                  return _context323.abrupt("return", _context323.sent);

                case 3:
                case "end":
                  return _context323.stop();
              }
            }
          }, _callee323, this);
        }));

        function updateEncoderConfig(_x512, _x513) {
          return _updateEncoderConfig5.apply(this, arguments);
        }

        return updateEncoderConfig;
      }()
    }, {
      key: "updateSendParameters",
      value: function () {
        var _updateSendParameters5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee324(e, t) {
          return _regeneratorRuntime.wrap(function _callee324$(_context324) {
            while (1) {
              switch (_context324.prev = _context324.next) {
                case 0:
                  _context324.next = 2;
                  return this._p2pConnection.updateSendParameters(e, t);

                case 2:
                  return _context324.abrupt("return", _context324.sent);

                case 3:
                case "end":
                  return _context324.stop();
              }
            }
          }, _callee324, this);
        }));

        function updateSendParameters(_x514, _x515) {
          return _updateSendParameters5.apply(this, arguments);
        }

        return updateSendParameters;
      }()
    }, {
      key: "setStatsRemoteVideoIsReady",
      value: function setStatsRemoteVideoIsReady(e, t) {
        this._p2pConnection.setStatsRemoteVideoIsReady(e, t);
      }
    }, {
      key: "replaceTrack",
      value: function () {
        var _replaceTrack6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee325(e, t) {
          return _regeneratorRuntime.wrap(function _callee325$(_context325) {
            while (1) {
              switch (_context325.prev = _context325.next) {
                case 0:
                  _context325.next = 2;
                  return this._p2pConnection.replaceTrack(e, t);

                case 2:
                  return _context325.abrupt("return", _context325.sent);

                case 3:
                case "end":
                  return _context325.stop();
              }
            }
          }, _callee325, this);
        }));

        function replaceTrack(_x516, _x517) {
          return _replaceTrack6.apply(this, arguments);
        }

        return replaceTrack;
      }()
    }, {
      key: "getRemoteSSRC",
      value: function () {
        var _getRemoteSSRC5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee326(e) {
          return _regeneratorRuntime.wrap(function _callee326$(_context326) {
            while (1) {
              switch (_context326.prev = _context326.next) {
                case 0:
                  return _context326.abrupt("return", this._p2pConnection.getRemoteSSRC(e));

                case 1:
                case "end":
                  return _context326.stop();
              }
            }
          }, _callee326, this);
        }));

        function getRemoteSSRC(_x518) {
          return _getRemoteSSRC5.apply(this, arguments);
        }

        return getRemoteSSRC;
      }()
    }, {
      key: "logSDPExchange",
      value: function logSDPExchange(e, t, i, n) {
        var _this266 = this;

        if (DC("SDP_LOGGING")) return YC.upload("exchanging ".concat(i, " ").concat(t, " SDP during DataChannelConnection.").concat(n, "\n"), e), "offer" === t ? function (e) {
          _this266.logSDPExchange(e, "answer", "local" === i ? "remote" : "local", n);
        } : void 0;
      }
    }, {
      key: "bindPCEvents",
      value: function bindPCEvents() {
        var _this267 = this;

        this._p2pConnection.onICEConnectionStateChange = function (e) {
          var t;
          return null === (t = _this267.onICEConnectionStateChange) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onConnectionStateChange = function (e) {
          var t;
          return null === (t = _this267.onConnectionStateChange) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onDTLSTransportStateChange = function (e) {
          var t;
          return null === (t = _this267.onDTLSTransportStateChange) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onDTLSTransportError = function (e) {
          var t;
          return null === (t = _this267.onDTLSTransportError) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onICETransportStateChange = function (e) {
          var t;
          return null === (t = _this267.onICETransportStateChange) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onFirstAudioReceived = function (e) {
          var t;
          return null === (t = _this267.onFirstAudioReceived) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onFirstVideoReceived = function (e) {
          var t;
          return null === (t = _this267.onFirstVideoReceived) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onFirstAudioDecoded = function (e) {
          var t;
          return null === (t = _this267.onFirstAudioDecoded) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onFirstVideoDecoded = function (e, t, i) {
          var n;
          return null === (n = _this267.onFirstVideoDecoded) || void 0 === n ? void 0 : n.call(_this267, e, t, i);
        }, this._p2pConnection.onFirstVideoDecodedTimeout = function (e) {
          var t;
          return null === (t = _this267.onFirstVideoDecodedTimeout) || void 0 === t ? void 0 : t.call(_this267, e);
        }, this._p2pConnection.onSelectedLocalCandidateChanged = function (e, t) {
          var i;
          return null === (i = _this267.onSelectedLocalCandidateChanged) || void 0 === i ? void 0 : i.call(_this267, e, t);
        }, this._p2pConnection.onSelectedRemoteCandidateChanged = function (e, t) {
          var i;
          return null === (i = _this267.onSelectedRemoteCandidateChanged) || void 0 === i ? void 0 : i.call(_this267, e, t);
        };
      }
    }, {
      key: "closeSignal",
      value: function closeSignal() {
        this.dataChannel.close(), this.peerConnection.close();
      }
    }, {
      key: "unbindConnectionEvents",
      value: function unbindConnectionEvents(e) {
        e.onConnectionStateChange = void 0, e.onICEConnectionStateChange = void 0, e.onICETransportStateChange = void 0, e.onDTLSTransportStateChange = void 0, e.onDTLSTransportError = void 0, e.onFirstAudioDecoded = void 0, e.onFirstAudioReceived = void 0, e.onFirstVideoDecoded = void 0, e.onFirstVideoReceived = void 0, e.onSelectedLocalCandidateChanged = void 0, e.onSelectedRemoteCandidateChanged = void 0, e.onFirstVideoDecodedTimeout = void 0;
      }
    }, {
      key: "setConfiguration",
      value: function setConfiguration(e) {
        this._p2pConnection.setConfiguration(e);
      }
    }], [{
      key: "resolvePCConfiguration",
      value: function resolvePCConfiguration(e) {
        var _t$iceServers7, _t$iceServers8;

        var t = {
          iceServers: []
        };
        return e.iceServers ? t.iceServers = e.iceServers : e.turnServer && "off" !== e.turnServer.mode && (_g(e.turnServer.servers) ? t.iceServers = e.turnServer.servers : (t.iceServers && (_t$iceServers7 = t.iceServers).push.apply(_t$iceServers7, _toConsumableArray(Qk.turnServerConfigToIceServers(e.turnServer.servers))), DC("USE_TURN_SERVER_OF_GATEWAY") && t.iceServers && e.turnServer.serversFromGateway && (_t$iceServers8 = t.iceServers).push.apply(_t$iceServers8, _toConsumableArray(Qk.turnServerConfigToIceServers(e.turnServer.serversFromGateway))), DC("FORCE_TURN_TCP") ? t.iceTransportPolicy = "relay" : e.turnServer.servers.concat(e.turnServer.serversFromGateway || []).forEach(function (e) {
          e.forceturn && (t.iceTransportPolicy = "relay");
        }))), t;
      }
    }, {
      key: "turnServerConfigToIceServers",
      value: function turnServerConfigToIceServers(e) {
        var t = [];
        return e.forEach(function (e) {
          e.security ? e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turns:".concat(Iy(e.turnServerURL), ":").concat(e.tcpport, "?transport=tcp")
          }) : (e.udpport && !DC("FORCE_TURN_TCP") && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.udpport, "?transport=udp")
          }), e.tcpport && t.push({
            username: e.username,
            credential: e.password,
            credentialType: "password",
            urls: "turn:".concat(e.turnServerURL, ":").concat(e.tcpport, "?transport=tcp")
          }));
        }), t;
      }
    }]);

    return Qk;
  }(Mv);

  function Zk(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee327() {
      var e,
          i,
          s,
          r,
          o,
          _args327 = arguments;
      return _regeneratorRuntime.wrap(function _callee327$(_context327) {
        while (1) {
          switch (_context327.prev = _context327.next) {
            case 0:
              e = this.mutex;
              _context327.next = 3;
              return e.lock("From DataChannelConnection.".concat(t));

            case 3:
              i = _context327.sent;
              _context327.prev = 4;

              for (s = _args327.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args327[o];
              }

              _context327.next = 8;
              return n.apply(this, r);

            case 8:
              return _context327.abrupt("return", _context327.sent);

            case 9:
              _context327.prev = 9;
              i();
              return _context327.finish(9);

            case 12:
            case "end":
              return _context327.stop();
          }
        }
      }, _callee327, this, [[4,, 9, 12]]);
    })), i;
  }

  function $k(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function eM(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? $k(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : $k(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  function tM(e) {
    var t,
        i,
        n,
        s = 2;

    for ("undefined" != typeof Symbol && (i = Ik, n = Symbol.iterator); s--;) {
      if (i && null != (t = e[i])) return t.call(e);
      if (n && null != (t = e[n])) return new iM(t.call(e));
      i = "@@asyncIterator", n = "@@iterator";
    }

    throw new TypeError("Object is not async iterable");
  }

  function iM(e) {
    function t(e) {
      if (Object(e) !== e) return tT.reject(new TypeError(e + " is not an object."));
      var t = e.done;
      return tT.resolve(e.value).then(function (e) {
        return {
          value: e,
          done: t
        };
      });
    }

    return iM = function iM(e) {
      this.s = e, this.n = e.next;
    }, iM.prototype = {
      s: null,
      n: null,
      next: function next() {
        return t(this.n.apply(this.s, arguments));
      },
      return: function _return(e) {
        var i = this.s.return;
        return void 0 === i ? tT.resolve({
          value: e,
          done: !0
        }) : t(i.apply(this.s, arguments));
      },
      throw: function _throw(e) {
        var i = this.s.return;
        return void 0 === i ? tT.reject(e) : t(i.apply(this.s, arguments));
      }
    }, new iM(e);
  }

  UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], Qk.prototype, "connect", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Array, Array]), xI("design:returntype", tT)], Qk.prototype, "updateRemoteRTPCapabilities", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Object, Array]), xI("design:returntype", tT)], Qk.prototype, "createDataChannels", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String, Array, String, Object]), xI("design:returntype", tT)], Qk.prototype, "receive", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Qk.prototype, "stopReceiving", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Qk.prototype, "muteRemote", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Qk.prototype, "unmuteRemote", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Qk.prototype, "muteLocal", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], Qk.prototype, "unmuteLocal", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], Qk.prototype, "close", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], Qk.prototype, "updateEncoderConfig", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String, _b]), xI("design:returntype", tT)], Qk.prototype, "updateSendParameters", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [_b, String]), xI("design:returntype", tT)], Qk.prototype, "replaceTrack", null), UI([Zk, xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], Qk.prototype, "getRemoteSSRC", null);

  var nM = /*#__PURE__*/function (_ig31) {
    _inherits(nM, _ig31);

    var _super66 = _createSuper(nM);

    function nM(e, t) {
      var _this268;

      _classCallCheck(this, nM);

      _this268 = _super66.call(this), nh(_assertThisInitialized(_this268), "store", void 0), nh(_assertThisInitialized(_this268), "statsUploader", void 0), nh(_assertThisInitialized(_this268), "connection", void 0), nh(_assertThisInitialized(_this268), "localTrackMap", new Map()), nh(_assertThisInitialized(_this268), "remoteUserMap", new Map()), nh(_assertThisInitialized(_this268), "localDataChannels", []), nh(_assertThisInitialized(_this268), "remoteDataChannelMap", new Map()), nh(_assertThisInitialized(_this268), "pendingLocalTracks", []), nh(_assertThisInitialized(_this268), "pendingRemoteTracks", []), nh(_assertThisInitialized(_this268), "pendingLocalDataChannels", []), nh(_assertThisInitialized(_this268), "pendingRemoteDataChannels", []), nh(_assertThisInitialized(_this268), "statsCollector", void 0), nh(_assertThisInitialized(_this268), "isPlanB", !1), nh(_assertThisInitialized(_this268), "shouldForwardP2PCreation", void 0), nh(_assertThisInitialized(_this268), "iceFailedCount", 0), nh(_assertThisInitialized(_this268), "dtlsFailedCount", 0), nh(_assertThisInitialized(_this268), "mutex", new Yg("P2PChannel-mutex")), nh(_assertThisInitialized(_this268), "_state", mv.Disconnected), nh(_assertThisInitialized(_this268), "_pcStatsUploadType", DC("NEW_ICE_RESTART") ? _v.FIRST_CONNECTION : _v.OLD_FIRST_CONNECTION), nh(_assertThisInitialized(_this268), "_isInRestartIce", !1), nh(_assertThisInitialized(_this268), "_isStartRestartIce", !1), nh(_assertThisInitialized(_this268), "_restartStates", ["disconnected", "failed"]), nh(_assertThisInitialized(_this268), "_restartTimer", void 0), nh(_assertThisInitialized(_this268), "_isFirstConnected", !0), nh(_assertThisInitialized(_this268), "handleMuteLocalTrack", /*#__PURE__*/function () {
        var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee328(e, t, i) {
          var n, _s88, _r58, _o46;

          return _regeneratorRuntime.wrap(function _callee328$(_context328) {
            while (1) {
              switch (_context328.prev = _context328.next) {
                case 0:
                  _context328.next = 2;
                  return _this268.mutex.lock("Locking from P2PChannel.handleMuteLocalTrack");

                case 2:
                  n = _context328.sent;
                  _context328.prev = 3;

                  if (!(!_this268.connection || _this268.state !== mv.Connected)) {
                    _context328.next = 6;
                    break;
                  }

                  return _context328.abrupt("return", void i(new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel.handleMuteLocalTrack before connection established.")));

                case 6:
                  _s88 = _this268.filterTobeMutedTracks(e);

                  if (!(0 === _s88.length)) {
                    _context328.next = 9;
                    break;
                  }

                  return _context328.abrupt("return", void t());

                case 9:
                  _r58 = _s88.find(function (e) {
                    return "videoLowTrack" === e[0];
                  });

                  if (_r58) {
                    _r58[1].track._originMediaStreamTrack.stop();
                  }

                  _context328.next = 13;
                  return _this268.connection.muteLocal(_s88.map(function (e) {
                    var _e309 = _slicedToArray(e, 2),
                        t = _e309[1].id;

                    return t;
                  }));

                case 13:
                  _o46 = _this268.createMuteMessage(_s88);
                  _context328.next = 16;
                  return Tg(_assertThisInitialized(_this268), fv.RequestMuteLocal, _o46);

                case 16:
                  t();
                  _context328.next = 22;
                  break;

                case 19:
                  _context328.prev = 19;
                  _context328.t0 = _context328["catch"](3);
                  i(_context328.t0);

                case 22:
                  _context328.prev = 22;
                  n();
                  return _context328.finish(22);

                case 25:
                case "end":
                  return _context328.stop();
              }
            }
          }, _callee328, null, [[3, 19, 22, 25]]);
        }));

        return function (_x519, _x520, _x521) {
          return _ref73.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this268), "handleUnmuteLocalTrack", /*#__PURE__*/function () {
        var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee329(e, t, i) {
          var n, _s89, _r59, _t281, _i143, _i144, _o47;

          return _regeneratorRuntime.wrap(function _callee329$(_context329) {
            while (1) {
              switch (_context329.prev = _context329.next) {
                case 0:
                  _context329.next = 2;
                  return _this268.mutex.lock("Locking from P2PChannel.handleUnmuteLocalTrack");

                case 2:
                  n = _context329.sent;
                  _context329.prev = 3;

                  if (!(!_this268.connection || _this268.state !== mv.Connected)) {
                    _context329.next = 6;
                    break;
                  }

                  return _context329.abrupt("return", void i(new VT(xT.INVALID_OPERATION, "Cannot call P2PChannel.handleUnmuteLocalTrack before connection established.")));

                case 6:
                  _s89 = _this268.filterTobeUnmutedTracks(e);

                  if (!(0 === _s89.length)) {
                    _context329.next = 9;
                    break;
                  }

                  return _context329.abrupt("return", void t());

                case 9:
                  _r59 = _s89.find(function (e) {
                    return "videoLowTrack" === e[0];
                  });

                  if (!_r59) {
                    _context329.next = 15;
                    break;
                  }

                  _t281 = _r59[1];

                  if (_t281.track._originMediaStreamTrack.stop(), !DC("DISABLE_DUAL_STREAM_USE_ENCODING") && wA().supportDualStreamEncoding) {
                    _i143 = e._mediaStreamTrack.clone();
                    _t281.track._mediaStreamTrack = _i143, _t281.track._originMediaStreamTrack = _i143;
                  } else {
                    _i144 = FL(e, Sg(_assertThisInitialized(_this268), fv.RequestLowStreamParameter));
                    _t281.track._mediaStreamTrack = _i144, _t281.track._originMediaStreamTrack = _i144;
                  }

                  _context329.next = 15;
                  return new tT(function (e, i) {
                    _this268.handleReplaceTrack(_t281.track, e, i, !0);
                  });

                case 15:
                  _context329.next = 17;
                  return _this268.connection.unmuteLocal(_s89.map(function (e) {
                    var _e310 = _slicedToArray(e, 2),
                        t = _e310[1].id;

                    return t;
                  }));

                case 17:
                  _o47 = _this268.createUnmuteMessage(_s89);
                  _context329.next = 20;
                  return Tg(_assertThisInitialized(_this268), fv.RequestUnmuteLocal, _o47);

                case 20:
                  t();
                  _context329.next = 26;
                  break;

                case 23:
                  _context329.prev = 23;
                  _context329.t0 = _context329["catch"](3);
                  i(_context329.t0);

                case 26:
                  _context329.prev = 26;
                  n();
                  return _context329.finish(26);

                case 29:
                case "end":
                  return _context329.stop();
              }
            }
          }, _callee329, null, [[3, 23, 26, 29]]);
        }));

        return function (_x522, _x523, _x524) {
          return _ref74.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this268), "handleUpdateVideoEncoder", /*#__PURE__*/function () {
        var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee330(e, t, i) {
          var n, _i145, _s90, _r60;

          return _regeneratorRuntime.wrap(function _callee330$(_context330) {
            while (1) {
              switch (_context330.prev = _context330.next) {
                case 0:
                  _context330.next = 2;
                  return _this268.mutex.lock("Locking from P2PChannel.handleSetVideoEncoder");

                case 2:
                  n = _context330.sent;
                  _context330.prev = 3;
                  _i145 = _this268.localTrackMap.get(Ev.LocalVideoTrack);

                  if (!(!_this268.connection || !_i145 || _i145.track !== e || _this268.state !== mv.Connected)) {
                    _context330.next = 7;
                    break;
                  }

                  return _context330.abrupt("return", void t());

                case 7:
                  _s90 = _i145.id, _r60 = _i145.track;
                  _context330.next = 10;
                  return _this268.connection.updateSendParameters(_s90, _r60);

                case 10:
                  _context330.next = 12;
                  return _this268.connection.updateEncoderConfig(_s90, _r60);

                case 12:
                  _this268.emit(fv.UpdateVideoEncoder, _r60);

                  t();
                  _context330.next = 19;
                  break;

                case 16:
                  _context330.prev = 16;
                  _context330.t0 = _context330["catch"](3);
                  i(_context330.t0);

                case 19:
                  _context330.prev = 19;
                  n();
                  return _context330.finish(19);

                case 22:
                case "end":
                  return _context330.stop();
              }
            }
          }, _callee330, null, [[3, 16, 19, 22]]);
        }));

        return function (_x525, _x526, _x527) {
          return _ref75.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this268), "handleSetOptimizationMode", /*#__PURE__*/function () {
        var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee331(e, t, i) {
          var n, _i146, _s91, _r61;

          return _regeneratorRuntime.wrap(function _callee331$(_context331) {
            while (1) {
              switch (_context331.prev = _context331.next) {
                case 0:
                  _context331.next = 2;
                  return _this268.mutex.lock("Locking from P2PChannel.handleSetOptimizationMode");

                case 2:
                  n = _context331.sent;
                  _context331.prev = 3;
                  _i146 = _this268.localTrackMap.get(Ev.LocalVideoTrack);

                  if (!(!_this268.connection || !_i146 || _i146.track !== e || _this268.state !== mv.Connected)) {
                    _context331.next = 7;
                    break;
                  }

                  return _context331.abrupt("return");

                case 7:
                  _s91 = _i146.id, _r61 = _i146.track;
                  _context331.next = 10;
                  return _this268.connection.updateSendParameters(_s91, _r61);

                case 10:
                  t();
                  _context331.next = 16;
                  break;

                case 13:
                  _context331.prev = 13;
                  _context331.t0 = _context331["catch"](3);
                  i(_context331.t0);

                case 16:
                  _context331.prev = 16;
                  n();
                  return _context331.finish(16);

                case 19:
                case "end":
                  return _context331.stop();
              }
            }
          }, _callee331, null, [[3, 13, 16, 19]]);
        }));

        return function (_x528, _x529, _x530) {
          return _ref76.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this268), "handleReplaceTrack", /*#__PURE__*/function () {
        var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee332(e, t, i, n) {
          var s, r, _i147, _t283, _t284, _i148, o;

          return _regeneratorRuntime.wrap(function _callee332$(_context332) {
            while (1) {
              switch (_context332.prev = _context332.next) {
                case 0:
                  YC.debug("[".concat(_this268.store.clientId, "] P2PChannel handleReplaceTrack for [track-id-").concat(e.getTrackId(), "]"));
                  _context332.t0 = "boolean" == typeof n && n;

                  if (_context332.t0) {
                    _context332.next = 6;
                    break;
                  }

                  _context332.next = 5;
                  return _this268.mutex.lock("From P2PChannel.handleReplaceTrack");

                case 5:
                  s = _context332.sent;

                case 6:
                  _context332.prev = 6;
                  _i147 = Array.from(_this268.localTrackMap.entries()).find(function (t) {
                    var _t282 = _slicedToArray(t, 2),
                        i = _t282[1].track;

                    return e === i;
                  });

                  if (!(!_this268.connection || !_i147 || _this268.state !== mv.Connected)) {
                    _context332.next = 10;
                    break;
                  }

                  return _context332.abrupt("return", void t());

                case 10:
                  _context332.next = 12;
                  return null === (r = _this268.connection) || void 0 === r ? void 0 : r.replaceTrack(e, _i147[1].id);

                case 12:
                  if (!_this268.isPlanB) {
                    _context332.next = 15;
                    break;
                  }

                  _t283 = _i147[1];
                  _t283.id = e._mediaStreamTrack.id, _this268.localTrackMap.set(_i147[0], _t283);

                case 15:
                  if (!(_i147[0] === Ev.LocalVideoTrack && !DC("DISABLE_DUAL_STREAM_USE_ENCODING") && wA().supportDualStreamEncoding)) {
                    _context332.next = 24;
                    break;
                  }

                  _t284 = _this268.localTrackMap.get(Ev.LocalVideoLowTrack);

                  if (!_t284) {
                    _context332.next = 24;
                    break;
                  }

                  _i148 = e._mediaStreamTrack.clone();

                  _t284.track._originMediaStreamTrack.stop();

                  _t284.track._mediaStreamTrack = _i148;
                  _t284.track._originMediaStreamTrack = _i148;
                  _context332.next = 24;
                  return new tT(function (e, i) {
                    _this268.handleReplaceTrack(_t284.track, e, i, !0);
                  });

                case 24:
                  t();
                  _context332.next = 30;
                  break;

                case 27:
                  _context332.prev = 27;
                  _context332.t1 = _context332["catch"](6);
                  i(_context332.t1);

                case 30:
                  _context332.prev = 30;
                  null === (o = s) || void 0 === o || o();
                  return _context332.finish(30);

                case 33:
                case "end":
                  return _context332.stop();
              }
            }
          }, _callee332, null, [[6, 27, 30, 33]]);
        }));

        return function (_x531, _x532, _x533, _x534) {
          return _ref77.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this268), "handleGetRTCStats", function (e) {
        e(_this268.statsCollector.getRTCStats());
      }), nh(_assertThisInitialized(_this268), "handleGetLocalVideoStats", function (e) {
        e(_this268.statsCollector.getLocalVideoTrackStats());
      }), nh(_assertThisInitialized(_this268), "handleGetLocalAudioStats", function (e) {
        e(_this268.statsCollector.getLocalAudioTrackStats());
      }), nh(_assertThisInitialized(_this268), "handleGetRemoteVideoStats", function (e) {
        return _this268.statsCollector.getRemoteVideoTrackStats(e.uid)[e.uid];
      }), nh(_assertThisInitialized(_this268), "handleGetRemoteAudioStats", function (e) {
        return _this268.statsCollector.getRemoteAudioTrackStats(e.uid)[e.uid];
      }), _this268.store = e, _this268.statsCollector = t, _this268.statsCollector.addP2PChannel(_assertThisInitialized(_this268)), _this268.statsUploader = new tk(_this268.store), _this268.bindStatsUploaderEvents(), _this268.isPlanB = !wA().supportUnifiedPlan || DC("CHROME_FORCE_PLAN_B") && kT(), _this268.shouldForwardP2PCreation = DC("FORWARD_P2P_CREATION") && wA().supportPCSetConfiguration && function () {
        var e = _T();

        return e === aT.ANDROID || e === aT.IOS || e === aT.HARMONY_OS;
      }(), _this268.shouldForwardP2PCreation && (_this268.connection = _this268.store.useDataChannel ? new Qk({}, _this268.store) : _this268.isPlanB ? new wk({}, _this268.store) : new Uk({}, _this268.store), _this268.bindConnectionEvents(_this268.connection));
      return _this268;
    }

    _createClass(nM, [{
      key: "state",
      get: function get() {
        return this._state;
      },
      set: function set(e) {
        var t = this._state;
        this._state = e, this.emit(fv.StateChange, t, this._state);
      }
    }, {
      key: "startP2PConnection",
      value: function () {
        var _startP2PConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee333(e, t) {
          var i, n;
          return _regeneratorRuntime.wrap(function _callee333$(_context333) {
            while (1) {
              switch (_context333.prev = _context333.next) {
                case 0:
                  this.state = mv.New;
                  n = this.shouldForwardP2PCreation && "closed" === (null === (i = this.connection) || void 0 === i ? void 0 : i.peerConnectionState);

                  if (!(this.shouldForwardP2PCreation && !n || (n && this.connection && (YC.warning("[".concat(this.store.clientId, "] P2PChannel.startP2PConnection ForwardP2P closed.")), this.connection.close(), this.unbindConnectionEvents(this.connection)), this.connection = this.store.useDataChannel ? new Qk(e, this.store) : this.isPlanB ? new wk(e, this.store) : new Uk(e, this.store), this.bindConnectionEvents(this.connection)), !this.connection)) {
                    _context333.next = 4;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel.startConnection before P2PConnection initialization .");

                case 4:
                  return _context333.abrupt("return", (this._pcStatsUploadType = DC("NEW_ICE_RESTART") ? _v.FIRST_CONNECTION : _v.OLD_FIRST_CONNECTION, this._isFirstConnected = !0, this._isInRestartIce = !1, this._isStartRestartIce = !1, this.connection.setConfiguration(e), this.connection.establishPromise));

                case 5:
                case "end":
                  return _context333.stop();
              }
            }
          }, _callee333, this);
        }));

        function startP2PConnection(_x535, _x536) {
          return _startP2PConnection2.apply(this, arguments);
        }

        return startP2PConnection;
      }()
    }, {
      key: "connect",
      value: function () {
        var _connect10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee334(e, t, i, n, s, r) {
          return _regeneratorRuntime.wrap(function _callee334$(_context334) {
            while (1) {
              switch (_context334.prev = _context334.next) {
                case 0:
                  if (this.connection) {
                    _context334.next = 2;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel.connect before P2PChannel.startP2PConnection .");

                case 2:
                  if (!(this.connection instanceof Qk)) {
                    _context334.next = 6;
                    break;
                  }

                  this.connection.updateRemoteConnect(n);
                  _context334.next = 12;
                  break;

                case 6:
                  this.store.peerConnectionStart();
                  _context334.next = 9;
                  return this.connection.connect(e, t, i, n, s, r);

                case 9:
                  this.statsUploader.startUploadTransportStats();
                  this.statsUploader.startUploadExtensionUsageStats();
                  this.state = mv.Connected;

                case 12:
                case "end":
                  return _context334.stop();
              }
            }
          }, _callee334, this);
        }));

        function connect(_x537, _x538, _x539, _x540, _x541, _x542) {
          return _connect10.apply(this, arguments);
        }

        return connect;
      }()
    }, {
      key: "updateRemoteRTPCapabilities",
      value: function updateRemoteRTPCapabilities(e) {
        var t = Array.from(this.localTrackMap.entries()).filter(function (e) {
          var t;

          var _e311 = _slicedToArray(e, 1),
              i = _e311[0];

          return bn(t = [Ev.LocalVideoLowTrack, Ev.LocalVideoTrack]).call(t, i);
        }),
            i = t.map(function (e) {
          var _e312 = _slicedToArray(e, 2),
              t = _e312[1].id;

          return t;
        }),
            n = t.map(function (e) {
          var _e313 = _slicedToArray(e, 1),
              t = _e313[0];

          return t;
        });

        if (this.connection instanceof Uk) {
          if (rI.updateRemoteRTPCapabilities(this.store.sessionId, {
            trackTypes: JSON.stringify(n),
            localCodecs: JSON.stringify(this.connection.localCodecs),
            remoteCodecs: JSON.stringify(e)
          }), !bn(e).call(e, this.store.codec)) {
            var _t285 = ["vp8", "h264"].find(function (t) {
              return bn(e).call(e, t);
            });

            _t285 && (this.store.codec = _t285, YC.debug("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, " updateRemoteRTPCapabilities] default codec is not available, hence the fallback to ").concat(_t285, ".")));
          }

          this.connection.updateRemoteRTPCapabilities(i, e);
        }
      }
    }, {
      key: "preConnect",
      value: function () {
        var _preConnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee335(e, t, i, n, s, r) {
          var o;
          return _regeneratorRuntime.wrap(function _callee335$(_context335) {
            while (1) {
              switch (_context335.prev = _context335.next) {
                case 0:
                  if (this.connection) {
                    _context335.next = 2;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot P2PChannel.connect before P2PChannel.startP2PConnection .");

                case 2:
                  this.store.peerConnectionStart();
                  _context335.next = 5;
                  return this.connection.connect(e, t, i, n, s, r);

                case 5:
                  o = _context335.sent;
                  return _context335.abrupt("return", (this.statsUploader.startUploadTransportStats(), this.statsUploader.startUploadExtensionUsageStats(), this.state = mv.Connected, o));

                case 7:
                case "end":
                  return _context335.stop();
              }
            }
          }, _callee335, this);
        }));

        function preConnect(_x543, _x544, _x545, _x546, _x547, _x548) {
          return _preConnect2.apply(this, arguments);
        }

        return preConnect;
      }()
    }, {
      key: "getEstablishParams",
      value: function getEstablishParams() {
        if (this.connection instanceof Qk) return this.connection.getP2PConnectionParams();
        throw new Error("Only DataChannelConnection needs to obtain establishParams");
      }
    }, {
      key: "publishDataChannel",
      value: function () {
        var _publishDataChannel3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee336(e) {
          var _this269 = this;

          var _t286, t;

          return _regeneratorRuntime.wrap(function _callee336$(_context336) {
            while (1) {
              switch (_context336.prev = _context336.next) {
                case 0:
                  if (this.connection) {
                    _context336.next = 5;
                    break;
                  }

                  if (!(this.state === mv.Disconnected)) {
                    _context336.next = 3;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "PeerConnection already disconnected.");

                case 3:
                  _t286 = e.filter(function (e) {
                    return -1 !== _this269.pendingLocalDataChannels.findIndex(function (t) {
                      return t.id === e.id;
                    });
                  });
                  return _context336.abrupt("return", void (this.pendingLocalDataChannels = this.pendingLocalDataChannels.concat(_t286)));

                case 5:
                  t = this.filterTobePublishedDataChannels(e);
                  _context336.t0 = 0 !== t.length;

                  if (!_context336.t0) {
                    _context336.next = 12;
                    break;
                  }

                  t.forEach(function (e) {
                    var t = Date.now();

                    _this269.store.publish(e.id.toString(), "datachannel", t);
                  });
                  _context336.next = 11;
                  return this.connection.createDataChannels(this.store.uid, t);

                case 11:
                  t.forEach(function (e) {
                    _this269.localDataChannels.push(e);

                    var t = Date.now();

                    _this269.store.publish(e.id + "", "datachannel", void 0, t);
                  });

                case 12:
                case "end":
                  return _context336.stop();
              }
            }
          }, _callee336, this);
        }));

        function publishDataChannel(_x549) {
          return _publishDataChannel3.apply(this, arguments);
        }

        return publishDataChannel;
      }()
    }, {
      key: "publish",
      value: function publish(e, t, i) {
        var n = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee337() {
          var s, _t287, _r62;

          return _regeneratorRuntime.wrap(function _callee337$(_context337) {
            while (1) {
              switch (_context337.prev = _context337.next) {
                case 0:
                  _context337.next = 2;
                  return SP(n.mutex.lock("From P2PChannel.publish"));

                case 2:
                  s = _context337.sent;
                  _context337.prev = 3;

                  if (!(!n.connection || n.state !== mv.Connected)) {
                    _context337.next = 10;
                    break;
                  }

                  if (!(n.state === mv.Disconnected)) {
                    _context337.next = 7;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "PeerConnection already disconnected.");

                case 7:
                  n.throwIfTrackTypeNotMatch(e);
                  _t287 = e.filter(function (e) {
                    return -1 === n.pendingLocalTracks.indexOf(e);
                  });
                  return _context337.abrupt("return", void (n.pendingLocalTracks = n.pendingLocalTracks.concat(_t287)));

                case 10:
                  n.store.pubId = n.store.pubId + 1, TP.markPublishStart(n.store.clientId, n.store.pubId);
                  _r62 = n.filterTobePublishedTracks(e, t, i);

                  if (!(0 === _r62.length)) {
                    _context337.next = 16;
                    break;
                  }

                  _context337.next = 15;
                  return SP(n.tryToUnmuteAudio(e));

                case 15:
                  return _context337.abrupt("return", void _context337.sent);

                case 16:
                  return _context337.delegateYield(Ck(tM(n.doPublish(n.connection, _r62))), "t0", 17);

                case 17:
                  _context337.prev = 17;
                  s();
                  return _context337.finish(17);

                case 20:
                case "end":
                  return _context337.stop();
              }
            }
          }, _callee337, null, [[3,, 17, 20]]);
        }))();
      }
    }, {
      key: "doPublish",
      value: function doPublish(e, t) {
        var i = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee338() {
          var n, s, r, o, a, c;
          return _regeneratorRuntime.wrap(function _callee338$(_context338) {
            while (1) {
              switch (_context338.prev = _context338.next) {
                case 0:
                  t.forEach(function (e) {
                    var t = e.track,
                        n = e.type;
                    var s = Date.now();
                    i.store.publish(t.getTrackId(), n === Ev.LocalAudioTrack ? "audio" : "video", s);
                  }), i.bindLocalTrackEvents(t);
                  _context338.next = 3;
                  return SP(e.send(t.map(function (e) {
                    var t = e.track;
                    return t;
                  }), i.store.codec, i.store.audioCodec));

                case 3:
                  n = _context338.sent;
                  _context338.next = 6;
                  return SP(n.next());

                case 6:
                  s = _context338.sent.value;
                  r = i.createGatewayPublishMessage(t, s);
                  _context338.prev = 8;
                  _context338.next = 11;
                  return r;

                case 11:
                  o = _context338.sent;
                  _context338.next = 17;
                  break;

                case 14:
                  _context338.prev = 14;
                  _context338.t0 = _context338["catch"](8);
                  throw n.throw(_context338.t0), (null == _context338.t0 ? void 0 : _context338.t0.code) === xT.WS_ABORT && t.forEach(function (e) {
                    var t = e.track;
                    -1 === i.pendingLocalTracks.indexOf(t) && i.pendingLocalTracks.push(t);
                  }), i.unbindLocalTrackEvents(t), _context338.t0;

                case 17:
                  a = i.mapPubResToRemoteConfig(r, o);
                  _context338.next = 20;
                  return SP(n.next(a));

                case 20:
                  c = _context338.sent.value;
                  t.forEach(function (e) {
                    var t = e.type;
                    i.statsCollector.addLocalStats(t);
                  }), i.assignLocalTracks(t, c), i.statsUploader.startUploadOutboundStats(), t.forEach(function (e) {
                    var t = e.track,
                        n = e.type;
                    var s = Date.now();
                    i.store.publish(t.getTrackId(), n === Ev.LocalAudioTrack ? "audio" : "video", void 0, s);
                  });

                case 22:
                case "end":
                  return _context338.stop();
              }
            }
          }, _callee338, null, [[8, 14]]);
        }))();
      }
    }, {
      key: "updateVideoStreamParameter",
      value: function () {
        var _updateVideoStreamParameter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee339(e, t) {
          var i, n, s, _t288;

          return _regeneratorRuntime.wrap(function _callee339$(_context339) {
            while (1) {
              switch (_context339.prev = _context339.next) {
                case 0:
                  i = this.localTrackMap.get(t);

                  if (i) {
                    _context339.next = 3;
                    break;
                  }

                  return _context339.abrupt("return");

                case 3:
                  if (i.track instanceof Nw) {
                    _context339.next = 5;
                    break;
                  }

                  return _context339.abrupt("return", YC.warn("[updateVideoStreamParameter]: track is not an instance of LocalVideoTrack"));

                case 5:
                  if (this.connection instanceof Uk || this.connection instanceof wk) {
                    _context339.next = 7;
                    break;
                  }

                  return _context339.abrupt("return", YC.warn("[updateVideoStreamParameter]: connection is not P2PConnection or P2PConnectionPlanB"));

                case 7:
                  n = i.track, s = function (e, t) {
                    var i = {};
                    return e.height && e.width && (i.scaleResolutionDownBy = Ny(e, t)), i.maxFramerate = e.framerate ? yy(e.framerate) : void 0, i.maxBitrate = e.bitrate ? 1e3 * e.bitrate : void 0, i;
                  }(e, n);

                  if (!(n._encoderConfig || (n._encoderConfig = {}), t !== Ev.LocalVideoLowTrack || !DC("DISABLE_DUAL_STREAM_USE_ENCODING") && wA().supportDualStreamEncoding)) {
                    _context339.next = 12;
                    break;
                  }

                  null != s.scaleResolutionDownBy && (n._encoderConfig.scaleResolutionDownBy = s.scaleResolutionDownBy);
                  _context339.next = 16;
                  break;

                case 12:
                  _t288 = n._originMediaStreamTrack;

                  if (_t288.canvas) {
                    _context339.next = 15;
                    break;
                  }

                  return _context339.abrupt("return", YC.warn("[".concat(n.getTrackId(), "] no canvas on track")));

                case 15:
                  !function (e, t) {
                    var i = e.canvas;
                    t.width && (i.width = yy(t.width)), t.height && (i.height = yy(t.height)), t.framerate && (i.stopCapture && i.stopCapture(), i.stopCapture = vb(function () {
                      !i.startCapture && i.stopCapture && i.stopCapture(), i.startCapture && i.startCapture();
                    }, yy(t.framerate)));
                  }(_t288, e);

                case 16:
                  null != s.maxBitrate && (n._encoderConfig.bitrateMax = s.maxBitrate / 1e3);
                  null != s.maxFramerate && (n._encoderConfig.frameRate && "object" == _typeof(n._encoderConfig.frameRate) ? n._encoderConfig.frameRate.max = s.maxFramerate : n._encoderConfig.frameRate = {
                    max: s.maxFramerate
                  });
                  YC.debug("[".concat(n.getTrackId(), "] LowStreamEncoderConfig: , ").concat(JSON.stringify(n._encoderConfig)));
                  _context339.next = 21;
                  return this.connection.updateRtpSenderEncodings(n);

                case 21:
                case "end":
                  return _context339.stop();
              }
            }
          }, _callee339, this);
        }));

        function updateVideoStreamParameter(_x550, _x551) {
          return _updateVideoStreamParameter2.apply(this, arguments);
        }

        return updateVideoStreamParameter;
      }()
    }, {
      key: "publishLowStream",
      value: function publishLowStream(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee340() {
          var i, _s92, _r63, n, _e314;

          return _regeneratorRuntime.wrap(function _callee340$(_context340) {
            while (1) {
              switch (_context340.prev = _context340.next) {
                case 0:
                  if (!(!t.connection || t.state !== mv.Connected)) {
                    _context340.next = 2;
                    break;
                  }

                  return _context340.abrupt("return");

                case 2:
                  _context340.next = 4;
                  return SP(t.mutex.lock("Locking from P2PChannel.publishLowStream"));

                case 4:
                  i = _context340.sent;
                  _context340.prev = 5;
                  _s92 = t.localTrackMap.get(Ev.LocalVideoTrack);

                  if (_s92) {
                    _context340.next = 9;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Could not find high stream");

                case 9:
                  if (!t.localTrackMap.has(Ev.LocalVideoLowTrack)) {
                    _context340.next = 11;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "[".concat(t.store.clientId, "] Can't publish low stream when stream already publish"));

                case 11:
                  _r63 = [{
                    track: t.getLowVideoTrack(_s92.track, e),
                    type: Ev.LocalVideoLowTrack
                  }];
                  return _context340.delegateYield(Ck(tM(t.doPublish(t.connection, _r63))), "t0", 13);

                case 13:
                  if (!(_s92.track.muted || !_s92.track.enabled)) {
                    _context340.next = 19;
                    break;
                  }

                  _e314 = null === (n = t.localTrackMap.get(Ev.LocalVideoLowTrack)) || void 0 === n ? void 0 : n.id;
                  _context340.t1 = void 0 !== _e314;

                  if (!_context340.t1) {
                    _context340.next = 19;
                    break;
                  }

                  _context340.next = 19;
                  return SP(t.connection.muteLocal([_e314]));

                case 19:
                  _context340.prev = 19;
                  i();
                  return _context340.finish(19);

                case 22:
                case "end":
                  return _context340.stop();
              }
            }
          }, _callee340, null, [[5,, 19, 22]]);
        }))();
      }
    }, {
      key: "republish",
      value: function () {
        var _republish2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee341() {
          return _regeneratorRuntime.wrap(function _callee341$(_context341) {
            while (1) {
              switch (_context341.prev = _context341.next) {
                case 0:
                  _context341.t0 = this.pendingLocalTracks.length > 0;

                  if (!_context341.t0) {
                    _context341.next = 7;
                    break;
                  }

                  YC.debug("[".concat(this.store.clientId, "] Emit P2PChannelEvents.RequestRePublish to republish tracks."));
                  _context341.next = 5;
                  return fg(this, fv.RequestRePublish, this.pendingLocalTracks);

                case 5:
                  this.emit(fv.MediaReconnectEnd, this.store.uid);
                  this.pendingLocalTracks = [];

                case 7:
                  _context341.t1 = this.pendingLocalDataChannels.length > 0;

                  if (!_context341.t1) {
                    _context341.next = 13;
                    break;
                  }

                  YC.debug("Emit P2PChannelEvents.RequestRePublishDataChannel to republish datachannels.");
                  _context341.next = 12;
                  return fg(this, fv.RequestRePublishDataChannel, this.pendingLocalDataChannels);

                case 12:
                  this.pendingLocalDataChannels = [];

                case 13:
                case "end":
                  return _context341.stop();
              }
            }
          }, _callee341, this);
        }));

        function republish() {
          return _republish2.apply(this, arguments);
        }

        return republish;
      }()
    }, {
      key: "reSubscribe",
      value: function () {
        var _reSubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee342(e) {
          var _this270 = this;

          var _e315, _this$pendingRemoteTr, _t289, i, _iterator37, _step37, _step37$value, _e316, _t290;

          return _regeneratorRuntime.wrap(function _callee342$(_context342) {
            while (1) {
              switch (_context342.prev = _context342.next) {
                case 0:
                  for (_e315 = this.pendingRemoteTracks.length - 1; _e315 >= 0; _e315--) {
                    _this$pendingRemoteTr = this.pendingRemoteTracks[_e315], _t289 = _this$pendingRemoteTr.user, i = _this$pendingRemoteTr.kind;
                    (i !== hv.AUDIO || _t289._audio_added_ && _t289._audioSSRC) && (i !== hv.VIDEO || _t289._video_added_ && _t289._videoSSRC) || this.pendingRemoteTracks.splice(_e315, 1);
                  }

                  if (!e) {
                    _context342.next = 6;
                    break;
                  }

                  _context342.next = 4;
                  return fg(this, fv.RequestReSubscribe, this.pendingRemoteTracks);

                case 4:
                  _context342.next = 23;
                  break;

                case 6:
                  _iterator37 = _createForOfIteratorHelper(this.pendingRemoteTracks);
                  _context342.prev = 7;

                  _iterator37.s();

                case 9:
                  if ((_step37 = _iterator37.n()).done) {
                    _context342.next = 15;
                    break;
                  }

                  _step37$value = _step37.value, _e316 = _step37$value.user, _t290 = _step37$value.kind;
                  _context342.next = 13;
                  return this.subscribe(_e316, _t290, _t290 === hv.VIDEO ? _e316._videoSSRC : _e316._audioSSRC);

                case 13:
                  _context342.next = 9;
                  break;

                case 15:
                  _context342.next = 20;
                  break;

                case 17:
                  _context342.prev = 17;
                  _context342.t0 = _context342["catch"](7);

                  _iterator37.e(_context342.t0);

                case 20:
                  _context342.prev = 20;

                  _iterator37.f();

                  return _context342.finish(20);

                case 23:
                  this.pendingRemoteTracks.forEach(function (e) {
                    var t = e.user;

                    _this270.emit(fv.MediaReconnectEnd, t.uid);
                  }), this.pendingRemoteTracks = [];

                case 24:
                case "end":
                  return _context342.stop();
              }
            }
          }, _callee342, this, [[7, 17, 20, 23]]);
        }));

        function reSubscribe(_x552) {
          return _reSubscribe2.apply(this, arguments);
        }

        return reSubscribe;
      }()
    }, {
      key: "unpublish",
      value: function () {
        var _unpublish3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee343(e) {
          var _this271 = this;

          var t, i;
          return _regeneratorRuntime.wrap(function _callee343$(_context343) {
            while (1) {
              switch (_context343.prev = _context343.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context343.next = 2;
                    break;
                  }

                  return _context343.abrupt("return", void e.forEach(function (e) {
                    var t = _this271.pendingLocalTracks.indexOf(e);

                    -1 !== t && _this271.pendingLocalTracks.splice(t, 1);
                  }));

                case 2:
                  t = this.filterTobeUnpublishedTracks(e);

                  if (!(0 === t.length)) {
                    _context343.next = 5;
                    break;
                  }

                  return _context343.abrupt("return");

                case 5:
                  i = t.find(function (e) {
                    return "videoLowTrack" === e[0];
                  });

                  if (i) {
                    i[1].track.close();
                  }

                  return _context343.abrupt("return", this.doUnpublish(this.connection, t));

                case 8:
                case "end":
                  return _context343.stop();
              }
            }
          }, _callee343, this);
        }));

        function unpublish(_x553) {
          return _unpublish3.apply(this, arguments);
        }

        return unpublish;
      }()
    }, {
      key: "unpublishDataChannel",
      value: function () {
        var _unpublishDataChannel3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee344(e) {
          var _this272 = this;

          var t;
          return _regeneratorRuntime.wrap(function _callee344$(_context344) {
            while (1) {
              switch (_context344.prev = _context344.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context344.next = 2;
                    break;
                  }

                  return _context344.abrupt("return", void e.forEach(function (e) {
                    var t = _this272.pendingLocalDataChannels.indexOf(e);

                    -1 !== t && _this272.pendingLocalDataChannels.splice(t, 1);
                  }));

                case 2:
                  t = this.filterTobeUnpublishedDataChannels(e);

                  if (!(0 !== t.length)) {
                    _context344.next = 12;
                    break;
                  }

                  t.forEach(function (e) {
                    var t = _this272.localDataChannels.indexOf(e);

                    -1 !== t && _this272.localDataChannels.splice(t, 1);
                  });
                  _context344.t1 = 0 === this.localDataChannels.length;

                  if (!_context344.t1) {
                    _context344.next = 9;
                    break;
                  }

                  _context344.next = 9;
                  return this.connection.stopDataChannels(this.store.uid);

                case 9:
                  _context344.t0 = t.map(function (e) {
                    return e.id;
                  });
                  _context344.next = 13;
                  break;

                case 12:
                  _context344.t0 = void 0;

                case 13:
                  return _context344.abrupt("return", _context344.t0);

                case 14:
                case "end":
                  return _context344.stop();
              }
            }
          }, _callee344, this);
        }));

        function unpublishDataChannel(_x554) {
          return _unpublishDataChannel3.apply(this, arguments);
        }

        return unpublishDataChannel;
      }()
    }, {
      key: "unpublishLowStream",
      value: function () {
        var _unpublishLowStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee345() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee345$(_context345) {
            while (1) {
              switch (_context345.prev = _context345.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context345.next = 2;
                    break;
                  }

                  return _context345.abrupt("return");

                case 2:
                  e = this.localTrackMap.get(Ev.LocalVideoLowTrack);

                  if (e) {
                    _context345.next = 5;
                    break;
                  }

                  return _context345.abrupt("return");

                case 5:
                  e.track.close();
                  t = [[Ev.LocalVideoLowTrack, e]];
                  return _context345.abrupt("return", this.doUnpublish(this.connection, t));

                case 8:
                case "end":
                  return _context345.stop();
              }
            }
          }, _callee345, this);
        }));

        function unpublishLowStream() {
          return _unpublishLowStream2.apply(this, arguments);
        }

        return unpublishLowStream;
      }()
    }, {
      key: "doUnpublish",
      value: function () {
        var _doUnpublish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee346(e, t) {
          var _this273 = this;

          var i;
          return _regeneratorRuntime.wrap(function _callee346$(_context346) {
            while (1) {
              switch (_context346.prev = _context346.next) {
                case 0:
                  i = this.createGatewayUnpublishMessage(t);
                  _context346.next = 3;
                  return e.stopSending(t.map(function (e) {
                    var _e317 = _slicedToArray(e, 2),
                        t = _e317[1].id;

                    return t;
                  }));

                case 3:
                  this.withdrawLocalTracks(t);
                  this.unbindLocalTrackEvents(t.map(function (e) {
                    var _e318 = _slicedToArray(e, 2),
                        t = _e318[0],
                        i = _e318[1].track;

                    return {
                      type: t,
                      track: i
                    };
                  }));
                  t.forEach(function (e) {
                    var _e319 = _slicedToArray(e, 1),
                        t = _e319[0];

                    _this273.statsCollector.removeLocalStats(t);
                  });
                  0 === this.localTrackMap.size && this.statsUploader.stopUploadOutboundStats();
                  return _context346.abrupt("return", i);

                case 8:
                case "end":
                  return _context346.stop();
              }
            }
          }, _callee346, this);
        }));

        function doUnpublish(_x555, _x556) {
          return _doUnpublish.apply(this, arguments);
        }

        return doUnpublish;
      }()
    }, {
      key: "subscribeDataChannel",
      value: function () {
        var _subscribeDataChannel3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee347(e, t) {
          var _this274 = this;

          var i;
          return _regeneratorRuntime.wrap(function _callee347$(_context347) {
            while (1) {
              switch (_context347.prev = _context347.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context347.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot subscribe remote user when peerConnection disconnected.");

                case 2:
                  i = t.filter(function (t) {
                    var i;
                    return !(null !== (i = _this274.remoteDataChannelMap.get(e)) && void 0 !== i && i.get(t.id));
                  });

                  if (!(0 !== i.length)) {
                    _context347.next = 8;
                    break;
                  }

                  _context347.next = 6;
                  return this.connection.createDataChannels(e.uid, i);

                case 6:
                  i.forEach(function (t) {
                    var i;
                    _this274.remoteDataChannelMap.has(e) ? null === (i = _this274.remoteDataChannelMap.get(e)) || void 0 === i || i.set(t.id, t) : _this274.remoteDataChannelMap.set(e, new Map([[t.id, t]]));

                    var n = _this274.pendingRemoteDataChannels.findIndex(function (i) {
                      var n = i.user,
                          s = i.id;
                      return n.uid === e.uid && s === t.id;
                    });

                    -1 !== n && _this274.pendingRemoteDataChannels.splice(n, 1);
                  });
                  return _context347.abrupt("return", i.map(function (e) {
                    return e.id;
                  }));

                case 8:
                case "end":
                  return _context347.stop();
              }
            }
          }, _callee347, this);
        }));

        function subscribeDataChannel(_x557, _x558) {
          return _subscribeDataChannel3.apply(this, arguments);
        }

        return subscribeDataChannel;
      }()
    }, {
      key: "subscribe",
      value: function () {
        var _subscribe3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee348(e, t, i, n, s) {
          var r, o, a, c, _i149, _n137, _s93, d, l;

          return _regeneratorRuntime.wrap(function _callee348$(_context348) {
            while (1) {
              switch (_context348.prev = _context348.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context348.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot subscribe remote user when peerConnection disconnected.");

                case 2:
                  if (!(null !== (r = this.remoteUserMap.get(e)) && void 0 !== r && r.has(t))) {
                    _context348.next = 4;
                    break;
                  }

                  return _context348.abrupt("return");

                case 4:
                  if (!s) {
                    _context348.next = 14;
                    break;
                  }

                  _i149 = s.find(function (e) {
                    var i = e.stream_type;
                    return i === t;
                  });

                  if (_i149) {
                    _context348.next = 8;
                    break;
                  }

                  throw new VT(xT.UNEXPECTED_ERROR, "Cannot subscribe to remote ".concat(t, " for user: ").concat(e.uid, " because subscribe answer from gateway does not contain stream_type: ").concat(t, "."));

                case 8:
                  _context348.next = 10;
                  return this.connection.receive(t, _i149.ssrcs, String(e._uintid), _i149.attributes);

                case 10:
                  _n137 = _context348.sent;
                  this.connection instanceof Uk && (c = _n137.transceiver), o = _n137.track, a = _n137.id;
                  _context348.next = 18;
                  break;

                case 14:
                  _context348.next = 16;
                  return this.connection.receive(t, [{
                    ssrcId: i,
                    rtx: n
                  }], String(e._uintid), void 0);

                case 16:
                  _s93 = _context348.sent;
                  this.connection instanceof Uk && (c = _s93.transceiver), o = _s93.track, a = _s93.id;

                case 18:
                  t === hv.AUDIO ? (e._audioTrack ? e._audioTrack._updateOriginMediaStreamTrack(o) : (e._audioTrack = new Fw(o, e.uid, e._uintid, this.store), YC.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote audio track: ").concat(e._audioTrack.getTrackId()))), c && e._audioTrack._updateRtpTransceiver(c), this.bindRemoteTrackEvents(e, e._audioTrack)) : (e._videoTrack ? e._videoTrack._updateOriginMediaStreamTrack(o) : (e._videoTrack = new Vw(o, e.uid, e._uintid, this.store), YC.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote video track: ").concat(e._videoTrack.getTrackId()))), c && e._videoTrack._updateRtpTransceiver(c), this.bindRemoteTrackEvents(e, e._videoTrack));
                  d = this.remoteUserMap.get(e);
                  d ? d.set(t, a) : this.remoteUserMap.set(e, new Map([[t, a]])), this.statsCollector.addRemoteStats(e.uid), this.statsUploader.startUploadInboundStats();
                  l = this.pendingRemoteTracks.findIndex(function (i) {
                    var n = i.user,
                        s = i.kind;
                    return n.uid === e.uid && t === s;
                  });
                  -1 !== l && (this.pendingRemoteTracks.splice(l, 1), this.emit(fv.MediaReconnectEnd, e.uid));

                case 23:
                case "end":
                  return _context348.stop();
              }
            }
          }, _callee348, this);
        }));

        function subscribe(_x559, _x560, _x561, _x562, _x563) {
          return _subscribe3.apply(this, arguments);
        }

        return subscribe;
      }()
    }, {
      key: "massSubscribe",
      value: function () {
        var _massSubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee349(e) {
          return _regeneratorRuntime.wrap(function _callee349$(_context349) {
            while (1) {
              switch (_context349.prev = _context349.next) {
                case 0:
                  return _context349.abrupt("return", this.massSubscribeNoLock(e));

                case 1:
                case "end":
                  return _context349.stop();
              }
            }
          }, _callee349, this);
        }));

        function massSubscribe(_x564) {
          return _massSubscribe2.apply(this, arguments);
        }

        return massSubscribe;
      }()
    }, {
      key: "massSubscribeNoLock",
      value: function () {
        var _massSubscribeNoLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee350(e) {
          var _this275 = this;

          var t;
          return _regeneratorRuntime.wrap(function _callee350$(_context350) {
            while (1) {
              switch (_context350.prev = _context350.next) {
                case 0:
                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context350.next = 2;
                    break;
                  }

                  throw new VT(xT.INVALID_OPERATION, "Cannot subscribeAll remote users when peerConnection disconnected.");

                case 2:
                  e = e.filter(function (e) {
                    var t;
                    var i = e.user,
                        n = e.mediaType;
                    return !(null !== (t = _this275.remoteUserMap.get(i)) && void 0 !== t && t.has(n));
                  });
                  _context350.next = 5;
                  return this.connection.batchReceive(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType,
                        n = e.ssrcId,
                        s = e.rtxSsrcId;
                    return {
                      kind: i,
                      ssrcMsg: [{
                        ssrcId: n,
                        rtx: s
                      }],
                      mslabel: String(t._uintid)
                    };
                  }));

                case 5:
                  t = _context350.sent;
                  e.forEach(function (e, i) {
                    var n = e.user,
                        s = e.mediaType;
                    var _t$i = t[i],
                        r = _t$i.track,
                        o = _t$i.id,
                        a = _t$i.transceiver;
                    s === hv.AUDIO ? (n._audioTrack ? n._audioTrack._updateOriginMediaStreamTrack(r) : (n._audioTrack = new Fw(r, n.uid, n._uintid, _this275.store), YC.info("[".concat(_this275.store.clientId, "] [").concat(_this275.store.p2pId, "] create remote audio track: ").concat(n._audioTrack.getTrackId()))), a && n._audioTrack._updateRtpTransceiver(a), _this275.bindRemoteTrackEvents(n, n._audioTrack)) : (n._videoTrack ? n._videoTrack._updateOriginMediaStreamTrack(r) : (n._videoTrack = new Vw(r, n.uid, n._uintid, _this275.store), YC.info("[".concat(_this275.store.clientId, "] [").concat(_this275.store.p2pId, "] create remote video track: ").concat(n._videoTrack.getTrackId()))), a && n._videoTrack._updateRtpTransceiver(a), _this275.bindRemoteTrackEvents(n, n._videoTrack));

                    var c = _this275.remoteUserMap.get(n);

                    c ? c.set(s, o) : _this275.remoteUserMap.set(n, new Map([[s, o]])), _this275.statsCollector.addRemoteStats(n.uid), _this275.statsUploader.startUploadInboundStats();

                    var d = _this275.pendingRemoteTracks.findIndex(function (e) {
                      var t = e.user,
                          i = e.kind;
                      return t.uid === n.uid && s === i;
                    });

                    -1 !== d && (_this275.pendingRemoteTracks.splice(d, 1), _this275.emit(fv.MediaReconnectEnd, n.uid));
                  });

                case 7:
                case "end":
                  return _context350.stop();
              }
            }
          }, _callee350, this);
        }));

        function massSubscribeNoLock(_x565) {
          return _massSubscribeNoLock2.apply(this, arguments);
        }

        return massSubscribeNoLock;
      }()
    }, {
      key: "unsubscribe",
      value: function () {
        var _unsubscribe3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee351(e, t, i) {
          var _this276 = this;

          var n, s, r;
          return _regeneratorRuntime.wrap(function _callee351$(_context351) {
            while (1) {
              switch (_context351.prev = _context351.next) {
                case 0:
                  n = this.pendingRemoteTracks.filter(function (i) {
                    var n = i.user,
                        s = i.kind;
                    return void 0 !== t ? n.uid === e.uid && t === s : n.uid === e.uid;
                  });

                  if (!(n.forEach(function (e) {
                    var t = _this276.pendingRemoteTracks.indexOf(e);

                    _this276.pendingRemoteTracks.splice(t, 1);
                  }), this.connection && this.state === mv.Connected || i || n.forEach(function (t) {
                    var i = t.kind;
                    var n;
                    if (i === hv.AUDIO) null === (n = e._audioTrack) || void 0 === n || n._destroy(), e._audioTrack = void 0;else if (i === hv.VIDEO) {
                      var s;
                      null === (s = e._videoTrack) || void 0 === s || s._destroy(), e._videoTrack = void 0;
                    }
                  }), !this.connection || this.state !== mv.Connected)) {
                    _context351.next = 3;
                    break;
                  }

                  return _context351.abrupt("return");

                case 3:
                  s = this.filterTobeUnSubscribedTracks(e, t);

                  if (!(0 === s.length)) {
                    _context351.next = 6;
                    break;
                  }

                  return _context351.abrupt("return");

                case 6:
                  _context351.next = 8;
                  return this.connection.stopReceiving(s.map(function (e) {
                    var _e320 = _slicedToArray(e, 2),
                        t = _e320[1].id;

                    return t;
                  }));

                case 8:
                  r = this.createUnsubscribeMessage(s);
                  return _context351.abrupt("return", (this.withdrawRemoteTracks(s), 0 === this.remoteUserMap.size && this.statsUploader.stopUploadInboundStats(), s.forEach(function (e) {
                    var _e321 = _slicedToArray(e, 2),
                        t = _e321[0],
                        n = _e321[1].kind;

                    var s, r;
                    n === hv.VIDEO && t._videoSSRC && (null === (s = _this276.connection) || void 0 === s || s.setStatsRemoteVideoIsReady(t._videoSSRC, !1));
                    if (n === hv.VIDEO) _this276.unbindRemoteTrackEvents(t._videoTrack), i || (null === (r = t._videoTrack) || void 0 === r || r._destroy(), t._videoTrack = void 0);else if (n === hv.AUDIO) {
                      var o;
                      if (_this276.unbindRemoteTrackEvents(t._audioTrack), !i) null === (o = t._audioTrack) || void 0 === o || o._destroy(), t._audioTrack = void 0;
                    }
                  }), r));

                case 10:
                case "end":
                  return _context351.stop();
              }
            }
          }, _callee351, this);
        }));

        function unsubscribe(_x566, _x567, _x568) {
          return _unsubscribe3.apply(this, arguments);
        }

        return unsubscribe;
      }()
    }, {
      key: "unsubscribeDataChannel",
      value: function () {
        var _unsubscribeDataChannel3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee352(e, t) {
          var _this277 = this;

          var i, n;
          return _regeneratorRuntime.wrap(function _callee352$(_context352) {
            while (1) {
              switch (_context352.prev = _context352.next) {
                case 0:
                  if (!(t.forEach(function (e) {
                    var t = _this277.pendingRemoteDataChannels.findIndex(function (t) {
                      return t.id === e.id;
                    });

                    -1 !== t && _this277.pendingRemoteDataChannels.splice(t, 1);
                  }), !this.connection)) {
                    _context352.next = 2;
                    break;
                  }

                  return _context352.abrupt("return");

                case 2:
                  i = this.filterTobeUnSubscribedDataChannels(e, t);

                  if (!(0 === i.length)) {
                    _context352.next = 5;
                    break;
                  }

                  return _context352.abrupt("return");

                case 5:
                  t.forEach(function (e) {
                    e._close();
                  });
                  n = this.remoteDataChannelMap.get(e);
                  i.forEach(function (e) {
                    n && n.delete(e.id);
                  });
                  _context352.t0 = n && 0 === n.size;

                  if (!_context352.t0) {
                    _context352.next = 13;
                    break;
                  }

                  this.remoteDataChannelMap.delete(e);
                  _context352.next = 13;
                  return this.connection.stopDataChannels(e.uid);

                case 13:
                  return _context352.abrupt("return", i.map(function (e) {
                    return e.id;
                  }));

                case 14:
                case "end":
                  return _context352.stop();
              }
            }
          }, _callee352, this);
        }));

        function unsubscribeDataChannel(_x569, _x570) {
          return _unsubscribeDataChannel3.apply(this, arguments);
        }

        return unsubscribeDataChannel;
      }()
    }, {
      key: "massUnsubscribe",
      value: function () {
        var _massUnsubscribe3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee353(e) {
          return _regeneratorRuntime.wrap(function _callee353$(_context353) {
            while (1) {
              switch (_context353.prev = _context353.next) {
                case 0:
                  return _context353.abrupt("return", this.massUnsubscribeNoLock(e));

                case 1:
                case "end":
                  return _context353.stop();
              }
            }
          }, _callee353, this);
        }));

        function massUnsubscribe(_x571) {
          return _massUnsubscribe3.apply(this, arguments);
        }

        return massUnsubscribe;
      }()
    }, {
      key: "massUnsubscribeNoLock",
      value: function () {
        var _massUnsubscribeNoLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee354(e) {
          var _this278 = this;

          var t, _iterator38, _step38, _loop5, i, n;

          return _regeneratorRuntime.wrap(function _callee354$(_context354) {
            while (1) {
              switch (_context354.prev = _context354.next) {
                case 0:
                  t = [];
                  _iterator38 = _createForOfIteratorHelper(e);

                  try {
                    _loop5 = function _loop5() {
                      var _step38$value = _step38.value,
                          i = _step38$value.user,
                          n = _step38$value.mediaType;

                      var e = _this278.pendingRemoteTracks.filter(function (e) {
                        var t = e.user,
                            s = e.kind;
                        return void 0 !== n ? t.uid === i.uid && n === s : t.uid === i.uid;
                      });

                      e.forEach(function (e) {
                        var t = _this278.pendingRemoteTracks.indexOf(e);

                        _this278.pendingRemoteTracks.splice(t, 1);
                      }), t = t.concat(e);
                    };

                    for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                      _loop5();
                    }
                  } catch (err) {
                    _iterator38.e(err);
                  } finally {
                    _iterator38.f();
                  }

                  if (!(!this.connection || this.state !== mv.Connected)) {
                    _context354.next = 5;
                    break;
                  }

                  return _context354.abrupt("return", void t.forEach(function (e) {
                    var t = e.user,
                        i = e.kind;
                    var n;
                    if (i === hv.AUDIO) null === (n = t._audioTrack) || void 0 === n || n._destroy(), t._audioTrack = void 0;else if (i === hv.VIDEO) {
                      var s;
                      null === (s = t._videoTrack) || void 0 === s || s._destroy(), t._videoTrack = void 0;
                    }
                  }));

                case 5:
                  i = cS(e).call(e, function (e, t) {
                    var i = t.user,
                        n = t.mediaType;

                    var s = _this278.filterTobeUnSubscribedTracks(i, n);

                    return e.concat(s);
                  }, []);

                  if (!(0 === i.length)) {
                    _context354.next = 8;
                    break;
                  }

                  return _context354.abrupt("return");

                case 8:
                  _context354.next = 10;
                  return this.connection.stopReceiving(i.map(function (e) {
                    var _e322 = _slicedToArray(e, 2),
                        t = _e322[1].id;

                    return t;
                  }));

                case 10:
                  n = this.createUnsubscribeAllMessage(i);
                  return _context354.abrupt("return", (this.withdrawRemoteTracks(i), 0 === this.remoteUserMap.size && this.statsUploader.stopUploadInboundStats(), i.forEach(function (e) {
                    var _e323 = _slicedToArray(e, 2),
                        t = _e323[0],
                        i = _e323[1].kind;

                    var n, s;
                    i === hv.VIDEO && t._videoSSRC && (null === (n = _this278.connection) || void 0 === n || n.setStatsRemoteVideoIsReady(t._videoSSRC, !1));
                    if (i === hv.VIDEO) _this278.unbindRemoteTrackEvents(t._videoTrack), null === (s = t._videoTrack) || void 0 === s || s._destroy(), t._videoTrack = void 0;else if (i === hv.AUDIO) {
                      var r;
                      _this278.unbindRemoteTrackEvents(t._audioTrack), null === (r = t._audioTrack) || void 0 === r || r._destroy(), t._audioTrack = void 0;
                    }
                  }), n));

                case 12:
                case "end":
                  return _context354.stop();
              }
            }
          }, _callee354, this);
        }));

        function massUnsubscribeNoLock(_x572) {
          return _massUnsubscribeNoLock2.apply(this, arguments);
        }

        return massUnsubscribeNoLock;
      }()
    }, {
      key: "muteRemote",
      value: function () {
        var _muteRemote7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee355(e, t) {
          var i, n;
          return _regeneratorRuntime.wrap(function _callee355$(_context355) {
            while (1) {
              switch (_context355.prev = _context355.next) {
                case 0:
                  if (this.connection) {
                    _context355.next = 2;
                    break;
                  }

                  return _context355.abrupt("return");

                case 2:
                  i = this.remoteUserMap.get(e);

                  if (i) {
                    _context355.next = 5;
                    break;
                  }

                  return _context355.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel.muteRemote has no remote user ").concat(e.uid, ".")));

                case 5:
                  if (i.get(t)) {
                    _context355.next = 7;
                    break;
                  }

                  return _context355.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel.muteRemote has no remote user ").concat(e.uid, " media type ").concat(t, ".")));

                case 7:
                  n = t === hv.VIDEO ? e._videoSSRC : e._audioSSRC;
                  void 0 !== n && this.connection.setStatsRemoteVideoIsReady(n, !1);

                case 9:
                case "end":
                  return _context355.stop();
              }
            }
          }, _callee355, this);
        }));

        function muteRemote(_x573, _x574) {
          return _muteRemote7.apply(this, arguments);
        }

        return muteRemote;
      }()
    }, {
      key: "unmuteRemote",
      value: function () {
        var _unmuteRemote7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee356(e, t) {
          return _regeneratorRuntime.wrap(function _callee356$(_context356) {
            while (1) {
              switch (_context356.prev = _context356.next) {
                case 0:
                  return _context356.abrupt("return", this.unmuteRemoteNoLock(e, t));

                case 1:
                case "end":
                  return _context356.stop();
              }
            }
          }, _callee356, this);
        }));

        function unmuteRemote(_x575, _x576) {
          return _unmuteRemote7.apply(this, arguments);
        }

        return unmuteRemote;
      }()
    }, {
      key: "unmuteRemoteNoLock",
      value: function () {
        var _unmuteRemoteNoLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee357(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee357$(_context357) {
            while (1) {
              switch (_context357.prev = _context357.next) {
                case 0:
                  if (this.connection) {
                    _context357.next = 2;
                    break;
                  }

                  return _context357.abrupt("return");

                case 2:
                  i = this.remoteUserMap.get(e);

                  if (i) {
                    _context357.next = 5;
                    break;
                  }

                  return _context357.abrupt("return", void YC.warning("[".concat(this.store.clientId, "] P2PChannel.unmuteRemote has no remote user ").concat(e.uid, ".")));

                case 5:
                  i.get(t) || YC.warning("[".concat(this.store.clientId, "] P2PChannel.unmuteRemote has no remote user ").concat(e.uid, " media type ").concat(t, "."));

                case 6:
                case "end":
                  return _context357.stop();
              }
            }
          }, _callee357, this);
        }));

        function unmuteRemoteNoLock(_x577, _x578) {
          return _unmuteRemoteNoLock2.apply(this, arguments);
        }

        return unmuteRemoteNoLock;
      }()
    }, {
      key: "getAllTracks",
      value: function getAllTracks(e) {
        var t = this.localTrackMap.get(Ev.LocalAudioTrack);

        if ((null == t ? void 0 : t.track) instanceof uw) {
          var i = t.track;
          return Array.from(this.localTrackMap.entries()).filter(function (e) {
            var _e324 = _slicedToArray(e, 1),
                t = _e324[0];

            return t !== Ev.LocalAudioTrack;
          }).filter(function (t) {
            var _t291 = _slicedToArray(t, 1),
                i = _t291[0];

            return !(e && i === Ev.LocalVideoLowTrack);
          }).map(function (e) {
            var _e325 = _slicedToArray(e, 2),
                t = _e325[1].track;

            return t;
          }).concat(i.trackList);
        }

        return Array.from(this.localTrackMap.entries()).filter(function (t) {
          var _t292 = _slicedToArray(t, 1),
              i = _t292[0];

          return !(e && i === Ev.LocalVideoLowTrack);
        }).map(function (e) {
          var _e326 = _slicedToArray(e, 2),
              t = _e326[1].track;

          return t;
        });
      }
    }, {
      key: "getAllDataChannels",
      value: function getAllDataChannels() {
        return this.localDataChannels;
      }
    }, {
      key: "reportPublishEvent",
      value: function reportPublishEvent(e, t, i, n, s) {
        if (e) {
          var _i150 = this.localTrackMap.get(Ev.LocalAudioTrack),
              _r64 = n ? this.localTrackMap.get(Ev.LocalVideoLowTrack) : this.localTrackMap.get(Ev.LocalVideoTrack);

          rI.publish(this.store.sessionId, {
            eventElapse: TP.measureFromPublishStart(this.store.clientId, this.store.pubId),
            succ: e,
            ec: t,
            audioName: null == _i150 ? void 0 : _i150.track.getTrackLabel(),
            videoName: null == _r64 ? void 0 : _r64.track.getTrackLabel(),
            screenshare: -1 !== (null == _r64 ? void 0 : _r64.track._hints.indexOf(YA.SCREEN_TRACK)),
            audio: !!_i150,
            video: !!_r64,
            p2pid: this.store.p2pId,
            publishRequestid: this.store.pubId,
            extend: s
          });
        } else {
          var r;
          i || (i = []);

          var _o48 = i.find(function (e) {
            return e instanceof cw;
          }),
              _a28 = n ? null === (r = this.localTrackMap.get(Ev.LocalVideoTrack)) || void 0 === r ? void 0 : r.track : i.find(function (e) {
            return e instanceof Nw;
          });

          rI.publish(this.store.sessionId, {
            eventElapse: TP.measureFromPublishStart(this.store.clientId, this.store.pubId),
            succ: e,
            ec: t,
            audioName: null == _o48 ? void 0 : _o48.getTrackLabel(),
            videoName: null == _a28 ? void 0 : _a28.getTrackLabel(),
            screenshare: -1 !== (null == _a28 ? void 0 : _a28._hints.indexOf(YA.SCREEN_TRACK)),
            audio: !!_o48,
            video: !!_a28,
            p2pid: this.store.p2pId,
            publishRequestid: this.store.pubId,
            extend: s
          });
        }
      }
    }, {
      key: "reportSubscribeEvent",
      value: function reportSubscribeEvent(e, t, i, n) {
        var s = n === hv.VIDEO ? i._videoSSRC : i._audioSSRC;
        s && rI.subscribe(this.store.sessionId, {
          succ: e,
          ec: t,
          video: n === hv.VIDEO,
          audio: n === hv.AUDIO,
          peerid: i.uid,
          subscribeRequestid: n === hv.VIDEO ? i._videoSSRC : i._audioSSRC,
          p2pid: this.store.p2pId,
          eventElapse: TP.measureFromSubscribeStart(this.store.clientId, s)
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        YC.debug("[".concat(this.store.clientId, "] P2PChannel.reset")), this.mutex = new Yg("P2PChannel-mutex"), this.connection && (this.connection.close(), this.unbindConnectionEvents(this.connection), this.connection = void 0), this.shouldForwardP2PCreation && (this.connection = this.store.useDataChannel ? new Qk({}, this.store) : this.isPlanB ? new wk({}, this.store) : new Uk({}, this.store), this.bindConnectionEvents(this.connection)), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), this.statsUploader.stopUploadExtensionUsageStats(), this.unbindLocalTrackEvents(), this.unbindAllRemoteTrackEvents(), this.unbindRtpTransceiver();
        var e = this.localTrackMap.get(Ev.LocalAudioTrack);

        if ((null == e ? void 0 : e.track) instanceof uw) {
          if (e.track.trackList.length > 0) {
            var _t293 = e.track;
            e.track.trackList.forEach(function (e) {
              _t293.removeAudioTrack(e);
            });
          }

          e.track.close();
        }

        this.localTrackMap.clear(), this.remoteUserMap.clear(), this.statsCollector.removeRemoteStats(), this.statsCollector.removeLocalStats(), this.iceFailedCount = 0, this.dtlsFailedCount = 0, this.pendingLocalTracks = [], this.pendingRemoteTracks = [], this.localDataChannels = [], this.remoteDataChannelMap.clear(), this.pendingLocalDataChannels = [], this.pendingRemoteDataChannels = [], this.state = mv.Disconnected;
      }
    }, {
      key: "getStats",
      value: function getStats() {
        var e;
        return null === (e = this.connection) || void 0 === e ? void 0 : e.getStats();
      }
    }, {
      key: "getRemoteVideoIsReady",
      value: function getRemoteVideoIsReady(e) {
        var t;
        return (null === (t = this.connection) || void 0 === t ? void 0 : t.getRemoteVideoIsReady(e)) || !1;
      }
    }, {
      key: "getLocalAudioVolume",
      value: function getLocalAudioVolume() {
        var e = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e) return e.track.getVolumeLevel();
      }
    }, {
      key: "getLocalVideoSize",
      value: function getLocalVideoSize() {
        var e = this.localTrackMap.get(Ev.LocalVideoTrack);
        if (e) return {
          width: e.track._videoWidth || 0,
          height: e.track._videoHeight || 0
        };
      }
    }, {
      key: "getEncoderConfig",
      value: function getEncoderConfig(e) {
        var t = this.localTrackMap.get(e);
        return t && t.track instanceof Nw || t && t.track instanceof cw ? t.track._encoderConfig : void 0;
      }
    }, {
      key: "getLocalMedia",
      value: function getLocalMedia(e) {
        return this.localTrackMap.get(e);
      }
    }, {
      key: "hasLocalMedia",
      value: function hasLocalMedia() {
        return this.localTrackMap.size > 0;
      }
    }, {
      key: "hasRemoteMedia",
      value: function hasRemoteMedia(e, t) {
        if (!e) return this.remoteUserMap.size > 0;
        var i = this.remoteUserMap.get(e);
        return !!i && (!t || i.has(t));
      }
    }, {
      key: "hasRemoteMediaWithLock",
      value: function () {
        var _hasRemoteMediaWithLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee358(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee358$(_context358) {
            while (1) {
              switch (_context358.prev = _context358.next) {
                case 0:
                  if (e) {
                    _context358.next = 2;
                    break;
                  }

                  return _context358.abrupt("return", this.remoteUserMap.size > 0);

                case 2:
                  i = this.remoteUserMap.get(e);
                  return _context358.abrupt("return", !!i && (!t || i.has(t)));

                case 4:
                case "end":
                  return _context358.stop();
              }
            }
          }, _callee358, this);
        }));

        function hasRemoteMediaWithLock(_x579, _x580) {
          return _hasRemoteMediaWithLock2.apply(this, arguments);
        }

        return hasRemoteMediaWithLock;
      }()
    }, {
      key: "getRemoteMedia",
      value: function getRemoteMedia(e) {
        var t;
        var i = Array.from(uh(t = this.remoteUserMap).call(t)).find(function (t) {
          return t.uid === e;
        });
        return i ? {
          audioTrack: i.audioTrack,
          audioSSRC: i._audioSSRC,
          videoTrack: i.videoTrack,
          videoSSRC: i._videoSSRC
        } : {};
      }
    }, {
      key: "getAudioLevels",
      value: function getAudioLevels() {
        var e = Array.from(this.remoteUserMap.entries()).map(function (e) {
          var _e327 = _slicedToArray(e, 1),
              t = _e327[0];

          return {
            uid: t.uid,
            level: t.audioTrack ? 100 * t.audioTrack._source.getAccurateVolumeLevel() : 0
          };
        });
        var t = this.localTrackMap.get(Ev.LocalAudioTrack);
        return t && e.push({
          level: 100 * t.track._source.getAccurateVolumeLevel(),
          uid: this.store.uid
        }), e = Zh(e).call(e, function (e, t) {
          return e.level - t.level;
        }), e;
      }
    }, {
      key: "disconnectForReconnect",
      value: function () {
        var _disconnectForReconnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee359() {
          var _this279 = this;

          return _regeneratorRuntime.wrap(function _callee359$(_context359) {
            while (1) {
              switch (_context359.prev = _context359.next) {
                case 0:
                  this.connection && (YC.debug("[".concat(this.store.clientId, "] P2PChannel.disconnectForReconnect closing P2PConnection")), this.state = mv.Reconnecting, DC("KEEP_LAST_FRAME") && 0 !== this.remoteUserMap.size && Array.from(this.remoteUserMap.entries()).forEach(function (e) {
                    var _e328 = _slicedToArray(e, 1),
                        t = _e328[0];

                    var i;
                    t._videoTrack && t._videoTrack._player && (null === (i = t._videoTrack._player.getVideoElement()) || void 0 === i || i.pause(), t._videoTrack._player.isKeepLastFrame = !0, t._videoTrack._originMediaStreamTrack.stop());
                  }), this.connection.close(), this.unbindConnectionEvents(this.connection), this.connection = void 0, this.shouldForwardP2PCreation && (this.connection = this.store.useDataChannel ? new Qk({}, this.store) : this.isPlanB ? new wk({}, this.store) : new Uk({}, this.store), this.bindConnectionEvents(this.connection)), 0 !== this.localTrackMap.size && (Array.from(this.localTrackMap.entries()).forEach(function (e) {
                    var t;

                    var _e329 = _slicedToArray(e, 2),
                        i = _e329[0],
                        n = _e329[1].track;

                    switch (i) {
                      case Ev.LocalVideoTrack:
                        bn(t = n._hints).call(t, YA.LOW_STREAM) ? n.close() : _this279.pendingLocalTracks.push(n);
                        break;

                      case Ev.LocalAudioTrack:
                        n instanceof uw ? _this279.pendingLocalTracks = _this279.pendingLocalTracks.concat(n.trackList) : _this279.pendingLocalTracks.push(n);

                      case Ev.LocalVideoLowTrack:
                    }
                  }), this.emit(fv.MediaReconnectStart, this.store.uid)), this.unbindLocalTrackEvents(), this.localTrackMap.clear(), 0 !== this.remoteUserMap.size && Array.from(this.remoteUserMap.entries()).forEach(function (e) {
                    var _e330 = _slicedToArray(e, 2),
                        t = _e330[0],
                        i = _e330[1];

                    Array.from(uh(i).call(i)).forEach(function (e) {
                      _this279.setPendingRemoteMedia(t, e);
                    }), _this279.emit(fv.MediaReconnectStart, t.uid);
                  }), this.unbindAllRemoteTrackEvents(), this.remoteUserMap.clear(), 0 !== this.localDataChannels.length && (this.localDataChannels.forEach(function (e) {
                    _this279.pendingLocalDataChannels.push(e);
                  }), this.localDataChannels.length = 0), 0 !== this.remoteDataChannelMap.size && (Array.from(this.remoteDataChannelMap.entries()).forEach(function (e) {
                    var _e331 = _slicedToArray(e, 2),
                        t = _e331[0],
                        i = _e331[1];

                    Array.from(uh(i).call(i)).forEach(function (e) {
                      _this279.setPendingRemoteDataChannel(t, e);
                    });
                  }), this.remoteDataChannelMap.clear()), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), YC.debug("[".concat(this.store.clientId, "] P2PChannel disconnected, waiting to reconnect.")));

                case 1:
                case "end":
                  return _context359.stop();
              }
            }
          }, _callee359, this);
        }));

        function disconnectForReconnect() {
          return _disconnectForReconnect2.apply(this, arguments);
        }

        return disconnectForReconnect;
      }()
    }, {
      key: "hasPendingRemoteDataChannel",
      value: function hasPendingRemoteDataChannel(e, t) {
        var _iterator39 = _createForOfIteratorHelper(this.pendingRemoteDataChannels),
            _step39;

        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var i = _step39.value;
            var _n138 = i.user,
                _s94 = i.id;
            if ((e instanceof ik ? e.uid : e) === _n138.uid && _s94 === t) return !0;
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }

        return !1;
      }
    }, {
      key: "setPendingRemoteDataChannel",
      value: function setPendingRemoteDataChannel(e, t) {
        this.hasPendingRemoteDataChannel(e, t) || this.pendingRemoteDataChannels.push({
          user: e,
          id: t
        });
      }
    }, {
      key: "hasPendingRemoteMedia",
      value: function hasPendingRemoteMedia(e, t) {
        var _iterator40 = _createForOfIteratorHelper(this.pendingRemoteTracks),
            _step40;

        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var i = _step40.value;
            var _n139 = i.user,
                _s95 = i.kind;
            if ((e instanceof ik ? e.uid : e) === _n139.uid && t === _s95) return !0;
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }

        return !1;
      }
    }, {
      key: "setPendingRemoteMedia",
      value: function setPendingRemoteMedia(e, t) {
        this.hasPendingRemoteMedia(e, t) || this.pendingRemoteTracks.push({
          user: e,
          kind: t
        });
      }
    }, {
      key: "restartICE",
      value: function restartICE(e) {
        var t = this;
        return OP( /*#__PURE__*/_regeneratorRuntime.mark(function _callee360() {
          var i, n, _s96, _r65, _o49, s;

          return _regeneratorRuntime.wrap(function _callee360$(_context360) {
            while (1) {
              switch (_context360.prev = _context360.next) {
                case 0:
                  if (!(!t.connection || t.state !== mv.Connected || t.connection instanceof Qk)) {
                    _context360.next = 2;
                    break;
                  }

                  return _context360.abrupt("return");

                case 2:
                  _context360.next = 4;
                  return SP(t.mutex.lock("From P2PChannel.restartICE"));

                case 4:
                  i = _context360.sent;
                  _context360.prev = 5;
                  _context360.next = 8;
                  return SP(t.connection.restartICE(e));

                case 8:
                  n = _context360.sent;
                  _context360.next = 11;
                  return SP(n.next());

                case 11:
                  _s96 = _context360.sent;

                  if (!_s96.done) {
                    _context360.next = 14;
                    break;
                  }

                  return _context360.abrupt("return");

                case 14:
                  _r65 = _s96.value;
                  _context360.next = 17;
                  return _r65;

                case 17:
                  _o49 = _context360.sent;
                  _context360.t0 = (t.reportPCDisconnectedOrFailed(e), e);
                  _context360.next = _context360.t0 === pv.TCP ? 21 : _context360.t0 === pv.RELAY ? 23 : 25;
                  break;

                case 21:
                  t._pcStatsUploadType = _v.TCP_RESTART;
                  return _context360.abrupt("break", 26);

                case 23:
                  t._pcStatsUploadType = _v.RELAY_RESTART;
                  return _context360.abrupt("break", 26);

                case 25:
                  t._pcStatsUploadType = _v.OLD_RESTART;

                case 26:
                  t._isInRestartIce = !0, n.next(_o49);
                  _context360.next = 32;
                  break;

                case 29:
                  _context360.prev = 29;
                  _context360.t1 = _context360["catch"](5);
                  null === (s = n) || void 0 === s || s.throw(_context360.t1);

                case 32:
                  _context360.prev = 32;
                  i();
                  return _context360.finish(32);

                case 35:
                case "end":
                  return _context360.stop();
              }
            }
          }, _callee360, null, [[5, 29, 32, 35]]);
        }))();
      }
    }, {
      key: "getUplinkNetworkQuality",
      value: function getUplinkNetworkQuality() {
        if (!this.connection) return 0;
        var e = this.connection.getStats(),
            t = this.localTrackMap.get(Ev.LocalVideoTrack),
            i = this.localTrackMap.get(Ev.LocalAudioTrack),
            n = e.videoSend.find(function (e) {
          return e.ssrc === (null == t ? void 0 : t.ssrcs[0].ssrcId);
        }),
            s = e.audioSend.find(function (e) {
          return e.ssrc === (null == i ? void 0 : i.ssrcs[0].ssrcId);
        });
        if (!n || !s) return 1;
        var r = gg(this, fv.NeedSignalRTT),
            o = n ? n.rttMs : void 0,
            a = s ? s.rttMs : void 0,
            c = o && a ? (o + a) / 2 : o || a,
            d = (c && r ? (c + r) / 2 : c || r) || 0,
            l = 100 * e.sendPacketLossRate * .7 / 50 + .3 * d / 1500,
            u = l < .17 ? 1 : l < .36 ? 2 : l < .59 ? 3 : l < .1 ? 4 : 5,
            h = null == t ? void 0 : t.track;

        if (h && h._encoderConfig && -1 === h._hints.indexOf(YA.SCREEN_TRACK)) {
          var _t294 = h._encoderConfig.bitrateMax,
              _i151 = e.bitrate.actualEncoded;

          if (_t294 && _i151) {
            var _e332 = (1e3 * _t294 - _i151) / (1e3 * _t294);

            return cI[_e332 < .15 ? 0 : _e332 < .3 ? 1 : _e332 < .45 ? 2 : _e332 < .6 ? 3 : 4][u];
          }
        }

        return u;
      }
    }, {
      key: "getDownlinkNetworkQuality",
      value: function getDownlinkNetworkQuality() {
        var _this280 = this;

        if (!this.connection) return 0;
        var e = this.connection.getStats();
        var t = 0;
        return Array.from(this.remoteUserMap.entries()).forEach(function (i) {
          var _i152 = _slicedToArray(i, 1),
              n = _i152[0];

          var s = n._audioSSRC,
              r = n._videoSSRC,
              o = e.audioRecv.find(function (e) {
            return e.ssrc === s;
          }),
              a = e.videoRecv.find(function (e) {
            return e.ssrc === r;
          });
          if (!o && !a) return void (t += 1);
          var c = gg(_this280, fv.NeedSignalRTT),
              d = e.rtt,
              l = (d && c ? (d + c) / 2 : d || c) || 0,
              u = o ? o.jitterMs : void 0,
              h = e.recvPacketLossRate;
          var p = .7 * h * 100 / 50 + .3 * l / 1500;
          u && (p = .6 * h * 100 / 50 + .2 * l / 1500 + .2 * u / 400);
          t += p < .1 ? 1 : p < .17 ? 2 : p < .36 ? 3 : p < .59 ? 4 : 5;
        }), this.remoteUserMap.size > 0 ? Math.round(t / this.remoteUserMap.size) : t;
      }
    }, {
      key: "muteLocalTrack",
      value: function () {
        var _muteLocalTrack2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee361(e) {
          var _this281 = this;

          return _regeneratorRuntime.wrap(function _callee361$(_context361) {
            while (1) {
              switch (_context361.prev = _context361.next) {
                case 0:
                  return _context361.abrupt("return", new tT(function (t, i) {
                    _this281.handleMuteLocalTrack(e, t, i);
                  }));

                case 1:
                case "end":
                  return _context361.stop();
              }
            }
          }, _callee361);
        }));

        function muteLocalTrack(_x581) {
          return _muteLocalTrack2.apply(this, arguments);
        }

        return muteLocalTrack;
      }()
    }, {
      key: "filterTobePublishedTracks",
      value: function filterTobePublishedTracks(e, t, i) {
        var n = [],
            s = wA(),
            r = this.getAllTracks();
        e = yg(e = e.filter(function (e) {
          return -1 === r.indexOf(e);
        }));
        var o = !1,
            a = !1;

        var _iterator41 = _createForOfIteratorHelper(e),
            _step41;

        try {
          for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
            var _r66 = _step41.value;

            if (_r66 instanceof Nw && (this.localTrackMap.has(Ev.LocalVideoTrack) || o ? new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS).throw() : (n.push({
              track: _r66,
              type: Ev.LocalVideoTrack
            }), o = !0), t)) {
              var _e333 = this.getLowVideoTrack(_r66, i);

              n.push({
                track: _e333,
                type: Ev.LocalVideoLowTrack
              });
            }

            if (_r66 instanceof cw) {
              var _e334 = this.localTrackMap.get(Ev.LocalAudioTrack);

              if (_e334) {
                if (!(_e334.track instanceof uw)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
                if (_r66._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");
                _e334.track.addAudioTrack(_r66), this.bindLocalAudioTrackEvents(_r66, !0);
              } else if (a) {
                var _e335 = n.find(function (e) {
                  var t = e.type;
                  return t === Ev.LocalAudioTrack;
                });

                if (!(_e335.track instanceof uw)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
                if (_r66._bypassWebAudio) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");

                _e335.track.addAudioTrack(_r66);
              } else {
                if (!s.webAudioMediaStreamDest || _r66 instanceof uw || _r66._bypassWebAudio) n.push({
                  track: _r66,
                  type: Ev.LocalAudioTrack
                });else {
                  var _e336 = new uw();

                  _e336.addAudioTrack(_r66), n.push({
                    track: _e336,
                    type: Ev.LocalAudioTrack
                  });
                }
                a = !0;
              }
            }
          }
        } catch (err) {
          _iterator41.e(err);
        } finally {
          _iterator41.f();
        }

        return n;
      }
    }, {
      key: "filterTobeUnpublishedTracks",
      value: function filterTobeUnpublishedTracks(e) {
        var t = [],
            i = this.getAllTracks();
        e = yg(e = e.filter(function (e) {
          return -1 !== i.indexOf(e);
        }));

        var _iterator42 = _createForOfIteratorHelper(e),
            _step42;

        try {
          for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
            var _i153 = _step42.value;

            if (_i153 instanceof cw) {
              var _e337 = this.localTrackMap.get(Ev.LocalAudioTrack);

              if (!_e337) continue;
              _e337.track instanceof uw ? (_e337.track.removeAudioTrack(_i153), this.unbindLocalAudioTrackEvents(_i153), 0 === _e337.track.trackList.length && (t.push([Ev.LocalAudioTrack, _e337]), _e337.track.close())) : t.push([Ev.LocalAudioTrack, _e337]);
            }

            if (_i153 instanceof Nw) {
              var _e338 = this.localTrackMap.get(Ev.LocalVideoTrack);

              if (!_e338) continue;
              t.push([Ev.LocalVideoTrack, _e338]);

              var _i154 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

              _i154 && t.push([Ev.LocalVideoLowTrack, _i154]);
            }
          }
        } catch (err) {
          _iterator42.e(err);
        } finally {
          _iterator42.f();
        }

        return t;
      }
    }, {
      key: "filterTobePublishedDataChannels",
      value: function filterTobePublishedDataChannels(e) {
        var _this282 = this;

        return e = (e = yg(e)).filter(function (e) {
          return -1 === _this282.localDataChannels.findIndex(function (t) {
            return t.id === e.id;
          });
        });
      }
    }, {
      key: "filterTobeUnpublishedDataChannels",
      value: function filterTobeUnpublishedDataChannels(e) {
        var _this283 = this;

        return e = (e = (e = yg(e)).filter(function (e) {
          return -1 !== _this283.localDataChannels.indexOf(e);
        })).filter(function (e) {
          return e._originDataChannel;
        });
      }
    }, {
      key: "bindLocalTrackEvents",
      value: function bindLocalTrackEvents(e) {
        var _this284 = this;

        e.forEach(function (e) {
          var t = e.track,
              i = e.type;

          switch (i) {
            case Ev.LocalVideoTrack:
              t.addListener(KA.GET_STATS, _this284.handleGetLocalVideoStats), t.addListener(KA.GET_RTC_STATS, _this284.handleGetRTCStats), t.addListener(KA.NEED_DISABLE_TRACK, _this284.handleMuteLocalTrack), t.addListener(KA.NEED_ENABLE_TRACK, _this284.handleUnmuteLocalTrack), t.addListener(KA.NEED_UPDATE_VIDEO_ENCODER, _this284.handleUpdateVideoEncoder), t.addListener(KA.SET_OPTIMIZATION_MODE, _this284.handleSetOptimizationMode), t.addListener(KA.NEED_REPLACE_TRACK, _this284.handleReplaceTrack), t.addListener(KA.NEED_MUTE_TRACK, _this284.handleMuteLocalTrack), t.addListener(KA.NEED_UNMUTE_TRACK, _this284.handleUnmuteLocalTrack);
              break;

            case Ev.LocalAudioTrack:
              _this284.bindLocalAudioTrackEvents(t);

            case Ev.LocalVideoLowTrack:
          }
        });
      }
    }, {
      key: "bindLocalAudioTrackEvents",
      value: function bindLocalAudioTrackEvents(e, t) {
        var _this285 = this;

        e instanceof uw ? e.trackList.forEach(function (e) {
          e.addListener(KA.NEED_DISABLE_TRACK, _this285.handleMuteLocalTrack), e.addListener(KA.NEED_ENABLE_TRACK, _this285.handleUnmuteLocalTrack), e.addListener(KA.GET_STATS, _this285.handleGetLocalAudioStats), e.addListener(KA.NEED_MUTE_TRACK, _this285.handleMuteLocalTrack), e.addListener(KA.NEED_UNMUTE_TRACK, _this285.handleUnmuteLocalTrack);
        }) : (e.addListener(KA.GET_STATS, this.handleGetLocalAudioStats), e.addListener(KA.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.addListener(KA.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.addListener(KA.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.addListener(KA.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack), t || e.addListener(KA.NEED_REPLACE_TRACK, this.handleReplaceTrack));
      }
    }, {
      key: "unbindLocalTrackEvents",
      value: function unbindLocalTrackEvents(e) {
        var _this286 = this;

        e || (e = Array.from(this.localTrackMap.entries()).map(function (e) {
          var _e339 = _slicedToArray(e, 2),
              t = _e339[0],
              i = _e339[1].track;

          return {
            track: i,
            type: t
          };
        })), e.forEach(function (e) {
          var t = e.track,
              i = e.type;

          switch (i) {
            case Ev.LocalVideoTrack:
              t.off(KA.GET_STATS, _this286.handleGetLocalVideoStats), t.off(KA.GET_RTC_STATS, _this286.handleGetRTCStats), t.off(KA.NEED_DISABLE_TRACK, _this286.handleMuteLocalTrack), t.off(KA.NEED_ENABLE_TRACK, _this286.handleUnmuteLocalTrack), t.off(KA.NEED_UPDATE_VIDEO_ENCODER, _this286.handleUpdateVideoEncoder), t.off(KA.SET_OPTIMIZATION_MODE, _this286.handleSetOptimizationMode), t.off(KA.NEED_REPLACE_TRACK, _this286.handleReplaceTrack), t.off(KA.NEED_MUTE_TRACK, _this286.handleMuteLocalTrack), t.off(KA.NEED_UNMUTE_TRACK, _this286.handleUnmuteLocalTrack);
              break;

            case Ev.LocalAudioTrack:
              _this286.unbindLocalAudioTrackEvents(t);

            case Ev.LocalVideoLowTrack:
          }
        });
      }
    }, {
      key: "unbindLocalAudioTrackEvents",
      value: function unbindLocalAudioTrackEvents(e) {
        var _this287 = this;

        e instanceof uw ? e.trackList.forEach(function (e) {
          e.off(KA.NEED_DISABLE_TRACK, _this287.handleMuteLocalTrack), e.off(KA.NEED_ENABLE_TRACK, _this287.handleUnmuteLocalTrack), e.off(KA.GET_STATS, _this287.handleGetLocalAudioStats), e.off(KA.NEED_MUTE_TRACK, _this287.handleMuteLocalTrack), e.off(KA.NEED_UNMUTE_TRACK, _this287.handleUnmuteLocalTrack);
        }) : (e.off(KA.GET_STATS, this.handleGetLocalAudioStats), e.off(KA.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.off(KA.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.off(KA.NEED_REPLACE_TRACK, this.handleReplaceTrack), e.off(KA.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.off(KA.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack));
      }
    }, {
      key: "bindRemoteTrackEvents",
      value: function bindRemoteTrackEvents(e, t) {
        var _this288 = this;

        t instanceof Vw && t.addListener(KA.GET_STATS, function (t) {
          t(_this288.handleGetRemoteVideoStats(e));
        }), t instanceof Fw && t.addListener(KA.GET_STATS, function (t) {
          t(_this288.handleGetRemoteAudioStats(e));
        });
      }
    }, {
      key: "unbindRemoteTrackEvents",
      value: function unbindRemoteTrackEvents(e) {
        e && e.removeAllListeners(KA.GET_STATS);
      }
    }, {
      key: "unbindAllRemoteTrackEvents",
      value: function unbindAllRemoteTrackEvents() {
        var _this289 = this;

        Array.from(this.remoteUserMap.entries()).forEach(function (e) {
          var _e340 = _slicedToArray(e, 2),
              t = _e340[0],
              i = _e340[1];

          i.has(hv.AUDIO) && _this289.unbindRemoteTrackEvents(t._audioTrack), i.has(hv.VIDEO) && _this289.unbindRemoteTrackEvents(t._videoTrack);
        });
      }
    }, {
      key: "createGatewayPublishMessage",
      value: function createGatewayPublishMessage(e, t) {
        var _this290 = this;

        return e.map(function (e, i) {
          var n;
          var s,
              r,
              o = e.track,
              a = e.type;

          switch (a) {
            case Ev.LocalAudioTrack:
              s = ev.Audio, r = {
                dtx: o instanceof dw && o._config.DTX,
                hq: !1,
                lq: !1,
                stereo: !1,
                speech: !1
              };
              break;

            case Ev.LocalVideoTrack:
              s = bn(n = o._hints).call(n, YA.SCREEN_TRACK) ? ev.Screen : ev.High, r = eM(eM({}, Ay(o)), {}, {
                codec: _this290.store.codec
              });
              break;

            case Ev.LocalVideoLowTrack:
              s = ev.Low, r = eM(eM({}, Ay(o)), {}, {
                codec: _this290.store.codec
              });
          }

          return {
            stream_type: s,
            attributes: r,
            ssrcs: t[i]
          };
        });
      }
    }, {
      key: "createGatewayUnpublishMessage",
      value: function createGatewayUnpublishMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e341 = _slicedToArray(e, 2),
              n = _e341[0],
              _e341$ = _e341[1],
              s = _e341$.track,
              r = _e341$.ssrcs,
              o = _e341$.id;

          switch (n) {
            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "assignLocalTracks",
      value: function assignLocalTracks(e, t) {
        var _this291 = this;

        e.forEach(function (e, i) {
          var n = e.track,
              s = e.type;

          _this291.localTrackMap.set(s, {
            track: n,
            id: t[i].id,
            ssrcs: t[i].localSSRC
          });
        });
      }
    }, {
      key: "withdrawLocalTracks",
      value: function withdrawLocalTracks(e) {
        var _this292 = this;

        e.forEach(function (e) {
          var _e342 = _slicedToArray(e, 1),
              t = _e342[0];

          _this292.localTrackMap.delete(t);
        });
      }
    }, {
      key: "bindConnectionEvents",
      value: function bindConnectionEvents(e) {
        var _this293 = this;

        e.onConnectionStateChange = /*#__PURE__*/function () {
          var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee362(t) {
            var i, _t295, _i155, _n140;

            return _regeneratorRuntime.wrap(function _callee362$(_context362) {
              while (1) {
                switch (_context362.prev = _context362.next) {
                  case 0:
                    if (!(YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.onConnectionStateChange(").concat(t, ")")), _this293.emit(fv.PeerConnectionStateChange, t), "connected" !== t || _this293.store.keyMetrics.peerConnectionEnd || _this293.store.peerConnectionEnd(), "connected" === t && (_this293._restartTimer && (clearTimeout(_this293._restartTimer), _this293._restartTimer = void 0), (_this293._isFirstConnected || _this293._isInRestartIce) && _this293.reportPCStats(Date.now(), !0, _this293._pcStatsUploadType), _this293._isInRestartIce = !1, _this293._isFirstConnected = !1, _this293._isStartRestartIce = !1), DC("NEW_ICE_RESTART"))) {
                      _context362.next = 9;
                      break;
                    }

                    if (!bn(i = _this293._restartStates).call(i, t)) {
                      _context362.next = 7;
                      break;
                    }

                    if (!_this293._isStartRestartIce) {
                      _context362.next = 4;
                      break;
                    }

                    return _context362.abrupt("return");

                  case 4:
                    _this293._isStartRestartIce = !0;
                    _t295 = function _t295(t) {
                      if ("disconnected" === e.iceConnectionState || "checking" === e.iceConnectionState || "failed" === e.iceConnectionState) {
                        YC.debug("[".concat(_this293.store.clientId, "] [P2PChannel] start use restartICE, type is ").concat(t));
                        "CONNECTED" === gg(_this293, fv.QueryClientConnectionState) && _this293.emit(fv.RequestRestartICE, t);
                      }
                    }, _i155 = function _i155() {
                      "disconnected" !== e.iceConnectionState && "checking" !== e.iceConnectionState && "failed" !== e.iceConnectionState || (_this293.reportPCStats(Date.now(), !1, _this293._pcStatsUploadType), YC.debug("[".concat(_this293.store.clientId, "] P2PConnection disconnected timeout, force reconnect")), setTimeout(function () {
                        return _this293.emit(fv.P2PLost);
                      }, 0), _this293.iceFailedCount += 1, _this293.requestReconnect());
                    }, _n140 = DC("ICE_RESTART_INTERVAL");
                    return _context362.abrupt("return", void (_this293._restartTimer = window.setTimeout(function () {
                      if (DC("JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE") && wA().supportPCSetConfiguration) _t295(pv.RELAY), _this293._restartTimer = window.setTimeout(_i155, _n140);else if (RT()) _t295(pv.UDP), _this293._restartTimer = window.setTimeout(_i155, 4e3);else {
                        if (_t295(pv.TCP), wA().supportPCSetConfiguration) return void (_this293._restartTimer = window.setTimeout(function () {
                          _t295(pv.RELAY), _this293._restartTimer = window.setTimeout(_i155, _n140);
                        }, _n140));
                        _this293._restartTimer = window.setTimeout(_i155, _n140);
                      }
                    }, 800)));

                  case 7:
                    _context362.next = 19;
                    break;

                  case 9:
                    if (!("disconnected" === t && "disconnected" === e.iceConnectionState)) {
                      _context362.next = 11;
                      break;
                    }

                    return _context362.abrupt("return", (setTimeout(function () {
                      if ("disconnected" === e.iceConnectionState && DC("ICE_RESTART")) {
                        "CONNECTED" === gg(_this293, fv.QueryClientConnectionState) && _this293.emit(fv.RequestRestartICE);
                      }
                    }, 800), void setTimeout(function () {
                      "disconnected" === e.peerConnectionState && (YC.debug("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection disconnected timeout 4000ms, force reconnect")), _this293.reportPCStats(Date.now(), !1, _this293._pcStatsUploadType), _this293._isInRestartIce = !1, setTimeout(function () {
                        return _this293.emit(fv.P2PLost);
                      }, 0), _this293.iceFailedCount += 1, _this293.requestReconnect());
                    }, 4e3)));

                  case 11:
                    _context362.t0 = "failed" === t;

                    if (!_context362.t0) {
                      _context362.next = 19;
                      break;
                    }

                    YC.debug("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection state failed, force reconnect"));

                    _this293.reportPCDisconnectedOrFailed();

                    setTimeout(function () {
                      return _this293.emit(fv.P2PLost);
                    }, 0);
                    _this293.iceFailedCount += 1;
                    _context362.next = 19;
                    return _this293.requestReconnect();

                  case 19:
                  case "end":
                    return _context362.stop();
                }
              }
            }, _callee362);
          }));

          return function (_x582) {
            return _ref78.apply(this, arguments);
          };
        }(), e.onICEConnectionStateChange = function (e) {
          "connected" !== e || _this293.store.keyMetrics.iceConnectionEnd || _this293.store.iceConnectionEnd(), YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.onICEConnectionStateChange(").concat(e, ")")), rI.reportApiInvoke(_this293.store.sessionId, {
            name: "ICEConnectionStateChange",
            options: e,
            tag: og.TRACER
          }).onSuccess(), _this293.emit(fv.IceConnectionStateChange, e);
        }, e.onICETransportStateChange = function (e) {
          YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.onICETransportStateChange(").concat(e, ")"));
        }, e.onDTLSTransportStateChange = function (e) {
          YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.onDTLSTransportStateChange(").concat(e, ")"));
        }, e.onDTLSTransportError = function (e) {
          YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.onDTLSTransportError(").concat(e, ")"));
        }, e.onFirstAudioDecoded = function (e) {
          var t;
          var i = Array.from(uh(t = _this293.remoteUserMap).call(t)).find(function (t) {
            return t._audioSSRC === e;
          });
          var n;
          i && (_this293.store.subscribe(i.uid, "audio", void 0, void 0, void 0, Date.now()), null === (n = i.audioTrack) || void 0 === n || n.emit(ZA.FIRST_FRAME_DECODED), rI.firstRemoteFrame(_this293.store.sessionId, QC.FIRST_AUDIO_DECODE, ZC.FIRST_AUDIO_DECODE, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this293.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this293.store.p2pId
          }));
        }, e.onFirstAudioReceived = function (e) {
          var t;
          var i = Array.from(uh(t = _this293.remoteUserMap).call(t)).find(function (t) {
            return t._audioSSRC === e;
          });
          i && rI.firstRemoteFrame(_this293.store.sessionId, QC.FIRST_AUDIO_RECEIVED, ZC.FIRST_AUDIO_RECEIVED, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this293.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this293.store.p2pId
          });
        }, e.onFirstVideoDecoded = function (e, t, i) {
          _this293.reportVideoFirstFrameDecoded(e, t, i);
        }, e.onFirstVideoReceived = function (e) {
          var t;
          var i = Array.from(uh(t = _this293.remoteUserMap).call(t)).find(function (t) {
            return t._videoSSRC === e;
          });
          i && rI.firstRemoteFrame(_this293.store.sessionId, QC.FIRST_VIDEO_RECEIVED, ZC.FIRST_VIDEO_RECEIVED, {
            peer: i._uintid,
            subscribeElapse: TP.measureFromSubscribeStart(_this293.store.clientId, e),
            subscribeRequestid: e,
            p2pid: _this293.store.p2pId
          });
        }, e.onSelectedLocalCandidateChanged = function (e, t) {
          var i = "relay" === e.candidateType,
              n = "relay" === t.candidateType;
          "unknown" !== t.candidateType && i === n || _this293.emit(fv.ConnectionTypeChange, i), YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.SelectedLocalCandidateChanged(").concat(JSON.stringify(Dy(t)), " -> ").concat(JSON.stringify(Dy(e)), ")"));
        }, e.onSelectedRemoteCandidateChanged = function (e, t) {
          YC.info("[".concat(_this293.store.clientId, "] [p2pId: ").concat(_this293.store.p2pId, "]: P2PConnection.SelectedRemoteCandidateChanged(").concat(JSON.stringify(Dy(t)), " -> ").concat(JSON.stringify(Dy(e)), ")"));
        }, e.onFirstVideoDecodedTimeout = function (e) {
          _this293.reportVideoFirstFrameDecoded(e, void 0, void 0, !0);
        };
      }
    }, {
      key: "unbindConnectionEvents",
      value: function unbindConnectionEvents(e) {
        e.onConnectionStateChange = void 0, e.onICEConnectionStateChange = void 0, e.onICETransportStateChange = void 0, e.onDTLSTransportStateChange = void 0, e.onDTLSTransportError = void 0, e.onFirstAudioDecoded = void 0, e.onFirstAudioReceived = void 0, e.onFirstVideoDecoded = void 0, e.onFirstVideoReceived = void 0, e.onSelectedLocalCandidateChanged = void 0, e.onSelectedRemoteCandidateChanged = void 0, e.onFirstVideoDecodedTimeout = void 0;
      }
    }, {
      key: "filterTobeMutedTracks",
      value: function filterTobeMutedTracks(e) {
        var t = [];
        if (-1 === this.getAllTracks().indexOf(e)) return t;
        var i = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e instanceof cw && (null == i ? void 0 : i.track) instanceof uw) return i.track.isActive || t.push([Ev.LocalAudioTrack, i]), t;
        var n = Array.from(this.localTrackMap.entries()).find(function (t) {
          var _t296 = _slicedToArray(t, 2),
              i = _t296[1].track;

          return e === i;
        });

        if (n && (t.push(n), n[0] === Ev.LocalVideoTrack)) {
          var _e343 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

          _e343 && t.push([Ev.LocalVideoLowTrack, _e343]);
        }

        return t;
      }
    }, {
      key: "filterTobeUnmutedTracks",
      value: function filterTobeUnmutedTracks(e) {
        var t = [],
            i = this.localTrackMap.get(Ev.LocalAudioTrack);
        if (e instanceof cw && (null == i ? void 0 : i.track) instanceof uw) return i.track.isActive && t.push([Ev.LocalAudioTrack, i]), t;
        var n = Array.from(this.localTrackMap.entries()).find(function (t) {
          var _t297 = _slicedToArray(t, 2),
              i = _t297[1].track;

          return e === i;
        });
        if (n) if (n[0] === Ev.LocalVideoTrack) {
          t.push(n);

          var _e344 = this.localTrackMap.get(Ev.LocalVideoLowTrack);

          _e344 && t.push([Ev.LocalVideoLowTrack, _e344]);
        } else t.push(n);
        return t;
      }
    }, {
      key: "createMuteMessage",
      value: function createMuteMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e345 = _slicedToArray(e, 2),
              n = _e345[0],
              _e345$ = _e345[1],
              s = _e345$.track,
              r = _e345$.ssrcs,
              o = _e345$.id;

          switch (n) {
            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "createUnmuteMessage",
      value: function createUnmuteMessage(e) {
        return e.map(function (e) {
          var t;

          var i,
              _e346 = _slicedToArray(e, 2),
              n = _e346[0],
              _e346$ = _e346[1],
              s = _e346$.track,
              r = _e346$.ssrcs,
              o = _e346$.id;

          switch (n) {
            case Ev.LocalAudioTrack:
              i = ev.Audio;
              break;

            case Ev.LocalVideoTrack:
              i = bn(t = s._hints).call(t, YA.SCREEN_TRACK) ? ev.Screen : ev.High;
              break;

            case Ev.LocalVideoLowTrack:
              i = ev.Low;
          }

          return {
            stream_type: i,
            ssrcs: r,
            mid: o
          };
        });
      }
    }, {
      key: "filterTobeUnSubscribedTracks",
      value: function filterTobeUnSubscribedTracks(e, t) {
        var i = [],
            n = this.remoteUserMap.get(e);
        if (!n) return i;

        if (t) {
          var _s97 = n.get(t);

          if (!_s97) return i;
          i.push([e, {
            kind: t,
            id: _s97
          }]);
        } else Array.from(n.entries()).forEach(function (t) {
          var _t298 = _slicedToArray(t, 2),
              n = _t298[0],
              s = _t298[1];

          i.push([e, {
            kind: n,
            id: s
          }]);
        });

        return i;
      }
    }, {
      key: "filterTobeUnSubscribedDataChannels",
      value: function filterTobeUnSubscribedDataChannels(e, t) {
        var _this294 = this;

        var i = [];
        return t.forEach(function (t) {
          var n;
          null !== (n = _this294.remoteDataChannelMap.get(e)) && void 0 !== n && n.has(t.id) && i.push(t);
        }), i;
      }
    }, {
      key: "createUnsubscribeMessage",
      value: function createUnsubscribeMessage(e) {
        var t = [];
        return e.forEach(function (e) {
          var _e347 = _slicedToArray(e, 2),
              i = _e347[0],
              _e347$ = _e347[1],
              n = _e347$.kind,
              s = _e347$.id;

          switch (n) {
            case hv.VIDEO:
              return void (i._videoSSRC && t.push({
                stream_type: hv.VIDEO,
                ssrcId: i._videoSSRC
              }));

            case hv.AUDIO:
              return void (i._audioSSRC && t.push({
                stream_type: hv.AUDIO,
                ssrcId: i._audioSSRC
              }));
          }
        }), t;
      }
    }, {
      key: "createUnsubscribeAllMessage",
      value: function createUnsubscribeAllMessage(e) {
        var t = new Map();
        return e.forEach(function (e) {
          var _e348 = _slicedToArray(e, 2),
              i = _e348[0],
              n = _e348[1].kind;

          if (t.has(i)) {
            var _e349 = t.get(i);

            n === hv.VIDEO ? _e349 |= nv.Video : _e349 |= nv.Audio, t.set(i, _e349);
          } else n === hv.VIDEO ? t.set(i, nv.Video) : t.set(i, nv.Audio);
        }), {
          users: Array.from(t.entries()).map(function (e) {
            var _e350 = _slicedToArray(e, 2),
                t = _e350[0],
                i = _e350[1];

            return {
              stream_id: t.uid,
              stream_type: i
            };
          })
        };
      }
    }, {
      key: "withdrawRemoteTracks",
      value: function withdrawRemoteTracks(e) {
        var _this295 = this;

        e.forEach(function (e) {
          var _e351 = _slicedToArray(e, 2),
              t = _e351[0],
              i = _e351[1].kind;

          var n = _this295.remoteUserMap.get(t);

          n && (n.delete(i), 0 === Array.from(n.entries()).length && _this295.remoteUserMap.delete(t));
        });
      }
    }, {
      key: "updateBitrateLimit",
      value: function () {
        var _updateBitrateLimit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee363(e) {
          var t, i;
          return _regeneratorRuntime.wrap(function _callee363$(_context363) {
            while (1) {
              switch (_context363.prev = _context363.next) {
                case 0:
                  t = this.localTrackMap.get(Ev.LocalVideoTrack), i = this.localTrackMap.get(Ev.LocalVideoLowTrack);
                  _context363.t0 = t;

                  if (!_context363.t0) {
                    _context363.next = 5;
                    break;
                  }

                  _context363.next = 5;
                  return t.track.setBitrateLimit(e.uplink);

                case 5:
                  _context363.t1 = i && e.low_stream_uplink;

                  if (!_context363.t1) {
                    _context363.next = 9;
                    break;
                  }

                  _context363.next = 9;
                  return i.track.setBitrateLimit({
                    max_bitrate: e.low_stream_uplink.bitrate,
                    min_bitrate: e.low_stream_uplink.bitrate || 0
                  });

                case 9:
                case "end":
                  return _context363.stop();
              }
            }
          }, _callee363, this);
        }));

        function updateBitrateLimit(_x583) {
          return _updateBitrateLimit2.apply(this, arguments);
        }

        return updateBitrateLimit;
      }()
    }, {
      key: "isP2PDisconnected",
      value: function isP2PDisconnected() {
        if (this.connection) {
          return "connected" !== this.connection.peerConnectionState;
        }

        return !0;
      }
    }, {
      key: "mapPubResToRemoteConfig",
      value: function mapPubResToRemoteConfig(e, t) {
        return e.map(function (e, i) {
          var n;
          var s = e.stream_type;
          return null === (n = t.find(function (e) {
            var t = e.stream_type;
            return s === t;
          })) || void 0 === n ? void 0 : n.attributes;
        });
      }
    }, {
      key: "tryToUnmuteAudio",
      value: function () {
        var _tryToUnmuteAudio2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee364(e) {
          var i, t, _n141, _s98;

          return _regeneratorRuntime.wrap(function _callee364$(_context364) {
            while (1) {
              switch (_context364.prev = _context364.next) {
                case 0:
                  i = 0;

                case 1:
                  if (!(i < e.length)) {
                    _context364.next = 15;
                    break;
                  }

                  if (!(e[i] instanceof cw)) {
                    _context364.next = 12;
                    break;
                  }

                  _n141 = this.filterTobeUnmutedTracks(e[i]);

                  if (!(0 === _n141.length)) {
                    _context364.next = 6;
                    break;
                  }

                  return _context364.abrupt("continue", 12);

                case 6:
                  _context364.next = 8;
                  return null === (t = this.connection) || void 0 === t ? void 0 : t.unmuteLocal(_n141.map(function (e) {
                    var _e352 = _slicedToArray(e, 2),
                        t = _e352[1].id;

                    return t;
                  }));

                case 8:
                  _s98 = this.createUnmuteMessage(_n141);
                  _context364.next = 11;
                  return Tg(this, fv.RequestUnmuteLocal, _s98);

                case 11:
                  return _context364.abrupt("return", void _context364.sent);

                case 12:
                  i++;
                  _context364.next = 1;
                  break;

                case 15:
                case "end":
                  return _context364.stop();
              }
            }
          }, _callee364, this);
        }));

        function tryToUnmuteAudio(_x584) {
          return _tryToUnmuteAudio2.apply(this, arguments);
        }

        return tryToUnmuteAudio;
      }()
    }, {
      key: "bindStatsUploaderEvents",
      value: function bindStatsUploaderEvents() {
        var _this296 = this;

        this.statsUploader.requestStats = function () {
          return _this296.getStats();
        }, this.statsUploader.requestLocalMedia = function () {
          return Array.from(_this296.localTrackMap.entries());
        }, this.statsUploader.requestRemoteMedia = function () {
          return Array.from(_this296.remoteUserMap.entries());
        }, this.statsUploader.requestVideoIsReady = function (e) {
          var t;
          return !(null === (t = _this296.connection) || void 0 === t || !t.getRemoteVideoIsReady(e));
        }, this.statsUploader.requestUpload = function (e, t) {
          return _this296.emit(fv.RequestUpload, e, t);
        }, this.statsUploader.requestUploadStats = function (e) {
          return _this296.emit(fv.RequestUploadStats, e);
        }, this.statsUploader.requestAllTracks = function () {
          return _this296.getAllTracks();
        };
      }
    }, {
      key: "unbindStatsUploaderEvents",
      value: function unbindStatsUploaderEvents() {
        this.statsUploader.requestStats = void 0, this.statsUploader.requestLocalMedia = void 0, this.statsUploader.requestRemoteMedia = void 0, this.statsUploader.requestVideoIsReady = void 0;
      }
    }, {
      key: "requestReconnect",
      value: function () {
        var _requestReconnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee365() {
          return _regeneratorRuntime.wrap(function _callee365$(_context365) {
            while (1) {
              switch (_context365.prev = _context365.next) {
                case 0:
                  this.dtlsFailedCount += 1;
                  _context365.next = 3;
                  return Ug(zg(this.dtlsFailedCount, Jg));

                case 3:
                  this.emit(fv.RequestReconnect);

                case 4:
                case "end":
                  return _context365.stop();
              }
            }
          }, _callee365, this);
        }));

        function requestReconnect() {
          return _requestReconnect2.apply(this, arguments);
        }

        return requestReconnect;
      }()
    }, {
      key: "reconnectP2P",
      value: function () {
        var _reconnectP2P2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee366() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee366$(_context366) {
            while (1) {
              switch (_context366.prev = _context366.next) {
                case 0:
                  e = Array.from(this.localTrackMap.entries()), t = this.createGatewayUnpublishMessage(e);
                  Array.from(this.remoteUserMap.entries());
                  _context366.t0 = t.length > 0;

                  if (!_context366.t0) {
                    _context366.next = 6;
                    break;
                  }

                  _context366.next = 6;
                  return fg(this, fv.RequestUnpublishForReconnectPC, t);

                case 6:
                  this.disconnectForReconnect();
                  this.emit(fv.RequestReconnectPC);

                case 8:
                case "end":
                  return _context366.stop();
              }
            }
          }, _callee366, this);
        }));

        function reconnectP2P() {
          return _reconnectP2P2.apply(this, arguments);
        }

        return reconnectP2P;
      }()
    }, {
      key: "canPublishLowStream",
      value: function canPublishLowStream() {
        return this.localTrackMap.has(Ev.LocalVideoTrack) || this.pendingLocalTracks.some(function (e) {
          return e instanceof Nw;
        });
      }
    }, {
      key: "throwIfTrackTypeNotMatch",
      value: function throwIfTrackTypeNotMatch(e) {
        if (e.filter(function (e) {
          return e instanceof Nw;
        }).length > 1) throw new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
        if (e.filter(function (e) {
          return e instanceof cw;
        }).length > 1 && (e.some(function (e) {
          return e instanceof cw && e._bypassWebAudio;
        }) || !wA().webAudioMediaStreamDest)) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");

        var _iterator43 = _createForOfIteratorHelper(e),
            _step43;

        try {
          for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
            var _t299 = _step43.value;
            if (_t299 instanceof Nw && this.pendingLocalTracks.some(function (e) {
              return e instanceof Nw;
            })) throw new VT(xT.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
            if (_t299 instanceof cw && this.pendingLocalTracks.some(function (e) {
              return e instanceof cw;
            }) && (!wA().webAudioMediaStreamDest || _t299._bypassWebAudio || this.pendingLocalTracks.some(function (e) {
              return e instanceof cw && e._bypassWebAudio;
            }))) throw new VT(xT.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
          }
        } catch (err) {
          _iterator43.e(err);
        } finally {
          _iterator43.f();
        }
      }
    }, {
      key: "getLowVideoTrack",
      value: function getLowVideoTrack(e, t) {
        var i = !DC("DISABLE_DUAL_STREAM_USE_ENCODING") && wA().supportDualStreamEncoding,
            n = eM(eM({}, {
          width: 160,
          height: 120,
          framerate: 15,
          bitrate: 50
        }), t);
        var s;
        s = i ? e._mediaStreamTrack.clone() : FL(e, n);
        var r = xg(8, "track-low-"),
            o = new Nw(s, eM(eM({}, i && {
          scaleResolutionDownBy: Ny(n, e)
        }), {}, {
          frameRate: n.framerate,
          bitrateMax: n.bitrate,
          bitrateMin: n.bitrate
        }), void 0, void 0, r);
        return o.on(XA.TRANSCEIVER_UPDATED, function (t) {
          e._updateRtpTransceiver(t, qA.LOW_STREAM);
        }), o._hints.push(YA.LOW_STREAM), e.addListener(KA.NEED_CLOSE, function () {
          o.close();
        }), o;
      }
    }, {
      key: "globalLock",
      value: function () {
        var _globalLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee367() {
          return _regeneratorRuntime.wrap(function _callee367$(_context367) {
            while (1) {
              switch (_context367.prev = _context367.next) {
                case 0:
                  return _context367.abrupt("return", this.mutex.lock("From P2PChannel.globalLock"));

                case 1:
                case "end":
                  return _context367.stop();
              }
            }
          }, _callee367, this);
        }));

        function globalLock() {
          return _globalLock2.apply(this, arguments);
        }

        return globalLock;
      }()
    }, {
      key: "reportPCStats",
      value: function () {
        var _reportPCStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee368(e, t, i) {
          var n,
              s,
              r,
              o,
              a,
              c,
              _this$connection,
              _d19,
              _l16,
              _u8,
              _yield$this$connectio,
              _h8,
              _p7,
              _args368 = arguments;

          return _regeneratorRuntime.wrap(function _callee368$(_context368) {
            while (1) {
              switch (_context368.prev = _context368.next) {
                case 0:
                  n = _args368.length > 3 && void 0 !== _args368[3] ? _args368[3] : null;

                  if (!(this.connection && this.connection instanceof Uk)) {
                    _context368.next = 13;
                    break;
                  }

                  c = this.store.keyMetrics.descriptionStart || 0;
                  _this$connection = this.connection;
                  _d19 = _this$connection.iceConnectionState;
                  _l16 = _this$connection.dtlsTransportState;
                  _u8 = _this$connection.peerConnectionState;
                  _context368.next = 9;
                  return this.connection.getSelectedCandidatePair();

                case 9:
                  _yield$this$connectio = _context368.sent;
                  _h8 = _yield$this$connectio.local;
                  _p7 = _yield$this$connectio.remote;
                  rI.pcStats(this.store.sessionId, {
                    startTime: c,
                    eventElapse: e - c || 0,
                    iceconnectionsate: _d19,
                    dtlsstate: _l16,
                    connectionstate: _u8,
                    intSucc: t ? 1 : 2,
                    error: n,
                    selectedLocalCandidateProtocol: null !== (s = null == _h8 ? void 0 : _h8.protocol) && void 0 !== s ? s : "",
                    selectedLocalCandidateType: null !== (r = _h8.candidateType) && void 0 !== r ? r : "",
                    selectedLocalCandidateAddress: "".concat(_h8.address, ":").concat(_h8.port),
                    selectedRemoteCandidateProtocol: null !== (o = _p7.protocol) && void 0 !== o ? o : "",
                    selectedRemoteCandidateType: null !== (a = _p7.candidateType) && void 0 !== a ? a : "",
                    selectedRemoteCandidateAddress: "".concat(_p7.address, ":").concat(_p7.port),
                    restartCnt: i
                  });

                case 13:
                case "end":
                  return _context368.stop();
              }
            }
          }, _callee368, this);
        }));

        function reportPCStats(_x585, _x586, _x587) {
          return _reportPCStats.apply(this, arguments);
        }

        return reportPCStats;
      }()
    }, {
      key: "reportVideoFirstFrameDecoded",
      value: function reportVideoFirstFrameDecoded(e, t, i, n) {
        var s;
        var r = Array.from(uh(s = this.remoteUserMap).call(s)).find(function (t) {
          return t._videoSSRC === e;
        });

        if (r) {
          n || this.store.subscribe(r.uid, "video", void 0, void 0, void 0, void 0, Date.now());

          var _s99 = this.store.keyMetrics,
              _o50 = _s99.subscribe.find(function (e) {
            return e.userId === r.uid && "video" === e.type;
          });

          rI.firstRemoteVideoDecode(this.store.sessionId, QC.FIRST_VIDEO_DECODE, ZC.FIRST_VIDEO_DECODE, {
            peer: r._uintid,
            videowidth: t,
            videoheight: i,
            subscribeElapse: TP.measureFromSubscribeStart(this.store.clientId, e),
            subscribeRequestid: e,
            p2pid: this.store.p2pId,
            apEnd: _s99.requestAPEnd || 0,
            apStart: _s99.requestAPStart || 0,
            joinGwEnd: _s99.joinGatewayEnd || 0,
            joinGwStart: _s99.joinGatewayStart || 0,
            pcEnd: _s99.peerConnectionEnd || 0,
            pcStart: _s99.peerConnectionStart || 0,
            subscriberEnd: (null == _o50 ? void 0 : _o50.subscribeEnd) || 0,
            subscriberStart: (null == _o50 ? void 0 : _o50.subscribeStart) || 0,
            videoAddNotify: (null == _o50 ? void 0 : _o50.streamAdded) || 0,
            state: n ? 1 : 0
          });
        }
      }
    }, {
      key: "remoteMediaSsrcChanged",
      value: function () {
        var _remoteMediaSsrcChanged2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee369(e, t, i) {
          var n, s, r;
          return _regeneratorRuntime.wrap(function _callee369$(_context369) {
            while (1) {
              switch (_context369.prev = _context369.next) {
                case 0:
                  if (this.connection) {
                    _context369.next = 2;
                    break;
                  }

                  return _context369.abrupt("return", !1);

                case 2:
                  n = this.remoteUserMap.get(e);

                  if (n) {
                    _context369.next = 5;
                    break;
                  }

                  return _context369.abrupt("return", !1);

                case 5:
                  s = n.get(t);

                  if (s) {
                    _context369.next = 8;
                    break;
                  }

                  return _context369.abrupt("return", !1);

                case 8:
                  _context369.next = 10;
                  return this.connection.getRemoteSSRC(s);

                case 10:
                  r = _context369.sent;
                  return _context369.abrupt("return", void 0 !== r && r !== i);

                case 12:
                case "end":
                  return _context369.stop();
              }
            }
          }, _callee369, this);
        }));

        function remoteMediaSsrcChanged(_x588, _x589, _x590) {
          return _remoteMediaSsrcChanged2.apply(this, arguments);
        }

        return remoteMediaSsrcChanged;
      }()
    }, {
      key: "resetConnection",
      value: function resetConnection(e) {
        YC.debug("[".concat(this.store.clientId, "] [P2PChannel] reset connection to ").concat(e)), this.state === mv.Connected ? (YC.debug("[".concat(this.store.clientId, "] [P2PChannel] fallback to websocket but P2PChannel state still connected, disconnect first")), this.disconnectForReconnect()) : (this.connection && (this.connection.close(), this.unbindConnectionEvents(this.connection), this.connection = void 0), this.shouldForwardP2PCreation && (this.connection = e === sv.datachannel ? new Qk({}, this.store) : this.isPlanB ? new wk({}, this.store) : new Uk({}, this.store), this.bindConnectionEvents(this.connection)));
      }
    }, {
      key: "unbindRtpTransceiver",
      value: function unbindRtpTransceiver() {
        0 !== this.localTrackMap.size && Array.from(this.localTrackMap.entries()).forEach(function (e) {
          var _e353 = _slicedToArray(e, 2),
              t = _e353[0],
              i = _e353[1].track;

          t === Ev.LocalVideoLowTrack ? i._updateRtpTransceiver(void 0, qA.LOW_STREAM) : i._updateRtpTransceiver(void 0);
        });
      }
    }, {
      key: "reportPCDisconnectedOrFailed",
      value: function reportPCDisconnectedOrFailed(e) {
        this.connection && this.connection instanceof Uk && ("disconnected" !== this.connection.iceConnectionState && "checking" !== this.connection.iceConnectionState && "failed" !== this.connection.iceConnectionState || (this._isFirstConnected ? (this.reportPCStats(Date.now(), !1, this._pcStatsUploadType), this._isFirstConnected = !1) : this._pcStatsUploadType === _v.TCP_RESTART && e === pv.RELAY ? this.reportPCStats(Date.now(), !1, this._pcStatsUploadType) : this.reportPCStats(Date.now(), !1, _v.DISCONNECTED_OR_FAILED)));
      }
    }]);

    return nM;
  }(ig);

  function sM(e, t, i) {
    var n = e[t];
    if ("function" != typeof n) throw new Error("Cannot use mutex on object property.");
    return i.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee370() {
      var e,
          i,
          s,
          r,
          o,
          _args370 = arguments;
      return _regeneratorRuntime.wrap(function _callee370$(_context370) {
        while (1) {
          switch (_context370.prev = _context370.next) {
            case 0:
              e = this.mutex;
              _context370.next = 3;
              return e.lock("From P2PChannel.".concat(t));

            case 3:
              i = _context370.sent;
              _context370.prev = 4;

              for (s = _args370.length, r = new Array(s), o = 0; o < s; o++) {
                r[o] = _args370[o];
              }

              _context370.next = 8;
              return n.apply(this, r);

            case 8:
              return _context370.abrupt("return", _context370.sent);

            case 9:
              _context370.prev = 9;
              i();
              return _context370.finish(9);

            case 12:
            case "end":
              return _context370.stop();
          }
        }
      }, _callee370, this, [[4,, 9, 12]]);
    })), i;
  }

  function rM(e) {
    var t = mM();
    return function (e, t) {
      var i = e.appId;
      void 0 !== i && (NM(t, 10), IM(t, i));
      var n = e.cid;
      void 0 !== n && (NM(t, 16), NM(t, n));
      var s = e.cname;
      void 0 !== s && (NM(t, 26), IM(t, s));
      var r = e.deviceId;
      void 0 !== r && (NM(t, 34), IM(t, r));
      var o = e.elapse;
      void 0 !== o && (NM(t, 40), DM(t, o));
      var a = e.fileSize;
      void 0 !== a && (NM(t, 48), DM(t, _M(a)));
      var c = e.height;
      void 0 !== c && (NM(t, 56), DM(t, _M(c)));
      var d = e.jpg;
      void 0 !== d && (NM(t, 66), NM(t, d.length), function (e, t) {
        var i = SM(e, t.length);
        e.bytes.set(t, i);
      }(t, d));
      var l = e.networkType;
      void 0 !== l && (NM(t, 72), DM(t, _M(l)));
      var u = e.osType;
      void 0 !== u && (NM(t, 80), DM(t, _M(u)));
      var h = e.requestId;
      void 0 !== h && (NM(t, 90), IM(t, h));
      var p = e.sdkVersion;
      void 0 !== p && (NM(t, 98), IM(t, p));
      var _ = e.sequence;
      void 0 !== _ && (NM(t, 104), DM(t, _M(_)));
      var E = e.sid;
      void 0 !== E && (NM(t, 114), IM(t, E));
      var m = e.timestamp;
      void 0 !== m && (NM(t, 120), DM(t, m));
      var f = e.uid;
      void 0 !== f && (NM(t, 128), NM(t, f));
      var T = e.vid;
      void 0 !== T && (NM(t, 136), NM(t, T));
      var g = e.width;
      void 0 !== g && (NM(t, 144), DM(t, _M(g)));
      var S = e.service;
      void 0 !== S && (NM(t, 152), NM(t, S));
      var R = e.callbackData;
      void 0 !== R && (NM(t, 162), IM(t, R));
      var C = e.jpgEncryption;
      void 0 !== C && (NM(t, 168), NM(t, C));
      var I = e.requestType;
      void 0 !== I && (NM(t, 176), NM(t, I));
      var v = e.scorePorn;
      void 0 !== v && (NM(t, 185), wM(t, v));
      var y = e.scoreSexy;
      void 0 !== y && (NM(t, 193), wM(t, y));
      var A = e.scoreNeutral;
      void 0 !== A && (NM(t, 201), wM(t, A));
      var b = e.scene;
      void 0 !== b && (NM(t, 208), NM(t, b));
      var w = e.ossFilePrefix;
      void 0 !== w && (NM(t, 218), IM(t, w));
      var O = e.serviceVendor;

      if (void 0 !== O) {
        var _iterator44 = _createForOfIteratorHelper(O),
            _step44;

        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var _e354 = _step44.value;
            NM(t, 226);

            var _i156 = mM();

            cM(_e354, _i156), NM(t, _i156.limit), vM(t, _i156), fM(_i156);
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
      }
    }(e, t), function (e) {
      var t = e.bytes,
          i = e.limit;
      return t.length === i ? t : t.subarray(0, i);
    }(t);
  }

  function oM(e) {
    return function (e) {
      var t = {};

      e: for (; !gM(e);) {
        var i = OM(e);

        switch (i >>> 3) {
          case 0:
            break e;

          case 1:
            t.code = OM(e);
            break;

          case 2:
            t.msg = CM(e, OM(e));
            break;

          case 3:
            {
              var _i157 = dM(e);

              t.data = aM(e), e.limit = _i157;
              break;
            }

          default:
            lM(e, 7 & i);
        }
      }

      return t;
    }({
      bytes: t = e,
      offset: 0,
      limit: t.length
    });
    var t;
  }

  function aM(e) {
    var t = {};

    e: for (; !gM(e);) {
      var i = OM(e);

      switch (i >>> 3) {
        case 0:
          break e;

        case 1:
          t.requestId = CM(e, OM(e));
          break;

        case 2:
          t.requestType = OM(e) >>> 0;
          break;

        case 3:
          t.scorePorn = bM(e);
          break;

        case 4:
          t.scoreSexy = bM(e);
          break;

        case 5:
          t.scoreNeutral = bM(e);
          break;

        case 6:
          t.requestScene = OM(e) >>> 0;
          break;

        case 7:
          t.scene = OM(e) >>> 0;
          break;

        default:
          lM(e, 7 & i);
      }
    }

    return t;
  }

  function cM(e, t) {
    var i = e.service;
    void 0 !== i && (NM(t, 8), NM(t, i));
    var n = e.vendor;
    void 0 !== n && (NM(t, 16), NM(t, n));
    var s = e.token;
    void 0 !== s && (NM(t, 26), IM(t, s));
    var r = e.callbackUrl;
    void 0 !== r && (NM(t, 34), IM(t, r));
  }

  function dM(e) {
    var t = OM(e),
        i = e.limit;
    return e.limit = e.offset + t, i;
  }

  function lM(e, t) {
    switch (t) {
      case 0:
        for (; 128 & yM(e);) {
          ;
        }

        break;

      case 2:
        TM(e, OM(e));
        break;

      case 5:
        TM(e, 4);
        break;

      case 1:
        TM(e, 8);
        break;

      default:
        throw new Error("Unimplemented type: " + t);
    }
  }

  UI([sM, xI("design:type", Function), xI("design:paramtypes", [Object, Boolean]), xI("design:returntype", tT)], nM.prototype, "startP2PConnection", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], nM.prototype, "connect", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", void 0)], nM.prototype, "updateRemoteRTPCapabilities", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Object, Object, Array, Object, String, String]), xI("design:returntype", tT)], nM.prototype, "preConnect", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], nM.prototype, "publishDataChannel", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], nM.prototype, "unpublish", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], nM.prototype, "unpublishDataChannel", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], nM.prototype, "unpublishLowStream", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, Array]), xI("design:returntype", tT)], nM.prototype, "subscribeDataChannel", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String, Number, Number, Array]), xI("design:returntype", tT)], nM.prototype, "subscribe", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], nM.prototype, "massSubscribe", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String, Boolean]), xI("design:returntype", tT)], nM.prototype, "unsubscribe", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, Array]), xI("design:returntype", tT)], nM.prototype, "unsubscribeDataChannel", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], nM.prototype, "massUnsubscribe", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], nM.prototype, "muteRemote", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], nM.prototype, "unmuteRemote", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String]), xI("design:returntype", tT)], nM.prototype, "hasRemoteMediaWithLock", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], nM.prototype, "disconnectForReconnect", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], nM.prototype, "updateBitrateLimit", null), UI([sM, xI("design:type", Function), xI("design:paramtypes", [ik, String, Number]), xI("design:returntype", tT)], nM.prototype, "remoteMediaSsrcChanged", null);
  var uM = new Float32Array(1);
  new Uint8Array(uM.buffer);
  var hM = new Float64Array(1),
      pM = new Uint8Array(hM.buffer);

  function _M(e) {
    return {
      low: e |= 0,
      high: e >> 31,
      unsigned: e >= 0
    };
  }

  var EM = [];

  function mM() {
    var e = EM.pop();
    return e ? (e.offset = e.limit = 0, e) : {
      bytes: new Uint8Array(64),
      offset: 0,
      limit: 0
    };
  }

  function fM(e) {
    EM.push(e);
  }

  function TM(e, t) {
    if (e.offset + t > e.limit) throw new Error("Skip past limit");
    e.offset += t;
  }

  function gM(e) {
    return e.offset >= e.limit;
  }

  function SM(e, t) {
    var i = e.bytes,
        n = e.offset,
        s = e.limit,
        r = n + t;

    if (r > i.length) {
      var _t300 = new Uint8Array(2 * r);

      _t300.set(i), e.bytes = _t300;
    }

    return e.offset = r, r > s && (e.limit = r), n;
  }

  function RM(e, t) {
    var i = e.offset;
    if (i + t > e.limit) throw new Error("Read past limit");
    return e.offset += t, i;
  }

  function CM(e, t) {
    var i = RM(e, t),
        n = String.fromCharCode,
        s = e.bytes,
        r = "�",
        o = "";

    for (var _e355 = 0; _e355 < t; _e355++) {
      var _a29 = void 0,
          c = void 0,
          _d20 = void 0,
          _l17 = void 0,
          _u9 = s[_e355 + i];

      0 == (128 & _u9) ? o += n(_u9) : 192 == (224 & _u9) ? _e355 + 1 >= t ? o += r : (_a29 = s[_e355 + i + 1], 128 != (192 & _a29) ? o += r : (_l17 = (31 & _u9) << 6 | 63 & _a29, _l17 < 128 ? o += r : (o += n(_l17), _e355++))) : 224 == (240 & _u9) ? _e355 + 2 >= t ? o += r : (_a29 = s[_e355 + i + 1], c = s[_e355 + i + 2], 32896 != (49344 & (_a29 | c << 8)) ? o += r : (_l17 = (15 & _u9) << 12 | (63 & _a29) << 6 | 63 & c, _l17 < 2048 || _l17 >= 55296 && _l17 <= 57343 ? o += r : (o += n(_l17), _e355 += 2))) : 240 == (248 & _u9) ? _e355 + 3 >= t ? o += r : (_a29 = s[_e355 + i + 1], c = s[_e355 + i + 2], _d20 = s[_e355 + i + 3], 8421504 != (12632256 & (_a29 | c << 8 | _d20 << 16)) ? o += r : (_l17 = (7 & _u9) << 18 | (63 & _a29) << 12 | (63 & c) << 6 | 63 & _d20, _l17 < 65536 || _l17 > 1114111 ? o += r : (_l17 -= 65536, o += n(55296 + (_l17 >> 10), 56320 + (1023 & _l17)), _e355 += 3))) : o += r;
    }

    return o;
  }

  function IM(e, t) {
    var i = t.length,
        n = 0;

    for (var _e356 = 0; _e356 < i; _e356++) {
      var _s100 = t.charCodeAt(_e356);

      _s100 >= 55296 && _s100 <= 56319 && _e356 + 1 < i && (_s100 = (_s100 << 10) + t.charCodeAt(++_e356) - 56613888), n += _s100 < 128 ? 1 : _s100 < 2048 ? 2 : _s100 < 65536 ? 3 : 4;
    }

    NM(e, n);
    var s = SM(e, n),
        r = e.bytes;

    for (var _e357 = 0; _e357 < i; _e357++) {
      var _n142 = t.charCodeAt(_e357);

      _n142 >= 55296 && _n142 <= 56319 && _e357 + 1 < i && (_n142 = (_n142 << 10) + t.charCodeAt(++_e357) - 56613888), _n142 < 128 ? r[s++] = _n142 : (_n142 < 2048 ? r[s++] = _n142 >> 6 & 31 | 192 : (_n142 < 65536 ? r[s++] = _n142 >> 12 & 15 | 224 : (r[s++] = _n142 >> 18 & 7 | 240, r[s++] = _n142 >> 12 & 63 | 128), r[s++] = _n142 >> 6 & 63 | 128), r[s++] = 63 & _n142 | 128);
    }
  }

  function vM(e, t) {
    var i = SM(e, t.limit),
        n = e.bytes,
        s = t.bytes;

    for (var _e358 = 0, _r67 = t.limit; _e358 < _r67; _e358++) {
      n[_e358 + i] = s[_e358];
    }
  }

  function yM(e) {
    return e.bytes[RM(e, 1)];
  }

  function AM(e, t) {
    var i = SM(e, 1);
    e.bytes[i] = t;
  }

  function bM(e) {
    var t = RM(e, 8),
        i = e.bytes;
    return pM[0] = i[t++], pM[1] = i[t++], pM[2] = i[t++], pM[3] = i[t++], pM[4] = i[t++], pM[5] = i[t++], pM[6] = i[t++], pM[7] = i[t++], hM[0];
  }

  function wM(e, t) {
    var i = SM(e, 8),
        n = e.bytes;
    hM[0] = t, n[i++] = pM[0], n[i++] = pM[1], n[i++] = pM[2], n[i++] = pM[3], n[i++] = pM[4], n[i++] = pM[5], n[i++] = pM[6], n[i++] = pM[7];
  }

  function OM(e) {
    var t,
        i = 0,
        n = 0;

    do {
      t = yM(e), i < 32 && (n |= (127 & t) << i), i += 7;
    } while (128 & t);

    return n;
  }

  function NM(e, t) {
    for (t >>>= 0; t >= 128;) {
      AM(e, 127 & t | 128), t >>>= 7;
    }

    AM(e, t);
  }

  function DM(e, t) {
    var i = t.low >>> 0,
        n = (t.low >>> 28 | t.high << 4) >>> 0,
        s = t.high >>> 24,
        r = 0 === s ? 0 === n ? i < 16384 ? i < 128 ? 1 : 2 : i < 1 << 21 ? 3 : 4 : n < 16384 ? n < 128 ? 5 : 6 : n < 1 << 21 ? 7 : 8 : s < 128 ? 9 : 10,
        o = SM(e, r),
        a = e.bytes;

    switch (r) {
      case 10:
        a[o + 9] = s >>> 7 & 1;

      case 9:
        a[o + 8] = 9 !== r ? 128 | s : 127 & s;

      case 8:
        a[o + 7] = 8 !== r ? n >>> 21 | 128 : n >>> 21 & 127;

      case 7:
        a[o + 6] = 7 !== r ? n >>> 14 | 128 : n >>> 14 & 127;

      case 6:
        a[o + 5] = 6 !== r ? n >>> 7 | 128 : n >>> 7 & 127;

      case 5:
        a[o + 4] = 5 !== r ? 128 | n : 127 & n;

      case 4:
        a[o + 3] = 4 !== r ? i >>> 21 | 128 : i >>> 21 & 127;

      case 3:
        a[o + 2] = 3 !== r ? i >>> 14 | 128 : i >>> 14 & 127;

      case 2:
        a[o + 1] = 2 !== r ? i >>> 7 | 128 : i >>> 7 & 127;

      case 1:
        a[o] = 1 !== r ? 128 | i : 127 & i;
    }
  }

  function PM(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  var LM = new Map([["moderation", 1], ["supervise", 2]]);

  var kM = /*#__PURE__*/function (_ig32) {
    _inherits(kM, _ig32);

    var _super67 = _createSuper(kM);

    function kM(e) {
      var _this297;

      _classCallCheck(this, kM);

      _this297 = _super67.call(this), nh(_assertThisInitialized(_this297), "name", "AgoraRTCVideoContentInspect"), nh(_assertThisInitialized(_this297), "_connectionState", gv.CONNECTING), nh(_assertThisInitialized(_this297), "_innerConnectionState", void 0), nh(_assertThisInitialized(_this297), "sequence", 0), nh(_assertThisInitialized(_this297), "inspectStartTime", void 0), nh(_assertThisInitialized(_this297), "workerManagerConnection", void 0), nh(_assertThisInitialized(_this297), "workerConnection", void 0), nh(_assertThisInitialized(_this297), "workerMessageLengthLimit", void 0), nh(_assertThisInitialized(_this297), "inspectIntervalMinimum", void 0), nh(_assertThisInitialized(_this297), "qualityRatio", void 0), nh(_assertThisInitialized(_this297), "_connectInfo", void 0), nh(_assertThisInitialized(_this297), "_cancelTokenSource", EC.CancelToken.source()), nh(_assertThisInitialized(_this297), "_retryConfig", void 0), nh(_assertThisInitialized(_this297), "wmSequence", 0), nh(_assertThisInitialized(_this297), "inspectInterval", void 0), nh(_assertThisInitialized(_this297), "inspectTimer", null), nh(_assertThisInitialized(_this297), "ossFilePrefix", void 0), nh(_assertThisInitialized(_this297), "extraInfo", void 0), nh(_assertThisInitialized(_this297), "_inspectType", void 0), nh(_assertThisInitialized(_this297), "_inspectMode", void 0), nh(_assertThisInitialized(_this297), "_quality", 1), nh(_assertThisInitialized(_this297), "qualityTimer", null), nh(_assertThisInitialized(_this297), "_inspectId", void 0), nh(_assertThisInitialized(_this297), "_needWorkUrlOnly", !1), nh(_assertThisInitialized(_this297), "inspectImage", function () {
        if (_this297.connectionState !== gv.CONNECTED) throw new VI(xT.OPERATION_ABORTED, "content inspect service connection status is ".concat(_this297.connectionState));
        _this297.inspectTimer && (window.clearInterval(_this297.inspectTimer), _this297.inspectTimer = null), _this297.inspectTimer = window.setInterval(function () {
          _this297.connectionState === gv.CONNECTED ? _this297.requestToInspectImage() : YC.debug("[".concat(_this297._inspectId, "] Inspect State is not connected , "), _this297.connectionState);
        }, _this297.inspectInterval < _this297.inspectIntervalMinimum ? _this297.inspectIntervalMinimum : _this297.inspectInterval), _this297.requestToInspectImage();
      }), _this297._inspectId = xg(5, "inspect-"), _this297.workerMessageLengthLimit = DC("VIDEO_INSPECT_WORKER_MESSAGE_LENGTH_LIMIT"), _this297.inspectIntervalMinimum = DC("VIDEO_INSPECT_INTERVAL_MINIMUM"), _this297.qualityRatio = DC("VIDEO_INSPECT_QUALITY_RATIO"), _this297.inspectInterval = e.interval, _this297.ossFilePrefix = e.ossFilePrefix, _this297.extraInfo = e.extraInfo, _this297.inspectType = e.inspectType, _this297.inspectStartTime = Number(Date.now()), _this297.workerManagerConnection = new $v("worker-manager-" + _this297._inspectId, Jg), _this297.on(Rv.STATE_CHANGE, function (e, t) {
        _this297._innerConnectionState = e, YC.debug("[".concat(_this297._inspectId, "] Inspect operation :").concat(Sv[e], " ").concat(t || ""));
      }), _this297.handleWorkerManagerEvents(), _this297.workerConnection = new $v("worker-" + _this297._inspectId, Jg), _this297.handleWorkerEvents();
      return _this297;
    }

    _createClass(kM, [{
      key: "connectionState",
      get: function get() {
        return this._connectionState;
      },
      set: function set(e) {
        if (this._connectionState === e) return;
        var t = this._connectionState;
        this._connectionState = e, this.emit(Rv.CONNECTION_STATE_CHANGE, t, e);
      }
    }, {
      key: "inspectType",
      get: function get() {
        return this._inspectType;
      },
      set: function set(e) {
        var t;
        this._inspectMode = cS(t = e.map(function (e) {
          return LM.get(e) || 0;
        })).call(t, function (e, t) {
          return e + t;
        }), this._inspectType = e;
      }
    }, {
      key: "quality",
      get: function get() {
        return this._quality;
      },
      set: function set(e) {
        var _this298 = this;

        this._quality = e > 1 ? 1 : e < .1 ? .1 : e, this.qualityTimer && (window.clearTimeout(this.qualityTimer), this.qualityTimer = null), this._quality >= 1 || (this.qualityTimer = window.setTimeout(function () {
          _this298.quality = _this298._quality / _this298.qualityRatio;
        }, 6e4));
      }
    }, {
      key: "init",
      value: function () {
        var _init4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee371(e, t) {
          var _this299 = this;

          var i;
          return _regeneratorRuntime.wrap(function _callee371$(_context371) {
            while (1) {
              switch (_context371.prev = _context371.next) {
                case 0:
                  this.emit(Rv.STATE_CHANGE, Sv.CONNECT_AP), this._connectInfo = e;
                  i = this._cancelTokenSource.token;
                  return _context371.abrupt("return", (this._retryConfig = t, new tT(function (n, s) {
                    _this299.on(Rv.CONNECTION_STATE_CHANGE, function (e, t) {
                      t === gv.CONNECTED && n();
                    }), _this299.requestAP(e, i, t).then(function (e) {
                      _this299.connectWorkerManager(e);
                    }).catch(function (e) {
                      s(e);
                    });
                  })));

                case 3:
                case "end":
                  return _context371.stop();
              }
            }
          }, _callee371, this);
        }));

        function init(_x591, _x592) {
          return _init4.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "requestAP",
      value: function () {
        var _requestAP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee373(e, t, i) {
          var n, s, r;
          return _regeneratorRuntime.wrap(function _callee373$(_context373) {
            while (1) {
              switch (_context373.prev = _context373.next) {
                case 0:
                  n = DC("WEBCS_DOMAIN").map(function (e) {
                    return "https://".concat(e, "/api/v1");
                  });
                  _context373.next = 3;
                  return function (e, t, i, n) {
                    var s = t.appId,
                        r = t.areaCode,
                        o = t.cname,
                        a = t.sid,
                        c = t.token,
                        d = t.uid;
                    pA++;
                    var l = "image_moderation_api",
                        u = {
                      service_name: l,
                      json_body: JSON.stringify({
                        appId: s,
                        areaCode: r,
                        cname: o,
                        command: "allocateEdge",
                        requestId: pA,
                        seq: pA,
                        sid: a,
                        token: c,
                        ts: Date.now(),
                        uid: d + ""
                      })
                    };
                    var h,
                        p,
                        _ = e[0];
                    return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee372() {
                      var e, _t301, t, _e359, _e360, n, s;

                      return _regeneratorRuntime.wrap(function _callee372$(_context372) {
                        while (1) {
                          switch (_context372.prev = _context372.next) {
                            case 0:
                              h = Date.now();
                              _context372.next = 3;
                              return Ky(_, {
                                data: u,
                                cancelToken: i,
                                headers: {
                                  "X-Packet-Service-Type": "0",
                                  "X-Packet-URI": "61"
                                },
                                params: {
                                  action: "wrtc_gateway"
                                }
                              });

                            case 3:
                              e = _context372.sent;

                              if (!(p = Date.now() - h, 0 !== e.code)) {
                                _context372.next = 7;
                                break;
                              }

                              _t301 = new VI(xT.UNEXPECTED_RESPONSE, "image inspect ap error, code" + e.code, {
                                retry: !0,
                                responseTime: p
                              });
                              throw YC.error(_t301.toString()), _t301;

                            case 7:
                              t = JSON.parse(e.json_body);

                              if (!(200 !== t.code)) {
                                _context372.next = 11;
                                break;
                              }

                              _e359 = new VI(xT.UNEXPECTED_RESPONSE, "image inspect ap error, code: ".concat(t.code, ", reason: ").concat(t.reason), {
                                code: t.code,
                                responseTime: p
                              });
                              throw YC.error(_e359.toString()), _e359;

                            case 11:
                              if (!(!t.servers || !Array.isArray(t.servers) || 0 === t.servers.length)) {
                                _context372.next = 14;
                                break;
                              }

                              _e360 = new VI(xT.UNEXPECTED_RESPONSE, "image inspect ap empty server", {
                                code: t.code,
                                responseTime: p
                              });
                              throw YC.error(_e360.toString()), _e360;

                            case 14:
                              n = DC("VIDEO_INSPECT_WORKER_MANAGER_HOST"), s = DC("VIDEO_INSPECT_WORKER_MANAGER_PORT");
                              return _context372.abrupt("return", {
                                addressList: t.servers.map(function (e) {
                                  var t = e.address,
                                      i = e.wss;
                                  if (t && i) return "wss://".concat(t.replace(/\./g, "-"), ".").concat(n, ":").concat(s || i);
                                }).filter(function (e) {
                                  return !!e;
                                }),
                                workerToken: t.workerToken,
                                vid: t.vid,
                                responseTime: p
                              });

                            case 16:
                            case "end":
                              return _context372.stop();
                          }
                        }
                      }, _callee372);
                    })), function (t, i) {
                      return rI.apworkerEvent(a, {
                        success: !0,
                        sc: 200,
                        serviceName: l,
                        responseDetail: JSON.stringify(t.addressList),
                        firstSuccess: 0 === i,
                        responseTime: p,
                        serverIp: e[i % e.length]
                      }), !1;
                    }, function (t, i) {
                      return rI.apworkerEvent(a, {
                        success: !1,
                        sc: t.data && t.data.code || 200,
                        serviceName: l,
                        responseTime: p,
                        serverIp: e[i % e.length]
                      }), !!(t.code !== xT.OPERATION_ABORTED && t.code !== xT.UNEXPECTED_RESPONSE || t.data && t.data.retry) && (_ = e[(i + 1) % e.length], !0);
                    }, n);
                  }(n, e, t, i);

                case 3:
                  s = _context373.sent;
                  this.emit(Rv.STATE_CHANGE, Sv.AP_CONNECTED);
                  r = s.addressList;
                  return _context373.abrupt("return", (this.wmSequence++, r));

                case 7:
                case "end":
                  return _context373.stop();
              }
            }
          }, _callee373, this);
        }));

        function requestAP(_x593, _x594, _x595) {
          return _requestAP.apply(this, arguments);
        }

        return requestAP;
      }()
    }, {
      key: "connectWorkerManager",
      value: function () {
        var _connectWorkerManager = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee374(e) {
          var t,
              _args374 = arguments;
          return _regeneratorRuntime.wrap(function _callee374$(_context374) {
            while (1) {
              switch (_context374.prev = _context374.next) {
                case 0:
                  t = _args374.length > 1 && void 0 !== _args374[1] && _args374[1];
                  this._needWorkUrlOnly = t;
                  this.emit(Rv.STATE_CHANGE, Sv.CONNECT_WORKER_MANAGER);
                  _context374.next = 5;
                  return this.workerManagerConnection.init(e, 1e4);

                case 5:
                case "end":
                  return _context374.stop();
              }
            }
          }, _callee374, this);
        }));

        function connectWorkerManager(_x596) {
          return _connectWorkerManager.apply(this, arguments);
        }

        return connectWorkerManager;
      }()
    }, {
      key: "connectWorker",
      value: function () {
        var _connectWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee375(e) {
          return _regeneratorRuntime.wrap(function _callee375$(_context375) {
            while (1) {
              switch (_context375.prev = _context375.next) {
                case 0:
                  _context375.next = 2;
                  return this.workerConnection.init([e]);

                case 2:
                case "end":
                  return _context375.stop();
              }
            }
          }, _callee375, this);
        }));

        function connectWorker(_x597) {
          return _connectWorker.apply(this, arguments);
        }

        return connectWorker;
      }()
    }, {
      key: "handleWorkerManagerEvents",
      value: function handleWorkerManagerEvents() {
        var _this300 = this;

        this.workerManagerConnection.on(yI.CONNECTED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee376() {
          return _regeneratorRuntime.wrap(function _callee376$(_context376) {
            while (1) {
              switch (_context376.prev = _context376.next) {
                case 0:
                  _this300.emit(Rv.STATE_CHANGE, Sv.WORKER_MANAGER_CONNECTED, _this300.workerManagerConnection.url), _this300.workerManagerConnection.sendMessage({
                    appId: _this300._connectInfo.appId,
                    cname: _this300._connectInfo.cname,
                    uid: _this300._connectInfo.uid + "",
                    sdkVersion: "4.20.0",
                    sid: _this300._connectInfo.sid,
                    seq: _this300.wmSequence,
                    ts: Number(Date.now()),
                    requestId: Math.floor(1e12 * Math.random()),
                    allocate: !0,
                    clientRequest: {
                      command: "join"
                    }
                  }, !0);

                case 1:
                case "end":
                  return _context376.stop();
              }
            }
          }, _callee376);
        }))), this.workerManagerConnection.on(yI.CLOSED, function () {
          _this300._innerConnectionState < Sv.GET_WORKER_MANAGER_RESPONSE && YC.debug("[".concat(_this300._inspectId, "] Inspect worker manager is closed before connecting worker"));
        }), this.workerManagerConnection.on(yI.FAILED, function () {
          _this300._innerConnectionState < Sv.GET_WORKER_MANAGER_RESPONSE && YC.debug("[".concat(_this300._inspectId, "] Connecting inspect worker manager is failed before connecting worker"));
        }), this.workerManagerConnection.on(yI.RECONNECTING, function () {
          _this300._innerConnectionState < Sv.GET_WORKER_MANAGER_RESPONSE && YC.debug("[".concat(_this300._inspectId, "] Inspect worker manager is reconnecting before connecting worker"));
        }), this.workerManagerConnection.on(yI.ON_MESSAGE, /*#__PURE__*/function () {
          var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee377(e) {
            var t, i, _e361, _n143;

            return _regeneratorRuntime.wrap(function _callee377$(_context377) {
              while (1) {
                switch (_context377.prev = _context377.next) {
                  case 0:
                    _this300.emit(Rv.STATE_CHANGE, Sv.GET_WORKER_MANAGER_RESPONSE);

                    t = _this300.workerManagerConnection.url;

                    _this300.workerManagerConnection.close();

                    i = JSON.parse(e.data);

                    if (!(200 !== i.code)) {
                      _context377.next = 6;
                      break;
                    }

                    throw YC.error("[".concat(_this300._inspectId, "] Unexpected code ").concat(i.code, " from worker manager")), new VI(xT.UNEXPECTED_RESPONSE, "response code of worker is unexpected", i);

                  case 6:
                    if (i.serverResponse && i.serverResponse.portWss && t) {
                      _context377.next = 8;
                      break;
                    }

                    throw YC.error("[".concat(_this300._inspectId, "] Unexpected content from worker manager : ").concat(JSON.stringify(i))), new VI(xT.UNEXPECTED_RESPONSE, "response content of worker is unexpected", i);

                  case 8:
                    _e361 = DC("VIDEO_INSPECT_WORKER_PORT") || i.serverResponse.portWss, _n143 = t.replace(/:\d+\/?$/, ":".concat(_e361));

                    _this300.emit(Rv.STATE_CHANGE, Sv.CONNECT_WORKER, _n143);

                    if (!_this300._needWorkUrlOnly) {
                      _context377.next = 14;
                      break;
                    }

                    _this300.emit(Rv.REQUEST_NEW_WORKER_URL, _n143);

                    _context377.next = 16;
                    break;

                  case 14:
                    _context377.next = 16;
                    return _this300.connectWorker(_n143);

                  case 16:
                  case "end":
                    return _context377.stop();
                }
              }
            }, _callee377);
          }));

          return function (_x598) {
            return _ref82.apply(this, arguments);
          };
        }()), this.workerManagerConnection.on(yI.WILL_RECONNECT, function (e, t, i) {
          i(e);
        }), this.workerManagerConnection.on(yI.REQUEST_NEW_URLS, function (e, t) {
          _this300.requestAP(_this300._connectInfo, _this300._cancelTokenSource.token, _this300._retryConfig).then(e).catch(t);
        });
      }
    }, {
      key: "handleWorkerEvents",
      value: function handleWorkerEvents() {
        var _this301 = this;

        this.workerConnection.on(yI.CONNECTED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee378() {
          return _regeneratorRuntime.wrap(function _callee378$(_context378) {
            while (1) {
              switch (_context378.prev = _context378.next) {
                case 0:
                  _this301.emit(Rv.STATE_CHANGE, Sv.WORKER_CONNECTED, _this301.workerConnection.url), _this301.connectionState = gv.CONNECTED;

                case 1:
                case "end":
                  return _context378.stop();
              }
            }
          }, _callee378);
        }))), this.workerConnection.on(yI.ON_MESSAGE, /*#__PURE__*/function () {
          var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee379(e) {
            var i, t, _e362, _n144, _s101;

            return _regeneratorRuntime.wrap(function _callee379$(_context379) {
              while (1) {
                switch (_context379.prev = _context379.next) {
                  case 0:
                    if (!(e.data instanceof ArrayBuffer)) {
                      _context379.next = 11;
                      break;
                    }

                    i = oM(new Uint8Array(e.data));

                    if (!(DC("SHOW_VIDEO_INSPECT_WORKER_MESSAGE") && YC.debug("[".concat(_this301._inspectId, "] Response message for worker of inspect content "), JSON.stringify(i)), 200 === i.code)) {
                      _context379.next = 8;
                      break;
                    }

                    if (!(Array.isArray(_this301.inspectType) && 1 === _this301.inspectType.length && "supervise" === _this301.inspectType[0])) {
                      _context379.next = 5;
                      break;
                    }

                    return _context379.abrupt("return", void _this301.emit(Rv.INSPECT_RESULT, void 0, void 0));

                  case 5:
                    if (i.data && i.data.scorePorn && i.data.scoreSexy && i.data.scoreNeutral) {
                      _e362 = {
                        porn: i.data.scorePorn,
                        sexy: i.data.scoreSexy,
                        neutral: i.data.scoreNeutral
                      }, _n144 = cS(t = Object.keys(_e362)).call(t, function (t, i) {
                        return _e362[t] > _e362[i] ? t : i;
                      }, "porn"), _s101 = Object.keys(_e362).find(function (e) {
                        return e === _n144;
                      });

                      _this301.emit(Rv.INSPECT_RESULT, _s101);
                    } else _this301.emit(Rv.INSPECT_RESULT, void 0, new VI(xT.UNEXPECTED_RESPONSE, i.code + "", "There is an unexpected data on message"));

                    _context379.next = 9;
                    break;

                  case 8:
                    _this301.emit(Rv.INSPECT_RESULT, void 0, new VI(xT.UNEXPECTED_RESPONSE, i.code + "", i.msg));

                  case 9:
                    _context379.next = 12;
                    break;

                  case 11:
                    YC.error("[".concat(_this301._inspectId, "] Unexpected message type from worker")), _this301.emit(Rv.INSPECT_RESULT, void 0, new VI(xT.UNEXPECTED_RESPONSE, "invalid worker message type"));

                  case 12:
                  case "end":
                    return _context379.stop();
                }
              }
            }, _callee379);
          }));

          return function (_x599) {
            return _ref84.apply(this, arguments);
          };
        }()), this.workerConnection.on(yI.CLOSED, function () {
          _this301.connectionState = gv.CLOSED;
        }), this.workerConnection.on(yI.FAILED, function () {
          _this301.connectionState = gv.CLOSED;
        }), this.workerConnection.on(yI.RECONNECTING, function () {
          _this301.connectionState = _this301.connectionState === gv.CONNECTED ? gv.RECONNECTING : gv.CONNECTING;
        }), this.workerConnection.on(yI.WILL_RECONNECT, function (e, t, i) {
          "recover" === e && i(e), i("tryNext");
        }), this.workerConnection.on(yI.REQUEST_NEW_URLS, function (e, t) {
          _this301.workerManagerConnection.close(), _this301.once(Rv.REQUEST_NEW_WORKER_URL, function (t) {
            e([t]);
          }), _this301.requestAP(_this301._connectInfo, _this301._cancelTokenSource.token, _this301._retryConfig).then(function (e) {
            _this301.connectWorkerManager(e, !0);
          }).catch(function (e) {
            t(e);
          });
        });
      }
    }, {
      key: "requestToInspectImage",
      value: function () {
        var _requestToInspectImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee380() {
          var e, t, i;
          return _regeneratorRuntime.wrap(function _callee380$(_context380) {
            while (1) {
              switch (_context380.prev = _context380.next) {
                case 0:
                  this.sequence++;
                  e = gg(this, Rv.CLIENT_LOCAL_VIDEO_TRACK), t = {
                    appId: this._connectInfo.appId,
                    cname: this._connectInfo.cname,
                    cid: this._connectInfo.cid,
                    sid: this._connectInfo.sid,
                    uid: this._connectInfo.uid,
                    vid: this._connectInfo.vid
                  };

                  if (!e) {
                    _context380.next = 11;
                    break;
                  }

                  if (e.isPlaying) {
                    _context380.next = 5;
                    break;
                  }

                  return _context380.abrupt("return", void this.emit(Rv.INSPECT_RESULT, void 0, new VI(xT.INVALID_OPERATION, "Only the track being played can be inspected")));

                case 5:
                  _context380.next = 7;
                  return this.generateRequestData(e, t);

                case 7:
                  i = _context380.sent;
                  this.workerConnection.sendMessage(i, !0, !0);
                  _context380.next = 12;
                  break;

                case 11:
                  this.emit(Rv.INSPECT_RESULT, void 0, new VI(xT.INVALID_OPERATION, "Only the track being published can be inspected"));

                case 12:
                case "end":
                  return _context380.stop();
              }
            }
          }, _callee380, this);
        }));

        function requestToInspectImage() {
          return _requestToInspectImage.apply(this, arguments);
        }

        return requestToInspectImage;
      }()
    }, {
      key: "generateRequestData",
      value: function () {
        var _generateRequestData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee381(e, t) {
          var i, n, s, r, o, a, c, d, l, u, h, p, _e363, _t302;

          return _regeneratorRuntime.wrap(function _callee381$(_context381) {
            while (1) {
              switch (_context381.prev = _context381.next) {
                case 0:
                  i = t.appId, n = t.cname, s = t.cid, r = t.vid, o = t.sid, a = t.uid;
                  c = Date.now();
                  _context381.next = 4;
                  return e.getCurrentFrameImage("image/jpeg", this.quality);

                case 4:
                  d = _context381.sent;
                  _context381.next = 7;
                  return bw(d, i, n);

                case 7:
                  l = _context381.sent;
                  u = this.sequence + "-" + s + "-" + a + "-" + c + "-" + xg(12, "");
                  h = {
                    appId: i,
                    cid: s,
                    cname: n,
                    deviceId: "",
                    elapse: kM.intToLong(Number(c - this.inspectStartTime)),
                    fileSize: l.byteLength,
                    jpgEncryption: 2,
                    height: d.height,
                    width: d.width,
                    jpg: l,
                    networkType: 6,
                    osType: 7,
                    requestId: u,
                    sdkVersion: "4.20.0",
                    sequence: this.sequence,
                    sid: o,
                    timestamp: kM.intToLong(c),
                    uid: a,
                    vid: r,
                    service: this._inspectMode,
                    callbackData: this.extraInfo,
                    ossFilePrefix: this.ossFilePrefix
                  };
                  void 0 === this.extraInfo && delete h.callbackData, void 0 === this.ossFilePrefix && delete h.ossFilePrefix;
                  p = rM(h);

                  if (!(p.byteLength < this.workerMessageLengthLimit)) {
                    _context381.next = 15;
                    break;
                  }

                  if (DC("SHOW_VIDEO_INSPECT_WORKER_MESSAGE")) {
                    _e363 = function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var i = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? PM(Object(i), !0).forEach(function (t) {
                          nh(e, t, i[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : PM(Object(i)).forEach(function (t) {
                          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                        });
                      }

                      return e;
                    }({}, h);

                    delete _e363.jpg, YC.debug("[".concat(this._inspectId, "] Request message for worker of inspect content "), JSON.stringify(_e363));
                  }

                  return _context381.abrupt("return", p);

                case 15:
                  _t302 = this.quality * this.qualityRatio;
                  this.quality = _t302;
                  _context381.next = 19;
                  return this.generateRequestData(e, {
                    appId: i,
                    cname: n,
                    cid: s,
                    vid: r,
                    sid: o,
                    uid: a
                  });

                case 19:
                  return _context381.abrupt("return", _context381.sent);

                case 20:
                case "end":
                  return _context381.stop();
              }
            }
          }, _callee381, this);
        }));

        function generateRequestData(_x600, _x601) {
          return _generateRequestData.apply(this, arguments);
        }

        return generateRequestData;
      }()
    }, {
      key: "close",
      value: function close() {
        this._cancelTokenSource.cancel(), this._cancelTokenSource = EC.CancelToken.source(), this.workerManagerConnection && this.workerManagerConnection.close(), this.workerConnection && this.workerConnection.close(), this.inspectTimer && window.clearInterval(this.inspectTimer), this.inspectTimer = null, this.connectionState = gv.CLOSED, this.emit(Rv.STATE_CHANGE, Sv.CLOSED);
      }
    }], [{
      key: "intToLong",
      value: function intToLong(e) {
        return {
          low: e |= 0,
          high: e >> 31,
          unsigned: e >= 0
        };
      }
    }]);

    return kM;
  }(ig);

  function MM(e) {
    var t = function () {
      var e = FM.pop();
      return e ? (e.offset = e.limit = 0, e) : {
        bytes: new Uint8Array(64),
        offset: 0,
        limit: 0
      };
    }();

    return function (e, t) {
      var i = e.appId;
      void 0 !== i && (XM(t, 10), YM(t, i));
      var n = e.cid;
      void 0 !== n && (XM(t, 16), XM(t, n));
      var s = e.cname;
      void 0 !== s && (XM(t, 26), YM(t, s));
      var r = e.deviceId;
      void 0 !== r && (XM(t, 34), YM(t, r));
      var o = e.elapse;
      void 0 !== o && (XM(t, 40), ZM(t, o));
      var a = e.fileSize;
      void 0 !== a && (XM(t, 48), ZM(t, VM(a)));
      var c = e.height;
      void 0 !== c && (XM(t, 56), ZM(t, VM(c)));
      var d = e.jpg;
      void 0 !== d && (XM(t, 66), XM(t, d.length), HM(t, d));
      var l = e.networkType;
      void 0 !== l && (XM(t, 72), ZM(t, VM(l)));
      var u = e.osType;
      void 0 !== u && (XM(t, 80), ZM(t, VM(u)));
      var h = e.requestId;
      void 0 !== h && (XM(t, 90), YM(t, h));
      var p = e.sdkVersion;
      void 0 !== p && (XM(t, 98), YM(t, p));
      var _ = e.sequence;
      void 0 !== _ && (XM(t, 104), ZM(t, VM(_)));
      var E = e.sid;
      void 0 !== E && (XM(t, 114), YM(t, E));
      var m = e.timestamp;
      void 0 !== m && (XM(t, 120), ZM(t, m));
      var f = e.uid;
      void 0 !== f && (XM(t, 128), XM(t, f));
      var T = e.vid;
      void 0 !== T && (XM(t, 136), XM(t, T));
      var g = e.width;
      void 0 !== g && (XM(t, 144), ZM(t, VM(g)));
      var S = e.service;
      void 0 !== S && (XM(t, 152), XM(t, S));
      var R = e.callbackData;
      void 0 !== R && (XM(t, 162), XM(t, R.length), HM(t, R));
      var C = e.ticket;
      void 0 !== C && (XM(t, 170), YM(t, C));
      var I = e.vendorConfigs;
      void 0 !== I && (XM(t, 178), YM(t, I));
    }(e, t), function (e) {
      var t = e.bytes,
          i = e.limit;
      return t.length === i ? t : t.subarray(0, i);
    }(t);
  }

  function UM(e) {
    return function (e) {
      var t = {};

      e: for (; !jM(e);) {
        var i = zM(e);

        switch (i >>> 3) {
          case 0:
            break e;

          case 1:
            t.code = zM(e);
            break;

          case 2:
            t.msg = KM(e, zM(e));
            break;

          case 3:
            t.requestId = KM(e, zM(e));
            break;

          case 4:
            t.timestamp = QM(e, !1);
            break;

          default:
            xM(e, 7 & i);
        }
      }

      return t;
    }({
      bytes: t = e,
      offset: 0,
      limit: t.length
    });
    var t;
  }

  function xM(e, t) {
    switch (t) {
      case 0:
        for (; 128 & qM(e);) {
          ;
        }

        break;

      case 2:
        BM(e, zM(e));
        break;

      case 5:
        BM(e, 4);
        break;

      case 1:
        BM(e, 8);
        break;

      default:
        throw new Error("Unimplemented type: " + t);
    }
  }

  function VM(e) {
    return {
      low: e |= 0,
      high: e >> 31,
      unsigned: e >= 0
    };
  }

  var FM = [];

  function BM(e, t) {
    if (e.offset + t > e.limit) throw new Error("Skip past limit");
    e.offset += t;
  }

  function jM(e) {
    return e.offset >= e.limit;
  }

  function GM(e, t) {
    var i = e.bytes,
        n = e.offset,
        s = e.limit,
        r = n + t;

    if (r > i.length) {
      var _t303 = new Uint8Array(2 * r);

      _t303.set(i), e.bytes = _t303;
    }

    return e.offset = r, r > s && (e.limit = r), n;
  }

  function WM(e, t) {
    var i = e.offset;
    if (i + t > e.limit) throw new Error("Read past limit");
    return e.offset += t, i;
  }

  function HM(e, t) {
    var i = GM(e, t.length);
    e.bytes.set(t, i);
  }

  function KM(e, t) {
    var i = WM(e, t),
        n = String.fromCharCode,
        s = e.bytes,
        r = "�",
        o = "";

    for (var _e364 = 0; _e364 < t; _e364++) {
      var _a30 = void 0,
          c = void 0,
          _d21 = void 0,
          _l18 = void 0,
          _u10 = s[_e364 + i];

      0 == (128 & _u10) ? o += n(_u10) : 192 == (224 & _u10) ? _e364 + 1 >= t ? o += r : (_a30 = s[_e364 + i + 1], 128 != (192 & _a30) ? o += r : (_l18 = (31 & _u10) << 6 | 63 & _a30, _l18 < 128 ? o += r : (o += n(_l18), _e364++))) : 224 == (240 & _u10) ? _e364 + 2 >= t ? o += r : (_a30 = s[_e364 + i + 1], c = s[_e364 + i + 2], 32896 != (49344 & (_a30 | c << 8)) ? o += r : (_l18 = (15 & _u10) << 12 | (63 & _a30) << 6 | 63 & c, _l18 < 2048 || _l18 >= 55296 && _l18 <= 57343 ? o += r : (o += n(_l18), _e364 += 2))) : 240 == (248 & _u10) ? _e364 + 3 >= t ? o += r : (_a30 = s[_e364 + i + 1], c = s[_e364 + i + 2], _d21 = s[_e364 + i + 3], 8421504 != (12632256 & (_a30 | c << 8 | _d21 << 16)) ? o += r : (_l18 = (7 & _u10) << 18 | (63 & _a30) << 12 | (63 & c) << 6 | 63 & _d21, _l18 < 65536 || _l18 > 1114111 ? o += r : (_l18 -= 65536, o += n(55296 + (_l18 >> 10), 56320 + (1023 & _l18)), _e364 += 3))) : o += r;
    }

    return o;
  }

  function YM(e, t) {
    var i = t.length,
        n = 0;

    for (var _e365 = 0; _e365 < i; _e365++) {
      var _s102 = t.charCodeAt(_e365);

      _s102 >= 55296 && _s102 <= 56319 && _e365 + 1 < i && (_s102 = (_s102 << 10) + t.charCodeAt(++_e365) - 56613888), n += _s102 < 128 ? 1 : _s102 < 2048 ? 2 : _s102 < 65536 ? 3 : 4;
    }

    XM(e, n);
    var s = GM(e, n),
        r = e.bytes;

    for (var _e366 = 0; _e366 < i; _e366++) {
      var _n145 = t.charCodeAt(_e366);

      _n145 >= 55296 && _n145 <= 56319 && _e366 + 1 < i && (_n145 = (_n145 << 10) + t.charCodeAt(++_e366) - 56613888), _n145 < 128 ? r[s++] = _n145 : (_n145 < 2048 ? r[s++] = _n145 >> 6 & 31 | 192 : (_n145 < 65536 ? r[s++] = _n145 >> 12 & 15 | 224 : (r[s++] = _n145 >> 18 & 7 | 240, r[s++] = _n145 >> 12 & 63 | 128), r[s++] = _n145 >> 6 & 63 | 128), r[s++] = 63 & _n145 | 128);
    }
  }

  function qM(e) {
    return e.bytes[WM(e, 1)];
  }

  function JM(e, t) {
    var i = GM(e, 1);
    e.bytes[i] = t;
  }

  function zM(e) {
    var t,
        i = 0,
        n = 0;

    do {
      t = qM(e), i < 32 && (n |= (127 & t) << i), i += 7;
    } while (128 & t);

    return n;
  }

  function XM(e, t) {
    for (t >>>= 0; t >= 128;) {
      JM(e, 127 & t | 128), t >>>= 7;
    }

    JM(e, t);
  }

  function QM(e, t) {
    var i,
        n = 0,
        s = 0,
        r = 0;
    return i = qM(e), n = 127 & i, 128 & i && (i = qM(e), n |= (127 & i) << 7, 128 & i && (i = qM(e), n |= (127 & i) << 14, 128 & i && (i = qM(e), n |= (127 & i) << 21, 128 & i && (i = qM(e), s = 127 & i, 128 & i && (i = qM(e), s |= (127 & i) << 7, 128 & i && (i = qM(e), s |= (127 & i) << 14, 128 & i && (i = qM(e), s |= (127 & i) << 21, 128 & i && (i = qM(e), r = 127 & i, 128 & i && (i = qM(e), r |= (127 & i) << 7))))))))), {
      low: n | s << 28,
      high: s >>> 4 | r << 24,
      unsigned: t
    };
  }

  function ZM(e, t) {
    var i = t.low >>> 0,
        n = (t.low >>> 28 | t.high << 4) >>> 0,
        s = t.high >>> 24,
        r = 0 === s ? 0 === n ? i < 16384 ? i < 128 ? 1 : 2 : i < 1 << 21 ? 3 : 4 : n < 16384 ? n < 128 ? 5 : 6 : n < 1 << 21 ? 7 : 8 : s < 128 ? 9 : 10,
        o = GM(e, r),
        a = e.bytes;

    switch (r) {
      case 10:
        a[o + 9] = s >>> 7 & 1;

      case 9:
        a[o + 8] = 9 !== r ? 128 | s : 127 & s;

      case 8:
        a[o + 7] = 8 !== r ? n >>> 21 | 128 : n >>> 21 & 127;

      case 7:
        a[o + 6] = 7 !== r ? n >>> 14 | 128 : n >>> 14 & 127;

      case 6:
        a[o + 5] = 6 !== r ? n >>> 7 | 128 : n >>> 7 & 127;

      case 5:
        a[o + 4] = 5 !== r ? 128 | n : 127 & n;

      case 4:
        a[o + 3] = 4 !== r ? i >>> 21 | 128 : i >>> 21 & 127;

      case 3:
        a[o + 2] = 3 !== r ? i >>> 14 | 128 : i >>> 14 & 127;

      case 2:
        a[o + 1] = 2 !== r ? i >>> 7 | 128 : i >>> 7 & 127;

      case 1:
        a[o] = 1 !== r ? 128 | i : 127 & i;
    }
  }

  var $M = {},
      eU = {},
      tU = 4294967296,
      iU = tU * tU,
      nU = iU / 2,
      sU = dU(0, !0),
      rU = dU(0),
      oU = lU(0, -2147483648, !1),
      aU = lU(-1, 2147483647, !1),
      cU = lU(-1, -1, !0);

  function dU(e, t) {
    var i, n, s;
    return t ? (s = 0 <= (e >>>= 0) && e < 256) && (n = eU[e], n) ? n : (i = lU(e, 0, !0), s && (eU[e] = i), i) : (s = -128 <= (e |= 0) && e < 128) && (n = $M[e], n) ? n : (i = lU(e, e < 0 ? -1 : 0, !1), s && ($M[e] = i), i);
  }

  function lU(e, t, i) {
    return {
      low: 0 | e,
      high: 0 | t,
      unsigned: !!i
    };
  }

  function uU(e, t) {
    if (isNaN(e)) return t ? sU : rU;

    if (t) {
      if (e < 0) return sU;
      if (e >= iU) return cU;
    } else {
      if (e <= -nU) return oU;
      if (e + 1 >= nU) return aU;
    }

    return e < 0 ? t ? sU : rU : lU(e % tU | 0, e / tU | 0, t);
  }

  function hU(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  var pU = /*#__PURE__*/function (_ig33) {
    _inherits(pU, _ig33);

    var _super68 = _createSuper(pU);

    function pU(e) {
      var _this302;

      _classCallCheck(this, pU);

      var t;
      _this302 = _super68.call(this), nh(_assertThisInitialized(_this302), "name", "AgoraRTCImageModeration"), nh(_assertThisInitialized(_this302), "_connectionState", Av.CONNECTING), nh(_assertThisInitialized(_this302), "_sequence", 0), nh(_assertThisInitialized(_this302), "_moderationStartTime", void 0), nh(_assertThisInitialized(_this302), "_workerConnection", void 0), nh(_assertThisInitialized(_this302), "_workerMessageLengthLimit", void 0), nh(_assertThisInitialized(_this302), "_qualityRatio", void 0), nh(_assertThisInitialized(_this302), "_connectInfo", void 0), nh(_assertThisInitialized(_this302), "_cancelTokenSource", EC.CancelToken.source()), nh(_assertThisInitialized(_this302), "_retryConfig", void 0), nh(_assertThisInitialized(_this302), "_moderationInterval", void 0), nh(_assertThisInitialized(_this302), "_moderationTimer", null), nh(_assertThisInitialized(_this302), "_moderationMode", 1), nh(_assertThisInitialized(_this302), "_quality", 1), nh(_assertThisInitialized(_this302), "_qualityTimer", null), nh(_assertThisInitialized(_this302), "_ticket", void 0), nh(_assertThisInitialized(_this302), "_moderationIntervalMinimum", void 0), nh(_assertThisInitialized(_this302), "_uploadFailedNum", 0), nh(_assertThisInitialized(_this302), "_uploadNum", 0), nh(_assertThisInitialized(_this302), "_uploadTimer", null), nh(_assertThisInitialized(_this302), "_extraInfo", void 0), nh(_assertThisInitialized(_this302), "_vendor", ""), nh(_assertThisInitialized(_this302), "_encoder", new TextEncoder()), nh(_assertThisInitialized(_this302), "_moderationId", void 0), nh(_assertThisInitialized(_this302), "inspectImage", function () {
        if (_this302.connectionState !== Av.CONNECTED) throw new VI(xT.OPERATION_ABORTED, "image moderation service connection status is ".concat(_this302.connectionState));
        _this302._moderationTimer && (window.clearInterval(_this302._moderationTimer), _this302._moderationTimer = null), _this302._moderationTimer = window.setInterval(function () {
          _this302.connectionState === Av.CONNECTED ? _this302.requestToInspectImage() : YC.debug("[".concat(_this302._moderationId, "] Moderation State is not connected , "), _this302.connectionState);
        }, _this302._moderationInterval < _this302._moderationIntervalMinimum ? _this302._moderationIntervalMinimum : _this302._moderationInterval), _this302.requestToInspectImage();
      }), _this302._moderationId = xg(5, "image-moderation-"), _this302._workerMessageLengthLimit = DC("IMAGE_MODERATION_WORKER_MESSAGE_LENGTH_LIMIT"), _this302._moderationIntervalMinimum = DC("IMAGE_MODERATION_INTERVAL_MINIMUM"), _this302._moderationInterval = null !== (t = e.interval) && void 0 !== t ? t : 1e3, e.extraInfo && (_this302._extraInfo = _this302._encoder.encode(e.extraInfo)), e.vendor && (_this302._vendor = e.vendor), _this302._qualityRatio = DC("IMAGE_MODERATION_QUALITY_RATIO"), _this302._moderationStartTime = Number(Date.now()), _this302._workerConnection = new $v("worker-" + _this302._moderationId, Jg), _this302.on(bv.STATE_CHANGE, function (e, t) {
        YC.debug("[".concat(_this302._moderationId, "] Moderation operation :").concat(wv[e], " ").concat(t || ""));
      }), _this302.handleWorkerEvents();
      return _this302;
    }

    _createClass(pU, [{
      key: "connectionState",
      get: function get() {
        return this._connectionState;
      },
      set: function set(e) {
        if (this._connectionState === e) return;
        var t = this._connectionState;
        this._connectionState = e, this.emit(bv.CONNECTION_STATE_CHANGE, e, t);
      }
    }, {
      key: "quality",
      get: function get() {
        return this._quality;
      },
      set: function set(e) {
        var _this303 = this;

        this._quality = e > 1 ? 1 : e < .1 ? .1 : e, this._qualityTimer && (window.clearTimeout(this._qualityTimer), this._qualityTimer = null), this._quality >= 1 || (this._qualityTimer = window.setTimeout(function () {
          _this303.quality = _this303._quality / _this303._qualityRatio;
        }, 6e4));
      }
    }, {
      key: "init",
      value: function () {
        var _init5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee382(e, t) {
          var _this304 = this;

          var i;
          return _regeneratorRuntime.wrap(function _callee382$(_context382) {
            while (1) {
              switch (_context382.prev = _context382.next) {
                case 0:
                  this.emit(bv.STATE_CHANGE, wv.CONNECT_AP), this._connectInfo = e;
                  i = this._cancelTokenSource.token;
                  return _context382.abrupt("return", (this._retryConfig = t, new tT(function (n, s) {
                    _this304.on(bv.CONNECTION_STATE_CHANGE, function (e, t) {
                      e === Av.CONNECTED && n();
                    }), _this304.requestAP(e, i, t).then(function (e) {
                      _this304.connectWorker(e);
                    }).catch(function (e) {
                      s(e);
                    });
                  })));

                case 3:
                case "end":
                  return _context382.stop();
              }
            }
          }, _callee382, this);
        }));

        function init(_x602, _x603) {
          return _init5.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "updateConfig",
      value: function updateConfig(e) {
        var t;
        this._moderationInterval = null !== (t = e.interval) && void 0 !== t ? t : 1e3, e.extraInfo && (this._extraInfo = this._encoder.encode(e.extraInfo)), e.vendor && (this._vendor = e.vendor), YC.debug("[".concat(this._moderationId, "] updateConfig: ").concat(JSON.stringify(e))), this.connectionState === Av.CONNECTED && this.inspectImage();
      }
    }, {
      key: "requestAP",
      value: function () {
        var _requestAP2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee384(e, t, i) {
          var n, s, r, o;
          return _regeneratorRuntime.wrap(function _callee384$(_context384) {
            while (1) {
              switch (_context384.prev = _context384.next) {
                case 0:
                  n = DC("WEBCS_DOMAIN").map(function (e) {
                    return "https://".concat(e, "/api/v1");
                  });
                  _context384.next = 3;
                  return function (e, t, i, n) {
                    var s = t.appId,
                        r = t.areaCode,
                        o = t.cname,
                        a = t.sid,
                        c = t.token,
                        d = t.uid;
                    pA++;
                    var l = "moderation_plugin",
                        u = {
                      service_name: l,
                      json_body: JSON.stringify({
                        appId: s,
                        areaCode: r,
                        cname: o,
                        command: "allocateEdge",
                        requestId: pA,
                        seq: pA,
                        sid: a,
                        appToken: c,
                        ts: Date.now(),
                        uid: d + ""
                      })
                    };
                    var h,
                        p,
                        _ = e[0];
                    return Xg( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee383() {
                      var e, _t304, t, _e367, _e368, _e369, n;

                      return _regeneratorRuntime.wrap(function _callee383$(_context383) {
                        while (1) {
                          switch (_context383.prev = _context383.next) {
                            case 0:
                              h = Date.now();
                              _context383.next = 3;
                              return Ky(_, {
                                data: u,
                                cancelToken: i,
                                headers: {
                                  "X-Packet-Service-Type": "0",
                                  "X-Packet-URI": "61"
                                },
                                params: {
                                  action: "wrtc_gateway"
                                }
                              });

                            case 3:
                              e = _context383.sent;

                              if (!(p = Date.now() - h, 0 !== e.code)) {
                                _context383.next = 7;
                                break;
                              }

                              _t304 = new VI(xT.UNEXPECTED_RESPONSE, "moderation plugin ap error, code" + e.code, {
                                retry: !0,
                                responseTime: p
                              });
                              throw YC.error(_t304.toString()), _t304;

                            case 7:
                              t = JSON.parse(e.json_body);

                              if (!(200 !== t.code)) {
                                _context383.next = 11;
                                break;
                              }

                              _e367 = new VI(xT.UNEXPECTED_RESPONSE, "moderation plugin ap error, code: ".concat(t.code, ", reason: ").concat(t.reason), {
                                code: t.code,
                                responseTime: p
                              });
                              throw YC.error(_e367.toString()), _e367;

                            case 11:
                              if (!(!t.servers || !Array.isArray(t.servers) || 0 === t.servers.length)) {
                                _context383.next = 14;
                                break;
                              }

                              _e368 = new VI(xT.UNEXPECTED_RESPONSE, "moderation plugin ap empty server", {
                                code: t.code,
                                responseTime: p
                              });
                              throw YC.error(_e368.toString()), _e368;

                            case 14:
                              if (t.servers.some(function (e) {
                                return !!e.wss;
                              })) {
                                _context383.next = 17;
                                break;
                              }

                              _e369 = new VI(xT.UNEXPECTED_RESPONSE, "moderation plugin ap empty port", {
                                code: t.code,
                                responseTime: p
                              });
                              throw YC.error(_e369.toString()), _e369;

                            case 17:
                              n = DC("IMAGE_MODERATION_WORKER_HOST");
                              return _context383.abrupt("return", {
                                addressList: t.servers.map(function (e) {
                                  var t = e.address,
                                      i = e.wss;
                                  if (t && i) return "wss://".concat(t.replace(/\./g, "-"), ".").concat(n, ":").concat(i, "/moderation");
                                }).filter(function (e) {
                                  return !!e;
                                }),
                                workerToken: t.workerToken,
                                vid: t.vid,
                                ticket: t.appTicket,
                                responseTime: p
                              });

                            case 19:
                            case "end":
                              return _context383.stop();
                          }
                        }
                      }, _callee383);
                    })), function (t, i) {
                      return rI.apworkerEvent(a, {
                        success: !0,
                        sc: 200,
                        serviceName: l,
                        responseDetail: JSON.stringify(t.addressList),
                        firstSuccess: 0 === i,
                        responseTime: p,
                        serverIp: e[i % e.length]
                      }), !1;
                    }, function (t, i) {
                      return rI.apworkerEvent(a, {
                        success: !1,
                        sc: t.data && t.data.code || 200,
                        serviceName: l,
                        responseTime: p,
                        serverIp: e[i % e.length]
                      }), !!(t.code !== xT.OPERATION_ABORTED && t.code !== xT.UNEXPECTED_RESPONSE || t.data && t.data.retry) && (_ = e[(i + 1) % e.length], !0);
                    }, n);
                  }(n, e, t, i);

                case 3:
                  s = _context384.sent;
                  this.emit(bv.STATE_CHANGE, wv.AP_CONNECTED);
                  r = s.addressList, o = s.ticket;
                  return _context384.abrupt("return", (this._ticket = o, r));

                case 7:
                case "end":
                  return _context384.stop();
              }
            }
          }, _callee384, this);
        }));

        function requestAP(_x604, _x605, _x606) {
          return _requestAP2.apply(this, arguments);
        }

        return requestAP;
      }()
    }, {
      key: "connectWorker",
      value: function () {
        var _connectWorker2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee385(e) {
          return _regeneratorRuntime.wrap(function _callee385$(_context385) {
            while (1) {
              switch (_context385.prev = _context385.next) {
                case 0:
                  this.emit(bv.STATE_CHANGE, wv.CONNECT_WORKER);
                  _context385.next = 3;
                  return this._workerConnection.init(e, 1e4);

                case 3:
                case "end":
                  return _context385.stop();
              }
            }
          }, _callee385, this);
        }));

        function connectWorker(_x607) {
          return _connectWorker2.apply(this, arguments);
        }

        return connectWorker;
      }()
    }, {
      key: "handleWorkerEvents",
      value: function handleWorkerEvents() {
        var _this305 = this;

        this._workerConnection.on(yI.CONNECTED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee386() {
          return _regeneratorRuntime.wrap(function _callee386$(_context386) {
            while (1) {
              switch (_context386.prev = _context386.next) {
                case 0:
                  _this305.emit(bv.STATE_CHANGE, wv.WORKER_CONNECTED, _this305._workerConnection.url), _this305.connectionState = Av.CONNECTED;

                case 1:
                case "end":
                  return _context386.stop();
              }
            }
          }, _callee386);
        }))), this._workerConnection.on(yI.CLOSED, function () {
          _this305.connectionState = Av.CLOSED;
        }), this._workerConnection.on(yI.FAILED, function () {
          _this305.connectionState = Av.CLOSED;
        }), this._workerConnection.on(yI.RECONNECTING, function () {
          _this305.connectionState = _this305.connectionState === Av.CONNECTED ? Av.RECONNECTING : Av.CONNECTING;
        }), this._workerConnection.on(yI.ON_MESSAGE, /*#__PURE__*/function () {
          var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee387(e) {
            var _t305;

            return _regeneratorRuntime.wrap(function _callee387$(_context387) {
              while (1) {
                switch (_context387.prev = _context387.next) {
                  case 0:
                    if (e.data instanceof ArrayBuffer) {
                      _t305 = UM(new Uint8Array(e.data));
                      DC("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && YC.debug("[".concat(_this305._moderationId, "] Response message for worker of image moderation "), JSON.stringify(_t305)), _this305._uploadNum++, void 0 === _t305.code || 0 === _t305.code || (_this305._uploadFailedNum++, YC.error("[".concat(_this305._moderationId, "] Error response from worke, code is ").concat(_t305.code, ", msg is ").concat(_t305.msg)), _this305._uploadTimer || (_this305._uploadTimer = window.setTimeout(function () {
                        rI.reportApiInvoke(_this305._connectInfo.sid || null, {
                          name: rg.IMAGE_MODERATION_UPLOAD,
                          options: [_this305._uploadFailedNum, _this305._uploadNum, _t305.code],
                          tag: og.TRACER
                        }).onError(new VI(xT.IMAGE_MODERATION_UPLOAD_FAILED, _t305.msg)), _this305._uploadTimer = null;
                      }, DC("IMAGE_MODERATION_UPLOAD_REPORT_INTERVAL"))));
                    } else YC.error("[".concat(_this305._moderationId, "] Unexpected message type from worker"));

                  case 1:
                  case "end":
                    return _context387.stop();
                }
              }
            }, _callee387);
          }));

          return function (_x608) {
            return _ref87.apply(this, arguments);
          };
        }()), this._workerConnection.on(yI.WILL_RECONNECT, function (e, t, i) {
          "recover" === e && i(e), i("tryNext");
        }), this._workerConnection.on(yI.REQUEST_NEW_URLS, function (e, t) {
          _this305.requestAP(_this305._connectInfo, _this305._cancelTokenSource.token, _this305._retryConfig).then(e).catch(t);
        });
      }
    }, {
      key: "requestToInspectImage",
      value: function () {
        var _requestToInspectImage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee388() {
          var e, t, i;
          return _regeneratorRuntime.wrap(function _callee388$(_context388) {
            while (1) {
              switch (_context388.prev = _context388.next) {
                case 0:
                  e = gg(this, bv.CLIENT_LOCAL_VIDEO_TRACK), t = {
                    appId: this._connectInfo.appId,
                    cname: this._connectInfo.cname,
                    cid: this._connectInfo.cid,
                    sid: this._connectInfo.sid,
                    uid: this._connectInfo.uid,
                    vid: this._connectInfo.vid
                  };

                  if (!e) {
                    _context388.next = 11;
                    break;
                  }

                  if (e.isPlaying) {
                    _context388.next = 4;
                    break;
                  }

                  return _context388.abrupt("return", void (DC("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && YC.debug("Only the track being played can be inspected")));

                case 4:
                  this._sequence++;
                  _context388.next = 7;
                  return this.generateRequestData(e, t);

                case 7:
                  i = _context388.sent;

                  this._workerConnection.sendMessage(i, !0, !0);

                  _context388.next = 12;
                  break;

                case 11:
                  DC("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && YC.debug("Only the track being published can be inspected");

                case 12:
                case "end":
                  return _context388.stop();
              }
            }
          }, _callee388, this);
        }));

        function requestToInspectImage() {
          return _requestToInspectImage2.apply(this, arguments);
        }

        return requestToInspectImage;
      }()
    }, {
      key: "generateRequestData",
      value: function () {
        var _generateRequestData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee389(e, t) {
          var i, n, s, r, o, a, c, d, l, u, h, p, _e370, _t306;

          return _regeneratorRuntime.wrap(function _callee389$(_context389) {
            while (1) {
              switch (_context389.prev = _context389.next) {
                case 0:
                  i = t.appId, n = t.cname, s = t.cid, r = t.vid, o = t.sid, a = t.uid;
                  c = Date.now();
                  _context389.next = 4;
                  return e.getCurrentFrameImage("image/jpeg", this.quality);

                case 4:
                  d = _context389.sent;
                  _context389.next = 7;
                  return bw(d, i, n);

                case 7:
                  l = _context389.sent;
                  u = this._sequence + "-" + s + "-" + a + "-" + c + "-" + xg(12, "");
                  h = {
                    appId: i,
                    cid: s,
                    cname: n,
                    deviceId: "",
                    elapse: pU.intToLong(Number(c - this._moderationStartTime)),
                    fileSize: d.buffer.byteLength,
                    height: d.height,
                    width: d.width,
                    jpg: l,
                    networkType: 6,
                    osType: 7,
                    requestId: u,
                    sdkVersion: "4.20.0",
                    sequence: this._sequence,
                    sid: o,
                    timestamp: uU(c),
                    uid: a,
                    vid: r,
                    service: this._moderationMode,
                    ticket: this._ticket,
                    callbackData: this._extraInfo,
                    vendorConfigs: this._vendor
                  };
                  void 0 === this._extraInfo && delete h.callbackData;
                  p = MM(h);

                  if (!(p.byteLength < this._workerMessageLengthLimit)) {
                    _context389.next = 15;
                    break;
                  }

                  if (DC("SHOW_IMAGE_MODERATION_WORKER_MESSAGE")) {
                    _e370 = function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var i = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? hU(Object(i), !0).forEach(function (t) {
                          nh(e, t, i[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : hU(Object(i)).forEach(function (t) {
                          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                        });
                      }

                      return e;
                    }({}, h);

                    delete _e370.jpg, YC.debug("[".concat(this._moderationId, "] Request message for worker of image moderation service: "), JSON.stringify(_e370));
                  }

                  return _context389.abrupt("return", p);

                case 15:
                  _t306 = this.quality * this._qualityRatio;
                  this.quality = _t306;
                  _context389.next = 19;
                  return this.generateRequestData(e, {
                    appId: i,
                    cname: n,
                    cid: s,
                    vid: r,
                    sid: o,
                    uid: a
                  });

                case 19:
                  return _context389.abrupt("return", _context389.sent);

                case 20:
                case "end":
                  return _context389.stop();
              }
            }
          }, _callee389, this);
        }));

        function generateRequestData(_x609, _x610) {
          return _generateRequestData2.apply(this, arguments);
        }

        return generateRequestData;
      }()
    }, {
      key: "close",
      value: function close() {
        this._cancelTokenSource.cancel(), this._cancelTokenSource = EC.CancelToken.source(), this._workerConnection && this._workerConnection.close(), this._moderationTimer && window.clearInterval(this._moderationTimer), this._moderationTimer = null, this._uploadTimer && window.clearTimeout(this._uploadTimer), this._uploadTimer = null, this.connectionState = Av.CLOSED, this.emit(bv.STATE_CHANGE, wv.CLOSED);
      }
    }], [{
      key: "intToLong",
      value: function intToLong(e) {
        return {
          low: e |= 0,
          high: e >> 31,
          unsigned: e >= 0
        };
      }
    }]);

    return pU;
  }(ig);

  function _U(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function EU(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? _U(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : _U(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var mU = Date.now(),
      fU = 20,
      TU = new Map(),
      gU = new Map();

  function SU(_x611) {
    return _SU.apply(this, arguments);
  }

  function _SU() {
    _SU = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee494(e) {
      var t, i, n, s, r, o, a;
      return _regeneratorRuntime.wrap(function _callee494$(_context494) {
        while (1) {
          switch (_context494.prev = _context494.next) {
            case 0:
              t = TU.get(e), i = Array.isArray(t) && t[t.length - 1], n = gU.get(e);

              if (i) {
                _context494.next = 3;
                break;
              }

              return _context494.abrupt("return", void (n.isSyncing = !1));

            case 3:
              s = {
                uid: i.uid,
                payload: Dg(i.payload)
              };
              0 === n.firstRecvTs && (n.firstRecvTs = i.recvTs, n.firstSendTs = i.sendTs);
              r = i.sendTs - n.firstSendTs, o = r - (Date.now() - n.firstRecvTs);
              o > 0 && (n.firstRecvTs = Date.now() - r);
              a = i.mediaDelay + o;
              a <= 0 ? (t.pop(), RU(i.context, s), a = 0) : a = Math.min(a, fU), setTimeout(function () {
                return t.length && SU(e);
              }, a);

            case 9:
            case "end":
              return _context494.stop();
          }
        }
      }, _callee494);
    }));
    return _SU.apply(this, arguments);
  }

  function RU(e, t) {
    e.safeEmit(dg.STREAM_MESSAGE, t.uid, t.payload), e.onStreamMessage && e.onStreamMessage(t);
  }

  function CU(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        i = arguments.length > 2 ? arguments[2] : void 0;
    if (!e.syncWithAudio) return RU(i, {
      uid: e.uid,
      payload: Dg(e.payload)
    });
    var n = "".concat(i.id, "-").concat(e.uid),
        s = TU.get(n) || [],
        r = s.findIndex(function (t) {
      return e.sendTs >= t.sendTs;
    }),
        o = EU(EU({}, e), {}, {
      context: i,
      mediaDelay: t,
      recvTs: Date.now()
    });
    -1 === r ? s.push(o) : s.splice(r, 0, o), TU.set(n, s);
    var a = !1;
    var c;
    gU.has(n) ? a = !(null === (c = gU.get(n)) || void 0 === c || !c.isSyncing) : gU.set(n, {
      isSyncing: a,
      firstRecvTs: 0,
      firstSendTs: 0
    });
    a || SU(n);
  }

  var IU = pT().name;

  function vU() {
    return !function (e, t, i) {
      var n = pT();
      if (n.os !== aT.IOS || !n.osVersion) return !1;
      var s = n.osVersion.split(".");
      return i ? t && Number(s[0]) === e && Number(s[1]) < t || Number(s[0]) < e : t ? Number(s[0]) === e && Number(s[1]) <= t || Number(s[0]) < e : Number(s[0]) <= e;
    }(16, 0, !0) && !function (e, t, i) {
      var n = pT();
      if (n.name !== cT.SAFARI || !n.osVersion) return !1;
      var s = n.version.split(".");
      return i ? t && Number(s[0]) === e && Number(s[1]) < t || Number(s[0]) < e : t ? Number(s[0]) === e && Number(s[1]) <= t || Number(s[0]) < e : Number(s[0]) <= e;
    }(16, 0, !0);
  }

  function yU(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function AU(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? yU(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : yU(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  Yg.setLogger(YC);

  var bU = /*#__PURE__*/function (_ig34) {
    _inherits(bU, _ig34);

    var _super69 = _createSuper(bU);

    function bU(e) {
      var _this306;

      _classCallCheck(this, bU);

      var t;
      if (_this306 = _super69.call(this), nh(_assertThisInitialized(_this306), "store", void 0), nh(_assertThisInitialized(_this306), "_uid", void 0), nh(_assertThisInitialized(_this306), "_channelName", void 0), nh(_assertThisInitialized(_this306), "_uintUid", void 0), nh(_assertThisInitialized(_this306), "_users", []), nh(_assertThisInitialized(_this306), "_config", void 0), nh(_assertThisInitialized(_this306), "_clientId", void 0), nh(_assertThisInitialized(_this306), "_appId", void 0), nh(_assertThisInitialized(_this306), "_sessionId", null), nh(_assertThisInitialized(_this306), "_key", void 0), nh(_assertThisInitialized(_this306), "_rtmConfig", {}), nh(_assertThisInitialized(_this306), "_joinInfo", void 0), nh(_assertThisInitialized(_this306), "_gateway", void 0), nh(_assertThisInitialized(_this306), "_statsCollector", void 0), nh(_assertThisInitialized(_this306), "_configDistribute", void 0), nh(_assertThisInitialized(_this306), "_leaveMutex", new Yg("client-leave")), nh(_assertThisInitialized(_this306), "_publishMutex", new Yg("client-publish")), nh(_assertThisInitialized(_this306), "_renewTokenMutex", new Yg("client-renewtoken")), nh(_assertThisInitialized(_this306), "_subscribeMutex", new Yg("client-subscribe")), nh(_assertThisInitialized(_this306), "_encryptionMode", "none"), nh(_assertThisInitialized(_this306), "_encryptionSecret", null), nh(_assertThisInitialized(_this306), "_encryptionSalt", null), nh(_assertThisInitialized(_this306), "_proxyServer", void 0), nh(_assertThisInitialized(_this306), "_turnServer", {
        servers: [],
        mode: "auto"
      }), nh(_assertThisInitialized(_this306), "_cloudProxyServerMode", "disabled"), nh(_assertThisInitialized(_this306), "_isDualStreamEnabled", !1), nh(_assertThisInitialized(_this306), "_defaultStreamFallbackType", void 0), nh(_assertThisInitialized(_this306), "_lowStreamParameter", void 0), nh(_assertThisInitialized(_this306), "_streamFallbackTypeCacheMap", new Map()), nh(_assertThisInitialized(_this306), "_remoteStreamTypeCacheMap", new Map()), nh(_assertThisInitialized(_this306), "_axiosCancelSource", EC.CancelToken.source()), nh(_assertThisInitialized(_this306), "_audioVolumeIndicationInterval", void 0), nh(_assertThisInitialized(_this306), "_networkQualityInterval", void 0), nh(_assertThisInitialized(_this306), "_userOfflineTimeout", void 0), nh(_assertThisInitialized(_this306), "_streamRemovedTimeout", void 0), nh(_assertThisInitialized(_this306), "_injectStreamingClient", void 0), nh(_assertThisInitialized(_this306), "_liveTranscodeStreamingClient", void 0), nh(_assertThisInitialized(_this306), "_liveRawStreamingClient", void 0), nh(_assertThisInitialized(_this306), "_channelMediaRelayClient", void 0), nh(_assertThisInitialized(_this306), "_networkQualitySensitivity", "normal"), nh(_assertThisInitialized(_this306), "_p2pChannel", void 0), nh(_assertThisInitialized(_this306), "_useLocalAccessPoint", !1), nh(_assertThisInitialized(_this306), "_setLocalAPVersion", void 0), nh(_assertThisInitialized(_this306), "_joinAndNotLeaveYet", !1), nh(_assertThisInitialized(_this306), "_numberOfJoinCount", 0), nh(_assertThisInitialized(_this306), "_remoteDefaultVideoStreamType", void 0), nh(_assertThisInitialized(_this306), "_inspect", void 0), nh(_assertThisInitialized(_this306), "_moderation", void 0), nh(_assertThisInitialized(_this306), "_license", void 0), nh(_assertThisInitialized(_this306), "_pendingPublishedUsers", []), nh(_assertThisInitialized(_this306), "ntpAlignErrorCount", 0), nh(_assertThisInitialized(_this306), "remoteInboundOffset", 0), nh(_assertThisInitialized(_this306), "_handleLocalTrackEnable", function (e, t, i) {
        _this306.publish(e, !1).then(t).catch(i);
      }), nh(_assertThisInitialized(_this306), "_handleLocalTrackDisable", function (e, t, i) {
        _this306.unpublish(e).then(t).catch(i);
      }), nh(_assertThisInitialized(_this306), "_handleUserOnline", function (e) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(e.uid, _this306.channelName)) return void YC.debug("[".concat(e.uid, "] will be ignored in local"));
        _this306.isStringUID && "string" != typeof e.uid && YC.error("[".concat(_this306._clientId, "] StringUID is Mixed with UintUID"));

        var t = _this306._users.find(function (t) {
          return t.uid === e.uid;
        });

        if (t) t._trust_in_room_ = !0, t._is_pre_created && (t._is_pre_created = !1, _this306.safeEmit(dg.USER_JOINED, t));else {
          var _t307 = new ik(e.uid, e.uint_id || e.uid);

          _this306._users.push(_t307), YC.debug("[".concat(_this306._clientId, "] user online"), e.uid), _this306.safeEmit(dg.USER_JOINED, _t307);
        }
      }), nh(_assertThisInitialized(_this306), "_handleUserOffline", function (e) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(e.uid, _this306.channelName)) return;

        var t = _this306._users.find(function (t) {
          return t.uid === e.uid;
        });

        t && (_this306._handleRemoveStream(e), _this306._handleRemoveDataChannels(e), t._audio_pre_subscribed || t._video_pre_subscribed ? t._is_pre_created = !0 : vg(_this306._users, t), _this306._remoteStreamTypeCacheMap.delete(t.uid), _this306._streamFallbackTypeCacheMap.delete(t.uid), YC.debug("[".concat(_this306._clientId, "] user offline"), e.uid, "reason:", e.reason), _this306.safeEmit(dg.USER_LEAVED, t, e.reason));
      }), nh(_assertThisInitialized(_this306), "_handleAddAudioOrVideoStream", function (e, t, i, n, s, r, o) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(t, _this306.channelName)) return;

        var a = _this306._users.find(function (e) {
          return e.uid === t;
        });

        if (!a) return void YC.error("[".concat(_this306._clientId, "] can not find target user!(on_add_stream)"));
        YC.debug("[".concat(_this306._clientId, "] stream added with uid ").concat(t, ", type ").concat(e)), _this306.store.subscribe(a.uid, e, void 0, void 0, void 0, Date.now());
        var c = "audio" === e ? a.hasAudio : a.hasVideo;
        a._uintid || (a._uintid = s || t), "audio" === e ? a._trust_audio_stream_added_state_ = !0 : a._trust_video_stream_added_state_ = !0, "audio" === e ? (a._audio_added_ = !0, void 0 !== i && (a._audioSSRC = i), void 0 !== n && (a._cname = n), r && (a._audioOrtc = r)) : (a._video_added_ = !0, void 0 !== i && (a._videoSSRC = i), void 0 !== n && (a._cname = n), void 0 !== o && (a._rtxSsrcId = o), r && (a._videoOrtc = r)), ("audio" === e ? a.hasAudio : a.hasVideo) && !c && (YC.info("[".concat(_this306._clientId, "] remote user ").concat(a.uid, " published ").concat(e)), _this306.safeEmit(dg.USER_PUBLISHED, a, e)), "video" === e ? rI.onGatewayStream(_this306._sessionId, QC.ON_ADD_VIDEO_STREAM, ZC.ON_ADD_VIDEO_STREAM, {
          peer: s || t,
          ssrc: a._videoSSRC
        }) : rI.onGatewayStream(_this306._sessionId, QC.ON_ADD_AUDIO_STREAM, ZC.ON_ADD_AUDIO_STREAM, {
          peer: s || t,
          ssrc: a._audioSSRC
        }), _this306._p2pChannel.remoteMediaSsrcChanged(a, e, i).then(function (t) {
          if (t && (YC.debug("[".concat(_this306._clientId, "] resubscribe ").concat(e, " for user ").concat(a.uid, " after rejoin because SSRC id changed.")), _this306._p2pChannel instanceof nM)) return _this306._p2pChannel.unsubscribe(a, e, !0).then(function () {
            return _this306._subscribe(a, e, !0).catch(function (e) {
              YC.error("[".concat(_this306._clientId, "] resubscribe error"), e.toString());
            });
          });
        }), _this306._p2pChannel.hasPendingRemoteMedia(a, e) && (YC.debug("[".concat(_this306._clientId, "] resubscribe ").concat(e, " for user ").concat(a.uid, " after reconnect.")), _this306._subscribe(a, e, !0).catch(function (e) {
          YC.error("[".concat(_this306._clientId, "] resubscribe error"), e.toString());
        }));
      }), nh(_assertThisInitialized(_this306), "_handleRemoveStream", function (e) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(e.uid, _this306.channelName)) return;

        var t = _this306._users.find(function (t) {
          return t.uid === e.uid;
        });

        if (!t) return void YC.warning("[".concat(_this306._clientId, "] can not find target user!(on_remove_stream)"));
        YC.debug("[".concat(_this306._clientId, "] stream removed with uid ").concat(e.uid));

        var i = function i() {};

        t.hasAudio && t.hasVideo ? i = function i() {
          YC.info("[".concat(_this306._clientId, "] remote user ").concat(t.uid, " unpublished audio track")), _this306.safeEmit(dg.USER_UNPUBLISHED, t, "audio"), YC.info("[".concat(_this306._clientId, "] remote user ").concat(t.uid, " unpublished video track")), _this306.safeEmit(dg.USER_UNPUBLISHED, t, "video");
        } : t.hasVideo ? i = function i() {
          YC.info("[".concat(_this306._clientId, "] remote user ").concat(t.uid, " unpublished video track")), _this306.safeEmit(dg.USER_UNPUBLISHED, t, "video");
        } : t.hasAudio && (i = function i() {
          YC.info("[".concat(_this306._clientId, "] remote user ").concat(t.uid, " unpublished audio track")), _this306.safeEmit(dg.USER_UNPUBLISHED, t, "audio");
        }), t._video_pre_subscribed || t._audio_pre_subscribed || (t._trust_audio_stream_added_state_ = !0, t._trust_video_stream_added_state_ = !0, t._audio_added_ = !1, t._video_added_ = !1, _this306._p2pChannel instanceof nM && _this306._p2pChannel.unsubscribe(t).then(function (e) {
          if (e) return _this306._gateway.unsubscribe(e, t.uid);
        }), t._audioSSRC = void 0, t._videoSSRC = void 0, t._audioOrtc = void 0, t._videoOrtc = void 0, t._rtxSsrcId = void 0), rI.onGatewayStream(_this306._sessionId, QC.ON_REMOVE_STREAM, ZC.ON_REMOVE_STREAM, {
          peer: e.uint_id || e.uid
        }), i();
      }), nh(_assertThisInitialized(_this306), "_handleSetStreamLocalEnable", function (e, t, i) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(t, _this306.channelName)) return;

        var n = _this306._users.find(function (e) {
          return e.uid === t;
        });

        if (!n) return void YC.error("[".concat(_this306._clientId, "] can not find target user!(disable_local)"));
        YC.debug("[".concat(_this306._clientId, "] local ").concat(e, " ").concat(i ? "enabled" : "disabled", " with uid ").concat(t));
        var s = "audio" === e ? n.hasAudio : n.hasVideo;

        if ("audio" === e) {
          n._trust_audio_enabled_state_ = !0;
          var _e371 = n._audio_enabled_;
          if (n._audio_enabled_ = i, n._audio_enabled_ === _e371) return;
          {
            var _e372 = n._audio_enabled_ ? "enable-local-audio" : "disable-local-audio";

            YC.debug("[".concat(_this306._clientId, "] user-info-updated, uid: ").concat(t, ", msg: ").concat(_e372)), _this306.safeEmit(dg.USER_INFO_UPDATED, t, _e372);
          }
        } else {
          n._trust_video_enabled_state_ = !0;
          var _e373 = n._video_enabled_;
          if (n._video_enabled_ = i, n._video_enabled_ === _e373) return;
          {
            var _e374 = n._video_enabled_ ? "enable-local-video" : "disable-local-video";

            YC.debug("[".concat(_this306._clientId, "] user-info-update, uid: ").concat(t, ", msg: ").concat(_e374)), _this306.safeEmit(dg.USER_INFO_UPDATED, t, _e374);
          }
        }

        var r = "audio" === e ? n.hasAudio : n.hasVideo;
        return s !== r ? !s && r ? (YC.info("[".concat(_this306._clientId, "] remote user ").concat(t, " published ").concat(e)), void _this306.safeEmit(dg.USER_PUBLISHED, n, e)) : ("video" === e && n._videoTrack && n._videoTrack._destroy(), "audio" === e && n._audioTrack, _this306._p2pChannel.muteRemote(n, e), YC.info("[".concat(_this306._clientId, "] remote user ").concat(t, " unpublished ").concat(e)), void _this306.safeEmit(dg.USER_UNPUBLISHED, n, e)) : void 0;
      }), nh(_assertThisInitialized(_this306), "_handleMuteStream", function (e, t, i) {
        if (DC("BLOCK_LOCAL_CLIENT") && lI(e, _this306.channelName)) return;
        YC.debug("[".concat(_this306._clientId, "] receive mute message"), e, t, i);

        var n = _this306._users.find(function (t) {
          return t.uid === e;
        });

        if (!n) return void YC.warning("[".concat(_this306._clientId, "] can not find remote user, ignore mute event, uid: ").concat(e));
        var s = "audio" === t ? n.hasAudio : n.hasVideo;

        if ("audio" === t) {
          n._trust_audio_mute_state_ = !0;
          var _t308 = n._audio_muted_;
          if (n._audio_muted_ = i, n._audio_muted_ === _t308) return;
          {
            var _t309 = n._audio_muted_ ? "mute-audio" : "unmute-audio";

            YC.debug("[".concat(_this306._clientId, "] user-info-update, uid: ").concat(e, ", msg: ").concat(_t309)), _this306.safeEmit(dg.USER_INFO_UPDATED, e, _t309);
          }
        } else {
          n._trust_video_mute_state_ = !0;
          var _t310 = n._video_muted_;
          if (n._video_muted_ = i, n._video_muted_ === _t310) return;
          {
            var _t311 = n._video_muted_ ? "mute-video" : "unmute-video";

            YC.debug("[".concat(_this306._clientId, "] user-info-update, uid: ").concat(e, ", msg: ").concat(_t311)), _this306.safeEmit(dg.USER_INFO_UPDATED, e, _t311);
          }
        }

        var r = "audio" === t ? n.hasAudio : n.hasVideo;

        if (s !== r) {
          if (!s && r) {
            return ("audio" === t ? n._audioSSRC : n._videoSSRC) ? (YC.info("[".concat(_this306._clientId, "] remote user ").concat(e, " published ").concat(t)), void _this306.safeEmit(dg.USER_PUBLISHED, n, t)) : void YC.warning("[".concat(_this306._clientId, "] remote user ").concat(e, " receive ").concat(t, " unmute message  before add stream message, ").concat(t, " SSRC doesn't exist yet."));
          }

          "video" === t && n._videoTrack && !n._video_pre_subscribed && n._videoTrack._destroy(), "audio" === t && n._audioTrack, _this306._p2pChannel.muteRemote(n, t), YC.info("[".concat(_this306._clientId, "] remote user ").concat(e, " unpublished ").concat(t)), _this306.safeEmit(dg.USER_UNPUBLISHED, n, t);
        }
      }), nh(_assertThisInitialized(_this306), "_handleP2PLost", /*#__PURE__*/function () {
        var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee390(e) {
          return _regeneratorRuntime.wrap(function _callee390$(_context390) {
            while (1) {
              switch (_context390.prev = _context390.next) {
                case 0:
                  YC.debug("[".concat(_this306._clientId, "] receive p2p lost"), e);

                  if (!(parseInt(e.p2pid, 10) === _this306.store.p2pId)) {
                    _context390.next = 6;
                    break;
                  }

                  _context390.next = 4;
                  return _this306._p2pChannel.requestReconnect();

                case 4:
                  _context390.next = 7;
                  break;

                case 6:
                  YC.warning("[".concat(_this306._clientId, "] P2PLost stream not found"), e);

                case 7:
                case "end":
                  return _context390.stop();
              }
            }
          }, _callee390);
        }));

        return function (_x612) {
          return _ref88.apply(this, arguments);
        };
      }()), nh(_assertThisInitialized(_this306), "_handleTokenWillExpire", function () {
        YC.debug("[".concat(_this306._clientId, "] received message onTokenPrivilegeWillExpire")), _this306.safeEmit(dg.ON_TOKEN_PRIVILEGE_WILL_EXPIRE);
      }), nh(_assertThisInitialized(_this306), "_handleBeforeUnload", function (e) {
        "beforeunload" === e.type && void 0 !== e.returnValue && "" !== e.returnValue || (_this306.leave(), YC.info("[".concat(_this306._clientId, "] auto leave onbeforeunload or pagehide")));
      }), nh(_assertThisInitialized(_this306), "_handleUpdateNetworkQuality", function () {
        if ("normal" === _this306._networkQualitySensitivity) return;
        if (navigator && void 0 !== navigator.onLine && !navigator.onLine) return void _this306.safeEmit(dg.NETWORK_QUALITY, {
          downlinkNetworkQuality: 6,
          uplinkNetworkQuality: 6
        });
        var e = {
          downlinkNetworkQuality: 0,
          uplinkNetworkQuality: 0
        };
        e.uplinkNetworkQuality = _this306._p2pChannel.getUplinkNetworkQuality(), e.downlinkNetworkQuality = _this306._p2pChannel.getDownlinkNetworkQuality(), _this306.safeEmit(dg.NETWORK_QUALITY, e);
      }), nh(_assertThisInitialized(_this306), "_handleP2PAddAudioOrVideoStream", function (e, t, i, n) {
        var s = _this306._users.find(function (e) {
          return e.uid === t;
        });

        if (!s) return void YC.error("[".concat(_this306._clientId, "] can not find target user!(on_add_stream)"));
        YC.debug("[".concat(_this306._clientId, "] stream added with uid ").concat(t, ", type ").concat(e)), _this306.store.subscribe(s.uid, e, void 0, void 0, void 0, Date.now());
        var r = "audio" === e ? s.hasAudio : s.hasVideo;
        "audio" === e ? s._trust_audio_stream_added_state_ = !0 : s._trust_video_stream_added_state_ = !0, "audio" === e ? (s._audio_added_ = !0, void 0 !== i && (s._audioSSRC = i), void 0 !== n && (s._audioMid = n)) : (s._video_added_ = !0, void 0 !== i && (s._videoSSRC = i), void 0 !== n && (s._videoMid = n)), ("audio" === e ? s.hasAudio : s.hasVideo) && !r && (YC.info("[".concat(_this306._clientId, "] remote user ").concat(s.uid, " published ").concat(e)), _this306.safeEmit(dg.USER_PUBLISHED, s, e)), _this306._p2pChannel.hasPendingRemoteMedia(s, e) && (YC.debug("[".concat(_this306._clientId, "] resubscribe ").concat(e, " for user ").concat(s.uid, " after reconnect.")), _this306._subscribe(s, e, !0).catch(function (e) {
          YC.error("[".concat(_this306._clientId, "] resubscribe error"), e.toString());
        }));
      }), _this306._config = e, _this306._clientId = xg(5, "client-"), _this306.store = new UC(e.codec, e.audioCodec, e.mode, _this306._clientId), _this306.store.clientCreated(), e.proxyServer && _this306.setProxyServer(e.proxyServer, !0), e.turnServer && _this306.setTurnServer(e.turnServer, !0), YC.info("[".concat(_this306._clientId, "] Initializing AgoraRTC client v").concat(yC, " build: ").concat(wC, ", mode: ").concat(_this306.mode, ", codec: ").concat(_this306.codec)), e.clientRoleOptions) try {
        mg(e.clientRoleOptions), t = Object.assign({}, e.clientRoleOptions);
      } catch (e) {
        YC.warning("[".concat(_this306._clientId, "] ").concat(e.toString()));
      }
      _this306._statsCollector = new uk(_this306.store), _this306._statsCollector.onStatsException = function (e, t, i) {
        YC.debug("[".concat(_this306._clientId, "] receive exception msg, code: ").concat(e, ", msg: ").concat(t, ", uid: ").concat(i)), _this306.safeEmit(dg.EXCEPTION, {
          code: e,
          msg: t,
          uid: i
        });
      }, _this306._statsCollector.onUploadPublishDuration = function (e, t, i, n) {
        var s = _this306._users.find(function (t) {
          return t.uid === e;
        });

        s && rI.peerPublishStatus(_this306._sessionId, {
          subscribeElapse: n,
          audioPublishDuration: t,
          videoPublishDuration: i,
          peer: s._uintid
        });
      }, _this306.store.useDataChannel = wA().supportDataChannel && DC("SIGNAL_CHANNEL"), _this306.store.useP2P = "p2p" === e.mode, _this306._gateway = new Gy(_this306.store, {
        clientId: _this306._clientId,
        mode: _this306.mode,
        codec: _this306.codec,
        websocketRetryConfig: e.websocketRetryConfig || Jg,
        httpRetryConfig: e.httpRetryConfig || Jg,
        forceWaitGatewayResponse: void 0 === e.forceWaitGatewayResponse || e.forceWaitGatewayResponse,
        statsCollector: _this306._statsCollector,
        role: e.role,
        clientRoleOptions: t
      }), _this306._configDistribute = new AA(), _this306.store.useP2P ? (_this306._p2pChannel = new ak(_this306.store, _this306._statsCollector), _this306._handleP2PEvents()) : _this306._p2pChannel = new nM(_this306.store, _this306._statsCollector), _this306._handleP2PChannelEvents(), _this306._handleGatewayEvents(), _this306._handleGatewaySignalEvents();
      return _possibleConstructorReturn(_this306);
    }

    _createClass(bU, [{
      key: "connectionState",
      get: function get() {
        return this._gateway.state;
      }
    }, {
      key: "remoteUsers",
      get: function get() {
        return this._users;
      }
    }, {
      key: "localTracks",
      get: function get() {
        return this._p2pChannel.getAllTracks(!0);
      }
    }, {
      key: "uid",
      get: function get() {
        return this._uid;
      }
    }, {
      key: "channelName",
      get: function get() {
        return this._channelName;
      }
    }, {
      key: "localDataChannels",
      get: function get() {
        return this._p2pChannel.getAllDataChannels();
      }
    }, {
      key: "mode",
      get: function get() {
        return this._config.mode;
      }
    }, {
      key: "role",
      get: function get() {
        var e;
        return (null === (e = this._config) || void 0 === e ? void 0 : e.role) || "audience";
      }
    }, {
      key: "codec",
      get: function get() {
        return this._config.codec;
      }
    }, {
      key: "audioCodec",
      get: function get() {
        return this._config.audioCodec || "opus";
      }
    }, {
      key: "isStringUID",
      get: function get() {
        return !!this._joinInfo && !!this._joinInfo.stringUid;
      }
    }, {
      key: "__className__",
      get: function get() {
        return "Client";
      }
    }, {
      key: "joinMeta",
      value: function () {
        var _joinMeta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee392(e, t, i, n, s) {
          var r,
              o,
              a,
              _args392 = arguments;
          return _regeneratorRuntime.wrap(function _callee392$(_context392) {
            while (1) {
              switch (_context392.prev = _context392.next) {
                case 0:
                  r = !(_args392.length > 5 && void 0 !== _args392[5]) || _args392[5], o = _args392.length > 6 && void 0 !== _args392[6] && _args392[6];
                  NC("JOIN_GATEWAY_USE_443PORT_ONLY", r), NC("JOIN_GATEWAY_USE_DUAL_DOMAIN", o);
                  a = this._gateway.signal.websocket;
                  return _context392.abrupt("return", (a instanceof Zv && (a.use443PortOnly = r, a.tryDoubleDomain = o), function () {
                    var _ref89 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee391(e, t, i) {
                      var n,
                          s,
                          _e375,
                          r,
                          o,
                          a,
                          c,
                          _args391 = arguments;

                      return _regeneratorRuntime.wrap(function _callee391$(_context391) {
                        while (1) {
                          switch (_context391.prev = _context391.next) {
                            case 0:
                              sT.get(e) || sT.set(e, []), rT.get(e) || rT.set(e, t), oT.get(e) || oT.set(e, 0);
                              n = sT.get(e), s = rT.get(e);

                              if (!(!n || !s)) {
                                _context391.next = 4;
                                break;
                              }

                              throw new Error("concurrent: deferQueue or maxConcurrency is null");

                            case 4:
                              if (!(oT.get(e) === s)) {
                                _context391.next = 9;
                                break;
                              }

                              _e375 = nT();
                              n.push(_e375);
                              _context391.next = 9;
                              return _e375.promise;

                            case 9:
                              oT.set(e, oT.get(e) + 1);

                              for (r = _args391.length, o = new Array(r > 3 ? r - 3 : 0), a = 3; a < r; a++) {
                                o[a - 3] = _args391[a];
                              }

                              _context391.next = 13;
                              return i.apply(void 0, o);

                            case 13:
                              c = _context391.sent;
                              return _context391.abrupt("return", (oT.set(e, oT.get(e) - 1), oT.get(e) === s - 1 && n.length > 0 && (n[0].resolve(), n.shift()), 0 === oT.get(e) && (sT.set(e, []), rT.set(e, 0), oT.set(e, 0)), c));

                            case 15:
                            case "end":
                              return _context391.stop();
                          }
                        }
                      }, _callee391);
                    }));

                    return function (_x618, _x619, _x620) {
                      return _ref89.apply(this, arguments);
                    };
                  }()("client.join", DC("JOIN_MAX_CONCURRENCY"), this.join.bind(this), e, t, i, n, s)));

                case 4:
                case "end":
                  return _context392.stop();
              }
            }
          }, _callee392, this);
        }));

        function joinMeta(_x613, _x614, _x615, _x616, _x617) {
          return _joinMeta.apply(this, arguments);
        }

        return joinMeta;
      }()
    }, {
      key: "join",
      value: function () {
        var _join5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee393(e, t, i, n, s) {
          var _this307 = this;

          var r, o, a, _e376, c, d, _e377, l, u, h, _n146, _s103, _e378, _yield$tT$all, _yield$tT$all2, _e379, _r68, _o51, _a31, _c9, _t312, p;

          return _regeneratorRuntime.wrap(function _callee393$(_context393) {
            while (1) {
              switch (_context393.prev = _context393.next) {
                case 0:
                  r = ++this._numberOfJoinCount;
                  this.store.joinStart(), n && (this.store.uid = n);
                  o = IC(), a = vC() ? window.isSecureContext : "Browser Not Support";

                  if (!vC() && !o || !window.isSecureContext) {
                    _e376 = "The website must be running in a secure context (About secure context: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts ), otherwise the media collection will be restricted by the browser";
                    YC.warning(_e376);
                  }

                  c = Vg();
                  "DISCONNECTED" === this.connectionState && (this.store.avoidJoinStart = Math.round(Date.now()), YC.debug("[".concat(this._clientId, "] set avoidJoinStart to ").concat(this.store.avoidJoinStart)));
                  d = rI.reportApiInvoke(c, {
                    name: rg.JOIN,
                    options: [e, t, i, n],
                    states: {
                      isHttps: o,
                      isSecureContext: a
                    },
                    tag: og.TRACER
                  });
                  rI.setAppId(e);
                  _context393.prev = 8;

                  if (!(!i && null !== i)) {
                    _context393.next = 11;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "Invalid token: ".concat(i, ". If you don not use token, set it to null"));

                case 11:
                  i && WT(i, "token", 1, 2047), WT(e, "appid", 1, 2047), FI(t), n && BI(n), s && WT(s, "optionalInfo", 1, 2047);
                  _context393.next = 17;
                  break;

                case 14:
                  _context393.prev = 14;
                  _context393.t0 = _context393["catch"](8);
                  throw d.onError(_context393.t0), _context393.t0;

                case 17:
                  if (!(YC.info("[".concat(this._clientId, "] start join channel ").concat(t, ", join number: ").concat(r)), this._leaveMutex.isLocked)) {
                    _context393.next = 24;
                    break;
                  }

                  YC.debug("[".concat(this._clientId, "] join: waiting leave operation"));
                  _context393.next = 21;
                  return this._leaveMutex.lock();

                case 21:
                  _context393.t1 = _context393.sent;
                  (0, _context393.t1)();
                  YC.debug("[".concat(this._clientId, "] join: continue"));

                case 24:
                  if (!(this._joinAndNotLeaveYet = !0, "DISCONNECTED" !== this.connectionState)) {
                    _context393.next = 27;
                    break;
                  }

                  _e377 = new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Client already in connecting/connected state"));
                  throw d.onError(_e377), _e377;

                case 27:
                  this._sessionId || (this._sessionId = c, this.store.sessionId = this._sessionId), this._gateway.state = "CONNECTING";
                  l = AU(AU({}, this._rtmConfig), {}, {
                    clientId: this._clientId,
                    appId: e,
                    sid: this._sessionId,
                    cname: t,
                    uid: "string" != typeof n ? n : null,
                    turnServer: this._turnServer,
                    proxyServer: this._proxyServer,
                    token: i || e,
                    cloudProxyServer: this._cloudProxyServerMode,
                    optionalInfo: s,
                    license: this._license,
                    useLocalAccessPoint: this._useLocalAccessPoint
                  }, void 0 !== this._remoteDefaultVideoStreamType && {
                    defaultVideoStream: this._remoteDefaultVideoStreamType
                  });

                  if (!(this._useLocalAccessPoint && (l.setLocalAPVersion = this._setLocalAPVersion), "string" == typeof n && (l.stringUid = n, this._uintUid ? (l.uid = this._uintUid, this._uintUid = void 0) : l.uid = 0), "none" !== this._encryptionMode && this._encryptionSecret)) {
                    _context393.next = 37;
                    break;
                  }

                  l.aesmode = this._encryptionMode;
                  _context393.next = 33;
                  return eg(this._encryptionSecret);

                case 33:
                  l.aespassword = _context393.sent;

                  if (this._joinAndNotLeaveYet) {
                    _context393.next = 36;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));

                case 36:
                  this._encryptionSalt && (l.aessalt = this._encryptionSalt);

                case 37:
                  this._startSession(this._sessionId, {
                    channel: t,
                    appId: e,
                    stringUid: l.stringUid
                  });

                  u = this._sessionId;
                  setTimeout(function () {
                    "CONNECTING" === _this307.connectionState && u === _this307._sessionId && rI.joinChannelTimeout(_this307._sessionId, 5);
                  }, 5e3);
                  _context393.prev = 40;
                  _s103 = l.cloudProxyServer;

                  if (bn(h = ["proxy3", "proxy4", "proxy5"]).call(h, _s103)) {
                    _e378 = DC("PROXY_SERVER_TYPE3");
                    Array.isArray(_e378) ? l.proxyServer = _e378[0] : l.proxyServer = _e378;
                  }

                  if (!(rI.setProxyServer(l.proxyServer), YC.setProxyServer(l.proxyServer), this.store.requestAPStart(), l.stringUid && !l.uid)) {
                    _context393.next = 57;
                    break;
                  }

                  _context393.next = 46;
                  return tT.all([TA(l.stringUid, l, this._axiosCancelSource.token, this._config.httpRetryConfig || Jg, this.store), fA(l, this._axiosCancelSource.token, this._config.httpRetryConfig || Jg, !0, this.store)]);

                case 46:
                  _yield$tT$all = _context393.sent;
                  _yield$tT$all2 = _slicedToArray(_yield$tT$all, 2);
                  _e379 = _yield$tT$all2[0];
                  _n146 = _yield$tT$all2[1];
                  _yield$tT$all;
                  YC.debug("[".concat(this._clientId, "] getUserAccount Success ").concat(l.stringUid, " => ").concat(_e379));
                  l.uid = _e379;
                  _n146.gatewayInfo.uid = _e379;
                  _n146.gatewayInfo.res.uid = _e379;
                  _context393.next = 60;
                  break;

                case 57:
                  _context393.next = 59;
                  return fA(l, this._axiosCancelSource.token, this._config.httpRetryConfig || Jg, !0, this.store);

                case 59:
                  _n146 = _context393.sent;

                case 60:
                  if (this._joinAndNotLeaveYet) {
                    _context393.next = 62;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));

                case 62:
                  this.store.requestAPEnd(), setTimeout(function () {
                    _this307._configDistribute.startGetConfigDistribute(l, _this307._axiosCancelSource.token), _this307._configDistribute.on(lv.UPDATE_BITRATE_LIMIT, function (e) {
                      _this307._p2pChannel.updateBitrateLimit(e);
                    });
                  }, 0), this._key = i || e;
                  _r68 = _n146.gatewayInfo, _o51 = l.uid ? l.uid : _r68.uid;
                  this._joinInfo = AU(AU({}, l), {}, {
                    cid: _r68.cid,
                    uid: _o51,
                    vid: _r68.vid,
                    apResponse: _r68.res,
                    uni_lbs_ip: _r68.uni_lbs_ip,
                    gatewayAddrs: _r68.gatewayAddrs
                  }), this.store.intUid = _o51;
                  _context393.next = 67;
                  return this._joinGateway();

                case 67:
                  _a31 = _context393.sent;

                  if (this._joinAndNotLeaveYet) {
                    _context393.next = 70;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));

                case 70:
                  d.onSuccess(_a31), this._appId = e, this._channelName = l.cname, this._uid = _a31, this.store.uid = _a31, setTimeout(function () {
                    _this307._networkQualityInterval && window.clearInterval(_this307._networkQualityInterval), _this307._networkQualityInterval = window.setInterval(_this307._handleUpdateNetworkQuality, 2e3), window.addEventListener(ST() ? "beforeunload" : "pagehide", _this307._handleBeforeUnload);
                  }, 0);
                  _c9 = l.stringUid ? "string uid: ".concat(l.stringUid, ",uid: ").concat(l.uid) : "uid: ".concat(this._uid);
                  return _context393.abrupt("return", (YC.info("[".concat(this._clientId, "] Joining channel success: channel: ").concat(t, ",").concat(_c9)), setTimeout(function () {
                    YC.startUpload();
                  }, 5e3), this.store.joinEnd(), p = this, bn(dI).call(dI, p) || dI.push(p), _a31));

                case 75:
                  _context393.prev = 75;
                  _context393.t2 = _context393["catch"](40);
                  _t312 = Array.isArray(_context393.t2) ? _context393.t2[0] : _context393.t2;
                  throw _t312 && _t312.code === xT.OPERATION_ABORTED ? YC.warning("[".concat(this._clientId, "] join number: ").concat(r, ", Joining channel failed, rollback"), _t312) : YC.error("[".concat(this._clientId, "] join number: ").concat(r, ", Joining channel failed, rollback"), _t312), _t312.code !== xT.OPERATION_ABORTED && this._numberOfJoinCount === r && (this._gateway.state = "DISCONNECTED", this._reset()), d.onError(_t312), _t312;

                case 79:
                case "end":
                  return _context393.stop();
              }
            }
          }, _callee393, this, [[8, 14], [40, 75]]);
        }));

        function join(_x621, _x622, _x623, _x624, _x625) {
          return _join5.apply(this, arguments);
        }

        return join;
      }()
    }, {
      key: "_joinGateway",
      value: function _joinGateway() {
        var _this308 = this;

        if (!this._joinInfo || !this._key) throw new VI(xT.INVALID_OPERATION);
        return this._gateway.join(this._joinInfo, this._key, !("disabled" !== this._joinInfo.cloudProxyServer || this._joinInfo.proxyServer || !DC("JOIN_WITH_FALLBACK_SIGNAL_PROXY"))).then(function (e) {
          return e;
        }).catch(function (e) {
          if (e.code === xT.INIT_WEBSOCKET_TIMEOUT) return _this308._gateway.leave(!0, cg.FALLBACK), e;
          if (e.code === xT.INIT_DATACHANNEL_TIMEOUT) return _this308._gateway.leave(!0, cg.FALLBACK), e;
          throw e;
        }).then(function (e) {
          if (e instanceof VI) {
            if (e.code === xT.INIT_WEBSOCKET_TIMEOUT) {
              if (YC.info("[".concat(_this308._clientId, "] join timeout, fallback to proxy")), !_this308._joinInfo || !_this308._key) throw new VI(xT.INVALID_OPERATION);
              _this308._joinInfo.cloudProxyServer = "fallback", _this308._cloudProxyServerMode = "fallback", _this308.store.cloudProxyServerMode = "fallback";

              var _e380 = DC("PROXY_SERVER_TYPE3");

              if (Array.isArray(_e380)) {
                if (_this308._joinInfo.apUrl) {
                  var _t314 = /^https?:\/\/(.+?)(\/.*)?$/.exec(_this308._joinInfo.apUrl)[1].split("."),
                      i = _t314.slice(_t314.length - 2).join(".");

                  _e380.forEach(function (e) {
                    _this308._joinInfo && bn(e).call(e, i) && (_this308._joinInfo.proxyServer = e);
                  }), _this308._joinInfo.proxyServer || (_this308._joinInfo.proxyServer = _e380[0]);
                } else _this308._joinInfo.proxyServer = _e380[0];
              } else _this308._joinInfo.proxyServer = _e380;

              var _t313 = DC("LOG_UPLOAD_SERVER").match(/.+:(\d{1,5})$/);

              _t313 && _t313[1] && "443" !== _t313[1] && YC.setProxyServer(_this308._joinInfo.proxyServer), "443" !== DC("STATS_COLLECTOR_PORT").toString() && rI.setProxyServer(_this308._joinInfo.proxyServer);
              return rI.reportApiInvoke(_this308._sessionId, {
                name: rg.JOIN_FALLBACK_TO_PROXY,
                options: [_this308._joinInfo.proxyServer],
                tag: og.TRACER
              }).onSuccess(), _this308.safeEmit(dg.JOIN_FALLBACK_TO_PROXY, _this308._joinInfo.proxyServer), DC("JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE") && _this308._joinInfo.turnServer.servers.forEach(function (e) {
                "forceturn" in e && (e.forceturn = !0);
              }), _this308._gateway.join(_this308._joinInfo, _this308._key);
            }

            if (YC.info("[".concat(_this308._clientId, "] join by datachannel timeout, fallback to websocket")), !_this308._joinInfo || !_this308._key) throw new VI(xT.INVALID_OPERATION);
            return rI.reportApiInvoke(_this308._sessionId, {
              name: rg.DATACHANNEL_FAILBACK,
              options: [_this308.store.clientId],
              tag: og.TRACER
            }).onSuccess(), _this308._joinGateway();
          }

          return e;
        }).then(function (e) {
          return e;
        });
      }
    }, {
      key: "leave",
      value: function () {
        var _leave2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee394() {
          var e;
          return _regeneratorRuntime.wrap(function _callee394$(_context394) {
            while (1) {
              switch (_context394.prev = _context394.next) {
                case 0:
                  YC.info("[".concat(this._clientId, "] Leaving channel")), window.removeEventListener(ST() ? "beforeunload" : "pagehide", this._handleBeforeUnload), this._reset(), function (e) {
                    var t = dI.indexOf(e);
                    -1 !== t && dI.splice(t, 1);
                  }(this);
                  _context394.next = 3;
                  return this._leaveMutex.lock();

                case 3:
                  e = _context394.sent;

                  if (!("DISCONNECTED" === this.connectionState)) {
                    _context394.next = 6;
                    break;
                  }

                  return _context394.abrupt("return", (YC.info("[".concat(this._clientId, "] Leaving channel repeated, success")), void e()));

                case 6:
                  _context394.next = 8;
                  return this._gateway.leave("CONNECTED" !== this.connectionState);

                case 8:
                  YC.info("[".concat(this._clientId, "] Leaving channel success"));
                  this._joinAndNotLeaveYet = !1;
                  this.store.resetJoinChannelServiceRecords();
                  e();

                case 12:
                case "end":
                  return _context394.stop();
              }
            }
          }, _callee394, this);
        }));

        function leave() {
          return _leave2.apply(this, arguments);
        }

        return leave;
      }()
    }, {
      key: "publish",
      value: function () {
        var _publish2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee395(e) {
          var _this309 = this;

          var t,
              i,
              _iterator45,
              _step45,
              _e381,
              n,
              _args395 = arguments;

          return _regeneratorRuntime.wrap(function _callee395$(_context395) {
            while (1) {
              switch (_context395.prev = _context395.next) {
                case 0:
                  t = !(_args395.length > 1 && void 0 !== _args395[1]) || _args395[1];

                  if (Array.isArray(e)) {
                    _context395.next = 5;
                    break;
                  }

                  if (e instanceof _b) {
                    _context395.next = 4;
                    break;
                  }

                  return _context395.abrupt("return", this._publishDataChannel(e));

                case 4:
                  e = [e];

                case 5:
                  if (!(0 === e.length)) {
                    _context395.next = 7;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "param list is empty");

                case 7:
                  i = e;

                  if (!("audience" === this._gateway.role)) {
                    _context395.next = 10;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "audience can not publish stream");

                case 10:
                  _iterator45 = _createForOfIteratorHelper(i);
                  _context395.prev = 11;

                  _iterator45.s();

                case 13:
                  if ((_step45 = _iterator45.n()).done) {
                    _context395.next = 21;
                    break;
                  }

                  _e381 = _step45.value;

                  if (_e381 instanceof _b) {
                    _context395.next = 17;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "parameter is not local track");

                case 17:
                  if (!(!_e381._enabled && t)) {
                    _context395.next = 19;
                    break;
                  }

                  throw new VI(xT.TRACK_IS_DISABLED, "can not publish a disabled track: ".concat(_e381.getTrackId()));

                case 19:
                  _context395.next = 13;
                  break;

                case 21:
                  _context395.next = 26;
                  break;

                case 23:
                  _context395.prev = 23;
                  _context395.t0 = _context395["catch"](11);

                  _iterator45.e(_context395.t0);

                case 26:
                  _context395.prev = 26;

                  _iterator45.f();

                  return _context395.finish(26);

                case 29:
                  YC.info("[".concat(this._clientId, "] Publishing tracks, id ").concat(i.map(function (e) {
                    return "".concat(e.getTrackId(), " ");
                  })));
                  _context395.next = 32;
                  return this._publishMutex.lock();

                case 32:
                  n = _context395.sent;
                  _context395.next = 35;
                  return this._configDistribute.awaitConfigDistributeComplete();

                case 35:
                  t && i.forEach(function (e) {
                    var t = _this309._configDistribute.getBitrateLimit();

                    e instanceof Nw && t && e.setBitrateLimit(t.uplink);
                  });
                  _context395.prev = 36;
                  _context395.next = 39;
                  return this._publishHighStream(i);

                case 39:
                  YC.info("[".concat(this._clientId, "] Publish success, id ").concat(i.map(function (e) {
                    return "".concat(e.getTrackId(), " ");
                  })));
                  _context395.next = 45;
                  break;

                case 42:
                  _context395.prev = 42;
                  _context395.t1 = _context395["catch"](36);
                  throw YC.error("[".concat(this._clientId, "] publish error"), _context395.t1.toString()), _context395.t1;

                case 45:
                  _context395.prev = 45;
                  n();
                  return _context395.finish(45);

                case 48:
                case "end":
                  return _context395.stop();
              }
            }
          }, _callee395, this, [[11, 23, 26, 29], [36, 42, 45, 48]]);
        }));

        function publish(_x626) {
          return _publish2.apply(this, arguments);
        }

        return publish;
      }()
    }, {
      key: "_publishDataChannel",
      value: function () {
        var _publishDataChannel4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee396(e) {
          var t, i, _t315;

          return _regeneratorRuntime.wrap(function _callee396$(_context396) {
            while (1) {
              switch (_context396.prev = _context396.next) {
                case 0:
                  jT(e.id, "id", 0, 65535, !0), FT(e.ordered, "ordered"), WT(e.metadata, "metadata", 0, 512), YC.info("[".concat(this._clientId, "] Publishing datachannels, id ").concat(e.id));
                  _context396.next = 3;
                  return this._publishMutex.lock();

                case 3:
                  t = _context396.sent;
                  _context396.prev = 4;

                  if (!(-1 !== this._p2pChannel.getAllDataChannels().findIndex(function (t) {
                    return t.id === e.id;
                  }))) {
                    _context396.next = 7;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "Invalid id: ".concat(e.id, ". If you want to republish the datachannel, unpublish first"));

                case 7:
                  if (!(!this._joinInfo || void 0 === this._uid)) {
                    _context396.next = 9;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't publish datachannel, haven't joined yet!");

                case 9:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context396.next = 11;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish datachannel in ".concat(this.connectionState, " state"));

                case 11:
                  if (!("auto" === this._turnServer.mode && DC("FORCE_TURN") && !DC("TURN_ENABLE_TCP") && !DC("TURN_ENABLE_UDP"))) {
                    _context396.next = 13;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "force TURN With No TURN Configuration");

                case 13:
                  i = new EP(e);
                  _context396.next = 16;
                  return this._p2pChannel.publishDataChannel([i]);

                case 16:
                  _context396.prev = 16;
                  _t315 = {
                    streamId: e.id,
                    ordered: e.ordered,
                    maxRetransmits: DC("DATASTREAM_MAX_RETRANSMITS"),
                    metadata: e.metadata,
                    channelId: i._originDataChannelId
                  };
                  _context396.next = 20;
                  return this._gateway.publishDataChannel(this._uid, _t315, !0);

                case 20:
                  _context396.next = 26;
                  break;

                case 22:
                  _context396.prev = 22;
                  _context396.t0 = _context396["catch"](16);

                  if (!(_context396.t0.code !== xT.DISCONNECT_P2P)) {
                    _context396.next = 26;
                    break;
                  }

                  throw _context396.t0;

                case 26:
                  _context396.next = 28;
                  return i._waitTillOpen();

                case 28:
                  YC.info("[".concat(this._clientId, "] Publish dataChannels success, id ").concat(i.id));
                  return _context396.abrupt("return", i);

                case 32:
                  _context396.prev = 32;
                  _context396.t1 = _context396["catch"](4);
                  throw YC.error("[".concat(this._clientId, "] publish datachannels error"), _context396.t1.toString()), _context396.t1;

                case 35:
                  _context396.prev = 35;
                  t();
                  return _context396.finish(35);

                case 38:
                case "end":
                  return _context396.stop();
              }
            }
          }, _callee396, this, [[4, 32, 35, 38], [16, 22]]);
        }));

        function _publishDataChannel(_x627) {
          return _publishDataChannel4.apply(this, arguments);
        }

        return _publishDataChannel;
      }()
    }, {
      key: "unpublish",
      value: function () {
        var _unpublish4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee397(e) {
          var t, i, _e382, _e383;

          return _regeneratorRuntime.wrap(function _callee397$(_context397) {
            while (1) {
              switch (_context397.prev = _context397.next) {
                case 0:
                  if (!(!this._joinInfo || void 0 === this._uid)) {
                    _context397.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't unpublish stream, haven't joined yet!");

                case 2:
                  t = [];

                  if (!e) {
                    _context397.next = 13;
                    break;
                  }

                  if (!Array.isArray(e)) {
                    _context397.next = 8;
                    break;
                  }

                  t = e;
                  _context397.next = 11;
                  break;

                case 8:
                  if (e instanceof _b) {
                    _context397.next = 10;
                    break;
                  }

                  return _context397.abrupt("return", this._unpublishDataChannel([e]));

                case 10:
                  t = [e];

                case 11:
                  _context397.next = 18;
                  break;

                case 13:
                  _context397.t0 = this.store.useP2P;

                  if (_context397.t0) {
                    _context397.next = 17;
                    break;
                  }

                  _context397.next = 17;
                  return this._unpublishDataChannel();

                case 17:
                  t = this._p2pChannel.getAllTracks(!0);

                case 18:
                  YC.info("[".concat(this._clientId, "] Unpublish tracks, tracks ").concat(t.map(function (e) {
                    return "".concat(e.getTrackId(), " ");
                  }), " "));
                  _context397.next = 21;
                  return this._publishMutex.lock();

                case 21:
                  i = _context397.sent;
                  _context397.prev = 22;

                  if (!(this._p2pChannel instanceof ak)) {
                    _context397.next = 33;
                    break;
                  }

                  _context397.next = 26;
                  return this._p2pChannel.unpublish(t);

                case 26:
                  _e382 = _context397.sent;
                  _context397.t1 = _e382;

                  if (!_context397.t1) {
                    _context397.next = 31;
                    break;
                  }

                  _context397.next = 31;
                  return this._gateway.sendExtensionMessage(Ov.UNPUBLISH, {
                    unpubMsg: _e382
                  }, !0);

                case 31:
                  _context397.next = 41;
                  break;

                case 33:
                  _context397.next = 35;
                  return this._p2pChannel.unpublish(t);

                case 35:
                  _e383 = _context397.sent;
                  _context397.t2 = _e383;

                  if (!_context397.t2) {
                    _context397.next = 40;
                    break;
                  }

                  _context397.next = 40;
                  return this._gateway.unpublish(_e383, this._uid);

                case 40:
                  YC.info("[".concat(this._clientId, "] Unpublish success,tracks ").concat(t.map(function (e) {
                    return "".concat(e.getTrackId());
                  })));

                case 41:
                  _context397.next = 46;
                  break;

                case 43:
                  _context397.prev = 43;
                  _context397.t3 = _context397["catch"](22);
                  throw YC.error("[".concat(this._clientId, "] unpublish error"), _context397.t3.toString()), _context397.t3;

                case 46:
                  _context397.prev = 46;
                  i && i();
                  return _context397.finish(46);

                case 49:
                case "end":
                  return _context397.stop();
              }
            }
          }, _callee397, this, [[22, 43, 46, 49]]);
        }));

        function unpublish(_x628) {
          return _unpublish4.apply(this, arguments);
        }

        return unpublish;
      }()
    }, {
      key: "_unpublishDataChannel",
      value: function () {
        var _unpublishDataChannel4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee398(e) {
          var t, i;
          return _regeneratorRuntime.wrap(function _callee398$(_context398) {
            while (1) {
              switch (_context398.prev = _context398.next) {
                case 0:
                  void 0 !== e && 0 !== e.length || (e = this._p2pChannel.getAllDataChannels()), YC.info("[".concat(this._clientId, "] Unpublish datachannels, datachannels ").concat(e.map(function (e) {
                    return "".concat(e.id, " ");
                  }), " "));
                  _context398.next = 3;
                  return this._publishMutex.lock();

                case 3:
                  t = _context398.sent;
                  _context398.prev = 4;
                  _context398.next = 7;
                  return this._p2pChannel.unpublishDataChannel(e);

                case 7:
                  i = _context398.sent;
                  _context398.t0 = i;

                  if (!_context398.t0) {
                    _context398.next = 12;
                    break;
                  }

                  _context398.next = 12;
                  return this._gateway.unpublishDataChannel(i);

                case 12:
                  YC.info("[".concat(this._clientId, "] Unpublish dataChannel success,dataChannel ").concat(e.map(function (e) {
                    return "".concat(e.id);
                  })));
                  _context398.next = 18;
                  break;

                case 15:
                  _context398.prev = 15;
                  _context398.t1 = _context398["catch"](4);
                  throw YC.error("[".concat(this._clientId, "] unpublish dataChannel error"), _context398.t1.toString()), _context398.t1;

                case 18:
                  _context398.prev = 18;
                  t && t();
                  return _context398.finish(18);

                case 21:
                case "end":
                  return _context398.stop();
              }
            }
          }, _callee398, this, [[4, 15, 18, 21]]);
        }));

        function _unpublishDataChannel(_x629) {
          return _unpublishDataChannel4.apply(this, arguments);
        }

        return _unpublishDataChannel;
      }()
    }, {
      key: "subscribe",
      value: function () {
        var _subscribe4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee399(e, t, i) {
          return _regeneratorRuntime.wrap(function _callee399$(_context399) {
            while (1) {
              switch (_context399.prev = _context399.next) {
                case 0:
                  return _context399.abrupt("return", "datachannel" === t ? this._subscribeDataChannel(e, i) : this._subscribe(e, t));

                case 1:
                case "end":
                  return _context399.stop();
              }
            }
          }, _callee399, this);
        }));

        function subscribe(_x630, _x631, _x632) {
          return _subscribe4.apply(this, arguments);
        }

        return subscribe;
      }()
    }, {
      key: "presubscribe",
      value: function () {
        var _presubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee400(e, t) {
          var i, n, s, _yield$this$_gateway$, _r69, _o52, _a32, c, _d22, _l19, _u11;

          return _regeneratorRuntime.wrap(function _callee400$(_context400) {
            while (1) {
              switch (_context400.prev = _context400.next) {
                case 0:
                  if (!(BT(t, "mediaType", ["audio", "video"]), this._p2pChannel instanceof ak)) {
                    _context400.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can't presub at p2p mode");

                case 2:
                  if (this._joinInfo) {
                    _context400.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can't presub when not join");

                case 4:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context400.next = 6;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can't presub in ".concat(this.connectionState, " state"));

                case 6:
                  i = t === hv.AUDIO;
                  n = t === hv.VIDEO;
                  _context400.next = 10;
                  return this._subscribeMutex.lock();

                case 10:
                  s = _context400.sent;
                  _context400.prev = 11;
                  _context400.next = 14;
                  return this._gateway.presubscribe(e, t, !0);

                case 14:
                  _yield$this$_gateway$ = _context400.sent;
                  _r69 = _yield$this$_gateway$.ssrcId;
                  _o52 = _yield$this$_gateway$.ortc;
                  _a32 = _yield$this$_gateway$.rtxSsrcId;
                  c = _yield$this$_gateway$.cname;
                  _d22 = _yield$this$_gateway$.uint_id;

                  if (!(null == _r69)) {
                    _context400.next = 22;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_RESPONSE, "no ssrc id");

                case 22:
                  _l19 = this._users.find(function (t) {
                    return t.uid === e;
                  });
                  _l19 || (_l19 = new ik(e, _d22 || e), _l19._is_pre_created = !0, this._users.push(_l19));
                  c && (_l19._cname = c);
                  _l19._uintid || (_l19._uintid = _d22 || e);
                  i && (_l19._audioSSRC = _r69, _l19._audio_pre_subscribed = !0, _o52 && (_l19._audioOrtc = _o52));
                  n && (_l19._videoSSRC = _r69, _l19._video_pre_subscribed = !0, _o52 && (_l19._videoOrtc = _o52), null != _a32 && (_l19._rtxSsrcId = _a32));
                  YC.info("[".concat(this._clientId, "] presub succeed ssrc: ").concat(_r69));
                  _context400.next = 31;
                  return this._p2pChannel.subscribe(_l19, t, _r69, _a32, _o52);

                case 31:
                  _u11 = i ? _l19._audioTrack : _l19._videoTrack;

                  if (_u11) {
                    _context400.next = 34;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "can not find remote track in user");

                case 34:
                  return _context400.abrupt("return", (i && (_l19._trust_audio_stream_added_state_ = !0, _l19._audio_added_ = !0), n && (_l19._trust_video_stream_added_state_ = !0, _l19._video_added_ = !0), _u11));

                case 37:
                  _context400.prev = 37;
                  _context400.t0 = _context400["catch"](11);
                  throw YC.error("[".concat(this._clientId, "] presub user ").concat(e, " error"), _context400.t0), _context400.t0;

                case 40:
                  _context400.prev = 40;
                  s();
                  return _context400.finish(40);

                case 43:
                case "end":
                  return _context400.stop();
              }
            }
          }, _callee400, this, [[11, 37, 40, 43]]);
        }));

        function presubscribe(_x633, _x634) {
          return _presubscribe2.apply(this, arguments);
        }

        return presubscribe;
      }()
    }, {
      key: "_subscribeDataChannel",
      value: function () {
        var _subscribeDataChannel4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee401(e, t) {
          var i, n, s, _t316, r, _t317;

          return _regeneratorRuntime.wrap(function _callee401$(_context401) {
            while (1) {
              switch (_context401.prev = _context401.next) {
                case 0:
                  if (!(jT(t, "channelId", 0, 65535, !0), !this._joinInfo)) {
                    _context401.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe datachannel, not joined");

                case 2:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context401.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe datachannel in ".concat(this.connectionState, " state"));

                case 4:
                  if (this._users.find(function (t) {
                    return t === e;
                  })) {
                    _context401.next = 6;
                    break;
                  }

                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");

                case 6:
                  if (!(!e.hasAudio && !e.hasVideo && 0 === e._dataChannels.length)) {
                    _context401.next = 8;
                    break;
                  }

                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), new VI(xT.INVALID_REMOTE_USER, "user is not published");

                case 8:
                  n = null === (i = e._dataChannels) || void 0 === i ? void 0 : i.find(function (e) {
                    return e.id === t;
                  });

                  if (n) {
                    _context401.next = 11;
                    break;
                  }

                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType datachannel, remote datachannel is not published")), new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);

                case 11:
                  _context401.next = 13;
                  return this._subscribeMutex.lock();

                case 13:
                  s = _context401.sent;
                  YC.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: datachannel"));
                  _context401.prev = 15;
                  _context401.next = 18;
                  return this._p2pChannel.subscribeDataChannel(e, [n]);

                case 18:
                  _t316 = _context401.sent;

                  if (!(_t316 && bn(_t316).call(_t316, n.id))) {
                    _context401.next = 37;
                    break;
                  }

                  _context401.prev = 20;

                  if (n._originDataChannelId) {
                    _context401.next = 23;
                    break;
                  }

                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType datachannel, cannot get RTCDatachannel")), new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);

                case 23:
                  _t317 = {
                    id: n.id,
                    datachannelId: n._originDataChannelId,
                    ordered: n.ordered,
                    maxRetransmits: n.maxRetransmits,
                    metadata: null !== (r = n.metadata) && void 0 !== r ? r : ""
                  };
                  _context401.next = 26;
                  return this._gateway.subscribeDataChannel(e.uid, _t317, !0);

                case 26:
                  _context401.next = 37;
                  break;

                case 28:
                  _context401.prev = 28;
                  _context401.t0 = _context401["catch"](20);

                  if (!((null == _context401.t0 ? void 0 : _context401.t0.code) !== xT.WS_ABORT)) {
                    _context401.next = 34;
                    break;
                  }

                  _context401.next = 33;
                  return this._p2pChannel.unsubscribeDataChannel(e, [n]);

                case 33:
                  throw _context401.t0;

                case 34:
                  _context401.next = 36;
                  return this._p2pChannel.unsubscribeDataChannel(e, [n]);

                case 36:
                  this._p2pChannel.setPendingRemoteDataChannel(e, n.id);

                case 37:
                  _context401.next = 39;
                  return n._waitTillOpen();

                case 39:
                  YC.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: datachannel"));
                  return _context401.abrupt("return", n);

                case 41:
                  _context401.prev = 41;
                  s();
                  return _context401.finish(41);

                case 44:
                case "end":
                  return _context401.stop();
              }
            }
          }, _callee401, this, [[15,, 41, 44], [20, 28]]);
        }));

        function _subscribeDataChannel(_x635, _x636) {
          return _subscribeDataChannel4.apply(this, arguments);
        }

        return _subscribeDataChannel;
      }()
    }, {
      key: "_p2pSubscribe",
      value: function () {
        var _p2pSubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee402(e, t, i) {
          var _this310 = this;

          var _t318, _t319, _i158, n, _i160, _n147, _i159;

          return _regeneratorRuntime.wrap(function _callee402$(_context402) {
            while (1) {
              switch (_context402.prev = _context402.next) {
                case 0:
                  if (!(BT(t, "mediaType", ["audio", "video"]), !this._joinInfo)) {
                    _context402.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream, not joined");

                case 2:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context402.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));

                case 4:
                  if (this._users.find(function (t) {
                    return t === e;
                  })) {
                    _context402.next = 7;
                    break;
                  }

                  _t318 = new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), _t318;

                case 7:
                  if (!(!e.hasAudio && !e.hasVideo)) {
                    _context402.next = 10;
                    break;
                  }

                  _t319 = new VI(xT.INVALID_REMOTE_USER, "user is not published");
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), _t319;

                case 10:
                  if (!(!i && ("audio" === t && !e.hasAudio || "video" === t && !e.hasVideo))) {
                    _context402.next = 13;
                    break;
                  }

                  _i158 = new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType ").concat(t, ", remote track is not published")), _i158;

                case 13:
                  _context402.next = 15;
                  return this._subscribeMutex.lock();

                case 15:
                  n = _context402.sent;
                  YC.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: ").concat(t));
                  _context402.prev = 17;
                  _context402.next = 20;
                  return this._p2pChannel.hasRemoteMediaWithLock(e, t);

                case 20:
                  if (!_context402.sent) {
                    _context402.next = 25;
                    break;
                  }

                  _context402.next = 23;
                  return this._p2pChannel.unmuteRemote(e, t);

                case 23:
                  _context402.next = 37;
                  break;

                case 25:
                  _context402.prev = 25;
                  _i160 = "audio" === t ? e._audioSSRC : e._videoSSRC, _n147 = "audio" === t ? e._audioMid : e._videoMid;
                  this.store.subscribe(e.uid, t, Date.now());
                  _context402.t0 = this._p2pChannel instanceof ak;

                  if (!_context402.t0) {
                    _context402.next = 32;
                    break;
                  }

                  _context402.next = 32;
                  return this._p2pChannel.subscribe(e, t, _i160, _n147);

                case 32:
                  _context402.next = 37;
                  break;

                case 34:
                  _context402.prev = 34;
                  _context402.t1 = _context402["catch"](25);
                  throw _context402.t1;

                case 37:
                  YC.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: ").concat(t)), this._defaultStreamFallbackType && this.setStreamFallbackOption(e.uid, this._defaultStreamFallbackType).catch(function (e) {
                    YC.warning("[".concat(_this310._clientId, "] auto set fallback failed"), e);
                  });
                  _i159 = "audio" === t ? e._audioTrack : e._videoTrack;

                  if (_i159) {
                    _context402.next = 41;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "can not find remote track in user object");

                case 41:
                  return _context402.abrupt("return", _i159);

                case 44:
                  _context402.prev = 44;
                  _context402.t2 = _context402["catch"](17);
                  throw YC.error("[".concat(this._clientId, "] subscribe user ").concat(e.uid, " error"), _context402.t2), _context402.t2;

                case 47:
                  _context402.prev = 47;
                  n();
                  return _context402.finish(47);

                case 50:
                case "end":
                  return _context402.stop();
              }
            }
          }, _callee402, this, [[17, 44, 47, 50], [25, 34]]);
        }));

        function _p2pSubscribe(_x637, _x638, _x639) {
          return _p2pSubscribe2.apply(this, arguments);
        }

        return _p2pSubscribe;
      }()
    }, {
      key: "_subscribe",
      value: function () {
        var _subscribe5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee403(e, t, i) {
          var _this311 = this;

          var _t320, _t321, _i161, n, s, r, o, a, _i163, _i162;

          return _regeneratorRuntime.wrap(function _callee403$(_context403) {
            while (1) {
              switch (_context403.prev = _context403.next) {
                case 0:
                  if (!(this._p2pChannel instanceof ak)) {
                    _context403.next = 2;
                    break;
                  }

                  return _context403.abrupt("return", this._p2pSubscribe(e, t));

                case 2:
                  if (!(BT(t, "mediaType", ["audio", "video"]), !this._joinInfo)) {
                    _context403.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream, not joined");

                case 4:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context403.next = 6;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));

                case 6:
                  if (this._users.find(function (t) {
                    return t === e;
                  })) {
                    _context403.next = 9;
                    break;
                  }

                  _t320 = new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), _t320;

                case 9:
                  if (!(!e.hasAudio && !e.hasVideo)) {
                    _context403.next = 12;
                    break;
                  }

                  _t321 = new VI(xT.INVALID_REMOTE_USER, "user is not published");
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), _t321;

                case 12:
                  if (i || ("audio" !== t || e.hasAudio && void 0 !== e._audioSSRC) && ("video" !== t || e.hasVideo && void 0 !== e._videoSSRC)) {
                    _context403.next = 15;
                    break;
                  }

                  _i161 = new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);
                  throw YC.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType ").concat(t, ", remote track is not published")), _i161;

                case 15:
                  n = "audio" === t ? e._audioSSRC : e._videoSSRC, s = "audio" === t ? e._audioOrtc : e._videoOrtc, r = "video" === t ? e._rtxSsrcId : void 0, o = {
                    stream_type: "audio" === t ? hv.AUDIO : hv.VIDEO,
                    ssrcId: n
                  };
                  _context403.next = 18;
                  return this._subscribeMutex.lock();

                case 18:
                  a = _context403.sent;
                  YC.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: ").concat(t));
                  _context403.prev = 20;
                  _context403.next = 23;
                  return this._p2pChannel.hasRemoteMediaWithLock(e, t);

                case 23:
                  if (!_context403.sent) {
                    _context403.next = 28;
                    break;
                  }

                  _context403.next = 26;
                  return this._p2pChannel.unmuteRemote(e, t);

                case 26:
                  _context403.next = 55;
                  break;

                case 28:
                  _context403.prev = 28;
                  _i163 = "audio" === t ? e._audioSSRC : e._videoSSRC;
                  void 0 !== _i163 && _i163 !== n && (n = _i163, s = "audio" === t ? e._audioOrtc : e._videoOrtc, r = "video" === t ? e._rtxSsrcId : void 0, o = {
                    stream_type: "audio" === t ? hv.AUDIO : hv.VIDEO,
                    ssrcId: n
                  });
                  TP.markSubscribeStart(this.store.clientId, n);
                  this.store.subscribe(e.uid, t, Date.now());
                  _context403.next = 35;
                  return this._p2pChannel.subscribe(e, t, n, r, s);

                case 35:
                  _context403.prev = 35;
                  _context403.next = 38;
                  return this._gateway.subscribe(e.uid, o, !0);

                case 38:
                  _context403.next = 49;
                  break;

                case 40:
                  _context403.prev = 40;
                  _context403.t0 = _context403["catch"](35);

                  if (!((null == _context403.t0 ? void 0 : _context403.t0.code) !== xT.WS_ABORT)) {
                    _context403.next = 46;
                    break;
                  }

                  _context403.next = 45;
                  return this._p2pChannel.unsubscribe(e, t);

                case 45:
                  throw _context403.t0;

                case 46:
                  _context403.next = 48;
                  return this._p2pChannel.unsubscribe(e, t, !0);

                case 48:
                  this._p2pChannel.setPendingRemoteMedia(e, t);

                case 49:
                  this.store.subscribe(e.uid, t, void 0, Date.now()), this._p2pChannel.reportSubscribeEvent(!0, null, e, t);
                  _context403.next = 55;
                  break;

                case 52:
                  _context403.prev = 52;
                  _context403.t1 = _context403["catch"](28);
                  throw this._p2pChannel.reportSubscribeEvent(!1, null == _context403.t1 ? void 0 : _context403.t1.code, e, t), _context403.t1;

                case 55:
                  YC.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: ").concat(t)), this._defaultStreamFallbackType && this.setStreamFallbackOption(e.uid, this._defaultStreamFallbackType).catch(function (e) {
                    YC.warning("[".concat(_this311._clientId, "] auto set fallback failed"), e);
                  });
                  _i162 = "audio" === t ? e._audioTrack : e._videoTrack;

                  if (_i162) {
                    _context403.next = 59;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "can not find remote track in user object");

                case 59:
                  return _context403.abrupt("return", _i162);

                case 62:
                  _context403.prev = 62;
                  _context403.t2 = _context403["catch"](20);
                  throw YC.error("[".concat(this._clientId, "] subscribe user ").concat(e.uid, " error"), _context403.t2), _context403.t2;

                case 65:
                  _context403.prev = 65;
                  a();
                  return _context403.finish(65);

                case 68:
                case "end":
                  return _context403.stop();
              }
            }
          }, _callee403, this, [[20, 62, 65, 68], [28, 52], [35, 40]]);
        }));

        function _subscribe(_x640, _x641, _x642) {
          return _subscribe5.apply(this, arguments);
        }

        return _subscribe;
      }()
    }, {
      key: "massSubscribe",
      value: function () {
        var _massSubscribe3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee404(e) {
          var _this312 = this;

          var t, i, n, s, r, o, _loop6, _t322, _ret, _t323, _n148, _s104, _r70, _o53, _n149, _a33, _i164, _e384, _e385, _iterator46, _step46, _e387, _t325, _i165, _t326;

          return _regeneratorRuntime.wrap(function _callee404$(_context404) {
            while (1) {
              switch (_context404.prev = _context404.next) {
                case 0:
                  if (!(HT(e, "subscribeList"), !this._joinInfo)) {
                    _context404.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream, not joined");

                case 2:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context404.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));

                case 4:
                  t = Date.now();
                  i = new Map();
                  _context404.next = 8;
                  return this._subscribeMutex.lock();

                case 8:
                  n = _context404.sent;
                  YC.info("[".concat(this._clientId, "]start massSubscribe user ").concat(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return "user: ".concat(null == t ? void 0 : t.uid, ", mediaType: ").concat(i);
                  }).join("; ")));
                  s = (e = _toConsumableArray(e)).map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return {
                      user: t,
                      mediaType: i
                    };
                  });
                  _context404.next = 13;
                  return this._p2pChannel.globalLock();

                case 13:
                  r = _context404.sent;
                  _context404.prev = 14;

                  _loop6 = function _loop6(_t322) {
                    var n = e[_t322],
                        r = n.user,
                        o = n.mediaType;

                    if (BT(o, "mediaType", ["audio", "video"]), !r) {
                      var _e388 = new VI(xT.INVALID_PARAMS, "user property does not exist in subscribeList item");

                      throw YC.error("[".concat(_this312._clientId, "] user property does not exist in subscribeList item")), _e388;
                    }

                    if (!_this312._users.find(function (e) {
                      return e === r;
                    })) {
                      var _i166 = new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");

                      YC.error("[".concat(_this312._clientId, "] can not massSubscribe ").concat(r.uid, ", this user is not in the channel")), s[_t322].error = _i166, e.splice(_t322, 1);
                      return "continue";
                    }

                    if ("audio" === o && (!r.hasAudio || void 0 === r._audioSSRC) || "video" === o && (!r.hasVideo || void 0 === r._videoSSRC)) {
                      var _i167 = new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);

                      YC.error("[".concat(_this312._clientId, "] can not subscribe ").concat(r.uid, " with mediaType ").concat(o, ", remote user is not published")), s[_t322].error = _i167, e.splice(_t322, 1);
                      return "continue";
                    }

                    var a = nv.Video | nv.LwoVideo,
                        c = i.get(r);

                    if (c) {
                      if ("video" === o ? c & a : c & nv.Audio) {
                        e.splice(_t322, 1), YC.warning("[".concat(_this312._clientId, "] repeat massSubscribe user:").concat(r.uid, ", mediaType:").concat(o, " twice"));
                        return "continue";
                      }

                      i.set(r, c | ("video" === o ? a : nv.Audio));
                    } else i.set(r, "video" === o ? a : nv.Audio);
                  };

                  _t322 = e.length - 1;

                case 17:
                  if (!(_t322 >= 0)) {
                    _context404.next = 24;
                    break;
                  }

                  _ret = _loop6(_t322);

                  if (!(_ret === "continue")) {
                    _context404.next = 21;
                    break;
                  }

                  return _context404.abrupt("continue", 21);

                case 21:
                  _t322--;
                  _context404.next = 17;
                  break;

                case 24:
                  _t323 = e.length - 1;

                case 25:
                  if (!(_t323 >= 0)) {
                    _context404.next = 35;
                    break;
                  }

                  _n148 = e[_t323], _s104 = _n148.user, _r70 = _n148.mediaType, _o53 = nv.Video | nv.LwoVideo;

                  if (!this._p2pChannel.hasRemoteMedia(_s104, _r70)) {
                    _context404.next = 32;
                    break;
                  }

                  _context404.next = 30;
                  return this._p2pChannel.unmuteRemoteNoLock(_s104, _r70);

                case 30:
                  _n149 = i.get(_s104);
                  i.set(_s104, "video" === _r70 ? _n149 ^ _o53 : _n149 ^ nv.Audio), e.splice(_t323, 1);

                case 32:
                  _t323--;
                  _context404.next = 25;
                  break;

                case 35:
                  this.store.massSubscribe(e.map(function (e) {
                    return {
                      userId: e.user.uid,
                      type: e.mediaType
                    };
                  }), t);
                  _a33 = cS(o = Array.from(i.entries())).call(o, function (e, t) {
                    var _t324 = _slicedToArray(t, 2),
                        i = _t324[0],
                        n = _t324[1];

                    if (0 === n) return e;
                    var s = {
                      stream_id: i.uid,
                      stream_type: n
                    };
                    return n & nv.Audio && (s.audio_ssrc = i._audioSSRC), n & nv.Video && (s.video_ssrc = i._videoSSRC), e.push(s), e;
                  }, []);
                  _context404.prev = 37;
                  _context404.t0 = e.length > 0;

                  if (!_context404.t0) {
                    _context404.next = 42;
                    break;
                  }

                  _context404.next = 42;
                  return this._p2pChannel.massSubscribeNoLock(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return {
                      user: t,
                      mediaType: i,
                      ssrcId: i === hv.VIDEO ? t._videoSSRC : t._audioSSRC,
                      rtxSsrcId: i === hv.VIDEO ? t._rtxSsrcId : void 0
                    };
                  }));

                case 42:
                  _i164 = new Map();

                  if (!(_a33.length > 0)) {
                    _context404.next = 48;
                    break;
                  }

                  _context404.next = 46;
                  return this._gateway.subscribeAll(_a33, !0);

                case 46:
                  _e384 = _context404.sent;
                  ((null == _e384 ? void 0 : _e384.users) || []).forEach(function (e) {
                    var t = e.stream_id,
                        n = e.video_error_code,
                        s = e.audio_error_code,
                        r = e.error_code;
                    (n || s || r) && _i164.set(t, {
                      video_error_code: n,
                      audio_error_code: s,
                      error_code: r
                    });
                  });

                case 48:
                  if (!(Array.from(_i164.entries()).length > 0)) {
                    _context404.next = 52;
                    break;
                  }

                  _e385 = Array.from(_i164.entries()).map(function (e) {
                    var t,
                        _e386 = _slicedToArray(e, 2),
                        i = _e386[0],
                        n = _e386[1];

                    n.error_code || n.video_error_code && n.audio_error_code ? t = void 0 : n.video_error_code ? t = hv.VIDEO : n.audio_error_code && (t = hv.AUDIO);
                    return {
                      user: _this312.remoteUsers.find(function (e) {
                        return e.uid === i;
                      }),
                      mediaType: t
                    };
                  });
                  _context404.next = 52;
                  return this._p2pChannel.massUnsubscribeNoLock(_e385);

                case 52:
                  _iterator46 = _createForOfIteratorHelper(s);

                  try {
                    for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                      _e387 = _step46.value;
                      _t325 = _i164.get(_e387.user.uid);

                      if (_t325) {
                        _i165 = _t325.error_code || "audio" === _e387.mediaType && _t325.audio_error_code || "video" === _e387.mediaType && _t325.video_error_code;

                        if (_i165) {
                          _t326 = Fv(_i165);
                          YC.error("user:".concat(_e387.user.uid, " mediaType:").concat(_e387.mediaType, " has massSubscribe error ").concat(_t326.desc)), _e387.error = new VI(xT.SUBSCRIBE_FAILED, "code ".concat(_i165, ": ").concat(_t326.desc));
                        }
                      }

                      _e387.error || ("video" === _e387.mediaType ? _e387.track = _e387.user.videoTrack : _e387.track = _e387.user.audioTrack);
                    }
                  } catch (err) {
                    _iterator46.e(err);
                  } finally {
                    _iterator46.f();
                  }

                  return _context404.abrupt("return", (this.store.massSubscribe(s.filter(function (e) {
                    return !e.error;
                  }).map(function (e) {
                    return {
                      userId: e.user.uid,
                      type: e.mediaType
                    };
                  }), void 0, Date.now()), s.forEach(function (e) {
                    var i;
                    rI.subscribe(_this312.store.sessionId, {
                      succ: !!e.error,
                      ec: (null === (i = e.error) || void 0 === i ? void 0 : i.code) || null,
                      video: e.mediaType === hv.VIDEO,
                      audio: e.mediaType === hv.AUDIO,
                      peerid: e.user.uid,
                      subscribeRequestid: e.mediaType === hv.VIDEO ? e.user._videoSSRC : e.user._audioSSRC,
                      p2pid: _this312.store.p2pId,
                      eventElapse: Math.floor(performance.now() - t)
                    }, !0);
                  }), YC.info("[".concat(this._clientId, "] massSubscribe success ").concat(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return "user: ".concat(null == t ? void 0 : t.uid, ", mediaType: ").concat(i);
                  }).join("; "))), s));

                case 57:
                  _context404.prev = 57;
                  _context404.t1 = _context404["catch"](37);
                  _context404.next = 61;
                  return this._p2pChannel.massUnsubscribeNoLock(e);

                case 61:
                  throw _context404.t1;

                case 62:
                  _context404.prev = 62;
                  r(), n();
                  return _context404.finish(62);

                case 65:
                case "end":
                  return _context404.stop();
              }
            }
          }, _callee404, this, [[14,, 62, 65], [37, 57]]);
        }));

        function massSubscribe(_x643) {
          return _massSubscribe3.apply(this, arguments);
        }

        return massSubscribe;
      }()
    }, {
      key: "unsubscribe",
      value: function () {
        var _unsubscribe4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee405(e, t, i) {
          var _t327, n, _i168;

          return _regeneratorRuntime.wrap(function _callee405$(_context405) {
            while (1) {
              switch (_context405.prev = _context405.next) {
                case 0:
                  if (!(t || this.store.useP2P)) {
                    _context405.next = 5;
                    break;
                  }

                  if (!("datachannel" === t)) {
                    _context405.next = 3;
                    break;
                  }

                  return _context405.abrupt("return", this._unsubscribeDataChannel(e, i));

                case 3:
                  _context405.next = 7;
                  break;

                case 5:
                  _context405.next = 7;
                  return this._unsubscribeDataChannel(e, i);

                case 7:
                  if (!(t && BT(t, "mediaType", ["audio", "video"]), !this._joinInfo)) {
                    _context405.next = 9;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't unsubscribe stream, haven't joined yet!");

                case 9:
                  if (this._users.find(function (t) {
                    return t === e;
                  })) {
                    _context405.next = 12;
                    break;
                  }

                  _t327 = new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");
                  throw YC.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, ", user is not in the channel")), _t327;

                case 12:
                  YC.info("[".concat(this._clientId, "] unsubscribe uid: ").concat(e.uid, ", mediaType: ").concat(t));
                  _context405.next = 15;
                  return this._subscribeMutex.lock();

                case 15:
                  n = _context405.sent;
                  _context405.prev = 16;

                  if (!(this._p2pChannel instanceof ak)) {
                    _context405.next = 22;
                    break;
                  }

                  _context405.next = 20;
                  return this._p2pChannel.unsubscribe(e, t);

                case 20:
                  _context405.next = 33;
                  break;

                case 22:
                  _context405.next = 24;
                  return this._p2pChannel.unsubscribe(e, t);

                case 24:
                  _i168 = _context405.sent;
                  _context405.t0 = _i168;

                  if (!_context405.t0) {
                    _context405.next = 29;
                    break;
                  }

                  _context405.next = 29;
                  return this._gateway.unsubscribe(_i168, e.uid);

                case 29:
                  t && "audio" !== t || (e._audio_pre_subscribed = !1);
                  t && "video" !== t || (e._video_pre_subscribed = !1);
                  e._is_pre_created && vg(this._users, e);
                  YC.info("[".concat(this._clientId, "] unsubscribe success uid: ").concat(e.uid, ", mediaType: ").concat(t));

                case 33:
                  _context405.next = 40;
                  break;

                case 35:
                  _context405.prev = 35;
                  _context405.t1 = _context405["catch"](16);

                  if (!(_context405.t1.code === xT.DISCONNECT_P2P)) {
                    _context405.next = 39;
                    break;
                  }

                  return _context405.abrupt("return", void YC.warning("disconnecting p2p, abort unsubscribe request."));

                case 39:
                  throw YC.error("[".concat(this._clientId, "] unsubscribe user ").concat(e.uid, " error"), _context405.t1.toString()), _context405.t1;

                case 40:
                  _context405.prev = 40;
                  n();
                  return _context405.finish(40);

                case 43:
                case "end":
                  return _context405.stop();
              }
            }
          }, _callee405, this, [[16, 35, 40, 43]]);
        }));

        function unsubscribe(_x644, _x645, _x646) {
          return _unsubscribe4.apply(this, arguments);
        }

        return unsubscribe;
      }()
    }, {
      key: "_unsubscribeDataChannel",
      value: function () {
        var _unsubscribeDataChannel4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee406(e, t) {
          var _t328, i, _n150, _i169, _t329;

          return _regeneratorRuntime.wrap(function _callee406$(_context406) {
            while (1) {
              switch (_context406.prev = _context406.next) {
                case 0:
                  if (!(t && jT(t, "id", 0, 65535, !0), !this._joinInfo)) {
                    _context406.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't unsubscribe datachannel, haven't joined yet!");

                case 2:
                  if (this._users.find(function (t) {
                    return t === e;
                  })) {
                    _context406.next = 5;
                    break;
                  }

                  _t328 = new VI(xT.INVALID_REMOTE_USER, "user is not in the channel");
                  throw YC.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, ", user is not in the channel")), _t328;

                case 5:
                  if ("number" == typeof t) {
                    _n150 = e._dataChannels.find(function (e) {
                      return e.id === t;
                    });
                    _n150 && (i = [_n150]);
                  } else i = e._dataChannels;

                  if (!(void 0 === i)) {
                    _context406.next = 9;
                    break;
                  }

                  _i169 = new VI(xT.REMOTE_USER_IS_NOT_PUBLISHED);
                  throw YC.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, " with channelId ").concat(t, ", remote datachannel is not published")), _i169;

                case 9:
                  YC.info("[".concat(this._clientId, "] unsubscribe uid: ").concat(e.uid, ", mediaType: datachannel, ids: ").concat(i.map(function (e) {
                    return e.id;
                  })));
                  _context406.prev = 10;
                  _context406.next = 13;
                  return this._p2pChannel.unsubscribeDataChannel(e, i);

                case 13:
                  _t329 = _context406.sent;
                  _context406.t0 = _t329;

                  if (!_context406.t0) {
                    _context406.next = 18;
                    break;
                  }

                  _context406.next = 18;
                  return this._gateway.unsubscribeDataChannel(_t329, e.uid);

                case 18:
                  YC.info("[".concat(this._clientId, "] unsubscribe datachannel success uid: ").concat(e.uid, ", mediaType: datachannel, ids: ").concat(_t329));
                  _context406.next = 26;
                  break;

                case 21:
                  _context406.prev = 21;
                  _context406.t1 = _context406["catch"](10);

                  if (!(_context406.t1.code === xT.DISCONNECT_P2P)) {
                    _context406.next = 25;
                    break;
                  }

                  return _context406.abrupt("return", void YC.warning("disconnecting p2p, abort unsubscribe request."));

                case 25:
                  throw YC.error("[".concat(this._clientId, "] unsubscribe user ").concat(e.uid, " error"), _context406.t1.toString()), _context406.t1;

                case 26:
                case "end":
                  return _context406.stop();
              }
            }
          }, _callee406, this, [[10, 21]]);
        }));

        function _unsubscribeDataChannel(_x647, _x648) {
          return _unsubscribeDataChannel4.apply(this, arguments);
        }

        return _unsubscribeDataChannel;
      }()
    }, {
      key: "massUnsubscribe",
      value: function () {
        var _massUnsubscribe4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee407(e) {
          var _this313 = this;

          var t, _loop7, _i170, _ret2, _t330;

          return _regeneratorRuntime.wrap(function _callee407$(_context407) {
            while (1) {
              switch (_context407.prev = _context407.next) {
                case 0:
                  if (!(HT(e, "unsubscribeList"), !this._joinInfo)) {
                    _context407.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't unsubscribeAll stream, haven't joined yet!");

                case 2:
                  YC.info("[".concat(this._clientId, "] start massUnsubscribe ").concat(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return "user: ".concat(null == t ? void 0 : t.uid, ", mediaType: ").concat(i, ";");
                  }).join())), e = _toConsumableArray(e);
                  t = new Map();

                  _loop7 = function _loop7(_i170) {
                    var _e$_i = e[_i170],
                        n = _e$_i.user,
                        s = _e$_i.mediaType;

                    if (!n) {
                      var _e389 = new VI(xT.INVALID_PARAMS, "user property does not exist in unsubscribeList item");

                      throw YC.error("[".concat(_this313._clientId, "] user property does not exist in unsubscribeList item")), _e389;
                    }

                    BT(s, "mediaType", ["video", "audio", void 0]);

                    if (!_this313._users.find(function (e) {
                      return e === n;
                    })) {
                      YC.warning("[".concat(_this313._clientId, "] can not unsubscribe ").concat(n.uid, ", user is not in the channel")), e.splice(_i170, 1);
                      return "continue";
                    }

                    var r = nv.Video | nv.LwoVideo;

                    if (t.has(n)) {
                      var _o54 = t.get(n);

                      var _a34;

                      switch (s) {
                        case "video":
                          _a34 = _o54 & r;
                          break;

                        case "audio":
                          _a34 = _o54 & nv.Audio;
                          break;

                        default:
                          _a34 = _o54 & (nv.Audio | r);
                      }

                      if (_a34) {
                        YC.warning("[".concat(_this313._clientId, "] repeat massUnsubscribe user:").concat(n.uid, ",mediaType:").concat(s, " twice.")), e.splice(_i170, 1);
                        return "continue";
                      }

                      s ? "audio" === s ? t.set(n, _o54 | nv.Audio) : "video" === s && t.set(n, _o54 | r) : t.set(n, _o54 | nv.Audio | r);
                    } else s ? "audio" === s ? t.set(n, nv.Audio) : "video" === s && t.set(n, r) : t.set(n, nv.Audio | r);
                  };

                  _i170 = e.length - 1;

                case 6:
                  if (!(_i170 >= 0)) {
                    _context407.next = 13;
                    break;
                  }

                  _ret2 = _loop7(_i170);

                  if (!(_ret2 === "continue")) {
                    _context407.next = 10;
                    break;
                  }

                  return _context407.abrupt("continue", 10);

                case 10:
                  _i170--;
                  _context407.next = 6;
                  break;

                case 13:
                  _context407.prev = 13;
                  _context407.next = 16;
                  return this._p2pChannel.massUnsubscribe(e);

                case 16:
                  _t330 = _context407.sent;
                  _context407.t0 = _t330;

                  if (!_context407.t0) {
                    _context407.next = 21;
                    break;
                  }

                  _context407.next = 21;
                  return this._gateway.massUnsubscribe(_t330);

                case 21:
                  YC.info("[".concat(this._clientId, "] massUnsubscribe success ").concat(e.map(function (e) {
                    var t = e.user,
                        i = e.mediaType;
                    return "user: ".concat(null == t ? void 0 : t.uid, ", mediaType: ").concat(i, ";");
                  }).join()));
                  _context407.next = 29;
                  break;

                case 24:
                  _context407.prev = 24;
                  _context407.t1 = _context407["catch"](13);

                  if (!(_context407.t1.code === xT.DISCONNECT_P2P)) {
                    _context407.next = 28;
                    break;
                  }

                  return _context407.abrupt("return", void YC.warning("[".concat(this._clientId, "] disconnecting p2p, abort unsubscribe request.")));

                case 28:
                  throw YC.error("[".concat(this._clientId, "] massUnsubscribe error"), _context407.t1.toString()), _context407.t1;

                case 29:
                case "end":
                  return _context407.stop();
              }
            }
          }, _callee407, this, [[13, 24]]);
        }));

        function massUnsubscribe(_x649) {
          return _massUnsubscribe4.apply(this, arguments);
        }

        return massUnsubscribe;
      }()
    }, {
      key: "setLowStreamParameter",
      value: function () {
        var _setLowStreamParameter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee408(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee408$(_context408) {
            while (1) {
              switch (_context408.prev = _context408.next) {
                case 0:
                  !function (e) {
                    if (!e) throw new VT(xT.INVALID_PARAMS);
                    KT(e.width) || GT(e.width, "streamParameter.width"), KT(e.height) || GT(e.height, "streamParameter.height"), KT(e.framerate) || GT(e.framerate, "streamParameter.framerate"), KT(e.bitrate) || jT(e.bitrate, "streamParameter.bitrate");
                  }(e), (!e.width && e.height || e.width && !e.height) && YC.warning("[".concat(this._clientId, "] The width and height parameters take effect only when both are set")), YC.info("[".concat(this._clientId, "] set low stream parameter to"), JSON.stringify(e));
                  t = this._configDistribute.getLowStreamConfigDistribute();

                  if (!(t && t.bitrate && e.bitrate && t.bitrate < e.bitrate && (e.bitrate = t.bitrate), this._lowStreamParameter = e, this._isDualStreamEnabled)) {
                    _context408.next = 4;
                    break;
                  }

                  return _context408.abrupt("return", this._p2pChannel.updateVideoStreamParameter(e, Ev.LocalVideoLowTrack));

                case 4:
                case "end":
                  return _context408.stop();
              }
            }
          }, _callee408, this);
        }));

        function setLowStreamParameter(_x650) {
          return _setLowStreamParameter.apply(this, arguments);
        }

        return setLowStreamParameter;
      }()
    }, {
      key: "enableDualStream",
      value: function () {
        var _enableDualStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee409() {
          return _regeneratorRuntime.wrap(function _callee409$(_context409) {
            while (1) {
              switch (_context409.prev = _context409.next) {
                case 0:
                  if (wA().supportDualStream) {
                    _context409.next = 2;
                    break;
                  }

                  throw rI.streamSwitch(this._sessionId, {
                    lts: Date.now(),
                    isdual: !0,
                    succ: !1
                  }), new VI(xT.NOT_SUPPORTED, "Your browser is not support dual stream");

                case 2:
                  if (!this._isDualStreamEnabled) {
                    _context409.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Dual stream is already enabled");

                case 4:
                  if (!this._p2pChannel.canPublishLowStream()) {
                    _context409.next = 13;
                    break;
                  }

                  _context409.prev = 5;
                  _context409.next = 8;
                  return this._publishLowStream();

                case 8:
                  _context409.next = 13;
                  break;

                case 10:
                  _context409.prev = 10;
                  _context409.t0 = _context409["catch"](5);
                  throw rI.streamSwitch(this._sessionId, {
                    lts: Date.now(),
                    isdual: !0,
                    succ: !1
                  }), _context409.t0;

                case 13:
                  this._isDualStreamEnabled = !0, rI.streamSwitch(this._sessionId, {
                    lts: Date.now(),
                    isdual: !0,
                    succ: !0
                  }), YC.info("[".concat(this._clientId, "] enable dual stream"));

                case 14:
                case "end":
                  return _context409.stop();
              }
            }
          }, _callee409, this, [[5, 10]]);
        }));

        function enableDualStream() {
          return _enableDualStream.apply(this, arguments);
        }

        return enableDualStream;
      }()
    }, {
      key: "disableDualStream",
      value: function () {
        var _disableDualStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee410() {
          var e;
          return _regeneratorRuntime.wrap(function _callee410$(_context410) {
            while (1) {
              switch (_context410.prev = _context410.next) {
                case 0:
                  if (!this._isDualStreamEnabled) {
                    _context410.next = 18;
                    break;
                  }

                  if (this._joinInfo) {
                    _context410.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");

                case 3:
                  if (!this._p2pChannel.getLocalMedia(Ev.LocalVideoLowTrack)) {
                    _context410.next = 17;
                    break;
                  }

                  _context410.prev = 4;
                  _context410.next = 7;
                  return this._p2pChannel.unpublishLowStream();

                case 7:
                  e = _context410.sent;
                  _context410.t0 = e;

                  if (!_context410.t0) {
                    _context410.next = 12;
                    break;
                  }

                  _context410.next = 12;
                  return this._gateway.unpublish(e, this._joinInfo.stringUid || this._joinInfo.uid);

                case 12:
                  _context410.next = 17;
                  break;

                case 14:
                  _context410.prev = 14;
                  _context410.t1 = _context410["catch"](4);
                  throw rI.streamSwitch(this._sessionId, {
                    lts: Date.now(),
                    isdual: !1,
                    succ: !1
                  }), _context410.t1;

                case 17:
                  this._isDualStreamEnabled = !1, rI.streamSwitch(this._sessionId, {
                    lts: Date.now(),
                    isdual: !1,
                    succ: !0
                  }), YC.info("[".concat(this._clientId, "] disable dual stream"));

                case 18:
                case "end":
                  return _context410.stop();
              }
            }
          }, _callee410, this, [[4, 14]]);
        }));

        function disableDualStream() {
          return _disableDualStream.apply(this, arguments);
        }

        return disableDualStream;
      }()
    }, {
      key: "setClientRole",
      value: function () {
        var _setClientRole2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee411(e, t) {
          return _regeneratorRuntime.wrap(function _callee411$(_context411) {
            while (1) {
              switch (_context411.prev = _context411.next) {
                case 0:
                  if (!(function (e) {
                    BT(e, "role", ["audience", "host"]);
                  }(e), t && mg(t), "rtc" === this.mode || "p2p" === this.mode)) {
                    _context411.next = 2;
                    break;
                  }

                  throw YC.warning("[".concat(this._clientId, "]").concat(this.mode, " mode can not use setClientRole")), new VI(xT.INVALID_OPERATION, "".concat(this.mode, " mode can not use setClientRole"));

                case 2:
                  if (!(t && t.level && "host" === e)) {
                    _context411.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "host mode can not set audience latency level");

                case 4:
                  if (!("audience" === e && this._p2pChannel.hasLocalMedia())) {
                    _context411.next = 6;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not set client role to audience when publishing stream");

                case 6:
                  _context411.next = 8;
                  return this._gateway.setClientRole(e, t);

                case 8:
                  this._config.role = e;
                  YC.info("[".concat(this._clientId, "] set client role to ").concat(e, ", level: ").concat(t && t.level));

                case 10:
                case "end":
                  return _context411.stop();
              }
            }
          }, _callee411, this);
        }));

        function setClientRole(_x651, _x652) {
          return _setClientRole2.apply(this, arguments);
        }

        return setClientRole;
      }()
    }, {
      key: "getRemoteInboundOffset",
      value: function getRemoteInboundOffset() {
        var e;
        var t = null === (e = this._p2pChannel.getStats()) || void 0 === e ? void 0 : e.audioSend[0];
        if (!t || !t.timestamp) return 0;
        var i = t.timestamp - Date.now();
        return Math.abs(i) > 1e3 + t.rttMs + 100 ? this.ntpAlignErrorCount += 1 : this.ntpAlignErrorCount = 0, this.ntpAlignErrorCount >= 3 ? i : 0;
      }
    }, {
      key: "getNtpWallTimeInMs",
      value: function getNtpWallTimeInMs() {
        return "visible" === document.visibilityState && (this.remoteInboundOffset = this.getRemoteInboundOffset()), this.remoteInboundOffset + Date.now() + this._gateway.ntpOffset;
      }
    }, {
      key: "setProxyServer",
      value: function setProxyServer(e, t) {
        if (WT(e, "proxyServer"), !t) {
          if ("DISCONNECTED" !== this.connectionState) throw new VI(xT.INVALID_OPERATION, "Set proxy server before join channel");
          if ("disabled" !== this._cloudProxyServerMode || this._useLocalAccessPoint) throw new VI(xT.INVALID_OPERATION, "You have already set the proxy");
        }

        this._proxyServer = e, rI.setProxyServer(this._proxyServer), YC.setProxyServer(this._proxyServer), YC.info("[".concat(this._clientId, "] Set proxy server ").concat(t ? "by initialize call" : "", " success."));
      }
    }, {
      key: "setTurnServer",
      value: function setTurnServer(e, t) {
        if (Array.isArray(e) || (e = [e]), !t) {
          if ("DISCONNECTED" !== this.connectionState) throw new VI(xT.INVALID_OPERATION, "Set turn server before join channel");
          if ("disabled" !== this._cloudProxyServerMode || this._useLocalAccessPoint) throw new VI(xT.INVALID_OPERATION, "You have already set the proxy");
        }

        if (_g(e)) return this._turnServer = {
          servers: e,
          mode: "original-manual"
        }, void YC.info("[".concat(this._clientId, "] Set original turnserver ").concat(t ? "by initialize call" : "", " success: ").concat(e.map(function (e) {
          return e.urls;
        }).join(","), "."));
        e.forEach(function (e) {
          return Eg(e);
        }), this._turnServer = {
          servers: e,
          mode: "manual"
        }, YC.info("[".concat(this._clientId, "] Set turnserver ").concat(t ? "by initialize call" : "", " success."));
      }
    }, {
      key: "setLicense",
      value: function setLicense(e) {
        if ("DISCONNECTED" !== this.connectionState) {
          throw new VI(xT.INVALID_OPERATION, "you should set license before join channel");
        }

        if (WT(e, "license", 32, 32), !/^[A-Za-z\d]+$/.test(e)) throw new VI(xT.INVALID_PARAMS, "license should only contains characters from A-Z a-z 0-9");
        this._license = e, YC.info("[".concat(this._clientId, "] set license success"), e);
      }
    }, {
      key: "startProxyServer",
      value: function startProxyServer(e) {
        if ("DISCONNECTED" !== this.connectionState) throw new VI(xT.INVALID_OPERATION, "Start proxy server before join channel");
        if (this._proxyServer || "manual" === this._turnServer.mode || this._useLocalAccessPoint) throw new VI(xT.INVALID_OPERATION, "You have already set the proxy");
        var t = [3, 4, 5];
        var i;

        switch (void 0 === e && (e = 3), e) {
          case 1:
          case 2:
            throw new VI(xT.NOT_SUPPORTED, "proxy mode 1/2 has been deprecated and not supported.");

          case 3:
            i = "proxy3";
            break;

          case 4:
            i = "proxy4";
            break;

          case 5:
            i = "proxy5";
            break;

          default:
            throw new VI(xT.INVALID_PARAMS, "proxy server mode must be ".concat(t.join("|")));
        }

        this._cloudProxyServerMode = i, this.store.cloudProxyServerMode = i, YC.info("[".concat(this._clientId, "] set cloud proxy server mode to"), this._cloudProxyServerMode);
      }
    }, {
      key: "stopProxyServer",
      value: function stopProxyServer() {
        if ("DISCONNECTED" !== this.connectionState) throw new VI(xT.INVALID_OPERATION, "Stop proxy server after leave channel");
        rI.setProxyServer(), YC.setProxyServer(), this._cloudProxyServerMode = "disabled", this.store.cloudProxyServerMode = "disabled", YC.info("[".concat(this._clientId, "] set cloud proxy server mode to"), this._cloudProxyServerMode), this._proxyServer = void 0, this._turnServer = {
          mode: "auto",
          servers: []
        };
      }
    }, {
      key: "setLocalAccessPointsV2",
      value: function setLocalAccessPointsV2(e) {
        if (!e.accessPoints) throw new VI(xT.INVALID_PARAMS, "accessPoints is required.");
        HT(e.accessPoints.serverList, "accessPoints.serverList"), WT(e.accessPoints.domain, "accessPoints.domain");

        var t = function (_t331) {
          function t(_x653, _x654) {
            return _t331.apply(this, arguments);
          }

          t.toString = function () {
            return _t331.toString();
          };

          return t;
        }(function (e, t) {
          jT(e, t, 0, 65535, !0);
        });

        var i = 443;
        if (e.accessPoints.port && (t(e.accessPoints.port, "accessPoints.port"), i = e.accessPoints.port), this._proxyServer || "disabled" !== this._cloudProxyServerMode) throw new VI(xT.INVALID_OPERATION, "set local access point failed, You have already set the cloud proxy");
        DC("CLOSE_AFB_FOR_LOCAL_AP") && (NC("JOIN_WITH_FALLBACK_SIGNAL_PROXY", !1), NC("JOIN_WITH_FALLBACK_MEDIA_PROXY", !1));
        var n = /^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
            s = e.accessPoints.domain,
            r = e.accessPoints.serverList.map(function (e) {
          return n.test(e) ? "".concat(e.replace(/\./g, "-"), ".").concat(s) : e;
        }),
            o = r.map(function (e) {
          return "".concat(e, ":").concat(i);
        });
        this._useLocalAccessPoint = !0, this._setLocalAPVersion = 2, NC("WEBCS_DOMAIN", o), NC("WEBCS_DOMAIN_BACKUP_LIST", o), NC("GATEWAY_DOMAINS", [s]), e.report && e.report.hostname && Array.isArray(e.report.hostname) && e.report.hostname.length ? (HT(e.report.hostname, "report.hostname"), NC("EVENT_REPORT_DOMAIN", e.report.hostname[0]), NC("EVENT_REPORT_BACKUP_DOMAIN", e.report.hostname[1] || e.report.hostname[0])) : (NC("EVENT_REPORT_DOMAIN", r[0]), NC("EVENT_REPORT_BACKUP_DOMAIN", r[1] || r[0]));
        var a = 6443;
        e.report && e.report.port && (t(e.report.port, "report.port"), a = e.report.port), NC("STATS_COLLECTOR_PORT", a), e.report ? NC("ENABLE_EVENT_REPORT", !0) : NC("ENABLE_EVENT_REPORT", !1);
        var c = "";
        e.log && e.log.hostname && Array.isArray(e.log.hostname) && e.log.hostname.length ? (HT(e.log.hostname, "log.hostname"), c = e.log.hostname[0]) : c = r[0];
        var d = 6444;
        e.log && e.log.port && (t(e.log.port, "log.port"), d = e.log.port), NC("LOG_UPLOAD_SERVER", "".concat(c, ":").concat(d));
        var l = [];
        e.cds && e.cds.hostname && Array.isArray(e.cds.hostname) && e.cds.hostname.length ? (HT(e.cds.hostname, "cds.hostname"), l = e.cds.hostname) : l = r;
        var u = 443;
        e.cds && e.cds.port && (t(e.cds.port, "cds.port"), u = e.cds.port), NC("CDS_AP", l.map(function (e) {
          return "".concat(e, ":").concat(u);
        })), e.cds ? NC("ENABLE_CONFIG_DISTRIBUTE", !0) : NC("ENABLE_CONFIG_DISTRIBUTE", !1), YC.info("set local access point v2 success");
      }
    }, {
      key: "setLocalAccessPoints",
      value: function setLocalAccessPoints(e, t) {
        if (HT(e, "serverList"), WT(t, "domain"), this._proxyServer || "disabled" !== this._cloudProxyServerMode) throw new VI(xT.INVALID_OPERATION, "set local access point failed, You have already set the cloud proxy");
        var i = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        e = e.map(function (e) {
          return i.test(e) ? "".concat(e.replace(/\./g, "-"), ".").concat(t) : e;
        }), this._useLocalAccessPoint = !0, this._setLocalAPVersion = 1, NC("WEBCS_DOMAIN", e), NC("WEBCS_DOMAIN_BACKUP_LIST", e), NC("GATEWAY_DOMAINS", [t]), NC("EVENT_REPORT_DOMAIN", e[0]), NC("EVENT_REPORT_BACKUP_DOMAIN", e[1] || e[0]), NC("LOG_UPLOAD_SERVER", "".concat(e[0], ":6444")), YC.info("[".concat(this._clientId, "] set local access point success"));
      }
    }, {
      key: "setRemoteDefaultVideoStreamType",
      value: function () {
        var _setRemoteDefaultVideoStreamType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee412(e) {
          return _regeneratorRuntime.wrap(function _callee412$(_context412) {
            while (1) {
              switch (_context412.prev = _context412.next) {
                case 0:
                  if (!(BT(e, "streamType", [0, 1]), this._remoteDefaultVideoStreamType = e, this._joinInfo)) {
                    _context412.next = 12;
                    break;
                  }

                  _context412.prev = 1;
                  _context412.next = 4;
                  return this._gateway.setDefaultRemoteVideoStreamType(e);

                case 4:
                  this._joinInfo.defaultVideoStream = this._remoteDefaultVideoStreamType;
                  _context412.next = 10;
                  break;

                case 7:
                  _context412.prev = 7;
                  _context412.t0 = _context412["catch"](1);
                  throw YC.error("[".concat(this._clientId, "] set default remote video stream type error"), _context412.t0.toString()), _context412.t0;

                case 10:
                  _context412.next = 13;
                  break;

                case 12:
                  YC.debug("[".concat(this._clientId, "] haven't joined yet, cache remoteDefaultVideoStreamType ").concat(e));

                case 13:
                case "end":
                  return _context412.stop();
              }
            }
          }, _callee412, this, [[1, 7]]);
        }));

        function setRemoteDefaultVideoStreamType(_x655) {
          return _setRemoteDefaultVideoStreamType.apply(this, arguments);
        }

        return setRemoteDefaultVideoStreamType;
      }()
    }, {
      key: "setRemoteVideoStreamType",
      value: function () {
        var _setRemoteVideoStreamType2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee413(e, t) {
          var _this314 = this;

          return _regeneratorRuntime.wrap(function _callee413$(_context413) {
            while (1) {
              switch (_context413.prev = _context413.next) {
                case 0:
                  BT(t, "streamType", [0, 1]);
                  _context413.prev = 1;
                  _context413.next = 4;
                  return this._gateway.setRemoteVideoStreamType(e, t);

                case 4:
                  setTimeout(function () {
                    var t = _this314._users.find(function (t) {
                      return t.uid === e;
                    });

                    t && t.videoTrack && t.videoTrack.updateMediaStreamTrackResolution();
                  }, 2e3);
                  _context413.next = 10;
                  break;

                case 7:
                  _context413.prev = 7;
                  _context413.t0 = _context413["catch"](1);
                  throw YC.error("[".concat(this._clientId, "] set remote video stream type error"), _context413.t0.toString()), _context413.t0;

                case 10:
                  YC.info("[".concat(this._clientId, "] set remote ").concat(e, " video stream type to ").concat(t)), this._remoteStreamTypeCacheMap.set(e, t);

                case 11:
                case "end":
                  return _context413.stop();
              }
            }
          }, _callee413, this, [[1, 7]]);
        }));

        function setRemoteVideoStreamType(_x656, _x657) {
          return _setRemoteVideoStreamType2.apply(this, arguments);
        }

        return setRemoteVideoStreamType;
      }()
    }, {
      key: "setStreamFallbackOption",
      value: function () {
        var _setStreamFallbackOption2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee414(e, t) {
          return _regeneratorRuntime.wrap(function _callee414$(_context414) {
            while (1) {
              switch (_context414.prev = _context414.next) {
                case 0:
                  BT(t, "fallbackType", [0, 1, 2]);
                  _context414.prev = 1;
                  _context414.next = 4;
                  return this._gateway.setStreamFallbackOption(e, t);

                case 4:
                  _context414.next = 9;
                  break;

                case 6:
                  _context414.prev = 6;
                  _context414.t0 = _context414["catch"](1);
                  throw YC.error("[".concat(this._clientId, "] set stream fallback option"), _context414.t0.toString()), _context414.t0;

                case 9:
                  YC.info("[".concat(this._clientId, "] set remote ").concat(e, " stream fallback type to ").concat(t)), this._streamFallbackTypeCacheMap.set(e, t);

                case 10:
                case "end":
                  return _context414.stop();
              }
            }
          }, _callee414, this, [[1, 6]]);
        }));

        function setStreamFallbackOption(_x658, _x659) {
          return _setStreamFallbackOption2.apply(this, arguments);
        }

        return setStreamFallbackOption;
      }()
    }, {
      key: "setEncryptionConfig",
      value: function setEncryptionConfig(e, t, i) {
        !function (e) {
          BT(e, "encryptionMode", ["aes-128-xts", "aes-256-xts", "aes-128-ecb", "sm4-128-ecb", "aes-128-gcm", "aes-256-gcm", "aes-128-gcm2", "aes-256-gcm2", "none"]);
        }(e), WT(t, "secret");
        var n = ["aes-128-gcm2", "aes-256-gcm2"];

        if (bn(n).call(n, e)) {
          if (!i || !(i instanceof Uint8Array && 32 === i.length)) throw new VI(xT.INVALID_PARAMS, "salt must be an Uint8Array and exactly equal to 32 bytes");
        } else if (i) throw new VI(xT.INVALID_PARAMS, "current encrypt mode does not need salt");

        new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.<>?/:;'\"|{}\\[\\]])(?=.{8,})").test(t) || YC.warning("The secret is not strong:\n      The secret must contain at least 1 lowercase alphabetical character,\n      The secret must contain at least 1 uppercase alphabetical character,\n      The secret must contain at least 1 numeric character,\n      The secret must contain at least one special character,\n      The secret must be eight characters or longer.\n      "), this._encryptionMode = e, this._encryptionSecret = t, i && (this._encryptionSalt = Pg(i));
      }
    }, {
      key: "renewToken",
      value: function () {
        var _renewToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee415(e) {
          var t, i, _t332;

          return _regeneratorRuntime.wrap(function _callee415$(_context415) {
            while (1) {
              switch (_context415.prev = _context415.next) {
                case 0:
                  if (!(WT(e, "token", 1, 2047), !this._key || !this._joinInfo)) {
                    _context415.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "renewToken should not be called before user join");

                case 2:
                  t = this._key;
                  this._key = e, this._joinInfo && (this._joinInfo.token = e);
                  _context415.next = 6;
                  return this._renewTokenMutex.lock();

                case 6:
                  i = _context415.sent;
                  _context415.prev = 7;

                  if (!DC("USE_NEW_TOKEN")) {
                    _context415.next = 18;
                    break;
                  }

                  YC.debug("[".concat(this._clientId, "] start renew token with ticket from unilbs"));
                  _context415.next = 12;
                  return IA(this._joinInfo, this._axiosCancelSource.token, this._config.httpRetryConfig || Jg);

                case 12:
                  _t332 = _context415.sent;
                  YC.debug("[".concat(this._clientId, "] get ticket from unilbs success"));
                  _context415.next = 16;
                  return this._gateway.renewToken({
                    token: e,
                    ticket: _t332
                  });

                case 16:
                  _context415.next = 21;
                  break;

                case 18:
                  YC.debug("[".concat(this._clientId, "] start renew token without ticket"));
                  _context415.next = 21;
                  return this._gateway.renewToken({
                    token: e
                  });

                case 21:
                  YC.debug("[".concat(this._clientId, "] renewToken success"));
                  _context415.next = 27;
                  break;

                case 24:
                  _context415.prev = 24;
                  _context415.t0 = _context415["catch"](7);
                  throw this._key = t, this._joinInfo.token = t, YC.error("[".concat(this._clientId, "] renewToken failed"), _context415.t0.toString()), _context415.t0;

                case 27:
                  _context415.prev = 27;
                  i();
                  return _context415.finish(27);

                case 30:
                case "end":
                  return _context415.stop();
              }
            }
          }, _callee415, this, [[7, 24, 27, 30]]);
        }));

        function renewToken(_x660) {
          return _renewToken2.apply(this, arguments);
        }

        return renewToken;
      }()
    }, {
      key: "enableAudioVolumeIndicator",
      value: function enableAudioVolumeIndicator() {
        var _this315 = this;

        this._audioVolumeIndicationInterval ? YC.warning("you have already enabled audio volume indicator!") : this._audioVolumeIndicationInterval = window.setInterval(function () {
          var e = _this315._p2pChannel.getAudioLevels();

          _this315.safeEmit(dg.VOLUME_INDICATOR, e);
        }, DC("AUDIO_VOLUME_INDICATION_INTERVAL") || 2e3);
      }
    }, {
      key: "getRTCStats",
      value: function getRTCStats() {
        var e = this._statsCollector.getRTCStats(),
            t = this._gateway.getInChannelInfo();

        return e.Duration = Math.round(t.duration / 1e3), e;
      }
    }, {
      key: "startLiveStreaming",
      value: function () {
        var _startLiveStreaming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee416(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee416$(_context416) {
            while (1) {
              switch (_context416.prev = _context416.next) {
                case 0:
                  if (t) {
                    _context416.next = 5;
                    break;
                  }

                  if (!("h264" !== this.codec)) {
                    _context416.next = 3;
                    break;
                  }

                  throw new VI(xT.LIVE_STREAMING_INVALID_RAW_STREAM, "raw streaming is only support h264");

                case 3:
                  if (this._p2pChannel.hasLocalMedia()) {
                    _context416.next = 5;
                    break;
                  }

                  throw new VI(xT.LIVE_STREAMING_INVALID_RAW_STREAM, "can not find stream to raw streaming");

                case 5:
                  if (!(this._liveRawStreamingClient && this._liveRawStreamingClient.hasUrl(e) || this._liveTranscodeStreamingClient && this._liveTranscodeStreamingClient.hasUrl(e))) {
                    _context416.next = 7;
                    break;
                  }

                  throw new VI(xT.LIVE_STREAMING_TASK_CONFLICT);

                case 7:
                  i = t ? AI.TRANSCODE : AI.RAW;
                  return _context416.abrupt("return", this._createLiveStreamingClient(i).startLiveStreamingTask(e, i));

                case 9:
                case "end":
                  return _context416.stop();
              }
            }
          }, _callee416, this);
        }));

        function startLiveStreaming(_x661, _x662) {
          return _startLiveStreaming.apply(this, arguments);
        }

        return startLiveStreaming;
      }()
    }, {
      key: "setLiveTranscoding",
      value: function setLiveTranscoding(e) {
        return this._createLiveStreamingClient(AI.TRANSCODE).setTranscodingConfig(e);
      }
    }, {
      key: "stopLiveStreaming",
      value: function () {
        var _stopLiveStreaming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee417(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee417$(_context417) {
            while (1) {
              switch (_context417.prev = _context417.next) {
                case 0:
                  t = [this._liveRawStreamingClient, this._liveTranscodeStreamingClient].filter(function (t) {
                    return t && t.hasUrl(e);
                  });

                  if (t.length) {
                    _context417.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "can not find live streaming url to stop");

                case 3:
                  _context417.next = 5;
                  return tT.all(t.map(function (t) {
                    return t && t.stopLiveStreamingTask(e);
                  }));

                case 5:
                case "end":
                  return _context417.stop();
              }
            }
          }, _callee417, this);
        }));

        function stopLiveStreaming(_x663) {
          return _stopLiveStreaming.apply(this, arguments);
        }

        return stopLiveStreaming;
      }()
    }, {
      key: "addInjectStreamUrl",
      value: function () {
        var _addInjectStreamUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee418(e, t) {
          var i;
          return _regeneratorRuntime.wrap(function _callee418$(_context418) {
            while (1) {
              switch (_context418.prev = _context418.next) {
                case 0:
                  if (this._joinInfo) {
                    _context418.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not addInjectStreamUrl, no joininfo");

                case 2:
                  i = this._createLiveStreamingClient(AI.INJECT);
                  i.setInjectStreamConfig(t, 0);
                  _context418.next = 6;
                  return i.startLiveStreamingTask(e, AI.INJECT);

                case 6:
                case "end":
                  return _context418.stop();
              }
            }
          }, _callee418, this);
        }));

        function addInjectStreamUrl(_x664, _x665) {
          return _addInjectStreamUrl.apply(this, arguments);
        }

        return addInjectStreamUrl;
      }()
    }, {
      key: "removeInjectStreamUrl",
      value: function () {
        var _removeInjectStreamUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee419() {
          var e, t, i;
          return _regeneratorRuntime.wrap(function _callee419$(_context419) {
            while (1) {
              switch (_context419.prev = _context419.next) {
                case 0:
                  t = this._createLiveStreamingClient(AI.INJECT), i = Array.from(MI(e = t.streamingTasks).call(e)).find(function (e) {
                    return e.mode === AI.INJECT;
                  });

                  if (!(!this._joinInfo || !i)) {
                    _context419.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can remove addInjectStreamUrl, no joininfo or inject task");

                case 3:
                  _context419.next = 5;
                  return t.stopLiveStreamingTask(i.url);

                case 5:
                case "end":
                  return _context419.stop();
              }
            }
          }, _callee419, this);
        }));

        function removeInjectStreamUrl() {
          return _removeInjectStreamUrl.apply(this, arguments);
        }

        return removeInjectStreamUrl;
      }()
    }, {
      key: "startChannelMediaRelay",
      value: function () {
        var _startChannelMediaRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee420(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee420$(_context420) {
            while (1) {
              switch (_context420.prev = _context420.next) {
                case 0:
                  gk(e);
                  t = this._createChannelMediaRelayClient();
                  _context420.next = 4;
                  return t.startChannelMediaRelay(e);

                case 4:
                case "end":
                  return _context420.stop();
              }
            }
          }, _callee420, this);
        }));

        function startChannelMediaRelay(_x666) {
          return _startChannelMediaRelay2.apply(this, arguments);
        }

        return startChannelMediaRelay;
      }()
    }, {
      key: "updateChannelMediaRelay",
      value: function () {
        var _updateChannelMediaRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee421(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee421$(_context421) {
            while (1) {
              switch (_context421.prev = _context421.next) {
                case 0:
                  gk(e);
                  t = this._createChannelMediaRelayClient();
                  _context421.next = 4;
                  return t.updateChannelMediaRelay(e);

                case 4:
                case "end":
                  return _context421.stop();
              }
            }
          }, _callee421, this);
        }));

        function updateChannelMediaRelay(_x667) {
          return _updateChannelMediaRelay2.apply(this, arguments);
        }

        return updateChannelMediaRelay;
      }()
    }, {
      key: "stopChannelMediaRelay",
      value: function () {
        var _stopChannelMediaRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee422() {
          var e;
          return _regeneratorRuntime.wrap(function _callee422$(_context422) {
            while (1) {
              switch (_context422.prev = _context422.next) {
                case 0:
                  e = this._createChannelMediaRelayClient();
                  _context422.next = 3;
                  return e.stopChannelMediaRelay();

                case 3:
                  this._statsCollector.onStatsChanged && (this._statsCollector.onStatsChanged = void 0);

                case 4:
                case "end":
                  return _context422.stop();
              }
            }
          }, _callee422, this);
        }));

        function stopChannelMediaRelay() {
          return _stopChannelMediaRelay2.apply(this, arguments);
        }

        return stopChannelMediaRelay;
      }()
    }, {
      key: "sendStreamMessage",
      value: function sendStreamMessage(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        if (!this._joinInfo) throw new VI(xT.INVALID_OPERATION, "can not send data stream, not joined");

        if (("string" == typeof e || e instanceof Uint8Array) && (e = {
          payload: e
        }), "string" == typeof e.payload) {
          var _t333 = new TextEncoder();

          e.payload = _t333.encode(e.payload);
        }

        if (new Blob([e.payload]).size > 1024) throw new VI(xT.INVALID_PARAMS, "stream message out of range.");
        return this._gateway.signal.request(SI.DATA_STREAM, {
          payload: Pg(e.payload),
          syncWithAudio: e.syncWithAudio,
          sendTs: Date.now() - mU
        }, !t);
      }
    }, {
      key: "sendMetadata",
      value: function sendMetadata(e) {
        if (!this._joinInfo) throw new VI(xT.INVALID_OPERATION, "can not send metadata, not joined");
        if (new Blob([e]).size > 1024) throw new VI(xT.METADATA_OUT_OF_RANGE);
        return this._gateway.signal.request(SI.SEND_METADATA, {
          session_id: this._joinInfo.sid,
          metadata: Pg(e)
        });
      }
    }, {
      key: "sendCustomReportMessage",
      value: function () {
        var _sendCustomReportMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee423(e) {
          return _regeneratorRuntime.wrap(function _callee423$(_context423) {
            while (1) {
              switch (_context423.prev = _context423.next) {
                case 0:
                  if (!(Array.isArray(e) || (e = [e]), e.forEach(zC), !this._joinInfo)) {
                    _context423.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not send custom report, not joined");

                case 2:
                  _context423.next = 4;
                  return rI.sendCustomReportMessage(this._joinInfo.sid, e);

                case 4:
                case "end":
                  return _context423.stop();
              }
            }
          }, _callee423, this);
        }));

        function sendCustomReportMessage(_x668) {
          return _sendCustomReportMessage2.apply(this, arguments);
        }

        return sendCustomReportMessage;
      }()
    }, {
      key: "getLocalAudioStats",
      value: function getLocalAudioStats() {
        return this._statsCollector.getLocalAudioTrackStats();
      }
    }, {
      key: "getRemoteAudioStats",
      value: function getRemoteAudioStats() {
        return this._statsCollector.getRemoteAudioTrackStats();
      }
    }, {
      key: "getLocalVideoStats",
      value: function getLocalVideoStats() {
        return this._statsCollector.getLocalVideoTrackStats();
      }
    }, {
      key: "getRemoteVideoStats",
      value: function getRemoteVideoStats() {
        return this._statsCollector.getRemoteVideoTrackStats();
      }
    }, {
      key: "getRemoteNetworkQuality",
      value: function getRemoteNetworkQuality() {
        return this._statsCollector.getRemoteNetworkQualityStats();
      }
    }, {
      key: "pickSVCLayer",
      value: function () {
        var _pickSVCLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee424(e, t) {
          return _regeneratorRuntime.wrap(function _callee424$(_context424) {
            while (1) {
              switch (_context424.prev = _context424.next) {
                case 0:
                  BT(t.spatialLayer, "spatialLayer", [0, 1, 2, 3]), BT(t.temporalLayer, "temporalLayer", [0, 1, 2, 3]);
                  _context424.prev = 1;
                  _context424.next = 4;
                  return this._gateway.pickSVCLayer(e, t);

                case 4:
                  _context424.next = 9;
                  break;

                case 6:
                  _context424.prev = 6;
                  _context424.t0 = _context424["catch"](1);
                  throw YC.error("[".concat(this._clientId, "] pick SVC layer failed"), _context424.t0.toString()), _context424.t0;

                case 9:
                case "end":
                  return _context424.stop();
              }
            }
          }, _callee424, this, [[1, 6]]);
        }));

        function pickSVCLayer(_x669, _x670) {
          return _pickSVCLayer2.apply(this, arguments);
        }

        return pickSVCLayer;
      }()
    }, {
      key: "setRTMConfig",
      value: function () {
        var _setRTMConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee425(e) {
          var _e$apRTM, t, i;

          return _regeneratorRuntime.wrap(function _callee425$(_context425) {
            while (1) {
              switch (_context425.prev = _context425.next) {
                case 0:
                  _e$apRTM = e.apRTM, t = _e$apRTM === void 0 ? !1 : _e$apRTM, i = e.rtmFlag;

                  if (!(FT(t, "apRTM"), jT(i, "rtmFlag", 0), this._rtmConfig.apRTM = t, this._rtmConfig.rtmFlag = i, YC.debug("[".concat(this._clientId, "] setRTMconfig ").concat(JSON.stringify(e), " in ").concat(this.connectionState, " state")), ("CONNECTED" === this.connectionState || "RECONNECTING" === this.connectionState) && this._joinInfo)) {
                    _context425.next = 3;
                    break;
                  }

                  return _context425.abrupt("return", (this._joinInfo.apRTM = t, this._joinInfo.rtmFlag = i, this._gateway.setRTM2Flag(i)));

                case 3:
                case "end":
                  return _context425.stop();
              }
            }
          }, _callee425, this);
        }));

        function setRTMConfig(_x671) {
          return _setRTMConfig.apply(this, arguments);
        }

        return setRTMConfig;
      }()
    }, {
      key: "_reset",
      value: function _reset() {
        if (YC.debug("[".concat(this._clientId, "] reset client")), this._axiosCancelSource.cancel(), this._axiosCancelSource = EC.CancelToken.source(), this._streamFallbackTypeCacheMap = new Map(), this._remoteStreamTypeCacheMap = new Map(), this._configDistribute.stopGetConfigDistribute(), this._joinInfo = void 0, this._proxyServer = void 0, this._defaultStreamFallbackType = void 0, this._sessionId = null, this.store.sessionId = null, this._statsCollector.reset(), this._key = void 0, this._appId = void 0, this._uid = void 0, this.store.uid = void 0, this._channelName = void 0, this._encryptionMode = "none", this._encryptionSecret = null, this._encryptionSalt = null, this._pendingPublishedUsers = [], this._users.forEach(function (e) {
          e._audioTrack && e._audioTrack._destroy(), e._videoTrack && e._videoTrack._destroy(), e._dataChannels && (e._dataChannels.forEach(function (e) {
            return e._close();
          }), e._dataChannels.length = 0);
        }), this._users = [], this._audioVolumeIndicationInterval && (window.clearInterval(this._audioVolumeIndicationInterval), this._audioVolumeIndicationInterval = void 0), "fallback" === this._cloudProxyServerMode && (this._cloudProxyServerMode = "disabled", this.store.cloudProxyServerMode = "disabled"), this._p2pChannel.reset(), this._publishMutex = new Yg("client-publish"), this._subscribeMutex = new Yg("client-subscribe"), this._networkQualityInterval && (window.clearInterval(this._networkQualityInterval), this._networkQualityInterval = void 0), this._injectStreamingClient && (this._injectStreamingClient.terminate(), this._injectStreamingClient.removeAllListeners(), this._injectStreamingClient = void 0), this._liveRawStreamingClient && (this._liveRawStreamingClient.terminate(), this._liveRawStreamingClient.removeAllListeners(), this._liveRawStreamingClient = void 0), this._liveTranscodeStreamingClient && (this._liveTranscodeStreamingClient.terminate(), this._liveTranscodeStreamingClient.removeAllListeners(), this._liveTranscodeStreamingClient = void 0), this._channelMediaRelayClient && (this._channelMediaRelayClient.dispose(), this._channelMediaRelayClient = void 0), this._inspect) try {
          this._inspect.close(), this._inspect = void 0;
        } catch (e) {}
        if (this._moderation) try {
          this.setImageModeration(!1);
        } catch (e) {}
      }
    }, {
      key: "_startSession",
      value: function _startSession(e, t) {
        var i;
        var n = e || Vg();
        e ? YC.debug("[".concat(this._clientId, "] new Session ").concat(n)) : YC.debug("[".concat(this._clientId, "] renewSession ").concat(this._sessionId, " => ").concat(n));
        var s = e ? "" : this._sessionId || "";
        this._sessionId = n, this.store.sessionId = n;
        var r = {
          lts: new Date().getTime(),
          mode: this.mode,
          stringUid: (null == t ? void 0 : t.stringUid) || (null === (i = this._joinInfo) || void 0 === i ? void 0 : i.stringUid),
          channelProfile: "live" === this.mode ? 1 : 0,
          channelMode: 0,
          isABTestSuccess: Number(this._configDistribute.isSuccess),
          lsid: s,
          clientRole: "audience" === this.role ? 2 : 1
        };
        t ? rI.sessionInit(this._sessionId, AU({
          cname: t.channel,
          appid: t.appId
        }, r)) : this._joinInfo ? rI.sessionInit(this._sessionId, AU({
          cname: this._joinInfo.cname,
          appid: this._joinInfo.appId
        }, r)) : this._gateway.joinInfo && rI.sessionInit(this._sessionId, AU({
          cname: this._gateway.joinInfo.cname,
          appid: this._gateway.joinInfo.appId
        }, r)), this._joinInfo && (this._joinInfo.sid = n), this._gateway.joinInfo && (this._gateway.joinInfo.sid = n);
      }
    }, {
      key: "_publishHighStream",
      value: function () {
        var _publishHighStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee426(e) {
          var _i171, _e390, _n151, t, _e391, _iterator47, _step47, _t334;

          return _regeneratorRuntime.wrap(function _callee426$(_context426) {
            while (1) {
              switch (_context426.prev = _context426.next) {
                case 0:
                  if (!(!this._joinInfo || void 0 === this._uid)) {
                    _context426.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");

                case 2:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context426.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish stream in ".concat(this.connectionState, " state"));

                case 4:
                  if (!("auto" === this._turnServer.mode && DC("FORCE_TURN") && !DC("TURN_ENABLE_TCP") && !DC("TURN_ENABLE_UDP"))) {
                    _context426.next = 6;
                    break;
                  }

                  throw new VI(xT.UNEXPECTED_ERROR, "force TURN With No TURN Configuration");

                case 6:
                  YC.debug("[".concat(this._clientId, "] publish high stream"));
                  _context426.prev = 7;
                  _context426.next = 10;
                  return this._p2pChannel.publish(e, this._isDualStreamEnabled, this._lowStreamParameter);

                case 10:
                  _i171 = _context426.sent;

                  if (!(this._p2pChannel instanceof ak)) {
                    _context426.next = 29;
                    break;
                  }

                  _context426.next = 14;
                  return _i171.next();

                case 14:
                  _e390 = _context426.sent.value;

                  if (!_e390) {
                    _context426.next = 26;
                    break;
                  }

                  _context426.prev = 16;
                  _context426.next = 19;
                  return this._gateway.sendExtensionMessage(Ov.PUBLISH, _e390, !0);

                case 19:
                  _context426.next = 24;
                  break;

                case 21:
                  _context426.prev = 21;
                  _context426.t0 = _context426["catch"](16);
                  throw _i171.throw(_context426.t0), _context426.t0;

                case 24:
                  _context426.next = 26;
                  return _i171.next();

                case 26:
                  this._p2pChannel.reportPublishEvent(!0, null);

                  _context426.next = 66;
                  break;

                case 29:
                  _context426.next = 31;
                  return _i171.next();

                case 31:
                  _n151 = _context426.sent.value;

                  if (!_n151) {
                    _context426.next = 45;
                    break;
                  }

                  _context426.prev = 33;
                  _context426.next = 36;
                  return this._gateway.publish(this._uid, _n151, !0);

                case 36:
                  _e391 = _context426.sent;
                  _context426.next = 43;
                  break;

                case 39:
                  _context426.prev = 39;
                  _context426.t1 = _context426["catch"](33);

                  if (!(_context426.t1.code !== xT.DISCONNECT_P2P)) {
                    _context426.next = 43;
                    break;
                  }

                  throw _i171.throw(_context426.t1), _context426.t1;

                case 43:
                  _context426.next = 45;
                  return _i171.next((null === (t = _e391) || void 0 === t ? void 0 : t.ortc) || []);

                case 45:
                  this._p2pChannel.reportPublishEvent(!0, null);

                  _iterator47 = _createForOfIteratorHelper(e);
                  _context426.prev = 47;

                  _iterator47.s();

                case 49:
                  if ((_step47 = _iterator47.n()).done) {
                    _context426.next = 58;
                    break;
                  }

                  _t334 = _step47.value;
                  _t334 instanceof Nw && _t334._encoderConfig && this._gateway.setVideoProfile(_t334._encoderConfig);
                  _context426.t2 = !_t334.muted && _t334.enabled;

                  if (_context426.t2) {
                    _context426.next = 56;
                    break;
                  }

                  _context426.next = 56;
                  return this._p2pChannel.muteLocalTrack(_t334);

                case 56:
                  _context426.next = 49;
                  break;

                case 58:
                  _context426.next = 63;
                  break;

                case 60:
                  _context426.prev = 60;
                  _context426.t3 = _context426["catch"](47);

                  _iterator47.e(_context426.t3);

                case 63:
                  _context426.prev = 63;

                  _iterator47.f();

                  return _context426.finish(63);

                case 66:
                  _context426.next = 73;
                  break;

                case 68:
                  _context426.prev = 68;
                  _context426.t4 = _context426["catch"](7);

                  if (!(this._p2pChannel.reportPublishEvent(!1, null == _context426.t4 ? void 0 : _context426.t4.code, e), (null == _context426.t4 ? void 0 : _context426.t4.code) === xT.WS_ABORT)) {
                    _context426.next = 72;
                    break;
                  }

                  return _context426.abrupt("return");

                case 72:
                  throw _context426.t4;

                case 73:
                case "end":
                  return _context426.stop();
              }
            }
          }, _callee426, this, [[7, 68], [16, 21], [33, 39], [47, 60, 63, 66]]);
        }));

        function _publishHighStream(_x672) {
          return _publishHighStream2.apply(this, arguments);
        }

        return _publishHighStream;
      }()
    }, {
      key: "_publishLowStream",
      value: function () {
        var _publishLowStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee427() {
          var e, _e392, _i172, t, _n152;

          return _regeneratorRuntime.wrap(function _callee427$(_context427) {
            while (1) {
              switch (_context427.prev = _context427.next) {
                case 0:
                  if (!(!this._joinInfo || void 0 === this._uid)) {
                    _context427.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");

                case 2:
                  if (!("CONNECTED" !== this.connectionState && "RECONNECTING" !== this.connectionState)) {
                    _context427.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "can not publish stream in ".concat(this.connectionState, " state"));

                case 4:
                  YC.debug("[".concat(this._clientId, "] publish low stream"));
                  e = this._configDistribute.getLowStreamConfigDistribute();
                  e && e.bitrate && (this._lowStreamParameter || (this._lowStreamParameter = {
                    width: 160,
                    height: 120,
                    framerate: 15,
                    bitrate: 50
                  }), this._lowStreamParameter && this._lowStreamParameter.bitrate && e.bitrate < this._lowStreamParameter.bitrate && (this._lowStreamParameter.bitrate = e.bitrate));
                  _context427.prev = 7;
                  _context427.next = 10;
                  return this._p2pChannel.publishLowStream(this._lowStreamParameter);

                case 10:
                  _e392 = _context427.sent;
                  _context427.next = 13;
                  return _e392.next();

                case 13:
                  _i172 = _context427.sent.value;

                  if (!_i172) {
                    _context427.next = 26;
                    break;
                  }

                  _context427.prev = 15;
                  _context427.next = 18;
                  return this._gateway.publish(this._uid, _i172, !0);

                case 18:
                  _n152 = _context427.sent;
                  _context427.next = 25;
                  break;

                case 21:
                  _context427.prev = 21;
                  _context427.t0 = _context427["catch"](15);

                  if (!(_context427.t0.code !== xT.DISCONNECT_P2P)) {
                    _context427.next = 25;
                    break;
                  }

                  throw _e392.throw(_context427.t0), _context427.t0;

                case 25:
                  _e392.next((null === (t = _n152) || void 0 === t ? void 0 : t.ortc) || []), this._p2pChannel.reportPublishEvent(!0, null, void 0, !0);

                case 26:
                  _context427.next = 33;
                  break;

                case 28:
                  _context427.prev = 28;
                  _context427.t1 = _context427["catch"](7);

                  if (!(this._p2pChannel.reportPublishEvent(!1, null == _context427.t1 ? void 0 : _context427.t1.code, void 0, !0), (null == _context427.t1 ? void 0 : _context427.t1.code) === xT.WS_ABORT)) {
                    _context427.next = 32;
                    break;
                  }

                  return _context427.abrupt("return");

                case 32:
                  throw _context427.t1;

                case 33:
                case "end":
                  return _context427.stop();
              }
            }
          }, _callee427, this, [[7, 28], [15, 21]]);
        }));

        function _publishLowStream() {
          return _publishLowStream2.apply(this, arguments);
        }

        return _publishLowStream;
      }()
    }, {
      key: "_createLiveStreamingClient",
      value: function _createLiveStreamingClient(e) {
        var _this316 = this;

        if (!this._joinInfo || !this._appId) {
          return new VI(xT.INVALID_OPERATION, "can not create live streaming client, please join channel first").throw();
        }

        var t = function t() {
          return new fk(_this316._joinInfo, _this316._config.websocketRetryConfig || Jg, _this316._config.httpRetryConfig || Jg);
        },
            i = function i(e) {
          e.onLiveStreamError = function (e, t) {
            rI.reportApiInvoke(_this316._sessionId, {
              name: rg.ON_LIVE_STREAM_ERROR,
              options: [e, t],
              tag: og.TRACER
            }).onSuccess(), _this316.safeEmit(dg.LIVE_STREAMING_ERROR, e, t);
          }, e.onLiveStreamWarning = function (e, t) {
            rI.reportApiInvoke(_this316._sessionId, {
              name: rg.ON_LIVE_STREAM_WARNING,
              options: [e, t],
              tag: og.TRACER
            }).onSuccess(), _this316.safeEmit(dg.LIVE_STREAMING_WARNING, e, t);
          }, e.on(qI.REQUEST_WORKER_MANAGER_LIST, function (e, t, i) {
            if (!_this316._joinInfo) return i(new VI(xT.INVALID_OPERATION, "can not find join info to get worker manager"));
            RA(e, _this316._joinInfo, _this316._axiosCancelSource.token, Jg).then(t).catch(i);
          });
        };

        switch (e) {
          case AI.RAW:
            return this._liveRawStreamingClient || (this._liveRawStreamingClient = t(), i(this._liveRawStreamingClient)), this._liveRawStreamingClient;

          case AI.TRANSCODE:
            return this._liveTranscodeStreamingClient || (this._liveTranscodeStreamingClient = t(), i(this._liveTranscodeStreamingClient)), this._liveTranscodeStreamingClient;

          case AI.INJECT:
            return this._injectStreamingClient || (this._injectStreamingClient = t(), this._injectStreamingClient.on(qI.REQUEST_WORKER_MANAGER_LIST, function (e, t, i) {
              if (!_this316._joinInfo) return i(new VI(xT.INVALID_OPERATION, "can not find join info to get worker manager"));
              RA(e, _this316._joinInfo, _this316._axiosCancelSource.token, Jg).then(t).catch(i);
            }), this._injectStreamingClient.onInjectStatusChange = function (e, t, i) {
              _this316.safeEmit(dg.INJECT_STREAM_STATUS, e, t, i);
            }), this._injectStreamingClient;
        }
      }
    }, {
      key: "_createChannelMediaRelayClient",
      value: function _createChannelMediaRelayClient() {
        var _this317 = this;

        if (!this._joinInfo) {
          return new VI(xT.INVALID_OPERATION, "can not create channel media relay client, please join channel first").throw();
        }

        if (!this._channelMediaRelayClient) {
          var _this$getLocalVideoSt = this.getLocalVideoStats(),
              e = _this$getLocalVideoSt.sendResolutionWidth,
              _t335 = _this$getLocalVideoSt.sendResolutionHeight,
              _i173 = {
            width: e,
            height: _t335
          };

          this._channelMediaRelayClient = new Rk(this._joinInfo, this._clientId, this._config.websocketRetryConfig || Jg, this._config.httpRetryConfig || Jg, _i173), this._channelMediaRelayClient.on("state", function (e) {
            e === ZI.RELAY_STATE_FAILURE && _this317._channelMediaRelayClient && _this317._channelMediaRelayClient.dispose(), _this317.safeEmit(dg.CHANNEL_MEDIA_RELAY_STATE, e);
          }), this._channelMediaRelayClient.on("event", function (e) {
            _this317.safeEmit(dg.CHANNEL_MEDIA_RELAY_EVENT, e);
          }), this._statsCollector.onStatsChanged = function (e, t) {
            var i;
            "resolution" === e && (null === (i = _this317._channelMediaRelayClient) || void 0 === i || i.setVideoProfile(t));
          };
        }

        return this._channelMediaRelayClient;
      }
    }, {
      key: "_handleUpdateDataChannel",
      value: function _handleUpdateDataChannel(e, t) {
        var _this318 = this;

        var i = e.added,
            n = e.deleted,
            s = [];
        Array.isArray(i) && i.length > 0 && i.forEach(function (e) {
          var i = e.uid,
              n = e.stream_id,
              r = e.ordered,
              o = e.max_retrans_times,
              a = e.metadata,
              c = _this318._users.find(function (e) {
            return e._uintid === i;
          });

          if (!c) return void YC.error("[".concat(_this318._clientId, "] can not find target user!(on_add_data_channel)"));
          YC.debug("[".concat(_this318._clientId, "] data_channel added with uid ").concat(i)), bn(s).call(s, c) || s.push(c), c._uintid || (c._uintid = i);

          if (!(-1 !== c._dataChannels.findIndex(function (t) {
            return t.id === e.stream_id;
          }))) {
            var _e393 = {
              id: n,
              ordered: !!r,
              maxRetransmits: o,
              metadata: a
            },
                _i174 = new _P(_e393);

            c._dataChannels.push(_i174), YC.info("[".concat(_this318._clientId, "] remote user ").concat(c.uid, " published datachannel")), t || _this318.safeEmit(dg.USER_PUBLISHED, c, "datachannel", _e393);
          }

          _this318._p2pChannel.hasPendingRemoteDataChannel(c, e.stream_id) && (YC.debug("[".concat(_this318._clientId, "] resubscribe datachannel for user ").concat(c.uid, " after reconnect.")), _this318._subscribeDataChannel(c, e.stream_id).catch(function (e) {
            YC.error("[".concat(_this318._clientId, "] resubscribe datachannel error"), e.toString());
          }));
        }), t && (this.safeEmit(dg.PUBLISHED_USER_LIST, this._pendingPublishedUsers), this._pendingPublishedUsers = []), Array.isArray(n) && n.length > 0 && n.forEach(function (e) {
          var t = e.uid,
              i = e.stream_id,
              n = _this318._users.find(function (e) {
            return e._uintid === t;
          });

          if (!n) return void YC.error("[".concat(_this318._clientId, "] can not find target user!(on_delete_data_channel)"));

          var s = n._dataChannels.find(function (t) {
            return t.id === e.stream_id;
          });

          s && (YC.debug("[".concat(_this318._clientId, "] data_stream delete with uid ").concat(t)), _this318._p2pChannel.unsubscribeDataChannel(n, [s]).then(function (e) {
            if (n._dataChannels = n._dataChannels.filter(function (e) {
              return e !== s;
            }), e) return _this318._gateway.unsubscribeDataChannel(e, n.uid);
          }), YC.info("[".concat(_this318._clientId, "] remote user ").concat(t, " unpublished datachannel ,id:").concat(s.id)), _this318.safeEmit(dg.USER_UNPUBLISHED, n, "datachannel", s._config));
        });
      }
    }, {
      key: "_handleRemoveDataChannels",
      value: function _handleRemoveDataChannels(e) {
        var _this319 = this;

        var t = this._users.find(function (t) {
          return t.uid === e.uid;
        });

        if (t) {
          if (void 0 !== t._dataChannels && t._dataChannels.length > 0) {
            YC.debug("[".concat(this._clientId, "] datachannel removed with uid ").concat(e.uid));

            var _i175 = function _i175() {
              YC.info("[".concat(_this319._clientId, "] remote user ").concat(t.uid, " unpublished datachannel")), t._dataChannels.forEach(function (e) {
                _this319.safeEmit(dg.USER_UNPUBLISHED, t, "datachannel", e._config);
              });
            };

            this._p2pChannel.unsubscribeDataChannel(t, t._dataChannels).then(function (e) {
              if (e) return _this319._gateway.unsubscribeDataChannel(e, t.uid);
            }), _i175();
          }
        } else YC.warning("[".concat(this._clientId, "] can not find target user!(on_remove_datachannel)"));
      }
    }, {
      key: "_handleGatewayEvents",
      value: function _handleGatewayEvents() {
        var _this320 = this;

        this._gateway.on(tv.DISCONNECT_P2P, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee428() {
          return _regeneratorRuntime.wrap(function _callee428$(_context428) {
            while (1) {
              switch (_context428.prev = _context428.next) {
                case 0:
                  _context428.next = 2;
                  return _this320._p2pChannel.disconnectForReconnect();

                case 2:
                case "end":
                  return _context428.stop();
              }
            }
          }, _callee428);
        }))), this._gateway.on(tv.CONNECTION_STATE_CHANGE, function (e, t, i) {
          var n;
          if (i === cg.FALLBACK) return;

          var s = function s() {
            _this320.safeEmit(dg.CONNECTION_STATE_CHANGE, e, t, i);
          };

          if (rI.reportApiInvoke(_this320._sessionId || (null === (n = _this320._gateway.joinInfo) || void 0 === n ? void 0 : n.sid) || null, {
            name: rg.CONNECTION_STATE_CHANGE,
            options: [e, t, i],
            tag: og.TRACER
          }).onSuccess(JSON.stringify({
            cur: e,
            prev: t,
            reason: i
          })), YC.info("[".concat(_this320._clientId, "] connection state change: ").concat(t, " -> ").concat(e)), "DISCONNECTED" === e) return _this320._reset(), void s();
          if ("RECONNECTING" === e) _this320._users.forEach(function (e) {
            e._trust_in_room_ = !1, e._trust_audio_enabled_state_ = !1, e._trust_video_enabled_state_ = !1, e._trust_audio_mute_state_ = !1, e._trust_video_mute_state_ = !1, e._trust_audio_stream_added_state_ = !1, e._trust_video_stream_added_state_ = !1, e._is_pre_created || (e._audio_pre_subscribed || (e._audioSSRC = void 0, e._audioOrtc = void 0), e._video_pre_subscribed || (e._videoSSRC = void 0, e._videoOrtc = void 0, e._rtxSsrcId = void 0), e._cname = void 0);
          }), _this320._userOfflineTimeout && window.clearTimeout(_this320._userOfflineTimeout), _this320._streamRemovedTimeout && window.clearTimeout(_this320._streamRemovedTimeout), _this320._userOfflineTimeout = void 0, _this320._streamRemovedTimeout = void 0;else if ("CONNECTED" === e) {
            var r;
            _this320._streamFallbackTypeCacheMap.forEach(function (e, t) {
              _this320._gateway.setStreamFallbackOption(t, e).catch(function (e) {
                YC.warning("[".concat(_this320._clientId, "] auto set stream fallback option failed"), e);
              });
            }), _this320._remoteStreamTypeCacheMap.forEach(function (e, t) {
              _this320._gateway.setRemoteVideoStreamType(t, e).catch(function (e) {
                YC.warning("[".concat(_this320._clientId, "] auto set remote stream type failed"), e);
              });
            }), void 0 !== _this320._remoteDefaultVideoStreamType && void 0 === (null === (r = _this320._joinInfo) || void 0 === r ? void 0 : r.defaultVideoStream) && _this320.setRemoteDefaultVideoStreamType(_this320._remoteDefaultVideoStreamType).then(function () {
              YC.debug("[".concat(_this320._clientId, "] setRemoteDefaultVideoStreamType after gateway connected"));
            }).catch(function (e) {
              YC.error("[".concat(_this320._clientId, "] setRemoteDefaultVideoStreamType after gateway failed, ").concat(e));
            }), _this320.store.useP2P || (_this320._p2pChannel.republish(), _this320._userOfflineTimeout = window.setTimeout(function () {
              if ("CONNECTED" !== _this320.connectionState) return;
              _this320._userOfflineTimeout = void 0;

              _this320._users.filter(function (e) {
                return !e._trust_in_room_;
              }).forEach(function (e) {
                YC.debug("[".concat(_this320._clientId, "] user offline timeout, emit user offline ").concat(e.uid)), _this320._handleUserOffline({
                  uid: e.uid
                });
              });
            }, 3e3), _this320._streamRemovedTimeout = window.setTimeout(function () {
              "CONNECTED" === _this320.connectionState && (_this320._streamRemovedTimeout = void 0, _this320._users.forEach(function (e) {
                e._trust_audio_mute_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch audio unmute event ").concat(e.uid)), _this320._handleMuteStream(e.uid, hv.AUDIO, !1)), e._trust_video_mute_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch video unmute event ").concat(e.uid)), _this320._handleMuteStream(e.uid, hv.VIDEO, !1)), e._trust_audio_enabled_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch enable local audio ").concat(e.uid)), _this320._handleSetStreamLocalEnable("audio", e.uid, !0)), e._trust_video_enabled_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch enable local video ").concat(e.uid)), _this320._handleSetStreamLocalEnable("video", e.uid, !0)), e._trust_video_stream_added_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch reset video stream added ").concat(e.uid)), _this320._handleResetAddStream(e, "video")), e._trust_audio_stream_added_state_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch reset audio stream added ").concat(e.uid)), _this320._handleResetAddStream(e, "audio")), e._video_added_ || e._audio_added_ || (YC.debug("[".concat(_this320._clientId, "] auto dispatch stream remove ").concat(e.uid)), _this320._handleRemoveStream({
                  uid: e.uid,
                  uint_id: e._uintid
                }));
              }));
            }, 1e3));
          }
          s();
        }), this._gateway.on(tv.REQUEST_NEW_GATEWAY_LIST, function (e, t) {
          if (!_this320._joinInfo) return t(new VI(xT.UNEXPECTED_ERROR, "can not recover, no join info"));
          mA(_this320._joinInfo, _this320._axiosCancelSource.token, _this320._config.httpRetryConfig || Jg, _this320.store).then(function (t) {
            _this320._joinInfo && (_this320._joinInfo.apResponse = t.gatewayInfo.res, _this320._joinInfo.gatewayAddrs = t.gatewayInfo.gatewayAddrs, _this320._joinInfo.uni_lbs_ip = t.gatewayInfo.uni_lbs_ip);
            var i = [];
            t.gatewayInfo.gatewayAddrs.forEach(function (e) {
              var t = e.address;

              var _t$split = t.split(":"),
                  _t$split2 = _slicedToArray(_t$split, 2),
                  n = _t$split2[0],
                  s = _t$split2[1];

              _this320._joinInfo && _this320._joinInfo.proxyServer ? i.push({
                proxy: _this320._joinInfo.proxyServer,
                host: n,
                port: s
              }) : i.push({
                host: n,
                port: s
              });
            }), e(i);
          }).catch(t);
        }), this._gateway.on(tv.NETWORK_QUALITY, function (e) {
          "normal" === _this320._networkQualitySensitivity && _this320.safeEmit(dg.NETWORK_QUALITY, e);
        }), this._gateway.on(tv.STREAM_TYPE_CHANGE, function (e, t) {
          _this320.safeEmit(dg.STREAM_TYPE_CHANGED, e, t);

          rI.reportApiInvoke(_this320._sessionId, {
            name: rg.STREAM_TYPE_CHANGE,
            options: [e, t],
            tag: og.TRACER
          }).onSuccess(JSON.stringify({
            uid: e,
            streamType: t
          }));
        }), this._gateway.on(tv.IS_P2P_DISCONNECTED, function (e) {
          _this320._p2pChannel.isP2PDisconnected() ? e(!0) : _this320._p2pChannel.hasLocalMedia() || _this320._p2pChannel.hasRemoteMedia() ? e(!1) : e(!0);
        }), this._gateway.on(tv.NEED_RENEW_SESSION, function () {
          _this320._startSession();
        }), this._gateway.on(tv.REQUEST_P2P_CONNECTION_PARAMS, /*#__PURE__*/function () {
          var _ref91 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee429(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee429$(_context429) {
              while (1) {
                switch (_context429.prev = _context429.next) {
                  case 0:
                    _context429.prev = 0;
                    _context429.t0 = t;
                    _context429.next = 4;
                    return _this320._p2pChannel.startP2PConnection(e);

                  case 4:
                    _context429.t1 = _context429.sent;
                    (0, _context429.t0)(_context429.t1);
                    _context429.next = 11;
                    break;

                  case 8:
                    _context429.prev = 8;
                    _context429.t2 = _context429["catch"](0);
                    i(_context429.t2);

                  case 11:
                  case "end":
                    return _context429.stop();
                }
              }
            }, _callee429, null, [[0, 8]]);
          }));

          return function (_x673, _x674, _x675) {
            return _ref91.apply(this, arguments);
          };
        }()), this._gateway.on(tv.JOIN_RESPONSE, function (e, t) {
          if (_this320.store.useP2P) return;

          var _TL = TL(e.ortc, t),
              i = _TL.dtlsParameters,
              n = _TL.iceParameters,
              s = _TL.candidates,
              r = _TL.rtpCapabilities,
              o = _TL.setup,
              a = _TL.cname;

          _this320._p2pChannel.connect(n, i, s, r, o, a);
        }), this._gateway.on(tv.REQUEST_DC_CONNECTION_PARAMS, function (e) {
          e(_this320._p2pChannel.getEstablishParams());
        }), this._gateway.on(tv.RESET_SIGNAL, function (e) {
          _this320._p2pChannel.resetConnection(e), _this320._handleGatewaySignalEvents();
        }), this._gateway.on(tv.DATACHANNEL_FAILBACK, function () {
          _this320._joinGateway();
        }), this._gateway.on(tv.DATACHANNEL_PRECONNECT, /*#__PURE__*/function () {
          var _ref92 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee430(e, t, i, n) {
            var s, r, o, a, c, d, l;
            return _regeneratorRuntime.wrap(function _callee430$(_context430) {
              while (1) {
                switch (_context430.prev = _context430.next) {
                  case 0:
                    _context430.next = 2;
                    return _this320._p2pChannel.startP2PConnection({
                      turnServer: null === (s = _this320._joinInfo) || void 0 === s ? void 0 : s.turnServer
                    }, !0);

                  case 2:
                    l = function (e, t) {
                      var i;
                      return t && t.ip && "number" == typeof t.port ? (i = [{
                        foundation: "udpcandidate",
                        componentId: "1",
                        transport: "udp",
                        priority: "2103266323",
                        connectionAddress: t.ip,
                        port: t.port.toString(),
                        type: "host",
                        extension: {}
                      }], YC.debug("Using remote candidate from AP ".concat(t.ip, ":").concat(t.port)), t.ip6 && (i.push({
                        foundation: "udpcandidate",
                        componentId: "1",
                        transport: "udp",
                        priority: "2103266323",
                        connectionAddress: t.ip6,
                        port: t.port.toString(),
                        type: "host",
                        extension: {}
                      }), YC.debug("Using IPV6 remote candidate from AP ".concat(t.ip6, ":").concat(t.port)))) : i = [{
                        foundation: "udpcandidate",
                        componentId: "1",
                        transport: "udp",
                        priority: "2103266323",
                        connectionAddress: e.ip,
                        port: e.port.toString(),
                        type: "host",
                        extension: {}
                      }], i;
                    }(e, t);

                    return _context430.abrupt("return", _this320._p2pChannel.preConnect({
                      iceUfrag: "".concat(null === (r = _this320._joinInfo) || void 0 === r ? void 0 : r.apResponse.cid, "_").concat(null === (o = _this320._joinInfo) || void 0 === o ? void 0 : o.apResponse.cert),
                      icePwd: "".concat(null === (a = _this320._joinInfo) || void 0 === a ? void 0 : a.apResponse.cid, "_").concat(null === (c = _this320._joinInfo) || void 0 === c ? void 0 : c.apResponse.cert)
                    }, {
                      fingerprints: [{
                        hashFunction: "sha-256",
                        fingerprint: null !== (d = DC("FINGERPRINT")) && void 0 !== d ? d : e.fingerprint
                      }]
                    }, l, {
                      send: {
                        audioCodecs: [],
                        videoCodecs: [],
                        audioExtensions: [],
                        videoExtensions: []
                      },
                      recv: {
                        audioCodecs: [],
                        videoCodecs: [],
                        audioExtensions: [],
                        videoExtensions: []
                      }
                    }, "active", "o/i14u9pJrxRKAsu").then(i).catch(n));

                  case 4:
                  case "end":
                    return _context430.stop();
                }
              }
            }, _callee430);
          }));

          return function (_x676, _x677, _x678, _x679) {
            return _ref92.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "_handleGatewaySignalEvents",
      value: function _handleGatewaySignalEvents() {
        var _this321 = this;

        this._gateway.signal.on(CI.ON_USER_ONLINE, this._handleUserOnline), this._gateway.signal.on(CI.ON_USER_OFFLINE, this._handleUserOffline), this._gateway.signal.on(CI.ON_ADD_AUDIO_STREAM, function (e) {
          return _this321._handleAddAudioOrVideoStream("audio", e.uid, e.ssrcId, e.cname, e.uint_id, e.ortc);
        }), this._gateway.signal.on(CI.ON_ADD_VIDEO_STREAM, function (e) {
          return _this321._handleAddAudioOrVideoStream("video", e.uid, e.ssrcId, e.cname, e.uint_id, e.ortc, e.rtxSsrcId);
        }), this._gateway.signal.on(CI.ON_REMOTE_DATASTREAM_UPDATE, function (e) {
          _this321._handleUpdateDataChannel(e);
        }), this._gateway.signal.on(CI.ON_REMOTE_FULL_DATASTREAM_INFO, function (e) {
          _this321._handleUpdateDataChannel({
            added: e.datastreams,
            deleted: []
          }, !0);
        }), this._gateway.signal.on(CI.ON_REMOVE_STREAM, this._handleRemoveStream), this._gateway.signal.on(CI.ON_P2P_LOST, this._handleP2PLost), this._gateway.signal.on(CI.MUTE_AUDIO, function (e) {
          return _this321._handleMuteStream(e.uid, hv.AUDIO, !0);
        }), this._gateway.signal.on(CI.UNMUTE_AUDIO, function (e) {
          return _this321._handleMuteStream(e.uid, hv.AUDIO, !1);
        }), this._gateway.signal.on(CI.MUTE_VIDEO, function (e) {
          return _this321._handleMuteStream(e.uid, hv.VIDEO, !0);
        }), this._gateway.signal.on(CI.UNMUTE_VIDEO, function (e) {
          return _this321._handleMuteStream(e.uid, hv.VIDEO, !1);
        }), this._gateway.signal.on(CI.RECEIVE_METADATA, function (e) {
          var t = Dg(e.metadata);

          _this321.safeEmit(dg.RECEIVE_METADATA, e.uid, t);
        }), this._gateway.signal.on(CI.ON_DATA_STREAM, /*#__PURE__*/function () {
          var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee431(e) {
            var t, _i176, _n153, _s105;

            return _regeneratorRuntime.wrap(function _callee431$(_context431) {
              while (1) {
                switch (_context431.prev = _context431.next) {
                  case 0:
                    if (e) {
                      _context431.next = 2;
                      break;
                    }

                    return _context431.abrupt("return");

                  case 2:
                    t = 0;

                    if (e.ordered || e.syncWithAudio) {
                      _i176 = _this321._p2pChannel.getStats(), _n153 = _this321.remoteUsers.find(function (t) {
                        return t.uid === e.uid;
                      }), _s105 = null == _i176 ? void 0 : _i176.audioRecv.find(function (e) {
                        return e.ssrc === (null == _n153 ? void 0 : _n153._audioSSRC);
                      });
                      t = null == _s105 ? void 0 : _s105.jitterBufferMs;
                    }

                    null == t && (t = 0), CU(e, t, {
                      id: _this321._clientId,
                      onStreamMessage: "function" == typeof _this321.onStreamMessage ? _this321.onStreamMessage.bind(_this321) : void 0,
                      safeEmit: _this321.safeEmit.bind(_this321)
                    });

                  case 5:
                  case "end":
                    return _context431.stop();
                }
              }
            }, _callee431);
          }));

          return function (_x680) {
            return _ref93.apply(this, arguments);
          };
        }()), this._gateway.signal.on(CI.ON_CRYPT_ERROR, function () {
          Ng(function () {
            YC.warning("[".concat(_this321._clientId, "] on crypt error")), _this321.safeEmit(dg.CRYPT_ERROR);
          }, _this321._sessionId);
        }), this._gateway.signal.on(CI.ON_TOKEN_PRIVILEGE_WILL_EXPIRE, this._handleTokenWillExpire), this._gateway.signal.on(CI.ON_TOKEN_PRIVILEGE_DID_EXPIRE, function () {
          YC.warning("[".concat(_this321._clientId, "] received message onTokenPrivilegeDidExpire, please get new token and join again")), _this321._gateway.leave(!0, cg.TOKEN_EXPIRE), _this321.safeEmit(dg.ON_TOKEN_PRIVILEGE_DID_EXPIRE), _this321._reset();
        }), this._gateway.signal.on(CI.ON_STREAM_FALLBACK_UPDATE, function (e) {
          YC.debug("[".concat(_this321._clientId, "] stream fallback peerId: ").concat(e.stream_id, ", attr: ").concat(e.stream_type)), _this321.safeEmit(dg.STREAM_FALLBACK, e.stream_id, 1 === e.stream_type ? "fallback" : "recover");
        }), this._gateway.signal.on(CI.ON_PUBLISH_STREAM, function (e) {
          _this321.uid === _this321._uid && (_this321._p2pChannel.reportPublishEvent(!0, null, void 0, !1, JSON.stringify({
            proxy: e.proxy
          })), YC.info("[".concat(_this321._clientId, "] on publish stream, ").concat(JSON.stringify(e))));
        }), this._gateway.signal.on(CI.ENABLE_LOCAL_VIDEO, function (e) {
          _this321._handleSetStreamLocalEnable("video", e.uid, !0);
        }), this._gateway.signal.on(CI.DISABLE_LOCAL_VIDEO, function (e) {
          _this321._handleSetStreamLocalEnable("video", e.uid, !1);
        }), this._gateway.signal.on(gI.REQUEST_TIMEOUT, function (e, t) {
          if (_this321._joinInfo) switch (e) {
            case SI.PUBLISH:
              {
                if (!t) return;
                var _e394 = t.ortc;

                if (_e394) {
                  var i, n;

                  var _s106 = _e394.some(function (e) {
                    var t = e.stream_type;
                    return t === ev.Audio;
                  }),
                      _r71 = _e394.some(function (e) {
                    var t = e.stream_type;
                    return t !== ev.Audio;
                  }),
                      _o55 = _e394.some(function (e) {
                    var t = e.stream_type;
                    return t === ev.Screen || t === ev.ScreenLow;
                  });

                  "offer" === t.state && rI.publish(_this321._joinInfo.sid, {
                    eventElapse: TP.measureFromPublishStart(_this321.store.clientId, _this321.store.pubId),
                    succ: !1,
                    ec: xT.TIMEOUT,
                    audio: _s106,
                    video: _r71,
                    p2pid: t.p2p_id,
                    publishRequestid: _this321.store.pubId,
                    screenshare: _o55,
                    audioName: _s106 ? null === (i = _e394.find(function (e) {
                      var t = e.stream_type;
                      return t === ev.Audio;
                    })) || void 0 === i || null === (i = i.ssrcs[0]) || void 0 === i ? void 0 : i.ssrcId.toString() : void 0,
                    videoName: _r71 ? null === (n = _e394.find(function (e) {
                      var t = e.stream_type;
                      return t !== ev.Audio;
                    })) || void 0 === n || null === (n = n.ssrcs[0]) || void 0 === n ? void 0 : n.ssrcId.toString() : void 0
                  });
                }

                break;
              }

            case SI.SUBSCRIBE:
              t && rI.subscribe(_this321._joinInfo.sid, {
                succ: !1,
                ec: xT.TIMEOUT,
                audio: t.stream_type === hv.AUDIO,
                video: t.stream_type === hv.VIDEO,
                peerid: t.stream_id,
                subscribeRequestid: t.ssrcId,
                p2pid: _this321.store.p2pId,
                eventElapse: TP.measureFromSubscribeStart(_this321.store.clientId, t.ssrcId)
              });
          }
        }), this._gateway.signal.on(CI.ON_P2P_OK, function (e) {
          _this321.uid, _this321._uid;
        }), this._gateway.signal.on(CI.ON_PUBLISHED_USER_LIST, function (e) {
          if (null == e || !e.users) return;
          DC("BLOCK_LOCAL_CLIENT") && (e.users = e.users.filter(function (e) {
            return !lI(e.string_id || e.stream_id, _this321.channelName);
          }));
          var t = [],
              i = [];

          var _iterator48 = _createForOfIteratorHelper(e.users),
              _step48;

          try {
            var _loop8 = function _loop8() {
              var n = _step48.value;

              var e = _this321._users.find(function (e) {
                return e._uintid === n.stream_id;
              });

              e ? e._trust_in_room_ = !0 : (e = new ik(n.string_id || n.stream_id, n.stream_id), _this321._users.push(e), 0 === _this321.getListeners(dg.PUBLISHED_USER_LIST).length && (YC.debug("[".concat(_this321._clientId, "] user online"), n.stream_id), _this321.safeEmit(dg.USER_JOINED, e)));
              var s = nv.Audio & n.stream_type,
                  r = (nv.Video | nv.LwoVideo) & n.stream_type,
                  o = 0 != (65280 & n.stream_type),
                  a = s && e.hasAudio,
                  c = r && e.hasVideo;
              r && (e._trust_video_stream_added_state_ = !0, e._video_added_ = !0, e._videoSSRC = n.video_ssrc, e._rtxSsrcId = n.video_rtx), s && (e._trust_audio_stream_added_state_ = !0, e._audio_added_ = !0, e._audioSSRC = n.audio_ssrc), s && !a && 0 === _this321.getListeners(dg.PUBLISHED_USER_LIST).length && (YC.info("[".concat(_this321._clientId, "] remote user ").concat(e.uid, " published audio")), _this321.safeEmit(dg.USER_PUBLISHED, e, "audio")), r && !c && 0 === _this321.getListeners(dg.PUBLISHED_USER_LIST).length && (YC.info("[".concat(_this321._clientId, "] remote user ").concat(e.uid, " published video")), _this321.safeEmit(dg.USER_PUBLISHED, e, "video")), (s && !a || r && !c || o) && t.push(e), r && _this321._p2pChannel.hasPendingRemoteMedia(e, "video") && i.push({
                user: e,
                mediaType: "video"
              }), s && _this321._p2pChannel.hasPendingRemoteMedia(e, "audio") && i.push({
                user: e,
                mediaType: "audio"
              });
            };

            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              _loop8();
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }

          i.length > 0 && (YC.debug("[".concat(_this321._clientId, "] RE massSubscribe after reconnect ").concat(i.map(function (e) {
            return "user: ".concat(e.user.uid, ", mediaType: ").concat(e.mediaType);
          }).join("; "), " ")), _this321.massSubscribe(i).catch(function (e) {
            YC.error("[".concat(_this321._clientId, "] mass resubscribe error"), e.toString());
          })), _this321.getListeners(dg.PUBLISHED_USER_LIST).length > 0 ? DC("ENABLE_DATASTREAM_2") ? _this321._pendingPublishedUsers = t : (YC.info("[".concat(_this321._clientId, "] client emit user-list event, users: ").concat(t.map(function (e) {
            return e.uid;
          }).join(", "))), _this321.safeEmit(dg.PUBLISHED_USER_LIST, t)) : YC.info("[".concat(_this321._clientId, "] client not emit user-list event case there is no user-list listener, users: ").concat(t.map(function (e) {
            return e.uid;
          }).join(", ")));
        }), this._gateway.signal.on(CI.ON_RTP_CAPABILITY_CHANGE, function (e) {
          var t = e.video_codec;
          _this321._p2pChannel instanceof nM && _this321._p2pChannel.updateRemoteRTPCapabilities(t.map(function (e) {
            return e.toLowerCase();
          }).filter(function (e) {
            var t;
            return bn(t = Object.keys(xC)).call(t, e);
          }));
        });
      }
    }, {
      key: "_handleP2PEvents",
      value: function _handleP2PEvents() {
        var _this322 = this;

        this._gateway.signal.on(CI.ON_USER_OFFLINE, function () {
          _this322._p2pChannel.disconnectForReconnect();
        }), this._gateway.signal.on(Ov.PUBLISH, function (e, t, i) {
          var n = e.uid;
          e.forEach(function (e) {
            var s = e.kind,
                r = e.ssrcs,
                o = e.mid,
                a = e.isMuted;

            _this322._handleP2PAddAudioOrVideoStream(s, n, r[0].ssrcId, o);

            var c = _this322._users.find(function (e) {
              return e.uid === n;
            });

            return c && _this322._p2pChannel instanceof ak ? _this322._p2pChannel.mockSubscribe(c, s, r[0].ssrcId, o).then(function () {
              t();
            }).catch(i) : t(), _this322._handleMuteStream(n, s, !!a);
          });
        }), this._gateway.signal.on(Ov.CALL, /*#__PURE__*/function () {
          var _ref94 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee432(e, t, i) {
            var n;
            return _regeneratorRuntime.wrap(function _callee432$(_context432) {
              while (1) {
                switch (_context432.prev = _context432.next) {
                  case 0:
                    if (!(_this322._p2pChannel instanceof ak)) {
                      _context432.next = 12;
                      break;
                    }

                    _context432.prev = 1;
                    _context432.t0 = t;
                    _context432.next = 5;
                    return _this322._p2pChannel.startP2P({
                      turnServer: null === (n = _this322._joinInfo) || void 0 === n ? void 0 : n.turnServer
                    }, e);

                  case 5:
                    _context432.t1 = _context432.sent;
                    (0, _context432.t0)(_context432.t1);
                    _context432.next = 12;
                    break;

                  case 9:
                    _context432.prev = 9;
                    _context432.t2 = _context432["catch"](1);
                    i(_context432.t2);

                  case 12:
                  case "end":
                    return _context432.stop();
                }
              }
            }, _callee432, null, [[1, 9]]);
          }));

          return function (_x681, _x682, _x683) {
            return _ref94.apply(this, arguments);
          };
        }()), this._gateway.signal.on(gI.P2P_CONNECTION, /*#__PURE__*/function () {
          var _ref95 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee433(e) {
            return _regeneratorRuntime.wrap(function _callee433$(_context433) {
              while (1) {
                switch (_context433.prev = _context433.next) {
                  case 0:
                    _context433.t0 = _this322._p2pChannel instanceof ak;

                    if (!_context433.t0) {
                      _context433.next = 4;
                      break;
                    }

                    _context433.next = 4;
                    return _this322._p2pChannel.p2pConnect(e);

                  case 4:
                  case "end":
                    return _context433.stop();
                }
              }
            }, _callee433);
          }));

          return function (_x684) {
            return _ref95.apply(this, arguments);
          };
        }()), this._gateway.signal.on(Ov.UNPUBLISH, /*#__PURE__*/function () {
          var _ref96 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee435(e, t, i) {
            var _n154, _s107, _r72;

            return _regeneratorRuntime.wrap(function _callee435$(_context435) {
              while (1) {
                switch (_context435.prev = _context435.next) {
                  case 0:
                    if (!(_this322._p2pChannel instanceof ak)) {
                      _context435.next = 5;
                      break;
                    }

                    _n154 = e.unpubMsg, _s107 = e.uid, _r72 = _this322._users.find(function (e) {
                      return e.uid === _s107;
                    });

                    if (_r72) {
                      _context435.next = 4;
                      break;
                    }

                    return _context435.abrupt("return", (YC.warning("[".concat(_this322._clientId, "] can not find remote user, ignore mute event, uid: ").concat(_s107)), void t()));

                  case 4:
                    try {
                      _n154.forEach( /*#__PURE__*/function () {
                        var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee434(e) {
                          var t, i;
                          return _regeneratorRuntime.wrap(function _callee434$(_context434) {
                            while (1) {
                              switch (_context434.prev = _context434.next) {
                                case 0:
                                  t = e.stream_type;
                                  i = t === ev.Audio ? hv.AUDIO : hv.VIDEO;
                                  _context434.next = 4;
                                  return _this322._p2pChannel.unsubscribe(_r72, i);

                                case 4:
                                  _this322._handleMuteStream(_s107, i, !0);

                                case 5:
                                case "end":
                                  return _context434.stop();
                              }
                            }
                          }, _callee434);
                        }));

                        return function (_x688) {
                          return _ref97.apply(this, arguments);
                        };
                      }()), t();
                    } catch (e) {
                      i(e);
                    }

                  case 5:
                  case "end":
                    return _context435.stop();
                }
              }
            }, _callee435);
          }));

          return function (_x685, _x686, _x687) {
            return _ref96.apply(this, arguments);
          };
        }()), this._gateway.signal.on(Ov.CONTROL, /*#__PURE__*/function () {
          var _ref98 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee436(e, t) {
            var i;
            return _regeneratorRuntime.wrap(function _callee436$(_context436) {
              while (1) {
                switch (_context436.prev = _context436.next) {
                  case 0:
                    i = e.action;
                    _context436.t0 = i;
                    _context436.next = _context436.t0 === Dv.MUTE_LOCAL_VIDEO ? 4 : _context436.t0 === Dv.MUTE_LOCAL_AUDIO ? 6 : _context436.t0 === Dv.UNMUTE_LOCAL_VIDEO ? 8 : _context436.t0 === Dv.UNMUTE_LOCAL_AUDIO ? 10 : 11;
                    break;

                  case 4:
                    _this322._handleMuteStream(t, hv.VIDEO, !0);

                    return _context436.abrupt("break", 11);

                  case 6:
                    _this322._handleMuteStream(t, hv.AUDIO, !0);

                    return _context436.abrupt("break", 11);

                  case 8:
                    _this322._handleP2PAddAudioOrVideoStream("video", t), _this322._handleMuteStream(t, hv.VIDEO, !1);
                    return _context436.abrupt("break", 11);

                  case 10:
                    _this322._handleP2PAddAudioOrVideoStream("audio", t), _this322._handleMuteStream(t, hv.AUDIO, !1);

                  case 11:
                  case "end":
                    return _context436.stop();
                }
              }
            }, _callee436);
          }));

          return function (_x689, _x690) {
            return _ref98.apply(this, arguments);
          };
        }()), this._gateway.signal.on(Ov.RESTART_ICE, /*#__PURE__*/function () {
          var _ref99 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee437(e, t, i) {
            var _i177, _n155;

            return _regeneratorRuntime.wrap(function _callee437$(_context437) {
              while (1) {
                switch (_context437.prev = _context437.next) {
                  case 0:
                    if (!(_this322._p2pChannel instanceof ak)) {
                      _context437.next = 17;
                      break;
                    }

                    _context437.prev = 1;
                    _i177 = e.direction, _n155 = e.iceParameter;

                    if (!(_i177 !== vI.SEND_ONLY || _n155)) {
                      _context437.next = 11;
                      break;
                    }

                    _context437.t0 = t;
                    _context437.next = 7;
                    return _this322._p2pChannel.restartICE(_i177, _n155);

                  case 7:
                    _context437.t1 = _context437.sent;
                    (0, _context437.t0)(_context437.t1);
                    _context437.next = 12;
                    break;

                  case 11:
                    _this322._p2pChannel.handleDisconnect(_i177), t();

                  case 12:
                    _context437.next = 17;
                    break;

                  case 14:
                    _context437.prev = 14;
                    _context437.t2 = _context437["catch"](1);
                    i(_context437.t2);

                  case 17:
                  case "end":
                    return _context437.stop();
                }
              }
            }, _callee437, null, [[1, 14]]);
          }));

          return function (_x691, _x692, _x693) {
            return _ref99.apply(this, arguments);
          };
        }()), this._gateway.signal.on(Ov.CANDIDATE, function (e) {
          if (_this322._p2pChannel instanceof ak) {
            var _t336 = e.candidate,
                _i178 = e.direction;

            _this322._p2pChannel.addRemoteCandidate(_t336, _i178);
          }
        }), this._p2pChannel.on(fv.RequestP2PRestartICE, /*#__PURE__*/function () {
          var _ref100 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee438(e, t, i) {
            var _i179;

            return _regeneratorRuntime.wrap(function _callee438$(_context438) {
              while (1) {
                switch (_context438.prev = _context438.next) {
                  case 0:
                    _context438.prev = 0;
                    _i179 = e.direction;
                    _context438.t0 = t;
                    _context438.next = 5;
                    return _this322._gateway.sendExtensionMessage(Ov.RESTART_ICE, e, _i179 === vI.SEND_ONLY);

                  case 5:
                    _context438.t1 = _context438.sent;
                    (0, _context438.t0)(_context438.t1);
                    _context438.next = 12;
                    break;

                  case 9:
                    _context438.prev = 9;
                    _context438.t2 = _context438["catch"](0);
                    i(_context438.t2);

                  case 12:
                  case "end":
                    return _context438.stop();
                }
              }
            }, _callee438, null, [[0, 9]]);
          }));

          return function (_x694, _x695, _x696) {
            return _ref100.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.LocalCandidate, function (e) {
          _this322._gateway.sendExtensionMessage(Ov.CANDIDATE, JSON.stringify(e), !0);
        }), this._p2pChannel.on(fv.RequestP2PMuteLocal, /*#__PURE__*/function () {
          var _ref101 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee439(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee439$(_context439) {
              while (1) {
                switch (_context439.prev = _context439.next) {
                  case 0:
                    _context439.prev = 0;
                    _context439.next = 3;
                    return _this322._gateway.sendExtensionMessage(Ov.CONTROL, e, !0);

                  case 3:
                    t();
                    _context439.next = 9;
                    break;

                  case 6:
                    _context439.prev = 6;
                    _context439.t0 = _context439["catch"](0);
                    i(_context439.t0);

                  case 9:
                  case "end":
                    return _context439.stop();
                }
              }
            }, _callee439, null, [[0, 6]]);
          }));

          return function (_x697, _x698, _x699) {
            return _ref101.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestP2PUnmuteRemote, /*#__PURE__*/function () {
          var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee440(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee440$(_context440) {
              while (1) {
                switch (_context440.prev = _context440.next) {
                  case 0:
                    if (!_this322._joinInfo) {
                      _context440.next = 12;
                      break;
                    }

                    _context440.prev = 1;
                    _context440.next = 4;
                    return _this322._gateway.unmuteRemote(e, _this322._joinInfo.stringUid || _this322._joinInfo.uid);

                  case 4:
                    t();
                    _context440.next = 10;
                    break;

                  case 7:
                    _context440.prev = 7;
                    _context440.t0 = _context440["catch"](1);
                    _context440.t0.code === xT.DISCONNECT_P2P ? t() : i(_context440.t0);

                  case 10:
                    _context440.next = 13;
                    break;

                  case 12:
                    t();

                  case 13:
                  case "end":
                    return _context440.stop();
                }
              }
            }, _callee440, null, [[1, 7]]);
          }));

          return function (_x700, _x701, _x702) {
            return _ref102.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestP2PMuteRemote, /*#__PURE__*/function () {
          var _ref103 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee441(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee441$(_context441) {
              while (1) {
                switch (_context441.prev = _context441.next) {
                  case 0:
                    if (!_this322._joinInfo) {
                      _context441.next = 12;
                      break;
                    }

                    _context441.prev = 1;
                    _context441.next = 4;
                    return _this322._gateway.muteRemote(e, _this322._joinInfo.stringUid || _this322._joinInfo.uid);

                  case 4:
                    t();
                    _context441.next = 10;
                    break;

                  case 7:
                    _context441.prev = 7;
                    _context441.t0 = _context441["catch"](1);
                    _context441.t0.code === xT.DISCONNECT_P2P ? t() : i(_context441.t0);

                  case 10:
                    _context441.next = 13;
                    break;

                  case 12:
                    t();

                  case 13:
                  case "end":
                    return _context441.stop();
                }
              }
            }, _callee441, null, [[1, 7]]);
          }));

          return function (_x703, _x704, _x705) {
            return _ref103.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.StateChange, function (e, t) {
          t === mv.Connected && _this322._p2pChannel.republish();
        });
      }
    }, {
      key: "_handleP2PChannelEvents",
      value: function _handleP2PChannelEvents() {
        var _this323 = this;

        this._p2pChannel.on(fv.RequestMuteLocal, /*#__PURE__*/function () {
          var _ref104 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee442(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee442$(_context442) {
              while (1) {
                switch (_context442.prev = _context442.next) {
                  case 0:
                    if (!_this323._joinInfo) {
                      _context442.next = 12;
                      break;
                    }

                    _context442.prev = 1;
                    _context442.next = 4;
                    return _this323._gateway.muteLocal(e, _this323._joinInfo.stringUid || _this323._joinInfo.uid);

                  case 4:
                    t();
                    _context442.next = 10;
                    break;

                  case 7:
                    _context442.prev = 7;
                    _context442.t0 = _context442["catch"](1);
                    _context442.t0.code === xT.DISCONNECT_P2P ? t() : i(_context442.t0);

                  case 10:
                    _context442.next = 13;
                    break;

                  case 12:
                    t();

                  case 13:
                  case "end":
                    return _context442.stop();
                }
              }
            }, _callee442, null, [[1, 7]]);
          }));

          return function (_x706, _x707, _x708) {
            return _ref104.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestUnmuteLocal, /*#__PURE__*/function () {
          var _ref105 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee443(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee443$(_context443) {
              while (1) {
                switch (_context443.prev = _context443.next) {
                  case 0:
                    if (!_this323._joinInfo) {
                      _context443.next = 12;
                      break;
                    }

                    _context443.prev = 1;
                    _context443.next = 4;
                    return _this323._gateway.unmuteLocal(e, _this323._joinInfo.stringUid || _this323._joinInfo.uid);

                  case 4:
                    t();
                    _context443.next = 10;
                    break;

                  case 7:
                    _context443.prev = 7;
                    _context443.t0 = _context443["catch"](1);
                    _context443.t0.code === xT.DISCONNECT_P2P ? t() : i(_context443.t0);

                  case 10:
                    _context443.next = 13;
                    break;

                  case 12:
                    t();

                  case 13:
                  case "end":
                    return _context443.stop();
                }
              }
            }, _callee443, null, [[1, 7]]);
          }));

          return function (_x709, _x710, _x711) {
            return _ref105.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestRePublish, function (e, t, i) {
          _this323.publish(e, !1).then(t).catch(i);
        }), this._p2pChannel.on(fv.RequestRePublishDataChannel, function (e, t, i) {
          tT.all(e.map( /*#__PURE__*/function () {
            var _ref106 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee444(e) {
              var t;
              return _regeneratorRuntime.wrap(function _callee444$(_context444) {
                while (1) {
                  switch (_context444.prev = _context444.next) {
                    case 0:
                      _context444.next = 2;
                      return _this323._p2pChannel.publishDataChannel([e]);

                    case 2:
                      t = {
                        streamId: e.id,
                        ordered: e.ordered,
                        maxRetransmits: e.maxRetransmits,
                        metadata: e.metadata,
                        channelId: e._originDataChannelId
                      };
                      _context444.prev = 3;
                      _context444.next = 6;
                      return _this323._gateway.publishDataChannel(_this323._uid, t, !0);

                    case 6:
                      _context444.next = 12;
                      break;

                    case 8:
                      _context444.prev = 8;
                      _context444.t0 = _context444["catch"](3);

                      if (!(_context444.t0.code !== xT.DISCONNECT_P2P)) {
                        _context444.next = 12;
                        break;
                      }

                      throw _context444.t0;

                    case 12:
                    case "end":
                      return _context444.stop();
                  }
                }
              }, _callee444, null, [[3, 8]]);
            }));

            return function (_x712) {
              return _ref106.apply(this, arguments);
            };
          }())).then(t).catch(i);
        }), this._p2pChannel.on(fv.RequestReSubscribe, /*#__PURE__*/function () {
          var _ref107 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee445(e, t, i) {
            var _iterator49, _step49, _step49$value, _t337, _i180;

            return _regeneratorRuntime.wrap(function _callee445$(_context445) {
              while (1) {
                switch (_context445.prev = _context445.next) {
                  case 0:
                    _context445.prev = 0;
                    _iterator49 = _createForOfIteratorHelper(e);
                    _context445.prev = 2;

                    _iterator49.s();

                  case 4:
                    if ((_step49 = _iterator49.n()).done) {
                      _context445.next = 15;
                      break;
                    }

                    _step49$value = _step49.value, _t337 = _step49$value.user, _i180 = _step49$value.kind;

                    if (!(_i180 === hv.VIDEO)) {
                      _context445.next = 11;
                      break;
                    }

                    _context445.next = 9;
                    return _this323.subscribe(_t337, "video");

                  case 9:
                    _context445.next = 13;
                    break;

                  case 11:
                    _context445.next = 13;
                    return _this323.subscribe(_t337, "audio");

                  case 13:
                    _context445.next = 4;
                    break;

                  case 15:
                    _context445.next = 20;
                    break;

                  case 17:
                    _context445.prev = 17;
                    _context445.t0 = _context445["catch"](2);

                    _iterator49.e(_context445.t0);

                  case 20:
                    _context445.prev = 20;

                    _iterator49.f();

                    return _context445.finish(20);

                  case 23:
                    t();
                    _context445.next = 29;
                    break;

                  case 26:
                    _context445.prev = 26;
                    _context445.t1 = _context445["catch"](0);
                    i(_context445.t1);

                  case 29:
                  case "end":
                    return _context445.stop();
                }
              }
            }, _callee445, null, [[0, 26], [2, 17, 20, 23]]);
          }));

          return function (_x713, _x714, _x715) {
            return _ref107.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestUpload, function (e, t) {
          _this323._gateway.upload(e, t);
        }), this._p2pChannel.on(fv.RequestUploadStats, function (e) {
          _this323._gateway.uploadWRTCStats(e);
        }), this._p2pChannel.on(fv.MediaReconnectStart, function (e) {
          _this323.safeEmit(dg.MEDIA_RECONNECT_START, e);
        }), this._p2pChannel.on(fv.MediaReconnectEnd, function (e) {
          _this323.safeEmit(dg.MEDIA_RECONNECT_END, e);
        }), this._p2pChannel.on(fv.NeedSignalRTT, function (e) {
          e(_this323._gateway.getSignalRTT());
        }), this._p2pChannel.on(fv.RequestRestartICE, /*#__PURE__*/function () {
          var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee446(e) {
            var t, i, n, s, _ref109, r;

            return _regeneratorRuntime.wrap(function _callee446$(_context446) {
              while (1) {
                switch (_context446.prev = _context446.next) {
                  case 0:
                    if (!(_this323._p2pChannel instanceof ak)) {
                      _context446.next = 2;
                      break;
                    }

                    return _context446.abrupt("return");

                  case 2:
                    _context446.next = 4;
                    return _this323._p2pChannel.restartICE(e);

                  case 4:
                    t = _context446.sent;
                    _context446.next = 7;
                    return t.next();

                  case 7:
                    i = _context446.sent;

                    if (!i.done) {
                      _context446.next = 10;
                      break;
                    }

                    return _context446.abrupt("return");

                  case 10:
                    n = i.value;
                    _context446.prev = 11;
                    _context446.next = 14;
                    return _this323._gateway.restartICE({
                      iceParameters: n
                    });

                  case 14:
                    s = _context446.sent;
                    _context446.next = 20;
                    break;

                  case 17:
                    _context446.prev = 17;
                    _context446.t0 = _context446["catch"](11);
                    return _context446.abrupt("return", void t.throw(_context446.t0));

                  case 20:
                    _ref109 = function (e) {
                      var t = e.iceParameters;
                      return {
                        iceParameters: {
                          iceUfrag: t.iceUfrag,
                          icePwd: t.icePwd
                        }
                      };
                    }(s), r = _ref109.iceParameters;
                    _context446.next = 23;
                    return t.next({
                      remoteIceParameters: r
                    });

                  case 23:
                  case "end":
                    return _context446.stop();
                }
              }
            }, _callee446, null, [[11, 17]]);
          }));

          return function (_x716) {
            return _ref108.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.RequestReconnect, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee447() {
          return _regeneratorRuntime.wrap(function _callee447$(_context447) {
            while (1) {
              switch (_context447.prev = _context447.next) {
                case 0:
                  _this323._gateway.reconnect();

                case 1:
                case "end":
                  return _context447.stop();
              }
            }
          }, _callee447);
        }))), this._p2pChannel.on(fv.RequestReconnectPC, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee448() {
          var e, _yield$_this323$_p2pC, t, i, n, _yield$_this323$_gate, s, r, _TL2, o, a, c, d, l, u;

          return _regeneratorRuntime.wrap(function _callee448$(_context448) {
            while (1) {
              switch (_context448.prev = _context448.next) {
                case 0:
                  _context448.next = 2;
                  return _this323._p2pChannel.startP2PConnection({
                    turnServer: null === (e = _this323._joinInfo) || void 0 === e ? void 0 : e.turnServer
                  });

                case 2:
                  _yield$_this323$_p2pC = _context448.sent;
                  t = _yield$_this323$_p2pC.iceParameters;
                  i = _yield$_this323$_p2pC.dtlsParameters;
                  n = _yield$_this323$_p2pC.rtpCapabilities;
                  _context448.next = 8;
                  return _this323._gateway.reconnectPC({
                    iceParameters: t,
                    dtlsParameters: i,
                    rtpCapabilities: n
                  });

                case 8:
                  _yield$_this323$_gate = _context448.sent;
                  s = _yield$_this323$_gate.gatewayEstablishParams;
                  r = _yield$_this323$_gate.gatewayAddress;
                  _TL2 = TL(s, r);
                  o = _TL2.dtlsParameters;
                  a = _TL2.iceParameters;
                  c = _TL2.candidates;
                  d = _TL2.rtpCapabilities;
                  l = _TL2.setup;
                  u = _TL2.cname;
                  _context448.next = 20;
                  return _this323._p2pChannel.connect(a, o, c, d, l, u);

                case 20:
                  _context448.next = 22;
                  return _this323._p2pChannel.republish();

                case 22:
                  _context448.next = 24;
                  return _this323._p2pChannel.reSubscribe();

                case 24:
                case "end":
                  return _context448.stop();
              }
            }
          }, _callee448);
        }))), this._p2pChannel.on(fv.RequestUnpublishForReconnectPC, /*#__PURE__*/function () {
          var _ref112 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee449(e, t, i) {
            return _regeneratorRuntime.wrap(function _callee449$(_context449) {
              while (1) {
                switch (_context449.prev = _context449.next) {
                  case 0:
                    if (!(_this323._joinInfo && void 0 !== _this323._uid)) {
                      _context449.next = 6;
                      break;
                    }

                    _context449.next = 3;
                    return _this323._gateway.unpublish(e, _this323._uid);

                  case 3:
                    t();
                    _context449.next = 7;
                    break;

                  case 6:
                    i();

                  case 7:
                  case "end":
                    return _context449.stop();
                }
              }
            }, _callee449);
          }));

          return function (_x717, _x718, _x719) {
            return _ref112.apply(this, arguments);
          };
        }()), this._p2pChannel.on(fv.P2PLost, function () {
          _this323.safeEmit(dg.P2P_LOST, _this323.store.uid);
        }), this._p2pChannel.on(fv.UpdateVideoEncoder, function (e) {
          e._encoderConfig && _this323._gateway.setVideoProfile(e._encoderConfig);
        }), this._p2pChannel.on(fv.ConnectionTypeChange, function (e) {
          _this323.safeEmit(dg.IS_USING_CLOUD_PROXY, e);
        }), this._p2pChannel.on(fv.RequestLowStreamParameter, function (e) {
          e(_this323._lowStreamParameter || {
            width: 160,
            height: 120,
            framerate: 15,
            bitrate: 50
          });
        }), this._p2pChannel.on(fv.QueryClientConnectionState, function (e) {
          e(_this323.connectionState);
        });
      }
    }, {
      key: "getKeyMetrics",
      value: function getKeyMetrics() {
        return this.store.keyMetrics;
      }
    }, {
      key: "enableContentInspect",
      value: function () {
        var _enableContentInspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee450(e) {
          var _this324 = this;

          var _t338, _t339;

          return _regeneratorRuntime.wrap(function _callee450$(_context450) {
            while (1) {
              switch (_context450.prev = _context450.next) {
                case 0:
                  if (!("CONNECTED" !== this.connectionState || !this._joinInfo)) {
                    _context450.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Client did not join channel"));

                case 2:
                  if (!this._inspect) {
                    _context450.next = 4;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] Inspect content service already in connecting/connected state"));

                case 4:
                  if (e) {
                    _context450.next = 6;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] inspectConfig is necessary"));

                case 6:
                  if (!(!e.inspectType || !Array.isArray(e.inspectType))) {
                    _context450.next = 8;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] inspectConfig.inspectType is necessary and is an instance of Array."));

                case 8:
                  _t338 = _toConsumableArray(new Set(e.inspectType));
                  _t338.forEach(function (e) {
                    var t;
                    if (!bn(t = ["supervise", "moderation"]).call(t, e)) throw new VI(xT.INVALID_PARAMS, "[".concat(_this324._clientId, "] ").concat(e, " is not a valid inspect type."));
                  }), e.inspectType = _t338;

                  if (!(e && e.extraInfo && e.extraInfo.length > 1024)) {
                    _context450.next = 12;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] inspectConfig.extraInfo length cannot exceed 1024 bytes"));

                case 12:
                  _context450.prev = 12;
                  _t339 = new kM(e);
                  this._inspect = _t339;
                  this.handleVideoInspectEvents(this._inspect);
                  _context450.next = 18;
                  return _t339.init({
                    appId: this._joinInfo.appId,
                    areaCode: "",
                    cname: this._joinInfo.cname,
                    sid: this._joinInfo.sid,
                    token: this._joinInfo.token,
                    uid: this._joinInfo.uid,
                    cid: this._joinInfo.cid,
                    vid: this._joinInfo.vid ? Number(this._joinInfo.vid) : 0
                  }, Jg);

                case 18:
                  _context450.next = 23;
                  break;

                case 20:
                  _context450.prev = 20;
                  _context450.t0 = _context450["catch"](12);
                  throw Array.isArray(_context450.t0) ? _context450.t0[0] : _context450.t0;

                case 23:
                case "end":
                  return _context450.stop();
              }
            }
          }, _callee450, this, [[12, 20]]);
        }));

        function enableContentInspect(_x720) {
          return _enableContentInspect.apply(this, arguments);
        }

        return enableContentInspect;
      }()
    }, {
      key: "disableContentInspect",
      value: function () {
        var _disableContentInspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee451() {
          return _regeneratorRuntime.wrap(function _callee451$(_context451) {
            while (1) {
              switch (_context451.prev = _context451.next) {
                case 0:
                  if (this._inspect) {
                    _context451.next = 2;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] inspectVideoContent not started"));

                case 2:
                  _context451.prev = 2;
                  this._inspect.close(), this._inspect = void 0;
                  _context451.next = 9;
                  break;

                case 6:
                  _context451.prev = 6;
                  _context451.t0 = _context451["catch"](2);
                  throw Array.isArray(_context451.t0) ? _context451.t0[0] : _context451.t0;

                case 9:
                case "end":
                  return _context451.stop();
              }
            }
          }, _callee451, this, [[2, 6]]);
        }));

        function disableContentInspect() {
          return _disableContentInspect.apply(this, arguments);
        }

        return disableContentInspect;
      }()
    }, {
      key: "setImageModeration",
      value: function () {
        var _setImageModeration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee452(e, t) {
          var _e395;

          return _regeneratorRuntime.wrap(function _callee452$(_context452) {
            while (1) {
              switch (_context452.prev = _context452.next) {
                case 0:
                  if (!(FT(e, "enabled"), e)) {
                    _context452.next = 24;
                    break;
                  }

                  if (t) {
                    _context452.next = 3;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] config is necessary"));

                case 3:
                  if (!(jT(t.interval, "interval", 1e3, 1 / 0), t && t.extraInfo && t.extraInfo.length > 1024)) {
                    _context452.next = 5;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] config.extraInfo length cannot exceed 1024 bytes"));

                case 5:
                  if (!(t && t.vendor && t.vendor.length > 1024)) {
                    _context452.next = 7;
                    break;
                  }

                  throw new VI(xT.INVALID_PARAMS, "[".concat(this._clientId, "] config.vendor length cannot exceed 1024 bytes"));

                case 7:
                  if (!("CONNECTED" !== this.connectionState || !this._joinInfo)) {
                    _context452.next = 9;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, '] can not enable image moderation, not joined"'));

                case 9:
                  _context452.prev = 9;

                  if (!this._moderation) {
                    _context452.next = 12;
                    break;
                  }

                  return _context452.abrupt("return", void this._moderation.updateConfig(t));

                case 12:
                  _e395 = new pU(t);
                  this._moderation = _e395;
                  this.handleImageModerationEvents(this._moderation);
                  _context452.next = 17;
                  return _e395.init({
                    appId: this._joinInfo.appId,
                    areaCode: "",
                    cname: this._joinInfo.cname,
                    sid: this._joinInfo.sid,
                    token: this._joinInfo.token,
                    uid: this._joinInfo.uid,
                    cid: this._joinInfo.cid,
                    vid: this._joinInfo.vid ? Number(this._joinInfo.vid) : 0
                  }, Jg);

                case 17:
                  _context452.next = 22;
                  break;

                case 19:
                  _context452.prev = 19;
                  _context452.t0 = _context452["catch"](9);
                  throw Array.isArray(_context452.t0) ? _context452.t0[0] : _context452.t0;

                case 22:
                  _context452.next = 33;
                  break;

                case 24:
                  if (this._moderation) {
                    _context452.next = 26;
                    break;
                  }

                  throw new VI(xT.INVALID_OPERATION, "[".concat(this._clientId, "] image moderation not started"));

                case 26:
                  _context452.prev = 26;
                  this._moderation.close(), this._moderation.removeAllListeners(), this._moderation = void 0;
                  _context452.next = 33;
                  break;

                case 30:
                  _context452.prev = 30;
                  _context452.t1 = _context452["catch"](26);
                  throw Array.isArray(_context452.t1) ? _context452.t1[0] : _context452.t1;

                case 33:
                case "end":
                  return _context452.stop();
              }
            }
          }, _callee452, this, [[9, 19], [26, 30]]);
        }));

        function setImageModeration(_x721, _x722) {
          return _setImageModeration.apply(this, arguments);
        }

        return setImageModeration;
      }()
    }, {
      key: "setP2PTransport",
      value: function setP2PTransport(e) {
        if (function (e) {
          BT(e, "transport", ["default", "auto", "relay", "sd-rtn"]);
        }(e), "p2p" !== this.mode) throw new VI(xT.INVALID_OPERATION, "only p2p mode can set p2pTransport");
        this.store.p2pTransport = e, YC.info("[".concat(this._clientId, "] set client p2pTransport to ").concat(e));
      }
    }, {
      key: "handleImageModerationEvents",
      value: function handleImageModerationEvents(e) {
        var _this325 = this;

        e.on(bv.CONNECTION_STATE_CHANGE, function (t, i) {
          if (_this325.safeEmit(dg.IMAGE_MODERATION_CONNECTION_STATE_CHANGE, t, i), t === Av.CONNECTED) {
            if ("CONNECTED" !== _this325.connectionState) throw _this325.setImageModeration(!1), new VI(xT.OPERATION_ABORTED, "Image moderation was cancelled because it left the channel");
            e.inspectImage();
          }
        }), e.on(bv.CLIENT_LOCAL_VIDEO_TRACK, function (e) {
          e(_this325.localTracks.filter(function (e) {
            return "video" === e.trackMediaType;
          })[0]);
        });
      }
    }, {
      key: "handleVideoInspectEvents",
      value: function handleVideoInspectEvents(e) {
        var _this326 = this;

        e.on(Rv.CONNECTION_STATE_CHANGE, function (t, i) {
          if (_this326.safeEmit(dg.CONTENT_INSPECT_CONNECTION_STATE_CHANGE, t, i), i === gv.CONNECTED) {
            if ("CONNECTED" !== _this326.connectionState) return void _this326.safeEmit(dg.CONTENT_INSPECT_ERROR, new VI(xT.OPERATION_ABORTED, "Content inspect was cancelled because it left the channel"));
            e.inspectImage();
          }
        }), e.on(Rv.INSPECT_RESULT, function (e, t) {
          var i;
          if ((null == t ? void 0 : t.code) === xT.INVALID_OPERATION && "DISCONNECTED" === _this326.connectionState) return YC.debug("Stop inspect content because that has left channel"), null == _this326 || null === (i = _this326._inspect) || void 0 === i || i.close(), void (_this326._inspect = void 0);

          _this326.safeEmit(dg.CONTENT_INSPECT_RESULT, e, t);
        }), e.on(Rv.CLIENT_LOCAL_VIDEO_TRACK, function (e) {
          e(_this326.localTracks.filter(function (e) {
            return "video" === e.trackMediaType;
          })[0]);
        });
      }
    }, {
      key: "getJoinChannelServiceRecords",
      value: function getJoinChannelServiceRecords() {
        return YC.debug("getJoinChannelServiceRecords"), this.store.joinChannelServiceRecords;
      }
    }, {
      key: "setPublishAudioFilterEnabled",
      value: function () {
        var _setPublishAudioFilterEnabled2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee453(e) {
          return _regeneratorRuntime.wrap(function _callee453$(_context453) {
            while (1) {
              switch (_context453.prev = _context453.next) {
                case 0:
                  FT(e, "enabled");
                  NC("ENABLE_PUBLISH_AUDIO_FILTER", e);
                  _context453.t0 = this._joinInfo;

                  if (!_context453.t0) {
                    _context453.next = 6;
                    break;
                  }

                  _context453.next = 6;
                  return this._gateway.setPublishAudioFilterEnabled(e);

                case 6:
                case "end":
                  return _context453.stop();
              }
            }
          }, _callee453, this);
        }));

        function setPublishAudioFilterEnabled(_x723) {
          return _setPublishAudioFilterEnabled2.apply(this, arguments);
        }

        return setPublishAudioFilterEnabled;
      }()
    }, {
      key: "_handleResetAddStream",
      value: function _handleResetAddStream(e, t) {
        switch (t) {
          case "audio":
            e._audio_added_ = !1, e._trust_audio_stream_added_state_ = !0;
            break;

          case "video":
            e._video_added_ = !1, e._trust_video_stream_added_state_ = !0;
        }
      }
    }]);

    return bU;
  }(ig);

  UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "leave", null), UI([sI({
    argsMap: function argsMap(e, t) {
      if (!Array.isArray(t)) {
        if (!(t instanceof _b)) return [t];
        t = [t];
      }

      return t.map(function (e) {
        return e ? Object(e).toString() : "null";
      });
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object, Boolean]), xI("design:returntype", tT)], bU.prototype, "publish", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return t || (t = []), t instanceof EP ? [t.getChannelId()] : (Array.isArray(t) || (t = [t]), t.map(function (e) {
        return e.getTrackId();
      }));
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "unpublish", null), UI([sI({
    argsMap: function argsMap(e, t, i, n) {
      return [t.uid, i, n];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [ik, String, Number]), xI("design:returntype", tT)], bU.prototype, "subscribe", null), UI([sI({
    argsMap: function argsMap(e, t, i) {
      return [t, i];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object, String]), xI("design:returntype", tT)], bU.prototype, "presubscribe", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return t.map(function (e) {
        var t = e.user,
            i = e.mediaType;
        return [null == t ? void 0 : t.uid, i];
      });
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], bU.prototype, "massSubscribe", null), UI([sI({
    argsMap: function argsMap(e, t, i, n) {
      return [t.uid, i, n];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [ik, String, Number]), xI("design:returntype", tT)], bU.prototype, "unsubscribe", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return t.map(function (e) {
        var t = e.user,
            i = e.mediaType;
        return {
          uid: null == t ? void 0 : t.uid,
          mediaType: i
        };
      });
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Array]), xI("design:returntype", tT)], bU.prototype, "massUnsubscribe", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "setLowStreamParameter", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "enableDualStream", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "disableDualStream", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String, Object]), xI("design:returntype", tT)], bU.prototype, "setClientRole", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String, Boolean]), xI("design:returntype", void 0)], bU.prototype, "setProxyServer", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object, Boolean]), xI("design:returntype", void 0)], bU.prototype, "setTurnServer", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", void 0)], bU.prototype, "setLicense", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", void 0)], bU.prototype, "startProxyServer", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], bU.prototype, "stopProxyServer", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", void 0)], bU.prototype, "setLocalAccessPointsV2", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Array, String]), xI("design:returntype", void 0)], bU.prototype, "setLocalAccessPoints", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Number]), xI("design:returntype", tT)], bU.prototype, "setRemoteDefaultVideoStreamType", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object, Number]), xI("design:returntype", tT)], bU.prototype, "setRemoteVideoStreamType", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object, Number]), xI("design:returntype", tT)], bU.prototype, "setStreamFallbackOption", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return [t];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [String, String, Uint8Array]), xI("design:returntype", void 0)], bU.prototype, "setEncryptionConfig", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], bU.prototype, "renewToken", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", void 0)], bU.prototype, "enableAudioVolumeIndicator", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String, Boolean]), xI("design:returntype", tT)], bU.prototype, "startLiveStreaming", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "setLiveTranscoding", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", tT)], bU.prototype, "stopLiveStreaming", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String, Object]), xI("design:returntype", tT)], bU.prototype, "addInjectStreamUrl", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "removeInjectStreamUrl", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Tk]), xI("design:returntype", tT)], bU.prototype, "startChannelMediaRelay", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Tk]), xI("design:returntype", tT)], bU.prototype, "updateChannelMediaRelay", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "stopChannelMediaRelay", null), UI([sI({
    argsMap: function argsMap(e, t) {
      return Array.isArray(t) || (t = [t]), [JSON.stringify(t)];
    }
  }), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "sendCustomReportMessage", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object, Object]), xI("design:returntype", tT)], bU.prototype, "pickSVCLayer", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "setRTMConfig", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Object]), xI("design:returntype", tT)], bU.prototype, "enableContentInspect", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", tT)], bU.prototype, "disableContentInspect", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Boolean, Object]), xI("design:returntype", tT)], bU.prototype, "setImageModeration", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [String]), xI("design:returntype", void 0)], bU.prototype, "setP2PTransport", null), UI([sI({
    reportResult: !0
  }), xI("design:type", Function), xI("design:paramtypes", []), xI("design:returntype", Array)], bU.prototype, "getJoinChannelServiceRecords", null), UI([sI(), xI("design:type", Function), xI("design:paramtypes", [Boolean]), xI("design:returntype", tT)], bU.prototype, "setPublishAudioFilterEnabled", null);

  var wU = /*#__PURE__*/function () {
    function wU(e, t) {
      _classCallCheck(this, wU);

      nh(this, "id", 0), nh(this, "element", void 0), nh(this, "peerPair", void 0), nh(this, "context", void 0), nh(this, "audioPlayerElement", void 0), nh(this, "audioTrack", void 0), wU.count += 1, this.id = wU.count, this.element = e, this.context = t;
    }

    _createClass(wU, [{
      key: "initPeers",
      value: function initPeers() {
        var _this327 = this;

        this.peerPair = [new RTCPeerConnection(), new RTCPeerConnection()], this.peerPair[1].ontrack = function (e) {
          var t = document.createElement("audio");
          t.srcObject = new MediaStream([e.track]), t.play(), _this327.audioPlayerElement = t;
        };
      }
    }, {
      key: "switchSdp",
      value: function () {
        var _switchSdp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee456() {
          var e, t, _i181, _n156;

          return _regeneratorRuntime.wrap(function _callee456$(_context456) {
            while (1) {
              switch (_context456.prev = _context456.next) {
                case 0:
                  if (this.peerPair) {
                    _context456.next = 2;
                    break;
                  }

                  return _context456.abrupt("return");

                case 2:
                  e = /*#__PURE__*/function () {
                    var _ref113 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee454(_e396, t) {
                      var i;
                      return _regeneratorRuntime.wrap(function _callee454$(_context454) {
                        while (1) {
                          switch (_context454.prev = _context454.next) {
                            case 0:
                              if (!("offer" === t)) {
                                _context454.next = 6;
                                break;
                              }

                              _context454.next = 3;
                              return _e396.createOffer();

                            case 3:
                              _context454.t0 = _context454.sent;
                              _context454.next = 9;
                              break;

                            case 6:
                              _context454.next = 8;
                              return _e396.createAnswer();

                            case 8:
                              _context454.t0 = _context454.sent;

                            case 9:
                              i = _context454.t0;
                              _context454.next = 12;
                              return _e396.setLocalDescription(i);

                            case 12:
                              return _context454.abrupt("return", "complete" === _e396.iceGatheringState ? _e396.localDescription : new tT(function (t) {
                                _e396.onicegatheringstatechange = function () {
                                  "complete" === _e396.iceGatheringState && t(_e396.localDescription);
                                };
                              }));

                            case 13:
                            case "end":
                              return _context454.stop();
                          }
                        }
                      }, _callee454);
                    }));

                    return function e(_x724, _x725) {
                      return _ref113.apply(this, arguments);
                    };
                  }(), t = /*#__PURE__*/function () {
                    var _ref114 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee455(e, t) {
                      return _regeneratorRuntime.wrap(function _callee455$(_context455) {
                        while (1) {
                          switch (_context455.prev = _context455.next) {
                            case 0:
                              _context455.next = 2;
                              return e.setRemoteDescription(t);

                            case 2:
                              return _context455.abrupt("return", _context455.sent);

                            case 3:
                            case "end":
                              return _context455.stop();
                          }
                        }
                      }, _callee455);
                    }));

                    return function (_x726, _x727) {
                      return _ref114.apply(this, arguments);
                    };
                  }();
                  _context456.prev = 3;
                  _context456.next = 6;
                  return e(this.peerPair[0], "offer");

                case 6:
                  _i181 = _context456.sent;
                  _context456.next = 9;
                  return t(this.peerPair[1], _i181);

                case 9:
                  _context456.next = 11;
                  return e(this.peerPair[1], "answer");

                case 11:
                  _n156 = _context456.sent;
                  _context456.next = 14;
                  return t(this.peerPair[0], _n156);

                case 14:
                  _context456.next = 19;
                  break;

                case 16:
                  _context456.prev = 16;
                  _context456.t0 = _context456["catch"](3);
                  throw new VI(xT.LOCAL_AEC_ERROR, _context456.t0.toString()).print();

                case 19:
                case "end":
                  return _context456.stop();
              }
            }
          }, _callee456, this, [[3, 16]]);
        }));

        function switchSdp() {
          return _switchSdp.apply(this, arguments);
        }

        return switchSdp;
      }()
    }, {
      key: "getTracksFromMediaElement",
      value: function () {
        var _getTracksFromMediaElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee457(e) {
          var t, i;
          return _regeneratorRuntime.wrap(function _callee457$(_context457) {
            while (1) {
              switch (_context457.prev = _context457.next) {
                case 0:
                  if (!this.audioTrack) {
                    _context457.next = 2;
                    break;
                  }

                  return _context457.abrupt("return", this.audioTrack);

                case 2:
                  _context457.prev = 2;
                  e instanceof HTMLVideoElement && (e.captureStream ? e.captureStream() : e.mozCaptureStream()), t = this.context.createMediaStreamDestination();
                  this.context.createMediaElementSource(e).connect(t);
                  _context457.next = 10;
                  break;

                case 7:
                  _context457.prev = 7;
                  _context457.t0 = _context457["catch"](2);
                  throw new VI(xT.LOCAL_AEC_ERROR, _context457.t0.toString()).print();

                case 10:
                  if (t) {
                    _context457.next = 12;
                    break;
                  }

                  throw new VI(xT.LOCAL_AEC_ERROR, "no dest node when local aec").print();

                case 12:
                  i = t.stream.getAudioTracks()[0];
                  return _context457.abrupt("return", (this.audioTrack = i, i));

                case 14:
                case "end":
                  return _context457.stop();
              }
            }
          }, _callee457, this, [[2, 7]]);
        }));

        function getTracksFromMediaElement(_x730) {
          return _getTracksFromMediaElement.apply(this, arguments);
        }

        return getTracksFromMediaElement;
      }()
    }, {
      key: "getElement",
      value: function getElement() {
        return this.element;
      }
    }, {
      key: "startEchoCancellation",
      value: function () {
        var _startEchoCancellation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee458() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee458$(_context458) {
            while (1) {
              switch (_context458.prev = _context458.next) {
                case 0:
                  this.context.resume(), this.peerPair && this.close(), this.initPeers();
                  e = this.element;
                  _context458.next = 4;
                  return this.getTracksFromMediaElement(e);

                case 4:
                  t = _context458.sent;
                  this.peerPair && this.peerPair[0].addTrack(t);
                  _context458.next = 8;
                  return this.switchSdp();

                case 8:
                case "end":
                  return _context458.stop();
              }
            }
          }, _callee458, this);
        }));

        function startEchoCancellation() {
          return _startEchoCancellation.apply(this, arguments);
        }

        return startEchoCancellation;
      }()
    }, {
      key: "close",
      value: function close() {
        YC.debug("close echo cancellation unit, id is", this.id), this.audioPlayerElement && this.audioPlayerElement.pause(), this.peerPair && this.peerPair.forEach(function (e) {
          e.close();
        }), this.peerPair = void 0, this.audioPlayerElement = void 0;
      }
    }]);

    return wU;
  }();

  nh(wU, "count", 0);
  var OU = window.AudioContext || window.webkitAudioContext;

  var NU = /*#__PURE__*/function () {
    function NU() {
      _classCallCheck(this, NU);

      nh(this, "units", []), nh(this, "context", void 0);
    }

    _createClass(NU, [{
      key: "processExternalMediaAEC",
      value: function processExternalMediaAEC(e) {
        if (!this._doesEnvironmentNeedAEC()) return YC.debug("the system does not need to process local aec"), -1;
        this.context || (this.context = new OU());
        var t = this.units.find(function (t) {
          return t && t.getElement() === e;
        });
        return t || (t = new wU(e, this.context), this.units.push(t)), t.startEchoCancellation(), YC.debug("start processing local audio echo cancellation, id is", t.id), t.id;
      }
    }, {
      key: "_doesEnvironmentNeedAEC",
      value: function _doesEnvironmentNeedAEC() {
        return pT().name !== cT.SAFARI;
      }
    }]);

    return NU;
  }();

  UI([sI({
    report: rI
  }), xI("design:type", Function), xI("design:paramtypes", [HTMLAudioElement]), xI("design:returntype", Number)], NU.prototype, "processExternalMediaAEC", null);
  var DU = new NU();

  function PU(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function LU(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2 ? PU(Object(i), !0).forEach(function (t) {
        nh(e, t, i[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : PU(Object(i)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
      });
    }

    return e;
  }

  var kU = window || document;

  function MU(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    if (!kU) return;
    var i = xU._cspEventHandlerPointer;
    if (i && t) return void console.error(i, t);

    var n = function n(e) {
      if (!(e && e.blockedURI && (xU.onSecurityPolicyViolation || xU.getListeners(vv.SECURITY_POLICY_VIOLATION).length > 0))) return;
      var t = e.blockedURI;
      DC("CSP_DETECTED_HOSTNAME_LIST").some(function (e) {
        return bn(t).call(t, e);
      }) && (xU.onSecurityPolicyViolation && "function" == typeof xU.onSecurityPolicyViolation && xU.onSecurityPolicyViolation(e), xU.getListeners(vv.SECURITY_POLICY_VIOLATION).length > 0 && xU.safeEmit(vv.SECURITY_POLICY_VIOLATION, e));
    };

    i && kU.removeEventListener("securitypolicyviolation", i), (t || e && "function" == typeof e || xU.getListeners(vv.SECURITY_POLICY_VIOLATION).length > 0) && kU.addEventListener("securitypolicyviolation", n), xU._cspEventHandlerPointer = n;
  }

  NC("PROCESS_ID", "process-".concat(xg(8, ""), "-").concat(xg(4, ""), "-").concat(xg(4, ""), "-").concat(xg(4, ""), "-").concat(xg(12, ""))), function () {
    var e;

    try {
      e = window.localStorage.getItem("websdk_ng_global_parameter");
    } catch (e) {
      return void YC.error("Error loading sdk config", e.message);
    }

    if (e) try {
      var _t341 = JSON.parse(window.atob(e)),
          _i182 = Date.now();

      YC.debug("Loading global parameters from cache", _t341), Object.keys(_t341).forEach(function (e) {
        if (Object.prototype.hasOwnProperty.call(OC, e)) {
          var _t341$e = _t341[e],
              _n157 = _t341$e.value,
              _s108 = _t341$e.expires;
          if (_s108 && _s108 <= _i182) return;
          PC[e] = _n157, OC[e] = _n157;
        }
      });
    } catch (t) {
      YC.error("Error loading mutableParamsCache: ".concat(e), t.message);
    }
  }(), Array.isArray(PC.AREAS) && PC.AREAS.length > 0 && eA(PC.AREAS, !0);

  var UU = function UU(e, t, i) {
    YC.debug("setParameter key:".concat(e, ", value:").concat(JSON.stringify(t))), NC(e, t, i);
  },
      xU = function (e) {
    var t = new ig(),
        i = e,
        n = {
      getListeners: t.getListeners.bind(t),
      on: function on(e, i) {
        return function (e, t) {
          e === vv.SECURITY_POLICY_VIOLATION && MU(t, !0);
        }(e, i), t.on.bind(t)(e, i);
      },
      addListener: t.addListener.bind(t),
      once: t.once.bind(t),
      off: t.off.bind(t),
      removeAllListeners: t.removeAllListeners.bind(t),
      emit: t.emit.bind(t),
      safeEmit: t.safeEmit.bind(t)
    };
    return LU(LU({}, i), n);
  }({
    __TRACK_LIST__: WA,
    VERSION: yC,
    BUILD: wC,
    ESM_BUNDLER: !1,
    ESM: !1,
    UMD: !0,
    DEV: !1,
    setParameter: UU,
    getParameter: DC,
    getSupportedCodec: function () {
      var _getSupportedCodec = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee459() {
        var e, _t342, _i183;

        return _regeneratorRuntime.wrap(function _callee459$(_context459) {
          while (1) {
            switch (_context459.prev = _context459.next) {
              case 0:
                e = {
                  audio: [],
                  video: []
                };
                _context459.prev = 1;
                _t342 = new RTCPeerConnection();
                _t342.addTransceiver("video", {
                  direction: "recvonly"
                }), _t342.addTransceiver("audio", {
                  direction: "recvonly"
                });
                _context459.next = 6;
                return _t342.createOffer();

              case 6:
                _i183 = _context459.sent.sdp;

                if (_i183) {
                  _context459.next = 9;
                  break;
                }

                return _context459.abrupt("return", e);

              case 9:
                _t342.close(), _t342 = null, e = function (e) {
                  var t = {
                    video: [],
                    audio: []
                  };
                  return e.match(/ VP8/i) && t.video.push("VP8"), e.match(/ VP9/i) && t.video.push("VP9"), e.match(/ AV1/i) && t.video.push("AV1"), e.match(/ H264/i) && t.video.push("H264"), e.match(/ H265/i) && t.video.push("H265"), e.match(/ opus/i) && t.audio.push("OPUS"), e.match(/ PCMU/i) && t.audio.push("PCMU"), e.match(/ PCMA/i) && t.audio.push("PCMA"), e.match(/ G722/i) && t.audio.push("G722"), t;
                }(_i183);
                _context459.next = 15;
                break;

              case 12:
                _context459.prev = 12;
                _context459.t0 = _context459["catch"](1);
                throw new VI(xT.CREATE_OFFER_FAILED, _context459.t0.toString && _context459.t0.toString()).print();

              case 15:
                return _context459.abrupt("return", e);

              case 16:
              case "end":
                return _context459.stop();
            }
          }
        }, _callee459, null, [[1, 12]]);
      }));

      function getSupportedCodec() {
        return _getSupportedCodec.apply(this, arguments);
      }

      return getSupportedCodec;
    }(),
    checkSystemRequirements: function checkSystemRequirements() {
      var e = rI.reportApiInvoke(null, {
        name: rg.CHECK_SYSTEM_REQUIREMENTS,
        options: [],
        tag: og.TRACER
      });
      var t = !1;

      try {
        var _e397 = window.RTCPeerConnection,
            _i184 = navigator.mediaDevices && navigator.mediaDevices.getUserMedia,
            _n158 = window.WebSocket;

        t = !!(_e397 && _i184 && _n158);
      } catch (e) {
        return YC.error("check system requirement failed: ", e), !1;
      }

      var i = !1;
      var n = pT();
      n.name === cT.CHROME && Number(n.version) >= 58 && (!TT() || fT()) && (i = !0), n.name === cT.FIREFOX && Number(n.version) >= 56 && (i = !0), n.name === cT.OPERA && Number(n.version) >= 45 && (i = !0), n.name === cT.SAFARI && Number(n.version) >= 11 && (i = !0), (PT() || pT().name === cT.QQ) && (i = !0), YC.debug("checkSystemRequirements, api:", t, "browser", i);
      var s = t && i;
      return e.onSuccess(s), s;
    },
    getDevices: function getDevices(e) {
      return Fb.enumerateDevices(!0, !0, e);
    },
    getMicrophones: function getMicrophones(e) {
      return Fb.getRecordingDevices(e);
    },
    getCameras: function getCameras(e) {
      return Fb.getCamerasDevices(e);
    },
    getElectronScreenSources: Nb,
    getPlaybackDevices: function getPlaybackDevices(e) {
      return Fb.getSpeakers(e);
    },
    createClient: function createClient() {
      var e;
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        codec: "vp8",
        audioCodec: "opus",
        mode: "rtc"
      };
      var i = rI.reportApiInvoke(null, {
        name: rg.CREATE_CLIENT,
        options: [t],
        tag: og.TRACER
      });

      try {
        !function (e) {
          BT(e.codec, "config.codec", ["vp8", "vp9", "av1", "h264", "h265"]), BT(e.mode, "config.mode", ["rtc", "live", "p2p"]), void 0 !== e.audioCodec && BT(e.audioCodec, "config.audioCodec", ["opus", "pcmu", "pcma", "g722"]), void 0 !== e.proxyServer && WT(e.proxyServer, "config.proxyServer", 1, 1e4), void 0 !== e.turnServer && Eg(e.turnServer), void 0 !== e.httpRetryConfig && pg(e.httpRetryConfig), void 0 !== e.websocketRetryConfig && pg(e.websocketRetryConfig);
        }(t);
      } catch (e) {
        throw i.onError(e), e;
      }

      return vU() || ("vp9" === t.codec && (t.codec = "vp8", YC.debug("browser not support vp9, force use vp8")), NC("UNSUPPORTED_VIDEO_CODEC", ["vp9"])), void 0 === t.audioCodec && (t.audioCodec = "opus"), i.onSuccess(), new bU(AU(AU({
        forceWaitGatewayResponse: !0
      }, t), {}, {
        role: bn(e = ["rtc", "p2p"]).call(e, t.mode) ? "host" : t.role || "audience"
      }));
    },
    createCameraVideoTrack: function () {
      var _createCameraVideoTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee460() {
        var e,
            t,
            i,
            n,
            s,
            r,
            _e398,
            o,
            _args460 = arguments;

        return _regeneratorRuntime.wrap(function _callee460$(_context460) {
          while (1) {
            switch (_context460.prev = _context460.next) {
              case 0:
                e = _args460.length > 0 && void 0 !== _args460[0] ? _args460[0] : {};
                t = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CREATE_CAM_VIDEO_TRACK,
                  options: [Lw({}, e)]
                }), i = hw(e), n = xg(8, "track-cam-");
                s = null;
                r = "720p_auto" === e.encoderConfig;
                YC.info("start create camera video track with config", JSON.stringify(e), "trackId", n);
                _context460.prev = 5;
                _context460.next = 8;
                return Mb({
                  video: i
                }, n);

              case 8:
                _context460.t0 = _context460.sent.getVideoTracks()[0];

                if (_context460.t0) {
                  _context460.next = 11;
                  break;
                }

                _context460.t0 = null;

              case 11:
                s = _context460.t0;
                _context460.next = 17;
                break;

              case 14:
                _context460.prev = 14;
                _context460.t1 = _context460["catch"](5);
                throw t.onError(_context460.t1), _context460.t1;

              case 17:
                if (s) {
                  _context460.next = 20;
                  break;
                }

                _e398 = new VT(xT.UNEXPECTED_ERROR, "can not find track in media stream");
                return _context460.abrupt("return", (t.onError(_e398), _e398.throw(YC)));

              case 20:
                e.optimizationMode && kw(n, s, e, VA(e.encoderConfig));
                o = new Dw(s, e, i, e.scalabiltyMode ? BA(e.scalabiltyMode) : {
                  numSpatialLayers: 1,
                  numTemporalLayers: 1
                }, e.optimizationMode, n);
                return _context460.abrupt("return", (r && o.startMonitorStats(), t.onSuccess(o.getTrackId()), YC.info("create camera video success, trackId:", n), o));

              case 23:
              case "end":
                return _context460.stop();
            }
          }
        }, _callee460, null, [[5, 14]]);
      }));

      function createCameraVideoTrack() {
        return _createCameraVideoTrack.apply(this, arguments);
      }

      return createCameraVideoTrack;
    }(),
    createCustomVideoTrack: function createCustomVideoTrack(e) {
      var t = rI.reportApiInvoke(null, {
        tag: og.TRACER,
        name: rg.CREATE_CUSTOM_VIDEO_TRACK,
        options: [e]
      }),
          i = new Nw(e.mediaStreamTrack, {
        width: e.width,
        height: e.height,
        frameRate: e.frameRate,
        bitrateMax: e.bitrateMax,
        bitrateMin: e.bitrateMin
      }, e.scalabiltyMode ? BA(e.scalabiltyMode) : {
        numSpatialLayers: 1,
        numTemporalLayers: 1
      }, e.optimizationMode, xg(8, "track-cus-"), [YA.CUSTOM_TRACK]);
      return t.onSuccess(i.getTrackId()), YC.info("create custom video track success with config", e, "trackId", i.getTrackId()), i;
    },
    createScreenVideoTrack: function () {
      var _createScreenVideoTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee461() {
        var e,
            t,
            i,
            n,
            s,
            r,
            o,
            a,
            c,
            _e399,
            _e400,
            _e401,
            _e402,
            d,
            l,
            _args461 = arguments;

        return _regeneratorRuntime.wrap(function _callee461$(_context461) {
          while (1) {
            switch (_context461.prev = _context461.next) {
              case 0:
                e = _args461.length > 0 && void 0 !== _args461[0] ? _args461[0] : {}, t = _args461.length > 1 && void 0 !== _args461[1] ? _args461[1] : "disable";
                i = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CREATE_SCREEN_VIDEO_TRACK,
                  options: [Lw({}, e), t]
                }), n = "720p_auto" === e.encoderConfig;
                e.encoderConfig ? "string" == typeof e.encoderConfig || e.encoderConfig.width && e.encoderConfig.height || (e.encoderConfig.width = {
                  max: 1920
                }, e.encoderConfig.height = {
                  max: 1080
                }) : e.encoderConfig = "1080p_2";
                s = function (e) {
                  var t = {};
                  e.screenSourceType && (t.mediaSource = e.screenSourceType), e.extensionId && gT() && (t.extensionId = e.extensionId);
                  var i = e.displaySurface,
                      n = e.selfBrowserSurface,
                      s = e.surfaceSwitching,
                      r = e.systemAudio;
                  (IT(107) || vT(107) || yT(93)) && (i && (BT(i, "displaySurface", ["browser", "window", "monitor"]), t.displaySurface = i), n ? (BT(n, "selfBrowserSurface", ["exclude", "include"]), t.selfBrowserSurface = n) : t.selfBrowserSurface = "include", s && (BT(s, "surfaceSwitching", ["exclude", "include"]), t.surfaceSwitching = s)), (IT(105) || vT(105) || yT(91)) && r && (BT(r, "systemAudio", ["exclude", "include"]), t.systemAudio = r), e.electronScreenSourceId && (t.sourceId = e.electronScreenSourceId);
                  var o = e.encoderConfig ? FA(e.encoderConfig) : null;
                  return t.mandatory = {
                    chromeMediaSource: "desktop",
                    maxWidth: o ? o.width : void 0,
                    maxHeight: o ? o.height : void 0
                  }, o && (o.frameRate && ("number" == typeof o.frameRate ? (t.mandatory.maxFrameRate = o.frameRate, t.mandatory.minFrameRate = o.frameRate) : (t.mandatory.maxFrameRate = o.frameRate.max || o.frameRate.ideal || o.frameRate.exact || void 0, t.mandatory.minFrameRate = o.frameRate.min || o.frameRate.ideal || o.frameRate.exact || void 0), t.frameRate = o.frameRate), o.width && (t.width = o.width), o.height && (t.height = o.height)), t;
                }(e), r = xg(8, "track-scr-v-");
                o = null, a = null;
                c = wA();

                if (!(!c.supportShareAudio && "enable" === t)) {
                  _context461.next = 9;
                  break;
                }

                _e399 = new VT(xT.NOT_SUPPORTED, "your browser or platform is not support share-screen with audio");
                return _context461.abrupt("return", (i.onError(_e399), _e399.throw(YC)));

              case 9:
                YC.info("start create screen video track with config", e, "withAudio", t, "trackId", r);
                _context461.prev = 10;
                _context461.next = 13;
                return Mb({
                  screen: s,
                  screenAudio: "auto" === t ? c.supportShareAudio : "enable" === t
                }, r);

              case 13:
                _e400 = _context461.sent;
                o = _e400.getVideoTracks()[0] || null, a = _e400.getAudioTracks()[0] || null;
                _context461.next = 20;
                break;

              case 17:
                _context461.prev = 17;
                _context461.t0 = _context461["catch"](10);
                throw i.onError(_context461.t0), _context461.t0;

              case 20:
                if (o) {
                  _context461.next = 23;
                  break;
                }

                _e401 = new VT(xT.UNEXPECTED_ERROR, "can not find track in media stream");
                return _context461.abrupt("return", (i.onError(_e401), _e401.throw(YC)));

              case 23:
                if (!(!a && "enable" === t)) {
                  _context461.next = 27;
                  break;
                }

                o && o.stop();
                _e402 = new VT(xT.SHARE_AUDIO_NOT_ALLOWED);
                return _context461.abrupt("return", (i.onError(_e402), _e402.throw(YC)));

              case 27:
                if (e.optimizationMode || (e.optimizationMode = "detail"), e.optimizationMode) {
                  kw(r, o, e, e.encoderConfig && FA(e.encoderConfig) || void 0), e.encoderConfig && "string" != typeof e.encoderConfig && (e.encoderConfig.bitrateMin = e.encoderConfig.bitrateMax);
                }

                d = new Nw(o, e.encoderConfig ? FA(e.encoderConfig) : {}, e.scalabiltyMode ? BA(e.scalabiltyMode) : {
                  numSpatialLayers: 1,
                  numTemporalLayers: 1
                }, e.optimizationMode, r, [YA.SCREEN_TRACK]);

                if (!(n && d.startMonitorStats(), !a)) {
                  _context461.next = 31;
                  break;
                }

                return _context461.abrupt("return", (i.onSuccess(d.getTrackId()), YC.info("create screen video track success", "video:", d.getTrackId()), d));

              case 31:
                l = new cw(a, void 0, xg(8, "track-scr-a-"), !1, !0);
                return _context461.abrupt("return", (i.onSuccess([d.getTrackId(), l.getTrackId()]), YC.info("create screen video track success", "video:", d.getTrackId(), "audio:", l.getTrackId()), [d, l]));

              case 33:
              case "end":
                return _context461.stop();
            }
          }
        }, _callee461, null, [[10, 17]]);
      }));

      function createScreenVideoTrack() {
        return _createScreenVideoTrack.apply(this, arguments);
      }

      return createScreenVideoTrack;
    }(),
    createMicrophoneAndCameraTracks: function () {
      var _createMicrophoneAndCameraTracks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee462() {
        var e,
            t,
            i,
            n,
            s,
            r,
            o,
            a,
            c,
            d,
            _e403,
            _e404,
            l,
            u,
            _args462 = arguments;

        return _regeneratorRuntime.wrap(function _callee462$(_context462) {
          while (1) {
            switch (_context462.prev = _context462.next) {
              case 0:
                e = _args462.length > 0 && void 0 !== _args462[0] ? _args462[0] : {}, t = _args462.length > 1 && void 0 !== _args462[1] ? _args462[1] : {};
                i = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CREATE_MIC_AND_CAM_TRACKS,
                  options: [e, t]
                }), n = "720p_auto" === t.encoderConfig, s = hw(t), r = pw(e), o = xg(8, "track-mic-"), a = xg(8, "track-cam-");
                c = null, d = null;
                YC.info("start create camera video track(".concat(a, ") and microphone audio track(").concat(o, ") with config, audio: ").concat(JSON.stringify(e), ", video: ").concat(JSON.stringify(t)));
                _context462.prev = 4;
                _context462.next = 7;
                return Mb({
                  audio: r,
                  video: s
                }, "".concat(o, "-").concat(a));

              case 7:
                _e403 = _context462.sent;
                c = _e403.getAudioTracks()[0], d = _e403.getVideoTracks()[0];
                _context462.next = 14;
                break;

              case 11:
                _context462.prev = 11;
                _context462.t0 = _context462["catch"](4);
                throw i.onError(_context462.t0), _context462.t0;

              case 14:
                if (!(!c || !d)) {
                  _context462.next = 17;
                  break;
                }

                _e404 = new VT(xT.UNEXPECTED_ERROR, "can not find tracks in media stream");
                return _context462.abrupt("return", (i.onError(_e404), _e404.throw(YC)));

              case 17:
                t.optimizationMode && kw(a, d, t, VA(t.encoderConfig));
                l = new dw(c, e, r, o), u = new Dw(d, t, s, t.scalabiltyMode ? BA(t.scalabiltyMode) : {
                  numSpatialLayers: 1,
                  numTemporalLayers: 1
                }, t.optimizationMode, a);
                return _context462.abrupt("return", (n && u.startMonitorStats(), i.onSuccess([l.getTrackId(), u.getTrackId()]), YC.info("create camera video track(".concat(a, ") and microphone audio track(").concat(o, ") success")), [l, u]));

              case 20:
              case "end":
                return _context462.stop();
            }
          }
        }, _callee462, null, [[4, 11]]);
      }));

      function createMicrophoneAndCameraTracks() {
        return _createMicrophoneAndCameraTracks.apply(this, arguments);
      }

      return createMicrophoneAndCameraTracks;
    }(),
    createMicrophoneAudioTrack: function () {
      var _createMicrophoneAudioTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee463() {
        var e,
            t,
            i,
            n,
            s,
            _e405,
            r,
            _args463 = arguments;

        return _regeneratorRuntime.wrap(function _callee463$(_context463) {
          while (1) {
            switch (_context463.prev = _context463.next) {
              case 0:
                e = _args463.length > 0 && void 0 !== _args463[0] ? _args463[0] : {};
                t = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CREATE_MIC_AUDIO_TRACK,
                  options: [e]
                }), i = pw(e), n = xg(8, "track-mic-");
                s = null;
                YC.info("start create microphone audio track with config", JSON.stringify(e), "trackId", n);
                _context463.prev = 4;
                _context463.next = 7;
                return Mb({
                  audio: i
                }, n);

              case 7:
                _context463.t0 = _context463.sent.getAudioTracks()[0];

                if (_context463.t0) {
                  _context463.next = 10;
                  break;
                }

                _context463.t0 = null;

              case 10:
                s = _context463.t0;
                _context463.next = 16;
                break;

              case 13:
                _context463.prev = 13;
                _context463.t1 = _context463["catch"](4);
                throw t.onError(_context463.t1), _context463.t1;

              case 16:
                if (s) {
                  _context463.next = 19;
                  break;
                }

                _e405 = new VT(xT.UNEXPECTED_ERROR, "can not find track in media stream");
                return _context463.abrupt("return", (t.onError(_e405), _e405.throw(YC)));

              case 19:
                r = new dw(s, e, i, n);
                return _context463.abrupt("return", (t.onSuccess(r.getTrackId()), YC.info("create microphone audio track success, trackId:", n), r));

              case 21:
              case "end":
                return _context463.stop();
            }
          }
        }, _callee463, null, [[4, 13]]);
      }));

      function createMicrophoneAudioTrack() {
        return _createMicrophoneAudioTrack.apply(this, arguments);
      }

      return createMicrophoneAudioTrack;
    }(),
    createCustomAudioTrack: function createCustomAudioTrack(e) {
      var t = rI.reportApiInvoke(null, {
        tag: og.TRACER,
        name: rg.CREATE_CUSTOM_AUDIO_TRACK,
        options: [e]
      }),
          i = new cw(e.mediaStreamTrack, e.encoderConfig ? GA(e.encoderConfig) : {}, xg(8, "track-cus-"), !1, !0);
      return YC.info("create custom audio track success with config", e, "trackId", i.getTrackId()), t.onSuccess(i.getTrackId()), i;
    },
    createBufferSourceAudioTrack: function () {
      var _createBufferSourceAudioTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee464(e) {
        var t, i, n, s, r, o, a, c, d, l;
        return _regeneratorRuntime.wrap(function _callee464$(_context464) {
          while (1) {
            switch (_context464.prev = _context464.next) {
              case 0:
                i = e.cacheOnlineFile, n = e.encoderConfig;
                s = e.source;
                r = {
                  source: s instanceof AudioBuffer ? "AudioBuffer" : s instanceof File ? null !== (t = File.name) && void 0 !== t ? t : "File" : s,
                  cacheOnlineFile: i,
                  encoderConfig: n
                }, o = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CREATE_BUFFER_AUDIO_TRACK,
                  options: [r]
                });

                if (!DC("DISABLE_WEBAUDIO")) {
                  _context464.next = 5;
                  break;
                }

                throw new VT(xT.NOT_SUPPORTED, "can not create BufferSourceAudioTrack when WebAudio disabled");

              case 5:
                a = xg(8, "track-buf-");
                YC.info("start create buffer source audio track with config", JSON.stringify(r), "trackId", a);
                c = s;

                if (s instanceof AudioBuffer) {
                  _context464.next = 18;
                  break;
                }

                _context464.prev = 9;
                _context464.next = 12;
                return mw(s, i);

              case 12:
                s = _context464.sent;
                _context464.next = 18;
                break;

              case 15:
                _context464.prev = 15;
                _context464.t0 = _context464["catch"](9);
                return _context464.abrupt("return", (o.onError(_context464.t0), _context464.t0.throw(YC)));

              case 18:
                d = new _w(s), l = new lw(c, d, n ? GA(n) : {}, a);
                return _context464.abrupt("return", (YC.info("create buffer source audio track success, trackId:", a), o.onSuccess(l.getTrackId()), l));

              case 20:
              case "end":
                return _context464.stop();
            }
          }
        }, _callee464, null, [[9, 15]]);
      }));

      function createBufferSourceAudioTrack(_x731) {
        return _createBufferSourceAudioTrack.apply(this, arguments);
      }

      return createBufferSourceAudioTrack;
    }(),
    setAppType: function setAppType(e) {
      if (YC.debug("setAppType: ".concat(e)), !(Number.isInteger(e) && e >= 0)) throw YC.debug("Invalid appType"), new VI(xT.INVALID_PARAMS, "invalid app type", e);
      NC("APP_TYPE", Math.floor(e));
    },
    setLogLevel: function setLogLevel(e) {
      YC.setLogLevel(e);
    },
    enableLogUpload: function enableLogUpload() {
      DC("USE_NEW_LOG") ? NC("UPLOAD_LOG", !0) : YC.enableLogUpload();
    },
    disableLogUpload: function disableLogUpload() {
      DC("USE_NEW_LOG") ? NC("UPLOAD_LOG", !1) : YC.disableLogUpload();
    },
    createChannelMediaRelayConfiguration: function createChannelMediaRelayConfiguration() {
      return new Tk();
    },
    checkAudioTrackIsActive: function () {
      var _checkAudioTrackIsActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee465(e) {
        var t,
            i,
            _e406,
            n,
            s,
            r,
            o,
            a,
            _args465 = arguments;

        return _regeneratorRuntime.wrap(function _callee465$(_context465) {
          while (1) {
            switch (_context465.prev = _context465.next) {
              case 0:
                t = _args465.length > 1 && void 0 !== _args465[1] ? _args465[1] : 5e3;
                i = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CHECK_AUDIO_TRACK_IS_ACTIVE,
                  options: [t]
                });

                if (e instanceof cw || e instanceof Fw) {
                  _context465.next = 5;
                  break;
                }

                _e406 = new VI(xT.INVALID_TRACK, "the parameter is not a audio track");
                return _context465.abrupt("return", (i.onError(_e406), _e406.throw()));

              case 5:
                t && t < 1e3 && (t = 1e3);
                n = e instanceof cw ? e.getTrackLabel() : "remote_track", s = e.getVolumeLevel();
                r = s, o = s;
                a = Date.now();
                return _context465.abrupt("return", new tT(function (s) {
                  var c = setInterval(function () {
                    var d = e.getVolumeLevel();
                    r = d > r ? d : r, o = d < o ? d : o;
                    var l = r - o > 1e-4,
                        u = Date.now() - a;

                    if (l || u > t) {
                      clearInterval(c);
                      var _t343 = l,
                          _o56 = {
                        duration: u,
                        deviceLabel: n,
                        maxVolumeLevel: r,
                        result: _t343
                      };
                      YC.info("[track-".concat(e.getTrackId(), "] check audio track active completed. ").concat(JSON.stringify(_o56))), i.onSuccess(_o56), s(_t343);
                    }
                  }, 200);
                }));

              case 10:
              case "end":
                return _context465.stop();
            }
          }
        }, _callee465);
      }));

      function checkAudioTrackIsActive(_x732) {
        return _checkAudioTrackIsActive.apply(this, arguments);
      }

      return checkAudioTrackIsActive;
    }(),
    checkVideoTrackIsActive: function () {
      var _checkVideoTrackIsActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee466(e) {
        var t,
            i,
            _e407,
            n,
            s,
            r,
            o,
            a,
            c,
            _e408,
            d,
            l,
            _args466 = arguments;

        return _regeneratorRuntime.wrap(function _callee466$(_context466) {
          while (1) {
            switch (_context466.prev = _context466.next) {
              case 0:
                t = _args466.length > 1 && void 0 !== _args466[1] ? _args466[1] : 5e3;
                i = rI.reportApiInvoke(null, {
                  tag: og.TRACER,
                  name: rg.CHECK_VIDEO_TRACK_IS_ACTIVE,
                  options: [t]
                });

                if (e instanceof Nw || e instanceof Vw) {
                  _context466.next = 5;
                  break;
                }

                _e407 = new VI(xT.INVALID_TRACK, "the parameter is not a video track");
                return _context466.abrupt("return", (i.onError(_e407), _e407.throw()));

              case 5:
                t && t < 1e3 && (t = 1e3);
                n = e instanceof Nw ? e.getTrackLabel() : "remote_track", s = e.getMediaStreamTrack(!0), r = document.createElement("video");
                r.style.width = "1px", r.style.height = "1px", r.setAttribute("muted", ""), r.muted = !0, r.setAttribute("playsinline", ""), r.controls = !1, (ST() || mT()) && (r.style.opacity = "0.01", r.style.position = "fixed", r.style.left = "0", r.style.top = "0", document.body.appendChild(r)), r.srcObject = new MediaStream([s]), r.play();
                o = document.createElement("canvas");
                o.width = 160, o.height = 120;
                a = 0, c = 0;
                _context466.prev = 11;
                _e408 = Date.now();
                _context466.next = 15;
                return function (e, t, i, n) {
                  var s,
                      r = 0,
                      o = null;
                  return new tT(function (a, c) {
                    function d() {
                      r > n && s && (s(), a(r));
                      var t = i.getContext("2d");

                      if (!t) {
                        var _e409 = new VI(xT.UNEXPECTED_ERROR, "can not get canvas 2d context.");

                        return YC.error(_e409.toString()), void c(_e409);
                      }

                      t.drawImage(e, 0, 0, 160, 120);
                      var d = t.getImageData(0, 0, i.width, i.height),
                          l = Math.floor(d.data.length / 3);

                      if (o) {
                        for (var _e410 = 0; _e410 < l; _e410 += 3) {
                          if (d.data[_e410] !== o[_e410]) return r += 1, void (o = d.data);
                        }

                        o = d.data;
                      } else o = d.data;
                    }

                    setTimeout(function () {
                      s && (s(), a(r));
                    }, t), s = vb(function () {
                      d();
                    }, 30);
                  });
                }(r, t, o, 4);

              case 15:
                a = _context466.sent;
                c = Date.now() - _e408;
                _context466.next = 22;
                break;

              case 19:
                _context466.prev = 19;
                _context466.t0 = _context466["catch"](11);
                throw i.onError(_context466.t0), _context466.t0;

              case 22:
                IU === cT.SAFARI && (r.pause(), r.remove()), r.srcObject = null;
                d = a > 4, l = {
                  duration: c,
                  changedPicNum: a,
                  deviceLabel: n,
                  result: d
                };
                return _context466.abrupt("return", (YC.info("[track-".concat(e.getTrackId(), "] check video track active completed. ").concat(JSON.stringify(l))), i.onSuccess(l), d));

              case 25:
              case "end":
                return _context466.stop();
            }
          }
        }, _callee466, null, [[11, 19]]);
      }));

      function checkVideoTrackIsActive(_x733) {
        return _checkVideoTrackIsActive.apply(this, arguments);
      }

      return checkVideoTrackIsActive;
    }(),
    setArea: eA,
    audioElementPlayCenter: qb,
    resumeAudioContext: function resumeAudioContext() {
      qb.autoResumeAfterInterruption(!0);
    },
    processExternalMediaAEC: function processExternalMediaAEC(e) {
      DU.processExternalMediaAEC(e);
    },
    registerExtensions: function registerExtensions(e) {
      var t = DC("PLUGIN_INFO") || [];
      e.forEach(function (e) {
        "name" in e && !bn(t).call(t, e.name) && t.push(e.name);
        var i = e;
        i.__registered__ = !0, i.logger.hookLog = YC.extLog, i.reporter.hookApiInvoke = rI.extApiInvoke, i.parameters && Object.keys(i.parameters).forEach(function (e) {
          i.parameters[e] = DC(e);
        });
      }), UU("PLUGIN_INFO", t);
    },
    ChannelMediaRelayError: $I,
    ChannelMediaRelayEvent: QI,
    ChannelMediaRelayState: ZI,
    RemoteStreamFallbackType: zA,
    RemoteStreamType: JA,
    ConnectionDisconnectedReason: cg,
    AudienceLatencyLevelType: ag,
    AREAS: rv
  });

  return Object.defineProperties(xU, {
    onAudioAutoplayFailed: {
      get: function get() {
        return jb.onAudioAutoplayFailed;
      },
      set: function set(e) {
        jb.onAudioAutoplayFailed = e;
      }
    },
    onAutoplayFailed: {
      get: function get() {
        return jb.onAutoplayFailed;
      },
      set: function set(e) {
        jb.onAutoplayFailed = e;
      }
    },
    _onSecurityPolicyViolation: {
      value: void 0,
      writable: !0
    },
    _cspEventHandlerPointer: {
      value: void 0,
      writable: !0
    },
    onSecurityPolicyViolation: {
      get: function get() {
        return xU._onSecurityPolicyViolation;
      },
      set: function set(e) {
        xU._onSecurityPolicyViolation = e, MU(e);
      }
    },
    __CLIENT_LIST__: {
      get: function get() {
        return DC("SHOW_GLOBAL_CLIENT_LIST") ? dI : [];
      }
    }
  }), Fb.on(db.CAMERA_DEVICE_CHANGED, function (e) {
    YC.info("camera device changed", JSON.stringify(e)), xU.onCameraChanged && xU.onCameraChanged(e), xU.safeEmit(vv.CAMERA_CHANGED, e);
  }), Fb.on(db.RECORDING_DEVICE_CHANGED, function (e) {
    YC.info("microphone device changed", JSON.stringify(e)), xU.onMicrophoneChanged && xU.onMicrophoneChanged(e), xU.safeEmit(vv.MICROPHONE_CHANGED, e);
  }), Fb.on(db.PLAYOUT_DEVICE_CHANGED, function (e) {
    YC.debug("playout device changed", JSON.stringify(e)), xU.onPlaybackDeviceChanged && xU.onPlaybackDeviceChanged(e), xU.safeEmit(vv.PLAYBACK_DEVICE_CHANGED, e);
  }), qb.onAutoplayFailed = function () {
    YC.info("detect audio element autoplay failed"), jb.onAudioAutoplayFailed && jb.onAudioAutoplayFailed();
  }, Tb.on("autoplay-failed", function () {
    YC.info("detect webaudio autoplay failed"), jb.onAudioAutoplayFailed && jb.onAudioAutoplayFailed(), xU.safeEmit(vv.AUTOPLAY_FAILED);
  }), Tb.on(OA.STATE_CHANGE, function (e, t) {
    YC.info("audio context state changed: ".concat(t, " => ").concat(e)), xU.onAudioContextStateChanged && xU.onAudioContextStateChanged(e, t), xU.safeEmit(vv.AUDIO_CONTEXT_STATE_CHANGED, e, t);
  }), Rg.on(hg.NETWORK_STATE_CHANGE, function (e, t) {
    YC.info("[network-indicator] network state changed, ".concat(t, " => ").concat(e));
  }), window && (window.__ARTC__ = xU), xU;
});